import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  date: any;
  interval: any;
  json: any;
  jsonb: any;
  numeric: any;
  point: any;
  timestamptz: any;
  tstzrange: any;
  uuid: any;
};

export type BillingReportOutput = {
  __typename?: 'BillingReportOutput';
  location: Scalars['uuid'];
  user: Scalars['uuid'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type CancelPatientBookingInput = {
  actor: PatientBookingCancelActor;
  patientBooking: Scalars['uuid'];
  releasePieces?: InputMaybe<Scalars['Boolean']>;
};

export type CancelPatientBookingOutput = {
  __typename?: 'CancelPatientBookingOutput';
  patientBooking: Scalars['uuid'];
  releasedReservations: Array<Scalars['uuid']>;
};

export type CancelUserPlanInput = {
  id: Scalars['uuid'];
};

export type CancelUserPlanOutput = {
  __typename?: 'CancelUserPlanOutput';
  benefitsEndAt: Scalars['timestamptz'];
  canceledAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
};

export type ConfirmBookingOutput = {
  __typename?: 'ConfirmBookingOutput';
  invoiceId?: Maybe<Scalars['uuid']>;
  status: ConfirmBookingStatus;
  stripeInvoiceId?: Maybe<Scalars['uuid']>;
};

export enum ConfirmBookingStatus {
  Confirmed = 'CONFIRMED',
  InProgress = 'IN_PROGRESS'
}

export type ConfirmMultipleBookingsOutputItem = {
  __typename?: 'ConfirmMultipleBookingsOutputItem';
  invoiceId?: Maybe<Scalars['uuid']>;
  stripeInvoiceId?: Maybe<Scalars['uuid']>;
};

export type ConfirmPatientBookingInput = {
  patientBooking: Scalars['uuid'];
};

export type ConfirmPatientBookingOutput = {
  __typename?: 'ConfirmPatientBookingOutput';
  confirmedReservations: Array<ConfirmPatientBookingReservation>;
  patientBooking: Scalars['uuid'];
};

/**
 * A covering reservation confirmed AND billed by this confirm call (the
 * appointment's own pieces). Pre-existing confirmed coverage never appears
 * here - it was billed when it was confirmed.
 */
export type ConfirmPatientBookingReservation = {
  __typename?: 'ConfirmPatientBookingReservation';
  id: Scalars['uuid'];
  invoiceId?: Maybe<Scalars['uuid']>;
  stripeInvoiceId?: Maybe<Scalars['uuid']>;
};

export type CreateBookingInput = {
  ehrProcedure?: InputMaybe<Scalars['uuid']>;
  isFree?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['uuid']>;
  model?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  provider: Scalars['uuid'];
  room?: InputMaybe<Scalars['uuid']>;
  timespan: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Booking_Type_Enum>;
  user?: InputMaybe<Scalars['uuid']>;
};

export type CreateBookingOutput = {
  __typename?: 'CreateBookingOutput';
  id: Scalars['uuid'];
  model?: Maybe<Scalars['uuid']>;
  modelRate?: Maybe<Scalars['Int']>;
  modelTaxRate?: Maybe<Scalars['numeric']>;
  provider: Scalars['uuid'];
  room?: Maybe<Scalars['uuid']>;
  roomByRoom?: Maybe<Room>;
  roomRate?: Maybe<Scalars['Int']>;
  roomTaxRate?: Maybe<Scalars['numeric']>;
  timespan: Scalars['String'];
  title: Scalars['String'];
  user?: Maybe<Scalars['uuid']>;
  userByUser?: Maybe<User>;
};

export type CreateCheckoutSessionInput = {
  userId: Scalars['uuid'];
};

export type CreateCheckoutSessionOutput = {
  __typename?: 'CreateCheckoutSessionOutput';
  id: Scalars['String'];
  stripeCustomerId: Scalars['String'];
};

export type CreateMsoPurchaseRequestInvoiceOutput = {
  __typename?: 'CreateMsoPurchaseRequestInvoiceOutput';
  id: Scalars['uuid'];
  stripeInvoiceId: Scalars['String'];
  stripeInvoiceUrl: Scalars['String'];
};

export type CreateNewMsoInput = {
  location: Scalars['uuid'];
  msoName: Scalars['String'];
  msoSetupEmail: Scalars['String'];
};

export type CreateNewMsoOutput = {
  __typename?: 'CreateNewMsoOutput';
  id: Scalars['uuid'];
  name: Scalars['String'];
};

export type CreateOpenInput = {
  frequency: Scalars['String'];
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  timespan: Scalars['String'];
};

export type CreateOpenOutput = {
  __typename?: 'CreateOpenOutput';
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  repeating?: Maybe<Scalars['String']>;
  timespan: Scalars['String'];
};

export type CreatePatientBookingInput = {
  isFree: Scalars['Boolean'];
  location: Scalars['uuid'];
  patient: Scalars['uuid'];
  provider: Scalars['uuid'];
  room?: InputMaybe<Scalars['uuid']>;
  timespan: Scalars['String'];
};

export type CreatePatientBookingOutput = {
  __typename?: 'CreatePatientBookingOutput';
  createdReservations: Array<CreatePatientBookingReservation>;
  patientBooking: Scalars['uuid'];
};

export type CreatePatientBookingRequestOutput = {
  __typename?: 'CreatePatientBookingRequestOutput';
  /**
   * True when the appointment is already confirmed and billed, false when it is
   * pending the provider's answer.
   */
  confirmed: Scalars['Boolean'];
  end: Scalars['String'];
  patientBooking: Scalars['uuid'];
  provider: Scalars['uuid'];
  start: Scalars['String'];
};

export type CreatePatientBookingReservation = {
  __typename?: 'CreatePatientBookingReservation';
  id: Scalars['uuid'];
  room: Scalars['uuid'];
  timespan: Scalars['String'];
};

export type CreatePlanInput = {
  annualCost?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  discountRate?: InputMaybe<Scalars['Float']>;
  location: Scalars['uuid'];
  monthlyCost: Scalars['Int'];
  monthlyCredit?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type CreatePlanOutput = {
  __typename?: 'CreatePlanOutput';
  annualCost?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  discountRate?: Maybe<Scalars['Float']>;
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  monthlyCost: Scalars['Int'];
  monthlyCredit?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type CreateProviderHoursInput = {
  frequency: Scalars['String'];
  location: Scalars['uuid'];
  provider: Scalars['uuid'];
  timespan: Scalars['String'];
};

export type CreateProviderHoursOutput = {
  __typename?: 'CreateProviderHoursOutput';
  deletedAt?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  provider: Scalars['uuid'];
  repeatingKey?: Maybe<Scalars['uuid']>;
  timespan: Scalars['String'];
};

export type CreateRepeatBookingInput = {
  interval: RepeatBookingInterval;
  last_date: Scalars['String'];
  location?: InputMaybe<Scalars['uuid']>;
  model?: InputMaybe<Scalars['uuid']>;
  provider: Scalars['uuid'];
  room?: InputMaybe<Scalars['uuid']>;
  timespan: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['uuid']>;
};

export type CreateRepeatBookingOutput = {
  __typename?: 'CreateRepeatBookingOutput';
  id?: Maybe<Scalars['uuid']>;
  model?: Maybe<Scalars['uuid']>;
  modelRate?: Maybe<Scalars['Int']>;
  modelTaxRate?: Maybe<Scalars['numeric']>;
  provider: Scalars['uuid'];
  room?: Maybe<Scalars['uuid']>;
  roomRate?: Maybe<Scalars['Int']>;
  roomTaxRate?: Maybe<Scalars['numeric']>;
  succeeded: Scalars['Boolean'];
  timespan: Scalars['String'];
  title: Scalars['String'];
  user?: Maybe<Scalars['uuid']>;
};

export type CreateSetupIntentInput = {
  userId: Scalars['uuid'];
};

export type CreateSetupIntentOutput = {
  __typename?: 'CreateSetupIntentOutput';
  clientSecret: Scalars['String'];
  id: Scalars['String'];
  stripeCustomerId: Scalars['String'];
};

export type CreateSquareCustomerOutput = {
  __typename?: 'CreateSquareCustomerOutput';
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  squareCustomerId: Scalars['String'];
};

export type CreateStripeCustomerInput = {
  cognitoUsername: Scalars['String'];
  userId: Scalars['uuid'];
};

export type CreateStripeCustomerOutput = {
  __typename?: 'CreateStripeCustomerOutput';
  stripeCustomerId: Scalars['String'];
  userId: Scalars['uuid'];
};

export type CreateUserPlanInput = {
  annual: Scalars['Boolean'];
  plan: Scalars['uuid'];
  user: Scalars['uuid'];
};

export type CreateUserPlanOutput = {
  __typename?: 'CreateUserPlanOutput';
  annual: Scalars['Boolean'];
  id: Scalars['uuid'];
  plan: Scalars['uuid'];
  user: Scalars['uuid'];
};

export type CreateWeeklyNonMedicalBookingOutput = {
  __typename?: 'CreateWeeklyNonMedicalBookingOutput';
  id: Scalars['uuid'];
  model?: Maybe<Scalars['uuid']>;
  modelRate?: Maybe<Scalars['Int']>;
  modelTaxRate?: Maybe<Scalars['numeric']>;
  provider: Scalars['uuid'];
  recurringKey: Scalars['uuid'];
  room?: Maybe<Scalars['uuid']>;
  roomRate?: Maybe<Scalars['Int']>;
  roomTaxRate?: Maybe<Scalars['numeric']>;
  timespan: Scalars['String'];
  title: Scalars['String'];
  user?: Maybe<Scalars['uuid']>;
};

export type DeleteCognitoUserInput = {
  id: Scalars['uuid'];
};

export type DeleteCognitoUserOutput = {
  __typename?: 'DeleteCognitoUserOutput';
  id: Scalars['uuid'];
};

export type DeleteOpenInput = {
  carryForwards?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
};

export type DeleteOpenOutput = {
  __typename?: 'DeleteOpenOutput';
  id: Scalars['uuid'];
};

export type DeletePaymentMethodInput = {
  id: Scalars['String'];
  type: PaymentMethodType;
  userId: Scalars['String'];
};

export type DeletePaymentMethodOutput = {
  __typename?: 'DeletePaymentMethodOutput';
  id: Scalars['String'];
};

export type DeletePlanInput = {
  id: Scalars['uuid'];
};

export type DeletePlanOutput = {
  __typename?: 'DeletePlanOutput';
  id: Scalars['uuid'];
};

export type DisconnectSquareOutput = {
  __typename?: 'DisconnectSquareOutput';
  id: Scalars['uuid'];
  squareCredentialsById?: Maybe<Square_Credentials>;
};

export type EditBookingInput = {
  id: Scalars['uuid'];
  model?: InputMaybe<Scalars['uuid']>;
  provider: Scalars['uuid'];
  room?: InputMaybe<Scalars['uuid']>;
  timespan: Scalars['String'];
  title: Scalars['String'];
  user?: InputMaybe<Scalars['uuid']>;
};

export type EditBookingOutput = {
  __typename?: 'EditBookingOutput';
  id: Scalars['uuid'];
  model: Scalars['uuid'];
  modelRate: Scalars['Int'];
  modelTaxRate: Scalars['numeric'];
  provider: Scalars['uuid'];
  room: Scalars['uuid'];
  roomRate: Scalars['Int'];
  roomTaxRate: Scalars['numeric'];
  timespan: Scalars['String'];
  title: Scalars['String'];
  user?: Maybe<Scalars['uuid']>;
};

export type EditOpenInput = {
  carryForwards?: InputMaybe<Scalars['Boolean']>;
  frequency: Scalars['String'];
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  timespan: Scalars['String'];
};

export type EhrCreateChargeInput = {
  amountCents: Scalars['Int'];
  encounterId?: InputMaybe<Scalars['uuid']>;
  idempotencyKey: Scalars['uuid'];
  patientBookingId?: InputMaybe<Scalars['uuid']>;
  patientId: Scalars['uuid'];
  squareCardId?: InputMaybe<Scalars['String']>;
};

export type EhrCreateChargeOutput = {
  __typename?: 'EhrCreateChargeOutput';
  amountCents: Scalars['Int'];
  cardBrand?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  squareCardId?: Maybe<Scalars['String']>;
  squarePaymentId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type EhrDeleteCardInput = {
  ehrPatientCardId: Scalars['uuid'];
};

export type EhrDeleteCardOutput = {
  __typename?: 'EhrDeleteCardOutput';
  success: Scalars['Boolean'];
};

export type EhrListCardsInput = {
  patientId: Scalars['uuid'];
};

export type EhrListCardsOutputItem = {
  __typename?: 'EhrListCardsOutputItem';
  brand: Scalars['String'];
  createdByService: Scalars['Boolean'];
  ehrPatientCardId?: Maybe<Scalars['uuid']>;
  ehrPatientCardIdByEhrPatientCardId?: Maybe<Ehr_Patient_Card>;
  enabled: Scalars['Boolean'];
  expMonth?: Maybe<Scalars['Int']>;
  expYear?: Maybe<Scalars['Int']>;
  isDefault: Scalars['Boolean'];
  isOurs: Scalars['Boolean'];
  last4: Scalars['String'];
  squareCardId: Scalars['String'];
};

export type EhrListChargesInput = {
  encounterId?: InputMaybe<Scalars['uuid']>;
  patientBookingId?: InputMaybe<Scalars['uuid']>;
};

export type EhrListChargesOutputItem = {
  __typename?: 'EhrListChargesOutputItem';
  amountCents: Scalars['Int'];
  cardBrand?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  squareCardId?: Maybe<Scalars['String']>;
  squarePaymentId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type EhrListPatientChargesInput = {
  patientId: Scalars['uuid'];
};

export type EhrListPatientChargesOutputItem = {
  __typename?: 'EhrListPatientChargesOutputItem';
  amountCents: Scalars['Int'];
  bookingDate?: Maybe<Scalars['String']>;
  cardBrand?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  encounterDate?: Maybe<Scalars['String']>;
  encounterType?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  sourceType: Scalars['String'];
  squareCardId?: Maybe<Scalars['String']>;
  squarePaymentId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export enum EhrPhotoType {
  EhrEncounterPhoto = 'EHR_ENCOUNTER_PHOTO',
  EncounterScan_3D = 'ENCOUNTER_SCAN_3D',
  FillerProcedureProductInstance = 'FILLER_PROCEDURE_PRODUCT_INSTANCE',
  GlobalEhrProduct = 'GLOBAL_EHR_PRODUCT',
  PatientProfilePhoto = 'PATIENT_PROFILE_PHOTO',
  ProcedureAudioRecording = 'PROCEDURE_AUDIO_RECORDING',
  ProcedureAudioTranscript = 'PROCEDURE_AUDIO_TRANSCRIPT',
  ProviderEhrUsedProductRecord = 'PROVIDER_EHR_USED_PRODUCT_RECORD'
}

export type EhrRegisterCardInput = {
  consent: Scalars['Boolean'];
  patientId: Scalars['uuid'];
  squareCardId: Scalars['String'];
};

export type EhrResolveCustomerInput = {
  patientId: Scalars['uuid'];
};

export type EhrResolveCustomerOutput = {
  __typename?: 'EhrResolveCustomerOutput';
  candidates: Array<SquareCustomerCandidate>;
  resolved: Scalars['Boolean'];
  squareCustomerId?: Maybe<Scalars['String']>;
};

export type EhrSaveCardInput = {
  consent: Scalars['Boolean'];
  patientId: Scalars['uuid'];
  sourceId: Scalars['String'];
  squareCustomerId: Scalars['String'];
};

export type EhrSaveCardOutput = {
  __typename?: 'EhrSaveCardOutput';
  brand: Scalars['String'];
  createdByService: Scalars['Boolean'];
  ehrPatientCardId?: Maybe<Scalars['uuid']>;
  enabled: Scalars['Boolean'];
  expMonth?: Maybe<Scalars['Int']>;
  expYear?: Maybe<Scalars['Int']>;
  isDefault: Scalars['Boolean'];
  isOurs: Scalars['Boolean'];
  last4: Scalars['String'];
  squareCardId: Scalars['String'];
};

export type EhrSetDefaultCardInput = {
  patientId: Scalars['uuid'];
  squareCardId: Scalars['String'];
};

export type EhrSetDefaultCardOutput = {
  __typename?: 'EhrSetDefaultCardOutput';
  patientId: Scalars['uuid'];
  squareDefaultCardId?: Maybe<Scalars['String']>;
};

export type EhrSubscriptionOutput = {
  __typename?: 'EhrSubscriptionOutput';
  id: Scalars['uuid'];
  status: Scalars['String'];
};

export enum EhrTier {
  Essential = 'ESSENTIAL',
  Practice = 'PRACTICE',
  Professional = 'PROFESSIONAL'
}

export type EhrTierInput = {
  location: Scalars['uuid'];
  partner?: InputMaybe<Scalars['uuid']>;
  tier: EhrTier;
};

export type EhrTierOutput = {
  __typename?: 'EhrTierOutput';
  tier: EhrTier;
};

export type EhrUnitInput = {
  location: Scalars['uuid'];
  partner?: InputMaybe<Scalars['uuid']>;
};

export type FinancialReportOutput = {
  __typename?: 'FinancialReportOutput';
  admin: Scalars['uuid'];
  location: Scalars['uuid'];
};

export type GetBookingAvailabilityOutput = {
  __typename?: 'GetBookingAvailabilityOutput';
  payload: Scalars['String'];
};

export type GetDownloadDocumentUrlInput = {
  user: Scalars['uuid'];
};

export type GetDownloadDocumentUrlOutputItem = {
  __typename?: 'GetDownloadDocumentUrlOutputItem';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  original_name: Scalars['String'];
  type: Scalars['String'];
  url: Scalars['String'];
};

export type GetHostedInvoiceUrlOutput = {
  __typename?: 'GetHostedInvoiceUrlOutput';
  hostedInvoiceUrl: Scalars['String'];
};

export type GetInvoiceLineItemsInput = {
  id?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type GetMsoDashboardMetricOutput = {
  __typename?: 'GetMsoDashboardMetricOutput';
  dataset: Array<Scalars['Int']>;
  display_dataset: Array<Scalars['String']>;
  labels: Array<Scalars['String']>;
};

export type GetPaymentMethodsInput = {
  userId: Scalars['uuid'];
};

export type GetPaymentMethodsOutput = {
  __typename?: 'GetPaymentMethodsOutput';
  bank?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  expMonth?: Maybe<Scalars['Int']>;
  expYear?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  isDefault: Scalars['Boolean'];
  last4: Scalars['String'];
  methodType: Scalars['String'];
};

export type GetPaymentsListOutput = {
  __typename?: 'GetPaymentsListOutput';
  amount: Scalars['String'];
  created: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
};

export type GetProviderSquareCustomersOutput = {
  __typename?: 'GetProviderSquareCustomersOutput';
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  squareCustomerId: Scalars['String'];
};

export type GetSignedUrlForEhrPhotoOutput = {
  __typename?: 'GetSignedUrlForEhrPhotoOutput';
  url: Scalars['String'];
};

export type GetSquareMerchantNameOutput = {
  __typename?: 'GetSquareMerchantNameOutput';
  businessName?: Maybe<Scalars['String']>;
  connected: Scalars['Boolean'];
};

export type GetSquareOauthLinkUrlResponse = {
  __typename?: 'GetSquareOauthLinkUrlResponse';
  url: Scalars['String'];
};

export type GetSquareUserCardsOutputItem = {
  __typename?: 'GetSquareUserCardsOutputItem';
  brand: Scalars['String'];
  id: Scalars['String'];
  last4: Scalars['String'];
  type: Scalars['String'];
};

export type GetStripeSubscriptionInvoicesLineItem = {
  __typename?: 'GetStripeSubscriptionInvoicesLineItem';
  name: Scalars['String'];
  stripeId: Scalars['String'];
  totalCost: Scalars['Int'];
  unitCost: Scalars['Int'];
  units: Scalars['Int'];
};

export type GetStripeSubscriptionInvoicesOutput = {
  __typename?: 'GetStripeSubscriptionInvoicesOutput';
  amountDue: Scalars['Int'];
  createdAt: Scalars['String'];
  lineItem: GetStripeSubscriptionInvoicesLineItem;
  link: Scalars['String'];
  stripeId: Scalars['String'];
};

export type GetUploadDocumentUrlInput = {
  count: Scalars['Int'];
  types?: InputMaybe<Array<Scalars['String']>>;
  user: Scalars['uuid'];
};

export type GetUploadDocumentUrlOutputItem = {
  __typename?: 'GetUploadDocumentUrlOutputItem';
  id: Scalars['String'];
  url: Scalars['String'];
};

export type GetUploadPhotoUrlInput = {
  ehrPhotoType?: InputMaybe<EhrPhotoType>;
  types: Array<Scalars['String']>;
  uniqueKey?: InputMaybe<Scalars['uuid']>;
  user: Scalars['uuid'];
};

export type GetUploadPhotoUrlOutput = {
  __typename?: 'GetUploadPhotoUrlOutput';
  id: Scalars['String'];
  url: Scalars['String'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['Int']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['Int']>>;
  _eq?: InputMaybe<Array<Scalars['Int']>>;
  _gt?: InputMaybe<Array<Scalars['Int']>>;
  _gte?: InputMaybe<Array<Scalars['Int']>>;
  _in?: InputMaybe<Array<Array<Scalars['Int']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['Int']>>;
  _lte?: InputMaybe<Array<Scalars['Int']>>;
  _neq?: InputMaybe<Array<Scalars['Int']>>;
  _nin?: InputMaybe<Array<Array<Scalars['Int']>>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type InviteProviderOutput = {
  __typename?: 'InviteProviderOutput';
  /**
   * Active state of the matched provider, surfaced for non-blocking UI signals.
   * true  — provider exists and is active.
   * false — provider exists but user.active=false (e.g. on leave). The invite
   *         is still created; FE should show a "this provider is currently
   *         inactive" warning, not block.
   * null  — no provider matched (email is unclaimed); no statement to make
   *         about activity.
   */
  providerActive?: Maybe<Scalars['Boolean']>;
  /**
   * Display name of the matched provider, when the email mapped to an existing
   * Provider in our system. NULL when the email did not resolve and the invite
   * is awaiting claim by a future signup.
   */
  providerName?: Maybe<Scalars['String']>;
  status: InviteProviderStatus;
  supervisorProviderId: Scalars['uuid'];
};

export enum InviteProviderStatus {
  /** An active relationship already exists for this supervisor + provider. */
  AlreadyActive = 'ALREADY_ACTIVE',
  /** A pending invite already exists for this supervisor + email. */
  AlreadyPending = 'ALREADY_PENDING',
  /** A new pending invite was created. */
  Pending = 'PENDING'
}

export type InviteSupervisorOutput = {
  __typename?: 'InviteSupervisorOutput';
  status: Scalars['String'];
  supervisorName: Scalars['String'];
  supervisorProviderId: Scalars['uuid'];
};

export type LineItem = {
  __typename?: 'LineItem';
  /**
   * Which booking produced this row (set on batch previews) - group by it to
   * attribute pieces; two pieces in the same room otherwise render identically.
   */
  bookingId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  taxRate: Scalars['Float'];
  taxTotal: Scalars['Int'];
  total: Scalars['Int'];
  type?: Maybe<LineItemLiteral>;
  unitPrice: Scalars['Int'];
  units: Scalars['Int'];
};

export enum LineItemLiteral {
  Credit = 'CREDIT',
  CreditSurcharge = 'CREDIT_SURCHARGE',
  Equipment = 'EQUIPMENT',
  PlanRoomDiscount = 'PLAN_ROOM_DISCOUNT',
  Product = 'PRODUCT',
  Room = 'ROOM',
  VolumeDiscount = 'VOLUME_DISCOUNT'
}

export type LookupPhoneNumberTwilioCarrier = {
  __typename?: 'LookupPhoneNumberTwilioCarrier';
  error_code?: Maybe<Scalars['String']>;
  mobile_country_code?: Maybe<Scalars['String']>;
  mobile_network_code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<TwilioLineType>;
};

export type LookupPhoneNumberTwilioOutput = {
  __typename?: 'LookupPhoneNumberTwilioOutput';
  add_ons?: Maybe<Scalars['String']>;
  caller_name?: Maybe<Scalars['String']>;
  carrier?: Maybe<LookupPhoneNumberTwilioCarrier>;
  country_code?: Maybe<Scalars['String']>;
  national_format?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum MsoDashboardMetric {
  TotalRevenue = 'TOTAL_REVENUE',
  TotalSalesTax = 'TOTAL_SALES_TAX',
  TotalSubscribers = 'TOTAL_SUBSCRIBERS'
}

export enum MsoDashboardMetricCompareToInterval {
  Month = 'MONTH',
  Period = 'PERIOD',
  Quarter = 'QUARTER',
  Year = 'YEAR'
}

export enum MsoDashboardMetricInterval {
  Day = 'DAY',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Weeks_4 = 'WEEKS_4',
  Year = 'YEAR'
}

/**
 * Who cancelled (phase-2 D8: actor-only vocabulary). System reasons
 * (ROOM_BOOKING_CANCELLED, CONFIRM_TIMEOUT) are not caller-suppliable.
 */
export enum PatientBookingCancelActor {
  Patient = 'PATIENT',
  Provider = 'PROVIDER'
}

export type PatientTemplate = {
  __typename?: 'PatientTemplate';
  newSendTemplateId: Scalars['uuid'];
  optional: Scalars['Boolean'];
  status?: Maybe<Scalars['String']>;
  statusDocumentId?: Maybe<Scalars['uuid']>;
  statusTemplateId: Scalars['uuid'];
  statusTemplateName: Scalars['String'];
};

export enum PaymentMethodType {
  Bank = 'bank',
  Card = 'card'
}

export type PreparePatientBookingConfirmInput = {
  patientBooking: Scalars['uuid'];
};

export type PreparePatientBookingConfirmOutput = {
  __typename?: 'PreparePatientBookingConfirmOutput';
  patientBooking: Scalars['uuid'];
  reservations: Array<PreparedReservation>;
};

/** Room time held for the appointment, unconfirmed and unbilled. */
export type PreparedReservation = {
  __typename?: 'PreparedReservation';
  id: Scalars['uuid'];
  room?: Maybe<Scalars['uuid']>;
  timespan: Scalars['String'];
};

export type ProductLookupBarcodeEhrProduct = {
  __typename?: 'ProductLookupBarcodeEhrProduct';
  id: Scalars['uuid'];
  name: Scalars['String'];
};

export type ProductLookupBarcodeResult = {
  __typename?: 'ProductLookupBarcodeResult';
  dosage?: Maybe<Scalars['String']>;
  ehrFdaProduct?: Maybe<Scalars['uuid']>;
  ehrProduct?: Maybe<ProductLookupBarcodeEhrProduct>;
  expirationDate?: Maybe<Scalars['String']>;
  fillVolumeMl?: Maybe<Scalars['String']>;
  lotNumber?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
};

export type ProductPurchaseOutput = {
  __typename?: 'ProductPurchaseOutput';
  invoiceId: Scalars['String'];
  stripeInvoiceId: Scalars['String'];
};

export type RegisterMedicalSupervisorAddressInput = {
  city: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zipcode: Scalars['String'];
};

export type RegisterMedicalSupervisorInput = {
  accreditation: SupervisorAccreditation;
  address: RegisterMedicalSupervisorAddressInput;
  agreedToAiEhr: Scalars['Boolean'];
  agreedToPrivacy: Scalars['Boolean'];
  agreedToTos: Scalars['Boolean'];
  agreedToTransactionalSms: Scalars['Boolean'];
  cognitoUserSub: Scalars['uuid'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  locationId: Scalars['uuid'];
};

export type RegisterMedicalSupervisorOutput = {
  __typename?: 'RegisterMedicalSupervisorOutput';
  userId: Scalars['uuid'];
};

export type RegisterProviderAddressInput = {
  city: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zipcode: Scalars['String'];
};

export type RegisterProviderInput = {
  address: RegisterProviderAddressInput;
  agreedToAiEhr: Scalars['Boolean'];
  agreedToDemoNotice?: InputMaybe<Scalars['Boolean']>;
  agreedToPrivacy: Scalars['Boolean'];
  agreedToTos: Scalars['Boolean'];
  agreedToTransactionalSms: Scalars['Boolean'];
  cognitoUserSub: Scalars['uuid'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  locationId: Scalars['uuid'];
};

export type RegisterProviderOutput = {
  __typename?: 'RegisterProviderOutput';
  userId: Scalars['uuid'];
};

export type RemoveBookingOutput = {
  __typename?: 'RemoveBookingOutput';
  booking_id: Scalars['uuid'];
  credit_id?: Maybe<Scalars['uuid']>;
  credit_ids: Array<Maybe<Scalars['uuid']>>;
};

export type RemoveRepeatBookingOutput = {
  __typename?: 'RemoveRepeatBookingOutput';
  booking_ids: Array<Maybe<Scalars['uuid']>>;
  credit_id?: Maybe<Scalars['uuid']>;
  credit_ids: Array<Maybe<Scalars['uuid']>>;
};

export enum RepeatBookingInterval {
  Monthly = 'MONTHLY',
  No = 'NO',
  Weekly = 'WEEKLY'
}

export type SaveSquareCustomerCardInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  cardholderName: Scalars['String'];
  city: Scalars['String'];
  provider?: InputMaybe<Scalars['uuid']>;
  sourceId: Scalars['String'];
  squareCustomerId?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zipcode: Scalars['String'];
};

export type SaveSquareCustomerCardOutput = {
  __typename?: 'SaveSquareCustomerCardOutput';
  brand: Scalars['String'];
  id: Scalars['String'];
  last4: Scalars['String'];
  type: Scalars['String'];
};

export type SeedDemoAccountOutput = {
  __typename?: 'SeedDemoAccountOutput';
  setUp: Scalars['Boolean'];
};

export type SendPatientRegistrationInviteOutput = {
  __typename?: 'SendPatientRegistrationInviteOutput';
  patientId: Scalars['uuid'];
};

export type SetAsDefaultPaymentMethodInput = {
  id: Scalars['String'];
  type: PaymentMethodType;
  userId: Scalars['String'];
};

export type SetAsDefaultPaymentMethodOutput = {
  __typename?: 'SetAsDefaultPaymentMethodOutput';
  id: Scalars['String'];
  isDefault: Scalars['Boolean'];
};

export type SigningDocumentCreateInput = {
  documentName: Scalars['String'];
  fields?: InputMaybe<Array<SigningTemplateFieldValueInput>>;
  patient?: InputMaybe<Scalars['uuid']>;
  signerUserId?: InputMaybe<Scalars['uuid']>;
  templateId: Scalars['uuid'];
};

export type SigningDocumentCreateOutput = {
  __typename?: 'SigningDocumentCreateOutput';
  embeddedSigningUrl?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
};

export type SigningDocumentGetEmbeddedLinkInput = {
  id: Scalars['uuid'];
};

export type SigningDocumentGetEmbeddedLinkOutput = {
  __typename?: 'SigningDocumentGetEmbeddedLinkOutput';
  embeddedSigningUrl: Scalars['String'];
  id: Scalars['uuid'];
};

export type SigningDocumentsGetPdfOutput = {
  __typename?: 'SigningDocumentsGetPdfOutput';
  url: Scalars['String'];
};

export type SigningFieldInput = {
  apiId?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  page: Scalars['Int'];
  placeholder: SigningPlaceholder;
  required?: InputMaybe<Scalars['Boolean']>;
  type: SigningFieldType;
  value?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type SigningFieldOutput = {
  __typename?: 'SigningFieldOutput';
  apiId: Scalars['String'];
  height: Scalars['Float'];
  page: Scalars['Int'];
  placeholder?: Maybe<SigningPlaceholder>;
  required: Scalars['Boolean'];
  type: SigningFieldType;
  value?: Maybe<Scalars['String']>;
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export enum SigningFieldType {
  Checkbox = 'checkbox',
  Date = 'date',
  Initials = 'initials',
  Signature = 'signature',
  Text = 'text'
}

export enum SigningPlaceholder {
  Patient = 'patient',
  Provider = 'provider',
  Supervisor = 'supervisor'
}

export type SigningTemplateCreateInput = {
  expirationDate?: InputMaybe<Scalars['date']>;
  fields?: InputMaybe<Array<SigningFieldInput>>;
  kind: SigningTemplateKind;
  location: Scalars['uuid'];
  name: Scalars['String'];
  sourceFileId: Scalars['uuid'];
};

export type SigningTemplateCreateOutput = {
  __typename?: 'SigningTemplateCreateOutput';
  fieldCount?: Maybe<Scalars['Int']>;
  templateId: Scalars['uuid'];
};

export type SigningTemplateFieldValueInput = {
  apiId: Scalars['String'];
  value: Scalars['String'];
};

export type SigningTemplateGetFieldsOutput = {
  __typename?: 'SigningTemplateGetFieldsOutput';
  fields: Array<SigningFieldOutput>;
  templateId: Scalars['uuid'];
};

export type SigningTemplateGetPreviewUrlsInput = {
  sourceFileId: Scalars['uuid'];
};

export type SigningTemplateGetPreviewUrlsOutput = {
  __typename?: 'SigningTemplateGetPreviewUrlsOutput';
  previewUrls: Array<Scalars['String']>;
};

export enum SigningTemplateKind {
  PatientForm = 'PATIENT_FORM',
  SupervisorForm = 'SUPERVISOR_FORM'
}

export type SquareCustomerCandidate = {
  __typename?: 'SquareCustomerCandidate';
  email?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  squareCustomerId: Scalars['String'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']>>;
  _eq?: InputMaybe<Array<Scalars['String']>>;
  _gt?: InputMaybe<Array<Scalars['String']>>;
  _gte?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['String']>>;
  _lte?: InputMaybe<Array<Scalars['String']>>;
  _neq?: InputMaybe<Array<Scalars['String']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/**
 * Accreditations valid for a MedicalSupervisor signup. Narrower than the
 * `accreditation` table's full set — supervision is restricted to physicians,
 * dentists, and nurse practitioners. The user.accreditation column itself
 * accepts the full enum (other roles can hold DO, RN, PA, etc.); this
 * narrowing is mirrored by the `user_supervisor_accreditation_check`
 * CHECK constraint on the user table.
 */
export enum SupervisorAccreditation {
  Dds = 'DDS',
  Md = 'MD',
  Np = 'NP'
}

export enum TwilioLineType {
  Landline = 'landline',
  Mobile = 'mobile',
  Voip = 'voip'
}

export type UpdatePartnerStripeUserToChargeInput = {
  chargeUserPaymentMethod?: InputMaybe<Scalars['String']>;
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  stripeUserToCharge: Scalars['String'];
};

export type UpdatePartnerStripeUserToChargeOutput = {
  __typename?: 'UpdatePartnerStripeUserToChargeOutput';
  chargeUserPaymentMethod?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  stripeUserToCharge: Scalars['String'];
};

export type UpdatePlanInput = {
  annualCost?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  discountRate?: InputMaybe<Scalars['Float']>;
  id: Scalars['uuid'];
  monthlyCost?: InputMaybe<Scalars['Int']>;
  monthlyCredit?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type UpdatePlanOutput = {
  __typename?: 'UpdatePlanOutput';
  annualCost?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  discountRate?: Maybe<Scalars['Float']>;
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  monthlyCost?: Maybe<Scalars['Int']>;
  monthlyCredit?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type UpdateProviderHoursInput = {
  frequency: Scalars['String'];
  id: Scalars['uuid'];
  propagateForward: Scalars['Boolean'];
  timespan: Scalars['String'];
};

export type UpdateProviderHoursOutput = {
  __typename?: 'UpdateProviderHoursOutput';
  deletedAt?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  provider: Scalars['uuid'];
  repeatingKey?: Maybe<Scalars['uuid']>;
  timespan: Scalars['String'];
};

export type UpdateSupervisorSettingInput = {
  cascadeToProviders: Scalars['Boolean'];
  hardCount: Scalars['Int'];
  samplingPercentage: Scalars['Int'];
  samplingPeriod: Supervisor_Sampling_Period_Type_Enum;
};

export type UpdateSupervisorSettingOutput = {
  __typename?: 'UpdateSupervisorSettingOutput';
  supervisorSettingId: Scalars['uuid'];
};

export type UpdateUserPlanInput = {
  id: Scalars['String'];
};

export type UpdateUserPlanOutput = {
  __typename?: 'UpdateUserPlanOutput';
  annual: Scalars['Boolean'];
  id: Scalars['String'];
};

export type UploadSigningTemplateSourceFileInput = {
  location: Scalars['uuid'];
  s3Url: Scalars['String'];
};

export type UploadSigningTemplateSourceFileOutput = {
  __typename?: 'UploadSigningTemplateSourceFileOutput';
  previewUrls: Array<Scalars['String']>;
  sourceFileId: Scalars['uuid'];
};

export type UploadTmpDocumentOutput = {
  __typename?: 'UploadTmpDocumentOutput';
  getUrl: Scalars['String'];
  id: Scalars['uuid'];
  putUrl: Scalars['String'];
};

export type ValidatePatientInviteOutput = {
  __typename?: 'ValidatePatientInviteOutput';
  maskedPhone: Scalars['String'];
  username: Scalars['String'];
};

/** columns and relationships of "accreditation" */
export type Accreditation = {
  __typename?: 'accreditation';
  /** An array relationship */
  accreditation_location_privileges: Array<Accreditation_Location_Privilege>;
  /** An aggregate relationship */
  accreditation_location_privileges_aggregate: Accreditation_Location_Privilege_Aggregate;
  id: Scalars['String'];
};


/** columns and relationships of "accreditation" */
export type AccreditationAccreditation_Location_PrivilegesArgs = {
  distinct_on?: InputMaybe<Array<Accreditation_Location_Privilege_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accreditation_Location_Privilege_Order_By>>;
  where?: InputMaybe<Accreditation_Location_Privilege_Bool_Exp>;
};


/** columns and relationships of "accreditation" */
export type AccreditationAccreditation_Location_Privileges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accreditation_Location_Privilege_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accreditation_Location_Privilege_Order_By>>;
  where?: InputMaybe<Accreditation_Location_Privilege_Bool_Exp>;
};

/** aggregated selection of "accreditation" */
export type Accreditation_Aggregate = {
  __typename?: 'accreditation_aggregate';
  aggregate?: Maybe<Accreditation_Aggregate_Fields>;
  nodes: Array<Accreditation>;
};

/** aggregate fields of "accreditation" */
export type Accreditation_Aggregate_Fields = {
  __typename?: 'accreditation_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Accreditation_Max_Fields>;
  min?: Maybe<Accreditation_Min_Fields>;
};


/** aggregate fields of "accreditation" */
export type Accreditation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Accreditation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "accreditation". All fields are combined with a logical 'AND'. */
export type Accreditation_Bool_Exp = {
  _and?: InputMaybe<Array<Accreditation_Bool_Exp>>;
  _not?: InputMaybe<Accreditation_Bool_Exp>;
  _or?: InputMaybe<Array<Accreditation_Bool_Exp>>;
  accreditation_location_privileges?: InputMaybe<Accreditation_Location_Privilege_Bool_Exp>;
  accreditation_location_privileges_aggregate?: InputMaybe<Accreditation_Location_Privilege_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "accreditation" */
export enum Accreditation_Constraint {
  /** unique or primary key constraint on columns "id" */
  TitlePkey = 'title_pkey'
}

export enum Accreditation_Enum {
  As = 'AS',
  Dds = 'DDS',
  Do = 'DO',
  Lt = 'LT',
  Md = 'MD',
  NonMedical = 'NON_MEDICAL',
  Np = 'NP',
  Od = 'OD',
  On = 'ON',
  Pa = 'PA',
  Rn = 'RN'
}

/** Boolean expression to compare columns of type "accreditation_enum". All fields are combined with logical 'AND'. */
export type Accreditation_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Accreditation_Enum>;
  _in?: InputMaybe<Array<Accreditation_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Accreditation_Enum>;
  _nin?: InputMaybe<Array<Accreditation_Enum>>;
};

/** input type for inserting data into table "accreditation" */
export type Accreditation_Insert_Input = {
  accreditation_location_privileges?: InputMaybe<Accreditation_Location_Privilege_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "accreditation_location_privilege" */
export type Accreditation_Location_Privilege = {
  __typename?: 'accreditation_location_privilege';
  accreditation: Accreditation_Enum;
  canBookWithoutDirector: Scalars['Boolean'];
  canPurchasePrescriptionProducts: Scalars['Boolean'];
  location: Scalars['uuid'];
};

/** aggregated selection of "accreditation_location_privilege" */
export type Accreditation_Location_Privilege_Aggregate = {
  __typename?: 'accreditation_location_privilege_aggregate';
  aggregate?: Maybe<Accreditation_Location_Privilege_Aggregate_Fields>;
  nodes: Array<Accreditation_Location_Privilege>;
};

export type Accreditation_Location_Privilege_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Accreditation_Location_Privilege_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Accreditation_Location_Privilege_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Accreditation_Location_Privilege_Aggregate_Bool_Exp_Count>;
};

export type Accreditation_Location_Privilege_Aggregate_Bool_Exp_Bool_And = {
  arguments: Accreditation_Location_Privilege_Select_Column_Accreditation_Location_Privilege_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Accreditation_Location_Privilege_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Accreditation_Location_Privilege_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Accreditation_Location_Privilege_Select_Column_Accreditation_Location_Privilege_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Accreditation_Location_Privilege_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Accreditation_Location_Privilege_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Accreditation_Location_Privilege_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Accreditation_Location_Privilege_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "accreditation_location_privilege" */
export type Accreditation_Location_Privilege_Aggregate_Fields = {
  __typename?: 'accreditation_location_privilege_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Accreditation_Location_Privilege_Max_Fields>;
  min?: Maybe<Accreditation_Location_Privilege_Min_Fields>;
};


/** aggregate fields of "accreditation_location_privilege" */
export type Accreditation_Location_Privilege_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Accreditation_Location_Privilege_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "accreditation_location_privilege" */
export type Accreditation_Location_Privilege_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Accreditation_Location_Privilege_Max_Order_By>;
  min?: InputMaybe<Accreditation_Location_Privilege_Min_Order_By>;
};

/** input type for inserting array relation for remote table "accreditation_location_privilege" */
export type Accreditation_Location_Privilege_Arr_Rel_Insert_Input = {
  data: Array<Accreditation_Location_Privilege_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Accreditation_Location_Privilege_On_Conflict>;
};

/** Boolean expression to filter rows from the table "accreditation_location_privilege". All fields are combined with a logical 'AND'. */
export type Accreditation_Location_Privilege_Bool_Exp = {
  _and?: InputMaybe<Array<Accreditation_Location_Privilege_Bool_Exp>>;
  _not?: InputMaybe<Accreditation_Location_Privilege_Bool_Exp>;
  _or?: InputMaybe<Array<Accreditation_Location_Privilege_Bool_Exp>>;
  accreditation?: InputMaybe<Accreditation_Enum_Comparison_Exp>;
  canBookWithoutDirector?: InputMaybe<Boolean_Comparison_Exp>;
  canPurchasePrescriptionProducts?: InputMaybe<Boolean_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "accreditation_location_privilege" */
export enum Accreditation_Location_Privilege_Constraint {
  /** unique or primary key constraint on columns "accreditation", "location" */
  AccreditationLocationPrivilegesPkey = 'accreditation_location_privileges_pkey'
}

/** input type for inserting data into table "accreditation_location_privilege" */
export type Accreditation_Location_Privilege_Insert_Input = {
  accreditation?: InputMaybe<Accreditation_Enum>;
  canBookWithoutDirector?: InputMaybe<Scalars['Boolean']>;
  canPurchasePrescriptionProducts?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Accreditation_Location_Privilege_Max_Fields = {
  __typename?: 'accreditation_location_privilege_max_fields';
  location?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "accreditation_location_privilege" */
export type Accreditation_Location_Privilege_Max_Order_By = {
  location?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Accreditation_Location_Privilege_Min_Fields = {
  __typename?: 'accreditation_location_privilege_min_fields';
  location?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "accreditation_location_privilege" */
export type Accreditation_Location_Privilege_Min_Order_By = {
  location?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "accreditation_location_privilege" */
export type Accreditation_Location_Privilege_Mutation_Response = {
  __typename?: 'accreditation_location_privilege_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Accreditation_Location_Privilege>;
};

/** on_conflict condition type for table "accreditation_location_privilege" */
export type Accreditation_Location_Privilege_On_Conflict = {
  constraint: Accreditation_Location_Privilege_Constraint;
  update_columns?: Array<Accreditation_Location_Privilege_Update_Column>;
  where?: InputMaybe<Accreditation_Location_Privilege_Bool_Exp>;
};

/** Ordering options when selecting data from "accreditation_location_privilege". */
export type Accreditation_Location_Privilege_Order_By = {
  accreditation?: InputMaybe<Order_By>;
  canBookWithoutDirector?: InputMaybe<Order_By>;
  canPurchasePrescriptionProducts?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accreditation_location_privilege */
export type Accreditation_Location_Privilege_Pk_Columns_Input = {
  accreditation: Accreditation_Enum;
  location: Scalars['uuid'];
};

/** select columns of table "accreditation_location_privilege" */
export enum Accreditation_Location_Privilege_Select_Column {
  /** column name */
  Accreditation = 'accreditation',
  /** column name */
  CanBookWithoutDirector = 'canBookWithoutDirector',
  /** column name */
  CanPurchasePrescriptionProducts = 'canPurchasePrescriptionProducts',
  /** column name */
  Location = 'location'
}

/** select "accreditation_location_privilege_aggregate_bool_exp_bool_and_arguments_columns" columns of table "accreditation_location_privilege" */
export enum Accreditation_Location_Privilege_Select_Column_Accreditation_Location_Privilege_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CanBookWithoutDirector = 'canBookWithoutDirector',
  /** column name */
  CanPurchasePrescriptionProducts = 'canPurchasePrescriptionProducts'
}

/** select "accreditation_location_privilege_aggregate_bool_exp_bool_or_arguments_columns" columns of table "accreditation_location_privilege" */
export enum Accreditation_Location_Privilege_Select_Column_Accreditation_Location_Privilege_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CanBookWithoutDirector = 'canBookWithoutDirector',
  /** column name */
  CanPurchasePrescriptionProducts = 'canPurchasePrescriptionProducts'
}

/** input type for updating data in table "accreditation_location_privilege" */
export type Accreditation_Location_Privilege_Set_Input = {
  accreditation?: InputMaybe<Accreditation_Enum>;
  canBookWithoutDirector?: InputMaybe<Scalars['Boolean']>;
  canPurchasePrescriptionProducts?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "accreditation_location_privilege" */
export type Accreditation_Location_Privilege_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Accreditation_Location_Privilege_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Accreditation_Location_Privilege_Stream_Cursor_Value_Input = {
  accreditation?: InputMaybe<Accreditation_Enum>;
  canBookWithoutDirector?: InputMaybe<Scalars['Boolean']>;
  canPurchasePrescriptionProducts?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "accreditation_location_privilege" */
export enum Accreditation_Location_Privilege_Update_Column {
  /** column name */
  Accreditation = 'accreditation',
  /** column name */
  CanBookWithoutDirector = 'canBookWithoutDirector',
  /** column name */
  CanPurchasePrescriptionProducts = 'canPurchasePrescriptionProducts',
  /** column name */
  Location = 'location'
}

export type Accreditation_Location_Privilege_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Accreditation_Location_Privilege_Set_Input>;
  /** filter the rows which have to be updated */
  where: Accreditation_Location_Privilege_Bool_Exp;
};

/** aggregate max on columns */
export type Accreditation_Max_Fields = {
  __typename?: 'accreditation_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Accreditation_Min_Fields = {
  __typename?: 'accreditation_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "accreditation" */
export type Accreditation_Mutation_Response = {
  __typename?: 'accreditation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Accreditation>;
};

/** input type for inserting object relation for remote table "accreditation" */
export type Accreditation_Obj_Rel_Insert_Input = {
  data: Accreditation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Accreditation_On_Conflict>;
};

/** on_conflict condition type for table "accreditation" */
export type Accreditation_On_Conflict = {
  constraint: Accreditation_Constraint;
  update_columns?: Array<Accreditation_Update_Column>;
  where?: InputMaybe<Accreditation_Bool_Exp>;
};

/** Ordering options when selecting data from "accreditation". */
export type Accreditation_Order_By = {
  accreditation_location_privileges_aggregate?: InputMaybe<Accreditation_Location_Privilege_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accreditation */
export type Accreditation_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "accreditation" */
export enum Accreditation_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "accreditation" */
export type Accreditation_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "accreditation" */
export type Accreditation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Accreditation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Accreditation_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "accreditation" */
export enum Accreditation_Update_Column {
  /** column name */
  Id = 'id'
}

export type Accreditation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Accreditation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Accreditation_Bool_Exp;
};

/** columns and relationships of "address" */
export type Address = {
  __typename?: 'address';
  city: Scalars['String'];
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  /** An object relationship */
  location?: Maybe<Location>;
  /** An array relationship */
  patients: Array<Patient>;
  /** An aggregate relationship */
  patients_aggregate: Patient_Aggregate;
  state: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  users: Array<User>;
  /** An aggregate relationship */
  users_aggregate: User_Aggregate;
  zipcode: Scalars['String'];
};


/** columns and relationships of "address" */
export type AddressPatientsArgs = {
  distinct_on?: InputMaybe<Array<Patient_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Order_By>>;
  where?: InputMaybe<Patient_Bool_Exp>;
};


/** columns and relationships of "address" */
export type AddressPatients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Order_By>>;
  where?: InputMaybe<Patient_Bool_Exp>;
};


/** columns and relationships of "address" */
export type AddressUsersArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


/** columns and relationships of "address" */
export type AddressUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** aggregated selection of "address" */
export type Address_Aggregate = {
  __typename?: 'address_aggregate';
  aggregate?: Maybe<Address_Aggregate_Fields>;
  nodes: Array<Address>;
};

/** aggregate fields of "address" */
export type Address_Aggregate_Fields = {
  __typename?: 'address_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Address_Max_Fields>;
  min?: Maybe<Address_Min_Fields>;
};


/** aggregate fields of "address" */
export type Address_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "address". All fields are combined with a logical 'AND'. */
export type Address_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Bool_Exp>>;
  _not?: InputMaybe<Address_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  line1?: InputMaybe<String_Comparison_Exp>;
  line2?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<Location_Bool_Exp>;
  patients?: InputMaybe<Patient_Bool_Exp>;
  patients_aggregate?: InputMaybe<Patient_Aggregate_Bool_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  users?: InputMaybe<User_Bool_Exp>;
  users_aggregate?: InputMaybe<User_Aggregate_Bool_Exp>;
  zipcode?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "address" */
export enum Address_Constraint {
  /** unique or primary key constraint on columns "id" */
  AddressPkey = 'address_pkey'
}

/** input type for inserting data into table "address" */
export type Address_Insert_Input = {
  city?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  patients?: InputMaybe<Patient_Arr_Rel_Insert_Input>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  users?: InputMaybe<User_Arr_Rel_Insert_Input>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Address_Max_Fields = {
  __typename?: 'address_max_fields';
  city?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Address_Min_Fields = {
  __typename?: 'address_min_fields';
  city?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "address" */
export type Address_Mutation_Response = {
  __typename?: 'address_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Address>;
};

/** input type for inserting object relation for remote table "address" */
export type Address_Obj_Rel_Insert_Input = {
  data: Address_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Address_On_Conflict>;
};

/** on_conflict condition type for table "address" */
export type Address_On_Conflict = {
  constraint: Address_Constraint;
  update_columns?: Array<Address_Update_Column>;
  where?: InputMaybe<Address_Bool_Exp>;
};

/** Ordering options when selecting data from "address". */
export type Address_Order_By = {
  city?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line1?: InputMaybe<Order_By>;
  line2?: InputMaybe<Order_By>;
  location?: InputMaybe<Location_Order_By>;
  patients_aggregate?: InputMaybe<Patient_Aggregate_Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<User_Aggregate_Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: address */
export type Address_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "address" */
export enum Address_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Line1 = 'line1',
  /** column name */
  Line2 = 'line2',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Zipcode = 'zipcode'
}

/** input type for updating data in table "address" */
export type Address_Set_Input = {
  city?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "address" */
export type Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Stream_Cursor_Value_Input = {
  city?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** update columns of table "address" */
export enum Address_Update_Column {
  /** column name */
  City = 'city',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Line1 = 'line1',
  /** column name */
  Line2 = 'line2',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Zipcode = 'zipcode'
}

export type Address_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Address_Set_Input>;
  /** filter the rows which have to be updated */
  where: Address_Bool_Exp;
};

/** columns and relationships of "agreement_type" */
export type Agreement_Type = {
  __typename?: 'agreement_type';
  id: Scalars['String'];
};

/** aggregated selection of "agreement_type" */
export type Agreement_Type_Aggregate = {
  __typename?: 'agreement_type_aggregate';
  aggregate?: Maybe<Agreement_Type_Aggregate_Fields>;
  nodes: Array<Agreement_Type>;
};

/** aggregate fields of "agreement_type" */
export type Agreement_Type_Aggregate_Fields = {
  __typename?: 'agreement_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Agreement_Type_Max_Fields>;
  min?: Maybe<Agreement_Type_Min_Fields>;
};


/** aggregate fields of "agreement_type" */
export type Agreement_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agreement_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "agreement_type". All fields are combined with a logical 'AND'. */
export type Agreement_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Agreement_Type_Bool_Exp>>;
  _not?: InputMaybe<Agreement_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Agreement_Type_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "agreement_type" */
export enum Agreement_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  AgreementTypesPkey = 'agreement_types_pkey'
}

export enum Agreement_Type_Enum {
  AiEhr = 'Ai_ehr',
  DemoNotice = 'Demo_notice',
  PrivacyCookies = 'Privacy_cookies',
  TermsOfService = 'Terms_of_service',
  TransactionalSms = 'Transactional_sms'
}

/** Boolean expression to compare columns of type "agreement_type_enum". All fields are combined with logical 'AND'. */
export type Agreement_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Agreement_Type_Enum>;
  _in?: InputMaybe<Array<Agreement_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Agreement_Type_Enum>;
  _nin?: InputMaybe<Array<Agreement_Type_Enum>>;
};

/** input type for inserting data into table "agreement_type" */
export type Agreement_Type_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Agreement_Type_Max_Fields = {
  __typename?: 'agreement_type_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Agreement_Type_Min_Fields = {
  __typename?: 'agreement_type_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "agreement_type" */
export type Agreement_Type_Mutation_Response = {
  __typename?: 'agreement_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Agreement_Type>;
};

/** input type for inserting object relation for remote table "agreement_type" */
export type Agreement_Type_Obj_Rel_Insert_Input = {
  data: Agreement_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Agreement_Type_On_Conflict>;
};

/** on_conflict condition type for table "agreement_type" */
export type Agreement_Type_On_Conflict = {
  constraint: Agreement_Type_Constraint;
  update_columns?: Array<Agreement_Type_Update_Column>;
  where?: InputMaybe<Agreement_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "agreement_type". */
export type Agreement_Type_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agreement_type */
export type Agreement_Type_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "agreement_type" */
export enum Agreement_Type_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "agreement_type" */
export type Agreement_Type_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "agreement_type" */
export type Agreement_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agreement_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agreement_Type_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "agreement_type" */
export enum Agreement_Type_Update_Column {
  /** column name */
  Id = 'id'
}

export type Agreement_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agreement_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Agreement_Type_Bool_Exp;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** A booking of any type (portable if a model; room if a room - if so the model if any comes from the room linkage) */
export type Booking = {
  __typename?: 'booking';
  appointment_derived: Scalars['Boolean'];
  cancelReason?: Maybe<Cancel_Reason_Enum>;
  cancelled_at?: Maybe<Scalars['timestamptz']>;
  confirmedAt?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  ehrEncounters: Array<Ehr_Encounter>;
  /** An aggregate relationship */
  ehrEncounters_aggregate: Ehr_Encounter_Aggregate;
  id: Scalars['uuid'];
  /** An array relationship */
  invoices: Array<Invoice>;
  /** An aggregate relationship */
  invoices_aggregate: Invoice_Aggregate;
  /** Free booking where provider is an admin and doesn't want to charge themselves. */
  isFree: Scalars['Boolean'];
  isResourceFree: Scalars['Boolean'];
  /** Needed due to portable (non-room) bookings */
  location?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  locationByLocation?: Maybe<Location>;
  model?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  modelByModel?: Maybe<Model>;
  modelRate?: Maybe<Scalars['Int']>;
  modelTaxRate?: Maybe<Scalars['numeric']>;
  /** TEMPORARY wire-compat shim for pre-stacking app builds - always null */
  patient?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  patientBookingBookings: Array<Patient_Booking_Booking>;
  /** An aggregate relationship */
  patientBookingBookings_aggregate: Patient_Booking_Booking_Aggregate;
  /** An array relationship */
  patientBookingMetadata: Array<Patient_Booking_Metadata>;
  /** An aggregate relationship */
  patientBookingMetadata_aggregate: Patient_Booking_Metadata_Aggregate;
  /** An array relationship */
  productPurchases: Array<Product_Purchase>;
  /** An aggregate relationship */
  productPurchases_aggregate: Product_Purchase_Aggregate;
  /** The provider who is going to do the procedure */
  provider: Scalars['uuid'];
  /** An array relationship */
  recurringBookingsSet: Array<Booking>;
  /** An aggregate relationship */
  recurringBookingsSet_aggregate: Booking_Aggregate;
  recurringKey?: Maybe<Scalars['uuid']>;
  room?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  roomByRoom?: Maybe<Room>;
  roomRate?: Maybe<Scalars['Int']>;
  roomTaxRate?: Maybe<Scalars['numeric']>;
  timespan: Scalars['tstzrange'];
  /** A computed field, executes function "booking_timespan_lower" */
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  timespan_lower_bound: Scalars['timestamptz'];
  /** lower(timespan) Postgres computed field */
  timespan_range_lower: Scalars['timestamptz'];
  timespan_range_upper: Scalars['timestamptz'];
  /** A computed field, executes function "booking_timespan_upper" */
  timespan_upper?: Maybe<Scalars['timestamptz']>;
  title: Scalars['String'];
  type: Booking_Type_Enum;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  userByProvider: User;
  /** A computed field, executes function "booking_visible_to_supervisor" */
  visibleToSupervisor?: Maybe<Scalars['Boolean']>;
};


/** A booking of any type (portable if a model; room if a room - if so the model if any comes from the room linkage) */
export type BookingEhrEncountersArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Bool_Exp>;
};


/** A booking of any type (portable if a model; room if a room - if so the model if any comes from the room linkage) */
export type BookingEhrEncounters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Bool_Exp>;
};


/** A booking of any type (portable if a model; room if a room - if so the model if any comes from the room linkage) */
export type BookingInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


/** A booking of any type (portable if a model; room if a room - if so the model if any comes from the room linkage) */
export type BookingInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


/** A booking of any type (portable if a model; room if a room - if so the model if any comes from the room linkage) */
export type BookingPatientBookingBookingsArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Booking_Order_By>>;
  where?: InputMaybe<Patient_Booking_Booking_Bool_Exp>;
};


/** A booking of any type (portable if a model; room if a room - if so the model if any comes from the room linkage) */
export type BookingPatientBookingBookings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Booking_Order_By>>;
  where?: InputMaybe<Patient_Booking_Booking_Bool_Exp>;
};


/** A booking of any type (portable if a model; room if a room - if so the model if any comes from the room linkage) */
export type BookingPatientBookingMetadataArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Metadata_Order_By>>;
  where?: InputMaybe<Patient_Booking_Metadata_Bool_Exp>;
};


/** A booking of any type (portable if a model; room if a room - if so the model if any comes from the room linkage) */
export type BookingPatientBookingMetadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Metadata_Order_By>>;
  where?: InputMaybe<Patient_Booking_Metadata_Bool_Exp>;
};


/** A booking of any type (portable if a model; room if a room - if so the model if any comes from the room linkage) */
export type BookingProductPurchasesArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchase_Order_By>>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};


/** A booking of any type (portable if a model; room if a room - if so the model if any comes from the room linkage) */
export type BookingProductPurchases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchase_Order_By>>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};


/** A booking of any type (portable if a model; room if a room - if so the model if any comes from the room linkage) */
export type BookingRecurringBookingsSetArgs = {
  distinct_on?: InputMaybe<Array<Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Order_By>>;
  where?: InputMaybe<Booking_Bool_Exp>;
};


/** A booking of any type (portable if a model; room if a room - if so the model if any comes from the room linkage) */
export type BookingRecurringBookingsSet_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Order_By>>;
  where?: InputMaybe<Booking_Bool_Exp>;
};

/** aggregated selection of "booking" */
export type Booking_Aggregate = {
  __typename?: 'booking_aggregate';
  aggregate?: Maybe<Booking_Aggregate_Fields>;
  nodes: Array<Booking>;
};

export type Booking_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Booking_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Booking_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Booking_Aggregate_Bool_Exp_Count>;
};

export type Booking_Aggregate_Bool_Exp_Bool_And = {
  arguments: Booking_Select_Column_Booking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Booking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Booking_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Booking_Select_Column_Booking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Booking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Booking_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Booking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Booking_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "booking" */
export type Booking_Aggregate_Fields = {
  __typename?: 'booking_aggregate_fields';
  avg?: Maybe<Booking_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Booking_Max_Fields>;
  min?: Maybe<Booking_Min_Fields>;
  stddev?: Maybe<Booking_Stddev_Fields>;
  stddev_pop?: Maybe<Booking_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Booking_Stddev_Samp_Fields>;
  sum?: Maybe<Booking_Sum_Fields>;
  var_pop?: Maybe<Booking_Var_Pop_Fields>;
  var_samp?: Maybe<Booking_Var_Samp_Fields>;
  variance?: Maybe<Booking_Variance_Fields>;
};


/** aggregate fields of "booking" */
export type Booking_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Booking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "booking" */
export type Booking_Aggregate_Order_By = {
  avg?: InputMaybe<Booking_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Booking_Max_Order_By>;
  min?: InputMaybe<Booking_Min_Order_By>;
  stddev?: InputMaybe<Booking_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Booking_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Booking_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Booking_Sum_Order_By>;
  var_pop?: InputMaybe<Booking_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Booking_Var_Samp_Order_By>;
  variance?: InputMaybe<Booking_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "booking" */
export type Booking_Arr_Rel_Insert_Input = {
  data: Array<Booking_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Booking_On_Conflict>;
};

/** aggregate avg on columns */
export type Booking_Avg_Fields = {
  __typename?: 'booking_avg_fields';
  modelRate?: Maybe<Scalars['Float']>;
  modelTaxRate?: Maybe<Scalars['Float']>;
  roomRate?: Maybe<Scalars['Float']>;
  roomTaxRate?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "booking" */
export type Booking_Avg_Order_By = {
  modelRate?: InputMaybe<Order_By>;
  modelTaxRate?: InputMaybe<Order_By>;
  roomRate?: InputMaybe<Order_By>;
  roomTaxRate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "booking". All fields are combined with a logical 'AND'. */
export type Booking_Bool_Exp = {
  _and?: InputMaybe<Array<Booking_Bool_Exp>>;
  _not?: InputMaybe<Booking_Bool_Exp>;
  _or?: InputMaybe<Array<Booking_Bool_Exp>>;
  appointment_derived?: InputMaybe<Boolean_Comparison_Exp>;
  cancelReason?: InputMaybe<Cancel_Reason_Enum_Comparison_Exp>;
  cancelled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  confirmedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrEncounters?: InputMaybe<Ehr_Encounter_Bool_Exp>;
  ehrEncounters_aggregate?: InputMaybe<Ehr_Encounter_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoices?: InputMaybe<Invoice_Bool_Exp>;
  invoices_aggregate?: InputMaybe<Invoice_Aggregate_Bool_Exp>;
  isFree?: InputMaybe<Boolean_Comparison_Exp>;
  isResourceFree?: InputMaybe<Boolean_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  model?: InputMaybe<Uuid_Comparison_Exp>;
  modelByModel?: InputMaybe<Model_Bool_Exp>;
  modelRate?: InputMaybe<Int_Comparison_Exp>;
  modelTaxRate?: InputMaybe<Numeric_Comparison_Exp>;
  patient?: InputMaybe<Uuid_Comparison_Exp>;
  patientBookingBookings?: InputMaybe<Patient_Booking_Booking_Bool_Exp>;
  patientBookingBookings_aggregate?: InputMaybe<Patient_Booking_Booking_Aggregate_Bool_Exp>;
  patientBookingMetadata?: InputMaybe<Patient_Booking_Metadata_Bool_Exp>;
  patientBookingMetadata_aggregate?: InputMaybe<Patient_Booking_Metadata_Aggregate_Bool_Exp>;
  productPurchases?: InputMaybe<Product_Purchase_Bool_Exp>;
  productPurchases_aggregate?: InputMaybe<Product_Purchase_Aggregate_Bool_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  recurringBookingsSet?: InputMaybe<Booking_Bool_Exp>;
  recurringBookingsSet_aggregate?: InputMaybe<Booking_Aggregate_Bool_Exp>;
  recurringKey?: InputMaybe<Uuid_Comparison_Exp>;
  room?: InputMaybe<Uuid_Comparison_Exp>;
  roomByRoom?: InputMaybe<Room_Bool_Exp>;
  roomRate?: InputMaybe<Int_Comparison_Exp>;
  roomTaxRate?: InputMaybe<Numeric_Comparison_Exp>;
  timespan?: InputMaybe<Tstzrange_Comparison_Exp>;
  timespan_lower?: InputMaybe<Timestamptz_Comparison_Exp>;
  timespan_lower_bound?: InputMaybe<Timestamptz_Comparison_Exp>;
  timespan_range_lower?: InputMaybe<Timestamptz_Comparison_Exp>;
  timespan_range_upper?: InputMaybe<Timestamptz_Comparison_Exp>;
  timespan_upper?: InputMaybe<Timestamptz_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Booking_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  userByProvider?: InputMaybe<User_Bool_Exp>;
  visibleToSupervisor?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "booking" */
export enum Booking_Constraint {
  /** unique or primary key constraint on columns "id" */
  BookingPkey = 'booking_pkey'
}

/** input type for incrementing numeric columns in table "booking" */
export type Booking_Inc_Input = {
  modelRate?: InputMaybe<Scalars['Int']>;
  modelTaxRate?: InputMaybe<Scalars['numeric']>;
  roomRate?: InputMaybe<Scalars['Int']>;
  roomTaxRate?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "booking" */
export type Booking_Insert_Input = {
  appointment_derived?: InputMaybe<Scalars['Boolean']>;
  cancelReason?: InputMaybe<Cancel_Reason_Enum>;
  cancelled_at?: InputMaybe<Scalars['timestamptz']>;
  confirmedAt?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  ehrEncounters?: InputMaybe<Ehr_Encounter_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  invoices?: InputMaybe<Invoice_Arr_Rel_Insert_Input>;
  /** Free booking where provider is an admin and doesn't want to charge themselves. */
  isFree?: InputMaybe<Scalars['Boolean']>;
  /** Needed due to portable (non-room) bookings */
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  model?: InputMaybe<Scalars['uuid']>;
  modelByModel?: InputMaybe<Model_Obj_Rel_Insert_Input>;
  modelRate?: InputMaybe<Scalars['Int']>;
  modelTaxRate?: InputMaybe<Scalars['numeric']>;
  patientBookingBookings?: InputMaybe<Patient_Booking_Booking_Arr_Rel_Insert_Input>;
  patientBookingMetadata?: InputMaybe<Patient_Booking_Metadata_Arr_Rel_Insert_Input>;
  productPurchases?: InputMaybe<Product_Purchase_Arr_Rel_Insert_Input>;
  /** The provider who is going to do the procedure */
  provider?: InputMaybe<Scalars['uuid']>;
  recurringBookingsSet?: InputMaybe<Booking_Arr_Rel_Insert_Input>;
  recurringKey?: InputMaybe<Scalars['uuid']>;
  room?: InputMaybe<Scalars['uuid']>;
  roomByRoom?: InputMaybe<Room_Obj_Rel_Insert_Input>;
  roomRate?: InputMaybe<Scalars['Int']>;
  roomTaxRate?: InputMaybe<Scalars['numeric']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Booking_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Booking_Max_Fields = {
  __typename?: 'booking_max_fields';
  cancelled_at?: Maybe<Scalars['timestamptz']>;
  confirmedAt?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** Needed due to portable (non-room) bookings */
  location?: Maybe<Scalars['uuid']>;
  model?: Maybe<Scalars['uuid']>;
  modelRate?: Maybe<Scalars['Int']>;
  modelTaxRate?: Maybe<Scalars['numeric']>;
  /** TEMPORARY wire-compat shim for pre-stacking app builds - always null */
  patient?: Maybe<Scalars['uuid']>;
  /** The provider who is going to do the procedure */
  provider?: Maybe<Scalars['uuid']>;
  recurringKey?: Maybe<Scalars['uuid']>;
  room?: Maybe<Scalars['uuid']>;
  roomRate?: Maybe<Scalars['Int']>;
  roomTaxRate?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "booking_timespan_lower" */
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  timespan_lower_bound?: Maybe<Scalars['timestamptz']>;
  /** lower(timespan) Postgres computed field */
  timespan_range_lower?: Maybe<Scalars['timestamptz']>;
  timespan_range_upper?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "booking_timespan_upper" */
  timespan_upper?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "booking" */
export type Booking_Max_Order_By = {
  cancelled_at?: InputMaybe<Order_By>;
  confirmedAt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Needed due to portable (non-room) bookings */
  location?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  modelRate?: InputMaybe<Order_By>;
  modelTaxRate?: InputMaybe<Order_By>;
  /** The provider who is going to do the procedure */
  provider?: InputMaybe<Order_By>;
  recurringKey?: InputMaybe<Order_By>;
  room?: InputMaybe<Order_By>;
  roomRate?: InputMaybe<Order_By>;
  roomTaxRate?: InputMaybe<Order_By>;
  timespan_lower_bound?: InputMaybe<Order_By>;
  /** lower(timespan) Postgres computed field */
  timespan_range_lower?: InputMaybe<Order_By>;
  timespan_range_upper?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Booking_Min_Fields = {
  __typename?: 'booking_min_fields';
  cancelled_at?: Maybe<Scalars['timestamptz']>;
  confirmedAt?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** Needed due to portable (non-room) bookings */
  location?: Maybe<Scalars['uuid']>;
  model?: Maybe<Scalars['uuid']>;
  modelRate?: Maybe<Scalars['Int']>;
  modelTaxRate?: Maybe<Scalars['numeric']>;
  /** TEMPORARY wire-compat shim for pre-stacking app builds - always null */
  patient?: Maybe<Scalars['uuid']>;
  /** The provider who is going to do the procedure */
  provider?: Maybe<Scalars['uuid']>;
  recurringKey?: Maybe<Scalars['uuid']>;
  room?: Maybe<Scalars['uuid']>;
  roomRate?: Maybe<Scalars['Int']>;
  roomTaxRate?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "booking_timespan_lower" */
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  timespan_lower_bound?: Maybe<Scalars['timestamptz']>;
  /** lower(timespan) Postgres computed field */
  timespan_range_lower?: Maybe<Scalars['timestamptz']>;
  timespan_range_upper?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "booking_timespan_upper" */
  timespan_upper?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "booking" */
export type Booking_Min_Order_By = {
  cancelled_at?: InputMaybe<Order_By>;
  confirmedAt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Needed due to portable (non-room) bookings */
  location?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  modelRate?: InputMaybe<Order_By>;
  modelTaxRate?: InputMaybe<Order_By>;
  /** The provider who is going to do the procedure */
  provider?: InputMaybe<Order_By>;
  recurringKey?: InputMaybe<Order_By>;
  room?: InputMaybe<Order_By>;
  roomRate?: InputMaybe<Order_By>;
  roomTaxRate?: InputMaybe<Order_By>;
  timespan_lower_bound?: InputMaybe<Order_By>;
  /** lower(timespan) Postgres computed field */
  timespan_range_lower?: InputMaybe<Order_By>;
  timespan_range_upper?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "booking" */
export type Booking_Mutation_Response = {
  __typename?: 'booking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Booking>;
};

/** input type for inserting object relation for remote table "booking" */
export type Booking_Obj_Rel_Insert_Input = {
  data: Booking_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Booking_On_Conflict>;
};

/** on_conflict condition type for table "booking" */
export type Booking_On_Conflict = {
  constraint: Booking_Constraint;
  update_columns?: Array<Booking_Update_Column>;
  where?: InputMaybe<Booking_Bool_Exp>;
};

/** Ordering options when selecting data from "booking". */
export type Booking_Order_By = {
  appointment_derived?: InputMaybe<Order_By>;
  cancelReason?: InputMaybe<Order_By>;
  cancelled_at?: InputMaybe<Order_By>;
  confirmedAt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  ehrEncounters_aggregate?: InputMaybe<Ehr_Encounter_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  invoices_aggregate?: InputMaybe<Invoice_Aggregate_Order_By>;
  isFree?: InputMaybe<Order_By>;
  isResourceFree?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  model?: InputMaybe<Order_By>;
  modelByModel?: InputMaybe<Model_Order_By>;
  modelRate?: InputMaybe<Order_By>;
  modelTaxRate?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  patientBookingBookings_aggregate?: InputMaybe<Patient_Booking_Booking_Aggregate_Order_By>;
  patientBookingMetadata_aggregate?: InputMaybe<Patient_Booking_Metadata_Aggregate_Order_By>;
  productPurchases_aggregate?: InputMaybe<Product_Purchase_Aggregate_Order_By>;
  provider?: InputMaybe<Order_By>;
  recurringBookingsSet_aggregate?: InputMaybe<Booking_Aggregate_Order_By>;
  recurringKey?: InputMaybe<Order_By>;
  room?: InputMaybe<Order_By>;
  roomByRoom?: InputMaybe<Room_Order_By>;
  roomRate?: InputMaybe<Order_By>;
  roomTaxRate?: InputMaybe<Order_By>;
  timespan?: InputMaybe<Order_By>;
  timespan_lower?: InputMaybe<Order_By>;
  timespan_lower_bound?: InputMaybe<Order_By>;
  timespan_range_lower?: InputMaybe<Order_By>;
  timespan_range_upper?: InputMaybe<Order_By>;
  timespan_upper?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userByProvider?: InputMaybe<User_Order_By>;
  visibleToSupervisor?: InputMaybe<Order_By>;
};

/** primary key columns input for table: booking */
export type Booking_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "booking_public" */
export type Booking_Public = {
  __typename?: 'booking_public';
  /** An object relationship */
  RoomByRoom?: Maybe<Room>;
  cancelled_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  model?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  modelByModel?: Maybe<Model>;
  provider?: Maybe<Scalars['uuid']>;
  room?: Maybe<Scalars['uuid']>;
  timespan?: Maybe<Scalars['tstzrange']>;
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  timespan_upper?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "booking_public" */
export type Booking_Public_Aggregate = {
  __typename?: 'booking_public_aggregate';
  aggregate?: Maybe<Booking_Public_Aggregate_Fields>;
  nodes: Array<Booking_Public>;
};

export type Booking_Public_Aggregate_Bool_Exp = {
  count?: InputMaybe<Booking_Public_Aggregate_Bool_Exp_Count>;
};

export type Booking_Public_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Booking_Public_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Booking_Public_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "booking_public" */
export type Booking_Public_Aggregate_Fields = {
  __typename?: 'booking_public_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Booking_Public_Max_Fields>;
  min?: Maybe<Booking_Public_Min_Fields>;
};


/** aggregate fields of "booking_public" */
export type Booking_Public_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Booking_Public_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "booking_public" */
export type Booking_Public_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Booking_Public_Max_Order_By>;
  min?: InputMaybe<Booking_Public_Min_Order_By>;
};

/** input type for inserting array relation for remote table "booking_public" */
export type Booking_Public_Arr_Rel_Insert_Input = {
  data: Array<Booking_Public_Insert_Input>;
};

/** Boolean expression to filter rows from the table "booking_public". All fields are combined with a logical 'AND'. */
export type Booking_Public_Bool_Exp = {
  RoomByRoom?: InputMaybe<Room_Bool_Exp>;
  _and?: InputMaybe<Array<Booking_Public_Bool_Exp>>;
  _not?: InputMaybe<Booking_Public_Bool_Exp>;
  _or?: InputMaybe<Array<Booking_Public_Bool_Exp>>;
  cancelled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  model?: InputMaybe<Uuid_Comparison_Exp>;
  modelByModel?: InputMaybe<Model_Bool_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  room?: InputMaybe<Uuid_Comparison_Exp>;
  timespan?: InputMaybe<Tstzrange_Comparison_Exp>;
  timespan_lower?: InputMaybe<Timestamptz_Comparison_Exp>;
  timespan_upper?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "booking_public" */
export type Booking_Public_Insert_Input = {
  RoomByRoom?: InputMaybe<Room_Obj_Rel_Insert_Input>;
  cancelled_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  model?: InputMaybe<Scalars['uuid']>;
  modelByModel?: InputMaybe<Model_Obj_Rel_Insert_Input>;
  provider?: InputMaybe<Scalars['uuid']>;
  room?: InputMaybe<Scalars['uuid']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
  timespan_lower?: InputMaybe<Scalars['timestamptz']>;
  timespan_upper?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Booking_Public_Max_Fields = {
  __typename?: 'booking_public_max_fields';
  cancelled_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  model?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  room?: Maybe<Scalars['uuid']>;
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  timespan_upper?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "booking_public" */
export type Booking_Public_Max_Order_By = {
  cancelled_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  room?: InputMaybe<Order_By>;
  timespan_lower?: InputMaybe<Order_By>;
  timespan_upper?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Booking_Public_Min_Fields = {
  __typename?: 'booking_public_min_fields';
  cancelled_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  model?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  room?: Maybe<Scalars['uuid']>;
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  timespan_upper?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "booking_public" */
export type Booking_Public_Min_Order_By = {
  cancelled_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  room?: InputMaybe<Order_By>;
  timespan_lower?: InputMaybe<Order_By>;
  timespan_upper?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "booking_public" */
export type Booking_Public_Mutation_Response = {
  __typename?: 'booking_public_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Booking_Public>;
};

/** Ordering options when selecting data from "booking_public". */
export type Booking_Public_Order_By = {
  RoomByRoom?: InputMaybe<Room_Order_By>;
  cancelled_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  modelByModel?: InputMaybe<Model_Order_By>;
  provider?: InputMaybe<Order_By>;
  room?: InputMaybe<Order_By>;
  timespan?: InputMaybe<Order_By>;
  timespan_lower?: InputMaybe<Order_By>;
  timespan_upper?: InputMaybe<Order_By>;
};

/** select columns of table "booking_public" */
export enum Booking_Public_Select_Column {
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Model = 'model',
  /** column name */
  Provider = 'provider',
  /** column name */
  Room = 'room',
  /** column name */
  Timespan = 'timespan',
  /** column name */
  TimespanLower = 'timespan_lower',
  /** column name */
  TimespanUpper = 'timespan_upper'
}

/** input type for updating data in table "booking_public" */
export type Booking_Public_Set_Input = {
  cancelled_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  model?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  room?: InputMaybe<Scalars['uuid']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
  timespan_lower?: InputMaybe<Scalars['timestamptz']>;
  timespan_upper?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "booking_public" */
export type Booking_Public_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Booking_Public_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Booking_Public_Stream_Cursor_Value_Input = {
  cancelled_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  model?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  room?: InputMaybe<Scalars['uuid']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
  timespan_lower?: InputMaybe<Scalars['timestamptz']>;
  timespan_upper?: InputMaybe<Scalars['timestamptz']>;
};

export type Booking_Public_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Booking_Public_Set_Input>;
  /** filter the rows which have to be updated */
  where: Booking_Public_Bool_Exp;
};

/** select columns of table "booking" */
export enum Booking_Select_Column {
  /** column name */
  AppointmentDerived = 'appointment_derived',
  /** column name */
  CancelReason = 'cancelReason',
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  ConfirmedAt = 'confirmedAt',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsFree = 'isFree',
  /** column name */
  IsResourceFree = 'isResourceFree',
  /** column name */
  Location = 'location',
  /** column name */
  Model = 'model',
  /** column name */
  ModelRate = 'modelRate',
  /** column name */
  ModelTaxRate = 'modelTaxRate',
  /** column name */
  Provider = 'provider',
  /** column name */
  RecurringKey = 'recurringKey',
  /** column name */
  Room = 'room',
  /** column name */
  RoomRate = 'roomRate',
  /** column name */
  RoomTaxRate = 'roomTaxRate',
  /** column name */
  Timespan = 'timespan',
  /** column name */
  TimespanLowerBound = 'timespan_lower_bound',
  /** column name */
  TimespanRangeLower = 'timespan_range_lower',
  /** column name */
  TimespanRangeUpper = 'timespan_range_upper',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "booking_aggregate_bool_exp_bool_and_arguments_columns" columns of table "booking" */
export enum Booking_Select_Column_Booking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AppointmentDerived = 'appointment_derived',
  /** column name */
  IsFree = 'isFree',
  /** column name */
  IsResourceFree = 'isResourceFree'
}

/** select "booking_aggregate_bool_exp_bool_or_arguments_columns" columns of table "booking" */
export enum Booking_Select_Column_Booking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AppointmentDerived = 'appointment_derived',
  /** column name */
  IsFree = 'isFree',
  /** column name */
  IsResourceFree = 'isResourceFree'
}

/** input type for updating data in table "booking" */
export type Booking_Set_Input = {
  appointment_derived?: InputMaybe<Scalars['Boolean']>;
  cancelReason?: InputMaybe<Cancel_Reason_Enum>;
  cancelled_at?: InputMaybe<Scalars['timestamptz']>;
  confirmedAt?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Free booking where provider is an admin and doesn't want to charge themselves. */
  isFree?: InputMaybe<Scalars['Boolean']>;
  /** Needed due to portable (non-room) bookings */
  location?: InputMaybe<Scalars['uuid']>;
  model?: InputMaybe<Scalars['uuid']>;
  modelRate?: InputMaybe<Scalars['Int']>;
  modelTaxRate?: InputMaybe<Scalars['numeric']>;
  /** The provider who is going to do the procedure */
  provider?: InputMaybe<Scalars['uuid']>;
  recurringKey?: InputMaybe<Scalars['uuid']>;
  room?: InputMaybe<Scalars['uuid']>;
  roomRate?: InputMaybe<Scalars['Int']>;
  roomTaxRate?: InputMaybe<Scalars['numeric']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Booking_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Booking_Stddev_Fields = {
  __typename?: 'booking_stddev_fields';
  modelRate?: Maybe<Scalars['Float']>;
  modelTaxRate?: Maybe<Scalars['Float']>;
  roomRate?: Maybe<Scalars['Float']>;
  roomTaxRate?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "booking" */
export type Booking_Stddev_Order_By = {
  modelRate?: InputMaybe<Order_By>;
  modelTaxRate?: InputMaybe<Order_By>;
  roomRate?: InputMaybe<Order_By>;
  roomTaxRate?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Booking_Stddev_Pop_Fields = {
  __typename?: 'booking_stddev_pop_fields';
  modelRate?: Maybe<Scalars['Float']>;
  modelTaxRate?: Maybe<Scalars['Float']>;
  roomRate?: Maybe<Scalars['Float']>;
  roomTaxRate?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "booking" */
export type Booking_Stddev_Pop_Order_By = {
  modelRate?: InputMaybe<Order_By>;
  modelTaxRate?: InputMaybe<Order_By>;
  roomRate?: InputMaybe<Order_By>;
  roomTaxRate?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Booking_Stddev_Samp_Fields = {
  __typename?: 'booking_stddev_samp_fields';
  modelRate?: Maybe<Scalars['Float']>;
  modelTaxRate?: Maybe<Scalars['Float']>;
  roomRate?: Maybe<Scalars['Float']>;
  roomTaxRate?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "booking" */
export type Booking_Stddev_Samp_Order_By = {
  modelRate?: InputMaybe<Order_By>;
  modelTaxRate?: InputMaybe<Order_By>;
  roomRate?: InputMaybe<Order_By>;
  roomTaxRate?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "booking" */
export type Booking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Booking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Booking_Stream_Cursor_Value_Input = {
  appointment_derived?: InputMaybe<Scalars['Boolean']>;
  cancelReason?: InputMaybe<Cancel_Reason_Enum>;
  cancelled_at?: InputMaybe<Scalars['timestamptz']>;
  confirmedAt?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Free booking where provider is an admin and doesn't want to charge themselves. */
  isFree?: InputMaybe<Scalars['Boolean']>;
  isResourceFree?: InputMaybe<Scalars['Boolean']>;
  /** Needed due to portable (non-room) bookings */
  location?: InputMaybe<Scalars['uuid']>;
  model?: InputMaybe<Scalars['uuid']>;
  modelRate?: InputMaybe<Scalars['Int']>;
  modelTaxRate?: InputMaybe<Scalars['numeric']>;
  /** The provider who is going to do the procedure */
  provider?: InputMaybe<Scalars['uuid']>;
  recurringKey?: InputMaybe<Scalars['uuid']>;
  room?: InputMaybe<Scalars['uuid']>;
  roomRate?: InputMaybe<Scalars['Int']>;
  roomTaxRate?: InputMaybe<Scalars['numeric']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
  timespan_lower_bound?: InputMaybe<Scalars['timestamptz']>;
  /** lower(timespan) Postgres computed field */
  timespan_range_lower?: InputMaybe<Scalars['timestamptz']>;
  timespan_range_upper?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Booking_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Booking_Sum_Fields = {
  __typename?: 'booking_sum_fields';
  modelRate?: Maybe<Scalars['Int']>;
  modelTaxRate?: Maybe<Scalars['numeric']>;
  roomRate?: Maybe<Scalars['Int']>;
  roomTaxRate?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "booking" */
export type Booking_Sum_Order_By = {
  modelRate?: InputMaybe<Order_By>;
  modelTaxRate?: InputMaybe<Order_By>;
  roomRate?: InputMaybe<Order_By>;
  roomTaxRate?: InputMaybe<Order_By>;
};

/** columns and relationships of "booking_type" */
export type Booking_Type = {
  __typename?: 'booking_type';
  name: Scalars['String'];
};

/** aggregated selection of "booking_type" */
export type Booking_Type_Aggregate = {
  __typename?: 'booking_type_aggregate';
  aggregate?: Maybe<Booking_Type_Aggregate_Fields>;
  nodes: Array<Booking_Type>;
};

/** aggregate fields of "booking_type" */
export type Booking_Type_Aggregate_Fields = {
  __typename?: 'booking_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Booking_Type_Max_Fields>;
  min?: Maybe<Booking_Type_Min_Fields>;
};


/** aggregate fields of "booking_type" */
export type Booking_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Booking_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "booking_type". All fields are combined with a logical 'AND'. */
export type Booking_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Booking_Type_Bool_Exp>>;
  _not?: InputMaybe<Booking_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Booking_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "booking_type" */
export enum Booking_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  LongTermBookingTypePkey = 'long_term_booking_type_pkey'
}

export enum Booking_Type_Enum {
  Monthly = 'MONTHLY',
  Standard = 'STANDARD',
  Weekly = 'WEEKLY'
}

/** Boolean expression to compare columns of type "booking_type_enum". All fields are combined with logical 'AND'. */
export type Booking_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Booking_Type_Enum>;
  _in?: InputMaybe<Array<Booking_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Booking_Type_Enum>;
  _nin?: InputMaybe<Array<Booking_Type_Enum>>;
};

/** input type for inserting data into table "booking_type" */
export type Booking_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Booking_Type_Max_Fields = {
  __typename?: 'booking_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Booking_Type_Min_Fields = {
  __typename?: 'booking_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "booking_type" */
export type Booking_Type_Mutation_Response = {
  __typename?: 'booking_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Booking_Type>;
};

/** on_conflict condition type for table "booking_type" */
export type Booking_Type_On_Conflict = {
  constraint: Booking_Type_Constraint;
  update_columns?: Array<Booking_Type_Update_Column>;
  where?: InputMaybe<Booking_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "booking_type". */
export type Booking_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: booking_type */
export type Booking_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "booking_type" */
export enum Booking_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "booking_type" */
export type Booking_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "booking_type" */
export type Booking_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Booking_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Booking_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "booking_type" */
export enum Booking_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Booking_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Booking_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Booking_Type_Bool_Exp;
};

/** update columns of table "booking" */
export enum Booking_Update_Column {
  /** column name */
  AppointmentDerived = 'appointment_derived',
  /** column name */
  CancelReason = 'cancelReason',
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  ConfirmedAt = 'confirmedAt',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsFree = 'isFree',
  /** column name */
  Location = 'location',
  /** column name */
  Model = 'model',
  /** column name */
  ModelRate = 'modelRate',
  /** column name */
  ModelTaxRate = 'modelTaxRate',
  /** column name */
  Provider = 'provider',
  /** column name */
  RecurringKey = 'recurringKey',
  /** column name */
  Room = 'room',
  /** column name */
  RoomRate = 'roomRate',
  /** column name */
  RoomTaxRate = 'roomTaxRate',
  /** column name */
  Timespan = 'timespan',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Booking_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Booking_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Booking_Set_Input>;
  /** filter the rows which have to be updated */
  where: Booking_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Booking_Var_Pop_Fields = {
  __typename?: 'booking_var_pop_fields';
  modelRate?: Maybe<Scalars['Float']>;
  modelTaxRate?: Maybe<Scalars['Float']>;
  roomRate?: Maybe<Scalars['Float']>;
  roomTaxRate?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "booking" */
export type Booking_Var_Pop_Order_By = {
  modelRate?: InputMaybe<Order_By>;
  modelTaxRate?: InputMaybe<Order_By>;
  roomRate?: InputMaybe<Order_By>;
  roomTaxRate?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Booking_Var_Samp_Fields = {
  __typename?: 'booking_var_samp_fields';
  modelRate?: Maybe<Scalars['Float']>;
  modelTaxRate?: Maybe<Scalars['Float']>;
  roomRate?: Maybe<Scalars['Float']>;
  roomTaxRate?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "booking" */
export type Booking_Var_Samp_Order_By = {
  modelRate?: InputMaybe<Order_By>;
  modelTaxRate?: InputMaybe<Order_By>;
  roomRate?: InputMaybe<Order_By>;
  roomTaxRate?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Booking_Variance_Fields = {
  __typename?: 'booking_variance_fields';
  modelRate?: Maybe<Scalars['Float']>;
  modelTaxRate?: Maybe<Scalars['Float']>;
  roomRate?: Maybe<Scalars['Float']>;
  roomTaxRate?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "booking" */
export type Booking_Variance_Order_By = {
  modelRate?: InputMaybe<Order_By>;
  modelTaxRate?: InputMaybe<Order_By>;
  roomRate?: InputMaybe<Order_By>;
  roomTaxRate?: InputMaybe<Order_By>;
};

/** columns and relationships of "cancel_reason" */
export type Cancel_Reason = {
  __typename?: 'cancel_reason';
  id: Scalars['String'];
};

/** aggregated selection of "cancel_reason" */
export type Cancel_Reason_Aggregate = {
  __typename?: 'cancel_reason_aggregate';
  aggregate?: Maybe<Cancel_Reason_Aggregate_Fields>;
  nodes: Array<Cancel_Reason>;
};

/** aggregate fields of "cancel_reason" */
export type Cancel_Reason_Aggregate_Fields = {
  __typename?: 'cancel_reason_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Cancel_Reason_Max_Fields>;
  min?: Maybe<Cancel_Reason_Min_Fields>;
};


/** aggregate fields of "cancel_reason" */
export type Cancel_Reason_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cancel_Reason_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "cancel_reason". All fields are combined with a logical 'AND'. */
export type Cancel_Reason_Bool_Exp = {
  _and?: InputMaybe<Array<Cancel_Reason_Bool_Exp>>;
  _not?: InputMaybe<Cancel_Reason_Bool_Exp>;
  _or?: InputMaybe<Array<Cancel_Reason_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cancel_reason" */
export enum Cancel_Reason_Constraint {
  /** unique or primary key constraint on columns "id" */
  CancelReasonPkey = 'cancel_reason_pkey'
}

export enum Cancel_Reason_Enum {
  ConfirmTimeout = 'CONFIRM_TIMEOUT',
  PreConfirm = 'PRE_CONFIRM',
  User = 'USER'
}

/** Boolean expression to compare columns of type "cancel_reason_enum". All fields are combined with logical 'AND'. */
export type Cancel_Reason_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Cancel_Reason_Enum>;
  _in?: InputMaybe<Array<Cancel_Reason_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Cancel_Reason_Enum>;
  _nin?: InputMaybe<Array<Cancel_Reason_Enum>>;
};

/** input type for inserting data into table "cancel_reason" */
export type Cancel_Reason_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Cancel_Reason_Max_Fields = {
  __typename?: 'cancel_reason_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Cancel_Reason_Min_Fields = {
  __typename?: 'cancel_reason_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "cancel_reason" */
export type Cancel_Reason_Mutation_Response = {
  __typename?: 'cancel_reason_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cancel_Reason>;
};

/** on_conflict condition type for table "cancel_reason" */
export type Cancel_Reason_On_Conflict = {
  constraint: Cancel_Reason_Constraint;
  update_columns?: Array<Cancel_Reason_Update_Column>;
  where?: InputMaybe<Cancel_Reason_Bool_Exp>;
};

/** Ordering options when selecting data from "cancel_reason". */
export type Cancel_Reason_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cancel_reason */
export type Cancel_Reason_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "cancel_reason" */
export enum Cancel_Reason_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "cancel_reason" */
export type Cancel_Reason_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "cancel_reason" */
export type Cancel_Reason_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cancel_Reason_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cancel_Reason_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "cancel_reason" */
export enum Cancel_Reason_Update_Column {
  /** column name */
  Id = 'id'
}

export type Cancel_Reason_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cancel_Reason_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cancel_Reason_Bool_Exp;
};

export type Check_Proposed_Patient_Booking_For_Stacking_Args = {
  location_procedure_id?: InputMaybe<Scalars['uuid']>;
  proposed_timespan_1?: InputMaybe<Scalars['tstzrange']>;
  proposed_timespan_2?: InputMaybe<Scalars['tstzrange']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
};

export type ConfirmCognitoUserInput = {
  id: Scalars['uuid'];
};

export type ConfirmCognitoUserOutput = {
  __typename?: 'confirmCognitoUserOutput';
  status: Scalars['String'];
};

export type ConsentedAt_User_Args = {
  consentType?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "credit" */
export type Credit = {
  __typename?: 'credit';
  active: Scalars['Boolean'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  credit_type: Credit_Type;
  currentBalance: Scalars['Int'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  initialBalance: Scalars['Int'];
  location?: Maybe<Scalars['uuid']>;
  type: Credit_Type_Enum;
  updated_at: Scalars['timestamptz'];
  user: Scalars['uuid'];
  /** An object relationship */
  userByUser: User;
};

/** aggregated selection of "credit" */
export type Credit_Aggregate = {
  __typename?: 'credit_aggregate';
  aggregate?: Maybe<Credit_Aggregate_Fields>;
  nodes: Array<Credit>;
};

export type Credit_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Credit_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Credit_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Credit_Aggregate_Bool_Exp_Count>;
};

export type Credit_Aggregate_Bool_Exp_Bool_And = {
  arguments: Credit_Select_Column_Credit_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Credit_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Credit_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Credit_Select_Column_Credit_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Credit_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Credit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Credit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Credit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "credit" */
export type Credit_Aggregate_Fields = {
  __typename?: 'credit_aggregate_fields';
  avg?: Maybe<Credit_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Credit_Max_Fields>;
  min?: Maybe<Credit_Min_Fields>;
  stddev?: Maybe<Credit_Stddev_Fields>;
  stddev_pop?: Maybe<Credit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Credit_Stddev_Samp_Fields>;
  sum?: Maybe<Credit_Sum_Fields>;
  var_pop?: Maybe<Credit_Var_Pop_Fields>;
  var_samp?: Maybe<Credit_Var_Samp_Fields>;
  variance?: Maybe<Credit_Variance_Fields>;
};


/** aggregate fields of "credit" */
export type Credit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Credit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "credit" */
export type Credit_Aggregate_Order_By = {
  avg?: InputMaybe<Credit_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Credit_Max_Order_By>;
  min?: InputMaybe<Credit_Min_Order_By>;
  stddev?: InputMaybe<Credit_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Credit_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Credit_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Credit_Sum_Order_By>;
  var_pop?: InputMaybe<Credit_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Credit_Var_Samp_Order_By>;
  variance?: InputMaybe<Credit_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "credit" */
export type Credit_Arr_Rel_Insert_Input = {
  data: Array<Credit_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Credit_On_Conflict>;
};

/** aggregate avg on columns */
export type Credit_Avg_Fields = {
  __typename?: 'credit_avg_fields';
  currentBalance?: Maybe<Scalars['Float']>;
  initialBalance?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "credit" */
export type Credit_Avg_Order_By = {
  currentBalance?: InputMaybe<Order_By>;
  initialBalance?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "credit". All fields are combined with a logical 'AND'. */
export type Credit_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Bool_Exp>>;
  _not?: InputMaybe<Credit_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_type?: InputMaybe<Credit_Type_Bool_Exp>;
  currentBalance?: InputMaybe<Int_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  initialBalance?: InputMaybe<Int_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Credit_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Uuid_Comparison_Exp>;
  userByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "credit" */
export enum Credit_Constraint {
  /** unique or primary key constraint on columns "id" */
  CreditPkey = 'credit_pkey'
}

/** input type for incrementing numeric columns in table "credit" */
export type Credit_Inc_Input = {
  currentBalance?: InputMaybe<Scalars['Int']>;
  initialBalance?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "credit" */
export type Credit_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credit_type?: InputMaybe<Credit_Type_Obj_Rel_Insert_Input>;
  currentBalance?: InputMaybe<Scalars['Int']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  initialBalance?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Credit_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
  userByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Credit_Max_Fields = {
  __typename?: 'credit_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  currentBalance?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  initialBalance?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "credit" */
export type Credit_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  currentBalance?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initialBalance?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Credit_Min_Fields = {
  __typename?: 'credit_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  currentBalance?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  initialBalance?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "credit" */
export type Credit_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  currentBalance?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initialBalance?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "credit" */
export type Credit_Mutation_Response = {
  __typename?: 'credit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Credit>;
};

/** input type for inserting object relation for remote table "credit" */
export type Credit_Obj_Rel_Insert_Input = {
  data: Credit_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Credit_On_Conflict>;
};

/** on_conflict condition type for table "credit" */
export type Credit_On_Conflict = {
  constraint: Credit_Constraint;
  update_columns?: Array<Credit_Update_Column>;
  where?: InputMaybe<Credit_Bool_Exp>;
};

/** Ordering options when selecting data from "credit". */
export type Credit_Order_By = {
  active?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_type?: InputMaybe<Credit_Type_Order_By>;
  currentBalance?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initialBalance?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  userByUser?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: credit */
export type Credit_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "credit" */
export enum Credit_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentBalance = 'currentBalance',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  InitialBalance = 'initialBalance',
  /** column name */
  Location = 'location',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  User = 'user'
}

/** select "credit_aggregate_bool_exp_bool_and_arguments_columns" columns of table "credit" */
export enum Credit_Select_Column_Credit_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active'
}

/** select "credit_aggregate_bool_exp_bool_or_arguments_columns" columns of table "credit" */
export enum Credit_Select_Column_Credit_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active'
}

/** input type for updating data in table "credit" */
export type Credit_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currentBalance?: InputMaybe<Scalars['Int']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  initialBalance?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Credit_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Credit_Stddev_Fields = {
  __typename?: 'credit_stddev_fields';
  currentBalance?: Maybe<Scalars['Float']>;
  initialBalance?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "credit" */
export type Credit_Stddev_Order_By = {
  currentBalance?: InputMaybe<Order_By>;
  initialBalance?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Credit_Stddev_Pop_Fields = {
  __typename?: 'credit_stddev_pop_fields';
  currentBalance?: Maybe<Scalars['Float']>;
  initialBalance?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "credit" */
export type Credit_Stddev_Pop_Order_By = {
  currentBalance?: InputMaybe<Order_By>;
  initialBalance?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Credit_Stddev_Samp_Fields = {
  __typename?: 'credit_stddev_samp_fields';
  currentBalance?: Maybe<Scalars['Float']>;
  initialBalance?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "credit" */
export type Credit_Stddev_Samp_Order_By = {
  currentBalance?: InputMaybe<Order_By>;
  initialBalance?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "credit" */
export type Credit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currentBalance?: InputMaybe<Scalars['Int']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  initialBalance?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Credit_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Credit_Sum_Fields = {
  __typename?: 'credit_sum_fields';
  currentBalance?: Maybe<Scalars['Int']>;
  initialBalance?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "credit" */
export type Credit_Sum_Order_By = {
  currentBalance?: InputMaybe<Order_By>;
  initialBalance?: InputMaybe<Order_By>;
};

/** columns and relationships of "credit_transaction" */
export type Credit_Transaction = {
  __typename?: 'credit_transaction';
  created_at: Scalars['timestamptz'];
  credit: Scalars['uuid'];
  /** An object relationship */
  creditByCredit: Credit;
  debit: Scalars['Int'];
  id: Scalars['uuid'];
  stripeInvoiceId?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "credit_transaction" */
export type Credit_Transaction_Aggregate = {
  __typename?: 'credit_transaction_aggregate';
  aggregate?: Maybe<Credit_Transaction_Aggregate_Fields>;
  nodes: Array<Credit_Transaction>;
};

/** aggregate fields of "credit_transaction" */
export type Credit_Transaction_Aggregate_Fields = {
  __typename?: 'credit_transaction_aggregate_fields';
  avg?: Maybe<Credit_Transaction_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Credit_Transaction_Max_Fields>;
  min?: Maybe<Credit_Transaction_Min_Fields>;
  stddev?: Maybe<Credit_Transaction_Stddev_Fields>;
  stddev_pop?: Maybe<Credit_Transaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Credit_Transaction_Stddev_Samp_Fields>;
  sum?: Maybe<Credit_Transaction_Sum_Fields>;
  var_pop?: Maybe<Credit_Transaction_Var_Pop_Fields>;
  var_samp?: Maybe<Credit_Transaction_Var_Samp_Fields>;
  variance?: Maybe<Credit_Transaction_Variance_Fields>;
};


/** aggregate fields of "credit_transaction" */
export type Credit_Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Credit_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Credit_Transaction_Avg_Fields = {
  __typename?: 'credit_transaction_avg_fields';
  debit?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "credit_transaction". All fields are combined with a logical 'AND'. */
export type Credit_Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Transaction_Bool_Exp>>;
  _not?: InputMaybe<Credit_Transaction_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Transaction_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit?: InputMaybe<Uuid_Comparison_Exp>;
  creditByCredit?: InputMaybe<Credit_Bool_Exp>;
  debit?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  stripeInvoiceId?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "credit_transaction" */
export enum Credit_Transaction_Constraint {
  /** unique or primary key constraint on columns "id" */
  CreditTransactionPkey = 'credit_transaction_pkey'
}

/** input type for incrementing numeric columns in table "credit_transaction" */
export type Credit_Transaction_Inc_Input = {
  debit?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "credit_transaction" */
export type Credit_Transaction_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credit?: InputMaybe<Scalars['uuid']>;
  creditByCredit?: InputMaybe<Credit_Obj_Rel_Insert_Input>;
  debit?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  stripeInvoiceId?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Credit_Transaction_Max_Fields = {
  __typename?: 'credit_transaction_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  credit?: Maybe<Scalars['uuid']>;
  debit?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Credit_Transaction_Min_Fields = {
  __typename?: 'credit_transaction_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  credit?: Maybe<Scalars['uuid']>;
  debit?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "credit_transaction" */
export type Credit_Transaction_Mutation_Response = {
  __typename?: 'credit_transaction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Credit_Transaction>;
};

/** on_conflict condition type for table "credit_transaction" */
export type Credit_Transaction_On_Conflict = {
  constraint: Credit_Transaction_Constraint;
  update_columns?: Array<Credit_Transaction_Update_Column>;
  where?: InputMaybe<Credit_Transaction_Bool_Exp>;
};

/** Ordering options when selecting data from "credit_transaction". */
export type Credit_Transaction_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credit?: InputMaybe<Order_By>;
  creditByCredit?: InputMaybe<Credit_Order_By>;
  debit?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stripeInvoiceId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: credit_transaction */
export type Credit_Transaction_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "credit_transaction" */
export enum Credit_Transaction_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Credit = 'credit',
  /** column name */
  Debit = 'debit',
  /** column name */
  Id = 'id',
  /** column name */
  StripeInvoiceId = 'stripeInvoiceId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "credit_transaction" */
export type Credit_Transaction_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credit?: InputMaybe<Scalars['uuid']>;
  debit?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  stripeInvoiceId?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Credit_Transaction_Stddev_Fields = {
  __typename?: 'credit_transaction_stddev_fields';
  debit?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Credit_Transaction_Stddev_Pop_Fields = {
  __typename?: 'credit_transaction_stddev_pop_fields';
  debit?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Credit_Transaction_Stddev_Samp_Fields = {
  __typename?: 'credit_transaction_stddev_samp_fields';
  debit?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "credit_transaction" */
export type Credit_Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Transaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Transaction_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credit?: InputMaybe<Scalars['uuid']>;
  debit?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  stripeInvoiceId?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Credit_Transaction_Sum_Fields = {
  __typename?: 'credit_transaction_sum_fields';
  debit?: Maybe<Scalars['Int']>;
};

/** update columns of table "credit_transaction" */
export enum Credit_Transaction_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Credit = 'credit',
  /** column name */
  Debit = 'debit',
  /** column name */
  Id = 'id',
  /** column name */
  StripeInvoiceId = 'stripeInvoiceId',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Credit_Transaction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Credit_Transaction_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Credit_Transaction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Credit_Transaction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Credit_Transaction_Var_Pop_Fields = {
  __typename?: 'credit_transaction_var_pop_fields';
  debit?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Credit_Transaction_Var_Samp_Fields = {
  __typename?: 'credit_transaction_var_samp_fields';
  debit?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Credit_Transaction_Variance_Fields = {
  __typename?: 'credit_transaction_variance_fields';
  debit?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "credit_type" */
export type Credit_Type = {
  __typename?: 'credit_type';
  id: Scalars['String'];
};

/** aggregated selection of "credit_type" */
export type Credit_Type_Aggregate = {
  __typename?: 'credit_type_aggregate';
  aggregate?: Maybe<Credit_Type_Aggregate_Fields>;
  nodes: Array<Credit_Type>;
};

/** aggregate fields of "credit_type" */
export type Credit_Type_Aggregate_Fields = {
  __typename?: 'credit_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Credit_Type_Max_Fields>;
  min?: Maybe<Credit_Type_Min_Fields>;
};


/** aggregate fields of "credit_type" */
export type Credit_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Credit_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "credit_type". All fields are combined with a logical 'AND'. */
export type Credit_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Type_Bool_Exp>>;
  _not?: InputMaybe<Credit_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Type_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "credit_type" */
export enum Credit_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  CreditTypePkey = 'credit_type_pkey'
}

export enum Credit_Type_Enum {
  All = 'All',
  Booking = 'Booking'
}

/** Boolean expression to compare columns of type "credit_type_enum". All fields are combined with logical 'AND'. */
export type Credit_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Credit_Type_Enum>;
  _in?: InputMaybe<Array<Credit_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Credit_Type_Enum>;
  _nin?: InputMaybe<Array<Credit_Type_Enum>>;
};

/** input type for inserting data into table "credit_type" */
export type Credit_Type_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Credit_Type_Max_Fields = {
  __typename?: 'credit_type_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Credit_Type_Min_Fields = {
  __typename?: 'credit_type_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "credit_type" */
export type Credit_Type_Mutation_Response = {
  __typename?: 'credit_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Credit_Type>;
};

/** input type for inserting object relation for remote table "credit_type" */
export type Credit_Type_Obj_Rel_Insert_Input = {
  data: Credit_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Credit_Type_On_Conflict>;
};

/** on_conflict condition type for table "credit_type" */
export type Credit_Type_On_Conflict = {
  constraint: Credit_Type_Constraint;
  update_columns?: Array<Credit_Type_Update_Column>;
  where?: InputMaybe<Credit_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "credit_type". */
export type Credit_Type_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: credit_type */
export type Credit_Type_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "credit_type" */
export enum Credit_Type_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "credit_type" */
export type Credit_Type_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "credit_type" */
export type Credit_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Type_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "credit_type" */
export enum Credit_Type_Update_Column {
  /** column name */
  Id = 'id'
}

export type Credit_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Credit_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Credit_Type_Bool_Exp;
};

/** update columns of table "credit" */
export enum Credit_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentBalance = 'currentBalance',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  InitialBalance = 'initialBalance',
  /** column name */
  Location = 'location',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  User = 'user'
}

export type Credit_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Credit_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Credit_Set_Input>;
  /** filter the rows which have to be updated */
  where: Credit_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Credit_Var_Pop_Fields = {
  __typename?: 'credit_var_pop_fields';
  currentBalance?: Maybe<Scalars['Float']>;
  initialBalance?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "credit" */
export type Credit_Var_Pop_Order_By = {
  currentBalance?: InputMaybe<Order_By>;
  initialBalance?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Credit_Var_Samp_Fields = {
  __typename?: 'credit_var_samp_fields';
  currentBalance?: Maybe<Scalars['Float']>;
  initialBalance?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "credit" */
export type Credit_Var_Samp_Order_By = {
  currentBalance?: InputMaybe<Order_By>;
  initialBalance?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Credit_Variance_Fields = {
  __typename?: 'credit_variance_fields';
  currentBalance?: Maybe<Scalars['Float']>;
  initialBalance?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "credit" */
export type Credit_Variance_Order_By = {
  currentBalance?: InputMaybe<Order_By>;
  initialBalance?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** Marks a location as a demo location; a provider at one is a demo account */
export type Demo_Location = {
  __typename?: 'demo_location';
  createdAt: Scalars['timestamptz'];
  /** Form templates a demo account may hold at this location, archived and drafts included */
  formTemplateLimit: Scalars['Int'];
  /** A computed field, executes function "demo_form_templates_used" */
  formTemplatesUsed?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  /** Notes a demo account may create, counted at every location, deleted ones included */
  noteLimit: Scalars['Int'];
  /** A computed field, executes function "demo_notes_used" */
  notesUsed?: Maybe<Scalars['Int']>;
  /** Sends plus resends a demo account may make at this location */
  sendLimit: Scalars['Int'];
  /** A computed field, executes function "demo_sends_used" */
  sendsUsed?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "demo_set_up" */
  setUp?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  signingVansanityTemplateByStarterTemplate: Signing_Vansanity_Template;
  /** The public template each demo account here is given a copy of */
  starterTemplate: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "demo_location" */
export type Demo_Location_Aggregate = {
  __typename?: 'demo_location_aggregate';
  aggregate?: Maybe<Demo_Location_Aggregate_Fields>;
  nodes: Array<Demo_Location>;
};

/** aggregate fields of "demo_location" */
export type Demo_Location_Aggregate_Fields = {
  __typename?: 'demo_location_aggregate_fields';
  avg?: Maybe<Demo_Location_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Demo_Location_Max_Fields>;
  min?: Maybe<Demo_Location_Min_Fields>;
  stddev?: Maybe<Demo_Location_Stddev_Fields>;
  stddev_pop?: Maybe<Demo_Location_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Demo_Location_Stddev_Samp_Fields>;
  sum?: Maybe<Demo_Location_Sum_Fields>;
  var_pop?: Maybe<Demo_Location_Var_Pop_Fields>;
  var_samp?: Maybe<Demo_Location_Var_Samp_Fields>;
  variance?: Maybe<Demo_Location_Variance_Fields>;
};


/** aggregate fields of "demo_location" */
export type Demo_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Demo_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Demo_Location_Avg_Fields = {
  __typename?: 'demo_location_avg_fields';
  /** Form templates a demo account may hold at this location, archived and drafts included */
  formTemplateLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_form_templates_used" */
  formTemplatesUsed?: Maybe<Scalars['Int']>;
  /** Notes a demo account may create, counted at every location, deleted ones included */
  noteLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_notes_used" */
  notesUsed?: Maybe<Scalars['Int']>;
  /** Sends plus resends a demo account may make at this location */
  sendLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_sends_used" */
  sendsUsed?: Maybe<Scalars['Int']>;
};

/** Boolean expression to filter rows from the table "demo_location". All fields are combined with a logical 'AND'. */
export type Demo_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Demo_Location_Bool_Exp>>;
  _not?: InputMaybe<Demo_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Demo_Location_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  formTemplateLimit?: InputMaybe<Int_Comparison_Exp>;
  formTemplatesUsed?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  noteLimit?: InputMaybe<Int_Comparison_Exp>;
  notesUsed?: InputMaybe<Int_Comparison_Exp>;
  sendLimit?: InputMaybe<Int_Comparison_Exp>;
  sendsUsed?: InputMaybe<Int_Comparison_Exp>;
  setUp?: InputMaybe<Boolean_Comparison_Exp>;
  signingVansanityTemplateByStarterTemplate?: InputMaybe<Signing_Vansanity_Template_Bool_Exp>;
  starterTemplate?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "demo_location" */
export enum Demo_Location_Constraint {
  /** unique or primary key constraint on columns "location" */
  DemoLocationLocationKey = 'demo_location_location_key',
  /** unique or primary key constraint on columns "id" */
  DemoLocationPkey = 'demo_location_pkey'
}

/** input type for incrementing numeric columns in table "demo_location" */
export type Demo_Location_Inc_Input = {
  /** Form templates a demo account may hold at this location, archived and drafts included */
  formTemplateLimit?: InputMaybe<Scalars['Int']>;
  /** Notes a demo account may create, counted at every location, deleted ones included */
  noteLimit?: InputMaybe<Scalars['Int']>;
  /** Sends plus resends a demo account may make at this location */
  sendLimit?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "demo_location" */
export type Demo_Location_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Form templates a demo account may hold at this location, archived and drafts included */
  formTemplateLimit?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  /** Notes a demo account may create, counted at every location, deleted ones included */
  noteLimit?: InputMaybe<Scalars['Int']>;
  /** Sends plus resends a demo account may make at this location */
  sendLimit?: InputMaybe<Scalars['Int']>;
  signingVansanityTemplateByStarterTemplate?: InputMaybe<Signing_Vansanity_Template_Obj_Rel_Insert_Input>;
  /** The public template each demo account here is given a copy of */
  starterTemplate?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Demo_Location_Max_Fields = {
  __typename?: 'demo_location_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Form templates a demo account may hold at this location, archived and drafts included */
  formTemplateLimit?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "demo_form_templates_used" */
  formTemplatesUsed?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  /** Notes a demo account may create, counted at every location, deleted ones included */
  noteLimit?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "demo_notes_used" */
  notesUsed?: Maybe<Scalars['Int']>;
  /** Sends plus resends a demo account may make at this location */
  sendLimit?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "demo_sends_used" */
  sendsUsed?: Maybe<Scalars['Int']>;
  /** The public template each demo account here is given a copy of */
  starterTemplate?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Demo_Location_Min_Fields = {
  __typename?: 'demo_location_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** Form templates a demo account may hold at this location, archived and drafts included */
  formTemplateLimit?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "demo_form_templates_used" */
  formTemplatesUsed?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  /** Notes a demo account may create, counted at every location, deleted ones included */
  noteLimit?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "demo_notes_used" */
  notesUsed?: Maybe<Scalars['Int']>;
  /** Sends plus resends a demo account may make at this location */
  sendLimit?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "demo_sends_used" */
  sendsUsed?: Maybe<Scalars['Int']>;
  /** The public template each demo account here is given a copy of */
  starterTemplate?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "demo_location" */
export type Demo_Location_Mutation_Response = {
  __typename?: 'demo_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Demo_Location>;
};

/** on_conflict condition type for table "demo_location" */
export type Demo_Location_On_Conflict = {
  constraint: Demo_Location_Constraint;
  update_columns?: Array<Demo_Location_Update_Column>;
  where?: InputMaybe<Demo_Location_Bool_Exp>;
};

/** Ordering options when selecting data from "demo_location". */
export type Demo_Location_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  formTemplateLimit?: InputMaybe<Order_By>;
  formTemplatesUsed?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  noteLimit?: InputMaybe<Order_By>;
  notesUsed?: InputMaybe<Order_By>;
  sendLimit?: InputMaybe<Order_By>;
  sendsUsed?: InputMaybe<Order_By>;
  setUp?: InputMaybe<Order_By>;
  signingVansanityTemplateByStarterTemplate?: InputMaybe<Signing_Vansanity_Template_Order_By>;
  starterTemplate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: demo_location */
export type Demo_Location_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "demo_location" */
export enum Demo_Location_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FormTemplateLimit = 'formTemplateLimit',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  NoteLimit = 'noteLimit',
  /** column name */
  SendLimit = 'sendLimit',
  /** column name */
  StarterTemplate = 'starterTemplate',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "demo_location" */
export type Demo_Location_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Form templates a demo account may hold at this location, archived and drafts included */
  formTemplateLimit?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  /** Notes a demo account may create, counted at every location, deleted ones included */
  noteLimit?: InputMaybe<Scalars['Int']>;
  /** Sends plus resends a demo account may make at this location */
  sendLimit?: InputMaybe<Scalars['Int']>;
  /** The public template each demo account here is given a copy of */
  starterTemplate?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Demo_Location_Stddev_Fields = {
  __typename?: 'demo_location_stddev_fields';
  /** Form templates a demo account may hold at this location, archived and drafts included */
  formTemplateLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_form_templates_used" */
  formTemplatesUsed?: Maybe<Scalars['Int']>;
  /** Notes a demo account may create, counted at every location, deleted ones included */
  noteLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_notes_used" */
  notesUsed?: Maybe<Scalars['Int']>;
  /** Sends plus resends a demo account may make at this location */
  sendLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_sends_used" */
  sendsUsed?: Maybe<Scalars['Int']>;
};

/** aggregate stddev_pop on columns */
export type Demo_Location_Stddev_Pop_Fields = {
  __typename?: 'demo_location_stddev_pop_fields';
  /** Form templates a demo account may hold at this location, archived and drafts included */
  formTemplateLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_form_templates_used" */
  formTemplatesUsed?: Maybe<Scalars['Int']>;
  /** Notes a demo account may create, counted at every location, deleted ones included */
  noteLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_notes_used" */
  notesUsed?: Maybe<Scalars['Int']>;
  /** Sends plus resends a demo account may make at this location */
  sendLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_sends_used" */
  sendsUsed?: Maybe<Scalars['Int']>;
};

/** aggregate stddev_samp on columns */
export type Demo_Location_Stddev_Samp_Fields = {
  __typename?: 'demo_location_stddev_samp_fields';
  /** Form templates a demo account may hold at this location, archived and drafts included */
  formTemplateLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_form_templates_used" */
  formTemplatesUsed?: Maybe<Scalars['Int']>;
  /** Notes a demo account may create, counted at every location, deleted ones included */
  noteLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_notes_used" */
  notesUsed?: Maybe<Scalars['Int']>;
  /** Sends plus resends a demo account may make at this location */
  sendLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_sends_used" */
  sendsUsed?: Maybe<Scalars['Int']>;
};

/** Streaming cursor of the table "demo_location" */
export type Demo_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Demo_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Demo_Location_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** Form templates a demo account may hold at this location, archived and drafts included */
  formTemplateLimit?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  /** Notes a demo account may create, counted at every location, deleted ones included */
  noteLimit?: InputMaybe<Scalars['Int']>;
  /** Sends plus resends a demo account may make at this location */
  sendLimit?: InputMaybe<Scalars['Int']>;
  /** The public template each demo account here is given a copy of */
  starterTemplate?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Demo_Location_Sum_Fields = {
  __typename?: 'demo_location_sum_fields';
  /** Form templates a demo account may hold at this location, archived and drafts included */
  formTemplateLimit?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "demo_form_templates_used" */
  formTemplatesUsed?: Maybe<Scalars['Int']>;
  /** Notes a demo account may create, counted at every location, deleted ones included */
  noteLimit?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "demo_notes_used" */
  notesUsed?: Maybe<Scalars['Int']>;
  /** Sends plus resends a demo account may make at this location */
  sendLimit?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "demo_sends_used" */
  sendsUsed?: Maybe<Scalars['Int']>;
};

/** update columns of table "demo_location" */
export enum Demo_Location_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FormTemplateLimit = 'formTemplateLimit',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  NoteLimit = 'noteLimit',
  /** column name */
  SendLimit = 'sendLimit',
  /** column name */
  StarterTemplate = 'starterTemplate',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Demo_Location_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Demo_Location_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Demo_Location_Set_Input>;
  /** filter the rows which have to be updated */
  where: Demo_Location_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Demo_Location_Var_Pop_Fields = {
  __typename?: 'demo_location_var_pop_fields';
  /** Form templates a demo account may hold at this location, archived and drafts included */
  formTemplateLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_form_templates_used" */
  formTemplatesUsed?: Maybe<Scalars['Int']>;
  /** Notes a demo account may create, counted at every location, deleted ones included */
  noteLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_notes_used" */
  notesUsed?: Maybe<Scalars['Int']>;
  /** Sends plus resends a demo account may make at this location */
  sendLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_sends_used" */
  sendsUsed?: Maybe<Scalars['Int']>;
};

/** aggregate var_samp on columns */
export type Demo_Location_Var_Samp_Fields = {
  __typename?: 'demo_location_var_samp_fields';
  /** Form templates a demo account may hold at this location, archived and drafts included */
  formTemplateLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_form_templates_used" */
  formTemplatesUsed?: Maybe<Scalars['Int']>;
  /** Notes a demo account may create, counted at every location, deleted ones included */
  noteLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_notes_used" */
  notesUsed?: Maybe<Scalars['Int']>;
  /** Sends plus resends a demo account may make at this location */
  sendLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_sends_used" */
  sendsUsed?: Maybe<Scalars['Int']>;
};

/** aggregate variance on columns */
export type Demo_Location_Variance_Fields = {
  __typename?: 'demo_location_variance_fields';
  /** Form templates a demo account may hold at this location, archived and drafts included */
  formTemplateLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_form_templates_used" */
  formTemplatesUsed?: Maybe<Scalars['Int']>;
  /** Notes a demo account may create, counted at every location, deleted ones included */
  noteLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_notes_used" */
  notesUsed?: Maybe<Scalars['Int']>;
  /** Sends plus resends a demo account may make at this location */
  sendLimit?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "demo_sends_used" */
  sendsUsed?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "document_type" */
export type Document_Type = {
  __typename?: 'document_type';
  id: Scalars['String'];
};

/** aggregated selection of "document_type" */
export type Document_Type_Aggregate = {
  __typename?: 'document_type_aggregate';
  aggregate?: Maybe<Document_Type_Aggregate_Fields>;
  nodes: Array<Document_Type>;
};

/** aggregate fields of "document_type" */
export type Document_Type_Aggregate_Fields = {
  __typename?: 'document_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Document_Type_Max_Fields>;
  min?: Maybe<Document_Type_Min_Fields>;
};


/** aggregate fields of "document_type" */
export type Document_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "document_type". All fields are combined with a logical 'AND'. */
export type Document_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Type_Bool_Exp>>;
  _not?: InputMaybe<Document_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Type_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_type" */
export enum Document_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentTypePkey = 'document_type_pkey'
}

export enum Document_Type_Enum {
  License = 'License',
  Malpractice = 'Malpractice',
  MedicalDirector = 'Medical_Director'
}

/** Boolean expression to compare columns of type "document_type_enum". All fields are combined with logical 'AND'. */
export type Document_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Document_Type_Enum>;
  _in?: InputMaybe<Array<Document_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Document_Type_Enum>;
  _nin?: InputMaybe<Array<Document_Type_Enum>>;
};

/** input type for inserting data into table "document_type" */
export type Document_Type_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Document_Type_Max_Fields = {
  __typename?: 'document_type_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Document_Type_Min_Fields = {
  __typename?: 'document_type_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "document_type" */
export type Document_Type_Mutation_Response = {
  __typename?: 'document_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Type>;
};

/** input type for inserting object relation for remote table "document_type" */
export type Document_Type_Obj_Rel_Insert_Input = {
  data: Document_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Type_On_Conflict>;
};

/** on_conflict condition type for table "document_type" */
export type Document_Type_On_Conflict = {
  constraint: Document_Type_Constraint;
  update_columns?: Array<Document_Type_Update_Column>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "document_type". */
export type Document_Type_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: document_type */
export type Document_Type_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "document_type" */
export enum Document_Type_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "document_type" */
export type Document_Type_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "document_type" */
export type Document_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Type_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "document_type" */
export enum Document_Type_Update_Column {
  /** column name */
  Id = 'id'
}

export type Document_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Document_Type_Bool_Exp;
};

export type EhrConsentedAt_Patient_Args = {
  consentType?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "ehr_charge_ledger" */
export type Ehr_Charge_Ledger = {
  __typename?: 'ehr_charge_ledger';
  amountCents: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  encounter?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  encounterByEncounter?: Maybe<Ehr_Encounter>;
  id: Scalars['uuid'];
  /** The client's key for this charge. Unique across the table; NULL when the client sent none. */
  idempotencyKey?: Maybe<Scalars['uuid']>;
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  patient: Scalars['uuid'];
  /** An object relationship */
  patientBookingByPatientBooking?: Maybe<Patient_Booking>;
  /** An object relationship */
  patientByPatient: Patient;
  patient_booking?: Maybe<Scalars['uuid']>;
  squareCardId?: Maybe<Scalars['String']>;
  squareCustomerId: Scalars['String'];
  /** Square's error category for the refusal of this charge, verbatim. NULL when Square named no reason. */
  squareErrorCategory?: Maybe<Scalars['String']>;
  /** Square's error code word for the refusal of this charge, verbatim. NULL when Square named no reason. */
  squareErrorCode?: Maybe<Scalars['String']>;
  /** The note sent to Square with this charge. */
  squareNote?: Maybe<Scalars['String']>;
  squarePaymentId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

/** aggregated selection of "ehr_charge_ledger" */
export type Ehr_Charge_Ledger_Aggregate = {
  __typename?: 'ehr_charge_ledger_aggregate';
  aggregate?: Maybe<Ehr_Charge_Ledger_Aggregate_Fields>;
  nodes: Array<Ehr_Charge_Ledger>;
};

/** aggregate fields of "ehr_charge_ledger" */
export type Ehr_Charge_Ledger_Aggregate_Fields = {
  __typename?: 'ehr_charge_ledger_aggregate_fields';
  avg?: Maybe<Ehr_Charge_Ledger_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ehr_Charge_Ledger_Max_Fields>;
  min?: Maybe<Ehr_Charge_Ledger_Min_Fields>;
  stddev?: Maybe<Ehr_Charge_Ledger_Stddev_Fields>;
  stddev_pop?: Maybe<Ehr_Charge_Ledger_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ehr_Charge_Ledger_Stddev_Samp_Fields>;
  sum?: Maybe<Ehr_Charge_Ledger_Sum_Fields>;
  var_pop?: Maybe<Ehr_Charge_Ledger_Var_Pop_Fields>;
  var_samp?: Maybe<Ehr_Charge_Ledger_Var_Samp_Fields>;
  variance?: Maybe<Ehr_Charge_Ledger_Variance_Fields>;
};


/** aggregate fields of "ehr_charge_ledger" */
export type Ehr_Charge_Ledger_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Charge_Ledger_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Ehr_Charge_Ledger_Avg_Fields = {
  __typename?: 'ehr_charge_ledger_avg_fields';
  amountCents?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ehr_charge_ledger". All fields are combined with a logical 'AND'. */
export type Ehr_Charge_Ledger_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Charge_Ledger_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Charge_Ledger_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Charge_Ledger_Bool_Exp>>;
  amountCents?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  encounter?: InputMaybe<Uuid_Comparison_Exp>;
  encounterByEncounter?: InputMaybe<Ehr_Encounter_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  idempotencyKey?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  patient?: InputMaybe<Uuid_Comparison_Exp>;
  patientBookingByPatientBooking?: InputMaybe<Patient_Booking_Bool_Exp>;
  patientByPatient?: InputMaybe<Patient_Bool_Exp>;
  patient_booking?: InputMaybe<Uuid_Comparison_Exp>;
  squareCardId?: InputMaybe<String_Comparison_Exp>;
  squareCustomerId?: InputMaybe<String_Comparison_Exp>;
  squareErrorCategory?: InputMaybe<String_Comparison_Exp>;
  squareErrorCode?: InputMaybe<String_Comparison_Exp>;
  squareNote?: InputMaybe<String_Comparison_Exp>;
  squarePaymentId?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_charge_ledger" */
export enum Ehr_Charge_Ledger_Constraint {
  /** unique or primary key constraint on columns "idempotency_key" */
  EhrChargeLedgerIdempotencyKeyKey = 'ehr_charge_ledger_idempotency_key_key',
  /** unique or primary key constraint on columns "id" */
  EhrChargeLedgerPkey = 'ehr_charge_ledger_pkey'
}

/** input type for incrementing numeric columns in table "ehr_charge_ledger" */
export type Ehr_Charge_Ledger_Inc_Input = {
  amountCents?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ehr_charge_ledger" */
export type Ehr_Charge_Ledger_Insert_Input = {
  amountCents?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  encounter?: InputMaybe<Scalars['uuid']>;
  encounterByEncounter?: InputMaybe<Ehr_Encounter_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The client's key for this charge. Unique across the table; NULL when the client sent none. */
  idempotencyKey?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  patient?: InputMaybe<Scalars['uuid']>;
  patientBookingByPatientBooking?: InputMaybe<Patient_Booking_Obj_Rel_Insert_Input>;
  patientByPatient?: InputMaybe<Patient_Obj_Rel_Insert_Input>;
  patient_booking?: InputMaybe<Scalars['uuid']>;
  squareCardId?: InputMaybe<Scalars['String']>;
  squareCustomerId?: InputMaybe<Scalars['String']>;
  /** Square's error category for the refusal of this charge, verbatim. NULL when Square named no reason. */
  squareErrorCategory?: InputMaybe<Scalars['String']>;
  /** Square's error code word for the refusal of this charge, verbatim. NULL when Square named no reason. */
  squareErrorCode?: InputMaybe<Scalars['String']>;
  /** The note sent to Square with this charge. */
  squareNote?: InputMaybe<Scalars['String']>;
  squarePaymentId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ehr_Charge_Ledger_Max_Fields = {
  __typename?: 'ehr_charge_ledger_max_fields';
  amountCents?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  encounter?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The client's key for this charge. Unique across the table; NULL when the client sent none. */
  idempotencyKey?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  patient?: Maybe<Scalars['uuid']>;
  patient_booking?: Maybe<Scalars['uuid']>;
  squareCardId?: Maybe<Scalars['String']>;
  squareCustomerId?: Maybe<Scalars['String']>;
  /** Square's error category for the refusal of this charge, verbatim. NULL when Square named no reason. */
  squareErrorCategory?: Maybe<Scalars['String']>;
  /** Square's error code word for the refusal of this charge, verbatim. NULL when Square named no reason. */
  squareErrorCode?: Maybe<Scalars['String']>;
  /** The note sent to Square with this charge. */
  squareNote?: Maybe<Scalars['String']>;
  squarePaymentId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ehr_Charge_Ledger_Min_Fields = {
  __typename?: 'ehr_charge_ledger_min_fields';
  amountCents?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  encounter?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The client's key for this charge. Unique across the table; NULL when the client sent none. */
  idempotencyKey?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  patient?: Maybe<Scalars['uuid']>;
  patient_booking?: Maybe<Scalars['uuid']>;
  squareCardId?: Maybe<Scalars['String']>;
  squareCustomerId?: Maybe<Scalars['String']>;
  /** Square's error category for the refusal of this charge, verbatim. NULL when Square named no reason. */
  squareErrorCategory?: Maybe<Scalars['String']>;
  /** Square's error code word for the refusal of this charge, verbatim. NULL when Square named no reason. */
  squareErrorCode?: Maybe<Scalars['String']>;
  /** The note sent to Square with this charge. */
  squareNote?: Maybe<Scalars['String']>;
  squarePaymentId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ehr_charge_ledger" */
export type Ehr_Charge_Ledger_Mutation_Response = {
  __typename?: 'ehr_charge_ledger_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Charge_Ledger>;
};

/** on_conflict condition type for table "ehr_charge_ledger" */
export type Ehr_Charge_Ledger_On_Conflict = {
  constraint: Ehr_Charge_Ledger_Constraint;
  update_columns?: Array<Ehr_Charge_Ledger_Update_Column>;
  where?: InputMaybe<Ehr_Charge_Ledger_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_charge_ledger". */
export type Ehr_Charge_Ledger_Order_By = {
  amountCents?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  encounter?: InputMaybe<Order_By>;
  encounterByEncounter?: InputMaybe<Ehr_Encounter_Order_By>;
  id?: InputMaybe<Order_By>;
  idempotencyKey?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  patient?: InputMaybe<Order_By>;
  patientBookingByPatientBooking?: InputMaybe<Patient_Booking_Order_By>;
  patientByPatient?: InputMaybe<Patient_Order_By>;
  patient_booking?: InputMaybe<Order_By>;
  squareCardId?: InputMaybe<Order_By>;
  squareCustomerId?: InputMaybe<Order_By>;
  squareErrorCategory?: InputMaybe<Order_By>;
  squareErrorCode?: InputMaybe<Order_By>;
  squareNote?: InputMaybe<Order_By>;
  squarePaymentId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_charge_ledger */
export type Ehr_Charge_Ledger_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ehr_charge_ledger" */
export enum Ehr_Charge_Ledger_Select_Column {
  /** column name */
  AmountCents = 'amountCents',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Encounter = 'encounter',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotencyKey = 'idempotencyKey',
  /** column name */
  Location = 'location',
  /** column name */
  Patient = 'patient',
  /** column name */
  PatientBooking = 'patient_booking',
  /** column name */
  SquareCardId = 'squareCardId',
  /** column name */
  SquareCustomerId = 'squareCustomerId',
  /** column name */
  SquareErrorCategory = 'squareErrorCategory',
  /** column name */
  SquareErrorCode = 'squareErrorCode',
  /** column name */
  SquareNote = 'squareNote',
  /** column name */
  SquarePaymentId = 'squarePaymentId',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "ehr_charge_ledger" */
export type Ehr_Charge_Ledger_Set_Input = {
  amountCents?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  encounter?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The client's key for this charge. Unique across the table; NULL when the client sent none. */
  idempotencyKey?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  patient_booking?: InputMaybe<Scalars['uuid']>;
  squareCardId?: InputMaybe<Scalars['String']>;
  squareCustomerId?: InputMaybe<Scalars['String']>;
  /** Square's error category for the refusal of this charge, verbatim. NULL when Square named no reason. */
  squareErrorCategory?: InputMaybe<Scalars['String']>;
  /** Square's error code word for the refusal of this charge, verbatim. NULL when Square named no reason. */
  squareErrorCode?: InputMaybe<Scalars['String']>;
  /** The note sent to Square with this charge. */
  squareNote?: InputMaybe<Scalars['String']>;
  squarePaymentId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Ehr_Charge_Ledger_Stddev_Fields = {
  __typename?: 'ehr_charge_ledger_stddev_fields';
  amountCents?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ehr_Charge_Ledger_Stddev_Pop_Fields = {
  __typename?: 'ehr_charge_ledger_stddev_pop_fields';
  amountCents?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ehr_Charge_Ledger_Stddev_Samp_Fields = {
  __typename?: 'ehr_charge_ledger_stddev_samp_fields';
  amountCents?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ehr_charge_ledger" */
export type Ehr_Charge_Ledger_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Charge_Ledger_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Charge_Ledger_Stream_Cursor_Value_Input = {
  amountCents?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  encounter?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The client's key for this charge. Unique across the table; NULL when the client sent none. */
  idempotencyKey?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  patient_booking?: InputMaybe<Scalars['uuid']>;
  squareCardId?: InputMaybe<Scalars['String']>;
  squareCustomerId?: InputMaybe<Scalars['String']>;
  /** Square's error category for the refusal of this charge, verbatim. NULL when Square named no reason. */
  squareErrorCategory?: InputMaybe<Scalars['String']>;
  /** Square's error code word for the refusal of this charge, verbatim. NULL when Square named no reason. */
  squareErrorCode?: InputMaybe<Scalars['String']>;
  /** The note sent to Square with this charge. */
  squareNote?: InputMaybe<Scalars['String']>;
  squarePaymentId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Ehr_Charge_Ledger_Sum_Fields = {
  __typename?: 'ehr_charge_ledger_sum_fields';
  amountCents?: Maybe<Scalars['Int']>;
};

/** update columns of table "ehr_charge_ledger" */
export enum Ehr_Charge_Ledger_Update_Column {
  /** column name */
  AmountCents = 'amountCents',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Encounter = 'encounter',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotencyKey = 'idempotencyKey',
  /** column name */
  Location = 'location',
  /** column name */
  Patient = 'patient',
  /** column name */
  PatientBooking = 'patient_booking',
  /** column name */
  SquareCardId = 'squareCardId',
  /** column name */
  SquareCustomerId = 'squareCustomerId',
  /** column name */
  SquareErrorCategory = 'squareErrorCategory',
  /** column name */
  SquareErrorCode = 'squareErrorCode',
  /** column name */
  SquareNote = 'squareNote',
  /** column name */
  SquarePaymentId = 'squarePaymentId',
  /** column name */
  Status = 'status'
}

export type Ehr_Charge_Ledger_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ehr_Charge_Ledger_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Charge_Ledger_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Charge_Ledger_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ehr_Charge_Ledger_Var_Pop_Fields = {
  __typename?: 'ehr_charge_ledger_var_pop_fields';
  amountCents?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ehr_Charge_Ledger_Var_Samp_Fields = {
  __typename?: 'ehr_charge_ledger_var_samp_fields';
  amountCents?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ehr_Charge_Ledger_Variance_Fields = {
  __typename?: 'ehr_charge_ledger_variance_fields';
  amountCents?: Maybe<Scalars['Float']>;
};

/** Focal point for every interaction between a provider and patient - each ends up a local document in the EHR */
export type Ehr_Encounter = {
  __typename?: 'ehr_encounter';
  /** The clinical summary generated by AI across all the voice recordings */
  AiNotes?: Maybe<Scalars['jsonb']>;
  adverseEvent?: Maybe<Scalars['Boolean']>;
  /** Constraint enforces not null for all except GENERAL */
  booking?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  bookingByBooking?: Maybe<Booking>;
  /** Used internally only to avoid transcription races */
  completedTranscriptCount: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  ehrEncounterAddendums: Array<Ehr_Encounter_Addendum>;
  /** An aggregate relationship */
  ehrEncounterAddendums_aggregate: Ehr_Encounter_Addendum_Aggregate;
  /** An object relationship */
  ehrEncounterModalityByModality?: Maybe<Ehr_Encounter_Modality>;
  /** An array relationship */
  ehrEncounterPhotos: Array<Ehr_Encounter_Photo>;
  /** An aggregate relationship */
  ehrEncounterPhotos_aggregate: Ehr_Encounter_Photo_Aggregate;
  /** An object relationship */
  ehrEncounterTypeByehrEncounterType: Ehr_Encounter_Type;
  /** An object relationship */
  ehrEncounterbyReferenceEncounter?: Maybe<Ehr_Encounter>;
  /** Procedure performed. Set directly on the encounter; not denormalized from booking (booking has no ehr_procedure column). Required for PRE_PROCEDURE and POST_PROCEDURE encounter types (required_ehr_procedure CHECK). */
  ehrProcedure?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  ehrProcedureByEhrProcedure?: Maybe<Ehr_Procedure>;
  /** An array relationship */
  ehrProductProviderUsageRecordPhotos: Array<Ehr_Product_Provider_Usage_Record_Photo>;
  /** An aggregate relationship */
  ehrProductProviderUsageRecordPhotos_aggregate: Ehr_Product_Provider_Usage_Record_Photo_Aggregate;
  encounterType: Ehr_Encounter_Type_Enum;
  /** An array relationship */
  fillerProcedureInjections: Array<Filler_Procedure_Injection>;
  /** An aggregate relationship */
  fillerProcedureInjections_aggregate: Filler_Procedure_Injection_Aggregate;
  /** An array relationship */
  fillerProcedureProductInstances: Array<Filler_Procedure_Product_Instance>;
  /** An aggregate relationship */
  fillerProcedureProductInstances_aggregate: Filler_Procedure_Product_Instance_Aggregate;
  /** Potentially edited version of the base patient profile data, as submitted during signing. */
  finalMedicalProfile?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  /** 2D vs 3D injection marking space (TWO_D/THREE_D); NULL when not applicable (non-injection encounter). Set at submit, independent of injection count (zero-injection submits are valid). Filler today; reusable by other injection procedures as they adopt 2D/3D marking. */
  injection_space?: Maybe<Filler_Space_Enum>;
  /** A computed field, executes function "ehr_encounter_local_date" */
  localDate?: Maybe<Scalars['date']>;
  /** Where the encounter happened. */
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  /** Frozen from the medical profile on submission of transcripts the A if user opts to add these to the note */
  medicalProfile?: Maybe<Scalars['jsonb']>;
  modality?: Maybe<Ehr_Encounter_Modality_Enum>;
  /** A computed field, executes function "overseen_by_viewing_supervisor" */
  overseenByViewingSupervisor?: Maybe<Scalars['Boolean']>;
  /** Patient of the procedure. NOT NULL. For booking-driven encounters, denormalized from booking.patient at INSERT only by ehr_encounter_denormalize_from_booking_at_insert; must match booking.patient if both are supplied. Snapshot — does not follow subsequent booking changes. */
  patient: Scalars['uuid'];
  /** An object relationship */
  patientBookingByPatientBooking?: Maybe<Patient_Booking>;
  /** An object relationship */
  patientByPatient: Patient;
  patient_booking?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  procedureAudioRecordingsByprocedureAudioRecordings: Array<Procedure_Audio_Recording>;
  /** An aggregate relationship */
  procedureAudioRecordingsByprocedureAudioRecordings_aggregate: Procedure_Audio_Recording_Aggregate;
  provider: Scalars['uuid'];
  /** The possibly edited (from AI original) notes that the provider has legally submitted */
  providerNotes?: Maybe<Scalars['jsonb']>;
  /** When the voice recordings are submitted for transcription (this is not the same as the final signing) */
  recordingsSubmittedAt?: Maybe<Scalars['timestamptz']>;
  /** For post procedure encounters - the encounter they are the "post" of */
  referenceEncounter?: Maybe<Scalars['uuid']>;
  /** Date the provider legally "signs" the record for submission */
  signedAt?: Maybe<Scalars['timestamptz']>;
  signedBy?: Maybe<Scalars['uuid']>;
  /** Text name entry for "signing" */
  signingName?: Maybe<Scalars['String']>;
  /** When the encounter note was submitted (independent of recordings) */
  submittedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  supervisorReviewQueueItems: Array<Supervisor_Review_Queue_Item>;
  /** An aggregate relationship */
  supervisorReviewQueueItems_aggregate: Supervisor_Review_Queue_Item_Aggregate;
  /** Actual procedure window. For booking-driven encounters, defaulted from booking.timespan at INSERT if not supplied — provider typically overrides at signing time to reflect the actual window. Snapshot — distinct from booking.timespan, which records the originally-scheduled window. Required when signed (signed_encounter_has_timespan CHECK). */
  timespan?: Maybe<Scalars['tstzrange']>;
  /** A computed field, executes function "ehr_encounter_timespan_lower" */
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "ehr_encounter_timespan_upper" */
  timespan_upper?: Maybe<Scalars['timestamptz']>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  userByProvider: User;
  /** An object relationship */
  userBySignedBy?: Maybe<User>;
  /** A computed field, executes function "ehr_encounter_visible_to_supervisor" */
  visibleToSupervisor?: Maybe<Scalars['Boolean']>;
  zone_release?: Maybe<Scalars['uuid']>;
};


/** Focal point for every interaction between a provider and patient - each ends up a local document in the EHR */
export type Ehr_EncounterAiNotesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Focal point for every interaction between a provider and patient - each ends up a local document in the EHR */
export type Ehr_EncounterEhrEncounterAddendumsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Addendum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Addendum_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Addendum_Bool_Exp>;
};


/** Focal point for every interaction between a provider and patient - each ends up a local document in the EHR */
export type Ehr_EncounterEhrEncounterAddendums_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Addendum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Addendum_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Addendum_Bool_Exp>;
};


/** Focal point for every interaction between a provider and patient - each ends up a local document in the EHR */
export type Ehr_EncounterEhrEncounterPhotosArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Photo_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Photo_Bool_Exp>;
};


/** Focal point for every interaction between a provider and patient - each ends up a local document in the EHR */
export type Ehr_EncounterEhrEncounterPhotos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Photo_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Photo_Bool_Exp>;
};


/** Focal point for every interaction between a provider and patient - each ends up a local document in the EHR */
export type Ehr_EncounterEhrProductProviderUsageRecordPhotosArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Product_Provider_Usage_Record_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Product_Provider_Usage_Record_Photo_Order_By>>;
  where?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Bool_Exp>;
};


/** Focal point for every interaction between a provider and patient - each ends up a local document in the EHR */
export type Ehr_EncounterEhrProductProviderUsageRecordPhotos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Product_Provider_Usage_Record_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Product_Provider_Usage_Record_Photo_Order_By>>;
  where?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Bool_Exp>;
};


/** Focal point for every interaction between a provider and patient - each ends up a local document in the EHR */
export type Ehr_EncounterFillerProcedureInjectionsArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Injection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Injection_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Injection_Bool_Exp>;
};


/** Focal point for every interaction between a provider and patient - each ends up a local document in the EHR */
export type Ehr_EncounterFillerProcedureInjections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Injection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Injection_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Injection_Bool_Exp>;
};


/** Focal point for every interaction between a provider and patient - each ends up a local document in the EHR */
export type Ehr_EncounterFillerProcedureProductInstancesArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Product_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Product_Instance_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Product_Instance_Bool_Exp>;
};


/** Focal point for every interaction between a provider and patient - each ends up a local document in the EHR */
export type Ehr_EncounterFillerProcedureProductInstances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Product_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Product_Instance_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Product_Instance_Bool_Exp>;
};


/** Focal point for every interaction between a provider and patient - each ends up a local document in the EHR */
export type Ehr_EncounterFinalMedicalProfileArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Focal point for every interaction between a provider and patient - each ends up a local document in the EHR */
export type Ehr_EncounterMedicalProfileArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Focal point for every interaction between a provider and patient - each ends up a local document in the EHR */
export type Ehr_EncounterProcedureAudioRecordingsByprocedureAudioRecordingsArgs = {
  distinct_on?: InputMaybe<Array<Procedure_Audio_Recording_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Procedure_Audio_Recording_Order_By>>;
  where?: InputMaybe<Procedure_Audio_Recording_Bool_Exp>;
};


/** Focal point for every interaction between a provider and patient - each ends up a local document in the EHR */
export type Ehr_EncounterProcedureAudioRecordingsByprocedureAudioRecordings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Procedure_Audio_Recording_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Procedure_Audio_Recording_Order_By>>;
  where?: InputMaybe<Procedure_Audio_Recording_Bool_Exp>;
};


/** Focal point for every interaction between a provider and patient - each ends up a local document in the EHR */
export type Ehr_EncounterProviderNotesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Focal point for every interaction between a provider and patient - each ends up a local document in the EHR */
export type Ehr_EncounterSupervisorReviewQueueItemsArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Item_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Item_Bool_Exp>;
};


/** Focal point for every interaction between a provider and patient - each ends up a local document in the EHR */
export type Ehr_EncounterSupervisorReviewQueueItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Item_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Item_Bool_Exp>;
};

/** columns and relationships of "ehr_encounter_addendum" */
export type Ehr_Encounter_Addendum = {
  __typename?: 'ehr_encounter_addendum';
  body: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  encounter: Scalars['uuid'];
  /** An object relationship */
  encounterByEncounter: Ehr_Encounter;
  id: Scalars['uuid'];
  provider: Scalars['uuid'];
  s3Keys: Scalars['jsonb'];
  signature?: Maybe<Scalars['String']>;
  signedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  userByProvider: User;
};


/** columns and relationships of "ehr_encounter_addendum" */
export type Ehr_Encounter_AddendumS3KeysArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ehr_encounter_addendum" */
export type Ehr_Encounter_Addendum_Aggregate = {
  __typename?: 'ehr_encounter_addendum_aggregate';
  aggregate?: Maybe<Ehr_Encounter_Addendum_Aggregate_Fields>;
  nodes: Array<Ehr_Encounter_Addendum>;
};

export type Ehr_Encounter_Addendum_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ehr_Encounter_Addendum_Aggregate_Bool_Exp_Count>;
};

export type Ehr_Encounter_Addendum_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ehr_Encounter_Addendum_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Encounter_Addendum_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ehr_encounter_addendum" */
export type Ehr_Encounter_Addendum_Aggregate_Fields = {
  __typename?: 'ehr_encounter_addendum_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Encounter_Addendum_Max_Fields>;
  min?: Maybe<Ehr_Encounter_Addendum_Min_Fields>;
};


/** aggregate fields of "ehr_encounter_addendum" */
export type Ehr_Encounter_Addendum_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Encounter_Addendum_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ehr_encounter_addendum" */
export type Ehr_Encounter_Addendum_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Encounter_Addendum_Max_Order_By>;
  min?: InputMaybe<Ehr_Encounter_Addendum_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Ehr_Encounter_Addendum_Append_Input = {
  s3Keys?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "ehr_encounter_addendum" */
export type Ehr_Encounter_Addendum_Arr_Rel_Insert_Input = {
  data: Array<Ehr_Encounter_Addendum_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Encounter_Addendum_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ehr_encounter_addendum". All fields are combined with a logical 'AND'. */
export type Ehr_Encounter_Addendum_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Encounter_Addendum_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Encounter_Addendum_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Encounter_Addendum_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  encounter?: InputMaybe<Uuid_Comparison_Exp>;
  encounterByEncounter?: InputMaybe<Ehr_Encounter_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  s3Keys?: InputMaybe<Jsonb_Comparison_Exp>;
  signature?: InputMaybe<String_Comparison_Exp>;
  signedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userByProvider?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "ehr_encounter_addendum" */
export enum Ehr_Encounter_Addendum_Constraint {
  /** unique or primary key constraint on columns "id" */
  EhrEncounterAddendumPkey = 'ehr_encounter_addendum_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Ehr_Encounter_Addendum_Delete_At_Path_Input = {
  s3Keys?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Ehr_Encounter_Addendum_Delete_Elem_Input = {
  s3Keys?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Ehr_Encounter_Addendum_Delete_Key_Input = {
  s3Keys?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "ehr_encounter_addendum" */
export type Ehr_Encounter_Addendum_Insert_Input = {
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  encounter?: InputMaybe<Scalars['uuid']>;
  encounterByEncounter?: InputMaybe<Ehr_Encounter_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  s3Keys?: InputMaybe<Scalars['jsonb']>;
  signature?: InputMaybe<Scalars['String']>;
  signedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Ehr_Encounter_Addendum_Max_Fields = {
  __typename?: 'ehr_encounter_addendum_max_fields';
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  encounter?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  signature?: Maybe<Scalars['String']>;
  signedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "ehr_encounter_addendum" */
export type Ehr_Encounter_Addendum_Max_Order_By = {
  body?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  encounter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  signature?: InputMaybe<Order_By>;
  signedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ehr_Encounter_Addendum_Min_Fields = {
  __typename?: 'ehr_encounter_addendum_min_fields';
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  encounter?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  signature?: Maybe<Scalars['String']>;
  signedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "ehr_encounter_addendum" */
export type Ehr_Encounter_Addendum_Min_Order_By = {
  body?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  encounter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  signature?: InputMaybe<Order_By>;
  signedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ehr_encounter_addendum" */
export type Ehr_Encounter_Addendum_Mutation_Response = {
  __typename?: 'ehr_encounter_addendum_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Encounter_Addendum>;
};

/** on_conflict condition type for table "ehr_encounter_addendum" */
export type Ehr_Encounter_Addendum_On_Conflict = {
  constraint: Ehr_Encounter_Addendum_Constraint;
  update_columns?: Array<Ehr_Encounter_Addendum_Update_Column>;
  where?: InputMaybe<Ehr_Encounter_Addendum_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_encounter_addendum". */
export type Ehr_Encounter_Addendum_Order_By = {
  body?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  encounter?: InputMaybe<Order_By>;
  encounterByEncounter?: InputMaybe<Ehr_Encounter_Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  s3Keys?: InputMaybe<Order_By>;
  signature?: InputMaybe<Order_By>;
  signedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userByProvider?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: ehr_encounter_addendum */
export type Ehr_Encounter_Addendum_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Ehr_Encounter_Addendum_Prepend_Input = {
  s3Keys?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ehr_encounter_addendum" */
export enum Ehr_Encounter_Addendum_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Encounter = 'encounter',
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider',
  /** column name */
  S3Keys = 's3Keys',
  /** column name */
  Signature = 'signature',
  /** column name */
  SignedAt = 'signedAt',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "ehr_encounter_addendum" */
export type Ehr_Encounter_Addendum_Set_Input = {
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  encounter?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  s3Keys?: InputMaybe<Scalars['jsonb']>;
  signature?: InputMaybe<Scalars['String']>;
  signedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "ehr_encounter_addendum" */
export type Ehr_Encounter_Addendum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Encounter_Addendum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Encounter_Addendum_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  encounter?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  s3Keys?: InputMaybe<Scalars['jsonb']>;
  signature?: InputMaybe<Scalars['String']>;
  signedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "ehr_encounter_addendum" */
export enum Ehr_Encounter_Addendum_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Encounter = 'encounter',
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider',
  /** column name */
  S3Keys = 's3Keys',
  /** column name */
  Signature = 'signature',
  /** column name */
  SignedAt = 'signedAt',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Ehr_Encounter_Addendum_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Ehr_Encounter_Addendum_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Ehr_Encounter_Addendum_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Ehr_Encounter_Addendum_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Ehr_Encounter_Addendum_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Ehr_Encounter_Addendum_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Encounter_Addendum_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Encounter_Addendum_Bool_Exp;
};

/** aggregated selection of "ehr_encounter" */
export type Ehr_Encounter_Aggregate = {
  __typename?: 'ehr_encounter_aggregate';
  aggregate?: Maybe<Ehr_Encounter_Aggregate_Fields>;
  nodes: Array<Ehr_Encounter>;
};

export type Ehr_Encounter_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Ehr_Encounter_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Ehr_Encounter_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Ehr_Encounter_Aggregate_Bool_Exp_Count>;
};

export type Ehr_Encounter_Aggregate_Bool_Exp_Bool_And = {
  arguments: Ehr_Encounter_Select_Column_Ehr_Encounter_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Encounter_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ehr_Encounter_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Ehr_Encounter_Select_Column_Ehr_Encounter_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Encounter_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ehr_Encounter_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ehr_Encounter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Encounter_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ehr_encounter" */
export type Ehr_Encounter_Aggregate_Fields = {
  __typename?: 'ehr_encounter_aggregate_fields';
  avg?: Maybe<Ehr_Encounter_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ehr_Encounter_Max_Fields>;
  min?: Maybe<Ehr_Encounter_Min_Fields>;
  stddev?: Maybe<Ehr_Encounter_Stddev_Fields>;
  stddev_pop?: Maybe<Ehr_Encounter_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ehr_Encounter_Stddev_Samp_Fields>;
  sum?: Maybe<Ehr_Encounter_Sum_Fields>;
  var_pop?: Maybe<Ehr_Encounter_Var_Pop_Fields>;
  var_samp?: Maybe<Ehr_Encounter_Var_Samp_Fields>;
  variance?: Maybe<Ehr_Encounter_Variance_Fields>;
};


/** aggregate fields of "ehr_encounter" */
export type Ehr_Encounter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Encounter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ehr_encounter" */
export type Ehr_Encounter_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Encounter_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Encounter_Max_Order_By>;
  min?: InputMaybe<Ehr_Encounter_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Encounter_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Encounter_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Encounter_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Encounter_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Encounter_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Encounter_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Encounter_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Ehr_Encounter_Append_Input = {
  /** The clinical summary generated by AI across all the voice recordings */
  AiNotes?: InputMaybe<Scalars['jsonb']>;
  /** Potentially edited version of the base patient profile data, as submitted during signing. */
  finalMedicalProfile?: InputMaybe<Scalars['jsonb']>;
  /** Frozen from the medical profile on submission of transcripts the A if user opts to add these to the note */
  medicalProfile?: InputMaybe<Scalars['jsonb']>;
  /** The possibly edited (from AI original) notes that the provider has legally submitted */
  providerNotes?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "ehr_encounter" */
export type Ehr_Encounter_Arr_Rel_Insert_Input = {
  data: Array<Ehr_Encounter_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Encounter_On_Conflict>;
};

/** aggregate avg on columns */
export type Ehr_Encounter_Avg_Fields = {
  __typename?: 'ehr_encounter_avg_fields';
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: Maybe<Scalars['Float']>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ehr_encounter" */
export type Ehr_Encounter_Avg_Order_By = {
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: InputMaybe<Order_By>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_encounter". All fields are combined with a logical 'AND'. */
export type Ehr_Encounter_Bool_Exp = {
  AiNotes?: InputMaybe<Jsonb_Comparison_Exp>;
  _and?: InputMaybe<Array<Ehr_Encounter_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Encounter_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Encounter_Bool_Exp>>;
  adverseEvent?: InputMaybe<Boolean_Comparison_Exp>;
  booking?: InputMaybe<Uuid_Comparison_Exp>;
  bookingByBooking?: InputMaybe<Booking_Bool_Exp>;
  completedTranscriptCount?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrEncounterAddendums?: InputMaybe<Ehr_Encounter_Addendum_Bool_Exp>;
  ehrEncounterAddendums_aggregate?: InputMaybe<Ehr_Encounter_Addendum_Aggregate_Bool_Exp>;
  ehrEncounterModalityByModality?: InputMaybe<Ehr_Encounter_Modality_Bool_Exp>;
  ehrEncounterPhotos?: InputMaybe<Ehr_Encounter_Photo_Bool_Exp>;
  ehrEncounterPhotos_aggregate?: InputMaybe<Ehr_Encounter_Photo_Aggregate_Bool_Exp>;
  ehrEncounterTypeByehrEncounterType?: InputMaybe<Ehr_Encounter_Type_Bool_Exp>;
  ehrEncounterbyReferenceEncounter?: InputMaybe<Ehr_Encounter_Bool_Exp>;
  ehrProcedure?: InputMaybe<Uuid_Comparison_Exp>;
  ehrProcedureByEhrProcedure?: InputMaybe<Ehr_Procedure_Bool_Exp>;
  ehrProductProviderUsageRecordPhotos?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Bool_Exp>;
  ehrProductProviderUsageRecordPhotos_aggregate?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Aggregate_Bool_Exp>;
  encounterType?: InputMaybe<Ehr_Encounter_Type_Enum_Comparison_Exp>;
  fillerProcedureInjections?: InputMaybe<Filler_Procedure_Injection_Bool_Exp>;
  fillerProcedureInjections_aggregate?: InputMaybe<Filler_Procedure_Injection_Aggregate_Bool_Exp>;
  fillerProcedureProductInstances?: InputMaybe<Filler_Procedure_Product_Instance_Bool_Exp>;
  fillerProcedureProductInstances_aggregate?: InputMaybe<Filler_Procedure_Product_Instance_Aggregate_Bool_Exp>;
  finalMedicalProfile?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  injection_space?: InputMaybe<Filler_Space_Enum_Comparison_Exp>;
  localDate?: InputMaybe<Date_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  medicalProfile?: InputMaybe<Jsonb_Comparison_Exp>;
  modality?: InputMaybe<Ehr_Encounter_Modality_Enum_Comparison_Exp>;
  overseenByViewingSupervisor?: InputMaybe<Boolean_Comparison_Exp>;
  patient?: InputMaybe<Uuid_Comparison_Exp>;
  patientBookingByPatientBooking?: InputMaybe<Patient_Booking_Bool_Exp>;
  patientByPatient?: InputMaybe<Patient_Bool_Exp>;
  patient_booking?: InputMaybe<Uuid_Comparison_Exp>;
  procedureAudioRecordingsByprocedureAudioRecordings?: InputMaybe<Procedure_Audio_Recording_Bool_Exp>;
  procedureAudioRecordingsByprocedureAudioRecordings_aggregate?: InputMaybe<Procedure_Audio_Recording_Aggregate_Bool_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  providerNotes?: InputMaybe<Jsonb_Comparison_Exp>;
  recordingsSubmittedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  referenceEncounter?: InputMaybe<Uuid_Comparison_Exp>;
  signedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  signedBy?: InputMaybe<Uuid_Comparison_Exp>;
  signingName?: InputMaybe<String_Comparison_Exp>;
  submittedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  supervisorReviewQueueItems?: InputMaybe<Supervisor_Review_Queue_Item_Bool_Exp>;
  supervisorReviewQueueItems_aggregate?: InputMaybe<Supervisor_Review_Queue_Item_Aggregate_Bool_Exp>;
  timespan?: InputMaybe<Tstzrange_Comparison_Exp>;
  timespan_lower?: InputMaybe<Timestamptz_Comparison_Exp>;
  timespan_upper?: InputMaybe<Timestamptz_Comparison_Exp>;
  totalUploadedRecordingsCount?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userByProvider?: InputMaybe<User_Bool_Exp>;
  userBySignedBy?: InputMaybe<User_Bool_Exp>;
  visibleToSupervisor?: InputMaybe<Boolean_Comparison_Exp>;
  zone_release?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_encounter" */
export enum Ehr_Encounter_Constraint {
  /** unique or primary key constraint on columns "booking" */
  EhrEncounterConsultUnsignedUniquePerBookingIndex = 'ehr_encounter_consult_unsigned_unique_per_booking_index',
  /** unique or primary key constraint on columns "booking" */
  EhrEncounterOneGeneralUnsignedPerBooking = 'ehr_encounter_one_general_unsigned_per_booking',
  /** unique or primary key constraint on columns "encounter_type", "booking" */
  EhrEncounterTypeUniquePerBookingIndex = 'ehr_encounter_type_unique_per_booking_index',
  /** unique or primary key constraint on columns "id" */
  EhrPreProcedureRecordPkey = 'ehr_pre_procedure_record_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Ehr_Encounter_Delete_At_Path_Input = {
  /** The clinical summary generated by AI across all the voice recordings */
  AiNotes?: InputMaybe<Array<Scalars['String']>>;
  /** Potentially edited version of the base patient profile data, as submitted during signing. */
  finalMedicalProfile?: InputMaybe<Array<Scalars['String']>>;
  /** Frozen from the medical profile on submission of transcripts the A if user opts to add these to the note */
  medicalProfile?: InputMaybe<Array<Scalars['String']>>;
  /** The possibly edited (from AI original) notes that the provider has legally submitted */
  providerNotes?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Ehr_Encounter_Delete_Elem_Input = {
  /** The clinical summary generated by AI across all the voice recordings */
  AiNotes?: InputMaybe<Scalars['Int']>;
  /** Potentially edited version of the base patient profile data, as submitted during signing. */
  finalMedicalProfile?: InputMaybe<Scalars['Int']>;
  /** Frozen from the medical profile on submission of transcripts the A if user opts to add these to the note */
  medicalProfile?: InputMaybe<Scalars['Int']>;
  /** The possibly edited (from AI original) notes that the provider has legally submitted */
  providerNotes?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Ehr_Encounter_Delete_Key_Input = {
  /** The clinical summary generated by AI across all the voice recordings */
  AiNotes?: InputMaybe<Scalars['String']>;
  /** Potentially edited version of the base patient profile data, as submitted during signing. */
  finalMedicalProfile?: InputMaybe<Scalars['String']>;
  /** Frozen from the medical profile on submission of transcripts the A if user opts to add these to the note */
  medicalProfile?: InputMaybe<Scalars['String']>;
  /** The possibly edited (from AI original) notes that the provider has legally submitted */
  providerNotes?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "ehr_encounter" */
export type Ehr_Encounter_Inc_Input = {
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: InputMaybe<Scalars['Int']>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ehr_encounter" */
export type Ehr_Encounter_Insert_Input = {
  /** The clinical summary generated by AI across all the voice recordings */
  AiNotes?: InputMaybe<Scalars['jsonb']>;
  adverseEvent?: InputMaybe<Scalars['Boolean']>;
  /** Constraint enforces not null for all except GENERAL */
  booking?: InputMaybe<Scalars['uuid']>;
  bookingByBooking?: InputMaybe<Booking_Obj_Rel_Insert_Input>;
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  ehrEncounterAddendums?: InputMaybe<Ehr_Encounter_Addendum_Arr_Rel_Insert_Input>;
  ehrEncounterModalityByModality?: InputMaybe<Ehr_Encounter_Modality_Obj_Rel_Insert_Input>;
  ehrEncounterPhotos?: InputMaybe<Ehr_Encounter_Photo_Arr_Rel_Insert_Input>;
  ehrEncounterTypeByehrEncounterType?: InputMaybe<Ehr_Encounter_Type_Obj_Rel_Insert_Input>;
  ehrEncounterbyReferenceEncounter?: InputMaybe<Ehr_Encounter_Obj_Rel_Insert_Input>;
  /** Procedure performed. Set directly on the encounter; not denormalized from booking (booking has no ehr_procedure column). Required for PRE_PROCEDURE and POST_PROCEDURE encounter types (required_ehr_procedure CHECK). */
  ehrProcedure?: InputMaybe<Scalars['uuid']>;
  ehrProcedureByEhrProcedure?: InputMaybe<Ehr_Procedure_Obj_Rel_Insert_Input>;
  ehrProductProviderUsageRecordPhotos?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Arr_Rel_Insert_Input>;
  encounterType?: InputMaybe<Ehr_Encounter_Type_Enum>;
  fillerProcedureInjections?: InputMaybe<Filler_Procedure_Injection_Arr_Rel_Insert_Input>;
  fillerProcedureProductInstances?: InputMaybe<Filler_Procedure_Product_Instance_Arr_Rel_Insert_Input>;
  /** Potentially edited version of the base patient profile data, as submitted during signing. */
  finalMedicalProfile?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** 2D vs 3D injection marking space (TWO_D/THREE_D); NULL when not applicable (non-injection encounter). Set at submit, independent of injection count (zero-injection submits are valid). Filler today; reusable by other injection procedures as they adopt 2D/3D marking. */
  injection_space?: InputMaybe<Filler_Space_Enum>;
  /** Where the encounter happened. */
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  /** Frozen from the medical profile on submission of transcripts the A if user opts to add these to the note */
  medicalProfile?: InputMaybe<Scalars['jsonb']>;
  modality?: InputMaybe<Ehr_Encounter_Modality_Enum>;
  /** Patient of the procedure. NOT NULL. For booking-driven encounters, denormalized from booking.patient at INSERT only by ehr_encounter_denormalize_from_booking_at_insert; must match booking.patient if both are supplied. Snapshot — does not follow subsequent booking changes. */
  patient?: InputMaybe<Scalars['uuid']>;
  patientBookingByPatientBooking?: InputMaybe<Patient_Booking_Obj_Rel_Insert_Input>;
  patientByPatient?: InputMaybe<Patient_Obj_Rel_Insert_Input>;
  patient_booking?: InputMaybe<Scalars['uuid']>;
  procedureAudioRecordingsByprocedureAudioRecordings?: InputMaybe<Procedure_Audio_Recording_Arr_Rel_Insert_Input>;
  provider?: InputMaybe<Scalars['uuid']>;
  /** The possibly edited (from AI original) notes that the provider has legally submitted */
  providerNotes?: InputMaybe<Scalars['jsonb']>;
  /** When the voice recordings are submitted for transcription (this is not the same as the final signing) */
  recordingsSubmittedAt?: InputMaybe<Scalars['timestamptz']>;
  /** For post procedure encounters - the encounter they are the "post" of */
  referenceEncounter?: InputMaybe<Scalars['uuid']>;
  /** Date the provider legally "signs" the record for submission */
  signedAt?: InputMaybe<Scalars['timestamptz']>;
  signedBy?: InputMaybe<Scalars['uuid']>;
  /** Text name entry for "signing" */
  signingName?: InputMaybe<Scalars['String']>;
  /** When the encounter note was submitted (independent of recordings) */
  submittedAt?: InputMaybe<Scalars['timestamptz']>;
  supervisorReviewQueueItems?: InputMaybe<Supervisor_Review_Queue_Item_Arr_Rel_Insert_Input>;
  /** Actual procedure window. For booking-driven encounters, defaulted from booking.timespan at INSERT if not supplied — provider typically overrides at signing time to reflect the actual window. Snapshot — distinct from booking.timespan, which records the originally-scheduled window. Required when signed (signed_encounter_has_timespan CHECK). */
  timespan?: InputMaybe<Scalars['tstzrange']>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userBySignedBy?: InputMaybe<User_Obj_Rel_Insert_Input>;
  zone_release?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Ehr_Encounter_Max_Fields = {
  __typename?: 'ehr_encounter_max_fields';
  /** Constraint enforces not null for all except GENERAL */
  booking?: Maybe<Scalars['uuid']>;
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** Procedure performed. Set directly on the encounter; not denormalized from booking (booking has no ehr_procedure column). Required for PRE_PROCEDURE and POST_PROCEDURE encounter types (required_ehr_procedure CHECK). */
  ehrProcedure?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "ehr_encounter_local_date" */
  localDate?: Maybe<Scalars['date']>;
  /** Where the encounter happened. */
  location?: Maybe<Scalars['uuid']>;
  /** Patient of the procedure. NOT NULL. For booking-driven encounters, denormalized from booking.patient at INSERT only by ehr_encounter_denormalize_from_booking_at_insert; must match booking.patient if both are supplied. Snapshot — does not follow subsequent booking changes. */
  patient?: Maybe<Scalars['uuid']>;
  patient_booking?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  /** When the voice recordings are submitted for transcription (this is not the same as the final signing) */
  recordingsSubmittedAt?: Maybe<Scalars['timestamptz']>;
  /** For post procedure encounters - the encounter they are the "post" of */
  referenceEncounter?: Maybe<Scalars['uuid']>;
  /** Date the provider legally "signs" the record for submission */
  signedAt?: Maybe<Scalars['timestamptz']>;
  signedBy?: Maybe<Scalars['uuid']>;
  /** Text name entry for "signing" */
  signingName?: Maybe<Scalars['String']>;
  /** When the encounter note was submitted (independent of recordings) */
  submittedAt?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "ehr_encounter_timespan_lower" */
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "ehr_encounter_timespan_upper" */
  timespan_upper?: Maybe<Scalars['timestamptz']>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  zone_release?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "ehr_encounter" */
export type Ehr_Encounter_Max_Order_By = {
  /** Constraint enforces not null for all except GENERAL */
  booking?: InputMaybe<Order_By>;
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  /** Procedure performed. Set directly on the encounter; not denormalized from booking (booking has no ehr_procedure column). Required for PRE_PROCEDURE and POST_PROCEDURE encounter types (required_ehr_procedure CHECK). */
  ehrProcedure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Where the encounter happened. */
  location?: InputMaybe<Order_By>;
  /** Patient of the procedure. NOT NULL. For booking-driven encounters, denormalized from booking.patient at INSERT only by ehr_encounter_denormalize_from_booking_at_insert; must match booking.patient if both are supplied. Snapshot — does not follow subsequent booking changes. */
  patient?: InputMaybe<Order_By>;
  patient_booking?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  /** When the voice recordings are submitted for transcription (this is not the same as the final signing) */
  recordingsSubmittedAt?: InputMaybe<Order_By>;
  /** For post procedure encounters - the encounter they are the "post" of */
  referenceEncounter?: InputMaybe<Order_By>;
  /** Date the provider legally "signs" the record for submission */
  signedAt?: InputMaybe<Order_By>;
  signedBy?: InputMaybe<Order_By>;
  /** Text name entry for "signing" */
  signingName?: InputMaybe<Order_By>;
  /** When the encounter note was submitted (independent of recordings) */
  submittedAt?: InputMaybe<Order_By>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  zone_release?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ehr_Encounter_Min_Fields = {
  __typename?: 'ehr_encounter_min_fields';
  /** Constraint enforces not null for all except GENERAL */
  booking?: Maybe<Scalars['uuid']>;
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** Procedure performed. Set directly on the encounter; not denormalized from booking (booking has no ehr_procedure column). Required for PRE_PROCEDURE and POST_PROCEDURE encounter types (required_ehr_procedure CHECK). */
  ehrProcedure?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "ehr_encounter_local_date" */
  localDate?: Maybe<Scalars['date']>;
  /** Where the encounter happened. */
  location?: Maybe<Scalars['uuid']>;
  /** Patient of the procedure. NOT NULL. For booking-driven encounters, denormalized from booking.patient at INSERT only by ehr_encounter_denormalize_from_booking_at_insert; must match booking.patient if both are supplied. Snapshot — does not follow subsequent booking changes. */
  patient?: Maybe<Scalars['uuid']>;
  patient_booking?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  /** When the voice recordings are submitted for transcription (this is not the same as the final signing) */
  recordingsSubmittedAt?: Maybe<Scalars['timestamptz']>;
  /** For post procedure encounters - the encounter they are the "post" of */
  referenceEncounter?: Maybe<Scalars['uuid']>;
  /** Date the provider legally "signs" the record for submission */
  signedAt?: Maybe<Scalars['timestamptz']>;
  signedBy?: Maybe<Scalars['uuid']>;
  /** Text name entry for "signing" */
  signingName?: Maybe<Scalars['String']>;
  /** When the encounter note was submitted (independent of recordings) */
  submittedAt?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "ehr_encounter_timespan_lower" */
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "ehr_encounter_timespan_upper" */
  timespan_upper?: Maybe<Scalars['timestamptz']>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  zone_release?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "ehr_encounter" */
export type Ehr_Encounter_Min_Order_By = {
  /** Constraint enforces not null for all except GENERAL */
  booking?: InputMaybe<Order_By>;
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  /** Procedure performed. Set directly on the encounter; not denormalized from booking (booking has no ehr_procedure column). Required for PRE_PROCEDURE and POST_PROCEDURE encounter types (required_ehr_procedure CHECK). */
  ehrProcedure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Where the encounter happened. */
  location?: InputMaybe<Order_By>;
  /** Patient of the procedure. NOT NULL. For booking-driven encounters, denormalized from booking.patient at INSERT only by ehr_encounter_denormalize_from_booking_at_insert; must match booking.patient if both are supplied. Snapshot — does not follow subsequent booking changes. */
  patient?: InputMaybe<Order_By>;
  patient_booking?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  /** When the voice recordings are submitted for transcription (this is not the same as the final signing) */
  recordingsSubmittedAt?: InputMaybe<Order_By>;
  /** For post procedure encounters - the encounter they are the "post" of */
  referenceEncounter?: InputMaybe<Order_By>;
  /** Date the provider legally "signs" the record for submission */
  signedAt?: InputMaybe<Order_By>;
  signedBy?: InputMaybe<Order_By>;
  /** Text name entry for "signing" */
  signingName?: InputMaybe<Order_By>;
  /** When the encounter note was submitted (independent of recordings) */
  submittedAt?: InputMaybe<Order_By>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  zone_release?: InputMaybe<Order_By>;
};

/** The modality of an encounter */
export type Ehr_Encounter_Modality = {
  __typename?: 'ehr_encounter_modality';
  name: Scalars['String'];
};

/** aggregated selection of "ehr_encounter_modality" */
export type Ehr_Encounter_Modality_Aggregate = {
  __typename?: 'ehr_encounter_modality_aggregate';
  aggregate?: Maybe<Ehr_Encounter_Modality_Aggregate_Fields>;
  nodes: Array<Ehr_Encounter_Modality>;
};

/** aggregate fields of "ehr_encounter_modality" */
export type Ehr_Encounter_Modality_Aggregate_Fields = {
  __typename?: 'ehr_encounter_modality_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Encounter_Modality_Max_Fields>;
  min?: Maybe<Ehr_Encounter_Modality_Min_Fields>;
};


/** aggregate fields of "ehr_encounter_modality" */
export type Ehr_Encounter_Modality_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Encounter_Modality_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ehr_encounter_modality". All fields are combined with a logical 'AND'. */
export type Ehr_Encounter_Modality_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Encounter_Modality_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Encounter_Modality_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Encounter_Modality_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_encounter_modality" */
export enum Ehr_Encounter_Modality_Constraint {
  /** unique or primary key constraint on columns "name" */
  EhrEncounterModalityPkey = 'ehr_encounter_modality_pkey'
}

export enum Ehr_Encounter_Modality_Enum {
  InPerson = 'IN_PERSON',
  Other = 'OTHER',
  Phone = 'PHONE',
  Text = 'TEXT',
  Video = 'VIDEO'
}

/** Boolean expression to compare columns of type "ehr_encounter_modality_enum". All fields are combined with logical 'AND'. */
export type Ehr_Encounter_Modality_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ehr_Encounter_Modality_Enum>;
  _in?: InputMaybe<Array<Ehr_Encounter_Modality_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Ehr_Encounter_Modality_Enum>;
  _nin?: InputMaybe<Array<Ehr_Encounter_Modality_Enum>>;
};

/** input type for inserting data into table "ehr_encounter_modality" */
export type Ehr_Encounter_Modality_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ehr_Encounter_Modality_Max_Fields = {
  __typename?: 'ehr_encounter_modality_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ehr_Encounter_Modality_Min_Fields = {
  __typename?: 'ehr_encounter_modality_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ehr_encounter_modality" */
export type Ehr_Encounter_Modality_Mutation_Response = {
  __typename?: 'ehr_encounter_modality_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Encounter_Modality>;
};

/** input type for inserting object relation for remote table "ehr_encounter_modality" */
export type Ehr_Encounter_Modality_Obj_Rel_Insert_Input = {
  data: Ehr_Encounter_Modality_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Encounter_Modality_On_Conflict>;
};

/** on_conflict condition type for table "ehr_encounter_modality" */
export type Ehr_Encounter_Modality_On_Conflict = {
  constraint: Ehr_Encounter_Modality_Constraint;
  update_columns?: Array<Ehr_Encounter_Modality_Update_Column>;
  where?: InputMaybe<Ehr_Encounter_Modality_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_encounter_modality". */
export type Ehr_Encounter_Modality_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_encounter_modality */
export type Ehr_Encounter_Modality_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "ehr_encounter_modality" */
export enum Ehr_Encounter_Modality_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "ehr_encounter_modality" */
export type Ehr_Encounter_Modality_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ehr_encounter_modality" */
export type Ehr_Encounter_Modality_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Encounter_Modality_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Encounter_Modality_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ehr_encounter_modality" */
export enum Ehr_Encounter_Modality_Update_Column {
  /** column name */
  Name = 'name'
}

export type Ehr_Encounter_Modality_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Encounter_Modality_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Encounter_Modality_Bool_Exp;
};

/** response of any mutation on the table "ehr_encounter" */
export type Ehr_Encounter_Mutation_Response = {
  __typename?: 'ehr_encounter_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Encounter>;
};

/** input type for inserting object relation for remote table "ehr_encounter" */
export type Ehr_Encounter_Obj_Rel_Insert_Input = {
  data: Ehr_Encounter_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Encounter_On_Conflict>;
};

/** on_conflict condition type for table "ehr_encounter" */
export type Ehr_Encounter_On_Conflict = {
  constraint: Ehr_Encounter_Constraint;
  update_columns?: Array<Ehr_Encounter_Update_Column>;
  where?: InputMaybe<Ehr_Encounter_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_encounter". */
export type Ehr_Encounter_Order_By = {
  AiNotes?: InputMaybe<Order_By>;
  adverseEvent?: InputMaybe<Order_By>;
  booking?: InputMaybe<Order_By>;
  bookingByBooking?: InputMaybe<Booking_Order_By>;
  completedTranscriptCount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  ehrEncounterAddendums_aggregate?: InputMaybe<Ehr_Encounter_Addendum_Aggregate_Order_By>;
  ehrEncounterModalityByModality?: InputMaybe<Ehr_Encounter_Modality_Order_By>;
  ehrEncounterPhotos_aggregate?: InputMaybe<Ehr_Encounter_Photo_Aggregate_Order_By>;
  ehrEncounterTypeByehrEncounterType?: InputMaybe<Ehr_Encounter_Type_Order_By>;
  ehrEncounterbyReferenceEncounter?: InputMaybe<Ehr_Encounter_Order_By>;
  ehrProcedure?: InputMaybe<Order_By>;
  ehrProcedureByEhrProcedure?: InputMaybe<Ehr_Procedure_Order_By>;
  ehrProductProviderUsageRecordPhotos_aggregate?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Aggregate_Order_By>;
  encounterType?: InputMaybe<Order_By>;
  fillerProcedureInjections_aggregate?: InputMaybe<Filler_Procedure_Injection_Aggregate_Order_By>;
  fillerProcedureProductInstances_aggregate?: InputMaybe<Filler_Procedure_Product_Instance_Aggregate_Order_By>;
  finalMedicalProfile?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  injection_space?: InputMaybe<Order_By>;
  localDate?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  medicalProfile?: InputMaybe<Order_By>;
  modality?: InputMaybe<Order_By>;
  overseenByViewingSupervisor?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  patientBookingByPatientBooking?: InputMaybe<Patient_Booking_Order_By>;
  patientByPatient?: InputMaybe<Patient_Order_By>;
  patient_booking?: InputMaybe<Order_By>;
  procedureAudioRecordingsByprocedureAudioRecordings_aggregate?: InputMaybe<Procedure_Audio_Recording_Aggregate_Order_By>;
  provider?: InputMaybe<Order_By>;
  providerNotes?: InputMaybe<Order_By>;
  recordingsSubmittedAt?: InputMaybe<Order_By>;
  referenceEncounter?: InputMaybe<Order_By>;
  signedAt?: InputMaybe<Order_By>;
  signedBy?: InputMaybe<Order_By>;
  signingName?: InputMaybe<Order_By>;
  submittedAt?: InputMaybe<Order_By>;
  supervisorReviewQueueItems_aggregate?: InputMaybe<Supervisor_Review_Queue_Item_Aggregate_Order_By>;
  timespan?: InputMaybe<Order_By>;
  timespan_lower?: InputMaybe<Order_By>;
  timespan_upper?: InputMaybe<Order_By>;
  totalUploadedRecordingsCount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userByProvider?: InputMaybe<User_Order_By>;
  userBySignedBy?: InputMaybe<User_Order_By>;
  visibleToSupervisor?: InputMaybe<Order_By>;
  zone_release?: InputMaybe<Order_By>;
};

/** All photos related to specific encounter records - photo type (procedure...) comes from the associated encounter */
export type Ehr_Encounter_Photo = {
  __typename?: 'ehr_encounter_photo';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  ehrEncounter: Scalars['uuid'];
  /** An object relationship */
  ehrEncounterByEhrEncounter: Ehr_Encounter;
  /** An object relationship */
  ehrEncounterScan3dByScan3d?: Maybe<Ehr_Encounter_Scan_3d>;
  id: Scalars['uuid'];
  orientation: Scalars['String'];
  photoS3Key: Scalars['uuid'];
  /** An array relationship */
  preProcedurePhotoInjectionMarkings: Array<Pre_Procedure_Photo_Injection_Marking>;
  /** An aggregate relationship */
  preProcedurePhotoInjectionMarkings_aggregate: Pre_Procedure_Photo_Injection_Marking_Aggregate;
  provider: Scalars['uuid'];
  scan_3d?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  userByProvider: User;
};


/** All photos related to specific encounter records - photo type (procedure...) comes from the associated encounter */
export type Ehr_Encounter_PhotoPreProcedurePhotoInjectionMarkingsArgs = {
  distinct_on?: InputMaybe<Array<Pre_Procedure_Photo_Injection_Marking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pre_Procedure_Photo_Injection_Marking_Order_By>>;
  where?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Bool_Exp>;
};


/** All photos related to specific encounter records - photo type (procedure...) comes from the associated encounter */
export type Ehr_Encounter_PhotoPreProcedurePhotoInjectionMarkings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pre_Procedure_Photo_Injection_Marking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pre_Procedure_Photo_Injection_Marking_Order_By>>;
  where?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Bool_Exp>;
};

/** aggregated selection of "ehr_encounter_photo" */
export type Ehr_Encounter_Photo_Aggregate = {
  __typename?: 'ehr_encounter_photo_aggregate';
  aggregate?: Maybe<Ehr_Encounter_Photo_Aggregate_Fields>;
  nodes: Array<Ehr_Encounter_Photo>;
};

export type Ehr_Encounter_Photo_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ehr_Encounter_Photo_Aggregate_Bool_Exp_Count>;
};

export type Ehr_Encounter_Photo_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ehr_Encounter_Photo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Encounter_Photo_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ehr_encounter_photo" */
export type Ehr_Encounter_Photo_Aggregate_Fields = {
  __typename?: 'ehr_encounter_photo_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Encounter_Photo_Max_Fields>;
  min?: Maybe<Ehr_Encounter_Photo_Min_Fields>;
};


/** aggregate fields of "ehr_encounter_photo" */
export type Ehr_Encounter_Photo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Encounter_Photo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ehr_encounter_photo" */
export type Ehr_Encounter_Photo_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Encounter_Photo_Max_Order_By>;
  min?: InputMaybe<Ehr_Encounter_Photo_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ehr_encounter_photo" */
export type Ehr_Encounter_Photo_Arr_Rel_Insert_Input = {
  data: Array<Ehr_Encounter_Photo_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Encounter_Photo_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ehr_encounter_photo". All fields are combined with a logical 'AND'. */
export type Ehr_Encounter_Photo_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Encounter_Photo_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Encounter_Photo_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Encounter_Photo_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrEncounter?: InputMaybe<Uuid_Comparison_Exp>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Bool_Exp>;
  ehrEncounterScan3dByScan3d?: InputMaybe<Ehr_Encounter_Scan_3d_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  orientation?: InputMaybe<String_Comparison_Exp>;
  photoS3Key?: InputMaybe<Uuid_Comparison_Exp>;
  preProcedurePhotoInjectionMarkings?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Bool_Exp>;
  preProcedurePhotoInjectionMarkings_aggregate?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Aggregate_Bool_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  scan_3d?: InputMaybe<Uuid_Comparison_Exp>;
  userByProvider?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "ehr_encounter_photo" */
export enum Ehr_Encounter_Photo_Constraint {
  /** unique or primary key constraint on columns "orientation", "ehr_encounter" */
  EhrEncounterPhotoUniqueIndex = 'ehr_encounter_photo_unique_index',
  /** unique or primary key constraint on columns "id" */
  PreProcedurePhotoPkey = 'pre_procedure_photo_pkey'
}

/** input type for inserting data into table "ehr_encounter_photo" */
export type Ehr_Encounter_Photo_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  ehrEncounter?: InputMaybe<Scalars['uuid']>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Obj_Rel_Insert_Input>;
  ehrEncounterScan3dByScan3d?: InputMaybe<Ehr_Encounter_Scan_3d_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  orientation?: InputMaybe<Scalars['String']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  preProcedurePhotoInjectionMarkings?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Arr_Rel_Insert_Input>;
  provider?: InputMaybe<Scalars['uuid']>;
  scan_3d?: InputMaybe<Scalars['uuid']>;
  userByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Ehr_Encounter_Photo_Max_Fields = {
  __typename?: 'ehr_encounter_photo_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  ehrEncounter?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  orientation?: Maybe<Scalars['String']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  scan_3d?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "ehr_encounter_photo" */
export type Ehr_Encounter_Photo_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  ehrEncounter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orientation?: InputMaybe<Order_By>;
  photoS3Key?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  scan_3d?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ehr_Encounter_Photo_Min_Fields = {
  __typename?: 'ehr_encounter_photo_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  ehrEncounter?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  orientation?: Maybe<Scalars['String']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  scan_3d?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "ehr_encounter_photo" */
export type Ehr_Encounter_Photo_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  ehrEncounter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orientation?: InputMaybe<Order_By>;
  photoS3Key?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  scan_3d?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ehr_encounter_photo" */
export type Ehr_Encounter_Photo_Mutation_Response = {
  __typename?: 'ehr_encounter_photo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Encounter_Photo>;
};

/** input type for inserting object relation for remote table "ehr_encounter_photo" */
export type Ehr_Encounter_Photo_Obj_Rel_Insert_Input = {
  data: Ehr_Encounter_Photo_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Encounter_Photo_On_Conflict>;
};

/** on_conflict condition type for table "ehr_encounter_photo" */
export type Ehr_Encounter_Photo_On_Conflict = {
  constraint: Ehr_Encounter_Photo_Constraint;
  update_columns?: Array<Ehr_Encounter_Photo_Update_Column>;
  where?: InputMaybe<Ehr_Encounter_Photo_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_encounter_photo". */
export type Ehr_Encounter_Photo_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  ehrEncounter?: InputMaybe<Order_By>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Order_By>;
  ehrEncounterScan3dByScan3d?: InputMaybe<Ehr_Encounter_Scan_3d_Order_By>;
  id?: InputMaybe<Order_By>;
  orientation?: InputMaybe<Order_By>;
  photoS3Key?: InputMaybe<Order_By>;
  preProcedurePhotoInjectionMarkings_aggregate?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Aggregate_Order_By>;
  provider?: InputMaybe<Order_By>;
  scan_3d?: InputMaybe<Order_By>;
  userByProvider?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: ehr_encounter_photo */
export type Ehr_Encounter_Photo_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ehr_encounter_photo" */
export enum Ehr_Encounter_Photo_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EhrEncounter = 'ehrEncounter',
  /** column name */
  Id = 'id',
  /** column name */
  Orientation = 'orientation',
  /** column name */
  PhotoS3Key = 'photoS3Key',
  /** column name */
  Provider = 'provider',
  /** column name */
  Scan_3d = 'scan_3d'
}

/** input type for updating data in table "ehr_encounter_photo" */
export type Ehr_Encounter_Photo_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  ehrEncounter?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  orientation?: InputMaybe<Scalars['String']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  scan_3d?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "ehr_encounter_photo" */
export type Ehr_Encounter_Photo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Encounter_Photo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Encounter_Photo_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  ehrEncounter?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  orientation?: InputMaybe<Scalars['String']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  scan_3d?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "ehr_encounter_photo" */
export enum Ehr_Encounter_Photo_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EhrEncounter = 'ehrEncounter',
  /** column name */
  Id = 'id',
  /** column name */
  Orientation = 'orientation',
  /** column name */
  PhotoS3Key = 'photoS3Key',
  /** column name */
  Provider = 'provider',
  /** column name */
  Scan_3d = 'scan_3d'
}

export type Ehr_Encounter_Photo_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Encounter_Photo_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Encounter_Photo_Bool_Exp;
};

/** primary key columns input for table: ehr_encounter */
export type Ehr_Encounter_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Ehr_Encounter_Prepend_Input = {
  /** The clinical summary generated by AI across all the voice recordings */
  AiNotes?: InputMaybe<Scalars['jsonb']>;
  /** Potentially edited version of the base patient profile data, as submitted during signing. */
  finalMedicalProfile?: InputMaybe<Scalars['jsonb']>;
  /** Frozen from the medical profile on submission of transcripts the A if user opts to add these to the note */
  medicalProfile?: InputMaybe<Scalars['jsonb']>;
  /** The possibly edited (from AI original) notes that the provider has legally submitted */
  providerNotes?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "ehr_encounter_scan_3d" */
export type Ehr_Encounter_Scan_3d = {
  __typename?: 'ehr_encounter_scan_3d';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  ehrEncounterByEhrEncounter: Ehr_Encounter;
  /** An array relationship */
  ehrEncounterScan3dArtifacts: Array<Ehr_Encounter_Scan_3d_Artifact>;
  /** An aggregate relationship */
  ehrEncounterScan3dArtifacts_aggregate: Ehr_Encounter_Scan_3d_Artifact_Aggregate;
  ehr_encounter: Scalars['uuid'];
  /** An object relationship */
  fillerZoneReleaseByZoneRelease?: Maybe<Filler_Zone_Release>;
  id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  zone_release?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "ehr_encounter_scan_3d" */
export type Ehr_Encounter_Scan_3dEhrEncounterScan3dArtifactsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Bool_Exp>;
};


/** columns and relationships of "ehr_encounter_scan_3d" */
export type Ehr_Encounter_Scan_3dEhrEncounterScan3dArtifacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Bool_Exp>;
};

/** aggregated selection of "ehr_encounter_scan_3d" */
export type Ehr_Encounter_Scan_3d_Aggregate = {
  __typename?: 'ehr_encounter_scan_3d_aggregate';
  aggregate?: Maybe<Ehr_Encounter_Scan_3d_Aggregate_Fields>;
  nodes: Array<Ehr_Encounter_Scan_3d>;
};

/** aggregate fields of "ehr_encounter_scan_3d" */
export type Ehr_Encounter_Scan_3d_Aggregate_Fields = {
  __typename?: 'ehr_encounter_scan_3d_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Encounter_Scan_3d_Max_Fields>;
  min?: Maybe<Ehr_Encounter_Scan_3d_Min_Fields>;
};


/** aggregate fields of "ehr_encounter_scan_3d" */
export type Ehr_Encounter_Scan_3d_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact = {
  __typename?: 'ehr_encounter_scan_3d_artifact';
  content_type: Scalars['String'];
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  ehrEncounterScan3dByScan3d: Ehr_Encounter_Scan_3d;
  id: Scalars['uuid'];
  kind: Ehr_Encounter_Scan_3d_Artifact_Kind_Enum;
  provider?: Maybe<Scalars['uuid']>;
  s3_key: Scalars['uuid'];
  scan_3d: Scalars['uuid'];
  size_bytes?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  userByProvider?: Maybe<User>;
};

/** aggregated selection of "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Aggregate = {
  __typename?: 'ehr_encounter_scan_3d_artifact_aggregate';
  aggregate?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Aggregate_Fields>;
  nodes: Array<Ehr_Encounter_Scan_3d_Artifact>;
};

export type Ehr_Encounter_Scan_3d_Artifact_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Aggregate_Bool_Exp_Count>;
};

export type Ehr_Encounter_Scan_3d_Artifact_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Aggregate_Fields = {
  __typename?: 'ehr_encounter_scan_3d_artifact_aggregate_fields';
  avg?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Max_Fields>;
  min?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Min_Fields>;
  stddev?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Stddev_Fields>;
  stddev_pop?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Stddev_Samp_Fields>;
  sum?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Sum_Fields>;
  var_pop?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Var_Pop_Fields>;
  var_samp?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Var_Samp_Fields>;
  variance?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Variance_Fields>;
};


/** aggregate fields of "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Max_Order_By>;
  min?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Arr_Rel_Insert_Input = {
  data: Array<Ehr_Encounter_Scan_3d_Artifact_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_On_Conflict>;
};

/** aggregate avg on columns */
export type Ehr_Encounter_Scan_3d_Artifact_Avg_Fields = {
  __typename?: 'ehr_encounter_scan_3d_artifact_avg_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Avg_Order_By = {
  size_bytes?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_encounter_scan_3d_artifact". All fields are combined with a logical 'AND'. */
export type Ehr_Encounter_Scan_3d_Artifact_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Bool_Exp>>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrEncounterScan3dByScan3d?: InputMaybe<Ehr_Encounter_Scan_3d_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  kind?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Enum_Comparison_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  s3_key?: InputMaybe<Uuid_Comparison_Exp>;
  scan_3d?: InputMaybe<Uuid_Comparison_Exp>;
  size_bytes?: InputMaybe<Bigint_Comparison_Exp>;
  userByProvider?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "ehr_encounter_scan_3d_artifact" */
export enum Ehr_Encounter_Scan_3d_Artifact_Constraint {
  /** unique or primary key constraint on columns "id" */
  EhrEncounterScan_3dArtifactPkey = 'ehr_encounter_scan_3d_artifact_pkey',
  /** unique or primary key constraint on columns "kind", "scan_3d" */
  EhrEncounterScan_3dArtifactScanKindUniq = 'ehr_encounter_scan_3d_artifact_scan_kind_uniq'
}

/** input type for incrementing numeric columns in table "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Inc_Input = {
  size_bytes?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Insert_Input = {
  content_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  ehrEncounterScan3dByScan3d?: InputMaybe<Ehr_Encounter_Scan_3d_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  kind?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Enum>;
  provider?: InputMaybe<Scalars['uuid']>;
  s3_key?: InputMaybe<Scalars['uuid']>;
  scan_3d?: InputMaybe<Scalars['uuid']>;
  size_bytes?: InputMaybe<Scalars['bigint']>;
  userByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** columns and relationships of "ehr_encounter_scan_3d_artifact_kind" */
export type Ehr_Encounter_Scan_3d_Artifact_Kind = {
  __typename?: 'ehr_encounter_scan_3d_artifact_kind';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "ehr_encounter_scan_3d_artifact_kind" */
export type Ehr_Encounter_Scan_3d_Artifact_Kind_Aggregate = {
  __typename?: 'ehr_encounter_scan_3d_artifact_kind_aggregate';
  aggregate?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Aggregate_Fields>;
  nodes: Array<Ehr_Encounter_Scan_3d_Artifact_Kind>;
};

/** aggregate fields of "ehr_encounter_scan_3d_artifact_kind" */
export type Ehr_Encounter_Scan_3d_Artifact_Kind_Aggregate_Fields = {
  __typename?: 'ehr_encounter_scan_3d_artifact_kind_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Max_Fields>;
  min?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Min_Fields>;
};


/** aggregate fields of "ehr_encounter_scan_3d_artifact_kind" */
export type Ehr_Encounter_Scan_3d_Artifact_Kind_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Kind_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ehr_encounter_scan_3d_artifact_kind". All fields are combined with a logical 'AND'. */
export type Ehr_Encounter_Scan_3d_Artifact_Kind_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Kind_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Kind_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_encounter_scan_3d_artifact_kind" */
export enum Ehr_Encounter_Scan_3d_Artifact_Kind_Constraint {
  /** unique or primary key constraint on columns "value" */
  EhrEncounterScan_3dArtifactKindPkey = 'ehr_encounter_scan_3d_artifact_kind_pkey'
}

export enum Ehr_Encounter_Scan_3d_Artifact_Kind_Enum {
  /** ARKit canonical-topology carrier mesh (arkit-face.obj) */
  ArkitFaceObj = 'ARKIT_FACE_OBJ',
  /** QA fixture pinning the TS classifier to the Python reference (classify-parity.json) */
  ClassifyParity = 'CLASSIFY_PARITY',
  /** Per-frame camera intrinsics (intrinsics.json) */
  Intrinsics = 'INTRINSICS',
  /** Apple Vision face landmarks (landmarks.json) */
  Landmarks = 'LANDMARKS',
  /** Photogrammetry display mesh (model.usdz) */
  ModelUsdz = 'MODEL_USDZ',
  /** Per-frame camera poses (poses.json) */
  Poses = 'POSES',
  /** Carrier->scan similarity transform (registration.json) */
  Registration = 'REGISTRATION',
  /** Per-scan overlay mesh with carrier UVs (zones-overlay.json) */
  ZonesOverlayMesh = 'ZONES_OVERLAY_MESH',
  /** Per-scan zone outline polylines on the scan surface (zone-boundary.json) */
  ZoneBoundary = 'ZONE_BOUNDARY',
  /** Per-scan copy of the cross-patient UV zone partition (zones.uv.json) */
  ZoneUv = 'ZONE_UV'
}

/** Boolean expression to compare columns of type "ehr_encounter_scan_3d_artifact_kind_enum". All fields are combined with logical 'AND'. */
export type Ehr_Encounter_Scan_3d_Artifact_Kind_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Enum>;
  _in?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Kind_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Enum>;
  _nin?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Kind_Enum>>;
};

/** input type for inserting data into table "ehr_encounter_scan_3d_artifact_kind" */
export type Ehr_Encounter_Scan_3d_Artifact_Kind_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ehr_Encounter_Scan_3d_Artifact_Kind_Max_Fields = {
  __typename?: 'ehr_encounter_scan_3d_artifact_kind_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ehr_Encounter_Scan_3d_Artifact_Kind_Min_Fields = {
  __typename?: 'ehr_encounter_scan_3d_artifact_kind_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ehr_encounter_scan_3d_artifact_kind" */
export type Ehr_Encounter_Scan_3d_Artifact_Kind_Mutation_Response = {
  __typename?: 'ehr_encounter_scan_3d_artifact_kind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Encounter_Scan_3d_Artifact_Kind>;
};

/** on_conflict condition type for table "ehr_encounter_scan_3d_artifact_kind" */
export type Ehr_Encounter_Scan_3d_Artifact_Kind_On_Conflict = {
  constraint: Ehr_Encounter_Scan_3d_Artifact_Kind_Constraint;
  update_columns?: Array<Ehr_Encounter_Scan_3d_Artifact_Kind_Update_Column>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_encounter_scan_3d_artifact_kind". */
export type Ehr_Encounter_Scan_3d_Artifact_Kind_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_encounter_scan_3d_artifact_kind */
export type Ehr_Encounter_Scan_3d_Artifact_Kind_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "ehr_encounter_scan_3d_artifact_kind" */
export enum Ehr_Encounter_Scan_3d_Artifact_Kind_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "ehr_encounter_scan_3d_artifact_kind" */
export type Ehr_Encounter_Scan_3d_Artifact_Kind_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ehr_encounter_scan_3d_artifact_kind" */
export type Ehr_Encounter_Scan_3d_Artifact_Kind_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Encounter_Scan_3d_Artifact_Kind_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Encounter_Scan_3d_Artifact_Kind_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ehr_encounter_scan_3d_artifact_kind" */
export enum Ehr_Encounter_Scan_3d_Artifact_Kind_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Ehr_Encounter_Scan_3d_Artifact_Kind_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Encounter_Scan_3d_Artifact_Kind_Bool_Exp;
};

/** aggregate max on columns */
export type Ehr_Encounter_Scan_3d_Artifact_Max_Fields = {
  __typename?: 'ehr_encounter_scan_3d_artifact_max_fields';
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  s3_key?: Maybe<Scalars['uuid']>;
  scan_3d?: Maybe<Scalars['uuid']>;
  size_bytes?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Max_Order_By = {
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  s3_key?: InputMaybe<Order_By>;
  scan_3d?: InputMaybe<Order_By>;
  size_bytes?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ehr_Encounter_Scan_3d_Artifact_Min_Fields = {
  __typename?: 'ehr_encounter_scan_3d_artifact_min_fields';
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  s3_key?: Maybe<Scalars['uuid']>;
  scan_3d?: Maybe<Scalars['uuid']>;
  size_bytes?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Min_Order_By = {
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  s3_key?: InputMaybe<Order_By>;
  scan_3d?: InputMaybe<Order_By>;
  size_bytes?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Mutation_Response = {
  __typename?: 'ehr_encounter_scan_3d_artifact_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Encounter_Scan_3d_Artifact>;
};

/** on_conflict condition type for table "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_On_Conflict = {
  constraint: Ehr_Encounter_Scan_3d_Artifact_Constraint;
  update_columns?: Array<Ehr_Encounter_Scan_3d_Artifact_Update_Column>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_encounter_scan_3d_artifact". */
export type Ehr_Encounter_Scan_3d_Artifact_Order_By = {
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ehrEncounterScan3dByScan3d?: InputMaybe<Ehr_Encounter_Scan_3d_Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  s3_key?: InputMaybe<Order_By>;
  scan_3d?: InputMaybe<Order_By>;
  size_bytes?: InputMaybe<Order_By>;
  userByProvider?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: ehr_encounter_scan_3d_artifact */
export type Ehr_Encounter_Scan_3d_Artifact_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ehr_encounter_scan_3d_artifact" */
export enum Ehr_Encounter_Scan_3d_Artifact_Select_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Provider = 'provider',
  /** column name */
  S3Key = 's3_key',
  /** column name */
  Scan_3d = 'scan_3d',
  /** column name */
  SizeBytes = 'size_bytes'
}

/** input type for updating data in table "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Set_Input = {
  content_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  kind?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Enum>;
  provider?: InputMaybe<Scalars['uuid']>;
  s3_key?: InputMaybe<Scalars['uuid']>;
  scan_3d?: InputMaybe<Scalars['uuid']>;
  size_bytes?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Ehr_Encounter_Scan_3d_Artifact_Stddev_Fields = {
  __typename?: 'ehr_encounter_scan_3d_artifact_stddev_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Stddev_Order_By = {
  size_bytes?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ehr_Encounter_Scan_3d_Artifact_Stddev_Pop_Fields = {
  __typename?: 'ehr_encounter_scan_3d_artifact_stddev_pop_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Stddev_Pop_Order_By = {
  size_bytes?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ehr_Encounter_Scan_3d_Artifact_Stddev_Samp_Fields = {
  __typename?: 'ehr_encounter_scan_3d_artifact_stddev_samp_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Stddev_Samp_Order_By = {
  size_bytes?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Encounter_Scan_3d_Artifact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Encounter_Scan_3d_Artifact_Stream_Cursor_Value_Input = {
  content_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  kind?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Enum>;
  provider?: InputMaybe<Scalars['uuid']>;
  s3_key?: InputMaybe<Scalars['uuid']>;
  scan_3d?: InputMaybe<Scalars['uuid']>;
  size_bytes?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Ehr_Encounter_Scan_3d_Artifact_Sum_Fields = {
  __typename?: 'ehr_encounter_scan_3d_artifact_sum_fields';
  size_bytes?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Sum_Order_By = {
  size_bytes?: InputMaybe<Order_By>;
};

/** update columns of table "ehr_encounter_scan_3d_artifact" */
export enum Ehr_Encounter_Scan_3d_Artifact_Update_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Provider = 'provider',
  /** column name */
  S3Key = 's3_key',
  /** column name */
  Scan_3d = 'scan_3d',
  /** column name */
  SizeBytes = 'size_bytes'
}

export type Ehr_Encounter_Scan_3d_Artifact_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Encounter_Scan_3d_Artifact_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ehr_Encounter_Scan_3d_Artifact_Var_Pop_Fields = {
  __typename?: 'ehr_encounter_scan_3d_artifact_var_pop_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Var_Pop_Order_By = {
  size_bytes?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ehr_Encounter_Scan_3d_Artifact_Var_Samp_Fields = {
  __typename?: 'ehr_encounter_scan_3d_artifact_var_samp_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Var_Samp_Order_By = {
  size_bytes?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ehr_Encounter_Scan_3d_Artifact_Variance_Fields = {
  __typename?: 'ehr_encounter_scan_3d_artifact_variance_fields';
  size_bytes?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ehr_encounter_scan_3d_artifact" */
export type Ehr_Encounter_Scan_3d_Artifact_Variance_Order_By = {
  size_bytes?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_encounter_scan_3d". All fields are combined with a logical 'AND'. */
export type Ehr_Encounter_Scan_3d_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Encounter_Scan_3d_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Bool_Exp>;
  ehrEncounterScan3dArtifacts?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Bool_Exp>;
  ehrEncounterScan3dArtifacts_aggregate?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Aggregate_Bool_Exp>;
  ehr_encounter?: InputMaybe<Uuid_Comparison_Exp>;
  fillerZoneReleaseByZoneRelease?: InputMaybe<Filler_Zone_Release_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  zone_release?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_encounter_scan_3d" */
export enum Ehr_Encounter_Scan_3d_Constraint {
  /** unique or primary key constraint on columns "id" */
  EhrEncounterScan_3dPkey = 'ehr_encounter_scan_3d_pkey'
}

/** input type for inserting data into table "ehr_encounter_scan_3d" */
export type Ehr_Encounter_Scan_3d_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Obj_Rel_Insert_Input>;
  ehrEncounterScan3dArtifacts?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Arr_Rel_Insert_Input>;
  ehr_encounter?: InputMaybe<Scalars['uuid']>;
  fillerZoneReleaseByZoneRelease?: InputMaybe<Filler_Zone_Release_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  zone_release?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Ehr_Encounter_Scan_3d_Max_Fields = {
  __typename?: 'ehr_encounter_scan_3d_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  ehr_encounter?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zone_release?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Ehr_Encounter_Scan_3d_Min_Fields = {
  __typename?: 'ehr_encounter_scan_3d_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  ehr_encounter?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zone_release?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "ehr_encounter_scan_3d" */
export type Ehr_Encounter_Scan_3d_Mutation_Response = {
  __typename?: 'ehr_encounter_scan_3d_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Encounter_Scan_3d>;
};

/** input type for inserting object relation for remote table "ehr_encounter_scan_3d" */
export type Ehr_Encounter_Scan_3d_Obj_Rel_Insert_Input = {
  data: Ehr_Encounter_Scan_3d_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Encounter_Scan_3d_On_Conflict>;
};

/** on_conflict condition type for table "ehr_encounter_scan_3d" */
export type Ehr_Encounter_Scan_3d_On_Conflict = {
  constraint: Ehr_Encounter_Scan_3d_Constraint;
  update_columns?: Array<Ehr_Encounter_Scan_3d_Update_Column>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_encounter_scan_3d". */
export type Ehr_Encounter_Scan_3d_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Order_By>;
  ehrEncounterScan3dArtifacts_aggregate?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Aggregate_Order_By>;
  ehr_encounter?: InputMaybe<Order_By>;
  fillerZoneReleaseByZoneRelease?: InputMaybe<Filler_Zone_Release_Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zone_release?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_encounter_scan_3d */
export type Ehr_Encounter_Scan_3d_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ehr_encounter_scan_3d" */
export enum Ehr_Encounter_Scan_3d_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EhrEncounter = 'ehr_encounter',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ZoneRelease = 'zone_release'
}

/** input type for updating data in table "ehr_encounter_scan_3d" */
export type Ehr_Encounter_Scan_3d_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  ehr_encounter?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  zone_release?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "ehr_encounter_scan_3d" */
export type Ehr_Encounter_Scan_3d_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Encounter_Scan_3d_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Encounter_Scan_3d_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  ehr_encounter?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  zone_release?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "ehr_encounter_scan_3d" */
export enum Ehr_Encounter_Scan_3d_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EhrEncounter = 'ehr_encounter',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ZoneRelease = 'zone_release'
}

export type Ehr_Encounter_Scan_3d_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Encounter_Scan_3d_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Encounter_Scan_3d_Bool_Exp;
};

/** select columns of table "ehr_encounter" */
export enum Ehr_Encounter_Select_Column {
  /** column name */
  AiNotes = 'AiNotes',
  /** column name */
  AdverseEvent = 'adverseEvent',
  /** column name */
  Booking = 'booking',
  /** column name */
  CompletedTranscriptCount = 'completedTranscriptCount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EhrProcedure = 'ehrProcedure',
  /** column name */
  EncounterType = 'encounterType',
  /** column name */
  FinalMedicalProfile = 'finalMedicalProfile',
  /** column name */
  Id = 'id',
  /** column name */
  InjectionSpace = 'injection_space',
  /** column name */
  Location = 'location',
  /** column name */
  MedicalProfile = 'medicalProfile',
  /** column name */
  Modality = 'modality',
  /** column name */
  Patient = 'patient',
  /** column name */
  PatientBooking = 'patient_booking',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderNotes = 'providerNotes',
  /** column name */
  RecordingsSubmittedAt = 'recordingsSubmittedAt',
  /** column name */
  ReferenceEncounter = 'referenceEncounter',
  /** column name */
  SignedAt = 'signedAt',
  /** column name */
  SignedBy = 'signedBy',
  /** column name */
  SigningName = 'signingName',
  /** column name */
  SubmittedAt = 'submittedAt',
  /** column name */
  Timespan = 'timespan',
  /** column name */
  TotalUploadedRecordingsCount = 'totalUploadedRecordingsCount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ZoneRelease = 'zone_release'
}

/** select "ehr_encounter_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ehr_encounter" */
export enum Ehr_Encounter_Select_Column_Ehr_Encounter_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AdverseEvent = 'adverseEvent'
}

/** select "ehr_encounter_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ehr_encounter" */
export enum Ehr_Encounter_Select_Column_Ehr_Encounter_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AdverseEvent = 'adverseEvent'
}

/** input type for updating data in table "ehr_encounter" */
export type Ehr_Encounter_Set_Input = {
  /** The clinical summary generated by AI across all the voice recordings */
  AiNotes?: InputMaybe<Scalars['jsonb']>;
  adverseEvent?: InputMaybe<Scalars['Boolean']>;
  /** Constraint enforces not null for all except GENERAL */
  booking?: InputMaybe<Scalars['uuid']>;
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Procedure performed. Set directly on the encounter; not denormalized from booking (booking has no ehr_procedure column). Required for PRE_PROCEDURE and POST_PROCEDURE encounter types (required_ehr_procedure CHECK). */
  ehrProcedure?: InputMaybe<Scalars['uuid']>;
  encounterType?: InputMaybe<Ehr_Encounter_Type_Enum>;
  /** Potentially edited version of the base patient profile data, as submitted during signing. */
  finalMedicalProfile?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** 2D vs 3D injection marking space (TWO_D/THREE_D); NULL when not applicable (non-injection encounter). Set at submit, independent of injection count (zero-injection submits are valid). Filler today; reusable by other injection procedures as they adopt 2D/3D marking. */
  injection_space?: InputMaybe<Filler_Space_Enum>;
  /** Where the encounter happened. */
  location?: InputMaybe<Scalars['uuid']>;
  /** Frozen from the medical profile on submission of transcripts the A if user opts to add these to the note */
  medicalProfile?: InputMaybe<Scalars['jsonb']>;
  modality?: InputMaybe<Ehr_Encounter_Modality_Enum>;
  /** Patient of the procedure. NOT NULL. For booking-driven encounters, denormalized from booking.patient at INSERT only by ehr_encounter_denormalize_from_booking_at_insert; must match booking.patient if both are supplied. Snapshot — does not follow subsequent booking changes. */
  patient?: InputMaybe<Scalars['uuid']>;
  patient_booking?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  /** The possibly edited (from AI original) notes that the provider has legally submitted */
  providerNotes?: InputMaybe<Scalars['jsonb']>;
  /** When the voice recordings are submitted for transcription (this is not the same as the final signing) */
  recordingsSubmittedAt?: InputMaybe<Scalars['timestamptz']>;
  /** For post procedure encounters - the encounter they are the "post" of */
  referenceEncounter?: InputMaybe<Scalars['uuid']>;
  /** Date the provider legally "signs" the record for submission */
  signedAt?: InputMaybe<Scalars['timestamptz']>;
  signedBy?: InputMaybe<Scalars['uuid']>;
  /** Text name entry for "signing" */
  signingName?: InputMaybe<Scalars['String']>;
  /** When the encounter note was submitted (independent of recordings) */
  submittedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Actual procedure window. For booking-driven encounters, defaulted from booking.timespan at INSERT if not supplied — provider typically overrides at signing time to reflect the actual window. Snapshot — distinct from booking.timespan, which records the originally-scheduled window. Required when signed (signed_encounter_has_timespan CHECK). */
  timespan?: InputMaybe<Scalars['tstzrange']>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  zone_release?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Ehr_Encounter_Stddev_Fields = {
  __typename?: 'ehr_encounter_stddev_fields';
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: Maybe<Scalars['Float']>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ehr_encounter" */
export type Ehr_Encounter_Stddev_Order_By = {
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: InputMaybe<Order_By>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ehr_Encounter_Stddev_Pop_Fields = {
  __typename?: 'ehr_encounter_stddev_pop_fields';
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: Maybe<Scalars['Float']>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ehr_encounter" */
export type Ehr_Encounter_Stddev_Pop_Order_By = {
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: InputMaybe<Order_By>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ehr_Encounter_Stddev_Samp_Fields = {
  __typename?: 'ehr_encounter_stddev_samp_fields';
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: Maybe<Scalars['Float']>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ehr_encounter" */
export type Ehr_Encounter_Stddev_Samp_Order_By = {
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: InputMaybe<Order_By>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_encounter" */
export type Ehr_Encounter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Encounter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Encounter_Stream_Cursor_Value_Input = {
  /** The clinical summary generated by AI across all the voice recordings */
  AiNotes?: InputMaybe<Scalars['jsonb']>;
  adverseEvent?: InputMaybe<Scalars['Boolean']>;
  /** Constraint enforces not null for all except GENERAL */
  booking?: InputMaybe<Scalars['uuid']>;
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Procedure performed. Set directly on the encounter; not denormalized from booking (booking has no ehr_procedure column). Required for PRE_PROCEDURE and POST_PROCEDURE encounter types (required_ehr_procedure CHECK). */
  ehrProcedure?: InputMaybe<Scalars['uuid']>;
  encounterType?: InputMaybe<Ehr_Encounter_Type_Enum>;
  /** Potentially edited version of the base patient profile data, as submitted during signing. */
  finalMedicalProfile?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** 2D vs 3D injection marking space (TWO_D/THREE_D); NULL when not applicable (non-injection encounter). Set at submit, independent of injection count (zero-injection submits are valid). Filler today; reusable by other injection procedures as they adopt 2D/3D marking. */
  injection_space?: InputMaybe<Filler_Space_Enum>;
  /** Where the encounter happened. */
  location?: InputMaybe<Scalars['uuid']>;
  /** Frozen from the medical profile on submission of transcripts the A if user opts to add these to the note */
  medicalProfile?: InputMaybe<Scalars['jsonb']>;
  modality?: InputMaybe<Ehr_Encounter_Modality_Enum>;
  /** Patient of the procedure. NOT NULL. For booking-driven encounters, denormalized from booking.patient at INSERT only by ehr_encounter_denormalize_from_booking_at_insert; must match booking.patient if both are supplied. Snapshot — does not follow subsequent booking changes. */
  patient?: InputMaybe<Scalars['uuid']>;
  patient_booking?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  /** The possibly edited (from AI original) notes that the provider has legally submitted */
  providerNotes?: InputMaybe<Scalars['jsonb']>;
  /** When the voice recordings are submitted for transcription (this is not the same as the final signing) */
  recordingsSubmittedAt?: InputMaybe<Scalars['timestamptz']>;
  /** For post procedure encounters - the encounter they are the "post" of */
  referenceEncounter?: InputMaybe<Scalars['uuid']>;
  /** Date the provider legally "signs" the record for submission */
  signedAt?: InputMaybe<Scalars['timestamptz']>;
  signedBy?: InputMaybe<Scalars['uuid']>;
  /** Text name entry for "signing" */
  signingName?: InputMaybe<Scalars['String']>;
  /** When the encounter note was submitted (independent of recordings) */
  submittedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Actual procedure window. For booking-driven encounters, defaulted from booking.timespan at INSERT if not supplied — provider typically overrides at signing time to reflect the actual window. Snapshot — distinct from booking.timespan, which records the originally-scheduled window. Required when signed (signed_encounter_has_timespan CHECK). */
  timespan?: InputMaybe<Scalars['tstzrange']>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  zone_release?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Ehr_Encounter_Sum_Fields = {
  __typename?: 'ehr_encounter_sum_fields';
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: Maybe<Scalars['Int']>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ehr_encounter" */
export type Ehr_Encounter_Sum_Order_By = {
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: InputMaybe<Order_By>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: InputMaybe<Order_By>;
};

/** The type of an encounter, determines AI prompt.  GENERAL is for quick calls and such unrelated to bookings.  CONSULT for general consultations, possibly booking linked.  GENERAL_BOOKING for random booking linked. */
export type Ehr_Encounter_Type = {
  __typename?: 'ehr_encounter_type';
  name: Scalars['String'];
};

/** aggregated selection of "ehr_encounter_type" */
export type Ehr_Encounter_Type_Aggregate = {
  __typename?: 'ehr_encounter_type_aggregate';
  aggregate?: Maybe<Ehr_Encounter_Type_Aggregate_Fields>;
  nodes: Array<Ehr_Encounter_Type>;
};

/** aggregate fields of "ehr_encounter_type" */
export type Ehr_Encounter_Type_Aggregate_Fields = {
  __typename?: 'ehr_encounter_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Encounter_Type_Max_Fields>;
  min?: Maybe<Ehr_Encounter_Type_Min_Fields>;
};


/** aggregate fields of "ehr_encounter_type" */
export type Ehr_Encounter_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Encounter_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ehr_encounter_type". All fields are combined with a logical 'AND'. */
export type Ehr_Encounter_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Encounter_Type_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Encounter_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Encounter_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_encounter_type" */
export enum Ehr_Encounter_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  EhrEncounterTypePkey = 'ehr_encounter_type_pkey'
}

export enum Ehr_Encounter_Type_Enum {
  Consult = 'CONSULT',
  General = 'GENERAL',
  GeneralBooking = 'GENERAL_BOOKING',
  PostProcedure = 'POST_PROCEDURE',
  Procedure = 'PROCEDURE'
}

/** Boolean expression to compare columns of type "ehr_encounter_type_enum". All fields are combined with logical 'AND'. */
export type Ehr_Encounter_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ehr_Encounter_Type_Enum>;
  _in?: InputMaybe<Array<Ehr_Encounter_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Ehr_Encounter_Type_Enum>;
  _nin?: InputMaybe<Array<Ehr_Encounter_Type_Enum>>;
};

/** input type for inserting data into table "ehr_encounter_type" */
export type Ehr_Encounter_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ehr_Encounter_Type_Max_Fields = {
  __typename?: 'ehr_encounter_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ehr_Encounter_Type_Min_Fields = {
  __typename?: 'ehr_encounter_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ehr_encounter_type" */
export type Ehr_Encounter_Type_Mutation_Response = {
  __typename?: 'ehr_encounter_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Encounter_Type>;
};

/** input type for inserting object relation for remote table "ehr_encounter_type" */
export type Ehr_Encounter_Type_Obj_Rel_Insert_Input = {
  data: Ehr_Encounter_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Encounter_Type_On_Conflict>;
};

/** on_conflict condition type for table "ehr_encounter_type" */
export type Ehr_Encounter_Type_On_Conflict = {
  constraint: Ehr_Encounter_Type_Constraint;
  update_columns?: Array<Ehr_Encounter_Type_Update_Column>;
  where?: InputMaybe<Ehr_Encounter_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_encounter_type". */
export type Ehr_Encounter_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_encounter_type */
export type Ehr_Encounter_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "ehr_encounter_type" */
export enum Ehr_Encounter_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "ehr_encounter_type" */
export type Ehr_Encounter_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ehr_encounter_type" */
export type Ehr_Encounter_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Encounter_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Encounter_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ehr_encounter_type" */
export enum Ehr_Encounter_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Ehr_Encounter_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Encounter_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Encounter_Type_Bool_Exp;
};

/** update columns of table "ehr_encounter" */
export enum Ehr_Encounter_Update_Column {
  /** column name */
  AiNotes = 'AiNotes',
  /** column name */
  AdverseEvent = 'adverseEvent',
  /** column name */
  Booking = 'booking',
  /** column name */
  CompletedTranscriptCount = 'completedTranscriptCount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EhrProcedure = 'ehrProcedure',
  /** column name */
  EncounterType = 'encounterType',
  /** column name */
  FinalMedicalProfile = 'finalMedicalProfile',
  /** column name */
  Id = 'id',
  /** column name */
  InjectionSpace = 'injection_space',
  /** column name */
  Location = 'location',
  /** column name */
  MedicalProfile = 'medicalProfile',
  /** column name */
  Modality = 'modality',
  /** column name */
  Patient = 'patient',
  /** column name */
  PatientBooking = 'patient_booking',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderNotes = 'providerNotes',
  /** column name */
  RecordingsSubmittedAt = 'recordingsSubmittedAt',
  /** column name */
  ReferenceEncounter = 'referenceEncounter',
  /** column name */
  SignedAt = 'signedAt',
  /** column name */
  SignedBy = 'signedBy',
  /** column name */
  SigningName = 'signingName',
  /** column name */
  SubmittedAt = 'submittedAt',
  /** column name */
  Timespan = 'timespan',
  /** column name */
  TotalUploadedRecordingsCount = 'totalUploadedRecordingsCount',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ZoneRelease = 'zone_release'
}

export type Ehr_Encounter_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Ehr_Encounter_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Ehr_Encounter_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Ehr_Encounter_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Ehr_Encounter_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ehr_Encounter_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Ehr_Encounter_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Encounter_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Encounter_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ehr_Encounter_Var_Pop_Fields = {
  __typename?: 'ehr_encounter_var_pop_fields';
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: Maybe<Scalars['Float']>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ehr_encounter" */
export type Ehr_Encounter_Var_Pop_Order_By = {
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: InputMaybe<Order_By>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ehr_Encounter_Var_Samp_Fields = {
  __typename?: 'ehr_encounter_var_samp_fields';
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: Maybe<Scalars['Float']>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ehr_encounter" */
export type Ehr_Encounter_Var_Samp_Order_By = {
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: InputMaybe<Order_By>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ehr_Encounter_Variance_Fields = {
  __typename?: 'ehr_encounter_variance_fields';
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: Maybe<Scalars['Float']>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ehr_encounter" */
export type Ehr_Encounter_Variance_Order_By = {
  /** Used internally only to avoid transcription races */
  completedTranscriptCount?: InputMaybe<Order_By>;
  /** Final count of voice files uploaded for transcription.  Should have have final value, never intermediates.  Used for race avoidance. */
  totalUploadedRecordingsCount?: InputMaybe<Order_By>;
};

/** columns and relationships of "ehr_fda_product" */
export type Ehr_Fda_Product = {
  __typename?: 'ehr_fda_product';
  createdAt: Scalars['timestamptz'];
  /** The practice's catalog entry (ehr_product) this FDA product resolves to. Null until linked; set once (curation / first scan) and mutable if re-pointed. */
  ehrProduct?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  ehrProductByEhrProduct?: Maybe<Ehr_Product>;
  /** Standard fill volume of this specific SKU (per GTIN — the same product ships in multiple sizes). Prefilled onto a scanned instance's initial_volume_ml. Populated at seed time (PM-verified); OpenFDA's own volume data is unreliable. */
  fillVolumeMl?: Maybe<Scalars['numeric']>;
  /** Normalized GTIN-14 of the scanned barcode (zero-padded). Unique, but not the PK: it is an externally-assigned, derived value, so we keep it correctable in place without disturbing clinical FKs. */
  gtin: Scalars['String'];
  id: Scalars['uuid'];
  /** The manufacturer's consumer-facing product label (brand + line + variant), as recorded in the source dataset's misleadingly-named brand_name field. Often carries pack-size or SAMPLE/DEMO noise and inconsistent casing/accents. Full record in results; the stable identity is the GTIN. */
  productLabel?: Maybe<Scalars['String']>;
  results: Scalars['jsonb'];
  source: Ehr_Fda_Product_Source_Enum;
};


/** columns and relationships of "ehr_fda_product" */
export type Ehr_Fda_ProductResultsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ehr_fda_product" */
export type Ehr_Fda_Product_Aggregate = {
  __typename?: 'ehr_fda_product_aggregate';
  aggregate?: Maybe<Ehr_Fda_Product_Aggregate_Fields>;
  nodes: Array<Ehr_Fda_Product>;
};

/** aggregate fields of "ehr_fda_product" */
export type Ehr_Fda_Product_Aggregate_Fields = {
  __typename?: 'ehr_fda_product_aggregate_fields';
  avg?: Maybe<Ehr_Fda_Product_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ehr_Fda_Product_Max_Fields>;
  min?: Maybe<Ehr_Fda_Product_Min_Fields>;
  stddev?: Maybe<Ehr_Fda_Product_Stddev_Fields>;
  stddev_pop?: Maybe<Ehr_Fda_Product_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ehr_Fda_Product_Stddev_Samp_Fields>;
  sum?: Maybe<Ehr_Fda_Product_Sum_Fields>;
  var_pop?: Maybe<Ehr_Fda_Product_Var_Pop_Fields>;
  var_samp?: Maybe<Ehr_Fda_Product_Var_Samp_Fields>;
  variance?: Maybe<Ehr_Fda_Product_Variance_Fields>;
};


/** aggregate fields of "ehr_fda_product" */
export type Ehr_Fda_Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Fda_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Ehr_Fda_Product_Append_Input = {
  results?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Ehr_Fda_Product_Avg_Fields = {
  __typename?: 'ehr_fda_product_avg_fields';
  /** Standard fill volume of this specific SKU (per GTIN — the same product ships in multiple sizes). Prefilled onto a scanned instance's initial_volume_ml. Populated at seed time (PM-verified); OpenFDA's own volume data is unreliable. */
  fillVolumeMl?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ehr_fda_product". All fields are combined with a logical 'AND'. */
export type Ehr_Fda_Product_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Fda_Product_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Fda_Product_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Fda_Product_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrProduct?: InputMaybe<Uuid_Comparison_Exp>;
  ehrProductByEhrProduct?: InputMaybe<Ehr_Product_Bool_Exp>;
  fillVolumeMl?: InputMaybe<Numeric_Comparison_Exp>;
  gtin?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  productLabel?: InputMaybe<String_Comparison_Exp>;
  results?: InputMaybe<Jsonb_Comparison_Exp>;
  source?: InputMaybe<Ehr_Fda_Product_Source_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_fda_product" */
export enum Ehr_Fda_Product_Constraint {
  /** unique or primary key constraint on columns "gtin" */
  EhrFdaProductGtinKey = 'ehr_fda_product_gtin_key',
  /** unique or primary key constraint on columns "id" */
  EhrFdaProductPkey = 'ehr_fda_product_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Ehr_Fda_Product_Delete_At_Path_Input = {
  results?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Ehr_Fda_Product_Delete_Elem_Input = {
  results?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Ehr_Fda_Product_Delete_Key_Input = {
  results?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "ehr_fda_product" */
export type Ehr_Fda_Product_Inc_Input = {
  /** Standard fill volume of this specific SKU (per GTIN — the same product ships in multiple sizes). Prefilled onto a scanned instance's initial_volume_ml. Populated at seed time (PM-verified); OpenFDA's own volume data is unreliable. */
  fillVolumeMl?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "ehr_fda_product" */
export type Ehr_Fda_Product_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The practice's catalog entry (ehr_product) this FDA product resolves to. Null until linked; set once (curation / first scan) and mutable if re-pointed. */
  ehrProduct?: InputMaybe<Scalars['uuid']>;
  ehrProductByEhrProduct?: InputMaybe<Ehr_Product_Obj_Rel_Insert_Input>;
  /** Standard fill volume of this specific SKU (per GTIN — the same product ships in multiple sizes). Prefilled onto a scanned instance's initial_volume_ml. Populated at seed time (PM-verified); OpenFDA's own volume data is unreliable. */
  fillVolumeMl?: InputMaybe<Scalars['numeric']>;
  /** Normalized GTIN-14 of the scanned barcode (zero-padded). Unique, but not the PK: it is an externally-assigned, derived value, so we keep it correctable in place without disturbing clinical FKs. */
  gtin?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The manufacturer's consumer-facing product label (brand + line + variant), as recorded in the source dataset's misleadingly-named brand_name field. Often carries pack-size or SAMPLE/DEMO noise and inconsistent casing/accents. Full record in results; the stable identity is the GTIN. */
  productLabel?: InputMaybe<Scalars['String']>;
  results?: InputMaybe<Scalars['jsonb']>;
  source?: InputMaybe<Ehr_Fda_Product_Source_Enum>;
};

/** aggregate max on columns */
export type Ehr_Fda_Product_Max_Fields = {
  __typename?: 'ehr_fda_product_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The practice's catalog entry (ehr_product) this FDA product resolves to. Null until linked; set once (curation / first scan) and mutable if re-pointed. */
  ehrProduct?: Maybe<Scalars['uuid']>;
  /** Standard fill volume of this specific SKU (per GTIN — the same product ships in multiple sizes). Prefilled onto a scanned instance's initial_volume_ml. Populated at seed time (PM-verified); OpenFDA's own volume data is unreliable. */
  fillVolumeMl?: Maybe<Scalars['numeric']>;
  /** Normalized GTIN-14 of the scanned barcode (zero-padded). Unique, but not the PK: it is an externally-assigned, derived value, so we keep it correctable in place without disturbing clinical FKs. */
  gtin?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** The manufacturer's consumer-facing product label (brand + line + variant), as recorded in the source dataset's misleadingly-named brand_name field. Often carries pack-size or SAMPLE/DEMO noise and inconsistent casing/accents. Full record in results; the stable identity is the GTIN. */
  productLabel?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ehr_Fda_Product_Min_Fields = {
  __typename?: 'ehr_fda_product_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** The practice's catalog entry (ehr_product) this FDA product resolves to. Null until linked; set once (curation / first scan) and mutable if re-pointed. */
  ehrProduct?: Maybe<Scalars['uuid']>;
  /** Standard fill volume of this specific SKU (per GTIN — the same product ships in multiple sizes). Prefilled onto a scanned instance's initial_volume_ml. Populated at seed time (PM-verified); OpenFDA's own volume data is unreliable. */
  fillVolumeMl?: Maybe<Scalars['numeric']>;
  /** Normalized GTIN-14 of the scanned barcode (zero-padded). Unique, but not the PK: it is an externally-assigned, derived value, so we keep it correctable in place without disturbing clinical FKs. */
  gtin?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** The manufacturer's consumer-facing product label (brand + line + variant), as recorded in the source dataset's misleadingly-named brand_name field. Often carries pack-size or SAMPLE/DEMO noise and inconsistent casing/accents. Full record in results; the stable identity is the GTIN. */
  productLabel?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ehr_fda_product" */
export type Ehr_Fda_Product_Mutation_Response = {
  __typename?: 'ehr_fda_product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Fda_Product>;
};

/** on_conflict condition type for table "ehr_fda_product" */
export type Ehr_Fda_Product_On_Conflict = {
  constraint: Ehr_Fda_Product_Constraint;
  update_columns?: Array<Ehr_Fda_Product_Update_Column>;
  where?: InputMaybe<Ehr_Fda_Product_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_fda_product". */
export type Ehr_Fda_Product_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  ehrProduct?: InputMaybe<Order_By>;
  ehrProductByEhrProduct?: InputMaybe<Ehr_Product_Order_By>;
  fillVolumeMl?: InputMaybe<Order_By>;
  gtin?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  productLabel?: InputMaybe<Order_By>;
  results?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_fda_product */
export type Ehr_Fda_Product_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Ehr_Fda_Product_Prepend_Input = {
  results?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ehr_fda_product" */
export enum Ehr_Fda_Product_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EhrProduct = 'ehrProduct',
  /** column name */
  FillVolumeMl = 'fillVolumeMl',
  /** column name */
  Gtin = 'gtin',
  /** column name */
  Id = 'id',
  /** column name */
  ProductLabel = 'productLabel',
  /** column name */
  Results = 'results',
  /** column name */
  Source = 'source'
}

/** input type for updating data in table "ehr_fda_product" */
export type Ehr_Fda_Product_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The practice's catalog entry (ehr_product) this FDA product resolves to. Null until linked; set once (curation / first scan) and mutable if re-pointed. */
  ehrProduct?: InputMaybe<Scalars['uuid']>;
  /** Standard fill volume of this specific SKU (per GTIN — the same product ships in multiple sizes). Prefilled onto a scanned instance's initial_volume_ml. Populated at seed time (PM-verified); OpenFDA's own volume data is unreliable. */
  fillVolumeMl?: InputMaybe<Scalars['numeric']>;
  /** Normalized GTIN-14 of the scanned barcode (zero-padded). Unique, but not the PK: it is an externally-assigned, derived value, so we keep it correctable in place without disturbing clinical FKs. */
  gtin?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The manufacturer's consumer-facing product label (brand + line + variant), as recorded in the source dataset's misleadingly-named brand_name field. Often carries pack-size or SAMPLE/DEMO noise and inconsistent casing/accents. Full record in results; the stable identity is the GTIN. */
  productLabel?: InputMaybe<Scalars['String']>;
  results?: InputMaybe<Scalars['jsonb']>;
  source?: InputMaybe<Ehr_Fda_Product_Source_Enum>;
};

/** columns and relationships of "ehr_fda_product_source" */
export type Ehr_Fda_Product_Source = {
  __typename?: 'ehr_fda_product_source';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "ehr_fda_product_source" */
export type Ehr_Fda_Product_Source_Aggregate = {
  __typename?: 'ehr_fda_product_source_aggregate';
  aggregate?: Maybe<Ehr_Fda_Product_Source_Aggregate_Fields>;
  nodes: Array<Ehr_Fda_Product_Source>;
};

/** aggregate fields of "ehr_fda_product_source" */
export type Ehr_Fda_Product_Source_Aggregate_Fields = {
  __typename?: 'ehr_fda_product_source_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Fda_Product_Source_Max_Fields>;
  min?: Maybe<Ehr_Fda_Product_Source_Min_Fields>;
};


/** aggregate fields of "ehr_fda_product_source" */
export type Ehr_Fda_Product_Source_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Fda_Product_Source_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ehr_fda_product_source". All fields are combined with a logical 'AND'. */
export type Ehr_Fda_Product_Source_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Fda_Product_Source_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Fda_Product_Source_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Fda_Product_Source_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_fda_product_source" */
export enum Ehr_Fda_Product_Source_Constraint {
  /** unique or primary key constraint on columns "value" */
  EhrFdaProductSourcePkey = 'ehr_fda_product_source_pkey'
}

export enum Ehr_Fda_Product_Source_Enum {
  /** OpenFDA device UDI dataset (e.g. dermal fillers) */
  Device = 'device',
  /** OpenFDA drug NDC dataset (e.g. neurotoxins) */
  Drug = 'drug'
}

/** Boolean expression to compare columns of type "ehr_fda_product_source_enum". All fields are combined with logical 'AND'. */
export type Ehr_Fda_Product_Source_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ehr_Fda_Product_Source_Enum>;
  _in?: InputMaybe<Array<Ehr_Fda_Product_Source_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Ehr_Fda_Product_Source_Enum>;
  _nin?: InputMaybe<Array<Ehr_Fda_Product_Source_Enum>>;
};

/** input type for inserting data into table "ehr_fda_product_source" */
export type Ehr_Fda_Product_Source_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ehr_Fda_Product_Source_Max_Fields = {
  __typename?: 'ehr_fda_product_source_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ehr_Fda_Product_Source_Min_Fields = {
  __typename?: 'ehr_fda_product_source_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ehr_fda_product_source" */
export type Ehr_Fda_Product_Source_Mutation_Response = {
  __typename?: 'ehr_fda_product_source_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Fda_Product_Source>;
};

/** on_conflict condition type for table "ehr_fda_product_source" */
export type Ehr_Fda_Product_Source_On_Conflict = {
  constraint: Ehr_Fda_Product_Source_Constraint;
  update_columns?: Array<Ehr_Fda_Product_Source_Update_Column>;
  where?: InputMaybe<Ehr_Fda_Product_Source_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_fda_product_source". */
export type Ehr_Fda_Product_Source_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_fda_product_source */
export type Ehr_Fda_Product_Source_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "ehr_fda_product_source" */
export enum Ehr_Fda_Product_Source_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "ehr_fda_product_source" */
export type Ehr_Fda_Product_Source_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ehr_fda_product_source" */
export type Ehr_Fda_Product_Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Fda_Product_Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Fda_Product_Source_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ehr_fda_product_source" */
export enum Ehr_Fda_Product_Source_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Ehr_Fda_Product_Source_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Fda_Product_Source_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Fda_Product_Source_Bool_Exp;
};

/** aggregate stddev on columns */
export type Ehr_Fda_Product_Stddev_Fields = {
  __typename?: 'ehr_fda_product_stddev_fields';
  /** Standard fill volume of this specific SKU (per GTIN — the same product ships in multiple sizes). Prefilled onto a scanned instance's initial_volume_ml. Populated at seed time (PM-verified); OpenFDA's own volume data is unreliable. */
  fillVolumeMl?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ehr_Fda_Product_Stddev_Pop_Fields = {
  __typename?: 'ehr_fda_product_stddev_pop_fields';
  /** Standard fill volume of this specific SKU (per GTIN — the same product ships in multiple sizes). Prefilled onto a scanned instance's initial_volume_ml. Populated at seed time (PM-verified); OpenFDA's own volume data is unreliable. */
  fillVolumeMl?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ehr_Fda_Product_Stddev_Samp_Fields = {
  __typename?: 'ehr_fda_product_stddev_samp_fields';
  /** Standard fill volume of this specific SKU (per GTIN — the same product ships in multiple sizes). Prefilled onto a scanned instance's initial_volume_ml. Populated at seed time (PM-verified); OpenFDA's own volume data is unreliable. */
  fillVolumeMl?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ehr_fda_product" */
export type Ehr_Fda_Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Fda_Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Fda_Product_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** The practice's catalog entry (ehr_product) this FDA product resolves to. Null until linked; set once (curation / first scan) and mutable if re-pointed. */
  ehrProduct?: InputMaybe<Scalars['uuid']>;
  /** Standard fill volume of this specific SKU (per GTIN — the same product ships in multiple sizes). Prefilled onto a scanned instance's initial_volume_ml. Populated at seed time (PM-verified); OpenFDA's own volume data is unreliable. */
  fillVolumeMl?: InputMaybe<Scalars['numeric']>;
  /** Normalized GTIN-14 of the scanned barcode (zero-padded). Unique, but not the PK: it is an externally-assigned, derived value, so we keep it correctable in place without disturbing clinical FKs. */
  gtin?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The manufacturer's consumer-facing product label (brand + line + variant), as recorded in the source dataset's misleadingly-named brand_name field. Often carries pack-size or SAMPLE/DEMO noise and inconsistent casing/accents. Full record in results; the stable identity is the GTIN. */
  productLabel?: InputMaybe<Scalars['String']>;
  results?: InputMaybe<Scalars['jsonb']>;
  source?: InputMaybe<Ehr_Fda_Product_Source_Enum>;
};

/** aggregate sum on columns */
export type Ehr_Fda_Product_Sum_Fields = {
  __typename?: 'ehr_fda_product_sum_fields';
  /** Standard fill volume of this specific SKU (per GTIN — the same product ships in multiple sizes). Prefilled onto a scanned instance's initial_volume_ml. Populated at seed time (PM-verified); OpenFDA's own volume data is unreliable. */
  fillVolumeMl?: Maybe<Scalars['numeric']>;
};

/** update columns of table "ehr_fda_product" */
export enum Ehr_Fda_Product_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EhrProduct = 'ehrProduct',
  /** column name */
  FillVolumeMl = 'fillVolumeMl',
  /** column name */
  Gtin = 'gtin',
  /** column name */
  Id = 'id',
  /** column name */
  ProductLabel = 'productLabel',
  /** column name */
  Results = 'results',
  /** column name */
  Source = 'source'
}

export type Ehr_Fda_Product_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Ehr_Fda_Product_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Ehr_Fda_Product_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Ehr_Fda_Product_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Ehr_Fda_Product_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ehr_Fda_Product_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Ehr_Fda_Product_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Fda_Product_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Fda_Product_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ehr_Fda_Product_Var_Pop_Fields = {
  __typename?: 'ehr_fda_product_var_pop_fields';
  /** Standard fill volume of this specific SKU (per GTIN — the same product ships in multiple sizes). Prefilled onto a scanned instance's initial_volume_ml. Populated at seed time (PM-verified); OpenFDA's own volume data is unreliable. */
  fillVolumeMl?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ehr_Fda_Product_Var_Samp_Fields = {
  __typename?: 'ehr_fda_product_var_samp_fields';
  /** Standard fill volume of this specific SKU (per GTIN — the same product ships in multiple sizes). Prefilled onto a scanned instance's initial_volume_ml. Populated at seed time (PM-verified); OpenFDA's own volume data is unreliable. */
  fillVolumeMl?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ehr_Fda_Product_Variance_Fields = {
  __typename?: 'ehr_fda_product_variance_fields';
  /** Standard fill volume of this specific SKU (per GTIN — the same product ships in multiple sizes). Prefilled onto a scanned instance's initial_volume_ml. Populated at seed time (PM-verified); OpenFDA's own volume data is unreliable. */
  fillVolumeMl?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ehr_message" */
export type Ehr_Message = {
  __typename?: 'ehr_message';
  body: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  ehrEncounterByEncounter?: Maybe<Ehr_Encounter>;
  /** An array relationship */
  ehrMessageReads: Array<Ehr_Message_Read>;
  /** An aggregate relationship */
  ehrMessageReads_aggregate: Ehr_Message_Read_Aggregate;
  /** An object relationship */
  ehrMessageThreadByThread: Ehr_Message_Threads;
  encounter?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  patient?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  patientByPatient?: Maybe<Patient>;
  sender: Scalars['uuid'];
  thread: Scalars['uuid'];
  /** An object relationship */
  userBySender: User;
};


/** columns and relationships of "ehr_message" */
export type Ehr_MessageEhrMessageReadsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Message_Read_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Message_Read_Order_By>>;
  where?: InputMaybe<Ehr_Message_Read_Bool_Exp>;
};


/** columns and relationships of "ehr_message" */
export type Ehr_MessageEhrMessageReads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Message_Read_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Message_Read_Order_By>>;
  where?: InputMaybe<Ehr_Message_Read_Bool_Exp>;
};

/** aggregated selection of "ehr_message" */
export type Ehr_Message_Aggregate = {
  __typename?: 'ehr_message_aggregate';
  aggregate?: Maybe<Ehr_Message_Aggregate_Fields>;
  nodes: Array<Ehr_Message>;
};

export type Ehr_Message_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ehr_Message_Aggregate_Bool_Exp_Count>;
};

export type Ehr_Message_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ehr_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Message_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ehr_message" */
export type Ehr_Message_Aggregate_Fields = {
  __typename?: 'ehr_message_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Message_Max_Fields>;
  min?: Maybe<Ehr_Message_Min_Fields>;
};


/** aggregate fields of "ehr_message" */
export type Ehr_Message_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ehr_message" */
export type Ehr_Message_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Message_Max_Order_By>;
  min?: InputMaybe<Ehr_Message_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ehr_message" */
export type Ehr_Message_Arr_Rel_Insert_Input = {
  data: Array<Ehr_Message_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Message_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ehr_message". All fields are combined with a logical 'AND'. */
export type Ehr_Message_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Message_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Message_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Message_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrEncounterByEncounter?: InputMaybe<Ehr_Encounter_Bool_Exp>;
  ehrMessageReads?: InputMaybe<Ehr_Message_Read_Bool_Exp>;
  ehrMessageReads_aggregate?: InputMaybe<Ehr_Message_Read_Aggregate_Bool_Exp>;
  ehrMessageThreadByThread?: InputMaybe<Ehr_Message_Threads_Bool_Exp>;
  encounter?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  patient?: InputMaybe<Uuid_Comparison_Exp>;
  patientByPatient?: InputMaybe<Patient_Bool_Exp>;
  sender?: InputMaybe<Uuid_Comparison_Exp>;
  thread?: InputMaybe<Uuid_Comparison_Exp>;
  userBySender?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "ehr_message" */
export enum Ehr_Message_Constraint {
  /** unique or primary key constraint on columns "id" */
  EhrMessagePkey = 'ehr_message_pkey'
}

/** input type for inserting data into table "ehr_message" */
export type Ehr_Message_Insert_Input = {
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  ehrEncounterByEncounter?: InputMaybe<Ehr_Encounter_Obj_Rel_Insert_Input>;
  ehrMessageReads?: InputMaybe<Ehr_Message_Read_Arr_Rel_Insert_Input>;
  ehrMessageThreadByThread?: InputMaybe<Ehr_Message_Threads_Obj_Rel_Insert_Input>;
  encounter?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  patientByPatient?: InputMaybe<Patient_Obj_Rel_Insert_Input>;
  sender?: InputMaybe<Scalars['uuid']>;
  thread?: InputMaybe<Scalars['uuid']>;
  userBySender?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Ehr_Message_Max_Fields = {
  __typename?: 'ehr_message_max_fields';
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  encounter?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  patient?: Maybe<Scalars['uuid']>;
  sender?: Maybe<Scalars['uuid']>;
  thread?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "ehr_message" */
export type Ehr_Message_Max_Order_By = {
  body?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  encounter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  sender?: InputMaybe<Order_By>;
  thread?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ehr_Message_Min_Fields = {
  __typename?: 'ehr_message_min_fields';
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  encounter?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  patient?: Maybe<Scalars['uuid']>;
  sender?: Maybe<Scalars['uuid']>;
  thread?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "ehr_message" */
export type Ehr_Message_Min_Order_By = {
  body?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  encounter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  sender?: InputMaybe<Order_By>;
  thread?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ehr_message" */
export type Ehr_Message_Mutation_Response = {
  __typename?: 'ehr_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Message>;
};

/** input type for inserting object relation for remote table "ehr_message" */
export type Ehr_Message_Obj_Rel_Insert_Input = {
  data: Ehr_Message_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Message_On_Conflict>;
};

/** on_conflict condition type for table "ehr_message" */
export type Ehr_Message_On_Conflict = {
  constraint: Ehr_Message_Constraint;
  update_columns?: Array<Ehr_Message_Update_Column>;
  where?: InputMaybe<Ehr_Message_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_message". */
export type Ehr_Message_Order_By = {
  body?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  ehrEncounterByEncounter?: InputMaybe<Ehr_Encounter_Order_By>;
  ehrMessageReads_aggregate?: InputMaybe<Ehr_Message_Read_Aggregate_Order_By>;
  ehrMessageThreadByThread?: InputMaybe<Ehr_Message_Threads_Order_By>;
  encounter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  patientByPatient?: InputMaybe<Patient_Order_By>;
  sender?: InputMaybe<Order_By>;
  thread?: InputMaybe<Order_By>;
  userBySender?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: ehr_message */
export type Ehr_Message_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "ehr_message_read" */
export type Ehr_Message_Read = {
  __typename?: 'ehr_message_read';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  ehrMessageByMessage: Ehr_Message;
  id: Scalars['uuid'];
  message: Scalars['uuid'];
  readAt: Scalars['timestamptz'];
  reader: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  userByReader: User;
};

/** aggregated selection of "ehr_message_read" */
export type Ehr_Message_Read_Aggregate = {
  __typename?: 'ehr_message_read_aggregate';
  aggregate?: Maybe<Ehr_Message_Read_Aggregate_Fields>;
  nodes: Array<Ehr_Message_Read>;
};

export type Ehr_Message_Read_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ehr_Message_Read_Aggregate_Bool_Exp_Count>;
};

export type Ehr_Message_Read_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ehr_Message_Read_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Message_Read_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ehr_message_read" */
export type Ehr_Message_Read_Aggregate_Fields = {
  __typename?: 'ehr_message_read_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Message_Read_Max_Fields>;
  min?: Maybe<Ehr_Message_Read_Min_Fields>;
};


/** aggregate fields of "ehr_message_read" */
export type Ehr_Message_Read_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Message_Read_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ehr_message_read" */
export type Ehr_Message_Read_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Message_Read_Max_Order_By>;
  min?: InputMaybe<Ehr_Message_Read_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ehr_message_read" */
export type Ehr_Message_Read_Arr_Rel_Insert_Input = {
  data: Array<Ehr_Message_Read_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Message_Read_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ehr_message_read". All fields are combined with a logical 'AND'. */
export type Ehr_Message_Read_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Message_Read_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Message_Read_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Message_Read_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrMessageByMessage?: InputMaybe<Ehr_Message_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<Uuid_Comparison_Exp>;
  readAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  reader?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userByReader?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "ehr_message_read" */
export enum Ehr_Message_Read_Constraint {
  /** unique or primary key constraint on columns "reader", "message" */
  EhrMessageReadMessageReaderKey = 'ehr_message_read_message_reader_key',
  /** unique or primary key constraint on columns "id" */
  EhrMessageReadPkey = 'ehr_message_read_pkey'
}

/** input type for inserting data into table "ehr_message_read" */
export type Ehr_Message_Read_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  ehrMessageByMessage?: InputMaybe<Ehr_Message_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['uuid']>;
  readAt?: InputMaybe<Scalars['timestamptz']>;
  reader?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userByReader?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Ehr_Message_Read_Max_Fields = {
  __typename?: 'ehr_message_read_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  readAt?: Maybe<Scalars['timestamptz']>;
  reader?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "ehr_message_read" */
export type Ehr_Message_Read_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  readAt?: InputMaybe<Order_By>;
  reader?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ehr_Message_Read_Min_Fields = {
  __typename?: 'ehr_message_read_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  readAt?: Maybe<Scalars['timestamptz']>;
  reader?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "ehr_message_read" */
export type Ehr_Message_Read_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  readAt?: InputMaybe<Order_By>;
  reader?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ehr_message_read" */
export type Ehr_Message_Read_Mutation_Response = {
  __typename?: 'ehr_message_read_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Message_Read>;
};

/** on_conflict condition type for table "ehr_message_read" */
export type Ehr_Message_Read_On_Conflict = {
  constraint: Ehr_Message_Read_Constraint;
  update_columns?: Array<Ehr_Message_Read_Update_Column>;
  where?: InputMaybe<Ehr_Message_Read_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_message_read". */
export type Ehr_Message_Read_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  ehrMessageByMessage?: InputMaybe<Ehr_Message_Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  readAt?: InputMaybe<Order_By>;
  reader?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userByReader?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: ehr_message_read */
export type Ehr_Message_Read_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ehr_message_read" */
export enum Ehr_Message_Read_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  ReadAt = 'readAt',
  /** column name */
  Reader = 'reader',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "ehr_message_read" */
export type Ehr_Message_Read_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['uuid']>;
  readAt?: InputMaybe<Scalars['timestamptz']>;
  reader?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "ehr_message_read" */
export type Ehr_Message_Read_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Message_Read_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Message_Read_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['uuid']>;
  readAt?: InputMaybe<Scalars['timestamptz']>;
  reader?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "ehr_message_read" */
export enum Ehr_Message_Read_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  ReadAt = 'readAt',
  /** column name */
  Reader = 'reader',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Ehr_Message_Read_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Message_Read_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Message_Read_Bool_Exp;
};

/** select columns of table "ehr_message" */
export enum Ehr_Message_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Encounter = 'encounter',
  /** column name */
  Id = 'id',
  /** column name */
  Patient = 'patient',
  /** column name */
  Sender = 'sender',
  /** column name */
  Thread = 'thread'
}

/** input type for updating data in table "ehr_message" */
export type Ehr_Message_Set_Input = {
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  encounter?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  sender?: InputMaybe<Scalars['uuid']>;
  thread?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "ehr_message" */
export type Ehr_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Message_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  encounter?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  sender?: InputMaybe<Scalars['uuid']>;
  thread?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "ehr_message_threads" */
export type Ehr_Message_Threads = {
  __typename?: 'ehr_message_threads';
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  ehrMessages: Array<Ehr_Message>;
  /** An aggregate relationship */
  ehrMessages_aggregate: Ehr_Message_Aggregate;
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  provider: Scalars['uuid'];
  supervisor: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  userByProvider: User;
  /** An object relationship */
  userBySupervisor: User;
};


/** columns and relationships of "ehr_message_threads" */
export type Ehr_Message_ThreadsEhrMessagesArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Message_Order_By>>;
  where?: InputMaybe<Ehr_Message_Bool_Exp>;
};


/** columns and relationships of "ehr_message_threads" */
export type Ehr_Message_ThreadsEhrMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Message_Order_By>>;
  where?: InputMaybe<Ehr_Message_Bool_Exp>;
};

/** aggregated selection of "ehr_message_threads" */
export type Ehr_Message_Threads_Aggregate = {
  __typename?: 'ehr_message_threads_aggregate';
  aggregate?: Maybe<Ehr_Message_Threads_Aggregate_Fields>;
  nodes: Array<Ehr_Message_Threads>;
};

/** aggregate fields of "ehr_message_threads" */
export type Ehr_Message_Threads_Aggregate_Fields = {
  __typename?: 'ehr_message_threads_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Message_Threads_Max_Fields>;
  min?: Maybe<Ehr_Message_Threads_Min_Fields>;
};


/** aggregate fields of "ehr_message_threads" */
export type Ehr_Message_Threads_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Message_Threads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ehr_message_threads". All fields are combined with a logical 'AND'. */
export type Ehr_Message_Threads_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Message_Threads_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Message_Threads_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Message_Threads_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrMessages?: InputMaybe<Ehr_Message_Bool_Exp>;
  ehrMessages_aggregate?: InputMaybe<Ehr_Message_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  supervisor?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userByProvider?: InputMaybe<User_Bool_Exp>;
  userBySupervisor?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "ehr_message_threads" */
export enum Ehr_Message_Threads_Constraint {
  /** unique or primary key constraint on columns "id" */
  EhrMessageThreadsPkey = 'ehr_message_threads_pkey',
  /** unique or primary key constraint on columns "provider", "supervisor", "location" */
  EhrMessageThreadsSupProvLocUniq = 'ehr_message_threads_sup_prov_loc_uniq'
}

/** input type for inserting data into table "ehr_message_threads" */
export type Ehr_Message_Threads_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  ehrMessages?: InputMaybe<Ehr_Message_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  provider?: InputMaybe<Scalars['uuid']>;
  supervisor?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userBySupervisor?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Ehr_Message_Threads_Max_Fields = {
  __typename?: 'ehr_message_threads_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  supervisor?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Ehr_Message_Threads_Min_Fields = {
  __typename?: 'ehr_message_threads_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  supervisor?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "ehr_message_threads" */
export type Ehr_Message_Threads_Mutation_Response = {
  __typename?: 'ehr_message_threads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Message_Threads>;
};

/** input type for inserting object relation for remote table "ehr_message_threads" */
export type Ehr_Message_Threads_Obj_Rel_Insert_Input = {
  data: Ehr_Message_Threads_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Message_Threads_On_Conflict>;
};

/** on_conflict condition type for table "ehr_message_threads" */
export type Ehr_Message_Threads_On_Conflict = {
  constraint: Ehr_Message_Threads_Constraint;
  update_columns?: Array<Ehr_Message_Threads_Update_Column>;
  where?: InputMaybe<Ehr_Message_Threads_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_message_threads". */
export type Ehr_Message_Threads_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  ehrMessages_aggregate?: InputMaybe<Ehr_Message_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  provider?: InputMaybe<Order_By>;
  supervisor?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userByProvider?: InputMaybe<User_Order_By>;
  userBySupervisor?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: ehr_message_threads */
export type Ehr_Message_Threads_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ehr_message_threads" */
export enum Ehr_Message_Threads_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Provider = 'provider',
  /** column name */
  Supervisor = 'supervisor',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "ehr_message_threads" */
export type Ehr_Message_Threads_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  supervisor?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "ehr_message_threads" */
export type Ehr_Message_Threads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Message_Threads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Message_Threads_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  supervisor?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "ehr_message_threads" */
export enum Ehr_Message_Threads_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Provider = 'provider',
  /** column name */
  Supervisor = 'supervisor',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Ehr_Message_Threads_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Message_Threads_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Message_Threads_Bool_Exp;
};

/** update columns of table "ehr_message" */
export enum Ehr_Message_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Encounter = 'encounter',
  /** column name */
  Id = 'id',
  /** column name */
  Patient = 'patient',
  /** column name */
  Sender = 'sender',
  /** column name */
  Thread = 'thread'
}

export type Ehr_Message_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Message_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Message_Bool_Exp;
};

/** A card Square holds for the patient's customer, registered with the consent under which it may be charged. A removed registration keeps its row, with deleted_at set. */
export type Ehr_Patient_Card = {
  __typename?: 'ehr_patient_card';
  brand: Scalars['String'];
  consentAt: Scalars['timestamptz'];
  consentObtainedBy: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fingerprint: Scalars['String'];
  id: Scalars['uuid'];
  /** True when this card is the patient's default card. At most one row per patient with deleted_at NULL is the default. */
  isDefault: Scalars['Boolean'];
  last4: Scalars['String'];
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation?: Maybe<Location>;
  patient: Scalars['uuid'];
  /** An object relationship */
  patientByPatient: Patient;
  squareCardId: Scalars['String'];
};

/** aggregated selection of "ehr_patient_card" */
export type Ehr_Patient_Card_Aggregate = {
  __typename?: 'ehr_patient_card_aggregate';
  aggregate?: Maybe<Ehr_Patient_Card_Aggregate_Fields>;
  nodes: Array<Ehr_Patient_Card>;
};

export type Ehr_Patient_Card_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Ehr_Patient_Card_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Ehr_Patient_Card_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Ehr_Patient_Card_Aggregate_Bool_Exp_Count>;
};

export type Ehr_Patient_Card_Aggregate_Bool_Exp_Bool_And = {
  arguments: Ehr_Patient_Card_Select_Column_Ehr_Patient_Card_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Patient_Card_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ehr_Patient_Card_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Ehr_Patient_Card_Select_Column_Ehr_Patient_Card_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Patient_Card_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ehr_Patient_Card_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ehr_Patient_Card_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Patient_Card_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ehr_patient_card" */
export type Ehr_Patient_Card_Aggregate_Fields = {
  __typename?: 'ehr_patient_card_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Patient_Card_Max_Fields>;
  min?: Maybe<Ehr_Patient_Card_Min_Fields>;
};


/** aggregate fields of "ehr_patient_card" */
export type Ehr_Patient_Card_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Patient_Card_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ehr_patient_card" */
export type Ehr_Patient_Card_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Patient_Card_Max_Order_By>;
  min?: InputMaybe<Ehr_Patient_Card_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ehr_patient_card" */
export type Ehr_Patient_Card_Arr_Rel_Insert_Input = {
  data: Array<Ehr_Patient_Card_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Patient_Card_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ehr_patient_card". All fields are combined with a logical 'AND'. */
export type Ehr_Patient_Card_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Patient_Card_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Patient_Card_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Patient_Card_Bool_Exp>>;
  brand?: InputMaybe<String_Comparison_Exp>;
  consentAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  consentObtainedBy?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  fingerprint?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isDefault?: InputMaybe<Boolean_Comparison_Exp>;
  last4?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  patient?: InputMaybe<Uuid_Comparison_Exp>;
  patientByPatient?: InputMaybe<Patient_Bool_Exp>;
  squareCardId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_patient_card" */
export enum Ehr_Patient_Card_Constraint {
  /** unique or primary key constraint on columns "patient", "fingerprint" */
  EhrPatientCardOneActivePerFingerprint = 'ehr_patient_card_one_active_per_fingerprint',
  /** unique or primary key constraint on columns "square_card_id", "patient" */
  EhrPatientCardOneActivePerSquareCard = 'ehr_patient_card_one_active_per_square_card',
  /** unique or primary key constraint on columns "patient" */
  EhrPatientCardOneDefaultPerPatient = 'ehr_patient_card_one_default_per_patient',
  /** unique or primary key constraint on columns "id" */
  EhrPatientCardPkey = 'ehr_patient_card_pkey'
}

/** input type for inserting data into table "ehr_patient_card" */
export type Ehr_Patient_Card_Insert_Input = {
  brand?: InputMaybe<Scalars['String']>;
  consentAt?: InputMaybe<Scalars['timestamptz']>;
  consentObtainedBy?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fingerprint?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** True when this card is the patient's default card. At most one row per patient with deleted_at NULL is the default. */
  isDefault?: InputMaybe<Scalars['Boolean']>;
  last4?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  patient?: InputMaybe<Scalars['uuid']>;
  patientByPatient?: InputMaybe<Patient_Obj_Rel_Insert_Input>;
  squareCardId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ehr_Patient_Card_Max_Fields = {
  __typename?: 'ehr_patient_card_max_fields';
  brand?: Maybe<Scalars['String']>;
  consentAt?: Maybe<Scalars['timestamptz']>;
  consentObtainedBy?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fingerprint?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last4?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['uuid']>;
  patient?: Maybe<Scalars['uuid']>;
  squareCardId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ehr_patient_card" */
export type Ehr_Patient_Card_Max_Order_By = {
  brand?: InputMaybe<Order_By>;
  consentAt?: InputMaybe<Order_By>;
  consentObtainedBy?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  fingerprint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last4?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  squareCardId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ehr_Patient_Card_Min_Fields = {
  __typename?: 'ehr_patient_card_min_fields';
  brand?: Maybe<Scalars['String']>;
  consentAt?: Maybe<Scalars['timestamptz']>;
  consentObtainedBy?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fingerprint?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last4?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['uuid']>;
  patient?: Maybe<Scalars['uuid']>;
  squareCardId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ehr_patient_card" */
export type Ehr_Patient_Card_Min_Order_By = {
  brand?: InputMaybe<Order_By>;
  consentAt?: InputMaybe<Order_By>;
  consentObtainedBy?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  fingerprint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last4?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  squareCardId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ehr_patient_card" */
export type Ehr_Patient_Card_Mutation_Response = {
  __typename?: 'ehr_patient_card_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Patient_Card>;
};

/** on_conflict condition type for table "ehr_patient_card" */
export type Ehr_Patient_Card_On_Conflict = {
  constraint: Ehr_Patient_Card_Constraint;
  update_columns?: Array<Ehr_Patient_Card_Update_Column>;
  where?: InputMaybe<Ehr_Patient_Card_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_patient_card". */
export type Ehr_Patient_Card_Order_By = {
  brand?: InputMaybe<Order_By>;
  consentAt?: InputMaybe<Order_By>;
  consentObtainedBy?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  fingerprint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDefault?: InputMaybe<Order_By>;
  last4?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  patient?: InputMaybe<Order_By>;
  patientByPatient?: InputMaybe<Patient_Order_By>;
  squareCardId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_patient_card */
export type Ehr_Patient_Card_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ehr_patient_card" */
export enum Ehr_Patient_Card_Select_Column {
  /** column name */
  Brand = 'brand',
  /** column name */
  ConsentAt = 'consentAt',
  /** column name */
  ConsentObtainedBy = 'consentObtainedBy',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Fingerprint = 'fingerprint',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'isDefault',
  /** column name */
  Last4 = 'last4',
  /** column name */
  Location = 'location',
  /** column name */
  Patient = 'patient',
  /** column name */
  SquareCardId = 'squareCardId'
}

/** select "ehr_patient_card_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ehr_patient_card" */
export enum Ehr_Patient_Card_Select_Column_Ehr_Patient_Card_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDefault = 'isDefault'
}

/** select "ehr_patient_card_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ehr_patient_card" */
export enum Ehr_Patient_Card_Select_Column_Ehr_Patient_Card_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDefault = 'isDefault'
}

/** input type for updating data in table "ehr_patient_card" */
export type Ehr_Patient_Card_Set_Input = {
  brand?: InputMaybe<Scalars['String']>;
  consentAt?: InputMaybe<Scalars['timestamptz']>;
  consentObtainedBy?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fingerprint?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** True when this card is the patient's default card. At most one row per patient with deleted_at NULL is the default. */
  isDefault?: InputMaybe<Scalars['Boolean']>;
  last4?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  squareCardId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ehr_patient_card" */
export type Ehr_Patient_Card_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Patient_Card_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Patient_Card_Stream_Cursor_Value_Input = {
  brand?: InputMaybe<Scalars['String']>;
  consentAt?: InputMaybe<Scalars['timestamptz']>;
  consentObtainedBy?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fingerprint?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** True when this card is the patient's default card. At most one row per patient with deleted_at NULL is the default. */
  isDefault?: InputMaybe<Scalars['Boolean']>;
  last4?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  squareCardId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ehr_patient_card" */
export enum Ehr_Patient_Card_Update_Column {
  /** column name */
  Brand = 'brand',
  /** column name */
  ConsentAt = 'consentAt',
  /** column name */
  ConsentObtainedBy = 'consentObtainedBy',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Fingerprint = 'fingerprint',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'isDefault',
  /** column name */
  Last4 = 'last4',
  /** column name */
  Location = 'location',
  /** column name */
  Patient = 'patient',
  /** column name */
  SquareCardId = 'squareCardId'
}

export type Ehr_Patient_Card_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Patient_Card_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Patient_Card_Bool_Exp;
};

/** Append-only trail of patient consent events. The newest row per (patient, consent_type) is the current state: GRANTED means consent is in force as of occurred_at, REVOKED means withdrawn. Rows are never updated or deleted; renewals and withdrawals append new rows. The unique constraint doubles as the lookup index and a double-submit guard. */
export type Ehr_Patient_Consent = {
  __typename?: 'ehr_patient_consent';
  action: Ehr_Patient_Consent_Action_Enum;
  consentType: Ehr_Patient_Consent_Type_Enum;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  occurredAt: Scalars['timestamptz'];
  patient: Scalars['uuid'];
  /** An object relationship */
  patientByPatient: Patient;
  recordedBy: Scalars['uuid'];
  /** An object relationship */
  userByRecordedBy: User;
};

/** Enum of consent trail event actions. */
export type Ehr_Patient_Consent_Action = {
  __typename?: 'ehr_patient_consent_action';
  id: Scalars['String'];
};

/** aggregated selection of "ehr_patient_consent_action" */
export type Ehr_Patient_Consent_Action_Aggregate = {
  __typename?: 'ehr_patient_consent_action_aggregate';
  aggregate?: Maybe<Ehr_Patient_Consent_Action_Aggregate_Fields>;
  nodes: Array<Ehr_Patient_Consent_Action>;
};

/** aggregate fields of "ehr_patient_consent_action" */
export type Ehr_Patient_Consent_Action_Aggregate_Fields = {
  __typename?: 'ehr_patient_consent_action_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Patient_Consent_Action_Max_Fields>;
  min?: Maybe<Ehr_Patient_Consent_Action_Min_Fields>;
};


/** aggregate fields of "ehr_patient_consent_action" */
export type Ehr_Patient_Consent_Action_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Patient_Consent_Action_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ehr_patient_consent_action". All fields are combined with a logical 'AND'. */
export type Ehr_Patient_Consent_Action_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Patient_Consent_Action_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Patient_Consent_Action_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Patient_Consent_Action_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_patient_consent_action" */
export enum Ehr_Patient_Consent_Action_Constraint {
  /** unique or primary key constraint on columns "id" */
  EhrPatientConsentActionPkey = 'ehr_patient_consent_action_pkey'
}

export enum Ehr_Patient_Consent_Action_Enum {
  Granted = 'GRANTED',
  Revoked = 'REVOKED'
}

/** Boolean expression to compare columns of type "ehr_patient_consent_action_enum". All fields are combined with logical 'AND'. */
export type Ehr_Patient_Consent_Action_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ehr_Patient_Consent_Action_Enum>;
  _in?: InputMaybe<Array<Ehr_Patient_Consent_Action_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Ehr_Patient_Consent_Action_Enum>;
  _nin?: InputMaybe<Array<Ehr_Patient_Consent_Action_Enum>>;
};

/** input type for inserting data into table "ehr_patient_consent_action" */
export type Ehr_Patient_Consent_Action_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ehr_Patient_Consent_Action_Max_Fields = {
  __typename?: 'ehr_patient_consent_action_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ehr_Patient_Consent_Action_Min_Fields = {
  __typename?: 'ehr_patient_consent_action_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ehr_patient_consent_action" */
export type Ehr_Patient_Consent_Action_Mutation_Response = {
  __typename?: 'ehr_patient_consent_action_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Patient_Consent_Action>;
};

/** on_conflict condition type for table "ehr_patient_consent_action" */
export type Ehr_Patient_Consent_Action_On_Conflict = {
  constraint: Ehr_Patient_Consent_Action_Constraint;
  update_columns?: Array<Ehr_Patient_Consent_Action_Update_Column>;
  where?: InputMaybe<Ehr_Patient_Consent_Action_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_patient_consent_action". */
export type Ehr_Patient_Consent_Action_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_patient_consent_action */
export type Ehr_Patient_Consent_Action_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "ehr_patient_consent_action" */
export enum Ehr_Patient_Consent_Action_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "ehr_patient_consent_action" */
export type Ehr_Patient_Consent_Action_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ehr_patient_consent_action" */
export type Ehr_Patient_Consent_Action_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Patient_Consent_Action_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Patient_Consent_Action_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ehr_patient_consent_action" */
export enum Ehr_Patient_Consent_Action_Update_Column {
  /** column name */
  Id = 'id'
}

export type Ehr_Patient_Consent_Action_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Patient_Consent_Action_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Patient_Consent_Action_Bool_Exp;
};

/** aggregated selection of "ehr_patient_consent" */
export type Ehr_Patient_Consent_Aggregate = {
  __typename?: 'ehr_patient_consent_aggregate';
  aggregate?: Maybe<Ehr_Patient_Consent_Aggregate_Fields>;
  nodes: Array<Ehr_Patient_Consent>;
};

export type Ehr_Patient_Consent_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ehr_Patient_Consent_Aggregate_Bool_Exp_Count>;
};

export type Ehr_Patient_Consent_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ehr_Patient_Consent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Patient_Consent_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ehr_patient_consent" */
export type Ehr_Patient_Consent_Aggregate_Fields = {
  __typename?: 'ehr_patient_consent_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Patient_Consent_Max_Fields>;
  min?: Maybe<Ehr_Patient_Consent_Min_Fields>;
};


/** aggregate fields of "ehr_patient_consent" */
export type Ehr_Patient_Consent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Patient_Consent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ehr_patient_consent" */
export type Ehr_Patient_Consent_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Patient_Consent_Max_Order_By>;
  min?: InputMaybe<Ehr_Patient_Consent_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ehr_patient_consent" */
export type Ehr_Patient_Consent_Arr_Rel_Insert_Input = {
  data: Array<Ehr_Patient_Consent_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Patient_Consent_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ehr_patient_consent". All fields are combined with a logical 'AND'. */
export type Ehr_Patient_Consent_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Patient_Consent_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Patient_Consent_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Patient_Consent_Bool_Exp>>;
  action?: InputMaybe<Ehr_Patient_Consent_Action_Enum_Comparison_Exp>;
  consentType?: InputMaybe<Ehr_Patient_Consent_Type_Enum_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  occurredAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  patient?: InputMaybe<Uuid_Comparison_Exp>;
  patientByPatient?: InputMaybe<Patient_Bool_Exp>;
  recordedBy?: InputMaybe<Uuid_Comparison_Exp>;
  userByRecordedBy?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "ehr_patient_consent" */
export enum Ehr_Patient_Consent_Constraint {
  /** unique or primary key constraint on columns "consent_type", "patient", "occurred_at" */
  EhrPatientConsentPatientConsentTypeOccurredAtKey = 'ehr_patient_consent_patient_consent_type_occurred_at_key',
  /** unique or primary key constraint on columns "id" */
  EhrPatientConsentPkey = 'ehr_patient_consent_pkey'
}

/** input type for inserting data into table "ehr_patient_consent" */
export type Ehr_Patient_Consent_Insert_Input = {
  action?: InputMaybe<Ehr_Patient_Consent_Action_Enum>;
  consentType?: InputMaybe<Ehr_Patient_Consent_Type_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  patient?: InputMaybe<Scalars['uuid']>;
  patientByPatient?: InputMaybe<Patient_Obj_Rel_Insert_Input>;
  recordedBy?: InputMaybe<Scalars['uuid']>;
  userByRecordedBy?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Ehr_Patient_Consent_Max_Fields = {
  __typename?: 'ehr_patient_consent_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  patient?: Maybe<Scalars['uuid']>;
  recordedBy?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "ehr_patient_consent" */
export type Ehr_Patient_Consent_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  occurredAt?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  recordedBy?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ehr_Patient_Consent_Min_Fields = {
  __typename?: 'ehr_patient_consent_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  patient?: Maybe<Scalars['uuid']>;
  recordedBy?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "ehr_patient_consent" */
export type Ehr_Patient_Consent_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  occurredAt?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  recordedBy?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ehr_patient_consent" */
export type Ehr_Patient_Consent_Mutation_Response = {
  __typename?: 'ehr_patient_consent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Patient_Consent>;
};

/** on_conflict condition type for table "ehr_patient_consent" */
export type Ehr_Patient_Consent_On_Conflict = {
  constraint: Ehr_Patient_Consent_Constraint;
  update_columns?: Array<Ehr_Patient_Consent_Update_Column>;
  where?: InputMaybe<Ehr_Patient_Consent_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_patient_consent". */
export type Ehr_Patient_Consent_Order_By = {
  action?: InputMaybe<Order_By>;
  consentType?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  occurredAt?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  patientByPatient?: InputMaybe<Patient_Order_By>;
  recordedBy?: InputMaybe<Order_By>;
  userByRecordedBy?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: ehr_patient_consent */
export type Ehr_Patient_Consent_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ehr_patient_consent" */
export enum Ehr_Patient_Consent_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ConsentType = 'consentType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  OccurredAt = 'occurredAt',
  /** column name */
  Patient = 'patient',
  /** column name */
  RecordedBy = 'recordedBy'
}

/** input type for updating data in table "ehr_patient_consent" */
export type Ehr_Patient_Consent_Set_Input = {
  action?: InputMaybe<Ehr_Patient_Consent_Action_Enum>;
  consentType?: InputMaybe<Ehr_Patient_Consent_Type_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  patient?: InputMaybe<Scalars['uuid']>;
  recordedBy?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "ehr_patient_consent" */
export type Ehr_Patient_Consent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Patient_Consent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Patient_Consent_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Ehr_Patient_Consent_Action_Enum>;
  consentType?: InputMaybe<Ehr_Patient_Consent_Type_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  patient?: InputMaybe<Scalars['uuid']>;
  recordedBy?: InputMaybe<Scalars['uuid']>;
};

/** Enum of patient consent types tracked in ehr_patient_consent. */
export type Ehr_Patient_Consent_Type = {
  __typename?: 'ehr_patient_consent_type';
  id: Scalars['String'];
};

/** aggregated selection of "ehr_patient_consent_type" */
export type Ehr_Patient_Consent_Type_Aggregate = {
  __typename?: 'ehr_patient_consent_type_aggregate';
  aggregate?: Maybe<Ehr_Patient_Consent_Type_Aggregate_Fields>;
  nodes: Array<Ehr_Patient_Consent_Type>;
};

/** aggregate fields of "ehr_patient_consent_type" */
export type Ehr_Patient_Consent_Type_Aggregate_Fields = {
  __typename?: 'ehr_patient_consent_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Patient_Consent_Type_Max_Fields>;
  min?: Maybe<Ehr_Patient_Consent_Type_Min_Fields>;
};


/** aggregate fields of "ehr_patient_consent_type" */
export type Ehr_Patient_Consent_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Patient_Consent_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ehr_patient_consent_type". All fields are combined with a logical 'AND'. */
export type Ehr_Patient_Consent_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Patient_Consent_Type_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Patient_Consent_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Patient_Consent_Type_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_patient_consent_type" */
export enum Ehr_Patient_Consent_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  EhrPatientConsentTypePkey = 'ehr_patient_consent_type_pkey'
}

export enum Ehr_Patient_Consent_Type_Enum {
  RecordingPhoto = 'RECORDING_PHOTO',
  TextMessagesVerbal = 'TEXT_MESSAGES_VERBAL'
}

/** Boolean expression to compare columns of type "ehr_patient_consent_type_enum". All fields are combined with logical 'AND'. */
export type Ehr_Patient_Consent_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ehr_Patient_Consent_Type_Enum>;
  _in?: InputMaybe<Array<Ehr_Patient_Consent_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Ehr_Patient_Consent_Type_Enum>;
  _nin?: InputMaybe<Array<Ehr_Patient_Consent_Type_Enum>>;
};

/** input type for inserting data into table "ehr_patient_consent_type" */
export type Ehr_Patient_Consent_Type_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ehr_Patient_Consent_Type_Max_Fields = {
  __typename?: 'ehr_patient_consent_type_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ehr_Patient_Consent_Type_Min_Fields = {
  __typename?: 'ehr_patient_consent_type_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ehr_patient_consent_type" */
export type Ehr_Patient_Consent_Type_Mutation_Response = {
  __typename?: 'ehr_patient_consent_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Patient_Consent_Type>;
};

/** on_conflict condition type for table "ehr_patient_consent_type" */
export type Ehr_Patient_Consent_Type_On_Conflict = {
  constraint: Ehr_Patient_Consent_Type_Constraint;
  update_columns?: Array<Ehr_Patient_Consent_Type_Update_Column>;
  where?: InputMaybe<Ehr_Patient_Consent_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_patient_consent_type". */
export type Ehr_Patient_Consent_Type_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_patient_consent_type */
export type Ehr_Patient_Consent_Type_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "ehr_patient_consent_type" */
export enum Ehr_Patient_Consent_Type_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "ehr_patient_consent_type" */
export type Ehr_Patient_Consent_Type_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ehr_patient_consent_type" */
export type Ehr_Patient_Consent_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Patient_Consent_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Patient_Consent_Type_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ehr_patient_consent_type" */
export enum Ehr_Patient_Consent_Type_Update_Column {
  /** column name */
  Id = 'id'
}

export type Ehr_Patient_Consent_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Patient_Consent_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Patient_Consent_Type_Bool_Exp;
};

/** update columns of table "ehr_patient_consent" */
export enum Ehr_Patient_Consent_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ConsentType = 'consentType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  OccurredAt = 'occurredAt',
  /** column name */
  Patient = 'patient',
  /** column name */
  RecordedBy = 'recordedBy'
}

export type Ehr_Patient_Consent_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Patient_Consent_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Patient_Consent_Bool_Exp;
};

/** Procedures for the EHR - product associations, form associations */
export type Ehr_Procedure = {
  __typename?: 'ehr_procedure';
  body_parts?: Maybe<Array<Scalars['String']>>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  ehr_encounters: Array<Ehr_Encounter>;
  /** An aggregate relationship */
  ehr_encounters_aggregate: Ehr_Encounter_Aggregate;
  /** An array relationship */
  ehr_procedure_body_areas: Array<Ehr_Procedure_Body_Area>;
  /** An aggregate relationship */
  ehr_procedure_body_areas_aggregate: Ehr_Procedure_Body_Area_Aggregate;
  /** An array relationship */
  ehr_procedure_ehr_products: Array<Ehr_Procedure_Ehr_Product>;
  /** An aggregate relationship */
  ehr_procedure_ehr_products_aggregate: Ehr_Procedure_Ehr_Product_Aggregate;
  /** An object relationship */
  ehr_procedure_type_enum: Ehr_Procedure_Type_Enum;
  id: Scalars['uuid'];
  name: Ehr_Procedure_Type_Enum_Enum;
  /** An array relationship */
  providerInjectionDefaults: Array<Ehr_Procedure_Body_Part_Provider_Injection_Default>;
  /** An aggregate relationship */
  providerInjectionDefaults_aggregate: Ehr_Procedure_Body_Part_Provider_Injection_Default_Aggregate;
  /** An array relationship */
  signingProcedureAssociatedDocumentsBysigningProcedureAssociatedDocuments: Array<Signing_Procedure_Associated_Documents>;
  /** An aggregate relationship */
  signingProcedureAssociatedDocumentsBysigningProcedureAssociatedDocuments_aggregate: Signing_Procedure_Associated_Documents_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** Procedures for the EHR - product associations, form associations */
export type Ehr_ProcedureEhr_EncountersArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Bool_Exp>;
};


/** Procedures for the EHR - product associations, form associations */
export type Ehr_ProcedureEhr_Encounters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Bool_Exp>;
};


/** Procedures for the EHR - product associations, form associations */
export type Ehr_ProcedureEhr_Procedure_Body_AreasArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Body_Area_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Body_Area_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Body_Area_Bool_Exp>;
};


/** Procedures for the EHR - product associations, form associations */
export type Ehr_ProcedureEhr_Procedure_Body_Areas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Body_Area_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Body_Area_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Body_Area_Bool_Exp>;
};


/** Procedures for the EHR - product associations, form associations */
export type Ehr_ProcedureEhr_Procedure_Ehr_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Ehr_Product_Bool_Exp>;
};


/** Procedures for the EHR - product associations, form associations */
export type Ehr_ProcedureEhr_Procedure_Ehr_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Ehr_Product_Bool_Exp>;
};


/** Procedures for the EHR - product associations, form associations */
export type Ehr_ProcedureProviderInjectionDefaultsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Bool_Exp>;
};


/** Procedures for the EHR - product associations, form associations */
export type Ehr_ProcedureProviderInjectionDefaults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Bool_Exp>;
};


/** Procedures for the EHR - product associations, form associations */
export type Ehr_ProcedureSigningProcedureAssociatedDocumentsBysigningProcedureAssociatedDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Order_By>>;
  where?: InputMaybe<Signing_Procedure_Associated_Documents_Bool_Exp>;
};


/** Procedures for the EHR - product associations, form associations */
export type Ehr_ProcedureSigningProcedureAssociatedDocumentsBysigningProcedureAssociatedDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Order_By>>;
  where?: InputMaybe<Signing_Procedure_Associated_Documents_Bool_Exp>;
};

/** aggregated selection of "ehr_procedure" */
export type Ehr_Procedure_Aggregate = {
  __typename?: 'ehr_procedure_aggregate';
  aggregate?: Maybe<Ehr_Procedure_Aggregate_Fields>;
  nodes: Array<Ehr_Procedure>;
};

/** aggregate fields of "ehr_procedure" */
export type Ehr_Procedure_Aggregate_Fields = {
  __typename?: 'ehr_procedure_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Procedure_Max_Fields>;
  min?: Maybe<Ehr_Procedure_Min_Fields>;
};


/** aggregate fields of "ehr_procedure" */
export type Ehr_Procedure_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Procedure_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "ehr_procedure_body_area" */
export type Ehr_Procedure_Body_Area = {
  __typename?: 'ehr_procedure_body_area';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  ehrProcedure: Scalars['uuid'];
  /** An array relationship */
  ehr_procedure_body_parts: Array<Ehr_Procedure_Body_Part>;
  /** An aggregate relationship */
  ehr_procedure_body_parts_aggregate: Ehr_Procedure_Body_Part_Aggregate;
  /** An object relationship */
  ehr_procedure_by_ehr_procedure: Ehr_Procedure;
  id: Scalars['uuid'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "ehr_procedure_body_area" */
export type Ehr_Procedure_Body_AreaEhr_Procedure_Body_PartsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Body_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Body_Part_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Body_Part_Bool_Exp>;
};


/** columns and relationships of "ehr_procedure_body_area" */
export type Ehr_Procedure_Body_AreaEhr_Procedure_Body_Parts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Body_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Body_Part_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Body_Part_Bool_Exp>;
};

/** aggregated selection of "ehr_procedure_body_area" */
export type Ehr_Procedure_Body_Area_Aggregate = {
  __typename?: 'ehr_procedure_body_area_aggregate';
  aggregate?: Maybe<Ehr_Procedure_Body_Area_Aggregate_Fields>;
  nodes: Array<Ehr_Procedure_Body_Area>;
};

export type Ehr_Procedure_Body_Area_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ehr_Procedure_Body_Area_Aggregate_Bool_Exp_Count>;
};

export type Ehr_Procedure_Body_Area_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ehr_Procedure_Body_Area_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Procedure_Body_Area_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ehr_procedure_body_area" */
export type Ehr_Procedure_Body_Area_Aggregate_Fields = {
  __typename?: 'ehr_procedure_body_area_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Procedure_Body_Area_Max_Fields>;
  min?: Maybe<Ehr_Procedure_Body_Area_Min_Fields>;
};


/** aggregate fields of "ehr_procedure_body_area" */
export type Ehr_Procedure_Body_Area_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Procedure_Body_Area_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ehr_procedure_body_area" */
export type Ehr_Procedure_Body_Area_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Procedure_Body_Area_Max_Order_By>;
  min?: InputMaybe<Ehr_Procedure_Body_Area_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ehr_procedure_body_area" */
export type Ehr_Procedure_Body_Area_Arr_Rel_Insert_Input = {
  data: Array<Ehr_Procedure_Body_Area_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Procedure_Body_Area_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ehr_procedure_body_area". All fields are combined with a logical 'AND'. */
export type Ehr_Procedure_Body_Area_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Procedure_Body_Area_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Procedure_Body_Area_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Procedure_Body_Area_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrProcedure?: InputMaybe<Uuid_Comparison_Exp>;
  ehr_procedure_body_parts?: InputMaybe<Ehr_Procedure_Body_Part_Bool_Exp>;
  ehr_procedure_body_parts_aggregate?: InputMaybe<Ehr_Procedure_Body_Part_Aggregate_Bool_Exp>;
  ehr_procedure_by_ehr_procedure?: InputMaybe<Ehr_Procedure_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_procedure_body_area" */
export enum Ehr_Procedure_Body_Area_Constraint {
  /** unique or primary key constraint on columns "id" */
  EhrProcedureBodyAreaPkey = 'ehr_procedure_body_area_pkey',
  /** unique or primary key constraint on columns "ehr_procedure", "name" */
  EhrProcedureBodyAreaProcedureNameUniq = 'ehr_procedure_body_area_procedure_name_uniq'
}

/** input type for inserting data into table "ehr_procedure_body_area" */
export type Ehr_Procedure_Body_Area_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  ehrProcedure?: InputMaybe<Scalars['uuid']>;
  ehr_procedure_body_parts?: InputMaybe<Ehr_Procedure_Body_Part_Arr_Rel_Insert_Input>;
  ehr_procedure_by_ehr_procedure?: InputMaybe<Ehr_Procedure_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Ehr_Procedure_Body_Area_Max_Fields = {
  __typename?: 'ehr_procedure_body_area_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  ehrProcedure?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "ehr_procedure_body_area" */
export type Ehr_Procedure_Body_Area_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  ehrProcedure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ehr_Procedure_Body_Area_Min_Fields = {
  __typename?: 'ehr_procedure_body_area_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  ehrProcedure?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "ehr_procedure_body_area" */
export type Ehr_Procedure_Body_Area_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  ehrProcedure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ehr_procedure_body_area" */
export type Ehr_Procedure_Body_Area_Mutation_Response = {
  __typename?: 'ehr_procedure_body_area_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Procedure_Body_Area>;
};

/** input type for inserting object relation for remote table "ehr_procedure_body_area" */
export type Ehr_Procedure_Body_Area_Obj_Rel_Insert_Input = {
  data: Ehr_Procedure_Body_Area_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Procedure_Body_Area_On_Conflict>;
};

/** on_conflict condition type for table "ehr_procedure_body_area" */
export type Ehr_Procedure_Body_Area_On_Conflict = {
  constraint: Ehr_Procedure_Body_Area_Constraint;
  update_columns?: Array<Ehr_Procedure_Body_Area_Update_Column>;
  where?: InputMaybe<Ehr_Procedure_Body_Area_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_procedure_body_area". */
export type Ehr_Procedure_Body_Area_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  ehrProcedure?: InputMaybe<Order_By>;
  ehr_procedure_body_parts_aggregate?: InputMaybe<Ehr_Procedure_Body_Part_Aggregate_Order_By>;
  ehr_procedure_by_ehr_procedure?: InputMaybe<Ehr_Procedure_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_procedure_body_area */
export type Ehr_Procedure_Body_Area_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ehr_procedure_body_area" */
export enum Ehr_Procedure_Body_Area_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EhrProcedure = 'ehrProcedure',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "ehr_procedure_body_area" */
export type Ehr_Procedure_Body_Area_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  ehrProcedure?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "ehr_procedure_body_area" */
export type Ehr_Procedure_Body_Area_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Procedure_Body_Area_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Procedure_Body_Area_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  ehrProcedure?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "ehr_procedure_body_area" */
export enum Ehr_Procedure_Body_Area_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EhrProcedure = 'ehrProcedure',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Ehr_Procedure_Body_Area_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Procedure_Body_Area_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Procedure_Body_Area_Bool_Exp;
};

/** columns and relationships of "ehr_procedure_body_part" */
export type Ehr_Procedure_Body_Part = {
  __typename?: 'ehr_procedure_body_part';
  /** An object relationship */
  body_area_by_body_area: Ehr_Procedure_Body_Area;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  ehrProcedureBodyArea: Scalars['uuid'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "ehr_procedure_body_part" */
export type Ehr_Procedure_Body_Part_Aggregate = {
  __typename?: 'ehr_procedure_body_part_aggregate';
  aggregate?: Maybe<Ehr_Procedure_Body_Part_Aggregate_Fields>;
  nodes: Array<Ehr_Procedure_Body_Part>;
};

export type Ehr_Procedure_Body_Part_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ehr_Procedure_Body_Part_Aggregate_Bool_Exp_Count>;
};

export type Ehr_Procedure_Body_Part_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ehr_Procedure_Body_Part_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Procedure_Body_Part_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ehr_procedure_body_part" */
export type Ehr_Procedure_Body_Part_Aggregate_Fields = {
  __typename?: 'ehr_procedure_body_part_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Procedure_Body_Part_Max_Fields>;
  min?: Maybe<Ehr_Procedure_Body_Part_Min_Fields>;
};


/** aggregate fields of "ehr_procedure_body_part" */
export type Ehr_Procedure_Body_Part_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Procedure_Body_Part_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ehr_procedure_body_part" */
export type Ehr_Procedure_Body_Part_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Procedure_Body_Part_Max_Order_By>;
  min?: InputMaybe<Ehr_Procedure_Body_Part_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ehr_procedure_body_part" */
export type Ehr_Procedure_Body_Part_Arr_Rel_Insert_Input = {
  data: Array<Ehr_Procedure_Body_Part_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Procedure_Body_Part_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ehr_procedure_body_part". All fields are combined with a logical 'AND'. */
export type Ehr_Procedure_Body_Part_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Procedure_Body_Part_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Procedure_Body_Part_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Procedure_Body_Part_Bool_Exp>>;
  body_area_by_body_area?: InputMaybe<Ehr_Procedure_Body_Area_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrProcedureBodyArea?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_procedure_body_part" */
export enum Ehr_Procedure_Body_Part_Constraint {
  /** unique or primary key constraint on columns "name", "ehr_procedure_body_area" */
  EhrProcedureBodyPartAreaNameUniq = 'ehr_procedure_body_part_area_name_uniq',
  /** unique or primary key constraint on columns "id" */
  EhrProcedureBodyPartPkey = 'ehr_procedure_body_part_pkey'
}

/** input type for inserting data into table "ehr_procedure_body_part" */
export type Ehr_Procedure_Body_Part_Insert_Input = {
  body_area_by_body_area?: InputMaybe<Ehr_Procedure_Body_Area_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  ehrProcedureBodyArea?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Ehr_Procedure_Body_Part_Max_Fields = {
  __typename?: 'ehr_procedure_body_part_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  ehrProcedureBodyArea?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "ehr_procedure_body_part" */
export type Ehr_Procedure_Body_Part_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  ehrProcedureBodyArea?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ehr_Procedure_Body_Part_Min_Fields = {
  __typename?: 'ehr_procedure_body_part_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  ehrProcedureBodyArea?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "ehr_procedure_body_part" */
export type Ehr_Procedure_Body_Part_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  ehrProcedureBodyArea?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ehr_procedure_body_part" */
export type Ehr_Procedure_Body_Part_Mutation_Response = {
  __typename?: 'ehr_procedure_body_part_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Procedure_Body_Part>;
};

/** on_conflict condition type for table "ehr_procedure_body_part" */
export type Ehr_Procedure_Body_Part_On_Conflict = {
  constraint: Ehr_Procedure_Body_Part_Constraint;
  update_columns?: Array<Ehr_Procedure_Body_Part_Update_Column>;
  where?: InputMaybe<Ehr_Procedure_Body_Part_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_procedure_body_part". */
export type Ehr_Procedure_Body_Part_Order_By = {
  body_area_by_body_area?: InputMaybe<Ehr_Procedure_Body_Area_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  ehrProcedureBodyArea?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_procedure_body_part */
export type Ehr_Procedure_Body_Part_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** Provider-specific default injection settings per (procedure, body_part). Auto-fills ehr_product and dose during injection marking. */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default = {
  __typename?: 'ehr_procedure_body_part_provider_injection_default';
  bodyPart: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  dose: Scalars['numeric'];
  ehrProcedure: Scalars['uuid'];
  /** An object relationship */
  ehrProcedureByEhrProcedure?: Maybe<Ehr_Procedure>;
  ehrProduct: Scalars['uuid'];
  /** An object relationship */
  ehrProductByEhrProduct?: Maybe<Ehr_Product>;
  id: Scalars['uuid'];
  provider: Scalars['uuid'];
  /** An object relationship */
  providerByProvider: User;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Aggregate = {
  __typename?: 'ehr_procedure_body_part_provider_injection_default_aggregate';
  aggregate?: Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Aggregate_Fields>;
  nodes: Array<Ehr_Procedure_Body_Part_Provider_Injection_Default>;
};

export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Aggregate_Bool_Exp_Count>;
};

export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Aggregate_Fields = {
  __typename?: 'ehr_procedure_body_part_provider_injection_default_aggregate_fields';
  avg?: Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Max_Fields>;
  min?: Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Min_Fields>;
  stddev?: Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Stddev_Fields>;
  stddev_pop?: Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Stddev_Samp_Fields>;
  sum?: Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Sum_Fields>;
  var_pop?: Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Var_Pop_Fields>;
  var_samp?: Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Var_Samp_Fields>;
  variance?: Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Variance_Fields>;
};


/** aggregate fields of "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Aggregate_Order_By = {
  avg?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Max_Order_By>;
  min?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Min_Order_By>;
  stddev?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Sum_Order_By>;
  var_pop?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Var_Samp_Order_By>;
  variance?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Arr_Rel_Insert_Input = {
  data: Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_On_Conflict>;
};

/** aggregate avg on columns */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Avg_Fields = {
  __typename?: 'ehr_procedure_body_part_provider_injection_default_avg_fields';
  dose?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Avg_Order_By = {
  dose?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ehr_procedure_body_part_provider_injection_default". All fields are combined with a logical 'AND'. */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Bool_Exp>>;
  bodyPart?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  dose?: InputMaybe<Numeric_Comparison_Exp>;
  ehrProcedure?: InputMaybe<Uuid_Comparison_Exp>;
  ehrProcedureByEhrProcedure?: InputMaybe<Ehr_Procedure_Bool_Exp>;
  ehrProduct?: InputMaybe<Uuid_Comparison_Exp>;
  ehrProductByEhrProduct?: InputMaybe<Ehr_Product_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  providerByProvider?: InputMaybe<User_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_procedure_body_part_provider_injection_default" */
export enum Ehr_Procedure_Body_Part_Provider_Injection_Default_Constraint {
  /** unique or primary key constraint on columns "id" */
  EhrProcedureBodyPartProviderInjectionDefaultPkey = 'ehr_procedure_body_part_provider_injection_default_pkey',
  /** unique or primary key constraint on columns "provider", "body_part", "ehr_procedure" */
  EhrProcedureBodyPartProviderInjectionDefaultUnique = 'ehr_procedure_body_part_provider_injection_default_unique'
}

/** input type for incrementing numeric columns in table "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Inc_Input = {
  dose?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Insert_Input = {
  bodyPart?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dose?: InputMaybe<Scalars['numeric']>;
  ehrProcedure?: InputMaybe<Scalars['uuid']>;
  ehrProcedureByEhrProcedure?: InputMaybe<Ehr_Procedure_Obj_Rel_Insert_Input>;
  ehrProduct?: InputMaybe<Scalars['uuid']>;
  ehrProductByEhrProduct?: InputMaybe<Ehr_Product_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  providerByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Max_Fields = {
  __typename?: 'ehr_procedure_body_part_provider_injection_default_max_fields';
  bodyPart?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dose?: Maybe<Scalars['numeric']>;
  ehrProcedure?: Maybe<Scalars['uuid']>;
  ehrProduct?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Max_Order_By = {
  bodyPart?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dose?: InputMaybe<Order_By>;
  ehrProcedure?: InputMaybe<Order_By>;
  ehrProduct?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Min_Fields = {
  __typename?: 'ehr_procedure_body_part_provider_injection_default_min_fields';
  bodyPart?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dose?: Maybe<Scalars['numeric']>;
  ehrProcedure?: Maybe<Scalars['uuid']>;
  ehrProduct?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Min_Order_By = {
  bodyPart?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dose?: InputMaybe<Order_By>;
  ehrProcedure?: InputMaybe<Order_By>;
  ehrProduct?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Mutation_Response = {
  __typename?: 'ehr_procedure_body_part_provider_injection_default_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Procedure_Body_Part_Provider_Injection_Default>;
};

/** on_conflict condition type for table "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_On_Conflict = {
  constraint: Ehr_Procedure_Body_Part_Provider_Injection_Default_Constraint;
  update_columns?: Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Update_Column>;
  where?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_procedure_body_part_provider_injection_default". */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Order_By = {
  bodyPart?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dose?: InputMaybe<Order_By>;
  ehrProcedure?: InputMaybe<Order_By>;
  ehrProcedureByEhrProcedure?: InputMaybe<Ehr_Procedure_Order_By>;
  ehrProduct?: InputMaybe<Order_By>;
  ehrProductByEhrProduct?: InputMaybe<Ehr_Product_Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  providerByProvider?: InputMaybe<User_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_procedure_body_part_provider_injection_default */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ehr_procedure_body_part_provider_injection_default" */
export enum Ehr_Procedure_Body_Part_Provider_Injection_Default_Select_Column {
  /** column name */
  BodyPart = 'bodyPart',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Dose = 'dose',
  /** column name */
  EhrProcedure = 'ehrProcedure',
  /** column name */
  EhrProduct = 'ehrProduct',
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Set_Input = {
  bodyPart?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dose?: InputMaybe<Scalars['numeric']>;
  ehrProcedure?: InputMaybe<Scalars['uuid']>;
  ehrProduct?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Stddev_Fields = {
  __typename?: 'ehr_procedure_body_part_provider_injection_default_stddev_fields';
  dose?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Stddev_Order_By = {
  dose?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Stddev_Pop_Fields = {
  __typename?: 'ehr_procedure_body_part_provider_injection_default_stddev_pop_fields';
  dose?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Stddev_Pop_Order_By = {
  dose?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Stddev_Samp_Fields = {
  __typename?: 'ehr_procedure_body_part_provider_injection_default_stddev_samp_fields';
  dose?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Stddev_Samp_Order_By = {
  dose?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Procedure_Body_Part_Provider_Injection_Default_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Stream_Cursor_Value_Input = {
  bodyPart?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dose?: InputMaybe<Scalars['numeric']>;
  ehrProcedure?: InputMaybe<Scalars['uuid']>;
  ehrProduct?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Sum_Fields = {
  __typename?: 'ehr_procedure_body_part_provider_injection_default_sum_fields';
  dose?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Sum_Order_By = {
  dose?: InputMaybe<Order_By>;
};

/** update columns of table "ehr_procedure_body_part_provider_injection_default" */
export enum Ehr_Procedure_Body_Part_Provider_Injection_Default_Update_Column {
  /** column name */
  BodyPart = 'bodyPart',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Dose = 'dose',
  /** column name */
  EhrProcedure = 'ehrProcedure',
  /** column name */
  EhrProduct = 'ehrProduct',
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Procedure_Body_Part_Provider_Injection_Default_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Var_Pop_Fields = {
  __typename?: 'ehr_procedure_body_part_provider_injection_default_var_pop_fields';
  dose?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Var_Pop_Order_By = {
  dose?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Var_Samp_Fields = {
  __typename?: 'ehr_procedure_body_part_provider_injection_default_var_samp_fields';
  dose?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Var_Samp_Order_By = {
  dose?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Variance_Fields = {
  __typename?: 'ehr_procedure_body_part_provider_injection_default_variance_fields';
  dose?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ehr_procedure_body_part_provider_injection_default" */
export type Ehr_Procedure_Body_Part_Provider_Injection_Default_Variance_Order_By = {
  dose?: InputMaybe<Order_By>;
};

/** select columns of table "ehr_procedure_body_part" */
export enum Ehr_Procedure_Body_Part_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EhrProcedureBodyArea = 'ehrProcedureBodyArea',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "ehr_procedure_body_part" */
export type Ehr_Procedure_Body_Part_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  ehrProcedureBodyArea?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "ehr_procedure_body_part" */
export type Ehr_Procedure_Body_Part_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Procedure_Body_Part_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Procedure_Body_Part_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  ehrProcedureBodyArea?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "ehr_procedure_body_part" */
export enum Ehr_Procedure_Body_Part_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EhrProcedureBodyArea = 'ehrProcedureBodyArea',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Ehr_Procedure_Body_Part_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Procedure_Body_Part_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Procedure_Body_Part_Bool_Exp;
};

/** Boolean expression to filter rows from the table "ehr_procedure". All fields are combined with a logical 'AND'. */
export type Ehr_Procedure_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Procedure_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Procedure_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Procedure_Bool_Exp>>;
  body_parts?: InputMaybe<String_Array_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehr_encounters?: InputMaybe<Ehr_Encounter_Bool_Exp>;
  ehr_encounters_aggregate?: InputMaybe<Ehr_Encounter_Aggregate_Bool_Exp>;
  ehr_procedure_body_areas?: InputMaybe<Ehr_Procedure_Body_Area_Bool_Exp>;
  ehr_procedure_body_areas_aggregate?: InputMaybe<Ehr_Procedure_Body_Area_Aggregate_Bool_Exp>;
  ehr_procedure_ehr_products?: InputMaybe<Ehr_Procedure_Ehr_Product_Bool_Exp>;
  ehr_procedure_ehr_products_aggregate?: InputMaybe<Ehr_Procedure_Ehr_Product_Aggregate_Bool_Exp>;
  ehr_procedure_type_enum?: InputMaybe<Ehr_Procedure_Type_Enum_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<Ehr_Procedure_Type_Enum_Enum_Comparison_Exp>;
  providerInjectionDefaults?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Bool_Exp>;
  providerInjectionDefaults_aggregate?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Aggregate_Bool_Exp>;
  signingProcedureAssociatedDocumentsBysigningProcedureAssociatedDocuments?: InputMaybe<Signing_Procedure_Associated_Documents_Bool_Exp>;
  signingProcedureAssociatedDocumentsBysigningProcedureAssociatedDocuments_aggregate?: InputMaybe<Signing_Procedure_Associated_Documents_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_procedure" */
export enum Ehr_Procedure_Constraint {
  /** unique or primary key constraint on columns "id" */
  EhrProcedurePkey = 'ehr_procedure_pkey',
  /** unique or primary key constraint on columns "name" */
  IdxEhrProcedureNameActiveUnique = 'idx_ehr_procedure_name_active_unique'
}

/** columns and relationships of "ehr_procedure_ehr_product" */
export type Ehr_Procedure_Ehr_Product = {
  __typename?: 'ehr_procedure_ehr_product';
  ehrProcedure: Scalars['uuid'];
  /** An object relationship */
  ehrProcedureByEhrProcedure: Ehr_Procedure;
  ehrProduct: Scalars['uuid'];
  /** An object relationship */
  ehrProductByEhrProduct: Ehr_Product;
};

/** aggregated selection of "ehr_procedure_ehr_product" */
export type Ehr_Procedure_Ehr_Product_Aggregate = {
  __typename?: 'ehr_procedure_ehr_product_aggregate';
  aggregate?: Maybe<Ehr_Procedure_Ehr_Product_Aggregate_Fields>;
  nodes: Array<Ehr_Procedure_Ehr_Product>;
};

export type Ehr_Procedure_Ehr_Product_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ehr_Procedure_Ehr_Product_Aggregate_Bool_Exp_Count>;
};

export type Ehr_Procedure_Ehr_Product_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Procedure_Ehr_Product_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ehr_procedure_ehr_product" */
export type Ehr_Procedure_Ehr_Product_Aggregate_Fields = {
  __typename?: 'ehr_procedure_ehr_product_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Procedure_Ehr_Product_Max_Fields>;
  min?: Maybe<Ehr_Procedure_Ehr_Product_Min_Fields>;
};


/** aggregate fields of "ehr_procedure_ehr_product" */
export type Ehr_Procedure_Ehr_Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ehr_procedure_ehr_product" */
export type Ehr_Procedure_Ehr_Product_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Procedure_Ehr_Product_Max_Order_By>;
  min?: InputMaybe<Ehr_Procedure_Ehr_Product_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ehr_procedure_ehr_product" */
export type Ehr_Procedure_Ehr_Product_Arr_Rel_Insert_Input = {
  data: Array<Ehr_Procedure_Ehr_Product_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Procedure_Ehr_Product_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ehr_procedure_ehr_product". All fields are combined with a logical 'AND'. */
export type Ehr_Procedure_Ehr_Product_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Procedure_Ehr_Product_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Bool_Exp>>;
  ehrProcedure?: InputMaybe<Uuid_Comparison_Exp>;
  ehrProcedureByEhrProcedure?: InputMaybe<Ehr_Procedure_Bool_Exp>;
  ehrProduct?: InputMaybe<Uuid_Comparison_Exp>;
  ehrProductByEhrProduct?: InputMaybe<Ehr_Product_Bool_Exp>;
};

/** unique or primary key constraints on table "ehr_procedure_ehr_product" */
export enum Ehr_Procedure_Ehr_Product_Constraint {
  /** unique or primary key constraint on columns "ehr_product", "ehr_procedure" */
  EhrProcedureEhrProductPkey = 'ehr_procedure_ehr_product_pkey'
}

/** input type for inserting data into table "ehr_procedure_ehr_product" */
export type Ehr_Procedure_Ehr_Product_Insert_Input = {
  ehrProcedure?: InputMaybe<Scalars['uuid']>;
  ehrProcedureByEhrProcedure?: InputMaybe<Ehr_Procedure_Obj_Rel_Insert_Input>;
  ehrProduct?: InputMaybe<Scalars['uuid']>;
  ehrProductByEhrProduct?: InputMaybe<Ehr_Product_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Ehr_Procedure_Ehr_Product_Max_Fields = {
  __typename?: 'ehr_procedure_ehr_product_max_fields';
  ehrProcedure?: Maybe<Scalars['uuid']>;
  ehrProduct?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "ehr_procedure_ehr_product" */
export type Ehr_Procedure_Ehr_Product_Max_Order_By = {
  ehrProcedure?: InputMaybe<Order_By>;
  ehrProduct?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ehr_Procedure_Ehr_Product_Min_Fields = {
  __typename?: 'ehr_procedure_ehr_product_min_fields';
  ehrProcedure?: Maybe<Scalars['uuid']>;
  ehrProduct?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "ehr_procedure_ehr_product" */
export type Ehr_Procedure_Ehr_Product_Min_Order_By = {
  ehrProcedure?: InputMaybe<Order_By>;
  ehrProduct?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ehr_procedure_ehr_product" */
export type Ehr_Procedure_Ehr_Product_Mutation_Response = {
  __typename?: 'ehr_procedure_ehr_product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Procedure_Ehr_Product>;
};

/** on_conflict condition type for table "ehr_procedure_ehr_product" */
export type Ehr_Procedure_Ehr_Product_On_Conflict = {
  constraint: Ehr_Procedure_Ehr_Product_Constraint;
  update_columns?: Array<Ehr_Procedure_Ehr_Product_Update_Column>;
  where?: InputMaybe<Ehr_Procedure_Ehr_Product_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_procedure_ehr_product". */
export type Ehr_Procedure_Ehr_Product_Order_By = {
  ehrProcedure?: InputMaybe<Order_By>;
  ehrProcedureByEhrProcedure?: InputMaybe<Ehr_Procedure_Order_By>;
  ehrProduct?: InputMaybe<Order_By>;
  ehrProductByEhrProduct?: InputMaybe<Ehr_Product_Order_By>;
};

/** primary key columns input for table: ehr_procedure_ehr_product */
export type Ehr_Procedure_Ehr_Product_Pk_Columns_Input = {
  ehrProcedure: Scalars['uuid'];
  ehrProduct: Scalars['uuid'];
};

/** select columns of table "ehr_procedure_ehr_product" */
export enum Ehr_Procedure_Ehr_Product_Select_Column {
  /** column name */
  EhrProcedure = 'ehrProcedure',
  /** column name */
  EhrProduct = 'ehrProduct'
}

/** input type for updating data in table "ehr_procedure_ehr_product" */
export type Ehr_Procedure_Ehr_Product_Set_Input = {
  ehrProcedure?: InputMaybe<Scalars['uuid']>;
  ehrProduct?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "ehr_procedure_ehr_product" */
export type Ehr_Procedure_Ehr_Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Procedure_Ehr_Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Procedure_Ehr_Product_Stream_Cursor_Value_Input = {
  ehrProcedure?: InputMaybe<Scalars['uuid']>;
  ehrProduct?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "ehr_procedure_ehr_product" */
export enum Ehr_Procedure_Ehr_Product_Update_Column {
  /** column name */
  EhrProcedure = 'ehrProcedure',
  /** column name */
  EhrProduct = 'ehrProduct'
}

export type Ehr_Procedure_Ehr_Product_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Procedure_Ehr_Product_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Procedure_Ehr_Product_Bool_Exp;
};

/** input type for inserting data into table "ehr_procedure" */
export type Ehr_Procedure_Insert_Input = {
  body_parts?: InputMaybe<Array<Scalars['String']>>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  ehr_encounters?: InputMaybe<Ehr_Encounter_Arr_Rel_Insert_Input>;
  ehr_procedure_body_areas?: InputMaybe<Ehr_Procedure_Body_Area_Arr_Rel_Insert_Input>;
  ehr_procedure_ehr_products?: InputMaybe<Ehr_Procedure_Ehr_Product_Arr_Rel_Insert_Input>;
  ehr_procedure_type_enum?: InputMaybe<Ehr_Procedure_Type_Enum_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Ehr_Procedure_Type_Enum_Enum>;
  providerInjectionDefaults?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Arr_Rel_Insert_Input>;
  signingProcedureAssociatedDocumentsBysigningProcedureAssociatedDocuments?: InputMaybe<Signing_Procedure_Associated_Documents_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Ehr_Procedure_Max_Fields = {
  __typename?: 'ehr_procedure_max_fields';
  body_parts?: Maybe<Array<Scalars['String']>>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Ehr_Procedure_Min_Fields = {
  __typename?: 'ehr_procedure_min_fields';
  body_parts?: Maybe<Array<Scalars['String']>>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "ehr_procedure" */
export type Ehr_Procedure_Mutation_Response = {
  __typename?: 'ehr_procedure_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Procedure>;
};

/** input type for inserting object relation for remote table "ehr_procedure" */
export type Ehr_Procedure_Obj_Rel_Insert_Input = {
  data: Ehr_Procedure_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Procedure_On_Conflict>;
};

/** on_conflict condition type for table "ehr_procedure" */
export type Ehr_Procedure_On_Conflict = {
  constraint: Ehr_Procedure_Constraint;
  update_columns?: Array<Ehr_Procedure_Update_Column>;
  where?: InputMaybe<Ehr_Procedure_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_procedure". */
export type Ehr_Procedure_Order_By = {
  body_parts?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ehr_encounters_aggregate?: InputMaybe<Ehr_Encounter_Aggregate_Order_By>;
  ehr_procedure_body_areas_aggregate?: InputMaybe<Ehr_Procedure_Body_Area_Aggregate_Order_By>;
  ehr_procedure_ehr_products_aggregate?: InputMaybe<Ehr_Procedure_Ehr_Product_Aggregate_Order_By>;
  ehr_procedure_type_enum?: InputMaybe<Ehr_Procedure_Type_Enum_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  providerInjectionDefaults_aggregate?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Aggregate_Order_By>;
  signingProcedureAssociatedDocumentsBysigningProcedureAssociatedDocuments_aggregate?: InputMaybe<Signing_Procedure_Associated_Documents_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_procedure */
export type Ehr_Procedure_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ehr_procedure" */
export enum Ehr_Procedure_Select_Column {
  /** column name */
  BodyParts = 'body_parts',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ehr_procedure" */
export type Ehr_Procedure_Set_Input = {
  body_parts?: InputMaybe<Array<Scalars['String']>>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Ehr_Procedure_Type_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "ehr_procedure" */
export type Ehr_Procedure_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Procedure_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Procedure_Stream_Cursor_Value_Input = {
  body_parts?: InputMaybe<Array<Scalars['String']>>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Ehr_Procedure_Type_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "ehr_procedure_type_enum" */
export type Ehr_Procedure_Type_Enum = {
  __typename?: 'ehr_procedure_type_enum';
  name: Scalars['String'];
};

/** aggregated selection of "ehr_procedure_type_enum" */
export type Ehr_Procedure_Type_Enum_Aggregate = {
  __typename?: 'ehr_procedure_type_enum_aggregate';
  aggregate?: Maybe<Ehr_Procedure_Type_Enum_Aggregate_Fields>;
  nodes: Array<Ehr_Procedure_Type_Enum>;
};

/** aggregate fields of "ehr_procedure_type_enum" */
export type Ehr_Procedure_Type_Enum_Aggregate_Fields = {
  __typename?: 'ehr_procedure_type_enum_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Procedure_Type_Enum_Max_Fields>;
  min?: Maybe<Ehr_Procedure_Type_Enum_Min_Fields>;
};


/** aggregate fields of "ehr_procedure_type_enum" */
export type Ehr_Procedure_Type_Enum_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Procedure_Type_Enum_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ehr_procedure_type_enum". All fields are combined with a logical 'AND'. */
export type Ehr_Procedure_Type_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Procedure_Type_Enum_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Procedure_Type_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Procedure_Type_Enum_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_procedure_type_enum" */
export enum Ehr_Procedure_Type_Enum_Constraint {
  /** unique or primary key constraint on columns "name" */
  EhrProcedureTypeEnumPkey = 'ehr_procedure_type_enum_pkey'
}

export enum Ehr_Procedure_Type_Enum_Enum {
  Filler = 'Filler',
  Neurotoxin = 'Neurotoxin'
}

/** Boolean expression to compare columns of type "ehr_procedure_type_enum_enum". All fields are combined with logical 'AND'. */
export type Ehr_Procedure_Type_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ehr_Procedure_Type_Enum_Enum>;
  _in?: InputMaybe<Array<Ehr_Procedure_Type_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Ehr_Procedure_Type_Enum_Enum>;
  _nin?: InputMaybe<Array<Ehr_Procedure_Type_Enum_Enum>>;
};

/** input type for inserting data into table "ehr_procedure_type_enum" */
export type Ehr_Procedure_Type_Enum_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ehr_Procedure_Type_Enum_Max_Fields = {
  __typename?: 'ehr_procedure_type_enum_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ehr_Procedure_Type_Enum_Min_Fields = {
  __typename?: 'ehr_procedure_type_enum_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ehr_procedure_type_enum" */
export type Ehr_Procedure_Type_Enum_Mutation_Response = {
  __typename?: 'ehr_procedure_type_enum_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Procedure_Type_Enum>;
};

/** input type for inserting object relation for remote table "ehr_procedure_type_enum" */
export type Ehr_Procedure_Type_Enum_Obj_Rel_Insert_Input = {
  data: Ehr_Procedure_Type_Enum_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Procedure_Type_Enum_On_Conflict>;
};

/** on_conflict condition type for table "ehr_procedure_type_enum" */
export type Ehr_Procedure_Type_Enum_On_Conflict = {
  constraint: Ehr_Procedure_Type_Enum_Constraint;
  update_columns?: Array<Ehr_Procedure_Type_Enum_Update_Column>;
  where?: InputMaybe<Ehr_Procedure_Type_Enum_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_procedure_type_enum". */
export type Ehr_Procedure_Type_Enum_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_procedure_type_enum */
export type Ehr_Procedure_Type_Enum_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "ehr_procedure_type_enum" */
export enum Ehr_Procedure_Type_Enum_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "ehr_procedure_type_enum" */
export type Ehr_Procedure_Type_Enum_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ehr_procedure_type_enum" */
export type Ehr_Procedure_Type_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Procedure_Type_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Procedure_Type_Enum_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ehr_procedure_type_enum" */
export enum Ehr_Procedure_Type_Enum_Update_Column {
  /** column name */
  Name = 'name'
}

export type Ehr_Procedure_Type_Enum_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Procedure_Type_Enum_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Procedure_Type_Enum_Bool_Exp;
};

/** update columns of table "ehr_procedure" */
export enum Ehr_Procedure_Update_Column {
  /** column name */
  BodyParts = 'body_parts',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ehr_Procedure_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Procedure_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Procedure_Bool_Exp;
};

/** columns and relationships of "ehr_product" */
export type Ehr_Product = {
  __typename?: 'ehr_product';
  deletedAt?: Maybe<Scalars['timestamptz']>;
  dosages: Array<Scalars['numeric']>;
  /** An array relationship */
  ehr_procedure_ehr_products: Array<Ehr_Procedure_Ehr_Product>;
  /** An aggregate relationship */
  ehr_procedure_ehr_products_aggregate: Ehr_Procedure_Ehr_Product_Aggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
  photoS3Key?: Maybe<Scalars['uuid']>;
  /** Applies to all doses for the product */
  unitsText: Scalars['String'];
};


/** columns and relationships of "ehr_product" */
export type Ehr_ProductEhr_Procedure_Ehr_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Ehr_Product_Bool_Exp>;
};


/** columns and relationships of "ehr_product" */
export type Ehr_ProductEhr_Procedure_Ehr_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Ehr_Product_Bool_Exp>;
};

/** aggregated selection of "ehr_product" */
export type Ehr_Product_Aggregate = {
  __typename?: 'ehr_product_aggregate';
  aggregate?: Maybe<Ehr_Product_Aggregate_Fields>;
  nodes: Array<Ehr_Product>;
};

/** aggregate fields of "ehr_product" */
export type Ehr_Product_Aggregate_Fields = {
  __typename?: 'ehr_product_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Product_Max_Fields>;
  min?: Maybe<Ehr_Product_Min_Fields>;
};


/** aggregate fields of "ehr_product" */
export type Ehr_Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ehr_product". All fields are combined with a logical 'AND'. */
export type Ehr_Product_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Product_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Product_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Product_Bool_Exp>>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  dosages?: InputMaybe<Numeric_Array_Comparison_Exp>;
  ehr_procedure_ehr_products?: InputMaybe<Ehr_Procedure_Ehr_Product_Bool_Exp>;
  ehr_procedure_ehr_products_aggregate?: InputMaybe<Ehr_Procedure_Ehr_Product_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photoS3Key?: InputMaybe<Uuid_Comparison_Exp>;
  unitsText?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_product" */
export enum Ehr_Product_Constraint {
  /** unique or primary key constraint on columns "name" */
  EhrProductName = 'ehr_product_name',
  /** unique or primary key constraint on columns "id" */
  EhrProductPkey = 'ehr_product_pkey'
}

/** input type for inserting data into table "ehr_product" */
export type Ehr_Product_Insert_Input = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  dosages?: InputMaybe<Array<Scalars['numeric']>>;
  ehr_procedure_ehr_products?: InputMaybe<Ehr_Procedure_Ehr_Product_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  /** Applies to all doses for the product */
  unitsText?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ehr_Product_Max_Fields = {
  __typename?: 'ehr_product_max_fields';
  deletedAt?: Maybe<Scalars['timestamptz']>;
  dosages?: Maybe<Array<Scalars['numeric']>>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
  /** Applies to all doses for the product */
  unitsText?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ehr_Product_Min_Fields = {
  __typename?: 'ehr_product_min_fields';
  deletedAt?: Maybe<Scalars['timestamptz']>;
  dosages?: Maybe<Array<Scalars['numeric']>>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
  /** Applies to all doses for the product */
  unitsText?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ehr_product" */
export type Ehr_Product_Mutation_Response = {
  __typename?: 'ehr_product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Product>;
};

/** input type for inserting object relation for remote table "ehr_product" */
export type Ehr_Product_Obj_Rel_Insert_Input = {
  data: Ehr_Product_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Product_On_Conflict>;
};

/** on_conflict condition type for table "ehr_product" */
export type Ehr_Product_On_Conflict = {
  constraint: Ehr_Product_Constraint;
  update_columns?: Array<Ehr_Product_Update_Column>;
  where?: InputMaybe<Ehr_Product_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_product". */
export type Ehr_Product_Order_By = {
  deletedAt?: InputMaybe<Order_By>;
  dosages?: InputMaybe<Order_By>;
  ehr_procedure_ehr_products_aggregate?: InputMaybe<Ehr_Procedure_Ehr_Product_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photoS3Key?: InputMaybe<Order_By>;
  unitsText?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_product */
export type Ehr_Product_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "ehr_product_procedure" */
export type Ehr_Product_Procedure = {
  __typename?: 'ehr_product_procedure';
  ehr_product: Scalars['uuid'];
  /** An object relationship */
  ehr_product_by_ehr_product: Ehr_Product;
  procedure: Scalars['uuid'];
  /** An object relationship */
  procedureByProcedure: Procedure;
};

/** aggregated selection of "ehr_product_procedure" */
export type Ehr_Product_Procedure_Aggregate = {
  __typename?: 'ehr_product_procedure_aggregate';
  aggregate?: Maybe<Ehr_Product_Procedure_Aggregate_Fields>;
  nodes: Array<Ehr_Product_Procedure>;
};

export type Ehr_Product_Procedure_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ehr_Product_Procedure_Aggregate_Bool_Exp_Count>;
};

export type Ehr_Product_Procedure_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ehr_Product_Procedure_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Product_Procedure_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ehr_product_procedure" */
export type Ehr_Product_Procedure_Aggregate_Fields = {
  __typename?: 'ehr_product_procedure_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Product_Procedure_Max_Fields>;
  min?: Maybe<Ehr_Product_Procedure_Min_Fields>;
};


/** aggregate fields of "ehr_product_procedure" */
export type Ehr_Product_Procedure_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Product_Procedure_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ehr_product_procedure" */
export type Ehr_Product_Procedure_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Product_Procedure_Max_Order_By>;
  min?: InputMaybe<Ehr_Product_Procedure_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ehr_product_procedure" */
export type Ehr_Product_Procedure_Arr_Rel_Insert_Input = {
  data: Array<Ehr_Product_Procedure_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Product_Procedure_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ehr_product_procedure". All fields are combined with a logical 'AND'. */
export type Ehr_Product_Procedure_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Product_Procedure_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Product_Procedure_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Product_Procedure_Bool_Exp>>;
  ehr_product?: InputMaybe<Uuid_Comparison_Exp>;
  ehr_product_by_ehr_product?: InputMaybe<Ehr_Product_Bool_Exp>;
  procedure?: InputMaybe<Uuid_Comparison_Exp>;
  procedureByProcedure?: InputMaybe<Procedure_Bool_Exp>;
};

/** unique or primary key constraints on table "ehr_product_procedure" */
export enum Ehr_Product_Procedure_Constraint {
  /** unique or primary key constraint on columns "ehr_product", "procedure" */
  EhrProductProcedurePkey = 'ehr_product_procedure_pkey'
}

/** input type for inserting data into table "ehr_product_procedure" */
export type Ehr_Product_Procedure_Insert_Input = {
  ehr_product?: InputMaybe<Scalars['uuid']>;
  ehr_product_by_ehr_product?: InputMaybe<Ehr_Product_Obj_Rel_Insert_Input>;
  procedure?: InputMaybe<Scalars['uuid']>;
  procedureByProcedure?: InputMaybe<Procedure_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Ehr_Product_Procedure_Max_Fields = {
  __typename?: 'ehr_product_procedure_max_fields';
  ehr_product?: Maybe<Scalars['uuid']>;
  procedure?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "ehr_product_procedure" */
export type Ehr_Product_Procedure_Max_Order_By = {
  ehr_product?: InputMaybe<Order_By>;
  procedure?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ehr_Product_Procedure_Min_Fields = {
  __typename?: 'ehr_product_procedure_min_fields';
  ehr_product?: Maybe<Scalars['uuid']>;
  procedure?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "ehr_product_procedure" */
export type Ehr_Product_Procedure_Min_Order_By = {
  ehr_product?: InputMaybe<Order_By>;
  procedure?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ehr_product_procedure" */
export type Ehr_Product_Procedure_Mutation_Response = {
  __typename?: 'ehr_product_procedure_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Product_Procedure>;
};

/** on_conflict condition type for table "ehr_product_procedure" */
export type Ehr_Product_Procedure_On_Conflict = {
  constraint: Ehr_Product_Procedure_Constraint;
  update_columns?: Array<Ehr_Product_Procedure_Update_Column>;
  where?: InputMaybe<Ehr_Product_Procedure_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_product_procedure". */
export type Ehr_Product_Procedure_Order_By = {
  ehr_product?: InputMaybe<Order_By>;
  ehr_product_by_ehr_product?: InputMaybe<Ehr_Product_Order_By>;
  procedure?: InputMaybe<Order_By>;
  procedureByProcedure?: InputMaybe<Procedure_Order_By>;
};

/** primary key columns input for table: ehr_product_procedure */
export type Ehr_Product_Procedure_Pk_Columns_Input = {
  ehr_product: Scalars['uuid'];
  procedure: Scalars['uuid'];
};

/** select columns of table "ehr_product_procedure" */
export enum Ehr_Product_Procedure_Select_Column {
  /** column name */
  EhrProduct = 'ehr_product',
  /** column name */
  Procedure = 'procedure'
}

/** input type for updating data in table "ehr_product_procedure" */
export type Ehr_Product_Procedure_Set_Input = {
  ehr_product?: InputMaybe<Scalars['uuid']>;
  procedure?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "ehr_product_procedure" */
export type Ehr_Product_Procedure_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Product_Procedure_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Product_Procedure_Stream_Cursor_Value_Input = {
  ehr_product?: InputMaybe<Scalars['uuid']>;
  procedure?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "ehr_product_procedure" */
export enum Ehr_Product_Procedure_Update_Column {
  /** column name */
  EhrProduct = 'ehr_product',
  /** column name */
  Procedure = 'procedure'
}

export type Ehr_Product_Procedure_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Product_Procedure_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Product_Procedure_Bool_Exp;
};

/** columns and relationships of "ehr_product_provider_usage_record_photo" */
export type Ehr_Product_Provider_Usage_Record_Photo = {
  __typename?: 'ehr_product_provider_usage_record_photo';
  barcode?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  ehrEncounter: Scalars['uuid'];
  /** An object relationship */
  ehrEncounterByEhrEncounter: Ehr_Encounter;
  ehrFdaProduct?: Maybe<Scalars['uuid']>;
  ehrProduct: Scalars['uuid'];
  /** An object relationship */
  ehrProductByEhrProduct: Ehr_Product;
  expiration?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  lotNumber?: Maybe<Scalars['String']>;
  photoS3Key: Scalars['uuid'];
  serialNumber?: Maybe<Scalars['String']>;
};

/** aggregated selection of "ehr_product_provider_usage_record_photo" */
export type Ehr_Product_Provider_Usage_Record_Photo_Aggregate = {
  __typename?: 'ehr_product_provider_usage_record_photo_aggregate';
  aggregate?: Maybe<Ehr_Product_Provider_Usage_Record_Photo_Aggregate_Fields>;
  nodes: Array<Ehr_Product_Provider_Usage_Record_Photo>;
};

export type Ehr_Product_Provider_Usage_Record_Photo_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Aggregate_Bool_Exp_Count>;
};

export type Ehr_Product_Provider_Usage_Record_Photo_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ehr_Product_Provider_Usage_Record_Photo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ehr_product_provider_usage_record_photo" */
export type Ehr_Product_Provider_Usage_Record_Photo_Aggregate_Fields = {
  __typename?: 'ehr_product_provider_usage_record_photo_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Product_Provider_Usage_Record_Photo_Max_Fields>;
  min?: Maybe<Ehr_Product_Provider_Usage_Record_Photo_Min_Fields>;
};


/** aggregate fields of "ehr_product_provider_usage_record_photo" */
export type Ehr_Product_Provider_Usage_Record_Photo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Product_Provider_Usage_Record_Photo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ehr_product_provider_usage_record_photo" */
export type Ehr_Product_Provider_Usage_Record_Photo_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Max_Order_By>;
  min?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ehr_product_provider_usage_record_photo" */
export type Ehr_Product_Provider_Usage_Record_Photo_Arr_Rel_Insert_Input = {
  data: Array<Ehr_Product_Provider_Usage_Record_Photo_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ehr_product_provider_usage_record_photo". All fields are combined with a logical 'AND'. */
export type Ehr_Product_Provider_Usage_Record_Photo_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Product_Provider_Usage_Record_Photo_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Product_Provider_Usage_Record_Photo_Bool_Exp>>;
  barcode?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrEncounter?: InputMaybe<Uuid_Comparison_Exp>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Bool_Exp>;
  ehrFdaProduct?: InputMaybe<Uuid_Comparison_Exp>;
  ehrProduct?: InputMaybe<Uuid_Comparison_Exp>;
  ehrProductByEhrProduct?: InputMaybe<Ehr_Product_Bool_Exp>;
  expiration?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lotNumber?: InputMaybe<String_Comparison_Exp>;
  photoS3Key?: InputMaybe<Uuid_Comparison_Exp>;
  serialNumber?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_product_provider_usage_record_photo" */
export enum Ehr_Product_Provider_Usage_Record_Photo_Constraint {
  /** unique or primary key constraint on columns "photo_s3_key" */
  EhrProductProviderUsageRecordPhotoPhotoS3KeyKey = 'ehr_product_provider_usage_record_photo_photo_s3_key_key',
  /** unique or primary key constraint on columns "id" */
  EhrProductProviderUsageRecordPhotoPkey = 'ehr_product_provider_usage_record_photo_pkey'
}

/** input type for inserting data into table "ehr_product_provider_usage_record_photo" */
export type Ehr_Product_Provider_Usage_Record_Photo_Insert_Input = {
  barcode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  ehrEncounter?: InputMaybe<Scalars['uuid']>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Obj_Rel_Insert_Input>;
  ehrFdaProduct?: InputMaybe<Scalars['uuid']>;
  ehrProduct?: InputMaybe<Scalars['uuid']>;
  ehrProductByEhrProduct?: InputMaybe<Ehr_Product_Obj_Rel_Insert_Input>;
  expiration?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ehr_Product_Provider_Usage_Record_Photo_Max_Fields = {
  __typename?: 'ehr_product_provider_usage_record_photo_max_fields';
  barcode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  ehrEncounter?: Maybe<Scalars['uuid']>;
  ehrFdaProduct?: Maybe<Scalars['uuid']>;
  ehrProduct?: Maybe<Scalars['uuid']>;
  expiration?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  lotNumber?: Maybe<Scalars['String']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
  serialNumber?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ehr_product_provider_usage_record_photo" */
export type Ehr_Product_Provider_Usage_Record_Photo_Max_Order_By = {
  barcode?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  ehrEncounter?: InputMaybe<Order_By>;
  ehrFdaProduct?: InputMaybe<Order_By>;
  ehrProduct?: InputMaybe<Order_By>;
  expiration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lotNumber?: InputMaybe<Order_By>;
  photoS3Key?: InputMaybe<Order_By>;
  serialNumber?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ehr_Product_Provider_Usage_Record_Photo_Min_Fields = {
  __typename?: 'ehr_product_provider_usage_record_photo_min_fields';
  barcode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  ehrEncounter?: Maybe<Scalars['uuid']>;
  ehrFdaProduct?: Maybe<Scalars['uuid']>;
  ehrProduct?: Maybe<Scalars['uuid']>;
  expiration?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  lotNumber?: Maybe<Scalars['String']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
  serialNumber?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ehr_product_provider_usage_record_photo" */
export type Ehr_Product_Provider_Usage_Record_Photo_Min_Order_By = {
  barcode?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  ehrEncounter?: InputMaybe<Order_By>;
  ehrFdaProduct?: InputMaybe<Order_By>;
  ehrProduct?: InputMaybe<Order_By>;
  expiration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lotNumber?: InputMaybe<Order_By>;
  photoS3Key?: InputMaybe<Order_By>;
  serialNumber?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ehr_product_provider_usage_record_photo" */
export type Ehr_Product_Provider_Usage_Record_Photo_Mutation_Response = {
  __typename?: 'ehr_product_provider_usage_record_photo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Product_Provider_Usage_Record_Photo>;
};

/** on_conflict condition type for table "ehr_product_provider_usage_record_photo" */
export type Ehr_Product_Provider_Usage_Record_Photo_On_Conflict = {
  constraint: Ehr_Product_Provider_Usage_Record_Photo_Constraint;
  update_columns?: Array<Ehr_Product_Provider_Usage_Record_Photo_Update_Column>;
  where?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_product_provider_usage_record_photo". */
export type Ehr_Product_Provider_Usage_Record_Photo_Order_By = {
  barcode?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  ehrEncounter?: InputMaybe<Order_By>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Order_By>;
  ehrFdaProduct?: InputMaybe<Order_By>;
  ehrProduct?: InputMaybe<Order_By>;
  ehrProductByEhrProduct?: InputMaybe<Ehr_Product_Order_By>;
  expiration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lotNumber?: InputMaybe<Order_By>;
  photoS3Key?: InputMaybe<Order_By>;
  serialNumber?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_product_provider_usage_record_photo */
export type Ehr_Product_Provider_Usage_Record_Photo_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ehr_product_provider_usage_record_photo" */
export enum Ehr_Product_Provider_Usage_Record_Photo_Select_Column {
  /** column name */
  Barcode = 'barcode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EhrEncounter = 'ehrEncounter',
  /** column name */
  EhrFdaProduct = 'ehrFdaProduct',
  /** column name */
  EhrProduct = 'ehrProduct',
  /** column name */
  Expiration = 'expiration',
  /** column name */
  Id = 'id',
  /** column name */
  LotNumber = 'lotNumber',
  /** column name */
  PhotoS3Key = 'photoS3Key',
  /** column name */
  SerialNumber = 'serialNumber'
}

/** input type for updating data in table "ehr_product_provider_usage_record_photo" */
export type Ehr_Product_Provider_Usage_Record_Photo_Set_Input = {
  barcode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  ehrEncounter?: InputMaybe<Scalars['uuid']>;
  ehrFdaProduct?: InputMaybe<Scalars['uuid']>;
  ehrProduct?: InputMaybe<Scalars['uuid']>;
  expiration?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ehr_product_provider_usage_record_photo" */
export type Ehr_Product_Provider_Usage_Record_Photo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Product_Provider_Usage_Record_Photo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Product_Provider_Usage_Record_Photo_Stream_Cursor_Value_Input = {
  barcode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  ehrEncounter?: InputMaybe<Scalars['uuid']>;
  ehrFdaProduct?: InputMaybe<Scalars['uuid']>;
  ehrProduct?: InputMaybe<Scalars['uuid']>;
  expiration?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  serialNumber?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ehr_product_provider_usage_record_photo" */
export enum Ehr_Product_Provider_Usage_Record_Photo_Update_Column {
  /** column name */
  Barcode = 'barcode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EhrEncounter = 'ehrEncounter',
  /** column name */
  EhrFdaProduct = 'ehrFdaProduct',
  /** column name */
  EhrProduct = 'ehrProduct',
  /** column name */
  Expiration = 'expiration',
  /** column name */
  Id = 'id',
  /** column name */
  LotNumber = 'lotNumber',
  /** column name */
  PhotoS3Key = 'photoS3Key',
  /** column name */
  SerialNumber = 'serialNumber'
}

export type Ehr_Product_Provider_Usage_Record_Photo_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Product_Provider_Usage_Record_Photo_Bool_Exp;
};

/** select columns of table "ehr_product" */
export enum Ehr_Product_Select_Column {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Dosages = 'dosages',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoS3Key = 'photoS3Key',
  /** column name */
  UnitsText = 'unitsText'
}

/** input type for updating data in table "ehr_product" */
export type Ehr_Product_Set_Input = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  dosages?: InputMaybe<Array<Scalars['numeric']>>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  /** Applies to all doses for the product */
  unitsText?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ehr_product" */
export type Ehr_Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Product_Stream_Cursor_Value_Input = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  dosages?: InputMaybe<Array<Scalars['numeric']>>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  /** Applies to all doses for the product */
  unitsText?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ehr_product" */
export enum Ehr_Product_Update_Column {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Dosages = 'dosages',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoS3Key = 'photoS3Key',
  /** column name */
  UnitsText = 'unitsText'
}

export type Ehr_Product_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Product_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Product_Bool_Exp;
};

/** One billing unit's EHR subscription, and one Stripe subscription, for the row's whole life. Rows are never deleted: ended_at set means the subscription is over. The tier is in ehr_subscription_tier_term, not here. */
export type Ehr_Subscription = {
  __typename?: 'ehr_subscription';
  createdAt: Scalars['timestamptz'];
  /** When this subscription ended. NULL means the subscription is live. */
  endedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** The billing unit when it is an MSO practice. Exactly one of provider and partner is set. */
  partner?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  partnerByPartner?: Maybe<Partner>;
  /** The billing unit when it is a classic provider. Exactly one of provider and partner is set. */
  provider?: Maybe<Scalars['uuid']>;
  /** When service last resumed after a suspension. NULL if it never has. */
  resumedAt?: Maybe<Scalars['timestamptz']>;
  /** True if this row began as a free trial. */
  startedAsTrial: Scalars['Boolean'];
  status: Ehr_Subscription_Status_Enum;
  /** The Stripe subscription this row is. Unique: one row, one subscription. */
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  /** When the most recent suspension began. Not cleared on resume, and not a history of earlier suspensions. */
  suspendedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  tierTerms: Array<Ehr_Subscription_Tier_Term>;
  /** An aggregate relationship */
  tierTerms_aggregate: Ehr_Subscription_Tier_Term_Aggregate;
  /** The instant from which this row bills: when the trial ended on a trial row, or created_at on a later one. NULL while a trial is running, and on a row that ended during its trial. */
  trialEndedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  userByProvider?: Maybe<User>;
};


/** One billing unit's EHR subscription, and one Stripe subscription, for the row's whole life. Rows are never deleted: ended_at set means the subscription is over. The tier is in ehr_subscription_tier_term, not here. */
export type Ehr_SubscriptionTierTermsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Tier_Term_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Tier_Term_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Tier_Term_Bool_Exp>;
};


/** One billing unit's EHR subscription, and one Stripe subscription, for the row's whole life. Rows are never deleted: ended_at set means the subscription is over. The tier is in ehr_subscription_tier_term, not here. */
export type Ehr_SubscriptionTierTerms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Tier_Term_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Tier_Term_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Tier_Term_Bool_Exp>;
};

/** aggregated selection of "ehr_subscription" */
export type Ehr_Subscription_Aggregate = {
  __typename?: 'ehr_subscription_aggregate';
  aggregate?: Maybe<Ehr_Subscription_Aggregate_Fields>;
  nodes: Array<Ehr_Subscription>;
};

export type Ehr_Subscription_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Ehr_Subscription_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Ehr_Subscription_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Ehr_Subscription_Aggregate_Bool_Exp_Count>;
};

export type Ehr_Subscription_Aggregate_Bool_Exp_Bool_And = {
  arguments: Ehr_Subscription_Select_Column_Ehr_Subscription_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Subscription_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ehr_Subscription_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Ehr_Subscription_Select_Column_Ehr_Subscription_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Subscription_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ehr_Subscription_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ehr_Subscription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Subscription_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ehr_subscription" */
export type Ehr_Subscription_Aggregate_Fields = {
  __typename?: 'ehr_subscription_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Subscription_Max_Fields>;
  min?: Maybe<Ehr_Subscription_Min_Fields>;
};


/** aggregate fields of "ehr_subscription" */
export type Ehr_Subscription_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Subscription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ehr_subscription" */
export type Ehr_Subscription_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Subscription_Max_Order_By>;
  min?: InputMaybe<Ehr_Subscription_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ehr_subscription" */
export type Ehr_Subscription_Arr_Rel_Insert_Input = {
  data: Array<Ehr_Subscription_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Subscription_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ehr_subscription". All fields are combined with a logical 'AND'. */
export type Ehr_Subscription_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Subscription_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Subscription_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Subscription_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  endedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  partner?: InputMaybe<Uuid_Comparison_Exp>;
  partnerByPartner?: InputMaybe<Partner_Bool_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  resumedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  startedAsTrial?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<Ehr_Subscription_Status_Enum_Comparison_Exp>;
  stripeSubscriptionId?: InputMaybe<String_Comparison_Exp>;
  suspendedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  tierTerms?: InputMaybe<Ehr_Subscription_Tier_Term_Bool_Exp>;
  tierTerms_aggregate?: InputMaybe<Ehr_Subscription_Tier_Term_Aggregate_Bool_Exp>;
  trialEndedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userByProvider?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "ehr_subscription" */
export enum Ehr_Subscription_Constraint {
  /** unique or primary key constraint on columns "partner" */
  EhrSubscriptionOneLivePerPartnerIndex = 'ehr_subscription_one_live_per_partner_index',
  /** unique or primary key constraint on columns "provider" */
  EhrSubscriptionOneLivePerProviderIndex = 'ehr_subscription_one_live_per_provider_index',
  /** unique or primary key constraint on columns "partner" */
  EhrSubscriptionOneTrialEverPerPartnerIndex = 'ehr_subscription_one_trial_ever_per_partner_index',
  /** unique or primary key constraint on columns "provider" */
  EhrSubscriptionOneTrialEverPerProviderIndex = 'ehr_subscription_one_trial_ever_per_provider_index',
  /** unique or primary key constraint on columns "id" */
  EhrSubscriptionPkey = 'ehr_subscription_pkey',
  /** unique or primary key constraint on columns "stripe_subscription_id" */
  EhrSubscriptionStripeSubscriptionIdIndex = 'ehr_subscription_stripe_subscription_id_index'
}

/** input type for inserting data into table "ehr_subscription" */
export type Ehr_Subscription_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** When this subscription ended. NULL means the subscription is live. */
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The billing unit when it is an MSO practice. Exactly one of provider and partner is set. */
  partner?: InputMaybe<Scalars['uuid']>;
  partnerByPartner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  /** The billing unit when it is a classic provider. Exactly one of provider and partner is set. */
  provider?: InputMaybe<Scalars['uuid']>;
  /** When service last resumed after a suspension. NULL if it never has. */
  resumedAt?: InputMaybe<Scalars['timestamptz']>;
  /** True if this row began as a free trial. */
  startedAsTrial?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Ehr_Subscription_Status_Enum>;
  /** The Stripe subscription this row is. Unique: one row, one subscription. */
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  /** When the most recent suspension began. Not cleared on resume, and not a history of earlier suspensions. */
  suspendedAt?: InputMaybe<Scalars['timestamptz']>;
  tierTerms?: InputMaybe<Ehr_Subscription_Tier_Term_Arr_Rel_Insert_Input>;
  /** The instant from which this row bills: when the trial ended on a trial row, or created_at on a later one. NULL while a trial is running, and on a row that ended during its trial. */
  trialEndedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Ehr_Subscription_Max_Fields = {
  __typename?: 'ehr_subscription_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** When this subscription ended. NULL means the subscription is live. */
  endedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The billing unit when it is an MSO practice. Exactly one of provider and partner is set. */
  partner?: Maybe<Scalars['uuid']>;
  /** The billing unit when it is a classic provider. Exactly one of provider and partner is set. */
  provider?: Maybe<Scalars['uuid']>;
  /** When service last resumed after a suspension. NULL if it never has. */
  resumedAt?: Maybe<Scalars['timestamptz']>;
  /** The Stripe subscription this row is. Unique: one row, one subscription. */
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  /** When the most recent suspension began. Not cleared on resume, and not a history of earlier suspensions. */
  suspendedAt?: Maybe<Scalars['timestamptz']>;
  /** The instant from which this row bills: when the trial ended on a trial row, or created_at on a later one. NULL while a trial is running, and on a row that ended during its trial. */
  trialEndedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "ehr_subscription" */
export type Ehr_Subscription_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  /** When this subscription ended. NULL means the subscription is live. */
  endedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The billing unit when it is an MSO practice. Exactly one of provider and partner is set. */
  partner?: InputMaybe<Order_By>;
  /** The billing unit when it is a classic provider. Exactly one of provider and partner is set. */
  provider?: InputMaybe<Order_By>;
  /** When service last resumed after a suspension. NULL if it never has. */
  resumedAt?: InputMaybe<Order_By>;
  /** The Stripe subscription this row is. Unique: one row, one subscription. */
  stripeSubscriptionId?: InputMaybe<Order_By>;
  /** When the most recent suspension began. Not cleared on resume, and not a history of earlier suspensions. */
  suspendedAt?: InputMaybe<Order_By>;
  /** The instant from which this row bills: when the trial ended on a trial row, or created_at on a later one. NULL while a trial is running, and on a row that ended during its trial. */
  trialEndedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ehr_Subscription_Min_Fields = {
  __typename?: 'ehr_subscription_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** When this subscription ended. NULL means the subscription is live. */
  endedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The billing unit when it is an MSO practice. Exactly one of provider and partner is set. */
  partner?: Maybe<Scalars['uuid']>;
  /** The billing unit when it is a classic provider. Exactly one of provider and partner is set. */
  provider?: Maybe<Scalars['uuid']>;
  /** When service last resumed after a suspension. NULL if it never has. */
  resumedAt?: Maybe<Scalars['timestamptz']>;
  /** The Stripe subscription this row is. Unique: one row, one subscription. */
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  /** When the most recent suspension began. Not cleared on resume, and not a history of earlier suspensions. */
  suspendedAt?: Maybe<Scalars['timestamptz']>;
  /** The instant from which this row bills: when the trial ended on a trial row, or created_at on a later one. NULL while a trial is running, and on a row that ended during its trial. */
  trialEndedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "ehr_subscription" */
export type Ehr_Subscription_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  /** When this subscription ended. NULL means the subscription is live. */
  endedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The billing unit when it is an MSO practice. Exactly one of provider and partner is set. */
  partner?: InputMaybe<Order_By>;
  /** The billing unit when it is a classic provider. Exactly one of provider and partner is set. */
  provider?: InputMaybe<Order_By>;
  /** When service last resumed after a suspension. NULL if it never has. */
  resumedAt?: InputMaybe<Order_By>;
  /** The Stripe subscription this row is. Unique: one row, one subscription. */
  stripeSubscriptionId?: InputMaybe<Order_By>;
  /** When the most recent suspension began. Not cleared on resume, and not a history of earlier suspensions. */
  suspendedAt?: InputMaybe<Order_By>;
  /** The instant from which this row bills: when the trial ended on a trial row, or created_at on a later one. NULL while a trial is running, and on a row that ended during its trial. */
  trialEndedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ehr_subscription" */
export type Ehr_Subscription_Mutation_Response = {
  __typename?: 'ehr_subscription_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Subscription>;
};

/** input type for inserting object relation for remote table "ehr_subscription" */
export type Ehr_Subscription_Obj_Rel_Insert_Input = {
  data: Ehr_Subscription_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Subscription_On_Conflict>;
};

/** on_conflict condition type for table "ehr_subscription" */
export type Ehr_Subscription_On_Conflict = {
  constraint: Ehr_Subscription_Constraint;
  update_columns?: Array<Ehr_Subscription_Update_Column>;
  where?: InputMaybe<Ehr_Subscription_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_subscription". */
export type Ehr_Subscription_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  endedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  partner?: InputMaybe<Order_By>;
  partnerByPartner?: InputMaybe<Partner_Order_By>;
  provider?: InputMaybe<Order_By>;
  resumedAt?: InputMaybe<Order_By>;
  startedAsTrial?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripeSubscriptionId?: InputMaybe<Order_By>;
  suspendedAt?: InputMaybe<Order_By>;
  tierTerms_aggregate?: InputMaybe<Ehr_Subscription_Tier_Term_Aggregate_Order_By>;
  trialEndedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userByProvider?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: ehr_subscription */
export type Ehr_Subscription_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ehr_subscription" */
export enum Ehr_Subscription_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndedAt = 'endedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Partner = 'partner',
  /** column name */
  Provider = 'provider',
  /** column name */
  ResumedAt = 'resumedAt',
  /** column name */
  StartedAsTrial = 'startedAsTrial',
  /** column name */
  Status = 'status',
  /** column name */
  StripeSubscriptionId = 'stripeSubscriptionId',
  /** column name */
  SuspendedAt = 'suspendedAt',
  /** column name */
  TrialEndedAt = 'trialEndedAt',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "ehr_subscription_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ehr_subscription" */
export enum Ehr_Subscription_Select_Column_Ehr_Subscription_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  StartedAsTrial = 'startedAsTrial'
}

/** select "ehr_subscription_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ehr_subscription" */
export enum Ehr_Subscription_Select_Column_Ehr_Subscription_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  StartedAsTrial = 'startedAsTrial'
}

/** input type for updating data in table "ehr_subscription" */
export type Ehr_Subscription_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** When this subscription ended. NULL means the subscription is live. */
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The billing unit when it is an MSO practice. Exactly one of provider and partner is set. */
  partner?: InputMaybe<Scalars['uuid']>;
  /** The billing unit when it is a classic provider. Exactly one of provider and partner is set. */
  provider?: InputMaybe<Scalars['uuid']>;
  /** When service last resumed after a suspension. NULL if it never has. */
  resumedAt?: InputMaybe<Scalars['timestamptz']>;
  /** True if this row began as a free trial. */
  startedAsTrial?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Ehr_Subscription_Status_Enum>;
  /** The Stripe subscription this row is. Unique: one row, one subscription. */
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  /** When the most recent suspension began. Not cleared on resume, and not a history of earlier suspensions. */
  suspendedAt?: InputMaybe<Scalars['timestamptz']>;
  /** The instant from which this row bills: when the trial ended on a trial row, or created_at on a later one. NULL while a trial is running, and on a row that ended during its trial. */
  trialEndedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Enum of EHR subscription states. */
export type Ehr_Subscription_Status = {
  __typename?: 'ehr_subscription_status';
  id: Scalars['String'];
};

/** aggregated selection of "ehr_subscription_status" */
export type Ehr_Subscription_Status_Aggregate = {
  __typename?: 'ehr_subscription_status_aggregate';
  aggregate?: Maybe<Ehr_Subscription_Status_Aggregate_Fields>;
  nodes: Array<Ehr_Subscription_Status>;
};

/** aggregate fields of "ehr_subscription_status" */
export type Ehr_Subscription_Status_Aggregate_Fields = {
  __typename?: 'ehr_subscription_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Subscription_Status_Max_Fields>;
  min?: Maybe<Ehr_Subscription_Status_Min_Fields>;
};


/** aggregate fields of "ehr_subscription_status" */
export type Ehr_Subscription_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Subscription_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ehr_subscription_status". All fields are combined with a logical 'AND'. */
export type Ehr_Subscription_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Subscription_Status_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Subscription_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Subscription_Status_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_subscription_status" */
export enum Ehr_Subscription_Status_Constraint {
  /** unique or primary key constraint on columns "id" */
  EhrSubscriptionStatusPkey = 'ehr_subscription_status_pkey'
}

export enum Ehr_Subscription_Status_Enum {
  Active = 'ACTIVE',
  Canceling = 'CANCELING',
  EndedByCustomer = 'ENDED_BY_CUSTOMER',
  EndedUnpaid = 'ENDED_UNPAID',
  Suspended = 'SUSPENDED',
  Trial = 'TRIAL'
}

/** Boolean expression to compare columns of type "ehr_subscription_status_enum". All fields are combined with logical 'AND'. */
export type Ehr_Subscription_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ehr_Subscription_Status_Enum>;
  _in?: InputMaybe<Array<Ehr_Subscription_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Ehr_Subscription_Status_Enum>;
  _nin?: InputMaybe<Array<Ehr_Subscription_Status_Enum>>;
};

/** input type for inserting data into table "ehr_subscription_status" */
export type Ehr_Subscription_Status_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ehr_Subscription_Status_Max_Fields = {
  __typename?: 'ehr_subscription_status_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ehr_Subscription_Status_Min_Fields = {
  __typename?: 'ehr_subscription_status_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ehr_subscription_status" */
export type Ehr_Subscription_Status_Mutation_Response = {
  __typename?: 'ehr_subscription_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Subscription_Status>;
};

/** on_conflict condition type for table "ehr_subscription_status" */
export type Ehr_Subscription_Status_On_Conflict = {
  constraint: Ehr_Subscription_Status_Constraint;
  update_columns?: Array<Ehr_Subscription_Status_Update_Column>;
  where?: InputMaybe<Ehr_Subscription_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_subscription_status". */
export type Ehr_Subscription_Status_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_subscription_status */
export type Ehr_Subscription_Status_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "ehr_subscription_status" */
export enum Ehr_Subscription_Status_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "ehr_subscription_status" */
export type Ehr_Subscription_Status_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ehr_subscription_status" */
export type Ehr_Subscription_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Subscription_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Subscription_Status_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ehr_subscription_status" */
export enum Ehr_Subscription_Status_Update_Column {
  /** column name */
  Id = 'id'
}

export type Ehr_Subscription_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Subscription_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Subscription_Status_Bool_Exp;
};

/** Streaming cursor of the table "ehr_subscription" */
export type Ehr_Subscription_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Subscription_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Subscription_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** When this subscription ended. NULL means the subscription is live. */
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The billing unit when it is an MSO practice. Exactly one of provider and partner is set. */
  partner?: InputMaybe<Scalars['uuid']>;
  /** The billing unit when it is a classic provider. Exactly one of provider and partner is set. */
  provider?: InputMaybe<Scalars['uuid']>;
  /** When service last resumed after a suspension. NULL if it never has. */
  resumedAt?: InputMaybe<Scalars['timestamptz']>;
  /** True if this row began as a free trial. */
  startedAsTrial?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Ehr_Subscription_Status_Enum>;
  /** The Stripe subscription this row is. Unique: one row, one subscription. */
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  /** When the most recent suspension began. Not cleared on resume, and not a history of earlier suspensions. */
  suspendedAt?: InputMaybe<Scalars['timestamptz']>;
  /** The instant from which this row bills: when the trial ended on a trial row, or created_at on a later one. NULL while a trial is running, and on a row that ended during its trial. */
  trialEndedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Enum of EHR subscription tiers. */
export type Ehr_Subscription_Tier = {
  __typename?: 'ehr_subscription_tier';
  id: Scalars['String'];
};

/** aggregated selection of "ehr_subscription_tier" */
export type Ehr_Subscription_Tier_Aggregate = {
  __typename?: 'ehr_subscription_tier_aggregate';
  aggregate?: Maybe<Ehr_Subscription_Tier_Aggregate_Fields>;
  nodes: Array<Ehr_Subscription_Tier>;
};

/** aggregate fields of "ehr_subscription_tier" */
export type Ehr_Subscription_Tier_Aggregate_Fields = {
  __typename?: 'ehr_subscription_tier_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Subscription_Tier_Max_Fields>;
  min?: Maybe<Ehr_Subscription_Tier_Min_Fields>;
};


/** aggregate fields of "ehr_subscription_tier" */
export type Ehr_Subscription_Tier_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Subscription_Tier_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ehr_subscription_tier". All fields are combined with a logical 'AND'. */
export type Ehr_Subscription_Tier_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Subscription_Tier_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Subscription_Tier_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Subscription_Tier_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_subscription_tier" */
export enum Ehr_Subscription_Tier_Constraint {
  /** unique or primary key constraint on columns "id" */
  EhrSubscriptionTierPkey = 'ehr_subscription_tier_pkey'
}

export enum Ehr_Subscription_Tier_Enum {
  Essential = 'ESSENTIAL',
  Practice = 'PRACTICE',
  Professional = 'PROFESSIONAL'
}

/** Boolean expression to compare columns of type "ehr_subscription_tier_enum". All fields are combined with logical 'AND'. */
export type Ehr_Subscription_Tier_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ehr_Subscription_Tier_Enum>;
  _in?: InputMaybe<Array<Ehr_Subscription_Tier_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Ehr_Subscription_Tier_Enum>;
  _nin?: InputMaybe<Array<Ehr_Subscription_Tier_Enum>>;
};

/** input type for inserting data into table "ehr_subscription_tier" */
export type Ehr_Subscription_Tier_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ehr_Subscription_Tier_Max_Fields = {
  __typename?: 'ehr_subscription_tier_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ehr_Subscription_Tier_Min_Fields = {
  __typename?: 'ehr_subscription_tier_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ehr_subscription_tier" */
export type Ehr_Subscription_Tier_Mutation_Response = {
  __typename?: 'ehr_subscription_tier_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Subscription_Tier>;
};

/** on_conflict condition type for table "ehr_subscription_tier" */
export type Ehr_Subscription_Tier_On_Conflict = {
  constraint: Ehr_Subscription_Tier_Constraint;
  update_columns?: Array<Ehr_Subscription_Tier_Update_Column>;
  where?: InputMaybe<Ehr_Subscription_Tier_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_subscription_tier". */
export type Ehr_Subscription_Tier_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_subscription_tier */
export type Ehr_Subscription_Tier_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "ehr_subscription_tier" */
export enum Ehr_Subscription_Tier_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "ehr_subscription_tier" */
export type Ehr_Subscription_Tier_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ehr_subscription_tier" */
export type Ehr_Subscription_Tier_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Subscription_Tier_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Subscription_Tier_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** One interval of one tier on one subscription, and the only place tier lives - ehr_subscription has no tier column. Authoritative for tier over any window. */
export type Ehr_Subscription_Tier_Term = {
  __typename?: 'ehr_subscription_tier_term';
  createdAt: Scalars['timestamptz'];
  ehrSubscription: Scalars['uuid'];
  /** An object relationship */
  ehrSubscriptionByEhrSubscription: Ehr_Subscription;
  /** When this term stopped being in force. NULL means it still is. */
  endedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  startedAt: Scalars['timestamptz'];
  tier: Ehr_Subscription_Tier_Enum;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "ehr_subscription_tier_term" */
export type Ehr_Subscription_Tier_Term_Aggregate = {
  __typename?: 'ehr_subscription_tier_term_aggregate';
  aggregate?: Maybe<Ehr_Subscription_Tier_Term_Aggregate_Fields>;
  nodes: Array<Ehr_Subscription_Tier_Term>;
};

export type Ehr_Subscription_Tier_Term_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ehr_Subscription_Tier_Term_Aggregate_Bool_Exp_Count>;
};

export type Ehr_Subscription_Tier_Term_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ehr_Subscription_Tier_Term_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ehr_Subscription_Tier_Term_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ehr_subscription_tier_term" */
export type Ehr_Subscription_Tier_Term_Aggregate_Fields = {
  __typename?: 'ehr_subscription_tier_term_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ehr_Subscription_Tier_Term_Max_Fields>;
  min?: Maybe<Ehr_Subscription_Tier_Term_Min_Fields>;
};


/** aggregate fields of "ehr_subscription_tier_term" */
export type Ehr_Subscription_Tier_Term_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Subscription_Tier_Term_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ehr_subscription_tier_term" */
export type Ehr_Subscription_Tier_Term_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ehr_Subscription_Tier_Term_Max_Order_By>;
  min?: InputMaybe<Ehr_Subscription_Tier_Term_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ehr_subscription_tier_term" */
export type Ehr_Subscription_Tier_Term_Arr_Rel_Insert_Input = {
  data: Array<Ehr_Subscription_Tier_Term_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Subscription_Tier_Term_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ehr_subscription_tier_term". All fields are combined with a logical 'AND'. */
export type Ehr_Subscription_Tier_Term_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Subscription_Tier_Term_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Subscription_Tier_Term_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Subscription_Tier_Term_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrSubscription?: InputMaybe<Uuid_Comparison_Exp>;
  ehrSubscriptionByEhrSubscription?: InputMaybe<Ehr_Subscription_Bool_Exp>;
  endedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  startedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  tier?: InputMaybe<Ehr_Subscription_Tier_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr_subscription_tier_term" */
export enum Ehr_Subscription_Tier_Term_Constraint {
  /** unique or primary key constraint on columns "ehr_subscription" */
  EhrSubscriptionOneOpenTierTermIndex = 'ehr_subscription_one_open_tier_term_index',
  /** unique or primary key constraint on columns "id" */
  EhrSubscriptionTierTermPkey = 'ehr_subscription_tier_term_pkey'
}

/** input type for inserting data into table "ehr_subscription_tier_term" */
export type Ehr_Subscription_Tier_Term_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  ehrSubscription?: InputMaybe<Scalars['uuid']>;
  ehrSubscriptionByEhrSubscription?: InputMaybe<Ehr_Subscription_Obj_Rel_Insert_Input>;
  /** When this term stopped being in force. NULL means it still is. */
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  startedAt?: InputMaybe<Scalars['timestamptz']>;
  tier?: InputMaybe<Ehr_Subscription_Tier_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Ehr_Subscription_Tier_Term_Max_Fields = {
  __typename?: 'ehr_subscription_tier_term_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  ehrSubscription?: Maybe<Scalars['uuid']>;
  /** When this term stopped being in force. NULL means it still is. */
  endedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  startedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "ehr_subscription_tier_term" */
export type Ehr_Subscription_Tier_Term_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  ehrSubscription?: InputMaybe<Order_By>;
  /** When this term stopped being in force. NULL means it still is. */
  endedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  startedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ehr_Subscription_Tier_Term_Min_Fields = {
  __typename?: 'ehr_subscription_tier_term_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  ehrSubscription?: Maybe<Scalars['uuid']>;
  /** When this term stopped being in force. NULL means it still is. */
  endedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  startedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "ehr_subscription_tier_term" */
export type Ehr_Subscription_Tier_Term_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  ehrSubscription?: InputMaybe<Order_By>;
  /** When this term stopped being in force. NULL means it still is. */
  endedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  startedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ehr_subscription_tier_term" */
export type Ehr_Subscription_Tier_Term_Mutation_Response = {
  __typename?: 'ehr_subscription_tier_term_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Subscription_Tier_Term>;
};

/** on_conflict condition type for table "ehr_subscription_tier_term" */
export type Ehr_Subscription_Tier_Term_On_Conflict = {
  constraint: Ehr_Subscription_Tier_Term_Constraint;
  update_columns?: Array<Ehr_Subscription_Tier_Term_Update_Column>;
  where?: InputMaybe<Ehr_Subscription_Tier_Term_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr_subscription_tier_term". */
export type Ehr_Subscription_Tier_Term_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  ehrSubscription?: InputMaybe<Order_By>;
  ehrSubscriptionByEhrSubscription?: InputMaybe<Ehr_Subscription_Order_By>;
  endedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  startedAt?: InputMaybe<Order_By>;
  tier?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr_subscription_tier_term */
export type Ehr_Subscription_Tier_Term_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ehr_subscription_tier_term" */
export enum Ehr_Subscription_Tier_Term_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EhrSubscription = 'ehrSubscription',
  /** column name */
  EndedAt = 'endedAt',
  /** column name */
  Id = 'id',
  /** column name */
  StartedAt = 'startedAt',
  /** column name */
  Tier = 'tier',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "ehr_subscription_tier_term" */
export type Ehr_Subscription_Tier_Term_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  ehrSubscription?: InputMaybe<Scalars['uuid']>;
  /** When this term stopped being in force. NULL means it still is. */
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  startedAt?: InputMaybe<Scalars['timestamptz']>;
  tier?: InputMaybe<Ehr_Subscription_Tier_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "ehr_subscription_tier_term" */
export type Ehr_Subscription_Tier_Term_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Subscription_Tier_Term_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Subscription_Tier_Term_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  ehrSubscription?: InputMaybe<Scalars['uuid']>;
  /** When this term stopped being in force. NULL means it still is. */
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  startedAt?: InputMaybe<Scalars['timestamptz']>;
  tier?: InputMaybe<Ehr_Subscription_Tier_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "ehr_subscription_tier_term" */
export enum Ehr_Subscription_Tier_Term_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EhrSubscription = 'ehrSubscription',
  /** column name */
  EndedAt = 'endedAt',
  /** column name */
  Id = 'id',
  /** column name */
  StartedAt = 'startedAt',
  /** column name */
  Tier = 'tier',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Ehr_Subscription_Tier_Term_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Subscription_Tier_Term_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Subscription_Tier_Term_Bool_Exp;
};

/** update columns of table "ehr_subscription_tier" */
export enum Ehr_Subscription_Tier_Update_Column {
  /** column name */
  Id = 'id'
}

export type Ehr_Subscription_Tier_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Subscription_Tier_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Subscription_Tier_Bool_Exp;
};

/** update columns of table "ehr_subscription" */
export enum Ehr_Subscription_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndedAt = 'endedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Partner = 'partner',
  /** column name */
  Provider = 'provider',
  /** column name */
  ResumedAt = 'resumedAt',
  /** column name */
  StartedAsTrial = 'startedAsTrial',
  /** column name */
  Status = 'status',
  /** column name */
  StripeSubscriptionId = 'stripeSubscriptionId',
  /** column name */
  SuspendedAt = 'suspendedAt',
  /** column name */
  TrialEndedAt = 'trialEndedAt',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Ehr_Subscription_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Subscription_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Subscription_Bool_Exp;
};

/** columns and relationships of "event" */
export type Event = {
  __typename?: 'event';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  payload?: Maybe<Scalars['jsonb']>;
  source: Event_Source_Enum;
  subtype?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  user?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "event" */
export type EventPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "event" */
export type Event_Aggregate = {
  __typename?: 'event_aggregate';
  aggregate?: Maybe<Event_Aggregate_Fields>;
  nodes: Array<Event>;
};

export type Event_Aggregate_Bool_Exp = {
  count?: InputMaybe<Event_Aggregate_Bool_Exp_Count>;
};

export type Event_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Event_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "event" */
export type Event_Aggregate_Fields = {
  __typename?: 'event_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Event_Max_Fields>;
  min?: Maybe<Event_Min_Fields>;
};


/** aggregate fields of "event" */
export type Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event" */
export type Event_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Event_Max_Order_By>;
  min?: InputMaybe<Event_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Event_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "event" */
export type Event_Arr_Rel_Insert_Input = {
  data: Array<Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Event_On_Conflict>;
};

/** Boolean expression to filter rows from the table "event". All fields are combined with a logical 'AND'. */
export type Event_Bool_Exp = {
  _and?: InputMaybe<Array<Event_Bool_Exp>>;
  _not?: InputMaybe<Event_Bool_Exp>;
  _or?: InputMaybe<Array<Event_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  source?: InputMaybe<Event_Source_Enum_Comparison_Exp>;
  subtype?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "event" */
export enum Event_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventPkey = 'event_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Event_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Event_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Event_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "event" */
export type Event_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  source?: InputMaybe<Event_Source_Enum>;
  subtype?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Event_Max_Fields = {
  __typename?: 'event_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  subtype?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event" */
export type Event_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subtype?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Event_Min_Fields = {
  __typename?: 'event_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  subtype?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event" */
export type Event_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subtype?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "event" */
export type Event_Mutation_Response = {
  __typename?: 'event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Event>;
};

/** on_conflict condition type for table "event" */
export type Event_On_Conflict = {
  constraint: Event_Constraint;
  update_columns?: Array<Event_Update_Column>;
  where?: InputMaybe<Event_Bool_Exp>;
};

/** Ordering options when selecting data from "event". */
export type Event_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  subtype?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** primary key columns input for table: event */
export type Event_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Event_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "event" */
export enum Event_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Source = 'source',
  /** column name */
  Subtype = 'subtype',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  User = 'user'
}

/** input type for updating data in table "event" */
export type Event_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  source?: InputMaybe<Event_Source_Enum>;
  subtype?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "event_source" */
export type Event_Source = {
  __typename?: 'event_source';
  id: Scalars['String'];
};

/** aggregated selection of "event_source" */
export type Event_Source_Aggregate = {
  __typename?: 'event_source_aggregate';
  aggregate?: Maybe<Event_Source_Aggregate_Fields>;
  nodes: Array<Event_Source>;
};

/** aggregate fields of "event_source" */
export type Event_Source_Aggregate_Fields = {
  __typename?: 'event_source_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Event_Source_Max_Fields>;
  min?: Maybe<Event_Source_Min_Fields>;
};


/** aggregate fields of "event_source" */
export type Event_Source_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Event_Source_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_source". All fields are combined with a logical 'AND'. */
export type Event_Source_Bool_Exp = {
  _and?: InputMaybe<Array<Event_Source_Bool_Exp>>;
  _not?: InputMaybe<Event_Source_Bool_Exp>;
  _or?: InputMaybe<Array<Event_Source_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "event_source" */
export enum Event_Source_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventSourcePkey = 'event_source_pkey'
}

export enum Event_Source_Enum {
  Stripe = 'stripe'
}

/** Boolean expression to compare columns of type "event_source_enum". All fields are combined with logical 'AND'. */
export type Event_Source_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Event_Source_Enum>;
  _in?: InputMaybe<Array<Event_Source_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Event_Source_Enum>;
  _nin?: InputMaybe<Array<Event_Source_Enum>>;
};

/** input type for inserting data into table "event_source" */
export type Event_Source_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Event_Source_Max_Fields = {
  __typename?: 'event_source_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Event_Source_Min_Fields = {
  __typename?: 'event_source_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_source" */
export type Event_Source_Mutation_Response = {
  __typename?: 'event_source_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Event_Source>;
};

/** on_conflict condition type for table "event_source" */
export type Event_Source_On_Conflict = {
  constraint: Event_Source_Constraint;
  update_columns?: Array<Event_Source_Update_Column>;
  where?: InputMaybe<Event_Source_Bool_Exp>;
};

/** Ordering options when selecting data from "event_source". */
export type Event_Source_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: event_source */
export type Event_Source_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "event_source" */
export enum Event_Source_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "event_source" */
export type Event_Source_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_source" */
export type Event_Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Event_Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Event_Source_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_source" */
export enum Event_Source_Update_Column {
  /** column name */
  Id = 'id'
}

export type Event_Source_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Event_Source_Set_Input>;
  /** filter the rows which have to be updated */
  where: Event_Source_Bool_Exp;
};

/** Streaming cursor of the table "event" */
export type Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Event_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  source?: InputMaybe<Event_Source_Enum>;
  subtype?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "event" */
export enum Event_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Source = 'source',
  /** column name */
  Subtype = 'subtype',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  User = 'user'
}

export type Event_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Event_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Event_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Event_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Event_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Event_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Event_Bool_Exp;
};

/** columns and relationships of "filler_procedure_delivery_tool" */
export type Filler_Procedure_Delivery_Tool = {
  __typename?: 'filler_procedure_delivery_tool';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "filler_procedure_delivery_tool" */
export type Filler_Procedure_Delivery_Tool_Aggregate = {
  __typename?: 'filler_procedure_delivery_tool_aggregate';
  aggregate?: Maybe<Filler_Procedure_Delivery_Tool_Aggregate_Fields>;
  nodes: Array<Filler_Procedure_Delivery_Tool>;
};

/** aggregate fields of "filler_procedure_delivery_tool" */
export type Filler_Procedure_Delivery_Tool_Aggregate_Fields = {
  __typename?: 'filler_procedure_delivery_tool_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Filler_Procedure_Delivery_Tool_Max_Fields>;
  min?: Maybe<Filler_Procedure_Delivery_Tool_Min_Fields>;
};


/** aggregate fields of "filler_procedure_delivery_tool" */
export type Filler_Procedure_Delivery_Tool_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Filler_Procedure_Delivery_Tool_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "filler_procedure_delivery_tool". All fields are combined with a logical 'AND'. */
export type Filler_Procedure_Delivery_Tool_Bool_Exp = {
  _and?: InputMaybe<Array<Filler_Procedure_Delivery_Tool_Bool_Exp>>;
  _not?: InputMaybe<Filler_Procedure_Delivery_Tool_Bool_Exp>;
  _or?: InputMaybe<Array<Filler_Procedure_Delivery_Tool_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "filler_procedure_delivery_tool" */
export enum Filler_Procedure_Delivery_Tool_Constraint {
  /** unique or primary key constraint on columns "value" */
  FillerProcedureDeliveryToolPkey = 'filler_procedure_delivery_tool_pkey'
}

export enum Filler_Procedure_Delivery_Tool_Enum {
  /** Cannula delivery */
  Cannula = 'CANNULA',
  /** Needle delivery */
  Needle = 'NEEDLE'
}

/** Boolean expression to compare columns of type "filler_procedure_delivery_tool_enum". All fields are combined with logical 'AND'. */
export type Filler_Procedure_Delivery_Tool_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Filler_Procedure_Delivery_Tool_Enum>;
  _in?: InputMaybe<Array<Filler_Procedure_Delivery_Tool_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Filler_Procedure_Delivery_Tool_Enum>;
  _nin?: InputMaybe<Array<Filler_Procedure_Delivery_Tool_Enum>>;
};

/** input type for inserting data into table "filler_procedure_delivery_tool" */
export type Filler_Procedure_Delivery_Tool_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Filler_Procedure_Delivery_Tool_Max_Fields = {
  __typename?: 'filler_procedure_delivery_tool_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Filler_Procedure_Delivery_Tool_Min_Fields = {
  __typename?: 'filler_procedure_delivery_tool_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "filler_procedure_delivery_tool" */
export type Filler_Procedure_Delivery_Tool_Mutation_Response = {
  __typename?: 'filler_procedure_delivery_tool_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Filler_Procedure_Delivery_Tool>;
};

/** input type for inserting object relation for remote table "filler_procedure_delivery_tool" */
export type Filler_Procedure_Delivery_Tool_Obj_Rel_Insert_Input = {
  data: Filler_Procedure_Delivery_Tool_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Filler_Procedure_Delivery_Tool_On_Conflict>;
};

/** on_conflict condition type for table "filler_procedure_delivery_tool" */
export type Filler_Procedure_Delivery_Tool_On_Conflict = {
  constraint: Filler_Procedure_Delivery_Tool_Constraint;
  update_columns?: Array<Filler_Procedure_Delivery_Tool_Update_Column>;
  where?: InputMaybe<Filler_Procedure_Delivery_Tool_Bool_Exp>;
};

/** Ordering options when selecting data from "filler_procedure_delivery_tool". */
export type Filler_Procedure_Delivery_Tool_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: filler_procedure_delivery_tool */
export type Filler_Procedure_Delivery_Tool_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "filler_procedure_delivery_tool" */
export enum Filler_Procedure_Delivery_Tool_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "filler_procedure_delivery_tool" */
export type Filler_Procedure_Delivery_Tool_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "filler_procedure_delivery_tool" */
export type Filler_Procedure_Delivery_Tool_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Filler_Procedure_Delivery_Tool_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Filler_Procedure_Delivery_Tool_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "filler_procedure_delivery_tool" */
export enum Filler_Procedure_Delivery_Tool_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Filler_Procedure_Delivery_Tool_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Filler_Procedure_Delivery_Tool_Set_Input>;
  /** filter the rows which have to be updated */
  where: Filler_Procedure_Delivery_Tool_Bool_Exp;
};

/** columns and relationships of "filler_procedure_face_view" */
export type Filler_Procedure_Face_View = {
  __typename?: 'filler_procedure_face_view';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "filler_procedure_face_view" */
export type Filler_Procedure_Face_View_Aggregate = {
  __typename?: 'filler_procedure_face_view_aggregate';
  aggregate?: Maybe<Filler_Procedure_Face_View_Aggregate_Fields>;
  nodes: Array<Filler_Procedure_Face_View>;
};

/** aggregate fields of "filler_procedure_face_view" */
export type Filler_Procedure_Face_View_Aggregate_Fields = {
  __typename?: 'filler_procedure_face_view_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Filler_Procedure_Face_View_Max_Fields>;
  min?: Maybe<Filler_Procedure_Face_View_Min_Fields>;
};


/** aggregate fields of "filler_procedure_face_view" */
export type Filler_Procedure_Face_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Filler_Procedure_Face_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "filler_procedure_face_view". All fields are combined with a logical 'AND'. */
export type Filler_Procedure_Face_View_Bool_Exp = {
  _and?: InputMaybe<Array<Filler_Procedure_Face_View_Bool_Exp>>;
  _not?: InputMaybe<Filler_Procedure_Face_View_Bool_Exp>;
  _or?: InputMaybe<Array<Filler_Procedure_Face_View_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "filler_procedure_face_view" */
export enum Filler_Procedure_Face_View_Constraint {
  /** unique or primary key constraint on columns "value" */
  FillerProcedureFaceViewPkey = 'filler_procedure_face_view_pkey'
}

export enum Filler_Procedure_Face_View_Enum {
  /** Front-facing face view */
  Front = 'front',
  /** Left profile face view */
  Left = 'left',
  /** Right profile face view */
  Right = 'right'
}

/** Boolean expression to compare columns of type "filler_procedure_face_view_enum". All fields are combined with logical 'AND'. */
export type Filler_Procedure_Face_View_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Filler_Procedure_Face_View_Enum>;
  _in?: InputMaybe<Array<Filler_Procedure_Face_View_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Filler_Procedure_Face_View_Enum>;
  _nin?: InputMaybe<Array<Filler_Procedure_Face_View_Enum>>;
};

/** input type for inserting data into table "filler_procedure_face_view" */
export type Filler_Procedure_Face_View_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Filler_Procedure_Face_View_Max_Fields = {
  __typename?: 'filler_procedure_face_view_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Filler_Procedure_Face_View_Min_Fields = {
  __typename?: 'filler_procedure_face_view_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "filler_procedure_face_view" */
export type Filler_Procedure_Face_View_Mutation_Response = {
  __typename?: 'filler_procedure_face_view_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Filler_Procedure_Face_View>;
};

/** input type for inserting object relation for remote table "filler_procedure_face_view" */
export type Filler_Procedure_Face_View_Obj_Rel_Insert_Input = {
  data: Filler_Procedure_Face_View_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Filler_Procedure_Face_View_On_Conflict>;
};

/** on_conflict condition type for table "filler_procedure_face_view" */
export type Filler_Procedure_Face_View_On_Conflict = {
  constraint: Filler_Procedure_Face_View_Constraint;
  update_columns?: Array<Filler_Procedure_Face_View_Update_Column>;
  where?: InputMaybe<Filler_Procedure_Face_View_Bool_Exp>;
};

/** Ordering options when selecting data from "filler_procedure_face_view". */
export type Filler_Procedure_Face_View_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: filler_procedure_face_view */
export type Filler_Procedure_Face_View_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "filler_procedure_face_view" */
export enum Filler_Procedure_Face_View_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "filler_procedure_face_view" */
export type Filler_Procedure_Face_View_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "filler_procedure_face_view" */
export type Filler_Procedure_Face_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Filler_Procedure_Face_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Filler_Procedure_Face_View_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "filler_procedure_face_view" */
export enum Filler_Procedure_Face_View_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Filler_Procedure_Face_View_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Filler_Procedure_Face_View_Set_Input>;
  /** filter the rows which have to be updated */
  where: Filler_Procedure_Face_View_Bool_Exp;
};

/** columns and relationships of "filler_procedure_injection" */
export type Filler_Procedure_Injection = {
  __typename?: 'filler_procedure_injection';
  area: Scalars['String'];
  body_part_id?: Maybe<Scalars['uuid']>;
  body_part_identifier?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  delivery_tool: Filler_Procedure_Delivery_Tool_Enum;
  /** An object relationship */
  ehrEncounterByEhrEncounter: Ehr_Encounter;
  ehr_encounter: Scalars['uuid'];
  /** An object relationship */
  fillerProcedureDeliveryToolByDeliveryTool: Filler_Procedure_Delivery_Tool;
  /** An object relationship */
  fillerProcedureFaceViewByViewId?: Maybe<Filler_Procedure_Face_View>;
  /** An object relationship */
  fillerProcedureInjectionTypeByType: Filler_Procedure_Injection_Type;
  /** An object relationship */
  fillerProcedureProductInstanceByProductInstance: Filler_Procedure_Product_Instance;
  id: Scalars['uuid'];
  product_instance: Scalars['uuid'];
  provider: Scalars['uuid'];
  scan_3d?: Maybe<Scalars['uuid']>;
  space: Filler_Space_Enum;
  tip_x?: Maybe<Array<Scalars['numeric']>>;
  tip_y?: Maybe<Array<Scalars['numeric']>>;
  tip_z?: Maybe<Array<Scalars['numeric']>>;
  type: Filler_Procedure_Injection_Type_Enum;
  /** An object relationship */
  userByProvider: User;
  view_id?: Maybe<Filler_Procedure_Face_View_Enum>;
  volume_ml: Scalars['numeric'];
  x: Scalars['numeric'];
  y: Scalars['numeric'];
  z?: Maybe<Scalars['numeric']>;
  zone_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "filler_procedure_injection" */
export type Filler_Procedure_Injection_Aggregate = {
  __typename?: 'filler_procedure_injection_aggregate';
  aggregate?: Maybe<Filler_Procedure_Injection_Aggregate_Fields>;
  nodes: Array<Filler_Procedure_Injection>;
};

export type Filler_Procedure_Injection_Aggregate_Bool_Exp = {
  count?: InputMaybe<Filler_Procedure_Injection_Aggregate_Bool_Exp_Count>;
};

export type Filler_Procedure_Injection_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Filler_Procedure_Injection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Filler_Procedure_Injection_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "filler_procedure_injection" */
export type Filler_Procedure_Injection_Aggregate_Fields = {
  __typename?: 'filler_procedure_injection_aggregate_fields';
  avg?: Maybe<Filler_Procedure_Injection_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Filler_Procedure_Injection_Max_Fields>;
  min?: Maybe<Filler_Procedure_Injection_Min_Fields>;
  stddev?: Maybe<Filler_Procedure_Injection_Stddev_Fields>;
  stddev_pop?: Maybe<Filler_Procedure_Injection_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Filler_Procedure_Injection_Stddev_Samp_Fields>;
  sum?: Maybe<Filler_Procedure_Injection_Sum_Fields>;
  var_pop?: Maybe<Filler_Procedure_Injection_Var_Pop_Fields>;
  var_samp?: Maybe<Filler_Procedure_Injection_Var_Samp_Fields>;
  variance?: Maybe<Filler_Procedure_Injection_Variance_Fields>;
};


/** aggregate fields of "filler_procedure_injection" */
export type Filler_Procedure_Injection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Filler_Procedure_Injection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "filler_procedure_injection" */
export type Filler_Procedure_Injection_Aggregate_Order_By = {
  avg?: InputMaybe<Filler_Procedure_Injection_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Filler_Procedure_Injection_Max_Order_By>;
  min?: InputMaybe<Filler_Procedure_Injection_Min_Order_By>;
  stddev?: InputMaybe<Filler_Procedure_Injection_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Filler_Procedure_Injection_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Filler_Procedure_Injection_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Filler_Procedure_Injection_Sum_Order_By>;
  var_pop?: InputMaybe<Filler_Procedure_Injection_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Filler_Procedure_Injection_Var_Samp_Order_By>;
  variance?: InputMaybe<Filler_Procedure_Injection_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "filler_procedure_injection" */
export type Filler_Procedure_Injection_Arr_Rel_Insert_Input = {
  data: Array<Filler_Procedure_Injection_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Filler_Procedure_Injection_On_Conflict>;
};

/** aggregate avg on columns */
export type Filler_Procedure_Injection_Avg_Fields = {
  __typename?: 'filler_procedure_injection_avg_fields';
  volume_ml?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
  zone_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "filler_procedure_injection" */
export type Filler_Procedure_Injection_Avg_Order_By = {
  volume_ml?: InputMaybe<Order_By>;
  x?: InputMaybe<Order_By>;
  y?: InputMaybe<Order_By>;
  z?: InputMaybe<Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "filler_procedure_injection". All fields are combined with a logical 'AND'. */
export type Filler_Procedure_Injection_Bool_Exp = {
  _and?: InputMaybe<Array<Filler_Procedure_Injection_Bool_Exp>>;
  _not?: InputMaybe<Filler_Procedure_Injection_Bool_Exp>;
  _or?: InputMaybe<Array<Filler_Procedure_Injection_Bool_Exp>>;
  area?: InputMaybe<String_Comparison_Exp>;
  body_part_id?: InputMaybe<Uuid_Comparison_Exp>;
  body_part_identifier?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  delivery_tool?: InputMaybe<Filler_Procedure_Delivery_Tool_Enum_Comparison_Exp>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Bool_Exp>;
  ehr_encounter?: InputMaybe<Uuid_Comparison_Exp>;
  fillerProcedureDeliveryToolByDeliveryTool?: InputMaybe<Filler_Procedure_Delivery_Tool_Bool_Exp>;
  fillerProcedureFaceViewByViewId?: InputMaybe<Filler_Procedure_Face_View_Bool_Exp>;
  fillerProcedureInjectionTypeByType?: InputMaybe<Filler_Procedure_Injection_Type_Bool_Exp>;
  fillerProcedureProductInstanceByProductInstance?: InputMaybe<Filler_Procedure_Product_Instance_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  product_instance?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  scan_3d?: InputMaybe<Uuid_Comparison_Exp>;
  space?: InputMaybe<Filler_Space_Enum_Comparison_Exp>;
  tip_x?: InputMaybe<Numeric_Array_Comparison_Exp>;
  tip_y?: InputMaybe<Numeric_Array_Comparison_Exp>;
  tip_z?: InputMaybe<Numeric_Array_Comparison_Exp>;
  type?: InputMaybe<Filler_Procedure_Injection_Type_Enum_Comparison_Exp>;
  userByProvider?: InputMaybe<User_Bool_Exp>;
  view_id?: InputMaybe<Filler_Procedure_Face_View_Enum_Comparison_Exp>;
  volume_ml?: InputMaybe<Numeric_Comparison_Exp>;
  x?: InputMaybe<Numeric_Comparison_Exp>;
  y?: InputMaybe<Numeric_Comparison_Exp>;
  z?: InputMaybe<Numeric_Comparison_Exp>;
  zone_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "filler_procedure_injection" */
export enum Filler_Procedure_Injection_Constraint {
  /** unique or primary key constraint on columns "id" */
  FillerProcedureInjectionPkey = 'filler_procedure_injection_pkey'
}

/** input type for incrementing numeric columns in table "filler_procedure_injection" */
export type Filler_Procedure_Injection_Inc_Input = {
  volume_ml?: InputMaybe<Scalars['numeric']>;
  x?: InputMaybe<Scalars['numeric']>;
  y?: InputMaybe<Scalars['numeric']>;
  z?: InputMaybe<Scalars['numeric']>;
  zone_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "filler_procedure_injection" */
export type Filler_Procedure_Injection_Insert_Input = {
  area?: InputMaybe<Scalars['String']>;
  body_part_id?: InputMaybe<Scalars['uuid']>;
  body_part_identifier?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  delivery_tool?: InputMaybe<Filler_Procedure_Delivery_Tool_Enum>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Obj_Rel_Insert_Input>;
  ehr_encounter?: InputMaybe<Scalars['uuid']>;
  fillerProcedureDeliveryToolByDeliveryTool?: InputMaybe<Filler_Procedure_Delivery_Tool_Obj_Rel_Insert_Input>;
  fillerProcedureFaceViewByViewId?: InputMaybe<Filler_Procedure_Face_View_Obj_Rel_Insert_Input>;
  fillerProcedureInjectionTypeByType?: InputMaybe<Filler_Procedure_Injection_Type_Obj_Rel_Insert_Input>;
  fillerProcedureProductInstanceByProductInstance?: InputMaybe<Filler_Procedure_Product_Instance_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  product_instance?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  scan_3d?: InputMaybe<Scalars['uuid']>;
  space?: InputMaybe<Filler_Space_Enum>;
  tip_x?: InputMaybe<Array<Scalars['numeric']>>;
  tip_y?: InputMaybe<Array<Scalars['numeric']>>;
  tip_z?: InputMaybe<Array<Scalars['numeric']>>;
  type?: InputMaybe<Filler_Procedure_Injection_Type_Enum>;
  userByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
  view_id?: InputMaybe<Filler_Procedure_Face_View_Enum>;
  volume_ml?: InputMaybe<Scalars['numeric']>;
  x?: InputMaybe<Scalars['numeric']>;
  y?: InputMaybe<Scalars['numeric']>;
  z?: InputMaybe<Scalars['numeric']>;
  zone_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Filler_Procedure_Injection_Max_Fields = {
  __typename?: 'filler_procedure_injection_max_fields';
  area?: Maybe<Scalars['String']>;
  body_part_id?: Maybe<Scalars['uuid']>;
  body_part_identifier?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  ehr_encounter?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  product_instance?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  scan_3d?: Maybe<Scalars['uuid']>;
  tip_x?: Maybe<Array<Scalars['numeric']>>;
  tip_y?: Maybe<Array<Scalars['numeric']>>;
  tip_z?: Maybe<Array<Scalars['numeric']>>;
  volume_ml?: Maybe<Scalars['numeric']>;
  x?: Maybe<Scalars['numeric']>;
  y?: Maybe<Scalars['numeric']>;
  z?: Maybe<Scalars['numeric']>;
  zone_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "filler_procedure_injection" */
export type Filler_Procedure_Injection_Max_Order_By = {
  area?: InputMaybe<Order_By>;
  body_part_id?: InputMaybe<Order_By>;
  body_part_identifier?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ehr_encounter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_instance?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  scan_3d?: InputMaybe<Order_By>;
  tip_x?: InputMaybe<Order_By>;
  tip_y?: InputMaybe<Order_By>;
  tip_z?: InputMaybe<Order_By>;
  volume_ml?: InputMaybe<Order_By>;
  x?: InputMaybe<Order_By>;
  y?: InputMaybe<Order_By>;
  z?: InputMaybe<Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Filler_Procedure_Injection_Min_Fields = {
  __typename?: 'filler_procedure_injection_min_fields';
  area?: Maybe<Scalars['String']>;
  body_part_id?: Maybe<Scalars['uuid']>;
  body_part_identifier?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  ehr_encounter?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  product_instance?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  scan_3d?: Maybe<Scalars['uuid']>;
  tip_x?: Maybe<Array<Scalars['numeric']>>;
  tip_y?: Maybe<Array<Scalars['numeric']>>;
  tip_z?: Maybe<Array<Scalars['numeric']>>;
  volume_ml?: Maybe<Scalars['numeric']>;
  x?: Maybe<Scalars['numeric']>;
  y?: Maybe<Scalars['numeric']>;
  z?: Maybe<Scalars['numeric']>;
  zone_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "filler_procedure_injection" */
export type Filler_Procedure_Injection_Min_Order_By = {
  area?: InputMaybe<Order_By>;
  body_part_id?: InputMaybe<Order_By>;
  body_part_identifier?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ehr_encounter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_instance?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  scan_3d?: InputMaybe<Order_By>;
  tip_x?: InputMaybe<Order_By>;
  tip_y?: InputMaybe<Order_By>;
  tip_z?: InputMaybe<Order_By>;
  volume_ml?: InputMaybe<Order_By>;
  x?: InputMaybe<Order_By>;
  y?: InputMaybe<Order_By>;
  z?: InputMaybe<Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "filler_procedure_injection" */
export type Filler_Procedure_Injection_Mutation_Response = {
  __typename?: 'filler_procedure_injection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Filler_Procedure_Injection>;
};

/** on_conflict condition type for table "filler_procedure_injection" */
export type Filler_Procedure_Injection_On_Conflict = {
  constraint: Filler_Procedure_Injection_Constraint;
  update_columns?: Array<Filler_Procedure_Injection_Update_Column>;
  where?: InputMaybe<Filler_Procedure_Injection_Bool_Exp>;
};

/** Ordering options when selecting data from "filler_procedure_injection". */
export type Filler_Procedure_Injection_Order_By = {
  area?: InputMaybe<Order_By>;
  body_part_id?: InputMaybe<Order_By>;
  body_part_identifier?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  delivery_tool?: InputMaybe<Order_By>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Order_By>;
  ehr_encounter?: InputMaybe<Order_By>;
  fillerProcedureDeliveryToolByDeliveryTool?: InputMaybe<Filler_Procedure_Delivery_Tool_Order_By>;
  fillerProcedureFaceViewByViewId?: InputMaybe<Filler_Procedure_Face_View_Order_By>;
  fillerProcedureInjectionTypeByType?: InputMaybe<Filler_Procedure_Injection_Type_Order_By>;
  fillerProcedureProductInstanceByProductInstance?: InputMaybe<Filler_Procedure_Product_Instance_Order_By>;
  id?: InputMaybe<Order_By>;
  product_instance?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  scan_3d?: InputMaybe<Order_By>;
  space?: InputMaybe<Order_By>;
  tip_x?: InputMaybe<Order_By>;
  tip_y?: InputMaybe<Order_By>;
  tip_z?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  userByProvider?: InputMaybe<User_Order_By>;
  view_id?: InputMaybe<Order_By>;
  volume_ml?: InputMaybe<Order_By>;
  x?: InputMaybe<Order_By>;
  y?: InputMaybe<Order_By>;
  z?: InputMaybe<Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: filler_procedure_injection */
export type Filler_Procedure_Injection_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "filler_procedure_injection" */
export enum Filler_Procedure_Injection_Select_Column {
  /** column name */
  Area = 'area',
  /** column name */
  BodyPartId = 'body_part_id',
  /** column name */
  BodyPartIdentifier = 'body_part_identifier',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeliveryTool = 'delivery_tool',
  /** column name */
  EhrEncounter = 'ehr_encounter',
  /** column name */
  Id = 'id',
  /** column name */
  ProductInstance = 'product_instance',
  /** column name */
  Provider = 'provider',
  /** column name */
  Scan_3d = 'scan_3d',
  /** column name */
  Space = 'space',
  /** column name */
  TipX = 'tip_x',
  /** column name */
  TipY = 'tip_y',
  /** column name */
  TipZ = 'tip_z',
  /** column name */
  Type = 'type',
  /** column name */
  ViewId = 'view_id',
  /** column name */
  VolumeMl = 'volume_ml',
  /** column name */
  X = 'x',
  /** column name */
  Y = 'y',
  /** column name */
  Z = 'z',
  /** column name */
  ZoneId = 'zone_id'
}

/** input type for updating data in table "filler_procedure_injection" */
export type Filler_Procedure_Injection_Set_Input = {
  area?: InputMaybe<Scalars['String']>;
  body_part_id?: InputMaybe<Scalars['uuid']>;
  body_part_identifier?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  delivery_tool?: InputMaybe<Filler_Procedure_Delivery_Tool_Enum>;
  ehr_encounter?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  product_instance?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  scan_3d?: InputMaybe<Scalars['uuid']>;
  space?: InputMaybe<Filler_Space_Enum>;
  tip_x?: InputMaybe<Array<Scalars['numeric']>>;
  tip_y?: InputMaybe<Array<Scalars['numeric']>>;
  tip_z?: InputMaybe<Array<Scalars['numeric']>>;
  type?: InputMaybe<Filler_Procedure_Injection_Type_Enum>;
  view_id?: InputMaybe<Filler_Procedure_Face_View_Enum>;
  volume_ml?: InputMaybe<Scalars['numeric']>;
  x?: InputMaybe<Scalars['numeric']>;
  y?: InputMaybe<Scalars['numeric']>;
  z?: InputMaybe<Scalars['numeric']>;
  zone_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Filler_Procedure_Injection_Stddev_Fields = {
  __typename?: 'filler_procedure_injection_stddev_fields';
  volume_ml?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
  zone_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "filler_procedure_injection" */
export type Filler_Procedure_Injection_Stddev_Order_By = {
  volume_ml?: InputMaybe<Order_By>;
  x?: InputMaybe<Order_By>;
  y?: InputMaybe<Order_By>;
  z?: InputMaybe<Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Filler_Procedure_Injection_Stddev_Pop_Fields = {
  __typename?: 'filler_procedure_injection_stddev_pop_fields';
  volume_ml?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
  zone_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "filler_procedure_injection" */
export type Filler_Procedure_Injection_Stddev_Pop_Order_By = {
  volume_ml?: InputMaybe<Order_By>;
  x?: InputMaybe<Order_By>;
  y?: InputMaybe<Order_By>;
  z?: InputMaybe<Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Filler_Procedure_Injection_Stddev_Samp_Fields = {
  __typename?: 'filler_procedure_injection_stddev_samp_fields';
  volume_ml?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
  zone_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "filler_procedure_injection" */
export type Filler_Procedure_Injection_Stddev_Samp_Order_By = {
  volume_ml?: InputMaybe<Order_By>;
  x?: InputMaybe<Order_By>;
  y?: InputMaybe<Order_By>;
  z?: InputMaybe<Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "filler_procedure_injection" */
export type Filler_Procedure_Injection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Filler_Procedure_Injection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Filler_Procedure_Injection_Stream_Cursor_Value_Input = {
  area?: InputMaybe<Scalars['String']>;
  body_part_id?: InputMaybe<Scalars['uuid']>;
  body_part_identifier?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  delivery_tool?: InputMaybe<Filler_Procedure_Delivery_Tool_Enum>;
  ehr_encounter?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  product_instance?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  scan_3d?: InputMaybe<Scalars['uuid']>;
  space?: InputMaybe<Filler_Space_Enum>;
  tip_x?: InputMaybe<Array<Scalars['numeric']>>;
  tip_y?: InputMaybe<Array<Scalars['numeric']>>;
  tip_z?: InputMaybe<Array<Scalars['numeric']>>;
  type?: InputMaybe<Filler_Procedure_Injection_Type_Enum>;
  view_id?: InputMaybe<Filler_Procedure_Face_View_Enum>;
  volume_ml?: InputMaybe<Scalars['numeric']>;
  x?: InputMaybe<Scalars['numeric']>;
  y?: InputMaybe<Scalars['numeric']>;
  z?: InputMaybe<Scalars['numeric']>;
  zone_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Filler_Procedure_Injection_Sum_Fields = {
  __typename?: 'filler_procedure_injection_sum_fields';
  volume_ml?: Maybe<Scalars['numeric']>;
  x?: Maybe<Scalars['numeric']>;
  y?: Maybe<Scalars['numeric']>;
  z?: Maybe<Scalars['numeric']>;
  zone_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "filler_procedure_injection" */
export type Filler_Procedure_Injection_Sum_Order_By = {
  volume_ml?: InputMaybe<Order_By>;
  x?: InputMaybe<Order_By>;
  y?: InputMaybe<Order_By>;
  z?: InputMaybe<Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "filler_procedure_injection_type" */
export type Filler_Procedure_Injection_Type = {
  __typename?: 'filler_procedure_injection_type';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "filler_procedure_injection_type" */
export type Filler_Procedure_Injection_Type_Aggregate = {
  __typename?: 'filler_procedure_injection_type_aggregate';
  aggregate?: Maybe<Filler_Procedure_Injection_Type_Aggregate_Fields>;
  nodes: Array<Filler_Procedure_Injection_Type>;
};

/** aggregate fields of "filler_procedure_injection_type" */
export type Filler_Procedure_Injection_Type_Aggregate_Fields = {
  __typename?: 'filler_procedure_injection_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Filler_Procedure_Injection_Type_Max_Fields>;
  min?: Maybe<Filler_Procedure_Injection_Type_Min_Fields>;
};


/** aggregate fields of "filler_procedure_injection_type" */
export type Filler_Procedure_Injection_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Filler_Procedure_Injection_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "filler_procedure_injection_type". All fields are combined with a logical 'AND'. */
export type Filler_Procedure_Injection_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Filler_Procedure_Injection_Type_Bool_Exp>>;
  _not?: InputMaybe<Filler_Procedure_Injection_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Filler_Procedure_Injection_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "filler_procedure_injection_type" */
export enum Filler_Procedure_Injection_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  FillerProcedureInjectionTypePkey = 'filler_procedure_injection_type_pkey'
}

export enum Filler_Procedure_Injection_Type_Enum {
  /** Single-point bolus injection */
  Bolus = 'BOLUS',
  /** Cross-hatch covering a polygon zone */
  CrossHatch = 'CROSS_HATCH',
  /** Fan with 3 spokes */
  Fan = 'FAN',
  /** Linear thread injection with a tip endpoint */
  LinearThread = 'LINEAR_THREAD'
}

/** Boolean expression to compare columns of type "filler_procedure_injection_type_enum". All fields are combined with logical 'AND'. */
export type Filler_Procedure_Injection_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Filler_Procedure_Injection_Type_Enum>;
  _in?: InputMaybe<Array<Filler_Procedure_Injection_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Filler_Procedure_Injection_Type_Enum>;
  _nin?: InputMaybe<Array<Filler_Procedure_Injection_Type_Enum>>;
};

/** input type for inserting data into table "filler_procedure_injection_type" */
export type Filler_Procedure_Injection_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Filler_Procedure_Injection_Type_Max_Fields = {
  __typename?: 'filler_procedure_injection_type_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Filler_Procedure_Injection_Type_Min_Fields = {
  __typename?: 'filler_procedure_injection_type_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "filler_procedure_injection_type" */
export type Filler_Procedure_Injection_Type_Mutation_Response = {
  __typename?: 'filler_procedure_injection_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Filler_Procedure_Injection_Type>;
};

/** input type for inserting object relation for remote table "filler_procedure_injection_type" */
export type Filler_Procedure_Injection_Type_Obj_Rel_Insert_Input = {
  data: Filler_Procedure_Injection_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Filler_Procedure_Injection_Type_On_Conflict>;
};

/** on_conflict condition type for table "filler_procedure_injection_type" */
export type Filler_Procedure_Injection_Type_On_Conflict = {
  constraint: Filler_Procedure_Injection_Type_Constraint;
  update_columns?: Array<Filler_Procedure_Injection_Type_Update_Column>;
  where?: InputMaybe<Filler_Procedure_Injection_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "filler_procedure_injection_type". */
export type Filler_Procedure_Injection_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: filler_procedure_injection_type */
export type Filler_Procedure_Injection_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "filler_procedure_injection_type" */
export enum Filler_Procedure_Injection_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "filler_procedure_injection_type" */
export type Filler_Procedure_Injection_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "filler_procedure_injection_type" */
export type Filler_Procedure_Injection_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Filler_Procedure_Injection_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Filler_Procedure_Injection_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "filler_procedure_injection_type" */
export enum Filler_Procedure_Injection_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Filler_Procedure_Injection_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Filler_Procedure_Injection_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Filler_Procedure_Injection_Type_Bool_Exp;
};

/** update columns of table "filler_procedure_injection" */
export enum Filler_Procedure_Injection_Update_Column {
  /** column name */
  Area = 'area',
  /** column name */
  BodyPartId = 'body_part_id',
  /** column name */
  BodyPartIdentifier = 'body_part_identifier',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeliveryTool = 'delivery_tool',
  /** column name */
  EhrEncounter = 'ehr_encounter',
  /** column name */
  Id = 'id',
  /** column name */
  ProductInstance = 'product_instance',
  /** column name */
  Provider = 'provider',
  /** column name */
  Scan_3d = 'scan_3d',
  /** column name */
  Space = 'space',
  /** column name */
  TipX = 'tip_x',
  /** column name */
  TipY = 'tip_y',
  /** column name */
  TipZ = 'tip_z',
  /** column name */
  Type = 'type',
  /** column name */
  ViewId = 'view_id',
  /** column name */
  VolumeMl = 'volume_ml',
  /** column name */
  X = 'x',
  /** column name */
  Y = 'y',
  /** column name */
  Z = 'z',
  /** column name */
  ZoneId = 'zone_id'
}

export type Filler_Procedure_Injection_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Filler_Procedure_Injection_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Filler_Procedure_Injection_Set_Input>;
  /** filter the rows which have to be updated */
  where: Filler_Procedure_Injection_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Filler_Procedure_Injection_Var_Pop_Fields = {
  __typename?: 'filler_procedure_injection_var_pop_fields';
  volume_ml?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
  zone_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "filler_procedure_injection" */
export type Filler_Procedure_Injection_Var_Pop_Order_By = {
  volume_ml?: InputMaybe<Order_By>;
  x?: InputMaybe<Order_By>;
  y?: InputMaybe<Order_By>;
  z?: InputMaybe<Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Filler_Procedure_Injection_Var_Samp_Fields = {
  __typename?: 'filler_procedure_injection_var_samp_fields';
  volume_ml?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
  zone_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "filler_procedure_injection" */
export type Filler_Procedure_Injection_Var_Samp_Order_By = {
  volume_ml?: InputMaybe<Order_By>;
  x?: InputMaybe<Order_By>;
  y?: InputMaybe<Order_By>;
  z?: InputMaybe<Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Filler_Procedure_Injection_Variance_Fields = {
  __typename?: 'filler_procedure_injection_variance_fields';
  volume_ml?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
  zone_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "filler_procedure_injection" */
export type Filler_Procedure_Injection_Variance_Order_By = {
  volume_ml?: InputMaybe<Order_By>;
  x?: InputMaybe<Order_By>;
  y?: InputMaybe<Order_By>;
  z?: InputMaybe<Order_By>;
  zone_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance = {
  __typename?: 'filler_procedure_product_instance';
  barcode?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  ehrEncounterByEhrEncounter: Ehr_Encounter;
  /** An object relationship */
  ehrProductByEhrProduct: Ehr_Product;
  ehr_encounter: Scalars['uuid'];
  ehr_fda_product?: Maybe<Scalars['uuid']>;
  ehr_product: Scalars['uuid'];
  expiration?: Maybe<Scalars['date']>;
  /** An array relationship */
  fillerProcedureInjections: Array<Filler_Procedure_Injection>;
  /** An aggregate relationship */
  fillerProcedureInjections_aggregate: Filler_Procedure_Injection_Aggregate;
  /** An array relationship */
  fillerProcedureProductInstancePhotos: Array<Filler_Procedure_Product_Instance_Photo>;
  /** An aggregate relationship */
  fillerProcedureProductInstancePhotos_aggregate: Filler_Procedure_Product_Instance_Photo_Aggregate;
  id: Scalars['uuid'];
  initial_volume_ml: Scalars['numeric'];
  lot_number?: Maybe<Scalars['String']>;
  provider: Scalars['uuid'];
  serial_number?: Maybe<Scalars['String']>;
  sort_order: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  userByProvider: User;
};


/** columns and relationships of "filler_procedure_product_instance" */
export type Filler_Procedure_Product_InstanceFillerProcedureInjectionsArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Injection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Injection_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Injection_Bool_Exp>;
};


/** columns and relationships of "filler_procedure_product_instance" */
export type Filler_Procedure_Product_InstanceFillerProcedureInjections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Injection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Injection_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Injection_Bool_Exp>;
};


/** columns and relationships of "filler_procedure_product_instance" */
export type Filler_Procedure_Product_InstanceFillerProcedureProductInstancePhotosArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Product_Instance_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Product_Instance_Photo_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Bool_Exp>;
};


/** columns and relationships of "filler_procedure_product_instance" */
export type Filler_Procedure_Product_InstanceFillerProcedureProductInstancePhotos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Product_Instance_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Product_Instance_Photo_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Bool_Exp>;
};

/** aggregated selection of "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Aggregate = {
  __typename?: 'filler_procedure_product_instance_aggregate';
  aggregate?: Maybe<Filler_Procedure_Product_Instance_Aggregate_Fields>;
  nodes: Array<Filler_Procedure_Product_Instance>;
};

export type Filler_Procedure_Product_Instance_Aggregate_Bool_Exp = {
  count?: InputMaybe<Filler_Procedure_Product_Instance_Aggregate_Bool_Exp_Count>;
};

export type Filler_Procedure_Product_Instance_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Filler_Procedure_Product_Instance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Filler_Procedure_Product_Instance_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Aggregate_Fields = {
  __typename?: 'filler_procedure_product_instance_aggregate_fields';
  avg?: Maybe<Filler_Procedure_Product_Instance_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Filler_Procedure_Product_Instance_Max_Fields>;
  min?: Maybe<Filler_Procedure_Product_Instance_Min_Fields>;
  stddev?: Maybe<Filler_Procedure_Product_Instance_Stddev_Fields>;
  stddev_pop?: Maybe<Filler_Procedure_Product_Instance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Filler_Procedure_Product_Instance_Stddev_Samp_Fields>;
  sum?: Maybe<Filler_Procedure_Product_Instance_Sum_Fields>;
  var_pop?: Maybe<Filler_Procedure_Product_Instance_Var_Pop_Fields>;
  var_samp?: Maybe<Filler_Procedure_Product_Instance_Var_Samp_Fields>;
  variance?: Maybe<Filler_Procedure_Product_Instance_Variance_Fields>;
};


/** aggregate fields of "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Filler_Procedure_Product_Instance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Aggregate_Order_By = {
  avg?: InputMaybe<Filler_Procedure_Product_Instance_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Filler_Procedure_Product_Instance_Max_Order_By>;
  min?: InputMaybe<Filler_Procedure_Product_Instance_Min_Order_By>;
  stddev?: InputMaybe<Filler_Procedure_Product_Instance_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Filler_Procedure_Product_Instance_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Filler_Procedure_Product_Instance_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Filler_Procedure_Product_Instance_Sum_Order_By>;
  var_pop?: InputMaybe<Filler_Procedure_Product_Instance_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Filler_Procedure_Product_Instance_Var_Samp_Order_By>;
  variance?: InputMaybe<Filler_Procedure_Product_Instance_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Arr_Rel_Insert_Input = {
  data: Array<Filler_Procedure_Product_Instance_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Filler_Procedure_Product_Instance_On_Conflict>;
};

/** aggregate avg on columns */
export type Filler_Procedure_Product_Instance_Avg_Fields = {
  __typename?: 'filler_procedure_product_instance_avg_fields';
  initial_volume_ml?: Maybe<Scalars['Float']>;
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Avg_Order_By = {
  initial_volume_ml?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "filler_procedure_product_instance". All fields are combined with a logical 'AND'. */
export type Filler_Procedure_Product_Instance_Bool_Exp = {
  _and?: InputMaybe<Array<Filler_Procedure_Product_Instance_Bool_Exp>>;
  _not?: InputMaybe<Filler_Procedure_Product_Instance_Bool_Exp>;
  _or?: InputMaybe<Array<Filler_Procedure_Product_Instance_Bool_Exp>>;
  barcode?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Bool_Exp>;
  ehrProductByEhrProduct?: InputMaybe<Ehr_Product_Bool_Exp>;
  ehr_encounter?: InputMaybe<Uuid_Comparison_Exp>;
  ehr_fda_product?: InputMaybe<Uuid_Comparison_Exp>;
  ehr_product?: InputMaybe<Uuid_Comparison_Exp>;
  expiration?: InputMaybe<Date_Comparison_Exp>;
  fillerProcedureInjections?: InputMaybe<Filler_Procedure_Injection_Bool_Exp>;
  fillerProcedureInjections_aggregate?: InputMaybe<Filler_Procedure_Injection_Aggregate_Bool_Exp>;
  fillerProcedureProductInstancePhotos?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Bool_Exp>;
  fillerProcedureProductInstancePhotos_aggregate?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  initial_volume_ml?: InputMaybe<Numeric_Comparison_Exp>;
  lot_number?: InputMaybe<String_Comparison_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  serial_number?: InputMaybe<String_Comparison_Exp>;
  sort_order?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  userByProvider?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "filler_procedure_product_instance" */
export enum Filler_Procedure_Product_Instance_Constraint {
  /** unique or primary key constraint on columns "id" */
  FillerProcedureProductInstancePkey = 'filler_procedure_product_instance_pkey'
}

/** input type for incrementing numeric columns in table "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Inc_Input = {
  initial_volume_ml?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Insert_Input = {
  barcode?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Obj_Rel_Insert_Input>;
  ehrProductByEhrProduct?: InputMaybe<Ehr_Product_Obj_Rel_Insert_Input>;
  ehr_encounter?: InputMaybe<Scalars['uuid']>;
  ehr_fda_product?: InputMaybe<Scalars['uuid']>;
  ehr_product?: InputMaybe<Scalars['uuid']>;
  expiration?: InputMaybe<Scalars['date']>;
  fillerProcedureInjections?: InputMaybe<Filler_Procedure_Injection_Arr_Rel_Insert_Input>;
  fillerProcedureProductInstancePhotos?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  initial_volume_ml?: InputMaybe<Scalars['numeric']>;
  lot_number?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['uuid']>;
  serial_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Filler_Procedure_Product_Instance_Max_Fields = {
  __typename?: 'filler_procedure_product_instance_max_fields';
  barcode?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  ehr_encounter?: Maybe<Scalars['uuid']>;
  ehr_fda_product?: Maybe<Scalars['uuid']>;
  ehr_product?: Maybe<Scalars['uuid']>;
  expiration?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  initial_volume_ml?: Maybe<Scalars['numeric']>;
  lot_number?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['uuid']>;
  serial_number?: Maybe<Scalars['String']>;
  sort_order?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Max_Order_By = {
  barcode?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ehr_encounter?: InputMaybe<Order_By>;
  ehr_fda_product?: InputMaybe<Order_By>;
  ehr_product?: InputMaybe<Order_By>;
  expiration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_volume_ml?: InputMaybe<Order_By>;
  lot_number?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  serial_number?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Filler_Procedure_Product_Instance_Min_Fields = {
  __typename?: 'filler_procedure_product_instance_min_fields';
  barcode?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  ehr_encounter?: Maybe<Scalars['uuid']>;
  ehr_fda_product?: Maybe<Scalars['uuid']>;
  ehr_product?: Maybe<Scalars['uuid']>;
  expiration?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  initial_volume_ml?: Maybe<Scalars['numeric']>;
  lot_number?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['uuid']>;
  serial_number?: Maybe<Scalars['String']>;
  sort_order?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Min_Order_By = {
  barcode?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ehr_encounter?: InputMaybe<Order_By>;
  ehr_fda_product?: InputMaybe<Order_By>;
  ehr_product?: InputMaybe<Order_By>;
  expiration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_volume_ml?: InputMaybe<Order_By>;
  lot_number?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  serial_number?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Mutation_Response = {
  __typename?: 'filler_procedure_product_instance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Filler_Procedure_Product_Instance>;
};

/** input type for inserting object relation for remote table "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Obj_Rel_Insert_Input = {
  data: Filler_Procedure_Product_Instance_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Filler_Procedure_Product_Instance_On_Conflict>;
};

/** on_conflict condition type for table "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_On_Conflict = {
  constraint: Filler_Procedure_Product_Instance_Constraint;
  update_columns?: Array<Filler_Procedure_Product_Instance_Update_Column>;
  where?: InputMaybe<Filler_Procedure_Product_Instance_Bool_Exp>;
};

/** Ordering options when selecting data from "filler_procedure_product_instance". */
export type Filler_Procedure_Product_Instance_Order_By = {
  barcode?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Order_By>;
  ehrProductByEhrProduct?: InputMaybe<Ehr_Product_Order_By>;
  ehr_encounter?: InputMaybe<Order_By>;
  ehr_fda_product?: InputMaybe<Order_By>;
  ehr_product?: InputMaybe<Order_By>;
  expiration?: InputMaybe<Order_By>;
  fillerProcedureInjections_aggregate?: InputMaybe<Filler_Procedure_Injection_Aggregate_Order_By>;
  fillerProcedureProductInstancePhotos_aggregate?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  initial_volume_ml?: InputMaybe<Order_By>;
  lot_number?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  serial_number?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userByProvider?: InputMaybe<User_Order_By>;
};

/** columns and relationships of "filler_procedure_product_instance_photo" */
export type Filler_Procedure_Product_Instance_Photo = {
  __typename?: 'filler_procedure_product_instance_photo';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  fillerProcedureProductInstanceByFillerProcedureProductInstance: Filler_Procedure_Product_Instance;
  filler_procedure_product_instance: Scalars['uuid'];
  id: Scalars['uuid'];
  photo_s3_key: Scalars['String'];
  provider: Scalars['uuid'];
  /** An object relationship */
  userByProvider: User;
};

/** aggregated selection of "filler_procedure_product_instance_photo" */
export type Filler_Procedure_Product_Instance_Photo_Aggregate = {
  __typename?: 'filler_procedure_product_instance_photo_aggregate';
  aggregate?: Maybe<Filler_Procedure_Product_Instance_Photo_Aggregate_Fields>;
  nodes: Array<Filler_Procedure_Product_Instance_Photo>;
};

export type Filler_Procedure_Product_Instance_Photo_Aggregate_Bool_Exp = {
  count?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Aggregate_Bool_Exp_Count>;
};

export type Filler_Procedure_Product_Instance_Photo_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Filler_Procedure_Product_Instance_Photo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "filler_procedure_product_instance_photo" */
export type Filler_Procedure_Product_Instance_Photo_Aggregate_Fields = {
  __typename?: 'filler_procedure_product_instance_photo_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Filler_Procedure_Product_Instance_Photo_Max_Fields>;
  min?: Maybe<Filler_Procedure_Product_Instance_Photo_Min_Fields>;
};


/** aggregate fields of "filler_procedure_product_instance_photo" */
export type Filler_Procedure_Product_Instance_Photo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Filler_Procedure_Product_Instance_Photo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "filler_procedure_product_instance_photo" */
export type Filler_Procedure_Product_Instance_Photo_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Max_Order_By>;
  min?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Min_Order_By>;
};

/** input type for inserting array relation for remote table "filler_procedure_product_instance_photo" */
export type Filler_Procedure_Product_Instance_Photo_Arr_Rel_Insert_Input = {
  data: Array<Filler_Procedure_Product_Instance_Photo_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Filler_Procedure_Product_Instance_Photo_On_Conflict>;
};

/** Boolean expression to filter rows from the table "filler_procedure_product_instance_photo". All fields are combined with a logical 'AND'. */
export type Filler_Procedure_Product_Instance_Photo_Bool_Exp = {
  _and?: InputMaybe<Array<Filler_Procedure_Product_Instance_Photo_Bool_Exp>>;
  _not?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Bool_Exp>;
  _or?: InputMaybe<Array<Filler_Procedure_Product_Instance_Photo_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fillerProcedureProductInstanceByFillerProcedureProductInstance?: InputMaybe<Filler_Procedure_Product_Instance_Bool_Exp>;
  filler_procedure_product_instance?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  photo_s3_key?: InputMaybe<String_Comparison_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  userByProvider?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "filler_procedure_product_instance_photo" */
export enum Filler_Procedure_Product_Instance_Photo_Constraint {
  /** unique or primary key constraint on columns "id" */
  FillerProcedureProductInstancePhotoPkey = 'filler_procedure_product_instance_photo_pkey'
}

/** input type for inserting data into table "filler_procedure_product_instance_photo" */
export type Filler_Procedure_Product_Instance_Photo_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  fillerProcedureProductInstanceByFillerProcedureProductInstance?: InputMaybe<Filler_Procedure_Product_Instance_Obj_Rel_Insert_Input>;
  filler_procedure_product_instance?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  photo_s3_key?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['uuid']>;
  userByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Filler_Procedure_Product_Instance_Photo_Max_Fields = {
  __typename?: 'filler_procedure_product_instance_photo_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  filler_procedure_product_instance?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  photo_s3_key?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "filler_procedure_product_instance_photo" */
export type Filler_Procedure_Product_Instance_Photo_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  filler_procedure_product_instance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_s3_key?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Filler_Procedure_Product_Instance_Photo_Min_Fields = {
  __typename?: 'filler_procedure_product_instance_photo_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  filler_procedure_product_instance?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  photo_s3_key?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "filler_procedure_product_instance_photo" */
export type Filler_Procedure_Product_Instance_Photo_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  filler_procedure_product_instance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_s3_key?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "filler_procedure_product_instance_photo" */
export type Filler_Procedure_Product_Instance_Photo_Mutation_Response = {
  __typename?: 'filler_procedure_product_instance_photo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Filler_Procedure_Product_Instance_Photo>;
};

/** on_conflict condition type for table "filler_procedure_product_instance_photo" */
export type Filler_Procedure_Product_Instance_Photo_On_Conflict = {
  constraint: Filler_Procedure_Product_Instance_Photo_Constraint;
  update_columns?: Array<Filler_Procedure_Product_Instance_Photo_Update_Column>;
  where?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Bool_Exp>;
};

/** Ordering options when selecting data from "filler_procedure_product_instance_photo". */
export type Filler_Procedure_Product_Instance_Photo_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  fillerProcedureProductInstanceByFillerProcedureProductInstance?: InputMaybe<Filler_Procedure_Product_Instance_Order_By>;
  filler_procedure_product_instance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_s3_key?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  userByProvider?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: filler_procedure_product_instance_photo */
export type Filler_Procedure_Product_Instance_Photo_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "filler_procedure_product_instance_photo" */
export enum Filler_Procedure_Product_Instance_Photo_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FillerProcedureProductInstance = 'filler_procedure_product_instance',
  /** column name */
  Id = 'id',
  /** column name */
  PhotoS3Key = 'photo_s3_key',
  /** column name */
  Provider = 'provider'
}

/** input type for updating data in table "filler_procedure_product_instance_photo" */
export type Filler_Procedure_Product_Instance_Photo_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  filler_procedure_product_instance?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  photo_s3_key?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "filler_procedure_product_instance_photo" */
export type Filler_Procedure_Product_Instance_Photo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Filler_Procedure_Product_Instance_Photo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Filler_Procedure_Product_Instance_Photo_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  filler_procedure_product_instance?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  photo_s3_key?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "filler_procedure_product_instance_photo" */
export enum Filler_Procedure_Product_Instance_Photo_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FillerProcedureProductInstance = 'filler_procedure_product_instance',
  /** column name */
  Id = 'id',
  /** column name */
  PhotoS3Key = 'photo_s3_key',
  /** column name */
  Provider = 'provider'
}

export type Filler_Procedure_Product_Instance_Photo_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Set_Input>;
  /** filter the rows which have to be updated */
  where: Filler_Procedure_Product_Instance_Photo_Bool_Exp;
};

/** primary key columns input for table: filler_procedure_product_instance */
export type Filler_Procedure_Product_Instance_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "filler_procedure_product_instance" */
export enum Filler_Procedure_Product_Instance_Select_Column {
  /** column name */
  Barcode = 'barcode',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EhrEncounter = 'ehr_encounter',
  /** column name */
  EhrFdaProduct = 'ehr_fda_product',
  /** column name */
  EhrProduct = 'ehr_product',
  /** column name */
  Expiration = 'expiration',
  /** column name */
  Id = 'id',
  /** column name */
  InitialVolumeMl = 'initial_volume_ml',
  /** column name */
  LotNumber = 'lot_number',
  /** column name */
  Provider = 'provider',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Set_Input = {
  barcode?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  ehr_encounter?: InputMaybe<Scalars['uuid']>;
  ehr_fda_product?: InputMaybe<Scalars['uuid']>;
  ehr_product?: InputMaybe<Scalars['uuid']>;
  expiration?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  initial_volume_ml?: InputMaybe<Scalars['numeric']>;
  lot_number?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['uuid']>;
  serial_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Filler_Procedure_Product_Instance_Stddev_Fields = {
  __typename?: 'filler_procedure_product_instance_stddev_fields';
  initial_volume_ml?: Maybe<Scalars['Float']>;
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Stddev_Order_By = {
  initial_volume_ml?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Filler_Procedure_Product_Instance_Stddev_Pop_Fields = {
  __typename?: 'filler_procedure_product_instance_stddev_pop_fields';
  initial_volume_ml?: Maybe<Scalars['Float']>;
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Stddev_Pop_Order_By = {
  initial_volume_ml?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Filler_Procedure_Product_Instance_Stddev_Samp_Fields = {
  __typename?: 'filler_procedure_product_instance_stddev_samp_fields';
  initial_volume_ml?: Maybe<Scalars['Float']>;
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Stddev_Samp_Order_By = {
  initial_volume_ml?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Filler_Procedure_Product_Instance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Filler_Procedure_Product_Instance_Stream_Cursor_Value_Input = {
  barcode?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  ehr_encounter?: InputMaybe<Scalars['uuid']>;
  ehr_fda_product?: InputMaybe<Scalars['uuid']>;
  ehr_product?: InputMaybe<Scalars['uuid']>;
  expiration?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  initial_volume_ml?: InputMaybe<Scalars['numeric']>;
  lot_number?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['uuid']>;
  serial_number?: InputMaybe<Scalars['String']>;
  sort_order?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Filler_Procedure_Product_Instance_Sum_Fields = {
  __typename?: 'filler_procedure_product_instance_sum_fields';
  initial_volume_ml?: Maybe<Scalars['numeric']>;
  sort_order?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Sum_Order_By = {
  initial_volume_ml?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** update columns of table "filler_procedure_product_instance" */
export enum Filler_Procedure_Product_Instance_Update_Column {
  /** column name */
  Barcode = 'barcode',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EhrEncounter = 'ehr_encounter',
  /** column name */
  EhrFdaProduct = 'ehr_fda_product',
  /** column name */
  EhrProduct = 'ehr_product',
  /** column name */
  Expiration = 'expiration',
  /** column name */
  Id = 'id',
  /** column name */
  InitialVolumeMl = 'initial_volume_ml',
  /** column name */
  LotNumber = 'lot_number',
  /** column name */
  Provider = 'provider',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Filler_Procedure_Product_Instance_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Filler_Procedure_Product_Instance_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Filler_Procedure_Product_Instance_Set_Input>;
  /** filter the rows which have to be updated */
  where: Filler_Procedure_Product_Instance_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Filler_Procedure_Product_Instance_Var_Pop_Fields = {
  __typename?: 'filler_procedure_product_instance_var_pop_fields';
  initial_volume_ml?: Maybe<Scalars['Float']>;
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Var_Pop_Order_By = {
  initial_volume_ml?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Filler_Procedure_Product_Instance_Var_Samp_Fields = {
  __typename?: 'filler_procedure_product_instance_var_samp_fields';
  initial_volume_ml?: Maybe<Scalars['Float']>;
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Var_Samp_Order_By = {
  initial_volume_ml?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Filler_Procedure_Product_Instance_Variance_Fields = {
  __typename?: 'filler_procedure_product_instance_variance_fields';
  initial_volume_ml?: Maybe<Scalars['Float']>;
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "filler_procedure_product_instance" */
export type Filler_Procedure_Product_Instance_Variance_Order_By = {
  initial_volume_ml?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** columns and relationships of "filler_space" */
export type Filler_Space = {
  __typename?: 'filler_space';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "filler_space" */
export type Filler_Space_Aggregate = {
  __typename?: 'filler_space_aggregate';
  aggregate?: Maybe<Filler_Space_Aggregate_Fields>;
  nodes: Array<Filler_Space>;
};

/** aggregate fields of "filler_space" */
export type Filler_Space_Aggregate_Fields = {
  __typename?: 'filler_space_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Filler_Space_Max_Fields>;
  min?: Maybe<Filler_Space_Min_Fields>;
};


/** aggregate fields of "filler_space" */
export type Filler_Space_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Filler_Space_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "filler_space". All fields are combined with a logical 'AND'. */
export type Filler_Space_Bool_Exp = {
  _and?: InputMaybe<Array<Filler_Space_Bool_Exp>>;
  _not?: InputMaybe<Filler_Space_Bool_Exp>;
  _or?: InputMaybe<Array<Filler_Space_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "filler_space" */
export enum Filler_Space_Constraint {
  /** unique or primary key constraint on columns "value" */
  FillerSpacePkey = 'filler_space_pkey'
}

export enum Filler_Space_Enum {
  /** 3D face-scan space (model-local x/y/z coordinates) */
  ThreeD = 'THREE_D',
  /** 2D face-diagram space (image pixel coordinates) */
  TwoD = 'TWO_D'
}

/** Boolean expression to compare columns of type "filler_space_enum". All fields are combined with logical 'AND'. */
export type Filler_Space_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Filler_Space_Enum>;
  _in?: InputMaybe<Array<Filler_Space_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Filler_Space_Enum>;
  _nin?: InputMaybe<Array<Filler_Space_Enum>>;
};

/** input type for inserting data into table "filler_space" */
export type Filler_Space_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Filler_Space_Max_Fields = {
  __typename?: 'filler_space_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Filler_Space_Min_Fields = {
  __typename?: 'filler_space_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "filler_space" */
export type Filler_Space_Mutation_Response = {
  __typename?: 'filler_space_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Filler_Space>;
};

/** on_conflict condition type for table "filler_space" */
export type Filler_Space_On_Conflict = {
  constraint: Filler_Space_Constraint;
  update_columns?: Array<Filler_Space_Update_Column>;
  where?: InputMaybe<Filler_Space_Bool_Exp>;
};

/** Ordering options when selecting data from "filler_space". */
export type Filler_Space_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: filler_space */
export type Filler_Space_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "filler_space" */
export enum Filler_Space_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "filler_space" */
export type Filler_Space_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "filler_space" */
export type Filler_Space_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Filler_Space_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Filler_Space_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "filler_space" */
export enum Filler_Space_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Filler_Space_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Filler_Space_Set_Input>;
  /** filter the rows which have to be updated */
  where: Filler_Space_Bool_Exp;
};

/** Versioned, immutable, non-PHI filler zone scheme. Records pin a version to re-render against the geometry they were authored with. Geometry assets live on the public CDN under photos/filler_zone_release/<version>/. */
export type Filler_Zone_Release = {
  __typename?: 'filler_zone_release';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
};

/** aggregated selection of "filler_zone_release" */
export type Filler_Zone_Release_Aggregate = {
  __typename?: 'filler_zone_release_aggregate';
  aggregate?: Maybe<Filler_Zone_Release_Aggregate_Fields>;
  nodes: Array<Filler_Zone_Release>;
};

/** aggregate fields of "filler_zone_release" */
export type Filler_Zone_Release_Aggregate_Fields = {
  __typename?: 'filler_zone_release_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Filler_Zone_Release_Max_Fields>;
  min?: Maybe<Filler_Zone_Release_Min_Fields>;
};


/** aggregate fields of "filler_zone_release" */
export type Filler_Zone_Release_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Filler_Zone_Release_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "filler_zone_release". All fields are combined with a logical 'AND'. */
export type Filler_Zone_Release_Bool_Exp = {
  _and?: InputMaybe<Array<Filler_Zone_Release_Bool_Exp>>;
  _not?: InputMaybe<Filler_Zone_Release_Bool_Exp>;
  _or?: InputMaybe<Array<Filler_Zone_Release_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "filler_zone_release" */
export enum Filler_Zone_Release_Constraint {
  /** unique or primary key constraint on columns "id" */
  FillerZoneReleasePkey = 'filler_zone_release_pkey'
}

/** input type for inserting data into table "filler_zone_release" */
export type Filler_Zone_Release_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Filler_Zone_Release_Max_Fields = {
  __typename?: 'filler_zone_release_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Filler_Zone_Release_Min_Fields = {
  __typename?: 'filler_zone_release_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "filler_zone_release" */
export type Filler_Zone_Release_Mutation_Response = {
  __typename?: 'filler_zone_release_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Filler_Zone_Release>;
};

/** input type for inserting object relation for remote table "filler_zone_release" */
export type Filler_Zone_Release_Obj_Rel_Insert_Input = {
  data: Filler_Zone_Release_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Filler_Zone_Release_On_Conflict>;
};

/** on_conflict condition type for table "filler_zone_release" */
export type Filler_Zone_Release_On_Conflict = {
  constraint: Filler_Zone_Release_Constraint;
  update_columns?: Array<Filler_Zone_Release_Update_Column>;
  where?: InputMaybe<Filler_Zone_Release_Bool_Exp>;
};

/** Ordering options when selecting data from "filler_zone_release". */
export type Filler_Zone_Release_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: filler_zone_release */
export type Filler_Zone_Release_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "filler_zone_release" */
export enum Filler_Zone_Release_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "filler_zone_release" */
export type Filler_Zone_Release_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "filler_zone_release" */
export type Filler_Zone_Release_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Filler_Zone_Release_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Filler_Zone_Release_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "filler_zone_release" */
export enum Filler_Zone_Release_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id'
}

export type Filler_Zone_Release_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Filler_Zone_Release_Set_Input>;
  /** filter the rows which have to be updated */
  where: Filler_Zone_Release_Bool_Exp;
};

/** columns and relationships of "fn_check_proposed_patient_booking_for_stacking" */
export type Fn_Check_Proposed_Patient_Booking_For_Stacking = {
  __typename?: 'fn_check_proposed_patient_booking_for_stacking';
  proposed_patient_booking_timespan: Scalars['tstzrange'];
  provider_booking_id: Scalars['uuid'];
  provider_booking_timespan: Scalars['tstzrange'];
};

export type Fn_Check_Proposed_Patient_Booking_For_Stacking_Aggregate = {
  __typename?: 'fn_check_proposed_patient_booking_for_stacking_aggregate';
  aggregate?: Maybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Aggregate_Fields>;
  nodes: Array<Fn_Check_Proposed_Patient_Booking_For_Stacking>;
};

/** aggregate fields of "fn_check_proposed_patient_booking_for_stacking" */
export type Fn_Check_Proposed_Patient_Booking_For_Stacking_Aggregate_Fields = {
  __typename?: 'fn_check_proposed_patient_booking_for_stacking_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Max_Fields>;
  min?: Maybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Min_Fields>;
};


/** aggregate fields of "fn_check_proposed_patient_booking_for_stacking" */
export type Fn_Check_Proposed_Patient_Booking_For_Stacking_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "fn_check_proposed_patient_booking_for_stacking". All fields are combined with a logical 'AND'. */
export type Fn_Check_Proposed_Patient_Booking_For_Stacking_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Bool_Exp>>;
  _not?: InputMaybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Bool_Exp>>;
  proposed_patient_booking_timespan?: InputMaybe<Tstzrange_Comparison_Exp>;
  provider_booking_id?: InputMaybe<Uuid_Comparison_Exp>;
  provider_booking_timespan?: InputMaybe<Tstzrange_Comparison_Exp>;
};

/** unique or primary key constraints on table "fn_check_proposed_patient_booking_for_stacking" */
export enum Fn_Check_Proposed_Patient_Booking_For_Stacking_Constraint {
  /** unique or primary key constraint on columns "provider_booking_id" */
  FnCheckProposedPatientBookingForStackingPkey = 'fn_check_proposed_patient_booking_for_stacking_pkey'
}

/** input type for inserting data into table "fn_check_proposed_patient_booking_for_stacking" */
export type Fn_Check_Proposed_Patient_Booking_For_Stacking_Insert_Input = {
  proposed_patient_booking_timespan?: InputMaybe<Scalars['tstzrange']>;
  provider_booking_id?: InputMaybe<Scalars['uuid']>;
  provider_booking_timespan?: InputMaybe<Scalars['tstzrange']>;
};

/** aggregate max on columns */
export type Fn_Check_Proposed_Patient_Booking_For_Stacking_Max_Fields = {
  __typename?: 'fn_check_proposed_patient_booking_for_stacking_max_fields';
  provider_booking_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Fn_Check_Proposed_Patient_Booking_For_Stacking_Min_Fields = {
  __typename?: 'fn_check_proposed_patient_booking_for_stacking_min_fields';
  provider_booking_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "fn_check_proposed_patient_booking_for_stacking" */
export type Fn_Check_Proposed_Patient_Booking_For_Stacking_Mutation_Response = {
  __typename?: 'fn_check_proposed_patient_booking_for_stacking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fn_Check_Proposed_Patient_Booking_For_Stacking>;
};

/** on_conflict condition type for table "fn_check_proposed_patient_booking_for_stacking" */
export type Fn_Check_Proposed_Patient_Booking_For_Stacking_On_Conflict = {
  constraint: Fn_Check_Proposed_Patient_Booking_For_Stacking_Constraint;
  update_columns?: Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Update_Column>;
  where?: InputMaybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Bool_Exp>;
};

/** Ordering options when selecting data from "fn_check_proposed_patient_booking_for_stacking". */
export type Fn_Check_Proposed_Patient_Booking_For_Stacking_Order_By = {
  proposed_patient_booking_timespan?: InputMaybe<Order_By>;
  provider_booking_id?: InputMaybe<Order_By>;
  provider_booking_timespan?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fn_check_proposed_patient_booking_for_stacking */
export type Fn_Check_Proposed_Patient_Booking_For_Stacking_Pk_Columns_Input = {
  provider_booking_id: Scalars['uuid'];
};

/** select columns of table "fn_check_proposed_patient_booking_for_stacking" */
export enum Fn_Check_Proposed_Patient_Booking_For_Stacking_Select_Column {
  /** column name */
  ProposedPatientBookingTimespan = 'proposed_patient_booking_timespan',
  /** column name */
  ProviderBookingId = 'provider_booking_id',
  /** column name */
  ProviderBookingTimespan = 'provider_booking_timespan'
}

/** input type for updating data in table "fn_check_proposed_patient_booking_for_stacking" */
export type Fn_Check_Proposed_Patient_Booking_For_Stacking_Set_Input = {
  proposed_patient_booking_timespan?: InputMaybe<Scalars['tstzrange']>;
  provider_booking_id?: InputMaybe<Scalars['uuid']>;
  provider_booking_timespan?: InputMaybe<Scalars['tstzrange']>;
};

/** Streaming cursor of the table "fn_check_proposed_patient_booking_for_stacking" */
export type Fn_Check_Proposed_Patient_Booking_For_Stacking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Check_Proposed_Patient_Booking_For_Stacking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Check_Proposed_Patient_Booking_For_Stacking_Stream_Cursor_Value_Input = {
  proposed_patient_booking_timespan?: InputMaybe<Scalars['tstzrange']>;
  provider_booking_id?: InputMaybe<Scalars['uuid']>;
  provider_booking_timespan?: InputMaybe<Scalars['tstzrange']>;
};

/** update columns of table "fn_check_proposed_patient_booking_for_stacking" */
export enum Fn_Check_Proposed_Patient_Booking_For_Stacking_Update_Column {
  /** column name */
  ProposedPatientBookingTimespan = 'proposed_patient_booking_timespan',
  /** column name */
  ProviderBookingId = 'provider_booking_id',
  /** column name */
  ProviderBookingTimespan = 'provider_booking_timespan'
}

export type Fn_Check_Proposed_Patient_Booking_For_Stacking_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fn_Check_Proposed_Patient_Booking_For_Stacking_Bool_Exp;
};

/** columns and relationships of "fn_get_active_notification_preferences_for_type_and_location" */
export type Fn_Get_Active_Notification_Preferences_For_Type_And_Location = {
  __typename?: 'fn_get_active_notification_preferences_for_type_and_location';
  channel: Notification_Channel_Enum;
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  type: Scalars['String'];
  user: Scalars['uuid'];
  /** An object relationship */
  userByUser: User;
};

/** aggregated selection of "fn_get_active_notification_preferences_for_type_and_location" */
export type Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Aggregate = {
  __typename?: 'fn_get_active_notification_preferences_for_type_and_location_aggregate';
  aggregate?: Maybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Aggregate_Fields>;
  nodes: Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location>;
};

/** aggregate fields of "fn_get_active_notification_preferences_for_type_and_location" */
export type Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Aggregate_Fields = {
  __typename?: 'fn_get_active_notification_preferences_for_type_and_location_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Max_Fields>;
  min?: Maybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Min_Fields>;
};


/** aggregate fields of "fn_get_active_notification_preferences_for_type_and_location" */
export type Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "fn_get_active_notification_preferences_for_type_and_location". All fields are combined with a logical 'AND'. */
export type Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp>>;
  _not?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp>>;
  channel?: InputMaybe<Notification_Channel_Enum_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Uuid_Comparison_Exp>;
  userByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "fn_get_active_notification_preferences_for_type_and_location" */
export enum Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Constraint {
  /** unique or primary key constraint on columns "type", "user", "location" */
  FnGetActiveNotificationPreferencesForTypeAndLocatiPkey = 'fn_get_active_notification_preferences_for_type_and_locati_pkey'
}

/** input type for inserting data into table "fn_get_active_notification_preferences_for_type_and_location" */
export type Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Insert_Input = {
  channel?: InputMaybe<Notification_Channel_Enum>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['uuid']>;
  userByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Max_Fields = {
  __typename?: 'fn_get_active_notification_preferences_for_type_and_location_max_fields';
  location?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Min_Fields = {
  __typename?: 'fn_get_active_notification_preferences_for_type_and_location_min_fields';
  location?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "fn_get_active_notification_preferences_for_type_and_location" */
export type Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Mutation_Response = {
  __typename?: 'fn_get_active_notification_preferences_for_type_and_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location>;
};

/** on_conflict condition type for table "fn_get_active_notification_preferences_for_type_and_location" */
export type Fn_Get_Active_Notification_Preferences_For_Type_And_Location_On_Conflict = {
  constraint: Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Constraint;
  update_columns?: Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Update_Column>;
  where?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp>;
};

/** Ordering options when selecting data from "fn_get_active_notification_preferences_for_type_and_location". */
export type Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Order_By = {
  channel?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  userByUser?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: fn_get_active_notification_preferences_for_type_and_location */
export type Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Pk_Columns_Input = {
  location: Scalars['uuid'];
  type: Scalars['String'];
  user: Scalars['uuid'];
};

/** select columns of table "fn_get_active_notification_preferences_for_type_and_location" */
export enum Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Select_Column {
  /** column name */
  Channel = 'channel',
  /** column name */
  Location = 'location',
  /** column name */
  Type = 'type',
  /** column name */
  User = 'user'
}

/** input type for updating data in table "fn_get_active_notification_preferences_for_type_and_location" */
export type Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Set_Input = {
  channel?: InputMaybe<Notification_Channel_Enum>;
  location?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "fn_get_active_notification_preferences_for_type_and_location" */
export type Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Stream_Cursor_Value_Input = {
  channel?: InputMaybe<Notification_Channel_Enum>;
  location?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "fn_get_active_notification_preferences_for_type_and_location" */
export enum Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Update_Column {
  /** column name */
  Channel = 'channel',
  /** column name */
  Location = 'location',
  /** column name */
  Type = 'type',
  /** column name */
  User = 'user'
}

export type Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp;
};

/** columns and relationships of "fn_get_active_subscribers_query" */
export type Fn_Get_Active_Subscribers_Query = {
  __typename?: 'fn_get_active_subscribers_query';
  duration: Scalars['interval'];
  stripeCustomerId: Scalars['String'];
};

/** aggregated selection of "fn_get_active_subscribers_query" */
export type Fn_Get_Active_Subscribers_Query_Aggregate = {
  __typename?: 'fn_get_active_subscribers_query_aggregate';
  aggregate?: Maybe<Fn_Get_Active_Subscribers_Query_Aggregate_Fields>;
  nodes: Array<Fn_Get_Active_Subscribers_Query>;
};

/** aggregate fields of "fn_get_active_subscribers_query" */
export type Fn_Get_Active_Subscribers_Query_Aggregate_Fields = {
  __typename?: 'fn_get_active_subscribers_query_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Fn_Get_Active_Subscribers_Query_Max_Fields>;
  min?: Maybe<Fn_Get_Active_Subscribers_Query_Min_Fields>;
};


/** aggregate fields of "fn_get_active_subscribers_query" */
export type Fn_Get_Active_Subscribers_Query_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Get_Active_Subscribers_Query_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "fn_get_active_subscribers_query". All fields are combined with a logical 'AND'. */
export type Fn_Get_Active_Subscribers_Query_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Get_Active_Subscribers_Query_Bool_Exp>>;
  _not?: InputMaybe<Fn_Get_Active_Subscribers_Query_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Get_Active_Subscribers_Query_Bool_Exp>>;
  duration?: InputMaybe<Interval_Comparison_Exp>;
  stripeCustomerId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fn_get_active_subscribers_query" */
export enum Fn_Get_Active_Subscribers_Query_Constraint {
  /** unique or primary key constraint on columns "stripe_customer_id" */
  FnGetActiveSubscribersQueryPkey = 'fn_get_active_subscribers_query_pkey'
}

/** input type for inserting data into table "fn_get_active_subscribers_query" */
export type Fn_Get_Active_Subscribers_Query_Insert_Input = {
  duration?: InputMaybe<Scalars['interval']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Fn_Get_Active_Subscribers_Query_Max_Fields = {
  __typename?: 'fn_get_active_subscribers_query_max_fields';
  stripeCustomerId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Fn_Get_Active_Subscribers_Query_Min_Fields = {
  __typename?: 'fn_get_active_subscribers_query_min_fields';
  stripeCustomerId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "fn_get_active_subscribers_query" */
export type Fn_Get_Active_Subscribers_Query_Mutation_Response = {
  __typename?: 'fn_get_active_subscribers_query_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fn_Get_Active_Subscribers_Query>;
};

/** on_conflict condition type for table "fn_get_active_subscribers_query" */
export type Fn_Get_Active_Subscribers_Query_On_Conflict = {
  constraint: Fn_Get_Active_Subscribers_Query_Constraint;
  update_columns?: Array<Fn_Get_Active_Subscribers_Query_Update_Column>;
  where?: InputMaybe<Fn_Get_Active_Subscribers_Query_Bool_Exp>;
};

/** Ordering options when selecting data from "fn_get_active_subscribers_query". */
export type Fn_Get_Active_Subscribers_Query_Order_By = {
  duration?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fn_get_active_subscribers_query */
export type Fn_Get_Active_Subscribers_Query_Pk_Columns_Input = {
  stripeCustomerId: Scalars['String'];
};

/** select columns of table "fn_get_active_subscribers_query" */
export enum Fn_Get_Active_Subscribers_Query_Select_Column {
  /** column name */
  Duration = 'duration',
  /** column name */
  StripeCustomerId = 'stripeCustomerId'
}

/** input type for updating data in table "fn_get_active_subscribers_query" */
export type Fn_Get_Active_Subscribers_Query_Set_Input = {
  duration?: InputMaybe<Scalars['interval']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "fn_get_active_subscribers_query" */
export type Fn_Get_Active_Subscribers_Query_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Get_Active_Subscribers_Query_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Get_Active_Subscribers_Query_Stream_Cursor_Value_Input = {
  duration?: InputMaybe<Scalars['interval']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "fn_get_active_subscribers_query" */
export enum Fn_Get_Active_Subscribers_Query_Update_Column {
  /** column name */
  Duration = 'duration',
  /** column name */
  StripeCustomerId = 'stripeCustomerId'
}

export type Fn_Get_Active_Subscribers_Query_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fn_Get_Active_Subscribers_Query_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fn_Get_Active_Subscribers_Query_Bool_Exp;
};

/** columns and relationships of "fn_get_location_purchases_to_provider_purchases_query" */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query = {
  __typename?: 'fn_get_location_purchases_to_provider_purchases_query';
  location: Scalars['uuid'];
  location_purchases_total: Scalars['numeric'];
  provider_purchases_total: Scalars['numeric'];
};

/** aggregated selection of "fn_get_location_purchases_to_provider_purchases_query" */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Aggregate = {
  __typename?: 'fn_get_location_purchases_to_provider_purchases_query_aggregate';
  aggregate?: Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Aggregate_Fields>;
  nodes: Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query>;
};

/** aggregate fields of "fn_get_location_purchases_to_provider_purchases_query" */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Aggregate_Fields = {
  __typename?: 'fn_get_location_purchases_to_provider_purchases_query_aggregate_fields';
  avg?: Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Max_Fields>;
  min?: Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Min_Fields>;
  stddev?: Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Stddev_Fields>;
  stddev_pop?: Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Stddev_Samp_Fields>;
  sum?: Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Sum_Fields>;
  var_pop?: Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Var_Pop_Fields>;
  var_samp?: Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Var_Samp_Fields>;
  variance?: Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Variance_Fields>;
};


/** aggregate fields of "fn_get_location_purchases_to_provider_purchases_query" */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Avg_Fields = {
  __typename?: 'fn_get_location_purchases_to_provider_purchases_query_avg_fields';
  location_purchases_total?: Maybe<Scalars['Float']>;
  provider_purchases_total?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fn_get_location_purchases_to_provider_purchases_query". All fields are combined with a logical 'AND'. */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Bool_Exp>>;
  _not?: InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Bool_Exp>>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  location_purchases_total?: InputMaybe<Numeric_Comparison_Exp>;
  provider_purchases_total?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "fn_get_location_purchases_to_provider_purchases_query" */
export enum Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Constraint {
  /** unique or primary key constraint on columns "location" */
  FnGetLocationPurchasesToProviderPurchasesQueryPkey = 'fn_get_location_purchases_to_provider_purchases_query_pkey'
}

/** input type for incrementing numeric columns in table "fn_get_location_purchases_to_provider_purchases_query" */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Inc_Input = {
  location_purchases_total?: InputMaybe<Scalars['numeric']>;
  provider_purchases_total?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "fn_get_location_purchases_to_provider_purchases_query" */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Insert_Input = {
  location?: InputMaybe<Scalars['uuid']>;
  location_purchases_total?: InputMaybe<Scalars['numeric']>;
  provider_purchases_total?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Max_Fields = {
  __typename?: 'fn_get_location_purchases_to_provider_purchases_query_max_fields';
  location?: Maybe<Scalars['uuid']>;
  location_purchases_total?: Maybe<Scalars['numeric']>;
  provider_purchases_total?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Min_Fields = {
  __typename?: 'fn_get_location_purchases_to_provider_purchases_query_min_fields';
  location?: Maybe<Scalars['uuid']>;
  location_purchases_total?: Maybe<Scalars['numeric']>;
  provider_purchases_total?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "fn_get_location_purchases_to_provider_purchases_query" */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Mutation_Response = {
  __typename?: 'fn_get_location_purchases_to_provider_purchases_query_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query>;
};

/** on_conflict condition type for table "fn_get_location_purchases_to_provider_purchases_query" */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_On_Conflict = {
  constraint: Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Constraint;
  update_columns?: Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Update_Column>;
  where?: InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Bool_Exp>;
};

/** Ordering options when selecting data from "fn_get_location_purchases_to_provider_purchases_query". */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Order_By = {
  location?: InputMaybe<Order_By>;
  location_purchases_total?: InputMaybe<Order_By>;
  provider_purchases_total?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fn_get_location_purchases_to_provider_purchases_query */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Pk_Columns_Input = {
  location: Scalars['uuid'];
};

/** select columns of table "fn_get_location_purchases_to_provider_purchases_query" */
export enum Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Select_Column {
  /** column name */
  Location = 'location',
  /** column name */
  LocationPurchasesTotal = 'location_purchases_total',
  /** column name */
  ProviderPurchasesTotal = 'provider_purchases_total'
}

/** input type for updating data in table "fn_get_location_purchases_to_provider_purchases_query" */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Set_Input = {
  location?: InputMaybe<Scalars['uuid']>;
  location_purchases_total?: InputMaybe<Scalars['numeric']>;
  provider_purchases_total?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Stddev_Fields = {
  __typename?: 'fn_get_location_purchases_to_provider_purchases_query_stddev_fields';
  location_purchases_total?: Maybe<Scalars['Float']>;
  provider_purchases_total?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Stddev_Pop_Fields = {
  __typename?: 'fn_get_location_purchases_to_provider_purchases_query_stddev_pop_fields';
  location_purchases_total?: Maybe<Scalars['Float']>;
  provider_purchases_total?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Stddev_Samp_Fields = {
  __typename?: 'fn_get_location_purchases_to_provider_purchases_query_stddev_samp_fields';
  location_purchases_total?: Maybe<Scalars['Float']>;
  provider_purchases_total?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fn_get_location_purchases_to_provider_purchases_query" */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Stream_Cursor_Value_Input = {
  location?: InputMaybe<Scalars['uuid']>;
  location_purchases_total?: InputMaybe<Scalars['numeric']>;
  provider_purchases_total?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Sum_Fields = {
  __typename?: 'fn_get_location_purchases_to_provider_purchases_query_sum_fields';
  location_purchases_total?: Maybe<Scalars['numeric']>;
  provider_purchases_total?: Maybe<Scalars['numeric']>;
};

/** update columns of table "fn_get_location_purchases_to_provider_purchases_query" */
export enum Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Update_Column {
  /** column name */
  Location = 'location',
  /** column name */
  LocationPurchasesTotal = 'location_purchases_total',
  /** column name */
  ProviderPurchasesTotal = 'provider_purchases_total'
}

export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Var_Pop_Fields = {
  __typename?: 'fn_get_location_purchases_to_provider_purchases_query_var_pop_fields';
  location_purchases_total?: Maybe<Scalars['Float']>;
  provider_purchases_total?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Var_Samp_Fields = {
  __typename?: 'fn_get_location_purchases_to_provider_purchases_query_var_samp_fields';
  location_purchases_total?: Maybe<Scalars['Float']>;
  provider_purchases_total?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Variance_Fields = {
  __typename?: 'fn_get_location_purchases_to_provider_purchases_query_variance_fields';
  location_purchases_total?: Maybe<Scalars['Float']>;
  provider_purchases_total?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fn_get_stackable_booking_options_data" */
export type Fn_Get_Stackable_Booking_Options_Data = {
  __typename?: 'fn_get_stackable_booking_options_data';
  patientBookingTimespan: Array<Scalars['tstzrange']>;
  providerBookingId: Scalars['uuid'];
  providerBookingTimespan: Scalars['tstzrange'];
};

/** aggregated selection of "fn_get_stackable_booking_options_data" */
export type Fn_Get_Stackable_Booking_Options_Data_Aggregate = {
  __typename?: 'fn_get_stackable_booking_options_data_aggregate';
  aggregate?: Maybe<Fn_Get_Stackable_Booking_Options_Data_Aggregate_Fields>;
  nodes: Array<Fn_Get_Stackable_Booking_Options_Data>;
};

/** aggregate fields of "fn_get_stackable_booking_options_data" */
export type Fn_Get_Stackable_Booking_Options_Data_Aggregate_Fields = {
  __typename?: 'fn_get_stackable_booking_options_data_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Fn_Get_Stackable_Booking_Options_Data_Max_Fields>;
  min?: Maybe<Fn_Get_Stackable_Booking_Options_Data_Min_Fields>;
};


/** aggregate fields of "fn_get_stackable_booking_options_data" */
export type Fn_Get_Stackable_Booking_Options_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Get_Stackable_Booking_Options_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "fn_get_stackable_booking_options_data". All fields are combined with a logical 'AND'. */
export type Fn_Get_Stackable_Booking_Options_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Get_Stackable_Booking_Options_Data_Bool_Exp>>;
  _not?: InputMaybe<Fn_Get_Stackable_Booking_Options_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Get_Stackable_Booking_Options_Data_Bool_Exp>>;
  patientBookingTimespan?: InputMaybe<Tstzrange_Array_Comparison_Exp>;
  providerBookingId?: InputMaybe<Uuid_Comparison_Exp>;
  providerBookingTimespan?: InputMaybe<Tstzrange_Comparison_Exp>;
};

/** unique or primary key constraints on table "fn_get_stackable_booking_options_data" */
export enum Fn_Get_Stackable_Booking_Options_Data_Constraint {
  /** unique or primary key constraint on columns "provider_booking_id" */
  FnGetStackableBookingOptionsDataPkey = 'fn_get_stackable_booking_options_data_pkey'
}

/** input type for inserting data into table "fn_get_stackable_booking_options_data" */
export type Fn_Get_Stackable_Booking_Options_Data_Insert_Input = {
  patientBookingTimespan?: InputMaybe<Array<Scalars['tstzrange']>>;
  providerBookingId?: InputMaybe<Scalars['uuid']>;
  providerBookingTimespan?: InputMaybe<Scalars['tstzrange']>;
};

/** aggregate max on columns */
export type Fn_Get_Stackable_Booking_Options_Data_Max_Fields = {
  __typename?: 'fn_get_stackable_booking_options_data_max_fields';
  patientBookingTimespan?: Maybe<Array<Scalars['tstzrange']>>;
  providerBookingId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Fn_Get_Stackable_Booking_Options_Data_Min_Fields = {
  __typename?: 'fn_get_stackable_booking_options_data_min_fields';
  patientBookingTimespan?: Maybe<Array<Scalars['tstzrange']>>;
  providerBookingId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "fn_get_stackable_booking_options_data" */
export type Fn_Get_Stackable_Booking_Options_Data_Mutation_Response = {
  __typename?: 'fn_get_stackable_booking_options_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fn_Get_Stackable_Booking_Options_Data>;
};

/** on_conflict condition type for table "fn_get_stackable_booking_options_data" */
export type Fn_Get_Stackable_Booking_Options_Data_On_Conflict = {
  constraint: Fn_Get_Stackable_Booking_Options_Data_Constraint;
  update_columns?: Array<Fn_Get_Stackable_Booking_Options_Data_Update_Column>;
  where?: InputMaybe<Fn_Get_Stackable_Booking_Options_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "fn_get_stackable_booking_options_data". */
export type Fn_Get_Stackable_Booking_Options_Data_Order_By = {
  patientBookingTimespan?: InputMaybe<Order_By>;
  providerBookingId?: InputMaybe<Order_By>;
  providerBookingTimespan?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fn_get_stackable_booking_options_data */
export type Fn_Get_Stackable_Booking_Options_Data_Pk_Columns_Input = {
  providerBookingId: Scalars['uuid'];
};

/** select columns of table "fn_get_stackable_booking_options_data" */
export enum Fn_Get_Stackable_Booking_Options_Data_Select_Column {
  /** column name */
  PatientBookingTimespan = 'patientBookingTimespan',
  /** column name */
  ProviderBookingId = 'providerBookingId',
  /** column name */
  ProviderBookingTimespan = 'providerBookingTimespan'
}

/** input type for updating data in table "fn_get_stackable_booking_options_data" */
export type Fn_Get_Stackable_Booking_Options_Data_Set_Input = {
  patientBookingTimespan?: InputMaybe<Array<Scalars['tstzrange']>>;
  providerBookingId?: InputMaybe<Scalars['uuid']>;
  providerBookingTimespan?: InputMaybe<Scalars['tstzrange']>;
};

/** Streaming cursor of the table "fn_get_stackable_booking_options_data" */
export type Fn_Get_Stackable_Booking_Options_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Get_Stackable_Booking_Options_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Get_Stackable_Booking_Options_Data_Stream_Cursor_Value_Input = {
  patientBookingTimespan?: InputMaybe<Array<Scalars['tstzrange']>>;
  providerBookingId?: InputMaybe<Scalars['uuid']>;
  providerBookingTimespan?: InputMaybe<Scalars['tstzrange']>;
};

/** update columns of table "fn_get_stackable_booking_options_data" */
export enum Fn_Get_Stackable_Booking_Options_Data_Update_Column {
  /** column name */
  PatientBookingTimespan = 'patientBookingTimespan',
  /** column name */
  ProviderBookingId = 'providerBookingId',
  /** column name */
  ProviderBookingTimespan = 'providerBookingTimespan'
}

export type Fn_Get_Stackable_Booking_Options_Data_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fn_Get_Stackable_Booking_Options_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fn_Get_Stackable_Booking_Options_Data_Bool_Exp;
};

/** columns and relationships of "fn_get_user_booking_options_blockers" */
export type Fn_Get_User_Booking_Options_Blockers = {
  __typename?: 'fn_get_user_booking_options_blockers';
  bound: Scalars['String'];
  timestamp: Scalars['timestamptz'];
  type: Scalars['String'];
};

/** aggregated selection of "fn_get_user_booking_options_blockers" */
export type Fn_Get_User_Booking_Options_Blockers_Aggregate = {
  __typename?: 'fn_get_user_booking_options_blockers_aggregate';
  aggregate?: Maybe<Fn_Get_User_Booking_Options_Blockers_Aggregate_Fields>;
  nodes: Array<Fn_Get_User_Booking_Options_Blockers>;
};

/** aggregate fields of "fn_get_user_booking_options_blockers" */
export type Fn_Get_User_Booking_Options_Blockers_Aggregate_Fields = {
  __typename?: 'fn_get_user_booking_options_blockers_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Fn_Get_User_Booking_Options_Blockers_Max_Fields>;
  min?: Maybe<Fn_Get_User_Booking_Options_Blockers_Min_Fields>;
};


/** aggregate fields of "fn_get_user_booking_options_blockers" */
export type Fn_Get_User_Booking_Options_Blockers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Get_User_Booking_Options_Blockers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "fn_get_user_booking_options_blockers". All fields are combined with a logical 'AND'. */
export type Fn_Get_User_Booking_Options_Blockers_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Get_User_Booking_Options_Blockers_Bool_Exp>>;
  _not?: InputMaybe<Fn_Get_User_Booking_Options_Blockers_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Get_User_Booking_Options_Blockers_Bool_Exp>>;
  bound?: InputMaybe<String_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fn_get_user_booking_options_blockers" */
export enum Fn_Get_User_Booking_Options_Blockers_Constraint {
  /** unique or primary key constraint on columns "type", "timestamp", "bound" */
  FnGetUserBookingOptionsBlockersPkey = 'fn_get_user_booking_options_blockers_pkey'
}

/** input type for inserting data into table "fn_get_user_booking_options_blockers" */
export type Fn_Get_User_Booking_Options_Blockers_Insert_Input = {
  bound?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Fn_Get_User_Booking_Options_Blockers_Max_Fields = {
  __typename?: 'fn_get_user_booking_options_blockers_max_fields';
  bound?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Fn_Get_User_Booking_Options_Blockers_Min_Fields = {
  __typename?: 'fn_get_user_booking_options_blockers_min_fields';
  bound?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "fn_get_user_booking_options_blockers" */
export type Fn_Get_User_Booking_Options_Blockers_Mutation_Response = {
  __typename?: 'fn_get_user_booking_options_blockers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fn_Get_User_Booking_Options_Blockers>;
};

/** on_conflict condition type for table "fn_get_user_booking_options_blockers" */
export type Fn_Get_User_Booking_Options_Blockers_On_Conflict = {
  constraint: Fn_Get_User_Booking_Options_Blockers_Constraint;
  update_columns?: Array<Fn_Get_User_Booking_Options_Blockers_Update_Column>;
  where?: InputMaybe<Fn_Get_User_Booking_Options_Blockers_Bool_Exp>;
};

/** Ordering options when selecting data from "fn_get_user_booking_options_blockers". */
export type Fn_Get_User_Booking_Options_Blockers_Order_By = {
  bound?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fn_get_user_booking_options_blockers */
export type Fn_Get_User_Booking_Options_Blockers_Pk_Columns_Input = {
  bound: Scalars['String'];
  timestamp: Scalars['timestamptz'];
  type: Scalars['String'];
};

/** select columns of table "fn_get_user_booking_options_blockers" */
export enum Fn_Get_User_Booking_Options_Blockers_Select_Column {
  /** column name */
  Bound = 'bound',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "fn_get_user_booking_options_blockers" */
export type Fn_Get_User_Booking_Options_Blockers_Set_Input = {
  bound?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "fn_get_user_booking_options_blockers" */
export type Fn_Get_User_Booking_Options_Blockers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Get_User_Booking_Options_Blockers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Get_User_Booking_Options_Blockers_Stream_Cursor_Value_Input = {
  bound?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "fn_get_user_booking_options_blockers" */
export enum Fn_Get_User_Booking_Options_Blockers_Update_Column {
  /** column name */
  Bound = 'bound',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type'
}

export type Fn_Get_User_Booking_Options_Blockers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fn_Get_User_Booking_Options_Blockers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fn_Get_User_Booking_Options_Blockers_Bool_Exp;
};

/** columns and relationships of "fn_get_user_location_procedure_unavailable_rooms" */
export type Fn_Get_User_Location_Procedure_Unavailable_Rooms = {
  __typename?: 'fn_get_user_location_procedure_unavailable_rooms';
  room: Scalars['uuid'];
  timespanBlockedByBooking?: Maybe<Scalars['tstzrange']>;
  timespanBlockingBooking: Scalars['tstzrange'];
};

/** aggregated selection of "fn_get_user_location_procedure_unavailable_rooms" */
export type Fn_Get_User_Location_Procedure_Unavailable_Rooms_Aggregate = {
  __typename?: 'fn_get_user_location_procedure_unavailable_rooms_aggregate';
  aggregate?: Maybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Aggregate_Fields>;
  nodes: Array<Fn_Get_User_Location_Procedure_Unavailable_Rooms>;
};

/** aggregate fields of "fn_get_user_location_procedure_unavailable_rooms" */
export type Fn_Get_User_Location_Procedure_Unavailable_Rooms_Aggregate_Fields = {
  __typename?: 'fn_get_user_location_procedure_unavailable_rooms_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Max_Fields>;
  min?: Maybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Min_Fields>;
};


/** aggregate fields of "fn_get_user_location_procedure_unavailable_rooms" */
export type Fn_Get_User_Location_Procedure_Unavailable_Rooms_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "fn_get_user_location_procedure_unavailable_rooms". All fields are combined with a logical 'AND'. */
export type Fn_Get_User_Location_Procedure_Unavailable_Rooms_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Bool_Exp>>;
  _not?: InputMaybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Bool_Exp>>;
  room?: InputMaybe<Uuid_Comparison_Exp>;
  timespanBlockedByBooking?: InputMaybe<Tstzrange_Comparison_Exp>;
  timespanBlockingBooking?: InputMaybe<Tstzrange_Comparison_Exp>;
};

/** unique or primary key constraints on table "fn_get_user_location_procedure_unavailable_rooms" */
export enum Fn_Get_User_Location_Procedure_Unavailable_Rooms_Constraint {
  /** unique or primary key constraint on columns "room", "timespan_blocking_booking" */
  FnGetUserLocationProcedureUnavailableRoomsPkey = 'fn_get_user_location_procedure_unavailable_rooms_pkey'
}

/** input type for inserting data into table "fn_get_user_location_procedure_unavailable_rooms" */
export type Fn_Get_User_Location_Procedure_Unavailable_Rooms_Insert_Input = {
  room?: InputMaybe<Scalars['uuid']>;
  timespanBlockedByBooking?: InputMaybe<Scalars['tstzrange']>;
  timespanBlockingBooking?: InputMaybe<Scalars['tstzrange']>;
};

/** aggregate max on columns */
export type Fn_Get_User_Location_Procedure_Unavailable_Rooms_Max_Fields = {
  __typename?: 'fn_get_user_location_procedure_unavailable_rooms_max_fields';
  room?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Fn_Get_User_Location_Procedure_Unavailable_Rooms_Min_Fields = {
  __typename?: 'fn_get_user_location_procedure_unavailable_rooms_min_fields';
  room?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "fn_get_user_location_procedure_unavailable_rooms" */
export type Fn_Get_User_Location_Procedure_Unavailable_Rooms_Mutation_Response = {
  __typename?: 'fn_get_user_location_procedure_unavailable_rooms_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fn_Get_User_Location_Procedure_Unavailable_Rooms>;
};

/** on_conflict condition type for table "fn_get_user_location_procedure_unavailable_rooms" */
export type Fn_Get_User_Location_Procedure_Unavailable_Rooms_On_Conflict = {
  constraint: Fn_Get_User_Location_Procedure_Unavailable_Rooms_Constraint;
  update_columns?: Array<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Update_Column>;
  where?: InputMaybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Bool_Exp>;
};

/** Ordering options when selecting data from "fn_get_user_location_procedure_unavailable_rooms". */
export type Fn_Get_User_Location_Procedure_Unavailable_Rooms_Order_By = {
  room?: InputMaybe<Order_By>;
  timespanBlockedByBooking?: InputMaybe<Order_By>;
  timespanBlockingBooking?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fn_get_user_location_procedure_unavailable_rooms */
export type Fn_Get_User_Location_Procedure_Unavailable_Rooms_Pk_Columns_Input = {
  room: Scalars['uuid'];
  timespanBlockingBooking: Scalars['tstzrange'];
};

/** select columns of table "fn_get_user_location_procedure_unavailable_rooms" */
export enum Fn_Get_User_Location_Procedure_Unavailable_Rooms_Select_Column {
  /** column name */
  Room = 'room',
  /** column name */
  TimespanBlockedByBooking = 'timespanBlockedByBooking',
  /** column name */
  TimespanBlockingBooking = 'timespanBlockingBooking'
}

/** input type for updating data in table "fn_get_user_location_procedure_unavailable_rooms" */
export type Fn_Get_User_Location_Procedure_Unavailable_Rooms_Set_Input = {
  room?: InputMaybe<Scalars['uuid']>;
  timespanBlockedByBooking?: InputMaybe<Scalars['tstzrange']>;
  timespanBlockingBooking?: InputMaybe<Scalars['tstzrange']>;
};

/** Streaming cursor of the table "fn_get_user_location_procedure_unavailable_rooms" */
export type Fn_Get_User_Location_Procedure_Unavailable_Rooms_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Get_User_Location_Procedure_Unavailable_Rooms_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Get_User_Location_Procedure_Unavailable_Rooms_Stream_Cursor_Value_Input = {
  room?: InputMaybe<Scalars['uuid']>;
  timespanBlockedByBooking?: InputMaybe<Scalars['tstzrange']>;
  timespanBlockingBooking?: InputMaybe<Scalars['tstzrange']>;
};

/** update columns of table "fn_get_user_location_procedure_unavailable_rooms" */
export enum Fn_Get_User_Location_Procedure_Unavailable_Rooms_Update_Column {
  /** column name */
  Room = 'room',
  /** column name */
  TimespanBlockedByBooking = 'timespanBlockedByBooking',
  /** column name */
  TimespanBlockingBooking = 'timespanBlockingBooking'
}

export type Fn_Get_User_Location_Procedure_Unavailable_Rooms_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fn_Get_User_Location_Procedure_Unavailable_Rooms_Bool_Exp;
};

/** columns and relationships of "fn_get_user_products_to_rentals_query" */
export type Fn_Get_User_Products_To_Rentals_Query = {
  __typename?: 'fn_get_user_products_to_rentals_query';
  location: Scalars['uuid'];
  products_cost: Scalars['numeric'];
  rentals_cost: Scalars['numeric'];
  user: Scalars['uuid'];
};

/** aggregated selection of "fn_get_user_products_to_rentals_query" */
export type Fn_Get_User_Products_To_Rentals_Query_Aggregate = {
  __typename?: 'fn_get_user_products_to_rentals_query_aggregate';
  aggregate?: Maybe<Fn_Get_User_Products_To_Rentals_Query_Aggregate_Fields>;
  nodes: Array<Fn_Get_User_Products_To_Rentals_Query>;
};

/** aggregate fields of "fn_get_user_products_to_rentals_query" */
export type Fn_Get_User_Products_To_Rentals_Query_Aggregate_Fields = {
  __typename?: 'fn_get_user_products_to_rentals_query_aggregate_fields';
  avg?: Maybe<Fn_Get_User_Products_To_Rentals_Query_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fn_Get_User_Products_To_Rentals_Query_Max_Fields>;
  min?: Maybe<Fn_Get_User_Products_To_Rentals_Query_Min_Fields>;
  stddev?: Maybe<Fn_Get_User_Products_To_Rentals_Query_Stddev_Fields>;
  stddev_pop?: Maybe<Fn_Get_User_Products_To_Rentals_Query_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fn_Get_User_Products_To_Rentals_Query_Stddev_Samp_Fields>;
  sum?: Maybe<Fn_Get_User_Products_To_Rentals_Query_Sum_Fields>;
  var_pop?: Maybe<Fn_Get_User_Products_To_Rentals_Query_Var_Pop_Fields>;
  var_samp?: Maybe<Fn_Get_User_Products_To_Rentals_Query_Var_Samp_Fields>;
  variance?: Maybe<Fn_Get_User_Products_To_Rentals_Query_Variance_Fields>;
};


/** aggregate fields of "fn_get_user_products_to_rentals_query" */
export type Fn_Get_User_Products_To_Rentals_Query_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Get_User_Products_To_Rentals_Query_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Fn_Get_User_Products_To_Rentals_Query_Avg_Fields = {
  __typename?: 'fn_get_user_products_to_rentals_query_avg_fields';
  products_cost?: Maybe<Scalars['Float']>;
  rentals_cost?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fn_get_user_products_to_rentals_query". All fields are combined with a logical 'AND'. */
export type Fn_Get_User_Products_To_Rentals_Query_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Get_User_Products_To_Rentals_Query_Bool_Exp>>;
  _not?: InputMaybe<Fn_Get_User_Products_To_Rentals_Query_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Get_User_Products_To_Rentals_Query_Bool_Exp>>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  products_cost?: InputMaybe<Numeric_Comparison_Exp>;
  rentals_cost?: InputMaybe<Numeric_Comparison_Exp>;
  user?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "fn_get_user_products_to_rentals_query" */
export enum Fn_Get_User_Products_To_Rentals_Query_Constraint {
  /** unique or primary key constraint on columns "user" */
  FnGetUserProductsToRentalsQueryPkey = 'fn_get_user_products_to_rentals_query_pkey'
}

/** input type for incrementing numeric columns in table "fn_get_user_products_to_rentals_query" */
export type Fn_Get_User_Products_To_Rentals_Query_Inc_Input = {
  products_cost?: InputMaybe<Scalars['numeric']>;
  rentals_cost?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "fn_get_user_products_to_rentals_query" */
export type Fn_Get_User_Products_To_Rentals_Query_Insert_Input = {
  location?: InputMaybe<Scalars['uuid']>;
  products_cost?: InputMaybe<Scalars['numeric']>;
  rentals_cost?: InputMaybe<Scalars['numeric']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Fn_Get_User_Products_To_Rentals_Query_Max_Fields = {
  __typename?: 'fn_get_user_products_to_rentals_query_max_fields';
  location?: Maybe<Scalars['uuid']>;
  products_cost?: Maybe<Scalars['numeric']>;
  rentals_cost?: Maybe<Scalars['numeric']>;
  user?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Fn_Get_User_Products_To_Rentals_Query_Min_Fields = {
  __typename?: 'fn_get_user_products_to_rentals_query_min_fields';
  location?: Maybe<Scalars['uuid']>;
  products_cost?: Maybe<Scalars['numeric']>;
  rentals_cost?: Maybe<Scalars['numeric']>;
  user?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "fn_get_user_products_to_rentals_query" */
export type Fn_Get_User_Products_To_Rentals_Query_Mutation_Response = {
  __typename?: 'fn_get_user_products_to_rentals_query_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fn_Get_User_Products_To_Rentals_Query>;
};

/** on_conflict condition type for table "fn_get_user_products_to_rentals_query" */
export type Fn_Get_User_Products_To_Rentals_Query_On_Conflict = {
  constraint: Fn_Get_User_Products_To_Rentals_Query_Constraint;
  update_columns?: Array<Fn_Get_User_Products_To_Rentals_Query_Update_Column>;
  where?: InputMaybe<Fn_Get_User_Products_To_Rentals_Query_Bool_Exp>;
};

/** Ordering options when selecting data from "fn_get_user_products_to_rentals_query". */
export type Fn_Get_User_Products_To_Rentals_Query_Order_By = {
  location?: InputMaybe<Order_By>;
  products_cost?: InputMaybe<Order_By>;
  rentals_cost?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fn_get_user_products_to_rentals_query */
export type Fn_Get_User_Products_To_Rentals_Query_Pk_Columns_Input = {
  user: Scalars['uuid'];
};

/** select columns of table "fn_get_user_products_to_rentals_query" */
export enum Fn_Get_User_Products_To_Rentals_Query_Select_Column {
  /** column name */
  Location = 'location',
  /** column name */
  ProductsCost = 'products_cost',
  /** column name */
  RentalsCost = 'rentals_cost',
  /** column name */
  User = 'user'
}

/** input type for updating data in table "fn_get_user_products_to_rentals_query" */
export type Fn_Get_User_Products_To_Rentals_Query_Set_Input = {
  location?: InputMaybe<Scalars['uuid']>;
  products_cost?: InputMaybe<Scalars['numeric']>;
  rentals_cost?: InputMaybe<Scalars['numeric']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Fn_Get_User_Products_To_Rentals_Query_Stddev_Fields = {
  __typename?: 'fn_get_user_products_to_rentals_query_stddev_fields';
  products_cost?: Maybe<Scalars['Float']>;
  rentals_cost?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Fn_Get_User_Products_To_Rentals_Query_Stddev_Pop_Fields = {
  __typename?: 'fn_get_user_products_to_rentals_query_stddev_pop_fields';
  products_cost?: Maybe<Scalars['Float']>;
  rentals_cost?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Fn_Get_User_Products_To_Rentals_Query_Stddev_Samp_Fields = {
  __typename?: 'fn_get_user_products_to_rentals_query_stddev_samp_fields';
  products_cost?: Maybe<Scalars['Float']>;
  rentals_cost?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fn_get_user_products_to_rentals_query" */
export type Fn_Get_User_Products_To_Rentals_Query_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Get_User_Products_To_Rentals_Query_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Get_User_Products_To_Rentals_Query_Stream_Cursor_Value_Input = {
  location?: InputMaybe<Scalars['uuid']>;
  products_cost?: InputMaybe<Scalars['numeric']>;
  rentals_cost?: InputMaybe<Scalars['numeric']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Fn_Get_User_Products_To_Rentals_Query_Sum_Fields = {
  __typename?: 'fn_get_user_products_to_rentals_query_sum_fields';
  products_cost?: Maybe<Scalars['numeric']>;
  rentals_cost?: Maybe<Scalars['numeric']>;
};

/** update columns of table "fn_get_user_products_to_rentals_query" */
export enum Fn_Get_User_Products_To_Rentals_Query_Update_Column {
  /** column name */
  Location = 'location',
  /** column name */
  ProductsCost = 'products_cost',
  /** column name */
  RentalsCost = 'rentals_cost',
  /** column name */
  User = 'user'
}

export type Fn_Get_User_Products_To_Rentals_Query_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fn_Get_User_Products_To_Rentals_Query_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fn_Get_User_Products_To_Rentals_Query_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fn_Get_User_Products_To_Rentals_Query_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fn_Get_User_Products_To_Rentals_Query_Var_Pop_Fields = {
  __typename?: 'fn_get_user_products_to_rentals_query_var_pop_fields';
  products_cost?: Maybe<Scalars['Float']>;
  rentals_cost?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Fn_Get_User_Products_To_Rentals_Query_Var_Samp_Fields = {
  __typename?: 'fn_get_user_products_to_rentals_query_var_samp_fields';
  products_cost?: Maybe<Scalars['Float']>;
  rentals_cost?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Fn_Get_User_Products_To_Rentals_Query_Variance_Fields = {
  __typename?: 'fn_get_user_products_to_rentals_query_variance_fields';
  products_cost?: Maybe<Scalars['Float']>;
  rentals_cost?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location = {
  __typename?: 'fn_users_unfulfilled_product_purchases_count_by_location';
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  unitsUnfulfilled: Scalars['bigint'];
  user: Scalars['uuid'];
  /** An object relationship */
  userByUser: User;
};

/** aggregated selection of "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Aggregate = {
  __typename?: 'fn_users_unfulfilled_product_purchases_count_by_location_aggregate';
  aggregate?: Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Aggregate_Fields>;
  nodes: Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location>;
};

export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Aggregate_Bool_Exp = {
  count?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Aggregate_Bool_Exp_Count>;
};

export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Aggregate_Fields = {
  __typename?: 'fn_users_unfulfilled_product_purchases_count_by_location_aggregate_fields';
  avg?: Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Max_Fields>;
  min?: Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Min_Fields>;
  stddev?: Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Stddev_Fields>;
  stddev_pop?: Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Stddev_Samp_Fields>;
  sum?: Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Sum_Fields>;
  var_pop?: Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Var_Pop_Fields>;
  var_samp?: Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Var_Samp_Fields>;
  variance?: Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Variance_Fields>;
};


/** aggregate fields of "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Aggregate_Order_By = {
  avg?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Max_Order_By>;
  min?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Min_Order_By>;
  stddev?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Sum_Order_By>;
  var_pop?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Var_Samp_Order_By>;
  variance?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Arr_Rel_Insert_Input = {
  data: Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_On_Conflict>;
};

/** aggregate avg on columns */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Avg_Fields = {
  __typename?: 'fn_users_unfulfilled_product_purchases_count_by_location_avg_fields';
  unitsUnfulfilled?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Avg_Order_By = {
  unitsUnfulfilled?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fn_users_unfulfilled_product_purchases_count_by_location". All fields are combined with a logical 'AND'. */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp>>;
  _not?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp>>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  unitsUnfulfilled?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Uuid_Comparison_Exp>;
  userByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "fn_users_unfulfilled_product_purchases_count_by_location" */
export enum Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Constraint {
  /** unique or primary key constraint on columns "user", "location" */
  FnUsersUnfulfilledProductPurchasesCountByLocationPkey = 'fn_users_unfulfilled_product_purchases_count_by_location_pkey'
}

/** input type for incrementing numeric columns in table "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Inc_Input = {
  unitsUnfulfilled?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Insert_Input = {
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  unitsUnfulfilled?: InputMaybe<Scalars['bigint']>;
  user?: InputMaybe<Scalars['uuid']>;
  userByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Max_Fields = {
  __typename?: 'fn_users_unfulfilled_product_purchases_count_by_location_max_fields';
  location?: Maybe<Scalars['uuid']>;
  unitsUnfulfilled?: Maybe<Scalars['bigint']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Max_Order_By = {
  location?: InputMaybe<Order_By>;
  unitsUnfulfilled?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Min_Fields = {
  __typename?: 'fn_users_unfulfilled_product_purchases_count_by_location_min_fields';
  location?: Maybe<Scalars['uuid']>;
  unitsUnfulfilled?: Maybe<Scalars['bigint']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Min_Order_By = {
  location?: InputMaybe<Order_By>;
  unitsUnfulfilled?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Mutation_Response = {
  __typename?: 'fn_users_unfulfilled_product_purchases_count_by_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location>;
};

/** on_conflict condition type for table "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_On_Conflict = {
  constraint: Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Constraint;
  update_columns?: Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Update_Column>;
  where?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp>;
};

/** Ordering options when selecting data from "fn_users_unfulfilled_product_purchases_count_by_location". */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Order_By = {
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  unitsUnfulfilled?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  userByUser?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: fn_users_unfulfilled_product_purchases_count_by_location */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Pk_Columns_Input = {
  location: Scalars['uuid'];
  user: Scalars['uuid'];
};

/** select columns of table "fn_users_unfulfilled_product_purchases_count_by_location" */
export enum Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Select_Column {
  /** column name */
  Location = 'location',
  /** column name */
  UnitsUnfulfilled = 'unitsUnfulfilled',
  /** column name */
  User = 'user'
}

/** input type for updating data in table "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Set_Input = {
  location?: InputMaybe<Scalars['uuid']>;
  unitsUnfulfilled?: InputMaybe<Scalars['bigint']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Stddev_Fields = {
  __typename?: 'fn_users_unfulfilled_product_purchases_count_by_location_stddev_fields';
  unitsUnfulfilled?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Stddev_Order_By = {
  unitsUnfulfilled?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Stddev_Pop_Fields = {
  __typename?: 'fn_users_unfulfilled_product_purchases_count_by_location_stddev_pop_fields';
  unitsUnfulfilled?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Stddev_Pop_Order_By = {
  unitsUnfulfilled?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Stddev_Samp_Fields = {
  __typename?: 'fn_users_unfulfilled_product_purchases_count_by_location_stddev_samp_fields';
  unitsUnfulfilled?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Stddev_Samp_Order_By = {
  unitsUnfulfilled?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Stream_Cursor_Value_Input = {
  location?: InputMaybe<Scalars['uuid']>;
  unitsUnfulfilled?: InputMaybe<Scalars['bigint']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Sum_Fields = {
  __typename?: 'fn_users_unfulfilled_product_purchases_count_by_location_sum_fields';
  unitsUnfulfilled?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Sum_Order_By = {
  unitsUnfulfilled?: InputMaybe<Order_By>;
};

/** update columns of table "fn_users_unfulfilled_product_purchases_count_by_location" */
export enum Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Update_Column {
  /** column name */
  Location = 'location',
  /** column name */
  UnitsUnfulfilled = 'unitsUnfulfilled',
  /** column name */
  User = 'user'
}

export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Var_Pop_Fields = {
  __typename?: 'fn_users_unfulfilled_product_purchases_count_by_location_var_pop_fields';
  unitsUnfulfilled?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Var_Pop_Order_By = {
  unitsUnfulfilled?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Var_Samp_Fields = {
  __typename?: 'fn_users_unfulfilled_product_purchases_count_by_location_var_samp_fields';
  unitsUnfulfilled?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Var_Samp_Order_By = {
  unitsUnfulfilled?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Variance_Fields = {
  __typename?: 'fn_users_unfulfilled_product_purchases_count_by_location_variance_fields';
  unitsUnfulfilled?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "fn_users_unfulfilled_product_purchases_count_by_location" */
export type Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Variance_Order_By = {
  unitsUnfulfilled?: InputMaybe<Order_By>;
};

/** columns and relationships of "gender" */
export type Gender = {
  __typename?: 'gender';
  gender: Scalars['String'];
};

/** aggregated selection of "gender" */
export type Gender_Aggregate = {
  __typename?: 'gender_aggregate';
  aggregate?: Maybe<Gender_Aggregate_Fields>;
  nodes: Array<Gender>;
};

/** aggregate fields of "gender" */
export type Gender_Aggregate_Fields = {
  __typename?: 'gender_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Gender_Max_Fields>;
  min?: Maybe<Gender_Min_Fields>;
};


/** aggregate fields of "gender" */
export type Gender_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gender_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "gender". All fields are combined with a logical 'AND'. */
export type Gender_Bool_Exp = {
  _and?: InputMaybe<Array<Gender_Bool_Exp>>;
  _not?: InputMaybe<Gender_Bool_Exp>;
  _or?: InputMaybe<Array<Gender_Bool_Exp>>;
  gender?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "gender" */
export enum Gender_Constraint {
  /** unique or primary key constraint on columns "gender" */
  GenderPkey = 'gender_pkey'
}

export enum Gender_Enum {
  Female = 'Female',
  Male = 'Male',
  NonBinary = 'Non_Binary',
  NotListed = 'Not_Listed',
  PreferNotToSay = 'Prefer_Not_To_Say',
  TransgenderFemale = 'Transgender_Female',
  TransgenderMale = 'Transgender_Male'
}

/** Boolean expression to compare columns of type "gender_enum". All fields are combined with logical 'AND'. */
export type Gender_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Gender_Enum>;
  _in?: InputMaybe<Array<Gender_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Gender_Enum>;
  _nin?: InputMaybe<Array<Gender_Enum>>;
};

/** input type for inserting data into table "gender" */
export type Gender_Insert_Input = {
  gender?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Gender_Max_Fields = {
  __typename?: 'gender_max_fields';
  gender?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Gender_Min_Fields = {
  __typename?: 'gender_min_fields';
  gender?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "gender" */
export type Gender_Mutation_Response = {
  __typename?: 'gender_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Gender>;
};

/** input type for inserting object relation for remote table "gender" */
export type Gender_Obj_Rel_Insert_Input = {
  data: Gender_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Gender_On_Conflict>;
};

/** on_conflict condition type for table "gender" */
export type Gender_On_Conflict = {
  constraint: Gender_Constraint;
  update_columns?: Array<Gender_Update_Column>;
  where?: InputMaybe<Gender_Bool_Exp>;
};

/** Ordering options when selecting data from "gender". */
export type Gender_Order_By = {
  gender?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gender */
export type Gender_Pk_Columns_Input = {
  gender: Scalars['String'];
};

/** select columns of table "gender" */
export enum Gender_Select_Column {
  /** column name */
  Gender = 'gender'
}

/** input type for updating data in table "gender" */
export type Gender_Set_Input = {
  gender?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "gender" */
export type Gender_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gender_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gender_Stream_Cursor_Value_Input = {
  gender?: InputMaybe<Scalars['String']>;
};

/** update columns of table "gender" */
export enum Gender_Update_Column {
  /** column name */
  Gender = 'gender'
}

export type Gender_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gender_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gender_Bool_Exp;
};

export type GetCognitoUserInput = {
  id: Scalars['uuid'];
};

export type GetCognitoUserOutput = {
  __typename?: 'getCognitoUserOutput';
  cognitoUserSub: Scalars['String'];
  email: Scalars['String'];
  email_verified: Scalars['Boolean'];
  id: Scalars['uuid'];
  phone: Scalars['String'];
  phone_verified: Scalars['Boolean'];
  user_status: Scalars['String'];
};

export type GetPatientTemplatesOutput = {
  __typename?: 'getPatientTemplatesOutput';
  templates: Array<PatientTemplate>;
};

export type Get_Active_Notification_Preferences_For_Type_And_Location_Args = {
  is_medspa?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['uuid']>;
  notification_type_param?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

export type Get_Active_Notification_Preferences_For_Type_Any_Location_Args = {
  location_id?: InputMaybe<Scalars['uuid']>;
  notification_type_param?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

export type Get_Active_Subscribers_Query_Args = {
  active_minimum?: InputMaybe<Scalars['interval']>;
  loc?: InputMaybe<Scalars['uuid']>;
  range_end?: InputMaybe<Scalars['timestamptz']>;
  range_start?: InputMaybe<Scalars['timestamptz']>;
};

export type Get_Cumulative_Location_Plans_Args = {
  base_location?: InputMaybe<Scalars['uuid']>;
};

export type Get_Location_Purchases_To_Provider_Purchases_Query_Args = {
  range_end?: InputMaybe<Scalars['timestamptz']>;
  range_start?: InputMaybe<Scalars['timestamptz']>;
};

export type Get_Stackable_Booking_Options_Data_Args = {
  calendar_timespan?: InputMaybe<Scalars['tstzrange']>;
  location_procedure_id?: InputMaybe<Scalars['uuid']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
};

export type Get_User_Booking_Options_Blockers_Args = {
  location_id?: InputMaybe<Scalars['uuid']>;
  location_procedure_id?: InputMaybe<Scalars['uuid']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  range_end?: InputMaybe<Scalars['timestamptz']>;
  range_start?: InputMaybe<Scalars['timestamptz']>;
};

export type Get_User_Products_To_Rentals_Query_Args = {
  invoice_location?: InputMaybe<Scalars['uuid']>;
  range_end?: InputMaybe<Scalars['timestamptz']>;
  range_start?: InputMaybe<Scalars['timestamptz']>;
};

/** Boolean expression to compare columns of type "interval". All fields are combined with logical 'AND'. */
export type Interval_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['interval']>;
  _gt?: InputMaybe<Scalars['interval']>;
  _gte?: InputMaybe<Scalars['interval']>;
  _in?: InputMaybe<Array<Scalars['interval']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['interval']>;
  _lte?: InputMaybe<Scalars['interval']>;
  _neq?: InputMaybe<Scalars['interval']>;
  _nin?: InputMaybe<Array<Scalars['interval']>>;
};

/** columns and relationships of "invoice" */
export type Invoice = {
  __typename?: 'invoice';
  amount_due: Scalars['Int'];
  amount_paid: Scalars['Int'];
  amount_remaining: Scalars['Int'];
  booking?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  bookingByBooking?: Maybe<Booking>;
  confirm_attempt_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  finalized_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  marked_uncollectable_at?: Maybe<Scalars['timestamptz']>;
  paid: Scalars['Boolean'];
  paid_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  productPurchases: Array<Product_Purchase>;
  /** An aggregate relationship */
  productPurchases_aggregate: Product_Purchase_Aggregate;
  starting_balance: Scalars['Int'];
  status: Scalars['String'];
  stripeId: Scalars['String'];
  stripe_data?: Maybe<Scalars['jsonb']>;
  stripe_hosted_invoice_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** doubles as "stripe deleted at" for draft invoices */
  voided_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "invoice" */
export type InvoiceProductPurchasesArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchase_Order_By>>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};


/** columns and relationships of "invoice" */
export type InvoiceProductPurchases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchase_Order_By>>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};


/** columns and relationships of "invoice" */
export type InvoiceStripe_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "invoice" */
export type Invoice_Aggregate = {
  __typename?: 'invoice_aggregate';
  aggregate?: Maybe<Invoice_Aggregate_Fields>;
  nodes: Array<Invoice>;
};

export type Invoice_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Invoice_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Invoice_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Invoice_Aggregate_Bool_Exp_Count>;
};

export type Invoice_Aggregate_Bool_Exp_Bool_And = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invoice" */
export type Invoice_Aggregate_Fields = {
  __typename?: 'invoice_aggregate_fields';
  avg?: Maybe<Invoice_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Invoice_Max_Fields>;
  min?: Maybe<Invoice_Min_Fields>;
  stddev?: Maybe<Invoice_Stddev_Fields>;
  stddev_pop?: Maybe<Invoice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoice_Stddev_Samp_Fields>;
  sum?: Maybe<Invoice_Sum_Fields>;
  var_pop?: Maybe<Invoice_Var_Pop_Fields>;
  var_samp?: Maybe<Invoice_Var_Samp_Fields>;
  variance?: Maybe<Invoice_Variance_Fields>;
};


/** aggregate fields of "invoice" */
export type Invoice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoice" */
export type Invoice_Aggregate_Order_By = {
  avg?: InputMaybe<Invoice_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invoice_Max_Order_By>;
  min?: InputMaybe<Invoice_Min_Order_By>;
  stddev?: InputMaybe<Invoice_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Invoice_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Invoice_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Invoice_Sum_Order_By>;
  var_pop?: InputMaybe<Invoice_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Invoice_Var_Samp_Order_By>;
  variance?: InputMaybe<Invoice_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Invoice_Append_Input = {
  stripe_data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "invoice" */
export type Invoice_Arr_Rel_Insert_Input = {
  data: Array<Invoice_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Invoice_On_Conflict>;
};

/** aggregate avg on columns */
export type Invoice_Avg_Fields = {
  __typename?: 'invoice_avg_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_paid?: Maybe<Scalars['Float']>;
  amount_remaining?: Maybe<Scalars['Float']>;
  starting_balance?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "invoice" */
export type Invoice_Avg_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
};

/** columns and relationships of "invoice_billing_summary" */
export type Invoice_Billing_Summary = {
  __typename?: 'invoice_billing_summary';
  address?: Maybe<Scalars['jsonb']>;
  booking?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  line_items?: Maybe<Array<Scalars['json']>>;
  phone?: Maybe<Scalars['jsonb']>;
  stripe_id?: Maybe<Scalars['jsonb']>;
  subtotal?: Maybe<Scalars['jsonb']>;
  tax?: Maybe<Scalars['jsonb']>;
  total?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "invoice_billing_summary" */
export type Invoice_Billing_SummaryAddressArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "invoice_billing_summary" */
export type Invoice_Billing_SummaryEmailArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "invoice_billing_summary" */
export type Invoice_Billing_SummaryPhoneArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "invoice_billing_summary" */
export type Invoice_Billing_SummaryStripe_IdArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "invoice_billing_summary" */
export type Invoice_Billing_SummarySubtotalArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "invoice_billing_summary" */
export type Invoice_Billing_SummaryTaxArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "invoice_billing_summary" */
export type Invoice_Billing_SummaryTotalArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "invoice_billing_summary" */
export type Invoice_Billing_Summary_Aggregate = {
  __typename?: 'invoice_billing_summary_aggregate';
  aggregate?: Maybe<Invoice_Billing_Summary_Aggregate_Fields>;
  nodes: Array<Invoice_Billing_Summary>;
};

/** aggregate fields of "invoice_billing_summary" */
export type Invoice_Billing_Summary_Aggregate_Fields = {
  __typename?: 'invoice_billing_summary_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Invoice_Billing_Summary_Max_Fields>;
  min?: Maybe<Invoice_Billing_Summary_Min_Fields>;
};


/** aggregate fields of "invoice_billing_summary" */
export type Invoice_Billing_Summary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoice_Billing_Summary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Invoice_Billing_Summary_Append_Input = {
  address?: InputMaybe<Scalars['jsonb']>;
  email?: InputMaybe<Scalars['jsonb']>;
  phone?: InputMaybe<Scalars['jsonb']>;
  stripe_id?: InputMaybe<Scalars['jsonb']>;
  subtotal?: InputMaybe<Scalars['jsonb']>;
  tax?: InputMaybe<Scalars['jsonb']>;
  total?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "invoice_billing_summary". All fields are combined with a logical 'AND'. */
export type Invoice_Billing_Summary_Bool_Exp = {
  _and?: InputMaybe<Array<Invoice_Billing_Summary_Bool_Exp>>;
  _not?: InputMaybe<Invoice_Billing_Summary_Bool_Exp>;
  _or?: InputMaybe<Array<Invoice_Billing_Summary_Bool_Exp>>;
  address?: InputMaybe<Jsonb_Comparison_Exp>;
  booking?: InputMaybe<Uuid_Comparison_Exp>;
  email?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  line_items?: InputMaybe<Json_Array_Comparison_Exp>;
  phone?: InputMaybe<Jsonb_Comparison_Exp>;
  stripe_id?: InputMaybe<Jsonb_Comparison_Exp>;
  subtotal?: InputMaybe<Jsonb_Comparison_Exp>;
  tax?: InputMaybe<Jsonb_Comparison_Exp>;
  total?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Invoice_Billing_Summary_Delete_At_Path_Input = {
  address?: InputMaybe<Array<Scalars['String']>>;
  email?: InputMaybe<Array<Scalars['String']>>;
  phone?: InputMaybe<Array<Scalars['String']>>;
  stripe_id?: InputMaybe<Array<Scalars['String']>>;
  subtotal?: InputMaybe<Array<Scalars['String']>>;
  tax?: InputMaybe<Array<Scalars['String']>>;
  total?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Invoice_Billing_Summary_Delete_Elem_Input = {
  address?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['Int']>;
  stripe_id?: InputMaybe<Scalars['Int']>;
  subtotal?: InputMaybe<Scalars['Int']>;
  tax?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Invoice_Billing_Summary_Delete_Key_Input = {
  address?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  stripe_id?: InputMaybe<Scalars['String']>;
  subtotal?: InputMaybe<Scalars['String']>;
  tax?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "invoice_billing_summary" */
export type Invoice_Billing_Summary_Insert_Input = {
  address?: InputMaybe<Scalars['jsonb']>;
  booking?: InputMaybe<Scalars['uuid']>;
  email?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  line_items?: InputMaybe<Array<Scalars['json']>>;
  phone?: InputMaybe<Scalars['jsonb']>;
  stripe_id?: InputMaybe<Scalars['jsonb']>;
  subtotal?: InputMaybe<Scalars['jsonb']>;
  tax?: InputMaybe<Scalars['jsonb']>;
  total?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Invoice_Billing_Summary_Max_Fields = {
  __typename?: 'invoice_billing_summary_max_fields';
  booking?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  line_items?: Maybe<Array<Scalars['json']>>;
};

/** aggregate min on columns */
export type Invoice_Billing_Summary_Min_Fields = {
  __typename?: 'invoice_billing_summary_min_fields';
  booking?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  line_items?: Maybe<Array<Scalars['json']>>;
};

/** response of any mutation on the table "invoice_billing_summary" */
export type Invoice_Billing_Summary_Mutation_Response = {
  __typename?: 'invoice_billing_summary_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoice_Billing_Summary>;
};

/** Ordering options when selecting data from "invoice_billing_summary". */
export type Invoice_Billing_Summary_Order_By = {
  address?: InputMaybe<Order_By>;
  booking?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line_items?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Invoice_Billing_Summary_Prepend_Input = {
  address?: InputMaybe<Scalars['jsonb']>;
  email?: InputMaybe<Scalars['jsonb']>;
  phone?: InputMaybe<Scalars['jsonb']>;
  stripe_id?: InputMaybe<Scalars['jsonb']>;
  subtotal?: InputMaybe<Scalars['jsonb']>;
  tax?: InputMaybe<Scalars['jsonb']>;
  total?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "invoice_billing_summary" */
export enum Invoice_Billing_Summary_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Booking = 'booking',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  LineItems = 'line_items',
  /** column name */
  Phone = 'phone',
  /** column name */
  StripeId = 'stripe_id',
  /** column name */
  Subtotal = 'subtotal',
  /** column name */
  Tax = 'tax',
  /** column name */
  Total = 'total'
}

/** input type for updating data in table "invoice_billing_summary" */
export type Invoice_Billing_Summary_Set_Input = {
  address?: InputMaybe<Scalars['jsonb']>;
  booking?: InputMaybe<Scalars['uuid']>;
  email?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  line_items?: InputMaybe<Array<Scalars['json']>>;
  phone?: InputMaybe<Scalars['jsonb']>;
  stripe_id?: InputMaybe<Scalars['jsonb']>;
  subtotal?: InputMaybe<Scalars['jsonb']>;
  tax?: InputMaybe<Scalars['jsonb']>;
  total?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "invoice_billing_summary" */
export type Invoice_Billing_Summary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoice_Billing_Summary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoice_Billing_Summary_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['jsonb']>;
  booking?: InputMaybe<Scalars['uuid']>;
  email?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  line_items?: InputMaybe<Array<Scalars['json']>>;
  phone?: InputMaybe<Scalars['jsonb']>;
  stripe_id?: InputMaybe<Scalars['jsonb']>;
  subtotal?: InputMaybe<Scalars['jsonb']>;
  tax?: InputMaybe<Scalars['jsonb']>;
  total?: InputMaybe<Scalars['jsonb']>;
};

export type Invoice_Billing_Summary_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Invoice_Billing_Summary_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Invoice_Billing_Summary_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Invoice_Billing_Summary_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Invoice_Billing_Summary_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Invoice_Billing_Summary_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invoice_Billing_Summary_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invoice_Billing_Summary_Bool_Exp;
};

/** Boolean expression to filter rows from the table "invoice". All fields are combined with a logical 'AND'. */
export type Invoice_Bool_Exp = {
  _and?: InputMaybe<Array<Invoice_Bool_Exp>>;
  _not?: InputMaybe<Invoice_Bool_Exp>;
  _or?: InputMaybe<Array<Invoice_Bool_Exp>>;
  amount_due?: InputMaybe<Int_Comparison_Exp>;
  amount_paid?: InputMaybe<Int_Comparison_Exp>;
  amount_remaining?: InputMaybe<Int_Comparison_Exp>;
  booking?: InputMaybe<Uuid_Comparison_Exp>;
  bookingByBooking?: InputMaybe<Booking_Bool_Exp>;
  confirm_attempt_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  finalized_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  marked_uncollectable_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  paid?: InputMaybe<Boolean_Comparison_Exp>;
  paid_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  productPurchases?: InputMaybe<Product_Purchase_Bool_Exp>;
  productPurchases_aggregate?: InputMaybe<Product_Purchase_Aggregate_Bool_Exp>;
  starting_balance?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  stripeId?: InputMaybe<String_Comparison_Exp>;
  stripe_data?: InputMaybe<Jsonb_Comparison_Exp>;
  stripe_hosted_invoice_url?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  voided_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "invoice" */
export enum Invoice_Constraint {
  /** unique or primary key constraint on columns "booking" */
  InvoiceOneLiveRowPerBooking = 'invoice_one_live_row_per_booking',
  /** unique or primary key constraint on columns "id" */
  InvoicePkey = 'invoice_pkey',
  /** unique or primary key constraint on columns "stripe_id" */
  InvoiceStripeIdKey = 'invoice_stripeId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Invoice_Delete_At_Path_Input = {
  stripe_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Invoice_Delete_Elem_Input = {
  stripe_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Invoice_Delete_Key_Input = {
  stripe_data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "invoice" */
export type Invoice_Inc_Input = {
  amount_due?: InputMaybe<Scalars['Int']>;
  amount_paid?: InputMaybe<Scalars['Int']>;
  amount_remaining?: InputMaybe<Scalars['Int']>;
  starting_balance?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "invoice" */
export type Invoice_Insert_Input = {
  amount_due?: InputMaybe<Scalars['Int']>;
  amount_paid?: InputMaybe<Scalars['Int']>;
  amount_remaining?: InputMaybe<Scalars['Int']>;
  booking?: InputMaybe<Scalars['uuid']>;
  bookingByBooking?: InputMaybe<Booking_Obj_Rel_Insert_Input>;
  confirm_attempt_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  finalized_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  marked_uncollectable_at?: InputMaybe<Scalars['timestamptz']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  paid_at?: InputMaybe<Scalars['timestamptz']>;
  productPurchases?: InputMaybe<Product_Purchase_Arr_Rel_Insert_Input>;
  starting_balance?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  stripeId?: InputMaybe<Scalars['String']>;
  stripe_data?: InputMaybe<Scalars['jsonb']>;
  stripe_hosted_invoice_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  /** doubles as "stripe deleted at" for draft invoices */
  voided_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Invoice_Max_Fields = {
  __typename?: 'invoice_max_fields';
  amount_due?: Maybe<Scalars['Int']>;
  amount_paid?: Maybe<Scalars['Int']>;
  amount_remaining?: Maybe<Scalars['Int']>;
  booking?: Maybe<Scalars['uuid']>;
  confirm_attempt_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  finalized_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  marked_uncollectable_at?: Maybe<Scalars['timestamptz']>;
  paid_at?: Maybe<Scalars['timestamptz']>;
  starting_balance?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripe_hosted_invoice_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** doubles as "stripe deleted at" for draft invoices */
  voided_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "invoice" */
export type Invoice_Max_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  booking?: InputMaybe<Order_By>;
  confirm_attempt_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  finalized_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  marked_uncollectable_at?: InputMaybe<Order_By>;
  paid_at?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripeId?: InputMaybe<Order_By>;
  stripe_hosted_invoice_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  /** doubles as "stripe deleted at" for draft invoices */
  voided_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invoice_Min_Fields = {
  __typename?: 'invoice_min_fields';
  amount_due?: Maybe<Scalars['Int']>;
  amount_paid?: Maybe<Scalars['Int']>;
  amount_remaining?: Maybe<Scalars['Int']>;
  booking?: Maybe<Scalars['uuid']>;
  confirm_attempt_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  finalized_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  marked_uncollectable_at?: Maybe<Scalars['timestamptz']>;
  paid_at?: Maybe<Scalars['timestamptz']>;
  starting_balance?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  stripe_hosted_invoice_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** doubles as "stripe deleted at" for draft invoices */
  voided_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "invoice" */
export type Invoice_Min_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  booking?: InputMaybe<Order_By>;
  confirm_attempt_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  finalized_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  marked_uncollectable_at?: InputMaybe<Order_By>;
  paid_at?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripeId?: InputMaybe<Order_By>;
  stripe_hosted_invoice_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  /** doubles as "stripe deleted at" for draft invoices */
  voided_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "invoice" */
export type Invoice_Mutation_Response = {
  __typename?: 'invoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoice>;
};

/** input type for inserting object relation for remote table "invoice" */
export type Invoice_Obj_Rel_Insert_Input = {
  data: Invoice_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Invoice_On_Conflict>;
};

/** on_conflict condition type for table "invoice" */
export type Invoice_On_Conflict = {
  constraint: Invoice_Constraint;
  update_columns?: Array<Invoice_Update_Column>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};

/** Ordering options when selecting data from "invoice". */
export type Invoice_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  booking?: InputMaybe<Order_By>;
  bookingByBooking?: InputMaybe<Booking_Order_By>;
  confirm_attempt_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  finalized_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  marked_uncollectable_at?: InputMaybe<Order_By>;
  paid?: InputMaybe<Order_By>;
  paid_at?: InputMaybe<Order_By>;
  productPurchases_aggregate?: InputMaybe<Product_Purchase_Aggregate_Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripeId?: InputMaybe<Order_By>;
  stripe_data?: InputMaybe<Order_By>;
  stripe_hosted_invoice_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  voided_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invoice */
export type Invoice_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Invoice_Prepend_Input = {
  stripe_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "invoice" */
export enum Invoice_Select_Column {
  /** column name */
  AmountDue = 'amount_due',
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  AmountRemaining = 'amount_remaining',
  /** column name */
  Booking = 'booking',
  /** column name */
  ConfirmAttemptAt = 'confirm_attempt_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FinalizedAt = 'finalized_at',
  /** column name */
  Id = 'id',
  /** column name */
  MarkedUncollectableAt = 'marked_uncollectable_at',
  /** column name */
  Paid = 'paid',
  /** column name */
  PaidAt = 'paid_at',
  /** column name */
  StartingBalance = 'starting_balance',
  /** column name */
  Status = 'status',
  /** column name */
  StripeId = 'stripeId',
  /** column name */
  StripeData = 'stripe_data',
  /** column name */
  StripeHostedInvoiceUrl = 'stripe_hosted_invoice_url',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VoidedAt = 'voided_at'
}

/** select "invoice_aggregate_bool_exp_bool_and_arguments_columns" columns of table "invoice" */
export enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Paid = 'paid'
}

/** select "invoice_aggregate_bool_exp_bool_or_arguments_columns" columns of table "invoice" */
export enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Paid = 'paid'
}

/** input type for updating data in table "invoice" */
export type Invoice_Set_Input = {
  amount_due?: InputMaybe<Scalars['Int']>;
  amount_paid?: InputMaybe<Scalars['Int']>;
  amount_remaining?: InputMaybe<Scalars['Int']>;
  booking?: InputMaybe<Scalars['uuid']>;
  confirm_attempt_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  finalized_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  marked_uncollectable_at?: InputMaybe<Scalars['timestamptz']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  paid_at?: InputMaybe<Scalars['timestamptz']>;
  starting_balance?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  stripeId?: InputMaybe<Scalars['String']>;
  stripe_data?: InputMaybe<Scalars['jsonb']>;
  stripe_hosted_invoice_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  /** doubles as "stripe deleted at" for draft invoices */
  voided_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Invoice_Stddev_Fields = {
  __typename?: 'invoice_stddev_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_paid?: Maybe<Scalars['Float']>;
  amount_remaining?: Maybe<Scalars['Float']>;
  starting_balance?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "invoice" */
export type Invoice_Stddev_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Invoice_Stddev_Pop_Fields = {
  __typename?: 'invoice_stddev_pop_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_paid?: Maybe<Scalars['Float']>;
  amount_remaining?: Maybe<Scalars['Float']>;
  starting_balance?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "invoice" */
export type Invoice_Stddev_Pop_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Invoice_Stddev_Samp_Fields = {
  __typename?: 'invoice_stddev_samp_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_paid?: Maybe<Scalars['Float']>;
  amount_remaining?: Maybe<Scalars['Float']>;
  starting_balance?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "invoice" */
export type Invoice_Stddev_Samp_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "invoice" */
export type Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoice_Stream_Cursor_Value_Input = {
  amount_due?: InputMaybe<Scalars['Int']>;
  amount_paid?: InputMaybe<Scalars['Int']>;
  amount_remaining?: InputMaybe<Scalars['Int']>;
  booking?: InputMaybe<Scalars['uuid']>;
  confirm_attempt_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  finalized_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  marked_uncollectable_at?: InputMaybe<Scalars['timestamptz']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  paid_at?: InputMaybe<Scalars['timestamptz']>;
  starting_balance?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  stripeId?: InputMaybe<Scalars['String']>;
  stripe_data?: InputMaybe<Scalars['jsonb']>;
  stripe_hosted_invoice_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  /** doubles as "stripe deleted at" for draft invoices */
  voided_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Invoice_Sum_Fields = {
  __typename?: 'invoice_sum_fields';
  amount_due?: Maybe<Scalars['Int']>;
  amount_paid?: Maybe<Scalars['Int']>;
  amount_remaining?: Maybe<Scalars['Int']>;
  starting_balance?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "invoice" */
export type Invoice_Sum_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
};

/** update columns of table "invoice" */
export enum Invoice_Update_Column {
  /** column name */
  AmountDue = 'amount_due',
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  AmountRemaining = 'amount_remaining',
  /** column name */
  Booking = 'booking',
  /** column name */
  ConfirmAttemptAt = 'confirm_attempt_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FinalizedAt = 'finalized_at',
  /** column name */
  Id = 'id',
  /** column name */
  MarkedUncollectableAt = 'marked_uncollectable_at',
  /** column name */
  Paid = 'paid',
  /** column name */
  PaidAt = 'paid_at',
  /** column name */
  StartingBalance = 'starting_balance',
  /** column name */
  Status = 'status',
  /** column name */
  StripeId = 'stripeId',
  /** column name */
  StripeData = 'stripe_data',
  /** column name */
  StripeHostedInvoiceUrl = 'stripe_hosted_invoice_url',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VoidedAt = 'voided_at'
}

export type Invoice_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Invoice_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Invoice_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Invoice_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Invoice_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Invoice_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Invoice_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invoice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invoice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Invoice_Var_Pop_Fields = {
  __typename?: 'invoice_var_pop_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_paid?: Maybe<Scalars['Float']>;
  amount_remaining?: Maybe<Scalars['Float']>;
  starting_balance?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "invoice" */
export type Invoice_Var_Pop_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Invoice_Var_Samp_Fields = {
  __typename?: 'invoice_var_samp_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_paid?: Maybe<Scalars['Float']>;
  amount_remaining?: Maybe<Scalars['Float']>;
  starting_balance?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "invoice" */
export type Invoice_Var_Samp_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Invoice_Variance_Fields = {
  __typename?: 'invoice_variance_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_paid?: Maybe<Scalars['Float']>;
  amount_remaining?: Maybe<Scalars['Float']>;
  starting_balance?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "invoice" */
export type Invoice_Variance_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['json']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['json']>>;
  _eq?: InputMaybe<Array<Scalars['json']>>;
  _gt?: InputMaybe<Array<Scalars['json']>>;
  _gte?: InputMaybe<Array<Scalars['json']>>;
  _in?: InputMaybe<Array<Array<Scalars['json']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['json']>>;
  _lte?: InputMaybe<Array<Scalars['json']>>;
  _neq?: InputMaybe<Array<Scalars['json']>>;
  _nin?: InputMaybe<Array<Array<Scalars['json']>>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the jsonpath return any item for the specified JSON value */
  _jsonb_path_exists?: InputMaybe<Scalars['String']>;
  /** does the jsonpath predicate check return true for the specified JSON value */
  _jsonb_path_match?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "location" */
export type Location = {
  __typename?: 'location';
  address: Scalars['uuid'];
  /** An object relationship */
  addressByAddress: Address;
  allowResourceFree: Scalars['Boolean'];
  /** As it sounds, if not providers can only purchase products (enforced only in the app UI currently) */
  bookingAllowed: Scalars['Boolean'];
  /** An array relationship */
  childLocationByLocation: Array<Location>;
  /** An aggregate relationship */
  childLocationByLocation_aggregate: Location_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** When true, a provider must have uploaded a License document to book at this location. */
  licenseDocumentRequired: Scalars['Boolean'];
  /** When true, a provider must have a non-expired license_expiration to book at this location. */
  licenseExpirationRequired: Scalars['Boolean'];
  /** An array relationship */
  location_products: Array<Location_Product>;
  /** An aggregate relationship */
  location_products_aggregate: Location_Product_Aggregate;
  /** When true, a provider must have a current Malpractice document and a non-expired malpractice_expiration to book at this location. */
  malpracticeRequired: Scalars['Boolean'];
  /** When true (and the accreditation is not privileged to book without a director), a provider must have uploaded a Medical Director document to book at this location. */
  medicalDirectorRequired: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  opens: Array<Open>;
  /** An aggregate relationship */
  opens_aggregate: Open_Aggregate;
  parentLocation?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  parentLocationByLocation?: Maybe<Location>;
  partner: Scalars['uuid'];
  /** An object relationship */
  partnerByPartner: Partner;
  /** An array relationship */
  patients: Array<Patient>;
  /** An aggregate relationship */
  patients_aggregate: Patient_Aggregate;
  /** An array relationship */
  planByPlan: Array<Plan>;
  /** An aggregate relationship */
  planByPlan_aggregate: Plan_Aggregate;
  /** An array relationship */
  product_purchases: Array<Product_Purchase>;
  /** An aggregate relationship */
  product_purchases_aggregate: Product_Purchase_Aggregate;
  /** Whether provider product purchases are directly against the vendor (with markup) rather than from the MSO.  This *does not* have any implications for whether providers can make bookings. */
  providerDirectProductPurchase: Scalars['Boolean'];
  providerDirectPurchaseProfitMargin?: Maybe<Scalars['Int']>;
  /** Whether a plan is required to use the app.  The use cases for no are typically Medspa and locations where providers do not book appointments. */
  providerPlanRequired: Scalars['Boolean'];
  /** An array relationship */
  rooms: Array<Room>;
  /** An aggregate relationship */
  rooms_aggregate: Room_Aggregate;
  /** An array relationship */
  tax_rates: Array<Tax_Rate>;
  /** An aggregate relationship */
  tax_rates_aggregate: Tax_Rate_Aggregate;
  timezone: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_locations: Array<User_Location>;
  /** An aggregate relationship */
  user_locations_aggregate: User_Location_Aggregate;
  usesParentLocationPlans: Scalars['Boolean'];
  validSlotDurations: Array<Scalars['Int']>;
};


/** columns and relationships of "location" */
export type LocationChildLocationByLocationArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationChildLocationByLocation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationLocation_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Location_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Product_Order_By>>;
  where?: InputMaybe<Location_Product_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationLocation_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Product_Order_By>>;
  where?: InputMaybe<Location_Product_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationOpensArgs = {
  distinct_on?: InputMaybe<Array<Open_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Open_Order_By>>;
  where?: InputMaybe<Open_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationOpens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Open_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Open_Order_By>>;
  where?: InputMaybe<Open_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationPatientsArgs = {
  distinct_on?: InputMaybe<Array<Patient_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Order_By>>;
  where?: InputMaybe<Patient_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationPatients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Order_By>>;
  where?: InputMaybe<Patient_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationPlanByPlanArgs = {
  distinct_on?: InputMaybe<Array<Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationPlanByPlan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationProduct_PurchasesArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchase_Order_By>>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationProduct_Purchases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchase_Order_By>>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationRoomsArgs = {
  distinct_on?: InputMaybe<Array<Room_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Order_By>>;
  where?: InputMaybe<Room_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationRooms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Room_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Order_By>>;
  where?: InputMaybe<Room_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationTax_RatesArgs = {
  distinct_on?: InputMaybe<Array<Tax_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tax_Rate_Order_By>>;
  where?: InputMaybe<Tax_Rate_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationTax_Rates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tax_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tax_Rate_Order_By>>;
  where?: InputMaybe<Tax_Rate_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationUser_LocationsArgs = {
  distinct_on?: InputMaybe<Array<User_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Location_Order_By>>;
  where?: InputMaybe<User_Location_Bool_Exp>;
};


/** columns and relationships of "location" */
export type LocationUser_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Location_Order_By>>;
  where?: InputMaybe<User_Location_Bool_Exp>;
};

/** aggregated selection of "location" */
export type Location_Aggregate = {
  __typename?: 'location_aggregate';
  aggregate?: Maybe<Location_Aggregate_Fields>;
  nodes: Array<Location>;
};

export type Location_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Location_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Location_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Location_Aggregate_Bool_Exp_Count>;
};

export type Location_Aggregate_Bool_Exp_Bool_And = {
  arguments: Location_Select_Column_Location_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Location_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Location_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Location_Select_Column_Location_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Location_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Location_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Location_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "location" */
export type Location_Aggregate_Fields = {
  __typename?: 'location_aggregate_fields';
  avg?: Maybe<Location_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Location_Max_Fields>;
  min?: Maybe<Location_Min_Fields>;
  stddev?: Maybe<Location_Stddev_Fields>;
  stddev_pop?: Maybe<Location_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Location_Stddev_Samp_Fields>;
  sum?: Maybe<Location_Sum_Fields>;
  var_pop?: Maybe<Location_Var_Pop_Fields>;
  var_samp?: Maybe<Location_Var_Samp_Fields>;
  variance?: Maybe<Location_Variance_Fields>;
};


/** aggregate fields of "location" */
export type Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "location" */
export type Location_Aggregate_Order_By = {
  avg?: InputMaybe<Location_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Location_Max_Order_By>;
  min?: InputMaybe<Location_Min_Order_By>;
  stddev?: InputMaybe<Location_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Location_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Location_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Location_Sum_Order_By>;
  var_pop?: InputMaybe<Location_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Location_Var_Samp_Order_By>;
  variance?: InputMaybe<Location_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "location" */
export type Location_Arr_Rel_Insert_Input = {
  data: Array<Location_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Location_On_Conflict>;
};

/** aggregate avg on columns */
export type Location_Avg_Fields = {
  __typename?: 'location_avg_fields';
  providerDirectPurchaseProfitMargin?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "location" */
export type Location_Avg_Order_By = {
  providerDirectPurchaseProfitMargin?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "location". All fields are combined with a logical 'AND'. */
export type Location_Bool_Exp = {
  _and?: InputMaybe<Array<Location_Bool_Exp>>;
  _not?: InputMaybe<Location_Bool_Exp>;
  _or?: InputMaybe<Array<Location_Bool_Exp>>;
  address?: InputMaybe<Uuid_Comparison_Exp>;
  addressByAddress?: InputMaybe<Address_Bool_Exp>;
  allowResourceFree?: InputMaybe<Boolean_Comparison_Exp>;
  bookingAllowed?: InputMaybe<Boolean_Comparison_Exp>;
  childLocationByLocation?: InputMaybe<Location_Bool_Exp>;
  childLocationByLocation_aggregate?: InputMaybe<Location_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  licenseDocumentRequired?: InputMaybe<Boolean_Comparison_Exp>;
  licenseExpirationRequired?: InputMaybe<Boolean_Comparison_Exp>;
  location_products?: InputMaybe<Location_Product_Bool_Exp>;
  location_products_aggregate?: InputMaybe<Location_Product_Aggregate_Bool_Exp>;
  malpracticeRequired?: InputMaybe<Boolean_Comparison_Exp>;
  medicalDirectorRequired?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  opens?: InputMaybe<Open_Bool_Exp>;
  opens_aggregate?: InputMaybe<Open_Aggregate_Bool_Exp>;
  parentLocation?: InputMaybe<Uuid_Comparison_Exp>;
  parentLocationByLocation?: InputMaybe<Location_Bool_Exp>;
  partner?: InputMaybe<Uuid_Comparison_Exp>;
  partnerByPartner?: InputMaybe<Partner_Bool_Exp>;
  patients?: InputMaybe<Patient_Bool_Exp>;
  patients_aggregate?: InputMaybe<Patient_Aggregate_Bool_Exp>;
  planByPlan?: InputMaybe<Plan_Bool_Exp>;
  planByPlan_aggregate?: InputMaybe<Plan_Aggregate_Bool_Exp>;
  product_purchases?: InputMaybe<Product_Purchase_Bool_Exp>;
  product_purchases_aggregate?: InputMaybe<Product_Purchase_Aggregate_Bool_Exp>;
  providerDirectProductPurchase?: InputMaybe<Boolean_Comparison_Exp>;
  providerDirectPurchaseProfitMargin?: InputMaybe<Int_Comparison_Exp>;
  providerPlanRequired?: InputMaybe<Boolean_Comparison_Exp>;
  rooms?: InputMaybe<Room_Bool_Exp>;
  rooms_aggregate?: InputMaybe<Room_Aggregate_Bool_Exp>;
  tax_rates?: InputMaybe<Tax_Rate_Bool_Exp>;
  tax_rates_aggregate?: InputMaybe<Tax_Rate_Aggregate_Bool_Exp>;
  timezone?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_locations?: InputMaybe<User_Location_Bool_Exp>;
  user_locations_aggregate?: InputMaybe<User_Location_Aggregate_Bool_Exp>;
  usesParentLocationPlans?: InputMaybe<Boolean_Comparison_Exp>;
  validSlotDurations?: InputMaybe<Int_Array_Comparison_Exp>;
};

/** unique or primary key constraints on table "location" */
export enum Location_Constraint {
  /** unique or primary key constraint on columns "address" */
  LocationAddressKey = 'location_address_key',
  /** unique or primary key constraint on columns "name" */
  LocationNameKey = 'location_name_key',
  /** unique or primary key constraint on columns "id" */
  OfficePkey = 'office_pkey'
}

/** input type for incrementing numeric columns in table "location" */
export type Location_Inc_Input = {
  providerDirectPurchaseProfitMargin?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "location" */
export type Location_Insert_Input = {
  address?: InputMaybe<Scalars['uuid']>;
  addressByAddress?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  allowResourceFree?: InputMaybe<Scalars['Boolean']>;
  /** As it sounds, if not providers can only purchase products (enforced only in the app UI currently) */
  bookingAllowed?: InputMaybe<Scalars['Boolean']>;
  childLocationByLocation?: InputMaybe<Location_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** When true, a provider must have uploaded a License document to book at this location. */
  licenseDocumentRequired?: InputMaybe<Scalars['Boolean']>;
  /** When true, a provider must have a non-expired license_expiration to book at this location. */
  licenseExpirationRequired?: InputMaybe<Scalars['Boolean']>;
  location_products?: InputMaybe<Location_Product_Arr_Rel_Insert_Input>;
  /** When true, a provider must have a current Malpractice document and a non-expired malpractice_expiration to book at this location. */
  malpracticeRequired?: InputMaybe<Scalars['Boolean']>;
  /** When true (and the accreditation is not privileged to book without a director), a provider must have uploaded a Medical Director document to book at this location. */
  medicalDirectorRequired?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  opens?: InputMaybe<Open_Arr_Rel_Insert_Input>;
  parentLocation?: InputMaybe<Scalars['uuid']>;
  parentLocationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  partner?: InputMaybe<Scalars['uuid']>;
  partnerByPartner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  patients?: InputMaybe<Patient_Arr_Rel_Insert_Input>;
  planByPlan?: InputMaybe<Plan_Arr_Rel_Insert_Input>;
  product_purchases?: InputMaybe<Product_Purchase_Arr_Rel_Insert_Input>;
  /** Whether provider product purchases are directly against the vendor (with markup) rather than from the MSO.  This *does not* have any implications for whether providers can make bookings. */
  providerDirectProductPurchase?: InputMaybe<Scalars['Boolean']>;
  providerDirectPurchaseProfitMargin?: InputMaybe<Scalars['Int']>;
  /** Whether a plan is required to use the app.  The use cases for no are typically Medspa and locations where providers do not book appointments. */
  providerPlanRequired?: InputMaybe<Scalars['Boolean']>;
  rooms?: InputMaybe<Room_Arr_Rel_Insert_Input>;
  tax_rates?: InputMaybe<Tax_Rate_Arr_Rel_Insert_Input>;
  timezone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_locations?: InputMaybe<User_Location_Arr_Rel_Insert_Input>;
  usesParentLocationPlans?: InputMaybe<Scalars['Boolean']>;
  validSlotDurations?: InputMaybe<Array<Scalars['Int']>>;
};

/** aggregate max on columns */
export type Location_Max_Fields = {
  __typename?: 'location_max_fields';
  address?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parentLocation?: Maybe<Scalars['uuid']>;
  partner?: Maybe<Scalars['uuid']>;
  providerDirectPurchaseProfitMargin?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  validSlotDurations?: Maybe<Array<Scalars['Int']>>;
};

/** order by max() on columns of table "location" */
export type Location_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parentLocation?: InputMaybe<Order_By>;
  partner?: InputMaybe<Order_By>;
  providerDirectPurchaseProfitMargin?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  validSlotDurations?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Location_Min_Fields = {
  __typename?: 'location_min_fields';
  address?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parentLocation?: Maybe<Scalars['uuid']>;
  partner?: Maybe<Scalars['uuid']>;
  providerDirectPurchaseProfitMargin?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  validSlotDurations?: Maybe<Array<Scalars['Int']>>;
};

/** order by min() on columns of table "location" */
export type Location_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parentLocation?: InputMaybe<Order_By>;
  partner?: InputMaybe<Order_By>;
  providerDirectPurchaseProfitMargin?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  validSlotDurations?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "location" */
export type Location_Mutation_Response = {
  __typename?: 'location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Location>;
};

/** input type for inserting object relation for remote table "location" */
export type Location_Obj_Rel_Insert_Input = {
  data: Location_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Location_On_Conflict>;
};

/** on_conflict condition type for table "location" */
export type Location_On_Conflict = {
  constraint: Location_Constraint;
  update_columns?: Array<Location_Update_Column>;
  where?: InputMaybe<Location_Bool_Exp>;
};

/** Ordering options when selecting data from "location". */
export type Location_Order_By = {
  address?: InputMaybe<Order_By>;
  addressByAddress?: InputMaybe<Address_Order_By>;
  allowResourceFree?: InputMaybe<Order_By>;
  bookingAllowed?: InputMaybe<Order_By>;
  childLocationByLocation_aggregate?: InputMaybe<Location_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  licenseDocumentRequired?: InputMaybe<Order_By>;
  licenseExpirationRequired?: InputMaybe<Order_By>;
  location_products_aggregate?: InputMaybe<Location_Product_Aggregate_Order_By>;
  malpracticeRequired?: InputMaybe<Order_By>;
  medicalDirectorRequired?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  opens_aggregate?: InputMaybe<Open_Aggregate_Order_By>;
  parentLocation?: InputMaybe<Order_By>;
  parentLocationByLocation?: InputMaybe<Location_Order_By>;
  partner?: InputMaybe<Order_By>;
  partnerByPartner?: InputMaybe<Partner_Order_By>;
  patients_aggregate?: InputMaybe<Patient_Aggregate_Order_By>;
  planByPlan_aggregate?: InputMaybe<Plan_Aggregate_Order_By>;
  product_purchases_aggregate?: InputMaybe<Product_Purchase_Aggregate_Order_By>;
  providerDirectProductPurchase?: InputMaybe<Order_By>;
  providerDirectPurchaseProfitMargin?: InputMaybe<Order_By>;
  providerPlanRequired?: InputMaybe<Order_By>;
  rooms_aggregate?: InputMaybe<Room_Aggregate_Order_By>;
  tax_rates_aggregate?: InputMaybe<Tax_Rate_Aggregate_Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_locations_aggregate?: InputMaybe<User_Location_Aggregate_Order_By>;
  usesParentLocationPlans?: InputMaybe<Order_By>;
  validSlotDurations?: InputMaybe<Order_By>;
};

/** primary key columns input for table: location */
export type Location_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "location_procedure" */
export type Location_Procedure = {
  __typename?: 'location_procedure';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  /** An array relationship */
  location_procedure_rooms: Array<Location_Procedure_Room>;
  /** An aggregate relationship */
  location_procedure_rooms_aggregate: Location_Procedure_Room_Aggregate;
  procedure: Scalars['uuid'];
  /** An object relationship */
  procedureByProcedure: Procedure;
  /** An array relationship */
  provider_procedures: Array<Provider_Procedure>;
  /** An aggregate relationship */
  provider_procedures_aggregate: Provider_Procedure_Aggregate;
};


/** columns and relationships of "location_procedure" */
export type Location_ProcedureLocation_Procedure_RoomsArgs = {
  distinct_on?: InputMaybe<Array<Location_Procedure_Room_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Procedure_Room_Order_By>>;
  where?: InputMaybe<Location_Procedure_Room_Bool_Exp>;
};


/** columns and relationships of "location_procedure" */
export type Location_ProcedureLocation_Procedure_Rooms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Procedure_Room_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Procedure_Room_Order_By>>;
  where?: InputMaybe<Location_Procedure_Room_Bool_Exp>;
};


/** columns and relationships of "location_procedure" */
export type Location_ProcedureProvider_ProceduresArgs = {
  distinct_on?: InputMaybe<Array<Provider_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Procedure_Order_By>>;
  where?: InputMaybe<Provider_Procedure_Bool_Exp>;
};


/** columns and relationships of "location_procedure" */
export type Location_ProcedureProvider_Procedures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Procedure_Order_By>>;
  where?: InputMaybe<Provider_Procedure_Bool_Exp>;
};

/** aggregated selection of "location_procedure" */
export type Location_Procedure_Aggregate = {
  __typename?: 'location_procedure_aggregate';
  aggregate?: Maybe<Location_Procedure_Aggregate_Fields>;
  nodes: Array<Location_Procedure>;
};

export type Location_Procedure_Aggregate_Bool_Exp = {
  count?: InputMaybe<Location_Procedure_Aggregate_Bool_Exp_Count>;
};

export type Location_Procedure_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Location_Procedure_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Location_Procedure_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "location_procedure" */
export type Location_Procedure_Aggregate_Fields = {
  __typename?: 'location_procedure_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Location_Procedure_Max_Fields>;
  min?: Maybe<Location_Procedure_Min_Fields>;
};


/** aggregate fields of "location_procedure" */
export type Location_Procedure_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Location_Procedure_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "location_procedure" */
export type Location_Procedure_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Location_Procedure_Max_Order_By>;
  min?: InputMaybe<Location_Procedure_Min_Order_By>;
};

/** input type for inserting array relation for remote table "location_procedure" */
export type Location_Procedure_Arr_Rel_Insert_Input = {
  data: Array<Location_Procedure_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Location_Procedure_On_Conflict>;
};

/** Boolean expression to filter rows from the table "location_procedure". All fields are combined with a logical 'AND'. */
export type Location_Procedure_Bool_Exp = {
  _and?: InputMaybe<Array<Location_Procedure_Bool_Exp>>;
  _not?: InputMaybe<Location_Procedure_Bool_Exp>;
  _or?: InputMaybe<Array<Location_Procedure_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  location_procedure_rooms?: InputMaybe<Location_Procedure_Room_Bool_Exp>;
  location_procedure_rooms_aggregate?: InputMaybe<Location_Procedure_Room_Aggregate_Bool_Exp>;
  procedure?: InputMaybe<Uuid_Comparison_Exp>;
  procedureByProcedure?: InputMaybe<Procedure_Bool_Exp>;
  provider_procedures?: InputMaybe<Provider_Procedure_Bool_Exp>;
  provider_procedures_aggregate?: InputMaybe<Provider_Procedure_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "location_procedure" */
export enum Location_Procedure_Constraint {
  /** unique or primary key constraint on columns "procedure", "location" */
  LocationProcedureIndex = 'location_procedure_index',
  /** unique or primary key constraint on columns "id" */
  LocationProcedurePkey = 'location_procedure_pkey'
}

/** input type for inserting data into table "location_procedure" */
export type Location_Procedure_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  location_procedure_rooms?: InputMaybe<Location_Procedure_Room_Arr_Rel_Insert_Input>;
  procedure?: InputMaybe<Scalars['uuid']>;
  procedureByProcedure?: InputMaybe<Procedure_Obj_Rel_Insert_Input>;
  provider_procedures?: InputMaybe<Provider_Procedure_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Location_Procedure_Max_Fields = {
  __typename?: 'location_procedure_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  procedure?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "location_procedure" */
export type Location_Procedure_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  procedure?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Location_Procedure_Min_Fields = {
  __typename?: 'location_procedure_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  procedure?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "location_procedure" */
export type Location_Procedure_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  procedure?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "location_procedure" */
export type Location_Procedure_Mutation_Response = {
  __typename?: 'location_procedure_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Location_Procedure>;
};

/** input type for inserting object relation for remote table "location_procedure" */
export type Location_Procedure_Obj_Rel_Insert_Input = {
  data: Location_Procedure_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Location_Procedure_On_Conflict>;
};

/** on_conflict condition type for table "location_procedure" */
export type Location_Procedure_On_Conflict = {
  constraint: Location_Procedure_Constraint;
  update_columns?: Array<Location_Procedure_Update_Column>;
  where?: InputMaybe<Location_Procedure_Bool_Exp>;
};

/** Ordering options when selecting data from "location_procedure". */
export type Location_Procedure_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  location_procedure_rooms_aggregate?: InputMaybe<Location_Procedure_Room_Aggregate_Order_By>;
  procedure?: InputMaybe<Order_By>;
  procedureByProcedure?: InputMaybe<Procedure_Order_By>;
  provider_procedures_aggregate?: InputMaybe<Provider_Procedure_Aggregate_Order_By>;
};

/** primary key columns input for table: location_procedure */
export type Location_Procedure_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "location_procedure_room" */
export type Location_Procedure_Room = {
  __typename?: 'location_procedure_room';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  locationProcedure: Scalars['uuid'];
  /** An object relationship */
  locationProcedureByLocationProcedure: Location_Procedure;
  room: Scalars['uuid'];
  /** An object relationship */
  roomByRoom: Room;
};

/** aggregated selection of "location_procedure_room" */
export type Location_Procedure_Room_Aggregate = {
  __typename?: 'location_procedure_room_aggregate';
  aggregate?: Maybe<Location_Procedure_Room_Aggregate_Fields>;
  nodes: Array<Location_Procedure_Room>;
};

export type Location_Procedure_Room_Aggregate_Bool_Exp = {
  count?: InputMaybe<Location_Procedure_Room_Aggregate_Bool_Exp_Count>;
};

export type Location_Procedure_Room_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Location_Procedure_Room_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Location_Procedure_Room_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "location_procedure_room" */
export type Location_Procedure_Room_Aggregate_Fields = {
  __typename?: 'location_procedure_room_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Location_Procedure_Room_Max_Fields>;
  min?: Maybe<Location_Procedure_Room_Min_Fields>;
};


/** aggregate fields of "location_procedure_room" */
export type Location_Procedure_Room_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Location_Procedure_Room_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "location_procedure_room" */
export type Location_Procedure_Room_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Location_Procedure_Room_Max_Order_By>;
  min?: InputMaybe<Location_Procedure_Room_Min_Order_By>;
};

/** input type for inserting array relation for remote table "location_procedure_room" */
export type Location_Procedure_Room_Arr_Rel_Insert_Input = {
  data: Array<Location_Procedure_Room_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Location_Procedure_Room_On_Conflict>;
};

/** Boolean expression to filter rows from the table "location_procedure_room". All fields are combined with a logical 'AND'. */
export type Location_Procedure_Room_Bool_Exp = {
  _and?: InputMaybe<Array<Location_Procedure_Room_Bool_Exp>>;
  _not?: InputMaybe<Location_Procedure_Room_Bool_Exp>;
  _or?: InputMaybe<Array<Location_Procedure_Room_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  locationProcedure?: InputMaybe<Uuid_Comparison_Exp>;
  locationProcedureByLocationProcedure?: InputMaybe<Location_Procedure_Bool_Exp>;
  room?: InputMaybe<Uuid_Comparison_Exp>;
  roomByRoom?: InputMaybe<Room_Bool_Exp>;
};

/** unique or primary key constraints on table "location_procedure_room" */
export enum Location_Procedure_Room_Constraint {
  /** unique or primary key constraint on columns "id" */
  LocationProcedureRoomPkey = 'location_procedure_room_pkey'
}

/** input type for inserting data into table "location_procedure_room" */
export type Location_Procedure_Room_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  locationProcedure?: InputMaybe<Scalars['uuid']>;
  locationProcedureByLocationProcedure?: InputMaybe<Location_Procedure_Obj_Rel_Insert_Input>;
  room?: InputMaybe<Scalars['uuid']>;
  roomByRoom?: InputMaybe<Room_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Location_Procedure_Room_Max_Fields = {
  __typename?: 'location_procedure_room_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  locationProcedure?: Maybe<Scalars['uuid']>;
  room?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "location_procedure_room" */
export type Location_Procedure_Room_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locationProcedure?: InputMaybe<Order_By>;
  room?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Location_Procedure_Room_Min_Fields = {
  __typename?: 'location_procedure_room_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  locationProcedure?: Maybe<Scalars['uuid']>;
  room?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "location_procedure_room" */
export type Location_Procedure_Room_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locationProcedure?: InputMaybe<Order_By>;
  room?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "location_procedure_room" */
export type Location_Procedure_Room_Mutation_Response = {
  __typename?: 'location_procedure_room_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Location_Procedure_Room>;
};

/** on_conflict condition type for table "location_procedure_room" */
export type Location_Procedure_Room_On_Conflict = {
  constraint: Location_Procedure_Room_Constraint;
  update_columns?: Array<Location_Procedure_Room_Update_Column>;
  where?: InputMaybe<Location_Procedure_Room_Bool_Exp>;
};

/** Ordering options when selecting data from "location_procedure_room". */
export type Location_Procedure_Room_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locationProcedure?: InputMaybe<Order_By>;
  locationProcedureByLocationProcedure?: InputMaybe<Location_Procedure_Order_By>;
  room?: InputMaybe<Order_By>;
  roomByRoom?: InputMaybe<Room_Order_By>;
};

/** primary key columns input for table: location_procedure_room */
export type Location_Procedure_Room_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "location_procedure_room" */
export enum Location_Procedure_Room_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LocationProcedure = 'locationProcedure',
  /** column name */
  Room = 'room'
}

/** input type for updating data in table "location_procedure_room" */
export type Location_Procedure_Room_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  locationProcedure?: InputMaybe<Scalars['uuid']>;
  room?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "location_procedure_room" */
export type Location_Procedure_Room_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Location_Procedure_Room_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Location_Procedure_Room_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  locationProcedure?: InputMaybe<Scalars['uuid']>;
  room?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "location_procedure_room" */
export enum Location_Procedure_Room_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LocationProcedure = 'locationProcedure',
  /** column name */
  Room = 'room'
}

export type Location_Procedure_Room_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Location_Procedure_Room_Set_Input>;
  /** filter the rows which have to be updated */
  where: Location_Procedure_Room_Bool_Exp;
};

/** select columns of table "location_procedure" */
export enum Location_Procedure_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Procedure = 'procedure'
}

/** input type for updating data in table "location_procedure" */
export type Location_Procedure_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  procedure?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "location_procedure" */
export type Location_Procedure_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Location_Procedure_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Location_Procedure_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  procedure?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "location_procedure" */
export enum Location_Procedure_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Procedure = 'procedure'
}

export type Location_Procedure_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Location_Procedure_Set_Input>;
  /** filter the rows which have to be updated */
  where: Location_Procedure_Bool_Exp;
};

/** columns and relationships of "location_product" */
export type Location_Product = {
  __typename?: 'location_product';
  active: Scalars['Boolean'];
  created_at: Scalars['timestamptz'];
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  photoS3Key?: Maybe<Scalars['uuid']>;
  price: Scalars['Int'];
  product: Scalars['uuid'];
  /** An object relationship */
  productByProduct: Product;
  /** An object relationship */
  product_type?: Maybe<Product_Type>;
  stock: Scalars['Int'];
  stripeTaxId?: Maybe<Scalars['String']>;
  tax: Scalars['uuid'];
  /** An object relationship */
  taxRate: Tax_Rate;
  triggeredWarning?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
  warnAtStock?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "location_product" */
export type Location_Product_Aggregate = {
  __typename?: 'location_product_aggregate';
  aggregate?: Maybe<Location_Product_Aggregate_Fields>;
  nodes: Array<Location_Product>;
};

export type Location_Product_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Location_Product_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Location_Product_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Location_Product_Aggregate_Bool_Exp_Count>;
};

export type Location_Product_Aggregate_Bool_Exp_Bool_And = {
  arguments: Location_Product_Select_Column_Location_Product_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Location_Product_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Location_Product_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Location_Product_Select_Column_Location_Product_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Location_Product_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Location_Product_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Location_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Location_Product_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "location_product" */
export type Location_Product_Aggregate_Fields = {
  __typename?: 'location_product_aggregate_fields';
  avg?: Maybe<Location_Product_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Location_Product_Max_Fields>;
  min?: Maybe<Location_Product_Min_Fields>;
  stddev?: Maybe<Location_Product_Stddev_Fields>;
  stddev_pop?: Maybe<Location_Product_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Location_Product_Stddev_Samp_Fields>;
  sum?: Maybe<Location_Product_Sum_Fields>;
  var_pop?: Maybe<Location_Product_Var_Pop_Fields>;
  var_samp?: Maybe<Location_Product_Var_Samp_Fields>;
  variance?: Maybe<Location_Product_Variance_Fields>;
};


/** aggregate fields of "location_product" */
export type Location_Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Location_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "location_product" */
export type Location_Product_Aggregate_Order_By = {
  avg?: InputMaybe<Location_Product_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Location_Product_Max_Order_By>;
  min?: InputMaybe<Location_Product_Min_Order_By>;
  stddev?: InputMaybe<Location_Product_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Location_Product_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Location_Product_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Location_Product_Sum_Order_By>;
  var_pop?: InputMaybe<Location_Product_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Location_Product_Var_Samp_Order_By>;
  variance?: InputMaybe<Location_Product_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "location_product" */
export type Location_Product_Arr_Rel_Insert_Input = {
  data: Array<Location_Product_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Location_Product_On_Conflict>;
};

/** aggregate avg on columns */
export type Location_Product_Avg_Fields = {
  __typename?: 'location_product_avg_fields';
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
  warnAtStock?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "location_product" */
export type Location_Product_Avg_Order_By = {
  price?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
  warnAtStock?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "location_product". All fields are combined with a logical 'AND'. */
export type Location_Product_Bool_Exp = {
  _and?: InputMaybe<Array<Location_Product_Bool_Exp>>;
  _not?: InputMaybe<Location_Product_Bool_Exp>;
  _or?: InputMaybe<Array<Location_Product_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  photoS3Key?: InputMaybe<Uuid_Comparison_Exp>;
  price?: InputMaybe<Int_Comparison_Exp>;
  product?: InputMaybe<Uuid_Comparison_Exp>;
  productByProduct?: InputMaybe<Product_Bool_Exp>;
  product_type?: InputMaybe<Product_Type_Bool_Exp>;
  stock?: InputMaybe<Int_Comparison_Exp>;
  stripeTaxId?: InputMaybe<String_Comparison_Exp>;
  tax?: InputMaybe<Uuid_Comparison_Exp>;
  taxRate?: InputMaybe<Tax_Rate_Bool_Exp>;
  triggeredWarning?: InputMaybe<Boolean_Comparison_Exp>;
  type?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  warnAtStock?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "location_product" */
export enum Location_Product_Constraint {
  /** unique or primary key constraint on columns "product", "location" */
  LocationProductPkey = 'location_product_pkey'
}

/** input type for incrementing numeric columns in table "location_product" */
export type Location_Product_Inc_Input = {
  price?: InputMaybe<Scalars['Int']>;
  stock?: InputMaybe<Scalars['Int']>;
  warnAtStock?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "location_product" */
export type Location_Product_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<Scalars['uuid']>;
  productByProduct?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_type?: InputMaybe<Product_Type_Obj_Rel_Insert_Input>;
  stock?: InputMaybe<Scalars['Int']>;
  stripeTaxId?: InputMaybe<Scalars['String']>;
  tax?: InputMaybe<Scalars['uuid']>;
  taxRate?: InputMaybe<Tax_Rate_Obj_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  warnAtStock?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Location_Product_Max_Fields = {
  __typename?: 'location_product_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  location?: Maybe<Scalars['uuid']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['Int']>;
  product?: Maybe<Scalars['uuid']>;
  stock?: Maybe<Scalars['Int']>;
  stripeTaxId?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  warnAtStock?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "location_product" */
export type Location_Product_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  photoS3Key?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
  stripeTaxId?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warnAtStock?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Location_Product_Min_Fields = {
  __typename?: 'location_product_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  location?: Maybe<Scalars['uuid']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['Int']>;
  product?: Maybe<Scalars['uuid']>;
  stock?: Maybe<Scalars['Int']>;
  stripeTaxId?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  warnAtStock?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "location_product" */
export type Location_Product_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  photoS3Key?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
  stripeTaxId?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warnAtStock?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "location_product" */
export type Location_Product_Mutation_Response = {
  __typename?: 'location_product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Location_Product>;
};

/** input type for inserting object relation for remote table "location_product" */
export type Location_Product_Obj_Rel_Insert_Input = {
  data: Location_Product_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Location_Product_On_Conflict>;
};

/** on_conflict condition type for table "location_product" */
export type Location_Product_On_Conflict = {
  constraint: Location_Product_Constraint;
  update_columns?: Array<Location_Product_Update_Column>;
  where?: InputMaybe<Location_Product_Bool_Exp>;
};

/** Ordering options when selecting data from "location_product". */
export type Location_Product_Order_By = {
  active?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  photoS3Key?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  productByProduct?: InputMaybe<Product_Order_By>;
  product_type?: InputMaybe<Product_Type_Order_By>;
  stock?: InputMaybe<Order_By>;
  stripeTaxId?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  taxRate?: InputMaybe<Tax_Rate_Order_By>;
  triggeredWarning?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  warnAtStock?: InputMaybe<Order_By>;
};

/** primary key columns input for table: location_product */
export type Location_Product_Pk_Columns_Input = {
  location: Scalars['uuid'];
  product: Scalars['uuid'];
};

/** select columns of table "location_product" */
export enum Location_Product_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Location = 'location',
  /** column name */
  PhotoS3Key = 'photoS3Key',
  /** column name */
  Price = 'price',
  /** column name */
  Product = 'product',
  /** column name */
  Stock = 'stock',
  /** column name */
  StripeTaxId = 'stripeTaxId',
  /** column name */
  Tax = 'tax',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WarnAtStock = 'warnAtStock'
}

/** select "location_product_aggregate_bool_exp_bool_and_arguments_columns" columns of table "location_product" */
export enum Location_Product_Select_Column_Location_Product_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active'
}

/** select "location_product_aggregate_bool_exp_bool_or_arguments_columns" columns of table "location_product" */
export enum Location_Product_Select_Column_Location_Product_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active'
}

/** input type for updating data in table "location_product" */
export type Location_Product_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  location?: InputMaybe<Scalars['uuid']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<Scalars['uuid']>;
  stock?: InputMaybe<Scalars['Int']>;
  stripeTaxId?: InputMaybe<Scalars['String']>;
  tax?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  warnAtStock?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Location_Product_Stddev_Fields = {
  __typename?: 'location_product_stddev_fields';
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
  warnAtStock?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "location_product" */
export type Location_Product_Stddev_Order_By = {
  price?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
  warnAtStock?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Location_Product_Stddev_Pop_Fields = {
  __typename?: 'location_product_stddev_pop_fields';
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
  warnAtStock?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "location_product" */
export type Location_Product_Stddev_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
  warnAtStock?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Location_Product_Stddev_Samp_Fields = {
  __typename?: 'location_product_stddev_samp_fields';
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
  warnAtStock?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "location_product" */
export type Location_Product_Stddev_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
  warnAtStock?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "location_product" */
export type Location_Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Location_Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Location_Product_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  location?: InputMaybe<Scalars['uuid']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<Scalars['uuid']>;
  stock?: InputMaybe<Scalars['Int']>;
  stripeTaxId?: InputMaybe<Scalars['String']>;
  tax?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  warnAtStock?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Location_Product_Sum_Fields = {
  __typename?: 'location_product_sum_fields';
  price?: Maybe<Scalars['Int']>;
  stock?: Maybe<Scalars['Int']>;
  warnAtStock?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "location_product" */
export type Location_Product_Sum_Order_By = {
  price?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
  warnAtStock?: InputMaybe<Order_By>;
};

/** update columns of table "location_product" */
export enum Location_Product_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Location = 'location',
  /** column name */
  PhotoS3Key = 'photoS3Key',
  /** column name */
  Price = 'price',
  /** column name */
  Product = 'product',
  /** column name */
  Stock = 'stock',
  /** column name */
  StripeTaxId = 'stripeTaxId',
  /** column name */
  Tax = 'tax',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WarnAtStock = 'warnAtStock'
}

export type Location_Product_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Location_Product_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Location_Product_Set_Input>;
  /** filter the rows which have to be updated */
  where: Location_Product_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Location_Product_Var_Pop_Fields = {
  __typename?: 'location_product_var_pop_fields';
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
  warnAtStock?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "location_product" */
export type Location_Product_Var_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
  warnAtStock?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Location_Product_Var_Samp_Fields = {
  __typename?: 'location_product_var_samp_fields';
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
  warnAtStock?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "location_product" */
export type Location_Product_Var_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
  warnAtStock?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Location_Product_Variance_Fields = {
  __typename?: 'location_product_variance_fields';
  price?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
  warnAtStock?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "location_product" */
export type Location_Product_Variance_Order_By = {
  price?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
  warnAtStock?: InputMaybe<Order_By>;
};

/** select columns of table "location" */
export enum Location_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AllowResourceFree = 'allowResourceFree',
  /** column name */
  BookingAllowed = 'bookingAllowed',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  LicenseDocumentRequired = 'licenseDocumentRequired',
  /** column name */
  LicenseExpirationRequired = 'licenseExpirationRequired',
  /** column name */
  MalpracticeRequired = 'malpracticeRequired',
  /** column name */
  MedicalDirectorRequired = 'medicalDirectorRequired',
  /** column name */
  Name = 'name',
  /** column name */
  ParentLocation = 'parentLocation',
  /** column name */
  Partner = 'partner',
  /** column name */
  ProviderDirectProductPurchase = 'providerDirectProductPurchase',
  /** column name */
  ProviderDirectPurchaseProfitMargin = 'providerDirectPurchaseProfitMargin',
  /** column name */
  ProviderPlanRequired = 'providerPlanRequired',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsesParentLocationPlans = 'usesParentLocationPlans',
  /** column name */
  ValidSlotDurations = 'validSlotDurations'
}

/** select "location_aggregate_bool_exp_bool_and_arguments_columns" columns of table "location" */
export enum Location_Select_Column_Location_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AllowResourceFree = 'allowResourceFree',
  /** column name */
  BookingAllowed = 'bookingAllowed',
  /** column name */
  LicenseDocumentRequired = 'licenseDocumentRequired',
  /** column name */
  LicenseExpirationRequired = 'licenseExpirationRequired',
  /** column name */
  MalpracticeRequired = 'malpracticeRequired',
  /** column name */
  MedicalDirectorRequired = 'medicalDirectorRequired',
  /** column name */
  ProviderDirectProductPurchase = 'providerDirectProductPurchase',
  /** column name */
  ProviderPlanRequired = 'providerPlanRequired',
  /** column name */
  UsesParentLocationPlans = 'usesParentLocationPlans'
}

/** select "location_aggregate_bool_exp_bool_or_arguments_columns" columns of table "location" */
export enum Location_Select_Column_Location_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AllowResourceFree = 'allowResourceFree',
  /** column name */
  BookingAllowed = 'bookingAllowed',
  /** column name */
  LicenseDocumentRequired = 'licenseDocumentRequired',
  /** column name */
  LicenseExpirationRequired = 'licenseExpirationRequired',
  /** column name */
  MalpracticeRequired = 'malpracticeRequired',
  /** column name */
  MedicalDirectorRequired = 'medicalDirectorRequired',
  /** column name */
  ProviderDirectProductPurchase = 'providerDirectProductPurchase',
  /** column name */
  ProviderPlanRequired = 'providerPlanRequired',
  /** column name */
  UsesParentLocationPlans = 'usesParentLocationPlans'
}

/** input type for updating data in table "location" */
export type Location_Set_Input = {
  address?: InputMaybe<Scalars['uuid']>;
  allowResourceFree?: InputMaybe<Scalars['Boolean']>;
  /** As it sounds, if not providers can only purchase products (enforced only in the app UI currently) */
  bookingAllowed?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** When true, a provider must have uploaded a License document to book at this location. */
  licenseDocumentRequired?: InputMaybe<Scalars['Boolean']>;
  /** When true, a provider must have a non-expired license_expiration to book at this location. */
  licenseExpirationRequired?: InputMaybe<Scalars['Boolean']>;
  /** When true, a provider must have a current Malpractice document and a non-expired malpractice_expiration to book at this location. */
  malpracticeRequired?: InputMaybe<Scalars['Boolean']>;
  /** When true (and the accreditation is not privileged to book without a director), a provider must have uploaded a Medical Director document to book at this location. */
  medicalDirectorRequired?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentLocation?: InputMaybe<Scalars['uuid']>;
  partner?: InputMaybe<Scalars['uuid']>;
  /** Whether provider product purchases are directly against the vendor (with markup) rather than from the MSO.  This *does not* have any implications for whether providers can make bookings. */
  providerDirectProductPurchase?: InputMaybe<Scalars['Boolean']>;
  providerDirectPurchaseProfitMargin?: InputMaybe<Scalars['Int']>;
  /** Whether a plan is required to use the app.  The use cases for no are typically Medspa and locations where providers do not book appointments. */
  providerPlanRequired?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  usesParentLocationPlans?: InputMaybe<Scalars['Boolean']>;
  validSlotDurations?: InputMaybe<Array<Scalars['Int']>>;
};

/** aggregate stddev on columns */
export type Location_Stddev_Fields = {
  __typename?: 'location_stddev_fields';
  providerDirectPurchaseProfitMargin?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "location" */
export type Location_Stddev_Order_By = {
  providerDirectPurchaseProfitMargin?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Location_Stddev_Pop_Fields = {
  __typename?: 'location_stddev_pop_fields';
  providerDirectPurchaseProfitMargin?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "location" */
export type Location_Stddev_Pop_Order_By = {
  providerDirectPurchaseProfitMargin?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Location_Stddev_Samp_Fields = {
  __typename?: 'location_stddev_samp_fields';
  providerDirectPurchaseProfitMargin?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "location" */
export type Location_Stddev_Samp_Order_By = {
  providerDirectPurchaseProfitMargin?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "location" */
export type Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Location_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['uuid']>;
  allowResourceFree?: InputMaybe<Scalars['Boolean']>;
  /** As it sounds, if not providers can only purchase products (enforced only in the app UI currently) */
  bookingAllowed?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** When true, a provider must have uploaded a License document to book at this location. */
  licenseDocumentRequired?: InputMaybe<Scalars['Boolean']>;
  /** When true, a provider must have a non-expired license_expiration to book at this location. */
  licenseExpirationRequired?: InputMaybe<Scalars['Boolean']>;
  /** When true, a provider must have a current Malpractice document and a non-expired malpractice_expiration to book at this location. */
  malpracticeRequired?: InputMaybe<Scalars['Boolean']>;
  /** When true (and the accreditation is not privileged to book without a director), a provider must have uploaded a Medical Director document to book at this location. */
  medicalDirectorRequired?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentLocation?: InputMaybe<Scalars['uuid']>;
  partner?: InputMaybe<Scalars['uuid']>;
  /** Whether provider product purchases are directly against the vendor (with markup) rather than from the MSO.  This *does not* have any implications for whether providers can make bookings. */
  providerDirectProductPurchase?: InputMaybe<Scalars['Boolean']>;
  providerDirectPurchaseProfitMargin?: InputMaybe<Scalars['Int']>;
  /** Whether a plan is required to use the app.  The use cases for no are typically Medspa and locations where providers do not book appointments. */
  providerPlanRequired?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  usesParentLocationPlans?: InputMaybe<Scalars['Boolean']>;
  validSlotDurations?: InputMaybe<Array<Scalars['Int']>>;
};

/** aggregate sum on columns */
export type Location_Sum_Fields = {
  __typename?: 'location_sum_fields';
  providerDirectPurchaseProfitMargin?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "location" */
export type Location_Sum_Order_By = {
  providerDirectPurchaseProfitMargin?: InputMaybe<Order_By>;
};

/** update columns of table "location" */
export enum Location_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AllowResourceFree = 'allowResourceFree',
  /** column name */
  BookingAllowed = 'bookingAllowed',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  LicenseDocumentRequired = 'licenseDocumentRequired',
  /** column name */
  LicenseExpirationRequired = 'licenseExpirationRequired',
  /** column name */
  MalpracticeRequired = 'malpracticeRequired',
  /** column name */
  MedicalDirectorRequired = 'medicalDirectorRequired',
  /** column name */
  Name = 'name',
  /** column name */
  ParentLocation = 'parentLocation',
  /** column name */
  Partner = 'partner',
  /** column name */
  ProviderDirectProductPurchase = 'providerDirectProductPurchase',
  /** column name */
  ProviderDirectPurchaseProfitMargin = 'providerDirectPurchaseProfitMargin',
  /** column name */
  ProviderPlanRequired = 'providerPlanRequired',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsesParentLocationPlans = 'usesParentLocationPlans',
  /** column name */
  ValidSlotDurations = 'validSlotDurations'
}

export type Location_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Location_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Location_Set_Input>;
  /** filter the rows which have to be updated */
  where: Location_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Location_Var_Pop_Fields = {
  __typename?: 'location_var_pop_fields';
  providerDirectPurchaseProfitMargin?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "location" */
export type Location_Var_Pop_Order_By = {
  providerDirectPurchaseProfitMargin?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Location_Var_Samp_Fields = {
  __typename?: 'location_var_samp_fields';
  providerDirectPurchaseProfitMargin?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "location" */
export type Location_Var_Samp_Order_By = {
  providerDirectPurchaseProfitMargin?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Location_Variance_Fields = {
  __typename?: 'location_variance_fields';
  providerDirectPurchaseProfitMargin?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "location" */
export type Location_Variance_Order_By = {
  providerDirectPurchaseProfitMargin?: InputMaybe<Order_By>;
};

/** columns and relationships of "model" */
export type Model = {
  __typename?: 'model';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An array relationship */
  modelCounts: Array<Model_Count>;
  /** An aggregate relationship */
  modelCounts_aggregate: Model_Count_Aggregate;
  /** An array relationship */
  modelProducts: Array<Model_Product>;
  /** An aggregate relationship */
  modelProducts_aggregate: Model_Product_Aggregate;
  name: Scalars['String'];
  photoS3Key?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  procedures: Array<Procedure>;
  /** An aggregate relationship */
  procedures_aggregate: Procedure_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "model" */
export type ModelModelCountsArgs = {
  distinct_on?: InputMaybe<Array<Model_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Count_Order_By>>;
  where?: InputMaybe<Model_Count_Bool_Exp>;
};


/** columns and relationships of "model" */
export type ModelModelCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Count_Order_By>>;
  where?: InputMaybe<Model_Count_Bool_Exp>;
};


/** columns and relationships of "model" */
export type ModelModelProductsArgs = {
  distinct_on?: InputMaybe<Array<Model_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Product_Order_By>>;
  where?: InputMaybe<Model_Product_Bool_Exp>;
};


/** columns and relationships of "model" */
export type ModelModelProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Product_Order_By>>;
  where?: InputMaybe<Model_Product_Bool_Exp>;
};


/** columns and relationships of "model" */
export type ModelProceduresArgs = {
  distinct_on?: InputMaybe<Array<Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Procedure_Order_By>>;
  where?: InputMaybe<Procedure_Bool_Exp>;
};


/** columns and relationships of "model" */
export type ModelProcedures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Procedure_Order_By>>;
  where?: InputMaybe<Procedure_Bool_Exp>;
};

/** aggregated selection of "model" */
export type Model_Aggregate = {
  __typename?: 'model_aggregate';
  aggregate?: Maybe<Model_Aggregate_Fields>;
  nodes: Array<Model>;
};

/** aggregate fields of "model" */
export type Model_Aggregate_Fields = {
  __typename?: 'model_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Model_Max_Fields>;
  min?: Maybe<Model_Min_Fields>;
};


/** aggregate fields of "model" */
export type Model_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Model_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "model". All fields are combined with a logical 'AND'. */
export type Model_Bool_Exp = {
  _and?: InputMaybe<Array<Model_Bool_Exp>>;
  _not?: InputMaybe<Model_Bool_Exp>;
  _or?: InputMaybe<Array<Model_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  modelCounts?: InputMaybe<Model_Count_Bool_Exp>;
  modelCounts_aggregate?: InputMaybe<Model_Count_Aggregate_Bool_Exp>;
  modelProducts?: InputMaybe<Model_Product_Bool_Exp>;
  modelProducts_aggregate?: InputMaybe<Model_Product_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photoS3Key?: InputMaybe<Uuid_Comparison_Exp>;
  procedures?: InputMaybe<Procedure_Bool_Exp>;
  procedures_aggregate?: InputMaybe<Procedure_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "model" */
export enum Model_Constraint {
  /** unique or primary key constraint on columns "name" */
  EquipmentTypeNameKey = 'equipment_type_name_key',
  /** unique or primary key constraint on columns "id" */
  EquipmentTypePkey = 'equipment_type_pkey'
}

/** columns and relationships of "model_count" */
export type Model_Count = {
  __typename?: 'model_count';
  allowNonMedicalUsers: Scalars['Boolean'];
  allowVolumeDiscount: Scalars['Boolean'];
  count: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  model: Scalars['uuid'];
  /** An object relationship */
  modelByModel: Model;
  photoS3Key?: Maybe<Scalars['uuid']>;
  rate: Scalars['Int'];
  roomRequired: Scalars['Boolean'];
  timespan: Scalars['tstzrange'];
  /** A computed field, executes function "model_count_lower" */
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "model_count_upper" */
  timespan_upper?: Maybe<Scalars['timestamptz']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "model_count" */
export type Model_Count_Aggregate = {
  __typename?: 'model_count_aggregate';
  aggregate?: Maybe<Model_Count_Aggregate_Fields>;
  nodes: Array<Model_Count>;
};

export type Model_Count_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Model_Count_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Model_Count_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Model_Count_Aggregate_Bool_Exp_Count>;
};

export type Model_Count_Aggregate_Bool_Exp_Bool_And = {
  arguments: Model_Count_Select_Column_Model_Count_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Model_Count_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Model_Count_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Model_Count_Select_Column_Model_Count_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Model_Count_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Model_Count_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Model_Count_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Model_Count_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "model_count" */
export type Model_Count_Aggregate_Fields = {
  __typename?: 'model_count_aggregate_fields';
  avg?: Maybe<Model_Count_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Model_Count_Max_Fields>;
  min?: Maybe<Model_Count_Min_Fields>;
  stddev?: Maybe<Model_Count_Stddev_Fields>;
  stddev_pop?: Maybe<Model_Count_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Model_Count_Stddev_Samp_Fields>;
  sum?: Maybe<Model_Count_Sum_Fields>;
  var_pop?: Maybe<Model_Count_Var_Pop_Fields>;
  var_samp?: Maybe<Model_Count_Var_Samp_Fields>;
  variance?: Maybe<Model_Count_Variance_Fields>;
};


/** aggregate fields of "model_count" */
export type Model_Count_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Model_Count_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "model_count" */
export type Model_Count_Aggregate_Order_By = {
  avg?: InputMaybe<Model_Count_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Model_Count_Max_Order_By>;
  min?: InputMaybe<Model_Count_Min_Order_By>;
  stddev?: InputMaybe<Model_Count_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Model_Count_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Model_Count_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Model_Count_Sum_Order_By>;
  var_pop?: InputMaybe<Model_Count_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Model_Count_Var_Samp_Order_By>;
  variance?: InputMaybe<Model_Count_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "model_count" */
export type Model_Count_Arr_Rel_Insert_Input = {
  data: Array<Model_Count_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Model_Count_On_Conflict>;
};

/** aggregate avg on columns */
export type Model_Count_Avg_Fields = {
  __typename?: 'model_count_avg_fields';
  count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "model_count" */
export type Model_Count_Avg_Order_By = {
  count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "model_count". All fields are combined with a logical 'AND'. */
export type Model_Count_Bool_Exp = {
  _and?: InputMaybe<Array<Model_Count_Bool_Exp>>;
  _not?: InputMaybe<Model_Count_Bool_Exp>;
  _or?: InputMaybe<Array<Model_Count_Bool_Exp>>;
  allowNonMedicalUsers?: InputMaybe<Boolean_Comparison_Exp>;
  allowVolumeDiscount?: InputMaybe<Boolean_Comparison_Exp>;
  count?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  model?: InputMaybe<Uuid_Comparison_Exp>;
  modelByModel?: InputMaybe<Model_Bool_Exp>;
  photoS3Key?: InputMaybe<Uuid_Comparison_Exp>;
  rate?: InputMaybe<Int_Comparison_Exp>;
  roomRequired?: InputMaybe<Boolean_Comparison_Exp>;
  timespan?: InputMaybe<Tstzrange_Comparison_Exp>;
  timespan_lower?: InputMaybe<Timestamptz_Comparison_Exp>;
  timespan_upper?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "model_count" */
export enum Model_Count_Constraint {
  /** unique or primary key constraint on columns "id" */
  ModelCountTidKey = 'model_count_tid_key',
  /** unique or primary key constraint on columns "id" */
  PortableModelCountsPkey = 'portable_model_counts_pkey'
}

/** input type for incrementing numeric columns in table "model_count" */
export type Model_Count_Inc_Input = {
  count?: InputMaybe<Scalars['Int']>;
  rate?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "model_count" */
export type Model_Count_Insert_Input = {
  allowNonMedicalUsers?: InputMaybe<Scalars['Boolean']>;
  allowVolumeDiscount?: InputMaybe<Scalars['Boolean']>;
  count?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  model?: InputMaybe<Scalars['uuid']>;
  modelByModel?: InputMaybe<Model_Obj_Rel_Insert_Input>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  rate?: InputMaybe<Scalars['Int']>;
  roomRequired?: InputMaybe<Scalars['Boolean']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Model_Count_Max_Fields = {
  __typename?: 'model_count_max_fields';
  count?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  model?: Maybe<Scalars['uuid']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
  rate?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "model_count_lower" */
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "model_count_upper" */
  timespan_upper?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "model_count" */
export type Model_Count_Max_Order_By = {
  count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  photoS3Key?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Model_Count_Min_Fields = {
  __typename?: 'model_count_min_fields';
  count?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  model?: Maybe<Scalars['uuid']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
  rate?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "model_count_lower" */
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "model_count_upper" */
  timespan_upper?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "model_count" */
export type Model_Count_Min_Order_By = {
  count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  photoS3Key?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "model_count" */
export type Model_Count_Mutation_Response = {
  __typename?: 'model_count_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Model_Count>;
};

/** on_conflict condition type for table "model_count" */
export type Model_Count_On_Conflict = {
  constraint: Model_Count_Constraint;
  update_columns?: Array<Model_Count_Update_Column>;
  where?: InputMaybe<Model_Count_Bool_Exp>;
};

/** Ordering options when selecting data from "model_count". */
export type Model_Count_Order_By = {
  allowNonMedicalUsers?: InputMaybe<Order_By>;
  allowVolumeDiscount?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  model?: InputMaybe<Order_By>;
  modelByModel?: InputMaybe<Model_Order_By>;
  photoS3Key?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  roomRequired?: InputMaybe<Order_By>;
  timespan?: InputMaybe<Order_By>;
  timespan_lower?: InputMaybe<Order_By>;
  timespan_upper?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: model_count */
export type Model_Count_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "model_count" */
export enum Model_Count_Select_Column {
  /** column name */
  AllowNonMedicalUsers = 'allowNonMedicalUsers',
  /** column name */
  AllowVolumeDiscount = 'allowVolumeDiscount',
  /** column name */
  Count = 'count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Model = 'model',
  /** column name */
  PhotoS3Key = 'photoS3Key',
  /** column name */
  Rate = 'rate',
  /** column name */
  RoomRequired = 'roomRequired',
  /** column name */
  Timespan = 'timespan',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "model_count_aggregate_bool_exp_bool_and_arguments_columns" columns of table "model_count" */
export enum Model_Count_Select_Column_Model_Count_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AllowNonMedicalUsers = 'allowNonMedicalUsers',
  /** column name */
  AllowVolumeDiscount = 'allowVolumeDiscount',
  /** column name */
  RoomRequired = 'roomRequired'
}

/** select "model_count_aggregate_bool_exp_bool_or_arguments_columns" columns of table "model_count" */
export enum Model_Count_Select_Column_Model_Count_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AllowNonMedicalUsers = 'allowNonMedicalUsers',
  /** column name */
  AllowVolumeDiscount = 'allowVolumeDiscount',
  /** column name */
  RoomRequired = 'roomRequired'
}

/** input type for updating data in table "model_count" */
export type Model_Count_Set_Input = {
  allowNonMedicalUsers?: InputMaybe<Scalars['Boolean']>;
  allowVolumeDiscount?: InputMaybe<Scalars['Boolean']>;
  count?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  model?: InputMaybe<Scalars['uuid']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  rate?: InputMaybe<Scalars['Int']>;
  roomRequired?: InputMaybe<Scalars['Boolean']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Model_Count_Stddev_Fields = {
  __typename?: 'model_count_stddev_fields';
  count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "model_count" */
export type Model_Count_Stddev_Order_By = {
  count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Model_Count_Stddev_Pop_Fields = {
  __typename?: 'model_count_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "model_count" */
export type Model_Count_Stddev_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Model_Count_Stddev_Samp_Fields = {
  __typename?: 'model_count_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "model_count" */
export type Model_Count_Stddev_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "model_count" */
export type Model_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Model_Count_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Model_Count_Stream_Cursor_Value_Input = {
  allowNonMedicalUsers?: InputMaybe<Scalars['Boolean']>;
  allowVolumeDiscount?: InputMaybe<Scalars['Boolean']>;
  count?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  model?: InputMaybe<Scalars['uuid']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  rate?: InputMaybe<Scalars['Int']>;
  roomRequired?: InputMaybe<Scalars['Boolean']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Model_Count_Sum_Fields = {
  __typename?: 'model_count_sum_fields';
  count?: Maybe<Scalars['Int']>;
  rate?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "model_count" */
export type Model_Count_Sum_Order_By = {
  count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
};

/** update columns of table "model_count" */
export enum Model_Count_Update_Column {
  /** column name */
  AllowNonMedicalUsers = 'allowNonMedicalUsers',
  /** column name */
  AllowVolumeDiscount = 'allowVolumeDiscount',
  /** column name */
  Count = 'count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Model = 'model',
  /** column name */
  PhotoS3Key = 'photoS3Key',
  /** column name */
  Rate = 'rate',
  /** column name */
  RoomRequired = 'roomRequired',
  /** column name */
  Timespan = 'timespan',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Model_Count_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Model_Count_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Model_Count_Set_Input>;
  /** filter the rows which have to be updated */
  where: Model_Count_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Model_Count_Var_Pop_Fields = {
  __typename?: 'model_count_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "model_count" */
export type Model_Count_Var_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Model_Count_Var_Samp_Fields = {
  __typename?: 'model_count_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "model_count" */
export type Model_Count_Var_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Model_Count_Variance_Fields = {
  __typename?: 'model_count_variance_fields';
  count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "model_count" */
export type Model_Count_Variance_Order_By = {
  count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
};

/** input type for inserting data into table "model" */
export type Model_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  modelCounts?: InputMaybe<Model_Count_Arr_Rel_Insert_Input>;
  modelProducts?: InputMaybe<Model_Product_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  procedures?: InputMaybe<Procedure_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Model_Max_Fields = {
  __typename?: 'model_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Model_Min_Fields = {
  __typename?: 'model_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "model" */
export type Model_Mutation_Response = {
  __typename?: 'model_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Model>;
};

/** input type for inserting object relation for remote table "model" */
export type Model_Obj_Rel_Insert_Input = {
  data: Model_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Model_On_Conflict>;
};

/** on_conflict condition type for table "model" */
export type Model_On_Conflict = {
  constraint: Model_Constraint;
  update_columns?: Array<Model_Update_Column>;
  where?: InputMaybe<Model_Bool_Exp>;
};

/** Ordering options when selecting data from "model". */
export type Model_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  modelCounts_aggregate?: InputMaybe<Model_Count_Aggregate_Order_By>;
  modelProducts_aggregate?: InputMaybe<Model_Product_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  photoS3Key?: InputMaybe<Order_By>;
  procedures_aggregate?: InputMaybe<Procedure_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: model */
export type Model_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "model_product" */
export type Model_Product = {
  __typename?: 'model_product';
  created_at: Scalars['timestamptz'];
  model: Scalars['uuid'];
  /** An object relationship */
  modelByModel: Model;
  product: Scalars['uuid'];
  /** An object relationship */
  productByProduct: Product;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "model_product" */
export type Model_Product_Aggregate = {
  __typename?: 'model_product_aggregate';
  aggregate?: Maybe<Model_Product_Aggregate_Fields>;
  nodes: Array<Model_Product>;
};

export type Model_Product_Aggregate_Bool_Exp = {
  count?: InputMaybe<Model_Product_Aggregate_Bool_Exp_Count>;
};

export type Model_Product_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Model_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Model_Product_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "model_product" */
export type Model_Product_Aggregate_Fields = {
  __typename?: 'model_product_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Model_Product_Max_Fields>;
  min?: Maybe<Model_Product_Min_Fields>;
};


/** aggregate fields of "model_product" */
export type Model_Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Model_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "model_product" */
export type Model_Product_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Model_Product_Max_Order_By>;
  min?: InputMaybe<Model_Product_Min_Order_By>;
};

/** input type for inserting array relation for remote table "model_product" */
export type Model_Product_Arr_Rel_Insert_Input = {
  data: Array<Model_Product_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Model_Product_On_Conflict>;
};

/** Boolean expression to filter rows from the table "model_product". All fields are combined with a logical 'AND'. */
export type Model_Product_Bool_Exp = {
  _and?: InputMaybe<Array<Model_Product_Bool_Exp>>;
  _not?: InputMaybe<Model_Product_Bool_Exp>;
  _or?: InputMaybe<Array<Model_Product_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  model?: InputMaybe<Uuid_Comparison_Exp>;
  modelByModel?: InputMaybe<Model_Bool_Exp>;
  product?: InputMaybe<Uuid_Comparison_Exp>;
  productByProduct?: InputMaybe<Product_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "model_product" */
export enum Model_Product_Constraint {
  /** unique or primary key constraint on columns "product", "model" */
  EquipmentProductPkey = 'equipment_product_pkey'
}

/** input type for inserting data into table "model_product" */
export type Model_Product_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  model?: InputMaybe<Scalars['uuid']>;
  modelByModel?: InputMaybe<Model_Obj_Rel_Insert_Input>;
  product?: InputMaybe<Scalars['uuid']>;
  productByProduct?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Model_Product_Max_Fields = {
  __typename?: 'model_product_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  model?: Maybe<Scalars['uuid']>;
  product?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "model_product" */
export type Model_Product_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Model_Product_Min_Fields = {
  __typename?: 'model_product_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  model?: Maybe<Scalars['uuid']>;
  product?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "model_product" */
export type Model_Product_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "model_product" */
export type Model_Product_Mutation_Response = {
  __typename?: 'model_product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Model_Product>;
};

/** on_conflict condition type for table "model_product" */
export type Model_Product_On_Conflict = {
  constraint: Model_Product_Constraint;
  update_columns?: Array<Model_Product_Update_Column>;
  where?: InputMaybe<Model_Product_Bool_Exp>;
};

/** Ordering options when selecting data from "model_product". */
export type Model_Product_Order_By = {
  created_at?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  modelByModel?: InputMaybe<Model_Order_By>;
  product?: InputMaybe<Order_By>;
  productByProduct?: InputMaybe<Product_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: model_product */
export type Model_Product_Pk_Columns_Input = {
  model: Scalars['uuid'];
  product: Scalars['uuid'];
};

/** select columns of table "model_product" */
export enum Model_Product_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Model = 'model',
  /** column name */
  Product = 'product',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "model_product" */
export type Model_Product_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  model?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "model_product" */
export type Model_Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Model_Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Model_Product_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  model?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "model_product" */
export enum Model_Product_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Model = 'model',
  /** column name */
  Product = 'product',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Model_Product_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Model_Product_Set_Input>;
  /** filter the rows which have to be updated */
  where: Model_Product_Bool_Exp;
};

/** select columns of table "model" */
export enum Model_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoS3Key = 'photoS3Key',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "model" */
export type Model_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "model" */
export type Model_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Model_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Model_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "model" */
export enum Model_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoS3Key = 'photoS3Key',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Model_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Model_Set_Input>;
  /** filter the rows which have to be updated */
  where: Model_Bool_Exp;
};

/** columns and relationships of "mso_mode" */
export type Mso_Mode = {
  __typename?: 'mso_mode';
  mode: Scalars['String'];
};

/** aggregated selection of "mso_mode" */
export type Mso_Mode_Aggregate = {
  __typename?: 'mso_mode_aggregate';
  aggregate?: Maybe<Mso_Mode_Aggregate_Fields>;
  nodes: Array<Mso_Mode>;
};

/** aggregate fields of "mso_mode" */
export type Mso_Mode_Aggregate_Fields = {
  __typename?: 'mso_mode_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Mso_Mode_Max_Fields>;
  min?: Maybe<Mso_Mode_Min_Fields>;
};


/** aggregate fields of "mso_mode" */
export type Mso_Mode_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mso_Mode_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "mso_mode". All fields are combined with a logical 'AND'. */
export type Mso_Mode_Bool_Exp = {
  _and?: InputMaybe<Array<Mso_Mode_Bool_Exp>>;
  _not?: InputMaybe<Mso_Mode_Bool_Exp>;
  _or?: InputMaybe<Array<Mso_Mode_Bool_Exp>>;
  mode?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mso_mode" */
export enum Mso_Mode_Constraint {
  /** unique or primary key constraint on columns "mode" */
  MsoModePkey = 'mso_mode_pkey'
}

export enum Mso_Mode_Enum {
  ClassicVansanity = 'CLASSIC_VANSANITY',
  Medspa = 'MEDSPA'
}

/** Boolean expression to compare columns of type "mso_mode_enum". All fields are combined with logical 'AND'. */
export type Mso_Mode_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Mso_Mode_Enum>;
  _in?: InputMaybe<Array<Mso_Mode_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Mso_Mode_Enum>;
  _nin?: InputMaybe<Array<Mso_Mode_Enum>>;
};

/** input type for inserting data into table "mso_mode" */
export type Mso_Mode_Insert_Input = {
  mode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Mso_Mode_Max_Fields = {
  __typename?: 'mso_mode_max_fields';
  mode?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Mso_Mode_Min_Fields = {
  __typename?: 'mso_mode_min_fields';
  mode?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "mso_mode" */
export type Mso_Mode_Mutation_Response = {
  __typename?: 'mso_mode_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mso_Mode>;
};

/** on_conflict condition type for table "mso_mode" */
export type Mso_Mode_On_Conflict = {
  constraint: Mso_Mode_Constraint;
  update_columns?: Array<Mso_Mode_Update_Column>;
  where?: InputMaybe<Mso_Mode_Bool_Exp>;
};

/** Ordering options when selecting data from "mso_mode". */
export type Mso_Mode_Order_By = {
  mode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mso_mode */
export type Mso_Mode_Pk_Columns_Input = {
  mode: Scalars['String'];
};

/** select columns of table "mso_mode" */
export enum Mso_Mode_Select_Column {
  /** column name */
  Mode = 'mode'
}

/** input type for updating data in table "mso_mode" */
export type Mso_Mode_Set_Input = {
  mode?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "mso_mode" */
export type Mso_Mode_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mso_Mode_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mso_Mode_Stream_Cursor_Value_Input = {
  mode?: InputMaybe<Scalars['String']>;
};

/** update columns of table "mso_mode" */
export enum Mso_Mode_Update_Column {
  /** column name */
  Mode = 'mode'
}

export type Mso_Mode_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mso_Mode_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mso_Mode_Bool_Exp;
};

/** columns and relationships of "mso_tier" */
export type Mso_Tier = {
  __typename?: 'mso_tier';
  tier: Scalars['String'];
};

/** aggregated selection of "mso_tier" */
export type Mso_Tier_Aggregate = {
  __typename?: 'mso_tier_aggregate';
  aggregate?: Maybe<Mso_Tier_Aggregate_Fields>;
  nodes: Array<Mso_Tier>;
};

/** aggregate fields of "mso_tier" */
export type Mso_Tier_Aggregate_Fields = {
  __typename?: 'mso_tier_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Mso_Tier_Max_Fields>;
  min?: Maybe<Mso_Tier_Min_Fields>;
};


/** aggregate fields of "mso_tier" */
export type Mso_Tier_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mso_Tier_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "mso_tier". All fields are combined with a logical 'AND'. */
export type Mso_Tier_Bool_Exp = {
  _and?: InputMaybe<Array<Mso_Tier_Bool_Exp>>;
  _not?: InputMaybe<Mso_Tier_Bool_Exp>;
  _or?: InputMaybe<Array<Mso_Tier_Bool_Exp>>;
  tier?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mso_tier" */
export enum Mso_Tier_Constraint {
  /** unique or primary key constraint on columns "tier" */
  MsoTierPkey = 'mso_tier_pkey'
}

export enum Mso_Tier_Enum {
  Base = 'BASE',
  Basic = 'BASIC',
  WhiteGlove = 'WHITE_GLOVE'
}

/** Boolean expression to compare columns of type "mso_tier_enum". All fields are combined with logical 'AND'. */
export type Mso_Tier_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Mso_Tier_Enum>;
  _in?: InputMaybe<Array<Mso_Tier_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Mso_Tier_Enum>;
  _nin?: InputMaybe<Array<Mso_Tier_Enum>>;
};

/** input type for inserting data into table "mso_tier" */
export type Mso_Tier_Insert_Input = {
  tier?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Mso_Tier_Max_Fields = {
  __typename?: 'mso_tier_max_fields';
  tier?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Mso_Tier_Min_Fields = {
  __typename?: 'mso_tier_min_fields';
  tier?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "mso_tier" */
export type Mso_Tier_Mutation_Response = {
  __typename?: 'mso_tier_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mso_Tier>;
};

/** input type for inserting object relation for remote table "mso_tier" */
export type Mso_Tier_Obj_Rel_Insert_Input = {
  data: Mso_Tier_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mso_Tier_On_Conflict>;
};

/** on_conflict condition type for table "mso_tier" */
export type Mso_Tier_On_Conflict = {
  constraint: Mso_Tier_Constraint;
  update_columns?: Array<Mso_Tier_Update_Column>;
  where?: InputMaybe<Mso_Tier_Bool_Exp>;
};

/** Ordering options when selecting data from "mso_tier". */
export type Mso_Tier_Order_By = {
  tier?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mso_tier */
export type Mso_Tier_Pk_Columns_Input = {
  tier: Scalars['String'];
};

/** select columns of table "mso_tier" */
export enum Mso_Tier_Select_Column {
  /** column name */
  Tier = 'tier'
}

/** input type for updating data in table "mso_tier" */
export type Mso_Tier_Set_Input = {
  tier?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "mso_tier" */
export type Mso_Tier_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mso_Tier_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mso_Tier_Stream_Cursor_Value_Input = {
  tier?: InputMaybe<Scalars['String']>;
};

/** update columns of table "mso_tier" */
export enum Mso_Tier_Update_Column {
  /** column name */
  Tier = 'tier'
}

export type Mso_Tier_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mso_Tier_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mso_Tier_Bool_Exp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  CreateNonMedicalWeeklyBooking: Array<CreateWeeklyNonMedicalBookingOutput>;
  /** Record the authenticated patient's request for an appointment; nothing is held and nothing is billed */
  CreatePatientBookingRequest: CreatePatientBookingRequestOutput;
  CreateSquareCustomer: CreateSquareCustomerOutput;
  /** DisconnectSquare */
  DisconnectSquare: DisconnectSquareOutput;
  EhrCreateCharge: EhrCreateChargeOutput;
  EhrDeleteCard: EhrDeleteCardOutput;
  EhrRegisterCard: EhrListCardsOutputItem;
  EhrSaveCard: EhrSaveCardOutput;
  EhrSetDefaultCard: EhrSetDefaultCardOutput;
  InviteProvider: InviteProviderOutput;
  InviteSupervisor: InviteSupervisorOutput;
  /** Cancel the authenticated patient's own appointment or pending request, releasing the room time held for it */
  PatientCancelBooking: CancelPatientBookingOutput;
  RegisterMedicalSupervisor: RegisterMedicalSupervisorOutput;
  RegisterProvider: RegisterProviderOutput;
  SaveSquareCustomerCard: SaveSquareCustomerCardOutput;
  SendPatientRegistrationInvite: SendPatientRegistrationInviteOutput;
  UpdateSupervisorSetting: UpdateSupervisorSettingOutput;
  cancelEhrSubscription: EhrSubscriptionOutput;
  cancelPatientBooking: CancelPatientBookingOutput;
  cancelUserPlan: CancelUserPlanOutput;
  changeEhrTier: EhrTierOutput;
  confirmBooking?: Maybe<ConfirmBookingOutput>;
  confirmCognitoUser?: Maybe<ConfirmCognitoUserOutput>;
  confirmMultipleBookings: Array<Maybe<ConfirmMultipleBookingsOutputItem>>;
  confirmPatientBooking: ConfirmPatientBookingOutput;
  confirmProductPurchase?: Maybe<ProductPurchaseOutput>;
  createBooking?: Maybe<CreateBookingOutput>;
  createCheckoutSession: CreateCheckoutSessionOutput;
  /** CreateMsoPurchaseRequestInvoice */
  createMsoPurchaseRequestInvoice: CreateMsoPurchaseRequestInvoiceOutput;
  createNewMso: CreateNewMsoOutput;
  createOpen?: Maybe<Array<Maybe<CreateOpenOutput>>>;
  createPatientBooking: CreatePatientBookingOutput;
  createPlan: CreatePlanOutput;
  /** createProviderHours */
  createProviderHours: Array<CreateProviderHoursOutput>;
  createRepeatBooking: Array<CreateRepeatBookingOutput>;
  createSetupIntent: CreateSetupIntentOutput;
  createStripeCustomer?: Maybe<CreateStripeCustomerOutput>;
  createUserPlan?: Maybe<CreateUserPlanOutput>;
  deleteCognitoUser: DeleteCognitoUserOutput;
  deletePaymentMethod?: Maybe<DeletePaymentMethodOutput>;
  deletePlan?: Maybe<DeletePlanOutput>;
  /** delete data from the table: "accreditation" */
  delete_accreditation?: Maybe<Accreditation_Mutation_Response>;
  /** delete single row from the table: "accreditation" */
  delete_accreditation_by_pk?: Maybe<Accreditation>;
  /** delete data from the table: "accreditation_location_privilege" */
  delete_accreditation_location_privilege?: Maybe<Accreditation_Location_Privilege_Mutation_Response>;
  /** delete single row from the table: "accreditation_location_privilege" */
  delete_accreditation_location_privilege_by_pk?: Maybe<Accreditation_Location_Privilege>;
  /** delete data from the table: "address" */
  delete_address?: Maybe<Address_Mutation_Response>;
  /** delete single row from the table: "address" */
  delete_address_by_pk?: Maybe<Address>;
  /** delete data from the table: "agreement_type" */
  delete_agreement_type?: Maybe<Agreement_Type_Mutation_Response>;
  /** delete single row from the table: "agreement_type" */
  delete_agreement_type_by_pk?: Maybe<Agreement_Type>;
  /** delete data from the table: "booking" */
  delete_booking?: Maybe<Booking_Mutation_Response>;
  /** delete single row from the table: "booking" */
  delete_booking_by_pk?: Maybe<Booking>;
  /** delete data from the table: "booking_public" */
  delete_booking_public?: Maybe<Booking_Public_Mutation_Response>;
  /** delete data from the table: "booking_type" */
  delete_booking_type?: Maybe<Booking_Type_Mutation_Response>;
  /** delete single row from the table: "booking_type" */
  delete_booking_type_by_pk?: Maybe<Booking_Type>;
  /** delete data from the table: "cancel_reason" */
  delete_cancel_reason?: Maybe<Cancel_Reason_Mutation_Response>;
  /** delete single row from the table: "cancel_reason" */
  delete_cancel_reason_by_pk?: Maybe<Cancel_Reason>;
  /** delete data from the table: "credit" */
  delete_credit?: Maybe<Credit_Mutation_Response>;
  /** delete single row from the table: "credit" */
  delete_credit_by_pk?: Maybe<Credit>;
  /** delete data from the table: "credit_transaction" */
  delete_credit_transaction?: Maybe<Credit_Transaction_Mutation_Response>;
  /** delete single row from the table: "credit_transaction" */
  delete_credit_transaction_by_pk?: Maybe<Credit_Transaction>;
  /** delete data from the table: "credit_type" */
  delete_credit_type?: Maybe<Credit_Type_Mutation_Response>;
  /** delete single row from the table: "credit_type" */
  delete_credit_type_by_pk?: Maybe<Credit_Type>;
  /** delete data from the table: "demo_location" */
  delete_demo_location?: Maybe<Demo_Location_Mutation_Response>;
  /** delete single row from the table: "demo_location" */
  delete_demo_location_by_pk?: Maybe<Demo_Location>;
  /** delete data from the table: "document_type" */
  delete_document_type?: Maybe<Document_Type_Mutation_Response>;
  /** delete single row from the table: "document_type" */
  delete_document_type_by_pk?: Maybe<Document_Type>;
  /** delete data from the table: "ehr_charge_ledger" */
  delete_ehr_charge_ledger?: Maybe<Ehr_Charge_Ledger_Mutation_Response>;
  /** delete single row from the table: "ehr_charge_ledger" */
  delete_ehr_charge_ledger_by_pk?: Maybe<Ehr_Charge_Ledger>;
  /** delete data from the table: "ehr_encounter" */
  delete_ehr_encounter?: Maybe<Ehr_Encounter_Mutation_Response>;
  /** delete data from the table: "ehr_encounter_addendum" */
  delete_ehr_encounter_addendum?: Maybe<Ehr_Encounter_Addendum_Mutation_Response>;
  /** delete single row from the table: "ehr_encounter_addendum" */
  delete_ehr_encounter_addendum_by_pk?: Maybe<Ehr_Encounter_Addendum>;
  /** delete single row from the table: "ehr_encounter" */
  delete_ehr_encounter_by_pk?: Maybe<Ehr_Encounter>;
  /** delete data from the table: "ehr_encounter_modality" */
  delete_ehr_encounter_modality?: Maybe<Ehr_Encounter_Modality_Mutation_Response>;
  /** delete single row from the table: "ehr_encounter_modality" */
  delete_ehr_encounter_modality_by_pk?: Maybe<Ehr_Encounter_Modality>;
  /** delete data from the table: "ehr_encounter_photo" */
  delete_ehr_encounter_photo?: Maybe<Ehr_Encounter_Photo_Mutation_Response>;
  /** delete single row from the table: "ehr_encounter_photo" */
  delete_ehr_encounter_photo_by_pk?: Maybe<Ehr_Encounter_Photo>;
  /** delete data from the table: "ehr_encounter_scan_3d" */
  delete_ehr_encounter_scan_3d?: Maybe<Ehr_Encounter_Scan_3d_Mutation_Response>;
  /** delete data from the table: "ehr_encounter_scan_3d_artifact" */
  delete_ehr_encounter_scan_3d_artifact?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Mutation_Response>;
  /** delete single row from the table: "ehr_encounter_scan_3d_artifact" */
  delete_ehr_encounter_scan_3d_artifact_by_pk?: Maybe<Ehr_Encounter_Scan_3d_Artifact>;
  /** delete data from the table: "ehr_encounter_scan_3d_artifact_kind" */
  delete_ehr_encounter_scan_3d_artifact_kind?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Mutation_Response>;
  /** delete single row from the table: "ehr_encounter_scan_3d_artifact_kind" */
  delete_ehr_encounter_scan_3d_artifact_kind_by_pk?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Kind>;
  /** delete single row from the table: "ehr_encounter_scan_3d" */
  delete_ehr_encounter_scan_3d_by_pk?: Maybe<Ehr_Encounter_Scan_3d>;
  /** delete data from the table: "ehr_encounter_type" */
  delete_ehr_encounter_type?: Maybe<Ehr_Encounter_Type_Mutation_Response>;
  /** delete single row from the table: "ehr_encounter_type" */
  delete_ehr_encounter_type_by_pk?: Maybe<Ehr_Encounter_Type>;
  /** delete data from the table: "ehr_fda_product" */
  delete_ehr_fda_product?: Maybe<Ehr_Fda_Product_Mutation_Response>;
  /** delete single row from the table: "ehr_fda_product" */
  delete_ehr_fda_product_by_pk?: Maybe<Ehr_Fda_Product>;
  /** delete data from the table: "ehr_fda_product_source" */
  delete_ehr_fda_product_source?: Maybe<Ehr_Fda_Product_Source_Mutation_Response>;
  /** delete single row from the table: "ehr_fda_product_source" */
  delete_ehr_fda_product_source_by_pk?: Maybe<Ehr_Fda_Product_Source>;
  /** delete data from the table: "ehr_message" */
  delete_ehr_message?: Maybe<Ehr_Message_Mutation_Response>;
  /** delete single row from the table: "ehr_message" */
  delete_ehr_message_by_pk?: Maybe<Ehr_Message>;
  /** delete data from the table: "ehr_message_read" */
  delete_ehr_message_read?: Maybe<Ehr_Message_Read_Mutation_Response>;
  /** delete single row from the table: "ehr_message_read" */
  delete_ehr_message_read_by_pk?: Maybe<Ehr_Message_Read>;
  /** delete data from the table: "ehr_message_threads" */
  delete_ehr_message_threads?: Maybe<Ehr_Message_Threads_Mutation_Response>;
  /** delete single row from the table: "ehr_message_threads" */
  delete_ehr_message_threads_by_pk?: Maybe<Ehr_Message_Threads>;
  /** delete data from the table: "ehr_patient_card" */
  delete_ehr_patient_card?: Maybe<Ehr_Patient_Card_Mutation_Response>;
  /** delete single row from the table: "ehr_patient_card" */
  delete_ehr_patient_card_by_pk?: Maybe<Ehr_Patient_Card>;
  /** delete data from the table: "ehr_patient_consent" */
  delete_ehr_patient_consent?: Maybe<Ehr_Patient_Consent_Mutation_Response>;
  /** delete data from the table: "ehr_patient_consent_action" */
  delete_ehr_patient_consent_action?: Maybe<Ehr_Patient_Consent_Action_Mutation_Response>;
  /** delete single row from the table: "ehr_patient_consent_action" */
  delete_ehr_patient_consent_action_by_pk?: Maybe<Ehr_Patient_Consent_Action>;
  /** delete single row from the table: "ehr_patient_consent" */
  delete_ehr_patient_consent_by_pk?: Maybe<Ehr_Patient_Consent>;
  /** delete data from the table: "ehr_patient_consent_type" */
  delete_ehr_patient_consent_type?: Maybe<Ehr_Patient_Consent_Type_Mutation_Response>;
  /** delete single row from the table: "ehr_patient_consent_type" */
  delete_ehr_patient_consent_type_by_pk?: Maybe<Ehr_Patient_Consent_Type>;
  /** delete data from the table: "ehr_procedure" */
  delete_ehr_procedure?: Maybe<Ehr_Procedure_Mutation_Response>;
  /** delete data from the table: "ehr_procedure_body_area" */
  delete_ehr_procedure_body_area?: Maybe<Ehr_Procedure_Body_Area_Mutation_Response>;
  /** delete single row from the table: "ehr_procedure_body_area" */
  delete_ehr_procedure_body_area_by_pk?: Maybe<Ehr_Procedure_Body_Area>;
  /** delete data from the table: "ehr_procedure_body_part" */
  delete_ehr_procedure_body_part?: Maybe<Ehr_Procedure_Body_Part_Mutation_Response>;
  /** delete single row from the table: "ehr_procedure_body_part" */
  delete_ehr_procedure_body_part_by_pk?: Maybe<Ehr_Procedure_Body_Part>;
  /** delete data from the table: "ehr_procedure_body_part_provider_injection_default" */
  delete_ehr_procedure_body_part_provider_injection_default?: Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Mutation_Response>;
  /** delete single row from the table: "ehr_procedure_body_part_provider_injection_default" */
  delete_ehr_procedure_body_part_provider_injection_default_by_pk?: Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default>;
  /** delete single row from the table: "ehr_procedure" */
  delete_ehr_procedure_by_pk?: Maybe<Ehr_Procedure>;
  /** delete data from the table: "ehr_procedure_ehr_product" */
  delete_ehr_procedure_ehr_product?: Maybe<Ehr_Procedure_Ehr_Product_Mutation_Response>;
  /** delete single row from the table: "ehr_procedure_ehr_product" */
  delete_ehr_procedure_ehr_product_by_pk?: Maybe<Ehr_Procedure_Ehr_Product>;
  /** delete data from the table: "ehr_procedure_type_enum" */
  delete_ehr_procedure_type_enum?: Maybe<Ehr_Procedure_Type_Enum_Mutation_Response>;
  /** delete single row from the table: "ehr_procedure_type_enum" */
  delete_ehr_procedure_type_enum_by_pk?: Maybe<Ehr_Procedure_Type_Enum>;
  /** delete data from the table: "ehr_product" */
  delete_ehr_product?: Maybe<Ehr_Product_Mutation_Response>;
  /** delete single row from the table: "ehr_product" */
  delete_ehr_product_by_pk?: Maybe<Ehr_Product>;
  /** delete data from the table: "ehr_product_procedure" */
  delete_ehr_product_procedure?: Maybe<Ehr_Product_Procedure_Mutation_Response>;
  /** delete single row from the table: "ehr_product_procedure" */
  delete_ehr_product_procedure_by_pk?: Maybe<Ehr_Product_Procedure>;
  /** delete data from the table: "ehr_product_provider_usage_record_photo" */
  delete_ehr_product_provider_usage_record_photo?: Maybe<Ehr_Product_Provider_Usage_Record_Photo_Mutation_Response>;
  /** delete single row from the table: "ehr_product_provider_usage_record_photo" */
  delete_ehr_product_provider_usage_record_photo_by_pk?: Maybe<Ehr_Product_Provider_Usage_Record_Photo>;
  /** delete data from the table: "ehr_subscription" */
  delete_ehr_subscription?: Maybe<Ehr_Subscription_Mutation_Response>;
  /** delete single row from the table: "ehr_subscription" */
  delete_ehr_subscription_by_pk?: Maybe<Ehr_Subscription>;
  /** delete data from the table: "ehr_subscription_status" */
  delete_ehr_subscription_status?: Maybe<Ehr_Subscription_Status_Mutation_Response>;
  /** delete single row from the table: "ehr_subscription_status" */
  delete_ehr_subscription_status_by_pk?: Maybe<Ehr_Subscription_Status>;
  /** delete data from the table: "ehr_subscription_tier" */
  delete_ehr_subscription_tier?: Maybe<Ehr_Subscription_Tier_Mutation_Response>;
  /** delete single row from the table: "ehr_subscription_tier" */
  delete_ehr_subscription_tier_by_pk?: Maybe<Ehr_Subscription_Tier>;
  /** delete data from the table: "ehr_subscription_tier_term" */
  delete_ehr_subscription_tier_term?: Maybe<Ehr_Subscription_Tier_Term_Mutation_Response>;
  /** delete single row from the table: "ehr_subscription_tier_term" */
  delete_ehr_subscription_tier_term_by_pk?: Maybe<Ehr_Subscription_Tier_Term>;
  /** delete data from the table: "event" */
  delete_event?: Maybe<Event_Mutation_Response>;
  /** delete single row from the table: "event" */
  delete_event_by_pk?: Maybe<Event>;
  /** delete data from the table: "event_source" */
  delete_event_source?: Maybe<Event_Source_Mutation_Response>;
  /** delete single row from the table: "event_source" */
  delete_event_source_by_pk?: Maybe<Event_Source>;
  /** delete data from the table: "filler_procedure_delivery_tool" */
  delete_filler_procedure_delivery_tool?: Maybe<Filler_Procedure_Delivery_Tool_Mutation_Response>;
  /** delete single row from the table: "filler_procedure_delivery_tool" */
  delete_filler_procedure_delivery_tool_by_pk?: Maybe<Filler_Procedure_Delivery_Tool>;
  /** delete data from the table: "filler_procedure_face_view" */
  delete_filler_procedure_face_view?: Maybe<Filler_Procedure_Face_View_Mutation_Response>;
  /** delete single row from the table: "filler_procedure_face_view" */
  delete_filler_procedure_face_view_by_pk?: Maybe<Filler_Procedure_Face_View>;
  /** delete data from the table: "filler_procedure_injection" */
  delete_filler_procedure_injection?: Maybe<Filler_Procedure_Injection_Mutation_Response>;
  /** delete single row from the table: "filler_procedure_injection" */
  delete_filler_procedure_injection_by_pk?: Maybe<Filler_Procedure_Injection>;
  /** delete data from the table: "filler_procedure_injection_type" */
  delete_filler_procedure_injection_type?: Maybe<Filler_Procedure_Injection_Type_Mutation_Response>;
  /** delete single row from the table: "filler_procedure_injection_type" */
  delete_filler_procedure_injection_type_by_pk?: Maybe<Filler_Procedure_Injection_Type>;
  /** delete data from the table: "filler_procedure_product_instance" */
  delete_filler_procedure_product_instance?: Maybe<Filler_Procedure_Product_Instance_Mutation_Response>;
  /** delete single row from the table: "filler_procedure_product_instance" */
  delete_filler_procedure_product_instance_by_pk?: Maybe<Filler_Procedure_Product_Instance>;
  /** delete data from the table: "filler_procedure_product_instance_photo" */
  delete_filler_procedure_product_instance_photo?: Maybe<Filler_Procedure_Product_Instance_Photo_Mutation_Response>;
  /** delete single row from the table: "filler_procedure_product_instance_photo" */
  delete_filler_procedure_product_instance_photo_by_pk?: Maybe<Filler_Procedure_Product_Instance_Photo>;
  /** delete data from the table: "filler_space" */
  delete_filler_space?: Maybe<Filler_Space_Mutation_Response>;
  /** delete single row from the table: "filler_space" */
  delete_filler_space_by_pk?: Maybe<Filler_Space>;
  /** delete data from the table: "filler_zone_release" */
  delete_filler_zone_release?: Maybe<Filler_Zone_Release_Mutation_Response>;
  /** delete single row from the table: "filler_zone_release" */
  delete_filler_zone_release_by_pk?: Maybe<Filler_Zone_Release>;
  /** delete data from the table: "fn_check_proposed_patient_booking_for_stacking" */
  delete_fn_check_proposed_patient_booking_for_stacking?: Maybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Mutation_Response>;
  /** delete single row from the table: "fn_check_proposed_patient_booking_for_stacking" */
  delete_fn_check_proposed_patient_booking_for_stacking_by_pk?: Maybe<Fn_Check_Proposed_Patient_Booking_For_Stacking>;
  /** delete data from the table: "fn_get_active_notification_preferences_for_type_and_location" */
  delete_fn_get_active_notification_preferences_for_type_and_location?: Maybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Mutation_Response>;
  /** delete single row from the table: "fn_get_active_notification_preferences_for_type_and_location" */
  delete_fn_get_active_notification_preferences_for_type_and_location_by_pk?: Maybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location>;
  /** delete data from the table: "fn_get_active_subscribers_query" */
  delete_fn_get_active_subscribers_query?: Maybe<Fn_Get_Active_Subscribers_Query_Mutation_Response>;
  /** delete single row from the table: "fn_get_active_subscribers_query" */
  delete_fn_get_active_subscribers_query_by_pk?: Maybe<Fn_Get_Active_Subscribers_Query>;
  /** delete data from the table: "fn_get_location_purchases_to_provider_purchases_query" */
  delete_fn_get_location_purchases_to_provider_purchases_query?: Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Mutation_Response>;
  /** delete single row from the table: "fn_get_location_purchases_to_provider_purchases_query" */
  delete_fn_get_location_purchases_to_provider_purchases_query_by_pk?: Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query>;
  /** delete data from the table: "fn_get_stackable_booking_options_data" */
  delete_fn_get_stackable_booking_options_data?: Maybe<Fn_Get_Stackable_Booking_Options_Data_Mutation_Response>;
  /** delete single row from the table: "fn_get_stackable_booking_options_data" */
  delete_fn_get_stackable_booking_options_data_by_pk?: Maybe<Fn_Get_Stackable_Booking_Options_Data>;
  /** delete data from the table: "fn_get_user_booking_options_blockers" */
  delete_fn_get_user_booking_options_blockers?: Maybe<Fn_Get_User_Booking_Options_Blockers_Mutation_Response>;
  /** delete single row from the table: "fn_get_user_booking_options_blockers" */
  delete_fn_get_user_booking_options_blockers_by_pk?: Maybe<Fn_Get_User_Booking_Options_Blockers>;
  /** delete data from the table: "fn_get_user_location_procedure_unavailable_rooms" */
  delete_fn_get_user_location_procedure_unavailable_rooms?: Maybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Mutation_Response>;
  /** delete single row from the table: "fn_get_user_location_procedure_unavailable_rooms" */
  delete_fn_get_user_location_procedure_unavailable_rooms_by_pk?: Maybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms>;
  /** delete data from the table: "fn_get_user_products_to_rentals_query" */
  delete_fn_get_user_products_to_rentals_query?: Maybe<Fn_Get_User_Products_To_Rentals_Query_Mutation_Response>;
  /** delete single row from the table: "fn_get_user_products_to_rentals_query" */
  delete_fn_get_user_products_to_rentals_query_by_pk?: Maybe<Fn_Get_User_Products_To_Rentals_Query>;
  /** delete data from the table: "fn_users_unfulfilled_product_purchases_count_by_location" */
  delete_fn_users_unfulfilled_product_purchases_count_by_location?: Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Mutation_Response>;
  /** delete single row from the table: "fn_users_unfulfilled_product_purchases_count_by_location" */
  delete_fn_users_unfulfilled_product_purchases_count_by_location_by_pk?: Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location>;
  /** delete data from the table: "gender" */
  delete_gender?: Maybe<Gender_Mutation_Response>;
  /** delete single row from the table: "gender" */
  delete_gender_by_pk?: Maybe<Gender>;
  /** delete data from the table: "invoice" */
  delete_invoice?: Maybe<Invoice_Mutation_Response>;
  /** delete data from the table: "invoice_billing_summary" */
  delete_invoice_billing_summary?: Maybe<Invoice_Billing_Summary_Mutation_Response>;
  /** delete single row from the table: "invoice" */
  delete_invoice_by_pk?: Maybe<Invoice>;
  /** delete data from the table: "location" */
  delete_location?: Maybe<Location_Mutation_Response>;
  /** delete single row from the table: "location" */
  delete_location_by_pk?: Maybe<Location>;
  /** delete data from the table: "location_procedure" */
  delete_location_procedure?: Maybe<Location_Procedure_Mutation_Response>;
  /** delete single row from the table: "location_procedure" */
  delete_location_procedure_by_pk?: Maybe<Location_Procedure>;
  /** delete data from the table: "location_procedure_room" */
  delete_location_procedure_room?: Maybe<Location_Procedure_Room_Mutation_Response>;
  /** delete single row from the table: "location_procedure_room" */
  delete_location_procedure_room_by_pk?: Maybe<Location_Procedure_Room>;
  /** delete data from the table: "location_product" */
  delete_location_product?: Maybe<Location_Product_Mutation_Response>;
  /** delete single row from the table: "location_product" */
  delete_location_product_by_pk?: Maybe<Location_Product>;
  /** delete data from the table: "model" */
  delete_model?: Maybe<Model_Mutation_Response>;
  /** delete single row from the table: "model" */
  delete_model_by_pk?: Maybe<Model>;
  /** delete data from the table: "model_count" */
  delete_model_count?: Maybe<Model_Count_Mutation_Response>;
  /** delete single row from the table: "model_count" */
  delete_model_count_by_pk?: Maybe<Model_Count>;
  /** delete data from the table: "model_product" */
  delete_model_product?: Maybe<Model_Product_Mutation_Response>;
  /** delete single row from the table: "model_product" */
  delete_model_product_by_pk?: Maybe<Model_Product>;
  /** delete data from the table: "mso_mode" */
  delete_mso_mode?: Maybe<Mso_Mode_Mutation_Response>;
  /** delete single row from the table: "mso_mode" */
  delete_mso_mode_by_pk?: Maybe<Mso_Mode>;
  /** delete data from the table: "mso_tier" */
  delete_mso_tier?: Maybe<Mso_Tier_Mutation_Response>;
  /** delete single row from the table: "mso_tier" */
  delete_mso_tier_by_pk?: Maybe<Mso_Tier>;
  /** delete data from the table: "notification_audit_log" */
  delete_notification_audit_log?: Maybe<Notification_Audit_Log_Mutation_Response>;
  /** delete single row from the table: "notification_audit_log" */
  delete_notification_audit_log_by_pk?: Maybe<Notification_Audit_Log>;
  /** delete data from the table: "notification_broadcast_type" */
  delete_notification_broadcast_type?: Maybe<Notification_Broadcast_Type_Mutation_Response>;
  /** delete single row from the table: "notification_broadcast_type" */
  delete_notification_broadcast_type_by_pk?: Maybe<Notification_Broadcast_Type>;
  /** delete data from the table: "notification_channel" */
  delete_notification_channel?: Maybe<Notification_Channel_Mutation_Response>;
  /** delete single row from the table: "notification_channel" */
  delete_notification_channel_by_pk?: Maybe<Notification_Channel>;
  /** delete data from the table: "notification_preference" */
  delete_notification_preference?: Maybe<Notification_Preference_Mutation_Response>;
  /** delete single row from the table: "notification_preference" */
  delete_notification_preference_by_pk?: Maybe<Notification_Preference>;
  /** delete data from the table: "notification_type" */
  delete_notification_type?: Maybe<Notification_Type_Mutation_Response>;
  /** delete single row from the table: "notification_type" */
  delete_notification_type_by_pk?: Maybe<Notification_Type>;
  /** delete data from the table: "notification_type_default_channel" */
  delete_notification_type_default_channel?: Maybe<Notification_Type_Default_Channel_Mutation_Response>;
  /** delete single row from the table: "notification_type_default_channel" */
  delete_notification_type_default_channel_by_pk?: Maybe<Notification_Type_Default_Channel>;
  /** delete data from the table: "open" */
  delete_open?: Maybe<Open_Mutation_Response>;
  /** delete single row from the table: "open" */
  delete_open_by_pk?: Maybe<Open>;
  /** delete data from the table: "partner" */
  delete_partner?: Maybe<Partner_Mutation_Response>;
  /** delete data from the table: "partner_basic" */
  delete_partner_basic?: Maybe<Partner_Basic_Mutation_Response>;
  /** delete single row from the table: "partner" */
  delete_partner_by_pk?: Maybe<Partner>;
  /** delete data from the table: "patient" */
  delete_patient?: Maybe<Patient_Mutation_Response>;
  /** delete data from the table: "patient_account_event" */
  delete_patient_account_event?: Maybe<Patient_Account_Event_Mutation_Response>;
  /** delete single row from the table: "patient_account_event" */
  delete_patient_account_event_by_pk?: Maybe<Patient_Account_Event>;
  /** delete data from the table: "patient_account_event_type" */
  delete_patient_account_event_type?: Maybe<Patient_Account_Event_Type_Mutation_Response>;
  /** delete single row from the table: "patient_account_event_type" */
  delete_patient_account_event_type_by_pk?: Maybe<Patient_Account_Event_Type>;
  /** delete data from the table: "patient_auth_challenge" */
  delete_patient_auth_challenge?: Maybe<Patient_Auth_Challenge_Mutation_Response>;
  /** delete single row from the table: "patient_auth_challenge" */
  delete_patient_auth_challenge_by_pk?: Maybe<Patient_Auth_Challenge>;
  /** delete data from the table: "patient_bookable_ehr_procedure" */
  delete_patient_bookable_ehr_procedure?: Maybe<Patient_Bookable_Ehr_Procedure_Mutation_Response>;
  /** delete single row from the table: "patient_bookable_ehr_procedure" */
  delete_patient_bookable_ehr_procedure_by_pk?: Maybe<Patient_Bookable_Ehr_Procedure>;
  /** delete data from the table: "patient_booking" */
  delete_patient_booking?: Maybe<Patient_Booking_Mutation_Response>;
  /** delete data from the table: "patient_booking_booking" */
  delete_patient_booking_booking?: Maybe<Patient_Booking_Booking_Mutation_Response>;
  /** delete single row from the table: "patient_booking_booking" */
  delete_patient_booking_booking_by_pk?: Maybe<Patient_Booking_Booking>;
  /** delete single row from the table: "patient_booking" */
  delete_patient_booking_by_pk?: Maybe<Patient_Booking>;
  /** delete data from the table: "patient_booking_cancel_reason" */
  delete_patient_booking_cancel_reason?: Maybe<Patient_Booking_Cancel_Reason_Mutation_Response>;
  /** delete single row from the table: "patient_booking_cancel_reason" */
  delete_patient_booking_cancel_reason_by_pk?: Maybe<Patient_Booking_Cancel_Reason>;
  /** delete data from the table: "patient_booking_initiator" */
  delete_patient_booking_initiator?: Maybe<Patient_Booking_Initiator_Mutation_Response>;
  /** delete single row from the table: "patient_booking_initiator" */
  delete_patient_booking_initiator_by_pk?: Maybe<Patient_Booking_Initiator>;
  /** delete data from the table: "patient_booking_metadata" */
  delete_patient_booking_metadata?: Maybe<Patient_Booking_Metadata_Mutation_Response>;
  /** delete single row from the table: "patient_booking_metadata" */
  delete_patient_booking_metadata_by_pk?: Maybe<Patient_Booking_Metadata>;
  /** delete single row from the table: "patient" */
  delete_patient_by_pk?: Maybe<Patient>;
  /** delete data from the table: "patient_last_view" */
  delete_patient_last_view?: Maybe<Patient_Last_View_Mutation_Response>;
  /** delete single row from the table: "patient_last_view" */
  delete_patient_last_view_by_pk?: Maybe<Patient_Last_View>;
  /** delete data from the table: "patient_medical_profile" */
  delete_patient_medical_profile?: Maybe<Patient_Medical_Profile_Mutation_Response>;
  /** delete single row from the table: "patient_medical_profile" */
  delete_patient_medical_profile_by_pk?: Maybe<Patient_Medical_Profile>;
  /** delete data from the table: "patient_registration_invite" */
  delete_patient_registration_invite?: Maybe<Patient_Registration_Invite_Mutation_Response>;
  /** delete single row from the table: "patient_registration_invite" */
  delete_patient_registration_invite_by_pk?: Maybe<Patient_Registration_Invite>;
  /** delete data from the table: "patient_session" */
  delete_patient_session?: Maybe<Patient_Session_Mutation_Response>;
  /** delete single row from the table: "patient_session" */
  delete_patient_session_by_pk?: Maybe<Patient_Session>;
  /** delete data from the table: "patient_webauthn_challenge" */
  delete_patient_webauthn_challenge?: Maybe<Patient_Webauthn_Challenge_Mutation_Response>;
  /** delete single row from the table: "patient_webauthn_challenge" */
  delete_patient_webauthn_challenge_by_pk?: Maybe<Patient_Webauthn_Challenge>;
  /** delete data from the table: "patient_webauthn_credential" */
  delete_patient_webauthn_credential?: Maybe<Patient_Webauthn_Credential_Mutation_Response>;
  /** delete single row from the table: "patient_webauthn_credential" */
  delete_patient_webauthn_credential_by_pk?: Maybe<Patient_Webauthn_Credential>;
  /** delete data from the table: "plan" */
  delete_plan?: Maybe<Plan_Mutation_Response>;
  /** delete single row from the table: "plan" */
  delete_plan_by_pk?: Maybe<Plan>;
  /** delete data from the table: "plan_type" */
  delete_plan_type?: Maybe<Plan_Type_Mutation_Response>;
  /** delete single row from the table: "plan_type" */
  delete_plan_type_by_pk?: Maybe<Plan_Type>;
  /** delete data from the table: "pre_procedure_photo_injection_marking" */
  delete_pre_procedure_photo_injection_marking?: Maybe<Pre_Procedure_Photo_Injection_Marking_Mutation_Response>;
  /** delete single row from the table: "pre_procedure_photo_injection_marking" */
  delete_pre_procedure_photo_injection_marking_by_pk?: Maybe<Pre_Procedure_Photo_Injection_Marking>;
  /** delete data from the table: "procedure" */
  delete_procedure?: Maybe<Procedure_Mutation_Response>;
  /** delete data from the table: "procedure_audio_recording" */
  delete_procedure_audio_recording?: Maybe<Procedure_Audio_Recording_Mutation_Response>;
  /** delete single row from the table: "procedure_audio_recording" */
  delete_procedure_audio_recording_by_pk?: Maybe<Procedure_Audio_Recording>;
  /** delete single row from the table: "procedure" */
  delete_procedure_by_pk?: Maybe<Procedure>;
  /** delete data from the table: "product" */
  delete_product?: Maybe<Product_Mutation_Response>;
  /** delete single row from the table: "product" */
  delete_product_by_pk?: Maybe<Product>;
  /** delete data from the table: "product_purchase" */
  delete_product_purchase?: Maybe<Product_Purchase_Mutation_Response>;
  /** delete single row from the table: "product_purchase" */
  delete_product_purchase_by_pk?: Maybe<Product_Purchase>;
  /** delete data from the table: "product_type" */
  delete_product_type?: Maybe<Product_Type_Mutation_Response>;
  /** delete single row from the table: "product_type" */
  delete_product_type_by_pk?: Maybe<Product_Type>;
  /** delete data from the table: "provider_direct_product_purchase" */
  delete_provider_direct_product_purchase?: Maybe<Provider_Direct_Product_Purchase_Mutation_Response>;
  /** delete single row from the table: "provider_direct_product_purchase" */
  delete_provider_direct_product_purchase_by_pk?: Maybe<Provider_Direct_Product_Purchase>;
  /** delete data from the table: "provider_hours" */
  delete_provider_hours?: Maybe<Provider_Hours_Mutation_Response>;
  /** delete single row from the table: "provider_hours" */
  delete_provider_hours_by_pk?: Maybe<Provider_Hours>;
  /** delete data from the table: "provider_hours_repeat_interval" */
  delete_provider_hours_repeat_interval?: Maybe<Provider_Hours_Repeat_Interval_Mutation_Response>;
  /** delete single row from the table: "provider_hours_repeat_interval" */
  delete_provider_hours_repeat_interval_by_pk?: Maybe<Provider_Hours_Repeat_Interval>;
  /** delete data from the table: "provider_hours_repeater" */
  delete_provider_hours_repeater?: Maybe<Provider_Hours_Repeater_Mutation_Response>;
  /** delete single row from the table: "provider_hours_repeater" */
  delete_provider_hours_repeater_by_pk?: Maybe<Provider_Hours_Repeater>;
  /** delete data from the table: "provider_patient_booking_settings" */
  delete_provider_patient_booking_settings?: Maybe<Provider_Patient_Booking_Settings_Mutation_Response>;
  /** delete single row from the table: "provider_patient_booking_settings" */
  delete_provider_patient_booking_settings_by_pk?: Maybe<Provider_Patient_Booking_Settings>;
  /** delete data from the table: "provider_procedure" */
  delete_provider_procedure?: Maybe<Provider_Procedure_Mutation_Response>;
  /** delete single row from the table: "provider_procedure" */
  delete_provider_procedure_by_pk?: Maybe<Provider_Procedure>;
  /** delete data from the table: "purchase_for_location" */
  delete_purchase_for_location?: Maybe<Purchase_For_Location_Mutation_Response>;
  /** delete single row from the table: "purchase_for_location" */
  delete_purchase_for_location_by_pk?: Maybe<Purchase_For_Location>;
  /** delete data from the table: "rental_volume_discount" */
  delete_rental_volume_discount?: Maybe<Rental_Volume_Discount_Mutation_Response>;
  /** delete single row from the table: "rental_volume_discount" */
  delete_rental_volume_discount_by_pk?: Maybe<Rental_Volume_Discount>;
  /** delete data from the table: "repeating" */
  delete_repeating?: Maybe<Repeating_Mutation_Response>;
  /** delete single row from the table: "repeating" */
  delete_repeating_by_pk?: Maybe<Repeating>;
  /** delete data from the table: "report_preference" */
  delete_report_preference?: Maybe<Report_Preference_Mutation_Response>;
  /** delete single row from the table: "report_preference" */
  delete_report_preference_by_pk?: Maybe<Report_Preference>;
  /** delete data from the table: "report_type" */
  delete_report_type?: Maybe<Report_Type_Mutation_Response>;
  /** delete single row from the table: "report_type" */
  delete_report_type_by_pk?: Maybe<Report_Type>;
  /** delete data from the table: "role" */
  delete_role?: Maybe<Role_Mutation_Response>;
  /** delete single row from the table: "role" */
  delete_role_by_pk?: Maybe<Role>;
  /** delete data from the table: "role_notification" */
  delete_role_notification?: Maybe<Role_Notification_Mutation_Response>;
  /** delete single row from the table: "role_notification" */
  delete_role_notification_by_pk?: Maybe<Role_Notification>;
  /** delete data from the table: "room" */
  delete_room?: Maybe<Room_Mutation_Response>;
  /** delete single row from the table: "room" */
  delete_room_by_pk?: Maybe<Room>;
  /** delete data from the table: "room_model" */
  delete_room_model?: Maybe<Room_Model_Mutation_Response>;
  /** delete single row from the table: "room_model" */
  delete_room_model_by_pk?: Maybe<Room_Model>;
  /** delete data from the table: "room_type" */
  delete_room_type?: Maybe<Room_Type_Mutation_Response>;
  /** delete single row from the table: "room_type" */
  delete_room_type_by_pk?: Maybe<Room_Type>;
  /** delete data from the table: "sex" */
  delete_sex?: Maybe<Sex_Mutation_Response>;
  /** delete single row from the table: "sex" */
  delete_sex_by_pk?: Maybe<Sex>;
  /** delete data from the table: "signing_document" */
  delete_signing_document?: Maybe<Signing_Document_Mutation_Response>;
  /** delete single row from the table: "signing_document" */
  delete_signing_document_by_pk?: Maybe<Signing_Document>;
  /** delete data from the table: "signing_document_status_type" */
  delete_signing_document_status_type?: Maybe<Signing_Document_Status_Type_Mutation_Response>;
  /** delete single row from the table: "signing_document_status_type" */
  delete_signing_document_status_type_by_pk?: Maybe<Signing_Document_Status_Type>;
  /** delete data from the table: "signing_procedure_associated_documents" */
  delete_signing_procedure_associated_documents?: Maybe<Signing_Procedure_Associated_Documents_Mutation_Response>;
  /** delete single row from the table: "signing_procedure_associated_documents" */
  delete_signing_procedure_associated_documents_by_pk?: Maybe<Signing_Procedure_Associated_Documents>;
  /** delete data from the table: "signing_template" */
  delete_signing_template?: Maybe<Signing_Template_Mutation_Response>;
  /** delete single row from the table: "signing_template" */
  delete_signing_template_by_pk?: Maybe<Signing_Template>;
  /** delete data from the table: "signing_template_equivalents" */
  delete_signing_template_equivalents?: Maybe<Signing_Template_Equivalents_Mutation_Response>;
  /** delete single row from the table: "signing_template_equivalents" */
  delete_signing_template_equivalents_by_pk?: Maybe<Signing_Template_Equivalents>;
  /** delete data from the table: "signing_template_kind" */
  delete_signing_template_kind?: Maybe<Signing_Template_Kind_Mutation_Response>;
  /** delete single row from the table: "signing_template_kind" */
  delete_signing_template_kind_by_pk?: Maybe<Signing_Template_Kind>;
  /** delete data from the table: "signing_template_source_files" */
  delete_signing_template_source_files?: Maybe<Signing_Template_Source_Files_Mutation_Response>;
  /** delete single row from the table: "signing_template_source_files" */
  delete_signing_template_source_files_by_pk?: Maybe<Signing_Template_Source_Files>;
  /** delete data from the table: "signing_vansanity_template" */
  delete_signing_vansanity_template?: Maybe<Signing_Vansanity_Template_Mutation_Response>;
  /** delete single row from the table: "signing_vansanity_template" */
  delete_signing_vansanity_template_by_pk?: Maybe<Signing_Vansanity_Template>;
  /** delete data from the table: "signing_webhook_event" */
  delete_signing_webhook_event?: Maybe<Signing_Webhook_Event_Mutation_Response>;
  /** delete single row from the table: "signing_webhook_event" */
  delete_signing_webhook_event_by_pk?: Maybe<Signing_Webhook_Event>;
  /** delete data from the table: "signing_webhook_event_type" */
  delete_signing_webhook_event_type?: Maybe<Signing_Webhook_Event_Type_Mutation_Response>;
  /** delete single row from the table: "signing_webhook_event_type" */
  delete_signing_webhook_event_type_by_pk?: Maybe<Signing_Webhook_Event_Type>;
  /** delete data from the table: "square_credential_ownership_enum" */
  delete_square_credential_ownership_enum?: Maybe<Square_Credential_Ownership_Enum_Mutation_Response>;
  /** delete single row from the table: "square_credential_ownership_enum" */
  delete_square_credential_ownership_enum_by_pk?: Maybe<Square_Credential_Ownership_Enum>;
  /** delete data from the table: "square_credentials" */
  delete_square_credentials?: Maybe<Square_Credentials_Mutation_Response>;
  /** delete single row from the table: "square_credentials" */
  delete_square_credentials_by_pk?: Maybe<Square_Credentials>;
  /** delete data from the table: "supervisor_provider" */
  delete_supervisor_provider?: Maybe<Supervisor_Provider_Mutation_Response>;
  /** delete single row from the table: "supervisor_provider" */
  delete_supervisor_provider_by_pk?: Maybe<Supervisor_Provider>;
  /** delete data from the table: "supervisor_provider_initiated_by" */
  delete_supervisor_provider_initiated_by?: Maybe<Supervisor_Provider_Initiated_By_Mutation_Response>;
  /** delete single row from the table: "supervisor_provider_initiated_by" */
  delete_supervisor_provider_initiated_by_by_pk?: Maybe<Supervisor_Provider_Initiated_By>;
  /** delete data from the table: "supervisor_provider_term" */
  delete_supervisor_provider_term?: Maybe<Supervisor_Provider_Term_Mutation_Response>;
  /** delete single row from the table: "supervisor_provider_term" */
  delete_supervisor_provider_term_by_pk?: Maybe<Supervisor_Provider_Term>;
  /** delete data from the table: "supervisor_provider_term_ended_by" */
  delete_supervisor_provider_term_ended_by?: Maybe<Supervisor_Provider_Term_Ended_By_Mutation_Response>;
  /** delete single row from the table: "supervisor_provider_term_ended_by" */
  delete_supervisor_provider_term_ended_by_by_pk?: Maybe<Supervisor_Provider_Term_Ended_By>;
  /** delete data from the table: "supervisor_review_queue_item" */
  delete_supervisor_review_queue_item?: Maybe<Supervisor_Review_Queue_Item_Mutation_Response>;
  /** delete single row from the table: "supervisor_review_queue_item" */
  delete_supervisor_review_queue_item_by_pk?: Maybe<Supervisor_Review_Queue_Item>;
  /** delete data from the table: "supervisor_review_queue_item_status_history" */
  delete_supervisor_review_queue_item_status_history?: Maybe<Supervisor_Review_Queue_Item_Status_History_Mutation_Response>;
  /** delete single row from the table: "supervisor_review_queue_item_status_history" */
  delete_supervisor_review_queue_item_status_history_by_pk?: Maybe<Supervisor_Review_Queue_Item_Status_History>;
  /** delete data from the table: "supervisor_review_queue_source" */
  delete_supervisor_review_queue_source?: Maybe<Supervisor_Review_Queue_Source_Mutation_Response>;
  /** delete single row from the table: "supervisor_review_queue_source" */
  delete_supervisor_review_queue_source_by_pk?: Maybe<Supervisor_Review_Queue_Source>;
  /** delete data from the table: "supervisor_review_queue_status" */
  delete_supervisor_review_queue_status?: Maybe<Supervisor_Review_Queue_Status_Mutation_Response>;
  /** delete single row from the table: "supervisor_review_queue_status" */
  delete_supervisor_review_queue_status_by_pk?: Maybe<Supervisor_Review_Queue_Status>;
  /** delete data from the table: "supervisor_sampling_period_type" */
  delete_supervisor_sampling_period_type?: Maybe<Supervisor_Sampling_Period_Type_Mutation_Response>;
  /** delete single row from the table: "supervisor_sampling_period_type" */
  delete_supervisor_sampling_period_type_by_pk?: Maybe<Supervisor_Sampling_Period_Type>;
  /** delete data from the table: "supervisor_setting" */
  delete_supervisor_setting?: Maybe<Supervisor_Setting_Mutation_Response>;
  /** delete single row from the table: "supervisor_setting" */
  delete_supervisor_setting_by_pk?: Maybe<Supervisor_Setting>;
  /** delete data from the table: "tax_rate" */
  delete_tax_rate?: Maybe<Tax_Rate_Mutation_Response>;
  /** delete single row from the table: "tax_rate" */
  delete_tax_rate_by_pk?: Maybe<Tax_Rate>;
  /** delete data from the table: "tax_type" */
  delete_tax_type?: Maybe<Tax_Type_Mutation_Response>;
  /** delete single row from the table: "tax_type" */
  delete_tax_type_by_pk?: Maybe<Tax_Type>;
  /** delete data from the table: "user" */
  delete_user?: Maybe<User_Mutation_Response>;
  /** delete data from the table: "user_agreements" */
  delete_user_agreements?: Maybe<User_Agreements_Mutation_Response>;
  /** delete single row from the table: "user_agreements" */
  delete_user_agreements_by_pk?: Maybe<User_Agreements>;
  /** delete single row from the table: "user" */
  delete_user_by_pk?: Maybe<User>;
  /** delete data from the table: "user_consent" */
  delete_user_consent?: Maybe<User_Consent_Mutation_Response>;
  /** delete data from the table: "user_consent_action" */
  delete_user_consent_action?: Maybe<User_Consent_Action_Mutation_Response>;
  /** delete single row from the table: "user_consent_action" */
  delete_user_consent_action_by_pk?: Maybe<User_Consent_Action>;
  /** delete single row from the table: "user_consent" */
  delete_user_consent_by_pk?: Maybe<User_Consent>;
  /** delete data from the table: "user_consent_type" */
  delete_user_consent_type?: Maybe<User_Consent_Type_Mutation_Response>;
  /** delete single row from the table: "user_consent_type" */
  delete_user_consent_type_by_pk?: Maybe<User_Consent_Type>;
  /** delete data from the table: "user_device_push_notification_token" */
  delete_user_device_push_notification_token?: Maybe<User_Device_Push_Notification_Token_Mutation_Response>;
  /** delete single row from the table: "user_device_push_notification_token" */
  delete_user_device_push_notification_token_by_pk?: Maybe<User_Device_Push_Notification_Token>;
  /** delete data from the table: "user_document" */
  delete_user_document?: Maybe<User_Document_Mutation_Response>;
  /** delete single row from the table: "user_document" */
  delete_user_document_by_pk?: Maybe<User_Document>;
  /** delete data from the table: "user_location" */
  delete_user_location?: Maybe<User_Location_Mutation_Response>;
  /** delete single row from the table: "user_location" */
  delete_user_location_by_pk?: Maybe<User_Location>;
  /** delete data from the table: "user_plan" */
  delete_user_plan?: Maybe<User_Plan_Mutation_Response>;
  /** delete single row from the table: "user_plan" */
  delete_user_plan_by_pk?: Maybe<User_Plan>;
  /** delete data from the table: "version" */
  delete_version?: Maybe<Version_Mutation_Response>;
  /** delete single row from the table: "version" */
  delete_version_by_pk?: Maybe<Version>;
  editBooking?: Maybe<EditBookingOutput>;
  editOpen?: Maybe<Array<Maybe<CreateOpenOutput>>>;
  enableEhrSubscription: EhrSubscriptionOutput;
  /** insert data into the table: "accreditation" */
  insert_accreditation?: Maybe<Accreditation_Mutation_Response>;
  /** insert data into the table: "accreditation_location_privilege" */
  insert_accreditation_location_privilege?: Maybe<Accreditation_Location_Privilege_Mutation_Response>;
  /** insert a single row into the table: "accreditation_location_privilege" */
  insert_accreditation_location_privilege_one?: Maybe<Accreditation_Location_Privilege>;
  /** insert a single row into the table: "accreditation" */
  insert_accreditation_one?: Maybe<Accreditation>;
  /** insert data into the table: "address" */
  insert_address?: Maybe<Address_Mutation_Response>;
  /** insert a single row into the table: "address" */
  insert_address_one?: Maybe<Address>;
  /** insert data into the table: "agreement_type" */
  insert_agreement_type?: Maybe<Agreement_Type_Mutation_Response>;
  /** insert a single row into the table: "agreement_type" */
  insert_agreement_type_one?: Maybe<Agreement_Type>;
  /** insert data into the table: "booking" */
  insert_booking?: Maybe<Booking_Mutation_Response>;
  /** insert a single row into the table: "booking" */
  insert_booking_one?: Maybe<Booking>;
  /** insert data into the table: "booking_public" */
  insert_booking_public?: Maybe<Booking_Public_Mutation_Response>;
  /** insert a single row into the table: "booking_public" */
  insert_booking_public_one?: Maybe<Booking_Public>;
  /** insert data into the table: "booking_type" */
  insert_booking_type?: Maybe<Booking_Type_Mutation_Response>;
  /** insert a single row into the table: "booking_type" */
  insert_booking_type_one?: Maybe<Booking_Type>;
  /** insert data into the table: "cancel_reason" */
  insert_cancel_reason?: Maybe<Cancel_Reason_Mutation_Response>;
  /** insert a single row into the table: "cancel_reason" */
  insert_cancel_reason_one?: Maybe<Cancel_Reason>;
  /** insert data into the table: "credit" */
  insert_credit?: Maybe<Credit_Mutation_Response>;
  /** insert a single row into the table: "credit" */
  insert_credit_one?: Maybe<Credit>;
  /** insert data into the table: "credit_transaction" */
  insert_credit_transaction?: Maybe<Credit_Transaction_Mutation_Response>;
  /** insert a single row into the table: "credit_transaction" */
  insert_credit_transaction_one?: Maybe<Credit_Transaction>;
  /** insert data into the table: "credit_type" */
  insert_credit_type?: Maybe<Credit_Type_Mutation_Response>;
  /** insert a single row into the table: "credit_type" */
  insert_credit_type_one?: Maybe<Credit_Type>;
  /** insert data into the table: "demo_location" */
  insert_demo_location?: Maybe<Demo_Location_Mutation_Response>;
  /** insert a single row into the table: "demo_location" */
  insert_demo_location_one?: Maybe<Demo_Location>;
  /** insert data into the table: "document_type" */
  insert_document_type?: Maybe<Document_Type_Mutation_Response>;
  /** insert a single row into the table: "document_type" */
  insert_document_type_one?: Maybe<Document_Type>;
  /** insert data into the table: "ehr_charge_ledger" */
  insert_ehr_charge_ledger?: Maybe<Ehr_Charge_Ledger_Mutation_Response>;
  /** insert a single row into the table: "ehr_charge_ledger" */
  insert_ehr_charge_ledger_one?: Maybe<Ehr_Charge_Ledger>;
  /** insert data into the table: "ehr_encounter" */
  insert_ehr_encounter?: Maybe<Ehr_Encounter_Mutation_Response>;
  /** insert data into the table: "ehr_encounter_addendum" */
  insert_ehr_encounter_addendum?: Maybe<Ehr_Encounter_Addendum_Mutation_Response>;
  /** insert a single row into the table: "ehr_encounter_addendum" */
  insert_ehr_encounter_addendum_one?: Maybe<Ehr_Encounter_Addendum>;
  /** insert data into the table: "ehr_encounter_modality" */
  insert_ehr_encounter_modality?: Maybe<Ehr_Encounter_Modality_Mutation_Response>;
  /** insert a single row into the table: "ehr_encounter_modality" */
  insert_ehr_encounter_modality_one?: Maybe<Ehr_Encounter_Modality>;
  /** insert a single row into the table: "ehr_encounter" */
  insert_ehr_encounter_one?: Maybe<Ehr_Encounter>;
  /** insert data into the table: "ehr_encounter_photo" */
  insert_ehr_encounter_photo?: Maybe<Ehr_Encounter_Photo_Mutation_Response>;
  /** insert a single row into the table: "ehr_encounter_photo" */
  insert_ehr_encounter_photo_one?: Maybe<Ehr_Encounter_Photo>;
  /** insert data into the table: "ehr_encounter_scan_3d" */
  insert_ehr_encounter_scan_3d?: Maybe<Ehr_Encounter_Scan_3d_Mutation_Response>;
  /** insert data into the table: "ehr_encounter_scan_3d_artifact" */
  insert_ehr_encounter_scan_3d_artifact?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Mutation_Response>;
  /** insert data into the table: "ehr_encounter_scan_3d_artifact_kind" */
  insert_ehr_encounter_scan_3d_artifact_kind?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Mutation_Response>;
  /** insert a single row into the table: "ehr_encounter_scan_3d_artifact_kind" */
  insert_ehr_encounter_scan_3d_artifact_kind_one?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Kind>;
  /** insert a single row into the table: "ehr_encounter_scan_3d_artifact" */
  insert_ehr_encounter_scan_3d_artifact_one?: Maybe<Ehr_Encounter_Scan_3d_Artifact>;
  /** insert a single row into the table: "ehr_encounter_scan_3d" */
  insert_ehr_encounter_scan_3d_one?: Maybe<Ehr_Encounter_Scan_3d>;
  /** insert data into the table: "ehr_encounter_type" */
  insert_ehr_encounter_type?: Maybe<Ehr_Encounter_Type_Mutation_Response>;
  /** insert a single row into the table: "ehr_encounter_type" */
  insert_ehr_encounter_type_one?: Maybe<Ehr_Encounter_Type>;
  /** insert data into the table: "ehr_fda_product" */
  insert_ehr_fda_product?: Maybe<Ehr_Fda_Product_Mutation_Response>;
  /** insert a single row into the table: "ehr_fda_product" */
  insert_ehr_fda_product_one?: Maybe<Ehr_Fda_Product>;
  /** insert data into the table: "ehr_fda_product_source" */
  insert_ehr_fda_product_source?: Maybe<Ehr_Fda_Product_Source_Mutation_Response>;
  /** insert a single row into the table: "ehr_fda_product_source" */
  insert_ehr_fda_product_source_one?: Maybe<Ehr_Fda_Product_Source>;
  /** insert data into the table: "ehr_message" */
  insert_ehr_message?: Maybe<Ehr_Message_Mutation_Response>;
  /** insert a single row into the table: "ehr_message" */
  insert_ehr_message_one?: Maybe<Ehr_Message>;
  /** insert data into the table: "ehr_message_read" */
  insert_ehr_message_read?: Maybe<Ehr_Message_Read_Mutation_Response>;
  /** insert a single row into the table: "ehr_message_read" */
  insert_ehr_message_read_one?: Maybe<Ehr_Message_Read>;
  /** insert data into the table: "ehr_message_threads" */
  insert_ehr_message_threads?: Maybe<Ehr_Message_Threads_Mutation_Response>;
  /** insert a single row into the table: "ehr_message_threads" */
  insert_ehr_message_threads_one?: Maybe<Ehr_Message_Threads>;
  /** insert data into the table: "ehr_patient_card" */
  insert_ehr_patient_card?: Maybe<Ehr_Patient_Card_Mutation_Response>;
  /** insert a single row into the table: "ehr_patient_card" */
  insert_ehr_patient_card_one?: Maybe<Ehr_Patient_Card>;
  /** insert data into the table: "ehr_patient_consent" */
  insert_ehr_patient_consent?: Maybe<Ehr_Patient_Consent_Mutation_Response>;
  /** insert data into the table: "ehr_patient_consent_action" */
  insert_ehr_patient_consent_action?: Maybe<Ehr_Patient_Consent_Action_Mutation_Response>;
  /** insert a single row into the table: "ehr_patient_consent_action" */
  insert_ehr_patient_consent_action_one?: Maybe<Ehr_Patient_Consent_Action>;
  /** insert a single row into the table: "ehr_patient_consent" */
  insert_ehr_patient_consent_one?: Maybe<Ehr_Patient_Consent>;
  /** insert data into the table: "ehr_patient_consent_type" */
  insert_ehr_patient_consent_type?: Maybe<Ehr_Patient_Consent_Type_Mutation_Response>;
  /** insert a single row into the table: "ehr_patient_consent_type" */
  insert_ehr_patient_consent_type_one?: Maybe<Ehr_Patient_Consent_Type>;
  /** insert data into the table: "ehr_procedure" */
  insert_ehr_procedure?: Maybe<Ehr_Procedure_Mutation_Response>;
  /** insert data into the table: "ehr_procedure_body_area" */
  insert_ehr_procedure_body_area?: Maybe<Ehr_Procedure_Body_Area_Mutation_Response>;
  /** insert a single row into the table: "ehr_procedure_body_area" */
  insert_ehr_procedure_body_area_one?: Maybe<Ehr_Procedure_Body_Area>;
  /** insert data into the table: "ehr_procedure_body_part" */
  insert_ehr_procedure_body_part?: Maybe<Ehr_Procedure_Body_Part_Mutation_Response>;
  /** insert a single row into the table: "ehr_procedure_body_part" */
  insert_ehr_procedure_body_part_one?: Maybe<Ehr_Procedure_Body_Part>;
  /** insert data into the table: "ehr_procedure_body_part_provider_injection_default" */
  insert_ehr_procedure_body_part_provider_injection_default?: Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Mutation_Response>;
  /** insert a single row into the table: "ehr_procedure_body_part_provider_injection_default" */
  insert_ehr_procedure_body_part_provider_injection_default_one?: Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default>;
  /** insert data into the table: "ehr_procedure_ehr_product" */
  insert_ehr_procedure_ehr_product?: Maybe<Ehr_Procedure_Ehr_Product_Mutation_Response>;
  /** insert a single row into the table: "ehr_procedure_ehr_product" */
  insert_ehr_procedure_ehr_product_one?: Maybe<Ehr_Procedure_Ehr_Product>;
  /** insert a single row into the table: "ehr_procedure" */
  insert_ehr_procedure_one?: Maybe<Ehr_Procedure>;
  /** insert data into the table: "ehr_procedure_type_enum" */
  insert_ehr_procedure_type_enum?: Maybe<Ehr_Procedure_Type_Enum_Mutation_Response>;
  /** insert a single row into the table: "ehr_procedure_type_enum" */
  insert_ehr_procedure_type_enum_one?: Maybe<Ehr_Procedure_Type_Enum>;
  /** insert data into the table: "ehr_product" */
  insert_ehr_product?: Maybe<Ehr_Product_Mutation_Response>;
  /** insert a single row into the table: "ehr_product" */
  insert_ehr_product_one?: Maybe<Ehr_Product>;
  /** insert data into the table: "ehr_product_procedure" */
  insert_ehr_product_procedure?: Maybe<Ehr_Product_Procedure_Mutation_Response>;
  /** insert a single row into the table: "ehr_product_procedure" */
  insert_ehr_product_procedure_one?: Maybe<Ehr_Product_Procedure>;
  /** insert data into the table: "ehr_product_provider_usage_record_photo" */
  insert_ehr_product_provider_usage_record_photo?: Maybe<Ehr_Product_Provider_Usage_Record_Photo_Mutation_Response>;
  /** insert a single row into the table: "ehr_product_provider_usage_record_photo" */
  insert_ehr_product_provider_usage_record_photo_one?: Maybe<Ehr_Product_Provider_Usage_Record_Photo>;
  /** insert data into the table: "ehr_subscription" */
  insert_ehr_subscription?: Maybe<Ehr_Subscription_Mutation_Response>;
  /** insert a single row into the table: "ehr_subscription" */
  insert_ehr_subscription_one?: Maybe<Ehr_Subscription>;
  /** insert data into the table: "ehr_subscription_status" */
  insert_ehr_subscription_status?: Maybe<Ehr_Subscription_Status_Mutation_Response>;
  /** insert a single row into the table: "ehr_subscription_status" */
  insert_ehr_subscription_status_one?: Maybe<Ehr_Subscription_Status>;
  /** insert data into the table: "ehr_subscription_tier" */
  insert_ehr_subscription_tier?: Maybe<Ehr_Subscription_Tier_Mutation_Response>;
  /** insert a single row into the table: "ehr_subscription_tier" */
  insert_ehr_subscription_tier_one?: Maybe<Ehr_Subscription_Tier>;
  /** insert data into the table: "ehr_subscription_tier_term" */
  insert_ehr_subscription_tier_term?: Maybe<Ehr_Subscription_Tier_Term_Mutation_Response>;
  /** insert a single row into the table: "ehr_subscription_tier_term" */
  insert_ehr_subscription_tier_term_one?: Maybe<Ehr_Subscription_Tier_Term>;
  /** insert data into the table: "event" */
  insert_event?: Maybe<Event_Mutation_Response>;
  /** insert a single row into the table: "event" */
  insert_event_one?: Maybe<Event>;
  /** insert data into the table: "event_source" */
  insert_event_source?: Maybe<Event_Source_Mutation_Response>;
  /** insert a single row into the table: "event_source" */
  insert_event_source_one?: Maybe<Event_Source>;
  /** insert data into the table: "filler_procedure_delivery_tool" */
  insert_filler_procedure_delivery_tool?: Maybe<Filler_Procedure_Delivery_Tool_Mutation_Response>;
  /** insert a single row into the table: "filler_procedure_delivery_tool" */
  insert_filler_procedure_delivery_tool_one?: Maybe<Filler_Procedure_Delivery_Tool>;
  /** insert data into the table: "filler_procedure_face_view" */
  insert_filler_procedure_face_view?: Maybe<Filler_Procedure_Face_View_Mutation_Response>;
  /** insert a single row into the table: "filler_procedure_face_view" */
  insert_filler_procedure_face_view_one?: Maybe<Filler_Procedure_Face_View>;
  /** insert data into the table: "filler_procedure_injection" */
  insert_filler_procedure_injection?: Maybe<Filler_Procedure_Injection_Mutation_Response>;
  /** insert a single row into the table: "filler_procedure_injection" */
  insert_filler_procedure_injection_one?: Maybe<Filler_Procedure_Injection>;
  /** insert data into the table: "filler_procedure_injection_type" */
  insert_filler_procedure_injection_type?: Maybe<Filler_Procedure_Injection_Type_Mutation_Response>;
  /** insert a single row into the table: "filler_procedure_injection_type" */
  insert_filler_procedure_injection_type_one?: Maybe<Filler_Procedure_Injection_Type>;
  /** insert data into the table: "filler_procedure_product_instance" */
  insert_filler_procedure_product_instance?: Maybe<Filler_Procedure_Product_Instance_Mutation_Response>;
  /** insert a single row into the table: "filler_procedure_product_instance" */
  insert_filler_procedure_product_instance_one?: Maybe<Filler_Procedure_Product_Instance>;
  /** insert data into the table: "filler_procedure_product_instance_photo" */
  insert_filler_procedure_product_instance_photo?: Maybe<Filler_Procedure_Product_Instance_Photo_Mutation_Response>;
  /** insert a single row into the table: "filler_procedure_product_instance_photo" */
  insert_filler_procedure_product_instance_photo_one?: Maybe<Filler_Procedure_Product_Instance_Photo>;
  /** insert data into the table: "filler_space" */
  insert_filler_space?: Maybe<Filler_Space_Mutation_Response>;
  /** insert a single row into the table: "filler_space" */
  insert_filler_space_one?: Maybe<Filler_Space>;
  /** insert data into the table: "filler_zone_release" */
  insert_filler_zone_release?: Maybe<Filler_Zone_Release_Mutation_Response>;
  /** insert a single row into the table: "filler_zone_release" */
  insert_filler_zone_release_one?: Maybe<Filler_Zone_Release>;
  /** insert data into the table: "fn_check_proposed_patient_booking_for_stacking" */
  insert_fn_check_proposed_patient_booking_for_stacking?: Maybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Mutation_Response>;
  /** insert a single row into the table: "fn_check_proposed_patient_booking_for_stacking" */
  insert_fn_check_proposed_patient_booking_for_stacking_one?: Maybe<Fn_Check_Proposed_Patient_Booking_For_Stacking>;
  /** insert data into the table: "fn_get_active_notification_preferences_for_type_and_location" */
  insert_fn_get_active_notification_preferences_for_type_and_location?: Maybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Mutation_Response>;
  /** insert a single row into the table: "fn_get_active_notification_preferences_for_type_and_location" */
  insert_fn_get_active_notification_preferences_for_type_and_location_one?: Maybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location>;
  /** insert data into the table: "fn_get_active_subscribers_query" */
  insert_fn_get_active_subscribers_query?: Maybe<Fn_Get_Active_Subscribers_Query_Mutation_Response>;
  /** insert a single row into the table: "fn_get_active_subscribers_query" */
  insert_fn_get_active_subscribers_query_one?: Maybe<Fn_Get_Active_Subscribers_Query>;
  /** insert data into the table: "fn_get_location_purchases_to_provider_purchases_query" */
  insert_fn_get_location_purchases_to_provider_purchases_query?: Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Mutation_Response>;
  /** insert a single row into the table: "fn_get_location_purchases_to_provider_purchases_query" */
  insert_fn_get_location_purchases_to_provider_purchases_query_one?: Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query>;
  /** insert data into the table: "fn_get_stackable_booking_options_data" */
  insert_fn_get_stackable_booking_options_data?: Maybe<Fn_Get_Stackable_Booking_Options_Data_Mutation_Response>;
  /** insert a single row into the table: "fn_get_stackable_booking_options_data" */
  insert_fn_get_stackable_booking_options_data_one?: Maybe<Fn_Get_Stackable_Booking_Options_Data>;
  /** insert data into the table: "fn_get_user_booking_options_blockers" */
  insert_fn_get_user_booking_options_blockers?: Maybe<Fn_Get_User_Booking_Options_Blockers_Mutation_Response>;
  /** insert a single row into the table: "fn_get_user_booking_options_blockers" */
  insert_fn_get_user_booking_options_blockers_one?: Maybe<Fn_Get_User_Booking_Options_Blockers>;
  /** insert data into the table: "fn_get_user_location_procedure_unavailable_rooms" */
  insert_fn_get_user_location_procedure_unavailable_rooms?: Maybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Mutation_Response>;
  /** insert a single row into the table: "fn_get_user_location_procedure_unavailable_rooms" */
  insert_fn_get_user_location_procedure_unavailable_rooms_one?: Maybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms>;
  /** insert data into the table: "fn_get_user_products_to_rentals_query" */
  insert_fn_get_user_products_to_rentals_query?: Maybe<Fn_Get_User_Products_To_Rentals_Query_Mutation_Response>;
  /** insert a single row into the table: "fn_get_user_products_to_rentals_query" */
  insert_fn_get_user_products_to_rentals_query_one?: Maybe<Fn_Get_User_Products_To_Rentals_Query>;
  /** insert data into the table: "fn_users_unfulfilled_product_purchases_count_by_location" */
  insert_fn_users_unfulfilled_product_purchases_count_by_location?: Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Mutation_Response>;
  /** insert a single row into the table: "fn_users_unfulfilled_product_purchases_count_by_location" */
  insert_fn_users_unfulfilled_product_purchases_count_by_location_one?: Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location>;
  /** insert data into the table: "gender" */
  insert_gender?: Maybe<Gender_Mutation_Response>;
  /** insert a single row into the table: "gender" */
  insert_gender_one?: Maybe<Gender>;
  /** insert data into the table: "invoice" */
  insert_invoice?: Maybe<Invoice_Mutation_Response>;
  /** insert data into the table: "invoice_billing_summary" */
  insert_invoice_billing_summary?: Maybe<Invoice_Billing_Summary_Mutation_Response>;
  /** insert a single row into the table: "invoice_billing_summary" */
  insert_invoice_billing_summary_one?: Maybe<Invoice_Billing_Summary>;
  /** insert a single row into the table: "invoice" */
  insert_invoice_one?: Maybe<Invoice>;
  /** insert data into the table: "location" */
  insert_location?: Maybe<Location_Mutation_Response>;
  /** insert a single row into the table: "location" */
  insert_location_one?: Maybe<Location>;
  /** insert data into the table: "location_procedure" */
  insert_location_procedure?: Maybe<Location_Procedure_Mutation_Response>;
  /** insert a single row into the table: "location_procedure" */
  insert_location_procedure_one?: Maybe<Location_Procedure>;
  /** insert data into the table: "location_procedure_room" */
  insert_location_procedure_room?: Maybe<Location_Procedure_Room_Mutation_Response>;
  /** insert a single row into the table: "location_procedure_room" */
  insert_location_procedure_room_one?: Maybe<Location_Procedure_Room>;
  /** insert data into the table: "location_product" */
  insert_location_product?: Maybe<Location_Product_Mutation_Response>;
  /** insert a single row into the table: "location_product" */
  insert_location_product_one?: Maybe<Location_Product>;
  /** insert data into the table: "model" */
  insert_model?: Maybe<Model_Mutation_Response>;
  /** insert data into the table: "model_count" */
  insert_model_count?: Maybe<Model_Count_Mutation_Response>;
  /** insert a single row into the table: "model_count" */
  insert_model_count_one?: Maybe<Model_Count>;
  /** insert a single row into the table: "model" */
  insert_model_one?: Maybe<Model>;
  /** insert data into the table: "model_product" */
  insert_model_product?: Maybe<Model_Product_Mutation_Response>;
  /** insert a single row into the table: "model_product" */
  insert_model_product_one?: Maybe<Model_Product>;
  /** insert data into the table: "mso_mode" */
  insert_mso_mode?: Maybe<Mso_Mode_Mutation_Response>;
  /** insert a single row into the table: "mso_mode" */
  insert_mso_mode_one?: Maybe<Mso_Mode>;
  /** insert data into the table: "mso_tier" */
  insert_mso_tier?: Maybe<Mso_Tier_Mutation_Response>;
  /** insert a single row into the table: "mso_tier" */
  insert_mso_tier_one?: Maybe<Mso_Tier>;
  /** insert data into the table: "notification_audit_log" */
  insert_notification_audit_log?: Maybe<Notification_Audit_Log_Mutation_Response>;
  /** insert a single row into the table: "notification_audit_log" */
  insert_notification_audit_log_one?: Maybe<Notification_Audit_Log>;
  /** insert data into the table: "notification_broadcast_type" */
  insert_notification_broadcast_type?: Maybe<Notification_Broadcast_Type_Mutation_Response>;
  /** insert a single row into the table: "notification_broadcast_type" */
  insert_notification_broadcast_type_one?: Maybe<Notification_Broadcast_Type>;
  /** insert data into the table: "notification_channel" */
  insert_notification_channel?: Maybe<Notification_Channel_Mutation_Response>;
  /** insert a single row into the table: "notification_channel" */
  insert_notification_channel_one?: Maybe<Notification_Channel>;
  /** insert data into the table: "notification_preference" */
  insert_notification_preference?: Maybe<Notification_Preference_Mutation_Response>;
  /** insert a single row into the table: "notification_preference" */
  insert_notification_preference_one?: Maybe<Notification_Preference>;
  /** insert data into the table: "notification_type" */
  insert_notification_type?: Maybe<Notification_Type_Mutation_Response>;
  /** insert data into the table: "notification_type_default_channel" */
  insert_notification_type_default_channel?: Maybe<Notification_Type_Default_Channel_Mutation_Response>;
  /** insert a single row into the table: "notification_type_default_channel" */
  insert_notification_type_default_channel_one?: Maybe<Notification_Type_Default_Channel>;
  /** insert a single row into the table: "notification_type" */
  insert_notification_type_one?: Maybe<Notification_Type>;
  /** insert data into the table: "open" */
  insert_open?: Maybe<Open_Mutation_Response>;
  /** insert a single row into the table: "open" */
  insert_open_one?: Maybe<Open>;
  /** insert data into the table: "partner" */
  insert_partner?: Maybe<Partner_Mutation_Response>;
  /** insert data into the table: "partner_basic" */
  insert_partner_basic?: Maybe<Partner_Basic_Mutation_Response>;
  /** insert a single row into the table: "partner_basic" */
  insert_partner_basic_one?: Maybe<Partner_Basic>;
  /** insert a single row into the table: "partner" */
  insert_partner_one?: Maybe<Partner>;
  /** insert data into the table: "patient" */
  insert_patient?: Maybe<Patient_Mutation_Response>;
  /** insert data into the table: "patient_account_event" */
  insert_patient_account_event?: Maybe<Patient_Account_Event_Mutation_Response>;
  /** insert a single row into the table: "patient_account_event" */
  insert_patient_account_event_one?: Maybe<Patient_Account_Event>;
  /** insert data into the table: "patient_account_event_type" */
  insert_patient_account_event_type?: Maybe<Patient_Account_Event_Type_Mutation_Response>;
  /** insert a single row into the table: "patient_account_event_type" */
  insert_patient_account_event_type_one?: Maybe<Patient_Account_Event_Type>;
  /** insert data into the table: "patient_auth_challenge" */
  insert_patient_auth_challenge?: Maybe<Patient_Auth_Challenge_Mutation_Response>;
  /** insert a single row into the table: "patient_auth_challenge" */
  insert_patient_auth_challenge_one?: Maybe<Patient_Auth_Challenge>;
  /** insert data into the table: "patient_bookable_ehr_procedure" */
  insert_patient_bookable_ehr_procedure?: Maybe<Patient_Bookable_Ehr_Procedure_Mutation_Response>;
  /** insert a single row into the table: "patient_bookable_ehr_procedure" */
  insert_patient_bookable_ehr_procedure_one?: Maybe<Patient_Bookable_Ehr_Procedure>;
  /** insert data into the table: "patient_booking" */
  insert_patient_booking?: Maybe<Patient_Booking_Mutation_Response>;
  /** insert data into the table: "patient_booking_booking" */
  insert_patient_booking_booking?: Maybe<Patient_Booking_Booking_Mutation_Response>;
  /** insert a single row into the table: "patient_booking_booking" */
  insert_patient_booking_booking_one?: Maybe<Patient_Booking_Booking>;
  /** insert data into the table: "patient_booking_cancel_reason" */
  insert_patient_booking_cancel_reason?: Maybe<Patient_Booking_Cancel_Reason_Mutation_Response>;
  /** insert a single row into the table: "patient_booking_cancel_reason" */
  insert_patient_booking_cancel_reason_one?: Maybe<Patient_Booking_Cancel_Reason>;
  /** insert data into the table: "patient_booking_initiator" */
  insert_patient_booking_initiator?: Maybe<Patient_Booking_Initiator_Mutation_Response>;
  /** insert a single row into the table: "patient_booking_initiator" */
  insert_patient_booking_initiator_one?: Maybe<Patient_Booking_Initiator>;
  /** insert data into the table: "patient_booking_metadata" */
  insert_patient_booking_metadata?: Maybe<Patient_Booking_Metadata_Mutation_Response>;
  /** insert a single row into the table: "patient_booking_metadata" */
  insert_patient_booking_metadata_one?: Maybe<Patient_Booking_Metadata>;
  /** insert a single row into the table: "patient_booking" */
  insert_patient_booking_one?: Maybe<Patient_Booking>;
  /** insert data into the table: "patient_last_view" */
  insert_patient_last_view?: Maybe<Patient_Last_View_Mutation_Response>;
  /** insert a single row into the table: "patient_last_view" */
  insert_patient_last_view_one?: Maybe<Patient_Last_View>;
  /** insert data into the table: "patient_medical_profile" */
  insert_patient_medical_profile?: Maybe<Patient_Medical_Profile_Mutation_Response>;
  /** insert a single row into the table: "patient_medical_profile" */
  insert_patient_medical_profile_one?: Maybe<Patient_Medical_Profile>;
  /** insert a single row into the table: "patient" */
  insert_patient_one?: Maybe<Patient>;
  /** insert data into the table: "patient_registration_invite" */
  insert_patient_registration_invite?: Maybe<Patient_Registration_Invite_Mutation_Response>;
  /** insert a single row into the table: "patient_registration_invite" */
  insert_patient_registration_invite_one?: Maybe<Patient_Registration_Invite>;
  /** insert data into the table: "patient_session" */
  insert_patient_session?: Maybe<Patient_Session_Mutation_Response>;
  /** insert a single row into the table: "patient_session" */
  insert_patient_session_one?: Maybe<Patient_Session>;
  /** insert data into the table: "patient_webauthn_challenge" */
  insert_patient_webauthn_challenge?: Maybe<Patient_Webauthn_Challenge_Mutation_Response>;
  /** insert a single row into the table: "patient_webauthn_challenge" */
  insert_patient_webauthn_challenge_one?: Maybe<Patient_Webauthn_Challenge>;
  /** insert data into the table: "patient_webauthn_credential" */
  insert_patient_webauthn_credential?: Maybe<Patient_Webauthn_Credential_Mutation_Response>;
  /** insert a single row into the table: "patient_webauthn_credential" */
  insert_patient_webauthn_credential_one?: Maybe<Patient_Webauthn_Credential>;
  /** insert data into the table: "plan" */
  insert_plan?: Maybe<Plan_Mutation_Response>;
  /** insert a single row into the table: "plan" */
  insert_plan_one?: Maybe<Plan>;
  /** insert data into the table: "plan_type" */
  insert_plan_type?: Maybe<Plan_Type_Mutation_Response>;
  /** insert a single row into the table: "plan_type" */
  insert_plan_type_one?: Maybe<Plan_Type>;
  /** insert data into the table: "pre_procedure_photo_injection_marking" */
  insert_pre_procedure_photo_injection_marking?: Maybe<Pre_Procedure_Photo_Injection_Marking_Mutation_Response>;
  /** insert a single row into the table: "pre_procedure_photo_injection_marking" */
  insert_pre_procedure_photo_injection_marking_one?: Maybe<Pre_Procedure_Photo_Injection_Marking>;
  /** insert data into the table: "procedure" */
  insert_procedure?: Maybe<Procedure_Mutation_Response>;
  /** insert data into the table: "procedure_audio_recording" */
  insert_procedure_audio_recording?: Maybe<Procedure_Audio_Recording_Mutation_Response>;
  /** insert a single row into the table: "procedure_audio_recording" */
  insert_procedure_audio_recording_one?: Maybe<Procedure_Audio_Recording>;
  /** insert a single row into the table: "procedure" */
  insert_procedure_one?: Maybe<Procedure>;
  /** insert data into the table: "product" */
  insert_product?: Maybe<Product_Mutation_Response>;
  /** insert a single row into the table: "product" */
  insert_product_one?: Maybe<Product>;
  /** insert data into the table: "product_purchase" */
  insert_product_purchase?: Maybe<Product_Purchase_Mutation_Response>;
  /** insert a single row into the table: "product_purchase" */
  insert_product_purchase_one?: Maybe<Product_Purchase>;
  /** insert data into the table: "product_type" */
  insert_product_type?: Maybe<Product_Type_Mutation_Response>;
  /** insert a single row into the table: "product_type" */
  insert_product_type_one?: Maybe<Product_Type>;
  /** insert data into the table: "provider_direct_product_purchase" */
  insert_provider_direct_product_purchase?: Maybe<Provider_Direct_Product_Purchase_Mutation_Response>;
  /** insert a single row into the table: "provider_direct_product_purchase" */
  insert_provider_direct_product_purchase_one?: Maybe<Provider_Direct_Product_Purchase>;
  /** insert data into the table: "provider_hours" */
  insert_provider_hours?: Maybe<Provider_Hours_Mutation_Response>;
  /** insert a single row into the table: "provider_hours" */
  insert_provider_hours_one?: Maybe<Provider_Hours>;
  /** insert data into the table: "provider_hours_repeat_interval" */
  insert_provider_hours_repeat_interval?: Maybe<Provider_Hours_Repeat_Interval_Mutation_Response>;
  /** insert a single row into the table: "provider_hours_repeat_interval" */
  insert_provider_hours_repeat_interval_one?: Maybe<Provider_Hours_Repeat_Interval>;
  /** insert data into the table: "provider_hours_repeater" */
  insert_provider_hours_repeater?: Maybe<Provider_Hours_Repeater_Mutation_Response>;
  /** insert a single row into the table: "provider_hours_repeater" */
  insert_provider_hours_repeater_one?: Maybe<Provider_Hours_Repeater>;
  /** insert data into the table: "provider_patient_booking_settings" */
  insert_provider_patient_booking_settings?: Maybe<Provider_Patient_Booking_Settings_Mutation_Response>;
  /** insert a single row into the table: "provider_patient_booking_settings" */
  insert_provider_patient_booking_settings_one?: Maybe<Provider_Patient_Booking_Settings>;
  /** insert data into the table: "provider_procedure" */
  insert_provider_procedure?: Maybe<Provider_Procedure_Mutation_Response>;
  /** insert a single row into the table: "provider_procedure" */
  insert_provider_procedure_one?: Maybe<Provider_Procedure>;
  /** insert data into the table: "purchase_for_location" */
  insert_purchase_for_location?: Maybe<Purchase_For_Location_Mutation_Response>;
  /** insert a single row into the table: "purchase_for_location" */
  insert_purchase_for_location_one?: Maybe<Purchase_For_Location>;
  /** insert data into the table: "rental_volume_discount" */
  insert_rental_volume_discount?: Maybe<Rental_Volume_Discount_Mutation_Response>;
  /** insert a single row into the table: "rental_volume_discount" */
  insert_rental_volume_discount_one?: Maybe<Rental_Volume_Discount>;
  /** insert data into the table: "repeating" */
  insert_repeating?: Maybe<Repeating_Mutation_Response>;
  /** insert a single row into the table: "repeating" */
  insert_repeating_one?: Maybe<Repeating>;
  /** insert data into the table: "report_preference" */
  insert_report_preference?: Maybe<Report_Preference_Mutation_Response>;
  /** insert a single row into the table: "report_preference" */
  insert_report_preference_one?: Maybe<Report_Preference>;
  /** insert data into the table: "report_type" */
  insert_report_type?: Maybe<Report_Type_Mutation_Response>;
  /** insert a single row into the table: "report_type" */
  insert_report_type_one?: Maybe<Report_Type>;
  /** insert data into the table: "role" */
  insert_role?: Maybe<Role_Mutation_Response>;
  /** insert data into the table: "role_notification" */
  insert_role_notification?: Maybe<Role_Notification_Mutation_Response>;
  /** insert a single row into the table: "role_notification" */
  insert_role_notification_one?: Maybe<Role_Notification>;
  /** insert a single row into the table: "role" */
  insert_role_one?: Maybe<Role>;
  /** insert data into the table: "room" */
  insert_room?: Maybe<Room_Mutation_Response>;
  /** insert data into the table: "room_model" */
  insert_room_model?: Maybe<Room_Model_Mutation_Response>;
  /** insert a single row into the table: "room_model" */
  insert_room_model_one?: Maybe<Room_Model>;
  /** insert a single row into the table: "room" */
  insert_room_one?: Maybe<Room>;
  /** insert data into the table: "room_type" */
  insert_room_type?: Maybe<Room_Type_Mutation_Response>;
  /** insert a single row into the table: "room_type" */
  insert_room_type_one?: Maybe<Room_Type>;
  /** insert data into the table: "sex" */
  insert_sex?: Maybe<Sex_Mutation_Response>;
  /** insert a single row into the table: "sex" */
  insert_sex_one?: Maybe<Sex>;
  /** insert data into the table: "signing_document" */
  insert_signing_document?: Maybe<Signing_Document_Mutation_Response>;
  /** insert a single row into the table: "signing_document" */
  insert_signing_document_one?: Maybe<Signing_Document>;
  /** insert data into the table: "signing_document_status_type" */
  insert_signing_document_status_type?: Maybe<Signing_Document_Status_Type_Mutation_Response>;
  /** insert a single row into the table: "signing_document_status_type" */
  insert_signing_document_status_type_one?: Maybe<Signing_Document_Status_Type>;
  /** insert data into the table: "signing_procedure_associated_documents" */
  insert_signing_procedure_associated_documents?: Maybe<Signing_Procedure_Associated_Documents_Mutation_Response>;
  /** insert a single row into the table: "signing_procedure_associated_documents" */
  insert_signing_procedure_associated_documents_one?: Maybe<Signing_Procedure_Associated_Documents>;
  /** insert data into the table: "signing_template" */
  insert_signing_template?: Maybe<Signing_Template_Mutation_Response>;
  /** insert data into the table: "signing_template_equivalents" */
  insert_signing_template_equivalents?: Maybe<Signing_Template_Equivalents_Mutation_Response>;
  /** insert a single row into the table: "signing_template_equivalents" */
  insert_signing_template_equivalents_one?: Maybe<Signing_Template_Equivalents>;
  /** insert data into the table: "signing_template_kind" */
  insert_signing_template_kind?: Maybe<Signing_Template_Kind_Mutation_Response>;
  /** insert a single row into the table: "signing_template_kind" */
  insert_signing_template_kind_one?: Maybe<Signing_Template_Kind>;
  /** insert a single row into the table: "signing_template" */
  insert_signing_template_one?: Maybe<Signing_Template>;
  /** insert data into the table: "signing_template_source_files" */
  insert_signing_template_source_files?: Maybe<Signing_Template_Source_Files_Mutation_Response>;
  /** insert a single row into the table: "signing_template_source_files" */
  insert_signing_template_source_files_one?: Maybe<Signing_Template_Source_Files>;
  /** insert data into the table: "signing_vansanity_template" */
  insert_signing_vansanity_template?: Maybe<Signing_Vansanity_Template_Mutation_Response>;
  /** insert a single row into the table: "signing_vansanity_template" */
  insert_signing_vansanity_template_one?: Maybe<Signing_Vansanity_Template>;
  /** insert data into the table: "signing_webhook_event" */
  insert_signing_webhook_event?: Maybe<Signing_Webhook_Event_Mutation_Response>;
  /** insert a single row into the table: "signing_webhook_event" */
  insert_signing_webhook_event_one?: Maybe<Signing_Webhook_Event>;
  /** insert data into the table: "signing_webhook_event_type" */
  insert_signing_webhook_event_type?: Maybe<Signing_Webhook_Event_Type_Mutation_Response>;
  /** insert a single row into the table: "signing_webhook_event_type" */
  insert_signing_webhook_event_type_one?: Maybe<Signing_Webhook_Event_Type>;
  /** insert data into the table: "square_credential_ownership_enum" */
  insert_square_credential_ownership_enum?: Maybe<Square_Credential_Ownership_Enum_Mutation_Response>;
  /** insert a single row into the table: "square_credential_ownership_enum" */
  insert_square_credential_ownership_enum_one?: Maybe<Square_Credential_Ownership_Enum>;
  /** insert data into the table: "square_credentials" */
  insert_square_credentials?: Maybe<Square_Credentials_Mutation_Response>;
  /** insert a single row into the table: "square_credentials" */
  insert_square_credentials_one?: Maybe<Square_Credentials>;
  /** insert data into the table: "supervisor_provider" */
  insert_supervisor_provider?: Maybe<Supervisor_Provider_Mutation_Response>;
  /** insert data into the table: "supervisor_provider_initiated_by" */
  insert_supervisor_provider_initiated_by?: Maybe<Supervisor_Provider_Initiated_By_Mutation_Response>;
  /** insert a single row into the table: "supervisor_provider_initiated_by" */
  insert_supervisor_provider_initiated_by_one?: Maybe<Supervisor_Provider_Initiated_By>;
  /** insert a single row into the table: "supervisor_provider" */
  insert_supervisor_provider_one?: Maybe<Supervisor_Provider>;
  /** insert data into the table: "supervisor_provider_term" */
  insert_supervisor_provider_term?: Maybe<Supervisor_Provider_Term_Mutation_Response>;
  /** insert data into the table: "supervisor_provider_term_ended_by" */
  insert_supervisor_provider_term_ended_by?: Maybe<Supervisor_Provider_Term_Ended_By_Mutation_Response>;
  /** insert a single row into the table: "supervisor_provider_term_ended_by" */
  insert_supervisor_provider_term_ended_by_one?: Maybe<Supervisor_Provider_Term_Ended_By>;
  /** insert a single row into the table: "supervisor_provider_term" */
  insert_supervisor_provider_term_one?: Maybe<Supervisor_Provider_Term>;
  /** insert data into the table: "supervisor_review_queue_item" */
  insert_supervisor_review_queue_item?: Maybe<Supervisor_Review_Queue_Item_Mutation_Response>;
  /** insert a single row into the table: "supervisor_review_queue_item" */
  insert_supervisor_review_queue_item_one?: Maybe<Supervisor_Review_Queue_Item>;
  /** insert data into the table: "supervisor_review_queue_item_status_history" */
  insert_supervisor_review_queue_item_status_history?: Maybe<Supervisor_Review_Queue_Item_Status_History_Mutation_Response>;
  /** insert a single row into the table: "supervisor_review_queue_item_status_history" */
  insert_supervisor_review_queue_item_status_history_one?: Maybe<Supervisor_Review_Queue_Item_Status_History>;
  /** insert data into the table: "supervisor_review_queue_source" */
  insert_supervisor_review_queue_source?: Maybe<Supervisor_Review_Queue_Source_Mutation_Response>;
  /** insert a single row into the table: "supervisor_review_queue_source" */
  insert_supervisor_review_queue_source_one?: Maybe<Supervisor_Review_Queue_Source>;
  /** insert data into the table: "supervisor_review_queue_status" */
  insert_supervisor_review_queue_status?: Maybe<Supervisor_Review_Queue_Status_Mutation_Response>;
  /** insert a single row into the table: "supervisor_review_queue_status" */
  insert_supervisor_review_queue_status_one?: Maybe<Supervisor_Review_Queue_Status>;
  /** insert data into the table: "supervisor_sampling_period_type" */
  insert_supervisor_sampling_period_type?: Maybe<Supervisor_Sampling_Period_Type_Mutation_Response>;
  /** insert a single row into the table: "supervisor_sampling_period_type" */
  insert_supervisor_sampling_period_type_one?: Maybe<Supervisor_Sampling_Period_Type>;
  /** insert data into the table: "supervisor_setting" */
  insert_supervisor_setting?: Maybe<Supervisor_Setting_Mutation_Response>;
  /** insert a single row into the table: "supervisor_setting" */
  insert_supervisor_setting_one?: Maybe<Supervisor_Setting>;
  /** insert data into the table: "tax_rate" */
  insert_tax_rate?: Maybe<Tax_Rate_Mutation_Response>;
  /** insert a single row into the table: "tax_rate" */
  insert_tax_rate_one?: Maybe<Tax_Rate>;
  /** insert data into the table: "tax_type" */
  insert_tax_type?: Maybe<Tax_Type_Mutation_Response>;
  /** insert a single row into the table: "tax_type" */
  insert_tax_type_one?: Maybe<Tax_Type>;
  /** insert data into the table: "user" */
  insert_user?: Maybe<User_Mutation_Response>;
  /** insert data into the table: "user_agreements" */
  insert_user_agreements?: Maybe<User_Agreements_Mutation_Response>;
  /** insert a single row into the table: "user_agreements" */
  insert_user_agreements_one?: Maybe<User_Agreements>;
  /** insert data into the table: "user_consent" */
  insert_user_consent?: Maybe<User_Consent_Mutation_Response>;
  /** insert data into the table: "user_consent_action" */
  insert_user_consent_action?: Maybe<User_Consent_Action_Mutation_Response>;
  /** insert a single row into the table: "user_consent_action" */
  insert_user_consent_action_one?: Maybe<User_Consent_Action>;
  /** insert a single row into the table: "user_consent" */
  insert_user_consent_one?: Maybe<User_Consent>;
  /** insert data into the table: "user_consent_type" */
  insert_user_consent_type?: Maybe<User_Consent_Type_Mutation_Response>;
  /** insert a single row into the table: "user_consent_type" */
  insert_user_consent_type_one?: Maybe<User_Consent_Type>;
  /** insert data into the table: "user_device_push_notification_token" */
  insert_user_device_push_notification_token?: Maybe<User_Device_Push_Notification_Token_Mutation_Response>;
  /** insert a single row into the table: "user_device_push_notification_token" */
  insert_user_device_push_notification_token_one?: Maybe<User_Device_Push_Notification_Token>;
  /** insert data into the table: "user_document" */
  insert_user_document?: Maybe<User_Document_Mutation_Response>;
  /** insert a single row into the table: "user_document" */
  insert_user_document_one?: Maybe<User_Document>;
  /** insert data into the table: "user_location" */
  insert_user_location?: Maybe<User_Location_Mutation_Response>;
  /** insert a single row into the table: "user_location" */
  insert_user_location_one?: Maybe<User_Location>;
  /** insert a single row into the table: "user" */
  insert_user_one?: Maybe<User>;
  /** insert data into the table: "user_plan" */
  insert_user_plan?: Maybe<User_Plan_Mutation_Response>;
  /** insert a single row into the table: "user_plan" */
  insert_user_plan_one?: Maybe<User_Plan>;
  /** insert data into the table: "version" */
  insert_version?: Maybe<Version_Mutation_Response>;
  /** insert a single row into the table: "version" */
  insert_version_one?: Maybe<Version>;
  /** Hold the room time an appointment needs, priced, ready for confirmPatientBooking */
  preparePatientBookingConfirm: PreparePatientBookingConfirmOutput;
  removeBooking?: Maybe<RemoveBookingOutput>;
  removeOpen?: Maybe<Array<Maybe<DeleteOpenOutput>>>;
  removeRepeatBooking: RemoveRepeatBookingOutput;
  seedDemoAccount: SeedDemoAccountOutput;
  setAsDefaultPaymentMethod: SetAsDefaultPaymentMethodOutput;
  /** Create a signing document. PATIENT_FORM templates send via SignWell email link to the patient; when the template requires a sender countersignature, the sender also signs in-app via an embedded URL returned inline. SUPERVISOR_FORM templates use embedded signing for the supervised provider and, when the template requires a sender countersignature, the supervisor (sender) too. */
  signingDocumentCreate?: Maybe<SigningDocumentCreateOutput>;
  /** Return the calling user's embedded signing URL for a signing document. Available on SUPERVISOR_FORM and on dual-sig PATIENT_FORM. Caller must be either the sender (template author) or the supervised-provider signer (SUPERVISOR_FORM only). */
  signingDocumentGetEmbeddedLink?: Maybe<SigningDocumentGetEmbeddedLinkOutput>;
  signingDocumentsResendLink?: Maybe<SigningDocumentIdOutput>;
  /** Create a new signing template from an uploaded S3 document. MedicalSupervisor creates SUPERVISOR_FORM only; other roles create PATIENT_FORM only — the role-based Hasura insert presets enforce this. */
  signingTemplateCreate?: Maybe<SigningTemplateCreateOutput>;
  uncancelEhrSubscription: EhrSubscriptionOutput;
  /** Update stripe_user_to_charge in the partner table */
  updatePartnerStripeUserToCharge: UpdatePartnerStripeUserToChargeOutput;
  updatePlan?: Maybe<UpdatePlanOutput>;
  updateProviderHours: Array<UpdateProviderHoursOutput>;
  updateUserPlan?: Maybe<UpdateUserPlanOutput>;
  /** update data of the table: "accreditation" */
  update_accreditation?: Maybe<Accreditation_Mutation_Response>;
  /** update single row of the table: "accreditation" */
  update_accreditation_by_pk?: Maybe<Accreditation>;
  /** update data of the table: "accreditation_location_privilege" */
  update_accreditation_location_privilege?: Maybe<Accreditation_Location_Privilege_Mutation_Response>;
  /** update single row of the table: "accreditation_location_privilege" */
  update_accreditation_location_privilege_by_pk?: Maybe<Accreditation_Location_Privilege>;
  /** update multiples rows of table: "accreditation_location_privilege" */
  update_accreditation_location_privilege_many?: Maybe<Array<Maybe<Accreditation_Location_Privilege_Mutation_Response>>>;
  /** update multiples rows of table: "accreditation" */
  update_accreditation_many?: Maybe<Array<Maybe<Accreditation_Mutation_Response>>>;
  /** update data of the table: "address" */
  update_address?: Maybe<Address_Mutation_Response>;
  /** update single row of the table: "address" */
  update_address_by_pk?: Maybe<Address>;
  /** update multiples rows of table: "address" */
  update_address_many?: Maybe<Array<Maybe<Address_Mutation_Response>>>;
  /** update data of the table: "agreement_type" */
  update_agreement_type?: Maybe<Agreement_Type_Mutation_Response>;
  /** update single row of the table: "agreement_type" */
  update_agreement_type_by_pk?: Maybe<Agreement_Type>;
  /** update multiples rows of table: "agreement_type" */
  update_agreement_type_many?: Maybe<Array<Maybe<Agreement_Type_Mutation_Response>>>;
  /** update data of the table: "booking" */
  update_booking?: Maybe<Booking_Mutation_Response>;
  /** update single row of the table: "booking" */
  update_booking_by_pk?: Maybe<Booking>;
  /** update multiples rows of table: "booking" */
  update_booking_many?: Maybe<Array<Maybe<Booking_Mutation_Response>>>;
  /** update data of the table: "booking_public" */
  update_booking_public?: Maybe<Booking_Public_Mutation_Response>;
  /** update multiples rows of table: "booking_public" */
  update_booking_public_many?: Maybe<Array<Maybe<Booking_Public_Mutation_Response>>>;
  /** update data of the table: "booking_type" */
  update_booking_type?: Maybe<Booking_Type_Mutation_Response>;
  /** update single row of the table: "booking_type" */
  update_booking_type_by_pk?: Maybe<Booking_Type>;
  /** update multiples rows of table: "booking_type" */
  update_booking_type_many?: Maybe<Array<Maybe<Booking_Type_Mutation_Response>>>;
  /** update data of the table: "cancel_reason" */
  update_cancel_reason?: Maybe<Cancel_Reason_Mutation_Response>;
  /** update single row of the table: "cancel_reason" */
  update_cancel_reason_by_pk?: Maybe<Cancel_Reason>;
  /** update multiples rows of table: "cancel_reason" */
  update_cancel_reason_many?: Maybe<Array<Maybe<Cancel_Reason_Mutation_Response>>>;
  /** update data of the table: "credit" */
  update_credit?: Maybe<Credit_Mutation_Response>;
  /** update single row of the table: "credit" */
  update_credit_by_pk?: Maybe<Credit>;
  /** update multiples rows of table: "credit" */
  update_credit_many?: Maybe<Array<Maybe<Credit_Mutation_Response>>>;
  /** update data of the table: "credit_transaction" */
  update_credit_transaction?: Maybe<Credit_Transaction_Mutation_Response>;
  /** update single row of the table: "credit_transaction" */
  update_credit_transaction_by_pk?: Maybe<Credit_Transaction>;
  /** update multiples rows of table: "credit_transaction" */
  update_credit_transaction_many?: Maybe<Array<Maybe<Credit_Transaction_Mutation_Response>>>;
  /** update data of the table: "credit_type" */
  update_credit_type?: Maybe<Credit_Type_Mutation_Response>;
  /** update single row of the table: "credit_type" */
  update_credit_type_by_pk?: Maybe<Credit_Type>;
  /** update multiples rows of table: "credit_type" */
  update_credit_type_many?: Maybe<Array<Maybe<Credit_Type_Mutation_Response>>>;
  /** update data of the table: "demo_location" */
  update_demo_location?: Maybe<Demo_Location_Mutation_Response>;
  /** update single row of the table: "demo_location" */
  update_demo_location_by_pk?: Maybe<Demo_Location>;
  /** update multiples rows of table: "demo_location" */
  update_demo_location_many?: Maybe<Array<Maybe<Demo_Location_Mutation_Response>>>;
  /** update data of the table: "document_type" */
  update_document_type?: Maybe<Document_Type_Mutation_Response>;
  /** update single row of the table: "document_type" */
  update_document_type_by_pk?: Maybe<Document_Type>;
  /** update multiples rows of table: "document_type" */
  update_document_type_many?: Maybe<Array<Maybe<Document_Type_Mutation_Response>>>;
  /** update data of the table: "ehr_charge_ledger" */
  update_ehr_charge_ledger?: Maybe<Ehr_Charge_Ledger_Mutation_Response>;
  /** update single row of the table: "ehr_charge_ledger" */
  update_ehr_charge_ledger_by_pk?: Maybe<Ehr_Charge_Ledger>;
  /** update multiples rows of table: "ehr_charge_ledger" */
  update_ehr_charge_ledger_many?: Maybe<Array<Maybe<Ehr_Charge_Ledger_Mutation_Response>>>;
  /** update data of the table: "ehr_encounter" */
  update_ehr_encounter?: Maybe<Ehr_Encounter_Mutation_Response>;
  /** update data of the table: "ehr_encounter_addendum" */
  update_ehr_encounter_addendum?: Maybe<Ehr_Encounter_Addendum_Mutation_Response>;
  /** update single row of the table: "ehr_encounter_addendum" */
  update_ehr_encounter_addendum_by_pk?: Maybe<Ehr_Encounter_Addendum>;
  /** update multiples rows of table: "ehr_encounter_addendum" */
  update_ehr_encounter_addendum_many?: Maybe<Array<Maybe<Ehr_Encounter_Addendum_Mutation_Response>>>;
  /** update single row of the table: "ehr_encounter" */
  update_ehr_encounter_by_pk?: Maybe<Ehr_Encounter>;
  /** update multiples rows of table: "ehr_encounter" */
  update_ehr_encounter_many?: Maybe<Array<Maybe<Ehr_Encounter_Mutation_Response>>>;
  /** update data of the table: "ehr_encounter_modality" */
  update_ehr_encounter_modality?: Maybe<Ehr_Encounter_Modality_Mutation_Response>;
  /** update single row of the table: "ehr_encounter_modality" */
  update_ehr_encounter_modality_by_pk?: Maybe<Ehr_Encounter_Modality>;
  /** update multiples rows of table: "ehr_encounter_modality" */
  update_ehr_encounter_modality_many?: Maybe<Array<Maybe<Ehr_Encounter_Modality_Mutation_Response>>>;
  /** update data of the table: "ehr_encounter_photo" */
  update_ehr_encounter_photo?: Maybe<Ehr_Encounter_Photo_Mutation_Response>;
  /** update single row of the table: "ehr_encounter_photo" */
  update_ehr_encounter_photo_by_pk?: Maybe<Ehr_Encounter_Photo>;
  /** update multiples rows of table: "ehr_encounter_photo" */
  update_ehr_encounter_photo_many?: Maybe<Array<Maybe<Ehr_Encounter_Photo_Mutation_Response>>>;
  /** update data of the table: "ehr_encounter_scan_3d" */
  update_ehr_encounter_scan_3d?: Maybe<Ehr_Encounter_Scan_3d_Mutation_Response>;
  /** update data of the table: "ehr_encounter_scan_3d_artifact" */
  update_ehr_encounter_scan_3d_artifact?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Mutation_Response>;
  /** update single row of the table: "ehr_encounter_scan_3d_artifact" */
  update_ehr_encounter_scan_3d_artifact_by_pk?: Maybe<Ehr_Encounter_Scan_3d_Artifact>;
  /** update data of the table: "ehr_encounter_scan_3d_artifact_kind" */
  update_ehr_encounter_scan_3d_artifact_kind?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Mutation_Response>;
  /** update single row of the table: "ehr_encounter_scan_3d_artifact_kind" */
  update_ehr_encounter_scan_3d_artifact_kind_by_pk?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Kind>;
  /** update multiples rows of table: "ehr_encounter_scan_3d_artifact_kind" */
  update_ehr_encounter_scan_3d_artifact_kind_many?: Maybe<Array<Maybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Mutation_Response>>>;
  /** update multiples rows of table: "ehr_encounter_scan_3d_artifact" */
  update_ehr_encounter_scan_3d_artifact_many?: Maybe<Array<Maybe<Ehr_Encounter_Scan_3d_Artifact_Mutation_Response>>>;
  /** update single row of the table: "ehr_encounter_scan_3d" */
  update_ehr_encounter_scan_3d_by_pk?: Maybe<Ehr_Encounter_Scan_3d>;
  /** update multiples rows of table: "ehr_encounter_scan_3d" */
  update_ehr_encounter_scan_3d_many?: Maybe<Array<Maybe<Ehr_Encounter_Scan_3d_Mutation_Response>>>;
  /** update data of the table: "ehr_encounter_type" */
  update_ehr_encounter_type?: Maybe<Ehr_Encounter_Type_Mutation_Response>;
  /** update single row of the table: "ehr_encounter_type" */
  update_ehr_encounter_type_by_pk?: Maybe<Ehr_Encounter_Type>;
  /** update multiples rows of table: "ehr_encounter_type" */
  update_ehr_encounter_type_many?: Maybe<Array<Maybe<Ehr_Encounter_Type_Mutation_Response>>>;
  /** update data of the table: "ehr_fda_product" */
  update_ehr_fda_product?: Maybe<Ehr_Fda_Product_Mutation_Response>;
  /** update single row of the table: "ehr_fda_product" */
  update_ehr_fda_product_by_pk?: Maybe<Ehr_Fda_Product>;
  /** update multiples rows of table: "ehr_fda_product" */
  update_ehr_fda_product_many?: Maybe<Array<Maybe<Ehr_Fda_Product_Mutation_Response>>>;
  /** update data of the table: "ehr_fda_product_source" */
  update_ehr_fda_product_source?: Maybe<Ehr_Fda_Product_Source_Mutation_Response>;
  /** update single row of the table: "ehr_fda_product_source" */
  update_ehr_fda_product_source_by_pk?: Maybe<Ehr_Fda_Product_Source>;
  /** update multiples rows of table: "ehr_fda_product_source" */
  update_ehr_fda_product_source_many?: Maybe<Array<Maybe<Ehr_Fda_Product_Source_Mutation_Response>>>;
  /** update data of the table: "ehr_message" */
  update_ehr_message?: Maybe<Ehr_Message_Mutation_Response>;
  /** update single row of the table: "ehr_message" */
  update_ehr_message_by_pk?: Maybe<Ehr_Message>;
  /** update multiples rows of table: "ehr_message" */
  update_ehr_message_many?: Maybe<Array<Maybe<Ehr_Message_Mutation_Response>>>;
  /** update data of the table: "ehr_message_read" */
  update_ehr_message_read?: Maybe<Ehr_Message_Read_Mutation_Response>;
  /** update single row of the table: "ehr_message_read" */
  update_ehr_message_read_by_pk?: Maybe<Ehr_Message_Read>;
  /** update multiples rows of table: "ehr_message_read" */
  update_ehr_message_read_many?: Maybe<Array<Maybe<Ehr_Message_Read_Mutation_Response>>>;
  /** update data of the table: "ehr_message_threads" */
  update_ehr_message_threads?: Maybe<Ehr_Message_Threads_Mutation_Response>;
  /** update single row of the table: "ehr_message_threads" */
  update_ehr_message_threads_by_pk?: Maybe<Ehr_Message_Threads>;
  /** update multiples rows of table: "ehr_message_threads" */
  update_ehr_message_threads_many?: Maybe<Array<Maybe<Ehr_Message_Threads_Mutation_Response>>>;
  /** update data of the table: "ehr_patient_card" */
  update_ehr_patient_card?: Maybe<Ehr_Patient_Card_Mutation_Response>;
  /** update single row of the table: "ehr_patient_card" */
  update_ehr_patient_card_by_pk?: Maybe<Ehr_Patient_Card>;
  /** update multiples rows of table: "ehr_patient_card" */
  update_ehr_patient_card_many?: Maybe<Array<Maybe<Ehr_Patient_Card_Mutation_Response>>>;
  /** update data of the table: "ehr_patient_consent" */
  update_ehr_patient_consent?: Maybe<Ehr_Patient_Consent_Mutation_Response>;
  /** update data of the table: "ehr_patient_consent_action" */
  update_ehr_patient_consent_action?: Maybe<Ehr_Patient_Consent_Action_Mutation_Response>;
  /** update single row of the table: "ehr_patient_consent_action" */
  update_ehr_patient_consent_action_by_pk?: Maybe<Ehr_Patient_Consent_Action>;
  /** update multiples rows of table: "ehr_patient_consent_action" */
  update_ehr_patient_consent_action_many?: Maybe<Array<Maybe<Ehr_Patient_Consent_Action_Mutation_Response>>>;
  /** update single row of the table: "ehr_patient_consent" */
  update_ehr_patient_consent_by_pk?: Maybe<Ehr_Patient_Consent>;
  /** update multiples rows of table: "ehr_patient_consent" */
  update_ehr_patient_consent_many?: Maybe<Array<Maybe<Ehr_Patient_Consent_Mutation_Response>>>;
  /** update data of the table: "ehr_patient_consent_type" */
  update_ehr_patient_consent_type?: Maybe<Ehr_Patient_Consent_Type_Mutation_Response>;
  /** update single row of the table: "ehr_patient_consent_type" */
  update_ehr_patient_consent_type_by_pk?: Maybe<Ehr_Patient_Consent_Type>;
  /** update multiples rows of table: "ehr_patient_consent_type" */
  update_ehr_patient_consent_type_many?: Maybe<Array<Maybe<Ehr_Patient_Consent_Type_Mutation_Response>>>;
  /** update data of the table: "ehr_procedure" */
  update_ehr_procedure?: Maybe<Ehr_Procedure_Mutation_Response>;
  /** update data of the table: "ehr_procedure_body_area" */
  update_ehr_procedure_body_area?: Maybe<Ehr_Procedure_Body_Area_Mutation_Response>;
  /** update single row of the table: "ehr_procedure_body_area" */
  update_ehr_procedure_body_area_by_pk?: Maybe<Ehr_Procedure_Body_Area>;
  /** update multiples rows of table: "ehr_procedure_body_area" */
  update_ehr_procedure_body_area_many?: Maybe<Array<Maybe<Ehr_Procedure_Body_Area_Mutation_Response>>>;
  /** update data of the table: "ehr_procedure_body_part" */
  update_ehr_procedure_body_part?: Maybe<Ehr_Procedure_Body_Part_Mutation_Response>;
  /** update single row of the table: "ehr_procedure_body_part" */
  update_ehr_procedure_body_part_by_pk?: Maybe<Ehr_Procedure_Body_Part>;
  /** update multiples rows of table: "ehr_procedure_body_part" */
  update_ehr_procedure_body_part_many?: Maybe<Array<Maybe<Ehr_Procedure_Body_Part_Mutation_Response>>>;
  /** update data of the table: "ehr_procedure_body_part_provider_injection_default" */
  update_ehr_procedure_body_part_provider_injection_default?: Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Mutation_Response>;
  /** update single row of the table: "ehr_procedure_body_part_provider_injection_default" */
  update_ehr_procedure_body_part_provider_injection_default_by_pk?: Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default>;
  /** update multiples rows of table: "ehr_procedure_body_part_provider_injection_default" */
  update_ehr_procedure_body_part_provider_injection_default_many?: Maybe<Array<Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Mutation_Response>>>;
  /** update single row of the table: "ehr_procedure" */
  update_ehr_procedure_by_pk?: Maybe<Ehr_Procedure>;
  /** update data of the table: "ehr_procedure_ehr_product" */
  update_ehr_procedure_ehr_product?: Maybe<Ehr_Procedure_Ehr_Product_Mutation_Response>;
  /** update single row of the table: "ehr_procedure_ehr_product" */
  update_ehr_procedure_ehr_product_by_pk?: Maybe<Ehr_Procedure_Ehr_Product>;
  /** update multiples rows of table: "ehr_procedure_ehr_product" */
  update_ehr_procedure_ehr_product_many?: Maybe<Array<Maybe<Ehr_Procedure_Ehr_Product_Mutation_Response>>>;
  /** update multiples rows of table: "ehr_procedure" */
  update_ehr_procedure_many?: Maybe<Array<Maybe<Ehr_Procedure_Mutation_Response>>>;
  /** update data of the table: "ehr_procedure_type_enum" */
  update_ehr_procedure_type_enum?: Maybe<Ehr_Procedure_Type_Enum_Mutation_Response>;
  /** update single row of the table: "ehr_procedure_type_enum" */
  update_ehr_procedure_type_enum_by_pk?: Maybe<Ehr_Procedure_Type_Enum>;
  /** update multiples rows of table: "ehr_procedure_type_enum" */
  update_ehr_procedure_type_enum_many?: Maybe<Array<Maybe<Ehr_Procedure_Type_Enum_Mutation_Response>>>;
  /** update data of the table: "ehr_product" */
  update_ehr_product?: Maybe<Ehr_Product_Mutation_Response>;
  /** update single row of the table: "ehr_product" */
  update_ehr_product_by_pk?: Maybe<Ehr_Product>;
  /** update multiples rows of table: "ehr_product" */
  update_ehr_product_many?: Maybe<Array<Maybe<Ehr_Product_Mutation_Response>>>;
  /** update data of the table: "ehr_product_procedure" */
  update_ehr_product_procedure?: Maybe<Ehr_Product_Procedure_Mutation_Response>;
  /** update single row of the table: "ehr_product_procedure" */
  update_ehr_product_procedure_by_pk?: Maybe<Ehr_Product_Procedure>;
  /** update multiples rows of table: "ehr_product_procedure" */
  update_ehr_product_procedure_many?: Maybe<Array<Maybe<Ehr_Product_Procedure_Mutation_Response>>>;
  /** update data of the table: "ehr_product_provider_usage_record_photo" */
  update_ehr_product_provider_usage_record_photo?: Maybe<Ehr_Product_Provider_Usage_Record_Photo_Mutation_Response>;
  /** update single row of the table: "ehr_product_provider_usage_record_photo" */
  update_ehr_product_provider_usage_record_photo_by_pk?: Maybe<Ehr_Product_Provider_Usage_Record_Photo>;
  /** update multiples rows of table: "ehr_product_provider_usage_record_photo" */
  update_ehr_product_provider_usage_record_photo_many?: Maybe<Array<Maybe<Ehr_Product_Provider_Usage_Record_Photo_Mutation_Response>>>;
  /** update data of the table: "ehr_subscription" */
  update_ehr_subscription?: Maybe<Ehr_Subscription_Mutation_Response>;
  /** update single row of the table: "ehr_subscription" */
  update_ehr_subscription_by_pk?: Maybe<Ehr_Subscription>;
  /** update multiples rows of table: "ehr_subscription" */
  update_ehr_subscription_many?: Maybe<Array<Maybe<Ehr_Subscription_Mutation_Response>>>;
  /** update data of the table: "ehr_subscription_status" */
  update_ehr_subscription_status?: Maybe<Ehr_Subscription_Status_Mutation_Response>;
  /** update single row of the table: "ehr_subscription_status" */
  update_ehr_subscription_status_by_pk?: Maybe<Ehr_Subscription_Status>;
  /** update multiples rows of table: "ehr_subscription_status" */
  update_ehr_subscription_status_many?: Maybe<Array<Maybe<Ehr_Subscription_Status_Mutation_Response>>>;
  /** update data of the table: "ehr_subscription_tier" */
  update_ehr_subscription_tier?: Maybe<Ehr_Subscription_Tier_Mutation_Response>;
  /** update single row of the table: "ehr_subscription_tier" */
  update_ehr_subscription_tier_by_pk?: Maybe<Ehr_Subscription_Tier>;
  /** update multiples rows of table: "ehr_subscription_tier" */
  update_ehr_subscription_tier_many?: Maybe<Array<Maybe<Ehr_Subscription_Tier_Mutation_Response>>>;
  /** update data of the table: "ehr_subscription_tier_term" */
  update_ehr_subscription_tier_term?: Maybe<Ehr_Subscription_Tier_Term_Mutation_Response>;
  /** update single row of the table: "ehr_subscription_tier_term" */
  update_ehr_subscription_tier_term_by_pk?: Maybe<Ehr_Subscription_Tier_Term>;
  /** update multiples rows of table: "ehr_subscription_tier_term" */
  update_ehr_subscription_tier_term_many?: Maybe<Array<Maybe<Ehr_Subscription_Tier_Term_Mutation_Response>>>;
  /** update data of the table: "event" */
  update_event?: Maybe<Event_Mutation_Response>;
  /** update single row of the table: "event" */
  update_event_by_pk?: Maybe<Event>;
  /** update multiples rows of table: "event" */
  update_event_many?: Maybe<Array<Maybe<Event_Mutation_Response>>>;
  /** update data of the table: "event_source" */
  update_event_source?: Maybe<Event_Source_Mutation_Response>;
  /** update single row of the table: "event_source" */
  update_event_source_by_pk?: Maybe<Event_Source>;
  /** update multiples rows of table: "event_source" */
  update_event_source_many?: Maybe<Array<Maybe<Event_Source_Mutation_Response>>>;
  /** update data of the table: "filler_procedure_delivery_tool" */
  update_filler_procedure_delivery_tool?: Maybe<Filler_Procedure_Delivery_Tool_Mutation_Response>;
  /** update single row of the table: "filler_procedure_delivery_tool" */
  update_filler_procedure_delivery_tool_by_pk?: Maybe<Filler_Procedure_Delivery_Tool>;
  /** update multiples rows of table: "filler_procedure_delivery_tool" */
  update_filler_procedure_delivery_tool_many?: Maybe<Array<Maybe<Filler_Procedure_Delivery_Tool_Mutation_Response>>>;
  /** update data of the table: "filler_procedure_face_view" */
  update_filler_procedure_face_view?: Maybe<Filler_Procedure_Face_View_Mutation_Response>;
  /** update single row of the table: "filler_procedure_face_view" */
  update_filler_procedure_face_view_by_pk?: Maybe<Filler_Procedure_Face_View>;
  /** update multiples rows of table: "filler_procedure_face_view" */
  update_filler_procedure_face_view_many?: Maybe<Array<Maybe<Filler_Procedure_Face_View_Mutation_Response>>>;
  /** update data of the table: "filler_procedure_injection" */
  update_filler_procedure_injection?: Maybe<Filler_Procedure_Injection_Mutation_Response>;
  /** update single row of the table: "filler_procedure_injection" */
  update_filler_procedure_injection_by_pk?: Maybe<Filler_Procedure_Injection>;
  /** update multiples rows of table: "filler_procedure_injection" */
  update_filler_procedure_injection_many?: Maybe<Array<Maybe<Filler_Procedure_Injection_Mutation_Response>>>;
  /** update data of the table: "filler_procedure_injection_type" */
  update_filler_procedure_injection_type?: Maybe<Filler_Procedure_Injection_Type_Mutation_Response>;
  /** update single row of the table: "filler_procedure_injection_type" */
  update_filler_procedure_injection_type_by_pk?: Maybe<Filler_Procedure_Injection_Type>;
  /** update multiples rows of table: "filler_procedure_injection_type" */
  update_filler_procedure_injection_type_many?: Maybe<Array<Maybe<Filler_Procedure_Injection_Type_Mutation_Response>>>;
  /** update data of the table: "filler_procedure_product_instance" */
  update_filler_procedure_product_instance?: Maybe<Filler_Procedure_Product_Instance_Mutation_Response>;
  /** update single row of the table: "filler_procedure_product_instance" */
  update_filler_procedure_product_instance_by_pk?: Maybe<Filler_Procedure_Product_Instance>;
  /** update multiples rows of table: "filler_procedure_product_instance" */
  update_filler_procedure_product_instance_many?: Maybe<Array<Maybe<Filler_Procedure_Product_Instance_Mutation_Response>>>;
  /** update data of the table: "filler_procedure_product_instance_photo" */
  update_filler_procedure_product_instance_photo?: Maybe<Filler_Procedure_Product_Instance_Photo_Mutation_Response>;
  /** update single row of the table: "filler_procedure_product_instance_photo" */
  update_filler_procedure_product_instance_photo_by_pk?: Maybe<Filler_Procedure_Product_Instance_Photo>;
  /** update multiples rows of table: "filler_procedure_product_instance_photo" */
  update_filler_procedure_product_instance_photo_many?: Maybe<Array<Maybe<Filler_Procedure_Product_Instance_Photo_Mutation_Response>>>;
  /** update data of the table: "filler_space" */
  update_filler_space?: Maybe<Filler_Space_Mutation_Response>;
  /** update single row of the table: "filler_space" */
  update_filler_space_by_pk?: Maybe<Filler_Space>;
  /** update multiples rows of table: "filler_space" */
  update_filler_space_many?: Maybe<Array<Maybe<Filler_Space_Mutation_Response>>>;
  /** update data of the table: "filler_zone_release" */
  update_filler_zone_release?: Maybe<Filler_Zone_Release_Mutation_Response>;
  /** update single row of the table: "filler_zone_release" */
  update_filler_zone_release_by_pk?: Maybe<Filler_Zone_Release>;
  /** update multiples rows of table: "filler_zone_release" */
  update_filler_zone_release_many?: Maybe<Array<Maybe<Filler_Zone_Release_Mutation_Response>>>;
  /** update data of the table: "fn_check_proposed_patient_booking_for_stacking" */
  update_fn_check_proposed_patient_booking_for_stacking?: Maybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Mutation_Response>;
  /** update single row of the table: "fn_check_proposed_patient_booking_for_stacking" */
  update_fn_check_proposed_patient_booking_for_stacking_by_pk?: Maybe<Fn_Check_Proposed_Patient_Booking_For_Stacking>;
  /** update multiples rows of table: "fn_check_proposed_patient_booking_for_stacking" */
  update_fn_check_proposed_patient_booking_for_stacking_many?: Maybe<Array<Maybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Mutation_Response>>>;
  /** update data of the table: "fn_get_active_notification_preferences_for_type_and_location" */
  update_fn_get_active_notification_preferences_for_type_and_location?: Maybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Mutation_Response>;
  /** update single row of the table: "fn_get_active_notification_preferences_for_type_and_location" */
  update_fn_get_active_notification_preferences_for_type_and_location_by_pk?: Maybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location>;
  /** update multiples rows of table: "fn_get_active_notification_preferences_for_type_and_location" */
  update_fn_get_active_notification_preferences_for_type_and_location_many?: Maybe<Array<Maybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Mutation_Response>>>;
  /** update data of the table: "fn_get_active_subscribers_query" */
  update_fn_get_active_subscribers_query?: Maybe<Fn_Get_Active_Subscribers_Query_Mutation_Response>;
  /** update single row of the table: "fn_get_active_subscribers_query" */
  update_fn_get_active_subscribers_query_by_pk?: Maybe<Fn_Get_Active_Subscribers_Query>;
  /** update multiples rows of table: "fn_get_active_subscribers_query" */
  update_fn_get_active_subscribers_query_many?: Maybe<Array<Maybe<Fn_Get_Active_Subscribers_Query_Mutation_Response>>>;
  /** update data of the table: "fn_get_location_purchases_to_provider_purchases_query" */
  update_fn_get_location_purchases_to_provider_purchases_query?: Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Mutation_Response>;
  /** update single row of the table: "fn_get_location_purchases_to_provider_purchases_query" */
  update_fn_get_location_purchases_to_provider_purchases_query_by_pk?: Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query>;
  /** update multiples rows of table: "fn_get_location_purchases_to_provider_purchases_query" */
  update_fn_get_location_purchases_to_provider_purchases_query_many?: Maybe<Array<Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Mutation_Response>>>;
  /** update data of the table: "fn_get_stackable_booking_options_data" */
  update_fn_get_stackable_booking_options_data?: Maybe<Fn_Get_Stackable_Booking_Options_Data_Mutation_Response>;
  /** update single row of the table: "fn_get_stackable_booking_options_data" */
  update_fn_get_stackable_booking_options_data_by_pk?: Maybe<Fn_Get_Stackable_Booking_Options_Data>;
  /** update multiples rows of table: "fn_get_stackable_booking_options_data" */
  update_fn_get_stackable_booking_options_data_many?: Maybe<Array<Maybe<Fn_Get_Stackable_Booking_Options_Data_Mutation_Response>>>;
  /** update data of the table: "fn_get_user_booking_options_blockers" */
  update_fn_get_user_booking_options_blockers?: Maybe<Fn_Get_User_Booking_Options_Blockers_Mutation_Response>;
  /** update single row of the table: "fn_get_user_booking_options_blockers" */
  update_fn_get_user_booking_options_blockers_by_pk?: Maybe<Fn_Get_User_Booking_Options_Blockers>;
  /** update multiples rows of table: "fn_get_user_booking_options_blockers" */
  update_fn_get_user_booking_options_blockers_many?: Maybe<Array<Maybe<Fn_Get_User_Booking_Options_Blockers_Mutation_Response>>>;
  /** update data of the table: "fn_get_user_location_procedure_unavailable_rooms" */
  update_fn_get_user_location_procedure_unavailable_rooms?: Maybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Mutation_Response>;
  /** update single row of the table: "fn_get_user_location_procedure_unavailable_rooms" */
  update_fn_get_user_location_procedure_unavailable_rooms_by_pk?: Maybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms>;
  /** update multiples rows of table: "fn_get_user_location_procedure_unavailable_rooms" */
  update_fn_get_user_location_procedure_unavailable_rooms_many?: Maybe<Array<Maybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Mutation_Response>>>;
  /** update data of the table: "fn_get_user_products_to_rentals_query" */
  update_fn_get_user_products_to_rentals_query?: Maybe<Fn_Get_User_Products_To_Rentals_Query_Mutation_Response>;
  /** update single row of the table: "fn_get_user_products_to_rentals_query" */
  update_fn_get_user_products_to_rentals_query_by_pk?: Maybe<Fn_Get_User_Products_To_Rentals_Query>;
  /** update multiples rows of table: "fn_get_user_products_to_rentals_query" */
  update_fn_get_user_products_to_rentals_query_many?: Maybe<Array<Maybe<Fn_Get_User_Products_To_Rentals_Query_Mutation_Response>>>;
  /** update data of the table: "fn_users_unfulfilled_product_purchases_count_by_location" */
  update_fn_users_unfulfilled_product_purchases_count_by_location?: Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Mutation_Response>;
  /** update single row of the table: "fn_users_unfulfilled_product_purchases_count_by_location" */
  update_fn_users_unfulfilled_product_purchases_count_by_location_by_pk?: Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location>;
  /** update multiples rows of table: "fn_users_unfulfilled_product_purchases_count_by_location" */
  update_fn_users_unfulfilled_product_purchases_count_by_location_many?: Maybe<Array<Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Mutation_Response>>>;
  /** update data of the table: "gender" */
  update_gender?: Maybe<Gender_Mutation_Response>;
  /** update single row of the table: "gender" */
  update_gender_by_pk?: Maybe<Gender>;
  /** update multiples rows of table: "gender" */
  update_gender_many?: Maybe<Array<Maybe<Gender_Mutation_Response>>>;
  /** update data of the table: "invoice" */
  update_invoice?: Maybe<Invoice_Mutation_Response>;
  /** update data of the table: "invoice_billing_summary" */
  update_invoice_billing_summary?: Maybe<Invoice_Billing_Summary_Mutation_Response>;
  /** update multiples rows of table: "invoice_billing_summary" */
  update_invoice_billing_summary_many?: Maybe<Array<Maybe<Invoice_Billing_Summary_Mutation_Response>>>;
  /** update single row of the table: "invoice" */
  update_invoice_by_pk?: Maybe<Invoice>;
  /** update multiples rows of table: "invoice" */
  update_invoice_many?: Maybe<Array<Maybe<Invoice_Mutation_Response>>>;
  /** update data of the table: "location" */
  update_location?: Maybe<Location_Mutation_Response>;
  /** update single row of the table: "location" */
  update_location_by_pk?: Maybe<Location>;
  /** update multiples rows of table: "location" */
  update_location_many?: Maybe<Array<Maybe<Location_Mutation_Response>>>;
  /** update data of the table: "location_procedure" */
  update_location_procedure?: Maybe<Location_Procedure_Mutation_Response>;
  /** update single row of the table: "location_procedure" */
  update_location_procedure_by_pk?: Maybe<Location_Procedure>;
  /** update multiples rows of table: "location_procedure" */
  update_location_procedure_many?: Maybe<Array<Maybe<Location_Procedure_Mutation_Response>>>;
  /** update data of the table: "location_procedure_room" */
  update_location_procedure_room?: Maybe<Location_Procedure_Room_Mutation_Response>;
  /** update single row of the table: "location_procedure_room" */
  update_location_procedure_room_by_pk?: Maybe<Location_Procedure_Room>;
  /** update multiples rows of table: "location_procedure_room" */
  update_location_procedure_room_many?: Maybe<Array<Maybe<Location_Procedure_Room_Mutation_Response>>>;
  /** update data of the table: "location_product" */
  update_location_product?: Maybe<Location_Product_Mutation_Response>;
  /** update single row of the table: "location_product" */
  update_location_product_by_pk?: Maybe<Location_Product>;
  /** update multiples rows of table: "location_product" */
  update_location_product_many?: Maybe<Array<Maybe<Location_Product_Mutation_Response>>>;
  /** update data of the table: "model" */
  update_model?: Maybe<Model_Mutation_Response>;
  /** update single row of the table: "model" */
  update_model_by_pk?: Maybe<Model>;
  /** update data of the table: "model_count" */
  update_model_count?: Maybe<Model_Count_Mutation_Response>;
  /** update single row of the table: "model_count" */
  update_model_count_by_pk?: Maybe<Model_Count>;
  /** update multiples rows of table: "model_count" */
  update_model_count_many?: Maybe<Array<Maybe<Model_Count_Mutation_Response>>>;
  /** update multiples rows of table: "model" */
  update_model_many?: Maybe<Array<Maybe<Model_Mutation_Response>>>;
  /** update data of the table: "model_product" */
  update_model_product?: Maybe<Model_Product_Mutation_Response>;
  /** update single row of the table: "model_product" */
  update_model_product_by_pk?: Maybe<Model_Product>;
  /** update multiples rows of table: "model_product" */
  update_model_product_many?: Maybe<Array<Maybe<Model_Product_Mutation_Response>>>;
  /** update data of the table: "mso_mode" */
  update_mso_mode?: Maybe<Mso_Mode_Mutation_Response>;
  /** update single row of the table: "mso_mode" */
  update_mso_mode_by_pk?: Maybe<Mso_Mode>;
  /** update multiples rows of table: "mso_mode" */
  update_mso_mode_many?: Maybe<Array<Maybe<Mso_Mode_Mutation_Response>>>;
  /** update data of the table: "mso_tier" */
  update_mso_tier?: Maybe<Mso_Tier_Mutation_Response>;
  /** update single row of the table: "mso_tier" */
  update_mso_tier_by_pk?: Maybe<Mso_Tier>;
  /** update multiples rows of table: "mso_tier" */
  update_mso_tier_many?: Maybe<Array<Maybe<Mso_Tier_Mutation_Response>>>;
  /** update data of the table: "notification_audit_log" */
  update_notification_audit_log?: Maybe<Notification_Audit_Log_Mutation_Response>;
  /** update single row of the table: "notification_audit_log" */
  update_notification_audit_log_by_pk?: Maybe<Notification_Audit_Log>;
  /** update multiples rows of table: "notification_audit_log" */
  update_notification_audit_log_many?: Maybe<Array<Maybe<Notification_Audit_Log_Mutation_Response>>>;
  /** update data of the table: "notification_broadcast_type" */
  update_notification_broadcast_type?: Maybe<Notification_Broadcast_Type_Mutation_Response>;
  /** update single row of the table: "notification_broadcast_type" */
  update_notification_broadcast_type_by_pk?: Maybe<Notification_Broadcast_Type>;
  /** update multiples rows of table: "notification_broadcast_type" */
  update_notification_broadcast_type_many?: Maybe<Array<Maybe<Notification_Broadcast_Type_Mutation_Response>>>;
  /** update data of the table: "notification_channel" */
  update_notification_channel?: Maybe<Notification_Channel_Mutation_Response>;
  /** update single row of the table: "notification_channel" */
  update_notification_channel_by_pk?: Maybe<Notification_Channel>;
  /** update multiples rows of table: "notification_channel" */
  update_notification_channel_many?: Maybe<Array<Maybe<Notification_Channel_Mutation_Response>>>;
  /** update data of the table: "notification_preference" */
  update_notification_preference?: Maybe<Notification_Preference_Mutation_Response>;
  /** update single row of the table: "notification_preference" */
  update_notification_preference_by_pk?: Maybe<Notification_Preference>;
  /** update multiples rows of table: "notification_preference" */
  update_notification_preference_many?: Maybe<Array<Maybe<Notification_Preference_Mutation_Response>>>;
  /** update data of the table: "notification_type" */
  update_notification_type?: Maybe<Notification_Type_Mutation_Response>;
  /** update single row of the table: "notification_type" */
  update_notification_type_by_pk?: Maybe<Notification_Type>;
  /** update data of the table: "notification_type_default_channel" */
  update_notification_type_default_channel?: Maybe<Notification_Type_Default_Channel_Mutation_Response>;
  /** update single row of the table: "notification_type_default_channel" */
  update_notification_type_default_channel_by_pk?: Maybe<Notification_Type_Default_Channel>;
  /** update multiples rows of table: "notification_type_default_channel" */
  update_notification_type_default_channel_many?: Maybe<Array<Maybe<Notification_Type_Default_Channel_Mutation_Response>>>;
  /** update multiples rows of table: "notification_type" */
  update_notification_type_many?: Maybe<Array<Maybe<Notification_Type_Mutation_Response>>>;
  /** update data of the table: "open" */
  update_open?: Maybe<Open_Mutation_Response>;
  /** update single row of the table: "open" */
  update_open_by_pk?: Maybe<Open>;
  /** update multiples rows of table: "open" */
  update_open_many?: Maybe<Array<Maybe<Open_Mutation_Response>>>;
  /** update data of the table: "partner" */
  update_partner?: Maybe<Partner_Mutation_Response>;
  /** update data of the table: "partner_basic" */
  update_partner_basic?: Maybe<Partner_Basic_Mutation_Response>;
  /** update multiples rows of table: "partner_basic" */
  update_partner_basic_many?: Maybe<Array<Maybe<Partner_Basic_Mutation_Response>>>;
  /** update single row of the table: "partner" */
  update_partner_by_pk?: Maybe<Partner>;
  /** update multiples rows of table: "partner" */
  update_partner_many?: Maybe<Array<Maybe<Partner_Mutation_Response>>>;
  /** update data of the table: "patient" */
  update_patient?: Maybe<Patient_Mutation_Response>;
  /** update data of the table: "patient_account_event" */
  update_patient_account_event?: Maybe<Patient_Account_Event_Mutation_Response>;
  /** update single row of the table: "patient_account_event" */
  update_patient_account_event_by_pk?: Maybe<Patient_Account_Event>;
  /** update multiples rows of table: "patient_account_event" */
  update_patient_account_event_many?: Maybe<Array<Maybe<Patient_Account_Event_Mutation_Response>>>;
  /** update data of the table: "patient_account_event_type" */
  update_patient_account_event_type?: Maybe<Patient_Account_Event_Type_Mutation_Response>;
  /** update single row of the table: "patient_account_event_type" */
  update_patient_account_event_type_by_pk?: Maybe<Patient_Account_Event_Type>;
  /** update multiples rows of table: "patient_account_event_type" */
  update_patient_account_event_type_many?: Maybe<Array<Maybe<Patient_Account_Event_Type_Mutation_Response>>>;
  /** update data of the table: "patient_auth_challenge" */
  update_patient_auth_challenge?: Maybe<Patient_Auth_Challenge_Mutation_Response>;
  /** update single row of the table: "patient_auth_challenge" */
  update_patient_auth_challenge_by_pk?: Maybe<Patient_Auth_Challenge>;
  /** update multiples rows of table: "patient_auth_challenge" */
  update_patient_auth_challenge_many?: Maybe<Array<Maybe<Patient_Auth_Challenge_Mutation_Response>>>;
  /** update data of the table: "patient_bookable_ehr_procedure" */
  update_patient_bookable_ehr_procedure?: Maybe<Patient_Bookable_Ehr_Procedure_Mutation_Response>;
  /** update single row of the table: "patient_bookable_ehr_procedure" */
  update_patient_bookable_ehr_procedure_by_pk?: Maybe<Patient_Bookable_Ehr_Procedure>;
  /** update multiples rows of table: "patient_bookable_ehr_procedure" */
  update_patient_bookable_ehr_procedure_many?: Maybe<Array<Maybe<Patient_Bookable_Ehr_Procedure_Mutation_Response>>>;
  /** update data of the table: "patient_booking" */
  update_patient_booking?: Maybe<Patient_Booking_Mutation_Response>;
  /** update data of the table: "patient_booking_booking" */
  update_patient_booking_booking?: Maybe<Patient_Booking_Booking_Mutation_Response>;
  /** update single row of the table: "patient_booking_booking" */
  update_patient_booking_booking_by_pk?: Maybe<Patient_Booking_Booking>;
  /** update multiples rows of table: "patient_booking_booking" */
  update_patient_booking_booking_many?: Maybe<Array<Maybe<Patient_Booking_Booking_Mutation_Response>>>;
  /** update single row of the table: "patient_booking" */
  update_patient_booking_by_pk?: Maybe<Patient_Booking>;
  /** update data of the table: "patient_booking_cancel_reason" */
  update_patient_booking_cancel_reason?: Maybe<Patient_Booking_Cancel_Reason_Mutation_Response>;
  /** update single row of the table: "patient_booking_cancel_reason" */
  update_patient_booking_cancel_reason_by_pk?: Maybe<Patient_Booking_Cancel_Reason>;
  /** update multiples rows of table: "patient_booking_cancel_reason" */
  update_patient_booking_cancel_reason_many?: Maybe<Array<Maybe<Patient_Booking_Cancel_Reason_Mutation_Response>>>;
  /** update data of the table: "patient_booking_initiator" */
  update_patient_booking_initiator?: Maybe<Patient_Booking_Initiator_Mutation_Response>;
  /** update single row of the table: "patient_booking_initiator" */
  update_patient_booking_initiator_by_pk?: Maybe<Patient_Booking_Initiator>;
  /** update multiples rows of table: "patient_booking_initiator" */
  update_patient_booking_initiator_many?: Maybe<Array<Maybe<Patient_Booking_Initiator_Mutation_Response>>>;
  /** update multiples rows of table: "patient_booking" */
  update_patient_booking_many?: Maybe<Array<Maybe<Patient_Booking_Mutation_Response>>>;
  /** update data of the table: "patient_booking_metadata" */
  update_patient_booking_metadata?: Maybe<Patient_Booking_Metadata_Mutation_Response>;
  /** update single row of the table: "patient_booking_metadata" */
  update_patient_booking_metadata_by_pk?: Maybe<Patient_Booking_Metadata>;
  /** update multiples rows of table: "patient_booking_metadata" */
  update_patient_booking_metadata_many?: Maybe<Array<Maybe<Patient_Booking_Metadata_Mutation_Response>>>;
  /** update single row of the table: "patient" */
  update_patient_by_pk?: Maybe<Patient>;
  /** update data of the table: "patient_last_view" */
  update_patient_last_view?: Maybe<Patient_Last_View_Mutation_Response>;
  /** update single row of the table: "patient_last_view" */
  update_patient_last_view_by_pk?: Maybe<Patient_Last_View>;
  /** update multiples rows of table: "patient_last_view" */
  update_patient_last_view_many?: Maybe<Array<Maybe<Patient_Last_View_Mutation_Response>>>;
  /** update multiples rows of table: "patient" */
  update_patient_many?: Maybe<Array<Maybe<Patient_Mutation_Response>>>;
  /** update data of the table: "patient_medical_profile" */
  update_patient_medical_profile?: Maybe<Patient_Medical_Profile_Mutation_Response>;
  /** update single row of the table: "patient_medical_profile" */
  update_patient_medical_profile_by_pk?: Maybe<Patient_Medical_Profile>;
  /** update multiples rows of table: "patient_medical_profile" */
  update_patient_medical_profile_many?: Maybe<Array<Maybe<Patient_Medical_Profile_Mutation_Response>>>;
  /** update data of the table: "patient_registration_invite" */
  update_patient_registration_invite?: Maybe<Patient_Registration_Invite_Mutation_Response>;
  /** update single row of the table: "patient_registration_invite" */
  update_patient_registration_invite_by_pk?: Maybe<Patient_Registration_Invite>;
  /** update multiples rows of table: "patient_registration_invite" */
  update_patient_registration_invite_many?: Maybe<Array<Maybe<Patient_Registration_Invite_Mutation_Response>>>;
  /** update data of the table: "patient_session" */
  update_patient_session?: Maybe<Patient_Session_Mutation_Response>;
  /** update single row of the table: "patient_session" */
  update_patient_session_by_pk?: Maybe<Patient_Session>;
  /** update multiples rows of table: "patient_session" */
  update_patient_session_many?: Maybe<Array<Maybe<Patient_Session_Mutation_Response>>>;
  /** update data of the table: "patient_webauthn_challenge" */
  update_patient_webauthn_challenge?: Maybe<Patient_Webauthn_Challenge_Mutation_Response>;
  /** update single row of the table: "patient_webauthn_challenge" */
  update_patient_webauthn_challenge_by_pk?: Maybe<Patient_Webauthn_Challenge>;
  /** update multiples rows of table: "patient_webauthn_challenge" */
  update_patient_webauthn_challenge_many?: Maybe<Array<Maybe<Patient_Webauthn_Challenge_Mutation_Response>>>;
  /** update data of the table: "patient_webauthn_credential" */
  update_patient_webauthn_credential?: Maybe<Patient_Webauthn_Credential_Mutation_Response>;
  /** update single row of the table: "patient_webauthn_credential" */
  update_patient_webauthn_credential_by_pk?: Maybe<Patient_Webauthn_Credential>;
  /** update multiples rows of table: "patient_webauthn_credential" */
  update_patient_webauthn_credential_many?: Maybe<Array<Maybe<Patient_Webauthn_Credential_Mutation_Response>>>;
  /** update data of the table: "plan" */
  update_plan?: Maybe<Plan_Mutation_Response>;
  /** update single row of the table: "plan" */
  update_plan_by_pk?: Maybe<Plan>;
  /** update multiples rows of table: "plan" */
  update_plan_many?: Maybe<Array<Maybe<Plan_Mutation_Response>>>;
  /** update data of the table: "plan_type" */
  update_plan_type?: Maybe<Plan_Type_Mutation_Response>;
  /** update single row of the table: "plan_type" */
  update_plan_type_by_pk?: Maybe<Plan_Type>;
  /** update multiples rows of table: "plan_type" */
  update_plan_type_many?: Maybe<Array<Maybe<Plan_Type_Mutation_Response>>>;
  /** update data of the table: "pre_procedure_photo_injection_marking" */
  update_pre_procedure_photo_injection_marking?: Maybe<Pre_Procedure_Photo_Injection_Marking_Mutation_Response>;
  /** update single row of the table: "pre_procedure_photo_injection_marking" */
  update_pre_procedure_photo_injection_marking_by_pk?: Maybe<Pre_Procedure_Photo_Injection_Marking>;
  /** update multiples rows of table: "pre_procedure_photo_injection_marking" */
  update_pre_procedure_photo_injection_marking_many?: Maybe<Array<Maybe<Pre_Procedure_Photo_Injection_Marking_Mutation_Response>>>;
  /** update data of the table: "procedure" */
  update_procedure?: Maybe<Procedure_Mutation_Response>;
  /** update data of the table: "procedure_audio_recording" */
  update_procedure_audio_recording?: Maybe<Procedure_Audio_Recording_Mutation_Response>;
  /** update single row of the table: "procedure_audio_recording" */
  update_procedure_audio_recording_by_pk?: Maybe<Procedure_Audio_Recording>;
  /** update multiples rows of table: "procedure_audio_recording" */
  update_procedure_audio_recording_many?: Maybe<Array<Maybe<Procedure_Audio_Recording_Mutation_Response>>>;
  /** update single row of the table: "procedure" */
  update_procedure_by_pk?: Maybe<Procedure>;
  /** update multiples rows of table: "procedure" */
  update_procedure_many?: Maybe<Array<Maybe<Procedure_Mutation_Response>>>;
  /** update data of the table: "product" */
  update_product?: Maybe<Product_Mutation_Response>;
  /** update single row of the table: "product" */
  update_product_by_pk?: Maybe<Product>;
  /** update multiples rows of table: "product" */
  update_product_many?: Maybe<Array<Maybe<Product_Mutation_Response>>>;
  /** update data of the table: "product_purchase" */
  update_product_purchase?: Maybe<Product_Purchase_Mutation_Response>;
  /** update single row of the table: "product_purchase" */
  update_product_purchase_by_pk?: Maybe<Product_Purchase>;
  /** update multiples rows of table: "product_purchase" */
  update_product_purchase_many?: Maybe<Array<Maybe<Product_Purchase_Mutation_Response>>>;
  /** update data of the table: "product_type" */
  update_product_type?: Maybe<Product_Type_Mutation_Response>;
  /** update single row of the table: "product_type" */
  update_product_type_by_pk?: Maybe<Product_Type>;
  /** update multiples rows of table: "product_type" */
  update_product_type_many?: Maybe<Array<Maybe<Product_Type_Mutation_Response>>>;
  /** update data of the table: "provider_direct_product_purchase" */
  update_provider_direct_product_purchase?: Maybe<Provider_Direct_Product_Purchase_Mutation_Response>;
  /** update single row of the table: "provider_direct_product_purchase" */
  update_provider_direct_product_purchase_by_pk?: Maybe<Provider_Direct_Product_Purchase>;
  /** update multiples rows of table: "provider_direct_product_purchase" */
  update_provider_direct_product_purchase_many?: Maybe<Array<Maybe<Provider_Direct_Product_Purchase_Mutation_Response>>>;
  /** update data of the table: "provider_hours" */
  update_provider_hours?: Maybe<Provider_Hours_Mutation_Response>;
  /** update single row of the table: "provider_hours" */
  update_provider_hours_by_pk?: Maybe<Provider_Hours>;
  /** update multiples rows of table: "provider_hours" */
  update_provider_hours_many?: Maybe<Array<Maybe<Provider_Hours_Mutation_Response>>>;
  /** update data of the table: "provider_hours_repeat_interval" */
  update_provider_hours_repeat_interval?: Maybe<Provider_Hours_Repeat_Interval_Mutation_Response>;
  /** update single row of the table: "provider_hours_repeat_interval" */
  update_provider_hours_repeat_interval_by_pk?: Maybe<Provider_Hours_Repeat_Interval>;
  /** update multiples rows of table: "provider_hours_repeat_interval" */
  update_provider_hours_repeat_interval_many?: Maybe<Array<Maybe<Provider_Hours_Repeat_Interval_Mutation_Response>>>;
  /** update data of the table: "provider_hours_repeater" */
  update_provider_hours_repeater?: Maybe<Provider_Hours_Repeater_Mutation_Response>;
  /** update single row of the table: "provider_hours_repeater" */
  update_provider_hours_repeater_by_pk?: Maybe<Provider_Hours_Repeater>;
  /** update multiples rows of table: "provider_hours_repeater" */
  update_provider_hours_repeater_many?: Maybe<Array<Maybe<Provider_Hours_Repeater_Mutation_Response>>>;
  /** update data of the table: "provider_patient_booking_settings" */
  update_provider_patient_booking_settings?: Maybe<Provider_Patient_Booking_Settings_Mutation_Response>;
  /** update single row of the table: "provider_patient_booking_settings" */
  update_provider_patient_booking_settings_by_pk?: Maybe<Provider_Patient_Booking_Settings>;
  /** update multiples rows of table: "provider_patient_booking_settings" */
  update_provider_patient_booking_settings_many?: Maybe<Array<Maybe<Provider_Patient_Booking_Settings_Mutation_Response>>>;
  /** update data of the table: "provider_procedure" */
  update_provider_procedure?: Maybe<Provider_Procedure_Mutation_Response>;
  /** update single row of the table: "provider_procedure" */
  update_provider_procedure_by_pk?: Maybe<Provider_Procedure>;
  /** update multiples rows of table: "provider_procedure" */
  update_provider_procedure_many?: Maybe<Array<Maybe<Provider_Procedure_Mutation_Response>>>;
  /** update data of the table: "purchase_for_location" */
  update_purchase_for_location?: Maybe<Purchase_For_Location_Mutation_Response>;
  /** update single row of the table: "purchase_for_location" */
  update_purchase_for_location_by_pk?: Maybe<Purchase_For_Location>;
  /** update multiples rows of table: "purchase_for_location" */
  update_purchase_for_location_many?: Maybe<Array<Maybe<Purchase_For_Location_Mutation_Response>>>;
  /** update data of the table: "rental_volume_discount" */
  update_rental_volume_discount?: Maybe<Rental_Volume_Discount_Mutation_Response>;
  /** update single row of the table: "rental_volume_discount" */
  update_rental_volume_discount_by_pk?: Maybe<Rental_Volume_Discount>;
  /** update multiples rows of table: "rental_volume_discount" */
  update_rental_volume_discount_many?: Maybe<Array<Maybe<Rental_Volume_Discount_Mutation_Response>>>;
  /** update data of the table: "repeating" */
  update_repeating?: Maybe<Repeating_Mutation_Response>;
  /** update single row of the table: "repeating" */
  update_repeating_by_pk?: Maybe<Repeating>;
  /** update multiples rows of table: "repeating" */
  update_repeating_many?: Maybe<Array<Maybe<Repeating_Mutation_Response>>>;
  /** update data of the table: "report_preference" */
  update_report_preference?: Maybe<Report_Preference_Mutation_Response>;
  /** update single row of the table: "report_preference" */
  update_report_preference_by_pk?: Maybe<Report_Preference>;
  /** update multiples rows of table: "report_preference" */
  update_report_preference_many?: Maybe<Array<Maybe<Report_Preference_Mutation_Response>>>;
  /** update data of the table: "report_type" */
  update_report_type?: Maybe<Report_Type_Mutation_Response>;
  /** update single row of the table: "report_type" */
  update_report_type_by_pk?: Maybe<Report_Type>;
  /** update multiples rows of table: "report_type" */
  update_report_type_many?: Maybe<Array<Maybe<Report_Type_Mutation_Response>>>;
  /** update data of the table: "role" */
  update_role?: Maybe<Role_Mutation_Response>;
  /** update single row of the table: "role" */
  update_role_by_pk?: Maybe<Role>;
  /** update multiples rows of table: "role" */
  update_role_many?: Maybe<Array<Maybe<Role_Mutation_Response>>>;
  /** update data of the table: "role_notification" */
  update_role_notification?: Maybe<Role_Notification_Mutation_Response>;
  /** update single row of the table: "role_notification" */
  update_role_notification_by_pk?: Maybe<Role_Notification>;
  /** update multiples rows of table: "role_notification" */
  update_role_notification_many?: Maybe<Array<Maybe<Role_Notification_Mutation_Response>>>;
  /** update data of the table: "room" */
  update_room?: Maybe<Room_Mutation_Response>;
  /** update single row of the table: "room" */
  update_room_by_pk?: Maybe<Room>;
  /** update multiples rows of table: "room" */
  update_room_many?: Maybe<Array<Maybe<Room_Mutation_Response>>>;
  /** update data of the table: "room_model" */
  update_room_model?: Maybe<Room_Model_Mutation_Response>;
  /** update single row of the table: "room_model" */
  update_room_model_by_pk?: Maybe<Room_Model>;
  /** update multiples rows of table: "room_model" */
  update_room_model_many?: Maybe<Array<Maybe<Room_Model_Mutation_Response>>>;
  /** update data of the table: "room_type" */
  update_room_type?: Maybe<Room_Type_Mutation_Response>;
  /** update single row of the table: "room_type" */
  update_room_type_by_pk?: Maybe<Room_Type>;
  /** update multiples rows of table: "room_type" */
  update_room_type_many?: Maybe<Array<Maybe<Room_Type_Mutation_Response>>>;
  /** update data of the table: "sex" */
  update_sex?: Maybe<Sex_Mutation_Response>;
  /** update single row of the table: "sex" */
  update_sex_by_pk?: Maybe<Sex>;
  /** update multiples rows of table: "sex" */
  update_sex_many?: Maybe<Array<Maybe<Sex_Mutation_Response>>>;
  /** update data of the table: "signing_document" */
  update_signing_document?: Maybe<Signing_Document_Mutation_Response>;
  /** update single row of the table: "signing_document" */
  update_signing_document_by_pk?: Maybe<Signing_Document>;
  /** update multiples rows of table: "signing_document" */
  update_signing_document_many?: Maybe<Array<Maybe<Signing_Document_Mutation_Response>>>;
  /** update data of the table: "signing_document_status_type" */
  update_signing_document_status_type?: Maybe<Signing_Document_Status_Type_Mutation_Response>;
  /** update single row of the table: "signing_document_status_type" */
  update_signing_document_status_type_by_pk?: Maybe<Signing_Document_Status_Type>;
  /** update multiples rows of table: "signing_document_status_type" */
  update_signing_document_status_type_many?: Maybe<Array<Maybe<Signing_Document_Status_Type_Mutation_Response>>>;
  /** update data of the table: "signing_procedure_associated_documents" */
  update_signing_procedure_associated_documents?: Maybe<Signing_Procedure_Associated_Documents_Mutation_Response>;
  /** update single row of the table: "signing_procedure_associated_documents" */
  update_signing_procedure_associated_documents_by_pk?: Maybe<Signing_Procedure_Associated_Documents>;
  /** update multiples rows of table: "signing_procedure_associated_documents" */
  update_signing_procedure_associated_documents_many?: Maybe<Array<Maybe<Signing_Procedure_Associated_Documents_Mutation_Response>>>;
  /** update data of the table: "signing_template" */
  update_signing_template?: Maybe<Signing_Template_Mutation_Response>;
  /** update single row of the table: "signing_template" */
  update_signing_template_by_pk?: Maybe<Signing_Template>;
  /** update data of the table: "signing_template_equivalents" */
  update_signing_template_equivalents?: Maybe<Signing_Template_Equivalents_Mutation_Response>;
  /** update single row of the table: "signing_template_equivalents" */
  update_signing_template_equivalents_by_pk?: Maybe<Signing_Template_Equivalents>;
  /** update multiples rows of table: "signing_template_equivalents" */
  update_signing_template_equivalents_many?: Maybe<Array<Maybe<Signing_Template_Equivalents_Mutation_Response>>>;
  /** update data of the table: "signing_template_kind" */
  update_signing_template_kind?: Maybe<Signing_Template_Kind_Mutation_Response>;
  /** update single row of the table: "signing_template_kind" */
  update_signing_template_kind_by_pk?: Maybe<Signing_Template_Kind>;
  /** update multiples rows of table: "signing_template_kind" */
  update_signing_template_kind_many?: Maybe<Array<Maybe<Signing_Template_Kind_Mutation_Response>>>;
  /** update multiples rows of table: "signing_template" */
  update_signing_template_many?: Maybe<Array<Maybe<Signing_Template_Mutation_Response>>>;
  /** update data of the table: "signing_template_source_files" */
  update_signing_template_source_files?: Maybe<Signing_Template_Source_Files_Mutation_Response>;
  /** update single row of the table: "signing_template_source_files" */
  update_signing_template_source_files_by_pk?: Maybe<Signing_Template_Source_Files>;
  /** update multiples rows of table: "signing_template_source_files" */
  update_signing_template_source_files_many?: Maybe<Array<Maybe<Signing_Template_Source_Files_Mutation_Response>>>;
  /** update data of the table: "signing_vansanity_template" */
  update_signing_vansanity_template?: Maybe<Signing_Vansanity_Template_Mutation_Response>;
  /** update single row of the table: "signing_vansanity_template" */
  update_signing_vansanity_template_by_pk?: Maybe<Signing_Vansanity_Template>;
  /** update multiples rows of table: "signing_vansanity_template" */
  update_signing_vansanity_template_many?: Maybe<Array<Maybe<Signing_Vansanity_Template_Mutation_Response>>>;
  /** update data of the table: "signing_webhook_event" */
  update_signing_webhook_event?: Maybe<Signing_Webhook_Event_Mutation_Response>;
  /** update single row of the table: "signing_webhook_event" */
  update_signing_webhook_event_by_pk?: Maybe<Signing_Webhook_Event>;
  /** update multiples rows of table: "signing_webhook_event" */
  update_signing_webhook_event_many?: Maybe<Array<Maybe<Signing_Webhook_Event_Mutation_Response>>>;
  /** update data of the table: "signing_webhook_event_type" */
  update_signing_webhook_event_type?: Maybe<Signing_Webhook_Event_Type_Mutation_Response>;
  /** update single row of the table: "signing_webhook_event_type" */
  update_signing_webhook_event_type_by_pk?: Maybe<Signing_Webhook_Event_Type>;
  /** update multiples rows of table: "signing_webhook_event_type" */
  update_signing_webhook_event_type_many?: Maybe<Array<Maybe<Signing_Webhook_Event_Type_Mutation_Response>>>;
  /** update data of the table: "square_credential_ownership_enum" */
  update_square_credential_ownership_enum?: Maybe<Square_Credential_Ownership_Enum_Mutation_Response>;
  /** update single row of the table: "square_credential_ownership_enum" */
  update_square_credential_ownership_enum_by_pk?: Maybe<Square_Credential_Ownership_Enum>;
  /** update multiples rows of table: "square_credential_ownership_enum" */
  update_square_credential_ownership_enum_many?: Maybe<Array<Maybe<Square_Credential_Ownership_Enum_Mutation_Response>>>;
  /** update data of the table: "square_credentials" */
  update_square_credentials?: Maybe<Square_Credentials_Mutation_Response>;
  /** update single row of the table: "square_credentials" */
  update_square_credentials_by_pk?: Maybe<Square_Credentials>;
  /** update multiples rows of table: "square_credentials" */
  update_square_credentials_many?: Maybe<Array<Maybe<Square_Credentials_Mutation_Response>>>;
  /** update data of the table: "supervisor_provider" */
  update_supervisor_provider?: Maybe<Supervisor_Provider_Mutation_Response>;
  /** update single row of the table: "supervisor_provider" */
  update_supervisor_provider_by_pk?: Maybe<Supervisor_Provider>;
  /** update data of the table: "supervisor_provider_initiated_by" */
  update_supervisor_provider_initiated_by?: Maybe<Supervisor_Provider_Initiated_By_Mutation_Response>;
  /** update single row of the table: "supervisor_provider_initiated_by" */
  update_supervisor_provider_initiated_by_by_pk?: Maybe<Supervisor_Provider_Initiated_By>;
  /** update multiples rows of table: "supervisor_provider_initiated_by" */
  update_supervisor_provider_initiated_by_many?: Maybe<Array<Maybe<Supervisor_Provider_Initiated_By_Mutation_Response>>>;
  /** update multiples rows of table: "supervisor_provider" */
  update_supervisor_provider_many?: Maybe<Array<Maybe<Supervisor_Provider_Mutation_Response>>>;
  /** update data of the table: "supervisor_provider_term" */
  update_supervisor_provider_term?: Maybe<Supervisor_Provider_Term_Mutation_Response>;
  /** update single row of the table: "supervisor_provider_term" */
  update_supervisor_provider_term_by_pk?: Maybe<Supervisor_Provider_Term>;
  /** update data of the table: "supervisor_provider_term_ended_by" */
  update_supervisor_provider_term_ended_by?: Maybe<Supervisor_Provider_Term_Ended_By_Mutation_Response>;
  /** update single row of the table: "supervisor_provider_term_ended_by" */
  update_supervisor_provider_term_ended_by_by_pk?: Maybe<Supervisor_Provider_Term_Ended_By>;
  /** update multiples rows of table: "supervisor_provider_term_ended_by" */
  update_supervisor_provider_term_ended_by_many?: Maybe<Array<Maybe<Supervisor_Provider_Term_Ended_By_Mutation_Response>>>;
  /** update multiples rows of table: "supervisor_provider_term" */
  update_supervisor_provider_term_many?: Maybe<Array<Maybe<Supervisor_Provider_Term_Mutation_Response>>>;
  /** update data of the table: "supervisor_review_queue_item" */
  update_supervisor_review_queue_item?: Maybe<Supervisor_Review_Queue_Item_Mutation_Response>;
  /** update single row of the table: "supervisor_review_queue_item" */
  update_supervisor_review_queue_item_by_pk?: Maybe<Supervisor_Review_Queue_Item>;
  /** update multiples rows of table: "supervisor_review_queue_item" */
  update_supervisor_review_queue_item_many?: Maybe<Array<Maybe<Supervisor_Review_Queue_Item_Mutation_Response>>>;
  /** update data of the table: "supervisor_review_queue_item_status_history" */
  update_supervisor_review_queue_item_status_history?: Maybe<Supervisor_Review_Queue_Item_Status_History_Mutation_Response>;
  /** update single row of the table: "supervisor_review_queue_item_status_history" */
  update_supervisor_review_queue_item_status_history_by_pk?: Maybe<Supervisor_Review_Queue_Item_Status_History>;
  /** update multiples rows of table: "supervisor_review_queue_item_status_history" */
  update_supervisor_review_queue_item_status_history_many?: Maybe<Array<Maybe<Supervisor_Review_Queue_Item_Status_History_Mutation_Response>>>;
  /** update data of the table: "supervisor_review_queue_source" */
  update_supervisor_review_queue_source?: Maybe<Supervisor_Review_Queue_Source_Mutation_Response>;
  /** update single row of the table: "supervisor_review_queue_source" */
  update_supervisor_review_queue_source_by_pk?: Maybe<Supervisor_Review_Queue_Source>;
  /** update multiples rows of table: "supervisor_review_queue_source" */
  update_supervisor_review_queue_source_many?: Maybe<Array<Maybe<Supervisor_Review_Queue_Source_Mutation_Response>>>;
  /** update data of the table: "supervisor_review_queue_status" */
  update_supervisor_review_queue_status?: Maybe<Supervisor_Review_Queue_Status_Mutation_Response>;
  /** update single row of the table: "supervisor_review_queue_status" */
  update_supervisor_review_queue_status_by_pk?: Maybe<Supervisor_Review_Queue_Status>;
  /** update multiples rows of table: "supervisor_review_queue_status" */
  update_supervisor_review_queue_status_many?: Maybe<Array<Maybe<Supervisor_Review_Queue_Status_Mutation_Response>>>;
  /** update data of the table: "supervisor_sampling_period_type" */
  update_supervisor_sampling_period_type?: Maybe<Supervisor_Sampling_Period_Type_Mutation_Response>;
  /** update single row of the table: "supervisor_sampling_period_type" */
  update_supervisor_sampling_period_type_by_pk?: Maybe<Supervisor_Sampling_Period_Type>;
  /** update multiples rows of table: "supervisor_sampling_period_type" */
  update_supervisor_sampling_period_type_many?: Maybe<Array<Maybe<Supervisor_Sampling_Period_Type_Mutation_Response>>>;
  /** update data of the table: "supervisor_setting" */
  update_supervisor_setting?: Maybe<Supervisor_Setting_Mutation_Response>;
  /** update single row of the table: "supervisor_setting" */
  update_supervisor_setting_by_pk?: Maybe<Supervisor_Setting>;
  /** update multiples rows of table: "supervisor_setting" */
  update_supervisor_setting_many?: Maybe<Array<Maybe<Supervisor_Setting_Mutation_Response>>>;
  /** update data of the table: "tax_rate" */
  update_tax_rate?: Maybe<Tax_Rate_Mutation_Response>;
  /** update single row of the table: "tax_rate" */
  update_tax_rate_by_pk?: Maybe<Tax_Rate>;
  /** update multiples rows of table: "tax_rate" */
  update_tax_rate_many?: Maybe<Array<Maybe<Tax_Rate_Mutation_Response>>>;
  /** update data of the table: "tax_type" */
  update_tax_type?: Maybe<Tax_Type_Mutation_Response>;
  /** update single row of the table: "tax_type" */
  update_tax_type_by_pk?: Maybe<Tax_Type>;
  /** update multiples rows of table: "tax_type" */
  update_tax_type_many?: Maybe<Array<Maybe<Tax_Type_Mutation_Response>>>;
  /** update data of the table: "user" */
  update_user?: Maybe<User_Mutation_Response>;
  /** update data of the table: "user_agreements" */
  update_user_agreements?: Maybe<User_Agreements_Mutation_Response>;
  /** update single row of the table: "user_agreements" */
  update_user_agreements_by_pk?: Maybe<User_Agreements>;
  /** update multiples rows of table: "user_agreements" */
  update_user_agreements_many?: Maybe<Array<Maybe<User_Agreements_Mutation_Response>>>;
  /** update single row of the table: "user" */
  update_user_by_pk?: Maybe<User>;
  /** update data of the table: "user_consent" */
  update_user_consent?: Maybe<User_Consent_Mutation_Response>;
  /** update data of the table: "user_consent_action" */
  update_user_consent_action?: Maybe<User_Consent_Action_Mutation_Response>;
  /** update single row of the table: "user_consent_action" */
  update_user_consent_action_by_pk?: Maybe<User_Consent_Action>;
  /** update multiples rows of table: "user_consent_action" */
  update_user_consent_action_many?: Maybe<Array<Maybe<User_Consent_Action_Mutation_Response>>>;
  /** update single row of the table: "user_consent" */
  update_user_consent_by_pk?: Maybe<User_Consent>;
  /** update multiples rows of table: "user_consent" */
  update_user_consent_many?: Maybe<Array<Maybe<User_Consent_Mutation_Response>>>;
  /** update data of the table: "user_consent_type" */
  update_user_consent_type?: Maybe<User_Consent_Type_Mutation_Response>;
  /** update single row of the table: "user_consent_type" */
  update_user_consent_type_by_pk?: Maybe<User_Consent_Type>;
  /** update multiples rows of table: "user_consent_type" */
  update_user_consent_type_many?: Maybe<Array<Maybe<User_Consent_Type_Mutation_Response>>>;
  /** update data of the table: "user_device_push_notification_token" */
  update_user_device_push_notification_token?: Maybe<User_Device_Push_Notification_Token_Mutation_Response>;
  /** update single row of the table: "user_device_push_notification_token" */
  update_user_device_push_notification_token_by_pk?: Maybe<User_Device_Push_Notification_Token>;
  /** update multiples rows of table: "user_device_push_notification_token" */
  update_user_device_push_notification_token_many?: Maybe<Array<Maybe<User_Device_Push_Notification_Token_Mutation_Response>>>;
  /** update data of the table: "user_document" */
  update_user_document?: Maybe<User_Document_Mutation_Response>;
  /** update single row of the table: "user_document" */
  update_user_document_by_pk?: Maybe<User_Document>;
  /** update multiples rows of table: "user_document" */
  update_user_document_many?: Maybe<Array<Maybe<User_Document_Mutation_Response>>>;
  /** update data of the table: "user_location" */
  update_user_location?: Maybe<User_Location_Mutation_Response>;
  /** update single row of the table: "user_location" */
  update_user_location_by_pk?: Maybe<User_Location>;
  /** update multiples rows of table: "user_location" */
  update_user_location_many?: Maybe<Array<Maybe<User_Location_Mutation_Response>>>;
  /** update multiples rows of table: "user" */
  update_user_many?: Maybe<Array<Maybe<User_Mutation_Response>>>;
  /** update data of the table: "user_plan" */
  update_user_plan?: Maybe<User_Plan_Mutation_Response>;
  /** update single row of the table: "user_plan" */
  update_user_plan_by_pk?: Maybe<User_Plan>;
  /** update multiples rows of table: "user_plan" */
  update_user_plan_many?: Maybe<Array<Maybe<User_Plan_Mutation_Response>>>;
  /** update data of the table: "version" */
  update_version?: Maybe<Version_Mutation_Response>;
  /** update single row of the table: "version" */
  update_version_by_pk?: Maybe<Version>;
  /** update multiples rows of table: "version" */
  update_version_many?: Maybe<Array<Maybe<Version_Mutation_Response>>>;
  /** Upload a source file (PDF/image) and generate page previews synchronously */
  uploadSigningTemplateSourceFile: UploadSigningTemplateSourceFileOutput;
  /** Generate S3 upload and get signed URLs for a document that is ephemeral with TTL of < hour */
  uploadTmpDocument?: Maybe<UploadTmpDocumentOutput>;
};


/** mutation root */
export type Mutation_RootCreateNonMedicalWeeklyBookingArgs = {
  provider: Scalars['uuid'];
  room: Scalars['uuid'];
  start_time_iso: Scalars['timestamptz'];
};


/** mutation root */
export type Mutation_RootCreatePatientBookingRequestArgs = {
  procedure: Scalars['uuid'];
  provider?: InputMaybe<Scalars['uuid']>;
  start: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCreateSquareCustomerArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  provider: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDisconnectSquareArgs = {
  locationId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootEhrCreateChargeArgs = {
  object: EhrCreateChargeInput;
};


/** mutation root */
export type Mutation_RootEhrDeleteCardArgs = {
  object: EhrDeleteCardInput;
};


/** mutation root */
export type Mutation_RootEhrRegisterCardArgs = {
  object: EhrRegisterCardInput;
};


/** mutation root */
export type Mutation_RootEhrSaveCardArgs = {
  object: EhrSaveCardInput;
};


/** mutation root */
export type Mutation_RootEhrSetDefaultCardArgs = {
  object: EhrSetDefaultCardInput;
};


/** mutation root */
export type Mutation_RootInviteProviderArgs = {
  providerEmail: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInviteSupervisorArgs = {
  supervisorEmail: Scalars['String'];
};


/** mutation root */
export type Mutation_RootPatientCancelBookingArgs = {
  patientBooking: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootRegisterMedicalSupervisorArgs = {
  object: RegisterMedicalSupervisorInput;
};


/** mutation root */
export type Mutation_RootRegisterProviderArgs = {
  object: RegisterProviderInput;
};


/** mutation root */
export type Mutation_RootSaveSquareCustomerCardArgs = {
  object: SaveSquareCustomerCardInput;
};


/** mutation root */
export type Mutation_RootSendPatientRegistrationInviteArgs = {
  patientId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootUpdateSupervisorSettingArgs = {
  object: UpdateSupervisorSettingInput;
};


/** mutation root */
export type Mutation_RootCancelEhrSubscriptionArgs = {
  object: EhrUnitInput;
};


/** mutation root */
export type Mutation_RootCancelPatientBookingArgs = {
  object: CancelPatientBookingInput;
};


/** mutation root */
export type Mutation_RootCancelUserPlanArgs = {
  object: CancelUserPlanInput;
};


/** mutation root */
export type Mutation_RootChangeEhrTierArgs = {
  object: EhrTierInput;
};


/** mutation root */
export type Mutation_RootConfirmBookingArgs = {
  approvedTotal?: InputMaybe<Scalars['Int']>;
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootConfirmCognitoUserArgs = {
  object: ConfirmCognitoUserInput;
};


/** mutation root */
export type Mutation_RootConfirmMultipleBookingsArgs = {
  ids: Array<Scalars['uuid']>;
};


/** mutation root */
export type Mutation_RootConfirmPatientBookingArgs = {
  object: ConfirmPatientBookingInput;
};


/** mutation root */
export type Mutation_RootConfirmProductPurchaseArgs = {
  ids: Array<Scalars['uuid']>;
};


/** mutation root */
export type Mutation_RootCreateBookingArgs = {
  object: CreateBookingInput;
};


/** mutation root */
export type Mutation_RootCreateCheckoutSessionArgs = {
  object: CreateCheckoutSessionInput;
};


/** mutation root */
export type Mutation_RootCreateMsoPurchaseRequestInvoiceArgs = {
  location: Scalars['uuid'];
  partner_id: Scalars['uuid'];
  product_id: Scalars['uuid'];
  purchase_record_id: Scalars['uuid'];
  units: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootCreateNewMsoArgs = {
  object: CreateNewMsoInput;
};


/** mutation root */
export type Mutation_RootCreateOpenArgs = {
  object?: InputMaybe<CreateOpenInput>;
};


/** mutation root */
export type Mutation_RootCreatePatientBookingArgs = {
  object: CreatePatientBookingInput;
};


/** mutation root */
export type Mutation_RootCreatePlanArgs = {
  object: CreatePlanInput;
};


/** mutation root */
export type Mutation_RootCreateProviderHoursArgs = {
  object: CreateProviderHoursInput;
};


/** mutation root */
export type Mutation_RootCreateRepeatBookingArgs = {
  object: CreateRepeatBookingInput;
};


/** mutation root */
export type Mutation_RootCreateSetupIntentArgs = {
  object: CreateSetupIntentInput;
};


/** mutation root */
export type Mutation_RootCreateStripeCustomerArgs = {
  object: CreateStripeCustomerInput;
};


/** mutation root */
export type Mutation_RootCreateUserPlanArgs = {
  object: CreateUserPlanInput;
};


/** mutation root */
export type Mutation_RootDeleteCognitoUserArgs = {
  object: DeleteCognitoUserInput;
};


/** mutation root */
export type Mutation_RootDeletePaymentMethodArgs = {
  object: DeletePaymentMethodInput;
};


/** mutation root */
export type Mutation_RootDeletePlanArgs = {
  object: DeletePlanInput;
};


/** mutation root */
export type Mutation_RootDelete_AccreditationArgs = {
  where: Accreditation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Accreditation_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Accreditation_Location_PrivilegeArgs = {
  where: Accreditation_Location_Privilege_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Accreditation_Location_Privilege_By_PkArgs = {
  accreditation: Accreditation_Enum;
  location: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_AddressArgs = {
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Address_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Agreement_TypeArgs = {
  where: Agreement_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agreement_Type_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_BookingArgs = {
  where: Booking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Booking_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Booking_PublicArgs = {
  where: Booking_Public_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Booking_TypeArgs = {
  where: Booking_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Booking_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Cancel_ReasonArgs = {
  where: Cancel_Reason_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cancel_Reason_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_CreditArgs = {
  where: Credit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Credit_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Credit_TransactionArgs = {
  where: Credit_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Credit_Transaction_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Credit_TypeArgs = {
  where: Credit_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Credit_Type_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Demo_LocationArgs = {
  where: Demo_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Demo_Location_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Document_TypeArgs = {
  where: Document_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Type_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Charge_LedgerArgs = {
  where: Ehr_Charge_Ledger_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Charge_Ledger_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_EncounterArgs = {
  where: Ehr_Encounter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Encounter_AddendumArgs = {
  where: Ehr_Encounter_Addendum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Encounter_Addendum_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Encounter_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Encounter_ModalityArgs = {
  where: Ehr_Encounter_Modality_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Encounter_Modality_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Encounter_PhotoArgs = {
  where: Ehr_Encounter_Photo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Encounter_Photo_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Encounter_Scan_3dArgs = {
  where: Ehr_Encounter_Scan_3d_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Encounter_Scan_3d_ArtifactArgs = {
  where: Ehr_Encounter_Scan_3d_Artifact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Encounter_Scan_3d_Artifact_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Encounter_Scan_3d_Artifact_KindArgs = {
  where: Ehr_Encounter_Scan_3d_Artifact_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Encounter_Scan_3d_Artifact_Kind_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Encounter_Scan_3d_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Encounter_TypeArgs = {
  where: Ehr_Encounter_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Encounter_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Fda_ProductArgs = {
  where: Ehr_Fda_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Fda_Product_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Fda_Product_SourceArgs = {
  where: Ehr_Fda_Product_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Fda_Product_Source_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_MessageArgs = {
  where: Ehr_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Message_ReadArgs = {
  where: Ehr_Message_Read_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Message_Read_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Message_ThreadsArgs = {
  where: Ehr_Message_Threads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Message_Threads_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Patient_CardArgs = {
  where: Ehr_Patient_Card_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Patient_Card_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Patient_ConsentArgs = {
  where: Ehr_Patient_Consent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Patient_Consent_ActionArgs = {
  where: Ehr_Patient_Consent_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Patient_Consent_Action_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Patient_Consent_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Patient_Consent_TypeArgs = {
  where: Ehr_Patient_Consent_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Patient_Consent_Type_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_ProcedureArgs = {
  where: Ehr_Procedure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Procedure_Body_AreaArgs = {
  where: Ehr_Procedure_Body_Area_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Procedure_Body_Area_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Procedure_Body_PartArgs = {
  where: Ehr_Procedure_Body_Part_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Procedure_Body_Part_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Procedure_Body_Part_Provider_Injection_DefaultArgs = {
  where: Ehr_Procedure_Body_Part_Provider_Injection_Default_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Procedure_Body_Part_Provider_Injection_Default_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Procedure_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Procedure_Ehr_ProductArgs = {
  where: Ehr_Procedure_Ehr_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Procedure_Ehr_Product_By_PkArgs = {
  ehrProcedure: Scalars['uuid'];
  ehrProduct: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Procedure_Type_EnumArgs = {
  where: Ehr_Procedure_Type_Enum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Procedure_Type_Enum_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_ProductArgs = {
  where: Ehr_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Product_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Product_ProcedureArgs = {
  where: Ehr_Product_Procedure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Product_Procedure_By_PkArgs = {
  ehr_product: Scalars['uuid'];
  procedure: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Product_Provider_Usage_Record_PhotoArgs = {
  where: Ehr_Product_Provider_Usage_Record_Photo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Product_Provider_Usage_Record_Photo_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_SubscriptionArgs = {
  where: Ehr_Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Subscription_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Subscription_StatusArgs = {
  where: Ehr_Subscription_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Subscription_Status_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Subscription_TierArgs = {
  where: Ehr_Subscription_Tier_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Subscription_Tier_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Subscription_Tier_TermArgs = {
  where: Ehr_Subscription_Tier_Term_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Subscription_Tier_Term_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_EventArgs = {
  where: Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Event_SourceArgs = {
  where: Event_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Event_Source_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Filler_Procedure_Delivery_ToolArgs = {
  where: Filler_Procedure_Delivery_Tool_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Filler_Procedure_Delivery_Tool_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Filler_Procedure_Face_ViewArgs = {
  where: Filler_Procedure_Face_View_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Filler_Procedure_Face_View_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Filler_Procedure_InjectionArgs = {
  where: Filler_Procedure_Injection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Filler_Procedure_Injection_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Filler_Procedure_Injection_TypeArgs = {
  where: Filler_Procedure_Injection_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Filler_Procedure_Injection_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Filler_Procedure_Product_InstanceArgs = {
  where: Filler_Procedure_Product_Instance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Filler_Procedure_Product_Instance_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Filler_Procedure_Product_Instance_PhotoArgs = {
  where: Filler_Procedure_Product_Instance_Photo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Filler_Procedure_Product_Instance_Photo_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Filler_SpaceArgs = {
  where: Filler_Space_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Filler_Space_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Filler_Zone_ReleaseArgs = {
  where: Filler_Zone_Release_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Filler_Zone_Release_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Fn_Check_Proposed_Patient_Booking_For_StackingArgs = {
  where: Fn_Check_Proposed_Patient_Booking_For_Stacking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fn_Check_Proposed_Patient_Booking_For_Stacking_By_PkArgs = {
  provider_booking_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Fn_Get_Active_Notification_Preferences_For_Type_And_LocationArgs = {
  where: Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fn_Get_Active_Notification_Preferences_For_Type_And_Location_By_PkArgs = {
  location: Scalars['uuid'];
  type: Scalars['String'];
  user: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Fn_Get_Active_Subscribers_QueryArgs = {
  where: Fn_Get_Active_Subscribers_Query_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fn_Get_Active_Subscribers_Query_By_PkArgs = {
  stripeCustomerId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Fn_Get_Location_Purchases_To_Provider_Purchases_QueryArgs = {
  where: Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fn_Get_Location_Purchases_To_Provider_Purchases_Query_By_PkArgs = {
  location: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Fn_Get_Stackable_Booking_Options_DataArgs = {
  where: Fn_Get_Stackable_Booking_Options_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fn_Get_Stackable_Booking_Options_Data_By_PkArgs = {
  providerBookingId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Fn_Get_User_Booking_Options_BlockersArgs = {
  where: Fn_Get_User_Booking_Options_Blockers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fn_Get_User_Booking_Options_Blockers_By_PkArgs = {
  bound: Scalars['String'];
  timestamp: Scalars['timestamptz'];
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Fn_Get_User_Location_Procedure_Unavailable_RoomsArgs = {
  where: Fn_Get_User_Location_Procedure_Unavailable_Rooms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fn_Get_User_Location_Procedure_Unavailable_Rooms_By_PkArgs = {
  room: Scalars['uuid'];
  timespanBlockingBooking: Scalars['tstzrange'];
};


/** mutation root */
export type Mutation_RootDelete_Fn_Get_User_Products_To_Rentals_QueryArgs = {
  where: Fn_Get_User_Products_To_Rentals_Query_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fn_Get_User_Products_To_Rentals_Query_By_PkArgs = {
  user: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Fn_Users_Unfulfilled_Product_Purchases_Count_By_LocationArgs = {
  where: Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_By_PkArgs = {
  location: Scalars['uuid'];
  user: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_GenderArgs = {
  where: Gender_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gender_By_PkArgs = {
  gender: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_InvoiceArgs = {
  where: Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoice_Billing_SummaryArgs = {
  where: Invoice_Billing_Summary_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoice_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_LocationArgs = {
  where: Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Location_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Location_ProcedureArgs = {
  where: Location_Procedure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Location_Procedure_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Location_Procedure_RoomArgs = {
  where: Location_Procedure_Room_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Location_Procedure_Room_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Location_ProductArgs = {
  where: Location_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Location_Product_By_PkArgs = {
  location: Scalars['uuid'];
  product: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ModelArgs = {
  where: Model_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Model_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Model_CountArgs = {
  where: Model_Count_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Model_Count_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Model_ProductArgs = {
  where: Model_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Model_Product_By_PkArgs = {
  model: Scalars['uuid'];
  product: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Mso_ModeArgs = {
  where: Mso_Mode_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mso_Mode_By_PkArgs = {
  mode: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Mso_TierArgs = {
  where: Mso_Tier_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mso_Tier_By_PkArgs = {
  tier: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_Audit_LogArgs = {
  where: Notification_Audit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Audit_Log_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_Broadcast_TypeArgs = {
  where: Notification_Broadcast_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Broadcast_Type_By_PkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_ChannelArgs = {
  where: Notification_Channel_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Channel_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_PreferenceArgs = {
  where: Notification_Preference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Preference_By_PkArgs = {
  channel: Notification_Channel_Enum;
  location: Scalars['uuid'];
  type: Scalars['String'];
  user: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_TypeArgs = {
  where: Notification_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_Type_Default_ChannelArgs = {
  where: Notification_Type_Default_Channel_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Type_Default_Channel_By_PkArgs = {
  channel: Notification_Channel_Enum;
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_OpenArgs = {
  where: Open_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Open_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PartnerArgs = {
  where: Partner_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_BasicArgs = {
  where: Partner_Basic_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PatientArgs = {
  where: Patient_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Account_EventArgs = {
  where: Patient_Account_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Account_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Patient_Account_Event_TypeArgs = {
  where: Patient_Account_Event_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Account_Event_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Patient_Auth_ChallengeArgs = {
  where: Patient_Auth_Challenge_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Auth_Challenge_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Patient_Bookable_Ehr_ProcedureArgs = {
  where: Patient_Bookable_Ehr_Procedure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Bookable_Ehr_Procedure_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Patient_BookingArgs = {
  where: Patient_Booking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Booking_BookingArgs = {
  where: Patient_Booking_Booking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Booking_Booking_By_PkArgs = {
  booking: Scalars['uuid'];
  patient_booking: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Patient_Booking_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Patient_Booking_Cancel_ReasonArgs = {
  where: Patient_Booking_Cancel_Reason_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Booking_Cancel_Reason_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Patient_Booking_InitiatorArgs = {
  where: Patient_Booking_Initiator_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Booking_Initiator_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Patient_Booking_MetadataArgs = {
  where: Patient_Booking_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Booking_Metadata_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Patient_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Patient_Last_ViewArgs = {
  where: Patient_Last_View_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Last_View_By_PkArgs = {
  patient: Scalars['uuid'];
  user: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Patient_Medical_ProfileArgs = {
  where: Patient_Medical_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Medical_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Patient_Registration_InviteArgs = {
  where: Patient_Registration_Invite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Registration_Invite_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Patient_SessionArgs = {
  where: Patient_Session_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Session_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Patient_Webauthn_ChallengeArgs = {
  where: Patient_Webauthn_Challenge_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Webauthn_Challenge_By_PkArgs = {
  patient: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Patient_Webauthn_CredentialArgs = {
  where: Patient_Webauthn_Credential_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Webauthn_Credential_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PlanArgs = {
  where: Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plan_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Plan_TypeArgs = {
  where: Plan_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plan_Type_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Pre_Procedure_Photo_Injection_MarkingArgs = {
  where: Pre_Procedure_Photo_Injection_Marking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pre_Procedure_Photo_Injection_Marking_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ProcedureArgs = {
  where: Procedure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Procedure_Audio_RecordingArgs = {
  where: Procedure_Audio_Recording_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Procedure_Audio_Recording_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Procedure_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ProductArgs = {
  where: Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_PurchaseArgs = {
  where: Product_Purchase_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Purchase_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Product_TypeArgs = {
  where: Product_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Provider_Direct_Product_PurchaseArgs = {
  where: Provider_Direct_Product_Purchase_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Provider_Direct_Product_Purchase_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Provider_HoursArgs = {
  where: Provider_Hours_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Provider_Hours_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Provider_Hours_Repeat_IntervalArgs = {
  where: Provider_Hours_Repeat_Interval_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Provider_Hours_Repeat_Interval_By_PkArgs = {
  interval: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Provider_Hours_RepeaterArgs = {
  where: Provider_Hours_Repeater_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Provider_Hours_Repeater_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Provider_Patient_Booking_SettingsArgs = {
  where: Provider_Patient_Booking_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Provider_Patient_Booking_Settings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Provider_ProcedureArgs = {
  where: Provider_Procedure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Provider_Procedure_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Purchase_For_LocationArgs = {
  where: Purchase_For_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Purchase_For_Location_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Rental_Volume_DiscountArgs = {
  where: Rental_Volume_Discount_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rental_Volume_Discount_By_PkArgs = {
  hours: Scalars['Int'];
  location: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_RepeatingArgs = {
  where: Repeating_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Repeating_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Report_PreferenceArgs = {
  where: Report_Preference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Report_Preference_By_PkArgs = {
  location: Scalars['uuid'];
  owningUser: Scalars['uuid'];
  type: Report_Type_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Report_TypeArgs = {
  where: Report_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Report_Type_By_PkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_RoleArgs = {
  where: Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Role_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Role_NotificationArgs = {
  where: Role_Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Role_Notification_By_PkArgs = {
  broadcastType: Notification_Broadcast_Type_Enum;
  notification_type: Scalars['String'];
  role: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_RoomArgs = {
  where: Room_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Room_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Room_ModelArgs = {
  where: Room_Model_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Room_Model_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Room_TypeArgs = {
  where: Room_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Room_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SexArgs = {
  where: Sex_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sex_By_PkArgs = {
  sex: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Signing_DocumentArgs = {
  where: Signing_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Signing_Document_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Signing_Document_Status_TypeArgs = {
  where: Signing_Document_Status_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Signing_Document_Status_Type_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Signing_Procedure_Associated_DocumentsArgs = {
  where: Signing_Procedure_Associated_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Signing_Procedure_Associated_Documents_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Signing_TemplateArgs = {
  where: Signing_Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Signing_Template_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Signing_Template_EquivalentsArgs = {
  where: Signing_Template_Equivalents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Signing_Template_Equivalents_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Signing_Template_KindArgs = {
  where: Signing_Template_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Signing_Template_Kind_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Signing_Template_Source_FilesArgs = {
  where: Signing_Template_Source_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Signing_Template_Source_Files_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Signing_Vansanity_TemplateArgs = {
  where: Signing_Vansanity_Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Signing_Vansanity_Template_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Signing_Webhook_EventArgs = {
  where: Signing_Webhook_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Signing_Webhook_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Signing_Webhook_Event_TypeArgs = {
  where: Signing_Webhook_Event_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Signing_Webhook_Event_Type_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Square_Credential_Ownership_EnumArgs = {
  where: Square_Credential_Ownership_Enum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Square_Credential_Ownership_Enum_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Square_CredentialsArgs = {
  where: Square_Credentials_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Square_Credentials_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_ProviderArgs = {
  where: Supervisor_Provider_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_Provider_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_Provider_Initiated_ByArgs = {
  where: Supervisor_Provider_Initiated_By_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_Provider_Initiated_By_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_Provider_TermArgs = {
  where: Supervisor_Provider_Term_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_Provider_Term_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_Provider_Term_Ended_ByArgs = {
  where: Supervisor_Provider_Term_Ended_By_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_Provider_Term_Ended_By_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_Review_Queue_ItemArgs = {
  where: Supervisor_Review_Queue_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_Review_Queue_Item_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_Review_Queue_Item_Status_HistoryArgs = {
  where: Supervisor_Review_Queue_Item_Status_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_Review_Queue_Item_Status_History_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_Review_Queue_SourceArgs = {
  where: Supervisor_Review_Queue_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_Review_Queue_Source_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_Review_Queue_StatusArgs = {
  where: Supervisor_Review_Queue_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_Review_Queue_Status_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_Sampling_Period_TypeArgs = {
  where: Supervisor_Sampling_Period_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_Sampling_Period_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_SettingArgs = {
  where: Supervisor_Setting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Supervisor_Setting_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Tax_RateArgs = {
  where: Tax_Rate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tax_Rate_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Tax_TypeArgs = {
  where: Tax_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tax_Type_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_UserArgs = {
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_AgreementsArgs = {
  where: User_Agreements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Agreements_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_ConsentArgs = {
  where: User_Consent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Consent_ActionArgs = {
  where: User_Consent_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Consent_Action_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_Consent_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_Consent_TypeArgs = {
  where: User_Consent_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Consent_Type_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_Device_Push_Notification_TokenArgs = {
  where: User_Device_Push_Notification_Token_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Device_Push_Notification_Token_By_PkArgs = {
  token: Scalars['String'];
  user: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_DocumentArgs = {
  where: User_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Document_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_LocationArgs = {
  where: User_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Location_By_PkArgs = {
  location: Scalars['uuid'];
  user: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_PlanArgs = {
  where: User_Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Plan_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_VersionArgs = {
  where: Version_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Version_By_PkArgs = {
  providerAppAndroid: Scalars['numeric'];
  providerAppIos: Scalars['String'];
};


/** mutation root */
export type Mutation_RootEditBookingArgs = {
  object: EditBookingInput;
};


/** mutation root */
export type Mutation_RootEditOpenArgs = {
  object: EditOpenInput;
};


/** mutation root */
export type Mutation_RootEnableEhrSubscriptionArgs = {
  object: EhrTierInput;
};


/** mutation root */
export type Mutation_RootInsert_AccreditationArgs = {
  objects: Array<Accreditation_Insert_Input>;
  on_conflict?: InputMaybe<Accreditation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accreditation_Location_PrivilegeArgs = {
  objects: Array<Accreditation_Location_Privilege_Insert_Input>;
  on_conflict?: InputMaybe<Accreditation_Location_Privilege_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accreditation_Location_Privilege_OneArgs = {
  object: Accreditation_Location_Privilege_Insert_Input;
  on_conflict?: InputMaybe<Accreditation_Location_Privilege_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accreditation_OneArgs = {
  object: Accreditation_Insert_Input;
  on_conflict?: InputMaybe<Accreditation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AddressArgs = {
  objects: Array<Address_Insert_Input>;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_OneArgs = {
  object: Address_Insert_Input;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_TypeArgs = {
  objects: Array<Agreement_Type_Insert_Input>;
  on_conflict?: InputMaybe<Agreement_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_Type_OneArgs = {
  object: Agreement_Type_Insert_Input;
  on_conflict?: InputMaybe<Agreement_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BookingArgs = {
  objects: Array<Booking_Insert_Input>;
  on_conflict?: InputMaybe<Booking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Booking_OneArgs = {
  object: Booking_Insert_Input;
  on_conflict?: InputMaybe<Booking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Booking_PublicArgs = {
  objects: Array<Booking_Public_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Booking_Public_OneArgs = {
  object: Booking_Public_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Booking_TypeArgs = {
  objects: Array<Booking_Type_Insert_Input>;
  on_conflict?: InputMaybe<Booking_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Booking_Type_OneArgs = {
  object: Booking_Type_Insert_Input;
  on_conflict?: InputMaybe<Booking_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cancel_ReasonArgs = {
  objects: Array<Cancel_Reason_Insert_Input>;
  on_conflict?: InputMaybe<Cancel_Reason_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cancel_Reason_OneArgs = {
  object: Cancel_Reason_Insert_Input;
  on_conflict?: InputMaybe<Cancel_Reason_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CreditArgs = {
  objects: Array<Credit_Insert_Input>;
  on_conflict?: InputMaybe<Credit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_OneArgs = {
  object: Credit_Insert_Input;
  on_conflict?: InputMaybe<Credit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_TransactionArgs = {
  objects: Array<Credit_Transaction_Insert_Input>;
  on_conflict?: InputMaybe<Credit_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_Transaction_OneArgs = {
  object: Credit_Transaction_Insert_Input;
  on_conflict?: InputMaybe<Credit_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_TypeArgs = {
  objects: Array<Credit_Type_Insert_Input>;
  on_conflict?: InputMaybe<Credit_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_Type_OneArgs = {
  object: Credit_Type_Insert_Input;
  on_conflict?: InputMaybe<Credit_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Demo_LocationArgs = {
  objects: Array<Demo_Location_Insert_Input>;
  on_conflict?: InputMaybe<Demo_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Demo_Location_OneArgs = {
  object: Demo_Location_Insert_Input;
  on_conflict?: InputMaybe<Demo_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_TypeArgs = {
  objects: Array<Document_Type_Insert_Input>;
  on_conflict?: InputMaybe<Document_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Type_OneArgs = {
  object: Document_Type_Insert_Input;
  on_conflict?: InputMaybe<Document_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Charge_LedgerArgs = {
  objects: Array<Ehr_Charge_Ledger_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Charge_Ledger_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Charge_Ledger_OneArgs = {
  object: Ehr_Charge_Ledger_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Charge_Ledger_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_EncounterArgs = {
  objects: Array<Ehr_Encounter_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Encounter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Encounter_AddendumArgs = {
  objects: Array<Ehr_Encounter_Addendum_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Encounter_Addendum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Encounter_Addendum_OneArgs = {
  object: Ehr_Encounter_Addendum_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Encounter_Addendum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Encounter_ModalityArgs = {
  objects: Array<Ehr_Encounter_Modality_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Encounter_Modality_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Encounter_Modality_OneArgs = {
  object: Ehr_Encounter_Modality_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Encounter_Modality_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Encounter_OneArgs = {
  object: Ehr_Encounter_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Encounter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Encounter_PhotoArgs = {
  objects: Array<Ehr_Encounter_Photo_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Encounter_Photo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Encounter_Photo_OneArgs = {
  object: Ehr_Encounter_Photo_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Encounter_Photo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Encounter_Scan_3dArgs = {
  objects: Array<Ehr_Encounter_Scan_3d_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Encounter_Scan_3d_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Encounter_Scan_3d_ArtifactArgs = {
  objects: Array<Ehr_Encounter_Scan_3d_Artifact_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Encounter_Scan_3d_Artifact_KindArgs = {
  objects: Array<Ehr_Encounter_Scan_3d_Artifact_Kind_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Encounter_Scan_3d_Artifact_Kind_OneArgs = {
  object: Ehr_Encounter_Scan_3d_Artifact_Kind_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Encounter_Scan_3d_Artifact_OneArgs = {
  object: Ehr_Encounter_Scan_3d_Artifact_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Encounter_Scan_3d_OneArgs = {
  object: Ehr_Encounter_Scan_3d_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Encounter_Scan_3d_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Encounter_TypeArgs = {
  objects: Array<Ehr_Encounter_Type_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Encounter_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Encounter_Type_OneArgs = {
  object: Ehr_Encounter_Type_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Encounter_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Fda_ProductArgs = {
  objects: Array<Ehr_Fda_Product_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Fda_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Fda_Product_OneArgs = {
  object: Ehr_Fda_Product_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Fda_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Fda_Product_SourceArgs = {
  objects: Array<Ehr_Fda_Product_Source_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Fda_Product_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Fda_Product_Source_OneArgs = {
  object: Ehr_Fda_Product_Source_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Fda_Product_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_MessageArgs = {
  objects: Array<Ehr_Message_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Message_OneArgs = {
  object: Ehr_Message_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Message_ReadArgs = {
  objects: Array<Ehr_Message_Read_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Message_Read_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Message_Read_OneArgs = {
  object: Ehr_Message_Read_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Message_Read_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Message_ThreadsArgs = {
  objects: Array<Ehr_Message_Threads_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Message_Threads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Message_Threads_OneArgs = {
  object: Ehr_Message_Threads_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Message_Threads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Patient_CardArgs = {
  objects: Array<Ehr_Patient_Card_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Patient_Card_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Patient_Card_OneArgs = {
  object: Ehr_Patient_Card_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Patient_Card_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Patient_ConsentArgs = {
  objects: Array<Ehr_Patient_Consent_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Patient_Consent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Patient_Consent_ActionArgs = {
  objects: Array<Ehr_Patient_Consent_Action_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Patient_Consent_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Patient_Consent_Action_OneArgs = {
  object: Ehr_Patient_Consent_Action_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Patient_Consent_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Patient_Consent_OneArgs = {
  object: Ehr_Patient_Consent_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Patient_Consent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Patient_Consent_TypeArgs = {
  objects: Array<Ehr_Patient_Consent_Type_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Patient_Consent_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Patient_Consent_Type_OneArgs = {
  object: Ehr_Patient_Consent_Type_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Patient_Consent_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_ProcedureArgs = {
  objects: Array<Ehr_Procedure_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Procedure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Procedure_Body_AreaArgs = {
  objects: Array<Ehr_Procedure_Body_Area_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Procedure_Body_Area_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Procedure_Body_Area_OneArgs = {
  object: Ehr_Procedure_Body_Area_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Procedure_Body_Area_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Procedure_Body_PartArgs = {
  objects: Array<Ehr_Procedure_Body_Part_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Procedure_Body_Part_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Procedure_Body_Part_OneArgs = {
  object: Ehr_Procedure_Body_Part_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Procedure_Body_Part_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Procedure_Body_Part_Provider_Injection_DefaultArgs = {
  objects: Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Procedure_Body_Part_Provider_Injection_Default_OneArgs = {
  object: Ehr_Procedure_Body_Part_Provider_Injection_Default_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Procedure_Ehr_ProductArgs = {
  objects: Array<Ehr_Procedure_Ehr_Product_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Procedure_Ehr_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Procedure_Ehr_Product_OneArgs = {
  object: Ehr_Procedure_Ehr_Product_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Procedure_Ehr_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Procedure_OneArgs = {
  object: Ehr_Procedure_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Procedure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Procedure_Type_EnumArgs = {
  objects: Array<Ehr_Procedure_Type_Enum_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Procedure_Type_Enum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Procedure_Type_Enum_OneArgs = {
  object: Ehr_Procedure_Type_Enum_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Procedure_Type_Enum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_ProductArgs = {
  objects: Array<Ehr_Product_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Product_OneArgs = {
  object: Ehr_Product_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Product_ProcedureArgs = {
  objects: Array<Ehr_Product_Procedure_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Product_Procedure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Product_Procedure_OneArgs = {
  object: Ehr_Product_Procedure_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Product_Procedure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Product_Provider_Usage_Record_PhotoArgs = {
  objects: Array<Ehr_Product_Provider_Usage_Record_Photo_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Product_Provider_Usage_Record_Photo_OneArgs = {
  object: Ehr_Product_Provider_Usage_Record_Photo_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_SubscriptionArgs = {
  objects: Array<Ehr_Subscription_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Subscription_OneArgs = {
  object: Ehr_Subscription_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Subscription_StatusArgs = {
  objects: Array<Ehr_Subscription_Status_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Subscription_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Subscription_Status_OneArgs = {
  object: Ehr_Subscription_Status_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Subscription_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Subscription_TierArgs = {
  objects: Array<Ehr_Subscription_Tier_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Subscription_Tier_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Subscription_Tier_OneArgs = {
  object: Ehr_Subscription_Tier_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Subscription_Tier_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Subscription_Tier_TermArgs = {
  objects: Array<Ehr_Subscription_Tier_Term_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Subscription_Tier_Term_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Subscription_Tier_Term_OneArgs = {
  object: Ehr_Subscription_Tier_Term_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Subscription_Tier_Term_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventArgs = {
  objects: Array<Event_Insert_Input>;
  on_conflict?: InputMaybe<Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_OneArgs = {
  object: Event_Insert_Input;
  on_conflict?: InputMaybe<Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_SourceArgs = {
  objects: Array<Event_Source_Insert_Input>;
  on_conflict?: InputMaybe<Event_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_Source_OneArgs = {
  object: Event_Source_Insert_Input;
  on_conflict?: InputMaybe<Event_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Filler_Procedure_Delivery_ToolArgs = {
  objects: Array<Filler_Procedure_Delivery_Tool_Insert_Input>;
  on_conflict?: InputMaybe<Filler_Procedure_Delivery_Tool_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Filler_Procedure_Delivery_Tool_OneArgs = {
  object: Filler_Procedure_Delivery_Tool_Insert_Input;
  on_conflict?: InputMaybe<Filler_Procedure_Delivery_Tool_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Filler_Procedure_Face_ViewArgs = {
  objects: Array<Filler_Procedure_Face_View_Insert_Input>;
  on_conflict?: InputMaybe<Filler_Procedure_Face_View_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Filler_Procedure_Face_View_OneArgs = {
  object: Filler_Procedure_Face_View_Insert_Input;
  on_conflict?: InputMaybe<Filler_Procedure_Face_View_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Filler_Procedure_InjectionArgs = {
  objects: Array<Filler_Procedure_Injection_Insert_Input>;
  on_conflict?: InputMaybe<Filler_Procedure_Injection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Filler_Procedure_Injection_OneArgs = {
  object: Filler_Procedure_Injection_Insert_Input;
  on_conflict?: InputMaybe<Filler_Procedure_Injection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Filler_Procedure_Injection_TypeArgs = {
  objects: Array<Filler_Procedure_Injection_Type_Insert_Input>;
  on_conflict?: InputMaybe<Filler_Procedure_Injection_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Filler_Procedure_Injection_Type_OneArgs = {
  object: Filler_Procedure_Injection_Type_Insert_Input;
  on_conflict?: InputMaybe<Filler_Procedure_Injection_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Filler_Procedure_Product_InstanceArgs = {
  objects: Array<Filler_Procedure_Product_Instance_Insert_Input>;
  on_conflict?: InputMaybe<Filler_Procedure_Product_Instance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Filler_Procedure_Product_Instance_OneArgs = {
  object: Filler_Procedure_Product_Instance_Insert_Input;
  on_conflict?: InputMaybe<Filler_Procedure_Product_Instance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Filler_Procedure_Product_Instance_PhotoArgs = {
  objects: Array<Filler_Procedure_Product_Instance_Photo_Insert_Input>;
  on_conflict?: InputMaybe<Filler_Procedure_Product_Instance_Photo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Filler_Procedure_Product_Instance_Photo_OneArgs = {
  object: Filler_Procedure_Product_Instance_Photo_Insert_Input;
  on_conflict?: InputMaybe<Filler_Procedure_Product_Instance_Photo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Filler_SpaceArgs = {
  objects: Array<Filler_Space_Insert_Input>;
  on_conflict?: InputMaybe<Filler_Space_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Filler_Space_OneArgs = {
  object: Filler_Space_Insert_Input;
  on_conflict?: InputMaybe<Filler_Space_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Filler_Zone_ReleaseArgs = {
  objects: Array<Filler_Zone_Release_Insert_Input>;
  on_conflict?: InputMaybe<Filler_Zone_Release_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Filler_Zone_Release_OneArgs = {
  object: Filler_Zone_Release_Insert_Input;
  on_conflict?: InputMaybe<Filler_Zone_Release_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fn_Check_Proposed_Patient_Booking_For_StackingArgs = {
  objects: Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Insert_Input>;
  on_conflict?: InputMaybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fn_Check_Proposed_Patient_Booking_For_Stacking_OneArgs = {
  object: Fn_Check_Proposed_Patient_Booking_For_Stacking_Insert_Input;
  on_conflict?: InputMaybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fn_Get_Active_Notification_Preferences_For_Type_And_LocationArgs = {
  objects: Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Insert_Input>;
  on_conflict?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fn_Get_Active_Notification_Preferences_For_Type_And_Location_OneArgs = {
  object: Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Insert_Input;
  on_conflict?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fn_Get_Active_Subscribers_QueryArgs = {
  objects: Array<Fn_Get_Active_Subscribers_Query_Insert_Input>;
  on_conflict?: InputMaybe<Fn_Get_Active_Subscribers_Query_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fn_Get_Active_Subscribers_Query_OneArgs = {
  object: Fn_Get_Active_Subscribers_Query_Insert_Input;
  on_conflict?: InputMaybe<Fn_Get_Active_Subscribers_Query_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fn_Get_Location_Purchases_To_Provider_Purchases_QueryArgs = {
  objects: Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Insert_Input>;
  on_conflict?: InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fn_Get_Location_Purchases_To_Provider_Purchases_Query_OneArgs = {
  object: Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Insert_Input;
  on_conflict?: InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fn_Get_Stackable_Booking_Options_DataArgs = {
  objects: Array<Fn_Get_Stackable_Booking_Options_Data_Insert_Input>;
  on_conflict?: InputMaybe<Fn_Get_Stackable_Booking_Options_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fn_Get_Stackable_Booking_Options_Data_OneArgs = {
  object: Fn_Get_Stackable_Booking_Options_Data_Insert_Input;
  on_conflict?: InputMaybe<Fn_Get_Stackable_Booking_Options_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fn_Get_User_Booking_Options_BlockersArgs = {
  objects: Array<Fn_Get_User_Booking_Options_Blockers_Insert_Input>;
  on_conflict?: InputMaybe<Fn_Get_User_Booking_Options_Blockers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fn_Get_User_Booking_Options_Blockers_OneArgs = {
  object: Fn_Get_User_Booking_Options_Blockers_Insert_Input;
  on_conflict?: InputMaybe<Fn_Get_User_Booking_Options_Blockers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fn_Get_User_Location_Procedure_Unavailable_RoomsArgs = {
  objects: Array<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Insert_Input>;
  on_conflict?: InputMaybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fn_Get_User_Location_Procedure_Unavailable_Rooms_OneArgs = {
  object: Fn_Get_User_Location_Procedure_Unavailable_Rooms_Insert_Input;
  on_conflict?: InputMaybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fn_Get_User_Products_To_Rentals_QueryArgs = {
  objects: Array<Fn_Get_User_Products_To_Rentals_Query_Insert_Input>;
  on_conflict?: InputMaybe<Fn_Get_User_Products_To_Rentals_Query_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fn_Get_User_Products_To_Rentals_Query_OneArgs = {
  object: Fn_Get_User_Products_To_Rentals_Query_Insert_Input;
  on_conflict?: InputMaybe<Fn_Get_User_Products_To_Rentals_Query_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fn_Users_Unfulfilled_Product_Purchases_Count_By_LocationArgs = {
  objects: Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Insert_Input>;
  on_conflict?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_OneArgs = {
  object: Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Insert_Input;
  on_conflict?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GenderArgs = {
  objects: Array<Gender_Insert_Input>;
  on_conflict?: InputMaybe<Gender_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gender_OneArgs = {
  object: Gender_Insert_Input;
  on_conflict?: InputMaybe<Gender_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InvoiceArgs = {
  objects: Array<Invoice_Insert_Input>;
  on_conflict?: InputMaybe<Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoice_Billing_SummaryArgs = {
  objects: Array<Invoice_Billing_Summary_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Invoice_Billing_Summary_OneArgs = {
  object: Invoice_Billing_Summary_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Invoice_OneArgs = {
  object: Invoice_Insert_Input;
  on_conflict?: InputMaybe<Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LocationArgs = {
  objects: Array<Location_Insert_Input>;
  on_conflict?: InputMaybe<Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Location_OneArgs = {
  object: Location_Insert_Input;
  on_conflict?: InputMaybe<Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Location_ProcedureArgs = {
  objects: Array<Location_Procedure_Insert_Input>;
  on_conflict?: InputMaybe<Location_Procedure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Location_Procedure_OneArgs = {
  object: Location_Procedure_Insert_Input;
  on_conflict?: InputMaybe<Location_Procedure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Location_Procedure_RoomArgs = {
  objects: Array<Location_Procedure_Room_Insert_Input>;
  on_conflict?: InputMaybe<Location_Procedure_Room_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Location_Procedure_Room_OneArgs = {
  object: Location_Procedure_Room_Insert_Input;
  on_conflict?: InputMaybe<Location_Procedure_Room_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Location_ProductArgs = {
  objects: Array<Location_Product_Insert_Input>;
  on_conflict?: InputMaybe<Location_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Location_Product_OneArgs = {
  object: Location_Product_Insert_Input;
  on_conflict?: InputMaybe<Location_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ModelArgs = {
  objects: Array<Model_Insert_Input>;
  on_conflict?: InputMaybe<Model_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_CountArgs = {
  objects: Array<Model_Count_Insert_Input>;
  on_conflict?: InputMaybe<Model_Count_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_Count_OneArgs = {
  object: Model_Count_Insert_Input;
  on_conflict?: InputMaybe<Model_Count_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_OneArgs = {
  object: Model_Insert_Input;
  on_conflict?: InputMaybe<Model_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_ProductArgs = {
  objects: Array<Model_Product_Insert_Input>;
  on_conflict?: InputMaybe<Model_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_Product_OneArgs = {
  object: Model_Product_Insert_Input;
  on_conflict?: InputMaybe<Model_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mso_ModeArgs = {
  objects: Array<Mso_Mode_Insert_Input>;
  on_conflict?: InputMaybe<Mso_Mode_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mso_Mode_OneArgs = {
  object: Mso_Mode_Insert_Input;
  on_conflict?: InputMaybe<Mso_Mode_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mso_TierArgs = {
  objects: Array<Mso_Tier_Insert_Input>;
  on_conflict?: InputMaybe<Mso_Tier_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mso_Tier_OneArgs = {
  object: Mso_Tier_Insert_Input;
  on_conflict?: InputMaybe<Mso_Tier_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Audit_LogArgs = {
  objects: Array<Notification_Audit_Log_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Audit_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Audit_Log_OneArgs = {
  object: Notification_Audit_Log_Insert_Input;
  on_conflict?: InputMaybe<Notification_Audit_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Broadcast_TypeArgs = {
  objects: Array<Notification_Broadcast_Type_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Broadcast_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Broadcast_Type_OneArgs = {
  object: Notification_Broadcast_Type_Insert_Input;
  on_conflict?: InputMaybe<Notification_Broadcast_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_ChannelArgs = {
  objects: Array<Notification_Channel_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Channel_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Channel_OneArgs = {
  object: Notification_Channel_Insert_Input;
  on_conflict?: InputMaybe<Notification_Channel_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_PreferenceArgs = {
  objects: Array<Notification_Preference_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Preference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Preference_OneArgs = {
  object: Notification_Preference_Insert_Input;
  on_conflict?: InputMaybe<Notification_Preference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_TypeArgs = {
  objects: Array<Notification_Type_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Type_Default_ChannelArgs = {
  objects: Array<Notification_Type_Default_Channel_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Type_Default_Channel_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Type_Default_Channel_OneArgs = {
  object: Notification_Type_Default_Channel_Insert_Input;
  on_conflict?: InputMaybe<Notification_Type_Default_Channel_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Type_OneArgs = {
  object: Notification_Type_Insert_Input;
  on_conflict?: InputMaybe<Notification_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OpenArgs = {
  objects: Array<Open_Insert_Input>;
  on_conflict?: InputMaybe<Open_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Open_OneArgs = {
  object: Open_Insert_Input;
  on_conflict?: InputMaybe<Open_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PartnerArgs = {
  objects: Array<Partner_Insert_Input>;
  on_conflict?: InputMaybe<Partner_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_BasicArgs = {
  objects: Array<Partner_Basic_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Partner_Basic_OneArgs = {
  object: Partner_Basic_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Partner_OneArgs = {
  object: Partner_Insert_Input;
  on_conflict?: InputMaybe<Partner_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PatientArgs = {
  objects: Array<Patient_Insert_Input>;
  on_conflict?: InputMaybe<Patient_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Account_EventArgs = {
  objects: Array<Patient_Account_Event_Insert_Input>;
  on_conflict?: InputMaybe<Patient_Account_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Account_Event_OneArgs = {
  object: Patient_Account_Event_Insert_Input;
  on_conflict?: InputMaybe<Patient_Account_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Account_Event_TypeArgs = {
  objects: Array<Patient_Account_Event_Type_Insert_Input>;
  on_conflict?: InputMaybe<Patient_Account_Event_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Account_Event_Type_OneArgs = {
  object: Patient_Account_Event_Type_Insert_Input;
  on_conflict?: InputMaybe<Patient_Account_Event_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Auth_ChallengeArgs = {
  objects: Array<Patient_Auth_Challenge_Insert_Input>;
  on_conflict?: InputMaybe<Patient_Auth_Challenge_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Auth_Challenge_OneArgs = {
  object: Patient_Auth_Challenge_Insert_Input;
  on_conflict?: InputMaybe<Patient_Auth_Challenge_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Bookable_Ehr_ProcedureArgs = {
  objects: Array<Patient_Bookable_Ehr_Procedure_Insert_Input>;
  on_conflict?: InputMaybe<Patient_Bookable_Ehr_Procedure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Bookable_Ehr_Procedure_OneArgs = {
  object: Patient_Bookable_Ehr_Procedure_Insert_Input;
  on_conflict?: InputMaybe<Patient_Bookable_Ehr_Procedure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_BookingArgs = {
  objects: Array<Patient_Booking_Insert_Input>;
  on_conflict?: InputMaybe<Patient_Booking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Booking_BookingArgs = {
  objects: Array<Patient_Booking_Booking_Insert_Input>;
  on_conflict?: InputMaybe<Patient_Booking_Booking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Booking_Booking_OneArgs = {
  object: Patient_Booking_Booking_Insert_Input;
  on_conflict?: InputMaybe<Patient_Booking_Booking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Booking_Cancel_ReasonArgs = {
  objects: Array<Patient_Booking_Cancel_Reason_Insert_Input>;
  on_conflict?: InputMaybe<Patient_Booking_Cancel_Reason_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Booking_Cancel_Reason_OneArgs = {
  object: Patient_Booking_Cancel_Reason_Insert_Input;
  on_conflict?: InputMaybe<Patient_Booking_Cancel_Reason_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Booking_InitiatorArgs = {
  objects: Array<Patient_Booking_Initiator_Insert_Input>;
  on_conflict?: InputMaybe<Patient_Booking_Initiator_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Booking_Initiator_OneArgs = {
  object: Patient_Booking_Initiator_Insert_Input;
  on_conflict?: InputMaybe<Patient_Booking_Initiator_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Booking_MetadataArgs = {
  objects: Array<Patient_Booking_Metadata_Insert_Input>;
  on_conflict?: InputMaybe<Patient_Booking_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Booking_Metadata_OneArgs = {
  object: Patient_Booking_Metadata_Insert_Input;
  on_conflict?: InputMaybe<Patient_Booking_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Booking_OneArgs = {
  object: Patient_Booking_Insert_Input;
  on_conflict?: InputMaybe<Patient_Booking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Last_ViewArgs = {
  objects: Array<Patient_Last_View_Insert_Input>;
  on_conflict?: InputMaybe<Patient_Last_View_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Last_View_OneArgs = {
  object: Patient_Last_View_Insert_Input;
  on_conflict?: InputMaybe<Patient_Last_View_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Medical_ProfileArgs = {
  objects: Array<Patient_Medical_Profile_Insert_Input>;
  on_conflict?: InputMaybe<Patient_Medical_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Medical_Profile_OneArgs = {
  object: Patient_Medical_Profile_Insert_Input;
  on_conflict?: InputMaybe<Patient_Medical_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_OneArgs = {
  object: Patient_Insert_Input;
  on_conflict?: InputMaybe<Patient_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Registration_InviteArgs = {
  objects: Array<Patient_Registration_Invite_Insert_Input>;
  on_conflict?: InputMaybe<Patient_Registration_Invite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Registration_Invite_OneArgs = {
  object: Patient_Registration_Invite_Insert_Input;
  on_conflict?: InputMaybe<Patient_Registration_Invite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_SessionArgs = {
  objects: Array<Patient_Session_Insert_Input>;
  on_conflict?: InputMaybe<Patient_Session_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Session_OneArgs = {
  object: Patient_Session_Insert_Input;
  on_conflict?: InputMaybe<Patient_Session_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Webauthn_ChallengeArgs = {
  objects: Array<Patient_Webauthn_Challenge_Insert_Input>;
  on_conflict?: InputMaybe<Patient_Webauthn_Challenge_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Webauthn_Challenge_OneArgs = {
  object: Patient_Webauthn_Challenge_Insert_Input;
  on_conflict?: InputMaybe<Patient_Webauthn_Challenge_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Webauthn_CredentialArgs = {
  objects: Array<Patient_Webauthn_Credential_Insert_Input>;
  on_conflict?: InputMaybe<Patient_Webauthn_Credential_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Webauthn_Credential_OneArgs = {
  object: Patient_Webauthn_Credential_Insert_Input;
  on_conflict?: InputMaybe<Patient_Webauthn_Credential_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlanArgs = {
  objects: Array<Plan_Insert_Input>;
  on_conflict?: InputMaybe<Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plan_OneArgs = {
  object: Plan_Insert_Input;
  on_conflict?: InputMaybe<Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plan_TypeArgs = {
  objects: Array<Plan_Type_Insert_Input>;
  on_conflict?: InputMaybe<Plan_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plan_Type_OneArgs = {
  object: Plan_Type_Insert_Input;
  on_conflict?: InputMaybe<Plan_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pre_Procedure_Photo_Injection_MarkingArgs = {
  objects: Array<Pre_Procedure_Photo_Injection_Marking_Insert_Input>;
  on_conflict?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pre_Procedure_Photo_Injection_Marking_OneArgs = {
  object: Pre_Procedure_Photo_Injection_Marking_Insert_Input;
  on_conflict?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProcedureArgs = {
  objects: Array<Procedure_Insert_Input>;
  on_conflict?: InputMaybe<Procedure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Procedure_Audio_RecordingArgs = {
  objects: Array<Procedure_Audio_Recording_Insert_Input>;
  on_conflict?: InputMaybe<Procedure_Audio_Recording_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Procedure_Audio_Recording_OneArgs = {
  object: Procedure_Audio_Recording_Insert_Input;
  on_conflict?: InputMaybe<Procedure_Audio_Recording_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Procedure_OneArgs = {
  object: Procedure_Insert_Input;
  on_conflict?: InputMaybe<Procedure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProductArgs = {
  objects: Array<Product_Insert_Input>;
  on_conflict?: InputMaybe<Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_OneArgs = {
  object: Product_Insert_Input;
  on_conflict?: InputMaybe<Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_PurchaseArgs = {
  objects: Array<Product_Purchase_Insert_Input>;
  on_conflict?: InputMaybe<Product_Purchase_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Purchase_OneArgs = {
  object: Product_Purchase_Insert_Input;
  on_conflict?: InputMaybe<Product_Purchase_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_TypeArgs = {
  objects: Array<Product_Type_Insert_Input>;
  on_conflict?: InputMaybe<Product_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Type_OneArgs = {
  object: Product_Type_Insert_Input;
  on_conflict?: InputMaybe<Product_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_Direct_Product_PurchaseArgs = {
  objects: Array<Provider_Direct_Product_Purchase_Insert_Input>;
  on_conflict?: InputMaybe<Provider_Direct_Product_Purchase_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_Direct_Product_Purchase_OneArgs = {
  object: Provider_Direct_Product_Purchase_Insert_Input;
  on_conflict?: InputMaybe<Provider_Direct_Product_Purchase_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_HoursArgs = {
  objects: Array<Provider_Hours_Insert_Input>;
  on_conflict?: InputMaybe<Provider_Hours_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_Hours_OneArgs = {
  object: Provider_Hours_Insert_Input;
  on_conflict?: InputMaybe<Provider_Hours_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_Hours_Repeat_IntervalArgs = {
  objects: Array<Provider_Hours_Repeat_Interval_Insert_Input>;
  on_conflict?: InputMaybe<Provider_Hours_Repeat_Interval_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_Hours_Repeat_Interval_OneArgs = {
  object: Provider_Hours_Repeat_Interval_Insert_Input;
  on_conflict?: InputMaybe<Provider_Hours_Repeat_Interval_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_Hours_RepeaterArgs = {
  objects: Array<Provider_Hours_Repeater_Insert_Input>;
  on_conflict?: InputMaybe<Provider_Hours_Repeater_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_Hours_Repeater_OneArgs = {
  object: Provider_Hours_Repeater_Insert_Input;
  on_conflict?: InputMaybe<Provider_Hours_Repeater_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_Patient_Booking_SettingsArgs = {
  objects: Array<Provider_Patient_Booking_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Provider_Patient_Booking_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_Patient_Booking_Settings_OneArgs = {
  object: Provider_Patient_Booking_Settings_Insert_Input;
  on_conflict?: InputMaybe<Provider_Patient_Booking_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_ProcedureArgs = {
  objects: Array<Provider_Procedure_Insert_Input>;
  on_conflict?: InputMaybe<Provider_Procedure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_Procedure_OneArgs = {
  object: Provider_Procedure_Insert_Input;
  on_conflict?: InputMaybe<Provider_Procedure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Purchase_For_LocationArgs = {
  objects: Array<Purchase_For_Location_Insert_Input>;
  on_conflict?: InputMaybe<Purchase_For_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Purchase_For_Location_OneArgs = {
  object: Purchase_For_Location_Insert_Input;
  on_conflict?: InputMaybe<Purchase_For_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Volume_DiscountArgs = {
  objects: Array<Rental_Volume_Discount_Insert_Input>;
  on_conflict?: InputMaybe<Rental_Volume_Discount_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rental_Volume_Discount_OneArgs = {
  object: Rental_Volume_Discount_Insert_Input;
  on_conflict?: InputMaybe<Rental_Volume_Discount_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RepeatingArgs = {
  objects: Array<Repeating_Insert_Input>;
  on_conflict?: InputMaybe<Repeating_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Repeating_OneArgs = {
  object: Repeating_Insert_Input;
  on_conflict?: InputMaybe<Repeating_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Report_PreferenceArgs = {
  objects: Array<Report_Preference_Insert_Input>;
  on_conflict?: InputMaybe<Report_Preference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Report_Preference_OneArgs = {
  object: Report_Preference_Insert_Input;
  on_conflict?: InputMaybe<Report_Preference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Report_TypeArgs = {
  objects: Array<Report_Type_Insert_Input>;
  on_conflict?: InputMaybe<Report_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Report_Type_OneArgs = {
  object: Report_Type_Insert_Input;
  on_conflict?: InputMaybe<Report_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoleArgs = {
  objects: Array<Role_Insert_Input>;
  on_conflict?: InputMaybe<Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Role_NotificationArgs = {
  objects: Array<Role_Notification_Insert_Input>;
  on_conflict?: InputMaybe<Role_Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Role_Notification_OneArgs = {
  object: Role_Notification_Insert_Input;
  on_conflict?: InputMaybe<Role_Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Role_OneArgs = {
  object: Role_Insert_Input;
  on_conflict?: InputMaybe<Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomArgs = {
  objects: Array<Room_Insert_Input>;
  on_conflict?: InputMaybe<Room_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Room_ModelArgs = {
  objects: Array<Room_Model_Insert_Input>;
  on_conflict?: InputMaybe<Room_Model_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Room_Model_OneArgs = {
  object: Room_Model_Insert_Input;
  on_conflict?: InputMaybe<Room_Model_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Room_OneArgs = {
  object: Room_Insert_Input;
  on_conflict?: InputMaybe<Room_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Room_TypeArgs = {
  objects: Array<Room_Type_Insert_Input>;
  on_conflict?: InputMaybe<Room_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Room_Type_OneArgs = {
  object: Room_Type_Insert_Input;
  on_conflict?: InputMaybe<Room_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SexArgs = {
  objects: Array<Sex_Insert_Input>;
  on_conflict?: InputMaybe<Sex_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sex_OneArgs = {
  object: Sex_Insert_Input;
  on_conflict?: InputMaybe<Sex_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_DocumentArgs = {
  objects: Array<Signing_Document_Insert_Input>;
  on_conflict?: InputMaybe<Signing_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_Document_OneArgs = {
  object: Signing_Document_Insert_Input;
  on_conflict?: InputMaybe<Signing_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_Document_Status_TypeArgs = {
  objects: Array<Signing_Document_Status_Type_Insert_Input>;
  on_conflict?: InputMaybe<Signing_Document_Status_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_Document_Status_Type_OneArgs = {
  object: Signing_Document_Status_Type_Insert_Input;
  on_conflict?: InputMaybe<Signing_Document_Status_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_Procedure_Associated_DocumentsArgs = {
  objects: Array<Signing_Procedure_Associated_Documents_Insert_Input>;
  on_conflict?: InputMaybe<Signing_Procedure_Associated_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_Procedure_Associated_Documents_OneArgs = {
  object: Signing_Procedure_Associated_Documents_Insert_Input;
  on_conflict?: InputMaybe<Signing_Procedure_Associated_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_TemplateArgs = {
  objects: Array<Signing_Template_Insert_Input>;
  on_conflict?: InputMaybe<Signing_Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_Template_EquivalentsArgs = {
  objects: Array<Signing_Template_Equivalents_Insert_Input>;
  on_conflict?: InputMaybe<Signing_Template_Equivalents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_Template_Equivalents_OneArgs = {
  object: Signing_Template_Equivalents_Insert_Input;
  on_conflict?: InputMaybe<Signing_Template_Equivalents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_Template_KindArgs = {
  objects: Array<Signing_Template_Kind_Insert_Input>;
  on_conflict?: InputMaybe<Signing_Template_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_Template_Kind_OneArgs = {
  object: Signing_Template_Kind_Insert_Input;
  on_conflict?: InputMaybe<Signing_Template_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_Template_OneArgs = {
  object: Signing_Template_Insert_Input;
  on_conflict?: InputMaybe<Signing_Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_Template_Source_FilesArgs = {
  objects: Array<Signing_Template_Source_Files_Insert_Input>;
  on_conflict?: InputMaybe<Signing_Template_Source_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_Template_Source_Files_OneArgs = {
  object: Signing_Template_Source_Files_Insert_Input;
  on_conflict?: InputMaybe<Signing_Template_Source_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_Vansanity_TemplateArgs = {
  objects: Array<Signing_Vansanity_Template_Insert_Input>;
  on_conflict?: InputMaybe<Signing_Vansanity_Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_Vansanity_Template_OneArgs = {
  object: Signing_Vansanity_Template_Insert_Input;
  on_conflict?: InputMaybe<Signing_Vansanity_Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_Webhook_EventArgs = {
  objects: Array<Signing_Webhook_Event_Insert_Input>;
  on_conflict?: InputMaybe<Signing_Webhook_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_Webhook_Event_OneArgs = {
  object: Signing_Webhook_Event_Insert_Input;
  on_conflict?: InputMaybe<Signing_Webhook_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_Webhook_Event_TypeArgs = {
  objects: Array<Signing_Webhook_Event_Type_Insert_Input>;
  on_conflict?: InputMaybe<Signing_Webhook_Event_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Signing_Webhook_Event_Type_OneArgs = {
  object: Signing_Webhook_Event_Type_Insert_Input;
  on_conflict?: InputMaybe<Signing_Webhook_Event_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Square_Credential_Ownership_EnumArgs = {
  objects: Array<Square_Credential_Ownership_Enum_Insert_Input>;
  on_conflict?: InputMaybe<Square_Credential_Ownership_Enum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Square_Credential_Ownership_Enum_OneArgs = {
  object: Square_Credential_Ownership_Enum_Insert_Input;
  on_conflict?: InputMaybe<Square_Credential_Ownership_Enum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Square_CredentialsArgs = {
  objects: Array<Square_Credentials_Insert_Input>;
  on_conflict?: InputMaybe<Square_Credentials_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Square_Credentials_OneArgs = {
  object: Square_Credentials_Insert_Input;
  on_conflict?: InputMaybe<Square_Credentials_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_ProviderArgs = {
  objects: Array<Supervisor_Provider_Insert_Input>;
  on_conflict?: InputMaybe<Supervisor_Provider_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_Provider_Initiated_ByArgs = {
  objects: Array<Supervisor_Provider_Initiated_By_Insert_Input>;
  on_conflict?: InputMaybe<Supervisor_Provider_Initiated_By_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_Provider_Initiated_By_OneArgs = {
  object: Supervisor_Provider_Initiated_By_Insert_Input;
  on_conflict?: InputMaybe<Supervisor_Provider_Initiated_By_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_Provider_OneArgs = {
  object: Supervisor_Provider_Insert_Input;
  on_conflict?: InputMaybe<Supervisor_Provider_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_Provider_TermArgs = {
  objects: Array<Supervisor_Provider_Term_Insert_Input>;
  on_conflict?: InputMaybe<Supervisor_Provider_Term_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_Provider_Term_Ended_ByArgs = {
  objects: Array<Supervisor_Provider_Term_Ended_By_Insert_Input>;
  on_conflict?: InputMaybe<Supervisor_Provider_Term_Ended_By_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_Provider_Term_Ended_By_OneArgs = {
  object: Supervisor_Provider_Term_Ended_By_Insert_Input;
  on_conflict?: InputMaybe<Supervisor_Provider_Term_Ended_By_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_Provider_Term_OneArgs = {
  object: Supervisor_Provider_Term_Insert_Input;
  on_conflict?: InputMaybe<Supervisor_Provider_Term_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_Review_Queue_ItemArgs = {
  objects: Array<Supervisor_Review_Queue_Item_Insert_Input>;
  on_conflict?: InputMaybe<Supervisor_Review_Queue_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_Review_Queue_Item_OneArgs = {
  object: Supervisor_Review_Queue_Item_Insert_Input;
  on_conflict?: InputMaybe<Supervisor_Review_Queue_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_Review_Queue_Item_Status_HistoryArgs = {
  objects: Array<Supervisor_Review_Queue_Item_Status_History_Insert_Input>;
  on_conflict?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_Review_Queue_Item_Status_History_OneArgs = {
  object: Supervisor_Review_Queue_Item_Status_History_Insert_Input;
  on_conflict?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_Review_Queue_SourceArgs = {
  objects: Array<Supervisor_Review_Queue_Source_Insert_Input>;
  on_conflict?: InputMaybe<Supervisor_Review_Queue_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_Review_Queue_Source_OneArgs = {
  object: Supervisor_Review_Queue_Source_Insert_Input;
  on_conflict?: InputMaybe<Supervisor_Review_Queue_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_Review_Queue_StatusArgs = {
  objects: Array<Supervisor_Review_Queue_Status_Insert_Input>;
  on_conflict?: InputMaybe<Supervisor_Review_Queue_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_Review_Queue_Status_OneArgs = {
  object: Supervisor_Review_Queue_Status_Insert_Input;
  on_conflict?: InputMaybe<Supervisor_Review_Queue_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_Sampling_Period_TypeArgs = {
  objects: Array<Supervisor_Sampling_Period_Type_Insert_Input>;
  on_conflict?: InputMaybe<Supervisor_Sampling_Period_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_Sampling_Period_Type_OneArgs = {
  object: Supervisor_Sampling_Period_Type_Insert_Input;
  on_conflict?: InputMaybe<Supervisor_Sampling_Period_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_SettingArgs = {
  objects: Array<Supervisor_Setting_Insert_Input>;
  on_conflict?: InputMaybe<Supervisor_Setting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Supervisor_Setting_OneArgs = {
  object: Supervisor_Setting_Insert_Input;
  on_conflict?: InputMaybe<Supervisor_Setting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tax_RateArgs = {
  objects: Array<Tax_Rate_Insert_Input>;
  on_conflict?: InputMaybe<Tax_Rate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tax_Rate_OneArgs = {
  object: Tax_Rate_Insert_Input;
  on_conflict?: InputMaybe<Tax_Rate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tax_TypeArgs = {
  objects: Array<Tax_Type_Insert_Input>;
  on_conflict?: InputMaybe<Tax_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tax_Type_OneArgs = {
  object: Tax_Type_Insert_Input;
  on_conflict?: InputMaybe<Tax_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserArgs = {
  objects: Array<User_Insert_Input>;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_AgreementsArgs = {
  objects: Array<User_Agreements_Insert_Input>;
  on_conflict?: InputMaybe<User_Agreements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Agreements_OneArgs = {
  object: User_Agreements_Insert_Input;
  on_conflict?: InputMaybe<User_Agreements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_ConsentArgs = {
  objects: Array<User_Consent_Insert_Input>;
  on_conflict?: InputMaybe<User_Consent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Consent_ActionArgs = {
  objects: Array<User_Consent_Action_Insert_Input>;
  on_conflict?: InputMaybe<User_Consent_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Consent_Action_OneArgs = {
  object: User_Consent_Action_Insert_Input;
  on_conflict?: InputMaybe<User_Consent_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Consent_OneArgs = {
  object: User_Consent_Insert_Input;
  on_conflict?: InputMaybe<User_Consent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Consent_TypeArgs = {
  objects: Array<User_Consent_Type_Insert_Input>;
  on_conflict?: InputMaybe<User_Consent_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Consent_Type_OneArgs = {
  object: User_Consent_Type_Insert_Input;
  on_conflict?: InputMaybe<User_Consent_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Device_Push_Notification_TokenArgs = {
  objects: Array<User_Device_Push_Notification_Token_Insert_Input>;
  on_conflict?: InputMaybe<User_Device_Push_Notification_Token_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Device_Push_Notification_Token_OneArgs = {
  object: User_Device_Push_Notification_Token_Insert_Input;
  on_conflict?: InputMaybe<User_Device_Push_Notification_Token_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_DocumentArgs = {
  objects: Array<User_Document_Insert_Input>;
  on_conflict?: InputMaybe<User_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Document_OneArgs = {
  object: User_Document_Insert_Input;
  on_conflict?: InputMaybe<User_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_LocationArgs = {
  objects: Array<User_Location_Insert_Input>;
  on_conflict?: InputMaybe<User_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Location_OneArgs = {
  object: User_Location_Insert_Input;
  on_conflict?: InputMaybe<User_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_OneArgs = {
  object: User_Insert_Input;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_PlanArgs = {
  objects: Array<User_Plan_Insert_Input>;
  on_conflict?: InputMaybe<User_Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Plan_OneArgs = {
  object: User_Plan_Insert_Input;
  on_conflict?: InputMaybe<User_Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_VersionArgs = {
  objects: Array<Version_Insert_Input>;
  on_conflict?: InputMaybe<Version_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Version_OneArgs = {
  object: Version_Insert_Input;
  on_conflict?: InputMaybe<Version_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPreparePatientBookingConfirmArgs = {
  object: PreparePatientBookingConfirmInput;
};


/** mutation root */
export type Mutation_RootRemoveBookingArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootRemoveOpenArgs = {
  object: DeleteOpenInput;
};


/** mutation root */
export type Mutation_RootRemoveRepeatBookingArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootSetAsDefaultPaymentMethodArgs = {
  object: SetAsDefaultPaymentMethodInput;
};


/** mutation root */
export type Mutation_RootSigningDocumentCreateArgs = {
  object: SigningDocumentCreateInput;
};


/** mutation root */
export type Mutation_RootSigningDocumentGetEmbeddedLinkArgs = {
  object: SigningDocumentGetEmbeddedLinkInput;
};


/** mutation root */
export type Mutation_RootSigningDocumentsResendLinkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootSigningTemplateCreateArgs = {
  object: SigningTemplateCreateInput;
};


/** mutation root */
export type Mutation_RootUncancelEhrSubscriptionArgs = {
  object: EhrUnitInput;
};


/** mutation root */
export type Mutation_RootUpdatePartnerStripeUserToChargeArgs = {
  object: UpdatePartnerStripeUserToChargeInput;
};


/** mutation root */
export type Mutation_RootUpdatePlanArgs = {
  object: UpdatePlanInput;
};


/** mutation root */
export type Mutation_RootUpdateProviderHoursArgs = {
  object: UpdateProviderHoursInput;
};


/** mutation root */
export type Mutation_RootUpdateUserPlanArgs = {
  object: UpdateUserPlanInput;
};


/** mutation root */
export type Mutation_RootUpdate_AccreditationArgs = {
  _set?: InputMaybe<Accreditation_Set_Input>;
  where: Accreditation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Accreditation_By_PkArgs = {
  _set?: InputMaybe<Accreditation_Set_Input>;
  pk_columns: Accreditation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Accreditation_Location_PrivilegeArgs = {
  _set?: InputMaybe<Accreditation_Location_Privilege_Set_Input>;
  where: Accreditation_Location_Privilege_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Accreditation_Location_Privilege_By_PkArgs = {
  _set?: InputMaybe<Accreditation_Location_Privilege_Set_Input>;
  pk_columns: Accreditation_Location_Privilege_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Accreditation_Location_Privilege_ManyArgs = {
  updates: Array<Accreditation_Location_Privilege_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Accreditation_ManyArgs = {
  updates: Array<Accreditation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AddressArgs = {
  _set?: InputMaybe<Address_Set_Input>;
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_By_PkArgs = {
  _set?: InputMaybe<Address_Set_Input>;
  pk_columns: Address_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Address_ManyArgs = {
  updates: Array<Address_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_TypeArgs = {
  _set?: InputMaybe<Agreement_Type_Set_Input>;
  where: Agreement_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Type_By_PkArgs = {
  _set?: InputMaybe<Agreement_Type_Set_Input>;
  pk_columns: Agreement_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Type_ManyArgs = {
  updates: Array<Agreement_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BookingArgs = {
  _inc?: InputMaybe<Booking_Inc_Input>;
  _set?: InputMaybe<Booking_Set_Input>;
  where: Booking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_By_PkArgs = {
  _inc?: InputMaybe<Booking_Inc_Input>;
  _set?: InputMaybe<Booking_Set_Input>;
  pk_columns: Booking_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_ManyArgs = {
  updates: Array<Booking_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_PublicArgs = {
  _set?: InputMaybe<Booking_Public_Set_Input>;
  where: Booking_Public_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_Public_ManyArgs = {
  updates: Array<Booking_Public_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_TypeArgs = {
  _set?: InputMaybe<Booking_Type_Set_Input>;
  where: Booking_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_Type_By_PkArgs = {
  _set?: InputMaybe<Booking_Type_Set_Input>;
  pk_columns: Booking_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_Type_ManyArgs = {
  updates: Array<Booking_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cancel_ReasonArgs = {
  _set?: InputMaybe<Cancel_Reason_Set_Input>;
  where: Cancel_Reason_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cancel_Reason_By_PkArgs = {
  _set?: InputMaybe<Cancel_Reason_Set_Input>;
  pk_columns: Cancel_Reason_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cancel_Reason_ManyArgs = {
  updates: Array<Cancel_Reason_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CreditArgs = {
  _inc?: InputMaybe<Credit_Inc_Input>;
  _set?: InputMaybe<Credit_Set_Input>;
  where: Credit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_By_PkArgs = {
  _inc?: InputMaybe<Credit_Inc_Input>;
  _set?: InputMaybe<Credit_Set_Input>;
  pk_columns: Credit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_ManyArgs = {
  updates: Array<Credit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_TransactionArgs = {
  _inc?: InputMaybe<Credit_Transaction_Inc_Input>;
  _set?: InputMaybe<Credit_Transaction_Set_Input>;
  where: Credit_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_Transaction_By_PkArgs = {
  _inc?: InputMaybe<Credit_Transaction_Inc_Input>;
  _set?: InputMaybe<Credit_Transaction_Set_Input>;
  pk_columns: Credit_Transaction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_Transaction_ManyArgs = {
  updates: Array<Credit_Transaction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_TypeArgs = {
  _set?: InputMaybe<Credit_Type_Set_Input>;
  where: Credit_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_Type_By_PkArgs = {
  _set?: InputMaybe<Credit_Type_Set_Input>;
  pk_columns: Credit_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_Type_ManyArgs = {
  updates: Array<Credit_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Demo_LocationArgs = {
  _inc?: InputMaybe<Demo_Location_Inc_Input>;
  _set?: InputMaybe<Demo_Location_Set_Input>;
  where: Demo_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Demo_Location_By_PkArgs = {
  _inc?: InputMaybe<Demo_Location_Inc_Input>;
  _set?: InputMaybe<Demo_Location_Set_Input>;
  pk_columns: Demo_Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Demo_Location_ManyArgs = {
  updates: Array<Demo_Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_TypeArgs = {
  _set?: InputMaybe<Document_Type_Set_Input>;
  where: Document_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Type_By_PkArgs = {
  _set?: InputMaybe<Document_Type_Set_Input>;
  pk_columns: Document_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Type_ManyArgs = {
  updates: Array<Document_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Charge_LedgerArgs = {
  _inc?: InputMaybe<Ehr_Charge_Ledger_Inc_Input>;
  _set?: InputMaybe<Ehr_Charge_Ledger_Set_Input>;
  where: Ehr_Charge_Ledger_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Charge_Ledger_By_PkArgs = {
  _inc?: InputMaybe<Ehr_Charge_Ledger_Inc_Input>;
  _set?: InputMaybe<Ehr_Charge_Ledger_Set_Input>;
  pk_columns: Ehr_Charge_Ledger_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Charge_Ledger_ManyArgs = {
  updates: Array<Ehr_Charge_Ledger_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_EncounterArgs = {
  _append?: InputMaybe<Ehr_Encounter_Append_Input>;
  _delete_at_path?: InputMaybe<Ehr_Encounter_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ehr_Encounter_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ehr_Encounter_Delete_Key_Input>;
  _inc?: InputMaybe<Ehr_Encounter_Inc_Input>;
  _prepend?: InputMaybe<Ehr_Encounter_Prepend_Input>;
  _set?: InputMaybe<Ehr_Encounter_Set_Input>;
  where: Ehr_Encounter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_AddendumArgs = {
  _append?: InputMaybe<Ehr_Encounter_Addendum_Append_Input>;
  _delete_at_path?: InputMaybe<Ehr_Encounter_Addendum_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ehr_Encounter_Addendum_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ehr_Encounter_Addendum_Delete_Key_Input>;
  _prepend?: InputMaybe<Ehr_Encounter_Addendum_Prepend_Input>;
  _set?: InputMaybe<Ehr_Encounter_Addendum_Set_Input>;
  where: Ehr_Encounter_Addendum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_Addendum_By_PkArgs = {
  _append?: InputMaybe<Ehr_Encounter_Addendum_Append_Input>;
  _delete_at_path?: InputMaybe<Ehr_Encounter_Addendum_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ehr_Encounter_Addendum_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ehr_Encounter_Addendum_Delete_Key_Input>;
  _prepend?: InputMaybe<Ehr_Encounter_Addendum_Prepend_Input>;
  _set?: InputMaybe<Ehr_Encounter_Addendum_Set_Input>;
  pk_columns: Ehr_Encounter_Addendum_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_Addendum_ManyArgs = {
  updates: Array<Ehr_Encounter_Addendum_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_By_PkArgs = {
  _append?: InputMaybe<Ehr_Encounter_Append_Input>;
  _delete_at_path?: InputMaybe<Ehr_Encounter_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ehr_Encounter_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ehr_Encounter_Delete_Key_Input>;
  _inc?: InputMaybe<Ehr_Encounter_Inc_Input>;
  _prepend?: InputMaybe<Ehr_Encounter_Prepend_Input>;
  _set?: InputMaybe<Ehr_Encounter_Set_Input>;
  pk_columns: Ehr_Encounter_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_ManyArgs = {
  updates: Array<Ehr_Encounter_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_ModalityArgs = {
  _set?: InputMaybe<Ehr_Encounter_Modality_Set_Input>;
  where: Ehr_Encounter_Modality_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_Modality_By_PkArgs = {
  _set?: InputMaybe<Ehr_Encounter_Modality_Set_Input>;
  pk_columns: Ehr_Encounter_Modality_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_Modality_ManyArgs = {
  updates: Array<Ehr_Encounter_Modality_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_PhotoArgs = {
  _set?: InputMaybe<Ehr_Encounter_Photo_Set_Input>;
  where: Ehr_Encounter_Photo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_Photo_By_PkArgs = {
  _set?: InputMaybe<Ehr_Encounter_Photo_Set_Input>;
  pk_columns: Ehr_Encounter_Photo_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_Photo_ManyArgs = {
  updates: Array<Ehr_Encounter_Photo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_Scan_3dArgs = {
  _set?: InputMaybe<Ehr_Encounter_Scan_3d_Set_Input>;
  where: Ehr_Encounter_Scan_3d_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_Scan_3d_ArtifactArgs = {
  _inc?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Inc_Input>;
  _set?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Set_Input>;
  where: Ehr_Encounter_Scan_3d_Artifact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_Scan_3d_Artifact_By_PkArgs = {
  _inc?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Inc_Input>;
  _set?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Set_Input>;
  pk_columns: Ehr_Encounter_Scan_3d_Artifact_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_Scan_3d_Artifact_KindArgs = {
  _set?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Set_Input>;
  where: Ehr_Encounter_Scan_3d_Artifact_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_Scan_3d_Artifact_Kind_By_PkArgs = {
  _set?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Set_Input>;
  pk_columns: Ehr_Encounter_Scan_3d_Artifact_Kind_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_Scan_3d_Artifact_Kind_ManyArgs = {
  updates: Array<Ehr_Encounter_Scan_3d_Artifact_Kind_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_Scan_3d_Artifact_ManyArgs = {
  updates: Array<Ehr_Encounter_Scan_3d_Artifact_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_Scan_3d_By_PkArgs = {
  _set?: InputMaybe<Ehr_Encounter_Scan_3d_Set_Input>;
  pk_columns: Ehr_Encounter_Scan_3d_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_Scan_3d_ManyArgs = {
  updates: Array<Ehr_Encounter_Scan_3d_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_TypeArgs = {
  _set?: InputMaybe<Ehr_Encounter_Type_Set_Input>;
  where: Ehr_Encounter_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_Type_By_PkArgs = {
  _set?: InputMaybe<Ehr_Encounter_Type_Set_Input>;
  pk_columns: Ehr_Encounter_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Encounter_Type_ManyArgs = {
  updates: Array<Ehr_Encounter_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Fda_ProductArgs = {
  _append?: InputMaybe<Ehr_Fda_Product_Append_Input>;
  _delete_at_path?: InputMaybe<Ehr_Fda_Product_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ehr_Fda_Product_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ehr_Fda_Product_Delete_Key_Input>;
  _inc?: InputMaybe<Ehr_Fda_Product_Inc_Input>;
  _prepend?: InputMaybe<Ehr_Fda_Product_Prepend_Input>;
  _set?: InputMaybe<Ehr_Fda_Product_Set_Input>;
  where: Ehr_Fda_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Fda_Product_By_PkArgs = {
  _append?: InputMaybe<Ehr_Fda_Product_Append_Input>;
  _delete_at_path?: InputMaybe<Ehr_Fda_Product_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ehr_Fda_Product_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ehr_Fda_Product_Delete_Key_Input>;
  _inc?: InputMaybe<Ehr_Fda_Product_Inc_Input>;
  _prepend?: InputMaybe<Ehr_Fda_Product_Prepend_Input>;
  _set?: InputMaybe<Ehr_Fda_Product_Set_Input>;
  pk_columns: Ehr_Fda_Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Fda_Product_ManyArgs = {
  updates: Array<Ehr_Fda_Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Fda_Product_SourceArgs = {
  _set?: InputMaybe<Ehr_Fda_Product_Source_Set_Input>;
  where: Ehr_Fda_Product_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Fda_Product_Source_By_PkArgs = {
  _set?: InputMaybe<Ehr_Fda_Product_Source_Set_Input>;
  pk_columns: Ehr_Fda_Product_Source_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Fda_Product_Source_ManyArgs = {
  updates: Array<Ehr_Fda_Product_Source_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_MessageArgs = {
  _set?: InputMaybe<Ehr_Message_Set_Input>;
  where: Ehr_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Message_By_PkArgs = {
  _set?: InputMaybe<Ehr_Message_Set_Input>;
  pk_columns: Ehr_Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Message_ManyArgs = {
  updates: Array<Ehr_Message_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Message_ReadArgs = {
  _set?: InputMaybe<Ehr_Message_Read_Set_Input>;
  where: Ehr_Message_Read_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Message_Read_By_PkArgs = {
  _set?: InputMaybe<Ehr_Message_Read_Set_Input>;
  pk_columns: Ehr_Message_Read_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Message_Read_ManyArgs = {
  updates: Array<Ehr_Message_Read_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Message_ThreadsArgs = {
  _set?: InputMaybe<Ehr_Message_Threads_Set_Input>;
  where: Ehr_Message_Threads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Message_Threads_By_PkArgs = {
  _set?: InputMaybe<Ehr_Message_Threads_Set_Input>;
  pk_columns: Ehr_Message_Threads_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Message_Threads_ManyArgs = {
  updates: Array<Ehr_Message_Threads_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Patient_CardArgs = {
  _set?: InputMaybe<Ehr_Patient_Card_Set_Input>;
  where: Ehr_Patient_Card_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Patient_Card_By_PkArgs = {
  _set?: InputMaybe<Ehr_Patient_Card_Set_Input>;
  pk_columns: Ehr_Patient_Card_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Patient_Card_ManyArgs = {
  updates: Array<Ehr_Patient_Card_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Patient_ConsentArgs = {
  _set?: InputMaybe<Ehr_Patient_Consent_Set_Input>;
  where: Ehr_Patient_Consent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Patient_Consent_ActionArgs = {
  _set?: InputMaybe<Ehr_Patient_Consent_Action_Set_Input>;
  where: Ehr_Patient_Consent_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Patient_Consent_Action_By_PkArgs = {
  _set?: InputMaybe<Ehr_Patient_Consent_Action_Set_Input>;
  pk_columns: Ehr_Patient_Consent_Action_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Patient_Consent_Action_ManyArgs = {
  updates: Array<Ehr_Patient_Consent_Action_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Patient_Consent_By_PkArgs = {
  _set?: InputMaybe<Ehr_Patient_Consent_Set_Input>;
  pk_columns: Ehr_Patient_Consent_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Patient_Consent_ManyArgs = {
  updates: Array<Ehr_Patient_Consent_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Patient_Consent_TypeArgs = {
  _set?: InputMaybe<Ehr_Patient_Consent_Type_Set_Input>;
  where: Ehr_Patient_Consent_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Patient_Consent_Type_By_PkArgs = {
  _set?: InputMaybe<Ehr_Patient_Consent_Type_Set_Input>;
  pk_columns: Ehr_Patient_Consent_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Patient_Consent_Type_ManyArgs = {
  updates: Array<Ehr_Patient_Consent_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_ProcedureArgs = {
  _set?: InputMaybe<Ehr_Procedure_Set_Input>;
  where: Ehr_Procedure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Procedure_Body_AreaArgs = {
  _set?: InputMaybe<Ehr_Procedure_Body_Area_Set_Input>;
  where: Ehr_Procedure_Body_Area_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Procedure_Body_Area_By_PkArgs = {
  _set?: InputMaybe<Ehr_Procedure_Body_Area_Set_Input>;
  pk_columns: Ehr_Procedure_Body_Area_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Procedure_Body_Area_ManyArgs = {
  updates: Array<Ehr_Procedure_Body_Area_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Procedure_Body_PartArgs = {
  _set?: InputMaybe<Ehr_Procedure_Body_Part_Set_Input>;
  where: Ehr_Procedure_Body_Part_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Procedure_Body_Part_By_PkArgs = {
  _set?: InputMaybe<Ehr_Procedure_Body_Part_Set_Input>;
  pk_columns: Ehr_Procedure_Body_Part_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Procedure_Body_Part_ManyArgs = {
  updates: Array<Ehr_Procedure_Body_Part_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Procedure_Body_Part_Provider_Injection_DefaultArgs = {
  _inc?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Inc_Input>;
  _set?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Set_Input>;
  where: Ehr_Procedure_Body_Part_Provider_Injection_Default_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Procedure_Body_Part_Provider_Injection_Default_By_PkArgs = {
  _inc?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Inc_Input>;
  _set?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Set_Input>;
  pk_columns: Ehr_Procedure_Body_Part_Provider_Injection_Default_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Procedure_Body_Part_Provider_Injection_Default_ManyArgs = {
  updates: Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Procedure_By_PkArgs = {
  _set?: InputMaybe<Ehr_Procedure_Set_Input>;
  pk_columns: Ehr_Procedure_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Procedure_Ehr_ProductArgs = {
  _set?: InputMaybe<Ehr_Procedure_Ehr_Product_Set_Input>;
  where: Ehr_Procedure_Ehr_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Procedure_Ehr_Product_By_PkArgs = {
  _set?: InputMaybe<Ehr_Procedure_Ehr_Product_Set_Input>;
  pk_columns: Ehr_Procedure_Ehr_Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Procedure_Ehr_Product_ManyArgs = {
  updates: Array<Ehr_Procedure_Ehr_Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Procedure_ManyArgs = {
  updates: Array<Ehr_Procedure_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Procedure_Type_EnumArgs = {
  _set?: InputMaybe<Ehr_Procedure_Type_Enum_Set_Input>;
  where: Ehr_Procedure_Type_Enum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Procedure_Type_Enum_By_PkArgs = {
  _set?: InputMaybe<Ehr_Procedure_Type_Enum_Set_Input>;
  pk_columns: Ehr_Procedure_Type_Enum_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Procedure_Type_Enum_ManyArgs = {
  updates: Array<Ehr_Procedure_Type_Enum_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_ProductArgs = {
  _set?: InputMaybe<Ehr_Product_Set_Input>;
  where: Ehr_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Product_By_PkArgs = {
  _set?: InputMaybe<Ehr_Product_Set_Input>;
  pk_columns: Ehr_Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Product_ManyArgs = {
  updates: Array<Ehr_Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Product_ProcedureArgs = {
  _set?: InputMaybe<Ehr_Product_Procedure_Set_Input>;
  where: Ehr_Product_Procedure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Product_Procedure_By_PkArgs = {
  _set?: InputMaybe<Ehr_Product_Procedure_Set_Input>;
  pk_columns: Ehr_Product_Procedure_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Product_Procedure_ManyArgs = {
  updates: Array<Ehr_Product_Procedure_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Product_Provider_Usage_Record_PhotoArgs = {
  _set?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Set_Input>;
  where: Ehr_Product_Provider_Usage_Record_Photo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Product_Provider_Usage_Record_Photo_By_PkArgs = {
  _set?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Set_Input>;
  pk_columns: Ehr_Product_Provider_Usage_Record_Photo_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Product_Provider_Usage_Record_Photo_ManyArgs = {
  updates: Array<Ehr_Product_Provider_Usage_Record_Photo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_SubscriptionArgs = {
  _set?: InputMaybe<Ehr_Subscription_Set_Input>;
  where: Ehr_Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Subscription_By_PkArgs = {
  _set?: InputMaybe<Ehr_Subscription_Set_Input>;
  pk_columns: Ehr_Subscription_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Subscription_ManyArgs = {
  updates: Array<Ehr_Subscription_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Subscription_StatusArgs = {
  _set?: InputMaybe<Ehr_Subscription_Status_Set_Input>;
  where: Ehr_Subscription_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Subscription_Status_By_PkArgs = {
  _set?: InputMaybe<Ehr_Subscription_Status_Set_Input>;
  pk_columns: Ehr_Subscription_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Subscription_Status_ManyArgs = {
  updates: Array<Ehr_Subscription_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Subscription_TierArgs = {
  _set?: InputMaybe<Ehr_Subscription_Tier_Set_Input>;
  where: Ehr_Subscription_Tier_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Subscription_Tier_By_PkArgs = {
  _set?: InputMaybe<Ehr_Subscription_Tier_Set_Input>;
  pk_columns: Ehr_Subscription_Tier_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Subscription_Tier_ManyArgs = {
  updates: Array<Ehr_Subscription_Tier_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Subscription_Tier_TermArgs = {
  _set?: InputMaybe<Ehr_Subscription_Tier_Term_Set_Input>;
  where: Ehr_Subscription_Tier_Term_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Subscription_Tier_Term_By_PkArgs = {
  _set?: InputMaybe<Ehr_Subscription_Tier_Term_Set_Input>;
  pk_columns: Ehr_Subscription_Tier_Term_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Subscription_Tier_Term_ManyArgs = {
  updates: Array<Ehr_Subscription_Tier_Term_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventArgs = {
  _append?: InputMaybe<Event_Append_Input>;
  _delete_at_path?: InputMaybe<Event_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Event_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Event_Delete_Key_Input>;
  _prepend?: InputMaybe<Event_Prepend_Input>;
  _set?: InputMaybe<Event_Set_Input>;
  where: Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Event_By_PkArgs = {
  _append?: InputMaybe<Event_Append_Input>;
  _delete_at_path?: InputMaybe<Event_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Event_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Event_Delete_Key_Input>;
  _prepend?: InputMaybe<Event_Prepend_Input>;
  _set?: InputMaybe<Event_Set_Input>;
  pk_columns: Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Event_ManyArgs = {
  updates: Array<Event_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Event_SourceArgs = {
  _set?: InputMaybe<Event_Source_Set_Input>;
  where: Event_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Source_By_PkArgs = {
  _set?: InputMaybe<Event_Source_Set_Input>;
  pk_columns: Event_Source_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Source_ManyArgs = {
  updates: Array<Event_Source_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Procedure_Delivery_ToolArgs = {
  _set?: InputMaybe<Filler_Procedure_Delivery_Tool_Set_Input>;
  where: Filler_Procedure_Delivery_Tool_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Procedure_Delivery_Tool_By_PkArgs = {
  _set?: InputMaybe<Filler_Procedure_Delivery_Tool_Set_Input>;
  pk_columns: Filler_Procedure_Delivery_Tool_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Procedure_Delivery_Tool_ManyArgs = {
  updates: Array<Filler_Procedure_Delivery_Tool_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Procedure_Face_ViewArgs = {
  _set?: InputMaybe<Filler_Procedure_Face_View_Set_Input>;
  where: Filler_Procedure_Face_View_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Procedure_Face_View_By_PkArgs = {
  _set?: InputMaybe<Filler_Procedure_Face_View_Set_Input>;
  pk_columns: Filler_Procedure_Face_View_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Procedure_Face_View_ManyArgs = {
  updates: Array<Filler_Procedure_Face_View_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Procedure_InjectionArgs = {
  _inc?: InputMaybe<Filler_Procedure_Injection_Inc_Input>;
  _set?: InputMaybe<Filler_Procedure_Injection_Set_Input>;
  where: Filler_Procedure_Injection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Procedure_Injection_By_PkArgs = {
  _inc?: InputMaybe<Filler_Procedure_Injection_Inc_Input>;
  _set?: InputMaybe<Filler_Procedure_Injection_Set_Input>;
  pk_columns: Filler_Procedure_Injection_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Procedure_Injection_ManyArgs = {
  updates: Array<Filler_Procedure_Injection_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Procedure_Injection_TypeArgs = {
  _set?: InputMaybe<Filler_Procedure_Injection_Type_Set_Input>;
  where: Filler_Procedure_Injection_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Procedure_Injection_Type_By_PkArgs = {
  _set?: InputMaybe<Filler_Procedure_Injection_Type_Set_Input>;
  pk_columns: Filler_Procedure_Injection_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Procedure_Injection_Type_ManyArgs = {
  updates: Array<Filler_Procedure_Injection_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Procedure_Product_InstanceArgs = {
  _inc?: InputMaybe<Filler_Procedure_Product_Instance_Inc_Input>;
  _set?: InputMaybe<Filler_Procedure_Product_Instance_Set_Input>;
  where: Filler_Procedure_Product_Instance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Procedure_Product_Instance_By_PkArgs = {
  _inc?: InputMaybe<Filler_Procedure_Product_Instance_Inc_Input>;
  _set?: InputMaybe<Filler_Procedure_Product_Instance_Set_Input>;
  pk_columns: Filler_Procedure_Product_Instance_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Procedure_Product_Instance_ManyArgs = {
  updates: Array<Filler_Procedure_Product_Instance_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Procedure_Product_Instance_PhotoArgs = {
  _set?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Set_Input>;
  where: Filler_Procedure_Product_Instance_Photo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Procedure_Product_Instance_Photo_By_PkArgs = {
  _set?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Set_Input>;
  pk_columns: Filler_Procedure_Product_Instance_Photo_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Procedure_Product_Instance_Photo_ManyArgs = {
  updates: Array<Filler_Procedure_Product_Instance_Photo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_SpaceArgs = {
  _set?: InputMaybe<Filler_Space_Set_Input>;
  where: Filler_Space_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Space_By_PkArgs = {
  _set?: InputMaybe<Filler_Space_Set_Input>;
  pk_columns: Filler_Space_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Space_ManyArgs = {
  updates: Array<Filler_Space_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Zone_ReleaseArgs = {
  _set?: InputMaybe<Filler_Zone_Release_Set_Input>;
  where: Filler_Zone_Release_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Zone_Release_By_PkArgs = {
  _set?: InputMaybe<Filler_Zone_Release_Set_Input>;
  pk_columns: Filler_Zone_Release_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Filler_Zone_Release_ManyArgs = {
  updates: Array<Filler_Zone_Release_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Check_Proposed_Patient_Booking_For_StackingArgs = {
  _set?: InputMaybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Set_Input>;
  where: Fn_Check_Proposed_Patient_Booking_For_Stacking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Check_Proposed_Patient_Booking_For_Stacking_By_PkArgs = {
  _set?: InputMaybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Set_Input>;
  pk_columns: Fn_Check_Proposed_Patient_Booking_For_Stacking_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Check_Proposed_Patient_Booking_For_Stacking_ManyArgs = {
  updates: Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_Active_Notification_Preferences_For_Type_And_LocationArgs = {
  _set?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Set_Input>;
  where: Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_Active_Notification_Preferences_For_Type_And_Location_By_PkArgs = {
  _set?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Set_Input>;
  pk_columns: Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_Active_Notification_Preferences_For_Type_And_Location_ManyArgs = {
  updates: Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_Active_Subscribers_QueryArgs = {
  _set?: InputMaybe<Fn_Get_Active_Subscribers_Query_Set_Input>;
  where: Fn_Get_Active_Subscribers_Query_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_Active_Subscribers_Query_By_PkArgs = {
  _set?: InputMaybe<Fn_Get_Active_Subscribers_Query_Set_Input>;
  pk_columns: Fn_Get_Active_Subscribers_Query_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_Active_Subscribers_Query_ManyArgs = {
  updates: Array<Fn_Get_Active_Subscribers_Query_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_Location_Purchases_To_Provider_Purchases_QueryArgs = {
  _inc?: InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Inc_Input>;
  _set?: InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Set_Input>;
  where: Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_Location_Purchases_To_Provider_Purchases_Query_By_PkArgs = {
  _inc?: InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Inc_Input>;
  _set?: InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Set_Input>;
  pk_columns: Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_Location_Purchases_To_Provider_Purchases_Query_ManyArgs = {
  updates: Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_Stackable_Booking_Options_DataArgs = {
  _set?: InputMaybe<Fn_Get_Stackable_Booking_Options_Data_Set_Input>;
  where: Fn_Get_Stackable_Booking_Options_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_Stackable_Booking_Options_Data_By_PkArgs = {
  _set?: InputMaybe<Fn_Get_Stackable_Booking_Options_Data_Set_Input>;
  pk_columns: Fn_Get_Stackable_Booking_Options_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_Stackable_Booking_Options_Data_ManyArgs = {
  updates: Array<Fn_Get_Stackable_Booking_Options_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_User_Booking_Options_BlockersArgs = {
  _set?: InputMaybe<Fn_Get_User_Booking_Options_Blockers_Set_Input>;
  where: Fn_Get_User_Booking_Options_Blockers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_User_Booking_Options_Blockers_By_PkArgs = {
  _set?: InputMaybe<Fn_Get_User_Booking_Options_Blockers_Set_Input>;
  pk_columns: Fn_Get_User_Booking_Options_Blockers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_User_Booking_Options_Blockers_ManyArgs = {
  updates: Array<Fn_Get_User_Booking_Options_Blockers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_User_Location_Procedure_Unavailable_RoomsArgs = {
  _set?: InputMaybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Set_Input>;
  where: Fn_Get_User_Location_Procedure_Unavailable_Rooms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_User_Location_Procedure_Unavailable_Rooms_By_PkArgs = {
  _set?: InputMaybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Set_Input>;
  pk_columns: Fn_Get_User_Location_Procedure_Unavailable_Rooms_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_User_Location_Procedure_Unavailable_Rooms_ManyArgs = {
  updates: Array<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_User_Products_To_Rentals_QueryArgs = {
  _inc?: InputMaybe<Fn_Get_User_Products_To_Rentals_Query_Inc_Input>;
  _set?: InputMaybe<Fn_Get_User_Products_To_Rentals_Query_Set_Input>;
  where: Fn_Get_User_Products_To_Rentals_Query_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_User_Products_To_Rentals_Query_By_PkArgs = {
  _inc?: InputMaybe<Fn_Get_User_Products_To_Rentals_Query_Inc_Input>;
  _set?: InputMaybe<Fn_Get_User_Products_To_Rentals_Query_Set_Input>;
  pk_columns: Fn_Get_User_Products_To_Rentals_Query_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Get_User_Products_To_Rentals_Query_ManyArgs = {
  updates: Array<Fn_Get_User_Products_To_Rentals_Query_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Users_Unfulfilled_Product_Purchases_Count_By_LocationArgs = {
  _inc?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Inc_Input>;
  _set?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Set_Input>;
  where: Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_By_PkArgs = {
  _inc?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Inc_Input>;
  _set?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Set_Input>;
  pk_columns: Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_ManyArgs = {
  updates: Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GenderArgs = {
  _set?: InputMaybe<Gender_Set_Input>;
  where: Gender_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gender_By_PkArgs = {
  _set?: InputMaybe<Gender_Set_Input>;
  pk_columns: Gender_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gender_ManyArgs = {
  updates: Array<Gender_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InvoiceArgs = {
  _append?: InputMaybe<Invoice_Append_Input>;
  _delete_at_path?: InputMaybe<Invoice_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Invoice_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Invoice_Delete_Key_Input>;
  _inc?: InputMaybe<Invoice_Inc_Input>;
  _prepend?: InputMaybe<Invoice_Prepend_Input>;
  _set?: InputMaybe<Invoice_Set_Input>;
  where: Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_Billing_SummaryArgs = {
  _append?: InputMaybe<Invoice_Billing_Summary_Append_Input>;
  _delete_at_path?: InputMaybe<Invoice_Billing_Summary_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Invoice_Billing_Summary_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Invoice_Billing_Summary_Delete_Key_Input>;
  _prepend?: InputMaybe<Invoice_Billing_Summary_Prepend_Input>;
  _set?: InputMaybe<Invoice_Billing_Summary_Set_Input>;
  where: Invoice_Billing_Summary_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_Billing_Summary_ManyArgs = {
  updates: Array<Invoice_Billing_Summary_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_By_PkArgs = {
  _append?: InputMaybe<Invoice_Append_Input>;
  _delete_at_path?: InputMaybe<Invoice_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Invoice_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Invoice_Delete_Key_Input>;
  _inc?: InputMaybe<Invoice_Inc_Input>;
  _prepend?: InputMaybe<Invoice_Prepend_Input>;
  _set?: InputMaybe<Invoice_Set_Input>;
  pk_columns: Invoice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_ManyArgs = {
  updates: Array<Invoice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LocationArgs = {
  _inc?: InputMaybe<Location_Inc_Input>;
  _set?: InputMaybe<Location_Set_Input>;
  where: Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Location_By_PkArgs = {
  _inc?: InputMaybe<Location_Inc_Input>;
  _set?: InputMaybe<Location_Set_Input>;
  pk_columns: Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Location_ManyArgs = {
  updates: Array<Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Location_ProcedureArgs = {
  _set?: InputMaybe<Location_Procedure_Set_Input>;
  where: Location_Procedure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Location_Procedure_By_PkArgs = {
  _set?: InputMaybe<Location_Procedure_Set_Input>;
  pk_columns: Location_Procedure_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Location_Procedure_ManyArgs = {
  updates: Array<Location_Procedure_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Location_Procedure_RoomArgs = {
  _set?: InputMaybe<Location_Procedure_Room_Set_Input>;
  where: Location_Procedure_Room_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Location_Procedure_Room_By_PkArgs = {
  _set?: InputMaybe<Location_Procedure_Room_Set_Input>;
  pk_columns: Location_Procedure_Room_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Location_Procedure_Room_ManyArgs = {
  updates: Array<Location_Procedure_Room_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Location_ProductArgs = {
  _inc?: InputMaybe<Location_Product_Inc_Input>;
  _set?: InputMaybe<Location_Product_Set_Input>;
  where: Location_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Location_Product_By_PkArgs = {
  _inc?: InputMaybe<Location_Product_Inc_Input>;
  _set?: InputMaybe<Location_Product_Set_Input>;
  pk_columns: Location_Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Location_Product_ManyArgs = {
  updates: Array<Location_Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ModelArgs = {
  _set?: InputMaybe<Model_Set_Input>;
  where: Model_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Model_By_PkArgs = {
  _set?: InputMaybe<Model_Set_Input>;
  pk_columns: Model_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Model_CountArgs = {
  _inc?: InputMaybe<Model_Count_Inc_Input>;
  _set?: InputMaybe<Model_Count_Set_Input>;
  where: Model_Count_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Count_By_PkArgs = {
  _inc?: InputMaybe<Model_Count_Inc_Input>;
  _set?: InputMaybe<Model_Count_Set_Input>;
  pk_columns: Model_Count_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Count_ManyArgs = {
  updates: Array<Model_Count_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Model_ManyArgs = {
  updates: Array<Model_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Model_ProductArgs = {
  _set?: InputMaybe<Model_Product_Set_Input>;
  where: Model_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Product_By_PkArgs = {
  _set?: InputMaybe<Model_Product_Set_Input>;
  pk_columns: Model_Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Product_ManyArgs = {
  updates: Array<Model_Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mso_ModeArgs = {
  _set?: InputMaybe<Mso_Mode_Set_Input>;
  where: Mso_Mode_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mso_Mode_By_PkArgs = {
  _set?: InputMaybe<Mso_Mode_Set_Input>;
  pk_columns: Mso_Mode_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mso_Mode_ManyArgs = {
  updates: Array<Mso_Mode_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mso_TierArgs = {
  _set?: InputMaybe<Mso_Tier_Set_Input>;
  where: Mso_Tier_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mso_Tier_By_PkArgs = {
  _set?: InputMaybe<Mso_Tier_Set_Input>;
  pk_columns: Mso_Tier_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mso_Tier_ManyArgs = {
  updates: Array<Mso_Tier_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Audit_LogArgs = {
  _append?: InputMaybe<Notification_Audit_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Notification_Audit_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Notification_Audit_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Notification_Audit_Log_Delete_Key_Input>;
  _prepend?: InputMaybe<Notification_Audit_Log_Prepend_Input>;
  _set?: InputMaybe<Notification_Audit_Log_Set_Input>;
  where: Notification_Audit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Audit_Log_By_PkArgs = {
  _append?: InputMaybe<Notification_Audit_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Notification_Audit_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Notification_Audit_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Notification_Audit_Log_Delete_Key_Input>;
  _prepend?: InputMaybe<Notification_Audit_Log_Prepend_Input>;
  _set?: InputMaybe<Notification_Audit_Log_Set_Input>;
  pk_columns: Notification_Audit_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Audit_Log_ManyArgs = {
  updates: Array<Notification_Audit_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Broadcast_TypeArgs = {
  _set?: InputMaybe<Notification_Broadcast_Type_Set_Input>;
  where: Notification_Broadcast_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Broadcast_Type_By_PkArgs = {
  _set?: InputMaybe<Notification_Broadcast_Type_Set_Input>;
  pk_columns: Notification_Broadcast_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Broadcast_Type_ManyArgs = {
  updates: Array<Notification_Broadcast_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_ChannelArgs = {
  _set?: InputMaybe<Notification_Channel_Set_Input>;
  where: Notification_Channel_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Channel_By_PkArgs = {
  _set?: InputMaybe<Notification_Channel_Set_Input>;
  pk_columns: Notification_Channel_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Channel_ManyArgs = {
  updates: Array<Notification_Channel_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_PreferenceArgs = {
  _set?: InputMaybe<Notification_Preference_Set_Input>;
  where: Notification_Preference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Preference_By_PkArgs = {
  _set?: InputMaybe<Notification_Preference_Set_Input>;
  pk_columns: Notification_Preference_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Preference_ManyArgs = {
  updates: Array<Notification_Preference_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_TypeArgs = {
  _set?: InputMaybe<Notification_Type_Set_Input>;
  where: Notification_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Type_By_PkArgs = {
  _set?: InputMaybe<Notification_Type_Set_Input>;
  pk_columns: Notification_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Type_Default_ChannelArgs = {
  _set?: InputMaybe<Notification_Type_Default_Channel_Set_Input>;
  where: Notification_Type_Default_Channel_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Type_Default_Channel_By_PkArgs = {
  _set?: InputMaybe<Notification_Type_Default_Channel_Set_Input>;
  pk_columns: Notification_Type_Default_Channel_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Type_Default_Channel_ManyArgs = {
  updates: Array<Notification_Type_Default_Channel_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Type_ManyArgs = {
  updates: Array<Notification_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OpenArgs = {
  _set?: InputMaybe<Open_Set_Input>;
  where: Open_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Open_By_PkArgs = {
  _set?: InputMaybe<Open_Set_Input>;
  pk_columns: Open_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Open_ManyArgs = {
  updates: Array<Open_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PartnerArgs = {
  _set?: InputMaybe<Partner_Set_Input>;
  where: Partner_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_BasicArgs = {
  _set?: InputMaybe<Partner_Basic_Set_Input>;
  where: Partner_Basic_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_Basic_ManyArgs = {
  updates: Array<Partner_Basic_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_By_PkArgs = {
  _set?: InputMaybe<Partner_Set_Input>;
  pk_columns: Partner_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_ManyArgs = {
  updates: Array<Partner_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PatientArgs = {
  _inc?: InputMaybe<Patient_Inc_Input>;
  _set?: InputMaybe<Patient_Set_Input>;
  where: Patient_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Account_EventArgs = {
  _append?: InputMaybe<Patient_Account_Event_Append_Input>;
  _delete_at_path?: InputMaybe<Patient_Account_Event_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Patient_Account_Event_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Patient_Account_Event_Delete_Key_Input>;
  _prepend?: InputMaybe<Patient_Account_Event_Prepend_Input>;
  _set?: InputMaybe<Patient_Account_Event_Set_Input>;
  where: Patient_Account_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Account_Event_By_PkArgs = {
  _append?: InputMaybe<Patient_Account_Event_Append_Input>;
  _delete_at_path?: InputMaybe<Patient_Account_Event_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Patient_Account_Event_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Patient_Account_Event_Delete_Key_Input>;
  _prepend?: InputMaybe<Patient_Account_Event_Prepend_Input>;
  _set?: InputMaybe<Patient_Account_Event_Set_Input>;
  pk_columns: Patient_Account_Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Account_Event_ManyArgs = {
  updates: Array<Patient_Account_Event_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Account_Event_TypeArgs = {
  _set?: InputMaybe<Patient_Account_Event_Type_Set_Input>;
  where: Patient_Account_Event_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Account_Event_Type_By_PkArgs = {
  _set?: InputMaybe<Patient_Account_Event_Type_Set_Input>;
  pk_columns: Patient_Account_Event_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Account_Event_Type_ManyArgs = {
  updates: Array<Patient_Account_Event_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Auth_ChallengeArgs = {
  _inc?: InputMaybe<Patient_Auth_Challenge_Inc_Input>;
  _set?: InputMaybe<Patient_Auth_Challenge_Set_Input>;
  where: Patient_Auth_Challenge_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Auth_Challenge_By_PkArgs = {
  _inc?: InputMaybe<Patient_Auth_Challenge_Inc_Input>;
  _set?: InputMaybe<Patient_Auth_Challenge_Set_Input>;
  pk_columns: Patient_Auth_Challenge_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Auth_Challenge_ManyArgs = {
  updates: Array<Patient_Auth_Challenge_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Bookable_Ehr_ProcedureArgs = {
  _inc?: InputMaybe<Patient_Bookable_Ehr_Procedure_Inc_Input>;
  _set?: InputMaybe<Patient_Bookable_Ehr_Procedure_Set_Input>;
  where: Patient_Bookable_Ehr_Procedure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Bookable_Ehr_Procedure_By_PkArgs = {
  _inc?: InputMaybe<Patient_Bookable_Ehr_Procedure_Inc_Input>;
  _set?: InputMaybe<Patient_Bookable_Ehr_Procedure_Set_Input>;
  pk_columns: Patient_Bookable_Ehr_Procedure_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Bookable_Ehr_Procedure_ManyArgs = {
  updates: Array<Patient_Bookable_Ehr_Procedure_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_BookingArgs = {
  _set?: InputMaybe<Patient_Booking_Set_Input>;
  where: Patient_Booking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Booking_BookingArgs = {
  _set?: InputMaybe<Patient_Booking_Booking_Set_Input>;
  where: Patient_Booking_Booking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Booking_Booking_By_PkArgs = {
  _set?: InputMaybe<Patient_Booking_Booking_Set_Input>;
  pk_columns: Patient_Booking_Booking_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Booking_Booking_ManyArgs = {
  updates: Array<Patient_Booking_Booking_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Booking_By_PkArgs = {
  _set?: InputMaybe<Patient_Booking_Set_Input>;
  pk_columns: Patient_Booking_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Booking_Cancel_ReasonArgs = {
  _set?: InputMaybe<Patient_Booking_Cancel_Reason_Set_Input>;
  where: Patient_Booking_Cancel_Reason_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Booking_Cancel_Reason_By_PkArgs = {
  _set?: InputMaybe<Patient_Booking_Cancel_Reason_Set_Input>;
  pk_columns: Patient_Booking_Cancel_Reason_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Booking_Cancel_Reason_ManyArgs = {
  updates: Array<Patient_Booking_Cancel_Reason_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Booking_InitiatorArgs = {
  _set?: InputMaybe<Patient_Booking_Initiator_Set_Input>;
  where: Patient_Booking_Initiator_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Booking_Initiator_By_PkArgs = {
  _set?: InputMaybe<Patient_Booking_Initiator_Set_Input>;
  pk_columns: Patient_Booking_Initiator_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Booking_Initiator_ManyArgs = {
  updates: Array<Patient_Booking_Initiator_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Booking_ManyArgs = {
  updates: Array<Patient_Booking_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Booking_MetadataArgs = {
  _set?: InputMaybe<Patient_Booking_Metadata_Set_Input>;
  where: Patient_Booking_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Booking_Metadata_By_PkArgs = {
  _set?: InputMaybe<Patient_Booking_Metadata_Set_Input>;
  pk_columns: Patient_Booking_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Booking_Metadata_ManyArgs = {
  updates: Array<Patient_Booking_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_By_PkArgs = {
  _inc?: InputMaybe<Patient_Inc_Input>;
  _set?: InputMaybe<Patient_Set_Input>;
  pk_columns: Patient_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Last_ViewArgs = {
  _set?: InputMaybe<Patient_Last_View_Set_Input>;
  where: Patient_Last_View_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Last_View_By_PkArgs = {
  _set?: InputMaybe<Patient_Last_View_Set_Input>;
  pk_columns: Patient_Last_View_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Last_View_ManyArgs = {
  updates: Array<Patient_Last_View_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_ManyArgs = {
  updates: Array<Patient_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Medical_ProfileArgs = {
  _inc?: InputMaybe<Patient_Medical_Profile_Inc_Input>;
  _set?: InputMaybe<Patient_Medical_Profile_Set_Input>;
  where: Patient_Medical_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Medical_Profile_By_PkArgs = {
  _inc?: InputMaybe<Patient_Medical_Profile_Inc_Input>;
  _set?: InputMaybe<Patient_Medical_Profile_Set_Input>;
  pk_columns: Patient_Medical_Profile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Medical_Profile_ManyArgs = {
  updates: Array<Patient_Medical_Profile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Registration_InviteArgs = {
  _set?: InputMaybe<Patient_Registration_Invite_Set_Input>;
  where: Patient_Registration_Invite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Registration_Invite_By_PkArgs = {
  _set?: InputMaybe<Patient_Registration_Invite_Set_Input>;
  pk_columns: Patient_Registration_Invite_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Registration_Invite_ManyArgs = {
  updates: Array<Patient_Registration_Invite_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_SessionArgs = {
  _inc?: InputMaybe<Patient_Session_Inc_Input>;
  _set?: InputMaybe<Patient_Session_Set_Input>;
  where: Patient_Session_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Session_By_PkArgs = {
  _inc?: InputMaybe<Patient_Session_Inc_Input>;
  _set?: InputMaybe<Patient_Session_Set_Input>;
  pk_columns: Patient_Session_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Session_ManyArgs = {
  updates: Array<Patient_Session_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Webauthn_ChallengeArgs = {
  _set?: InputMaybe<Patient_Webauthn_Challenge_Set_Input>;
  where: Patient_Webauthn_Challenge_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Webauthn_Challenge_By_PkArgs = {
  _set?: InputMaybe<Patient_Webauthn_Challenge_Set_Input>;
  pk_columns: Patient_Webauthn_Challenge_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Webauthn_Challenge_ManyArgs = {
  updates: Array<Patient_Webauthn_Challenge_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Webauthn_CredentialArgs = {
  _inc?: InputMaybe<Patient_Webauthn_Credential_Inc_Input>;
  _set?: InputMaybe<Patient_Webauthn_Credential_Set_Input>;
  where: Patient_Webauthn_Credential_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Webauthn_Credential_By_PkArgs = {
  _inc?: InputMaybe<Patient_Webauthn_Credential_Inc_Input>;
  _set?: InputMaybe<Patient_Webauthn_Credential_Set_Input>;
  pk_columns: Patient_Webauthn_Credential_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Webauthn_Credential_ManyArgs = {
  updates: Array<Patient_Webauthn_Credential_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PlanArgs = {
  _inc?: InputMaybe<Plan_Inc_Input>;
  _set?: InputMaybe<Plan_Set_Input>;
  where: Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plan_By_PkArgs = {
  _inc?: InputMaybe<Plan_Inc_Input>;
  _set?: InputMaybe<Plan_Set_Input>;
  pk_columns: Plan_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plan_ManyArgs = {
  updates: Array<Plan_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plan_TypeArgs = {
  _set?: InputMaybe<Plan_Type_Set_Input>;
  where: Plan_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plan_Type_By_PkArgs = {
  _set?: InputMaybe<Plan_Type_Set_Input>;
  pk_columns: Plan_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plan_Type_ManyArgs = {
  updates: Array<Plan_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pre_Procedure_Photo_Injection_MarkingArgs = {
  _inc?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Inc_Input>;
  _set?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Set_Input>;
  where: Pre_Procedure_Photo_Injection_Marking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pre_Procedure_Photo_Injection_Marking_By_PkArgs = {
  _inc?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Inc_Input>;
  _set?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Set_Input>;
  pk_columns: Pre_Procedure_Photo_Injection_Marking_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pre_Procedure_Photo_Injection_Marking_ManyArgs = {
  updates: Array<Pre_Procedure_Photo_Injection_Marking_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProcedureArgs = {
  _set?: InputMaybe<Procedure_Set_Input>;
  where: Procedure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Procedure_Audio_RecordingArgs = {
  _append?: InputMaybe<Procedure_Audio_Recording_Append_Input>;
  _delete_at_path?: InputMaybe<Procedure_Audio_Recording_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Procedure_Audio_Recording_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Procedure_Audio_Recording_Delete_Key_Input>;
  _inc?: InputMaybe<Procedure_Audio_Recording_Inc_Input>;
  _prepend?: InputMaybe<Procedure_Audio_Recording_Prepend_Input>;
  _set?: InputMaybe<Procedure_Audio_Recording_Set_Input>;
  where: Procedure_Audio_Recording_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Procedure_Audio_Recording_By_PkArgs = {
  _append?: InputMaybe<Procedure_Audio_Recording_Append_Input>;
  _delete_at_path?: InputMaybe<Procedure_Audio_Recording_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Procedure_Audio_Recording_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Procedure_Audio_Recording_Delete_Key_Input>;
  _inc?: InputMaybe<Procedure_Audio_Recording_Inc_Input>;
  _prepend?: InputMaybe<Procedure_Audio_Recording_Prepend_Input>;
  _set?: InputMaybe<Procedure_Audio_Recording_Set_Input>;
  pk_columns: Procedure_Audio_Recording_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Procedure_Audio_Recording_ManyArgs = {
  updates: Array<Procedure_Audio_Recording_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Procedure_By_PkArgs = {
  _set?: InputMaybe<Procedure_Set_Input>;
  pk_columns: Procedure_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Procedure_ManyArgs = {
  updates: Array<Procedure_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductArgs = {
  _inc?: InputMaybe<Product_Inc_Input>;
  _set?: InputMaybe<Product_Set_Input>;
  where: Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_By_PkArgs = {
  _inc?: InputMaybe<Product_Inc_Input>;
  _set?: InputMaybe<Product_Set_Input>;
  pk_columns: Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_ManyArgs = {
  updates: Array<Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_PurchaseArgs = {
  _inc?: InputMaybe<Product_Purchase_Inc_Input>;
  _set?: InputMaybe<Product_Purchase_Set_Input>;
  where: Product_Purchase_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Purchase_By_PkArgs = {
  _inc?: InputMaybe<Product_Purchase_Inc_Input>;
  _set?: InputMaybe<Product_Purchase_Set_Input>;
  pk_columns: Product_Purchase_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Purchase_ManyArgs = {
  updates: Array<Product_Purchase_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_TypeArgs = {
  _set?: InputMaybe<Product_Type_Set_Input>;
  where: Product_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Type_By_PkArgs = {
  _set?: InputMaybe<Product_Type_Set_Input>;
  pk_columns: Product_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Type_ManyArgs = {
  updates: Array<Product_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Direct_Product_PurchaseArgs = {
  _set?: InputMaybe<Provider_Direct_Product_Purchase_Set_Input>;
  where: Provider_Direct_Product_Purchase_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Direct_Product_Purchase_By_PkArgs = {
  _set?: InputMaybe<Provider_Direct_Product_Purchase_Set_Input>;
  pk_columns: Provider_Direct_Product_Purchase_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Direct_Product_Purchase_ManyArgs = {
  updates: Array<Provider_Direct_Product_Purchase_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_HoursArgs = {
  _set?: InputMaybe<Provider_Hours_Set_Input>;
  where: Provider_Hours_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Hours_By_PkArgs = {
  _set?: InputMaybe<Provider_Hours_Set_Input>;
  pk_columns: Provider_Hours_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Hours_ManyArgs = {
  updates: Array<Provider_Hours_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Hours_Repeat_IntervalArgs = {
  _set?: InputMaybe<Provider_Hours_Repeat_Interval_Set_Input>;
  where: Provider_Hours_Repeat_Interval_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Hours_Repeat_Interval_By_PkArgs = {
  _set?: InputMaybe<Provider_Hours_Repeat_Interval_Set_Input>;
  pk_columns: Provider_Hours_Repeat_Interval_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Hours_Repeat_Interval_ManyArgs = {
  updates: Array<Provider_Hours_Repeat_Interval_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Hours_RepeaterArgs = {
  _set?: InputMaybe<Provider_Hours_Repeater_Set_Input>;
  where: Provider_Hours_Repeater_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Hours_Repeater_By_PkArgs = {
  _set?: InputMaybe<Provider_Hours_Repeater_Set_Input>;
  pk_columns: Provider_Hours_Repeater_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Hours_Repeater_ManyArgs = {
  updates: Array<Provider_Hours_Repeater_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Patient_Booking_SettingsArgs = {
  _inc?: InputMaybe<Provider_Patient_Booking_Settings_Inc_Input>;
  _set?: InputMaybe<Provider_Patient_Booking_Settings_Set_Input>;
  where: Provider_Patient_Booking_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Patient_Booking_Settings_By_PkArgs = {
  _inc?: InputMaybe<Provider_Patient_Booking_Settings_Inc_Input>;
  _set?: InputMaybe<Provider_Patient_Booking_Settings_Set_Input>;
  pk_columns: Provider_Patient_Booking_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Patient_Booking_Settings_ManyArgs = {
  updates: Array<Provider_Patient_Booking_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_ProcedureArgs = {
  _inc?: InputMaybe<Provider_Procedure_Inc_Input>;
  _set?: InputMaybe<Provider_Procedure_Set_Input>;
  where: Provider_Procedure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Procedure_By_PkArgs = {
  _inc?: InputMaybe<Provider_Procedure_Inc_Input>;
  _set?: InputMaybe<Provider_Procedure_Set_Input>;
  pk_columns: Provider_Procedure_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Procedure_ManyArgs = {
  updates: Array<Provider_Procedure_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Purchase_For_LocationArgs = {
  _inc?: InputMaybe<Purchase_For_Location_Inc_Input>;
  _set?: InputMaybe<Purchase_For_Location_Set_Input>;
  where: Purchase_For_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Purchase_For_Location_By_PkArgs = {
  _inc?: InputMaybe<Purchase_For_Location_Inc_Input>;
  _set?: InputMaybe<Purchase_For_Location_Set_Input>;
  pk_columns: Purchase_For_Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Purchase_For_Location_ManyArgs = {
  updates: Array<Purchase_For_Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Volume_DiscountArgs = {
  _inc?: InputMaybe<Rental_Volume_Discount_Inc_Input>;
  _set?: InputMaybe<Rental_Volume_Discount_Set_Input>;
  where: Rental_Volume_Discount_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Volume_Discount_By_PkArgs = {
  _inc?: InputMaybe<Rental_Volume_Discount_Inc_Input>;
  _set?: InputMaybe<Rental_Volume_Discount_Set_Input>;
  pk_columns: Rental_Volume_Discount_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rental_Volume_Discount_ManyArgs = {
  updates: Array<Rental_Volume_Discount_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RepeatingArgs = {
  _set?: InputMaybe<Repeating_Set_Input>;
  where: Repeating_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Repeating_By_PkArgs = {
  _set?: InputMaybe<Repeating_Set_Input>;
  pk_columns: Repeating_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Repeating_ManyArgs = {
  updates: Array<Repeating_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Report_PreferenceArgs = {
  _set?: InputMaybe<Report_Preference_Set_Input>;
  where: Report_Preference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Report_Preference_By_PkArgs = {
  _set?: InputMaybe<Report_Preference_Set_Input>;
  pk_columns: Report_Preference_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Report_Preference_ManyArgs = {
  updates: Array<Report_Preference_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Report_TypeArgs = {
  _set?: InputMaybe<Report_Type_Set_Input>;
  where: Report_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Report_Type_By_PkArgs = {
  _set?: InputMaybe<Report_Type_Set_Input>;
  pk_columns: Report_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Report_Type_ManyArgs = {
  updates: Array<Report_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RoleArgs = {
  _set?: InputMaybe<Role_Set_Input>;
  where: Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Role_By_PkArgs = {
  _set?: InputMaybe<Role_Set_Input>;
  pk_columns: Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Role_ManyArgs = {
  updates: Array<Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Role_NotificationArgs = {
  _set?: InputMaybe<Role_Notification_Set_Input>;
  where: Role_Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Role_Notification_By_PkArgs = {
  _set?: InputMaybe<Role_Notification_Set_Input>;
  pk_columns: Role_Notification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Role_Notification_ManyArgs = {
  updates: Array<Role_Notification_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RoomArgs = {
  _inc?: InputMaybe<Room_Inc_Input>;
  _set?: InputMaybe<Room_Set_Input>;
  where: Room_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Room_By_PkArgs = {
  _inc?: InputMaybe<Room_Inc_Input>;
  _set?: InputMaybe<Room_Set_Input>;
  pk_columns: Room_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Room_ManyArgs = {
  updates: Array<Room_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Room_ModelArgs = {
  _set?: InputMaybe<Room_Model_Set_Input>;
  where: Room_Model_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Room_Model_By_PkArgs = {
  _set?: InputMaybe<Room_Model_Set_Input>;
  pk_columns: Room_Model_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Room_Model_ManyArgs = {
  updates: Array<Room_Model_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Room_TypeArgs = {
  _set?: InputMaybe<Room_Type_Set_Input>;
  where: Room_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Room_Type_By_PkArgs = {
  _set?: InputMaybe<Room_Type_Set_Input>;
  pk_columns: Room_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Room_Type_ManyArgs = {
  updates: Array<Room_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SexArgs = {
  _set?: InputMaybe<Sex_Set_Input>;
  where: Sex_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sex_By_PkArgs = {
  _set?: InputMaybe<Sex_Set_Input>;
  pk_columns: Sex_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sex_ManyArgs = {
  updates: Array<Sex_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_DocumentArgs = {
  _inc?: InputMaybe<Signing_Document_Inc_Input>;
  _set?: InputMaybe<Signing_Document_Set_Input>;
  where: Signing_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Document_By_PkArgs = {
  _inc?: InputMaybe<Signing_Document_Inc_Input>;
  _set?: InputMaybe<Signing_Document_Set_Input>;
  pk_columns: Signing_Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Document_ManyArgs = {
  updates: Array<Signing_Document_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Document_Status_TypeArgs = {
  _set?: InputMaybe<Signing_Document_Status_Type_Set_Input>;
  where: Signing_Document_Status_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Document_Status_Type_By_PkArgs = {
  _set?: InputMaybe<Signing_Document_Status_Type_Set_Input>;
  pk_columns: Signing_Document_Status_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Document_Status_Type_ManyArgs = {
  updates: Array<Signing_Document_Status_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Procedure_Associated_DocumentsArgs = {
  _set?: InputMaybe<Signing_Procedure_Associated_Documents_Set_Input>;
  where: Signing_Procedure_Associated_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Procedure_Associated_Documents_By_PkArgs = {
  _set?: InputMaybe<Signing_Procedure_Associated_Documents_Set_Input>;
  pk_columns: Signing_Procedure_Associated_Documents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Procedure_Associated_Documents_ManyArgs = {
  updates: Array<Signing_Procedure_Associated_Documents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_TemplateArgs = {
  _set?: InputMaybe<Signing_Template_Set_Input>;
  where: Signing_Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Template_By_PkArgs = {
  _set?: InputMaybe<Signing_Template_Set_Input>;
  pk_columns: Signing_Template_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Template_EquivalentsArgs = {
  _set?: InputMaybe<Signing_Template_Equivalents_Set_Input>;
  where: Signing_Template_Equivalents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Template_Equivalents_By_PkArgs = {
  _set?: InputMaybe<Signing_Template_Equivalents_Set_Input>;
  pk_columns: Signing_Template_Equivalents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Template_Equivalents_ManyArgs = {
  updates: Array<Signing_Template_Equivalents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Template_KindArgs = {
  _set?: InputMaybe<Signing_Template_Kind_Set_Input>;
  where: Signing_Template_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Template_Kind_By_PkArgs = {
  _set?: InputMaybe<Signing_Template_Kind_Set_Input>;
  pk_columns: Signing_Template_Kind_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Template_Kind_ManyArgs = {
  updates: Array<Signing_Template_Kind_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Template_ManyArgs = {
  updates: Array<Signing_Template_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Template_Source_FilesArgs = {
  _append?: InputMaybe<Signing_Template_Source_Files_Append_Input>;
  _delete_at_path?: InputMaybe<Signing_Template_Source_Files_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Signing_Template_Source_Files_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Signing_Template_Source_Files_Delete_Key_Input>;
  _inc?: InputMaybe<Signing_Template_Source_Files_Inc_Input>;
  _prepend?: InputMaybe<Signing_Template_Source_Files_Prepend_Input>;
  _set?: InputMaybe<Signing_Template_Source_Files_Set_Input>;
  where: Signing_Template_Source_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Template_Source_Files_By_PkArgs = {
  _append?: InputMaybe<Signing_Template_Source_Files_Append_Input>;
  _delete_at_path?: InputMaybe<Signing_Template_Source_Files_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Signing_Template_Source_Files_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Signing_Template_Source_Files_Delete_Key_Input>;
  _inc?: InputMaybe<Signing_Template_Source_Files_Inc_Input>;
  _prepend?: InputMaybe<Signing_Template_Source_Files_Prepend_Input>;
  _set?: InputMaybe<Signing_Template_Source_Files_Set_Input>;
  pk_columns: Signing_Template_Source_Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Template_Source_Files_ManyArgs = {
  updates: Array<Signing_Template_Source_Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Vansanity_TemplateArgs = {
  _append?: InputMaybe<Signing_Vansanity_Template_Append_Input>;
  _delete_at_path?: InputMaybe<Signing_Vansanity_Template_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Signing_Vansanity_Template_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Signing_Vansanity_Template_Delete_Key_Input>;
  _inc?: InputMaybe<Signing_Vansanity_Template_Inc_Input>;
  _prepend?: InputMaybe<Signing_Vansanity_Template_Prepend_Input>;
  _set?: InputMaybe<Signing_Vansanity_Template_Set_Input>;
  where: Signing_Vansanity_Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Vansanity_Template_By_PkArgs = {
  _append?: InputMaybe<Signing_Vansanity_Template_Append_Input>;
  _delete_at_path?: InputMaybe<Signing_Vansanity_Template_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Signing_Vansanity_Template_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Signing_Vansanity_Template_Delete_Key_Input>;
  _inc?: InputMaybe<Signing_Vansanity_Template_Inc_Input>;
  _prepend?: InputMaybe<Signing_Vansanity_Template_Prepend_Input>;
  _set?: InputMaybe<Signing_Vansanity_Template_Set_Input>;
  pk_columns: Signing_Vansanity_Template_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Vansanity_Template_ManyArgs = {
  updates: Array<Signing_Vansanity_Template_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Webhook_EventArgs = {
  _append?: InputMaybe<Signing_Webhook_Event_Append_Input>;
  _delete_at_path?: InputMaybe<Signing_Webhook_Event_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Signing_Webhook_Event_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Signing_Webhook_Event_Delete_Key_Input>;
  _prepend?: InputMaybe<Signing_Webhook_Event_Prepend_Input>;
  _set?: InputMaybe<Signing_Webhook_Event_Set_Input>;
  where: Signing_Webhook_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Webhook_Event_By_PkArgs = {
  _append?: InputMaybe<Signing_Webhook_Event_Append_Input>;
  _delete_at_path?: InputMaybe<Signing_Webhook_Event_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Signing_Webhook_Event_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Signing_Webhook_Event_Delete_Key_Input>;
  _prepend?: InputMaybe<Signing_Webhook_Event_Prepend_Input>;
  _set?: InputMaybe<Signing_Webhook_Event_Set_Input>;
  pk_columns: Signing_Webhook_Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Webhook_Event_ManyArgs = {
  updates: Array<Signing_Webhook_Event_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Webhook_Event_TypeArgs = {
  _set?: InputMaybe<Signing_Webhook_Event_Type_Set_Input>;
  where: Signing_Webhook_Event_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Webhook_Event_Type_By_PkArgs = {
  _set?: InputMaybe<Signing_Webhook_Event_Type_Set_Input>;
  pk_columns: Signing_Webhook_Event_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Signing_Webhook_Event_Type_ManyArgs = {
  updates: Array<Signing_Webhook_Event_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Square_Credential_Ownership_EnumArgs = {
  _set?: InputMaybe<Square_Credential_Ownership_Enum_Set_Input>;
  where: Square_Credential_Ownership_Enum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Square_Credential_Ownership_Enum_By_PkArgs = {
  _set?: InputMaybe<Square_Credential_Ownership_Enum_Set_Input>;
  pk_columns: Square_Credential_Ownership_Enum_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Square_Credential_Ownership_Enum_ManyArgs = {
  updates: Array<Square_Credential_Ownership_Enum_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Square_CredentialsArgs = {
  _set?: InputMaybe<Square_Credentials_Set_Input>;
  where: Square_Credentials_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Square_Credentials_By_PkArgs = {
  _set?: InputMaybe<Square_Credentials_Set_Input>;
  pk_columns: Square_Credentials_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Square_Credentials_ManyArgs = {
  updates: Array<Square_Credentials_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_ProviderArgs = {
  _inc?: InputMaybe<Supervisor_Provider_Inc_Input>;
  _set?: InputMaybe<Supervisor_Provider_Set_Input>;
  where: Supervisor_Provider_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Provider_By_PkArgs = {
  _inc?: InputMaybe<Supervisor_Provider_Inc_Input>;
  _set?: InputMaybe<Supervisor_Provider_Set_Input>;
  pk_columns: Supervisor_Provider_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Provider_Initiated_ByArgs = {
  _set?: InputMaybe<Supervisor_Provider_Initiated_By_Set_Input>;
  where: Supervisor_Provider_Initiated_By_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Provider_Initiated_By_By_PkArgs = {
  _set?: InputMaybe<Supervisor_Provider_Initiated_By_Set_Input>;
  pk_columns: Supervisor_Provider_Initiated_By_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Provider_Initiated_By_ManyArgs = {
  updates: Array<Supervisor_Provider_Initiated_By_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Provider_ManyArgs = {
  updates: Array<Supervisor_Provider_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Provider_TermArgs = {
  _inc?: InputMaybe<Supervisor_Provider_Term_Inc_Input>;
  _set?: InputMaybe<Supervisor_Provider_Term_Set_Input>;
  where: Supervisor_Provider_Term_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Provider_Term_By_PkArgs = {
  _inc?: InputMaybe<Supervisor_Provider_Term_Inc_Input>;
  _set?: InputMaybe<Supervisor_Provider_Term_Set_Input>;
  pk_columns: Supervisor_Provider_Term_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Provider_Term_Ended_ByArgs = {
  _set?: InputMaybe<Supervisor_Provider_Term_Ended_By_Set_Input>;
  where: Supervisor_Provider_Term_Ended_By_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Provider_Term_Ended_By_By_PkArgs = {
  _set?: InputMaybe<Supervisor_Provider_Term_Ended_By_Set_Input>;
  pk_columns: Supervisor_Provider_Term_Ended_By_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Provider_Term_Ended_By_ManyArgs = {
  updates: Array<Supervisor_Provider_Term_Ended_By_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Provider_Term_ManyArgs = {
  updates: Array<Supervisor_Provider_Term_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Review_Queue_ItemArgs = {
  _set?: InputMaybe<Supervisor_Review_Queue_Item_Set_Input>;
  where: Supervisor_Review_Queue_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Review_Queue_Item_By_PkArgs = {
  _set?: InputMaybe<Supervisor_Review_Queue_Item_Set_Input>;
  pk_columns: Supervisor_Review_Queue_Item_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Review_Queue_Item_ManyArgs = {
  updates: Array<Supervisor_Review_Queue_Item_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Review_Queue_Item_Status_HistoryArgs = {
  _set?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Set_Input>;
  where: Supervisor_Review_Queue_Item_Status_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Review_Queue_Item_Status_History_By_PkArgs = {
  _set?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Set_Input>;
  pk_columns: Supervisor_Review_Queue_Item_Status_History_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Review_Queue_Item_Status_History_ManyArgs = {
  updates: Array<Supervisor_Review_Queue_Item_Status_History_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Review_Queue_SourceArgs = {
  _set?: InputMaybe<Supervisor_Review_Queue_Source_Set_Input>;
  where: Supervisor_Review_Queue_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Review_Queue_Source_By_PkArgs = {
  _set?: InputMaybe<Supervisor_Review_Queue_Source_Set_Input>;
  pk_columns: Supervisor_Review_Queue_Source_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Review_Queue_Source_ManyArgs = {
  updates: Array<Supervisor_Review_Queue_Source_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Review_Queue_StatusArgs = {
  _set?: InputMaybe<Supervisor_Review_Queue_Status_Set_Input>;
  where: Supervisor_Review_Queue_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Review_Queue_Status_By_PkArgs = {
  _set?: InputMaybe<Supervisor_Review_Queue_Status_Set_Input>;
  pk_columns: Supervisor_Review_Queue_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Review_Queue_Status_ManyArgs = {
  updates: Array<Supervisor_Review_Queue_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Sampling_Period_TypeArgs = {
  _set?: InputMaybe<Supervisor_Sampling_Period_Type_Set_Input>;
  where: Supervisor_Sampling_Period_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Sampling_Period_Type_By_PkArgs = {
  _set?: InputMaybe<Supervisor_Sampling_Period_Type_Set_Input>;
  pk_columns: Supervisor_Sampling_Period_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Sampling_Period_Type_ManyArgs = {
  updates: Array<Supervisor_Sampling_Period_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_SettingArgs = {
  _inc?: InputMaybe<Supervisor_Setting_Inc_Input>;
  _set?: InputMaybe<Supervisor_Setting_Set_Input>;
  where: Supervisor_Setting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Setting_By_PkArgs = {
  _inc?: InputMaybe<Supervisor_Setting_Inc_Input>;
  _set?: InputMaybe<Supervisor_Setting_Set_Input>;
  pk_columns: Supervisor_Setting_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Supervisor_Setting_ManyArgs = {
  updates: Array<Supervisor_Setting_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tax_RateArgs = {
  _inc?: InputMaybe<Tax_Rate_Inc_Input>;
  _set?: InputMaybe<Tax_Rate_Set_Input>;
  where: Tax_Rate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tax_Rate_By_PkArgs = {
  _inc?: InputMaybe<Tax_Rate_Inc_Input>;
  _set?: InputMaybe<Tax_Rate_Set_Input>;
  pk_columns: Tax_Rate_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tax_Rate_ManyArgs = {
  updates: Array<Tax_Rate_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tax_TypeArgs = {
  _set?: InputMaybe<Tax_Type_Set_Input>;
  where: Tax_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tax_Type_By_PkArgs = {
  _set?: InputMaybe<Tax_Type_Set_Input>;
  pk_columns: Tax_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tax_Type_ManyArgs = {
  updates: Array<Tax_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserArgs = {
  _set?: InputMaybe<User_Set_Input>;
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_AgreementsArgs = {
  _inc?: InputMaybe<User_Agreements_Inc_Input>;
  _set?: InputMaybe<User_Agreements_Set_Input>;
  where: User_Agreements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Agreements_By_PkArgs = {
  _inc?: InputMaybe<User_Agreements_Inc_Input>;
  _set?: InputMaybe<User_Agreements_Set_Input>;
  pk_columns: User_Agreements_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Agreements_ManyArgs = {
  updates: Array<User_Agreements_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_By_PkArgs = {
  _set?: InputMaybe<User_Set_Input>;
  pk_columns: User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_ConsentArgs = {
  _set?: InputMaybe<User_Consent_Set_Input>;
  where: User_Consent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Consent_ActionArgs = {
  _set?: InputMaybe<User_Consent_Action_Set_Input>;
  where: User_Consent_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Consent_Action_By_PkArgs = {
  _set?: InputMaybe<User_Consent_Action_Set_Input>;
  pk_columns: User_Consent_Action_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Consent_Action_ManyArgs = {
  updates: Array<User_Consent_Action_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Consent_By_PkArgs = {
  _set?: InputMaybe<User_Consent_Set_Input>;
  pk_columns: User_Consent_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Consent_ManyArgs = {
  updates: Array<User_Consent_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Consent_TypeArgs = {
  _set?: InputMaybe<User_Consent_Type_Set_Input>;
  where: User_Consent_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Consent_Type_By_PkArgs = {
  _set?: InputMaybe<User_Consent_Type_Set_Input>;
  pk_columns: User_Consent_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Consent_Type_ManyArgs = {
  updates: Array<User_Consent_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Device_Push_Notification_TokenArgs = {
  _set?: InputMaybe<User_Device_Push_Notification_Token_Set_Input>;
  where: User_Device_Push_Notification_Token_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Device_Push_Notification_Token_By_PkArgs = {
  _set?: InputMaybe<User_Device_Push_Notification_Token_Set_Input>;
  pk_columns: User_Device_Push_Notification_Token_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Device_Push_Notification_Token_ManyArgs = {
  updates: Array<User_Device_Push_Notification_Token_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_DocumentArgs = {
  _set?: InputMaybe<User_Document_Set_Input>;
  where: User_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Document_By_PkArgs = {
  _set?: InputMaybe<User_Document_Set_Input>;
  pk_columns: User_Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Document_ManyArgs = {
  updates: Array<User_Document_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_LocationArgs = {
  _set?: InputMaybe<User_Location_Set_Input>;
  where: User_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Location_By_PkArgs = {
  _set?: InputMaybe<User_Location_Set_Input>;
  pk_columns: User_Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Location_ManyArgs = {
  updates: Array<User_Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ManyArgs = {
  updates: Array<User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_PlanArgs = {
  _set?: InputMaybe<User_Plan_Set_Input>;
  where: User_Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Plan_By_PkArgs = {
  _set?: InputMaybe<User_Plan_Set_Input>;
  pk_columns: User_Plan_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Plan_ManyArgs = {
  updates: Array<User_Plan_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_VersionArgs = {
  _inc?: InputMaybe<Version_Inc_Input>;
  _set?: InputMaybe<Version_Set_Input>;
  where: Version_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Version_By_PkArgs = {
  _inc?: InputMaybe<Version_Inc_Input>;
  _set?: InputMaybe<Version_Set_Input>;
  pk_columns: Version_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Version_ManyArgs = {
  updates: Array<Version_Updates>;
};


/** mutation root */
export type Mutation_RootUploadSigningTemplateSourceFileArgs = {
  object: UploadSigningTemplateSourceFileInput;
};


/** mutation root */
export type Mutation_RootUploadTmpDocumentArgs = {
  contentType: Scalars['String'];
  user: Scalars['uuid'];
};

/** columns and relationships of "notification_audit_log" */
export type Notification_Audit_Log = {
  __typename?: 'notification_audit_log';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** NULL only for notification types that are not about a location. */
  location?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  locationByLocation?: Maybe<Location>;
  notification_channel: Notification_Channel_Enum;
  notification_type: Scalars['String'];
  payload: Scalars['jsonb'];
  sent_at?: Maybe<Scalars['timestamptz']>;
  sent_to: Scalars['uuid'];
};


/** columns and relationships of "notification_audit_log" */
export type Notification_Audit_LogPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "notification_audit_log" */
export type Notification_Audit_Log_Aggregate = {
  __typename?: 'notification_audit_log_aggregate';
  aggregate?: Maybe<Notification_Audit_Log_Aggregate_Fields>;
  nodes: Array<Notification_Audit_Log>;
};

/** aggregate fields of "notification_audit_log" */
export type Notification_Audit_Log_Aggregate_Fields = {
  __typename?: 'notification_audit_log_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Notification_Audit_Log_Max_Fields>;
  min?: Maybe<Notification_Audit_Log_Min_Fields>;
};


/** aggregate fields of "notification_audit_log" */
export type Notification_Audit_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Audit_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Notification_Audit_Log_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "notification_audit_log". All fields are combined with a logical 'AND'. */
export type Notification_Audit_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Audit_Log_Bool_Exp>>;
  _not?: InputMaybe<Notification_Audit_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Audit_Log_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  notification_channel?: InputMaybe<Notification_Channel_Enum_Comparison_Exp>;
  notification_type?: InputMaybe<String_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  sent_to?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_audit_log" */
export enum Notification_Audit_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationAuditLogPkey = 'notification_audit_log_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Notification_Audit_Log_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Notification_Audit_Log_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Notification_Audit_Log_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "notification_audit_log" */
export type Notification_Audit_Log_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** NULL only for notification types that are not about a location. */
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  notification_channel?: InputMaybe<Notification_Channel_Enum>;
  notification_type?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  sent_at?: InputMaybe<Scalars['timestamptz']>;
  sent_to?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Notification_Audit_Log_Max_Fields = {
  __typename?: 'notification_audit_log_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** NULL only for notification types that are not about a location. */
  location?: Maybe<Scalars['uuid']>;
  notification_type?: Maybe<Scalars['String']>;
  sent_at?: Maybe<Scalars['timestamptz']>;
  sent_to?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Notification_Audit_Log_Min_Fields = {
  __typename?: 'notification_audit_log_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** NULL only for notification types that are not about a location. */
  location?: Maybe<Scalars['uuid']>;
  notification_type?: Maybe<Scalars['String']>;
  sent_at?: Maybe<Scalars['timestamptz']>;
  sent_to?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "notification_audit_log" */
export type Notification_Audit_Log_Mutation_Response = {
  __typename?: 'notification_audit_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Audit_Log>;
};

/** on_conflict condition type for table "notification_audit_log" */
export type Notification_Audit_Log_On_Conflict = {
  constraint: Notification_Audit_Log_Constraint;
  update_columns?: Array<Notification_Audit_Log_Update_Column>;
  where?: InputMaybe<Notification_Audit_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_audit_log". */
export type Notification_Audit_Log_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  notification_channel?: InputMaybe<Order_By>;
  notification_type?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  sent_at?: InputMaybe<Order_By>;
  sent_to?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_audit_log */
export type Notification_Audit_Log_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Notification_Audit_Log_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "notification_audit_log" */
export enum Notification_Audit_Log_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  NotificationChannel = 'notification_channel',
  /** column name */
  NotificationType = 'notification_type',
  /** column name */
  Payload = 'payload',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  SentTo = 'sent_to'
}

/** input type for updating data in table "notification_audit_log" */
export type Notification_Audit_Log_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** NULL only for notification types that are not about a location. */
  location?: InputMaybe<Scalars['uuid']>;
  notification_channel?: InputMaybe<Notification_Channel_Enum>;
  notification_type?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  sent_at?: InputMaybe<Scalars['timestamptz']>;
  sent_to?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "notification_audit_log" */
export type Notification_Audit_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Audit_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Audit_Log_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** NULL only for notification types that are not about a location. */
  location?: InputMaybe<Scalars['uuid']>;
  notification_channel?: InputMaybe<Notification_Channel_Enum>;
  notification_type?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  sent_at?: InputMaybe<Scalars['timestamptz']>;
  sent_to?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "notification_audit_log" */
export enum Notification_Audit_Log_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  NotificationChannel = 'notification_channel',
  /** column name */
  NotificationType = 'notification_type',
  /** column name */
  Payload = 'payload',
  /** column name */
  SentAt = 'sent_at',
  /** column name */
  SentTo = 'sent_to'
}

export type Notification_Audit_Log_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Notification_Audit_Log_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Notification_Audit_Log_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Notification_Audit_Log_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Notification_Audit_Log_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Notification_Audit_Log_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Audit_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notification_Audit_Log_Bool_Exp;
};

/** columns and relationships of "notification_broadcast_type" */
export type Notification_Broadcast_Type = {
  __typename?: 'notification_broadcast_type';
  type: Scalars['String'];
};

/** aggregated selection of "notification_broadcast_type" */
export type Notification_Broadcast_Type_Aggregate = {
  __typename?: 'notification_broadcast_type_aggregate';
  aggregate?: Maybe<Notification_Broadcast_Type_Aggregate_Fields>;
  nodes: Array<Notification_Broadcast_Type>;
};

/** aggregate fields of "notification_broadcast_type" */
export type Notification_Broadcast_Type_Aggregate_Fields = {
  __typename?: 'notification_broadcast_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Notification_Broadcast_Type_Max_Fields>;
  min?: Maybe<Notification_Broadcast_Type_Min_Fields>;
};


/** aggregate fields of "notification_broadcast_type" */
export type Notification_Broadcast_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Broadcast_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "notification_broadcast_type". All fields are combined with a logical 'AND'. */
export type Notification_Broadcast_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Broadcast_Type_Bool_Exp>>;
  _not?: InputMaybe<Notification_Broadcast_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Broadcast_Type_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_broadcast_type" */
export enum Notification_Broadcast_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  NotificationBroadcastTypePkey = 'notification_broadcast_type_pkey'
}

export enum Notification_Broadcast_Type_Enum {
  AllUsersOfRole = 'ALL_USERS_OF_ROLE',
  IndividualRecipient = 'INDIVIDUAL_RECIPIENT'
}

/** Boolean expression to compare columns of type "notification_broadcast_type_enum". All fields are combined with logical 'AND'. */
export type Notification_Broadcast_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Notification_Broadcast_Type_Enum>;
  _in?: InputMaybe<Array<Notification_Broadcast_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Notification_Broadcast_Type_Enum>;
  _nin?: InputMaybe<Array<Notification_Broadcast_Type_Enum>>;
};

/** input type for inserting data into table "notification_broadcast_type" */
export type Notification_Broadcast_Type_Insert_Input = {
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Notification_Broadcast_Type_Max_Fields = {
  __typename?: 'notification_broadcast_type_max_fields';
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Notification_Broadcast_Type_Min_Fields = {
  __typename?: 'notification_broadcast_type_min_fields';
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "notification_broadcast_type" */
export type Notification_Broadcast_Type_Mutation_Response = {
  __typename?: 'notification_broadcast_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Broadcast_Type>;
};

/** on_conflict condition type for table "notification_broadcast_type" */
export type Notification_Broadcast_Type_On_Conflict = {
  constraint: Notification_Broadcast_Type_Constraint;
  update_columns?: Array<Notification_Broadcast_Type_Update_Column>;
  where?: InputMaybe<Notification_Broadcast_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_broadcast_type". */
export type Notification_Broadcast_Type_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_broadcast_type */
export type Notification_Broadcast_Type_Pk_Columns_Input = {
  type: Scalars['String'];
};

/** select columns of table "notification_broadcast_type" */
export enum Notification_Broadcast_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "notification_broadcast_type" */
export type Notification_Broadcast_Type_Set_Input = {
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "notification_broadcast_type" */
export type Notification_Broadcast_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Broadcast_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Broadcast_Type_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "notification_broadcast_type" */
export enum Notification_Broadcast_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Notification_Broadcast_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Broadcast_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notification_Broadcast_Type_Bool_Exp;
};

/** columns and relationships of "notification_channel" */
export type Notification_Channel = {
  __typename?: 'notification_channel';
  name: Scalars['String'];
};

/** aggregated selection of "notification_channel" */
export type Notification_Channel_Aggregate = {
  __typename?: 'notification_channel_aggregate';
  aggregate?: Maybe<Notification_Channel_Aggregate_Fields>;
  nodes: Array<Notification_Channel>;
};

/** aggregate fields of "notification_channel" */
export type Notification_Channel_Aggregate_Fields = {
  __typename?: 'notification_channel_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Notification_Channel_Max_Fields>;
  min?: Maybe<Notification_Channel_Min_Fields>;
};


/** aggregate fields of "notification_channel" */
export type Notification_Channel_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Channel_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "notification_channel". All fields are combined with a logical 'AND'. */
export type Notification_Channel_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Channel_Bool_Exp>>;
  _not?: InputMaybe<Notification_Channel_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Channel_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_channel" */
export enum Notification_Channel_Constraint {
  /** unique or primary key constraint on columns "name" */
  NotificationChannelPkey = 'notification_channel_pkey'
}

export enum Notification_Channel_Enum {
  AppPush = 'APP_PUSH',
  Email = 'EMAIL',
  Off = 'OFF',
  RealtimePubsub = 'REALTIME_PUBSUB',
  Sms = 'SMS'
}

/** Boolean expression to compare columns of type "notification_channel_enum". All fields are combined with logical 'AND'. */
export type Notification_Channel_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Notification_Channel_Enum>;
  _in?: InputMaybe<Array<Notification_Channel_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Notification_Channel_Enum>;
  _nin?: InputMaybe<Array<Notification_Channel_Enum>>;
};

/** input type for inserting data into table "notification_channel" */
export type Notification_Channel_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Notification_Channel_Max_Fields = {
  __typename?: 'notification_channel_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Notification_Channel_Min_Fields = {
  __typename?: 'notification_channel_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "notification_channel" */
export type Notification_Channel_Mutation_Response = {
  __typename?: 'notification_channel_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Channel>;
};

/** on_conflict condition type for table "notification_channel" */
export type Notification_Channel_On_Conflict = {
  constraint: Notification_Channel_Constraint;
  update_columns?: Array<Notification_Channel_Update_Column>;
  where?: InputMaybe<Notification_Channel_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_channel". */
export type Notification_Channel_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_channel */
export type Notification_Channel_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "notification_channel" */
export enum Notification_Channel_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "notification_channel" */
export type Notification_Channel_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "notification_channel" */
export type Notification_Channel_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Channel_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Channel_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "notification_channel" */
export enum Notification_Channel_Update_Column {
  /** column name */
  Name = 'name'
}

export type Notification_Channel_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Channel_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notification_Channel_Bool_Exp;
};

/** columns and relationships of "notification_preference" */
export type Notification_Preference = {
  __typename?: 'notification_preference';
  channel: Notification_Channel_Enum;
  location: Scalars['uuid'];
  /** An object relationship */
  notificationType: Notification_Type;
  type: Scalars['String'];
  user: Scalars['uuid'];
  /** An object relationship */
  userByUser: User;
};

/** aggregated selection of "notification_preference" */
export type Notification_Preference_Aggregate = {
  __typename?: 'notification_preference_aggregate';
  aggregate?: Maybe<Notification_Preference_Aggregate_Fields>;
  nodes: Array<Notification_Preference>;
};

export type Notification_Preference_Aggregate_Bool_Exp = {
  count?: InputMaybe<Notification_Preference_Aggregate_Bool_Exp_Count>;
};

export type Notification_Preference_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Notification_Preference_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Notification_Preference_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "notification_preference" */
export type Notification_Preference_Aggregate_Fields = {
  __typename?: 'notification_preference_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Notification_Preference_Max_Fields>;
  min?: Maybe<Notification_Preference_Min_Fields>;
};


/** aggregate fields of "notification_preference" */
export type Notification_Preference_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Preference_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "notification_preference" */
export type Notification_Preference_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notification_Preference_Max_Order_By>;
  min?: InputMaybe<Notification_Preference_Min_Order_By>;
};

/** input type for inserting array relation for remote table "notification_preference" */
export type Notification_Preference_Arr_Rel_Insert_Input = {
  data: Array<Notification_Preference_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Notification_Preference_On_Conflict>;
};

/** Boolean expression to filter rows from the table "notification_preference". All fields are combined with a logical 'AND'. */
export type Notification_Preference_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Preference_Bool_Exp>>;
  _not?: InputMaybe<Notification_Preference_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Preference_Bool_Exp>>;
  channel?: InputMaybe<Notification_Channel_Enum_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  notificationType?: InputMaybe<Notification_Type_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Uuid_Comparison_Exp>;
  userByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "notification_preference" */
export enum Notification_Preference_Constraint {
  /** unique or primary key constraint on columns "type", "user", "channel", "location" */
  NotificationPreferencePkey = 'notification_preference_pkey'
}

/** input type for inserting data into table "notification_preference" */
export type Notification_Preference_Insert_Input = {
  channel?: InputMaybe<Notification_Channel_Enum>;
  location?: InputMaybe<Scalars['uuid']>;
  notificationType?: InputMaybe<Notification_Type_Obj_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['uuid']>;
  userByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Notification_Preference_Max_Fields = {
  __typename?: 'notification_preference_max_fields';
  location?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "notification_preference" */
export type Notification_Preference_Max_Order_By = {
  location?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Notification_Preference_Min_Fields = {
  __typename?: 'notification_preference_min_fields';
  location?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "notification_preference" */
export type Notification_Preference_Min_Order_By = {
  location?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notification_preference" */
export type Notification_Preference_Mutation_Response = {
  __typename?: 'notification_preference_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Preference>;
};

/** on_conflict condition type for table "notification_preference" */
export type Notification_Preference_On_Conflict = {
  constraint: Notification_Preference_Constraint;
  update_columns?: Array<Notification_Preference_Update_Column>;
  where?: InputMaybe<Notification_Preference_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_preference". */
export type Notification_Preference_Order_By = {
  channel?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  notificationType?: InputMaybe<Notification_Type_Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  userByUser?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: notification_preference */
export type Notification_Preference_Pk_Columns_Input = {
  channel: Notification_Channel_Enum;
  location: Scalars['uuid'];
  type: Scalars['String'];
  user: Scalars['uuid'];
};

/** select columns of table "notification_preference" */
export enum Notification_Preference_Select_Column {
  /** column name */
  Channel = 'channel',
  /** column name */
  Location = 'location',
  /** column name */
  Type = 'type',
  /** column name */
  User = 'user'
}

/** input type for updating data in table "notification_preference" */
export type Notification_Preference_Set_Input = {
  channel?: InputMaybe<Notification_Channel_Enum>;
  location?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "notification_preference" */
export type Notification_Preference_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Preference_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Preference_Stream_Cursor_Value_Input = {
  channel?: InputMaybe<Notification_Channel_Enum>;
  location?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "notification_preference" */
export enum Notification_Preference_Update_Column {
  /** column name */
  Channel = 'channel',
  /** column name */
  Location = 'location',
  /** column name */
  Type = 'type',
  /** column name */
  User = 'user'
}

export type Notification_Preference_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Preference_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notification_Preference_Bool_Exp;
};

/** columns and relationships of "notification_type" */
export type Notification_Type = {
  __typename?: 'notification_type';
  /** When true, will not appear in notification preferences when location booking is_allowed is false */
  hideIfBookingNotAllowed: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  notificationPreferences: Array<Notification_Preference>;
  /** An aggregate relationship */
  notificationPreferences_aggregate: Notification_Preference_Aggregate;
  /** An array relationship */
  roleNotifications: Array<Role_Notification>;
  /** An aggregate relationship */
  roleNotifications_aggregate: Role_Notification_Aggregate;
};


/** columns and relationships of "notification_type" */
export type Notification_TypeNotificationPreferencesArgs = {
  distinct_on?: InputMaybe<Array<Notification_Preference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Preference_Order_By>>;
  where?: InputMaybe<Notification_Preference_Bool_Exp>;
};


/** columns and relationships of "notification_type" */
export type Notification_TypeNotificationPreferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Preference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Preference_Order_By>>;
  where?: InputMaybe<Notification_Preference_Bool_Exp>;
};


/** columns and relationships of "notification_type" */
export type Notification_TypeRoleNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Role_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Notification_Order_By>>;
  where?: InputMaybe<Role_Notification_Bool_Exp>;
};


/** columns and relationships of "notification_type" */
export type Notification_TypeRoleNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Notification_Order_By>>;
  where?: InputMaybe<Role_Notification_Bool_Exp>;
};

/** aggregated selection of "notification_type" */
export type Notification_Type_Aggregate = {
  __typename?: 'notification_type_aggregate';
  aggregate?: Maybe<Notification_Type_Aggregate_Fields>;
  nodes: Array<Notification_Type>;
};

/** aggregate fields of "notification_type" */
export type Notification_Type_Aggregate_Fields = {
  __typename?: 'notification_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Notification_Type_Max_Fields>;
  min?: Maybe<Notification_Type_Min_Fields>;
};


/** aggregate fields of "notification_type" */
export type Notification_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "notification_type". All fields are combined with a logical 'AND'. */
export type Notification_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Type_Bool_Exp>>;
  _not?: InputMaybe<Notification_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Type_Bool_Exp>>;
  hideIfBookingNotAllowed?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notificationPreferences?: InputMaybe<Notification_Preference_Bool_Exp>;
  notificationPreferences_aggregate?: InputMaybe<Notification_Preference_Aggregate_Bool_Exp>;
  roleNotifications?: InputMaybe<Role_Notification_Bool_Exp>;
  roleNotifications_aggregate?: InputMaybe<Role_Notification_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "notification_type" */
export enum Notification_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  NotificationTypePkey = 'notification_type_pkey'
}

/** columns and relationships of "notification_type_default_channel" */
export type Notification_Type_Default_Channel = {
  __typename?: 'notification_type_default_channel';
  channel: Notification_Channel_Enum;
  type: Scalars['String'];
};

/** aggregated selection of "notification_type_default_channel" */
export type Notification_Type_Default_Channel_Aggregate = {
  __typename?: 'notification_type_default_channel_aggregate';
  aggregate?: Maybe<Notification_Type_Default_Channel_Aggregate_Fields>;
  nodes: Array<Notification_Type_Default_Channel>;
};

/** aggregate fields of "notification_type_default_channel" */
export type Notification_Type_Default_Channel_Aggregate_Fields = {
  __typename?: 'notification_type_default_channel_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Notification_Type_Default_Channel_Max_Fields>;
  min?: Maybe<Notification_Type_Default_Channel_Min_Fields>;
};


/** aggregate fields of "notification_type_default_channel" */
export type Notification_Type_Default_Channel_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Type_Default_Channel_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "notification_type_default_channel". All fields are combined with a logical 'AND'. */
export type Notification_Type_Default_Channel_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Type_Default_Channel_Bool_Exp>>;
  _not?: InputMaybe<Notification_Type_Default_Channel_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Type_Default_Channel_Bool_Exp>>;
  channel?: InputMaybe<Notification_Channel_Enum_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_type_default_channel" */
export enum Notification_Type_Default_Channel_Constraint {
  /** unique or primary key constraint on columns "type", "channel" */
  NotificationTypeDefaultChannelPkey = 'notification_type_default_channel_pkey'
}

/** input type for inserting data into table "notification_type_default_channel" */
export type Notification_Type_Default_Channel_Insert_Input = {
  channel?: InputMaybe<Notification_Channel_Enum>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Notification_Type_Default_Channel_Max_Fields = {
  __typename?: 'notification_type_default_channel_max_fields';
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Notification_Type_Default_Channel_Min_Fields = {
  __typename?: 'notification_type_default_channel_min_fields';
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "notification_type_default_channel" */
export type Notification_Type_Default_Channel_Mutation_Response = {
  __typename?: 'notification_type_default_channel_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Type_Default_Channel>;
};

/** on_conflict condition type for table "notification_type_default_channel" */
export type Notification_Type_Default_Channel_On_Conflict = {
  constraint: Notification_Type_Default_Channel_Constraint;
  update_columns?: Array<Notification_Type_Default_Channel_Update_Column>;
  where?: InputMaybe<Notification_Type_Default_Channel_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_type_default_channel". */
export type Notification_Type_Default_Channel_Order_By = {
  channel?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_type_default_channel */
export type Notification_Type_Default_Channel_Pk_Columns_Input = {
  channel: Notification_Channel_Enum;
  type: Scalars['String'];
};

/** select columns of table "notification_type_default_channel" */
export enum Notification_Type_Default_Channel_Select_Column {
  /** column name */
  Channel = 'channel',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "notification_type_default_channel" */
export type Notification_Type_Default_Channel_Set_Input = {
  channel?: InputMaybe<Notification_Channel_Enum>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "notification_type_default_channel" */
export type Notification_Type_Default_Channel_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Type_Default_Channel_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Type_Default_Channel_Stream_Cursor_Value_Input = {
  channel?: InputMaybe<Notification_Channel_Enum>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "notification_type_default_channel" */
export enum Notification_Type_Default_Channel_Update_Column {
  /** column name */
  Channel = 'channel',
  /** column name */
  Type = 'type'
}

export type Notification_Type_Default_Channel_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Type_Default_Channel_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notification_Type_Default_Channel_Bool_Exp;
};

/** input type for inserting data into table "notification_type" */
export type Notification_Type_Insert_Input = {
  /** When true, will not appear in notification preferences when location booking is_allowed is false */
  hideIfBookingNotAllowed?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationPreferences?: InputMaybe<Notification_Preference_Arr_Rel_Insert_Input>;
  roleNotifications?: InputMaybe<Role_Notification_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Notification_Type_Max_Fields = {
  __typename?: 'notification_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Notification_Type_Min_Fields = {
  __typename?: 'notification_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "notification_type" */
export type Notification_Type_Mutation_Response = {
  __typename?: 'notification_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Type>;
};

/** input type for inserting object relation for remote table "notification_type" */
export type Notification_Type_Obj_Rel_Insert_Input = {
  data: Notification_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Notification_Type_On_Conflict>;
};

/** on_conflict condition type for table "notification_type" */
export type Notification_Type_On_Conflict = {
  constraint: Notification_Type_Constraint;
  update_columns?: Array<Notification_Type_Update_Column>;
  where?: InputMaybe<Notification_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_type". */
export type Notification_Type_Order_By = {
  hideIfBookingNotAllowed?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notificationPreferences_aggregate?: InputMaybe<Notification_Preference_Aggregate_Order_By>;
  roleNotifications_aggregate?: InputMaybe<Role_Notification_Aggregate_Order_By>;
};

/** primary key columns input for table: notification_type */
export type Notification_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "notification_type" */
export enum Notification_Type_Select_Column {
  /** column name */
  HideIfBookingNotAllowed = 'hideIfBookingNotAllowed',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "notification_type" */
export type Notification_Type_Set_Input = {
  /** When true, will not appear in notification preferences when location booking is_allowed is false */
  hideIfBookingNotAllowed?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "notification_type" */
export type Notification_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Type_Stream_Cursor_Value_Input = {
  /** When true, will not appear in notification preferences when location booking is_allowed is false */
  hideIfBookingNotAllowed?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "notification_type" */
export enum Notification_Type_Update_Column {
  /** column name */
  HideIfBookingNotAllowed = 'hideIfBookingNotAllowed',
  /** column name */
  Name = 'name'
}

export type Notification_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notification_Type_Bool_Exp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['numeric']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['numeric']>>;
  _eq?: InputMaybe<Array<Scalars['numeric']>>;
  _gt?: InputMaybe<Array<Scalars['numeric']>>;
  _gte?: InputMaybe<Array<Scalars['numeric']>>;
  _in?: InputMaybe<Array<Array<Scalars['numeric']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['numeric']>>;
  _lte?: InputMaybe<Array<Scalars['numeric']>>;
  _neq?: InputMaybe<Array<Scalars['numeric']>>;
  _nin?: InputMaybe<Array<Array<Scalars['numeric']>>>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** columns and relationships of "open" */
export type Open = {
  __typename?: 'open';
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  repeating?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  repeatingByRepeating?: Maybe<Repeating>;
  timespan: Scalars['tstzrange'];
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "open_upper_start" */
  timespan_upper?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "open" */
export type Open_Aggregate = {
  __typename?: 'open_aggregate';
  aggregate?: Maybe<Open_Aggregate_Fields>;
  nodes: Array<Open>;
};

export type Open_Aggregate_Bool_Exp = {
  count?: InputMaybe<Open_Aggregate_Bool_Exp_Count>;
};

export type Open_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Open_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Open_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "open" */
export type Open_Aggregate_Fields = {
  __typename?: 'open_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Open_Max_Fields>;
  min?: Maybe<Open_Min_Fields>;
};


/** aggregate fields of "open" */
export type Open_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Open_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "open" */
export type Open_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Open_Max_Order_By>;
  min?: InputMaybe<Open_Min_Order_By>;
};

/** input type for inserting array relation for remote table "open" */
export type Open_Arr_Rel_Insert_Input = {
  data: Array<Open_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Open_On_Conflict>;
};

/** Boolean expression to filter rows from the table "open". All fields are combined with a logical 'AND'. */
export type Open_Bool_Exp = {
  _and?: InputMaybe<Array<Open_Bool_Exp>>;
  _not?: InputMaybe<Open_Bool_Exp>;
  _or?: InputMaybe<Array<Open_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  repeating?: InputMaybe<Uuid_Comparison_Exp>;
  repeatingByRepeating?: InputMaybe<Repeating_Bool_Exp>;
  timespan?: InputMaybe<Tstzrange_Comparison_Exp>;
  timespan_lower?: InputMaybe<Timestamptz_Comparison_Exp>;
  timespan_upper?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "open" */
export enum Open_Constraint {
  /** unique or primary key constraint on columns "id" */
  OpenPkey = 'open_pkey'
}

/** input type for inserting data into table "open" */
export type Open_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  repeating?: InputMaybe<Scalars['uuid']>;
  repeatingByRepeating?: InputMaybe<Repeating_Obj_Rel_Insert_Input>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
};

/** aggregate max on columns */
export type Open_Max_Fields = {
  __typename?: 'open_max_fields';
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  repeating?: Maybe<Scalars['uuid']>;
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "open_upper_start" */
  timespan_upper?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "open" */
export type Open_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  repeating?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Open_Min_Fields = {
  __typename?: 'open_min_fields';
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  repeating?: Maybe<Scalars['uuid']>;
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "open_upper_start" */
  timespan_upper?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "open" */
export type Open_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  repeating?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "open" */
export type Open_Mutation_Response = {
  __typename?: 'open_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Open>;
};

/** on_conflict condition type for table "open" */
export type Open_On_Conflict = {
  constraint: Open_Constraint;
  update_columns?: Array<Open_Update_Column>;
  where?: InputMaybe<Open_Bool_Exp>;
};

/** Ordering options when selecting data from "open". */
export type Open_Order_By = {
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  repeating?: InputMaybe<Order_By>;
  repeatingByRepeating?: InputMaybe<Repeating_Order_By>;
  timespan?: InputMaybe<Order_By>;
  timespan_lower?: InputMaybe<Order_By>;
  timespan_upper?: InputMaybe<Order_By>;
};

/** primary key columns input for table: open */
export type Open_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "open" */
export enum Open_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Repeating = 'repeating',
  /** column name */
  Timespan = 'timespan'
}

/** input type for updating data in table "open" */
export type Open_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  repeating?: InputMaybe<Scalars['uuid']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
};

/** Streaming cursor of the table "open" */
export type Open_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Open_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Open_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  repeating?: InputMaybe<Scalars['uuid']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
};

/** update columns of table "open" */
export enum Open_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Repeating = 'repeating',
  /** column name */
  Timespan = 'timespan'
}

export type Open_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Open_Set_Input>;
  /** filter the rows which have to be updated */
  where: Open_Bool_Exp;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "partner" */
export type Partner = {
  __typename?: 'partner';
  chargeUserPaymentMethod?: Maybe<Scalars['String']>;
  /** An array relationship */
  ehrSubscriptions: Array<Ehr_Subscription>;
  /** An aggregate relationship */
  ehrSubscriptions_aggregate: Ehr_Subscription_Aggregate;
  id: Scalars['uuid'];
  isVansanity: Scalars['Boolean'];
  /** An array relationship */
  locations: Array<Location>;
  /** An aggregate relationship */
  locations_aggregate: Location_Aggregate;
  logoS3Key?: Maybe<Scalars['uuid']>;
  msoMode: Mso_Mode_Enum;
  msoTier: Mso_Tier_Enum;
  name: Scalars['String'];
  primaryColor: Scalars['String'];
  /** MSO only supports product purchasing and only by owner. These MSOs are hidden from location selection during onboarding, and patient-initiated booking is refused at their locations. */
  productOnly: Scalars['Boolean'];
  secondaryColor: Scalars['String'];
  stripeAccountId: Scalars['String'];
  /** Stripe id of user to charge when MSO needs to be charged. */
  stripeUserToCharge?: Maybe<Scalars['String']>;
  /** An object relationship */
  tierByMsoTier?: Maybe<Mso_Tier>;
};


/** columns and relationships of "partner" */
export type PartnerEhrSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerEhrSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerLocationsArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


/** columns and relationships of "partner" */
export type PartnerLocations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};

/** aggregated selection of "partner" */
export type Partner_Aggregate = {
  __typename?: 'partner_aggregate';
  aggregate?: Maybe<Partner_Aggregate_Fields>;
  nodes: Array<Partner>;
};

/** aggregate fields of "partner" */
export type Partner_Aggregate_Fields = {
  __typename?: 'partner_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Partner_Max_Fields>;
  min?: Maybe<Partner_Min_Fields>;
};


/** aggregate fields of "partner" */
export type Partner_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "partner_basic" */
export type Partner_Basic = {
  __typename?: 'partner_basic';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "partner_basic" */
export type Partner_Basic_Aggregate = {
  __typename?: 'partner_basic_aggregate';
  aggregate?: Maybe<Partner_Basic_Aggregate_Fields>;
  nodes: Array<Partner_Basic>;
};

/** aggregate fields of "partner_basic" */
export type Partner_Basic_Aggregate_Fields = {
  __typename?: 'partner_basic_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Partner_Basic_Max_Fields>;
  min?: Maybe<Partner_Basic_Min_Fields>;
};


/** aggregate fields of "partner_basic" */
export type Partner_Basic_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Basic_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "partner_basic". All fields are combined with a logical 'AND'. */
export type Partner_Basic_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Basic_Bool_Exp>>;
  _not?: InputMaybe<Partner_Basic_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Basic_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "partner_basic" */
export type Partner_Basic_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Partner_Basic_Max_Fields = {
  __typename?: 'partner_basic_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Partner_Basic_Min_Fields = {
  __typename?: 'partner_basic_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "partner_basic" */
export type Partner_Basic_Mutation_Response = {
  __typename?: 'partner_basic_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner_Basic>;
};

/** Ordering options when selecting data from "partner_basic". */
export type Partner_Basic_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "partner_basic" */
export enum Partner_Basic_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "partner_basic" */
export type Partner_Basic_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "partner_basic" */
export type Partner_Basic_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Basic_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Basic_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Partner_Basic_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Basic_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Basic_Bool_Exp;
};

/** Boolean expression to filter rows from the table "partner". All fields are combined with a logical 'AND'. */
export type Partner_Bool_Exp = {
  _and?: InputMaybe<Array<Partner_Bool_Exp>>;
  _not?: InputMaybe<Partner_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Bool_Exp>>;
  chargeUserPaymentMethod?: InputMaybe<String_Comparison_Exp>;
  ehrSubscriptions?: InputMaybe<Ehr_Subscription_Bool_Exp>;
  ehrSubscriptions_aggregate?: InputMaybe<Ehr_Subscription_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isVansanity?: InputMaybe<Boolean_Comparison_Exp>;
  locations?: InputMaybe<Location_Bool_Exp>;
  locations_aggregate?: InputMaybe<Location_Aggregate_Bool_Exp>;
  logoS3Key?: InputMaybe<Uuid_Comparison_Exp>;
  msoMode?: InputMaybe<Mso_Mode_Enum_Comparison_Exp>;
  msoTier?: InputMaybe<Mso_Tier_Enum_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  primaryColor?: InputMaybe<String_Comparison_Exp>;
  productOnly?: InputMaybe<Boolean_Comparison_Exp>;
  secondaryColor?: InputMaybe<String_Comparison_Exp>;
  stripeAccountId?: InputMaybe<String_Comparison_Exp>;
  stripeUserToCharge?: InputMaybe<String_Comparison_Exp>;
  tierByMsoTier?: InputMaybe<Mso_Tier_Bool_Exp>;
};

/** unique or primary key constraints on table "partner" */
export enum Partner_Constraint {
  /** unique or primary key constraint on columns "is_vansanity" */
  OnlyOneVansanity = 'only_one_vansanity',
  /** unique or primary key constraint on columns "id" */
  PartnerPkey = 'partner_pkey',
  /** unique or primary key constraint on columns "stripe_account_id" */
  PartnerStripeAccountIdKey = 'partner_stripe_account_id_key'
}

/** input type for inserting data into table "partner" */
export type Partner_Insert_Input = {
  chargeUserPaymentMethod?: InputMaybe<Scalars['String']>;
  ehrSubscriptions?: InputMaybe<Ehr_Subscription_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  isVansanity?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Location_Arr_Rel_Insert_Input>;
  logoS3Key?: InputMaybe<Scalars['uuid']>;
  msoMode?: InputMaybe<Mso_Mode_Enum>;
  msoTier?: InputMaybe<Mso_Tier_Enum>;
  name?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  /** MSO only supports product purchasing and only by owner. These MSOs are hidden from location selection during onboarding, and patient-initiated booking is refused at their locations. */
  productOnly?: InputMaybe<Scalars['Boolean']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
  stripeAccountId?: InputMaybe<Scalars['String']>;
  /** Stripe id of user to charge when MSO needs to be charged. */
  stripeUserToCharge?: InputMaybe<Scalars['String']>;
  tierByMsoTier?: InputMaybe<Mso_Tier_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Partner_Max_Fields = {
  __typename?: 'partner_max_fields';
  chargeUserPaymentMethod?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  logoS3Key?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  stripeAccountId?: Maybe<Scalars['String']>;
  /** Stripe id of user to charge when MSO needs to be charged. */
  stripeUserToCharge?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Partner_Min_Fields = {
  __typename?: 'partner_min_fields';
  chargeUserPaymentMethod?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  logoS3Key?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  stripeAccountId?: Maybe<Scalars['String']>;
  /** Stripe id of user to charge when MSO needs to be charged. */
  stripeUserToCharge?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "partner" */
export type Partner_Mutation_Response = {
  __typename?: 'partner_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner>;
};

/** input type for inserting object relation for remote table "partner" */
export type Partner_Obj_Rel_Insert_Input = {
  data: Partner_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_On_Conflict>;
};

/** on_conflict condition type for table "partner" */
export type Partner_On_Conflict = {
  constraint: Partner_Constraint;
  update_columns?: Array<Partner_Update_Column>;
  where?: InputMaybe<Partner_Bool_Exp>;
};

/** Ordering options when selecting data from "partner". */
export type Partner_Order_By = {
  chargeUserPaymentMethod?: InputMaybe<Order_By>;
  ehrSubscriptions_aggregate?: InputMaybe<Ehr_Subscription_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  isVansanity?: InputMaybe<Order_By>;
  locations_aggregate?: InputMaybe<Location_Aggregate_Order_By>;
  logoS3Key?: InputMaybe<Order_By>;
  msoMode?: InputMaybe<Order_By>;
  msoTier?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  primaryColor?: InputMaybe<Order_By>;
  productOnly?: InputMaybe<Order_By>;
  secondaryColor?: InputMaybe<Order_By>;
  stripeAccountId?: InputMaybe<Order_By>;
  stripeUserToCharge?: InputMaybe<Order_By>;
  tierByMsoTier?: InputMaybe<Mso_Tier_Order_By>;
};

/** primary key columns input for table: partner */
export type Partner_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "partner" */
export enum Partner_Select_Column {
  /** column name */
  ChargeUserPaymentMethod = 'chargeUserPaymentMethod',
  /** column name */
  Id = 'id',
  /** column name */
  IsVansanity = 'isVansanity',
  /** column name */
  LogoS3Key = 'logoS3Key',
  /** column name */
  MsoMode = 'msoMode',
  /** column name */
  MsoTier = 'msoTier',
  /** column name */
  Name = 'name',
  /** column name */
  PrimaryColor = 'primaryColor',
  /** column name */
  ProductOnly = 'productOnly',
  /** column name */
  SecondaryColor = 'secondaryColor',
  /** column name */
  StripeAccountId = 'stripeAccountId',
  /** column name */
  StripeUserToCharge = 'stripeUserToCharge'
}

/** input type for updating data in table "partner" */
export type Partner_Set_Input = {
  chargeUserPaymentMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isVansanity?: InputMaybe<Scalars['Boolean']>;
  logoS3Key?: InputMaybe<Scalars['uuid']>;
  msoMode?: InputMaybe<Mso_Mode_Enum>;
  msoTier?: InputMaybe<Mso_Tier_Enum>;
  name?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  /** MSO only supports product purchasing and only by owner. These MSOs are hidden from location selection during onboarding, and patient-initiated booking is refused at their locations. */
  productOnly?: InputMaybe<Scalars['Boolean']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
  stripeAccountId?: InputMaybe<Scalars['String']>;
  /** Stripe id of user to charge when MSO needs to be charged. */
  stripeUserToCharge?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "partner" */
export type Partner_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Partner_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Partner_Stream_Cursor_Value_Input = {
  chargeUserPaymentMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isVansanity?: InputMaybe<Scalars['Boolean']>;
  logoS3Key?: InputMaybe<Scalars['uuid']>;
  msoMode?: InputMaybe<Mso_Mode_Enum>;
  msoTier?: InputMaybe<Mso_Tier_Enum>;
  name?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  /** MSO only supports product purchasing and only by owner. These MSOs are hidden from location selection during onboarding, and patient-initiated booking is refused at their locations. */
  productOnly?: InputMaybe<Scalars['Boolean']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
  stripeAccountId?: InputMaybe<Scalars['String']>;
  /** Stripe id of user to charge when MSO needs to be charged. */
  stripeUserToCharge?: InputMaybe<Scalars['String']>;
};

/** update columns of table "partner" */
export enum Partner_Update_Column {
  /** column name */
  ChargeUserPaymentMethod = 'chargeUserPaymentMethod',
  /** column name */
  Id = 'id',
  /** column name */
  IsVansanity = 'isVansanity',
  /** column name */
  LogoS3Key = 'logoS3Key',
  /** column name */
  MsoMode = 'msoMode',
  /** column name */
  MsoTier = 'msoTier',
  /** column name */
  Name = 'name',
  /** column name */
  PrimaryColor = 'primaryColor',
  /** column name */
  ProductOnly = 'productOnly',
  /** column name */
  SecondaryColor = 'secondaryColor',
  /** column name */
  StripeAccountId = 'stripeAccountId',
  /** column name */
  StripeUserToCharge = 'stripeUserToCharge'
}

export type Partner_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Partner_Set_Input>;
  /** filter the rows which have to be updated */
  where: Partner_Bool_Exp;
};

/** columns and relationships of "patient" */
export type Patient = {
  __typename?: 'patient';
  address: Scalars['uuid'];
  /** An object relationship */
  addressByAddress: Address;
  /** Patient-pool Cognito user sub: the verified login identity durably linked to this record. Set at registration completion; NULL = no patient account. */
  cognitoSub?: Maybe<Scalars['uuid']>;
  /** Opaque Cognito username for this patient, rotated on every invite. Deliberately NOT the primary key and never PHI: it travels to Cognito, its logs, and the portal. */
  cognitoUsername?: Maybe<Scalars['uuid']>;
  consentToContact: Scalars['Boolean'];
  createdAt: Scalars['timestamptz'];
  credentialEpoch: Scalars['Int'];
  dateOfBirth: Scalars['date'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** occurred_at of the patient's newest consent event of the given consentType iff it is GRANTED, else null (never granted, or revoked since). Raises on an unknown consent type so a typo cannot masquerade as no-consent. */
  ehrConsentedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  ehrEncounters: Array<Ehr_Encounter>;
  /** An aggregate relationship */
  ehrEncounters_aggregate: Ehr_Encounter_Aggregate;
  /** An array relationship */
  ehrPatientCards: Array<Ehr_Patient_Card>;
  /** An aggregate relationship */
  ehrPatientCards_aggregate: Ehr_Patient_Card_Aggregate;
  /** An array relationship */
  ehrPatientConsents: Array<Ehr_Patient_Consent>;
  /** An aggregate relationship */
  ehrPatientConsents_aggregate: Ehr_Patient_Consent_Aggregate;
  email: Scalars['String'];
  emergencyContactName?: Maybe<Scalars['String']>;
  emergencyContactPhoneNumber?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender: Gender_Enum;
  /** An object relationship */
  genderByGender: Gender;
  genderNotes?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  lastName: Scalars['String'];
  /** If a medspa, everyone at the spa has access */
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  mobilePhoneNumber: Scalars['String'];
  nickname?: Maybe<Scalars['String']>;
  /** An array relationship */
  patientLastViews: Array<Patient_Last_View>;
  /** An aggregate relationship */
  patientLastViews_aggregate: Patient_Last_View_Aggregate;
  /** An array relationship */
  patientMedicalProfiles: Array<Patient_Medical_Profile>;
  /** An aggregate relationship */
  patientMedicalProfiles_aggregate: Patient_Medical_Profile_Aggregate;
  priorSquareCustomerIds: Array<Scalars['String']>;
  profilePhotoS3Key?: Maybe<Scalars['uuid']>;
  /** Creating provider (not the owner if a medspa location) */
  provider: Scalars['uuid'];
  /** An object relationship */
  providerByProvider: User;
  /** An array relationship */
  registrationInvites: Array<Patient_Registration_Invite>;
  /** An aggregate relationship */
  registrationInvites_aggregate: Patient_Registration_Invite_Aggregate;
  sessionsValidFrom?: Maybe<Scalars['timestamptz']>;
  sex: Sex_Enum;
  /** An object relationship */
  sexBySex: Sex;
  /** An array relationship */
  signingDocuments: Array<Signing_Document>;
  /** An aggregate relationship */
  signingDocuments_aggregate: Signing_Document_Aggregate;
  squareCustomerId?: Maybe<Scalars['String']>;
  stickyNotes?: Maybe<Scalars['String']>;
  /** True iff calling supervisor has an active relationship with this patient's provider AND patient.location is among that provider's current user_locations. */
  visibleToSupervisor?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  webauthnCredentials: Array<Patient_Webauthn_Credential>;
  /** An aggregate relationship */
  webauthnCredentials_aggregate: Patient_Webauthn_Credential_Aggregate;
};


/** columns and relationships of "patient" */
export type PatientEhrConsentedAtArgs = {
  args: EhrConsentedAt_Patient_Args;
};


/** columns and relationships of "patient" */
export type PatientEhrEncountersArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Bool_Exp>;
};


/** columns and relationships of "patient" */
export type PatientEhrEncounters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Bool_Exp>;
};


/** columns and relationships of "patient" */
export type PatientEhrPatientCardsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Card_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Card_Bool_Exp>;
};


/** columns and relationships of "patient" */
export type PatientEhrPatientCards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Card_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Card_Bool_Exp>;
};


/** columns and relationships of "patient" */
export type PatientEhrPatientConsentsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Consent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Consent_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Consent_Bool_Exp>;
};


/** columns and relationships of "patient" */
export type PatientEhrPatientConsents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Consent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Consent_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Consent_Bool_Exp>;
};


/** columns and relationships of "patient" */
export type PatientPatientLastViewsArgs = {
  distinct_on?: InputMaybe<Array<Patient_Last_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Last_View_Order_By>>;
  where?: InputMaybe<Patient_Last_View_Bool_Exp>;
};


/** columns and relationships of "patient" */
export type PatientPatientLastViews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Last_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Last_View_Order_By>>;
  where?: InputMaybe<Patient_Last_View_Bool_Exp>;
};


/** columns and relationships of "patient" */
export type PatientPatientMedicalProfilesArgs = {
  distinct_on?: InputMaybe<Array<Patient_Medical_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Medical_Profile_Order_By>>;
  where?: InputMaybe<Patient_Medical_Profile_Bool_Exp>;
};


/** columns and relationships of "patient" */
export type PatientPatientMedicalProfiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Medical_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Medical_Profile_Order_By>>;
  where?: InputMaybe<Patient_Medical_Profile_Bool_Exp>;
};


/** columns and relationships of "patient" */
export type PatientRegistrationInvitesArgs = {
  distinct_on?: InputMaybe<Array<Patient_Registration_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Registration_Invite_Order_By>>;
  where?: InputMaybe<Patient_Registration_Invite_Bool_Exp>;
};


/** columns and relationships of "patient" */
export type PatientRegistrationInvites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Registration_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Registration_Invite_Order_By>>;
  where?: InputMaybe<Patient_Registration_Invite_Bool_Exp>;
};


/** columns and relationships of "patient" */
export type PatientSigningDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Signing_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Document_Order_By>>;
  where?: InputMaybe<Signing_Document_Bool_Exp>;
};


/** columns and relationships of "patient" */
export type PatientSigningDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Document_Order_By>>;
  where?: InputMaybe<Signing_Document_Bool_Exp>;
};


/** columns and relationships of "patient" */
export type PatientWebauthnCredentialsArgs = {
  distinct_on?: InputMaybe<Array<Patient_Webauthn_Credential_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Webauthn_Credential_Order_By>>;
  where?: InputMaybe<Patient_Webauthn_Credential_Bool_Exp>;
};


/** columns and relationships of "patient" */
export type PatientWebauthnCredentials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Webauthn_Credential_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Webauthn_Credential_Order_By>>;
  where?: InputMaybe<Patient_Webauthn_Credential_Bool_Exp>;
};

/** Append-only audit trail for patient account lifecycle: invite sent (actor_user = inviting staff member), registration completed, passkey added/removed. */
export type Patient_Account_Event = {
  __typename?: 'patient_account_event';
  actorUser?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  eventType: Patient_Account_Event_Type_Enum;
  id: Scalars['uuid'];
  patient: Scalars['uuid'];
  /** An object relationship */
  patientByPatient: Patient;
  payload: Scalars['jsonb'];
  /** An object relationship */
  userByActorUser?: Maybe<User>;
};


/** Append-only audit trail for patient account lifecycle: invite sent (actor_user = inviting staff member), registration completed, passkey added/removed. */
export type Patient_Account_EventPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "patient_account_event" */
export type Patient_Account_Event_Aggregate = {
  __typename?: 'patient_account_event_aggregate';
  aggregate?: Maybe<Patient_Account_Event_Aggregate_Fields>;
  nodes: Array<Patient_Account_Event>;
};

/** aggregate fields of "patient_account_event" */
export type Patient_Account_Event_Aggregate_Fields = {
  __typename?: 'patient_account_event_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Patient_Account_Event_Max_Fields>;
  min?: Maybe<Patient_Account_Event_Min_Fields>;
};


/** aggregate fields of "patient_account_event" */
export type Patient_Account_Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Patient_Account_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Patient_Account_Event_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "patient_account_event". All fields are combined with a logical 'AND'. */
export type Patient_Account_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Patient_Account_Event_Bool_Exp>>;
  _not?: InputMaybe<Patient_Account_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Patient_Account_Event_Bool_Exp>>;
  actorUser?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  eventType?: InputMaybe<Patient_Account_Event_Type_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  patient?: InputMaybe<Uuid_Comparison_Exp>;
  patientByPatient?: InputMaybe<Patient_Bool_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  userByActorUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "patient_account_event" */
export enum Patient_Account_Event_Constraint {
  /** unique or primary key constraint on columns "id" */
  PatientAccountEventPkey = 'patient_account_event_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Patient_Account_Event_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Patient_Account_Event_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Patient_Account_Event_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "patient_account_event" */
export type Patient_Account_Event_Insert_Input = {
  actorUser?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  eventType?: InputMaybe<Patient_Account_Event_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  patientByPatient?: InputMaybe<Patient_Obj_Rel_Insert_Input>;
  payload?: InputMaybe<Scalars['jsonb']>;
  userByActorUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Patient_Account_Event_Max_Fields = {
  __typename?: 'patient_account_event_max_fields';
  actorUser?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  patient?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Patient_Account_Event_Min_Fields = {
  __typename?: 'patient_account_event_min_fields';
  actorUser?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  patient?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "patient_account_event" */
export type Patient_Account_Event_Mutation_Response = {
  __typename?: 'patient_account_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient_Account_Event>;
};

/** on_conflict condition type for table "patient_account_event" */
export type Patient_Account_Event_On_Conflict = {
  constraint: Patient_Account_Event_Constraint;
  update_columns?: Array<Patient_Account_Event_Update_Column>;
  where?: InputMaybe<Patient_Account_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "patient_account_event". */
export type Patient_Account_Event_Order_By = {
  actorUser?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  eventType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  patientByPatient?: InputMaybe<Patient_Order_By>;
  payload?: InputMaybe<Order_By>;
  userByActorUser?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: patient_account_event */
export type Patient_Account_Event_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Patient_Account_Event_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "patient_account_event" */
export enum Patient_Account_Event_Select_Column {
  /** column name */
  ActorUser = 'actorUser',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EventType = 'eventType',
  /** column name */
  Id = 'id',
  /** column name */
  Patient = 'patient',
  /** column name */
  Payload = 'payload'
}

/** input type for updating data in table "patient_account_event" */
export type Patient_Account_Event_Set_Input = {
  actorUser?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  eventType?: InputMaybe<Patient_Account_Event_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "patient_account_event" */
export type Patient_Account_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Patient_Account_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Patient_Account_Event_Stream_Cursor_Value_Input = {
  actorUser?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  eventType?: InputMaybe<Patient_Account_Event_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "patient_account_event_type" */
export type Patient_Account_Event_Type = {
  __typename?: 'patient_account_event_type';
  name: Scalars['String'];
};

/** aggregated selection of "patient_account_event_type" */
export type Patient_Account_Event_Type_Aggregate = {
  __typename?: 'patient_account_event_type_aggregate';
  aggregate?: Maybe<Patient_Account_Event_Type_Aggregate_Fields>;
  nodes: Array<Patient_Account_Event_Type>;
};

/** aggregate fields of "patient_account_event_type" */
export type Patient_Account_Event_Type_Aggregate_Fields = {
  __typename?: 'patient_account_event_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Patient_Account_Event_Type_Max_Fields>;
  min?: Maybe<Patient_Account_Event_Type_Min_Fields>;
};


/** aggregate fields of "patient_account_event_type" */
export type Patient_Account_Event_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Patient_Account_Event_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "patient_account_event_type". All fields are combined with a logical 'AND'. */
export type Patient_Account_Event_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Patient_Account_Event_Type_Bool_Exp>>;
  _not?: InputMaybe<Patient_Account_Event_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Patient_Account_Event_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "patient_account_event_type" */
export enum Patient_Account_Event_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  PatientAccountEventTypePkey = 'patient_account_event_type_pkey'
}

export enum Patient_Account_Event_Type_Enum {
  InviteSent = 'INVITE_SENT',
  PasskeyAdded = 'PASSKEY_ADDED',
  PasskeyRemoved = 'PASSKEY_REMOVED',
  RegistrationCompleted = 'REGISTRATION_COMPLETED'
}

/** Boolean expression to compare columns of type "patient_account_event_type_enum". All fields are combined with logical 'AND'. */
export type Patient_Account_Event_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Patient_Account_Event_Type_Enum>;
  _in?: InputMaybe<Array<Patient_Account_Event_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Patient_Account_Event_Type_Enum>;
  _nin?: InputMaybe<Array<Patient_Account_Event_Type_Enum>>;
};

/** input type for inserting data into table "patient_account_event_type" */
export type Patient_Account_Event_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Patient_Account_Event_Type_Max_Fields = {
  __typename?: 'patient_account_event_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Patient_Account_Event_Type_Min_Fields = {
  __typename?: 'patient_account_event_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "patient_account_event_type" */
export type Patient_Account_Event_Type_Mutation_Response = {
  __typename?: 'patient_account_event_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient_Account_Event_Type>;
};

/** on_conflict condition type for table "patient_account_event_type" */
export type Patient_Account_Event_Type_On_Conflict = {
  constraint: Patient_Account_Event_Type_Constraint;
  update_columns?: Array<Patient_Account_Event_Type_Update_Column>;
  where?: InputMaybe<Patient_Account_Event_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "patient_account_event_type". */
export type Patient_Account_Event_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: patient_account_event_type */
export type Patient_Account_Event_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "patient_account_event_type" */
export enum Patient_Account_Event_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "patient_account_event_type" */
export type Patient_Account_Event_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "patient_account_event_type" */
export type Patient_Account_Event_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Patient_Account_Event_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Patient_Account_Event_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "patient_account_event_type" */
export enum Patient_Account_Event_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Patient_Account_Event_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Patient_Account_Event_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Patient_Account_Event_Type_Bool_Exp;
};

/** update columns of table "patient_account_event" */
export enum Patient_Account_Event_Update_Column {
  /** column name */
  ActorUser = 'actorUser',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EventType = 'eventType',
  /** column name */
  Id = 'id',
  /** column name */
  Patient = 'patient',
  /** column name */
  Payload = 'payload'
}

export type Patient_Account_Event_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Patient_Account_Event_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Patient_Account_Event_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Patient_Account_Event_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Patient_Account_Event_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Patient_Account_Event_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Patient_Account_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Patient_Account_Event_Bool_Exp;
};

/** aggregated selection of "patient" */
export type Patient_Aggregate = {
  __typename?: 'patient_aggregate';
  aggregate?: Maybe<Patient_Aggregate_Fields>;
  nodes: Array<Patient>;
};

export type Patient_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Patient_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Patient_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Patient_Aggregate_Bool_Exp_Count>;
};

export type Patient_Aggregate_Bool_Exp_Bool_And = {
  arguments: Patient_Select_Column_Patient_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Patient_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Patient_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Patient_Select_Column_Patient_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Patient_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Patient_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Patient_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Patient_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "patient" */
export type Patient_Aggregate_Fields = {
  __typename?: 'patient_aggregate_fields';
  avg?: Maybe<Patient_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Patient_Max_Fields>;
  min?: Maybe<Patient_Min_Fields>;
  stddev?: Maybe<Patient_Stddev_Fields>;
  stddev_pop?: Maybe<Patient_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Patient_Stddev_Samp_Fields>;
  sum?: Maybe<Patient_Sum_Fields>;
  var_pop?: Maybe<Patient_Var_Pop_Fields>;
  var_samp?: Maybe<Patient_Var_Samp_Fields>;
  variance?: Maybe<Patient_Variance_Fields>;
};


/** aggregate fields of "patient" */
export type Patient_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Patient_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "patient" */
export type Patient_Aggregate_Order_By = {
  avg?: InputMaybe<Patient_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Patient_Max_Order_By>;
  min?: InputMaybe<Patient_Min_Order_By>;
  stddev?: InputMaybe<Patient_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Patient_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Patient_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Patient_Sum_Order_By>;
  var_pop?: InputMaybe<Patient_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Patient_Var_Samp_Order_By>;
  variance?: InputMaybe<Patient_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "patient" */
export type Patient_Arr_Rel_Insert_Input = {
  data: Array<Patient_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Patient_On_Conflict>;
};

/** columns and relationships of "patient_auth_challenge" */
export type Patient_Auth_Challenge = {
  __typename?: 'patient_auth_challenge';
  attemptsRemaining: Scalars['Int'];
  code: Scalars['String'];
  expiresAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  provider: Scalars['uuid'];
  /** An object relationship */
  providerByProvider: User;
  squareCustomer: Scalars['String'];
};

/** aggregated selection of "patient_auth_challenge" */
export type Patient_Auth_Challenge_Aggregate = {
  __typename?: 'patient_auth_challenge_aggregate';
  aggregate?: Maybe<Patient_Auth_Challenge_Aggregate_Fields>;
  nodes: Array<Patient_Auth_Challenge>;
};

/** aggregate fields of "patient_auth_challenge" */
export type Patient_Auth_Challenge_Aggregate_Fields = {
  __typename?: 'patient_auth_challenge_aggregate_fields';
  avg?: Maybe<Patient_Auth_Challenge_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Patient_Auth_Challenge_Max_Fields>;
  min?: Maybe<Patient_Auth_Challenge_Min_Fields>;
  stddev?: Maybe<Patient_Auth_Challenge_Stddev_Fields>;
  stddev_pop?: Maybe<Patient_Auth_Challenge_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Patient_Auth_Challenge_Stddev_Samp_Fields>;
  sum?: Maybe<Patient_Auth_Challenge_Sum_Fields>;
  var_pop?: Maybe<Patient_Auth_Challenge_Var_Pop_Fields>;
  var_samp?: Maybe<Patient_Auth_Challenge_Var_Samp_Fields>;
  variance?: Maybe<Patient_Auth_Challenge_Variance_Fields>;
};


/** aggregate fields of "patient_auth_challenge" */
export type Patient_Auth_Challenge_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Patient_Auth_Challenge_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Patient_Auth_Challenge_Avg_Fields = {
  __typename?: 'patient_auth_challenge_avg_fields';
  attemptsRemaining?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "patient_auth_challenge". All fields are combined with a logical 'AND'. */
export type Patient_Auth_Challenge_Bool_Exp = {
  _and?: InputMaybe<Array<Patient_Auth_Challenge_Bool_Exp>>;
  _not?: InputMaybe<Patient_Auth_Challenge_Bool_Exp>;
  _or?: InputMaybe<Array<Patient_Auth_Challenge_Bool_Exp>>;
  attemptsRemaining?: InputMaybe<Int_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  providerByProvider?: InputMaybe<User_Bool_Exp>;
  squareCustomer?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "patient_auth_challenge" */
export enum Patient_Auth_Challenge_Constraint {
  /** unique or primary key constraint on columns "id" */
  PatientAuthChallengePkey = 'patient_auth_challenge_pkey'
}

/** input type for incrementing numeric columns in table "patient_auth_challenge" */
export type Patient_Auth_Challenge_Inc_Input = {
  attemptsRemaining?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "patient_auth_challenge" */
export type Patient_Auth_Challenge_Insert_Input = {
  attemptsRemaining?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  providerByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
  squareCustomer?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Patient_Auth_Challenge_Max_Fields = {
  __typename?: 'patient_auth_challenge_max_fields';
  attemptsRemaining?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  squareCustomer?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Patient_Auth_Challenge_Min_Fields = {
  __typename?: 'patient_auth_challenge_min_fields';
  attemptsRemaining?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  squareCustomer?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "patient_auth_challenge" */
export type Patient_Auth_Challenge_Mutation_Response = {
  __typename?: 'patient_auth_challenge_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient_Auth_Challenge>;
};

/** on_conflict condition type for table "patient_auth_challenge" */
export type Patient_Auth_Challenge_On_Conflict = {
  constraint: Patient_Auth_Challenge_Constraint;
  update_columns?: Array<Patient_Auth_Challenge_Update_Column>;
  where?: InputMaybe<Patient_Auth_Challenge_Bool_Exp>;
};

/** Ordering options when selecting data from "patient_auth_challenge". */
export type Patient_Auth_Challenge_Order_By = {
  attemptsRemaining?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  providerByProvider?: InputMaybe<User_Order_By>;
  squareCustomer?: InputMaybe<Order_By>;
};

/** primary key columns input for table: patient_auth_challenge */
export type Patient_Auth_Challenge_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "patient_auth_challenge" */
export enum Patient_Auth_Challenge_Select_Column {
  /** column name */
  AttemptsRemaining = 'attemptsRemaining',
  /** column name */
  Code = 'code',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider',
  /** column name */
  SquareCustomer = 'squareCustomer'
}

/** input type for updating data in table "patient_auth_challenge" */
export type Patient_Auth_Challenge_Set_Input = {
  attemptsRemaining?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  squareCustomer?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Patient_Auth_Challenge_Stddev_Fields = {
  __typename?: 'patient_auth_challenge_stddev_fields';
  attemptsRemaining?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Patient_Auth_Challenge_Stddev_Pop_Fields = {
  __typename?: 'patient_auth_challenge_stddev_pop_fields';
  attemptsRemaining?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Patient_Auth_Challenge_Stddev_Samp_Fields = {
  __typename?: 'patient_auth_challenge_stddev_samp_fields';
  attemptsRemaining?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "patient_auth_challenge" */
export type Patient_Auth_Challenge_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Patient_Auth_Challenge_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Patient_Auth_Challenge_Stream_Cursor_Value_Input = {
  attemptsRemaining?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  squareCustomer?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Patient_Auth_Challenge_Sum_Fields = {
  __typename?: 'patient_auth_challenge_sum_fields';
  attemptsRemaining?: Maybe<Scalars['Int']>;
};

/** update columns of table "patient_auth_challenge" */
export enum Patient_Auth_Challenge_Update_Column {
  /** column name */
  AttemptsRemaining = 'attemptsRemaining',
  /** column name */
  Code = 'code',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider',
  /** column name */
  SquareCustomer = 'squareCustomer'
}

export type Patient_Auth_Challenge_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Patient_Auth_Challenge_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Patient_Auth_Challenge_Set_Input>;
  /** filter the rows which have to be updated */
  where: Patient_Auth_Challenge_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Patient_Auth_Challenge_Var_Pop_Fields = {
  __typename?: 'patient_auth_challenge_var_pop_fields';
  attemptsRemaining?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Patient_Auth_Challenge_Var_Samp_Fields = {
  __typename?: 'patient_auth_challenge_var_samp_fields';
  attemptsRemaining?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Patient_Auth_Challenge_Variance_Fields = {
  __typename?: 'patient_auth_challenge_variance_fields';
  attemptsRemaining?: Maybe<Scalars['Float']>;
};

/** aggregate avg on columns */
export type Patient_Avg_Fields = {
  __typename?: 'patient_avg_fields';
  credentialEpoch?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "patient" */
export type Patient_Avg_Order_By = {
  credentialEpoch?: InputMaybe<Order_By>;
};

/** BU-owned patient-facing procedure menu (main-164). Business unit = the provider at CLASSIC_VANSANITY locations, the location at MEDSPA. duration_minutes is the patient appointment length requested from the unified booking flow, not the room reservation length. Unrelated to ehr_procedure, and NOT the dead procedure/location_procedure/provider_procedure generation. */
export type Patient_Bookable_Ehr_Procedure = {
  __typename?: 'patient_bookable_ehr_procedure';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  durationMinutes: Scalars['Int'];
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  user: Scalars['uuid'];
  /** An object relationship */
  userByUser: User;
};

/** aggregated selection of "patient_bookable_ehr_procedure" */
export type Patient_Bookable_Ehr_Procedure_Aggregate = {
  __typename?: 'patient_bookable_ehr_procedure_aggregate';
  aggregate?: Maybe<Patient_Bookable_Ehr_Procedure_Aggregate_Fields>;
  nodes: Array<Patient_Bookable_Ehr_Procedure>;
};

/** aggregate fields of "patient_bookable_ehr_procedure" */
export type Patient_Bookable_Ehr_Procedure_Aggregate_Fields = {
  __typename?: 'patient_bookable_ehr_procedure_aggregate_fields';
  avg?: Maybe<Patient_Bookable_Ehr_Procedure_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Patient_Bookable_Ehr_Procedure_Max_Fields>;
  min?: Maybe<Patient_Bookable_Ehr_Procedure_Min_Fields>;
  stddev?: Maybe<Patient_Bookable_Ehr_Procedure_Stddev_Fields>;
  stddev_pop?: Maybe<Patient_Bookable_Ehr_Procedure_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Patient_Bookable_Ehr_Procedure_Stddev_Samp_Fields>;
  sum?: Maybe<Patient_Bookable_Ehr_Procedure_Sum_Fields>;
  var_pop?: Maybe<Patient_Bookable_Ehr_Procedure_Var_Pop_Fields>;
  var_samp?: Maybe<Patient_Bookable_Ehr_Procedure_Var_Samp_Fields>;
  variance?: Maybe<Patient_Bookable_Ehr_Procedure_Variance_Fields>;
};


/** aggregate fields of "patient_bookable_ehr_procedure" */
export type Patient_Bookable_Ehr_Procedure_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Patient_Bookable_Ehr_Procedure_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Patient_Bookable_Ehr_Procedure_Avg_Fields = {
  __typename?: 'patient_bookable_ehr_procedure_avg_fields';
  durationMinutes?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "patient_bookable_ehr_procedure". All fields are combined with a logical 'AND'. */
export type Patient_Bookable_Ehr_Procedure_Bool_Exp = {
  _and?: InputMaybe<Array<Patient_Bookable_Ehr_Procedure_Bool_Exp>>;
  _not?: InputMaybe<Patient_Bookable_Ehr_Procedure_Bool_Exp>;
  _or?: InputMaybe<Array<Patient_Bookable_Ehr_Procedure_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  durationMinutes?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Uuid_Comparison_Exp>;
  userByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "patient_bookable_ehr_procedure" */
export enum Patient_Bookable_Ehr_Procedure_Constraint {
  /** unique or primary key constraint on columns "id" */
  PatientBookableEhrProcedurePkey = 'patient_bookable_ehr_procedure_pkey'
}

/** input type for incrementing numeric columns in table "patient_bookable_ehr_procedure" */
export type Patient_Bookable_Ehr_Procedure_Inc_Input = {
  durationMinutes?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "patient_bookable_ehr_procedure" */
export type Patient_Bookable_Ehr_Procedure_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
  userByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Patient_Bookable_Ehr_Procedure_Max_Fields = {
  __typename?: 'patient_bookable_ehr_procedure_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  durationMinutes?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Patient_Bookable_Ehr_Procedure_Min_Fields = {
  __typename?: 'patient_bookable_ehr_procedure_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  durationMinutes?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "patient_bookable_ehr_procedure" */
export type Patient_Bookable_Ehr_Procedure_Mutation_Response = {
  __typename?: 'patient_bookable_ehr_procedure_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient_Bookable_Ehr_Procedure>;
};

/** input type for inserting object relation for remote table "patient_bookable_ehr_procedure" */
export type Patient_Bookable_Ehr_Procedure_Obj_Rel_Insert_Input = {
  data: Patient_Bookable_Ehr_Procedure_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Patient_Bookable_Ehr_Procedure_On_Conflict>;
};

/** on_conflict condition type for table "patient_bookable_ehr_procedure" */
export type Patient_Bookable_Ehr_Procedure_On_Conflict = {
  constraint: Patient_Bookable_Ehr_Procedure_Constraint;
  update_columns?: Array<Patient_Bookable_Ehr_Procedure_Update_Column>;
  where?: InputMaybe<Patient_Bookable_Ehr_Procedure_Bool_Exp>;
};

/** Ordering options when selecting data from "patient_bookable_ehr_procedure". */
export type Patient_Bookable_Ehr_Procedure_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  durationMinutes?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  userByUser?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: patient_bookable_ehr_procedure */
export type Patient_Bookable_Ehr_Procedure_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "patient_bookable_ehr_procedure" */
export enum Patient_Bookable_Ehr_Procedure_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  DurationMinutes = 'durationMinutes',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  User = 'user'
}

/** input type for updating data in table "patient_bookable_ehr_procedure" */
export type Patient_Bookable_Ehr_Procedure_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Patient_Bookable_Ehr_Procedure_Stddev_Fields = {
  __typename?: 'patient_bookable_ehr_procedure_stddev_fields';
  durationMinutes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Patient_Bookable_Ehr_Procedure_Stddev_Pop_Fields = {
  __typename?: 'patient_bookable_ehr_procedure_stddev_pop_fields';
  durationMinutes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Patient_Bookable_Ehr_Procedure_Stddev_Samp_Fields = {
  __typename?: 'patient_bookable_ehr_procedure_stddev_samp_fields';
  durationMinutes?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "patient_bookable_ehr_procedure" */
export type Patient_Bookable_Ehr_Procedure_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Patient_Bookable_Ehr_Procedure_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Patient_Bookable_Ehr_Procedure_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Patient_Bookable_Ehr_Procedure_Sum_Fields = {
  __typename?: 'patient_bookable_ehr_procedure_sum_fields';
  durationMinutes?: Maybe<Scalars['Int']>;
};

/** update columns of table "patient_bookable_ehr_procedure" */
export enum Patient_Bookable_Ehr_Procedure_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  DurationMinutes = 'durationMinutes',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  User = 'user'
}

export type Patient_Bookable_Ehr_Procedure_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Patient_Bookable_Ehr_Procedure_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Patient_Bookable_Ehr_Procedure_Set_Input>;
  /** filter the rows which have to be updated */
  where: Patient_Bookable_Ehr_Procedure_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Patient_Bookable_Ehr_Procedure_Var_Pop_Fields = {
  __typename?: 'patient_bookable_ehr_procedure_var_pop_fields';
  durationMinutes?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Patient_Bookable_Ehr_Procedure_Var_Samp_Fields = {
  __typename?: 'patient_bookable_ehr_procedure_var_samp_fields';
  durationMinutes?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Patient_Bookable_Ehr_Procedure_Variance_Fields = {
  __typename?: 'patient_bookable_ehr_procedure_variance_fields';
  durationMinutes?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "patient_booking" */
export type Patient_Booking = {
  __typename?: 'patient_booking';
  cancelReason?: Maybe<Patient_Booking_Cancel_Reason_Enum>;
  cancelled_at?: Maybe<Scalars['timestamptz']>;
  confirmed_at?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  ehrEncounters: Array<Ehr_Encounter>;
  /** An aggregate relationship */
  ehrEncounters_aggregate: Ehr_Encounter_Aggregate;
  id: Scalars['uuid'];
  initiated_by: Patient_Booking_Initiator_Enum;
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  patient: Scalars['uuid'];
  /** An object relationship */
  patientBookableEhrProcedure?: Maybe<Patient_Bookable_Ehr_Procedure>;
  /** An array relationship */
  patientBookingBookings: Array<Patient_Booking_Booking>;
  /** An aggregate relationship */
  patientBookingBookings_aggregate: Patient_Booking_Booking_Aggregate;
  /** An object relationship */
  patientByPatient: Patient;
  /** The patient-facing menu entry this appointment was requested for. NULL means not recorded, not no procedure. */
  patient_bookable_ehr_procedure?: Maybe<Scalars['uuid']>;
  provider: Scalars['uuid'];
  timespan: Scalars['tstzrange'];
  timespan_lower: Scalars['timestamptz'];
  timespan_upper: Scalars['timestamptz'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  userByProvider: User;
  /** A computed field, executes function "patient_booking_visible_to_supervisor" */
  visibleToSupervisor?: Maybe<Scalars['Boolean']>;
};


/** columns and relationships of "patient_booking" */
export type Patient_BookingEhrEncountersArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Bool_Exp>;
};


/** columns and relationships of "patient_booking" */
export type Patient_BookingEhrEncounters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Bool_Exp>;
};


/** columns and relationships of "patient_booking" */
export type Patient_BookingPatientBookingBookingsArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Booking_Order_By>>;
  where?: InputMaybe<Patient_Booking_Booking_Bool_Exp>;
};


/** columns and relationships of "patient_booking" */
export type Patient_BookingPatientBookingBookings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Booking_Order_By>>;
  where?: InputMaybe<Patient_Booking_Booking_Bool_Exp>;
};

/** aggregated selection of "patient_booking" */
export type Patient_Booking_Aggregate = {
  __typename?: 'patient_booking_aggregate';
  aggregate?: Maybe<Patient_Booking_Aggregate_Fields>;
  nodes: Array<Patient_Booking>;
};

/** aggregate fields of "patient_booking" */
export type Patient_Booking_Aggregate_Fields = {
  __typename?: 'patient_booking_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Patient_Booking_Max_Fields>;
  min?: Maybe<Patient_Booking_Min_Fields>;
};


/** aggregate fields of "patient_booking" */
export type Patient_Booking_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Patient_Booking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "patient_booking_booking" */
export type Patient_Booking_Booking = {
  __typename?: 'patient_booking_booking';
  booking: Scalars['uuid'];
  /** An object relationship */
  bookingByBooking: Booking;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  patientBookingByPatientBooking: Patient_Booking;
  patient_booking: Scalars['uuid'];
};

/** aggregated selection of "patient_booking_booking" */
export type Patient_Booking_Booking_Aggregate = {
  __typename?: 'patient_booking_booking_aggregate';
  aggregate?: Maybe<Patient_Booking_Booking_Aggregate_Fields>;
  nodes: Array<Patient_Booking_Booking>;
};

export type Patient_Booking_Booking_Aggregate_Bool_Exp = {
  count?: InputMaybe<Patient_Booking_Booking_Aggregate_Bool_Exp_Count>;
};

export type Patient_Booking_Booking_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Patient_Booking_Booking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Patient_Booking_Booking_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "patient_booking_booking" */
export type Patient_Booking_Booking_Aggregate_Fields = {
  __typename?: 'patient_booking_booking_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Patient_Booking_Booking_Max_Fields>;
  min?: Maybe<Patient_Booking_Booking_Min_Fields>;
};


/** aggregate fields of "patient_booking_booking" */
export type Patient_Booking_Booking_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Patient_Booking_Booking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "patient_booking_booking" */
export type Patient_Booking_Booking_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Patient_Booking_Booking_Max_Order_By>;
  min?: InputMaybe<Patient_Booking_Booking_Min_Order_By>;
};

/** input type for inserting array relation for remote table "patient_booking_booking" */
export type Patient_Booking_Booking_Arr_Rel_Insert_Input = {
  data: Array<Patient_Booking_Booking_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Patient_Booking_Booking_On_Conflict>;
};

/** Boolean expression to filter rows from the table "patient_booking_booking". All fields are combined with a logical 'AND'. */
export type Patient_Booking_Booking_Bool_Exp = {
  _and?: InputMaybe<Array<Patient_Booking_Booking_Bool_Exp>>;
  _not?: InputMaybe<Patient_Booking_Booking_Bool_Exp>;
  _or?: InputMaybe<Array<Patient_Booking_Booking_Bool_Exp>>;
  booking?: InputMaybe<Uuid_Comparison_Exp>;
  bookingByBooking?: InputMaybe<Booking_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  patientBookingByPatientBooking?: InputMaybe<Patient_Booking_Bool_Exp>;
  patient_booking?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "patient_booking_booking" */
export enum Patient_Booking_Booking_Constraint {
  /** unique or primary key constraint on columns "patient_booking", "booking" */
  PatientBookingBookingPkey = 'patient_booking_booking_pkey'
}

/** input type for inserting data into table "patient_booking_booking" */
export type Patient_Booking_Booking_Insert_Input = {
  booking?: InputMaybe<Scalars['uuid']>;
  bookingByBooking?: InputMaybe<Booking_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  patientBookingByPatientBooking?: InputMaybe<Patient_Booking_Obj_Rel_Insert_Input>;
  patient_booking?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Patient_Booking_Booking_Max_Fields = {
  __typename?: 'patient_booking_booking_max_fields';
  booking?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  patient_booking?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "patient_booking_booking" */
export type Patient_Booking_Booking_Max_Order_By = {
  booking?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  patient_booking?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Patient_Booking_Booking_Min_Fields = {
  __typename?: 'patient_booking_booking_min_fields';
  booking?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  patient_booking?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "patient_booking_booking" */
export type Patient_Booking_Booking_Min_Order_By = {
  booking?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  patient_booking?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "patient_booking_booking" */
export type Patient_Booking_Booking_Mutation_Response = {
  __typename?: 'patient_booking_booking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient_Booking_Booking>;
};

/** on_conflict condition type for table "patient_booking_booking" */
export type Patient_Booking_Booking_On_Conflict = {
  constraint: Patient_Booking_Booking_Constraint;
  update_columns?: Array<Patient_Booking_Booking_Update_Column>;
  where?: InputMaybe<Patient_Booking_Booking_Bool_Exp>;
};

/** Ordering options when selecting data from "patient_booking_booking". */
export type Patient_Booking_Booking_Order_By = {
  booking?: InputMaybe<Order_By>;
  bookingByBooking?: InputMaybe<Booking_Order_By>;
  created_at?: InputMaybe<Order_By>;
  patientBookingByPatientBooking?: InputMaybe<Patient_Booking_Order_By>;
  patient_booking?: InputMaybe<Order_By>;
};

/** primary key columns input for table: patient_booking_booking */
export type Patient_Booking_Booking_Pk_Columns_Input = {
  booking: Scalars['uuid'];
  patient_booking: Scalars['uuid'];
};

/** select columns of table "patient_booking_booking" */
export enum Patient_Booking_Booking_Select_Column {
  /** column name */
  Booking = 'booking',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  PatientBooking = 'patient_booking'
}

/** input type for updating data in table "patient_booking_booking" */
export type Patient_Booking_Booking_Set_Input = {
  booking?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  patient_booking?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "patient_booking_booking" */
export type Patient_Booking_Booking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Patient_Booking_Booking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Patient_Booking_Booking_Stream_Cursor_Value_Input = {
  booking?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  patient_booking?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "patient_booking_booking" */
export enum Patient_Booking_Booking_Update_Column {
  /** column name */
  Booking = 'booking',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  PatientBooking = 'patient_booking'
}

export type Patient_Booking_Booking_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Patient_Booking_Booking_Set_Input>;
  /** filter the rows which have to be updated */
  where: Patient_Booking_Booking_Bool_Exp;
};

/** Boolean expression to filter rows from the table "patient_booking". All fields are combined with a logical 'AND'. */
export type Patient_Booking_Bool_Exp = {
  _and?: InputMaybe<Array<Patient_Booking_Bool_Exp>>;
  _not?: InputMaybe<Patient_Booking_Bool_Exp>;
  _or?: InputMaybe<Array<Patient_Booking_Bool_Exp>>;
  cancelReason?: InputMaybe<Patient_Booking_Cancel_Reason_Enum_Comparison_Exp>;
  cancelled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  confirmed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrEncounters?: InputMaybe<Ehr_Encounter_Bool_Exp>;
  ehrEncounters_aggregate?: InputMaybe<Ehr_Encounter_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  initiated_by?: InputMaybe<Patient_Booking_Initiator_Enum_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  patient?: InputMaybe<Uuid_Comparison_Exp>;
  patientBookableEhrProcedure?: InputMaybe<Patient_Bookable_Ehr_Procedure_Bool_Exp>;
  patientBookingBookings?: InputMaybe<Patient_Booking_Booking_Bool_Exp>;
  patientBookingBookings_aggregate?: InputMaybe<Patient_Booking_Booking_Aggregate_Bool_Exp>;
  patientByPatient?: InputMaybe<Patient_Bool_Exp>;
  patient_bookable_ehr_procedure?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  timespan?: InputMaybe<Tstzrange_Comparison_Exp>;
  timespan_lower?: InputMaybe<Timestamptz_Comparison_Exp>;
  timespan_upper?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  userByProvider?: InputMaybe<User_Bool_Exp>;
  visibleToSupervisor?: InputMaybe<Boolean_Comparison_Exp>;
};

/** columns and relationships of "patient_booking_cancel_reason" */
export type Patient_Booking_Cancel_Reason = {
  __typename?: 'patient_booking_cancel_reason';
  id: Scalars['String'];
};

/** aggregated selection of "patient_booking_cancel_reason" */
export type Patient_Booking_Cancel_Reason_Aggregate = {
  __typename?: 'patient_booking_cancel_reason_aggregate';
  aggregate?: Maybe<Patient_Booking_Cancel_Reason_Aggregate_Fields>;
  nodes: Array<Patient_Booking_Cancel_Reason>;
};

/** aggregate fields of "patient_booking_cancel_reason" */
export type Patient_Booking_Cancel_Reason_Aggregate_Fields = {
  __typename?: 'patient_booking_cancel_reason_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Patient_Booking_Cancel_Reason_Max_Fields>;
  min?: Maybe<Patient_Booking_Cancel_Reason_Min_Fields>;
};


/** aggregate fields of "patient_booking_cancel_reason" */
export type Patient_Booking_Cancel_Reason_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Patient_Booking_Cancel_Reason_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "patient_booking_cancel_reason". All fields are combined with a logical 'AND'. */
export type Patient_Booking_Cancel_Reason_Bool_Exp = {
  _and?: InputMaybe<Array<Patient_Booking_Cancel_Reason_Bool_Exp>>;
  _not?: InputMaybe<Patient_Booking_Cancel_Reason_Bool_Exp>;
  _or?: InputMaybe<Array<Patient_Booking_Cancel_Reason_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "patient_booking_cancel_reason" */
export enum Patient_Booking_Cancel_Reason_Constraint {
  /** unique or primary key constraint on columns "id" */
  PatientBookingCancelReasonPkey = 'patient_booking_cancel_reason_pkey'
}

export enum Patient_Booking_Cancel_Reason_Enum {
  ConfirmTimeout = 'CONFIRM_TIMEOUT',
  Patient = 'PATIENT',
  Provider = 'PROVIDER',
  RoomBookingCancelled = 'ROOM_BOOKING_CANCELLED'
}

/** Boolean expression to compare columns of type "patient_booking_cancel_reason_enum". All fields are combined with logical 'AND'. */
export type Patient_Booking_Cancel_Reason_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Patient_Booking_Cancel_Reason_Enum>;
  _in?: InputMaybe<Array<Patient_Booking_Cancel_Reason_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Patient_Booking_Cancel_Reason_Enum>;
  _nin?: InputMaybe<Array<Patient_Booking_Cancel_Reason_Enum>>;
};

/** input type for inserting data into table "patient_booking_cancel_reason" */
export type Patient_Booking_Cancel_Reason_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Patient_Booking_Cancel_Reason_Max_Fields = {
  __typename?: 'patient_booking_cancel_reason_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Patient_Booking_Cancel_Reason_Min_Fields = {
  __typename?: 'patient_booking_cancel_reason_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "patient_booking_cancel_reason" */
export type Patient_Booking_Cancel_Reason_Mutation_Response = {
  __typename?: 'patient_booking_cancel_reason_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient_Booking_Cancel_Reason>;
};

/** on_conflict condition type for table "patient_booking_cancel_reason" */
export type Patient_Booking_Cancel_Reason_On_Conflict = {
  constraint: Patient_Booking_Cancel_Reason_Constraint;
  update_columns?: Array<Patient_Booking_Cancel_Reason_Update_Column>;
  where?: InputMaybe<Patient_Booking_Cancel_Reason_Bool_Exp>;
};

/** Ordering options when selecting data from "patient_booking_cancel_reason". */
export type Patient_Booking_Cancel_Reason_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: patient_booking_cancel_reason */
export type Patient_Booking_Cancel_Reason_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "patient_booking_cancel_reason" */
export enum Patient_Booking_Cancel_Reason_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "patient_booking_cancel_reason" */
export type Patient_Booking_Cancel_Reason_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "patient_booking_cancel_reason" */
export type Patient_Booking_Cancel_Reason_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Patient_Booking_Cancel_Reason_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Patient_Booking_Cancel_Reason_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "patient_booking_cancel_reason" */
export enum Patient_Booking_Cancel_Reason_Update_Column {
  /** column name */
  Id = 'id'
}

export type Patient_Booking_Cancel_Reason_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Patient_Booking_Cancel_Reason_Set_Input>;
  /** filter the rows which have to be updated */
  where: Patient_Booking_Cancel_Reason_Bool_Exp;
};

/** unique or primary key constraints on table "patient_booking" */
export enum Patient_Booking_Constraint {
  /** unique or primary key constraint on columns "id" */
  PatientBookingPkey = 'patient_booking_pkey'
}

/** columns and relationships of "patient_booking_initiator" */
export type Patient_Booking_Initiator = {
  __typename?: 'patient_booking_initiator';
  id: Scalars['String'];
};

/** aggregated selection of "patient_booking_initiator" */
export type Patient_Booking_Initiator_Aggregate = {
  __typename?: 'patient_booking_initiator_aggregate';
  aggregate?: Maybe<Patient_Booking_Initiator_Aggregate_Fields>;
  nodes: Array<Patient_Booking_Initiator>;
};

/** aggregate fields of "patient_booking_initiator" */
export type Patient_Booking_Initiator_Aggregate_Fields = {
  __typename?: 'patient_booking_initiator_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Patient_Booking_Initiator_Max_Fields>;
  min?: Maybe<Patient_Booking_Initiator_Min_Fields>;
};


/** aggregate fields of "patient_booking_initiator" */
export type Patient_Booking_Initiator_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Patient_Booking_Initiator_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "patient_booking_initiator". All fields are combined with a logical 'AND'. */
export type Patient_Booking_Initiator_Bool_Exp = {
  _and?: InputMaybe<Array<Patient_Booking_Initiator_Bool_Exp>>;
  _not?: InputMaybe<Patient_Booking_Initiator_Bool_Exp>;
  _or?: InputMaybe<Array<Patient_Booking_Initiator_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "patient_booking_initiator" */
export enum Patient_Booking_Initiator_Constraint {
  /** unique or primary key constraint on columns "id" */
  PatientBookingInitiatorPkey = 'patient_booking_initiator_pkey'
}

export enum Patient_Booking_Initiator_Enum {
  Patient = 'PATIENT',
  Staff = 'STAFF'
}

/** Boolean expression to compare columns of type "patient_booking_initiator_enum". All fields are combined with logical 'AND'. */
export type Patient_Booking_Initiator_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Patient_Booking_Initiator_Enum>;
  _in?: InputMaybe<Array<Patient_Booking_Initiator_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Patient_Booking_Initiator_Enum>;
  _nin?: InputMaybe<Array<Patient_Booking_Initiator_Enum>>;
};

/** input type for inserting data into table "patient_booking_initiator" */
export type Patient_Booking_Initiator_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Patient_Booking_Initiator_Max_Fields = {
  __typename?: 'patient_booking_initiator_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Patient_Booking_Initiator_Min_Fields = {
  __typename?: 'patient_booking_initiator_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "patient_booking_initiator" */
export type Patient_Booking_Initiator_Mutation_Response = {
  __typename?: 'patient_booking_initiator_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient_Booking_Initiator>;
};

/** on_conflict condition type for table "patient_booking_initiator" */
export type Patient_Booking_Initiator_On_Conflict = {
  constraint: Patient_Booking_Initiator_Constraint;
  update_columns?: Array<Patient_Booking_Initiator_Update_Column>;
  where?: InputMaybe<Patient_Booking_Initiator_Bool_Exp>;
};

/** Ordering options when selecting data from "patient_booking_initiator". */
export type Patient_Booking_Initiator_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: patient_booking_initiator */
export type Patient_Booking_Initiator_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "patient_booking_initiator" */
export enum Patient_Booking_Initiator_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "patient_booking_initiator" */
export type Patient_Booking_Initiator_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "patient_booking_initiator" */
export type Patient_Booking_Initiator_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Patient_Booking_Initiator_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Patient_Booking_Initiator_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "patient_booking_initiator" */
export enum Patient_Booking_Initiator_Update_Column {
  /** column name */
  Id = 'id'
}

export type Patient_Booking_Initiator_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Patient_Booking_Initiator_Set_Input>;
  /** filter the rows which have to be updated */
  where: Patient_Booking_Initiator_Bool_Exp;
};

/** input type for inserting data into table "patient_booking" */
export type Patient_Booking_Insert_Input = {
  cancelReason?: InputMaybe<Patient_Booking_Cancel_Reason_Enum>;
  cancelled_at?: InputMaybe<Scalars['timestamptz']>;
  confirmed_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  ehrEncounters?: InputMaybe<Ehr_Encounter_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  initiated_by?: InputMaybe<Patient_Booking_Initiator_Enum>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  patient?: InputMaybe<Scalars['uuid']>;
  patientBookableEhrProcedure?: InputMaybe<Patient_Bookable_Ehr_Procedure_Obj_Rel_Insert_Input>;
  patientBookingBookings?: InputMaybe<Patient_Booking_Booking_Arr_Rel_Insert_Input>;
  patientByPatient?: InputMaybe<Patient_Obj_Rel_Insert_Input>;
  /** The patient-facing menu entry this appointment was requested for. NULL means not recorded, not no procedure. */
  patient_bookable_ehr_procedure?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Patient_Booking_Max_Fields = {
  __typename?: 'patient_booking_max_fields';
  cancelled_at?: Maybe<Scalars['timestamptz']>;
  confirmed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  patient?: Maybe<Scalars['uuid']>;
  /** The patient-facing menu entry this appointment was requested for. NULL means not recorded, not no procedure. */
  patient_bookable_ehr_procedure?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  timespan_upper?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "patient_booking_metadata" */
export type Patient_Booking_Metadata = {
  __typename?: 'patient_booking_metadata';
  /** An object relationship */
  bookingByProviderBooking: Booking;
  confirmedAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  providerBooking: Scalars['uuid'];
  providerProcedure: Scalars['uuid'];
  /** An object relationship */
  providerProcedureByProviderProcedure: Provider_Procedure;
  squareBookingFeePaymentId?: Maybe<Scalars['String']>;
  squareUserId: Scalars['String'];
  timespan: Scalars['tstzrange'];
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  timespan_upper?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "patient_booking_metadata" */
export type Patient_Booking_Metadata_Aggregate = {
  __typename?: 'patient_booking_metadata_aggregate';
  aggregate?: Maybe<Patient_Booking_Metadata_Aggregate_Fields>;
  nodes: Array<Patient_Booking_Metadata>;
};

export type Patient_Booking_Metadata_Aggregate_Bool_Exp = {
  count?: InputMaybe<Patient_Booking_Metadata_Aggregate_Bool_Exp_Count>;
};

export type Patient_Booking_Metadata_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Patient_Booking_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Patient_Booking_Metadata_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "patient_booking_metadata" */
export type Patient_Booking_Metadata_Aggregate_Fields = {
  __typename?: 'patient_booking_metadata_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Patient_Booking_Metadata_Max_Fields>;
  min?: Maybe<Patient_Booking_Metadata_Min_Fields>;
};


/** aggregate fields of "patient_booking_metadata" */
export type Patient_Booking_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Patient_Booking_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "patient_booking_metadata" */
export type Patient_Booking_Metadata_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Patient_Booking_Metadata_Max_Order_By>;
  min?: InputMaybe<Patient_Booking_Metadata_Min_Order_By>;
};

/** input type for inserting array relation for remote table "patient_booking_metadata" */
export type Patient_Booking_Metadata_Arr_Rel_Insert_Input = {
  data: Array<Patient_Booking_Metadata_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Patient_Booking_Metadata_On_Conflict>;
};

/** Boolean expression to filter rows from the table "patient_booking_metadata". All fields are combined with a logical 'AND'. */
export type Patient_Booking_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Patient_Booking_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Patient_Booking_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Patient_Booking_Metadata_Bool_Exp>>;
  bookingByProviderBooking?: InputMaybe<Booking_Bool_Exp>;
  confirmedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  providerBooking?: InputMaybe<Uuid_Comparison_Exp>;
  providerProcedure?: InputMaybe<Uuid_Comparison_Exp>;
  providerProcedureByProviderProcedure?: InputMaybe<Provider_Procedure_Bool_Exp>;
  squareBookingFeePaymentId?: InputMaybe<String_Comparison_Exp>;
  squareUserId?: InputMaybe<String_Comparison_Exp>;
  timespan?: InputMaybe<Tstzrange_Comparison_Exp>;
  timespan_lower?: InputMaybe<Timestamptz_Comparison_Exp>;
  timespan_upper?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "patient_booking_metadata" */
export enum Patient_Booking_Metadata_Constraint {
  /** unique or primary key constraint on columns "id" */
  PatientBookingMetadataPkey = 'patient_booking_metadata_pkey'
}

/** input type for inserting data into table "patient_booking_metadata" */
export type Patient_Booking_Metadata_Insert_Input = {
  bookingByProviderBooking?: InputMaybe<Booking_Obj_Rel_Insert_Input>;
  confirmedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  providerBooking?: InputMaybe<Scalars['uuid']>;
  providerProcedure?: InputMaybe<Scalars['uuid']>;
  providerProcedureByProviderProcedure?: InputMaybe<Provider_Procedure_Obj_Rel_Insert_Input>;
  squareBookingFeePaymentId?: InputMaybe<Scalars['String']>;
  squareUserId?: InputMaybe<Scalars['String']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
};

/** aggregate max on columns */
export type Patient_Booking_Metadata_Max_Fields = {
  __typename?: 'patient_booking_metadata_max_fields';
  confirmedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  providerBooking?: Maybe<Scalars['uuid']>;
  providerProcedure?: Maybe<Scalars['uuid']>;
  squareBookingFeePaymentId?: Maybe<Scalars['String']>;
  squareUserId?: Maybe<Scalars['String']>;
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  timespan_upper?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "patient_booking_metadata" */
export type Patient_Booking_Metadata_Max_Order_By = {
  confirmedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  providerBooking?: InputMaybe<Order_By>;
  providerProcedure?: InputMaybe<Order_By>;
  squareBookingFeePaymentId?: InputMaybe<Order_By>;
  squareUserId?: InputMaybe<Order_By>;
  timespan_lower?: InputMaybe<Order_By>;
  timespan_upper?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Patient_Booking_Metadata_Min_Fields = {
  __typename?: 'patient_booking_metadata_min_fields';
  confirmedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  providerBooking?: Maybe<Scalars['uuid']>;
  providerProcedure?: Maybe<Scalars['uuid']>;
  squareBookingFeePaymentId?: Maybe<Scalars['String']>;
  squareUserId?: Maybe<Scalars['String']>;
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  timespan_upper?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "patient_booking_metadata" */
export type Patient_Booking_Metadata_Min_Order_By = {
  confirmedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  providerBooking?: InputMaybe<Order_By>;
  providerProcedure?: InputMaybe<Order_By>;
  squareBookingFeePaymentId?: InputMaybe<Order_By>;
  squareUserId?: InputMaybe<Order_By>;
  timespan_lower?: InputMaybe<Order_By>;
  timespan_upper?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "patient_booking_metadata" */
export type Patient_Booking_Metadata_Mutation_Response = {
  __typename?: 'patient_booking_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient_Booking_Metadata>;
};

/** on_conflict condition type for table "patient_booking_metadata" */
export type Patient_Booking_Metadata_On_Conflict = {
  constraint: Patient_Booking_Metadata_Constraint;
  update_columns?: Array<Patient_Booking_Metadata_Update_Column>;
  where?: InputMaybe<Patient_Booking_Metadata_Bool_Exp>;
};

/** Ordering options when selecting data from "patient_booking_metadata". */
export type Patient_Booking_Metadata_Order_By = {
  bookingByProviderBooking?: InputMaybe<Booking_Order_By>;
  confirmedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  providerBooking?: InputMaybe<Order_By>;
  providerProcedure?: InputMaybe<Order_By>;
  providerProcedureByProviderProcedure?: InputMaybe<Provider_Procedure_Order_By>;
  squareBookingFeePaymentId?: InputMaybe<Order_By>;
  squareUserId?: InputMaybe<Order_By>;
  timespan?: InputMaybe<Order_By>;
  timespan_lower?: InputMaybe<Order_By>;
  timespan_upper?: InputMaybe<Order_By>;
};

/** primary key columns input for table: patient_booking_metadata */
export type Patient_Booking_Metadata_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "patient_booking_metadata" */
export enum Patient_Booking_Metadata_Select_Column {
  /** column name */
  ConfirmedAt = 'confirmedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderBooking = 'providerBooking',
  /** column name */
  ProviderProcedure = 'providerProcedure',
  /** column name */
  SquareBookingFeePaymentId = 'squareBookingFeePaymentId',
  /** column name */
  SquareUserId = 'squareUserId',
  /** column name */
  Timespan = 'timespan',
  /** column name */
  TimespanLower = 'timespan_lower',
  /** column name */
  TimespanUpper = 'timespan_upper'
}

/** input type for updating data in table "patient_booking_metadata" */
export type Patient_Booking_Metadata_Set_Input = {
  confirmedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  providerBooking?: InputMaybe<Scalars['uuid']>;
  providerProcedure?: InputMaybe<Scalars['uuid']>;
  squareBookingFeePaymentId?: InputMaybe<Scalars['String']>;
  squareUserId?: InputMaybe<Scalars['String']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
};

/** Streaming cursor of the table "patient_booking_metadata" */
export type Patient_Booking_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Patient_Booking_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Patient_Booking_Metadata_Stream_Cursor_Value_Input = {
  confirmedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  providerBooking?: InputMaybe<Scalars['uuid']>;
  providerProcedure?: InputMaybe<Scalars['uuid']>;
  squareBookingFeePaymentId?: InputMaybe<Scalars['String']>;
  squareUserId?: InputMaybe<Scalars['String']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
  timespan_lower?: InputMaybe<Scalars['timestamptz']>;
  timespan_upper?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "patient_booking_metadata" */
export enum Patient_Booking_Metadata_Update_Column {
  /** column name */
  ConfirmedAt = 'confirmedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderBooking = 'providerBooking',
  /** column name */
  ProviderProcedure = 'providerProcedure',
  /** column name */
  SquareBookingFeePaymentId = 'squareBookingFeePaymentId',
  /** column name */
  SquareUserId = 'squareUserId',
  /** column name */
  Timespan = 'timespan'
}

export type Patient_Booking_Metadata_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Patient_Booking_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Patient_Booking_Metadata_Bool_Exp;
};

/** aggregate min on columns */
export type Patient_Booking_Min_Fields = {
  __typename?: 'patient_booking_min_fields';
  cancelled_at?: Maybe<Scalars['timestamptz']>;
  confirmed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  patient?: Maybe<Scalars['uuid']>;
  /** The patient-facing menu entry this appointment was requested for. NULL means not recorded, not no procedure. */
  patient_bookable_ehr_procedure?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  timespan_upper?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "patient_booking" */
export type Patient_Booking_Mutation_Response = {
  __typename?: 'patient_booking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient_Booking>;
};

/** input type for inserting object relation for remote table "patient_booking" */
export type Patient_Booking_Obj_Rel_Insert_Input = {
  data: Patient_Booking_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Patient_Booking_On_Conflict>;
};

/** on_conflict condition type for table "patient_booking" */
export type Patient_Booking_On_Conflict = {
  constraint: Patient_Booking_Constraint;
  update_columns?: Array<Patient_Booking_Update_Column>;
  where?: InputMaybe<Patient_Booking_Bool_Exp>;
};

/** Ordering options when selecting data from "patient_booking". */
export type Patient_Booking_Order_By = {
  cancelReason?: InputMaybe<Order_By>;
  cancelled_at?: InputMaybe<Order_By>;
  confirmed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  ehrEncounters_aggregate?: InputMaybe<Ehr_Encounter_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  initiated_by?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  patient?: InputMaybe<Order_By>;
  patientBookableEhrProcedure?: InputMaybe<Patient_Bookable_Ehr_Procedure_Order_By>;
  patientBookingBookings_aggregate?: InputMaybe<Patient_Booking_Booking_Aggregate_Order_By>;
  patientByPatient?: InputMaybe<Patient_Order_By>;
  patient_bookable_ehr_procedure?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  timespan?: InputMaybe<Order_By>;
  timespan_lower?: InputMaybe<Order_By>;
  timespan_upper?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userByProvider?: InputMaybe<User_Order_By>;
  visibleToSupervisor?: InputMaybe<Order_By>;
};

/** primary key columns input for table: patient_booking */
export type Patient_Booking_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "patient_booking" */
export enum Patient_Booking_Select_Column {
  /** column name */
  CancelReason = 'cancelReason',
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  ConfirmedAt = 'confirmed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InitiatedBy = 'initiated_by',
  /** column name */
  Location = 'location',
  /** column name */
  Patient = 'patient',
  /** column name */
  PatientBookableEhrProcedure = 'patient_bookable_ehr_procedure',
  /** column name */
  Provider = 'provider',
  /** column name */
  Timespan = 'timespan',
  /** column name */
  TimespanLower = 'timespan_lower',
  /** column name */
  TimespanUpper = 'timespan_upper',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "patient_booking" */
export type Patient_Booking_Set_Input = {
  cancelReason?: InputMaybe<Patient_Booking_Cancel_Reason_Enum>;
  cancelled_at?: InputMaybe<Scalars['timestamptz']>;
  confirmed_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  initiated_by?: InputMaybe<Patient_Booking_Initiator_Enum>;
  location?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  /** The patient-facing menu entry this appointment was requested for. NULL means not recorded, not no procedure. */
  patient_bookable_ehr_procedure?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "patient_booking" */
export type Patient_Booking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Patient_Booking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Patient_Booking_Stream_Cursor_Value_Input = {
  cancelReason?: InputMaybe<Patient_Booking_Cancel_Reason_Enum>;
  cancelled_at?: InputMaybe<Scalars['timestamptz']>;
  confirmed_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  initiated_by?: InputMaybe<Patient_Booking_Initiator_Enum>;
  location?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  /** The patient-facing menu entry this appointment was requested for. NULL means not recorded, not no procedure. */
  patient_bookable_ehr_procedure?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
  timespan_lower?: InputMaybe<Scalars['timestamptz']>;
  timespan_upper?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "patient_booking" */
export enum Patient_Booking_Update_Column {
  /** column name */
  CancelReason = 'cancelReason',
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  ConfirmedAt = 'confirmed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InitiatedBy = 'initiated_by',
  /** column name */
  Location = 'location',
  /** column name */
  Patient = 'patient',
  /** column name */
  PatientBookableEhrProcedure = 'patient_bookable_ehr_procedure',
  /** column name */
  Provider = 'provider',
  /** column name */
  Timespan = 'timespan',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Patient_Booking_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Patient_Booking_Set_Input>;
  /** filter the rows which have to be updated */
  where: Patient_Booking_Bool_Exp;
};

/** Boolean expression to filter rows from the table "patient". All fields are combined with a logical 'AND'. */
export type Patient_Bool_Exp = {
  _and?: InputMaybe<Array<Patient_Bool_Exp>>;
  _not?: InputMaybe<Patient_Bool_Exp>;
  _or?: InputMaybe<Array<Patient_Bool_Exp>>;
  address?: InputMaybe<Uuid_Comparison_Exp>;
  addressByAddress?: InputMaybe<Address_Bool_Exp>;
  cognitoSub?: InputMaybe<Uuid_Comparison_Exp>;
  cognitoUsername?: InputMaybe<Uuid_Comparison_Exp>;
  consentToContact?: InputMaybe<Boolean_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  credentialEpoch?: InputMaybe<Int_Comparison_Exp>;
  dateOfBirth?: InputMaybe<Date_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrEncounters?: InputMaybe<Ehr_Encounter_Bool_Exp>;
  ehrEncounters_aggregate?: InputMaybe<Ehr_Encounter_Aggregate_Bool_Exp>;
  ehrPatientCards?: InputMaybe<Ehr_Patient_Card_Bool_Exp>;
  ehrPatientCards_aggregate?: InputMaybe<Ehr_Patient_Card_Aggregate_Bool_Exp>;
  ehrPatientConsents?: InputMaybe<Ehr_Patient_Consent_Bool_Exp>;
  ehrPatientConsents_aggregate?: InputMaybe<Ehr_Patient_Consent_Aggregate_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  emergencyContactName?: InputMaybe<String_Comparison_Exp>;
  emergencyContactPhoneNumber?: InputMaybe<String_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<Gender_Enum_Comparison_Exp>;
  genderByGender?: InputMaybe<Gender_Bool_Exp>;
  genderNotes?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  mobilePhoneNumber?: InputMaybe<String_Comparison_Exp>;
  nickname?: InputMaybe<String_Comparison_Exp>;
  patientLastViews?: InputMaybe<Patient_Last_View_Bool_Exp>;
  patientLastViews_aggregate?: InputMaybe<Patient_Last_View_Aggregate_Bool_Exp>;
  patientMedicalProfiles?: InputMaybe<Patient_Medical_Profile_Bool_Exp>;
  patientMedicalProfiles_aggregate?: InputMaybe<Patient_Medical_Profile_Aggregate_Bool_Exp>;
  priorSquareCustomerIds?: InputMaybe<String_Array_Comparison_Exp>;
  profilePhotoS3Key?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  providerByProvider?: InputMaybe<User_Bool_Exp>;
  registrationInvites?: InputMaybe<Patient_Registration_Invite_Bool_Exp>;
  registrationInvites_aggregate?: InputMaybe<Patient_Registration_Invite_Aggregate_Bool_Exp>;
  sessionsValidFrom?: InputMaybe<Timestamptz_Comparison_Exp>;
  sex?: InputMaybe<Sex_Enum_Comparison_Exp>;
  sexBySex?: InputMaybe<Sex_Bool_Exp>;
  signingDocuments?: InputMaybe<Signing_Document_Bool_Exp>;
  signingDocuments_aggregate?: InputMaybe<Signing_Document_Aggregate_Bool_Exp>;
  squareCustomerId?: InputMaybe<String_Comparison_Exp>;
  stickyNotes?: InputMaybe<String_Comparison_Exp>;
  visibleToSupervisor?: InputMaybe<Boolean_Comparison_Exp>;
  webauthnCredentials?: InputMaybe<Patient_Webauthn_Credential_Bool_Exp>;
  webauthnCredentials_aggregate?: InputMaybe<Patient_Webauthn_Credential_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "patient" */
export enum Patient_Constraint {
  /** unique or primary key constraint on columns "cognito_sub" */
  PatientCognitoSubKey = 'patient_cognito_sub_key',
  /** unique or primary key constraint on columns "cognito_username" */
  PatientCognitoUsernameKey = 'patient_cognito_username_key',
  /** unique or primary key constraint on columns "id", "credential_epoch" */
  PatientIdCredentialEpochKey = 'patient_id_credential_epoch_key',
  /** unique or primary key constraint on columns "id" */
  PatientPkey = 'patient_pkey'
}

/** input type for incrementing numeric columns in table "patient" */
export type Patient_Inc_Input = {
  credentialEpoch?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "patient" */
export type Patient_Insert_Input = {
  address?: InputMaybe<Scalars['uuid']>;
  addressByAddress?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  /** Patient-pool Cognito user sub: the verified login identity durably linked to this record. Set at registration completion; NULL = no patient account. */
  cognitoSub?: InputMaybe<Scalars['uuid']>;
  /** Opaque Cognito username for this patient, rotated on every invite. Deliberately NOT the primary key and never PHI: it travels to Cognito, its logs, and the portal. */
  cognitoUsername?: InputMaybe<Scalars['uuid']>;
  consentToContact?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  credentialEpoch?: InputMaybe<Scalars['Int']>;
  dateOfBirth?: InputMaybe<Scalars['date']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  ehrEncounters?: InputMaybe<Ehr_Encounter_Arr_Rel_Insert_Input>;
  ehrPatientCards?: InputMaybe<Ehr_Patient_Card_Arr_Rel_Insert_Input>;
  ehrPatientConsents?: InputMaybe<Ehr_Patient_Consent_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']>;
  emergencyContactName?: InputMaybe<Scalars['String']>;
  emergencyContactPhoneNumber?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender_Enum>;
  genderByGender?: InputMaybe<Gender_Obj_Rel_Insert_Input>;
  genderNotes?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  /** If a medspa, everyone at the spa has access */
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  mobilePhoneNumber?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  patientLastViews?: InputMaybe<Patient_Last_View_Arr_Rel_Insert_Input>;
  patientMedicalProfiles?: InputMaybe<Patient_Medical_Profile_Arr_Rel_Insert_Input>;
  priorSquareCustomerIds?: InputMaybe<Array<Scalars['String']>>;
  profilePhotoS3Key?: InputMaybe<Scalars['uuid']>;
  /** Creating provider (not the owner if a medspa location) */
  provider?: InputMaybe<Scalars['uuid']>;
  providerByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
  registrationInvites?: InputMaybe<Patient_Registration_Invite_Arr_Rel_Insert_Input>;
  sessionsValidFrom?: InputMaybe<Scalars['timestamptz']>;
  sex?: InputMaybe<Sex_Enum>;
  sexBySex?: InputMaybe<Sex_Obj_Rel_Insert_Input>;
  signingDocuments?: InputMaybe<Signing_Document_Arr_Rel_Insert_Input>;
  squareCustomerId?: InputMaybe<Scalars['String']>;
  stickyNotes?: InputMaybe<Scalars['String']>;
  webauthnCredentials?: InputMaybe<Patient_Webauthn_Credential_Arr_Rel_Insert_Input>;
};

/** Track the most recently viewed patients for a provier-location.  Stored function keeps LRU trimmed to 20. */
export type Patient_Last_View = {
  __typename?: 'patient_last_view';
  createdAt: Scalars['timestamptz'];
  lastViewedAt: Scalars['timestamptz'];
  patient: Scalars['uuid'];
  /** An object relationship */
  patientByPatient: Patient;
  updatedAt: Scalars['timestamptz'];
  user: Scalars['uuid'];
  /** An object relationship */
  userByUser: User;
};

/** aggregated selection of "patient_last_view" */
export type Patient_Last_View_Aggregate = {
  __typename?: 'patient_last_view_aggregate';
  aggregate?: Maybe<Patient_Last_View_Aggregate_Fields>;
  nodes: Array<Patient_Last_View>;
};

export type Patient_Last_View_Aggregate_Bool_Exp = {
  count?: InputMaybe<Patient_Last_View_Aggregate_Bool_Exp_Count>;
};

export type Patient_Last_View_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Patient_Last_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Patient_Last_View_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "patient_last_view" */
export type Patient_Last_View_Aggregate_Fields = {
  __typename?: 'patient_last_view_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Patient_Last_View_Max_Fields>;
  min?: Maybe<Patient_Last_View_Min_Fields>;
};


/** aggregate fields of "patient_last_view" */
export type Patient_Last_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Patient_Last_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "patient_last_view" */
export type Patient_Last_View_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Patient_Last_View_Max_Order_By>;
  min?: InputMaybe<Patient_Last_View_Min_Order_By>;
};

/** input type for inserting array relation for remote table "patient_last_view" */
export type Patient_Last_View_Arr_Rel_Insert_Input = {
  data: Array<Patient_Last_View_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Patient_Last_View_On_Conflict>;
};

/** Boolean expression to filter rows from the table "patient_last_view". All fields are combined with a logical 'AND'. */
export type Patient_Last_View_Bool_Exp = {
  _and?: InputMaybe<Array<Patient_Last_View_Bool_Exp>>;
  _not?: InputMaybe<Patient_Last_View_Bool_Exp>;
  _or?: InputMaybe<Array<Patient_Last_View_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  lastViewedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  patient?: InputMaybe<Uuid_Comparison_Exp>;
  patientByPatient?: InputMaybe<Patient_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Uuid_Comparison_Exp>;
  userByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "patient_last_view" */
export enum Patient_Last_View_Constraint {
  /** unique or primary key constraint on columns "patient", "user" */
  PatientLastViewPkey = 'patient_last_view_pkey'
}

/** input type for inserting data into table "patient_last_view" */
export type Patient_Last_View_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  lastViewedAt?: InputMaybe<Scalars['timestamptz']>;
  patient?: InputMaybe<Scalars['uuid']>;
  patientByPatient?: InputMaybe<Patient_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
  userByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Patient_Last_View_Max_Fields = {
  __typename?: 'patient_last_view_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  lastViewedAt?: Maybe<Scalars['timestamptz']>;
  patient?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "patient_last_view" */
export type Patient_Last_View_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastViewedAt?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Patient_Last_View_Min_Fields = {
  __typename?: 'patient_last_view_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  lastViewedAt?: Maybe<Scalars['timestamptz']>;
  patient?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "patient_last_view" */
export type Patient_Last_View_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastViewedAt?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "patient_last_view" */
export type Patient_Last_View_Mutation_Response = {
  __typename?: 'patient_last_view_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient_Last_View>;
};

/** on_conflict condition type for table "patient_last_view" */
export type Patient_Last_View_On_Conflict = {
  constraint: Patient_Last_View_Constraint;
  update_columns?: Array<Patient_Last_View_Update_Column>;
  where?: InputMaybe<Patient_Last_View_Bool_Exp>;
};

/** Ordering options when selecting data from "patient_last_view". */
export type Patient_Last_View_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastViewedAt?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  patientByPatient?: InputMaybe<Patient_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  userByUser?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: patient_last_view */
export type Patient_Last_View_Pk_Columns_Input = {
  patient: Scalars['uuid'];
  user: Scalars['uuid'];
};

/** select columns of table "patient_last_view" */
export enum Patient_Last_View_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  LastViewedAt = 'lastViewedAt',
  /** column name */
  Patient = 'patient',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  User = 'user'
}

/** input type for updating data in table "patient_last_view" */
export type Patient_Last_View_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  lastViewedAt?: InputMaybe<Scalars['timestamptz']>;
  patient?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "patient_last_view" */
export type Patient_Last_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Patient_Last_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Patient_Last_View_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  lastViewedAt?: InputMaybe<Scalars['timestamptz']>;
  patient?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "patient_last_view" */
export enum Patient_Last_View_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  LastViewedAt = 'lastViewedAt',
  /** column name */
  Patient = 'patient',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  User = 'user'
}

export type Patient_Last_View_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Patient_Last_View_Set_Input>;
  /** filter the rows which have to be updated */
  where: Patient_Last_View_Bool_Exp;
};

/** aggregate max on columns */
export type Patient_Max_Fields = {
  __typename?: 'patient_max_fields';
  address?: Maybe<Scalars['uuid']>;
  /** Patient-pool Cognito user sub: the verified login identity durably linked to this record. Set at registration completion; NULL = no patient account. */
  cognitoSub?: Maybe<Scalars['uuid']>;
  /** Opaque Cognito username for this patient, rotated on every invite. Deliberately NOT the primary key and never PHI: it travels to Cognito, its logs, and the portal. */
  cognitoUsername?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  credentialEpoch?: Maybe<Scalars['Int']>;
  dateOfBirth?: Maybe<Scalars['date']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** occurred_at of the patient's newest consent event of the given consentType iff it is GRANTED, else null (never granted, or revoked since). Raises on an unknown consent type so a typo cannot masquerade as no-consent. */
  ehrConsentedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  emergencyContactName?: Maybe<Scalars['String']>;
  emergencyContactPhoneNumber?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  genderNotes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  /** If a medspa, everyone at the spa has access */
  location?: Maybe<Scalars['uuid']>;
  mobilePhoneNumber?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  priorSquareCustomerIds?: Maybe<Array<Scalars['String']>>;
  profilePhotoS3Key?: Maybe<Scalars['uuid']>;
  /** Creating provider (not the owner if a medspa location) */
  provider?: Maybe<Scalars['uuid']>;
  sessionsValidFrom?: Maybe<Scalars['timestamptz']>;
  squareCustomerId?: Maybe<Scalars['String']>;
  stickyNotes?: Maybe<Scalars['String']>;
};


/** aggregate max on columns */
export type Patient_Max_FieldsEhrConsentedAtArgs = {
  args: EhrConsentedAt_Patient_Args;
};

/** order by max() on columns of table "patient" */
export type Patient_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  /** Patient-pool Cognito user sub: the verified login identity durably linked to this record. Set at registration completion; NULL = no patient account. */
  cognitoSub?: InputMaybe<Order_By>;
  /** Opaque Cognito username for this patient, rotated on every invite. Deliberately NOT the primary key and never PHI: it travels to Cognito, its logs, and the portal. */
  cognitoUsername?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  credentialEpoch?: InputMaybe<Order_By>;
  dateOfBirth?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  emergencyContactName?: InputMaybe<Order_By>;
  emergencyContactPhoneNumber?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  genderNotes?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  /** If a medspa, everyone at the spa has access */
  location?: InputMaybe<Order_By>;
  mobilePhoneNumber?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  priorSquareCustomerIds?: InputMaybe<Order_By>;
  profilePhotoS3Key?: InputMaybe<Order_By>;
  /** Creating provider (not the owner if a medspa location) */
  provider?: InputMaybe<Order_By>;
  sessionsValidFrom?: InputMaybe<Order_By>;
  squareCustomerId?: InputMaybe<Order_By>;
  stickyNotes?: InputMaybe<Order_By>;
};

/** Created via trigger on Patient create, and deleted_at synced that way. */
export type Patient_Medical_Profile = {
  __typename?: 'patient_medical_profile';
  allergies?: Maybe<Scalars['String']>;
  bmi?: Maybe<Scalars['numeric']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  medicalHistory?: Maybe<Scalars['String']>;
  medications?: Maybe<Scalars['String']>;
  /** An object relationship */
  patientByPatient: Patient;
  surgicalHistory?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  weight?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "patient_medical_profile" */
export type Patient_Medical_Profile_Aggregate = {
  __typename?: 'patient_medical_profile_aggregate';
  aggregate?: Maybe<Patient_Medical_Profile_Aggregate_Fields>;
  nodes: Array<Patient_Medical_Profile>;
};

export type Patient_Medical_Profile_Aggregate_Bool_Exp = {
  count?: InputMaybe<Patient_Medical_Profile_Aggregate_Bool_Exp_Count>;
};

export type Patient_Medical_Profile_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Patient_Medical_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Patient_Medical_Profile_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "patient_medical_profile" */
export type Patient_Medical_Profile_Aggregate_Fields = {
  __typename?: 'patient_medical_profile_aggregate_fields';
  avg?: Maybe<Patient_Medical_Profile_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Patient_Medical_Profile_Max_Fields>;
  min?: Maybe<Patient_Medical_Profile_Min_Fields>;
  stddev?: Maybe<Patient_Medical_Profile_Stddev_Fields>;
  stddev_pop?: Maybe<Patient_Medical_Profile_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Patient_Medical_Profile_Stddev_Samp_Fields>;
  sum?: Maybe<Patient_Medical_Profile_Sum_Fields>;
  var_pop?: Maybe<Patient_Medical_Profile_Var_Pop_Fields>;
  var_samp?: Maybe<Patient_Medical_Profile_Var_Samp_Fields>;
  variance?: Maybe<Patient_Medical_Profile_Variance_Fields>;
};


/** aggregate fields of "patient_medical_profile" */
export type Patient_Medical_Profile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Patient_Medical_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "patient_medical_profile" */
export type Patient_Medical_Profile_Aggregate_Order_By = {
  avg?: InputMaybe<Patient_Medical_Profile_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Patient_Medical_Profile_Max_Order_By>;
  min?: InputMaybe<Patient_Medical_Profile_Min_Order_By>;
  stddev?: InputMaybe<Patient_Medical_Profile_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Patient_Medical_Profile_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Patient_Medical_Profile_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Patient_Medical_Profile_Sum_Order_By>;
  var_pop?: InputMaybe<Patient_Medical_Profile_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Patient_Medical_Profile_Var_Samp_Order_By>;
  variance?: InputMaybe<Patient_Medical_Profile_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "patient_medical_profile" */
export type Patient_Medical_Profile_Arr_Rel_Insert_Input = {
  data: Array<Patient_Medical_Profile_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Patient_Medical_Profile_On_Conflict>;
};

/** aggregate avg on columns */
export type Patient_Medical_Profile_Avg_Fields = {
  __typename?: 'patient_medical_profile_avg_fields';
  bmi?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "patient_medical_profile" */
export type Patient_Medical_Profile_Avg_Order_By = {
  bmi?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "patient_medical_profile". All fields are combined with a logical 'AND'. */
export type Patient_Medical_Profile_Bool_Exp = {
  _and?: InputMaybe<Array<Patient_Medical_Profile_Bool_Exp>>;
  _not?: InputMaybe<Patient_Medical_Profile_Bool_Exp>;
  _or?: InputMaybe<Array<Patient_Medical_Profile_Bool_Exp>>;
  allergies?: InputMaybe<String_Comparison_Exp>;
  bmi?: InputMaybe<Numeric_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  height?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  medicalHistory?: InputMaybe<String_Comparison_Exp>;
  medications?: InputMaybe<String_Comparison_Exp>;
  patientByPatient?: InputMaybe<Patient_Bool_Exp>;
  surgicalHistory?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  weight?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "patient_medical_profile" */
export enum Patient_Medical_Profile_Constraint {
  /** unique or primary key constraint on columns "id" */
  PatientMedicalProfilePkey = 'patient_medical_profile_pkey'
}

/** input type for incrementing numeric columns in table "patient_medical_profile" */
export type Patient_Medical_Profile_Inc_Input = {
  height?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "patient_medical_profile" */
export type Patient_Medical_Profile_Insert_Input = {
  allergies?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  height?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  medicalHistory?: InputMaybe<Scalars['String']>;
  medications?: InputMaybe<Scalars['String']>;
  patientByPatient?: InputMaybe<Patient_Obj_Rel_Insert_Input>;
  surgicalHistory?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Patient_Medical_Profile_Max_Fields = {
  __typename?: 'patient_medical_profile_max_fields';
  allergies?: Maybe<Scalars['String']>;
  bmi?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  medicalHistory?: Maybe<Scalars['String']>;
  medications?: Maybe<Scalars['String']>;
  surgicalHistory?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  weight?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "patient_medical_profile" */
export type Patient_Medical_Profile_Max_Order_By = {
  allergies?: InputMaybe<Order_By>;
  bmi?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  medicalHistory?: InputMaybe<Order_By>;
  medications?: InputMaybe<Order_By>;
  surgicalHistory?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Patient_Medical_Profile_Min_Fields = {
  __typename?: 'patient_medical_profile_min_fields';
  allergies?: Maybe<Scalars['String']>;
  bmi?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  medicalHistory?: Maybe<Scalars['String']>;
  medications?: Maybe<Scalars['String']>;
  surgicalHistory?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  weight?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "patient_medical_profile" */
export type Patient_Medical_Profile_Min_Order_By = {
  allergies?: InputMaybe<Order_By>;
  bmi?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  medicalHistory?: InputMaybe<Order_By>;
  medications?: InputMaybe<Order_By>;
  surgicalHistory?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "patient_medical_profile" */
export type Patient_Medical_Profile_Mutation_Response = {
  __typename?: 'patient_medical_profile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient_Medical_Profile>;
};

/** on_conflict condition type for table "patient_medical_profile" */
export type Patient_Medical_Profile_On_Conflict = {
  constraint: Patient_Medical_Profile_Constraint;
  update_columns?: Array<Patient_Medical_Profile_Update_Column>;
  where?: InputMaybe<Patient_Medical_Profile_Bool_Exp>;
};

/** Ordering options when selecting data from "patient_medical_profile". */
export type Patient_Medical_Profile_Order_By = {
  allergies?: InputMaybe<Order_By>;
  bmi?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  medicalHistory?: InputMaybe<Order_By>;
  medications?: InputMaybe<Order_By>;
  patientByPatient?: InputMaybe<Patient_Order_By>;
  surgicalHistory?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** primary key columns input for table: patient_medical_profile */
export type Patient_Medical_Profile_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "patient_medical_profile" */
export enum Patient_Medical_Profile_Select_Column {
  /** column name */
  Allergies = 'allergies',
  /** column name */
  Bmi = 'bmi',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Height = 'height',
  /** column name */
  Id = 'id',
  /** column name */
  MedicalHistory = 'medicalHistory',
  /** column name */
  Medications = 'medications',
  /** column name */
  SurgicalHistory = 'surgicalHistory',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Weight = 'weight'
}

/** input type for updating data in table "patient_medical_profile" */
export type Patient_Medical_Profile_Set_Input = {
  allergies?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  height?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  medicalHistory?: InputMaybe<Scalars['String']>;
  medications?: InputMaybe<Scalars['String']>;
  surgicalHistory?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Patient_Medical_Profile_Stddev_Fields = {
  __typename?: 'patient_medical_profile_stddev_fields';
  bmi?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "patient_medical_profile" */
export type Patient_Medical_Profile_Stddev_Order_By = {
  bmi?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Patient_Medical_Profile_Stddev_Pop_Fields = {
  __typename?: 'patient_medical_profile_stddev_pop_fields';
  bmi?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "patient_medical_profile" */
export type Patient_Medical_Profile_Stddev_Pop_Order_By = {
  bmi?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Patient_Medical_Profile_Stddev_Samp_Fields = {
  __typename?: 'patient_medical_profile_stddev_samp_fields';
  bmi?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "patient_medical_profile" */
export type Patient_Medical_Profile_Stddev_Samp_Order_By = {
  bmi?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "patient_medical_profile" */
export type Patient_Medical_Profile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Patient_Medical_Profile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Patient_Medical_Profile_Stream_Cursor_Value_Input = {
  allergies?: InputMaybe<Scalars['String']>;
  bmi?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  height?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  medicalHistory?: InputMaybe<Scalars['String']>;
  medications?: InputMaybe<Scalars['String']>;
  surgicalHistory?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Patient_Medical_Profile_Sum_Fields = {
  __typename?: 'patient_medical_profile_sum_fields';
  bmi?: Maybe<Scalars['numeric']>;
  height?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "patient_medical_profile" */
export type Patient_Medical_Profile_Sum_Order_By = {
  bmi?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** update columns of table "patient_medical_profile" */
export enum Patient_Medical_Profile_Update_Column {
  /** column name */
  Allergies = 'allergies',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Height = 'height',
  /** column name */
  Id = 'id',
  /** column name */
  MedicalHistory = 'medicalHistory',
  /** column name */
  Medications = 'medications',
  /** column name */
  SurgicalHistory = 'surgicalHistory',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Weight = 'weight'
}

export type Patient_Medical_Profile_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Patient_Medical_Profile_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Patient_Medical_Profile_Set_Input>;
  /** filter the rows which have to be updated */
  where: Patient_Medical_Profile_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Patient_Medical_Profile_Var_Pop_Fields = {
  __typename?: 'patient_medical_profile_var_pop_fields';
  bmi?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "patient_medical_profile" */
export type Patient_Medical_Profile_Var_Pop_Order_By = {
  bmi?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Patient_Medical_Profile_Var_Samp_Fields = {
  __typename?: 'patient_medical_profile_var_samp_fields';
  bmi?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "patient_medical_profile" */
export type Patient_Medical_Profile_Var_Samp_Order_By = {
  bmi?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Patient_Medical_Profile_Variance_Fields = {
  __typename?: 'patient_medical_profile_variance_fields';
  bmi?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "patient_medical_profile" */
export type Patient_Medical_Profile_Variance_Order_By = {
  bmi?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Patient_Min_Fields = {
  __typename?: 'patient_min_fields';
  address?: Maybe<Scalars['uuid']>;
  /** Patient-pool Cognito user sub: the verified login identity durably linked to this record. Set at registration completion; NULL = no patient account. */
  cognitoSub?: Maybe<Scalars['uuid']>;
  /** Opaque Cognito username for this patient, rotated on every invite. Deliberately NOT the primary key and never PHI: it travels to Cognito, its logs, and the portal. */
  cognitoUsername?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  credentialEpoch?: Maybe<Scalars['Int']>;
  dateOfBirth?: Maybe<Scalars['date']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** occurred_at of the patient's newest consent event of the given consentType iff it is GRANTED, else null (never granted, or revoked since). Raises on an unknown consent type so a typo cannot masquerade as no-consent. */
  ehrConsentedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  emergencyContactName?: Maybe<Scalars['String']>;
  emergencyContactPhoneNumber?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  genderNotes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  /** If a medspa, everyone at the spa has access */
  location?: Maybe<Scalars['uuid']>;
  mobilePhoneNumber?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  priorSquareCustomerIds?: Maybe<Array<Scalars['String']>>;
  profilePhotoS3Key?: Maybe<Scalars['uuid']>;
  /** Creating provider (not the owner if a medspa location) */
  provider?: Maybe<Scalars['uuid']>;
  sessionsValidFrom?: Maybe<Scalars['timestamptz']>;
  squareCustomerId?: Maybe<Scalars['String']>;
  stickyNotes?: Maybe<Scalars['String']>;
};


/** aggregate min on columns */
export type Patient_Min_FieldsEhrConsentedAtArgs = {
  args: EhrConsentedAt_Patient_Args;
};

/** order by min() on columns of table "patient" */
export type Patient_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  /** Patient-pool Cognito user sub: the verified login identity durably linked to this record. Set at registration completion; NULL = no patient account. */
  cognitoSub?: InputMaybe<Order_By>;
  /** Opaque Cognito username for this patient, rotated on every invite. Deliberately NOT the primary key and never PHI: it travels to Cognito, its logs, and the portal. */
  cognitoUsername?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  credentialEpoch?: InputMaybe<Order_By>;
  dateOfBirth?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  emergencyContactName?: InputMaybe<Order_By>;
  emergencyContactPhoneNumber?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  genderNotes?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  /** If a medspa, everyone at the spa has access */
  location?: InputMaybe<Order_By>;
  mobilePhoneNumber?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  priorSquareCustomerIds?: InputMaybe<Order_By>;
  profilePhotoS3Key?: InputMaybe<Order_By>;
  /** Creating provider (not the owner if a medspa location) */
  provider?: InputMaybe<Order_By>;
  sessionsValidFrom?: InputMaybe<Order_By>;
  squareCustomerId?: InputMaybe<Order_By>;
  stickyNotes?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "patient" */
export type Patient_Mutation_Response = {
  __typename?: 'patient_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient>;
};

/** input type for inserting object relation for remote table "patient" */
export type Patient_Obj_Rel_Insert_Input = {
  data: Patient_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Patient_On_Conflict>;
};

/** on_conflict condition type for table "patient" */
export type Patient_On_Conflict = {
  constraint: Patient_Constraint;
  update_columns?: Array<Patient_Update_Column>;
  where?: InputMaybe<Patient_Bool_Exp>;
};

/** Ordering options when selecting data from "patient". */
export type Patient_Order_By = {
  address?: InputMaybe<Order_By>;
  addressByAddress?: InputMaybe<Address_Order_By>;
  cognitoSub?: InputMaybe<Order_By>;
  cognitoUsername?: InputMaybe<Order_By>;
  consentToContact?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  credentialEpoch?: InputMaybe<Order_By>;
  dateOfBirth?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  ehrEncounters_aggregate?: InputMaybe<Ehr_Encounter_Aggregate_Order_By>;
  ehrPatientCards_aggregate?: InputMaybe<Ehr_Patient_Card_Aggregate_Order_By>;
  ehrPatientConsents_aggregate?: InputMaybe<Ehr_Patient_Consent_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  emergencyContactName?: InputMaybe<Order_By>;
  emergencyContactPhoneNumber?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  genderByGender?: InputMaybe<Gender_Order_By>;
  genderNotes?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  mobilePhoneNumber?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  patientLastViews_aggregate?: InputMaybe<Patient_Last_View_Aggregate_Order_By>;
  patientMedicalProfiles_aggregate?: InputMaybe<Patient_Medical_Profile_Aggregate_Order_By>;
  priorSquareCustomerIds?: InputMaybe<Order_By>;
  profilePhotoS3Key?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  providerByProvider?: InputMaybe<User_Order_By>;
  registrationInvites_aggregate?: InputMaybe<Patient_Registration_Invite_Aggregate_Order_By>;
  sessionsValidFrom?: InputMaybe<Order_By>;
  sex?: InputMaybe<Order_By>;
  sexBySex?: InputMaybe<Sex_Order_By>;
  signingDocuments_aggregate?: InputMaybe<Signing_Document_Aggregate_Order_By>;
  squareCustomerId?: InputMaybe<Order_By>;
  stickyNotes?: InputMaybe<Order_By>;
  visibleToSupervisor?: InputMaybe<Order_By>;
  webauthnCredentials_aggregate?: InputMaybe<Patient_Webauthn_Credential_Aggregate_Order_By>;
};

/** primary key columns input for table: patient */
export type Patient_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** Provider-sent patient registration invites. Single-use (consumed_at), expiring (expires_at); re-sending invalidates prior open invites (invalidated_at). Stores only the SHA-256 hex of the SMS link token, never the token itself. */
export type Patient_Registration_Invite = {
  __typename?: 'patient_registration_invite';
  consumedAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  expiresAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  invalidatedAt?: Maybe<Scalars['timestamptz']>;
  invitedBy: Scalars['uuid'];
  patient: Scalars['uuid'];
  /** An object relationship */
  patientByPatient: Patient;
  tokenHash: Scalars['String'];
  /** An object relationship */
  userByInvitedBy: User;
};

/** aggregated selection of "patient_registration_invite" */
export type Patient_Registration_Invite_Aggregate = {
  __typename?: 'patient_registration_invite_aggregate';
  aggregate?: Maybe<Patient_Registration_Invite_Aggregate_Fields>;
  nodes: Array<Patient_Registration_Invite>;
};

export type Patient_Registration_Invite_Aggregate_Bool_Exp = {
  count?: InputMaybe<Patient_Registration_Invite_Aggregate_Bool_Exp_Count>;
};

export type Patient_Registration_Invite_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Patient_Registration_Invite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Patient_Registration_Invite_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "patient_registration_invite" */
export type Patient_Registration_Invite_Aggregate_Fields = {
  __typename?: 'patient_registration_invite_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Patient_Registration_Invite_Max_Fields>;
  min?: Maybe<Patient_Registration_Invite_Min_Fields>;
};


/** aggregate fields of "patient_registration_invite" */
export type Patient_Registration_Invite_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Patient_Registration_Invite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "patient_registration_invite" */
export type Patient_Registration_Invite_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Patient_Registration_Invite_Max_Order_By>;
  min?: InputMaybe<Patient_Registration_Invite_Min_Order_By>;
};

/** input type for inserting array relation for remote table "patient_registration_invite" */
export type Patient_Registration_Invite_Arr_Rel_Insert_Input = {
  data: Array<Patient_Registration_Invite_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Patient_Registration_Invite_On_Conflict>;
};

/** Boolean expression to filter rows from the table "patient_registration_invite". All fields are combined with a logical 'AND'. */
export type Patient_Registration_Invite_Bool_Exp = {
  _and?: InputMaybe<Array<Patient_Registration_Invite_Bool_Exp>>;
  _not?: InputMaybe<Patient_Registration_Invite_Bool_Exp>;
  _or?: InputMaybe<Array<Patient_Registration_Invite_Bool_Exp>>;
  consumedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invalidatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  invitedBy?: InputMaybe<Uuid_Comparison_Exp>;
  patient?: InputMaybe<Uuid_Comparison_Exp>;
  patientByPatient?: InputMaybe<Patient_Bool_Exp>;
  tokenHash?: InputMaybe<String_Comparison_Exp>;
  userByInvitedBy?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "patient_registration_invite" */
export enum Patient_Registration_Invite_Constraint {
  /** unique or primary key constraint on columns "patient" */
  PatientRegistrationInviteOneOpenPerPatient = 'patient_registration_invite_one_open_per_patient',
  /** unique or primary key constraint on columns "id" */
  PatientRegistrationInvitePkey = 'patient_registration_invite_pkey',
  /** unique or primary key constraint on columns "token_hash" */
  PatientRegistrationInviteTokenHashKey = 'patient_registration_invite_token_hash_key'
}

/** input type for inserting data into table "patient_registration_invite" */
export type Patient_Registration_Invite_Insert_Input = {
  consumedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  invalidatedAt?: InputMaybe<Scalars['timestamptz']>;
  invitedBy?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  patientByPatient?: InputMaybe<Patient_Obj_Rel_Insert_Input>;
  tokenHash?: InputMaybe<Scalars['String']>;
  userByInvitedBy?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Patient_Registration_Invite_Max_Fields = {
  __typename?: 'patient_registration_invite_max_fields';
  consumedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invalidatedAt?: Maybe<Scalars['timestamptz']>;
  invitedBy?: Maybe<Scalars['uuid']>;
  patient?: Maybe<Scalars['uuid']>;
  tokenHash?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "patient_registration_invite" */
export type Patient_Registration_Invite_Max_Order_By = {
  consumedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invalidatedAt?: InputMaybe<Order_By>;
  invitedBy?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  tokenHash?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Patient_Registration_Invite_Min_Fields = {
  __typename?: 'patient_registration_invite_min_fields';
  consumedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invalidatedAt?: Maybe<Scalars['timestamptz']>;
  invitedBy?: Maybe<Scalars['uuid']>;
  patient?: Maybe<Scalars['uuid']>;
  tokenHash?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "patient_registration_invite" */
export type Patient_Registration_Invite_Min_Order_By = {
  consumedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invalidatedAt?: InputMaybe<Order_By>;
  invitedBy?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  tokenHash?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "patient_registration_invite" */
export type Patient_Registration_Invite_Mutation_Response = {
  __typename?: 'patient_registration_invite_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient_Registration_Invite>;
};

/** on_conflict condition type for table "patient_registration_invite" */
export type Patient_Registration_Invite_On_Conflict = {
  constraint: Patient_Registration_Invite_Constraint;
  update_columns?: Array<Patient_Registration_Invite_Update_Column>;
  where?: InputMaybe<Patient_Registration_Invite_Bool_Exp>;
};

/** Ordering options when selecting data from "patient_registration_invite". */
export type Patient_Registration_Invite_Order_By = {
  consumedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invalidatedAt?: InputMaybe<Order_By>;
  invitedBy?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  patientByPatient?: InputMaybe<Patient_Order_By>;
  tokenHash?: InputMaybe<Order_By>;
  userByInvitedBy?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: patient_registration_invite */
export type Patient_Registration_Invite_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "patient_registration_invite" */
export enum Patient_Registration_Invite_Select_Column {
  /** column name */
  ConsumedAt = 'consumedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  InvalidatedAt = 'invalidatedAt',
  /** column name */
  InvitedBy = 'invitedBy',
  /** column name */
  Patient = 'patient',
  /** column name */
  TokenHash = 'tokenHash'
}

/** input type for updating data in table "patient_registration_invite" */
export type Patient_Registration_Invite_Set_Input = {
  consumedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  invalidatedAt?: InputMaybe<Scalars['timestamptz']>;
  invitedBy?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  tokenHash?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "patient_registration_invite" */
export type Patient_Registration_Invite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Patient_Registration_Invite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Patient_Registration_Invite_Stream_Cursor_Value_Input = {
  consumedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  invalidatedAt?: InputMaybe<Scalars['timestamptz']>;
  invitedBy?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  tokenHash?: InputMaybe<Scalars['String']>;
};

/** update columns of table "patient_registration_invite" */
export enum Patient_Registration_Invite_Update_Column {
  /** column name */
  ConsumedAt = 'consumedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  InvalidatedAt = 'invalidatedAt',
  /** column name */
  InvitedBy = 'invitedBy',
  /** column name */
  Patient = 'patient',
  /** column name */
  TokenHash = 'tokenHash'
}

export type Patient_Registration_Invite_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Patient_Registration_Invite_Set_Input>;
  /** filter the rows which have to be updated */
  where: Patient_Registration_Invite_Bool_Exp;
};

/** select columns of table "patient" */
export enum Patient_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CognitoSub = 'cognitoSub',
  /** column name */
  CognitoUsername = 'cognitoUsername',
  /** column name */
  ConsentToContact = 'consentToContact',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CredentialEpoch = 'credentialEpoch',
  /** column name */
  DateOfBirth = 'dateOfBirth',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  EmergencyContactName = 'emergencyContactName',
  /** column name */
  EmergencyContactPhoneNumber = 'emergencyContactPhoneNumber',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Gender = 'gender',
  /** column name */
  GenderNotes = 'genderNotes',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'lastName',
  /** column name */
  Location = 'location',
  /** column name */
  MobilePhoneNumber = 'mobilePhoneNumber',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  PriorSquareCustomerIds = 'priorSquareCustomerIds',
  /** column name */
  ProfilePhotoS3Key = 'profilePhotoS3Key',
  /** column name */
  Provider = 'provider',
  /** column name */
  SessionsValidFrom = 'sessionsValidFrom',
  /** column name */
  Sex = 'sex',
  /** column name */
  SquareCustomerId = 'squareCustomerId',
  /** column name */
  StickyNotes = 'stickyNotes'
}

/** select "patient_aggregate_bool_exp_bool_and_arguments_columns" columns of table "patient" */
export enum Patient_Select_Column_Patient_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ConsentToContact = 'consentToContact'
}

/** select "patient_aggregate_bool_exp_bool_or_arguments_columns" columns of table "patient" */
export enum Patient_Select_Column_Patient_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ConsentToContact = 'consentToContact'
}

/** Server-owned patient sessions. A live row (token_hash set, revoked_at/expires_at unexpired) is the sole thing the auth webhook accepts for Patient access; minted only by a verified passkey assertion. Cognito tokens are not accepted for HIPAA data. */
export type Patient_Session = {
  __typename?: 'patient_session';
  claimedAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  patient: Scalars['uuid'];
  /** An object relationship */
  patientByPatient: Patient;
  regEpoch: Scalars['Int'];
  revokedAt?: Maybe<Scalars['timestamptz']>;
  tokenHash?: Maybe<Scalars['String']>;
};

/** aggregated selection of "patient_session" */
export type Patient_Session_Aggregate = {
  __typename?: 'patient_session_aggregate';
  aggregate?: Maybe<Patient_Session_Aggregate_Fields>;
  nodes: Array<Patient_Session>;
};

/** aggregate fields of "patient_session" */
export type Patient_Session_Aggregate_Fields = {
  __typename?: 'patient_session_aggregate_fields';
  avg?: Maybe<Patient_Session_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Patient_Session_Max_Fields>;
  min?: Maybe<Patient_Session_Min_Fields>;
  stddev?: Maybe<Patient_Session_Stddev_Fields>;
  stddev_pop?: Maybe<Patient_Session_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Patient_Session_Stddev_Samp_Fields>;
  sum?: Maybe<Patient_Session_Sum_Fields>;
  var_pop?: Maybe<Patient_Session_Var_Pop_Fields>;
  var_samp?: Maybe<Patient_Session_Var_Samp_Fields>;
  variance?: Maybe<Patient_Session_Variance_Fields>;
};


/** aggregate fields of "patient_session" */
export type Patient_Session_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Patient_Session_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Patient_Session_Avg_Fields = {
  __typename?: 'patient_session_avg_fields';
  regEpoch?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "patient_session". All fields are combined with a logical 'AND'. */
export type Patient_Session_Bool_Exp = {
  _and?: InputMaybe<Array<Patient_Session_Bool_Exp>>;
  _not?: InputMaybe<Patient_Session_Bool_Exp>;
  _or?: InputMaybe<Array<Patient_Session_Bool_Exp>>;
  claimedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  patient?: InputMaybe<Uuid_Comparison_Exp>;
  patientByPatient?: InputMaybe<Patient_Bool_Exp>;
  regEpoch?: InputMaybe<Int_Comparison_Exp>;
  revokedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  tokenHash?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "patient_session" */
export enum Patient_Session_Constraint {
  /** unique or primary key constraint on columns "patient" */
  PatientSessionOnePendingPerPatient = 'patient_session_one_pending_per_patient',
  /** unique or primary key constraint on columns "id" */
  PatientSessionPkey = 'patient_session_pkey',
  /** unique or primary key constraint on columns "token_hash" */
  PatientSessionTokenHashKey = 'patient_session_token_hash_key'
}

/** input type for incrementing numeric columns in table "patient_session" */
export type Patient_Session_Inc_Input = {
  regEpoch?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "patient_session" */
export type Patient_Session_Insert_Input = {
  claimedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  patientByPatient?: InputMaybe<Patient_Obj_Rel_Insert_Input>;
  regEpoch?: InputMaybe<Scalars['Int']>;
  revokedAt?: InputMaybe<Scalars['timestamptz']>;
  tokenHash?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Patient_Session_Max_Fields = {
  __typename?: 'patient_session_max_fields';
  claimedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  patient?: Maybe<Scalars['uuid']>;
  regEpoch?: Maybe<Scalars['Int']>;
  revokedAt?: Maybe<Scalars['timestamptz']>;
  tokenHash?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Patient_Session_Min_Fields = {
  __typename?: 'patient_session_min_fields';
  claimedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  patient?: Maybe<Scalars['uuid']>;
  regEpoch?: Maybe<Scalars['Int']>;
  revokedAt?: Maybe<Scalars['timestamptz']>;
  tokenHash?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "patient_session" */
export type Patient_Session_Mutation_Response = {
  __typename?: 'patient_session_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient_Session>;
};

/** on_conflict condition type for table "patient_session" */
export type Patient_Session_On_Conflict = {
  constraint: Patient_Session_Constraint;
  update_columns?: Array<Patient_Session_Update_Column>;
  where?: InputMaybe<Patient_Session_Bool_Exp>;
};

/** Ordering options when selecting data from "patient_session". */
export type Patient_Session_Order_By = {
  claimedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  patientByPatient?: InputMaybe<Patient_Order_By>;
  regEpoch?: InputMaybe<Order_By>;
  revokedAt?: InputMaybe<Order_By>;
  tokenHash?: InputMaybe<Order_By>;
};

/** primary key columns input for table: patient_session */
export type Patient_Session_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "patient_session" */
export enum Patient_Session_Select_Column {
  /** column name */
  ClaimedAt = 'claimedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Patient = 'patient',
  /** column name */
  RegEpoch = 'regEpoch',
  /** column name */
  RevokedAt = 'revokedAt',
  /** column name */
  TokenHash = 'tokenHash'
}

/** input type for updating data in table "patient_session" */
export type Patient_Session_Set_Input = {
  claimedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  regEpoch?: InputMaybe<Scalars['Int']>;
  revokedAt?: InputMaybe<Scalars['timestamptz']>;
  tokenHash?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Patient_Session_Stddev_Fields = {
  __typename?: 'patient_session_stddev_fields';
  regEpoch?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Patient_Session_Stddev_Pop_Fields = {
  __typename?: 'patient_session_stddev_pop_fields';
  regEpoch?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Patient_Session_Stddev_Samp_Fields = {
  __typename?: 'patient_session_stddev_samp_fields';
  regEpoch?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "patient_session" */
export type Patient_Session_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Patient_Session_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Patient_Session_Stream_Cursor_Value_Input = {
  claimedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  regEpoch?: InputMaybe<Scalars['Int']>;
  revokedAt?: InputMaybe<Scalars['timestamptz']>;
  tokenHash?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Patient_Session_Sum_Fields = {
  __typename?: 'patient_session_sum_fields';
  regEpoch?: Maybe<Scalars['Int']>;
};

/** update columns of table "patient_session" */
export enum Patient_Session_Update_Column {
  /** column name */
  ClaimedAt = 'claimedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Patient = 'patient',
  /** column name */
  RegEpoch = 'regEpoch',
  /** column name */
  RevokedAt = 'revokedAt',
  /** column name */
  TokenHash = 'tokenHash'
}

export type Patient_Session_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Patient_Session_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Patient_Session_Set_Input>;
  /** filter the rows which have to be updated */
  where: Patient_Session_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Patient_Session_Var_Pop_Fields = {
  __typename?: 'patient_session_var_pop_fields';
  regEpoch?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Patient_Session_Var_Samp_Fields = {
  __typename?: 'patient_session_var_samp_fields';
  regEpoch?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Patient_Session_Variance_Fields = {
  __typename?: 'patient_session_variance_fields';
  regEpoch?: Maybe<Scalars['Float']>;
};

/** input type for updating data in table "patient" */
export type Patient_Set_Input = {
  address?: InputMaybe<Scalars['uuid']>;
  /** Patient-pool Cognito user sub: the verified login identity durably linked to this record. Set at registration completion; NULL = no patient account. */
  cognitoSub?: InputMaybe<Scalars['uuid']>;
  /** Opaque Cognito username for this patient, rotated on every invite. Deliberately NOT the primary key and never PHI: it travels to Cognito, its logs, and the portal. */
  cognitoUsername?: InputMaybe<Scalars['uuid']>;
  consentToContact?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  credentialEpoch?: InputMaybe<Scalars['Int']>;
  dateOfBirth?: InputMaybe<Scalars['date']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  emergencyContactName?: InputMaybe<Scalars['String']>;
  emergencyContactPhoneNumber?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender_Enum>;
  genderNotes?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  /** If a medspa, everyone at the spa has access */
  location?: InputMaybe<Scalars['uuid']>;
  mobilePhoneNumber?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  priorSquareCustomerIds?: InputMaybe<Array<Scalars['String']>>;
  profilePhotoS3Key?: InputMaybe<Scalars['uuid']>;
  /** Creating provider (not the owner if a medspa location) */
  provider?: InputMaybe<Scalars['uuid']>;
  sessionsValidFrom?: InputMaybe<Scalars['timestamptz']>;
  sex?: InputMaybe<Sex_Enum>;
  squareCustomerId?: InputMaybe<Scalars['String']>;
  stickyNotes?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Patient_Stddev_Fields = {
  __typename?: 'patient_stddev_fields';
  credentialEpoch?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "patient" */
export type Patient_Stddev_Order_By = {
  credentialEpoch?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Patient_Stddev_Pop_Fields = {
  __typename?: 'patient_stddev_pop_fields';
  credentialEpoch?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "patient" */
export type Patient_Stddev_Pop_Order_By = {
  credentialEpoch?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Patient_Stddev_Samp_Fields = {
  __typename?: 'patient_stddev_samp_fields';
  credentialEpoch?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "patient" */
export type Patient_Stddev_Samp_Order_By = {
  credentialEpoch?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "patient" */
export type Patient_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Patient_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Patient_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['uuid']>;
  /** Patient-pool Cognito user sub: the verified login identity durably linked to this record. Set at registration completion; NULL = no patient account. */
  cognitoSub?: InputMaybe<Scalars['uuid']>;
  /** Opaque Cognito username for this patient, rotated on every invite. Deliberately NOT the primary key and never PHI: it travels to Cognito, its logs, and the portal. */
  cognitoUsername?: InputMaybe<Scalars['uuid']>;
  consentToContact?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  credentialEpoch?: InputMaybe<Scalars['Int']>;
  dateOfBirth?: InputMaybe<Scalars['date']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  emergencyContactName?: InputMaybe<Scalars['String']>;
  emergencyContactPhoneNumber?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender_Enum>;
  genderNotes?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  /** If a medspa, everyone at the spa has access */
  location?: InputMaybe<Scalars['uuid']>;
  mobilePhoneNumber?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  priorSquareCustomerIds?: InputMaybe<Array<Scalars['String']>>;
  profilePhotoS3Key?: InputMaybe<Scalars['uuid']>;
  /** Creating provider (not the owner if a medspa location) */
  provider?: InputMaybe<Scalars['uuid']>;
  sessionsValidFrom?: InputMaybe<Scalars['timestamptz']>;
  sex?: InputMaybe<Sex_Enum>;
  squareCustomerId?: InputMaybe<Scalars['String']>;
  stickyNotes?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Patient_Sum_Fields = {
  __typename?: 'patient_sum_fields';
  credentialEpoch?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "patient" */
export type Patient_Sum_Order_By = {
  credentialEpoch?: InputMaybe<Order_By>;
};

/** update columns of table "patient" */
export enum Patient_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CognitoSub = 'cognitoSub',
  /** column name */
  CognitoUsername = 'cognitoUsername',
  /** column name */
  ConsentToContact = 'consentToContact',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CredentialEpoch = 'credentialEpoch',
  /** column name */
  DateOfBirth = 'dateOfBirth',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  EmergencyContactName = 'emergencyContactName',
  /** column name */
  EmergencyContactPhoneNumber = 'emergencyContactPhoneNumber',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Gender = 'gender',
  /** column name */
  GenderNotes = 'genderNotes',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'lastName',
  /** column name */
  Location = 'location',
  /** column name */
  MobilePhoneNumber = 'mobilePhoneNumber',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  PriorSquareCustomerIds = 'priorSquareCustomerIds',
  /** column name */
  ProfilePhotoS3Key = 'profilePhotoS3Key',
  /** column name */
  Provider = 'provider',
  /** column name */
  SessionsValidFrom = 'sessionsValidFrom',
  /** column name */
  Sex = 'sex',
  /** column name */
  SquareCustomerId = 'squareCustomerId',
  /** column name */
  StickyNotes = 'stickyNotes'
}

export type Patient_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Patient_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Patient_Set_Input>;
  /** filter the rows which have to be updated */
  where: Patient_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Patient_Var_Pop_Fields = {
  __typename?: 'patient_var_pop_fields';
  credentialEpoch?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "patient" */
export type Patient_Var_Pop_Order_By = {
  credentialEpoch?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Patient_Var_Samp_Fields = {
  __typename?: 'patient_var_samp_fields';
  credentialEpoch?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "patient" */
export type Patient_Var_Samp_Order_By = {
  credentialEpoch?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Patient_Variance_Fields = {
  __typename?: 'patient_variance_fields';
  credentialEpoch?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "patient" */
export type Patient_Variance_Order_By = {
  credentialEpoch?: InputMaybe<Order_By>;
};

/** Short-lived, single-use WebAuthn registration challenges. PK on patient: issuing new options supersedes any outstanding challenge. */
export type Patient_Webauthn_Challenge = {
  __typename?: 'patient_webauthn_challenge';
  challenge: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  expiresAt: Scalars['timestamptz'];
  patient: Scalars['uuid'];
  /** An object relationship */
  patientByPatient: Patient;
};

/** aggregated selection of "patient_webauthn_challenge" */
export type Patient_Webauthn_Challenge_Aggregate = {
  __typename?: 'patient_webauthn_challenge_aggregate';
  aggregate?: Maybe<Patient_Webauthn_Challenge_Aggregate_Fields>;
  nodes: Array<Patient_Webauthn_Challenge>;
};

/** aggregate fields of "patient_webauthn_challenge" */
export type Patient_Webauthn_Challenge_Aggregate_Fields = {
  __typename?: 'patient_webauthn_challenge_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Patient_Webauthn_Challenge_Max_Fields>;
  min?: Maybe<Patient_Webauthn_Challenge_Min_Fields>;
};


/** aggregate fields of "patient_webauthn_challenge" */
export type Patient_Webauthn_Challenge_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Patient_Webauthn_Challenge_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "patient_webauthn_challenge". All fields are combined with a logical 'AND'. */
export type Patient_Webauthn_Challenge_Bool_Exp = {
  _and?: InputMaybe<Array<Patient_Webauthn_Challenge_Bool_Exp>>;
  _not?: InputMaybe<Patient_Webauthn_Challenge_Bool_Exp>;
  _or?: InputMaybe<Array<Patient_Webauthn_Challenge_Bool_Exp>>;
  challenge?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  patient?: InputMaybe<Uuid_Comparison_Exp>;
  patientByPatient?: InputMaybe<Patient_Bool_Exp>;
};

/** unique or primary key constraints on table "patient_webauthn_challenge" */
export enum Patient_Webauthn_Challenge_Constraint {
  /** unique or primary key constraint on columns "patient" */
  PatientWebauthnChallengePkey = 'patient_webauthn_challenge_pkey'
}

/** input type for inserting data into table "patient_webauthn_challenge" */
export type Patient_Webauthn_Challenge_Insert_Input = {
  challenge?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  patient?: InputMaybe<Scalars['uuid']>;
  patientByPatient?: InputMaybe<Patient_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Patient_Webauthn_Challenge_Max_Fields = {
  __typename?: 'patient_webauthn_challenge_max_fields';
  challenge?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  patient?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Patient_Webauthn_Challenge_Min_Fields = {
  __typename?: 'patient_webauthn_challenge_min_fields';
  challenge?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  patient?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "patient_webauthn_challenge" */
export type Patient_Webauthn_Challenge_Mutation_Response = {
  __typename?: 'patient_webauthn_challenge_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient_Webauthn_Challenge>;
};

/** on_conflict condition type for table "patient_webauthn_challenge" */
export type Patient_Webauthn_Challenge_On_Conflict = {
  constraint: Patient_Webauthn_Challenge_Constraint;
  update_columns?: Array<Patient_Webauthn_Challenge_Update_Column>;
  where?: InputMaybe<Patient_Webauthn_Challenge_Bool_Exp>;
};

/** Ordering options when selecting data from "patient_webauthn_challenge". */
export type Patient_Webauthn_Challenge_Order_By = {
  challenge?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  patientByPatient?: InputMaybe<Patient_Order_By>;
};

/** primary key columns input for table: patient_webauthn_challenge */
export type Patient_Webauthn_Challenge_Pk_Columns_Input = {
  patient: Scalars['uuid'];
};

/** select columns of table "patient_webauthn_challenge" */
export enum Patient_Webauthn_Challenge_Select_Column {
  /** column name */
  Challenge = 'challenge',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Patient = 'patient'
}

/** input type for updating data in table "patient_webauthn_challenge" */
export type Patient_Webauthn_Challenge_Set_Input = {
  challenge?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  patient?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "patient_webauthn_challenge" */
export type Patient_Webauthn_Challenge_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Patient_Webauthn_Challenge_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Patient_Webauthn_Challenge_Stream_Cursor_Value_Input = {
  challenge?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  patient?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "patient_webauthn_challenge" */
export enum Patient_Webauthn_Challenge_Update_Column {
  /** column name */
  Challenge = 'challenge',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Patient = 'patient'
}

export type Patient_Webauthn_Challenge_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Patient_Webauthn_Challenge_Set_Input>;
  /** filter the rows which have to be updated */
  where: Patient_Webauthn_Challenge_Bool_Exp;
};

/** Patient portal passkeys, verified and stored server-side (py_webauthn). A LIVE row (deleted_at IS NULL) is both the credential and the patient's access: there is no separate gate column. Soft-deleted rows are retained as the forensic record. */
export type Patient_Webauthn_Credential = {
  __typename?: 'patient_webauthn_credential';
  createdAt: Scalars['timestamptz'];
  credentialId: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  lastUsedAt?: Maybe<Scalars['timestamptz']>;
  patient: Scalars['uuid'];
  /** An object relationship */
  patientByPatient: Patient;
  publicKey: Scalars['String'];
  regEpoch?: Maybe<Scalars['Int']>;
  signCount: Scalars['bigint'];
};

/** aggregated selection of "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Aggregate = {
  __typename?: 'patient_webauthn_credential_aggregate';
  aggregate?: Maybe<Patient_Webauthn_Credential_Aggregate_Fields>;
  nodes: Array<Patient_Webauthn_Credential>;
};

export type Patient_Webauthn_Credential_Aggregate_Bool_Exp = {
  count?: InputMaybe<Patient_Webauthn_Credential_Aggregate_Bool_Exp_Count>;
};

export type Patient_Webauthn_Credential_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Patient_Webauthn_Credential_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Patient_Webauthn_Credential_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Aggregate_Fields = {
  __typename?: 'patient_webauthn_credential_aggregate_fields';
  avg?: Maybe<Patient_Webauthn_Credential_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Patient_Webauthn_Credential_Max_Fields>;
  min?: Maybe<Patient_Webauthn_Credential_Min_Fields>;
  stddev?: Maybe<Patient_Webauthn_Credential_Stddev_Fields>;
  stddev_pop?: Maybe<Patient_Webauthn_Credential_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Patient_Webauthn_Credential_Stddev_Samp_Fields>;
  sum?: Maybe<Patient_Webauthn_Credential_Sum_Fields>;
  var_pop?: Maybe<Patient_Webauthn_Credential_Var_Pop_Fields>;
  var_samp?: Maybe<Patient_Webauthn_Credential_Var_Samp_Fields>;
  variance?: Maybe<Patient_Webauthn_Credential_Variance_Fields>;
};


/** aggregate fields of "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Patient_Webauthn_Credential_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Aggregate_Order_By = {
  avg?: InputMaybe<Patient_Webauthn_Credential_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Patient_Webauthn_Credential_Max_Order_By>;
  min?: InputMaybe<Patient_Webauthn_Credential_Min_Order_By>;
  stddev?: InputMaybe<Patient_Webauthn_Credential_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Patient_Webauthn_Credential_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Patient_Webauthn_Credential_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Patient_Webauthn_Credential_Sum_Order_By>;
  var_pop?: InputMaybe<Patient_Webauthn_Credential_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Patient_Webauthn_Credential_Var_Samp_Order_By>;
  variance?: InputMaybe<Patient_Webauthn_Credential_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Arr_Rel_Insert_Input = {
  data: Array<Patient_Webauthn_Credential_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Patient_Webauthn_Credential_On_Conflict>;
};

/** aggregate avg on columns */
export type Patient_Webauthn_Credential_Avg_Fields = {
  __typename?: 'patient_webauthn_credential_avg_fields';
  regEpoch?: Maybe<Scalars['Float']>;
  signCount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Avg_Order_By = {
  regEpoch?: InputMaybe<Order_By>;
  signCount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "patient_webauthn_credential". All fields are combined with a logical 'AND'. */
export type Patient_Webauthn_Credential_Bool_Exp = {
  _and?: InputMaybe<Array<Patient_Webauthn_Credential_Bool_Exp>>;
  _not?: InputMaybe<Patient_Webauthn_Credential_Bool_Exp>;
  _or?: InputMaybe<Array<Patient_Webauthn_Credential_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  credentialId?: InputMaybe<String_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lastUsedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  patient?: InputMaybe<Uuid_Comparison_Exp>;
  patientByPatient?: InputMaybe<Patient_Bool_Exp>;
  publicKey?: InputMaybe<String_Comparison_Exp>;
  regEpoch?: InputMaybe<Int_Comparison_Exp>;
  signCount?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "patient_webauthn_credential" */
export enum Patient_Webauthn_Credential_Constraint {
  /** unique or primary key constraint on columns "credential_id" */
  PatientWebauthnCredentialLiveCredentialId = 'patient_webauthn_credential_live_credential_id',
  /** unique or primary key constraint on columns "id" */
  PatientWebauthnCredentialPkey = 'patient_webauthn_credential_pkey'
}

/** input type for incrementing numeric columns in table "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Inc_Input = {
  regEpoch?: InputMaybe<Scalars['Int']>;
  signCount?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  credentialId?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastUsedAt?: InputMaybe<Scalars['timestamptz']>;
  patient?: InputMaybe<Scalars['uuid']>;
  patientByPatient?: InputMaybe<Patient_Obj_Rel_Insert_Input>;
  publicKey?: InputMaybe<Scalars['String']>;
  regEpoch?: InputMaybe<Scalars['Int']>;
  signCount?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Patient_Webauthn_Credential_Max_Fields = {
  __typename?: 'patient_webauthn_credential_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  credentialId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lastUsedAt?: Maybe<Scalars['timestamptz']>;
  patient?: Maybe<Scalars['uuid']>;
  publicKey?: Maybe<Scalars['String']>;
  regEpoch?: Maybe<Scalars['Int']>;
  signCount?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  credentialId?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastUsedAt?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  publicKey?: InputMaybe<Order_By>;
  regEpoch?: InputMaybe<Order_By>;
  signCount?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Patient_Webauthn_Credential_Min_Fields = {
  __typename?: 'patient_webauthn_credential_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  credentialId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lastUsedAt?: Maybe<Scalars['timestamptz']>;
  patient?: Maybe<Scalars['uuid']>;
  publicKey?: Maybe<Scalars['String']>;
  regEpoch?: Maybe<Scalars['Int']>;
  signCount?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  credentialId?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastUsedAt?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  publicKey?: InputMaybe<Order_By>;
  regEpoch?: InputMaybe<Order_By>;
  signCount?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Mutation_Response = {
  __typename?: 'patient_webauthn_credential_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient_Webauthn_Credential>;
};

/** on_conflict condition type for table "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_On_Conflict = {
  constraint: Patient_Webauthn_Credential_Constraint;
  update_columns?: Array<Patient_Webauthn_Credential_Update_Column>;
  where?: InputMaybe<Patient_Webauthn_Credential_Bool_Exp>;
};

/** Ordering options when selecting data from "patient_webauthn_credential". */
export type Patient_Webauthn_Credential_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  credentialId?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastUsedAt?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  patientByPatient?: InputMaybe<Patient_Order_By>;
  publicKey?: InputMaybe<Order_By>;
  regEpoch?: InputMaybe<Order_By>;
  signCount?: InputMaybe<Order_By>;
};

/** primary key columns input for table: patient_webauthn_credential */
export type Patient_Webauthn_Credential_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "patient_webauthn_credential" */
export enum Patient_Webauthn_Credential_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CredentialId = 'credentialId',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LastUsedAt = 'lastUsedAt',
  /** column name */
  Patient = 'patient',
  /** column name */
  PublicKey = 'publicKey',
  /** column name */
  RegEpoch = 'regEpoch',
  /** column name */
  SignCount = 'signCount'
}

/** input type for updating data in table "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  credentialId?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastUsedAt?: InputMaybe<Scalars['timestamptz']>;
  patient?: InputMaybe<Scalars['uuid']>;
  publicKey?: InputMaybe<Scalars['String']>;
  regEpoch?: InputMaybe<Scalars['Int']>;
  signCount?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Patient_Webauthn_Credential_Stddev_Fields = {
  __typename?: 'patient_webauthn_credential_stddev_fields';
  regEpoch?: Maybe<Scalars['Float']>;
  signCount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Stddev_Order_By = {
  regEpoch?: InputMaybe<Order_By>;
  signCount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Patient_Webauthn_Credential_Stddev_Pop_Fields = {
  __typename?: 'patient_webauthn_credential_stddev_pop_fields';
  regEpoch?: Maybe<Scalars['Float']>;
  signCount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Stddev_Pop_Order_By = {
  regEpoch?: InputMaybe<Order_By>;
  signCount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Patient_Webauthn_Credential_Stddev_Samp_Fields = {
  __typename?: 'patient_webauthn_credential_stddev_samp_fields';
  regEpoch?: Maybe<Scalars['Float']>;
  signCount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Stddev_Samp_Order_By = {
  regEpoch?: InputMaybe<Order_By>;
  signCount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Patient_Webauthn_Credential_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Patient_Webauthn_Credential_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  credentialId?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastUsedAt?: InputMaybe<Scalars['timestamptz']>;
  patient?: InputMaybe<Scalars['uuid']>;
  publicKey?: InputMaybe<Scalars['String']>;
  regEpoch?: InputMaybe<Scalars['Int']>;
  signCount?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Patient_Webauthn_Credential_Sum_Fields = {
  __typename?: 'patient_webauthn_credential_sum_fields';
  regEpoch?: Maybe<Scalars['Int']>;
  signCount?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Sum_Order_By = {
  regEpoch?: InputMaybe<Order_By>;
  signCount?: InputMaybe<Order_By>;
};

/** update columns of table "patient_webauthn_credential" */
export enum Patient_Webauthn_Credential_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CredentialId = 'credentialId',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  LastUsedAt = 'lastUsedAt',
  /** column name */
  Patient = 'patient',
  /** column name */
  PublicKey = 'publicKey',
  /** column name */
  RegEpoch = 'regEpoch',
  /** column name */
  SignCount = 'signCount'
}

export type Patient_Webauthn_Credential_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Patient_Webauthn_Credential_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Patient_Webauthn_Credential_Set_Input>;
  /** filter the rows which have to be updated */
  where: Patient_Webauthn_Credential_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Patient_Webauthn_Credential_Var_Pop_Fields = {
  __typename?: 'patient_webauthn_credential_var_pop_fields';
  regEpoch?: Maybe<Scalars['Float']>;
  signCount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Var_Pop_Order_By = {
  regEpoch?: InputMaybe<Order_By>;
  signCount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Patient_Webauthn_Credential_Var_Samp_Fields = {
  __typename?: 'patient_webauthn_credential_var_samp_fields';
  regEpoch?: Maybe<Scalars['Float']>;
  signCount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Var_Samp_Order_By = {
  regEpoch?: InputMaybe<Order_By>;
  signCount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Patient_Webauthn_Credential_Variance_Fields = {
  __typename?: 'patient_webauthn_credential_variance_fields';
  regEpoch?: Maybe<Scalars['Float']>;
  signCount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "patient_webauthn_credential" */
export type Patient_Webauthn_Credential_Variance_Order_By = {
  regEpoch?: InputMaybe<Order_By>;
  signCount?: InputMaybe<Order_By>;
};

/** columns and relationships of "plan" */
export type Plan = {
  __typename?: 'plan';
  /** Null means not sold on annual discount basis */
  annualCost?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  discountRate?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  monthlyCost: Scalars['Int'];
  monthlyCredit?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** An object relationship */
  plan_type: Plan_Type;
  stripeProductId: Scalars['String'];
  type: Plan_Type_Enum;
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_plans: Array<User_Plan>;
  /** An aggregate relationship */
  user_plans_aggregate: User_Plan_Aggregate;
};


/** columns and relationships of "plan" */
export type PlanUser_PlansArgs = {
  distinct_on?: InputMaybe<Array<User_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Plan_Order_By>>;
  where?: InputMaybe<User_Plan_Bool_Exp>;
};


/** columns and relationships of "plan" */
export type PlanUser_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Plan_Order_By>>;
  where?: InputMaybe<User_Plan_Bool_Exp>;
};

/** aggregated selection of "plan" */
export type Plan_Aggregate = {
  __typename?: 'plan_aggregate';
  aggregate?: Maybe<Plan_Aggregate_Fields>;
  nodes: Array<Plan>;
};

export type Plan_Aggregate_Bool_Exp = {
  count?: InputMaybe<Plan_Aggregate_Bool_Exp_Count>;
};

export type Plan_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Plan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Plan_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "plan" */
export type Plan_Aggregate_Fields = {
  __typename?: 'plan_aggregate_fields';
  avg?: Maybe<Plan_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plan_Max_Fields>;
  min?: Maybe<Plan_Min_Fields>;
  stddev?: Maybe<Plan_Stddev_Fields>;
  stddev_pop?: Maybe<Plan_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plan_Stddev_Samp_Fields>;
  sum?: Maybe<Plan_Sum_Fields>;
  var_pop?: Maybe<Plan_Var_Pop_Fields>;
  var_samp?: Maybe<Plan_Var_Samp_Fields>;
  variance?: Maybe<Plan_Variance_Fields>;
};


/** aggregate fields of "plan" */
export type Plan_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "plan" */
export type Plan_Aggregate_Order_By = {
  avg?: InputMaybe<Plan_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Plan_Max_Order_By>;
  min?: InputMaybe<Plan_Min_Order_By>;
  stddev?: InputMaybe<Plan_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Plan_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Plan_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Plan_Sum_Order_By>;
  var_pop?: InputMaybe<Plan_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Plan_Var_Samp_Order_By>;
  variance?: InputMaybe<Plan_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "plan" */
export type Plan_Arr_Rel_Insert_Input = {
  data: Array<Plan_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Plan_On_Conflict>;
};

/** aggregate avg on columns */
export type Plan_Avg_Fields = {
  __typename?: 'plan_avg_fields';
  /** Null means not sold on annual discount basis */
  annualCost?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  monthlyCost?: Maybe<Scalars['Float']>;
  monthlyCredit?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "plan" */
export type Plan_Avg_Order_By = {
  /** Null means not sold on annual discount basis */
  annualCost?: InputMaybe<Order_By>;
  discountRate?: InputMaybe<Order_By>;
  monthlyCost?: InputMaybe<Order_By>;
  monthlyCredit?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "plan". All fields are combined with a logical 'AND'. */
export type Plan_Bool_Exp = {
  _and?: InputMaybe<Array<Plan_Bool_Exp>>;
  _not?: InputMaybe<Plan_Bool_Exp>;
  _or?: InputMaybe<Array<Plan_Bool_Exp>>;
  annualCost?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  discountRate?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  monthlyCost?: InputMaybe<Int_Comparison_Exp>;
  monthlyCredit?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  plan_type?: InputMaybe<Plan_Type_Bool_Exp>;
  stripeProductId?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Plan_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_plans?: InputMaybe<User_Plan_Bool_Exp>;
  user_plans_aggregate?: InputMaybe<User_Plan_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "plan" */
export enum Plan_Constraint {
  /** unique or primary key constraint on columns "id" */
  PlanPkey = 'plan_pkey',
  /** unique or primary key constraint on columns "stripe_product_id" */
  PlanStripeProductIdKey = 'plan_stripe_product_id_key'
}

/** input type for incrementing numeric columns in table "plan" */
export type Plan_Inc_Input = {
  /** Null means not sold on annual discount basis */
  annualCost?: InputMaybe<Scalars['Int']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  monthlyCost?: InputMaybe<Scalars['Int']>;
  monthlyCredit?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plan" */
export type Plan_Insert_Input = {
  /** Null means not sold on annual discount basis */
  annualCost?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  monthlyCost?: InputMaybe<Scalars['Int']>;
  monthlyCredit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  plan_type?: InputMaybe<Plan_Type_Obj_Rel_Insert_Input>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Plan_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_plans?: InputMaybe<User_Plan_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Plan_Max_Fields = {
  __typename?: 'plan_max_fields';
  /** Null means not sold on annual discount basis */
  annualCost?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  discountRate?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  monthlyCost?: Maybe<Scalars['Int']>;
  monthlyCredit?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  stripeProductId?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "plan" */
export type Plan_Max_Order_By = {
  /** Null means not sold on annual discount basis */
  annualCost?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discountRate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  monthlyCost?: InputMaybe<Order_By>;
  monthlyCredit?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  stripeProductId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Plan_Min_Fields = {
  __typename?: 'plan_min_fields';
  /** Null means not sold on annual discount basis */
  annualCost?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  discountRate?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  monthlyCost?: Maybe<Scalars['Int']>;
  monthlyCredit?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  stripeProductId?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "plan" */
export type Plan_Min_Order_By = {
  /** Null means not sold on annual discount basis */
  annualCost?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discountRate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  monthlyCost?: InputMaybe<Order_By>;
  monthlyCredit?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  stripeProductId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "plan" */
export type Plan_Mutation_Response = {
  __typename?: 'plan_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plan>;
};

/** input type for inserting object relation for remote table "plan" */
export type Plan_Obj_Rel_Insert_Input = {
  data: Plan_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Plan_On_Conflict>;
};

/** on_conflict condition type for table "plan" */
export type Plan_On_Conflict = {
  constraint: Plan_Constraint;
  update_columns?: Array<Plan_Update_Column>;
  where?: InputMaybe<Plan_Bool_Exp>;
};

/** Ordering options when selecting data from "plan". */
export type Plan_Order_By = {
  annualCost?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discountRate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  monthlyCost?: InputMaybe<Order_By>;
  monthlyCredit?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  plan_type?: InputMaybe<Plan_Type_Order_By>;
  stripeProductId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_plans_aggregate?: InputMaybe<User_Plan_Aggregate_Order_By>;
};

/** primary key columns input for table: plan */
export type Plan_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "plan" */
export enum Plan_Select_Column {
  /** column name */
  AnnualCost = 'annualCost',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  DiscountRate = 'discountRate',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  MonthlyCost = 'monthlyCost',
  /** column name */
  MonthlyCredit = 'monthlyCredit',
  /** column name */
  Name = 'name',
  /** column name */
  StripeProductId = 'stripeProductId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "plan" */
export type Plan_Set_Input = {
  /** Null means not sold on annual discount basis */
  annualCost?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  monthlyCost?: InputMaybe<Scalars['Int']>;
  monthlyCredit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Plan_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Plan_Stddev_Fields = {
  __typename?: 'plan_stddev_fields';
  /** Null means not sold on annual discount basis */
  annualCost?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  monthlyCost?: Maybe<Scalars['Float']>;
  monthlyCredit?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "plan" */
export type Plan_Stddev_Order_By = {
  /** Null means not sold on annual discount basis */
  annualCost?: InputMaybe<Order_By>;
  discountRate?: InputMaybe<Order_By>;
  monthlyCost?: InputMaybe<Order_By>;
  monthlyCredit?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Plan_Stddev_Pop_Fields = {
  __typename?: 'plan_stddev_pop_fields';
  /** Null means not sold on annual discount basis */
  annualCost?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  monthlyCost?: Maybe<Scalars['Float']>;
  monthlyCredit?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "plan" */
export type Plan_Stddev_Pop_Order_By = {
  /** Null means not sold on annual discount basis */
  annualCost?: InputMaybe<Order_By>;
  discountRate?: InputMaybe<Order_By>;
  monthlyCost?: InputMaybe<Order_By>;
  monthlyCredit?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Plan_Stddev_Samp_Fields = {
  __typename?: 'plan_stddev_samp_fields';
  /** Null means not sold on annual discount basis */
  annualCost?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  monthlyCost?: Maybe<Scalars['Float']>;
  monthlyCredit?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "plan" */
export type Plan_Stddev_Samp_Order_By = {
  /** Null means not sold on annual discount basis */
  annualCost?: InputMaybe<Order_By>;
  discountRate?: InputMaybe<Order_By>;
  monthlyCost?: InputMaybe<Order_By>;
  monthlyCredit?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "plan" */
export type Plan_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plan_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plan_Stream_Cursor_Value_Input = {
  /** Null means not sold on annual discount basis */
  annualCost?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  monthlyCost?: InputMaybe<Scalars['Int']>;
  monthlyCredit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Plan_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Plan_Sum_Fields = {
  __typename?: 'plan_sum_fields';
  /** Null means not sold on annual discount basis */
  annualCost?: Maybe<Scalars['Int']>;
  discountRate?: Maybe<Scalars['numeric']>;
  monthlyCost?: Maybe<Scalars['Int']>;
  monthlyCredit?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "plan" */
export type Plan_Sum_Order_By = {
  /** Null means not sold on annual discount basis */
  annualCost?: InputMaybe<Order_By>;
  discountRate?: InputMaybe<Order_By>;
  monthlyCost?: InputMaybe<Order_By>;
  monthlyCredit?: InputMaybe<Order_By>;
};

/** columns and relationships of "plan_type" */
export type Plan_Type = {
  __typename?: 'plan_type';
  id: Scalars['String'];
};

/** aggregated selection of "plan_type" */
export type Plan_Type_Aggregate = {
  __typename?: 'plan_type_aggregate';
  aggregate?: Maybe<Plan_Type_Aggregate_Fields>;
  nodes: Array<Plan_Type>;
};

/** aggregate fields of "plan_type" */
export type Plan_Type_Aggregate_Fields = {
  __typename?: 'plan_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Plan_Type_Max_Fields>;
  min?: Maybe<Plan_Type_Min_Fields>;
};


/** aggregate fields of "plan_type" */
export type Plan_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plan_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "plan_type". All fields are combined with a logical 'AND'. */
export type Plan_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Plan_Type_Bool_Exp>>;
  _not?: InputMaybe<Plan_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Plan_Type_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "plan_type" */
export enum Plan_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  PlanTypePkey = 'plan_type_pkey'
}

export enum Plan_Type_Enum {
  Credit = 'Credit',
  LongTermBooking = 'Long_Term_Booking',
  MedicalDirectorship = 'Medical_Directorship',
  Other = 'Other',
  RoomDiscount = 'Room_Discount'
}

/** Boolean expression to compare columns of type "plan_type_enum". All fields are combined with logical 'AND'. */
export type Plan_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Plan_Type_Enum>;
  _in?: InputMaybe<Array<Plan_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Plan_Type_Enum>;
  _nin?: InputMaybe<Array<Plan_Type_Enum>>;
};

/** input type for inserting data into table "plan_type" */
export type Plan_Type_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Plan_Type_Max_Fields = {
  __typename?: 'plan_type_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Plan_Type_Min_Fields = {
  __typename?: 'plan_type_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "plan_type" */
export type Plan_Type_Mutation_Response = {
  __typename?: 'plan_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plan_Type>;
};

/** input type for inserting object relation for remote table "plan_type" */
export type Plan_Type_Obj_Rel_Insert_Input = {
  data: Plan_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Plan_Type_On_Conflict>;
};

/** on_conflict condition type for table "plan_type" */
export type Plan_Type_On_Conflict = {
  constraint: Plan_Type_Constraint;
  update_columns?: Array<Plan_Type_Update_Column>;
  where?: InputMaybe<Plan_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "plan_type". */
export type Plan_Type_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plan_type */
export type Plan_Type_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "plan_type" */
export enum Plan_Type_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "plan_type" */
export type Plan_Type_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "plan_type" */
export type Plan_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plan_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plan_Type_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "plan_type" */
export enum Plan_Type_Update_Column {
  /** column name */
  Id = 'id'
}

export type Plan_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plan_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Plan_Type_Bool_Exp;
};

/** update columns of table "plan" */
export enum Plan_Update_Column {
  /** column name */
  AnnualCost = 'annualCost',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  DiscountRate = 'discountRate',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  MonthlyCost = 'monthlyCost',
  /** column name */
  MonthlyCredit = 'monthlyCredit',
  /** column name */
  Name = 'name',
  /** column name */
  StripeProductId = 'stripeProductId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Plan_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plan_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plan_Set_Input>;
  /** filter the rows which have to be updated */
  where: Plan_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plan_Var_Pop_Fields = {
  __typename?: 'plan_var_pop_fields';
  /** Null means not sold on annual discount basis */
  annualCost?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  monthlyCost?: Maybe<Scalars['Float']>;
  monthlyCredit?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "plan" */
export type Plan_Var_Pop_Order_By = {
  /** Null means not sold on annual discount basis */
  annualCost?: InputMaybe<Order_By>;
  discountRate?: InputMaybe<Order_By>;
  monthlyCost?: InputMaybe<Order_By>;
  monthlyCredit?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Plan_Var_Samp_Fields = {
  __typename?: 'plan_var_samp_fields';
  /** Null means not sold on annual discount basis */
  annualCost?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  monthlyCost?: Maybe<Scalars['Float']>;
  monthlyCredit?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "plan" */
export type Plan_Var_Samp_Order_By = {
  /** Null means not sold on annual discount basis */
  annualCost?: InputMaybe<Order_By>;
  discountRate?: InputMaybe<Order_By>;
  monthlyCost?: InputMaybe<Order_By>;
  monthlyCredit?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Plan_Variance_Fields = {
  __typename?: 'plan_variance_fields';
  /** Null means not sold on annual discount basis */
  annualCost?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  monthlyCost?: Maybe<Scalars['Float']>;
  monthlyCredit?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "plan" */
export type Plan_Variance_Order_By = {
  /** Null means not sold on annual discount basis */
  annualCost?: InputMaybe<Order_By>;
  discountRate?: InputMaybe<Order_By>;
  monthlyCost?: InputMaybe<Order_By>;
  monthlyCredit?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "point". All fields are combined with logical 'AND'. */
export type Point_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['point']>;
  _gt?: InputMaybe<Scalars['point']>;
  _gte?: InputMaybe<Scalars['point']>;
  _in?: InputMaybe<Array<Scalars['point']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['point']>;
  _lte?: InputMaybe<Scalars['point']>;
  _neq?: InputMaybe<Scalars['point']>;
  _nin?: InputMaybe<Array<Scalars['point']>>;
};

/** columns and relationships of "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking = {
  __typename?: 'pre_procedure_photo_injection_marking';
  bodyPart: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** Despite the name, these are not restricted to ML units */
  dosageML: Scalars['numeric'];
  ehrEncounterPhoto: Scalars['uuid'];
  /** An object relationship */
  ehrEncounterPhotoByEhrEncounterPhoto: Ehr_Encounter_Photo;
  ehrProduct: Scalars['uuid'];
  /** An object relationship */
  ehrProductByEhrProduct: Ehr_Product;
  id: Scalars['uuid'];
  photoPixelCoordinates: Scalars['point'];
  provider: Scalars['uuid'];
  /** An object relationship */
  userByProvider: User;
};

/** aggregated selection of "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Aggregate = {
  __typename?: 'pre_procedure_photo_injection_marking_aggregate';
  aggregate?: Maybe<Pre_Procedure_Photo_Injection_Marking_Aggregate_Fields>;
  nodes: Array<Pre_Procedure_Photo_Injection_Marking>;
};

export type Pre_Procedure_Photo_Injection_Marking_Aggregate_Bool_Exp = {
  count?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Aggregate_Bool_Exp_Count>;
};

export type Pre_Procedure_Photo_Injection_Marking_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Pre_Procedure_Photo_Injection_Marking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Aggregate_Fields = {
  __typename?: 'pre_procedure_photo_injection_marking_aggregate_fields';
  avg?: Maybe<Pre_Procedure_Photo_Injection_Marking_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pre_Procedure_Photo_Injection_Marking_Max_Fields>;
  min?: Maybe<Pre_Procedure_Photo_Injection_Marking_Min_Fields>;
  stddev?: Maybe<Pre_Procedure_Photo_Injection_Marking_Stddev_Fields>;
  stddev_pop?: Maybe<Pre_Procedure_Photo_Injection_Marking_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pre_Procedure_Photo_Injection_Marking_Stddev_Samp_Fields>;
  sum?: Maybe<Pre_Procedure_Photo_Injection_Marking_Sum_Fields>;
  var_pop?: Maybe<Pre_Procedure_Photo_Injection_Marking_Var_Pop_Fields>;
  var_samp?: Maybe<Pre_Procedure_Photo_Injection_Marking_Var_Samp_Fields>;
  variance?: Maybe<Pre_Procedure_Photo_Injection_Marking_Variance_Fields>;
};


/** aggregate fields of "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pre_Procedure_Photo_Injection_Marking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Aggregate_Order_By = {
  avg?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Max_Order_By>;
  min?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Min_Order_By>;
  stddev?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Sum_Order_By>;
  var_pop?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Var_Samp_Order_By>;
  variance?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Arr_Rel_Insert_Input = {
  data: Array<Pre_Procedure_Photo_Injection_Marking_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_On_Conflict>;
};

/** aggregate avg on columns */
export type Pre_Procedure_Photo_Injection_Marking_Avg_Fields = {
  __typename?: 'pre_procedure_photo_injection_marking_avg_fields';
  /** Despite the name, these are not restricted to ML units */
  dosageML?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Avg_Order_By = {
  /** Despite the name, these are not restricted to ML units */
  dosageML?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "pre_procedure_photo_injection_marking". All fields are combined with a logical 'AND'. */
export type Pre_Procedure_Photo_Injection_Marking_Bool_Exp = {
  _and?: InputMaybe<Array<Pre_Procedure_Photo_Injection_Marking_Bool_Exp>>;
  _not?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Bool_Exp>;
  _or?: InputMaybe<Array<Pre_Procedure_Photo_Injection_Marking_Bool_Exp>>;
  bodyPart?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  dosageML?: InputMaybe<Numeric_Comparison_Exp>;
  ehrEncounterPhoto?: InputMaybe<Uuid_Comparison_Exp>;
  ehrEncounterPhotoByEhrEncounterPhoto?: InputMaybe<Ehr_Encounter_Photo_Bool_Exp>;
  ehrProduct?: InputMaybe<Uuid_Comparison_Exp>;
  ehrProductByEhrProduct?: InputMaybe<Ehr_Product_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  photoPixelCoordinates?: InputMaybe<Point_Comparison_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  userByProvider?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "pre_procedure_photo_injection_marking" */
export enum Pre_Procedure_Photo_Injection_Marking_Constraint {
  /** unique or primary key constraint on columns "id" */
  PreProcedurePhotoInjectionMarkingPkey = 'pre_procedure_photo_injection_marking_pkey'
}

/** input type for incrementing numeric columns in table "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Inc_Input = {
  /** Despite the name, these are not restricted to ML units */
  dosageML?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Insert_Input = {
  bodyPart?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Despite the name, these are not restricted to ML units */
  dosageML?: InputMaybe<Scalars['numeric']>;
  ehrEncounterPhoto?: InputMaybe<Scalars['uuid']>;
  ehrEncounterPhotoByEhrEncounterPhoto?: InputMaybe<Ehr_Encounter_Photo_Obj_Rel_Insert_Input>;
  ehrProduct?: InputMaybe<Scalars['uuid']>;
  ehrProductByEhrProduct?: InputMaybe<Ehr_Product_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  photoPixelCoordinates?: InputMaybe<Scalars['point']>;
  provider?: InputMaybe<Scalars['uuid']>;
  userByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Pre_Procedure_Photo_Injection_Marking_Max_Fields = {
  __typename?: 'pre_procedure_photo_injection_marking_max_fields';
  bodyPart?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** Despite the name, these are not restricted to ML units */
  dosageML?: Maybe<Scalars['numeric']>;
  ehrEncounterPhoto?: Maybe<Scalars['uuid']>;
  ehrProduct?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Max_Order_By = {
  bodyPart?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  /** Despite the name, these are not restricted to ML units */
  dosageML?: InputMaybe<Order_By>;
  ehrEncounterPhoto?: InputMaybe<Order_By>;
  ehrProduct?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pre_Procedure_Photo_Injection_Marking_Min_Fields = {
  __typename?: 'pre_procedure_photo_injection_marking_min_fields';
  bodyPart?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** Despite the name, these are not restricted to ML units */
  dosageML?: Maybe<Scalars['numeric']>;
  ehrEncounterPhoto?: Maybe<Scalars['uuid']>;
  ehrProduct?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Min_Order_By = {
  bodyPart?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  /** Despite the name, these are not restricted to ML units */
  dosageML?: InputMaybe<Order_By>;
  ehrEncounterPhoto?: InputMaybe<Order_By>;
  ehrProduct?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Mutation_Response = {
  __typename?: 'pre_procedure_photo_injection_marking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pre_Procedure_Photo_Injection_Marking>;
};

/** on_conflict condition type for table "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_On_Conflict = {
  constraint: Pre_Procedure_Photo_Injection_Marking_Constraint;
  update_columns?: Array<Pre_Procedure_Photo_Injection_Marking_Update_Column>;
  where?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Bool_Exp>;
};

/** Ordering options when selecting data from "pre_procedure_photo_injection_marking". */
export type Pre_Procedure_Photo_Injection_Marking_Order_By = {
  bodyPart?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  dosageML?: InputMaybe<Order_By>;
  ehrEncounterPhoto?: InputMaybe<Order_By>;
  ehrEncounterPhotoByEhrEncounterPhoto?: InputMaybe<Ehr_Encounter_Photo_Order_By>;
  ehrProduct?: InputMaybe<Order_By>;
  ehrProductByEhrProduct?: InputMaybe<Ehr_Product_Order_By>;
  id?: InputMaybe<Order_By>;
  photoPixelCoordinates?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  userByProvider?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: pre_procedure_photo_injection_marking */
export type Pre_Procedure_Photo_Injection_Marking_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "pre_procedure_photo_injection_marking" */
export enum Pre_Procedure_Photo_Injection_Marking_Select_Column {
  /** column name */
  BodyPart = 'bodyPart',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DosageMl = 'dosageML',
  /** column name */
  EhrEncounterPhoto = 'ehrEncounterPhoto',
  /** column name */
  EhrProduct = 'ehrProduct',
  /** column name */
  Id = 'id',
  /** column name */
  PhotoPixelCoordinates = 'photoPixelCoordinates',
  /** column name */
  Provider = 'provider'
}

/** input type for updating data in table "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Set_Input = {
  bodyPart?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Despite the name, these are not restricted to ML units */
  dosageML?: InputMaybe<Scalars['numeric']>;
  ehrEncounterPhoto?: InputMaybe<Scalars['uuid']>;
  ehrProduct?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  photoPixelCoordinates?: InputMaybe<Scalars['point']>;
  provider?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Pre_Procedure_Photo_Injection_Marking_Stddev_Fields = {
  __typename?: 'pre_procedure_photo_injection_marking_stddev_fields';
  /** Despite the name, these are not restricted to ML units */
  dosageML?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Stddev_Order_By = {
  /** Despite the name, these are not restricted to ML units */
  dosageML?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pre_Procedure_Photo_Injection_Marking_Stddev_Pop_Fields = {
  __typename?: 'pre_procedure_photo_injection_marking_stddev_pop_fields';
  /** Despite the name, these are not restricted to ML units */
  dosageML?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Stddev_Pop_Order_By = {
  /** Despite the name, these are not restricted to ML units */
  dosageML?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pre_Procedure_Photo_Injection_Marking_Stddev_Samp_Fields = {
  __typename?: 'pre_procedure_photo_injection_marking_stddev_samp_fields';
  /** Despite the name, these are not restricted to ML units */
  dosageML?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Stddev_Samp_Order_By = {
  /** Despite the name, these are not restricted to ML units */
  dosageML?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pre_Procedure_Photo_Injection_Marking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pre_Procedure_Photo_Injection_Marking_Stream_Cursor_Value_Input = {
  bodyPart?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Despite the name, these are not restricted to ML units */
  dosageML?: InputMaybe<Scalars['numeric']>;
  ehrEncounterPhoto?: InputMaybe<Scalars['uuid']>;
  ehrProduct?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  photoPixelCoordinates?: InputMaybe<Scalars['point']>;
  provider?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Pre_Procedure_Photo_Injection_Marking_Sum_Fields = {
  __typename?: 'pre_procedure_photo_injection_marking_sum_fields';
  /** Despite the name, these are not restricted to ML units */
  dosageML?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Sum_Order_By = {
  /** Despite the name, these are not restricted to ML units */
  dosageML?: InputMaybe<Order_By>;
};

/** update columns of table "pre_procedure_photo_injection_marking" */
export enum Pre_Procedure_Photo_Injection_Marking_Update_Column {
  /** column name */
  BodyPart = 'bodyPart',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DosageMl = 'dosageML',
  /** column name */
  EhrEncounterPhoto = 'ehrEncounterPhoto',
  /** column name */
  EhrProduct = 'ehrProduct',
  /** column name */
  Id = 'id',
  /** column name */
  PhotoPixelCoordinates = 'photoPixelCoordinates',
  /** column name */
  Provider = 'provider'
}

export type Pre_Procedure_Photo_Injection_Marking_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pre_Procedure_Photo_Injection_Marking_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pre_Procedure_Photo_Injection_Marking_Var_Pop_Fields = {
  __typename?: 'pre_procedure_photo_injection_marking_var_pop_fields';
  /** Despite the name, these are not restricted to ML units */
  dosageML?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Var_Pop_Order_By = {
  /** Despite the name, these are not restricted to ML units */
  dosageML?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pre_Procedure_Photo_Injection_Marking_Var_Samp_Fields = {
  __typename?: 'pre_procedure_photo_injection_marking_var_samp_fields';
  /** Despite the name, these are not restricted to ML units */
  dosageML?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Var_Samp_Order_By = {
  /** Despite the name, these are not restricted to ML units */
  dosageML?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pre_Procedure_Photo_Injection_Marking_Variance_Fields = {
  __typename?: 'pre_procedure_photo_injection_marking_variance_fields';
  /** Despite the name, these are not restricted to ML units */
  dosageML?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pre_procedure_photo_injection_marking" */
export type Pre_Procedure_Photo_Injection_Marking_Variance_Order_By = {
  /** Despite the name, these are not restricted to ML units */
  dosageML?: InputMaybe<Order_By>;
};

/** The high level offerings potentially available at locations (locations/providers choose from this set) - these are global, VansanityAdmin must add any ones any location needs.  These are what patients can book and determine EHR documention and form requirements, as well as associated models. */
export type Procedure = {
  __typename?: 'procedure';
  bodyParts: Array<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  ehr_product_procedures: Array<Ehr_Product_Procedure>;
  /** An aggregate relationship */
  ehr_product_procedures_aggregate: Ehr_Product_Procedure_Aggregate;
  id: Scalars['uuid'];
  /** An array relationship */
  location_procedures: Array<Location_Procedure>;
  /** An aggregate relationship */
  location_procedures_aggregate: Location_Procedure_Aggregate;
  model?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  modelByModel?: Maybe<Model>;
  name: Scalars['String'];
};


/** The high level offerings potentially available at locations (locations/providers choose from this set) - these are global, VansanityAdmin must add any ones any location needs.  These are what patients can book and determine EHR documention and form requirements, as well as associated models. */
export type ProcedureEhr_Product_ProceduresArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Product_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Product_Procedure_Order_By>>;
  where?: InputMaybe<Ehr_Product_Procedure_Bool_Exp>;
};


/** The high level offerings potentially available at locations (locations/providers choose from this set) - these are global, VansanityAdmin must add any ones any location needs.  These are what patients can book and determine EHR documention and form requirements, as well as associated models. */
export type ProcedureEhr_Product_Procedures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Product_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Product_Procedure_Order_By>>;
  where?: InputMaybe<Ehr_Product_Procedure_Bool_Exp>;
};


/** The high level offerings potentially available at locations (locations/providers choose from this set) - these are global, VansanityAdmin must add any ones any location needs.  These are what patients can book and determine EHR documention and form requirements, as well as associated models. */
export type ProcedureLocation_ProceduresArgs = {
  distinct_on?: InputMaybe<Array<Location_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Procedure_Order_By>>;
  where?: InputMaybe<Location_Procedure_Bool_Exp>;
};


/** The high level offerings potentially available at locations (locations/providers choose from this set) - these are global, VansanityAdmin must add any ones any location needs.  These are what patients can book and determine EHR documention and form requirements, as well as associated models. */
export type ProcedureLocation_Procedures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Procedure_Order_By>>;
  where?: InputMaybe<Location_Procedure_Bool_Exp>;
};

/** aggregated selection of "procedure" */
export type Procedure_Aggregate = {
  __typename?: 'procedure_aggregate';
  aggregate?: Maybe<Procedure_Aggregate_Fields>;
  nodes: Array<Procedure>;
};

export type Procedure_Aggregate_Bool_Exp = {
  count?: InputMaybe<Procedure_Aggregate_Bool_Exp_Count>;
};

export type Procedure_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Procedure_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Procedure_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "procedure" */
export type Procedure_Aggregate_Fields = {
  __typename?: 'procedure_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Procedure_Max_Fields>;
  min?: Maybe<Procedure_Min_Fields>;
};


/** aggregate fields of "procedure" */
export type Procedure_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Procedure_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "procedure" */
export type Procedure_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Procedure_Max_Order_By>;
  min?: InputMaybe<Procedure_Min_Order_By>;
};

/** input type for inserting array relation for remote table "procedure" */
export type Procedure_Arr_Rel_Insert_Input = {
  data: Array<Procedure_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Procedure_On_Conflict>;
};

/** columns and relationships of "procedure_audio_recording" */
export type Procedure_Audio_Recording = {
  __typename?: 'procedure_audio_recording';
  audioS3Key: Scalars['uuid'];
  audioStartedRecordingAt: Scalars['timestamptz'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** Length of the recording */
  durationMs?: Maybe<Scalars['Int']>;
  ehrEncounter: Scalars['uuid'];
  /** An object relationship */
  ehrEncounterByEhrEncounter: Ehr_Encounter;
  /** S3 key for the mp3 format that Deepgram can handle (unlike the original) */
  fixedAudioS3Key?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  provider: Scalars['uuid'];
  rawTranscriptionResult?: Maybe<Scalars['jsonb']>;
  /** When a processor says they are responsible for initiating the transcription.  A semphore to prevent the races inherent in SQS, S3 and Lambda triggers. */
  transcriptionClaimedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  userByProvider: User;
};


/** columns and relationships of "procedure_audio_recording" */
export type Procedure_Audio_RecordingRawTranscriptionResultArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "procedure_audio_recording" */
export type Procedure_Audio_Recording_Aggregate = {
  __typename?: 'procedure_audio_recording_aggregate';
  aggregate?: Maybe<Procedure_Audio_Recording_Aggregate_Fields>;
  nodes: Array<Procedure_Audio_Recording>;
};

export type Procedure_Audio_Recording_Aggregate_Bool_Exp = {
  count?: InputMaybe<Procedure_Audio_Recording_Aggregate_Bool_Exp_Count>;
};

export type Procedure_Audio_Recording_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Procedure_Audio_Recording_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Procedure_Audio_Recording_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "procedure_audio_recording" */
export type Procedure_Audio_Recording_Aggregate_Fields = {
  __typename?: 'procedure_audio_recording_aggregate_fields';
  avg?: Maybe<Procedure_Audio_Recording_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Procedure_Audio_Recording_Max_Fields>;
  min?: Maybe<Procedure_Audio_Recording_Min_Fields>;
  stddev?: Maybe<Procedure_Audio_Recording_Stddev_Fields>;
  stddev_pop?: Maybe<Procedure_Audio_Recording_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Procedure_Audio_Recording_Stddev_Samp_Fields>;
  sum?: Maybe<Procedure_Audio_Recording_Sum_Fields>;
  var_pop?: Maybe<Procedure_Audio_Recording_Var_Pop_Fields>;
  var_samp?: Maybe<Procedure_Audio_Recording_Var_Samp_Fields>;
  variance?: Maybe<Procedure_Audio_Recording_Variance_Fields>;
};


/** aggregate fields of "procedure_audio_recording" */
export type Procedure_Audio_Recording_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Procedure_Audio_Recording_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "procedure_audio_recording" */
export type Procedure_Audio_Recording_Aggregate_Order_By = {
  avg?: InputMaybe<Procedure_Audio_Recording_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Procedure_Audio_Recording_Max_Order_By>;
  min?: InputMaybe<Procedure_Audio_Recording_Min_Order_By>;
  stddev?: InputMaybe<Procedure_Audio_Recording_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Procedure_Audio_Recording_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Procedure_Audio_Recording_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Procedure_Audio_Recording_Sum_Order_By>;
  var_pop?: InputMaybe<Procedure_Audio_Recording_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Procedure_Audio_Recording_Var_Samp_Order_By>;
  variance?: InputMaybe<Procedure_Audio_Recording_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Procedure_Audio_Recording_Append_Input = {
  rawTranscriptionResult?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "procedure_audio_recording" */
export type Procedure_Audio_Recording_Arr_Rel_Insert_Input = {
  data: Array<Procedure_Audio_Recording_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Procedure_Audio_Recording_On_Conflict>;
};

/** aggregate avg on columns */
export type Procedure_Audio_Recording_Avg_Fields = {
  __typename?: 'procedure_audio_recording_avg_fields';
  /** Length of the recording */
  durationMs?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "procedure_audio_recording" */
export type Procedure_Audio_Recording_Avg_Order_By = {
  /** Length of the recording */
  durationMs?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "procedure_audio_recording". All fields are combined with a logical 'AND'. */
export type Procedure_Audio_Recording_Bool_Exp = {
  _and?: InputMaybe<Array<Procedure_Audio_Recording_Bool_Exp>>;
  _not?: InputMaybe<Procedure_Audio_Recording_Bool_Exp>;
  _or?: InputMaybe<Array<Procedure_Audio_Recording_Bool_Exp>>;
  audioS3Key?: InputMaybe<Uuid_Comparison_Exp>;
  audioStartedRecordingAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  durationMs?: InputMaybe<Int_Comparison_Exp>;
  ehrEncounter?: InputMaybe<Uuid_Comparison_Exp>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Bool_Exp>;
  fixedAudioS3Key?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  rawTranscriptionResult?: InputMaybe<Jsonb_Comparison_Exp>;
  transcriptionClaimedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userByProvider?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "procedure_audio_recording" */
export enum Procedure_Audio_Recording_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProcedureAudioRecordingPkey = 'procedure_audio_recording_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Procedure_Audio_Recording_Delete_At_Path_Input = {
  rawTranscriptionResult?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Procedure_Audio_Recording_Delete_Elem_Input = {
  rawTranscriptionResult?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Procedure_Audio_Recording_Delete_Key_Input = {
  rawTranscriptionResult?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "procedure_audio_recording" */
export type Procedure_Audio_Recording_Inc_Input = {
  /** Length of the recording */
  durationMs?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "procedure_audio_recording" */
export type Procedure_Audio_Recording_Insert_Input = {
  audioS3Key?: InputMaybe<Scalars['uuid']>;
  audioStartedRecordingAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Length of the recording */
  durationMs?: InputMaybe<Scalars['Int']>;
  ehrEncounter?: InputMaybe<Scalars['uuid']>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Obj_Rel_Insert_Input>;
  /** S3 key for the mp3 format that Deepgram can handle (unlike the original) */
  fixedAudioS3Key?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  rawTranscriptionResult?: InputMaybe<Scalars['jsonb']>;
  /** When a processor says they are responsible for initiating the transcription.  A semphore to prevent the races inherent in SQS, S3 and Lambda triggers. */
  transcriptionClaimedAt?: InputMaybe<Scalars['timestamptz']>;
  userByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Procedure_Audio_Recording_Max_Fields = {
  __typename?: 'procedure_audio_recording_max_fields';
  audioS3Key?: Maybe<Scalars['uuid']>;
  audioStartedRecordingAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** Length of the recording */
  durationMs?: Maybe<Scalars['Int']>;
  ehrEncounter?: Maybe<Scalars['uuid']>;
  /** S3 key for the mp3 format that Deepgram can handle (unlike the original) */
  fixedAudioS3Key?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  /** When a processor says they are responsible for initiating the transcription.  A semphore to prevent the races inherent in SQS, S3 and Lambda triggers. */
  transcriptionClaimedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "procedure_audio_recording" */
export type Procedure_Audio_Recording_Max_Order_By = {
  audioS3Key?: InputMaybe<Order_By>;
  audioStartedRecordingAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  /** Length of the recording */
  durationMs?: InputMaybe<Order_By>;
  ehrEncounter?: InputMaybe<Order_By>;
  /** S3 key for the mp3 format that Deepgram can handle (unlike the original) */
  fixedAudioS3Key?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  /** When a processor says they are responsible for initiating the transcription.  A semphore to prevent the races inherent in SQS, S3 and Lambda triggers. */
  transcriptionClaimedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Procedure_Audio_Recording_Min_Fields = {
  __typename?: 'procedure_audio_recording_min_fields';
  audioS3Key?: Maybe<Scalars['uuid']>;
  audioStartedRecordingAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** Length of the recording */
  durationMs?: Maybe<Scalars['Int']>;
  ehrEncounter?: Maybe<Scalars['uuid']>;
  /** S3 key for the mp3 format that Deepgram can handle (unlike the original) */
  fixedAudioS3Key?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  /** When a processor says they are responsible for initiating the transcription.  A semphore to prevent the races inherent in SQS, S3 and Lambda triggers. */
  transcriptionClaimedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "procedure_audio_recording" */
export type Procedure_Audio_Recording_Min_Order_By = {
  audioS3Key?: InputMaybe<Order_By>;
  audioStartedRecordingAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  /** Length of the recording */
  durationMs?: InputMaybe<Order_By>;
  ehrEncounter?: InputMaybe<Order_By>;
  /** S3 key for the mp3 format that Deepgram can handle (unlike the original) */
  fixedAudioS3Key?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  /** When a processor says they are responsible for initiating the transcription.  A semphore to prevent the races inherent in SQS, S3 and Lambda triggers. */
  transcriptionClaimedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "procedure_audio_recording" */
export type Procedure_Audio_Recording_Mutation_Response = {
  __typename?: 'procedure_audio_recording_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Procedure_Audio_Recording>;
};

/** on_conflict condition type for table "procedure_audio_recording" */
export type Procedure_Audio_Recording_On_Conflict = {
  constraint: Procedure_Audio_Recording_Constraint;
  update_columns?: Array<Procedure_Audio_Recording_Update_Column>;
  where?: InputMaybe<Procedure_Audio_Recording_Bool_Exp>;
};

/** Ordering options when selecting data from "procedure_audio_recording". */
export type Procedure_Audio_Recording_Order_By = {
  audioS3Key?: InputMaybe<Order_By>;
  audioStartedRecordingAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  durationMs?: InputMaybe<Order_By>;
  ehrEncounter?: InputMaybe<Order_By>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Order_By>;
  fixedAudioS3Key?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  rawTranscriptionResult?: InputMaybe<Order_By>;
  transcriptionClaimedAt?: InputMaybe<Order_By>;
  userByProvider?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: procedure_audio_recording */
export type Procedure_Audio_Recording_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Procedure_Audio_Recording_Prepend_Input = {
  rawTranscriptionResult?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "procedure_audio_recording" */
export enum Procedure_Audio_Recording_Select_Column {
  /** column name */
  AudioS3Key = 'audioS3Key',
  /** column name */
  AudioStartedRecordingAt = 'audioStartedRecordingAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DurationMs = 'durationMs',
  /** column name */
  EhrEncounter = 'ehrEncounter',
  /** column name */
  FixedAudioS3Key = 'fixedAudioS3Key',
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider',
  /** column name */
  RawTranscriptionResult = 'rawTranscriptionResult',
  /** column name */
  TranscriptionClaimedAt = 'transcriptionClaimedAt'
}

/** input type for updating data in table "procedure_audio_recording" */
export type Procedure_Audio_Recording_Set_Input = {
  audioS3Key?: InputMaybe<Scalars['uuid']>;
  audioStartedRecordingAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Length of the recording */
  durationMs?: InputMaybe<Scalars['Int']>;
  ehrEncounter?: InputMaybe<Scalars['uuid']>;
  /** S3 key for the mp3 format that Deepgram can handle (unlike the original) */
  fixedAudioS3Key?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  rawTranscriptionResult?: InputMaybe<Scalars['jsonb']>;
  /** When a processor says they are responsible for initiating the transcription.  A semphore to prevent the races inherent in SQS, S3 and Lambda triggers. */
  transcriptionClaimedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Procedure_Audio_Recording_Stddev_Fields = {
  __typename?: 'procedure_audio_recording_stddev_fields';
  /** Length of the recording */
  durationMs?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "procedure_audio_recording" */
export type Procedure_Audio_Recording_Stddev_Order_By = {
  /** Length of the recording */
  durationMs?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Procedure_Audio_Recording_Stddev_Pop_Fields = {
  __typename?: 'procedure_audio_recording_stddev_pop_fields';
  /** Length of the recording */
  durationMs?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "procedure_audio_recording" */
export type Procedure_Audio_Recording_Stddev_Pop_Order_By = {
  /** Length of the recording */
  durationMs?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Procedure_Audio_Recording_Stddev_Samp_Fields = {
  __typename?: 'procedure_audio_recording_stddev_samp_fields';
  /** Length of the recording */
  durationMs?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "procedure_audio_recording" */
export type Procedure_Audio_Recording_Stddev_Samp_Order_By = {
  /** Length of the recording */
  durationMs?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "procedure_audio_recording" */
export type Procedure_Audio_Recording_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Procedure_Audio_Recording_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Procedure_Audio_Recording_Stream_Cursor_Value_Input = {
  audioS3Key?: InputMaybe<Scalars['uuid']>;
  audioStartedRecordingAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Length of the recording */
  durationMs?: InputMaybe<Scalars['Int']>;
  ehrEncounter?: InputMaybe<Scalars['uuid']>;
  /** S3 key for the mp3 format that Deepgram can handle (unlike the original) */
  fixedAudioS3Key?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  rawTranscriptionResult?: InputMaybe<Scalars['jsonb']>;
  /** When a processor says they are responsible for initiating the transcription.  A semphore to prevent the races inherent in SQS, S3 and Lambda triggers. */
  transcriptionClaimedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Procedure_Audio_Recording_Sum_Fields = {
  __typename?: 'procedure_audio_recording_sum_fields';
  /** Length of the recording */
  durationMs?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "procedure_audio_recording" */
export type Procedure_Audio_Recording_Sum_Order_By = {
  /** Length of the recording */
  durationMs?: InputMaybe<Order_By>;
};

/** update columns of table "procedure_audio_recording" */
export enum Procedure_Audio_Recording_Update_Column {
  /** column name */
  AudioS3Key = 'audioS3Key',
  /** column name */
  AudioStartedRecordingAt = 'audioStartedRecordingAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DurationMs = 'durationMs',
  /** column name */
  EhrEncounter = 'ehrEncounter',
  /** column name */
  FixedAudioS3Key = 'fixedAudioS3Key',
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider',
  /** column name */
  RawTranscriptionResult = 'rawTranscriptionResult',
  /** column name */
  TranscriptionClaimedAt = 'transcriptionClaimedAt'
}

export type Procedure_Audio_Recording_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Procedure_Audio_Recording_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Procedure_Audio_Recording_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Procedure_Audio_Recording_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Procedure_Audio_Recording_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Procedure_Audio_Recording_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Procedure_Audio_Recording_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Procedure_Audio_Recording_Set_Input>;
  /** filter the rows which have to be updated */
  where: Procedure_Audio_Recording_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Procedure_Audio_Recording_Var_Pop_Fields = {
  __typename?: 'procedure_audio_recording_var_pop_fields';
  /** Length of the recording */
  durationMs?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "procedure_audio_recording" */
export type Procedure_Audio_Recording_Var_Pop_Order_By = {
  /** Length of the recording */
  durationMs?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Procedure_Audio_Recording_Var_Samp_Fields = {
  __typename?: 'procedure_audio_recording_var_samp_fields';
  /** Length of the recording */
  durationMs?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "procedure_audio_recording" */
export type Procedure_Audio_Recording_Var_Samp_Order_By = {
  /** Length of the recording */
  durationMs?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Procedure_Audio_Recording_Variance_Fields = {
  __typename?: 'procedure_audio_recording_variance_fields';
  /** Length of the recording */
  durationMs?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "procedure_audio_recording" */
export type Procedure_Audio_Recording_Variance_Order_By = {
  /** Length of the recording */
  durationMs?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "procedure". All fields are combined with a logical 'AND'. */
export type Procedure_Bool_Exp = {
  _and?: InputMaybe<Array<Procedure_Bool_Exp>>;
  _not?: InputMaybe<Procedure_Bool_Exp>;
  _or?: InputMaybe<Array<Procedure_Bool_Exp>>;
  bodyParts?: InputMaybe<String_Array_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehr_product_procedures?: InputMaybe<Ehr_Product_Procedure_Bool_Exp>;
  ehr_product_procedures_aggregate?: InputMaybe<Ehr_Product_Procedure_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location_procedures?: InputMaybe<Location_Procedure_Bool_Exp>;
  location_procedures_aggregate?: InputMaybe<Location_Procedure_Aggregate_Bool_Exp>;
  model?: InputMaybe<Uuid_Comparison_Exp>;
  modelByModel?: InputMaybe<Model_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "procedure" */
export enum Procedure_Constraint {
  /** unique or primary key constraint on columns "name" */
  ProcedureNameIndex = 'procedure_name_index',
  /** unique or primary key constraint on columns "id" */
  ProcedurePkey = 'procedure_pkey'
}

/** input type for inserting data into table "procedure" */
export type Procedure_Insert_Input = {
  bodyParts?: InputMaybe<Array<Scalars['String']>>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  ehr_product_procedures?: InputMaybe<Ehr_Product_Procedure_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  location_procedures?: InputMaybe<Location_Procedure_Arr_Rel_Insert_Input>;
  model?: InputMaybe<Scalars['uuid']>;
  modelByModel?: InputMaybe<Model_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Procedure_Max_Fields = {
  __typename?: 'procedure_max_fields';
  bodyParts?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  model?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "procedure" */
export type Procedure_Max_Order_By = {
  bodyParts?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Procedure_Min_Fields = {
  __typename?: 'procedure_min_fields';
  bodyParts?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  model?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "procedure" */
export type Procedure_Min_Order_By = {
  bodyParts?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "procedure" */
export type Procedure_Mutation_Response = {
  __typename?: 'procedure_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Procedure>;
};

/** input type for inserting object relation for remote table "procedure" */
export type Procedure_Obj_Rel_Insert_Input = {
  data: Procedure_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Procedure_On_Conflict>;
};

/** on_conflict condition type for table "procedure" */
export type Procedure_On_Conflict = {
  constraint: Procedure_Constraint;
  update_columns?: Array<Procedure_Update_Column>;
  where?: InputMaybe<Procedure_Bool_Exp>;
};

/** Ordering options when selecting data from "procedure". */
export type Procedure_Order_By = {
  bodyParts?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  ehr_product_procedures_aggregate?: InputMaybe<Ehr_Product_Procedure_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  location_procedures_aggregate?: InputMaybe<Location_Procedure_Aggregate_Order_By>;
  model?: InputMaybe<Order_By>;
  modelByModel?: InputMaybe<Model_Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: procedure */
export type Procedure_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "procedure" */
export enum Procedure_Select_Column {
  /** column name */
  BodyParts = 'bodyParts',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Model = 'model',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "procedure" */
export type Procedure_Set_Input = {
  bodyParts?: InputMaybe<Array<Scalars['String']>>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  model?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "procedure" */
export type Procedure_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Procedure_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Procedure_Stream_Cursor_Value_Input = {
  bodyParts?: InputMaybe<Array<Scalars['String']>>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  model?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "procedure" */
export enum Procedure_Update_Column {
  /** column name */
  BodyParts = 'bodyParts',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Model = 'model',
  /** column name */
  Name = 'name'
}

export type Procedure_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Procedure_Set_Input>;
  /** filter the rows which have to be updated */
  where: Procedure_Bool_Exp;
};

/** This the *ecommerce/retail* product, not the product used in the EHR */
export type Product = {
  __typename?: 'product';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  id: Scalars['uuid'];
  isPrescription: Scalars['Boolean'];
  /** An array relationship */
  locationProducts: Array<Location_Product>;
  /** An aggregate relationship */
  locationProducts_aggregate: Location_Product_Aggregate;
  /** An array relationship */
  model_products: Array<Model_Product>;
  /** An aggregate relationship */
  model_products_aggregate: Model_Product_Aggregate;
  name: Scalars['String'];
  photoS3Key?: Maybe<Scalars['uuid']>;
  price: Scalars['Int'];
  /** An object relationship */
  product_type?: Maybe<Product_Type>;
  taxExempt: Scalars['Boolean'];
  type?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
};


/** This the *ecommerce/retail* product, not the product used in the EHR */
export type ProductLocationProductsArgs = {
  distinct_on?: InputMaybe<Array<Location_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Product_Order_By>>;
  where?: InputMaybe<Location_Product_Bool_Exp>;
};


/** This the *ecommerce/retail* product, not the product used in the EHR */
export type ProductLocationProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Product_Order_By>>;
  where?: InputMaybe<Location_Product_Bool_Exp>;
};


/** This the *ecommerce/retail* product, not the product used in the EHR */
export type ProductModel_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Model_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Product_Order_By>>;
  where?: InputMaybe<Model_Product_Bool_Exp>;
};


/** This the *ecommerce/retail* product, not the product used in the EHR */
export type ProductModel_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Product_Order_By>>;
  where?: InputMaybe<Model_Product_Bool_Exp>;
};

/** aggregated selection of "product" */
export type Product_Aggregate = {
  __typename?: 'product_aggregate';
  aggregate?: Maybe<Product_Aggregate_Fields>;
  nodes: Array<Product>;
};

/** aggregate fields of "product" */
export type Product_Aggregate_Fields = {
  __typename?: 'product_aggregate_fields';
  avg?: Maybe<Product_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Max_Fields>;
  min?: Maybe<Product_Min_Fields>;
  stddev?: Maybe<Product_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Sum_Fields>;
  var_pop?: Maybe<Product_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Var_Samp_Fields>;
  variance?: Maybe<Product_Variance_Fields>;
};


/** aggregate fields of "product" */
export type Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Product_Avg_Fields = {
  __typename?: 'product_avg_fields';
  price?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "product". All fields are combined with a logical 'AND'. */
export type Product_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Bool_Exp>>;
  _not?: InputMaybe<Product_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isPrescription?: InputMaybe<Boolean_Comparison_Exp>;
  locationProducts?: InputMaybe<Location_Product_Bool_Exp>;
  locationProducts_aggregate?: InputMaybe<Location_Product_Aggregate_Bool_Exp>;
  model_products?: InputMaybe<Model_Product_Bool_Exp>;
  model_products_aggregate?: InputMaybe<Model_Product_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photoS3Key?: InputMaybe<Uuid_Comparison_Exp>;
  price?: InputMaybe<Int_Comparison_Exp>;
  product_type?: InputMaybe<Product_Type_Bool_Exp>;
  taxExempt?: InputMaybe<Boolean_Comparison_Exp>;
  type?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "product" */
export enum Product_Constraint {
  /** unique or primary key constraint on columns "name" */
  ProductNameKey = 'product_name_key',
  /** unique or primary key constraint on columns "id" */
  ProductPkey = 'product_pkey'
}

/** input type for incrementing numeric columns in table "product" */
export type Product_Inc_Input = {
  price?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "product" */
export type Product_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPrescription?: InputMaybe<Scalars['Boolean']>;
  locationProducts?: InputMaybe<Location_Product_Arr_Rel_Insert_Input>;
  model_products?: InputMaybe<Model_Product_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['Int']>;
  product_type?: InputMaybe<Product_Type_Obj_Rel_Insert_Input>;
  taxExempt?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Product_Max_Fields = {
  __typename?: 'product_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Product_Min_Fields = {
  __typename?: 'product_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "product" */
export type Product_Mutation_Response = {
  __typename?: 'product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product>;
};

/** input type for inserting object relation for remote table "product" */
export type Product_Obj_Rel_Insert_Input = {
  data: Product_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_On_Conflict>;
};

/** on_conflict condition type for table "product" */
export type Product_On_Conflict = {
  constraint: Product_Constraint;
  update_columns?: Array<Product_Update_Column>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** Ordering options when selecting data from "product". */
export type Product_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isPrescription?: InputMaybe<Order_By>;
  locationProducts_aggregate?: InputMaybe<Location_Product_Aggregate_Order_By>;
  model_products_aggregate?: InputMaybe<Model_Product_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  photoS3Key?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  product_type?: InputMaybe<Product_Type_Order_By>;
  taxExempt?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product */
export type Product_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** Record of purchase of a product (product, location price are frozen from location_product) */
export type Product_Purchase = {
  __typename?: 'product_purchase';
  booking?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  bookingByBooking?: Maybe<Booking>;
  cancelledAt?: Maybe<Scalars['timestamptz']>;
  confirmedAt?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  invoice?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  invoiceByInvoice?: Maybe<Invoice>;
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  /** An object relationship */
  locationProduct?: Maybe<Location_Product>;
  price: Scalars['Int'];
  product: Scalars['uuid'];
  /** An object relationship */
  productByProduct: Product;
  providerDirectProductPurchase: Scalars['Boolean'];
  /** An array relationship */
  providerDirectProductPurchases: Array<Provider_Direct_Product_Purchase>;
  /** An aggregate relationship */
  providerDirectProductPurchases_aggregate: Provider_Direct_Product_Purchase_Aggregate;
  stripeId?: Maybe<Scalars['String']>;
  unitPriceWithoutDirectPurchaseMarkup?: Maybe<Scalars['Int']>;
  units: Scalars['Int'];
  unitsUnfulfilled?: Maybe<Scalars['Int']>;
  units_fulfilled: Scalars['Int'];
  user: Scalars['uuid'];
  /** An object relationship */
  userByUser: User;
};


/** Record of purchase of a product (product, location price are frozen from location_product) */
export type Product_PurchaseProviderDirectProductPurchasesArgs = {
  distinct_on?: InputMaybe<Array<Provider_Direct_Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Direct_Product_Purchase_Order_By>>;
  where?: InputMaybe<Provider_Direct_Product_Purchase_Bool_Exp>;
};


/** Record of purchase of a product (product, location price are frozen from location_product) */
export type Product_PurchaseProviderDirectProductPurchases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Direct_Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Direct_Product_Purchase_Order_By>>;
  where?: InputMaybe<Provider_Direct_Product_Purchase_Bool_Exp>;
};

/** aggregated selection of "product_purchase" */
export type Product_Purchase_Aggregate = {
  __typename?: 'product_purchase_aggregate';
  aggregate?: Maybe<Product_Purchase_Aggregate_Fields>;
  nodes: Array<Product_Purchase>;
};

export type Product_Purchase_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Product_Purchase_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Product_Purchase_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Product_Purchase_Aggregate_Bool_Exp_Count>;
};

export type Product_Purchase_Aggregate_Bool_Exp_Bool_And = {
  arguments: Product_Purchase_Select_Column_Product_Purchase_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Product_Purchase_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Purchase_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Product_Purchase_Select_Column_Product_Purchase_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Product_Purchase_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Purchase_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Purchase_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Product_Purchase_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_purchase" */
export type Product_Purchase_Aggregate_Fields = {
  __typename?: 'product_purchase_aggregate_fields';
  avg?: Maybe<Product_Purchase_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Purchase_Max_Fields>;
  min?: Maybe<Product_Purchase_Min_Fields>;
  stddev?: Maybe<Product_Purchase_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Purchase_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Purchase_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Purchase_Sum_Fields>;
  var_pop?: Maybe<Product_Purchase_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Purchase_Var_Samp_Fields>;
  variance?: Maybe<Product_Purchase_Variance_Fields>;
};


/** aggregate fields of "product_purchase" */
export type Product_Purchase_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Purchase_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_purchase" */
export type Product_Purchase_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Purchase_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Purchase_Max_Order_By>;
  min?: InputMaybe<Product_Purchase_Min_Order_By>;
  stddev?: InputMaybe<Product_Purchase_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Purchase_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Purchase_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Purchase_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Purchase_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Purchase_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Purchase_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_purchase" */
export type Product_Purchase_Arr_Rel_Insert_Input = {
  data: Array<Product_Purchase_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Purchase_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Purchase_Avg_Fields = {
  __typename?: 'product_purchase_avg_fields';
  price?: Maybe<Scalars['Float']>;
  unitPriceWithoutDirectPurchaseMarkup?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
  unitsUnfulfilled?: Maybe<Scalars['Float']>;
  units_fulfilled?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_purchase" */
export type Product_Purchase_Avg_Order_By = {
  price?: InputMaybe<Order_By>;
  unitPriceWithoutDirectPurchaseMarkup?: InputMaybe<Order_By>;
  units?: InputMaybe<Order_By>;
  unitsUnfulfilled?: InputMaybe<Order_By>;
  units_fulfilled?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_purchase". All fields are combined with a logical 'AND'. */
export type Product_Purchase_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Purchase_Bool_Exp>>;
  _not?: InputMaybe<Product_Purchase_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Purchase_Bool_Exp>>;
  booking?: InputMaybe<Uuid_Comparison_Exp>;
  bookingByBooking?: InputMaybe<Booking_Bool_Exp>;
  cancelledAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  confirmedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoice?: InputMaybe<Uuid_Comparison_Exp>;
  invoiceByInvoice?: InputMaybe<Invoice_Bool_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  locationProduct?: InputMaybe<Location_Product_Bool_Exp>;
  price?: InputMaybe<Int_Comparison_Exp>;
  product?: InputMaybe<Uuid_Comparison_Exp>;
  productByProduct?: InputMaybe<Product_Bool_Exp>;
  providerDirectProductPurchase?: InputMaybe<Boolean_Comparison_Exp>;
  providerDirectProductPurchases?: InputMaybe<Provider_Direct_Product_Purchase_Bool_Exp>;
  providerDirectProductPurchases_aggregate?: InputMaybe<Provider_Direct_Product_Purchase_Aggregate_Bool_Exp>;
  stripeId?: InputMaybe<String_Comparison_Exp>;
  unitPriceWithoutDirectPurchaseMarkup?: InputMaybe<Int_Comparison_Exp>;
  units?: InputMaybe<Int_Comparison_Exp>;
  unitsUnfulfilled?: InputMaybe<Int_Comparison_Exp>;
  units_fulfilled?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Uuid_Comparison_Exp>;
  userByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "product_purchase" */
export enum Product_Purchase_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductPurchasesPkey = 'product_purchases_pkey'
}

/** input type for incrementing numeric columns in table "product_purchase" */
export type Product_Purchase_Inc_Input = {
  price?: InputMaybe<Scalars['Int']>;
  unitPriceWithoutDirectPurchaseMarkup?: InputMaybe<Scalars['Int']>;
  units?: InputMaybe<Scalars['Int']>;
  units_fulfilled?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "product_purchase" */
export type Product_Purchase_Insert_Input = {
  booking?: InputMaybe<Scalars['uuid']>;
  bookingByBooking?: InputMaybe<Booking_Obj_Rel_Insert_Input>;
  cancelledAt?: InputMaybe<Scalars['timestamptz']>;
  confirmedAt?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  invoice?: InputMaybe<Scalars['uuid']>;
  invoiceByInvoice?: InputMaybe<Invoice_Obj_Rel_Insert_Input>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  locationProduct?: InputMaybe<Location_Product_Obj_Rel_Insert_Input>;
  price?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<Scalars['uuid']>;
  productByProduct?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  providerDirectProductPurchase?: InputMaybe<Scalars['Boolean']>;
  providerDirectProductPurchases?: InputMaybe<Provider_Direct_Product_Purchase_Arr_Rel_Insert_Input>;
  stripeId?: InputMaybe<Scalars['String']>;
  unitPriceWithoutDirectPurchaseMarkup?: InputMaybe<Scalars['Int']>;
  units?: InputMaybe<Scalars['Int']>;
  units_fulfilled?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Scalars['uuid']>;
  userByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Product_Purchase_Max_Fields = {
  __typename?: 'product_purchase_max_fields';
  booking?: Maybe<Scalars['uuid']>;
  cancelledAt?: Maybe<Scalars['timestamptz']>;
  confirmedAt?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invoice?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['Int']>;
  product?: Maybe<Scalars['uuid']>;
  stripeId?: Maybe<Scalars['String']>;
  unitPriceWithoutDirectPurchaseMarkup?: Maybe<Scalars['Int']>;
  units?: Maybe<Scalars['Int']>;
  unitsUnfulfilled?: Maybe<Scalars['Int']>;
  units_fulfilled?: Maybe<Scalars['Int']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "product_purchase" */
export type Product_Purchase_Max_Order_By = {
  booking?: InputMaybe<Order_By>;
  cancelledAt?: InputMaybe<Order_By>;
  confirmedAt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  stripeId?: InputMaybe<Order_By>;
  unitPriceWithoutDirectPurchaseMarkup?: InputMaybe<Order_By>;
  units?: InputMaybe<Order_By>;
  unitsUnfulfilled?: InputMaybe<Order_By>;
  units_fulfilled?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Purchase_Min_Fields = {
  __typename?: 'product_purchase_min_fields';
  booking?: Maybe<Scalars['uuid']>;
  cancelledAt?: Maybe<Scalars['timestamptz']>;
  confirmedAt?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invoice?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['Int']>;
  product?: Maybe<Scalars['uuid']>;
  stripeId?: Maybe<Scalars['String']>;
  unitPriceWithoutDirectPurchaseMarkup?: Maybe<Scalars['Int']>;
  units?: Maybe<Scalars['Int']>;
  unitsUnfulfilled?: Maybe<Scalars['Int']>;
  units_fulfilled?: Maybe<Scalars['Int']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "product_purchase" */
export type Product_Purchase_Min_Order_By = {
  booking?: InputMaybe<Order_By>;
  cancelledAt?: InputMaybe<Order_By>;
  confirmedAt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  stripeId?: InputMaybe<Order_By>;
  unitPriceWithoutDirectPurchaseMarkup?: InputMaybe<Order_By>;
  units?: InputMaybe<Order_By>;
  unitsUnfulfilled?: InputMaybe<Order_By>;
  units_fulfilled?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_purchase" */
export type Product_Purchase_Mutation_Response = {
  __typename?: 'product_purchase_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Purchase>;
};

/** input type for inserting object relation for remote table "product_purchase" */
export type Product_Purchase_Obj_Rel_Insert_Input = {
  data: Product_Purchase_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Purchase_On_Conflict>;
};

/** on_conflict condition type for table "product_purchase" */
export type Product_Purchase_On_Conflict = {
  constraint: Product_Purchase_Constraint;
  update_columns?: Array<Product_Purchase_Update_Column>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};

/** Ordering options when selecting data from "product_purchase". */
export type Product_Purchase_Order_By = {
  booking?: InputMaybe<Order_By>;
  bookingByBooking?: InputMaybe<Booking_Order_By>;
  cancelledAt?: InputMaybe<Order_By>;
  confirmedAt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Order_By>;
  invoiceByInvoice?: InputMaybe<Invoice_Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  locationProduct?: InputMaybe<Location_Product_Order_By>;
  price?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  productByProduct?: InputMaybe<Product_Order_By>;
  providerDirectProductPurchase?: InputMaybe<Order_By>;
  providerDirectProductPurchases_aggregate?: InputMaybe<Provider_Direct_Product_Purchase_Aggregate_Order_By>;
  stripeId?: InputMaybe<Order_By>;
  unitPriceWithoutDirectPurchaseMarkup?: InputMaybe<Order_By>;
  units?: InputMaybe<Order_By>;
  unitsUnfulfilled?: InputMaybe<Order_By>;
  units_fulfilled?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  userByUser?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: product_purchase */
export type Product_Purchase_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_purchase" */
export enum Product_Purchase_Select_Column {
  /** column name */
  Booking = 'booking',
  /** column name */
  CancelledAt = 'cancelledAt',
  /** column name */
  ConfirmedAt = 'confirmedAt',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  Location = 'location',
  /** column name */
  Price = 'price',
  /** column name */
  Product = 'product',
  /** column name */
  ProviderDirectProductPurchase = 'providerDirectProductPurchase',
  /** column name */
  StripeId = 'stripeId',
  /** column name */
  UnitPriceWithoutDirectPurchaseMarkup = 'unitPriceWithoutDirectPurchaseMarkup',
  /** column name */
  Units = 'units',
  /** column name */
  UnitsUnfulfilled = 'unitsUnfulfilled',
  /** column name */
  UnitsFulfilled = 'units_fulfilled',
  /** column name */
  User = 'user'
}

/** select "product_purchase_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product_purchase" */
export enum Product_Purchase_Select_Column_Product_Purchase_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ProviderDirectProductPurchase = 'providerDirectProductPurchase'
}

/** select "product_purchase_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product_purchase" */
export enum Product_Purchase_Select_Column_Product_Purchase_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ProviderDirectProductPurchase = 'providerDirectProductPurchase'
}

/** input type for updating data in table "product_purchase" */
export type Product_Purchase_Set_Input = {
  booking?: InputMaybe<Scalars['uuid']>;
  cancelledAt?: InputMaybe<Scalars['timestamptz']>;
  confirmedAt?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  invoice?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<Scalars['uuid']>;
  providerDirectProductPurchase?: InputMaybe<Scalars['Boolean']>;
  stripeId?: InputMaybe<Scalars['String']>;
  unitPriceWithoutDirectPurchaseMarkup?: InputMaybe<Scalars['Int']>;
  units?: InputMaybe<Scalars['Int']>;
  units_fulfilled?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Product_Purchase_Stddev_Fields = {
  __typename?: 'product_purchase_stddev_fields';
  price?: Maybe<Scalars['Float']>;
  unitPriceWithoutDirectPurchaseMarkup?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
  unitsUnfulfilled?: Maybe<Scalars['Float']>;
  units_fulfilled?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_purchase" */
export type Product_Purchase_Stddev_Order_By = {
  price?: InputMaybe<Order_By>;
  unitPriceWithoutDirectPurchaseMarkup?: InputMaybe<Order_By>;
  units?: InputMaybe<Order_By>;
  unitsUnfulfilled?: InputMaybe<Order_By>;
  units_fulfilled?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Purchase_Stddev_Pop_Fields = {
  __typename?: 'product_purchase_stddev_pop_fields';
  price?: Maybe<Scalars['Float']>;
  unitPriceWithoutDirectPurchaseMarkup?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
  unitsUnfulfilled?: Maybe<Scalars['Float']>;
  units_fulfilled?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_purchase" */
export type Product_Purchase_Stddev_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
  unitPriceWithoutDirectPurchaseMarkup?: InputMaybe<Order_By>;
  units?: InputMaybe<Order_By>;
  unitsUnfulfilled?: InputMaybe<Order_By>;
  units_fulfilled?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Purchase_Stddev_Samp_Fields = {
  __typename?: 'product_purchase_stddev_samp_fields';
  price?: Maybe<Scalars['Float']>;
  unitPriceWithoutDirectPurchaseMarkup?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
  unitsUnfulfilled?: Maybe<Scalars['Float']>;
  units_fulfilled?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_purchase" */
export type Product_Purchase_Stddev_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
  unitPriceWithoutDirectPurchaseMarkup?: InputMaybe<Order_By>;
  units?: InputMaybe<Order_By>;
  unitsUnfulfilled?: InputMaybe<Order_By>;
  units_fulfilled?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_purchase" */
export type Product_Purchase_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Purchase_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Purchase_Stream_Cursor_Value_Input = {
  booking?: InputMaybe<Scalars['uuid']>;
  cancelledAt?: InputMaybe<Scalars['timestamptz']>;
  confirmedAt?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  invoice?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<Scalars['uuid']>;
  providerDirectProductPurchase?: InputMaybe<Scalars['Boolean']>;
  stripeId?: InputMaybe<Scalars['String']>;
  unitPriceWithoutDirectPurchaseMarkup?: InputMaybe<Scalars['Int']>;
  units?: InputMaybe<Scalars['Int']>;
  unitsUnfulfilled?: InputMaybe<Scalars['Int']>;
  units_fulfilled?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Product_Purchase_Sum_Fields = {
  __typename?: 'product_purchase_sum_fields';
  price?: Maybe<Scalars['Int']>;
  unitPriceWithoutDirectPurchaseMarkup?: Maybe<Scalars['Int']>;
  units?: Maybe<Scalars['Int']>;
  unitsUnfulfilled?: Maybe<Scalars['Int']>;
  units_fulfilled?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "product_purchase" */
export type Product_Purchase_Sum_Order_By = {
  price?: InputMaybe<Order_By>;
  unitPriceWithoutDirectPurchaseMarkup?: InputMaybe<Order_By>;
  units?: InputMaybe<Order_By>;
  unitsUnfulfilled?: InputMaybe<Order_By>;
  units_fulfilled?: InputMaybe<Order_By>;
};

/** update columns of table "product_purchase" */
export enum Product_Purchase_Update_Column {
  /** column name */
  Booking = 'booking',
  /** column name */
  CancelledAt = 'cancelledAt',
  /** column name */
  ConfirmedAt = 'confirmedAt',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  Location = 'location',
  /** column name */
  Price = 'price',
  /** column name */
  Product = 'product',
  /** column name */
  ProviderDirectProductPurchase = 'providerDirectProductPurchase',
  /** column name */
  StripeId = 'stripeId',
  /** column name */
  UnitPriceWithoutDirectPurchaseMarkup = 'unitPriceWithoutDirectPurchaseMarkup',
  /** column name */
  Units = 'units',
  /** column name */
  UnitsFulfilled = 'units_fulfilled',
  /** column name */
  User = 'user'
}

export type Product_Purchase_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Purchase_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Purchase_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Purchase_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Purchase_Var_Pop_Fields = {
  __typename?: 'product_purchase_var_pop_fields';
  price?: Maybe<Scalars['Float']>;
  unitPriceWithoutDirectPurchaseMarkup?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
  unitsUnfulfilled?: Maybe<Scalars['Float']>;
  units_fulfilled?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_purchase" */
export type Product_Purchase_Var_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
  unitPriceWithoutDirectPurchaseMarkup?: InputMaybe<Order_By>;
  units?: InputMaybe<Order_By>;
  unitsUnfulfilled?: InputMaybe<Order_By>;
  units_fulfilled?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Purchase_Var_Samp_Fields = {
  __typename?: 'product_purchase_var_samp_fields';
  price?: Maybe<Scalars['Float']>;
  unitPriceWithoutDirectPurchaseMarkup?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
  unitsUnfulfilled?: Maybe<Scalars['Float']>;
  units_fulfilled?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_purchase" */
export type Product_Purchase_Var_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
  unitPriceWithoutDirectPurchaseMarkup?: InputMaybe<Order_By>;
  units?: InputMaybe<Order_By>;
  unitsUnfulfilled?: InputMaybe<Order_By>;
  units_fulfilled?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Purchase_Variance_Fields = {
  __typename?: 'product_purchase_variance_fields';
  price?: Maybe<Scalars['Float']>;
  unitPriceWithoutDirectPurchaseMarkup?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
  unitsUnfulfilled?: Maybe<Scalars['Float']>;
  units_fulfilled?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_purchase" */
export type Product_Purchase_Variance_Order_By = {
  price?: InputMaybe<Order_By>;
  unitPriceWithoutDirectPurchaseMarkup?: InputMaybe<Order_By>;
  units?: InputMaybe<Order_By>;
  unitsUnfulfilled?: InputMaybe<Order_By>;
  units_fulfilled?: InputMaybe<Order_By>;
};

/** select columns of table "product" */
export enum Product_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrescription = 'isPrescription',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoS3Key = 'photoS3Key',
  /** column name */
  Price = 'price',
  /** column name */
  TaxExempt = 'taxExempt',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "product" */
export type Product_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPrescription?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['Int']>;
  taxExempt?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Product_Stddev_Fields = {
  __typename?: 'product_stddev_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Product_Stddev_Pop_Fields = {
  __typename?: 'product_stddev_pop_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Product_Stddev_Samp_Fields = {
  __typename?: 'product_stddev_samp_fields';
  price?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "product" */
export type Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPrescription?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['Int']>;
  taxExempt?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Product_Sum_Fields = {
  __typename?: 'product_sum_fields';
  price?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "product_type" */
export type Product_Type = {
  __typename?: 'product_type';
  id: Scalars['uuid'];
  type: Scalars['String'];
};

/** aggregated selection of "product_type" */
export type Product_Type_Aggregate = {
  __typename?: 'product_type_aggregate';
  aggregate?: Maybe<Product_Type_Aggregate_Fields>;
  nodes: Array<Product_Type>;
};

/** aggregate fields of "product_type" */
export type Product_Type_Aggregate_Fields = {
  __typename?: 'product_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Product_Type_Max_Fields>;
  min?: Maybe<Product_Type_Min_Fields>;
};


/** aggregate fields of "product_type" */
export type Product_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "product_type". All fields are combined with a logical 'AND'. */
export type Product_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Type_Bool_Exp>>;
  _not?: InputMaybe<Product_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Type_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_type" */
export enum Product_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductTypePkey = 'product_type_pkey',
  /** unique or primary key constraint on columns "type" */
  ProductTypeTypeKey = 'product_type_type_key'
}

/** input type for inserting data into table "product_type" */
export type Product_Type_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Product_Type_Max_Fields = {
  __typename?: 'product_type_max_fields';
  id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Product_Type_Min_Fields = {
  __typename?: 'product_type_min_fields';
  id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "product_type" */
export type Product_Type_Mutation_Response = {
  __typename?: 'product_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Type>;
};

/** input type for inserting object relation for remote table "product_type" */
export type Product_Type_Obj_Rel_Insert_Input = {
  data: Product_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Type_On_Conflict>;
};

/** on_conflict condition type for table "product_type" */
export type Product_Type_On_Conflict = {
  constraint: Product_Type_Constraint;
  update_columns?: Array<Product_Type_Update_Column>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "product_type". */
export type Product_Type_Order_By = {
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_type */
export type Product_Type_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "product_type" */
export enum Product_Type_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "product_type" */
export type Product_Type_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "product_type" */
export type Product_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Type_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "product_type" */
export enum Product_Type_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type'
}

export type Product_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Type_Bool_Exp;
};

/** update columns of table "product" */
export enum Product_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrescription = 'isPrescription',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoS3Key = 'photoS3Key',
  /** column name */
  Price = 'price',
  /** column name */
  TaxExempt = 'taxExempt',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Product_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Var_Pop_Fields = {
  __typename?: 'product_var_pop_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Product_Var_Samp_Fields = {
  __typename?: 'product_var_samp_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Product_Variance_Fields = {
  __typename?: 'product_variance_fields';
  price?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "provider_direct_product_purchase" */
export type Provider_Direct_Product_Purchase = {
  __typename?: 'provider_direct_product_purchase';
  id: Scalars['uuid'];
  orderedAt?: Maybe<Scalars['timestamptz']>;
  packageTrackingCode?: Maybe<Scalars['String']>;
  productPurchase: Scalars['uuid'];
  /** An object relationship */
  productPurchaseByProductPurchase: Product_Purchase;
};

/** aggregated selection of "provider_direct_product_purchase" */
export type Provider_Direct_Product_Purchase_Aggregate = {
  __typename?: 'provider_direct_product_purchase_aggregate';
  aggregate?: Maybe<Provider_Direct_Product_Purchase_Aggregate_Fields>;
  nodes: Array<Provider_Direct_Product_Purchase>;
};

export type Provider_Direct_Product_Purchase_Aggregate_Bool_Exp = {
  count?: InputMaybe<Provider_Direct_Product_Purchase_Aggregate_Bool_Exp_Count>;
};

export type Provider_Direct_Product_Purchase_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Provider_Direct_Product_Purchase_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Provider_Direct_Product_Purchase_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "provider_direct_product_purchase" */
export type Provider_Direct_Product_Purchase_Aggregate_Fields = {
  __typename?: 'provider_direct_product_purchase_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Provider_Direct_Product_Purchase_Max_Fields>;
  min?: Maybe<Provider_Direct_Product_Purchase_Min_Fields>;
};


/** aggregate fields of "provider_direct_product_purchase" */
export type Provider_Direct_Product_Purchase_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Provider_Direct_Product_Purchase_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "provider_direct_product_purchase" */
export type Provider_Direct_Product_Purchase_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Provider_Direct_Product_Purchase_Max_Order_By>;
  min?: InputMaybe<Provider_Direct_Product_Purchase_Min_Order_By>;
};

/** input type for inserting array relation for remote table "provider_direct_product_purchase" */
export type Provider_Direct_Product_Purchase_Arr_Rel_Insert_Input = {
  data: Array<Provider_Direct_Product_Purchase_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Provider_Direct_Product_Purchase_On_Conflict>;
};

/** Boolean expression to filter rows from the table "provider_direct_product_purchase". All fields are combined with a logical 'AND'. */
export type Provider_Direct_Product_Purchase_Bool_Exp = {
  _and?: InputMaybe<Array<Provider_Direct_Product_Purchase_Bool_Exp>>;
  _not?: InputMaybe<Provider_Direct_Product_Purchase_Bool_Exp>;
  _or?: InputMaybe<Array<Provider_Direct_Product_Purchase_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  orderedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  packageTrackingCode?: InputMaybe<String_Comparison_Exp>;
  productPurchase?: InputMaybe<Uuid_Comparison_Exp>;
  productPurchaseByProductPurchase?: InputMaybe<Product_Purchase_Bool_Exp>;
};

/** unique or primary key constraints on table "provider_direct_product_purchase" */
export enum Provider_Direct_Product_Purchase_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProviderDirectProductPurchasePkey = 'provider_direct_product_purchase_pkey'
}

/** input type for inserting data into table "provider_direct_product_purchase" */
export type Provider_Direct_Product_Purchase_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  orderedAt?: InputMaybe<Scalars['timestamptz']>;
  packageTrackingCode?: InputMaybe<Scalars['String']>;
  productPurchase?: InputMaybe<Scalars['uuid']>;
  productPurchaseByProductPurchase?: InputMaybe<Product_Purchase_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Provider_Direct_Product_Purchase_Max_Fields = {
  __typename?: 'provider_direct_product_purchase_max_fields';
  id?: Maybe<Scalars['uuid']>;
  orderedAt?: Maybe<Scalars['timestamptz']>;
  packageTrackingCode?: Maybe<Scalars['String']>;
  productPurchase?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "provider_direct_product_purchase" */
export type Provider_Direct_Product_Purchase_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  orderedAt?: InputMaybe<Order_By>;
  packageTrackingCode?: InputMaybe<Order_By>;
  productPurchase?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Provider_Direct_Product_Purchase_Min_Fields = {
  __typename?: 'provider_direct_product_purchase_min_fields';
  id?: Maybe<Scalars['uuid']>;
  orderedAt?: Maybe<Scalars['timestamptz']>;
  packageTrackingCode?: Maybe<Scalars['String']>;
  productPurchase?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "provider_direct_product_purchase" */
export type Provider_Direct_Product_Purchase_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  orderedAt?: InputMaybe<Order_By>;
  packageTrackingCode?: InputMaybe<Order_By>;
  productPurchase?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "provider_direct_product_purchase" */
export type Provider_Direct_Product_Purchase_Mutation_Response = {
  __typename?: 'provider_direct_product_purchase_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Provider_Direct_Product_Purchase>;
};

/** on_conflict condition type for table "provider_direct_product_purchase" */
export type Provider_Direct_Product_Purchase_On_Conflict = {
  constraint: Provider_Direct_Product_Purchase_Constraint;
  update_columns?: Array<Provider_Direct_Product_Purchase_Update_Column>;
  where?: InputMaybe<Provider_Direct_Product_Purchase_Bool_Exp>;
};

/** Ordering options when selecting data from "provider_direct_product_purchase". */
export type Provider_Direct_Product_Purchase_Order_By = {
  id?: InputMaybe<Order_By>;
  orderedAt?: InputMaybe<Order_By>;
  packageTrackingCode?: InputMaybe<Order_By>;
  productPurchase?: InputMaybe<Order_By>;
  productPurchaseByProductPurchase?: InputMaybe<Product_Purchase_Order_By>;
};

/** primary key columns input for table: provider_direct_product_purchase */
export type Provider_Direct_Product_Purchase_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "provider_direct_product_purchase" */
export enum Provider_Direct_Product_Purchase_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OrderedAt = 'orderedAt',
  /** column name */
  PackageTrackingCode = 'packageTrackingCode',
  /** column name */
  ProductPurchase = 'productPurchase'
}

/** input type for updating data in table "provider_direct_product_purchase" */
export type Provider_Direct_Product_Purchase_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  orderedAt?: InputMaybe<Scalars['timestamptz']>;
  packageTrackingCode?: InputMaybe<Scalars['String']>;
  productPurchase?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "provider_direct_product_purchase" */
export type Provider_Direct_Product_Purchase_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Provider_Direct_Product_Purchase_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Provider_Direct_Product_Purchase_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  orderedAt?: InputMaybe<Scalars['timestamptz']>;
  packageTrackingCode?: InputMaybe<Scalars['String']>;
  productPurchase?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "provider_direct_product_purchase" */
export enum Provider_Direct_Product_Purchase_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OrderedAt = 'orderedAt',
  /** column name */
  PackageTrackingCode = 'packageTrackingCode',
  /** column name */
  ProductPurchase = 'productPurchase'
}

export type Provider_Direct_Product_Purchase_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Provider_Direct_Product_Purchase_Set_Input>;
  /** filter the rows which have to be updated */
  where: Provider_Direct_Product_Purchase_Bool_Exp;
};

/** columns and relationships of "provider_direct_purchase_web_admin_view" */
export type Provider_Direct_Purchase_Web_Admin_View = {
  __typename?: 'provider_direct_purchase_web_admin_view';
  cancelledAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  locationName?: Maybe<Scalars['String']>;
  orderedAt?: Maybe<Scalars['timestamptz']>;
  packageTrackingCode?: Maybe<Scalars['String']>;
  partner?: Maybe<Scalars['uuid']>;
  partnerName?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['uuid']>;
  productName?: Maybe<Scalars['String']>;
  productPurchase?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  providerFirstName?: Maybe<Scalars['String']>;
  providerLastName?: Maybe<Scalars['String']>;
  retailPrice?: Maybe<Scalars['Int']>;
  units?: Maybe<Scalars['Int']>;
  wholesalePrice?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "provider_direct_purchase_web_admin_view" */
export type Provider_Direct_Purchase_Web_Admin_View_Aggregate = {
  __typename?: 'provider_direct_purchase_web_admin_view_aggregate';
  aggregate?: Maybe<Provider_Direct_Purchase_Web_Admin_View_Aggregate_Fields>;
  nodes: Array<Provider_Direct_Purchase_Web_Admin_View>;
};

/** aggregate fields of "provider_direct_purchase_web_admin_view" */
export type Provider_Direct_Purchase_Web_Admin_View_Aggregate_Fields = {
  __typename?: 'provider_direct_purchase_web_admin_view_aggregate_fields';
  avg?: Maybe<Provider_Direct_Purchase_Web_Admin_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Provider_Direct_Purchase_Web_Admin_View_Max_Fields>;
  min?: Maybe<Provider_Direct_Purchase_Web_Admin_View_Min_Fields>;
  stddev?: Maybe<Provider_Direct_Purchase_Web_Admin_View_Stddev_Fields>;
  stddev_pop?: Maybe<Provider_Direct_Purchase_Web_Admin_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Provider_Direct_Purchase_Web_Admin_View_Stddev_Samp_Fields>;
  sum?: Maybe<Provider_Direct_Purchase_Web_Admin_View_Sum_Fields>;
  var_pop?: Maybe<Provider_Direct_Purchase_Web_Admin_View_Var_Pop_Fields>;
  var_samp?: Maybe<Provider_Direct_Purchase_Web_Admin_View_Var_Samp_Fields>;
  variance?: Maybe<Provider_Direct_Purchase_Web_Admin_View_Variance_Fields>;
};


/** aggregate fields of "provider_direct_purchase_web_admin_view" */
export type Provider_Direct_Purchase_Web_Admin_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Provider_Direct_Purchase_Web_Admin_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Provider_Direct_Purchase_Web_Admin_View_Avg_Fields = {
  __typename?: 'provider_direct_purchase_web_admin_view_avg_fields';
  retailPrice?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
  wholesalePrice?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "provider_direct_purchase_web_admin_view". All fields are combined with a logical 'AND'. */
export type Provider_Direct_Purchase_Web_Admin_View_Bool_Exp = {
  _and?: InputMaybe<Array<Provider_Direct_Purchase_Web_Admin_View_Bool_Exp>>;
  _not?: InputMaybe<Provider_Direct_Purchase_Web_Admin_View_Bool_Exp>;
  _or?: InputMaybe<Array<Provider_Direct_Purchase_Web_Admin_View_Bool_Exp>>;
  cancelledAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationName?: InputMaybe<String_Comparison_Exp>;
  orderedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  packageTrackingCode?: InputMaybe<String_Comparison_Exp>;
  partner?: InputMaybe<Uuid_Comparison_Exp>;
  partnerName?: InputMaybe<String_Comparison_Exp>;
  product?: InputMaybe<Uuid_Comparison_Exp>;
  productName?: InputMaybe<String_Comparison_Exp>;
  productPurchase?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  providerFirstName?: InputMaybe<String_Comparison_Exp>;
  providerLastName?: InputMaybe<String_Comparison_Exp>;
  retailPrice?: InputMaybe<Int_Comparison_Exp>;
  units?: InputMaybe<Int_Comparison_Exp>;
  wholesalePrice?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Provider_Direct_Purchase_Web_Admin_View_Max_Fields = {
  __typename?: 'provider_direct_purchase_web_admin_view_max_fields';
  cancelledAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  locationName?: Maybe<Scalars['String']>;
  orderedAt?: Maybe<Scalars['timestamptz']>;
  packageTrackingCode?: Maybe<Scalars['String']>;
  partner?: Maybe<Scalars['uuid']>;
  partnerName?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['uuid']>;
  productName?: Maybe<Scalars['String']>;
  productPurchase?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  providerFirstName?: Maybe<Scalars['String']>;
  providerLastName?: Maybe<Scalars['String']>;
  retailPrice?: Maybe<Scalars['Int']>;
  units?: Maybe<Scalars['Int']>;
  wholesalePrice?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Provider_Direct_Purchase_Web_Admin_View_Min_Fields = {
  __typename?: 'provider_direct_purchase_web_admin_view_min_fields';
  cancelledAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  locationName?: Maybe<Scalars['String']>;
  orderedAt?: Maybe<Scalars['timestamptz']>;
  packageTrackingCode?: Maybe<Scalars['String']>;
  partner?: Maybe<Scalars['uuid']>;
  partnerName?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['uuid']>;
  productName?: Maybe<Scalars['String']>;
  productPurchase?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  providerFirstName?: Maybe<Scalars['String']>;
  providerLastName?: Maybe<Scalars['String']>;
  retailPrice?: Maybe<Scalars['Int']>;
  units?: Maybe<Scalars['Int']>;
  wholesalePrice?: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "provider_direct_purchase_web_admin_view". */
export type Provider_Direct_Purchase_Web_Admin_View_Order_By = {
  cancelledAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationName?: InputMaybe<Order_By>;
  orderedAt?: InputMaybe<Order_By>;
  packageTrackingCode?: InputMaybe<Order_By>;
  partner?: InputMaybe<Order_By>;
  partnerName?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  productName?: InputMaybe<Order_By>;
  productPurchase?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  providerFirstName?: InputMaybe<Order_By>;
  providerLastName?: InputMaybe<Order_By>;
  retailPrice?: InputMaybe<Order_By>;
  units?: InputMaybe<Order_By>;
  wholesalePrice?: InputMaybe<Order_By>;
};

/** select columns of table "provider_direct_purchase_web_admin_view" */
export enum Provider_Direct_Purchase_Web_Admin_View_Select_Column {
  /** column name */
  CancelledAt = 'cancelledAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  LocationName = 'locationName',
  /** column name */
  OrderedAt = 'orderedAt',
  /** column name */
  PackageTrackingCode = 'packageTrackingCode',
  /** column name */
  Partner = 'partner',
  /** column name */
  PartnerName = 'partnerName',
  /** column name */
  Product = 'product',
  /** column name */
  ProductName = 'productName',
  /** column name */
  ProductPurchase = 'productPurchase',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderFirstName = 'providerFirstName',
  /** column name */
  ProviderLastName = 'providerLastName',
  /** column name */
  RetailPrice = 'retailPrice',
  /** column name */
  Units = 'units',
  /** column name */
  WholesalePrice = 'wholesalePrice'
}

/** aggregate stddev on columns */
export type Provider_Direct_Purchase_Web_Admin_View_Stddev_Fields = {
  __typename?: 'provider_direct_purchase_web_admin_view_stddev_fields';
  retailPrice?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
  wholesalePrice?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Provider_Direct_Purchase_Web_Admin_View_Stddev_Pop_Fields = {
  __typename?: 'provider_direct_purchase_web_admin_view_stddev_pop_fields';
  retailPrice?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
  wholesalePrice?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Provider_Direct_Purchase_Web_Admin_View_Stddev_Samp_Fields = {
  __typename?: 'provider_direct_purchase_web_admin_view_stddev_samp_fields';
  retailPrice?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
  wholesalePrice?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "provider_direct_purchase_web_admin_view" */
export type Provider_Direct_Purchase_Web_Admin_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Provider_Direct_Purchase_Web_Admin_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Provider_Direct_Purchase_Web_Admin_View_Stream_Cursor_Value_Input = {
  cancelledAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationName?: InputMaybe<Scalars['String']>;
  orderedAt?: InputMaybe<Scalars['timestamptz']>;
  packageTrackingCode?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<Scalars['uuid']>;
  partnerName?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['uuid']>;
  productName?: InputMaybe<Scalars['String']>;
  productPurchase?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  providerFirstName?: InputMaybe<Scalars['String']>;
  providerLastName?: InputMaybe<Scalars['String']>;
  retailPrice?: InputMaybe<Scalars['Int']>;
  units?: InputMaybe<Scalars['Int']>;
  wholesalePrice?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Provider_Direct_Purchase_Web_Admin_View_Sum_Fields = {
  __typename?: 'provider_direct_purchase_web_admin_view_sum_fields';
  retailPrice?: Maybe<Scalars['Int']>;
  units?: Maybe<Scalars['Int']>;
  wholesalePrice?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Provider_Direct_Purchase_Web_Admin_View_Var_Pop_Fields = {
  __typename?: 'provider_direct_purchase_web_admin_view_var_pop_fields';
  retailPrice?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
  wholesalePrice?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Provider_Direct_Purchase_Web_Admin_View_Var_Samp_Fields = {
  __typename?: 'provider_direct_purchase_web_admin_view_var_samp_fields';
  retailPrice?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
  wholesalePrice?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Provider_Direct_Purchase_Web_Admin_View_Variance_Fields = {
  __typename?: 'provider_direct_purchase_web_admin_view_variance_fields';
  retailPrice?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
  wholesalePrice?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "provider_hours" */
export type Provider_Hours = {
  __typename?: 'provider_hours';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  provider: Scalars['uuid'];
  /** An object relationship */
  provider_hours_repeater?: Maybe<Provider_Hours_Repeater>;
  repeatingKey?: Maybe<Scalars['uuid']>;
  timespan: Scalars['tstzrange'];
  /** A computed field, executes function "provider_hours_timespan_lower" */
  timespanLower?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "provider_hours_timespan_upper" */
  timespanUpper?: Maybe<Scalars['timestamptz']>;
  timespan_lower: Scalars['timestamptz'];
  timespan_upper: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
};

/** aggregated selection of "provider_hours" */
export type Provider_Hours_Aggregate = {
  __typename?: 'provider_hours_aggregate';
  aggregate?: Maybe<Provider_Hours_Aggregate_Fields>;
  nodes: Array<Provider_Hours>;
};

export type Provider_Hours_Aggregate_Bool_Exp = {
  count?: InputMaybe<Provider_Hours_Aggregate_Bool_Exp_Count>;
};

export type Provider_Hours_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Provider_Hours_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Provider_Hours_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "provider_hours" */
export type Provider_Hours_Aggregate_Fields = {
  __typename?: 'provider_hours_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Provider_Hours_Max_Fields>;
  min?: Maybe<Provider_Hours_Min_Fields>;
};


/** aggregate fields of "provider_hours" */
export type Provider_Hours_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Provider_Hours_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "provider_hours" */
export type Provider_Hours_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Provider_Hours_Max_Order_By>;
  min?: InputMaybe<Provider_Hours_Min_Order_By>;
};

/** input type for inserting array relation for remote table "provider_hours" */
export type Provider_Hours_Arr_Rel_Insert_Input = {
  data: Array<Provider_Hours_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Provider_Hours_On_Conflict>;
};

/** Boolean expression to filter rows from the table "provider_hours". All fields are combined with a logical 'AND'. */
export type Provider_Hours_Bool_Exp = {
  _and?: InputMaybe<Array<Provider_Hours_Bool_Exp>>;
  _not?: InputMaybe<Provider_Hours_Bool_Exp>;
  _or?: InputMaybe<Array<Provider_Hours_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  provider_hours_repeater?: InputMaybe<Provider_Hours_Repeater_Bool_Exp>;
  repeatingKey?: InputMaybe<Uuid_Comparison_Exp>;
  timespan?: InputMaybe<Tstzrange_Comparison_Exp>;
  timespanLower?: InputMaybe<Timestamptz_Comparison_Exp>;
  timespanUpper?: InputMaybe<Timestamptz_Comparison_Exp>;
  timespan_lower?: InputMaybe<Timestamptz_Comparison_Exp>;
  timespan_upper?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "provider_hours" */
export enum Provider_Hours_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProviderHoursPkey = 'provider_hours_pkey'
}

/** input type for inserting data into table "provider_hours" */
export type Provider_Hours_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  provider?: InputMaybe<Scalars['uuid']>;
  provider_hours_repeater?: InputMaybe<Provider_Hours_Repeater_Obj_Rel_Insert_Input>;
  repeatingKey?: InputMaybe<Scalars['uuid']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Provider_Hours_Max_Fields = {
  __typename?: 'provider_hours_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  repeatingKey?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "provider_hours_timespan_lower" */
  timespanLower?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "provider_hours_timespan_upper" */
  timespanUpper?: Maybe<Scalars['timestamptz']>;
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  timespan_upper?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "provider_hours" */
export type Provider_Hours_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  repeatingKey?: InputMaybe<Order_By>;
  timespan_lower?: InputMaybe<Order_By>;
  timespan_upper?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Provider_Hours_Min_Fields = {
  __typename?: 'provider_hours_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  repeatingKey?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "provider_hours_timespan_lower" */
  timespanLower?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "provider_hours_timespan_upper" */
  timespanUpper?: Maybe<Scalars['timestamptz']>;
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  timespan_upper?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "provider_hours" */
export type Provider_Hours_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  repeatingKey?: InputMaybe<Order_By>;
  timespan_lower?: InputMaybe<Order_By>;
  timespan_upper?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "provider_hours" */
export type Provider_Hours_Mutation_Response = {
  __typename?: 'provider_hours_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Provider_Hours>;
};

/** on_conflict condition type for table "provider_hours" */
export type Provider_Hours_On_Conflict = {
  constraint: Provider_Hours_Constraint;
  update_columns?: Array<Provider_Hours_Update_Column>;
  where?: InputMaybe<Provider_Hours_Bool_Exp>;
};

/** Ordering options when selecting data from "provider_hours". */
export type Provider_Hours_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  provider?: InputMaybe<Order_By>;
  provider_hours_repeater?: InputMaybe<Provider_Hours_Repeater_Order_By>;
  repeatingKey?: InputMaybe<Order_By>;
  timespan?: InputMaybe<Order_By>;
  timespanLower?: InputMaybe<Order_By>;
  timespanUpper?: InputMaybe<Order_By>;
  timespan_lower?: InputMaybe<Order_By>;
  timespan_upper?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: provider_hours */
export type Provider_Hours_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "provider_hours_repeat_interval" */
export type Provider_Hours_Repeat_Interval = {
  __typename?: 'provider_hours_repeat_interval';
  interval: Scalars['String'];
};

/** aggregated selection of "provider_hours_repeat_interval" */
export type Provider_Hours_Repeat_Interval_Aggregate = {
  __typename?: 'provider_hours_repeat_interval_aggregate';
  aggregate?: Maybe<Provider_Hours_Repeat_Interval_Aggregate_Fields>;
  nodes: Array<Provider_Hours_Repeat_Interval>;
};

/** aggregate fields of "provider_hours_repeat_interval" */
export type Provider_Hours_Repeat_Interval_Aggregate_Fields = {
  __typename?: 'provider_hours_repeat_interval_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Provider_Hours_Repeat_Interval_Max_Fields>;
  min?: Maybe<Provider_Hours_Repeat_Interval_Min_Fields>;
};


/** aggregate fields of "provider_hours_repeat_interval" */
export type Provider_Hours_Repeat_Interval_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Provider_Hours_Repeat_Interval_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "provider_hours_repeat_interval". All fields are combined with a logical 'AND'. */
export type Provider_Hours_Repeat_Interval_Bool_Exp = {
  _and?: InputMaybe<Array<Provider_Hours_Repeat_Interval_Bool_Exp>>;
  _not?: InputMaybe<Provider_Hours_Repeat_Interval_Bool_Exp>;
  _or?: InputMaybe<Array<Provider_Hours_Repeat_Interval_Bool_Exp>>;
  interval?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "provider_hours_repeat_interval" */
export enum Provider_Hours_Repeat_Interval_Constraint {
  /** unique or primary key constraint on columns "interval" */
  ProviderHoursRepeatIntervalPkey = 'provider_hours_repeat_interval_pkey'
}

export enum Provider_Hours_Repeat_Interval_Enum {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Never = 'NEVER',
  Weekdays = 'WEEKDAYS',
  Weekly = 'WEEKLY'
}

/** Boolean expression to compare columns of type "provider_hours_repeat_interval_enum". All fields are combined with logical 'AND'. */
export type Provider_Hours_Repeat_Interval_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Provider_Hours_Repeat_Interval_Enum>;
  _in?: InputMaybe<Array<Provider_Hours_Repeat_Interval_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Provider_Hours_Repeat_Interval_Enum>;
  _nin?: InputMaybe<Array<Provider_Hours_Repeat_Interval_Enum>>;
};

/** input type for inserting data into table "provider_hours_repeat_interval" */
export type Provider_Hours_Repeat_Interval_Insert_Input = {
  interval?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Provider_Hours_Repeat_Interval_Max_Fields = {
  __typename?: 'provider_hours_repeat_interval_max_fields';
  interval?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Provider_Hours_Repeat_Interval_Min_Fields = {
  __typename?: 'provider_hours_repeat_interval_min_fields';
  interval?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "provider_hours_repeat_interval" */
export type Provider_Hours_Repeat_Interval_Mutation_Response = {
  __typename?: 'provider_hours_repeat_interval_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Provider_Hours_Repeat_Interval>;
};

/** input type for inserting object relation for remote table "provider_hours_repeat_interval" */
export type Provider_Hours_Repeat_Interval_Obj_Rel_Insert_Input = {
  data: Provider_Hours_Repeat_Interval_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Provider_Hours_Repeat_Interval_On_Conflict>;
};

/** on_conflict condition type for table "provider_hours_repeat_interval" */
export type Provider_Hours_Repeat_Interval_On_Conflict = {
  constraint: Provider_Hours_Repeat_Interval_Constraint;
  update_columns?: Array<Provider_Hours_Repeat_Interval_Update_Column>;
  where?: InputMaybe<Provider_Hours_Repeat_Interval_Bool_Exp>;
};

/** Ordering options when selecting data from "provider_hours_repeat_interval". */
export type Provider_Hours_Repeat_Interval_Order_By = {
  interval?: InputMaybe<Order_By>;
};

/** primary key columns input for table: provider_hours_repeat_interval */
export type Provider_Hours_Repeat_Interval_Pk_Columns_Input = {
  interval: Scalars['String'];
};

/** select columns of table "provider_hours_repeat_interval" */
export enum Provider_Hours_Repeat_Interval_Select_Column {
  /** column name */
  Interval = 'interval'
}

/** input type for updating data in table "provider_hours_repeat_interval" */
export type Provider_Hours_Repeat_Interval_Set_Input = {
  interval?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "provider_hours_repeat_interval" */
export type Provider_Hours_Repeat_Interval_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Provider_Hours_Repeat_Interval_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Provider_Hours_Repeat_Interval_Stream_Cursor_Value_Input = {
  interval?: InputMaybe<Scalars['String']>;
};

/** update columns of table "provider_hours_repeat_interval" */
export enum Provider_Hours_Repeat_Interval_Update_Column {
  /** column name */
  Interval = 'interval'
}

export type Provider_Hours_Repeat_Interval_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Provider_Hours_Repeat_Interval_Set_Input>;
  /** filter the rows which have to be updated */
  where: Provider_Hours_Repeat_Interval_Bool_Exp;
};

/** columns and relationships of "provider_hours_repeater" */
export type Provider_Hours_Repeater = {
  __typename?: 'provider_hours_repeater';
  id: Scalars['uuid'];
  interval: Provider_Hours_Repeat_Interval_Enum;
  /** An array relationship */
  provider_hours: Array<Provider_Hours>;
  /** An aggregate relationship */
  provider_hours_aggregate: Provider_Hours_Aggregate;
  /** An object relationship */
  provider_hours_repeat_interval: Provider_Hours_Repeat_Interval;
};


/** columns and relationships of "provider_hours_repeater" */
export type Provider_Hours_RepeaterProvider_HoursArgs = {
  distinct_on?: InputMaybe<Array<Provider_Hours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Hours_Order_By>>;
  where?: InputMaybe<Provider_Hours_Bool_Exp>;
};


/** columns and relationships of "provider_hours_repeater" */
export type Provider_Hours_RepeaterProvider_Hours_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Hours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Hours_Order_By>>;
  where?: InputMaybe<Provider_Hours_Bool_Exp>;
};

/** aggregated selection of "provider_hours_repeater" */
export type Provider_Hours_Repeater_Aggregate = {
  __typename?: 'provider_hours_repeater_aggregate';
  aggregate?: Maybe<Provider_Hours_Repeater_Aggregate_Fields>;
  nodes: Array<Provider_Hours_Repeater>;
};

/** aggregate fields of "provider_hours_repeater" */
export type Provider_Hours_Repeater_Aggregate_Fields = {
  __typename?: 'provider_hours_repeater_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Provider_Hours_Repeater_Max_Fields>;
  min?: Maybe<Provider_Hours_Repeater_Min_Fields>;
};


/** aggregate fields of "provider_hours_repeater" */
export type Provider_Hours_Repeater_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Provider_Hours_Repeater_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "provider_hours_repeater". All fields are combined with a logical 'AND'. */
export type Provider_Hours_Repeater_Bool_Exp = {
  _and?: InputMaybe<Array<Provider_Hours_Repeater_Bool_Exp>>;
  _not?: InputMaybe<Provider_Hours_Repeater_Bool_Exp>;
  _or?: InputMaybe<Array<Provider_Hours_Repeater_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  interval?: InputMaybe<Provider_Hours_Repeat_Interval_Enum_Comparison_Exp>;
  provider_hours?: InputMaybe<Provider_Hours_Bool_Exp>;
  provider_hours_aggregate?: InputMaybe<Provider_Hours_Aggregate_Bool_Exp>;
  provider_hours_repeat_interval?: InputMaybe<Provider_Hours_Repeat_Interval_Bool_Exp>;
};

/** unique or primary key constraints on table "provider_hours_repeater" */
export enum Provider_Hours_Repeater_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProviderHoursRepeaterPkey = 'provider_hours_repeater_pkey'
}

/** input type for inserting data into table "provider_hours_repeater" */
export type Provider_Hours_Repeater_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  interval?: InputMaybe<Provider_Hours_Repeat_Interval_Enum>;
  provider_hours?: InputMaybe<Provider_Hours_Arr_Rel_Insert_Input>;
  provider_hours_repeat_interval?: InputMaybe<Provider_Hours_Repeat_Interval_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Provider_Hours_Repeater_Max_Fields = {
  __typename?: 'provider_hours_repeater_max_fields';
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Provider_Hours_Repeater_Min_Fields = {
  __typename?: 'provider_hours_repeater_min_fields';
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "provider_hours_repeater" */
export type Provider_Hours_Repeater_Mutation_Response = {
  __typename?: 'provider_hours_repeater_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Provider_Hours_Repeater>;
};

/** input type for inserting object relation for remote table "provider_hours_repeater" */
export type Provider_Hours_Repeater_Obj_Rel_Insert_Input = {
  data: Provider_Hours_Repeater_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Provider_Hours_Repeater_On_Conflict>;
};

/** on_conflict condition type for table "provider_hours_repeater" */
export type Provider_Hours_Repeater_On_Conflict = {
  constraint: Provider_Hours_Repeater_Constraint;
  update_columns?: Array<Provider_Hours_Repeater_Update_Column>;
  where?: InputMaybe<Provider_Hours_Repeater_Bool_Exp>;
};

/** Ordering options when selecting data from "provider_hours_repeater". */
export type Provider_Hours_Repeater_Order_By = {
  id?: InputMaybe<Order_By>;
  interval?: InputMaybe<Order_By>;
  provider_hours_aggregate?: InputMaybe<Provider_Hours_Aggregate_Order_By>;
  provider_hours_repeat_interval?: InputMaybe<Provider_Hours_Repeat_Interval_Order_By>;
};

/** primary key columns input for table: provider_hours_repeater */
export type Provider_Hours_Repeater_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "provider_hours_repeater" */
export enum Provider_Hours_Repeater_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Interval = 'interval'
}

/** input type for updating data in table "provider_hours_repeater" */
export type Provider_Hours_Repeater_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  interval?: InputMaybe<Provider_Hours_Repeat_Interval_Enum>;
};

/** Streaming cursor of the table "provider_hours_repeater" */
export type Provider_Hours_Repeater_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Provider_Hours_Repeater_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Provider_Hours_Repeater_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  interval?: InputMaybe<Provider_Hours_Repeat_Interval_Enum>;
};

/** update columns of table "provider_hours_repeater" */
export enum Provider_Hours_Repeater_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Interval = 'interval'
}

export type Provider_Hours_Repeater_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Provider_Hours_Repeater_Set_Input>;
  /** filter the rows which have to be updated */
  where: Provider_Hours_Repeater_Bool_Exp;
};

/** select columns of table "provider_hours" */
export enum Provider_Hours_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Provider = 'provider',
  /** column name */
  RepeatingKey = 'repeatingKey',
  /** column name */
  Timespan = 'timespan',
  /** column name */
  TimespanLower = 'timespan_lower',
  /** column name */
  TimespanUpper = 'timespan_upper'
}

/** input type for updating data in table "provider_hours" */
export type Provider_Hours_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  repeatingKey?: InputMaybe<Scalars['uuid']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
};

/** Streaming cursor of the table "provider_hours" */
export type Provider_Hours_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Provider_Hours_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Provider_Hours_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  repeatingKey?: InputMaybe<Scalars['uuid']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
  timespan_lower?: InputMaybe<Scalars['timestamptz']>;
  timespan_upper?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "provider_hours" */
export enum Provider_Hours_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Provider = 'provider',
  /** column name */
  RepeatingKey = 'repeatingKey',
  /** column name */
  Timespan = 'timespan'
}

export type Provider_Hours_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Provider_Hours_Set_Input>;
  /** filter the rows which have to be updated */
  where: Provider_Hours_Bool_Exp;
};

/** columns and relationships of "provider_patient_booking_settings" */
export type Provider_Patient_Booking_Settings = {
  __typename?: 'provider_patient_booking_settings';
  autoConfirmPatientBookings: Scalars['Boolean'];
  cancelUnconfirmedPatientBookingsAfterHours: Scalars['Int'];
  id: Scalars['uuid'];
  provider: Scalars['uuid'];
  /** An object relationship */
  providerByProvider: User;
};

/** aggregated selection of "provider_patient_booking_settings" */
export type Provider_Patient_Booking_Settings_Aggregate = {
  __typename?: 'provider_patient_booking_settings_aggregate';
  aggregate?: Maybe<Provider_Patient_Booking_Settings_Aggregate_Fields>;
  nodes: Array<Provider_Patient_Booking_Settings>;
};

/** aggregate fields of "provider_patient_booking_settings" */
export type Provider_Patient_Booking_Settings_Aggregate_Fields = {
  __typename?: 'provider_patient_booking_settings_aggregate_fields';
  avg?: Maybe<Provider_Patient_Booking_Settings_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Provider_Patient_Booking_Settings_Max_Fields>;
  min?: Maybe<Provider_Patient_Booking_Settings_Min_Fields>;
  stddev?: Maybe<Provider_Patient_Booking_Settings_Stddev_Fields>;
  stddev_pop?: Maybe<Provider_Patient_Booking_Settings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Provider_Patient_Booking_Settings_Stddev_Samp_Fields>;
  sum?: Maybe<Provider_Patient_Booking_Settings_Sum_Fields>;
  var_pop?: Maybe<Provider_Patient_Booking_Settings_Var_Pop_Fields>;
  var_samp?: Maybe<Provider_Patient_Booking_Settings_Var_Samp_Fields>;
  variance?: Maybe<Provider_Patient_Booking_Settings_Variance_Fields>;
};


/** aggregate fields of "provider_patient_booking_settings" */
export type Provider_Patient_Booking_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Provider_Patient_Booking_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Provider_Patient_Booking_Settings_Avg_Fields = {
  __typename?: 'provider_patient_booking_settings_avg_fields';
  cancelUnconfirmedPatientBookingsAfterHours?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "provider_patient_booking_settings". All fields are combined with a logical 'AND'. */
export type Provider_Patient_Booking_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Provider_Patient_Booking_Settings_Bool_Exp>>;
  _not?: InputMaybe<Provider_Patient_Booking_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Provider_Patient_Booking_Settings_Bool_Exp>>;
  autoConfirmPatientBookings?: InputMaybe<Boolean_Comparison_Exp>;
  cancelUnconfirmedPatientBookingsAfterHours?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  providerByProvider?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "provider_patient_booking_settings" */
export enum Provider_Patient_Booking_Settings_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProviderPatientBookingSettingsPkey = 'provider_patient_booking_settings_pkey',
  /** unique or primary key constraint on columns "provider" */
  ProviderPatientBookingSettingsProvider = 'provider_patient_booking_settings_provider'
}

/** input type for incrementing numeric columns in table "provider_patient_booking_settings" */
export type Provider_Patient_Booking_Settings_Inc_Input = {
  cancelUnconfirmedPatientBookingsAfterHours?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "provider_patient_booking_settings" */
export type Provider_Patient_Booking_Settings_Insert_Input = {
  autoConfirmPatientBookings?: InputMaybe<Scalars['Boolean']>;
  cancelUnconfirmedPatientBookingsAfterHours?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  providerByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Provider_Patient_Booking_Settings_Max_Fields = {
  __typename?: 'provider_patient_booking_settings_max_fields';
  cancelUnconfirmedPatientBookingsAfterHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Provider_Patient_Booking_Settings_Min_Fields = {
  __typename?: 'provider_patient_booking_settings_min_fields';
  cancelUnconfirmedPatientBookingsAfterHours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "provider_patient_booking_settings" */
export type Provider_Patient_Booking_Settings_Mutation_Response = {
  __typename?: 'provider_patient_booking_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Provider_Patient_Booking_Settings>;
};

/** input type for inserting object relation for remote table "provider_patient_booking_settings" */
export type Provider_Patient_Booking_Settings_Obj_Rel_Insert_Input = {
  data: Provider_Patient_Booking_Settings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Provider_Patient_Booking_Settings_On_Conflict>;
};

/** on_conflict condition type for table "provider_patient_booking_settings" */
export type Provider_Patient_Booking_Settings_On_Conflict = {
  constraint: Provider_Patient_Booking_Settings_Constraint;
  update_columns?: Array<Provider_Patient_Booking_Settings_Update_Column>;
  where?: InputMaybe<Provider_Patient_Booking_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "provider_patient_booking_settings". */
export type Provider_Patient_Booking_Settings_Order_By = {
  autoConfirmPatientBookings?: InputMaybe<Order_By>;
  cancelUnconfirmedPatientBookingsAfterHours?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  providerByProvider?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: provider_patient_booking_settings */
export type Provider_Patient_Booking_Settings_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "provider_patient_booking_settings" */
export enum Provider_Patient_Booking_Settings_Select_Column {
  /** column name */
  AutoConfirmPatientBookings = 'autoConfirmPatientBookings',
  /** column name */
  CancelUnconfirmedPatientBookingsAfterHours = 'cancelUnconfirmedPatientBookingsAfterHours',
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider'
}

/** input type for updating data in table "provider_patient_booking_settings" */
export type Provider_Patient_Booking_Settings_Set_Input = {
  autoConfirmPatientBookings?: InputMaybe<Scalars['Boolean']>;
  cancelUnconfirmedPatientBookingsAfterHours?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Provider_Patient_Booking_Settings_Stddev_Fields = {
  __typename?: 'provider_patient_booking_settings_stddev_fields';
  cancelUnconfirmedPatientBookingsAfterHours?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Provider_Patient_Booking_Settings_Stddev_Pop_Fields = {
  __typename?: 'provider_patient_booking_settings_stddev_pop_fields';
  cancelUnconfirmedPatientBookingsAfterHours?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Provider_Patient_Booking_Settings_Stddev_Samp_Fields = {
  __typename?: 'provider_patient_booking_settings_stddev_samp_fields';
  cancelUnconfirmedPatientBookingsAfterHours?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "provider_patient_booking_settings" */
export type Provider_Patient_Booking_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Provider_Patient_Booking_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Provider_Patient_Booking_Settings_Stream_Cursor_Value_Input = {
  autoConfirmPatientBookings?: InputMaybe<Scalars['Boolean']>;
  cancelUnconfirmedPatientBookingsAfterHours?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Provider_Patient_Booking_Settings_Sum_Fields = {
  __typename?: 'provider_patient_booking_settings_sum_fields';
  cancelUnconfirmedPatientBookingsAfterHours?: Maybe<Scalars['Int']>;
};

/** update columns of table "provider_patient_booking_settings" */
export enum Provider_Patient_Booking_Settings_Update_Column {
  /** column name */
  AutoConfirmPatientBookings = 'autoConfirmPatientBookings',
  /** column name */
  CancelUnconfirmedPatientBookingsAfterHours = 'cancelUnconfirmedPatientBookingsAfterHours',
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider'
}

export type Provider_Patient_Booking_Settings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Provider_Patient_Booking_Settings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Provider_Patient_Booking_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Provider_Patient_Booking_Settings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Provider_Patient_Booking_Settings_Var_Pop_Fields = {
  __typename?: 'provider_patient_booking_settings_var_pop_fields';
  cancelUnconfirmedPatientBookingsAfterHours?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Provider_Patient_Booking_Settings_Var_Samp_Fields = {
  __typename?: 'provider_patient_booking_settings_var_samp_fields';
  cancelUnconfirmedPatientBookingsAfterHours?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Provider_Patient_Booking_Settings_Variance_Fields = {
  __typename?: 'provider_patient_booking_settings_variance_fields';
  cancelUnconfirmedPatientBookingsAfterHours?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "provider_procedure" */
export type Provider_Procedure = {
  __typename?: 'provider_procedure';
  bookingFee: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  durationMinutes: Scalars['Int'];
  id: Scalars['uuid'];
  locationProcedure: Scalars['uuid'];
  /** An object relationship */
  locationProcedureByLocationProcedure: Location_Procedure;
  provider: Scalars['uuid'];
  /** An object relationship */
  providerByProvider: User;
  publishedPrice?: Maybe<Scalars['String']>;
  taxable: Scalars['Boolean'];
};

/** aggregated selection of "provider_procedure" */
export type Provider_Procedure_Aggregate = {
  __typename?: 'provider_procedure_aggregate';
  aggregate?: Maybe<Provider_Procedure_Aggregate_Fields>;
  nodes: Array<Provider_Procedure>;
};

export type Provider_Procedure_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Provider_Procedure_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Provider_Procedure_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Provider_Procedure_Aggregate_Bool_Exp_Count>;
};

export type Provider_Procedure_Aggregate_Bool_Exp_Bool_And = {
  arguments: Provider_Procedure_Select_Column_Provider_Procedure_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Provider_Procedure_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Provider_Procedure_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Provider_Procedure_Select_Column_Provider_Procedure_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Provider_Procedure_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Provider_Procedure_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Provider_Procedure_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Provider_Procedure_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "provider_procedure" */
export type Provider_Procedure_Aggregate_Fields = {
  __typename?: 'provider_procedure_aggregate_fields';
  avg?: Maybe<Provider_Procedure_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Provider_Procedure_Max_Fields>;
  min?: Maybe<Provider_Procedure_Min_Fields>;
  stddev?: Maybe<Provider_Procedure_Stddev_Fields>;
  stddev_pop?: Maybe<Provider_Procedure_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Provider_Procedure_Stddev_Samp_Fields>;
  sum?: Maybe<Provider_Procedure_Sum_Fields>;
  var_pop?: Maybe<Provider_Procedure_Var_Pop_Fields>;
  var_samp?: Maybe<Provider_Procedure_Var_Samp_Fields>;
  variance?: Maybe<Provider_Procedure_Variance_Fields>;
};


/** aggregate fields of "provider_procedure" */
export type Provider_Procedure_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Provider_Procedure_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "provider_procedure" */
export type Provider_Procedure_Aggregate_Order_By = {
  avg?: InputMaybe<Provider_Procedure_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Provider_Procedure_Max_Order_By>;
  min?: InputMaybe<Provider_Procedure_Min_Order_By>;
  stddev?: InputMaybe<Provider_Procedure_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Provider_Procedure_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Provider_Procedure_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Provider_Procedure_Sum_Order_By>;
  var_pop?: InputMaybe<Provider_Procedure_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Provider_Procedure_Var_Samp_Order_By>;
  variance?: InputMaybe<Provider_Procedure_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "provider_procedure" */
export type Provider_Procedure_Arr_Rel_Insert_Input = {
  data: Array<Provider_Procedure_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Provider_Procedure_On_Conflict>;
};

/** aggregate avg on columns */
export type Provider_Procedure_Avg_Fields = {
  __typename?: 'provider_procedure_avg_fields';
  bookingFee?: Maybe<Scalars['Float']>;
  durationMinutes?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "provider_procedure" */
export type Provider_Procedure_Avg_Order_By = {
  bookingFee?: InputMaybe<Order_By>;
  durationMinutes?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "provider_procedure". All fields are combined with a logical 'AND'. */
export type Provider_Procedure_Bool_Exp = {
  _and?: InputMaybe<Array<Provider_Procedure_Bool_Exp>>;
  _not?: InputMaybe<Provider_Procedure_Bool_Exp>;
  _or?: InputMaybe<Array<Provider_Procedure_Bool_Exp>>;
  bookingFee?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  durationMinutes?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  locationProcedure?: InputMaybe<Uuid_Comparison_Exp>;
  locationProcedureByLocationProcedure?: InputMaybe<Location_Procedure_Bool_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  providerByProvider?: InputMaybe<User_Bool_Exp>;
  publishedPrice?: InputMaybe<String_Comparison_Exp>;
  taxable?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "provider_procedure" */
export enum Provider_Procedure_Constraint {
  /** unique or primary key constraint on columns "provider", "location_procedure" */
  ProviderProcedureLocationProcedureIndex = 'provider_procedure_location_procedure_index',
  /** unique or primary key constraint on columns "id" */
  ProviderProceduresPkey = 'provider_procedures_pkey'
}

/** input type for incrementing numeric columns in table "provider_procedure" */
export type Provider_Procedure_Inc_Input = {
  bookingFee?: InputMaybe<Scalars['Int']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "provider_procedure" */
export type Provider_Procedure_Insert_Input = {
  bookingFee?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  locationProcedure?: InputMaybe<Scalars['uuid']>;
  locationProcedureByLocationProcedure?: InputMaybe<Location_Procedure_Obj_Rel_Insert_Input>;
  provider?: InputMaybe<Scalars['uuid']>;
  providerByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
  publishedPrice?: InputMaybe<Scalars['String']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Provider_Procedure_Max_Fields = {
  __typename?: 'provider_procedure_max_fields';
  bookingFee?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  durationMinutes?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  locationProcedure?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  publishedPrice?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "provider_procedure" */
export type Provider_Procedure_Max_Order_By = {
  bookingFee?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  durationMinutes?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locationProcedure?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  publishedPrice?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Provider_Procedure_Min_Fields = {
  __typename?: 'provider_procedure_min_fields';
  bookingFee?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  durationMinutes?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  locationProcedure?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  publishedPrice?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "provider_procedure" */
export type Provider_Procedure_Min_Order_By = {
  bookingFee?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  durationMinutes?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locationProcedure?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  publishedPrice?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "provider_procedure" */
export type Provider_Procedure_Mutation_Response = {
  __typename?: 'provider_procedure_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Provider_Procedure>;
};

/** input type for inserting object relation for remote table "provider_procedure" */
export type Provider_Procedure_Obj_Rel_Insert_Input = {
  data: Provider_Procedure_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Provider_Procedure_On_Conflict>;
};

/** on_conflict condition type for table "provider_procedure" */
export type Provider_Procedure_On_Conflict = {
  constraint: Provider_Procedure_Constraint;
  update_columns?: Array<Provider_Procedure_Update_Column>;
  where?: InputMaybe<Provider_Procedure_Bool_Exp>;
};

/** Ordering options when selecting data from "provider_procedure". */
export type Provider_Procedure_Order_By = {
  bookingFee?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  durationMinutes?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locationProcedure?: InputMaybe<Order_By>;
  locationProcedureByLocationProcedure?: InputMaybe<Location_Procedure_Order_By>;
  provider?: InputMaybe<Order_By>;
  providerByProvider?: InputMaybe<User_Order_By>;
  publishedPrice?: InputMaybe<Order_By>;
  taxable?: InputMaybe<Order_By>;
};

/** primary key columns input for table: provider_procedure */
export type Provider_Procedure_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "provider_procedure" */
export enum Provider_Procedure_Select_Column {
  /** column name */
  BookingFee = 'bookingFee',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DurationMinutes = 'durationMinutes',
  /** column name */
  Id = 'id',
  /** column name */
  LocationProcedure = 'locationProcedure',
  /** column name */
  Provider = 'provider',
  /** column name */
  PublishedPrice = 'publishedPrice',
  /** column name */
  Taxable = 'taxable'
}

/** select "provider_procedure_aggregate_bool_exp_bool_and_arguments_columns" columns of table "provider_procedure" */
export enum Provider_Procedure_Select_Column_Provider_Procedure_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Taxable = 'taxable'
}

/** select "provider_procedure_aggregate_bool_exp_bool_or_arguments_columns" columns of table "provider_procedure" */
export enum Provider_Procedure_Select_Column_Provider_Procedure_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Taxable = 'taxable'
}

/** input type for updating data in table "provider_procedure" */
export type Provider_Procedure_Set_Input = {
  bookingFee?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  locationProcedure?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  publishedPrice?: InputMaybe<Scalars['String']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Provider_Procedure_Stddev_Fields = {
  __typename?: 'provider_procedure_stddev_fields';
  bookingFee?: Maybe<Scalars['Float']>;
  durationMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "provider_procedure" */
export type Provider_Procedure_Stddev_Order_By = {
  bookingFee?: InputMaybe<Order_By>;
  durationMinutes?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Provider_Procedure_Stddev_Pop_Fields = {
  __typename?: 'provider_procedure_stddev_pop_fields';
  bookingFee?: Maybe<Scalars['Float']>;
  durationMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "provider_procedure" */
export type Provider_Procedure_Stddev_Pop_Order_By = {
  bookingFee?: InputMaybe<Order_By>;
  durationMinutes?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Provider_Procedure_Stddev_Samp_Fields = {
  __typename?: 'provider_procedure_stddev_samp_fields';
  bookingFee?: Maybe<Scalars['Float']>;
  durationMinutes?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "provider_procedure" */
export type Provider_Procedure_Stddev_Samp_Order_By = {
  bookingFee?: InputMaybe<Order_By>;
  durationMinutes?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "provider_procedure" */
export type Provider_Procedure_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Provider_Procedure_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Provider_Procedure_Stream_Cursor_Value_Input = {
  bookingFee?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  locationProcedure?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
  publishedPrice?: InputMaybe<Scalars['String']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Provider_Procedure_Sum_Fields = {
  __typename?: 'provider_procedure_sum_fields';
  bookingFee?: Maybe<Scalars['Int']>;
  durationMinutes?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "provider_procedure" */
export type Provider_Procedure_Sum_Order_By = {
  bookingFee?: InputMaybe<Order_By>;
  durationMinutes?: InputMaybe<Order_By>;
};

/** update columns of table "provider_procedure" */
export enum Provider_Procedure_Update_Column {
  /** column name */
  BookingFee = 'bookingFee',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DurationMinutes = 'durationMinutes',
  /** column name */
  Id = 'id',
  /** column name */
  LocationProcedure = 'locationProcedure',
  /** column name */
  Provider = 'provider',
  /** column name */
  PublishedPrice = 'publishedPrice',
  /** column name */
  Taxable = 'taxable'
}

export type Provider_Procedure_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Provider_Procedure_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Provider_Procedure_Set_Input>;
  /** filter the rows which have to be updated */
  where: Provider_Procedure_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Provider_Procedure_Var_Pop_Fields = {
  __typename?: 'provider_procedure_var_pop_fields';
  bookingFee?: Maybe<Scalars['Float']>;
  durationMinutes?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "provider_procedure" */
export type Provider_Procedure_Var_Pop_Order_By = {
  bookingFee?: InputMaybe<Order_By>;
  durationMinutes?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Provider_Procedure_Var_Samp_Fields = {
  __typename?: 'provider_procedure_var_samp_fields';
  bookingFee?: Maybe<Scalars['Float']>;
  durationMinutes?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "provider_procedure" */
export type Provider_Procedure_Var_Samp_Order_By = {
  bookingFee?: InputMaybe<Order_By>;
  durationMinutes?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Provider_Procedure_Variance_Fields = {
  __typename?: 'provider_procedure_variance_fields';
  bookingFee?: Maybe<Scalars['Float']>;
  durationMinutes?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "provider_procedure" */
export type Provider_Procedure_Variance_Order_By = {
  bookingFee?: InputMaybe<Order_By>;
  durationMinutes?: InputMaybe<Order_By>;
};

/** Purchases made on behalf of a location (not a provider) */
export type Purchase_For_Location = {
  __typename?: 'purchase_for_location';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  orderPlaced: Scalars['Boolean'];
  product: Scalars['uuid'];
  /** An object relationship */
  productByProduct: Product;
  productPrice: Scalars['Int'];
  purchasedBy: Scalars['uuid'];
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeInvoiceUrl?: Maybe<Scalars['String']>;
  trackingUrl?: Maybe<Scalars['String']>;
  units: Scalars['Int'];
  /** An object relationship */
  user: User;
};

/** aggregated selection of "purchase_for_location" */
export type Purchase_For_Location_Aggregate = {
  __typename?: 'purchase_for_location_aggregate';
  aggregate?: Maybe<Purchase_For_Location_Aggregate_Fields>;
  nodes: Array<Purchase_For_Location>;
};

/** aggregate fields of "purchase_for_location" */
export type Purchase_For_Location_Aggregate_Fields = {
  __typename?: 'purchase_for_location_aggregate_fields';
  avg?: Maybe<Purchase_For_Location_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Purchase_For_Location_Max_Fields>;
  min?: Maybe<Purchase_For_Location_Min_Fields>;
  stddev?: Maybe<Purchase_For_Location_Stddev_Fields>;
  stddev_pop?: Maybe<Purchase_For_Location_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Purchase_For_Location_Stddev_Samp_Fields>;
  sum?: Maybe<Purchase_For_Location_Sum_Fields>;
  var_pop?: Maybe<Purchase_For_Location_Var_Pop_Fields>;
  var_samp?: Maybe<Purchase_For_Location_Var_Samp_Fields>;
  variance?: Maybe<Purchase_For_Location_Variance_Fields>;
};


/** aggregate fields of "purchase_for_location" */
export type Purchase_For_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Purchase_For_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Purchase_For_Location_Avg_Fields = {
  __typename?: 'purchase_for_location_avg_fields';
  productPrice?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "purchase_for_location". All fields are combined with a logical 'AND'. */
export type Purchase_For_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Purchase_For_Location_Bool_Exp>>;
  _not?: InputMaybe<Purchase_For_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Purchase_For_Location_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  orderPlaced?: InputMaybe<Boolean_Comparison_Exp>;
  product?: InputMaybe<Uuid_Comparison_Exp>;
  productByProduct?: InputMaybe<Product_Bool_Exp>;
  productPrice?: InputMaybe<Int_Comparison_Exp>;
  purchasedBy?: InputMaybe<Uuid_Comparison_Exp>;
  stripeInvoiceId?: InputMaybe<String_Comparison_Exp>;
  stripeInvoiceUrl?: InputMaybe<String_Comparison_Exp>;
  trackingUrl?: InputMaybe<String_Comparison_Exp>;
  units?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "purchase_for_location" */
export enum Purchase_For_Location_Constraint {
  /** unique or primary key constraint on columns "id" */
  PurchaseForLocationPkey = 'purchase_for_location_pkey'
}

/** input type for incrementing numeric columns in table "purchase_for_location" */
export type Purchase_For_Location_Inc_Input = {
  productPrice?: InputMaybe<Scalars['Int']>;
  units?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "purchase_for_location" */
export type Purchase_For_Location_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  orderPlaced?: InputMaybe<Scalars['Boolean']>;
  product?: InputMaybe<Scalars['uuid']>;
  productByProduct?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  productPrice?: InputMaybe<Scalars['Int']>;
  purchasedBy?: InputMaybe<Scalars['uuid']>;
  stripeInvoiceId?: InputMaybe<Scalars['String']>;
  stripeInvoiceUrl?: InputMaybe<Scalars['String']>;
  trackingUrl?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Purchase_For_Location_Max_Fields = {
  __typename?: 'purchase_for_location_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  product?: Maybe<Scalars['uuid']>;
  productPrice?: Maybe<Scalars['Int']>;
  purchasedBy?: Maybe<Scalars['uuid']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeInvoiceUrl?: Maybe<Scalars['String']>;
  trackingUrl?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Purchase_For_Location_Min_Fields = {
  __typename?: 'purchase_for_location_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  product?: Maybe<Scalars['uuid']>;
  productPrice?: Maybe<Scalars['Int']>;
  purchasedBy?: Maybe<Scalars['uuid']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeInvoiceUrl?: Maybe<Scalars['String']>;
  trackingUrl?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "purchase_for_location" */
export type Purchase_For_Location_Mutation_Response = {
  __typename?: 'purchase_for_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Purchase_For_Location>;
};

/** on_conflict condition type for table "purchase_for_location" */
export type Purchase_For_Location_On_Conflict = {
  constraint: Purchase_For_Location_Constraint;
  update_columns?: Array<Purchase_For_Location_Update_Column>;
  where?: InputMaybe<Purchase_For_Location_Bool_Exp>;
};

/** Ordering options when selecting data from "purchase_for_location". */
export type Purchase_For_Location_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  orderPlaced?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  productByProduct?: InputMaybe<Product_Order_By>;
  productPrice?: InputMaybe<Order_By>;
  purchasedBy?: InputMaybe<Order_By>;
  stripeInvoiceId?: InputMaybe<Order_By>;
  stripeInvoiceUrl?: InputMaybe<Order_By>;
  trackingUrl?: InputMaybe<Order_By>;
  units?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: purchase_for_location */
export type Purchase_For_Location_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "purchase_for_location" */
export enum Purchase_For_Location_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  OrderPlaced = 'orderPlaced',
  /** column name */
  Product = 'product',
  /** column name */
  ProductPrice = 'productPrice',
  /** column name */
  PurchasedBy = 'purchasedBy',
  /** column name */
  StripeInvoiceId = 'stripeInvoiceId',
  /** column name */
  StripeInvoiceUrl = 'stripeInvoiceUrl',
  /** column name */
  TrackingUrl = 'trackingUrl',
  /** column name */
  Units = 'units'
}

/** input type for updating data in table "purchase_for_location" */
export type Purchase_For_Location_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  orderPlaced?: InputMaybe<Scalars['Boolean']>;
  product?: InputMaybe<Scalars['uuid']>;
  productPrice?: InputMaybe<Scalars['Int']>;
  purchasedBy?: InputMaybe<Scalars['uuid']>;
  stripeInvoiceId?: InputMaybe<Scalars['String']>;
  stripeInvoiceUrl?: InputMaybe<Scalars['String']>;
  trackingUrl?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Purchase_For_Location_Stddev_Fields = {
  __typename?: 'purchase_for_location_stddev_fields';
  productPrice?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Purchase_For_Location_Stddev_Pop_Fields = {
  __typename?: 'purchase_for_location_stddev_pop_fields';
  productPrice?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Purchase_For_Location_Stddev_Samp_Fields = {
  __typename?: 'purchase_for_location_stddev_samp_fields';
  productPrice?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "purchase_for_location" */
export type Purchase_For_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Purchase_For_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Purchase_For_Location_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  orderPlaced?: InputMaybe<Scalars['Boolean']>;
  product?: InputMaybe<Scalars['uuid']>;
  productPrice?: InputMaybe<Scalars['Int']>;
  purchasedBy?: InputMaybe<Scalars['uuid']>;
  stripeInvoiceId?: InputMaybe<Scalars['String']>;
  stripeInvoiceUrl?: InputMaybe<Scalars['String']>;
  trackingUrl?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Purchase_For_Location_Sum_Fields = {
  __typename?: 'purchase_for_location_sum_fields';
  productPrice?: Maybe<Scalars['Int']>;
  units?: Maybe<Scalars['Int']>;
};

/** update columns of table "purchase_for_location" */
export enum Purchase_For_Location_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  OrderPlaced = 'orderPlaced',
  /** column name */
  Product = 'product',
  /** column name */
  ProductPrice = 'productPrice',
  /** column name */
  PurchasedBy = 'purchasedBy',
  /** column name */
  StripeInvoiceId = 'stripeInvoiceId',
  /** column name */
  StripeInvoiceUrl = 'stripeInvoiceUrl',
  /** column name */
  TrackingUrl = 'trackingUrl',
  /** column name */
  Units = 'units'
}

export type Purchase_For_Location_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Purchase_For_Location_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Purchase_For_Location_Set_Input>;
  /** filter the rows which have to be updated */
  where: Purchase_For_Location_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Purchase_For_Location_Var_Pop_Fields = {
  __typename?: 'purchase_for_location_var_pop_fields';
  productPrice?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Purchase_For_Location_Var_Samp_Fields = {
  __typename?: 'purchase_for_location_var_samp_fields';
  productPrice?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Purchase_For_Location_Variance_Fields = {
  __typename?: 'purchase_for_location_variance_fields';
  productPrice?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "purchase_requests_list" */
export type Purchase_Requests_List = {
  __typename?: 'purchase_requests_list';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  locationName?: Maybe<Scalars['String']>;
  msoName?: Maybe<Scalars['String']>;
  orderPlaced?: Maybe<Scalars['Boolean']>;
  partner?: Maybe<Scalars['uuid']>;
  product?: Maybe<Scalars['uuid']>;
  productName?: Maybe<Scalars['String']>;
  productsCost?: Maybe<Scalars['numeric']>;
  purchasedByName?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeInvoiceUrl?: Maybe<Scalars['String']>;
  trackingUrl?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "purchase_requests_list" */
export type Purchase_Requests_List_Aggregate = {
  __typename?: 'purchase_requests_list_aggregate';
  aggregate?: Maybe<Purchase_Requests_List_Aggregate_Fields>;
  nodes: Array<Purchase_Requests_List>;
};

/** aggregate fields of "purchase_requests_list" */
export type Purchase_Requests_List_Aggregate_Fields = {
  __typename?: 'purchase_requests_list_aggregate_fields';
  avg?: Maybe<Purchase_Requests_List_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Purchase_Requests_List_Max_Fields>;
  min?: Maybe<Purchase_Requests_List_Min_Fields>;
  stddev?: Maybe<Purchase_Requests_List_Stddev_Fields>;
  stddev_pop?: Maybe<Purchase_Requests_List_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Purchase_Requests_List_Stddev_Samp_Fields>;
  sum?: Maybe<Purchase_Requests_List_Sum_Fields>;
  var_pop?: Maybe<Purchase_Requests_List_Var_Pop_Fields>;
  var_samp?: Maybe<Purchase_Requests_List_Var_Samp_Fields>;
  variance?: Maybe<Purchase_Requests_List_Variance_Fields>;
};


/** aggregate fields of "purchase_requests_list" */
export type Purchase_Requests_List_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Purchase_Requests_List_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Purchase_Requests_List_Avg_Fields = {
  __typename?: 'purchase_requests_list_avg_fields';
  productsCost?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "purchase_requests_list". All fields are combined with a logical 'AND'. */
export type Purchase_Requests_List_Bool_Exp = {
  _and?: InputMaybe<Array<Purchase_Requests_List_Bool_Exp>>;
  _not?: InputMaybe<Purchase_Requests_List_Bool_Exp>;
  _or?: InputMaybe<Array<Purchase_Requests_List_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationName?: InputMaybe<String_Comparison_Exp>;
  msoName?: InputMaybe<String_Comparison_Exp>;
  orderPlaced?: InputMaybe<Boolean_Comparison_Exp>;
  partner?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Uuid_Comparison_Exp>;
  productName?: InputMaybe<String_Comparison_Exp>;
  productsCost?: InputMaybe<Numeric_Comparison_Exp>;
  purchasedByName?: InputMaybe<String_Comparison_Exp>;
  stripeInvoiceId?: InputMaybe<String_Comparison_Exp>;
  stripeInvoiceUrl?: InputMaybe<String_Comparison_Exp>;
  trackingUrl?: InputMaybe<String_Comparison_Exp>;
  units?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Purchase_Requests_List_Max_Fields = {
  __typename?: 'purchase_requests_list_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  locationName?: Maybe<Scalars['String']>;
  msoName?: Maybe<Scalars['String']>;
  partner?: Maybe<Scalars['uuid']>;
  product?: Maybe<Scalars['uuid']>;
  productName?: Maybe<Scalars['String']>;
  productsCost?: Maybe<Scalars['numeric']>;
  purchasedByName?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeInvoiceUrl?: Maybe<Scalars['String']>;
  trackingUrl?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Purchase_Requests_List_Min_Fields = {
  __typename?: 'purchase_requests_list_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  locationName?: Maybe<Scalars['String']>;
  msoName?: Maybe<Scalars['String']>;
  partner?: Maybe<Scalars['uuid']>;
  product?: Maybe<Scalars['uuid']>;
  productName?: Maybe<Scalars['String']>;
  productsCost?: Maybe<Scalars['numeric']>;
  purchasedByName?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeInvoiceUrl?: Maybe<Scalars['String']>;
  trackingUrl?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "purchase_requests_list". */
export type Purchase_Requests_List_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationName?: InputMaybe<Order_By>;
  msoName?: InputMaybe<Order_By>;
  orderPlaced?: InputMaybe<Order_By>;
  partner?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  productName?: InputMaybe<Order_By>;
  productsCost?: InputMaybe<Order_By>;
  purchasedByName?: InputMaybe<Order_By>;
  stripeInvoiceId?: InputMaybe<Order_By>;
  stripeInvoiceUrl?: InputMaybe<Order_By>;
  trackingUrl?: InputMaybe<Order_By>;
  units?: InputMaybe<Order_By>;
};

/** select columns of table "purchase_requests_list" */
export enum Purchase_Requests_List_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  LocationName = 'locationName',
  /** column name */
  MsoName = 'msoName',
  /** column name */
  OrderPlaced = 'orderPlaced',
  /** column name */
  Partner = 'partner',
  /** column name */
  Product = 'product',
  /** column name */
  ProductName = 'productName',
  /** column name */
  ProductsCost = 'productsCost',
  /** column name */
  PurchasedByName = 'purchasedByName',
  /** column name */
  StripeInvoiceId = 'stripeInvoiceId',
  /** column name */
  StripeInvoiceUrl = 'stripeInvoiceUrl',
  /** column name */
  TrackingUrl = 'trackingUrl',
  /** column name */
  Units = 'units'
}

/** aggregate stddev on columns */
export type Purchase_Requests_List_Stddev_Fields = {
  __typename?: 'purchase_requests_list_stddev_fields';
  productsCost?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Purchase_Requests_List_Stddev_Pop_Fields = {
  __typename?: 'purchase_requests_list_stddev_pop_fields';
  productsCost?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Purchase_Requests_List_Stddev_Samp_Fields = {
  __typename?: 'purchase_requests_list_stddev_samp_fields';
  productsCost?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "purchase_requests_list" */
export type Purchase_Requests_List_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Purchase_Requests_List_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Purchase_Requests_List_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationName?: InputMaybe<Scalars['String']>;
  msoName?: InputMaybe<Scalars['String']>;
  orderPlaced?: InputMaybe<Scalars['Boolean']>;
  partner?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Scalars['uuid']>;
  productName?: InputMaybe<Scalars['String']>;
  productsCost?: InputMaybe<Scalars['numeric']>;
  purchasedByName?: InputMaybe<Scalars['String']>;
  stripeInvoiceId?: InputMaybe<Scalars['String']>;
  stripeInvoiceUrl?: InputMaybe<Scalars['String']>;
  trackingUrl?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Purchase_Requests_List_Sum_Fields = {
  __typename?: 'purchase_requests_list_sum_fields';
  productsCost?: Maybe<Scalars['numeric']>;
  units?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Purchase_Requests_List_Var_Pop_Fields = {
  __typename?: 'purchase_requests_list_var_pop_fields';
  productsCost?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Purchase_Requests_List_Var_Samp_Fields = {
  __typename?: 'purchase_requests_list_var_samp_fields';
  productsCost?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Purchase_Requests_List_Variance_Fields = {
  __typename?: 'purchase_requests_list_variance_fields';
  productsCost?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['Float']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  EhrListCards: Array<EhrListCardsOutputItem>;
  EhrListCharges: Array<EhrListChargesOutputItem>;
  EhrListPatientCharges: Array<EhrListPatientChargesOutputItem>;
  EhrResolveCustomer: EhrResolveCustomerOutput;
  /** Get available booking slots for a provider and model at a location */
  GetBookingAvailability: GetBookingAvailabilityOutput;
  GetMsoDashboardMetric: GetMsoDashboardMetricOutput;
  GetMsoDashboardMetricStripeStagingProd: Array<GetMsoDashboardMetricOutput>;
  /** Bookable slots for the authenticated patient, for one procedure over a window */
  GetPatientBookingAvailability: GetBookingAvailabilityOutput;
  GetPaymentsList: Array<GetPaymentsListOutput>;
  GetProviderSquareCustomers: Array<GetProviderSquareCustomersOutput>;
  GetSignedUrlForEhrPhoto: GetSignedUrlForEhrPhotoOutput;
  /** GetSquareMerchantName */
  GetSquareMerchantName: GetSquareMerchantNameOutput;
  GetSquareUserCards: Array<GetSquareUserCardsOutputItem>;
  GetStripeSubscriptionInvoices: Array<GetStripeSubscriptionInvoicesOutput>;
  LookupPhoneNumberTwilio: LookupPhoneNumberTwilioOutput;
  ValidatePatientInvite: ValidatePatientInviteOutput;
  /** fetch data from the table: "accreditation" */
  accreditation: Array<Accreditation>;
  /** fetch aggregated fields from the table: "accreditation" */
  accreditation_aggregate: Accreditation_Aggregate;
  /** fetch data from the table: "accreditation" using primary key columns */
  accreditation_by_pk?: Maybe<Accreditation>;
  /** fetch data from the table: "accreditation_location_privilege" */
  accreditation_location_privilege: Array<Accreditation_Location_Privilege>;
  /** fetch aggregated fields from the table: "accreditation_location_privilege" */
  accreditation_location_privilege_aggregate: Accreditation_Location_Privilege_Aggregate;
  /** fetch data from the table: "accreditation_location_privilege" using primary key columns */
  accreditation_location_privilege_by_pk?: Maybe<Accreditation_Location_Privilege>;
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch aggregated fields from the table: "address" */
  address_aggregate: Address_Aggregate;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>;
  /** fetch data from the table: "agreement_type" */
  agreement_type: Array<Agreement_Type>;
  /** fetch aggregated fields from the table: "agreement_type" */
  agreement_type_aggregate: Agreement_Type_Aggregate;
  /** fetch data from the table: "agreement_type" using primary key columns */
  agreement_type_by_pk?: Maybe<Agreement_Type>;
  /** fetch data from the table: "booking" */
  booking: Array<Booking>;
  /** fetch aggregated fields from the table: "booking" */
  booking_aggregate: Booking_Aggregate;
  /** fetch data from the table: "booking" using primary key columns */
  booking_by_pk?: Maybe<Booking>;
  /** fetch data from the table: "booking_public" */
  booking_public: Array<Booking_Public>;
  /** fetch aggregated fields from the table: "booking_public" */
  booking_public_aggregate: Booking_Public_Aggregate;
  /** fetch data from the table: "booking_type" */
  booking_type: Array<Booking_Type>;
  /** fetch aggregated fields from the table: "booking_type" */
  booking_type_aggregate: Booking_Type_Aggregate;
  /** fetch data from the table: "booking_type" using primary key columns */
  booking_type_by_pk?: Maybe<Booking_Type>;
  /** fetch data from the table: "cancel_reason" */
  cancel_reason: Array<Cancel_Reason>;
  /** fetch aggregated fields from the table: "cancel_reason" */
  cancel_reason_aggregate: Cancel_Reason_Aggregate;
  /** fetch data from the table: "cancel_reason" using primary key columns */
  cancel_reason_by_pk?: Maybe<Cancel_Reason>;
  /** execute function "check_proposed_patient_booking_for_stacking" which returns "fn_check_proposed_patient_booking_for_stacking" */
  check_proposed_patient_booking_for_stacking: Array<Fn_Check_Proposed_Patient_Booking_For_Stacking>;
  /** execute function "check_proposed_patient_booking_for_stacking" and query aggregates on result of table type "fn_check_proposed_patient_booking_for_stacking" */
  check_proposed_patient_booking_for_stacking_aggregate: Fn_Check_Proposed_Patient_Booking_For_Stacking_Aggregate;
  /** fetch data from the table: "credit" */
  credit: Array<Credit>;
  /** fetch aggregated fields from the table: "credit" */
  credit_aggregate: Credit_Aggregate;
  /** fetch data from the table: "credit" using primary key columns */
  credit_by_pk?: Maybe<Credit>;
  /** fetch data from the table: "credit_transaction" */
  credit_transaction: Array<Credit_Transaction>;
  /** fetch aggregated fields from the table: "credit_transaction" */
  credit_transaction_aggregate: Credit_Transaction_Aggregate;
  /** fetch data from the table: "credit_transaction" using primary key columns */
  credit_transaction_by_pk?: Maybe<Credit_Transaction>;
  /** fetch data from the table: "credit_type" */
  credit_type: Array<Credit_Type>;
  /** fetch aggregated fields from the table: "credit_type" */
  credit_type_aggregate: Credit_Type_Aggregate;
  /** fetch data from the table: "credit_type" using primary key columns */
  credit_type_by_pk?: Maybe<Credit_Type>;
  /** fetch data from the table: "demo_location" */
  demo_location: Array<Demo_Location>;
  /** fetch aggregated fields from the table: "demo_location" */
  demo_location_aggregate: Demo_Location_Aggregate;
  /** fetch data from the table: "demo_location" using primary key columns */
  demo_location_by_pk?: Maybe<Demo_Location>;
  /** fetch data from the table: "document_type" */
  document_type: Array<Document_Type>;
  /** fetch aggregated fields from the table: "document_type" */
  document_type_aggregate: Document_Type_Aggregate;
  /** fetch data from the table: "document_type" using primary key columns */
  document_type_by_pk?: Maybe<Document_Type>;
  /** fetch data from the table: "ehr_charge_ledger" */
  ehr_charge_ledger: Array<Ehr_Charge_Ledger>;
  /** fetch aggregated fields from the table: "ehr_charge_ledger" */
  ehr_charge_ledger_aggregate: Ehr_Charge_Ledger_Aggregate;
  /** fetch data from the table: "ehr_charge_ledger" using primary key columns */
  ehr_charge_ledger_by_pk?: Maybe<Ehr_Charge_Ledger>;
  /** fetch data from the table: "ehr_encounter" */
  ehr_encounter: Array<Ehr_Encounter>;
  /** fetch data from the table: "ehr_encounter_addendum" */
  ehr_encounter_addendum: Array<Ehr_Encounter_Addendum>;
  /** fetch aggregated fields from the table: "ehr_encounter_addendum" */
  ehr_encounter_addendum_aggregate: Ehr_Encounter_Addendum_Aggregate;
  /** fetch data from the table: "ehr_encounter_addendum" using primary key columns */
  ehr_encounter_addendum_by_pk?: Maybe<Ehr_Encounter_Addendum>;
  /** fetch aggregated fields from the table: "ehr_encounter" */
  ehr_encounter_aggregate: Ehr_Encounter_Aggregate;
  /** fetch data from the table: "ehr_encounter" using primary key columns */
  ehr_encounter_by_pk?: Maybe<Ehr_Encounter>;
  /** fetch data from the table: "ehr_encounter_modality" */
  ehr_encounter_modality: Array<Ehr_Encounter_Modality>;
  /** fetch aggregated fields from the table: "ehr_encounter_modality" */
  ehr_encounter_modality_aggregate: Ehr_Encounter_Modality_Aggregate;
  /** fetch data from the table: "ehr_encounter_modality" using primary key columns */
  ehr_encounter_modality_by_pk?: Maybe<Ehr_Encounter_Modality>;
  /** fetch data from the table: "ehr_encounter_photo" */
  ehr_encounter_photo: Array<Ehr_Encounter_Photo>;
  /** fetch aggregated fields from the table: "ehr_encounter_photo" */
  ehr_encounter_photo_aggregate: Ehr_Encounter_Photo_Aggregate;
  /** fetch data from the table: "ehr_encounter_photo" using primary key columns */
  ehr_encounter_photo_by_pk?: Maybe<Ehr_Encounter_Photo>;
  /** fetch data from the table: "ehr_encounter_scan_3d" */
  ehr_encounter_scan_3d: Array<Ehr_Encounter_Scan_3d>;
  /** fetch aggregated fields from the table: "ehr_encounter_scan_3d" */
  ehr_encounter_scan_3d_aggregate: Ehr_Encounter_Scan_3d_Aggregate;
  /** fetch data from the table: "ehr_encounter_scan_3d_artifact" */
  ehr_encounter_scan_3d_artifact: Array<Ehr_Encounter_Scan_3d_Artifact>;
  /** fetch aggregated fields from the table: "ehr_encounter_scan_3d_artifact" */
  ehr_encounter_scan_3d_artifact_aggregate: Ehr_Encounter_Scan_3d_Artifact_Aggregate;
  /** fetch data from the table: "ehr_encounter_scan_3d_artifact" using primary key columns */
  ehr_encounter_scan_3d_artifact_by_pk?: Maybe<Ehr_Encounter_Scan_3d_Artifact>;
  /** fetch data from the table: "ehr_encounter_scan_3d_artifact_kind" */
  ehr_encounter_scan_3d_artifact_kind: Array<Ehr_Encounter_Scan_3d_Artifact_Kind>;
  /** fetch aggregated fields from the table: "ehr_encounter_scan_3d_artifact_kind" */
  ehr_encounter_scan_3d_artifact_kind_aggregate: Ehr_Encounter_Scan_3d_Artifact_Kind_Aggregate;
  /** fetch data from the table: "ehr_encounter_scan_3d_artifact_kind" using primary key columns */
  ehr_encounter_scan_3d_artifact_kind_by_pk?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Kind>;
  /** fetch data from the table: "ehr_encounter_scan_3d" using primary key columns */
  ehr_encounter_scan_3d_by_pk?: Maybe<Ehr_Encounter_Scan_3d>;
  /** fetch data from the table: "ehr_encounter_type" */
  ehr_encounter_type: Array<Ehr_Encounter_Type>;
  /** fetch aggregated fields from the table: "ehr_encounter_type" */
  ehr_encounter_type_aggregate: Ehr_Encounter_Type_Aggregate;
  /** fetch data from the table: "ehr_encounter_type" using primary key columns */
  ehr_encounter_type_by_pk?: Maybe<Ehr_Encounter_Type>;
  /** fetch data from the table: "ehr_fda_product" */
  ehr_fda_product: Array<Ehr_Fda_Product>;
  /** fetch aggregated fields from the table: "ehr_fda_product" */
  ehr_fda_product_aggregate: Ehr_Fda_Product_Aggregate;
  /** fetch data from the table: "ehr_fda_product" using primary key columns */
  ehr_fda_product_by_pk?: Maybe<Ehr_Fda_Product>;
  /** fetch data from the table: "ehr_fda_product_source" */
  ehr_fda_product_source: Array<Ehr_Fda_Product_Source>;
  /** fetch aggregated fields from the table: "ehr_fda_product_source" */
  ehr_fda_product_source_aggregate: Ehr_Fda_Product_Source_Aggregate;
  /** fetch data from the table: "ehr_fda_product_source" using primary key columns */
  ehr_fda_product_source_by_pk?: Maybe<Ehr_Fda_Product_Source>;
  /** fetch data from the table: "ehr_message" */
  ehr_message: Array<Ehr_Message>;
  /** fetch aggregated fields from the table: "ehr_message" */
  ehr_message_aggregate: Ehr_Message_Aggregate;
  /** fetch data from the table: "ehr_message" using primary key columns */
  ehr_message_by_pk?: Maybe<Ehr_Message>;
  /** fetch data from the table: "ehr_message_read" */
  ehr_message_read: Array<Ehr_Message_Read>;
  /** fetch aggregated fields from the table: "ehr_message_read" */
  ehr_message_read_aggregate: Ehr_Message_Read_Aggregate;
  /** fetch data from the table: "ehr_message_read" using primary key columns */
  ehr_message_read_by_pk?: Maybe<Ehr_Message_Read>;
  /** fetch data from the table: "ehr_message_threads" */
  ehr_message_threads: Array<Ehr_Message_Threads>;
  /** fetch aggregated fields from the table: "ehr_message_threads" */
  ehr_message_threads_aggregate: Ehr_Message_Threads_Aggregate;
  /** fetch data from the table: "ehr_message_threads" using primary key columns */
  ehr_message_threads_by_pk?: Maybe<Ehr_Message_Threads>;
  /** fetch data from the table: "ehr_patient_card" */
  ehr_patient_card: Array<Ehr_Patient_Card>;
  /** fetch aggregated fields from the table: "ehr_patient_card" */
  ehr_patient_card_aggregate: Ehr_Patient_Card_Aggregate;
  /** fetch data from the table: "ehr_patient_card" using primary key columns */
  ehr_patient_card_by_pk?: Maybe<Ehr_Patient_Card>;
  /** fetch data from the table: "ehr_patient_consent" */
  ehr_patient_consent: Array<Ehr_Patient_Consent>;
  /** fetch data from the table: "ehr_patient_consent_action" */
  ehr_patient_consent_action: Array<Ehr_Patient_Consent_Action>;
  /** fetch aggregated fields from the table: "ehr_patient_consent_action" */
  ehr_patient_consent_action_aggregate: Ehr_Patient_Consent_Action_Aggregate;
  /** fetch data from the table: "ehr_patient_consent_action" using primary key columns */
  ehr_patient_consent_action_by_pk?: Maybe<Ehr_Patient_Consent_Action>;
  /** fetch aggregated fields from the table: "ehr_patient_consent" */
  ehr_patient_consent_aggregate: Ehr_Patient_Consent_Aggregate;
  /** fetch data from the table: "ehr_patient_consent" using primary key columns */
  ehr_patient_consent_by_pk?: Maybe<Ehr_Patient_Consent>;
  /** fetch data from the table: "ehr_patient_consent_type" */
  ehr_patient_consent_type: Array<Ehr_Patient_Consent_Type>;
  /** fetch aggregated fields from the table: "ehr_patient_consent_type" */
  ehr_patient_consent_type_aggregate: Ehr_Patient_Consent_Type_Aggregate;
  /** fetch data from the table: "ehr_patient_consent_type" using primary key columns */
  ehr_patient_consent_type_by_pk?: Maybe<Ehr_Patient_Consent_Type>;
  /** fetch data from the table: "ehr_procedure" */
  ehr_procedure: Array<Ehr_Procedure>;
  /** fetch aggregated fields from the table: "ehr_procedure" */
  ehr_procedure_aggregate: Ehr_Procedure_Aggregate;
  /** fetch data from the table: "ehr_procedure_body_area" */
  ehr_procedure_body_area: Array<Ehr_Procedure_Body_Area>;
  /** fetch aggregated fields from the table: "ehr_procedure_body_area" */
  ehr_procedure_body_area_aggregate: Ehr_Procedure_Body_Area_Aggregate;
  /** fetch data from the table: "ehr_procedure_body_area" using primary key columns */
  ehr_procedure_body_area_by_pk?: Maybe<Ehr_Procedure_Body_Area>;
  /** fetch data from the table: "ehr_procedure_body_part" */
  ehr_procedure_body_part: Array<Ehr_Procedure_Body_Part>;
  /** fetch aggregated fields from the table: "ehr_procedure_body_part" */
  ehr_procedure_body_part_aggregate: Ehr_Procedure_Body_Part_Aggregate;
  /** fetch data from the table: "ehr_procedure_body_part" using primary key columns */
  ehr_procedure_body_part_by_pk?: Maybe<Ehr_Procedure_Body_Part>;
  /** fetch data from the table: "ehr_procedure_body_part_provider_injection_default" */
  ehr_procedure_body_part_provider_injection_default: Array<Ehr_Procedure_Body_Part_Provider_Injection_Default>;
  /** fetch aggregated fields from the table: "ehr_procedure_body_part_provider_injection_default" */
  ehr_procedure_body_part_provider_injection_default_aggregate: Ehr_Procedure_Body_Part_Provider_Injection_Default_Aggregate;
  /** fetch data from the table: "ehr_procedure_body_part_provider_injection_default" using primary key columns */
  ehr_procedure_body_part_provider_injection_default_by_pk?: Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default>;
  /** fetch data from the table: "ehr_procedure" using primary key columns */
  ehr_procedure_by_pk?: Maybe<Ehr_Procedure>;
  /** fetch data from the table: "ehr_procedure_ehr_product" */
  ehr_procedure_ehr_product: Array<Ehr_Procedure_Ehr_Product>;
  /** fetch aggregated fields from the table: "ehr_procedure_ehr_product" */
  ehr_procedure_ehr_product_aggregate: Ehr_Procedure_Ehr_Product_Aggregate;
  /** fetch data from the table: "ehr_procedure_ehr_product" using primary key columns */
  ehr_procedure_ehr_product_by_pk?: Maybe<Ehr_Procedure_Ehr_Product>;
  /** fetch data from the table: "ehr_procedure_type_enum" */
  ehr_procedure_type_enum: Array<Ehr_Procedure_Type_Enum>;
  /** fetch aggregated fields from the table: "ehr_procedure_type_enum" */
  ehr_procedure_type_enum_aggregate: Ehr_Procedure_Type_Enum_Aggregate;
  /** fetch data from the table: "ehr_procedure_type_enum" using primary key columns */
  ehr_procedure_type_enum_by_pk?: Maybe<Ehr_Procedure_Type_Enum>;
  /** fetch data from the table: "ehr_product" */
  ehr_product: Array<Ehr_Product>;
  /** fetch aggregated fields from the table: "ehr_product" */
  ehr_product_aggregate: Ehr_Product_Aggregate;
  /** fetch data from the table: "ehr_product" using primary key columns */
  ehr_product_by_pk?: Maybe<Ehr_Product>;
  /** fetch data from the table: "ehr_product_procedure" */
  ehr_product_procedure: Array<Ehr_Product_Procedure>;
  /** fetch aggregated fields from the table: "ehr_product_procedure" */
  ehr_product_procedure_aggregate: Ehr_Product_Procedure_Aggregate;
  /** fetch data from the table: "ehr_product_procedure" using primary key columns */
  ehr_product_procedure_by_pk?: Maybe<Ehr_Product_Procedure>;
  /** fetch data from the table: "ehr_product_provider_usage_record_photo" */
  ehr_product_provider_usage_record_photo: Array<Ehr_Product_Provider_Usage_Record_Photo>;
  /** fetch aggregated fields from the table: "ehr_product_provider_usage_record_photo" */
  ehr_product_provider_usage_record_photo_aggregate: Ehr_Product_Provider_Usage_Record_Photo_Aggregate;
  /** fetch data from the table: "ehr_product_provider_usage_record_photo" using primary key columns */
  ehr_product_provider_usage_record_photo_by_pk?: Maybe<Ehr_Product_Provider_Usage_Record_Photo>;
  /** fetch data from the table: "ehr_subscription" */
  ehr_subscription: Array<Ehr_Subscription>;
  /** fetch aggregated fields from the table: "ehr_subscription" */
  ehr_subscription_aggregate: Ehr_Subscription_Aggregate;
  /** fetch data from the table: "ehr_subscription" using primary key columns */
  ehr_subscription_by_pk?: Maybe<Ehr_Subscription>;
  /** fetch data from the table: "ehr_subscription_status" */
  ehr_subscription_status: Array<Ehr_Subscription_Status>;
  /** fetch aggregated fields from the table: "ehr_subscription_status" */
  ehr_subscription_status_aggregate: Ehr_Subscription_Status_Aggregate;
  /** fetch data from the table: "ehr_subscription_status" using primary key columns */
  ehr_subscription_status_by_pk?: Maybe<Ehr_Subscription_Status>;
  /** fetch data from the table: "ehr_subscription_tier" */
  ehr_subscription_tier: Array<Ehr_Subscription_Tier>;
  /** fetch aggregated fields from the table: "ehr_subscription_tier" */
  ehr_subscription_tier_aggregate: Ehr_Subscription_Tier_Aggregate;
  /** fetch data from the table: "ehr_subscription_tier" using primary key columns */
  ehr_subscription_tier_by_pk?: Maybe<Ehr_Subscription_Tier>;
  /** fetch data from the table: "ehr_subscription_tier_term" */
  ehr_subscription_tier_term: Array<Ehr_Subscription_Tier_Term>;
  /** fetch aggregated fields from the table: "ehr_subscription_tier_term" */
  ehr_subscription_tier_term_aggregate: Ehr_Subscription_Tier_Term_Aggregate;
  /** fetch data from the table: "ehr_subscription_tier_term" using primary key columns */
  ehr_subscription_tier_term_by_pk?: Maybe<Ehr_Subscription_Tier_Term>;
  /** fetch data from the table: "event" */
  event: Array<Event>;
  /** fetch aggregated fields from the table: "event" */
  event_aggregate: Event_Aggregate;
  /** fetch data from the table: "event" using primary key columns */
  event_by_pk?: Maybe<Event>;
  /** fetch data from the table: "event_source" */
  event_source: Array<Event_Source>;
  /** fetch aggregated fields from the table: "event_source" */
  event_source_aggregate: Event_Source_Aggregate;
  /** fetch data from the table: "event_source" using primary key columns */
  event_source_by_pk?: Maybe<Event_Source>;
  /** fetch data from the table: "filler_procedure_delivery_tool" */
  filler_procedure_delivery_tool: Array<Filler_Procedure_Delivery_Tool>;
  /** fetch aggregated fields from the table: "filler_procedure_delivery_tool" */
  filler_procedure_delivery_tool_aggregate: Filler_Procedure_Delivery_Tool_Aggregate;
  /** fetch data from the table: "filler_procedure_delivery_tool" using primary key columns */
  filler_procedure_delivery_tool_by_pk?: Maybe<Filler_Procedure_Delivery_Tool>;
  /** fetch data from the table: "filler_procedure_face_view" */
  filler_procedure_face_view: Array<Filler_Procedure_Face_View>;
  /** fetch aggregated fields from the table: "filler_procedure_face_view" */
  filler_procedure_face_view_aggregate: Filler_Procedure_Face_View_Aggregate;
  /** fetch data from the table: "filler_procedure_face_view" using primary key columns */
  filler_procedure_face_view_by_pk?: Maybe<Filler_Procedure_Face_View>;
  /** fetch data from the table: "filler_procedure_injection" */
  filler_procedure_injection: Array<Filler_Procedure_Injection>;
  /** fetch aggregated fields from the table: "filler_procedure_injection" */
  filler_procedure_injection_aggregate: Filler_Procedure_Injection_Aggregate;
  /** fetch data from the table: "filler_procedure_injection" using primary key columns */
  filler_procedure_injection_by_pk?: Maybe<Filler_Procedure_Injection>;
  /** fetch data from the table: "filler_procedure_injection_type" */
  filler_procedure_injection_type: Array<Filler_Procedure_Injection_Type>;
  /** fetch aggregated fields from the table: "filler_procedure_injection_type" */
  filler_procedure_injection_type_aggregate: Filler_Procedure_Injection_Type_Aggregate;
  /** fetch data from the table: "filler_procedure_injection_type" using primary key columns */
  filler_procedure_injection_type_by_pk?: Maybe<Filler_Procedure_Injection_Type>;
  /** fetch data from the table: "filler_procedure_product_instance" */
  filler_procedure_product_instance: Array<Filler_Procedure_Product_Instance>;
  /** fetch aggregated fields from the table: "filler_procedure_product_instance" */
  filler_procedure_product_instance_aggregate: Filler_Procedure_Product_Instance_Aggregate;
  /** fetch data from the table: "filler_procedure_product_instance" using primary key columns */
  filler_procedure_product_instance_by_pk?: Maybe<Filler_Procedure_Product_Instance>;
  /** fetch data from the table: "filler_procedure_product_instance_photo" */
  filler_procedure_product_instance_photo: Array<Filler_Procedure_Product_Instance_Photo>;
  /** fetch aggregated fields from the table: "filler_procedure_product_instance_photo" */
  filler_procedure_product_instance_photo_aggregate: Filler_Procedure_Product_Instance_Photo_Aggregate;
  /** fetch data from the table: "filler_procedure_product_instance_photo" using primary key columns */
  filler_procedure_product_instance_photo_by_pk?: Maybe<Filler_Procedure_Product_Instance_Photo>;
  /** fetch data from the table: "filler_space" */
  filler_space: Array<Filler_Space>;
  /** fetch aggregated fields from the table: "filler_space" */
  filler_space_aggregate: Filler_Space_Aggregate;
  /** fetch data from the table: "filler_space" using primary key columns */
  filler_space_by_pk?: Maybe<Filler_Space>;
  /** fetch data from the table: "filler_zone_release" */
  filler_zone_release: Array<Filler_Zone_Release>;
  /** fetch aggregated fields from the table: "filler_zone_release" */
  filler_zone_release_aggregate: Filler_Zone_Release_Aggregate;
  /** fetch data from the table: "filler_zone_release" using primary key columns */
  filler_zone_release_by_pk?: Maybe<Filler_Zone_Release>;
  /** fetch data from the table: "fn_check_proposed_patient_booking_for_stacking" */
  fn_check_proposed_patient_booking_for_stacking: Array<Fn_Check_Proposed_Patient_Booking_For_Stacking>;
  /** fetch aggregated fields from the table: "fn_check_proposed_patient_booking_for_stacking" */
  fn_check_proposed_patient_booking_for_stacking_aggregate: Fn_Check_Proposed_Patient_Booking_For_Stacking_Aggregate;
  /** fetch data from the table: "fn_check_proposed_patient_booking_for_stacking" using primary key columns */
  fn_check_proposed_patient_booking_for_stacking_by_pk?: Maybe<Fn_Check_Proposed_Patient_Booking_For_Stacking>;
  /** fetch data from the table: "fn_get_active_notification_preferences_for_type_and_location" */
  fn_get_active_notification_preferences_for_type_and_location: Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location>;
  /** fetch aggregated fields from the table: "fn_get_active_notification_preferences_for_type_and_location" */
  fn_get_active_notification_preferences_for_type_and_location_aggregate: Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Aggregate;
  /** fetch data from the table: "fn_get_active_notification_preferences_for_type_and_location" using primary key columns */
  fn_get_active_notification_preferences_for_type_and_location_by_pk?: Maybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location>;
  /** fetch data from the table: "fn_get_active_subscribers_query" */
  fn_get_active_subscribers_query: Array<Fn_Get_Active_Subscribers_Query>;
  /** fetch aggregated fields from the table: "fn_get_active_subscribers_query" */
  fn_get_active_subscribers_query_aggregate: Fn_Get_Active_Subscribers_Query_Aggregate;
  /** fetch data from the table: "fn_get_active_subscribers_query" using primary key columns */
  fn_get_active_subscribers_query_by_pk?: Maybe<Fn_Get_Active_Subscribers_Query>;
  /** fetch data from the table: "fn_get_location_purchases_to_provider_purchases_query" */
  fn_get_location_purchases_to_provider_purchases_query: Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query>;
  /** fetch aggregated fields from the table: "fn_get_location_purchases_to_provider_purchases_query" */
  fn_get_location_purchases_to_provider_purchases_query_aggregate: Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Aggregate;
  /** fetch data from the table: "fn_get_location_purchases_to_provider_purchases_query" using primary key columns */
  fn_get_location_purchases_to_provider_purchases_query_by_pk?: Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query>;
  /** fetch data from the table: "fn_get_stackable_booking_options_data" */
  fn_get_stackable_booking_options_data: Array<Fn_Get_Stackable_Booking_Options_Data>;
  /** fetch aggregated fields from the table: "fn_get_stackable_booking_options_data" */
  fn_get_stackable_booking_options_data_aggregate: Fn_Get_Stackable_Booking_Options_Data_Aggregate;
  /** fetch data from the table: "fn_get_stackable_booking_options_data" using primary key columns */
  fn_get_stackable_booking_options_data_by_pk?: Maybe<Fn_Get_Stackable_Booking_Options_Data>;
  /** fetch data from the table: "fn_get_user_booking_options_blockers" */
  fn_get_user_booking_options_blockers: Array<Fn_Get_User_Booking_Options_Blockers>;
  /** fetch aggregated fields from the table: "fn_get_user_booking_options_blockers" */
  fn_get_user_booking_options_blockers_aggregate: Fn_Get_User_Booking_Options_Blockers_Aggregate;
  /** fetch data from the table: "fn_get_user_booking_options_blockers" using primary key columns */
  fn_get_user_booking_options_blockers_by_pk?: Maybe<Fn_Get_User_Booking_Options_Blockers>;
  /** fetch data from the table: "fn_get_user_location_procedure_unavailable_rooms" */
  fn_get_user_location_procedure_unavailable_rooms: Array<Fn_Get_User_Location_Procedure_Unavailable_Rooms>;
  /** fetch aggregated fields from the table: "fn_get_user_location_procedure_unavailable_rooms" */
  fn_get_user_location_procedure_unavailable_rooms_aggregate: Fn_Get_User_Location_Procedure_Unavailable_Rooms_Aggregate;
  /** fetch data from the table: "fn_get_user_location_procedure_unavailable_rooms" using primary key columns */
  fn_get_user_location_procedure_unavailable_rooms_by_pk?: Maybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms>;
  /** fetch data from the table: "fn_get_user_products_to_rentals_query" */
  fn_get_user_products_to_rentals_query: Array<Fn_Get_User_Products_To_Rentals_Query>;
  /** fetch aggregated fields from the table: "fn_get_user_products_to_rentals_query" */
  fn_get_user_products_to_rentals_query_aggregate: Fn_Get_User_Products_To_Rentals_Query_Aggregate;
  /** fetch data from the table: "fn_get_user_products_to_rentals_query" using primary key columns */
  fn_get_user_products_to_rentals_query_by_pk?: Maybe<Fn_Get_User_Products_To_Rentals_Query>;
  /** fetch data from the table: "fn_users_unfulfilled_product_purchases_count_by_location" */
  fn_users_unfulfilled_product_purchases_count_by_location: Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location>;
  /** fetch aggregated fields from the table: "fn_users_unfulfilled_product_purchases_count_by_location" */
  fn_users_unfulfilled_product_purchases_count_by_location_aggregate: Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Aggregate;
  /** fetch data from the table: "fn_users_unfulfilled_product_purchases_count_by_location" using primary key columns */
  fn_users_unfulfilled_product_purchases_count_by_location_by_pk?: Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location>;
  /** fetch data from the table: "gender" */
  gender: Array<Gender>;
  /** fetch aggregated fields from the table: "gender" */
  gender_aggregate: Gender_Aggregate;
  /** fetch data from the table: "gender" using primary key columns */
  gender_by_pk?: Maybe<Gender>;
  getBillingReport: BillingReportOutput;
  getBookingInvoiceLineItems: Array<LineItem>;
  getCognitoUser?: Maybe<GetCognitoUserOutput>;
  getDownloadDocumentUrl: Array<GetDownloadDocumentUrlOutputItem>;
  /** getInvoiceReport */
  getFinancialReport: FinancialReportOutput;
  getHostedInvoiceUrl: GetHostedInvoiceUrlOutput;
  /** For the given patient and procedure, return all the templates whose status is relevant for whether the patient is ready for the procedure. */
  getPatientTemplates: GetPatientTemplatesOutput;
  getPaymentMethods: Array<GetPaymentMethodsOutput>;
  getProductPurchaseLineItems: Array<LineItem>;
  /** GetSquareOauthLinkUrl */
  getSquareOauthLinkUrl: GetSquareOauthLinkUrlResponse;
  getUploadDocumentUrl?: Maybe<Array<Maybe<GetUploadDocumentUrlOutputItem>>>;
  getUploadPhotoUrl: Array<GetUploadPhotoUrlOutput>;
  /** execute function "get_active_notification_preferences_for_type_and_location" which returns "fn_get_active_notification_preferences_for_type_and_location" */
  get_active_notification_preferences_for_type_and_location: Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location>;
  /** execute function "get_active_notification_preferences_for_type_and_location" and query aggregates on result of table type "fn_get_active_notification_preferences_for_type_and_location" */
  get_active_notification_preferences_for_type_and_location_aggregate: Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Aggregate;
  /** execute function "get_active_notification_preferences_for_type_any_location" which returns "fn_get_active_notification_preferences_for_type_and_location" */
  get_active_notification_preferences_for_type_any_location: Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location>;
  /** execute function "get_active_notification_preferences_for_type_any_location" and query aggregates on result of table type "fn_get_active_notification_preferences_for_type_and_location" */
  get_active_notification_preferences_for_type_any_location_aggregate: Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Aggregate;
  /** execute function "get_active_subscribers_query" which returns "fn_get_active_subscribers_query" */
  get_active_subscribers_query: Array<Fn_Get_Active_Subscribers_Query>;
  /** execute function "get_active_subscribers_query" and query aggregates on result of table type "fn_get_active_subscribers_query" */
  get_active_subscribers_query_aggregate: Fn_Get_Active_Subscribers_Query_Aggregate;
  /** execute function "get_cumulative_location_plans" which returns "plan" */
  get_cumulative_location_plans: Array<Plan>;
  /** execute function "get_cumulative_location_plans" and query aggregates on result of table type "plan" */
  get_cumulative_location_plans_aggregate: Plan_Aggregate;
  /** execute function "get_location_purchases_to_provider_purchases_query" which returns "fn_get_location_purchases_to_provider_purchases_query" */
  get_location_purchases_to_provider_purchases_query: Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query>;
  /** execute function "get_location_purchases_to_provider_purchases_query" and query aggregates on result of table type "fn_get_location_purchases_to_provider_purchases_query" */
  get_location_purchases_to_provider_purchases_query_aggregate: Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Aggregate;
  /** execute function "get_stackable_booking_options_data" which returns "fn_get_stackable_booking_options_data" */
  get_stackable_booking_options_data: Array<Fn_Get_Stackable_Booking_Options_Data>;
  /** execute function "get_stackable_booking_options_data" and query aggregates on result of table type "fn_get_stackable_booking_options_data" */
  get_stackable_booking_options_data_aggregate: Fn_Get_Stackable_Booking_Options_Data_Aggregate;
  /** execute function "get_user_booking_options_blockers" which returns "fn_get_user_booking_options_blockers" */
  get_user_booking_options_blockers: Array<Fn_Get_User_Booking_Options_Blockers>;
  /** execute function "get_user_booking_options_blockers" and query aggregates on result of table type "fn_get_user_booking_options_blockers" */
  get_user_booking_options_blockers_aggregate: Fn_Get_User_Booking_Options_Blockers_Aggregate;
  /** execute function "get_user_products_to_rentals_query" which returns "fn_get_user_products_to_rentals_query" */
  get_user_products_to_rentals_query: Array<Fn_Get_User_Products_To_Rentals_Query>;
  /** execute function "get_user_products_to_rentals_query" and query aggregates on result of table type "fn_get_user_products_to_rentals_query" */
  get_user_products_to_rentals_query_aggregate: Fn_Get_User_Products_To_Rentals_Query_Aggregate;
  /** fetch data from the table: "invoice" */
  invoice: Array<Invoice>;
  /** fetch aggregated fields from the table: "invoice" */
  invoice_aggregate: Invoice_Aggregate;
  /** fetch data from the table: "invoice_billing_summary" */
  invoice_billing_summary: Array<Invoice_Billing_Summary>;
  /** fetch aggregated fields from the table: "invoice_billing_summary" */
  invoice_billing_summary_aggregate: Invoice_Billing_Summary_Aggregate;
  /** fetch data from the table: "invoice" using primary key columns */
  invoice_by_pk?: Maybe<Invoice>;
  /** fetch data from the table: "location" */
  location: Array<Location>;
  /** fetch aggregated fields from the table: "location" */
  location_aggregate: Location_Aggregate;
  /** fetch data from the table: "location" using primary key columns */
  location_by_pk?: Maybe<Location>;
  /** fetch data from the table: "location_procedure" */
  location_procedure: Array<Location_Procedure>;
  /** fetch aggregated fields from the table: "location_procedure" */
  location_procedure_aggregate: Location_Procedure_Aggregate;
  /** fetch data from the table: "location_procedure" using primary key columns */
  location_procedure_by_pk?: Maybe<Location_Procedure>;
  /** fetch data from the table: "location_procedure_room" */
  location_procedure_room: Array<Location_Procedure_Room>;
  /** fetch aggregated fields from the table: "location_procedure_room" */
  location_procedure_room_aggregate: Location_Procedure_Room_Aggregate;
  /** fetch data from the table: "location_procedure_room" using primary key columns */
  location_procedure_room_by_pk?: Maybe<Location_Procedure_Room>;
  /** fetch data from the table: "location_product" */
  location_product: Array<Location_Product>;
  /** fetch aggregated fields from the table: "location_product" */
  location_product_aggregate: Location_Product_Aggregate;
  /** fetch data from the table: "location_product" using primary key columns */
  location_product_by_pk?: Maybe<Location_Product>;
  /** fetch data from the table: "model" */
  model: Array<Model>;
  /** fetch aggregated fields from the table: "model" */
  model_aggregate: Model_Aggregate;
  /** fetch data from the table: "model" using primary key columns */
  model_by_pk?: Maybe<Model>;
  /** fetch data from the table: "model_count" */
  model_count: Array<Model_Count>;
  /** fetch aggregated fields from the table: "model_count" */
  model_count_aggregate: Model_Count_Aggregate;
  /** fetch data from the table: "model_count" using primary key columns */
  model_count_by_pk?: Maybe<Model_Count>;
  /** fetch data from the table: "model_product" */
  model_product: Array<Model_Product>;
  /** fetch aggregated fields from the table: "model_product" */
  model_product_aggregate: Model_Product_Aggregate;
  /** fetch data from the table: "model_product" using primary key columns */
  model_product_by_pk?: Maybe<Model_Product>;
  /** fetch data from the table: "mso_mode" */
  mso_mode: Array<Mso_Mode>;
  /** fetch aggregated fields from the table: "mso_mode" */
  mso_mode_aggregate: Mso_Mode_Aggregate;
  /** fetch data from the table: "mso_mode" using primary key columns */
  mso_mode_by_pk?: Maybe<Mso_Mode>;
  /** fetch data from the table: "mso_tier" */
  mso_tier: Array<Mso_Tier>;
  /** fetch aggregated fields from the table: "mso_tier" */
  mso_tier_aggregate: Mso_Tier_Aggregate;
  /** fetch data from the table: "mso_tier" using primary key columns */
  mso_tier_by_pk?: Maybe<Mso_Tier>;
  /** fetch data from the table: "notification_audit_log" */
  notification_audit_log: Array<Notification_Audit_Log>;
  /** fetch aggregated fields from the table: "notification_audit_log" */
  notification_audit_log_aggregate: Notification_Audit_Log_Aggregate;
  /** fetch data from the table: "notification_audit_log" using primary key columns */
  notification_audit_log_by_pk?: Maybe<Notification_Audit_Log>;
  /** fetch data from the table: "notification_broadcast_type" */
  notification_broadcast_type: Array<Notification_Broadcast_Type>;
  /** fetch aggregated fields from the table: "notification_broadcast_type" */
  notification_broadcast_type_aggregate: Notification_Broadcast_Type_Aggregate;
  /** fetch data from the table: "notification_broadcast_type" using primary key columns */
  notification_broadcast_type_by_pk?: Maybe<Notification_Broadcast_Type>;
  /** fetch data from the table: "notification_channel" */
  notification_channel: Array<Notification_Channel>;
  /** fetch aggregated fields from the table: "notification_channel" */
  notification_channel_aggregate: Notification_Channel_Aggregate;
  /** fetch data from the table: "notification_channel" using primary key columns */
  notification_channel_by_pk?: Maybe<Notification_Channel>;
  /** fetch data from the table: "notification_preference" */
  notification_preference: Array<Notification_Preference>;
  /** fetch aggregated fields from the table: "notification_preference" */
  notification_preference_aggregate: Notification_Preference_Aggregate;
  /** fetch data from the table: "notification_preference" using primary key columns */
  notification_preference_by_pk?: Maybe<Notification_Preference>;
  /** fetch data from the table: "notification_type" */
  notification_type: Array<Notification_Type>;
  /** fetch aggregated fields from the table: "notification_type" */
  notification_type_aggregate: Notification_Type_Aggregate;
  /** fetch data from the table: "notification_type" using primary key columns */
  notification_type_by_pk?: Maybe<Notification_Type>;
  /** fetch data from the table: "notification_type_default_channel" */
  notification_type_default_channel: Array<Notification_Type_Default_Channel>;
  /** fetch aggregated fields from the table: "notification_type_default_channel" */
  notification_type_default_channel_aggregate: Notification_Type_Default_Channel_Aggregate;
  /** fetch data from the table: "notification_type_default_channel" using primary key columns */
  notification_type_default_channel_by_pk?: Maybe<Notification_Type_Default_Channel>;
  /** fetch data from the table: "open" */
  open: Array<Open>;
  /** fetch aggregated fields from the table: "open" */
  open_aggregate: Open_Aggregate;
  /** fetch data from the table: "open" using primary key columns */
  open_by_pk?: Maybe<Open>;
  /** fetch data from the table: "partner" */
  partner: Array<Partner>;
  /** fetch aggregated fields from the table: "partner" */
  partner_aggregate: Partner_Aggregate;
  /** fetch data from the table: "partner_basic" */
  partner_basic: Array<Partner_Basic>;
  /** fetch aggregated fields from the table: "partner_basic" */
  partner_basic_aggregate: Partner_Basic_Aggregate;
  /** fetch data from the table: "partner" using primary key columns */
  partner_by_pk?: Maybe<Partner>;
  /** fetch data from the table: "patient" */
  patient: Array<Patient>;
  /** fetch data from the table: "patient_account_event" */
  patient_account_event: Array<Patient_Account_Event>;
  /** fetch aggregated fields from the table: "patient_account_event" */
  patient_account_event_aggregate: Patient_Account_Event_Aggregate;
  /** fetch data from the table: "patient_account_event" using primary key columns */
  patient_account_event_by_pk?: Maybe<Patient_Account_Event>;
  /** fetch data from the table: "patient_account_event_type" */
  patient_account_event_type: Array<Patient_Account_Event_Type>;
  /** fetch aggregated fields from the table: "patient_account_event_type" */
  patient_account_event_type_aggregate: Patient_Account_Event_Type_Aggregate;
  /** fetch data from the table: "patient_account_event_type" using primary key columns */
  patient_account_event_type_by_pk?: Maybe<Patient_Account_Event_Type>;
  /** fetch aggregated fields from the table: "patient" */
  patient_aggregate: Patient_Aggregate;
  /** fetch data from the table: "patient_auth_challenge" */
  patient_auth_challenge: Array<Patient_Auth_Challenge>;
  /** fetch aggregated fields from the table: "patient_auth_challenge" */
  patient_auth_challenge_aggregate: Patient_Auth_Challenge_Aggregate;
  /** fetch data from the table: "patient_auth_challenge" using primary key columns */
  patient_auth_challenge_by_pk?: Maybe<Patient_Auth_Challenge>;
  /** fetch data from the table: "patient_bookable_ehr_procedure" */
  patient_bookable_ehr_procedure: Array<Patient_Bookable_Ehr_Procedure>;
  /** fetch aggregated fields from the table: "patient_bookable_ehr_procedure" */
  patient_bookable_ehr_procedure_aggregate: Patient_Bookable_Ehr_Procedure_Aggregate;
  /** fetch data from the table: "patient_bookable_ehr_procedure" using primary key columns */
  patient_bookable_ehr_procedure_by_pk?: Maybe<Patient_Bookable_Ehr_Procedure>;
  /** fetch data from the table: "patient_booking" */
  patient_booking: Array<Patient_Booking>;
  /** fetch aggregated fields from the table: "patient_booking" */
  patient_booking_aggregate: Patient_Booking_Aggregate;
  /** fetch data from the table: "patient_booking_booking" */
  patient_booking_booking: Array<Patient_Booking_Booking>;
  /** fetch aggregated fields from the table: "patient_booking_booking" */
  patient_booking_booking_aggregate: Patient_Booking_Booking_Aggregate;
  /** fetch data from the table: "patient_booking_booking" using primary key columns */
  patient_booking_booking_by_pk?: Maybe<Patient_Booking_Booking>;
  /** fetch data from the table: "patient_booking" using primary key columns */
  patient_booking_by_pk?: Maybe<Patient_Booking>;
  /** fetch data from the table: "patient_booking_cancel_reason" */
  patient_booking_cancel_reason: Array<Patient_Booking_Cancel_Reason>;
  /** fetch aggregated fields from the table: "patient_booking_cancel_reason" */
  patient_booking_cancel_reason_aggregate: Patient_Booking_Cancel_Reason_Aggregate;
  /** fetch data from the table: "patient_booking_cancel_reason" using primary key columns */
  patient_booking_cancel_reason_by_pk?: Maybe<Patient_Booking_Cancel_Reason>;
  /** fetch data from the table: "patient_booking_initiator" */
  patient_booking_initiator: Array<Patient_Booking_Initiator>;
  /** fetch aggregated fields from the table: "patient_booking_initiator" */
  patient_booking_initiator_aggregate: Patient_Booking_Initiator_Aggregate;
  /** fetch data from the table: "patient_booking_initiator" using primary key columns */
  patient_booking_initiator_by_pk?: Maybe<Patient_Booking_Initiator>;
  /** fetch data from the table: "patient_booking_metadata" */
  patient_booking_metadata: Array<Patient_Booking_Metadata>;
  /** fetch aggregated fields from the table: "patient_booking_metadata" */
  patient_booking_metadata_aggregate: Patient_Booking_Metadata_Aggregate;
  /** fetch data from the table: "patient_booking_metadata" using primary key columns */
  patient_booking_metadata_by_pk?: Maybe<Patient_Booking_Metadata>;
  /** fetch data from the table: "patient" using primary key columns */
  patient_by_pk?: Maybe<Patient>;
  /** fetch data from the table: "patient_last_view" */
  patient_last_view: Array<Patient_Last_View>;
  /** fetch aggregated fields from the table: "patient_last_view" */
  patient_last_view_aggregate: Patient_Last_View_Aggregate;
  /** fetch data from the table: "patient_last_view" using primary key columns */
  patient_last_view_by_pk?: Maybe<Patient_Last_View>;
  /** fetch data from the table: "patient_medical_profile" */
  patient_medical_profile: Array<Patient_Medical_Profile>;
  /** fetch aggregated fields from the table: "patient_medical_profile" */
  patient_medical_profile_aggregate: Patient_Medical_Profile_Aggregate;
  /** fetch data from the table: "patient_medical_profile" using primary key columns */
  patient_medical_profile_by_pk?: Maybe<Patient_Medical_Profile>;
  /** fetch data from the table: "patient_registration_invite" */
  patient_registration_invite: Array<Patient_Registration_Invite>;
  /** fetch aggregated fields from the table: "patient_registration_invite" */
  patient_registration_invite_aggregate: Patient_Registration_Invite_Aggregate;
  /** fetch data from the table: "patient_registration_invite" using primary key columns */
  patient_registration_invite_by_pk?: Maybe<Patient_Registration_Invite>;
  /** fetch data from the table: "patient_session" */
  patient_session: Array<Patient_Session>;
  /** fetch aggregated fields from the table: "patient_session" */
  patient_session_aggregate: Patient_Session_Aggregate;
  /** fetch data from the table: "patient_session" using primary key columns */
  patient_session_by_pk?: Maybe<Patient_Session>;
  /** fetch data from the table: "patient_webauthn_challenge" */
  patient_webauthn_challenge: Array<Patient_Webauthn_Challenge>;
  /** fetch aggregated fields from the table: "patient_webauthn_challenge" */
  patient_webauthn_challenge_aggregate: Patient_Webauthn_Challenge_Aggregate;
  /** fetch data from the table: "patient_webauthn_challenge" using primary key columns */
  patient_webauthn_challenge_by_pk?: Maybe<Patient_Webauthn_Challenge>;
  /** fetch data from the table: "patient_webauthn_credential" */
  patient_webauthn_credential: Array<Patient_Webauthn_Credential>;
  /** fetch aggregated fields from the table: "patient_webauthn_credential" */
  patient_webauthn_credential_aggregate: Patient_Webauthn_Credential_Aggregate;
  /** fetch data from the table: "patient_webauthn_credential" using primary key columns */
  patient_webauthn_credential_by_pk?: Maybe<Patient_Webauthn_Credential>;
  /** fetch data from the table: "plan" */
  plan: Array<Plan>;
  /** fetch aggregated fields from the table: "plan" */
  plan_aggregate: Plan_Aggregate;
  /** fetch data from the table: "plan" using primary key columns */
  plan_by_pk?: Maybe<Plan>;
  /** fetch data from the table: "plan_type" */
  plan_type: Array<Plan_Type>;
  /** fetch aggregated fields from the table: "plan_type" */
  plan_type_aggregate: Plan_Type_Aggregate;
  /** fetch data from the table: "plan_type" using primary key columns */
  plan_type_by_pk?: Maybe<Plan_Type>;
  /** fetch data from the table: "pre_procedure_photo_injection_marking" */
  pre_procedure_photo_injection_marking: Array<Pre_Procedure_Photo_Injection_Marking>;
  /** fetch aggregated fields from the table: "pre_procedure_photo_injection_marking" */
  pre_procedure_photo_injection_marking_aggregate: Pre_Procedure_Photo_Injection_Marking_Aggregate;
  /** fetch data from the table: "pre_procedure_photo_injection_marking" using primary key columns */
  pre_procedure_photo_injection_marking_by_pk?: Maybe<Pre_Procedure_Photo_Injection_Marking>;
  /** fetch data from the table: "procedure" */
  procedure: Array<Procedure>;
  /** fetch aggregated fields from the table: "procedure" */
  procedure_aggregate: Procedure_Aggregate;
  /** fetch data from the table: "procedure_audio_recording" */
  procedure_audio_recording: Array<Procedure_Audio_Recording>;
  /** fetch aggregated fields from the table: "procedure_audio_recording" */
  procedure_audio_recording_aggregate: Procedure_Audio_Recording_Aggregate;
  /** fetch data from the table: "procedure_audio_recording" using primary key columns */
  procedure_audio_recording_by_pk?: Maybe<Procedure_Audio_Recording>;
  /** fetch data from the table: "procedure" using primary key columns */
  procedure_by_pk?: Maybe<Procedure>;
  /** fetch data from the table: "product" */
  product: Array<Product>;
  productLookupBarcode: Array<ProductLookupBarcodeResult>;
  /** fetch aggregated fields from the table: "product" */
  product_aggregate: Product_Aggregate;
  /** fetch data from the table: "product" using primary key columns */
  product_by_pk?: Maybe<Product>;
  /** fetch data from the table: "product_purchase" */
  product_purchase: Array<Product_Purchase>;
  /** fetch aggregated fields from the table: "product_purchase" */
  product_purchase_aggregate: Product_Purchase_Aggregate;
  /** fetch data from the table: "product_purchase" using primary key columns */
  product_purchase_by_pk?: Maybe<Product_Purchase>;
  /** fetch data from the table: "product_type" */
  product_type: Array<Product_Type>;
  /** fetch aggregated fields from the table: "product_type" */
  product_type_aggregate: Product_Type_Aggregate;
  /** fetch data from the table: "product_type" using primary key columns */
  product_type_by_pk?: Maybe<Product_Type>;
  /** fetch data from the table: "provider_direct_product_purchase" */
  provider_direct_product_purchase: Array<Provider_Direct_Product_Purchase>;
  /** fetch aggregated fields from the table: "provider_direct_product_purchase" */
  provider_direct_product_purchase_aggregate: Provider_Direct_Product_Purchase_Aggregate;
  /** fetch data from the table: "provider_direct_product_purchase" using primary key columns */
  provider_direct_product_purchase_by_pk?: Maybe<Provider_Direct_Product_Purchase>;
  /** fetch data from the table: "provider_direct_purchase_web_admin_view" */
  provider_direct_purchase_web_admin_view: Array<Provider_Direct_Purchase_Web_Admin_View>;
  /** fetch aggregated fields from the table: "provider_direct_purchase_web_admin_view" */
  provider_direct_purchase_web_admin_view_aggregate: Provider_Direct_Purchase_Web_Admin_View_Aggregate;
  /** An array relationship */
  provider_hours: Array<Provider_Hours>;
  /** An aggregate relationship */
  provider_hours_aggregate: Provider_Hours_Aggregate;
  /** fetch data from the table: "provider_hours" using primary key columns */
  provider_hours_by_pk?: Maybe<Provider_Hours>;
  /** fetch data from the table: "provider_hours_repeat_interval" */
  provider_hours_repeat_interval: Array<Provider_Hours_Repeat_Interval>;
  /** fetch aggregated fields from the table: "provider_hours_repeat_interval" */
  provider_hours_repeat_interval_aggregate: Provider_Hours_Repeat_Interval_Aggregate;
  /** fetch data from the table: "provider_hours_repeat_interval" using primary key columns */
  provider_hours_repeat_interval_by_pk?: Maybe<Provider_Hours_Repeat_Interval>;
  /** fetch data from the table: "provider_hours_repeater" */
  provider_hours_repeater: Array<Provider_Hours_Repeater>;
  /** fetch aggregated fields from the table: "provider_hours_repeater" */
  provider_hours_repeater_aggregate: Provider_Hours_Repeater_Aggregate;
  /** fetch data from the table: "provider_hours_repeater" using primary key columns */
  provider_hours_repeater_by_pk?: Maybe<Provider_Hours_Repeater>;
  /** fetch data from the table: "provider_patient_booking_settings" */
  provider_patient_booking_settings: Array<Provider_Patient_Booking_Settings>;
  /** fetch aggregated fields from the table: "provider_patient_booking_settings" */
  provider_patient_booking_settings_aggregate: Provider_Patient_Booking_Settings_Aggregate;
  /** fetch data from the table: "provider_patient_booking_settings" using primary key columns */
  provider_patient_booking_settings_by_pk?: Maybe<Provider_Patient_Booking_Settings>;
  /** fetch data from the table: "provider_procedure" */
  provider_procedure: Array<Provider_Procedure>;
  /** fetch aggregated fields from the table: "provider_procedure" */
  provider_procedure_aggregate: Provider_Procedure_Aggregate;
  /** fetch data from the table: "provider_procedure" using primary key columns */
  provider_procedure_by_pk?: Maybe<Provider_Procedure>;
  /** fetch data from the table: "purchase_for_location" */
  purchase_for_location: Array<Purchase_For_Location>;
  /** fetch aggregated fields from the table: "purchase_for_location" */
  purchase_for_location_aggregate: Purchase_For_Location_Aggregate;
  /** fetch data from the table: "purchase_for_location" using primary key columns */
  purchase_for_location_by_pk?: Maybe<Purchase_For_Location>;
  /** fetch data from the table: "purchase_requests_list" */
  purchase_requests_list: Array<Purchase_Requests_List>;
  /** fetch aggregated fields from the table: "purchase_requests_list" */
  purchase_requests_list_aggregate: Purchase_Requests_List_Aggregate;
  /** fetch data from the table: "rental_volume_discount" */
  rental_volume_discount: Array<Rental_Volume_Discount>;
  /** fetch aggregated fields from the table: "rental_volume_discount" */
  rental_volume_discount_aggregate: Rental_Volume_Discount_Aggregate;
  /** fetch data from the table: "rental_volume_discount" using primary key columns */
  rental_volume_discount_by_pk?: Maybe<Rental_Volume_Discount>;
  /** fetch data from the table: "repeating" */
  repeating: Array<Repeating>;
  /** fetch aggregated fields from the table: "repeating" */
  repeating_aggregate: Repeating_Aggregate;
  /** fetch data from the table: "repeating" using primary key columns */
  repeating_by_pk?: Maybe<Repeating>;
  /** fetch data from the table: "report_preference" */
  report_preference: Array<Report_Preference>;
  /** fetch aggregated fields from the table: "report_preference" */
  report_preference_aggregate: Report_Preference_Aggregate;
  /** fetch data from the table: "report_preference" using primary key columns */
  report_preference_by_pk?: Maybe<Report_Preference>;
  /** fetch data from the table: "report_type" */
  report_type: Array<Report_Type>;
  /** fetch aggregated fields from the table: "report_type" */
  report_type_aggregate: Report_Type_Aggregate;
  /** fetch data from the table: "report_type" using primary key columns */
  report_type_by_pk?: Maybe<Report_Type>;
  /** fetch data from the table: "role" */
  role: Array<Role>;
  /** fetch aggregated fields from the table: "role" */
  role_aggregate: Role_Aggregate;
  /** fetch data from the table: "role" using primary key columns */
  role_by_pk?: Maybe<Role>;
  /** fetch data from the table: "role_notification" */
  role_notification: Array<Role_Notification>;
  /** fetch aggregated fields from the table: "role_notification" */
  role_notification_aggregate: Role_Notification_Aggregate;
  /** fetch data from the table: "role_notification" using primary key columns */
  role_notification_by_pk?: Maybe<Role_Notification>;
  /** fetch data from the table: "room" */
  room: Array<Room>;
  /** fetch aggregated fields from the table: "room" */
  room_aggregate: Room_Aggregate;
  /** fetch data from the table: "room" using primary key columns */
  room_by_pk?: Maybe<Room>;
  /** fetch data from the table: "room_model" */
  room_model: Array<Room_Model>;
  /** fetch aggregated fields from the table: "room_model" */
  room_model_aggregate: Room_Model_Aggregate;
  /** fetch data from the table: "room_model" using primary key columns */
  room_model_by_pk?: Maybe<Room_Model>;
  /** fetch data from the table: "room_type" */
  room_type: Array<Room_Type>;
  /** fetch aggregated fields from the table: "room_type" */
  room_type_aggregate: Room_Type_Aggregate;
  /** fetch data from the table: "room_type" using primary key columns */
  room_type_by_pk?: Maybe<Room_Type>;
  /** fetch data from the table: "sex" */
  sex: Array<Sex>;
  /** fetch aggregated fields from the table: "sex" */
  sex_aggregate: Sex_Aggregate;
  /** fetch data from the table: "sex" using primary key columns */
  sex_by_pk?: Maybe<Sex>;
  /** Get URL for the signed document PDF from SignWell */
  signingDocumentsGetPdf: SigningDocumentsGetPdfOutput;
  /** Get current signing fields from a template */
  signingTemplateGetFields: SigningTemplateGetFieldsOutput;
  /** Get presigned S3 URLs for template page preview images */
  signingTemplateGetPreviewUrls: SigningTemplateGetPreviewUrlsOutput;
  /** fetch data from the table: "signing_document" */
  signing_document: Array<Signing_Document>;
  /** fetch aggregated fields from the table: "signing_document" */
  signing_document_aggregate: Signing_Document_Aggregate;
  /** fetch data from the table: "signing_document" using primary key columns */
  signing_document_by_pk?: Maybe<Signing_Document>;
  /** fetch data from the table: "signing_document_status_type" */
  signing_document_status_type: Array<Signing_Document_Status_Type>;
  /** fetch aggregated fields from the table: "signing_document_status_type" */
  signing_document_status_type_aggregate: Signing_Document_Status_Type_Aggregate;
  /** fetch data from the table: "signing_document_status_type" using primary key columns */
  signing_document_status_type_by_pk?: Maybe<Signing_Document_Status_Type>;
  /** fetch data from the table: "signing_procedure_associated_documents" */
  signing_procedure_associated_documents: Array<Signing_Procedure_Associated_Documents>;
  /** fetch aggregated fields from the table: "signing_procedure_associated_documents" */
  signing_procedure_associated_documents_aggregate: Signing_Procedure_Associated_Documents_Aggregate;
  /** fetch data from the table: "signing_procedure_associated_documents" using primary key columns */
  signing_procedure_associated_documents_by_pk?: Maybe<Signing_Procedure_Associated_Documents>;
  /** fetch data from the table: "signing_template" */
  signing_template: Array<Signing_Template>;
  /** fetch aggregated fields from the table: "signing_template" */
  signing_template_aggregate: Signing_Template_Aggregate;
  /** fetch data from the table: "signing_template" using primary key columns */
  signing_template_by_pk?: Maybe<Signing_Template>;
  /** fetch data from the table: "signing_template_equivalents" */
  signing_template_equivalents: Array<Signing_Template_Equivalents>;
  /** fetch aggregated fields from the table: "signing_template_equivalents" */
  signing_template_equivalents_aggregate: Signing_Template_Equivalents_Aggregate;
  /** fetch data from the table: "signing_template_equivalents" using primary key columns */
  signing_template_equivalents_by_pk?: Maybe<Signing_Template_Equivalents>;
  /** fetch data from the table: "signing_template_kind" */
  signing_template_kind: Array<Signing_Template_Kind>;
  /** fetch aggregated fields from the table: "signing_template_kind" */
  signing_template_kind_aggregate: Signing_Template_Kind_Aggregate;
  /** fetch data from the table: "signing_template_kind" using primary key columns */
  signing_template_kind_by_pk?: Maybe<Signing_Template_Kind>;
  /** fetch data from the table: "signing_template_source_files" */
  signing_template_source_files: Array<Signing_Template_Source_Files>;
  /** fetch aggregated fields from the table: "signing_template_source_files" */
  signing_template_source_files_aggregate: Signing_Template_Source_Files_Aggregate;
  /** fetch data from the table: "signing_template_source_files" using primary key columns */
  signing_template_source_files_by_pk?: Maybe<Signing_Template_Source_Files>;
  /** fetch data from the table: "signing_vansanity_template" */
  signing_vansanity_template: Array<Signing_Vansanity_Template>;
  /** fetch aggregated fields from the table: "signing_vansanity_template" */
  signing_vansanity_template_aggregate: Signing_Vansanity_Template_Aggregate;
  /** fetch data from the table: "signing_vansanity_template" using primary key columns */
  signing_vansanity_template_by_pk?: Maybe<Signing_Vansanity_Template>;
  /** fetch data from the table: "signing_webhook_event" */
  signing_webhook_event: Array<Signing_Webhook_Event>;
  /** fetch aggregated fields from the table: "signing_webhook_event" */
  signing_webhook_event_aggregate: Signing_Webhook_Event_Aggregate;
  /** fetch data from the table: "signing_webhook_event" using primary key columns */
  signing_webhook_event_by_pk?: Maybe<Signing_Webhook_Event>;
  /** fetch data from the table: "signing_webhook_event_type" */
  signing_webhook_event_type: Array<Signing_Webhook_Event_Type>;
  /** fetch aggregated fields from the table: "signing_webhook_event_type" */
  signing_webhook_event_type_aggregate: Signing_Webhook_Event_Type_Aggregate;
  /** fetch data from the table: "signing_webhook_event_type" using primary key columns */
  signing_webhook_event_type_by_pk?: Maybe<Signing_Webhook_Event_Type>;
  /** fetch data from the table: "square_credential_ownership_enum" */
  square_credential_ownership_enum: Array<Square_Credential_Ownership_Enum>;
  /** fetch aggregated fields from the table: "square_credential_ownership_enum" */
  square_credential_ownership_enum_aggregate: Square_Credential_Ownership_Enum_Aggregate;
  /** fetch data from the table: "square_credential_ownership_enum" using primary key columns */
  square_credential_ownership_enum_by_pk?: Maybe<Square_Credential_Ownership_Enum>;
  /** fetch data from the table: "square_credentials" */
  square_credentials: Array<Square_Credentials>;
  /** fetch aggregated fields from the table: "square_credentials" */
  square_credentials_aggregate: Square_Credentials_Aggregate;
  /** fetch data from the table: "square_credentials" using primary key columns */
  square_credentials_by_pk?: Maybe<Square_Credentials>;
  /** fetch data from the table: "supervisor_provider" */
  supervisor_provider: Array<Supervisor_Provider>;
  /** fetch aggregated fields from the table: "supervisor_provider" */
  supervisor_provider_aggregate: Supervisor_Provider_Aggregate;
  /** fetch data from the table: "supervisor_provider" using primary key columns */
  supervisor_provider_by_pk?: Maybe<Supervisor_Provider>;
  /** fetch data from the table: "supervisor_provider_initiated_by" */
  supervisor_provider_initiated_by: Array<Supervisor_Provider_Initiated_By>;
  /** fetch aggregated fields from the table: "supervisor_provider_initiated_by" */
  supervisor_provider_initiated_by_aggregate: Supervisor_Provider_Initiated_By_Aggregate;
  /** fetch data from the table: "supervisor_provider_initiated_by" using primary key columns */
  supervisor_provider_initiated_by_by_pk?: Maybe<Supervisor_Provider_Initiated_By>;
  /** fetch data from the table: "supervisor_provider_term" */
  supervisor_provider_term: Array<Supervisor_Provider_Term>;
  /** fetch aggregated fields from the table: "supervisor_provider_term" */
  supervisor_provider_term_aggregate: Supervisor_Provider_Term_Aggregate;
  /** fetch data from the table: "supervisor_provider_term" using primary key columns */
  supervisor_provider_term_by_pk?: Maybe<Supervisor_Provider_Term>;
  /** fetch data from the table: "supervisor_provider_term_ended_by" */
  supervisor_provider_term_ended_by: Array<Supervisor_Provider_Term_Ended_By>;
  /** fetch aggregated fields from the table: "supervisor_provider_term_ended_by" */
  supervisor_provider_term_ended_by_aggregate: Supervisor_Provider_Term_Ended_By_Aggregate;
  /** fetch data from the table: "supervisor_provider_term_ended_by" using primary key columns */
  supervisor_provider_term_ended_by_by_pk?: Maybe<Supervisor_Provider_Term_Ended_By>;
  /** fetch data from the table: "supervisor_review_queue_item" */
  supervisor_review_queue_item: Array<Supervisor_Review_Queue_Item>;
  /** fetch aggregated fields from the table: "supervisor_review_queue_item" */
  supervisor_review_queue_item_aggregate: Supervisor_Review_Queue_Item_Aggregate;
  /** fetch data from the table: "supervisor_review_queue_item" using primary key columns */
  supervisor_review_queue_item_by_pk?: Maybe<Supervisor_Review_Queue_Item>;
  /** fetch data from the table: "supervisor_review_queue_item_status_history" */
  supervisor_review_queue_item_status_history: Array<Supervisor_Review_Queue_Item_Status_History>;
  /** fetch aggregated fields from the table: "supervisor_review_queue_item_status_history" */
  supervisor_review_queue_item_status_history_aggregate: Supervisor_Review_Queue_Item_Status_History_Aggregate;
  /** fetch data from the table: "supervisor_review_queue_item_status_history" using primary key columns */
  supervisor_review_queue_item_status_history_by_pk?: Maybe<Supervisor_Review_Queue_Item_Status_History>;
  /** fetch data from the table: "supervisor_review_queue_source" */
  supervisor_review_queue_source: Array<Supervisor_Review_Queue_Source>;
  /** fetch aggregated fields from the table: "supervisor_review_queue_source" */
  supervisor_review_queue_source_aggregate: Supervisor_Review_Queue_Source_Aggregate;
  /** fetch data from the table: "supervisor_review_queue_source" using primary key columns */
  supervisor_review_queue_source_by_pk?: Maybe<Supervisor_Review_Queue_Source>;
  /** fetch data from the table: "supervisor_review_queue_status" */
  supervisor_review_queue_status: Array<Supervisor_Review_Queue_Status>;
  /** fetch aggregated fields from the table: "supervisor_review_queue_status" */
  supervisor_review_queue_status_aggregate: Supervisor_Review_Queue_Status_Aggregate;
  /** fetch data from the table: "supervisor_review_queue_status" using primary key columns */
  supervisor_review_queue_status_by_pk?: Maybe<Supervisor_Review_Queue_Status>;
  /** fetch data from the table: "supervisor_sampling_period_type" */
  supervisor_sampling_period_type: Array<Supervisor_Sampling_Period_Type>;
  /** fetch aggregated fields from the table: "supervisor_sampling_period_type" */
  supervisor_sampling_period_type_aggregate: Supervisor_Sampling_Period_Type_Aggregate;
  /** fetch data from the table: "supervisor_sampling_period_type" using primary key columns */
  supervisor_sampling_period_type_by_pk?: Maybe<Supervisor_Sampling_Period_Type>;
  /** fetch data from the table: "supervisor_setting" */
  supervisor_setting: Array<Supervisor_Setting>;
  /** fetch aggregated fields from the table: "supervisor_setting" */
  supervisor_setting_aggregate: Supervisor_Setting_Aggregate;
  /** fetch data from the table: "supervisor_setting" using primary key columns */
  supervisor_setting_by_pk?: Maybe<Supervisor_Setting>;
  /** fetch data from the table: "tax_rate" */
  tax_rate: Array<Tax_Rate>;
  /** fetch aggregated fields from the table: "tax_rate" */
  tax_rate_aggregate: Tax_Rate_Aggregate;
  /** fetch data from the table: "tax_rate" using primary key columns */
  tax_rate_by_pk?: Maybe<Tax_Rate>;
  /** fetch data from the table: "tax_type" */
  tax_type: Array<Tax_Type>;
  /** fetch aggregated fields from the table: "tax_type" */
  tax_type_aggregate: Tax_Type_Aggregate;
  /** fetch data from the table: "tax_type" using primary key columns */
  tax_type_by_pk?: Maybe<Tax_Type>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user_agreements" */
  user_agreements: Array<User_Agreements>;
  /** fetch aggregated fields from the table: "user_agreements" */
  user_agreements_aggregate: User_Agreements_Aggregate;
  /** fetch data from the table: "user_agreements" using primary key columns */
  user_agreements_by_pk?: Maybe<User_Agreements>;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_consent" */
  user_consent: Array<User_Consent>;
  /** fetch data from the table: "user_consent_action" */
  user_consent_action: Array<User_Consent_Action>;
  /** fetch aggregated fields from the table: "user_consent_action" */
  user_consent_action_aggregate: User_Consent_Action_Aggregate;
  /** fetch data from the table: "user_consent_action" using primary key columns */
  user_consent_action_by_pk?: Maybe<User_Consent_Action>;
  /** fetch aggregated fields from the table: "user_consent" */
  user_consent_aggregate: User_Consent_Aggregate;
  /** fetch data from the table: "user_consent" using primary key columns */
  user_consent_by_pk?: Maybe<User_Consent>;
  /** fetch data from the table: "user_consent_type" */
  user_consent_type: Array<User_Consent_Type>;
  /** fetch aggregated fields from the table: "user_consent_type" */
  user_consent_type_aggregate: User_Consent_Type_Aggregate;
  /** fetch data from the table: "user_consent_type" using primary key columns */
  user_consent_type_by_pk?: Maybe<User_Consent_Type>;
  /** fetch data from the table: "user_device_push_notification_token" */
  user_device_push_notification_token: Array<User_Device_Push_Notification_Token>;
  /** fetch aggregated fields from the table: "user_device_push_notification_token" */
  user_device_push_notification_token_aggregate: User_Device_Push_Notification_Token_Aggregate;
  /** fetch data from the table: "user_device_push_notification_token" using primary key columns */
  user_device_push_notification_token_by_pk?: Maybe<User_Device_Push_Notification_Token>;
  /** fetch data from the table: "user_document" */
  user_document: Array<User_Document>;
  /** fetch aggregated fields from the table: "user_document" */
  user_document_aggregate: User_Document_Aggregate;
  /** fetch data from the table: "user_document" using primary key columns */
  user_document_by_pk?: Maybe<User_Document>;
  /** fetch data from the table: "user_location" */
  user_location: Array<User_Location>;
  /** fetch aggregated fields from the table: "user_location" */
  user_location_aggregate: User_Location_Aggregate;
  /** fetch data from the table: "user_location" using primary key columns */
  user_location_by_pk?: Maybe<User_Location>;
  /** fetch data from the table: "user_plan" */
  user_plan: Array<User_Plan>;
  /** fetch aggregated fields from the table: "user_plan" */
  user_plan_aggregate: User_Plan_Aggregate;
  /** fetch data from the table: "user_plan" using primary key columns */
  user_plan_by_pk?: Maybe<User_Plan>;
  /** execute function "users_unfulfilled_product_purchases_count_by_location" which returns "fn_users_unfulfilled_product_purchases_count_by_location" */
  users_unfulfilled_product_purchases_count_by_location: Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location>;
  /** execute function "users_unfulfilled_product_purchases_count_by_location" and query aggregates on result of table type "fn_users_unfulfilled_product_purchases_count_by_location" */
  users_unfulfilled_product_purchases_count_by_location_aggregate: Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Aggregate;
  /** fetch data from the table: "version" */
  version: Array<Version>;
  /** fetch aggregated fields from the table: "version" */
  version_aggregate: Version_Aggregate;
  /** fetch data from the table: "version" using primary key columns */
  version_by_pk?: Maybe<Version>;
};


export type Query_RootEhrListCardsArgs = {
  object: EhrListCardsInput;
};


export type Query_RootEhrListChargesArgs = {
  object: EhrListChargesInput;
};


export type Query_RootEhrListPatientChargesArgs = {
  object: EhrListPatientChargesInput;
};


export type Query_RootEhrResolveCustomerArgs = {
  object: EhrResolveCustomerInput;
};


export type Query_RootGetBookingAvailabilityArgs = {
  duration: Scalars['Int'];
  end: Scalars['String'];
  isFree?: InputMaybe<Scalars['Boolean']>;
  location: Scalars['uuid'];
  model?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Scalars['uuid']>;
  provider: Scalars['uuid'];
  resourceFree?: InputMaybe<Scalars['Boolean']>;
  start: Scalars['String'];
};


export type Query_RootGetMsoDashboardMetricArgs = {
  interval: MsoDashboardMetricInterval;
  location: Scalars['uuid'];
  metric: MsoDashboardMetric;
};


export type Query_RootGetMsoDashboardMetricStripeStagingProdArgs = {
  compareToInterval: MsoDashboardMetricCompareToInterval;
  interval: MsoDashboardMetricInterval;
  location: Scalars['uuid'];
  metric: MsoDashboardMetric;
};


export type Query_RootGetPatientBookingAvailabilityArgs = {
  end: Scalars['String'];
  procedure: Scalars['uuid'];
  provider?: InputMaybe<Scalars['uuid']>;
  start: Scalars['String'];
};


export type Query_RootGetPaymentsListArgs = {
  location: Scalars['uuid'];
};


export type Query_RootGetProviderSquareCustomersArgs = {
  provider: Scalars['uuid'];
  squareCustomerId?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetSignedUrlForEhrPhotoArgs = {
  ehrPhotoType: EhrPhotoType;
  photoS3Key: Scalars['uuid'];
};


export type Query_RootGetSquareMerchantNameArgs = {
  includeBusinessName?: InputMaybe<Scalars['Boolean']>;
  location: Scalars['uuid'];
};


export type Query_RootGetSquareUserCardsArgs = {
  provider?: InputMaybe<Scalars['uuid']>;
  squareCustomerId?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetStripeSubscriptionInvoicesArgs = {
  location: Scalars['uuid'];
  provider: Scalars['uuid'];
};


export type Query_RootLookupPhoneNumberTwilioArgs = {
  phoneNumber: Scalars['String'];
};


export type Query_RootValidatePatientInviteArgs = {
  token: Scalars['String'];
};


export type Query_RootAccreditationArgs = {
  distinct_on?: InputMaybe<Array<Accreditation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accreditation_Order_By>>;
  where?: InputMaybe<Accreditation_Bool_Exp>;
};


export type Query_RootAccreditation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accreditation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accreditation_Order_By>>;
  where?: InputMaybe<Accreditation_Bool_Exp>;
};


export type Query_RootAccreditation_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootAccreditation_Location_PrivilegeArgs = {
  distinct_on?: InputMaybe<Array<Accreditation_Location_Privilege_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accreditation_Location_Privilege_Order_By>>;
  where?: InputMaybe<Accreditation_Location_Privilege_Bool_Exp>;
};


export type Query_RootAccreditation_Location_Privilege_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accreditation_Location_Privilege_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accreditation_Location_Privilege_Order_By>>;
  where?: InputMaybe<Accreditation_Location_Privilege_Bool_Exp>;
};


export type Query_RootAccreditation_Location_Privilege_By_PkArgs = {
  accreditation: Accreditation_Enum;
  location: Scalars['uuid'];
};


export type Query_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootAddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootAddress_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAgreement_TypeArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Type_Order_By>>;
  where?: InputMaybe<Agreement_Type_Bool_Exp>;
};


export type Query_RootAgreement_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Type_Order_By>>;
  where?: InputMaybe<Agreement_Type_Bool_Exp>;
};


export type Query_RootAgreement_Type_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootBookingArgs = {
  distinct_on?: InputMaybe<Array<Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Order_By>>;
  where?: InputMaybe<Booking_Bool_Exp>;
};


export type Query_RootBooking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Order_By>>;
  where?: InputMaybe<Booking_Bool_Exp>;
};


export type Query_RootBooking_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootBooking_PublicArgs = {
  distinct_on?: InputMaybe<Array<Booking_Public_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Public_Order_By>>;
  where?: InputMaybe<Booking_Public_Bool_Exp>;
};


export type Query_RootBooking_Public_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Booking_Public_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Public_Order_By>>;
  where?: InputMaybe<Booking_Public_Bool_Exp>;
};


export type Query_RootBooking_TypeArgs = {
  distinct_on?: InputMaybe<Array<Booking_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Type_Order_By>>;
  where?: InputMaybe<Booking_Type_Bool_Exp>;
};


export type Query_RootBooking_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Booking_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Type_Order_By>>;
  where?: InputMaybe<Booking_Type_Bool_Exp>;
};


export type Query_RootBooking_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCancel_ReasonArgs = {
  distinct_on?: InputMaybe<Array<Cancel_Reason_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cancel_Reason_Order_By>>;
  where?: InputMaybe<Cancel_Reason_Bool_Exp>;
};


export type Query_RootCancel_Reason_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cancel_Reason_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cancel_Reason_Order_By>>;
  where?: InputMaybe<Cancel_Reason_Bool_Exp>;
};


export type Query_RootCancel_Reason_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootCheck_Proposed_Patient_Booking_For_StackingArgs = {
  args: Check_Proposed_Patient_Booking_For_Stacking_Args;
  distinct_on?: InputMaybe<Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Order_By>>;
  where?: InputMaybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Bool_Exp>;
};


export type Query_RootCheck_Proposed_Patient_Booking_For_Stacking_AggregateArgs = {
  args: Check_Proposed_Patient_Booking_For_Stacking_Args;
  distinct_on?: InputMaybe<Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Order_By>>;
  where?: InputMaybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Bool_Exp>;
};


export type Query_RootCreditArgs = {
  distinct_on?: InputMaybe<Array<Credit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Order_By>>;
  where?: InputMaybe<Credit_Bool_Exp>;
};


export type Query_RootCredit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Order_By>>;
  where?: InputMaybe<Credit_Bool_Exp>;
};


export type Query_RootCredit_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCredit_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Credit_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Transaction_Order_By>>;
  where?: InputMaybe<Credit_Transaction_Bool_Exp>;
};


export type Query_RootCredit_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Transaction_Order_By>>;
  where?: InputMaybe<Credit_Transaction_Bool_Exp>;
};


export type Query_RootCredit_Transaction_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCredit_TypeArgs = {
  distinct_on?: InputMaybe<Array<Credit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Type_Order_By>>;
  where?: InputMaybe<Credit_Type_Bool_Exp>;
};


export type Query_RootCredit_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Type_Order_By>>;
  where?: InputMaybe<Credit_Type_Bool_Exp>;
};


export type Query_RootCredit_Type_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootDemo_LocationArgs = {
  distinct_on?: InputMaybe<Array<Demo_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demo_Location_Order_By>>;
  where?: InputMaybe<Demo_Location_Bool_Exp>;
};


export type Query_RootDemo_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demo_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demo_Location_Order_By>>;
  where?: InputMaybe<Demo_Location_Bool_Exp>;
};


export type Query_RootDemo_Location_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDocument_TypeArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_Order_By>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Query_RootDocument_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_Order_By>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Query_RootDocument_Type_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootEhr_Charge_LedgerArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Charge_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Charge_Ledger_Order_By>>;
  where?: InputMaybe<Ehr_Charge_Ledger_Bool_Exp>;
};


export type Query_RootEhr_Charge_Ledger_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Charge_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Charge_Ledger_Order_By>>;
  where?: InputMaybe<Ehr_Charge_Ledger_Bool_Exp>;
};


export type Query_RootEhr_Charge_Ledger_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_EncounterArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Bool_Exp>;
};


export type Query_RootEhr_Encounter_AddendumArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Addendum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Addendum_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Addendum_Bool_Exp>;
};


export type Query_RootEhr_Encounter_Addendum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Addendum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Addendum_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Addendum_Bool_Exp>;
};


export type Query_RootEhr_Encounter_Addendum_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_Encounter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Bool_Exp>;
};


export type Query_RootEhr_Encounter_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_Encounter_ModalityArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Modality_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Modality_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Modality_Bool_Exp>;
};


export type Query_RootEhr_Encounter_Modality_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Modality_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Modality_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Modality_Bool_Exp>;
};


export type Query_RootEhr_Encounter_Modality_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEhr_Encounter_PhotoArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Photo_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Photo_Bool_Exp>;
};


export type Query_RootEhr_Encounter_Photo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Photo_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Photo_Bool_Exp>;
};


export type Query_RootEhr_Encounter_Photo_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_Encounter_Scan_3dArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Bool_Exp>;
};


export type Query_RootEhr_Encounter_Scan_3d_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Bool_Exp>;
};


export type Query_RootEhr_Encounter_Scan_3d_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Bool_Exp>;
};


export type Query_RootEhr_Encounter_Scan_3d_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Bool_Exp>;
};


export type Query_RootEhr_Encounter_Scan_3d_Artifact_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_Encounter_Scan_3d_Artifact_KindArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Kind_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Bool_Exp>;
};


export type Query_RootEhr_Encounter_Scan_3d_Artifact_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Kind_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Bool_Exp>;
};


export type Query_RootEhr_Encounter_Scan_3d_Artifact_Kind_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootEhr_Encounter_Scan_3d_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_Encounter_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Type_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Type_Bool_Exp>;
};


export type Query_RootEhr_Encounter_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Type_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Type_Bool_Exp>;
};


export type Query_RootEhr_Encounter_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEhr_Fda_ProductArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Fda_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Fda_Product_Order_By>>;
  where?: InputMaybe<Ehr_Fda_Product_Bool_Exp>;
};


export type Query_RootEhr_Fda_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Fda_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Fda_Product_Order_By>>;
  where?: InputMaybe<Ehr_Fda_Product_Bool_Exp>;
};


export type Query_RootEhr_Fda_Product_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_Fda_Product_SourceArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Fda_Product_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Fda_Product_Source_Order_By>>;
  where?: InputMaybe<Ehr_Fda_Product_Source_Bool_Exp>;
};


export type Query_RootEhr_Fda_Product_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Fda_Product_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Fda_Product_Source_Order_By>>;
  where?: InputMaybe<Ehr_Fda_Product_Source_Bool_Exp>;
};


export type Query_RootEhr_Fda_Product_Source_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootEhr_MessageArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Message_Order_By>>;
  where?: InputMaybe<Ehr_Message_Bool_Exp>;
};


export type Query_RootEhr_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Message_Order_By>>;
  where?: InputMaybe<Ehr_Message_Bool_Exp>;
};


export type Query_RootEhr_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_Message_ReadArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Message_Read_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Message_Read_Order_By>>;
  where?: InputMaybe<Ehr_Message_Read_Bool_Exp>;
};


export type Query_RootEhr_Message_Read_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Message_Read_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Message_Read_Order_By>>;
  where?: InputMaybe<Ehr_Message_Read_Bool_Exp>;
};


export type Query_RootEhr_Message_Read_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_Message_ThreadsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Message_Threads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Message_Threads_Order_By>>;
  where?: InputMaybe<Ehr_Message_Threads_Bool_Exp>;
};


export type Query_RootEhr_Message_Threads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Message_Threads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Message_Threads_Order_By>>;
  where?: InputMaybe<Ehr_Message_Threads_Bool_Exp>;
};


export type Query_RootEhr_Message_Threads_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_Patient_CardArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Card_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Card_Bool_Exp>;
};


export type Query_RootEhr_Patient_Card_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Card_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Card_Bool_Exp>;
};


export type Query_RootEhr_Patient_Card_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_Patient_ConsentArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Consent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Consent_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Consent_Bool_Exp>;
};


export type Query_RootEhr_Patient_Consent_ActionArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Consent_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Consent_Action_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Consent_Action_Bool_Exp>;
};


export type Query_RootEhr_Patient_Consent_Action_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Consent_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Consent_Action_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Consent_Action_Bool_Exp>;
};


export type Query_RootEhr_Patient_Consent_Action_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootEhr_Patient_Consent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Consent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Consent_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Consent_Bool_Exp>;
};


export type Query_RootEhr_Patient_Consent_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_Patient_Consent_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Consent_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Consent_Type_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Consent_Type_Bool_Exp>;
};


export type Query_RootEhr_Patient_Consent_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Consent_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Consent_Type_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Consent_Type_Bool_Exp>;
};


export type Query_RootEhr_Patient_Consent_Type_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootEhr_ProcedureArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Bool_Exp>;
};


export type Query_RootEhr_Procedure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Bool_Exp>;
};


export type Query_RootEhr_Procedure_Body_AreaArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Body_Area_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Body_Area_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Body_Area_Bool_Exp>;
};


export type Query_RootEhr_Procedure_Body_Area_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Body_Area_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Body_Area_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Body_Area_Bool_Exp>;
};


export type Query_RootEhr_Procedure_Body_Area_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_Procedure_Body_PartArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Body_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Body_Part_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Body_Part_Bool_Exp>;
};


export type Query_RootEhr_Procedure_Body_Part_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Body_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Body_Part_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Body_Part_Bool_Exp>;
};


export type Query_RootEhr_Procedure_Body_Part_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_Procedure_Body_Part_Provider_Injection_DefaultArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Bool_Exp>;
};


export type Query_RootEhr_Procedure_Body_Part_Provider_Injection_Default_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Bool_Exp>;
};


export type Query_RootEhr_Procedure_Body_Part_Provider_Injection_Default_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_Procedure_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_Procedure_Ehr_ProductArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Ehr_Product_Bool_Exp>;
};


export type Query_RootEhr_Procedure_Ehr_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Ehr_Product_Bool_Exp>;
};


export type Query_RootEhr_Procedure_Ehr_Product_By_PkArgs = {
  ehrProcedure: Scalars['uuid'];
  ehrProduct: Scalars['uuid'];
};


export type Query_RootEhr_Procedure_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Type_Enum_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Type_Enum_Bool_Exp>;
};


export type Query_RootEhr_Procedure_Type_Enum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Type_Enum_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Type_Enum_Bool_Exp>;
};


export type Query_RootEhr_Procedure_Type_Enum_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEhr_ProductArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Product_Order_By>>;
  where?: InputMaybe<Ehr_Product_Bool_Exp>;
};


export type Query_RootEhr_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Product_Order_By>>;
  where?: InputMaybe<Ehr_Product_Bool_Exp>;
};


export type Query_RootEhr_Product_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_Product_ProcedureArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Product_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Product_Procedure_Order_By>>;
  where?: InputMaybe<Ehr_Product_Procedure_Bool_Exp>;
};


export type Query_RootEhr_Product_Procedure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Product_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Product_Procedure_Order_By>>;
  where?: InputMaybe<Ehr_Product_Procedure_Bool_Exp>;
};


export type Query_RootEhr_Product_Procedure_By_PkArgs = {
  ehr_product: Scalars['uuid'];
  procedure: Scalars['uuid'];
};


export type Query_RootEhr_Product_Provider_Usage_Record_PhotoArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Product_Provider_Usage_Record_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Product_Provider_Usage_Record_Photo_Order_By>>;
  where?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Bool_Exp>;
};


export type Query_RootEhr_Product_Provider_Usage_Record_Photo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Product_Provider_Usage_Record_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Product_Provider_Usage_Record_Photo_Order_By>>;
  where?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Bool_Exp>;
};


export type Query_RootEhr_Product_Provider_Usage_Record_Photo_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_SubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Bool_Exp>;
};


export type Query_RootEhr_Subscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Bool_Exp>;
};


export type Query_RootEhr_Subscription_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEhr_Subscription_StatusArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Status_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Status_Bool_Exp>;
};


export type Query_RootEhr_Subscription_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Status_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Status_Bool_Exp>;
};


export type Query_RootEhr_Subscription_Status_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootEhr_Subscription_TierArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Tier_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Tier_Bool_Exp>;
};


export type Query_RootEhr_Subscription_Tier_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Tier_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Tier_Bool_Exp>;
};


export type Query_RootEhr_Subscription_Tier_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootEhr_Subscription_Tier_TermArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Tier_Term_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Tier_Term_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Tier_Term_Bool_Exp>;
};


export type Query_RootEhr_Subscription_Tier_Term_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Tier_Term_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Tier_Term_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Tier_Term_Bool_Exp>;
};


export type Query_RootEhr_Subscription_Tier_Term_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEventArgs = {
  distinct_on?: InputMaybe<Array<Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Order_By>>;
  where?: InputMaybe<Event_Bool_Exp>;
};


export type Query_RootEvent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Order_By>>;
  where?: InputMaybe<Event_Bool_Exp>;
};


export type Query_RootEvent_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEvent_SourceArgs = {
  distinct_on?: InputMaybe<Array<Event_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Source_Order_By>>;
  where?: InputMaybe<Event_Source_Bool_Exp>;
};


export type Query_RootEvent_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Source_Order_By>>;
  where?: InputMaybe<Event_Source_Bool_Exp>;
};


export type Query_RootEvent_Source_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootFiller_Procedure_Delivery_ToolArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Delivery_Tool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Delivery_Tool_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Delivery_Tool_Bool_Exp>;
};


export type Query_RootFiller_Procedure_Delivery_Tool_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Delivery_Tool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Delivery_Tool_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Delivery_Tool_Bool_Exp>;
};


export type Query_RootFiller_Procedure_Delivery_Tool_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootFiller_Procedure_Face_ViewArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Face_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Face_View_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Face_View_Bool_Exp>;
};


export type Query_RootFiller_Procedure_Face_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Face_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Face_View_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Face_View_Bool_Exp>;
};


export type Query_RootFiller_Procedure_Face_View_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootFiller_Procedure_InjectionArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Injection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Injection_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Injection_Bool_Exp>;
};


export type Query_RootFiller_Procedure_Injection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Injection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Injection_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Injection_Bool_Exp>;
};


export type Query_RootFiller_Procedure_Injection_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFiller_Procedure_Injection_TypeArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Injection_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Injection_Type_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Injection_Type_Bool_Exp>;
};


export type Query_RootFiller_Procedure_Injection_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Injection_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Injection_Type_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Injection_Type_Bool_Exp>;
};


export type Query_RootFiller_Procedure_Injection_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootFiller_Procedure_Product_InstanceArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Product_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Product_Instance_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Product_Instance_Bool_Exp>;
};


export type Query_RootFiller_Procedure_Product_Instance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Product_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Product_Instance_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Product_Instance_Bool_Exp>;
};


export type Query_RootFiller_Procedure_Product_Instance_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFiller_Procedure_Product_Instance_PhotoArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Product_Instance_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Product_Instance_Photo_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Bool_Exp>;
};


export type Query_RootFiller_Procedure_Product_Instance_Photo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Product_Instance_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Product_Instance_Photo_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Bool_Exp>;
};


export type Query_RootFiller_Procedure_Product_Instance_Photo_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFiller_SpaceArgs = {
  distinct_on?: InputMaybe<Array<Filler_Space_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Space_Order_By>>;
  where?: InputMaybe<Filler_Space_Bool_Exp>;
};


export type Query_RootFiller_Space_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Space_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Space_Order_By>>;
  where?: InputMaybe<Filler_Space_Bool_Exp>;
};


export type Query_RootFiller_Space_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootFiller_Zone_ReleaseArgs = {
  distinct_on?: InputMaybe<Array<Filler_Zone_Release_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Zone_Release_Order_By>>;
  where?: InputMaybe<Filler_Zone_Release_Bool_Exp>;
};


export type Query_RootFiller_Zone_Release_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Zone_Release_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Zone_Release_Order_By>>;
  where?: InputMaybe<Filler_Zone_Release_Bool_Exp>;
};


export type Query_RootFiller_Zone_Release_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFn_Check_Proposed_Patient_Booking_For_StackingArgs = {
  distinct_on?: InputMaybe<Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Order_By>>;
  where?: InputMaybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Bool_Exp>;
};


export type Query_RootFn_Check_Proposed_Patient_Booking_For_Stacking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Order_By>>;
  where?: InputMaybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Bool_Exp>;
};


export type Query_RootFn_Check_Proposed_Patient_Booking_For_Stacking_By_PkArgs = {
  provider_booking_id: Scalars['uuid'];
};


export type Query_RootFn_Get_Active_Notification_Preferences_For_Type_And_LocationArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp>;
};


export type Query_RootFn_Get_Active_Notification_Preferences_For_Type_And_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp>;
};


export type Query_RootFn_Get_Active_Notification_Preferences_For_Type_And_Location_By_PkArgs = {
  location: Scalars['uuid'];
  type: Scalars['String'];
  user: Scalars['uuid'];
};


export type Query_RootFn_Get_Active_Subscribers_QueryArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Subscribers_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Subscribers_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Subscribers_Query_Bool_Exp>;
};


export type Query_RootFn_Get_Active_Subscribers_Query_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Subscribers_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Subscribers_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Subscribers_Query_Bool_Exp>;
};


export type Query_RootFn_Get_Active_Subscribers_Query_By_PkArgs = {
  stripeCustomerId: Scalars['String'];
};


export type Query_RootFn_Get_Location_Purchases_To_Provider_Purchases_QueryArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Bool_Exp>;
};


export type Query_RootFn_Get_Location_Purchases_To_Provider_Purchases_Query_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Bool_Exp>;
};


export type Query_RootFn_Get_Location_Purchases_To_Provider_Purchases_Query_By_PkArgs = {
  location: Scalars['uuid'];
};


export type Query_RootFn_Get_Stackable_Booking_Options_DataArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_Stackable_Booking_Options_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Stackable_Booking_Options_Data_Order_By>>;
  where?: InputMaybe<Fn_Get_Stackable_Booking_Options_Data_Bool_Exp>;
};


export type Query_RootFn_Get_Stackable_Booking_Options_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_Stackable_Booking_Options_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Stackable_Booking_Options_Data_Order_By>>;
  where?: InputMaybe<Fn_Get_Stackable_Booking_Options_Data_Bool_Exp>;
};


export type Query_RootFn_Get_Stackable_Booking_Options_Data_By_PkArgs = {
  providerBookingId: Scalars['uuid'];
};


export type Query_RootFn_Get_User_Booking_Options_BlockersArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_User_Booking_Options_Blockers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Booking_Options_Blockers_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Booking_Options_Blockers_Bool_Exp>;
};


export type Query_RootFn_Get_User_Booking_Options_Blockers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_User_Booking_Options_Blockers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Booking_Options_Blockers_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Booking_Options_Blockers_Bool_Exp>;
};


export type Query_RootFn_Get_User_Booking_Options_Blockers_By_PkArgs = {
  bound: Scalars['String'];
  timestamp: Scalars['timestamptz'];
  type: Scalars['String'];
};


export type Query_RootFn_Get_User_Location_Procedure_Unavailable_RoomsArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Bool_Exp>;
};


export type Query_RootFn_Get_User_Location_Procedure_Unavailable_Rooms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Bool_Exp>;
};


export type Query_RootFn_Get_User_Location_Procedure_Unavailable_Rooms_By_PkArgs = {
  room: Scalars['uuid'];
  timespanBlockingBooking: Scalars['tstzrange'];
};


export type Query_RootFn_Get_User_Products_To_Rentals_QueryArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_User_Products_To_Rentals_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Products_To_Rentals_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Products_To_Rentals_Query_Bool_Exp>;
};


export type Query_RootFn_Get_User_Products_To_Rentals_Query_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_User_Products_To_Rentals_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Products_To_Rentals_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Products_To_Rentals_Query_Bool_Exp>;
};


export type Query_RootFn_Get_User_Products_To_Rentals_Query_By_PkArgs = {
  user: Scalars['uuid'];
};


export type Query_RootFn_Users_Unfulfilled_Product_Purchases_Count_By_LocationArgs = {
  distinct_on?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Order_By>>;
  where?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp>;
};


export type Query_RootFn_Users_Unfulfilled_Product_Purchases_Count_By_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Order_By>>;
  where?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp>;
};


export type Query_RootFn_Users_Unfulfilled_Product_Purchases_Count_By_Location_By_PkArgs = {
  location: Scalars['uuid'];
  user: Scalars['uuid'];
};


export type Query_RootGenderArgs = {
  distinct_on?: InputMaybe<Array<Gender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gender_Order_By>>;
  where?: InputMaybe<Gender_Bool_Exp>;
};


export type Query_RootGender_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gender_Order_By>>;
  where?: InputMaybe<Gender_Bool_Exp>;
};


export type Query_RootGender_By_PkArgs = {
  gender: Scalars['String'];
};


export type Query_RootGetBillingReportArgs = {
  cc?: InputMaybe<Array<Scalars['String']>>;
  end: Scalars['String'];
  location: Scalars['uuid'];
  start: Scalars['String'];
  user: Scalars['uuid'];
};


export type Query_RootGetBookingInvoiceLineItemsArgs = {
  object: GetInvoiceLineItemsInput;
};


export type Query_RootGetCognitoUserArgs = {
  object: GetCognitoUserInput;
};


export type Query_RootGetDownloadDocumentUrlArgs = {
  object: GetDownloadDocumentUrlInput;
};


export type Query_RootGetFinancialReportArgs = {
  admin: Scalars['uuid'];
  end: Scalars['String'];
  location: Scalars['uuid'];
  start: Scalars['String'];
};


export type Query_RootGetHostedInvoiceUrlArgs = {
  invoiceId: Scalars['String'];
  location?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['uuid']>;
};


export type Query_RootGetPatientTemplatesArgs = {
  ehrProcedure: Scalars['uuid'];
  location: Scalars['uuid'];
  patient: Scalars['uuid'];
};


export type Query_RootGetPaymentMethodsArgs = {
  object: GetPaymentMethodsInput;
};


export type Query_RootGetProductPurchaseLineItemsArgs = {
  purchaseIds: Array<InputMaybe<Scalars['uuid']>>;
};


export type Query_RootGetUploadDocumentUrlArgs = {
  object: GetUploadDocumentUrlInput;
};


export type Query_RootGetUploadPhotoUrlArgs = {
  object: GetUploadPhotoUrlInput;
};


export type Query_RootGet_Active_Notification_Preferences_For_Type_And_LocationArgs = {
  args: Get_Active_Notification_Preferences_For_Type_And_Location_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp>;
};


export type Query_RootGet_Active_Notification_Preferences_For_Type_And_Location_AggregateArgs = {
  args: Get_Active_Notification_Preferences_For_Type_And_Location_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp>;
};


export type Query_RootGet_Active_Notification_Preferences_For_Type_Any_LocationArgs = {
  args: Get_Active_Notification_Preferences_For_Type_Any_Location_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp>;
};


export type Query_RootGet_Active_Notification_Preferences_For_Type_Any_Location_AggregateArgs = {
  args: Get_Active_Notification_Preferences_For_Type_Any_Location_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp>;
};


export type Query_RootGet_Active_Subscribers_QueryArgs = {
  args: Get_Active_Subscribers_Query_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Subscribers_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Subscribers_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Subscribers_Query_Bool_Exp>;
};


export type Query_RootGet_Active_Subscribers_Query_AggregateArgs = {
  args: Get_Active_Subscribers_Query_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Subscribers_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Subscribers_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Subscribers_Query_Bool_Exp>;
};


export type Query_RootGet_Cumulative_Location_PlansArgs = {
  args: Get_Cumulative_Location_Plans_Args;
  distinct_on?: InputMaybe<Array<Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Query_RootGet_Cumulative_Location_Plans_AggregateArgs = {
  args: Get_Cumulative_Location_Plans_Args;
  distinct_on?: InputMaybe<Array<Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Query_RootGet_Location_Purchases_To_Provider_Purchases_QueryArgs = {
  args: Get_Location_Purchases_To_Provider_Purchases_Query_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Bool_Exp>;
};


export type Query_RootGet_Location_Purchases_To_Provider_Purchases_Query_AggregateArgs = {
  args: Get_Location_Purchases_To_Provider_Purchases_Query_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Bool_Exp>;
};


export type Query_RootGet_Stackable_Booking_Options_DataArgs = {
  args: Get_Stackable_Booking_Options_Data_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Stackable_Booking_Options_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Stackable_Booking_Options_Data_Order_By>>;
  where?: InputMaybe<Fn_Get_Stackable_Booking_Options_Data_Bool_Exp>;
};


export type Query_RootGet_Stackable_Booking_Options_Data_AggregateArgs = {
  args: Get_Stackable_Booking_Options_Data_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Stackable_Booking_Options_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Stackable_Booking_Options_Data_Order_By>>;
  where?: InputMaybe<Fn_Get_Stackable_Booking_Options_Data_Bool_Exp>;
};


export type Query_RootGet_User_Booking_Options_BlockersArgs = {
  args: Get_User_Booking_Options_Blockers_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_User_Booking_Options_Blockers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Booking_Options_Blockers_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Booking_Options_Blockers_Bool_Exp>;
};


export type Query_RootGet_User_Booking_Options_Blockers_AggregateArgs = {
  args: Get_User_Booking_Options_Blockers_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_User_Booking_Options_Blockers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Booking_Options_Blockers_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Booking_Options_Blockers_Bool_Exp>;
};


export type Query_RootGet_User_Products_To_Rentals_QueryArgs = {
  args: Get_User_Products_To_Rentals_Query_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_User_Products_To_Rentals_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Products_To_Rentals_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Products_To_Rentals_Query_Bool_Exp>;
};


export type Query_RootGet_User_Products_To_Rentals_Query_AggregateArgs = {
  args: Get_User_Products_To_Rentals_Query_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_User_Products_To_Rentals_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Products_To_Rentals_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Products_To_Rentals_Query_Bool_Exp>;
};


export type Query_RootInvoiceArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Query_RootInvoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Query_RootInvoice_Billing_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Billing_Summary_Order_By>>;
  where?: InputMaybe<Invoice_Billing_Summary_Bool_Exp>;
};


export type Query_RootInvoice_Billing_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Billing_Summary_Order_By>>;
  where?: InputMaybe<Invoice_Billing_Summary_Bool_Exp>;
};


export type Query_RootInvoice_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLocationArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Query_RootLocation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Query_RootLocation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLocation_ProcedureArgs = {
  distinct_on?: InputMaybe<Array<Location_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Procedure_Order_By>>;
  where?: InputMaybe<Location_Procedure_Bool_Exp>;
};


export type Query_RootLocation_Procedure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Procedure_Order_By>>;
  where?: InputMaybe<Location_Procedure_Bool_Exp>;
};


export type Query_RootLocation_Procedure_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLocation_Procedure_RoomArgs = {
  distinct_on?: InputMaybe<Array<Location_Procedure_Room_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Procedure_Room_Order_By>>;
  where?: InputMaybe<Location_Procedure_Room_Bool_Exp>;
};


export type Query_RootLocation_Procedure_Room_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Procedure_Room_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Procedure_Room_Order_By>>;
  where?: InputMaybe<Location_Procedure_Room_Bool_Exp>;
};


export type Query_RootLocation_Procedure_Room_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLocation_ProductArgs = {
  distinct_on?: InputMaybe<Array<Location_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Product_Order_By>>;
  where?: InputMaybe<Location_Product_Bool_Exp>;
};


export type Query_RootLocation_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Product_Order_By>>;
  where?: InputMaybe<Location_Product_Bool_Exp>;
};


export type Query_RootLocation_Product_By_PkArgs = {
  location: Scalars['uuid'];
  product: Scalars['uuid'];
};


export type Query_RootModelArgs = {
  distinct_on?: InputMaybe<Array<Model_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Order_By>>;
  where?: InputMaybe<Model_Bool_Exp>;
};


export type Query_RootModel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Order_By>>;
  where?: InputMaybe<Model_Bool_Exp>;
};


export type Query_RootModel_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootModel_CountArgs = {
  distinct_on?: InputMaybe<Array<Model_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Count_Order_By>>;
  where?: InputMaybe<Model_Count_Bool_Exp>;
};


export type Query_RootModel_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Count_Order_By>>;
  where?: InputMaybe<Model_Count_Bool_Exp>;
};


export type Query_RootModel_Count_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootModel_ProductArgs = {
  distinct_on?: InputMaybe<Array<Model_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Product_Order_By>>;
  where?: InputMaybe<Model_Product_Bool_Exp>;
};


export type Query_RootModel_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Product_Order_By>>;
  where?: InputMaybe<Model_Product_Bool_Exp>;
};


export type Query_RootModel_Product_By_PkArgs = {
  model: Scalars['uuid'];
  product: Scalars['uuid'];
};


export type Query_RootMso_ModeArgs = {
  distinct_on?: InputMaybe<Array<Mso_Mode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mso_Mode_Order_By>>;
  where?: InputMaybe<Mso_Mode_Bool_Exp>;
};


export type Query_RootMso_Mode_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mso_Mode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mso_Mode_Order_By>>;
  where?: InputMaybe<Mso_Mode_Bool_Exp>;
};


export type Query_RootMso_Mode_By_PkArgs = {
  mode: Scalars['String'];
};


export type Query_RootMso_TierArgs = {
  distinct_on?: InputMaybe<Array<Mso_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mso_Tier_Order_By>>;
  where?: InputMaybe<Mso_Tier_Bool_Exp>;
};


export type Query_RootMso_Tier_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mso_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mso_Tier_Order_By>>;
  where?: InputMaybe<Mso_Tier_Bool_Exp>;
};


export type Query_RootMso_Tier_By_PkArgs = {
  tier: Scalars['String'];
};


export type Query_RootNotification_Audit_LogArgs = {
  distinct_on?: InputMaybe<Array<Notification_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Audit_Log_Order_By>>;
  where?: InputMaybe<Notification_Audit_Log_Bool_Exp>;
};


export type Query_RootNotification_Audit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Audit_Log_Order_By>>;
  where?: InputMaybe<Notification_Audit_Log_Bool_Exp>;
};


export type Query_RootNotification_Audit_Log_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootNotification_Broadcast_TypeArgs = {
  distinct_on?: InputMaybe<Array<Notification_Broadcast_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Broadcast_Type_Order_By>>;
  where?: InputMaybe<Notification_Broadcast_Type_Bool_Exp>;
};


export type Query_RootNotification_Broadcast_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Broadcast_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Broadcast_Type_Order_By>>;
  where?: InputMaybe<Notification_Broadcast_Type_Bool_Exp>;
};


export type Query_RootNotification_Broadcast_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Query_RootNotification_ChannelArgs = {
  distinct_on?: InputMaybe<Array<Notification_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Channel_Order_By>>;
  where?: InputMaybe<Notification_Channel_Bool_Exp>;
};


export type Query_RootNotification_Channel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Channel_Order_By>>;
  where?: InputMaybe<Notification_Channel_Bool_Exp>;
};


export type Query_RootNotification_Channel_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootNotification_PreferenceArgs = {
  distinct_on?: InputMaybe<Array<Notification_Preference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Preference_Order_By>>;
  where?: InputMaybe<Notification_Preference_Bool_Exp>;
};


export type Query_RootNotification_Preference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Preference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Preference_Order_By>>;
  where?: InputMaybe<Notification_Preference_Bool_Exp>;
};


export type Query_RootNotification_Preference_By_PkArgs = {
  channel: Notification_Channel_Enum;
  location: Scalars['uuid'];
  type: Scalars['String'];
  user: Scalars['uuid'];
};


export type Query_RootNotification_TypeArgs = {
  distinct_on?: InputMaybe<Array<Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Type_Order_By>>;
  where?: InputMaybe<Notification_Type_Bool_Exp>;
};


export type Query_RootNotification_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Type_Order_By>>;
  where?: InputMaybe<Notification_Type_Bool_Exp>;
};


export type Query_RootNotification_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootNotification_Type_Default_ChannelArgs = {
  distinct_on?: InputMaybe<Array<Notification_Type_Default_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Type_Default_Channel_Order_By>>;
  where?: InputMaybe<Notification_Type_Default_Channel_Bool_Exp>;
};


export type Query_RootNotification_Type_Default_Channel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Type_Default_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Type_Default_Channel_Order_By>>;
  where?: InputMaybe<Notification_Type_Default_Channel_Bool_Exp>;
};


export type Query_RootNotification_Type_Default_Channel_By_PkArgs = {
  channel: Notification_Channel_Enum;
  type: Scalars['String'];
};


export type Query_RootOpenArgs = {
  distinct_on?: InputMaybe<Array<Open_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Open_Order_By>>;
  where?: InputMaybe<Open_Bool_Exp>;
};


export type Query_RootOpen_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Open_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Open_Order_By>>;
  where?: InputMaybe<Open_Bool_Exp>;
};


export type Query_RootOpen_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPartnerArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


export type Query_RootPartner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


export type Query_RootPartner_BasicArgs = {
  distinct_on?: InputMaybe<Array<Partner_Basic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Partner_Basic_Order_By>>;
  where?: InputMaybe<Partner_Basic_Bool_Exp>;
};


export type Query_RootPartner_Basic_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Basic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Partner_Basic_Order_By>>;
  where?: InputMaybe<Partner_Basic_Bool_Exp>;
};


export type Query_RootPartner_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPatientArgs = {
  distinct_on?: InputMaybe<Array<Patient_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Order_By>>;
  where?: InputMaybe<Patient_Bool_Exp>;
};


export type Query_RootPatient_Account_EventArgs = {
  distinct_on?: InputMaybe<Array<Patient_Account_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Account_Event_Order_By>>;
  where?: InputMaybe<Patient_Account_Event_Bool_Exp>;
};


export type Query_RootPatient_Account_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Account_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Account_Event_Order_By>>;
  where?: InputMaybe<Patient_Account_Event_Bool_Exp>;
};


export type Query_RootPatient_Account_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPatient_Account_Event_TypeArgs = {
  distinct_on?: InputMaybe<Array<Patient_Account_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Account_Event_Type_Order_By>>;
  where?: InputMaybe<Patient_Account_Event_Type_Bool_Exp>;
};


export type Query_RootPatient_Account_Event_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Account_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Account_Event_Type_Order_By>>;
  where?: InputMaybe<Patient_Account_Event_Type_Bool_Exp>;
};


export type Query_RootPatient_Account_Event_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootPatient_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Order_By>>;
  where?: InputMaybe<Patient_Bool_Exp>;
};


export type Query_RootPatient_Auth_ChallengeArgs = {
  distinct_on?: InputMaybe<Array<Patient_Auth_Challenge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Auth_Challenge_Order_By>>;
  where?: InputMaybe<Patient_Auth_Challenge_Bool_Exp>;
};


export type Query_RootPatient_Auth_Challenge_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Auth_Challenge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Auth_Challenge_Order_By>>;
  where?: InputMaybe<Patient_Auth_Challenge_Bool_Exp>;
};


export type Query_RootPatient_Auth_Challenge_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPatient_Bookable_Ehr_ProcedureArgs = {
  distinct_on?: InputMaybe<Array<Patient_Bookable_Ehr_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Bookable_Ehr_Procedure_Order_By>>;
  where?: InputMaybe<Patient_Bookable_Ehr_Procedure_Bool_Exp>;
};


export type Query_RootPatient_Bookable_Ehr_Procedure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Bookable_Ehr_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Bookable_Ehr_Procedure_Order_By>>;
  where?: InputMaybe<Patient_Bookable_Ehr_Procedure_Bool_Exp>;
};


export type Query_RootPatient_Bookable_Ehr_Procedure_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPatient_BookingArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Order_By>>;
  where?: InputMaybe<Patient_Booking_Bool_Exp>;
};


export type Query_RootPatient_Booking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Order_By>>;
  where?: InputMaybe<Patient_Booking_Bool_Exp>;
};


export type Query_RootPatient_Booking_BookingArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Booking_Order_By>>;
  where?: InputMaybe<Patient_Booking_Booking_Bool_Exp>;
};


export type Query_RootPatient_Booking_Booking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Booking_Order_By>>;
  where?: InputMaybe<Patient_Booking_Booking_Bool_Exp>;
};


export type Query_RootPatient_Booking_Booking_By_PkArgs = {
  booking: Scalars['uuid'];
  patient_booking: Scalars['uuid'];
};


export type Query_RootPatient_Booking_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPatient_Booking_Cancel_ReasonArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Cancel_Reason_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Cancel_Reason_Order_By>>;
  where?: InputMaybe<Patient_Booking_Cancel_Reason_Bool_Exp>;
};


export type Query_RootPatient_Booking_Cancel_Reason_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Cancel_Reason_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Cancel_Reason_Order_By>>;
  where?: InputMaybe<Patient_Booking_Cancel_Reason_Bool_Exp>;
};


export type Query_RootPatient_Booking_Cancel_Reason_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootPatient_Booking_InitiatorArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Initiator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Initiator_Order_By>>;
  where?: InputMaybe<Patient_Booking_Initiator_Bool_Exp>;
};


export type Query_RootPatient_Booking_Initiator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Initiator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Initiator_Order_By>>;
  where?: InputMaybe<Patient_Booking_Initiator_Bool_Exp>;
};


export type Query_RootPatient_Booking_Initiator_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootPatient_Booking_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Metadata_Order_By>>;
  where?: InputMaybe<Patient_Booking_Metadata_Bool_Exp>;
};


export type Query_RootPatient_Booking_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Metadata_Order_By>>;
  where?: InputMaybe<Patient_Booking_Metadata_Bool_Exp>;
};


export type Query_RootPatient_Booking_Metadata_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPatient_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPatient_Last_ViewArgs = {
  distinct_on?: InputMaybe<Array<Patient_Last_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Last_View_Order_By>>;
  where?: InputMaybe<Patient_Last_View_Bool_Exp>;
};


export type Query_RootPatient_Last_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Last_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Last_View_Order_By>>;
  where?: InputMaybe<Patient_Last_View_Bool_Exp>;
};


export type Query_RootPatient_Last_View_By_PkArgs = {
  patient: Scalars['uuid'];
  user: Scalars['uuid'];
};


export type Query_RootPatient_Medical_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Patient_Medical_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Medical_Profile_Order_By>>;
  where?: InputMaybe<Patient_Medical_Profile_Bool_Exp>;
};


export type Query_RootPatient_Medical_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Medical_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Medical_Profile_Order_By>>;
  where?: InputMaybe<Patient_Medical_Profile_Bool_Exp>;
};


export type Query_RootPatient_Medical_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPatient_Registration_InviteArgs = {
  distinct_on?: InputMaybe<Array<Patient_Registration_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Registration_Invite_Order_By>>;
  where?: InputMaybe<Patient_Registration_Invite_Bool_Exp>;
};


export type Query_RootPatient_Registration_Invite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Registration_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Registration_Invite_Order_By>>;
  where?: InputMaybe<Patient_Registration_Invite_Bool_Exp>;
};


export type Query_RootPatient_Registration_Invite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPatient_SessionArgs = {
  distinct_on?: InputMaybe<Array<Patient_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Session_Order_By>>;
  where?: InputMaybe<Patient_Session_Bool_Exp>;
};


export type Query_RootPatient_Session_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Session_Order_By>>;
  where?: InputMaybe<Patient_Session_Bool_Exp>;
};


export type Query_RootPatient_Session_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPatient_Webauthn_ChallengeArgs = {
  distinct_on?: InputMaybe<Array<Patient_Webauthn_Challenge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Webauthn_Challenge_Order_By>>;
  where?: InputMaybe<Patient_Webauthn_Challenge_Bool_Exp>;
};


export type Query_RootPatient_Webauthn_Challenge_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Webauthn_Challenge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Webauthn_Challenge_Order_By>>;
  where?: InputMaybe<Patient_Webauthn_Challenge_Bool_Exp>;
};


export type Query_RootPatient_Webauthn_Challenge_By_PkArgs = {
  patient: Scalars['uuid'];
};


export type Query_RootPatient_Webauthn_CredentialArgs = {
  distinct_on?: InputMaybe<Array<Patient_Webauthn_Credential_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Webauthn_Credential_Order_By>>;
  where?: InputMaybe<Patient_Webauthn_Credential_Bool_Exp>;
};


export type Query_RootPatient_Webauthn_Credential_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Webauthn_Credential_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Webauthn_Credential_Order_By>>;
  where?: InputMaybe<Patient_Webauthn_Credential_Bool_Exp>;
};


export type Query_RootPatient_Webauthn_Credential_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlanArgs = {
  distinct_on?: InputMaybe<Array<Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Query_RootPlan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Query_RootPlan_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlan_TypeArgs = {
  distinct_on?: InputMaybe<Array<Plan_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Type_Order_By>>;
  where?: InputMaybe<Plan_Type_Bool_Exp>;
};


export type Query_RootPlan_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plan_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Type_Order_By>>;
  where?: InputMaybe<Plan_Type_Bool_Exp>;
};


export type Query_RootPlan_Type_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootPre_Procedure_Photo_Injection_MarkingArgs = {
  distinct_on?: InputMaybe<Array<Pre_Procedure_Photo_Injection_Marking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pre_Procedure_Photo_Injection_Marking_Order_By>>;
  where?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Bool_Exp>;
};


export type Query_RootPre_Procedure_Photo_Injection_Marking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pre_Procedure_Photo_Injection_Marking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pre_Procedure_Photo_Injection_Marking_Order_By>>;
  where?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Bool_Exp>;
};


export type Query_RootPre_Procedure_Photo_Injection_Marking_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProcedureArgs = {
  distinct_on?: InputMaybe<Array<Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Procedure_Order_By>>;
  where?: InputMaybe<Procedure_Bool_Exp>;
};


export type Query_RootProcedure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Procedure_Order_By>>;
  where?: InputMaybe<Procedure_Bool_Exp>;
};


export type Query_RootProcedure_Audio_RecordingArgs = {
  distinct_on?: InputMaybe<Array<Procedure_Audio_Recording_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Procedure_Audio_Recording_Order_By>>;
  where?: InputMaybe<Procedure_Audio_Recording_Bool_Exp>;
};


export type Query_RootProcedure_Audio_Recording_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Procedure_Audio_Recording_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Procedure_Audio_Recording_Order_By>>;
  where?: InputMaybe<Procedure_Audio_Recording_Bool_Exp>;
};


export type Query_RootProcedure_Audio_Recording_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProcedure_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootProductLookupBarcodeArgs = {
  scanData: Scalars['String'];
  scanType: Scalars['String'];
};


export type Query_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootProduct_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_PurchaseArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchase_Order_By>>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};


export type Query_RootProduct_Purchase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchase_Order_By>>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};


export type Query_RootProduct_Purchase_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProduct_TypeArgs = {
  distinct_on?: InputMaybe<Array<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Query_RootProduct_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Query_RootProduct_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProvider_Direct_Product_PurchaseArgs = {
  distinct_on?: InputMaybe<Array<Provider_Direct_Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Direct_Product_Purchase_Order_By>>;
  where?: InputMaybe<Provider_Direct_Product_Purchase_Bool_Exp>;
};


export type Query_RootProvider_Direct_Product_Purchase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Direct_Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Direct_Product_Purchase_Order_By>>;
  where?: InputMaybe<Provider_Direct_Product_Purchase_Bool_Exp>;
};


export type Query_RootProvider_Direct_Product_Purchase_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProvider_Direct_Purchase_Web_Admin_ViewArgs = {
  distinct_on?: InputMaybe<Array<Provider_Direct_Purchase_Web_Admin_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Direct_Purchase_Web_Admin_View_Order_By>>;
  where?: InputMaybe<Provider_Direct_Purchase_Web_Admin_View_Bool_Exp>;
};


export type Query_RootProvider_Direct_Purchase_Web_Admin_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Direct_Purchase_Web_Admin_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Direct_Purchase_Web_Admin_View_Order_By>>;
  where?: InputMaybe<Provider_Direct_Purchase_Web_Admin_View_Bool_Exp>;
};


export type Query_RootProvider_HoursArgs = {
  distinct_on?: InputMaybe<Array<Provider_Hours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Hours_Order_By>>;
  where?: InputMaybe<Provider_Hours_Bool_Exp>;
};


export type Query_RootProvider_Hours_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Hours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Hours_Order_By>>;
  where?: InputMaybe<Provider_Hours_Bool_Exp>;
};


export type Query_RootProvider_Hours_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProvider_Hours_Repeat_IntervalArgs = {
  distinct_on?: InputMaybe<Array<Provider_Hours_Repeat_Interval_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Hours_Repeat_Interval_Order_By>>;
  where?: InputMaybe<Provider_Hours_Repeat_Interval_Bool_Exp>;
};


export type Query_RootProvider_Hours_Repeat_Interval_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Hours_Repeat_Interval_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Hours_Repeat_Interval_Order_By>>;
  where?: InputMaybe<Provider_Hours_Repeat_Interval_Bool_Exp>;
};


export type Query_RootProvider_Hours_Repeat_Interval_By_PkArgs = {
  interval: Scalars['String'];
};


export type Query_RootProvider_Hours_RepeaterArgs = {
  distinct_on?: InputMaybe<Array<Provider_Hours_Repeater_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Hours_Repeater_Order_By>>;
  where?: InputMaybe<Provider_Hours_Repeater_Bool_Exp>;
};


export type Query_RootProvider_Hours_Repeater_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Hours_Repeater_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Hours_Repeater_Order_By>>;
  where?: InputMaybe<Provider_Hours_Repeater_Bool_Exp>;
};


export type Query_RootProvider_Hours_Repeater_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProvider_Patient_Booking_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Provider_Patient_Booking_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Patient_Booking_Settings_Order_By>>;
  where?: InputMaybe<Provider_Patient_Booking_Settings_Bool_Exp>;
};


export type Query_RootProvider_Patient_Booking_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Patient_Booking_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Patient_Booking_Settings_Order_By>>;
  where?: InputMaybe<Provider_Patient_Booking_Settings_Bool_Exp>;
};


export type Query_RootProvider_Patient_Booking_Settings_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProvider_ProcedureArgs = {
  distinct_on?: InputMaybe<Array<Provider_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Procedure_Order_By>>;
  where?: InputMaybe<Provider_Procedure_Bool_Exp>;
};


export type Query_RootProvider_Procedure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Procedure_Order_By>>;
  where?: InputMaybe<Provider_Procedure_Bool_Exp>;
};


export type Query_RootProvider_Procedure_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPurchase_For_LocationArgs = {
  distinct_on?: InputMaybe<Array<Purchase_For_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_For_Location_Order_By>>;
  where?: InputMaybe<Purchase_For_Location_Bool_Exp>;
};


export type Query_RootPurchase_For_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_For_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_For_Location_Order_By>>;
  where?: InputMaybe<Purchase_For_Location_Bool_Exp>;
};


export type Query_RootPurchase_For_Location_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPurchase_Requests_ListArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Requests_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Requests_List_Order_By>>;
  where?: InputMaybe<Purchase_Requests_List_Bool_Exp>;
};


export type Query_RootPurchase_Requests_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Requests_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Requests_List_Order_By>>;
  where?: InputMaybe<Purchase_Requests_List_Bool_Exp>;
};


export type Query_RootRental_Volume_DiscountArgs = {
  distinct_on?: InputMaybe<Array<Rental_Volume_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rental_Volume_Discount_Order_By>>;
  where?: InputMaybe<Rental_Volume_Discount_Bool_Exp>;
};


export type Query_RootRental_Volume_Discount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rental_Volume_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rental_Volume_Discount_Order_By>>;
  where?: InputMaybe<Rental_Volume_Discount_Bool_Exp>;
};


export type Query_RootRental_Volume_Discount_By_PkArgs = {
  hours: Scalars['Int'];
  location: Scalars['uuid'];
};


export type Query_RootRepeatingArgs = {
  distinct_on?: InputMaybe<Array<Repeating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Repeating_Order_By>>;
  where?: InputMaybe<Repeating_Bool_Exp>;
};


export type Query_RootRepeating_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Repeating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Repeating_Order_By>>;
  where?: InputMaybe<Repeating_Bool_Exp>;
};


export type Query_RootRepeating_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootReport_PreferenceArgs = {
  distinct_on?: InputMaybe<Array<Report_Preference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Preference_Order_By>>;
  where?: InputMaybe<Report_Preference_Bool_Exp>;
};


export type Query_RootReport_Preference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Preference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Preference_Order_By>>;
  where?: InputMaybe<Report_Preference_Bool_Exp>;
};


export type Query_RootReport_Preference_By_PkArgs = {
  location: Scalars['uuid'];
  owningUser: Scalars['uuid'];
  type: Report_Type_Enum;
};


export type Query_RootReport_TypeArgs = {
  distinct_on?: InputMaybe<Array<Report_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Type_Order_By>>;
  where?: InputMaybe<Report_Type_Bool_Exp>;
};


export type Query_RootReport_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Type_Order_By>>;
  where?: InputMaybe<Report_Type_Bool_Exp>;
};


export type Query_RootReport_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Query_RootRoleArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Query_RootRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Query_RootRole_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootRole_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Role_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Notification_Order_By>>;
  where?: InputMaybe<Role_Notification_Bool_Exp>;
};


export type Query_RootRole_Notification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Notification_Order_By>>;
  where?: InputMaybe<Role_Notification_Bool_Exp>;
};


export type Query_RootRole_Notification_By_PkArgs = {
  broadcastType: Notification_Broadcast_Type_Enum;
  notification_type: Scalars['String'];
  role: Scalars['String'];
};


export type Query_RootRoomArgs = {
  distinct_on?: InputMaybe<Array<Room_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Order_By>>;
  where?: InputMaybe<Room_Bool_Exp>;
};


export type Query_RootRoom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Room_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Order_By>>;
  where?: InputMaybe<Room_Bool_Exp>;
};


export type Query_RootRoom_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRoom_ModelArgs = {
  distinct_on?: InputMaybe<Array<Room_Model_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Model_Order_By>>;
  where?: InputMaybe<Room_Model_Bool_Exp>;
};


export type Query_RootRoom_Model_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Room_Model_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Model_Order_By>>;
  where?: InputMaybe<Room_Model_Bool_Exp>;
};


export type Query_RootRoom_Model_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRoom_TypeArgs = {
  distinct_on?: InputMaybe<Array<Room_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Type_Order_By>>;
  where?: InputMaybe<Room_Type_Bool_Exp>;
};


export type Query_RootRoom_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Room_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Type_Order_By>>;
  where?: InputMaybe<Room_Type_Bool_Exp>;
};


export type Query_RootRoom_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSexArgs = {
  distinct_on?: InputMaybe<Array<Sex_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sex_Order_By>>;
  where?: InputMaybe<Sex_Bool_Exp>;
};


export type Query_RootSex_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sex_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sex_Order_By>>;
  where?: InputMaybe<Sex_Bool_Exp>;
};


export type Query_RootSex_By_PkArgs = {
  sex: Scalars['String'];
};


export type Query_RootSigningDocumentsGetPdfArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSigningTemplateGetFieldsArgs = {
  templateId: Scalars['uuid'];
};


export type Query_RootSigningTemplateGetPreviewUrlsArgs = {
  object: SigningTemplateGetPreviewUrlsInput;
};


export type Query_RootSigning_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Signing_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Document_Order_By>>;
  where?: InputMaybe<Signing_Document_Bool_Exp>;
};


export type Query_RootSigning_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Document_Order_By>>;
  where?: InputMaybe<Signing_Document_Bool_Exp>;
};


export type Query_RootSigning_Document_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSigning_Document_Status_TypeArgs = {
  distinct_on?: InputMaybe<Array<Signing_Document_Status_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Document_Status_Type_Order_By>>;
  where?: InputMaybe<Signing_Document_Status_Type_Bool_Exp>;
};


export type Query_RootSigning_Document_Status_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Document_Status_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Document_Status_Type_Order_By>>;
  where?: InputMaybe<Signing_Document_Status_Type_Bool_Exp>;
};


export type Query_RootSigning_Document_Status_Type_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootSigning_Procedure_Associated_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Order_By>>;
  where?: InputMaybe<Signing_Procedure_Associated_Documents_Bool_Exp>;
};


export type Query_RootSigning_Procedure_Associated_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Order_By>>;
  where?: InputMaybe<Signing_Procedure_Associated_Documents_Bool_Exp>;
};


export type Query_RootSigning_Procedure_Associated_Documents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSigning_TemplateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Order_By>>;
  where?: InputMaybe<Signing_Template_Bool_Exp>;
};


export type Query_RootSigning_Template_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Order_By>>;
  where?: InputMaybe<Signing_Template_Bool_Exp>;
};


export type Query_RootSigning_Template_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSigning_Template_EquivalentsArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Equivalents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Equivalents_Order_By>>;
  where?: InputMaybe<Signing_Template_Equivalents_Bool_Exp>;
};


export type Query_RootSigning_Template_Equivalents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Equivalents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Equivalents_Order_By>>;
  where?: InputMaybe<Signing_Template_Equivalents_Bool_Exp>;
};


export type Query_RootSigning_Template_Equivalents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSigning_Template_KindArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Kind_Order_By>>;
  where?: InputMaybe<Signing_Template_Kind_Bool_Exp>;
};


export type Query_RootSigning_Template_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Kind_Order_By>>;
  where?: InputMaybe<Signing_Template_Kind_Bool_Exp>;
};


export type Query_RootSigning_Template_Kind_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootSigning_Template_Source_FilesArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Source_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Source_Files_Order_By>>;
  where?: InputMaybe<Signing_Template_Source_Files_Bool_Exp>;
};


export type Query_RootSigning_Template_Source_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Source_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Source_Files_Order_By>>;
  where?: InputMaybe<Signing_Template_Source_Files_Bool_Exp>;
};


export type Query_RootSigning_Template_Source_Files_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSigning_Vansanity_TemplateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Vansanity_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Vansanity_Template_Order_By>>;
  where?: InputMaybe<Signing_Vansanity_Template_Bool_Exp>;
};


export type Query_RootSigning_Vansanity_Template_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Vansanity_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Vansanity_Template_Order_By>>;
  where?: InputMaybe<Signing_Vansanity_Template_Bool_Exp>;
};


export type Query_RootSigning_Vansanity_Template_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSigning_Webhook_EventArgs = {
  distinct_on?: InputMaybe<Array<Signing_Webhook_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Webhook_Event_Order_By>>;
  where?: InputMaybe<Signing_Webhook_Event_Bool_Exp>;
};


export type Query_RootSigning_Webhook_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Webhook_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Webhook_Event_Order_By>>;
  where?: InputMaybe<Signing_Webhook_Event_Bool_Exp>;
};


export type Query_RootSigning_Webhook_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSigning_Webhook_Event_TypeArgs = {
  distinct_on?: InputMaybe<Array<Signing_Webhook_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Webhook_Event_Type_Order_By>>;
  where?: InputMaybe<Signing_Webhook_Event_Type_Bool_Exp>;
};


export type Query_RootSigning_Webhook_Event_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Webhook_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Webhook_Event_Type_Order_By>>;
  where?: InputMaybe<Signing_Webhook_Event_Type_Bool_Exp>;
};


export type Query_RootSigning_Webhook_Event_Type_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootSquare_Credential_Ownership_EnumArgs = {
  distinct_on?: InputMaybe<Array<Square_Credential_Ownership_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Square_Credential_Ownership_Enum_Order_By>>;
  where?: InputMaybe<Square_Credential_Ownership_Enum_Bool_Exp>;
};


export type Query_RootSquare_Credential_Ownership_Enum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Square_Credential_Ownership_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Square_Credential_Ownership_Enum_Order_By>>;
  where?: InputMaybe<Square_Credential_Ownership_Enum_Bool_Exp>;
};


export type Query_RootSquare_Credential_Ownership_Enum_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootSquare_CredentialsArgs = {
  distinct_on?: InputMaybe<Array<Square_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Square_Credentials_Order_By>>;
  where?: InputMaybe<Square_Credentials_Bool_Exp>;
};


export type Query_RootSquare_Credentials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Square_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Square_Credentials_Order_By>>;
  where?: InputMaybe<Square_Credentials_Bool_Exp>;
};


export type Query_RootSquare_Credentials_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSupervisor_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Bool_Exp>;
};


export type Query_RootSupervisor_Provider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Bool_Exp>;
};


export type Query_RootSupervisor_Provider_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSupervisor_Provider_Initiated_ByArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Initiated_By_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Initiated_By_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Initiated_By_Bool_Exp>;
};


export type Query_RootSupervisor_Provider_Initiated_By_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Initiated_By_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Initiated_By_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Initiated_By_Bool_Exp>;
};


export type Query_RootSupervisor_Provider_Initiated_By_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootSupervisor_Provider_TermArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Term_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Term_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Term_Bool_Exp>;
};


export type Query_RootSupervisor_Provider_Term_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Term_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Term_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Term_Bool_Exp>;
};


export type Query_RootSupervisor_Provider_Term_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSupervisor_Provider_Term_Ended_ByArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Term_Ended_By_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Term_Ended_By_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Term_Ended_By_Bool_Exp>;
};


export type Query_RootSupervisor_Provider_Term_Ended_By_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Term_Ended_By_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Term_Ended_By_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Term_Ended_By_Bool_Exp>;
};


export type Query_RootSupervisor_Provider_Term_Ended_By_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootSupervisor_Review_Queue_ItemArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Item_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Item_Bool_Exp>;
};


export type Query_RootSupervisor_Review_Queue_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Item_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Item_Bool_Exp>;
};


export type Query_RootSupervisor_Review_Queue_Item_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSupervisor_Review_Queue_Item_Status_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Item_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Item_Status_History_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Bool_Exp>;
};


export type Query_RootSupervisor_Review_Queue_Item_Status_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Item_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Item_Status_History_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Bool_Exp>;
};


export type Query_RootSupervisor_Review_Queue_Item_Status_History_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSupervisor_Review_Queue_SourceArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Source_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Source_Bool_Exp>;
};


export type Query_RootSupervisor_Review_Queue_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Source_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Source_Bool_Exp>;
};


export type Query_RootSupervisor_Review_Queue_Source_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootSupervisor_Review_Queue_StatusArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Status_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Status_Bool_Exp>;
};


export type Query_RootSupervisor_Review_Queue_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Status_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Status_Bool_Exp>;
};


export type Query_RootSupervisor_Review_Queue_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootSupervisor_Sampling_Period_TypeArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Sampling_Period_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Sampling_Period_Type_Order_By>>;
  where?: InputMaybe<Supervisor_Sampling_Period_Type_Bool_Exp>;
};


export type Query_RootSupervisor_Sampling_Period_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Sampling_Period_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Sampling_Period_Type_Order_By>>;
  where?: InputMaybe<Supervisor_Sampling_Period_Type_Bool_Exp>;
};


export type Query_RootSupervisor_Sampling_Period_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootSupervisor_SettingArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Setting_Order_By>>;
  where?: InputMaybe<Supervisor_Setting_Bool_Exp>;
};


export type Query_RootSupervisor_Setting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Setting_Order_By>>;
  where?: InputMaybe<Supervisor_Setting_Bool_Exp>;
};


export type Query_RootSupervisor_Setting_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTax_RateArgs = {
  distinct_on?: InputMaybe<Array<Tax_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tax_Rate_Order_By>>;
  where?: InputMaybe<Tax_Rate_Bool_Exp>;
};


export type Query_RootTax_Rate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tax_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tax_Rate_Order_By>>;
  where?: InputMaybe<Tax_Rate_Bool_Exp>;
};


export type Query_RootTax_Rate_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTax_TypeArgs = {
  distinct_on?: InputMaybe<Array<Tax_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tax_Type_Order_By>>;
  where?: InputMaybe<Tax_Type_Bool_Exp>;
};


export type Query_RootTax_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tax_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tax_Type_Order_By>>;
  where?: InputMaybe<Tax_Type_Bool_Exp>;
};


export type Query_RootTax_Type_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_AgreementsArgs = {
  distinct_on?: InputMaybe<Array<User_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Agreements_Order_By>>;
  where?: InputMaybe<User_Agreements_Bool_Exp>;
};


export type Query_RootUser_Agreements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Agreements_Order_By>>;
  where?: InputMaybe<User_Agreements_Bool_Exp>;
};


export type Query_RootUser_Agreements_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_ConsentArgs = {
  distinct_on?: InputMaybe<Array<User_Consent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Consent_Order_By>>;
  where?: InputMaybe<User_Consent_Bool_Exp>;
};


export type Query_RootUser_Consent_ActionArgs = {
  distinct_on?: InputMaybe<Array<User_Consent_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Consent_Action_Order_By>>;
  where?: InputMaybe<User_Consent_Action_Bool_Exp>;
};


export type Query_RootUser_Consent_Action_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Consent_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Consent_Action_Order_By>>;
  where?: InputMaybe<User_Consent_Action_Bool_Exp>;
};


export type Query_RootUser_Consent_Action_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootUser_Consent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Consent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Consent_Order_By>>;
  where?: InputMaybe<User_Consent_Bool_Exp>;
};


export type Query_RootUser_Consent_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_Consent_TypeArgs = {
  distinct_on?: InputMaybe<Array<User_Consent_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Consent_Type_Order_By>>;
  where?: InputMaybe<User_Consent_Type_Bool_Exp>;
};


export type Query_RootUser_Consent_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Consent_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Consent_Type_Order_By>>;
  where?: InputMaybe<User_Consent_Type_Bool_Exp>;
};


export type Query_RootUser_Consent_Type_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootUser_Device_Push_Notification_TokenArgs = {
  distinct_on?: InputMaybe<Array<User_Device_Push_Notification_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Device_Push_Notification_Token_Order_By>>;
  where?: InputMaybe<User_Device_Push_Notification_Token_Bool_Exp>;
};


export type Query_RootUser_Device_Push_Notification_Token_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Device_Push_Notification_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Device_Push_Notification_Token_Order_By>>;
  where?: InputMaybe<User_Device_Push_Notification_Token_Bool_Exp>;
};


export type Query_RootUser_Device_Push_Notification_Token_By_PkArgs = {
  token: Scalars['String'];
  user: Scalars['uuid'];
};


export type Query_RootUser_DocumentArgs = {
  distinct_on?: InputMaybe<Array<User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Document_Order_By>>;
  where?: InputMaybe<User_Document_Bool_Exp>;
};


export type Query_RootUser_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Document_Order_By>>;
  where?: InputMaybe<User_Document_Bool_Exp>;
};


export type Query_RootUser_Document_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_LocationArgs = {
  distinct_on?: InputMaybe<Array<User_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Location_Order_By>>;
  where?: InputMaybe<User_Location_Bool_Exp>;
};


export type Query_RootUser_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Location_Order_By>>;
  where?: InputMaybe<User_Location_Bool_Exp>;
};


export type Query_RootUser_Location_By_PkArgs = {
  location: Scalars['uuid'];
  user: Scalars['uuid'];
};


export type Query_RootUser_PlanArgs = {
  distinct_on?: InputMaybe<Array<User_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Plan_Order_By>>;
  where?: InputMaybe<User_Plan_Bool_Exp>;
};


export type Query_RootUser_Plan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Plan_Order_By>>;
  where?: InputMaybe<User_Plan_Bool_Exp>;
};


export type Query_RootUser_Plan_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUsers_Unfulfilled_Product_Purchases_Count_By_LocationArgs = {
  args: Users_Unfulfilled_Product_Purchases_Count_By_Location_Args;
  distinct_on?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Order_By>>;
  where?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp>;
};


export type Query_RootUsers_Unfulfilled_Product_Purchases_Count_By_Location_AggregateArgs = {
  args: Users_Unfulfilled_Product_Purchases_Count_By_Location_Args;
  distinct_on?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Order_By>>;
  where?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp>;
};


export type Query_RootVersionArgs = {
  distinct_on?: InputMaybe<Array<Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Version_Order_By>>;
  where?: InputMaybe<Version_Bool_Exp>;
};


export type Query_RootVersion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Version_Order_By>>;
  where?: InputMaybe<Version_Bool_Exp>;
};


export type Query_RootVersion_By_PkArgs = {
  providerAppAndroid: Scalars['numeric'];
  providerAppIos: Scalars['String'];
};

/** columns and relationships of "rental_volume_discount" */
export type Rental_Volume_Discount = {
  __typename?: 'rental_volume_discount';
  created_at: Scalars['timestamptz'];
  discountRate: Scalars['Int'];
  hours: Scalars['Int'];
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "rental_volume_discount" */
export type Rental_Volume_Discount_Aggregate = {
  __typename?: 'rental_volume_discount_aggregate';
  aggregate?: Maybe<Rental_Volume_Discount_Aggregate_Fields>;
  nodes: Array<Rental_Volume_Discount>;
};

/** aggregate fields of "rental_volume_discount" */
export type Rental_Volume_Discount_Aggregate_Fields = {
  __typename?: 'rental_volume_discount_aggregate_fields';
  avg?: Maybe<Rental_Volume_Discount_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Rental_Volume_Discount_Max_Fields>;
  min?: Maybe<Rental_Volume_Discount_Min_Fields>;
  stddev?: Maybe<Rental_Volume_Discount_Stddev_Fields>;
  stddev_pop?: Maybe<Rental_Volume_Discount_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Rental_Volume_Discount_Stddev_Samp_Fields>;
  sum?: Maybe<Rental_Volume_Discount_Sum_Fields>;
  var_pop?: Maybe<Rental_Volume_Discount_Var_Pop_Fields>;
  var_samp?: Maybe<Rental_Volume_Discount_Var_Samp_Fields>;
  variance?: Maybe<Rental_Volume_Discount_Variance_Fields>;
};


/** aggregate fields of "rental_volume_discount" */
export type Rental_Volume_Discount_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rental_Volume_Discount_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Rental_Volume_Discount_Avg_Fields = {
  __typename?: 'rental_volume_discount_avg_fields';
  discountRate?: Maybe<Scalars['Float']>;
  hours?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "rental_volume_discount". All fields are combined with a logical 'AND'. */
export type Rental_Volume_Discount_Bool_Exp = {
  _and?: InputMaybe<Array<Rental_Volume_Discount_Bool_Exp>>;
  _not?: InputMaybe<Rental_Volume_Discount_Bool_Exp>;
  _or?: InputMaybe<Array<Rental_Volume_Discount_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  discountRate?: InputMaybe<Int_Comparison_Exp>;
  hours?: InputMaybe<Int_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "rental_volume_discount" */
export enum Rental_Volume_Discount_Constraint {
  /** unique or primary key constraint on columns "hours", "location" */
  RentalVolumeDiscountPkey = 'rental_volume_discount_pkey'
}

/** input type for incrementing numeric columns in table "rental_volume_discount" */
export type Rental_Volume_Discount_Inc_Input = {
  discountRate?: InputMaybe<Scalars['Int']>;
  hours?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "rental_volume_discount" */
export type Rental_Volume_Discount_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discountRate?: InputMaybe<Scalars['Int']>;
  hours?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Rental_Volume_Discount_Max_Fields = {
  __typename?: 'rental_volume_discount_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  discountRate?: Maybe<Scalars['Int']>;
  hours?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Rental_Volume_Discount_Min_Fields = {
  __typename?: 'rental_volume_discount_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  discountRate?: Maybe<Scalars['Int']>;
  hours?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "rental_volume_discount" */
export type Rental_Volume_Discount_Mutation_Response = {
  __typename?: 'rental_volume_discount_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Rental_Volume_Discount>;
};

/** on_conflict condition type for table "rental_volume_discount" */
export type Rental_Volume_Discount_On_Conflict = {
  constraint: Rental_Volume_Discount_Constraint;
  update_columns?: Array<Rental_Volume_Discount_Update_Column>;
  where?: InputMaybe<Rental_Volume_Discount_Bool_Exp>;
};

/** Ordering options when selecting data from "rental_volume_discount". */
export type Rental_Volume_Discount_Order_By = {
  created_at?: InputMaybe<Order_By>;
  discountRate?: InputMaybe<Order_By>;
  hours?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rental_volume_discount */
export type Rental_Volume_Discount_Pk_Columns_Input = {
  hours: Scalars['Int'];
  location: Scalars['uuid'];
};

/** select columns of table "rental_volume_discount" */
export enum Rental_Volume_Discount_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountRate = 'discountRate',
  /** column name */
  Hours = 'hours',
  /** column name */
  Location = 'location',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "rental_volume_discount" */
export type Rental_Volume_Discount_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discountRate?: InputMaybe<Scalars['Int']>;
  hours?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Rental_Volume_Discount_Stddev_Fields = {
  __typename?: 'rental_volume_discount_stddev_fields';
  discountRate?: Maybe<Scalars['Float']>;
  hours?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Rental_Volume_Discount_Stddev_Pop_Fields = {
  __typename?: 'rental_volume_discount_stddev_pop_fields';
  discountRate?: Maybe<Scalars['Float']>;
  hours?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Rental_Volume_Discount_Stddev_Samp_Fields = {
  __typename?: 'rental_volume_discount_stddev_samp_fields';
  discountRate?: Maybe<Scalars['Float']>;
  hours?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "rental_volume_discount" */
export type Rental_Volume_Discount_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rental_Volume_Discount_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rental_Volume_Discount_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discountRate?: InputMaybe<Scalars['Int']>;
  hours?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Rental_Volume_Discount_Sum_Fields = {
  __typename?: 'rental_volume_discount_sum_fields';
  discountRate?: Maybe<Scalars['Int']>;
  hours?: Maybe<Scalars['Int']>;
};

/** update columns of table "rental_volume_discount" */
export enum Rental_Volume_Discount_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountRate = 'discountRate',
  /** column name */
  Hours = 'hours',
  /** column name */
  Location = 'location',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Rental_Volume_Discount_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rental_Volume_Discount_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rental_Volume_Discount_Set_Input>;
  /** filter the rows which have to be updated */
  where: Rental_Volume_Discount_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Rental_Volume_Discount_Var_Pop_Fields = {
  __typename?: 'rental_volume_discount_var_pop_fields';
  discountRate?: Maybe<Scalars['Float']>;
  hours?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Rental_Volume_Discount_Var_Samp_Fields = {
  __typename?: 'rental_volume_discount_var_samp_fields';
  discountRate?: Maybe<Scalars['Float']>;
  hours?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Rental_Volume_Discount_Variance_Fields = {
  __typename?: 'rental_volume_discount_variance_fields';
  discountRate?: Maybe<Scalars['Float']>;
  hours?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "repeating" */
export type Repeating = {
  __typename?: 'repeating';
  created_at: Scalars['timestamptz'];
  cutoff_at?: Maybe<Scalars['timestamptz']>;
  duration: Scalars['interval'];
  frequency: Scalars['String'];
  id: Scalars['uuid'];
  /** An array relationship */
  opens: Array<Open>;
  /** An aggregate relationship */
  opens_aggregate: Open_Aggregate;
  start_at: Scalars['timestamptz'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "repeating" */
export type RepeatingOpensArgs = {
  distinct_on?: InputMaybe<Array<Open_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Open_Order_By>>;
  where?: InputMaybe<Open_Bool_Exp>;
};


/** columns and relationships of "repeating" */
export type RepeatingOpens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Open_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Open_Order_By>>;
  where?: InputMaybe<Open_Bool_Exp>;
};

/** aggregated selection of "repeating" */
export type Repeating_Aggregate = {
  __typename?: 'repeating_aggregate';
  aggregate?: Maybe<Repeating_Aggregate_Fields>;
  nodes: Array<Repeating>;
};

/** aggregate fields of "repeating" */
export type Repeating_Aggregate_Fields = {
  __typename?: 'repeating_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Repeating_Max_Fields>;
  min?: Maybe<Repeating_Min_Fields>;
};


/** aggregate fields of "repeating" */
export type Repeating_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Repeating_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "repeating". All fields are combined with a logical 'AND'. */
export type Repeating_Bool_Exp = {
  _and?: InputMaybe<Array<Repeating_Bool_Exp>>;
  _not?: InputMaybe<Repeating_Bool_Exp>;
  _or?: InputMaybe<Array<Repeating_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  cutoff_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  duration?: InputMaybe<Interval_Comparison_Exp>;
  frequency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  opens?: InputMaybe<Open_Bool_Exp>;
  opens_aggregate?: InputMaybe<Open_Aggregate_Bool_Exp>;
  start_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "repeating" */
export enum Repeating_Constraint {
  /** unique or primary key constraint on columns "id" */
  RepeatingPkey = 'repeating_pkey'
}

/** input type for inserting data into table "repeating" */
export type Repeating_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  cutoff_at?: InputMaybe<Scalars['timestamptz']>;
  duration?: InputMaybe<Scalars['interval']>;
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  opens?: InputMaybe<Open_Arr_Rel_Insert_Input>;
  start_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Repeating_Max_Fields = {
  __typename?: 'repeating_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  cutoff_at?: Maybe<Scalars['timestamptz']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  start_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Repeating_Min_Fields = {
  __typename?: 'repeating_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  cutoff_at?: Maybe<Scalars['timestamptz']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  start_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "repeating" */
export type Repeating_Mutation_Response = {
  __typename?: 'repeating_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Repeating>;
};

/** input type for inserting object relation for remote table "repeating" */
export type Repeating_Obj_Rel_Insert_Input = {
  data: Repeating_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Repeating_On_Conflict>;
};

/** on_conflict condition type for table "repeating" */
export type Repeating_On_Conflict = {
  constraint: Repeating_Constraint;
  update_columns?: Array<Repeating_Update_Column>;
  where?: InputMaybe<Repeating_Bool_Exp>;
};

/** Ordering options when selecting data from "repeating". */
export type Repeating_Order_By = {
  created_at?: InputMaybe<Order_By>;
  cutoff_at?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  opens_aggregate?: InputMaybe<Open_Aggregate_Order_By>;
  start_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: repeating */
export type Repeating_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "repeating" */
export enum Repeating_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CutoffAt = 'cutoff_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  StartAt = 'start_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "repeating" */
export type Repeating_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  cutoff_at?: InputMaybe<Scalars['timestamptz']>;
  duration?: InputMaybe<Scalars['interval']>;
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  start_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "repeating" */
export type Repeating_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Repeating_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Repeating_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  cutoff_at?: InputMaybe<Scalars['timestamptz']>;
  duration?: InputMaybe<Scalars['interval']>;
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  start_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "repeating" */
export enum Repeating_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CutoffAt = 'cutoff_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  StartAt = 'start_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Repeating_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Repeating_Set_Input>;
  /** filter the rows which have to be updated */
  where: Repeating_Bool_Exp;
};

/** columns and relationships of "report_preference" */
export type Report_Preference = {
  __typename?: 'report_preference';
  additionalEmailRecipients: Scalars['String'];
  enabled: Scalars['Boolean'];
  frequency?: Maybe<Scalars['interval']>;
  location: Scalars['uuid'];
  owningUser: Scalars['uuid'];
  /** An object relationship */
  report_type: Report_Type;
  type: Report_Type_Enum;
  /** An object relationship */
  user: User;
};

/** aggregated selection of "report_preference" */
export type Report_Preference_Aggregate = {
  __typename?: 'report_preference_aggregate';
  aggregate?: Maybe<Report_Preference_Aggregate_Fields>;
  nodes: Array<Report_Preference>;
};

/** aggregate fields of "report_preference" */
export type Report_Preference_Aggregate_Fields = {
  __typename?: 'report_preference_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Report_Preference_Max_Fields>;
  min?: Maybe<Report_Preference_Min_Fields>;
};


/** aggregate fields of "report_preference" */
export type Report_Preference_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Report_Preference_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "report_preference". All fields are combined with a logical 'AND'. */
export type Report_Preference_Bool_Exp = {
  _and?: InputMaybe<Array<Report_Preference_Bool_Exp>>;
  _not?: InputMaybe<Report_Preference_Bool_Exp>;
  _or?: InputMaybe<Array<Report_Preference_Bool_Exp>>;
  additionalEmailRecipients?: InputMaybe<String_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  frequency?: InputMaybe<Interval_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  owningUser?: InputMaybe<Uuid_Comparison_Exp>;
  report_type?: InputMaybe<Report_Type_Bool_Exp>;
  type?: InputMaybe<Report_Type_Enum_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "report_preference" */
export enum Report_Preference_Constraint {
  /** unique or primary key constraint on columns "type", "owning_user", "location" */
  ReportPreferencesPkey = 'report_preferences_pkey'
}

/** input type for inserting data into table "report_preference" */
export type Report_Preference_Insert_Input = {
  additionalEmailRecipients?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  frequency?: InputMaybe<Scalars['interval']>;
  location?: InputMaybe<Scalars['uuid']>;
  owningUser?: InputMaybe<Scalars['uuid']>;
  report_type?: InputMaybe<Report_Type_Obj_Rel_Insert_Input>;
  type?: InputMaybe<Report_Type_Enum>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Report_Preference_Max_Fields = {
  __typename?: 'report_preference_max_fields';
  additionalEmailRecipients?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['uuid']>;
  owningUser?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Report_Preference_Min_Fields = {
  __typename?: 'report_preference_min_fields';
  additionalEmailRecipients?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['uuid']>;
  owningUser?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "report_preference" */
export type Report_Preference_Mutation_Response = {
  __typename?: 'report_preference_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Report_Preference>;
};

/** on_conflict condition type for table "report_preference" */
export type Report_Preference_On_Conflict = {
  constraint: Report_Preference_Constraint;
  update_columns?: Array<Report_Preference_Update_Column>;
  where?: InputMaybe<Report_Preference_Bool_Exp>;
};

/** Ordering options when selecting data from "report_preference". */
export type Report_Preference_Order_By = {
  additionalEmailRecipients?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  owningUser?: InputMaybe<Order_By>;
  report_type?: InputMaybe<Report_Type_Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: report_preference */
export type Report_Preference_Pk_Columns_Input = {
  location: Scalars['uuid'];
  owningUser: Scalars['uuid'];
  type: Report_Type_Enum;
};

/** select columns of table "report_preference" */
export enum Report_Preference_Select_Column {
  /** column name */
  AdditionalEmailRecipients = 'additionalEmailRecipients',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Location = 'location',
  /** column name */
  OwningUser = 'owningUser',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "report_preference" */
export type Report_Preference_Set_Input = {
  additionalEmailRecipients?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  frequency?: InputMaybe<Scalars['interval']>;
  location?: InputMaybe<Scalars['uuid']>;
  owningUser?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Report_Type_Enum>;
};

/** Streaming cursor of the table "report_preference" */
export type Report_Preference_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Report_Preference_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Report_Preference_Stream_Cursor_Value_Input = {
  additionalEmailRecipients?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  frequency?: InputMaybe<Scalars['interval']>;
  location?: InputMaybe<Scalars['uuid']>;
  owningUser?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Report_Type_Enum>;
};

/** update columns of table "report_preference" */
export enum Report_Preference_Update_Column {
  /** column name */
  AdditionalEmailRecipients = 'additionalEmailRecipients',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Location = 'location',
  /** column name */
  OwningUser = 'owningUser',
  /** column name */
  Type = 'type'
}

export type Report_Preference_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Report_Preference_Set_Input>;
  /** filter the rows which have to be updated */
  where: Report_Preference_Bool_Exp;
};

/** columns and relationships of "report_type" */
export type Report_Type = {
  __typename?: 'report_type';
  type: Scalars['String'];
};

/** aggregated selection of "report_type" */
export type Report_Type_Aggregate = {
  __typename?: 'report_type_aggregate';
  aggregate?: Maybe<Report_Type_Aggregate_Fields>;
  nodes: Array<Report_Type>;
};

/** aggregate fields of "report_type" */
export type Report_Type_Aggregate_Fields = {
  __typename?: 'report_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Report_Type_Max_Fields>;
  min?: Maybe<Report_Type_Min_Fields>;
};


/** aggregate fields of "report_type" */
export type Report_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Report_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "report_type". All fields are combined with a logical 'AND'. */
export type Report_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Report_Type_Bool_Exp>>;
  _not?: InputMaybe<Report_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Report_Type_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "report_type" */
export enum Report_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  ReportTypePkey = 'report_type_pkey'
}

export enum Report_Type_Enum {
  BillingReport = 'BILLING_REPORT'
}

/** Boolean expression to compare columns of type "report_type_enum". All fields are combined with logical 'AND'. */
export type Report_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Report_Type_Enum>;
  _in?: InputMaybe<Array<Report_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Report_Type_Enum>;
  _nin?: InputMaybe<Array<Report_Type_Enum>>;
};

/** input type for inserting data into table "report_type" */
export type Report_Type_Insert_Input = {
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Report_Type_Max_Fields = {
  __typename?: 'report_type_max_fields';
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Report_Type_Min_Fields = {
  __typename?: 'report_type_min_fields';
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "report_type" */
export type Report_Type_Mutation_Response = {
  __typename?: 'report_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Report_Type>;
};

/** input type for inserting object relation for remote table "report_type" */
export type Report_Type_Obj_Rel_Insert_Input = {
  data: Report_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Report_Type_On_Conflict>;
};

/** on_conflict condition type for table "report_type" */
export type Report_Type_On_Conflict = {
  constraint: Report_Type_Constraint;
  update_columns?: Array<Report_Type_Update_Column>;
  where?: InputMaybe<Report_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "report_type". */
export type Report_Type_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: report_type */
export type Report_Type_Pk_Columns_Input = {
  type: Scalars['String'];
};

/** select columns of table "report_type" */
export enum Report_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "report_type" */
export type Report_Type_Set_Input = {
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "report_type" */
export type Report_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Report_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Report_Type_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "report_type" */
export enum Report_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Report_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Report_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Report_Type_Bool_Exp;
};

/** columns and relationships of "role" */
export type Role = {
  __typename?: 'role';
  id: Scalars['String'];
  /** An array relationship */
  role_notifications: Array<Role_Notification>;
  /** An aggregate relationship */
  role_notifications_aggregate: Role_Notification_Aggregate;
  /** An array relationship */
  users: Array<User>;
  /** An aggregate relationship */
  users_aggregate: User_Aggregate;
};


/** columns and relationships of "role" */
export type RoleRole_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Role_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Notification_Order_By>>;
  where?: InputMaybe<Role_Notification_Bool_Exp>;
};


/** columns and relationships of "role" */
export type RoleRole_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Notification_Order_By>>;
  where?: InputMaybe<Role_Notification_Bool_Exp>;
};


/** columns and relationships of "role" */
export type RoleUsersArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


/** columns and relationships of "role" */
export type RoleUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** aggregated selection of "role" */
export type Role_Aggregate = {
  __typename?: 'role_aggregate';
  aggregate?: Maybe<Role_Aggregate_Fields>;
  nodes: Array<Role>;
};

/** aggregate fields of "role" */
export type Role_Aggregate_Fields = {
  __typename?: 'role_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Role_Max_Fields>;
  min?: Maybe<Role_Min_Fields>;
};


/** aggregate fields of "role" */
export type Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "role". All fields are combined with a logical 'AND'. */
export type Role_Bool_Exp = {
  _and?: InputMaybe<Array<Role_Bool_Exp>>;
  _not?: InputMaybe<Role_Bool_Exp>;
  _or?: InputMaybe<Array<Role_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  role_notifications?: InputMaybe<Role_Notification_Bool_Exp>;
  role_notifications_aggregate?: InputMaybe<Role_Notification_Aggregate_Bool_Exp>;
  users?: InputMaybe<User_Bool_Exp>;
  users_aggregate?: InputMaybe<User_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "role" */
export enum Role_Constraint {
  /** unique or primary key constraint on columns "id" */
  RolePkey = 'role_pkey'
}

export enum Role_Enum {
  Anonymous = 'Anonymous',
  LocationAdmin = 'LocationAdmin',
  Manager = 'Manager',
  MedicalSupervisor = 'MedicalSupervisor',
  ProductOnlyLocationAdmin = 'ProductOnlyLocationAdmin',
  Provider = 'Provider',
  ReadOnlyAdmin = 'ReadOnlyAdmin',
  VansanityAdmin = 'VansanityAdmin'
}

/** Boolean expression to compare columns of type "role_enum". All fields are combined with logical 'AND'. */
export type Role_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Role_Enum>;
  _in?: InputMaybe<Array<Role_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Role_Enum>;
  _nin?: InputMaybe<Array<Role_Enum>>;
};

/** input type for inserting data into table "role" */
export type Role_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
  role_notifications?: InputMaybe<Role_Notification_Arr_Rel_Insert_Input>;
  users?: InputMaybe<User_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Role_Max_Fields = {
  __typename?: 'role_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Role_Min_Fields = {
  __typename?: 'role_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "role" */
export type Role_Mutation_Response = {
  __typename?: 'role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Role>;
};

/** columns and relationships of "role_notification" */
export type Role_Notification = {
  __typename?: 'role_notification';
  broadcastType: Notification_Broadcast_Type_Enum;
  medspa_only: Scalars['Boolean'];
  /** An object relationship */
  notificationTypeByType: Notification_Type;
  notification_type: Scalars['String'];
  role: Scalars['String'];
};

/** aggregated selection of "role_notification" */
export type Role_Notification_Aggregate = {
  __typename?: 'role_notification_aggregate';
  aggregate?: Maybe<Role_Notification_Aggregate_Fields>;
  nodes: Array<Role_Notification>;
};

export type Role_Notification_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Role_Notification_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Role_Notification_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Role_Notification_Aggregate_Bool_Exp_Count>;
};

export type Role_Notification_Aggregate_Bool_Exp_Bool_And = {
  arguments: Role_Notification_Select_Column_Role_Notification_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Role_Notification_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Role_Notification_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Role_Notification_Select_Column_Role_Notification_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Role_Notification_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Role_Notification_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Role_Notification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Role_Notification_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "role_notification" */
export type Role_Notification_Aggregate_Fields = {
  __typename?: 'role_notification_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Role_Notification_Max_Fields>;
  min?: Maybe<Role_Notification_Min_Fields>;
};


/** aggregate fields of "role_notification" */
export type Role_Notification_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Role_Notification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "role_notification" */
export type Role_Notification_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Role_Notification_Max_Order_By>;
  min?: InputMaybe<Role_Notification_Min_Order_By>;
};

/** input type for inserting array relation for remote table "role_notification" */
export type Role_Notification_Arr_Rel_Insert_Input = {
  data: Array<Role_Notification_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Role_Notification_On_Conflict>;
};

/** Boolean expression to filter rows from the table "role_notification". All fields are combined with a logical 'AND'. */
export type Role_Notification_Bool_Exp = {
  _and?: InputMaybe<Array<Role_Notification_Bool_Exp>>;
  _not?: InputMaybe<Role_Notification_Bool_Exp>;
  _or?: InputMaybe<Array<Role_Notification_Bool_Exp>>;
  broadcastType?: InputMaybe<Notification_Broadcast_Type_Enum_Comparison_Exp>;
  medspa_only?: InputMaybe<Boolean_Comparison_Exp>;
  notificationTypeByType?: InputMaybe<Notification_Type_Bool_Exp>;
  notification_type?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "role_notification" */
export enum Role_Notification_Constraint {
  /** unique or primary key constraint on columns "notification_type", "broadcast_type", "role" */
  RoleNotificationPkey = 'role_notification_pkey'
}

/** input type for inserting data into table "role_notification" */
export type Role_Notification_Insert_Input = {
  broadcastType?: InputMaybe<Notification_Broadcast_Type_Enum>;
  medspa_only?: InputMaybe<Scalars['Boolean']>;
  notificationTypeByType?: InputMaybe<Notification_Type_Obj_Rel_Insert_Input>;
  notification_type?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Role_Notification_Max_Fields = {
  __typename?: 'role_notification_max_fields';
  notification_type?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "role_notification" */
export type Role_Notification_Max_Order_By = {
  notification_type?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Role_Notification_Min_Fields = {
  __typename?: 'role_notification_min_fields';
  notification_type?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "role_notification" */
export type Role_Notification_Min_Order_By = {
  notification_type?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "role_notification" */
export type Role_Notification_Mutation_Response = {
  __typename?: 'role_notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Role_Notification>;
};

/** on_conflict condition type for table "role_notification" */
export type Role_Notification_On_Conflict = {
  constraint: Role_Notification_Constraint;
  update_columns?: Array<Role_Notification_Update_Column>;
  where?: InputMaybe<Role_Notification_Bool_Exp>;
};

/** Ordering options when selecting data from "role_notification". */
export type Role_Notification_Order_By = {
  broadcastType?: InputMaybe<Order_By>;
  medspa_only?: InputMaybe<Order_By>;
  notificationTypeByType?: InputMaybe<Notification_Type_Order_By>;
  notification_type?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** primary key columns input for table: role_notification */
export type Role_Notification_Pk_Columns_Input = {
  broadcastType: Notification_Broadcast_Type_Enum;
  notification_type: Scalars['String'];
  role: Scalars['String'];
};

/** select columns of table "role_notification" */
export enum Role_Notification_Select_Column {
  /** column name */
  BroadcastType = 'broadcastType',
  /** column name */
  MedspaOnly = 'medspa_only',
  /** column name */
  NotificationType = 'notification_type',
  /** column name */
  Role = 'role'
}

/** select "role_notification_aggregate_bool_exp_bool_and_arguments_columns" columns of table "role_notification" */
export enum Role_Notification_Select_Column_Role_Notification_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  MedspaOnly = 'medspa_only'
}

/** select "role_notification_aggregate_bool_exp_bool_or_arguments_columns" columns of table "role_notification" */
export enum Role_Notification_Select_Column_Role_Notification_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  MedspaOnly = 'medspa_only'
}

/** input type for updating data in table "role_notification" */
export type Role_Notification_Set_Input = {
  broadcastType?: InputMaybe<Notification_Broadcast_Type_Enum>;
  medspa_only?: InputMaybe<Scalars['Boolean']>;
  notification_type?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "role_notification" */
export type Role_Notification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Role_Notification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Role_Notification_Stream_Cursor_Value_Input = {
  broadcastType?: InputMaybe<Notification_Broadcast_Type_Enum>;
  medspa_only?: InputMaybe<Scalars['Boolean']>;
  notification_type?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
};

/** update columns of table "role_notification" */
export enum Role_Notification_Update_Column {
  /** column name */
  BroadcastType = 'broadcastType',
  /** column name */
  MedspaOnly = 'medspa_only',
  /** column name */
  NotificationType = 'notification_type',
  /** column name */
  Role = 'role'
}

export type Role_Notification_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Role_Notification_Set_Input>;
  /** filter the rows which have to be updated */
  where: Role_Notification_Bool_Exp;
};

/** input type for inserting object relation for remote table "role" */
export type Role_Obj_Rel_Insert_Input = {
  data: Role_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Role_On_Conflict>;
};

/** on_conflict condition type for table "role" */
export type Role_On_Conflict = {
  constraint: Role_Constraint;
  update_columns?: Array<Role_Update_Column>;
  where?: InputMaybe<Role_Bool_Exp>;
};

/** Ordering options when selecting data from "role". */
export type Role_Order_By = {
  id?: InputMaybe<Order_By>;
  role_notifications_aggregate?: InputMaybe<Role_Notification_Aggregate_Order_By>;
  users_aggregate?: InputMaybe<User_Aggregate_Order_By>;
};

/** primary key columns input for table: role */
export type Role_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "role" */
export enum Role_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "role" */
export type Role_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "role" */
export type Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Role_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "role" */
export enum Role_Update_Column {
  /** column name */
  Id = 'id'
}

export type Role_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: Role_Bool_Exp;
};

/** columns and relationships of "room" */
export type Room = {
  __typename?: 'room';
  allowVolumeDiscount: Scalars['Boolean'];
  /** An array relationship */
  bookings: Array<Booking>;
  /** An array relationship */
  bookingsPublic: Array<Booking_Public>;
  /** An aggregate relationship */
  bookingsPublic_aggregate: Booking_Public_Aggregate;
  /** An aggregate relationship */
  bookings_aggregate: Booking_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  /** An array relationship */
  location_procedure_rooms: Array<Location_Procedure_Room>;
  /** An aggregate relationship */
  location_procedure_rooms_aggregate: Location_Procedure_Room_Aggregate;
  monthlyRate?: Maybe<Scalars['Int']>;
  monthlyRateNonMedical?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
  rate: Scalars['Int'];
  /** An array relationship */
  roomModels: Array<Room_Model>;
  /** An aggregate relationship */
  roomModels_aggregate: Room_Model_Aggregate;
  roomType?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  roomTypeByRoomType?: Maybe<Room_Type>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weeklyRate?: Maybe<Scalars['Int']>;
  weeklyRateNonMedical?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "room" */
export type RoomBookingsArgs = {
  distinct_on?: InputMaybe<Array<Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Order_By>>;
  where?: InputMaybe<Booking_Bool_Exp>;
};


/** columns and relationships of "room" */
export type RoomBookingsPublicArgs = {
  distinct_on?: InputMaybe<Array<Booking_Public_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Public_Order_By>>;
  where?: InputMaybe<Booking_Public_Bool_Exp>;
};


/** columns and relationships of "room" */
export type RoomBookingsPublic_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Booking_Public_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Public_Order_By>>;
  where?: InputMaybe<Booking_Public_Bool_Exp>;
};


/** columns and relationships of "room" */
export type RoomBookings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Order_By>>;
  where?: InputMaybe<Booking_Bool_Exp>;
};


/** columns and relationships of "room" */
export type RoomLocation_Procedure_RoomsArgs = {
  distinct_on?: InputMaybe<Array<Location_Procedure_Room_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Procedure_Room_Order_By>>;
  where?: InputMaybe<Location_Procedure_Room_Bool_Exp>;
};


/** columns and relationships of "room" */
export type RoomLocation_Procedure_Rooms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Procedure_Room_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Procedure_Room_Order_By>>;
  where?: InputMaybe<Location_Procedure_Room_Bool_Exp>;
};


/** columns and relationships of "room" */
export type RoomRoomModelsArgs = {
  distinct_on?: InputMaybe<Array<Room_Model_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Model_Order_By>>;
  where?: InputMaybe<Room_Model_Bool_Exp>;
};


/** columns and relationships of "room" */
export type RoomRoomModels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Room_Model_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Model_Order_By>>;
  where?: InputMaybe<Room_Model_Bool_Exp>;
};

/** aggregated selection of "room" */
export type Room_Aggregate = {
  __typename?: 'room_aggregate';
  aggregate?: Maybe<Room_Aggregate_Fields>;
  nodes: Array<Room>;
};

export type Room_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Room_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Room_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Room_Aggregate_Bool_Exp_Count>;
};

export type Room_Aggregate_Bool_Exp_Bool_And = {
  arguments: Room_Select_Column_Room_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Room_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Room_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Room_Select_Column_Room_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Room_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Room_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Room_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Room_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "room" */
export type Room_Aggregate_Fields = {
  __typename?: 'room_aggregate_fields';
  avg?: Maybe<Room_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Room_Max_Fields>;
  min?: Maybe<Room_Min_Fields>;
  stddev?: Maybe<Room_Stddev_Fields>;
  stddev_pop?: Maybe<Room_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Room_Stddev_Samp_Fields>;
  sum?: Maybe<Room_Sum_Fields>;
  var_pop?: Maybe<Room_Var_Pop_Fields>;
  var_samp?: Maybe<Room_Var_Samp_Fields>;
  variance?: Maybe<Room_Variance_Fields>;
};


/** aggregate fields of "room" */
export type Room_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Room_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "room" */
export type Room_Aggregate_Order_By = {
  avg?: InputMaybe<Room_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Room_Max_Order_By>;
  min?: InputMaybe<Room_Min_Order_By>;
  stddev?: InputMaybe<Room_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Room_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Room_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Room_Sum_Order_By>;
  var_pop?: InputMaybe<Room_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Room_Var_Samp_Order_By>;
  variance?: InputMaybe<Room_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "room" */
export type Room_Arr_Rel_Insert_Input = {
  data: Array<Room_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Room_On_Conflict>;
};

/** aggregate avg on columns */
export type Room_Avg_Fields = {
  __typename?: 'room_avg_fields';
  monthlyRate?: Maybe<Scalars['Float']>;
  monthlyRateNonMedical?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  weeklyRate?: Maybe<Scalars['Float']>;
  weeklyRateNonMedical?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "room" */
export type Room_Avg_Order_By = {
  monthlyRate?: InputMaybe<Order_By>;
  monthlyRateNonMedical?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  weeklyRate?: InputMaybe<Order_By>;
  weeklyRateNonMedical?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "room". All fields are combined with a logical 'AND'. */
export type Room_Bool_Exp = {
  _and?: InputMaybe<Array<Room_Bool_Exp>>;
  _not?: InputMaybe<Room_Bool_Exp>;
  _or?: InputMaybe<Array<Room_Bool_Exp>>;
  allowVolumeDiscount?: InputMaybe<Boolean_Comparison_Exp>;
  bookings?: InputMaybe<Booking_Bool_Exp>;
  bookingsPublic?: InputMaybe<Booking_Public_Bool_Exp>;
  bookingsPublic_aggregate?: InputMaybe<Booking_Public_Aggregate_Bool_Exp>;
  bookings_aggregate?: InputMaybe<Booking_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  location_procedure_rooms?: InputMaybe<Location_Procedure_Room_Bool_Exp>;
  location_procedure_rooms_aggregate?: InputMaybe<Location_Procedure_Room_Aggregate_Bool_Exp>;
  monthlyRate?: InputMaybe<Int_Comparison_Exp>;
  monthlyRateNonMedical?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photoS3Key?: InputMaybe<Uuid_Comparison_Exp>;
  rate?: InputMaybe<Int_Comparison_Exp>;
  roomModels?: InputMaybe<Room_Model_Bool_Exp>;
  roomModels_aggregate?: InputMaybe<Room_Model_Aggregate_Bool_Exp>;
  roomType?: InputMaybe<Uuid_Comparison_Exp>;
  roomTypeByRoomType?: InputMaybe<Room_Type_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  weeklyRate?: InputMaybe<Int_Comparison_Exp>;
  weeklyRateNonMedical?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "room" */
export enum Room_Constraint {
  /** unique or primary key constraint on columns "name", "location" */
  NameUnique = 'name_unique',
  /** unique or primary key constraint on columns "id" */
  RoomPkey = 'room_pkey'
}

/** input type for incrementing numeric columns in table "room" */
export type Room_Inc_Input = {
  monthlyRate?: InputMaybe<Scalars['Int']>;
  monthlyRateNonMedical?: InputMaybe<Scalars['Int']>;
  rate?: InputMaybe<Scalars['Int']>;
  weeklyRate?: InputMaybe<Scalars['Int']>;
  weeklyRateNonMedical?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "room" */
export type Room_Insert_Input = {
  allowVolumeDiscount?: InputMaybe<Scalars['Boolean']>;
  bookings?: InputMaybe<Booking_Arr_Rel_Insert_Input>;
  bookingsPublic?: InputMaybe<Booking_Public_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  location_procedure_rooms?: InputMaybe<Location_Procedure_Room_Arr_Rel_Insert_Input>;
  monthlyRate?: InputMaybe<Scalars['Int']>;
  monthlyRateNonMedical?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  rate?: InputMaybe<Scalars['Int']>;
  roomModels?: InputMaybe<Room_Model_Arr_Rel_Insert_Input>;
  roomType?: InputMaybe<Scalars['uuid']>;
  roomTypeByRoomType?: InputMaybe<Room_Type_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weeklyRate?: InputMaybe<Scalars['Int']>;
  weeklyRateNonMedical?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Room_Max_Fields = {
  __typename?: 'room_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  monthlyRate?: Maybe<Scalars['Int']>;
  monthlyRateNonMedical?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
  rate?: Maybe<Scalars['Int']>;
  roomType?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weeklyRate?: Maybe<Scalars['Int']>;
  weeklyRateNonMedical?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "room" */
export type Room_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  monthlyRate?: InputMaybe<Order_By>;
  monthlyRateNonMedical?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photoS3Key?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  roomType?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weeklyRate?: InputMaybe<Order_By>;
  weeklyRateNonMedical?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Room_Min_Fields = {
  __typename?: 'room_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  monthlyRate?: Maybe<Scalars['Int']>;
  monthlyRateNonMedical?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
  rate?: Maybe<Scalars['Int']>;
  roomType?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weeklyRate?: Maybe<Scalars['Int']>;
  weeklyRateNonMedical?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "room" */
export type Room_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  monthlyRate?: InputMaybe<Order_By>;
  monthlyRateNonMedical?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photoS3Key?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  roomType?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weeklyRate?: InputMaybe<Order_By>;
  weeklyRateNonMedical?: InputMaybe<Order_By>;
};

/** columns and relationships of "room_model" */
export type Room_Model = {
  __typename?: 'room_model';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  model: Scalars['uuid'];
  /** An object relationship */
  modelByModel: Model;
  room: Scalars['uuid'];
  /** An object relationship */
  roomByRoom: Room;
  timespan: Scalars['tstzrange'];
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  timespan_upper?: Maybe<Scalars['timestamptz']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "room_model" */
export type Room_Model_Aggregate = {
  __typename?: 'room_model_aggregate';
  aggregate?: Maybe<Room_Model_Aggregate_Fields>;
  nodes: Array<Room_Model>;
};

export type Room_Model_Aggregate_Bool_Exp = {
  count?: InputMaybe<Room_Model_Aggregate_Bool_Exp_Count>;
};

export type Room_Model_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Room_Model_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Room_Model_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "room_model" */
export type Room_Model_Aggregate_Fields = {
  __typename?: 'room_model_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Room_Model_Max_Fields>;
  min?: Maybe<Room_Model_Min_Fields>;
};


/** aggregate fields of "room_model" */
export type Room_Model_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Room_Model_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "room_model" */
export type Room_Model_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Room_Model_Max_Order_By>;
  min?: InputMaybe<Room_Model_Min_Order_By>;
};

/** input type for inserting array relation for remote table "room_model" */
export type Room_Model_Arr_Rel_Insert_Input = {
  data: Array<Room_Model_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Room_Model_On_Conflict>;
};

/** Boolean expression to filter rows from the table "room_model". All fields are combined with a logical 'AND'. */
export type Room_Model_Bool_Exp = {
  _and?: InputMaybe<Array<Room_Model_Bool_Exp>>;
  _not?: InputMaybe<Room_Model_Bool_Exp>;
  _or?: InputMaybe<Array<Room_Model_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  model?: InputMaybe<Uuid_Comparison_Exp>;
  modelByModel?: InputMaybe<Model_Bool_Exp>;
  room?: InputMaybe<Uuid_Comparison_Exp>;
  roomByRoom?: InputMaybe<Room_Bool_Exp>;
  timespan?: InputMaybe<Tstzrange_Comparison_Exp>;
  timespan_lower?: InputMaybe<Timestamptz_Comparison_Exp>;
  timespan_upper?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "room_model" */
export enum Room_Model_Constraint {
  /** unique or primary key constraint on columns "id" */
  RoomModelPkey = 'room_model_pkey'
}

/** input type for inserting data into table "room_model" */
export type Room_Model_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  model?: InputMaybe<Scalars['uuid']>;
  modelByModel?: InputMaybe<Model_Obj_Rel_Insert_Input>;
  room?: InputMaybe<Scalars['uuid']>;
  roomByRoom?: InputMaybe<Room_Obj_Rel_Insert_Input>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Room_Model_Max_Fields = {
  __typename?: 'room_model_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  model?: Maybe<Scalars['uuid']>;
  room?: Maybe<Scalars['uuid']>;
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  timespan_upper?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "room_model" */
export type Room_Model_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  room?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Room_Model_Min_Fields = {
  __typename?: 'room_model_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  model?: Maybe<Scalars['uuid']>;
  room?: Maybe<Scalars['uuid']>;
  timespan_lower?: Maybe<Scalars['timestamptz']>;
  timespan_upper?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "room_model" */
export type Room_Model_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  room?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "room_model" */
export type Room_Model_Mutation_Response = {
  __typename?: 'room_model_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Room_Model>;
};

/** on_conflict condition type for table "room_model" */
export type Room_Model_On_Conflict = {
  constraint: Room_Model_Constraint;
  update_columns?: Array<Room_Model_Update_Column>;
  where?: InputMaybe<Room_Model_Bool_Exp>;
};

/** Ordering options when selecting data from "room_model". */
export type Room_Model_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  modelByModel?: InputMaybe<Model_Order_By>;
  room?: InputMaybe<Order_By>;
  roomByRoom?: InputMaybe<Room_Order_By>;
  timespan?: InputMaybe<Order_By>;
  timespan_lower?: InputMaybe<Order_By>;
  timespan_upper?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: room_model */
export type Room_Model_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "room_model" */
export enum Room_Model_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Model = 'model',
  /** column name */
  Room = 'room',
  /** column name */
  Timespan = 'timespan',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "room_model" */
export type Room_Model_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  model?: InputMaybe<Scalars['uuid']>;
  room?: InputMaybe<Scalars['uuid']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "room_model" */
export type Room_Model_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Room_Model_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Room_Model_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  model?: InputMaybe<Scalars['uuid']>;
  room?: InputMaybe<Scalars['uuid']>;
  timespan?: InputMaybe<Scalars['tstzrange']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "room_model" */
export enum Room_Model_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Model = 'model',
  /** column name */
  Room = 'room',
  /** column name */
  Timespan = 'timespan',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Room_Model_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Room_Model_Set_Input>;
  /** filter the rows which have to be updated */
  where: Room_Model_Bool_Exp;
};

/** response of any mutation on the table "room" */
export type Room_Mutation_Response = {
  __typename?: 'room_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Room>;
};

/** input type for inserting object relation for remote table "room" */
export type Room_Obj_Rel_Insert_Input = {
  data: Room_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Room_On_Conflict>;
};

/** on_conflict condition type for table "room" */
export type Room_On_Conflict = {
  constraint: Room_Constraint;
  update_columns?: Array<Room_Update_Column>;
  where?: InputMaybe<Room_Bool_Exp>;
};

/** Ordering options when selecting data from "room". */
export type Room_Order_By = {
  allowVolumeDiscount?: InputMaybe<Order_By>;
  bookingsPublic_aggregate?: InputMaybe<Booking_Public_Aggregate_Order_By>;
  bookings_aggregate?: InputMaybe<Booking_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  location_procedure_rooms_aggregate?: InputMaybe<Location_Procedure_Room_Aggregate_Order_By>;
  monthlyRate?: InputMaybe<Order_By>;
  monthlyRateNonMedical?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photoS3Key?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  roomModels_aggregate?: InputMaybe<Room_Model_Aggregate_Order_By>;
  roomType?: InputMaybe<Order_By>;
  roomTypeByRoomType?: InputMaybe<Room_Type_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weeklyRate?: InputMaybe<Order_By>;
  weeklyRateNonMedical?: InputMaybe<Order_By>;
};

/** primary key columns input for table: room */
export type Room_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "room" */
export enum Room_Select_Column {
  /** column name */
  AllowVolumeDiscount = 'allowVolumeDiscount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  MonthlyRate = 'monthlyRate',
  /** column name */
  MonthlyRateNonMedical = 'monthlyRateNonMedical',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoS3Key = 'photoS3Key',
  /** column name */
  Rate = 'rate',
  /** column name */
  RoomType = 'roomType',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeeklyRate = 'weeklyRate',
  /** column name */
  WeeklyRateNonMedical = 'weeklyRateNonMedical'
}

/** select "room_aggregate_bool_exp_bool_and_arguments_columns" columns of table "room" */
export enum Room_Select_Column_Room_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AllowVolumeDiscount = 'allowVolumeDiscount'
}

/** select "room_aggregate_bool_exp_bool_or_arguments_columns" columns of table "room" */
export enum Room_Select_Column_Room_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AllowVolumeDiscount = 'allowVolumeDiscount'
}

/** input type for updating data in table "room" */
export type Room_Set_Input = {
  allowVolumeDiscount?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  monthlyRate?: InputMaybe<Scalars['Int']>;
  monthlyRateNonMedical?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  rate?: InputMaybe<Scalars['Int']>;
  roomType?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weeklyRate?: InputMaybe<Scalars['Int']>;
  weeklyRateNonMedical?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Room_Stddev_Fields = {
  __typename?: 'room_stddev_fields';
  monthlyRate?: Maybe<Scalars['Float']>;
  monthlyRateNonMedical?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  weeklyRate?: Maybe<Scalars['Float']>;
  weeklyRateNonMedical?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "room" */
export type Room_Stddev_Order_By = {
  monthlyRate?: InputMaybe<Order_By>;
  monthlyRateNonMedical?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  weeklyRate?: InputMaybe<Order_By>;
  weeklyRateNonMedical?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Room_Stddev_Pop_Fields = {
  __typename?: 'room_stddev_pop_fields';
  monthlyRate?: Maybe<Scalars['Float']>;
  monthlyRateNonMedical?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  weeklyRate?: Maybe<Scalars['Float']>;
  weeklyRateNonMedical?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "room" */
export type Room_Stddev_Pop_Order_By = {
  monthlyRate?: InputMaybe<Order_By>;
  monthlyRateNonMedical?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  weeklyRate?: InputMaybe<Order_By>;
  weeklyRateNonMedical?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Room_Stddev_Samp_Fields = {
  __typename?: 'room_stddev_samp_fields';
  monthlyRate?: Maybe<Scalars['Float']>;
  monthlyRateNonMedical?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  weeklyRate?: Maybe<Scalars['Float']>;
  weeklyRateNonMedical?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "room" */
export type Room_Stddev_Samp_Order_By = {
  monthlyRate?: InputMaybe<Order_By>;
  monthlyRateNonMedical?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  weeklyRate?: InputMaybe<Order_By>;
  weeklyRateNonMedical?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "room" */
export type Room_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Room_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Room_Stream_Cursor_Value_Input = {
  allowVolumeDiscount?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  monthlyRate?: InputMaybe<Scalars['Int']>;
  monthlyRateNonMedical?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  photoS3Key?: InputMaybe<Scalars['uuid']>;
  rate?: InputMaybe<Scalars['Int']>;
  roomType?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weeklyRate?: InputMaybe<Scalars['Int']>;
  weeklyRateNonMedical?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Room_Sum_Fields = {
  __typename?: 'room_sum_fields';
  monthlyRate?: Maybe<Scalars['Int']>;
  monthlyRateNonMedical?: Maybe<Scalars['Int']>;
  rate?: Maybe<Scalars['Int']>;
  weeklyRate?: Maybe<Scalars['Int']>;
  weeklyRateNonMedical?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "room" */
export type Room_Sum_Order_By = {
  monthlyRate?: InputMaybe<Order_By>;
  monthlyRateNonMedical?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  weeklyRate?: InputMaybe<Order_By>;
  weeklyRateNonMedical?: InputMaybe<Order_By>;
};

/** columns and relationships of "room_type" */
export type Room_Type = {
  __typename?: 'room_type';
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  name: Scalars['String'];
  /** An array relationship */
  rooms: Array<Room>;
  /** An aggregate relationship */
  rooms_aggregate: Room_Aggregate;
};


/** columns and relationships of "room_type" */
export type Room_TypeRoomsArgs = {
  distinct_on?: InputMaybe<Array<Room_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Order_By>>;
  where?: InputMaybe<Room_Bool_Exp>;
};


/** columns and relationships of "room_type" */
export type Room_TypeRooms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Room_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Order_By>>;
  where?: InputMaybe<Room_Bool_Exp>;
};

/** aggregated selection of "room_type" */
export type Room_Type_Aggregate = {
  __typename?: 'room_type_aggregate';
  aggregate?: Maybe<Room_Type_Aggregate_Fields>;
  nodes: Array<Room_Type>;
};

/** aggregate fields of "room_type" */
export type Room_Type_Aggregate_Fields = {
  __typename?: 'room_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Room_Type_Max_Fields>;
  min?: Maybe<Room_Type_Min_Fields>;
};


/** aggregate fields of "room_type" */
export type Room_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Room_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "room_type". All fields are combined with a logical 'AND'. */
export type Room_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Room_Type_Bool_Exp>>;
  _not?: InputMaybe<Room_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Room_Type_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  rooms?: InputMaybe<Room_Bool_Exp>;
  rooms_aggregate?: InputMaybe<Room_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "room_type" */
export enum Room_Type_Constraint {
  /** unique or primary key constraint on columns "name", "location" */
  RoomTypeLocationNameKey = 'room_type_location_name_key',
  /** unique or primary key constraint on columns "id" */
  RoomTypePkey = 'room_type_pkey'
}

/** input type for inserting data into table "room_type" */
export type Room_Type_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  rooms?: InputMaybe<Room_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Room_Type_Max_Fields = {
  __typename?: 'room_type_max_fields';
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Room_Type_Min_Fields = {
  __typename?: 'room_type_min_fields';
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "room_type" */
export type Room_Type_Mutation_Response = {
  __typename?: 'room_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Room_Type>;
};

/** input type for inserting object relation for remote table "room_type" */
export type Room_Type_Obj_Rel_Insert_Input = {
  data: Room_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Room_Type_On_Conflict>;
};

/** on_conflict condition type for table "room_type" */
export type Room_Type_On_Conflict = {
  constraint: Room_Type_Constraint;
  update_columns?: Array<Room_Type_Update_Column>;
  where?: InputMaybe<Room_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "room_type". */
export type Room_Type_Order_By = {
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  name?: InputMaybe<Order_By>;
  rooms_aggregate?: InputMaybe<Room_Aggregate_Order_By>;
};

/** primary key columns input for table: room_type */
export type Room_Type_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "room_type" */
export enum Room_Type_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "room_type" */
export type Room_Type_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "room_type" */
export type Room_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Room_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Room_Type_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "room_type" */
export enum Room_Type_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name'
}

export type Room_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Room_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Room_Type_Bool_Exp;
};

/** update columns of table "room" */
export enum Room_Update_Column {
  /** column name */
  AllowVolumeDiscount = 'allowVolumeDiscount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  MonthlyRate = 'monthlyRate',
  /** column name */
  MonthlyRateNonMedical = 'monthlyRateNonMedical',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoS3Key = 'photoS3Key',
  /** column name */
  Rate = 'rate',
  /** column name */
  RoomType = 'roomType',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeeklyRate = 'weeklyRate',
  /** column name */
  WeeklyRateNonMedical = 'weeklyRateNonMedical'
}

export type Room_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Room_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Room_Set_Input>;
  /** filter the rows which have to be updated */
  where: Room_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Room_Var_Pop_Fields = {
  __typename?: 'room_var_pop_fields';
  monthlyRate?: Maybe<Scalars['Float']>;
  monthlyRateNonMedical?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  weeklyRate?: Maybe<Scalars['Float']>;
  weeklyRateNonMedical?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "room" */
export type Room_Var_Pop_Order_By = {
  monthlyRate?: InputMaybe<Order_By>;
  monthlyRateNonMedical?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  weeklyRate?: InputMaybe<Order_By>;
  weeklyRateNonMedical?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Room_Var_Samp_Fields = {
  __typename?: 'room_var_samp_fields';
  monthlyRate?: Maybe<Scalars['Float']>;
  monthlyRateNonMedical?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  weeklyRate?: Maybe<Scalars['Float']>;
  weeklyRateNonMedical?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "room" */
export type Room_Var_Samp_Order_By = {
  monthlyRate?: InputMaybe<Order_By>;
  monthlyRateNonMedical?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  weeklyRate?: InputMaybe<Order_By>;
  weeklyRateNonMedical?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Room_Variance_Fields = {
  __typename?: 'room_variance_fields';
  monthlyRate?: Maybe<Scalars['Float']>;
  monthlyRateNonMedical?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  weeklyRate?: Maybe<Scalars['Float']>;
  weeklyRateNonMedical?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "room" */
export type Room_Variance_Order_By = {
  monthlyRate?: InputMaybe<Order_By>;
  monthlyRateNonMedical?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  weeklyRate?: InputMaybe<Order_By>;
  weeklyRateNonMedical?: InputMaybe<Order_By>;
};

/** columns and relationships of "sex" */
export type Sex = {
  __typename?: 'sex';
  sex: Scalars['String'];
};

/** aggregated selection of "sex" */
export type Sex_Aggregate = {
  __typename?: 'sex_aggregate';
  aggregate?: Maybe<Sex_Aggregate_Fields>;
  nodes: Array<Sex>;
};

/** aggregate fields of "sex" */
export type Sex_Aggregate_Fields = {
  __typename?: 'sex_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Sex_Max_Fields>;
  min?: Maybe<Sex_Min_Fields>;
};


/** aggregate fields of "sex" */
export type Sex_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sex_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "sex". All fields are combined with a logical 'AND'. */
export type Sex_Bool_Exp = {
  _and?: InputMaybe<Array<Sex_Bool_Exp>>;
  _not?: InputMaybe<Sex_Bool_Exp>;
  _or?: InputMaybe<Array<Sex_Bool_Exp>>;
  sex?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "sex" */
export enum Sex_Constraint {
  /** unique or primary key constraint on columns "sex" */
  SexPkey = 'sex_pkey'
}

export enum Sex_Enum {
  Female = 'Female',
  Intersex = 'Intersex',
  Male = 'Male',
  PreferNotToSay = 'Prefer_Not_To_Say'
}

/** Boolean expression to compare columns of type "sex_enum". All fields are combined with logical 'AND'. */
export type Sex_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Sex_Enum>;
  _in?: InputMaybe<Array<Sex_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Sex_Enum>;
  _nin?: InputMaybe<Array<Sex_Enum>>;
};

/** input type for inserting data into table "sex" */
export type Sex_Insert_Input = {
  sex?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Sex_Max_Fields = {
  __typename?: 'sex_max_fields';
  sex?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Sex_Min_Fields = {
  __typename?: 'sex_min_fields';
  sex?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "sex" */
export type Sex_Mutation_Response = {
  __typename?: 'sex_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sex>;
};

/** input type for inserting object relation for remote table "sex" */
export type Sex_Obj_Rel_Insert_Input = {
  data: Sex_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sex_On_Conflict>;
};

/** on_conflict condition type for table "sex" */
export type Sex_On_Conflict = {
  constraint: Sex_Constraint;
  update_columns?: Array<Sex_Update_Column>;
  where?: InputMaybe<Sex_Bool_Exp>;
};

/** Ordering options when selecting data from "sex". */
export type Sex_Order_By = {
  sex?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sex */
export type Sex_Pk_Columns_Input = {
  sex: Scalars['String'];
};

/** select columns of table "sex" */
export enum Sex_Select_Column {
  /** column name */
  Sex = 'sex'
}

/** input type for updating data in table "sex" */
export type Sex_Set_Input = {
  sex?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "sex" */
export type Sex_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sex_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sex_Stream_Cursor_Value_Input = {
  sex?: InputMaybe<Scalars['String']>;
};

/** update columns of table "sex" */
export enum Sex_Update_Column {
  /** column name */
  Sex = 'sex'
}

export type Sex_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sex_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sex_Bool_Exp;
};

export type SigningDocumentIdOutput = {
  __typename?: 'signingDocumentIdOutput';
  id: Scalars['uuid'];
};

/** Corresponds to doc on the signeasy side, sent to a user.  */
export type Signing_Document = {
  __typename?: 'signing_document';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  externalId: Scalars['String'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  patient?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  patientByPatient?: Maybe<Patient>;
  recipientSignedAt?: Maybe<Scalars['timestamptz']>;
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount: Scalars['Int'];
  senderSignedAt?: Maybe<Scalars['timestamptz']>;
  /** Timestamp when the document was sent for signing (from webhook events) */
  sentAt?: Maybe<Scalars['timestamptz']>;
  /** Timestamp when the document was signed (from webhook events) */
  signedAt?: Maybe<Scalars['timestamptz']>;
  signerUser?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  signingDocumenStatusTypeBysigningDocumenStatusType: Signing_Document_Status_Type;
  signingTemplate: Scalars['uuid'];
  /** An object relationship */
  signingTemplateBySigningTemplate: Signing_Template;
  /** An array relationship */
  signingWebhookEvents: Array<Signing_Webhook_Event>;
  /** An aggregate relationship */
  signingWebhookEvents_aggregate: Signing_Webhook_Event_Aggregate;
  /** The *signing* status, which is derived from webhooks from the signing Saas partner */
  status: Signing_Document_Status_Type_Enum;
  updatedAt: Scalars['timestamptz'];
  user: Scalars['uuid'];
  /** An object relationship */
  userBySignerUser?: Maybe<User>;
  /** An object relationship */
  userByUser: User;
  /** True iff the doc has a patient, has been signed (DOCUMENT_COMPLETED webhook received), and the calling supervisor either has an accepted term with the patient's provider that is open or ended on or after the signing, or currently supervises someone at the patient's location and that location is MEDSPA. Always false for SUPERVISOR_FORM documents and for unsigned documents. */
  visibleToSupervisor?: Maybe<Scalars['Boolean']>;
};


/** Corresponds to doc on the signeasy side, sent to a user.  */
export type Signing_DocumentSigningWebhookEventsArgs = {
  distinct_on?: InputMaybe<Array<Signing_Webhook_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Webhook_Event_Order_By>>;
  where?: InputMaybe<Signing_Webhook_Event_Bool_Exp>;
};


/** Corresponds to doc on the signeasy side, sent to a user.  */
export type Signing_DocumentSigningWebhookEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Webhook_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Webhook_Event_Order_By>>;
  where?: InputMaybe<Signing_Webhook_Event_Bool_Exp>;
};

/** aggregated selection of "signing_document" */
export type Signing_Document_Aggregate = {
  __typename?: 'signing_document_aggregate';
  aggregate?: Maybe<Signing_Document_Aggregate_Fields>;
  nodes: Array<Signing_Document>;
};

export type Signing_Document_Aggregate_Bool_Exp = {
  count?: InputMaybe<Signing_Document_Aggregate_Bool_Exp_Count>;
};

export type Signing_Document_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Signing_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Signing_Document_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "signing_document" */
export type Signing_Document_Aggregate_Fields = {
  __typename?: 'signing_document_aggregate_fields';
  avg?: Maybe<Signing_Document_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Signing_Document_Max_Fields>;
  min?: Maybe<Signing_Document_Min_Fields>;
  stddev?: Maybe<Signing_Document_Stddev_Fields>;
  stddev_pop?: Maybe<Signing_Document_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Signing_Document_Stddev_Samp_Fields>;
  sum?: Maybe<Signing_Document_Sum_Fields>;
  var_pop?: Maybe<Signing_Document_Var_Pop_Fields>;
  var_samp?: Maybe<Signing_Document_Var_Samp_Fields>;
  variance?: Maybe<Signing_Document_Variance_Fields>;
};


/** aggregate fields of "signing_document" */
export type Signing_Document_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Signing_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "signing_document" */
export type Signing_Document_Aggregate_Order_By = {
  avg?: InputMaybe<Signing_Document_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Signing_Document_Max_Order_By>;
  min?: InputMaybe<Signing_Document_Min_Order_By>;
  stddev?: InputMaybe<Signing_Document_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Signing_Document_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Signing_Document_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Signing_Document_Sum_Order_By>;
  var_pop?: InputMaybe<Signing_Document_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Signing_Document_Var_Samp_Order_By>;
  variance?: InputMaybe<Signing_Document_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "signing_document" */
export type Signing_Document_Arr_Rel_Insert_Input = {
  data: Array<Signing_Document_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Signing_Document_On_Conflict>;
};

/** aggregate avg on columns */
export type Signing_Document_Avg_Fields = {
  __typename?: 'signing_document_avg_fields';
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "signing_document" */
export type Signing_Document_Avg_Order_By = {
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "signing_document". All fields are combined with a logical 'AND'. */
export type Signing_Document_Bool_Exp = {
  _and?: InputMaybe<Array<Signing_Document_Bool_Exp>>;
  _not?: InputMaybe<Signing_Document_Bool_Exp>;
  _or?: InputMaybe<Array<Signing_Document_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  externalId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  patient?: InputMaybe<Uuid_Comparison_Exp>;
  patientByPatient?: InputMaybe<Patient_Bool_Exp>;
  recipientSignedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  resendCount?: InputMaybe<Int_Comparison_Exp>;
  senderSignedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  sentAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  signedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  signerUser?: InputMaybe<Uuid_Comparison_Exp>;
  signingDocumenStatusTypeBysigningDocumenStatusType?: InputMaybe<Signing_Document_Status_Type_Bool_Exp>;
  signingTemplate?: InputMaybe<Uuid_Comparison_Exp>;
  signingTemplateBySigningTemplate?: InputMaybe<Signing_Template_Bool_Exp>;
  signingWebhookEvents?: InputMaybe<Signing_Webhook_Event_Bool_Exp>;
  signingWebhookEvents_aggregate?: InputMaybe<Signing_Webhook_Event_Aggregate_Bool_Exp>;
  status?: InputMaybe<Signing_Document_Status_Type_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Uuid_Comparison_Exp>;
  userBySignerUser?: InputMaybe<User_Bool_Exp>;
  userByUser?: InputMaybe<User_Bool_Exp>;
  visibleToSupervisor?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "signing_document" */
export enum Signing_Document_Constraint {
  /** unique or primary key constraint on columns "external_id" */
  SigningDocumentExternalIdKey = 'signing_document_external_id_key',
  /** unique or primary key constraint on columns "id" */
  SigningDocumentPkey = 'signing_document_pkey'
}

/** input type for incrementing numeric columns in table "signing_document" */
export type Signing_Document_Inc_Input = {
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "signing_document" */
export type Signing_Document_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  patient?: InputMaybe<Scalars['uuid']>;
  patientByPatient?: InputMaybe<Patient_Obj_Rel_Insert_Input>;
  recipientSignedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: InputMaybe<Scalars['Int']>;
  senderSignedAt?: InputMaybe<Scalars['timestamptz']>;
  signerUser?: InputMaybe<Scalars['uuid']>;
  signingDocumenStatusTypeBysigningDocumenStatusType?: InputMaybe<Signing_Document_Status_Type_Obj_Rel_Insert_Input>;
  signingTemplate?: InputMaybe<Scalars['uuid']>;
  signingTemplateBySigningTemplate?: InputMaybe<Signing_Template_Obj_Rel_Insert_Input>;
  signingWebhookEvents?: InputMaybe<Signing_Webhook_Event_Arr_Rel_Insert_Input>;
  /** The *signing* status, which is derived from webhooks from the signing Saas partner */
  status?: InputMaybe<Signing_Document_Status_Type_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
  userBySignerUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Signing_Document_Max_Fields = {
  __typename?: 'signing_document_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  patient?: Maybe<Scalars['uuid']>;
  recipientSignedAt?: Maybe<Scalars['timestamptz']>;
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: Maybe<Scalars['Int']>;
  senderSignedAt?: Maybe<Scalars['timestamptz']>;
  /** Timestamp when the document was sent for signing (from webhook events) */
  sentAt?: Maybe<Scalars['timestamptz']>;
  /** Timestamp when the document was signed (from webhook events) */
  signedAt?: Maybe<Scalars['timestamptz']>;
  signerUser?: Maybe<Scalars['uuid']>;
  signingTemplate?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "signing_document" */
export type Signing_Document_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  externalId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  recipientSignedAt?: InputMaybe<Order_By>;
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: InputMaybe<Order_By>;
  senderSignedAt?: InputMaybe<Order_By>;
  signerUser?: InputMaybe<Order_By>;
  signingTemplate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Signing_Document_Min_Fields = {
  __typename?: 'signing_document_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  patient?: Maybe<Scalars['uuid']>;
  recipientSignedAt?: Maybe<Scalars['timestamptz']>;
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: Maybe<Scalars['Int']>;
  senderSignedAt?: Maybe<Scalars['timestamptz']>;
  /** Timestamp when the document was sent for signing (from webhook events) */
  sentAt?: Maybe<Scalars['timestamptz']>;
  /** Timestamp when the document was signed (from webhook events) */
  signedAt?: Maybe<Scalars['timestamptz']>;
  signerUser?: Maybe<Scalars['uuid']>;
  signingTemplate?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "signing_document" */
export type Signing_Document_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  externalId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  recipientSignedAt?: InputMaybe<Order_By>;
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: InputMaybe<Order_By>;
  senderSignedAt?: InputMaybe<Order_By>;
  signerUser?: InputMaybe<Order_By>;
  signingTemplate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "signing_document" */
export type Signing_Document_Mutation_Response = {
  __typename?: 'signing_document_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Signing_Document>;
};

/** input type for inserting object relation for remote table "signing_document" */
export type Signing_Document_Obj_Rel_Insert_Input = {
  data: Signing_Document_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Signing_Document_On_Conflict>;
};

/** on_conflict condition type for table "signing_document" */
export type Signing_Document_On_Conflict = {
  constraint: Signing_Document_Constraint;
  update_columns?: Array<Signing_Document_Update_Column>;
  where?: InputMaybe<Signing_Document_Bool_Exp>;
};

/** Ordering options when selecting data from "signing_document". */
export type Signing_Document_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  externalId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  patient?: InputMaybe<Order_By>;
  patientByPatient?: InputMaybe<Patient_Order_By>;
  recipientSignedAt?: InputMaybe<Order_By>;
  resendCount?: InputMaybe<Order_By>;
  senderSignedAt?: InputMaybe<Order_By>;
  sentAt?: InputMaybe<Order_By>;
  signedAt?: InputMaybe<Order_By>;
  signerUser?: InputMaybe<Order_By>;
  signingDocumenStatusTypeBysigningDocumenStatusType?: InputMaybe<Signing_Document_Status_Type_Order_By>;
  signingTemplate?: InputMaybe<Order_By>;
  signingTemplateBySigningTemplate?: InputMaybe<Signing_Template_Order_By>;
  signingWebhookEvents_aggregate?: InputMaybe<Signing_Webhook_Event_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  userBySignerUser?: InputMaybe<User_Order_By>;
  userByUser?: InputMaybe<User_Order_By>;
  visibleToSupervisor?: InputMaybe<Order_By>;
};

/** primary key columns input for table: signing_document */
export type Signing_Document_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "signing_document" */
export enum Signing_Document_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  ExternalId = 'externalId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Patient = 'patient',
  /** column name */
  RecipientSignedAt = 'recipientSignedAt',
  /** column name */
  ResendCount = 'resendCount',
  /** column name */
  SenderSignedAt = 'senderSignedAt',
  /** column name */
  SignerUser = 'signerUser',
  /** column name */
  SigningTemplate = 'signingTemplate',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  User = 'user'
}

/** input type for updating data in table "signing_document" */
export type Signing_Document_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  patient?: InputMaybe<Scalars['uuid']>;
  recipientSignedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: InputMaybe<Scalars['Int']>;
  senderSignedAt?: InputMaybe<Scalars['timestamptz']>;
  signerUser?: InputMaybe<Scalars['uuid']>;
  signingTemplate?: InputMaybe<Scalars['uuid']>;
  /** The *signing* status, which is derived from webhooks from the signing Saas partner */
  status?: InputMaybe<Signing_Document_Status_Type_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "signing_document_status_type" */
export type Signing_Document_Status_Type = {
  __typename?: 'signing_document_status_type';
  id: Scalars['String'];
};

/** aggregated selection of "signing_document_status_type" */
export type Signing_Document_Status_Type_Aggregate = {
  __typename?: 'signing_document_status_type_aggregate';
  aggregate?: Maybe<Signing_Document_Status_Type_Aggregate_Fields>;
  nodes: Array<Signing_Document_Status_Type>;
};

/** aggregate fields of "signing_document_status_type" */
export type Signing_Document_Status_Type_Aggregate_Fields = {
  __typename?: 'signing_document_status_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Signing_Document_Status_Type_Max_Fields>;
  min?: Maybe<Signing_Document_Status_Type_Min_Fields>;
};


/** aggregate fields of "signing_document_status_type" */
export type Signing_Document_Status_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Signing_Document_Status_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "signing_document_status_type". All fields are combined with a logical 'AND'. */
export type Signing_Document_Status_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Signing_Document_Status_Type_Bool_Exp>>;
  _not?: InputMaybe<Signing_Document_Status_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Signing_Document_Status_Type_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "signing_document_status_type" */
export enum Signing_Document_Status_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  SigningStatusTypePkey = 'signing_status_type_pkey'
}

export enum Signing_Document_Status_Type_Enum {
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Sent = 'SENT',
  Signed = 'SIGNED'
}

/** Boolean expression to compare columns of type "signing_document_status_type_enum". All fields are combined with logical 'AND'. */
export type Signing_Document_Status_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Signing_Document_Status_Type_Enum>;
  _in?: InputMaybe<Array<Signing_Document_Status_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Signing_Document_Status_Type_Enum>;
  _nin?: InputMaybe<Array<Signing_Document_Status_Type_Enum>>;
};

/** input type for inserting data into table "signing_document_status_type" */
export type Signing_Document_Status_Type_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Signing_Document_Status_Type_Max_Fields = {
  __typename?: 'signing_document_status_type_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Signing_Document_Status_Type_Min_Fields = {
  __typename?: 'signing_document_status_type_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "signing_document_status_type" */
export type Signing_Document_Status_Type_Mutation_Response = {
  __typename?: 'signing_document_status_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Signing_Document_Status_Type>;
};

/** input type for inserting object relation for remote table "signing_document_status_type" */
export type Signing_Document_Status_Type_Obj_Rel_Insert_Input = {
  data: Signing_Document_Status_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Signing_Document_Status_Type_On_Conflict>;
};

/** on_conflict condition type for table "signing_document_status_type" */
export type Signing_Document_Status_Type_On_Conflict = {
  constraint: Signing_Document_Status_Type_Constraint;
  update_columns?: Array<Signing_Document_Status_Type_Update_Column>;
  where?: InputMaybe<Signing_Document_Status_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "signing_document_status_type". */
export type Signing_Document_Status_Type_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: signing_document_status_type */
export type Signing_Document_Status_Type_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "signing_document_status_type" */
export enum Signing_Document_Status_Type_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "signing_document_status_type" */
export type Signing_Document_Status_Type_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "signing_document_status_type" */
export type Signing_Document_Status_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Signing_Document_Status_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Signing_Document_Status_Type_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "signing_document_status_type" */
export enum Signing_Document_Status_Type_Update_Column {
  /** column name */
  Id = 'id'
}

export type Signing_Document_Status_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Signing_Document_Status_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Signing_Document_Status_Type_Bool_Exp;
};

/** aggregate stddev on columns */
export type Signing_Document_Stddev_Fields = {
  __typename?: 'signing_document_stddev_fields';
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "signing_document" */
export type Signing_Document_Stddev_Order_By = {
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Signing_Document_Stddev_Pop_Fields = {
  __typename?: 'signing_document_stddev_pop_fields';
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "signing_document" */
export type Signing_Document_Stddev_Pop_Order_By = {
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Signing_Document_Stddev_Samp_Fields = {
  __typename?: 'signing_document_stddev_samp_fields';
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "signing_document" */
export type Signing_Document_Stddev_Samp_Order_By = {
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "signing_document" */
export type Signing_Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Signing_Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Signing_Document_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  patient?: InputMaybe<Scalars['uuid']>;
  recipientSignedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: InputMaybe<Scalars['Int']>;
  senderSignedAt?: InputMaybe<Scalars['timestamptz']>;
  signerUser?: InputMaybe<Scalars['uuid']>;
  signingTemplate?: InputMaybe<Scalars['uuid']>;
  /** The *signing* status, which is derived from webhooks from the signing Saas partner */
  status?: InputMaybe<Signing_Document_Status_Type_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Signing_Document_Sum_Fields = {
  __typename?: 'signing_document_sum_fields';
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "signing_document" */
export type Signing_Document_Sum_Order_By = {
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: InputMaybe<Order_By>;
};

/** update columns of table "signing_document" */
export enum Signing_Document_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  ExternalId = 'externalId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Patient = 'patient',
  /** column name */
  RecipientSignedAt = 'recipientSignedAt',
  /** column name */
  ResendCount = 'resendCount',
  /** column name */
  SenderSignedAt = 'senderSignedAt',
  /** column name */
  SignerUser = 'signerUser',
  /** column name */
  SigningTemplate = 'signingTemplate',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  User = 'user'
}

export type Signing_Document_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Signing_Document_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Signing_Document_Set_Input>;
  /** filter the rows which have to be updated */
  where: Signing_Document_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Signing_Document_Var_Pop_Fields = {
  __typename?: 'signing_document_var_pop_fields';
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "signing_document" */
export type Signing_Document_Var_Pop_Order_By = {
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Signing_Document_Var_Samp_Fields = {
  __typename?: 'signing_document_var_samp_fields';
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "signing_document" */
export type Signing_Document_Var_Samp_Order_By = {
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Signing_Document_Variance_Fields = {
  __typename?: 'signing_document_variance_fields';
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "signing_document" */
export type Signing_Document_Variance_Order_By = {
  /** Resends of this document's signing link counted against a demo location's send limit */
  resendCount?: InputMaybe<Order_By>;
};

/** The signing document types required to perform a given procedure, set per business unit. */
export type Signing_Procedure_Associated_Documents = {
  __typename?: 'signing_procedure_associated_documents';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  ehrProcedure: Scalars['uuid'];
  /** An object relationship */
  ehrProcedureByEhrProcedure: Ehr_Procedure;
  id: Scalars['uuid'];
  /** If fase, hardstops starting a procedure for a patient without the document */
  optional: Scalars['Boolean'];
  signingTemplate: Scalars['uuid'];
  /** An object relationship */
  signingTemplateBySigningTemplate: Signing_Template;
  updatedAt: Scalars['timestamptz'];
  /** Always populated from the creator, but only signifies owner at classic vansanity */
  user: Scalars['uuid'];
  /** An object relationship */
  userByUser: User;
};

/** aggregated selection of "signing_procedure_associated_documents" */
export type Signing_Procedure_Associated_Documents_Aggregate = {
  __typename?: 'signing_procedure_associated_documents_aggregate';
  aggregate?: Maybe<Signing_Procedure_Associated_Documents_Aggregate_Fields>;
  nodes: Array<Signing_Procedure_Associated_Documents>;
};

export type Signing_Procedure_Associated_Documents_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Signing_Procedure_Associated_Documents_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Signing_Procedure_Associated_Documents_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Signing_Procedure_Associated_Documents_Aggregate_Bool_Exp_Count>;
};

export type Signing_Procedure_Associated_Documents_Aggregate_Bool_Exp_Bool_And = {
  arguments: Signing_Procedure_Associated_Documents_Select_Column_Signing_Procedure_Associated_Documents_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Signing_Procedure_Associated_Documents_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Signing_Procedure_Associated_Documents_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Signing_Procedure_Associated_Documents_Select_Column_Signing_Procedure_Associated_Documents_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Signing_Procedure_Associated_Documents_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Signing_Procedure_Associated_Documents_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Signing_Procedure_Associated_Documents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "signing_procedure_associated_documents" */
export type Signing_Procedure_Associated_Documents_Aggregate_Fields = {
  __typename?: 'signing_procedure_associated_documents_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Signing_Procedure_Associated_Documents_Max_Fields>;
  min?: Maybe<Signing_Procedure_Associated_Documents_Min_Fields>;
};


/** aggregate fields of "signing_procedure_associated_documents" */
export type Signing_Procedure_Associated_Documents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "signing_procedure_associated_documents" */
export type Signing_Procedure_Associated_Documents_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Signing_Procedure_Associated_Documents_Max_Order_By>;
  min?: InputMaybe<Signing_Procedure_Associated_Documents_Min_Order_By>;
};

/** input type for inserting array relation for remote table "signing_procedure_associated_documents" */
export type Signing_Procedure_Associated_Documents_Arr_Rel_Insert_Input = {
  data: Array<Signing_Procedure_Associated_Documents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Signing_Procedure_Associated_Documents_On_Conflict>;
};

/** Boolean expression to filter rows from the table "signing_procedure_associated_documents". All fields are combined with a logical 'AND'. */
export type Signing_Procedure_Associated_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Bool_Exp>>;
  _not?: InputMaybe<Signing_Procedure_Associated_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrProcedure?: InputMaybe<Uuid_Comparison_Exp>;
  ehrProcedureByEhrProcedure?: InputMaybe<Ehr_Procedure_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  optional?: InputMaybe<Boolean_Comparison_Exp>;
  signingTemplate?: InputMaybe<Uuid_Comparison_Exp>;
  signingTemplateBySigningTemplate?: InputMaybe<Signing_Template_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Uuid_Comparison_Exp>;
  userByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "signing_procedure_associated_documents" */
export enum Signing_Procedure_Associated_Documents_Constraint {
  /** unique or primary key constraint on columns "signing_template", "ehr_procedure" */
  SigningProcedureAssociatedDocumentsUniqueLiveLink = 'signing_procedure_associated_documents_unique_live_link',
  /** unique or primary key constraint on columns "id" */
  SigningProcedureRequiredDocumentTypesPkey = 'signing_procedure_required_document_types_pkey'
}

/** input type for inserting data into table "signing_procedure_associated_documents" */
export type Signing_Procedure_Associated_Documents_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  ehrProcedure?: InputMaybe<Scalars['uuid']>;
  ehrProcedureByEhrProcedure?: InputMaybe<Ehr_Procedure_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  /** If fase, hardstops starting a procedure for a patient without the document */
  optional?: InputMaybe<Scalars['Boolean']>;
  signingTemplate?: InputMaybe<Scalars['uuid']>;
  signingTemplateBySigningTemplate?: InputMaybe<Signing_Template_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Always populated from the creator, but only signifies owner at classic vansanity */
  user?: InputMaybe<Scalars['uuid']>;
  userByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Signing_Procedure_Associated_Documents_Max_Fields = {
  __typename?: 'signing_procedure_associated_documents_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  ehrProcedure?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  signingTemplate?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** Always populated from the creator, but only signifies owner at classic vansanity */
  user?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "signing_procedure_associated_documents" */
export type Signing_Procedure_Associated_Documents_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  ehrProcedure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signingTemplate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  /** Always populated from the creator, but only signifies owner at classic vansanity */
  user?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Signing_Procedure_Associated_Documents_Min_Fields = {
  __typename?: 'signing_procedure_associated_documents_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  ehrProcedure?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  signingTemplate?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** Always populated from the creator, but only signifies owner at classic vansanity */
  user?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "signing_procedure_associated_documents" */
export type Signing_Procedure_Associated_Documents_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  ehrProcedure?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signingTemplate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  /** Always populated from the creator, but only signifies owner at classic vansanity */
  user?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "signing_procedure_associated_documents" */
export type Signing_Procedure_Associated_Documents_Mutation_Response = {
  __typename?: 'signing_procedure_associated_documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Signing_Procedure_Associated_Documents>;
};

/** on_conflict condition type for table "signing_procedure_associated_documents" */
export type Signing_Procedure_Associated_Documents_On_Conflict = {
  constraint: Signing_Procedure_Associated_Documents_Constraint;
  update_columns?: Array<Signing_Procedure_Associated_Documents_Update_Column>;
  where?: InputMaybe<Signing_Procedure_Associated_Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "signing_procedure_associated_documents". */
export type Signing_Procedure_Associated_Documents_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  ehrProcedure?: InputMaybe<Order_By>;
  ehrProcedureByEhrProcedure?: InputMaybe<Ehr_Procedure_Order_By>;
  id?: InputMaybe<Order_By>;
  optional?: InputMaybe<Order_By>;
  signingTemplate?: InputMaybe<Order_By>;
  signingTemplateBySigningTemplate?: InputMaybe<Signing_Template_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  userByUser?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: signing_procedure_associated_documents */
export type Signing_Procedure_Associated_Documents_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "signing_procedure_associated_documents" */
export enum Signing_Procedure_Associated_Documents_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EhrProcedure = 'ehrProcedure',
  /** column name */
  Id = 'id',
  /** column name */
  Optional = 'optional',
  /** column name */
  SigningTemplate = 'signingTemplate',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  User = 'user'
}

/** select "signing_procedure_associated_documents_aggregate_bool_exp_bool_and_arguments_columns" columns of table "signing_procedure_associated_documents" */
export enum Signing_Procedure_Associated_Documents_Select_Column_Signing_Procedure_Associated_Documents_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Optional = 'optional'
}

/** select "signing_procedure_associated_documents_aggregate_bool_exp_bool_or_arguments_columns" columns of table "signing_procedure_associated_documents" */
export enum Signing_Procedure_Associated_Documents_Select_Column_Signing_Procedure_Associated_Documents_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Optional = 'optional'
}

/** input type for updating data in table "signing_procedure_associated_documents" */
export type Signing_Procedure_Associated_Documents_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  ehrProcedure?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** If fase, hardstops starting a procedure for a patient without the document */
  optional?: InputMaybe<Scalars['Boolean']>;
  signingTemplate?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Always populated from the creator, but only signifies owner at classic vansanity */
  user?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "signing_procedure_associated_documents" */
export type Signing_Procedure_Associated_Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Signing_Procedure_Associated_Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Signing_Procedure_Associated_Documents_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  ehrProcedure?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** If fase, hardstops starting a procedure for a patient without the document */
  optional?: InputMaybe<Scalars['Boolean']>;
  signingTemplate?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Always populated from the creator, but only signifies owner at classic vansanity */
  user?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "signing_procedure_associated_documents" */
export enum Signing_Procedure_Associated_Documents_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EhrProcedure = 'ehrProcedure',
  /** column name */
  Id = 'id',
  /** column name */
  Optional = 'optional',
  /** column name */
  SigningTemplate = 'signingTemplate',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  User = 'user'
}

export type Signing_Procedure_Associated_Documents_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Signing_Procedure_Associated_Documents_Set_Input>;
  /** filter the rows which have to be updated */
  where: Signing_Procedure_Associated_Documents_Bool_Exp;
};

/** Corresponds to a single Template in Signnow, shared by a single business unit.  The business unit will start with common set from Vansanity, but can add and edit that. */
export type Signing_Template = {
  __typename?: 'signing_template';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** After expiration will not be available to generate documents from.  Null is never expires. */
  expirationDate?: Maybe<Scalars['date']>;
  externalId: Scalars['String'];
  id: Scalars['uuid'];
  kind: Signing_Template_Kind_Enum;
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  name: Scalars['String'];
  /** Draft mode until this is set, so cannot generate documents */
  promotedFromDraftAt?: Maybe<Scalars['timestamptz']>;
  requiresSenderSignature: Scalars['Boolean'];
  /** An array relationship */
  signingDocumentsBySigningDocuments: Array<Signing_Document>;
  /** An aggregate relationship */
  signingDocumentsBySigningDocuments_aggregate: Signing_Document_Aggregate;
  /** An array relationship */
  signingLocationProcedureRequiredDocumentsBySigningLocationProcedureRequiredDocuments: Array<Signing_Procedure_Associated_Documents>;
  /** An aggregate relationship */
  signingLocationProcedureRequiredDocumentsBySigningLocationProcedureRequiredDocuments_aggregate: Signing_Procedure_Associated_Documents_Aggregate;
  /** An array relationship */
  signingTemplateEquivalentsBySigningTemplateEquivalentsFromEquivalent: Array<Signing_Template_Equivalents>;
  /** An aggregate relationship */
  signingTemplateEquivalentsBySigningTemplateEquivalentsFromEquivalent_aggregate: Signing_Template_Equivalents_Aggregate;
  /** An array relationship */
  signingTemplateEquivalentsBySigningTemplateEquivalentsFromSource: Array<Signing_Template_Equivalents>;
  /** An aggregate relationship */
  signingTemplateEquivalentsBySigningTemplateEquivalentsFromSource_aggregate: Signing_Template_Equivalents_Aggregate;
  /** An object relationship */
  signingTemplateKindByKind: Signing_Template_Kind;
  signingTemplateSourceFile?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  signingTemplateSourceFileBySigningTemplateSourceFile?: Maybe<Signing_Template_Source_Files>;
  updatedAt: Scalars['timestamptz'];
  /** User is the owner at a classic vansanity, just the creator at a medspa */
  user: Scalars['uuid'];
  /** An object relationship */
  userByUser: User;
};


/** Corresponds to a single Template in Signnow, shared by a single business unit.  The business unit will start with common set from Vansanity, but can add and edit that. */
export type Signing_TemplateSigningDocumentsBySigningDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Signing_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Document_Order_By>>;
  where?: InputMaybe<Signing_Document_Bool_Exp>;
};


/** Corresponds to a single Template in Signnow, shared by a single business unit.  The business unit will start with common set from Vansanity, but can add and edit that. */
export type Signing_TemplateSigningDocumentsBySigningDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Document_Order_By>>;
  where?: InputMaybe<Signing_Document_Bool_Exp>;
};


/** Corresponds to a single Template in Signnow, shared by a single business unit.  The business unit will start with common set from Vansanity, but can add and edit that. */
export type Signing_TemplateSigningLocationProcedureRequiredDocumentsBySigningLocationProcedureRequiredDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Order_By>>;
  where?: InputMaybe<Signing_Procedure_Associated_Documents_Bool_Exp>;
};


/** Corresponds to a single Template in Signnow, shared by a single business unit.  The business unit will start with common set from Vansanity, but can add and edit that. */
export type Signing_TemplateSigningLocationProcedureRequiredDocumentsBySigningLocationProcedureRequiredDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Order_By>>;
  where?: InputMaybe<Signing_Procedure_Associated_Documents_Bool_Exp>;
};


/** Corresponds to a single Template in Signnow, shared by a single business unit.  The business unit will start with common set from Vansanity, but can add and edit that. */
export type Signing_TemplateSigningTemplateEquivalentsBySigningTemplateEquivalentsFromEquivalentArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Equivalents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Equivalents_Order_By>>;
  where?: InputMaybe<Signing_Template_Equivalents_Bool_Exp>;
};


/** Corresponds to a single Template in Signnow, shared by a single business unit.  The business unit will start with common set from Vansanity, but can add and edit that. */
export type Signing_TemplateSigningTemplateEquivalentsBySigningTemplateEquivalentsFromEquivalent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Equivalents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Equivalents_Order_By>>;
  where?: InputMaybe<Signing_Template_Equivalents_Bool_Exp>;
};


/** Corresponds to a single Template in Signnow, shared by a single business unit.  The business unit will start with common set from Vansanity, but can add and edit that. */
export type Signing_TemplateSigningTemplateEquivalentsBySigningTemplateEquivalentsFromSourceArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Equivalents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Equivalents_Order_By>>;
  where?: InputMaybe<Signing_Template_Equivalents_Bool_Exp>;
};


/** Corresponds to a single Template in Signnow, shared by a single business unit.  The business unit will start with common set from Vansanity, but can add and edit that. */
export type Signing_TemplateSigningTemplateEquivalentsBySigningTemplateEquivalentsFromSource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Equivalents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Equivalents_Order_By>>;
  where?: InputMaybe<Signing_Template_Equivalents_Bool_Exp>;
};

/** aggregated selection of "signing_template" */
export type Signing_Template_Aggregate = {
  __typename?: 'signing_template_aggregate';
  aggregate?: Maybe<Signing_Template_Aggregate_Fields>;
  nodes: Array<Signing_Template>;
};

/** aggregate fields of "signing_template" */
export type Signing_Template_Aggregate_Fields = {
  __typename?: 'signing_template_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Signing_Template_Max_Fields>;
  min?: Maybe<Signing_Template_Min_Fields>;
};


/** aggregate fields of "signing_template" */
export type Signing_Template_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Signing_Template_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "signing_template". All fields are combined with a logical 'AND'. */
export type Signing_Template_Bool_Exp = {
  _and?: InputMaybe<Array<Signing_Template_Bool_Exp>>;
  _not?: InputMaybe<Signing_Template_Bool_Exp>;
  _or?: InputMaybe<Array<Signing_Template_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  expirationDate?: InputMaybe<Date_Comparison_Exp>;
  externalId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  kind?: InputMaybe<Signing_Template_Kind_Enum_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  promotedFromDraftAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  requiresSenderSignature?: InputMaybe<Boolean_Comparison_Exp>;
  signingDocumentsBySigningDocuments?: InputMaybe<Signing_Document_Bool_Exp>;
  signingDocumentsBySigningDocuments_aggregate?: InputMaybe<Signing_Document_Aggregate_Bool_Exp>;
  signingLocationProcedureRequiredDocumentsBySigningLocationProcedureRequiredDocuments?: InputMaybe<Signing_Procedure_Associated_Documents_Bool_Exp>;
  signingLocationProcedureRequiredDocumentsBySigningLocationProcedureRequiredDocuments_aggregate?: InputMaybe<Signing_Procedure_Associated_Documents_Aggregate_Bool_Exp>;
  signingTemplateEquivalentsBySigningTemplateEquivalentsFromEquivalent?: InputMaybe<Signing_Template_Equivalents_Bool_Exp>;
  signingTemplateEquivalentsBySigningTemplateEquivalentsFromEquivalent_aggregate?: InputMaybe<Signing_Template_Equivalents_Aggregate_Bool_Exp>;
  signingTemplateEquivalentsBySigningTemplateEquivalentsFromSource?: InputMaybe<Signing_Template_Equivalents_Bool_Exp>;
  signingTemplateEquivalentsBySigningTemplateEquivalentsFromSource_aggregate?: InputMaybe<Signing_Template_Equivalents_Aggregate_Bool_Exp>;
  signingTemplateKindByKind?: InputMaybe<Signing_Template_Kind_Bool_Exp>;
  signingTemplateSourceFile?: InputMaybe<Uuid_Comparison_Exp>;
  signingTemplateSourceFileBySigningTemplateSourceFile?: InputMaybe<Signing_Template_Source_Files_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Uuid_Comparison_Exp>;
  userByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "signing_template" */
export enum Signing_Template_Constraint {
  /** unique or primary key constraint on columns "id" */
  SigningTemplatePkey = 'signing_template_pkey',
  /** unique or primary key constraint on columns "external_id", "user" */
  SigningTemplateUserExternalIdKey = 'signing_template_user_external_id_key'
}

/** When the equivalent template is signed, it counts as a signature on the source_template assuming that the equivalent is not expired. */
export type Signing_Template_Equivalents = {
  __typename?: 'signing_template_equivalents';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  equivalentTemplate: Scalars['uuid'];
  /** An object relationship */
  equivalentTemplateByEquivalentTemplate: Signing_Template;
  id: Scalars['uuid'];
  sourceTemplate: Scalars['uuid'];
  /** An object relationship */
  sourceTemplateBySourceTemplate: Signing_Template;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "signing_template_equivalents" */
export type Signing_Template_Equivalents_Aggregate = {
  __typename?: 'signing_template_equivalents_aggregate';
  aggregate?: Maybe<Signing_Template_Equivalents_Aggregate_Fields>;
  nodes: Array<Signing_Template_Equivalents>;
};

export type Signing_Template_Equivalents_Aggregate_Bool_Exp = {
  count?: InputMaybe<Signing_Template_Equivalents_Aggregate_Bool_Exp_Count>;
};

export type Signing_Template_Equivalents_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Signing_Template_Equivalents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Signing_Template_Equivalents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "signing_template_equivalents" */
export type Signing_Template_Equivalents_Aggregate_Fields = {
  __typename?: 'signing_template_equivalents_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Signing_Template_Equivalents_Max_Fields>;
  min?: Maybe<Signing_Template_Equivalents_Min_Fields>;
};


/** aggregate fields of "signing_template_equivalents" */
export type Signing_Template_Equivalents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Signing_Template_Equivalents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "signing_template_equivalents" */
export type Signing_Template_Equivalents_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Signing_Template_Equivalents_Max_Order_By>;
  min?: InputMaybe<Signing_Template_Equivalents_Min_Order_By>;
};

/** input type for inserting array relation for remote table "signing_template_equivalents" */
export type Signing_Template_Equivalents_Arr_Rel_Insert_Input = {
  data: Array<Signing_Template_Equivalents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Signing_Template_Equivalents_On_Conflict>;
};

/** Boolean expression to filter rows from the table "signing_template_equivalents". All fields are combined with a logical 'AND'. */
export type Signing_Template_Equivalents_Bool_Exp = {
  _and?: InputMaybe<Array<Signing_Template_Equivalents_Bool_Exp>>;
  _not?: InputMaybe<Signing_Template_Equivalents_Bool_Exp>;
  _or?: InputMaybe<Array<Signing_Template_Equivalents_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  equivalentTemplate?: InputMaybe<Uuid_Comparison_Exp>;
  equivalentTemplateByEquivalentTemplate?: InputMaybe<Signing_Template_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  sourceTemplate?: InputMaybe<Uuid_Comparison_Exp>;
  sourceTemplateBySourceTemplate?: InputMaybe<Signing_Template_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "signing_template_equivalents" */
export enum Signing_Template_Equivalents_Constraint {
  /** unique or primary key constraint on columns "id" */
  SigningTemplateEquivalentsPkey = 'signing_template_equivalents_pkey'
}

/** input type for inserting data into table "signing_template_equivalents" */
export type Signing_Template_Equivalents_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  equivalentTemplate?: InputMaybe<Scalars['uuid']>;
  equivalentTemplateByEquivalentTemplate?: InputMaybe<Signing_Template_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  sourceTemplate?: InputMaybe<Scalars['uuid']>;
  sourceTemplateBySourceTemplate?: InputMaybe<Signing_Template_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Signing_Template_Equivalents_Max_Fields = {
  __typename?: 'signing_template_equivalents_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  equivalentTemplate?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  sourceTemplate?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "signing_template_equivalents" */
export type Signing_Template_Equivalents_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  equivalentTemplate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sourceTemplate?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Signing_Template_Equivalents_Min_Fields = {
  __typename?: 'signing_template_equivalents_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  equivalentTemplate?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  sourceTemplate?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "signing_template_equivalents" */
export type Signing_Template_Equivalents_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  equivalentTemplate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sourceTemplate?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "signing_template_equivalents" */
export type Signing_Template_Equivalents_Mutation_Response = {
  __typename?: 'signing_template_equivalents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Signing_Template_Equivalents>;
};

/** on_conflict condition type for table "signing_template_equivalents" */
export type Signing_Template_Equivalents_On_Conflict = {
  constraint: Signing_Template_Equivalents_Constraint;
  update_columns?: Array<Signing_Template_Equivalents_Update_Column>;
  where?: InputMaybe<Signing_Template_Equivalents_Bool_Exp>;
};

/** Ordering options when selecting data from "signing_template_equivalents". */
export type Signing_Template_Equivalents_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  equivalentTemplate?: InputMaybe<Order_By>;
  equivalentTemplateByEquivalentTemplate?: InputMaybe<Signing_Template_Order_By>;
  id?: InputMaybe<Order_By>;
  sourceTemplate?: InputMaybe<Order_By>;
  sourceTemplateBySourceTemplate?: InputMaybe<Signing_Template_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: signing_template_equivalents */
export type Signing_Template_Equivalents_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "signing_template_equivalents" */
export enum Signing_Template_Equivalents_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EquivalentTemplate = 'equivalentTemplate',
  /** column name */
  Id = 'id',
  /** column name */
  SourceTemplate = 'sourceTemplate',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "signing_template_equivalents" */
export type Signing_Template_Equivalents_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  equivalentTemplate?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  sourceTemplate?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "signing_template_equivalents" */
export type Signing_Template_Equivalents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Signing_Template_Equivalents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Signing_Template_Equivalents_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  equivalentTemplate?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  sourceTemplate?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "signing_template_equivalents" */
export enum Signing_Template_Equivalents_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EquivalentTemplate = 'equivalentTemplate',
  /** column name */
  Id = 'id',
  /** column name */
  SourceTemplate = 'sourceTemplate',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Signing_Template_Equivalents_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Signing_Template_Equivalents_Set_Input>;
  /** filter the rows which have to be updated */
  where: Signing_Template_Equivalents_Bool_Exp;
};

/** input type for inserting data into table "signing_template" */
export type Signing_Template_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** After expiration will not be available to generate documents from.  Null is never expires. */
  expirationDate?: InputMaybe<Scalars['date']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  kind?: InputMaybe<Signing_Template_Kind_Enum>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  /** Draft mode until this is set, so cannot generate documents */
  promotedFromDraftAt?: InputMaybe<Scalars['timestamptz']>;
  requiresSenderSignature?: InputMaybe<Scalars['Boolean']>;
  signingDocumentsBySigningDocuments?: InputMaybe<Signing_Document_Arr_Rel_Insert_Input>;
  signingLocationProcedureRequiredDocumentsBySigningLocationProcedureRequiredDocuments?: InputMaybe<Signing_Procedure_Associated_Documents_Arr_Rel_Insert_Input>;
  signingTemplateEquivalentsBySigningTemplateEquivalentsFromEquivalent?: InputMaybe<Signing_Template_Equivalents_Arr_Rel_Insert_Input>;
  signingTemplateEquivalentsBySigningTemplateEquivalentsFromSource?: InputMaybe<Signing_Template_Equivalents_Arr_Rel_Insert_Input>;
  signingTemplateKindByKind?: InputMaybe<Signing_Template_Kind_Obj_Rel_Insert_Input>;
  signingTemplateSourceFile?: InputMaybe<Scalars['uuid']>;
  signingTemplateSourceFileBySigningTemplateSourceFile?: InputMaybe<Signing_Template_Source_Files_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** User is the owner at a classic vansanity, just the creator at a medspa */
  user?: InputMaybe<Scalars['uuid']>;
  userByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** columns and relationships of "signing_template_kind" */
export type Signing_Template_Kind = {
  __typename?: 'signing_template_kind';
  id: Scalars['String'];
};

/** aggregated selection of "signing_template_kind" */
export type Signing_Template_Kind_Aggregate = {
  __typename?: 'signing_template_kind_aggregate';
  aggregate?: Maybe<Signing_Template_Kind_Aggregate_Fields>;
  nodes: Array<Signing_Template_Kind>;
};

/** aggregate fields of "signing_template_kind" */
export type Signing_Template_Kind_Aggregate_Fields = {
  __typename?: 'signing_template_kind_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Signing_Template_Kind_Max_Fields>;
  min?: Maybe<Signing_Template_Kind_Min_Fields>;
};


/** aggregate fields of "signing_template_kind" */
export type Signing_Template_Kind_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Signing_Template_Kind_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "signing_template_kind". All fields are combined with a logical 'AND'. */
export type Signing_Template_Kind_Bool_Exp = {
  _and?: InputMaybe<Array<Signing_Template_Kind_Bool_Exp>>;
  _not?: InputMaybe<Signing_Template_Kind_Bool_Exp>;
  _or?: InputMaybe<Array<Signing_Template_Kind_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "signing_template_kind" */
export enum Signing_Template_Kind_Constraint {
  /** unique or primary key constraint on columns "id" */
  SigningTemplateKindPkey = 'signing_template_kind_pkey'
}

export enum Signing_Template_Kind_Enum {
  PatientForm = 'PATIENT_FORM',
  SupervisorForm = 'SUPERVISOR_FORM'
}

/** Boolean expression to compare columns of type "signing_template_kind_enum". All fields are combined with logical 'AND'. */
export type Signing_Template_Kind_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Signing_Template_Kind_Enum>;
  _in?: InputMaybe<Array<Signing_Template_Kind_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Signing_Template_Kind_Enum>;
  _nin?: InputMaybe<Array<Signing_Template_Kind_Enum>>;
};

/** input type for inserting data into table "signing_template_kind" */
export type Signing_Template_Kind_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Signing_Template_Kind_Max_Fields = {
  __typename?: 'signing_template_kind_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Signing_Template_Kind_Min_Fields = {
  __typename?: 'signing_template_kind_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "signing_template_kind" */
export type Signing_Template_Kind_Mutation_Response = {
  __typename?: 'signing_template_kind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Signing_Template_Kind>;
};

/** input type for inserting object relation for remote table "signing_template_kind" */
export type Signing_Template_Kind_Obj_Rel_Insert_Input = {
  data: Signing_Template_Kind_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Signing_Template_Kind_On_Conflict>;
};

/** on_conflict condition type for table "signing_template_kind" */
export type Signing_Template_Kind_On_Conflict = {
  constraint: Signing_Template_Kind_Constraint;
  update_columns?: Array<Signing_Template_Kind_Update_Column>;
  where?: InputMaybe<Signing_Template_Kind_Bool_Exp>;
};

/** Ordering options when selecting data from "signing_template_kind". */
export type Signing_Template_Kind_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: signing_template_kind */
export type Signing_Template_Kind_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "signing_template_kind" */
export enum Signing_Template_Kind_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "signing_template_kind" */
export type Signing_Template_Kind_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "signing_template_kind" */
export type Signing_Template_Kind_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Signing_Template_Kind_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Signing_Template_Kind_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "signing_template_kind" */
export enum Signing_Template_Kind_Update_Column {
  /** column name */
  Id = 'id'
}

export type Signing_Template_Kind_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Signing_Template_Kind_Set_Input>;
  /** filter the rows which have to be updated */
  where: Signing_Template_Kind_Bool_Exp;
};

/** aggregate max on columns */
export type Signing_Template_Max_Fields = {
  __typename?: 'signing_template_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** After expiration will not be available to generate documents from.  Null is never expires. */
  expirationDate?: Maybe<Scalars['date']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  /** Draft mode until this is set, so cannot generate documents */
  promotedFromDraftAt?: Maybe<Scalars['timestamptz']>;
  signingTemplateSourceFile?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** User is the owner at a classic vansanity, just the creator at a medspa */
  user?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Signing_Template_Min_Fields = {
  __typename?: 'signing_template_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** After expiration will not be available to generate documents from.  Null is never expires. */
  expirationDate?: Maybe<Scalars['date']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  /** Draft mode until this is set, so cannot generate documents */
  promotedFromDraftAt?: Maybe<Scalars['timestamptz']>;
  signingTemplateSourceFile?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** User is the owner at a classic vansanity, just the creator at a medspa */
  user?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "signing_template" */
export type Signing_Template_Mutation_Response = {
  __typename?: 'signing_template_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Signing_Template>;
};

/** input type for inserting object relation for remote table "signing_template" */
export type Signing_Template_Obj_Rel_Insert_Input = {
  data: Signing_Template_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Signing_Template_On_Conflict>;
};

/** on_conflict condition type for table "signing_template" */
export type Signing_Template_On_Conflict = {
  constraint: Signing_Template_Constraint;
  update_columns?: Array<Signing_Template_Update_Column>;
  where?: InputMaybe<Signing_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "signing_template". */
export type Signing_Template_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  expirationDate?: InputMaybe<Order_By>;
  externalId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  name?: InputMaybe<Order_By>;
  promotedFromDraftAt?: InputMaybe<Order_By>;
  requiresSenderSignature?: InputMaybe<Order_By>;
  signingDocumentsBySigningDocuments_aggregate?: InputMaybe<Signing_Document_Aggregate_Order_By>;
  signingLocationProcedureRequiredDocumentsBySigningLocationProcedureRequiredDocuments_aggregate?: InputMaybe<Signing_Procedure_Associated_Documents_Aggregate_Order_By>;
  signingTemplateEquivalentsBySigningTemplateEquivalentsFromEquivalent_aggregate?: InputMaybe<Signing_Template_Equivalents_Aggregate_Order_By>;
  signingTemplateEquivalentsBySigningTemplateEquivalentsFromSource_aggregate?: InputMaybe<Signing_Template_Equivalents_Aggregate_Order_By>;
  signingTemplateKindByKind?: InputMaybe<Signing_Template_Kind_Order_By>;
  signingTemplateSourceFile?: InputMaybe<Order_By>;
  signingTemplateSourceFileBySigningTemplateSourceFile?: InputMaybe<Signing_Template_Source_Files_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  userByUser?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: signing_template */
export type Signing_Template_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "signing_template" */
export enum Signing_Template_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  ExternalId = 'externalId',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  PromotedFromDraftAt = 'promotedFromDraftAt',
  /** column name */
  RequiresSenderSignature = 'requiresSenderSignature',
  /** column name */
  SigningTemplateSourceFile = 'signingTemplateSourceFile',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  User = 'user'
}

/** input type for updating data in table "signing_template" */
export type Signing_Template_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** After expiration will not be available to generate documents from.  Null is never expires. */
  expirationDate?: InputMaybe<Scalars['date']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  kind?: InputMaybe<Signing_Template_Kind_Enum>;
  location?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  /** Draft mode until this is set, so cannot generate documents */
  promotedFromDraftAt?: InputMaybe<Scalars['timestamptz']>;
  requiresSenderSignature?: InputMaybe<Scalars['Boolean']>;
  signingTemplateSourceFile?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** User is the owner at a classic vansanity, just the creator at a medspa */
  user?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "signing_template_source_files" */
export type Signing_Template_Source_Files = {
  __typename?: 'signing_template_source_files';
  contentType: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  documentS3Key: Scalars['String'];
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  pageCount: Scalars['Int'];
  pagePreviewS3Keys: Scalars['jsonb'];
  updatedAt: Scalars['timestamptz'];
  user: Scalars['uuid'];
  /** An object relationship */
  userByUser: User;
};


/** columns and relationships of "signing_template_source_files" */
export type Signing_Template_Source_FilesPagePreviewS3KeysArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "signing_template_source_files" */
export type Signing_Template_Source_Files_Aggregate = {
  __typename?: 'signing_template_source_files_aggregate';
  aggregate?: Maybe<Signing_Template_Source_Files_Aggregate_Fields>;
  nodes: Array<Signing_Template_Source_Files>;
};

/** aggregate fields of "signing_template_source_files" */
export type Signing_Template_Source_Files_Aggregate_Fields = {
  __typename?: 'signing_template_source_files_aggregate_fields';
  avg?: Maybe<Signing_Template_Source_Files_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Signing_Template_Source_Files_Max_Fields>;
  min?: Maybe<Signing_Template_Source_Files_Min_Fields>;
  stddev?: Maybe<Signing_Template_Source_Files_Stddev_Fields>;
  stddev_pop?: Maybe<Signing_Template_Source_Files_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Signing_Template_Source_Files_Stddev_Samp_Fields>;
  sum?: Maybe<Signing_Template_Source_Files_Sum_Fields>;
  var_pop?: Maybe<Signing_Template_Source_Files_Var_Pop_Fields>;
  var_samp?: Maybe<Signing_Template_Source_Files_Var_Samp_Fields>;
  variance?: Maybe<Signing_Template_Source_Files_Variance_Fields>;
};


/** aggregate fields of "signing_template_source_files" */
export type Signing_Template_Source_Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Signing_Template_Source_Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Signing_Template_Source_Files_Append_Input = {
  pagePreviewS3Keys?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Signing_Template_Source_Files_Avg_Fields = {
  __typename?: 'signing_template_source_files_avg_fields';
  pageCount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "signing_template_source_files". All fields are combined with a logical 'AND'. */
export type Signing_Template_Source_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Signing_Template_Source_Files_Bool_Exp>>;
  _not?: InputMaybe<Signing_Template_Source_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Signing_Template_Source_Files_Bool_Exp>>;
  contentType?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  documentS3Key?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  pageCount?: InputMaybe<Int_Comparison_Exp>;
  pagePreviewS3Keys?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Uuid_Comparison_Exp>;
  userByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "signing_template_source_files" */
export enum Signing_Template_Source_Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  SigningTemplateSourceFilesPkey = 'signing_template_source_files_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Signing_Template_Source_Files_Delete_At_Path_Input = {
  pagePreviewS3Keys?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Signing_Template_Source_Files_Delete_Elem_Input = {
  pagePreviewS3Keys?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Signing_Template_Source_Files_Delete_Key_Input = {
  pagePreviewS3Keys?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "signing_template_source_files" */
export type Signing_Template_Source_Files_Inc_Input = {
  pageCount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "signing_template_source_files" */
export type Signing_Template_Source_Files_Insert_Input = {
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  documentS3Key?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  pageCount?: InputMaybe<Scalars['Int']>;
  pagePreviewS3Keys?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
  userByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Signing_Template_Source_Files_Max_Fields = {
  __typename?: 'signing_template_source_files_max_fields';
  contentType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  documentS3Key?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  pageCount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Signing_Template_Source_Files_Min_Fields = {
  __typename?: 'signing_template_source_files_min_fields';
  contentType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  documentS3Key?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  pageCount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "signing_template_source_files" */
export type Signing_Template_Source_Files_Mutation_Response = {
  __typename?: 'signing_template_source_files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Signing_Template_Source_Files>;
};

/** input type for inserting object relation for remote table "signing_template_source_files" */
export type Signing_Template_Source_Files_Obj_Rel_Insert_Input = {
  data: Signing_Template_Source_Files_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Signing_Template_Source_Files_On_Conflict>;
};

/** on_conflict condition type for table "signing_template_source_files" */
export type Signing_Template_Source_Files_On_Conflict = {
  constraint: Signing_Template_Source_Files_Constraint;
  update_columns?: Array<Signing_Template_Source_Files_Update_Column>;
  where?: InputMaybe<Signing_Template_Source_Files_Bool_Exp>;
};

/** Ordering options when selecting data from "signing_template_source_files". */
export type Signing_Template_Source_Files_Order_By = {
  contentType?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  documentS3Key?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  pageCount?: InputMaybe<Order_By>;
  pagePreviewS3Keys?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  userByUser?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: signing_template_source_files */
export type Signing_Template_Source_Files_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Signing_Template_Source_Files_Prepend_Input = {
  pagePreviewS3Keys?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "signing_template_source_files" */
export enum Signing_Template_Source_Files_Select_Column {
  /** column name */
  ContentType = 'contentType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DocumentS3Key = 'documentS3Key',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  PageCount = 'pageCount',
  /** column name */
  PagePreviewS3Keys = 'pagePreviewS3Keys',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  User = 'user'
}

/** input type for updating data in table "signing_template_source_files" */
export type Signing_Template_Source_Files_Set_Input = {
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  documentS3Key?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  pageCount?: InputMaybe<Scalars['Int']>;
  pagePreviewS3Keys?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Signing_Template_Source_Files_Stddev_Fields = {
  __typename?: 'signing_template_source_files_stddev_fields';
  pageCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Signing_Template_Source_Files_Stddev_Pop_Fields = {
  __typename?: 'signing_template_source_files_stddev_pop_fields';
  pageCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Signing_Template_Source_Files_Stddev_Samp_Fields = {
  __typename?: 'signing_template_source_files_stddev_samp_fields';
  pageCount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "signing_template_source_files" */
export type Signing_Template_Source_Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Signing_Template_Source_Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Signing_Template_Source_Files_Stream_Cursor_Value_Input = {
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  documentS3Key?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  pageCount?: InputMaybe<Scalars['Int']>;
  pagePreviewS3Keys?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Signing_Template_Source_Files_Sum_Fields = {
  __typename?: 'signing_template_source_files_sum_fields';
  pageCount?: Maybe<Scalars['Int']>;
};

/** update columns of table "signing_template_source_files" */
export enum Signing_Template_Source_Files_Update_Column {
  /** column name */
  ContentType = 'contentType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DocumentS3Key = 'documentS3Key',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  PageCount = 'pageCount',
  /** column name */
  PagePreviewS3Keys = 'pagePreviewS3Keys',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  User = 'user'
}

export type Signing_Template_Source_Files_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Signing_Template_Source_Files_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Signing_Template_Source_Files_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Signing_Template_Source_Files_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Signing_Template_Source_Files_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Signing_Template_Source_Files_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Signing_Template_Source_Files_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Signing_Template_Source_Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Signing_Template_Source_Files_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Signing_Template_Source_Files_Var_Pop_Fields = {
  __typename?: 'signing_template_source_files_var_pop_fields';
  pageCount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Signing_Template_Source_Files_Var_Samp_Fields = {
  __typename?: 'signing_template_source_files_var_samp_fields';
  pageCount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Signing_Template_Source_Files_Variance_Fields = {
  __typename?: 'signing_template_source_files_variance_fields';
  pageCount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "signing_template" */
export type Signing_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Signing_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Signing_Template_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** After expiration will not be available to generate documents from.  Null is never expires. */
  expirationDate?: InputMaybe<Scalars['date']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  kind?: InputMaybe<Signing_Template_Kind_Enum>;
  location?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  /** Draft mode until this is set, so cannot generate documents */
  promotedFromDraftAt?: InputMaybe<Scalars['timestamptz']>;
  requiresSenderSignature?: InputMaybe<Scalars['Boolean']>;
  signingTemplateSourceFile?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** User is the owner at a classic vansanity, just the creator at a medspa */
  user?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "signing_template" */
export enum Signing_Template_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  ExpirationDate = 'expirationDate',
  /** column name */
  ExternalId = 'externalId',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  PromotedFromDraftAt = 'promotedFromDraftAt',
  /** column name */
  RequiresSenderSignature = 'requiresSenderSignature',
  /** column name */
  SigningTemplateSourceFile = 'signingTemplateSourceFile',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  User = 'user'
}

export type Signing_Template_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Signing_Template_Set_Input>;
  /** filter the rows which have to be updated */
  where: Signing_Template_Bool_Exp;
};

/** Public form templates: provided by VanSanity, belonging to no account and no location */
export type Signing_Vansanity_Template = {
  __typename?: 'signing_vansanity_template';
  contentType: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** S3 key of the uploaded source file the signing service's template was made from */
  documentS3Key: Scalars['String'];
  /** The signing service's template id */
  externalId: Scalars['String'];
  id: Scalars['uuid'];
  kind: Signing_Template_Kind_Enum;
  name: Scalars['String'];
  pageCount: Scalars['Int'];
  /** S3 keys of the page preview images, in page order */
  pagePreviewS3Keys: Scalars['jsonb'];
  requiresSenderSignature: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
};


/** Public form templates: provided by VanSanity, belonging to no account and no location */
export type Signing_Vansanity_TemplatePagePreviewS3KeysArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "signing_vansanity_template" */
export type Signing_Vansanity_Template_Aggregate = {
  __typename?: 'signing_vansanity_template_aggregate';
  aggregate?: Maybe<Signing_Vansanity_Template_Aggregate_Fields>;
  nodes: Array<Signing_Vansanity_Template>;
};

/** aggregate fields of "signing_vansanity_template" */
export type Signing_Vansanity_Template_Aggregate_Fields = {
  __typename?: 'signing_vansanity_template_aggregate_fields';
  avg?: Maybe<Signing_Vansanity_Template_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Signing_Vansanity_Template_Max_Fields>;
  min?: Maybe<Signing_Vansanity_Template_Min_Fields>;
  stddev?: Maybe<Signing_Vansanity_Template_Stddev_Fields>;
  stddev_pop?: Maybe<Signing_Vansanity_Template_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Signing_Vansanity_Template_Stddev_Samp_Fields>;
  sum?: Maybe<Signing_Vansanity_Template_Sum_Fields>;
  var_pop?: Maybe<Signing_Vansanity_Template_Var_Pop_Fields>;
  var_samp?: Maybe<Signing_Vansanity_Template_Var_Samp_Fields>;
  variance?: Maybe<Signing_Vansanity_Template_Variance_Fields>;
};


/** aggregate fields of "signing_vansanity_template" */
export type Signing_Vansanity_Template_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Signing_Vansanity_Template_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Signing_Vansanity_Template_Append_Input = {
  /** S3 keys of the page preview images, in page order */
  pagePreviewS3Keys?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Signing_Vansanity_Template_Avg_Fields = {
  __typename?: 'signing_vansanity_template_avg_fields';
  pageCount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "signing_vansanity_template". All fields are combined with a logical 'AND'. */
export type Signing_Vansanity_Template_Bool_Exp = {
  _and?: InputMaybe<Array<Signing_Vansanity_Template_Bool_Exp>>;
  _not?: InputMaybe<Signing_Vansanity_Template_Bool_Exp>;
  _or?: InputMaybe<Array<Signing_Vansanity_Template_Bool_Exp>>;
  contentType?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  documentS3Key?: InputMaybe<String_Comparison_Exp>;
  externalId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  kind?: InputMaybe<Signing_Template_Kind_Enum_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  pageCount?: InputMaybe<Int_Comparison_Exp>;
  pagePreviewS3Keys?: InputMaybe<Jsonb_Comparison_Exp>;
  requiresSenderSignature?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "signing_vansanity_template" */
export enum Signing_Vansanity_Template_Constraint {
  /** unique or primary key constraint on columns "external_id" */
  SigningVansanityTemplateSignNowIdKey = 'signing_vansanity_template_sign_now_id_key',
  /** unique or primary key constraint on columns "id" */
  SigningVansanityTemplatesPkey = 'signing_vansanity_templates_pkey',
  /** unique or primary key constraint on columns "name" */
  UniqueSigningVansanityTemplateName = 'unique_signing_vansanity_template_name'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Signing_Vansanity_Template_Delete_At_Path_Input = {
  /** S3 keys of the page preview images, in page order */
  pagePreviewS3Keys?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Signing_Vansanity_Template_Delete_Elem_Input = {
  /** S3 keys of the page preview images, in page order */
  pagePreviewS3Keys?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Signing_Vansanity_Template_Delete_Key_Input = {
  /** S3 keys of the page preview images, in page order */
  pagePreviewS3Keys?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "signing_vansanity_template" */
export type Signing_Vansanity_Template_Inc_Input = {
  pageCount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "signing_vansanity_template" */
export type Signing_Vansanity_Template_Insert_Input = {
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** S3 key of the uploaded source file the signing service's template was made from */
  documentS3Key?: InputMaybe<Scalars['String']>;
  /** The signing service's template id */
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  kind?: InputMaybe<Signing_Template_Kind_Enum>;
  name?: InputMaybe<Scalars['String']>;
  pageCount?: InputMaybe<Scalars['Int']>;
  /** S3 keys of the page preview images, in page order */
  pagePreviewS3Keys?: InputMaybe<Scalars['jsonb']>;
  requiresSenderSignature?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Signing_Vansanity_Template_Max_Fields = {
  __typename?: 'signing_vansanity_template_max_fields';
  contentType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** S3 key of the uploaded source file the signing service's template was made from */
  documentS3Key?: Maybe<Scalars['String']>;
  /** The signing service's template id */
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  pageCount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Signing_Vansanity_Template_Min_Fields = {
  __typename?: 'signing_vansanity_template_min_fields';
  contentType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** S3 key of the uploaded source file the signing service's template was made from */
  documentS3Key?: Maybe<Scalars['String']>;
  /** The signing service's template id */
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  pageCount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "signing_vansanity_template" */
export type Signing_Vansanity_Template_Mutation_Response = {
  __typename?: 'signing_vansanity_template_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Signing_Vansanity_Template>;
};

/** input type for inserting object relation for remote table "signing_vansanity_template" */
export type Signing_Vansanity_Template_Obj_Rel_Insert_Input = {
  data: Signing_Vansanity_Template_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Signing_Vansanity_Template_On_Conflict>;
};

/** on_conflict condition type for table "signing_vansanity_template" */
export type Signing_Vansanity_Template_On_Conflict = {
  constraint: Signing_Vansanity_Template_Constraint;
  update_columns?: Array<Signing_Vansanity_Template_Update_Column>;
  where?: InputMaybe<Signing_Vansanity_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "signing_vansanity_template". */
export type Signing_Vansanity_Template_Order_By = {
  contentType?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  documentS3Key?: InputMaybe<Order_By>;
  externalId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pageCount?: InputMaybe<Order_By>;
  pagePreviewS3Keys?: InputMaybe<Order_By>;
  requiresSenderSignature?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: signing_vansanity_template */
export type Signing_Vansanity_Template_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Signing_Vansanity_Template_Prepend_Input = {
  /** S3 keys of the page preview images, in page order */
  pagePreviewS3Keys?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "signing_vansanity_template" */
export enum Signing_Vansanity_Template_Select_Column {
  /** column name */
  ContentType = 'contentType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DocumentS3Key = 'documentS3Key',
  /** column name */
  ExternalId = 'externalId',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Name = 'name',
  /** column name */
  PageCount = 'pageCount',
  /** column name */
  PagePreviewS3Keys = 'pagePreviewS3Keys',
  /** column name */
  RequiresSenderSignature = 'requiresSenderSignature',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "signing_vansanity_template" */
export type Signing_Vansanity_Template_Set_Input = {
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** S3 key of the uploaded source file the signing service's template was made from */
  documentS3Key?: InputMaybe<Scalars['String']>;
  /** The signing service's template id */
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  kind?: InputMaybe<Signing_Template_Kind_Enum>;
  name?: InputMaybe<Scalars['String']>;
  pageCount?: InputMaybe<Scalars['Int']>;
  /** S3 keys of the page preview images, in page order */
  pagePreviewS3Keys?: InputMaybe<Scalars['jsonb']>;
  requiresSenderSignature?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Signing_Vansanity_Template_Stddev_Fields = {
  __typename?: 'signing_vansanity_template_stddev_fields';
  pageCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Signing_Vansanity_Template_Stddev_Pop_Fields = {
  __typename?: 'signing_vansanity_template_stddev_pop_fields';
  pageCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Signing_Vansanity_Template_Stddev_Samp_Fields = {
  __typename?: 'signing_vansanity_template_stddev_samp_fields';
  pageCount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "signing_vansanity_template" */
export type Signing_Vansanity_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Signing_Vansanity_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Signing_Vansanity_Template_Stream_Cursor_Value_Input = {
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  /** S3 key of the uploaded source file the signing service's template was made from */
  documentS3Key?: InputMaybe<Scalars['String']>;
  /** The signing service's template id */
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  kind?: InputMaybe<Signing_Template_Kind_Enum>;
  name?: InputMaybe<Scalars['String']>;
  pageCount?: InputMaybe<Scalars['Int']>;
  /** S3 keys of the page preview images, in page order */
  pagePreviewS3Keys?: InputMaybe<Scalars['jsonb']>;
  requiresSenderSignature?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Signing_Vansanity_Template_Sum_Fields = {
  __typename?: 'signing_vansanity_template_sum_fields';
  pageCount?: Maybe<Scalars['Int']>;
};

/** update columns of table "signing_vansanity_template" */
export enum Signing_Vansanity_Template_Update_Column {
  /** column name */
  ContentType = 'contentType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DocumentS3Key = 'documentS3Key',
  /** column name */
  ExternalId = 'externalId',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Name = 'name',
  /** column name */
  PageCount = 'pageCount',
  /** column name */
  PagePreviewS3Keys = 'pagePreviewS3Keys',
  /** column name */
  RequiresSenderSignature = 'requiresSenderSignature',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Signing_Vansanity_Template_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Signing_Vansanity_Template_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Signing_Vansanity_Template_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Signing_Vansanity_Template_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Signing_Vansanity_Template_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Signing_Vansanity_Template_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Signing_Vansanity_Template_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Signing_Vansanity_Template_Set_Input>;
  /** filter the rows which have to be updated */
  where: Signing_Vansanity_Template_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Signing_Vansanity_Template_Var_Pop_Fields = {
  __typename?: 'signing_vansanity_template_var_pop_fields';
  pageCount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Signing_Vansanity_Template_Var_Samp_Fields = {
  __typename?: 'signing_vansanity_template_var_samp_fields';
  pageCount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Signing_Vansanity_Template_Variance_Fields = {
  __typename?: 'signing_vansanity_template_variance_fields';
  pageCount?: Maybe<Scalars['Float']>;
};

/** Record of a webhook from SignNow */
export type Signing_Webhook_Event = {
  __typename?: 'signing_webhook_event';
  created_at: Scalars['timestamptz'];
  document: Scalars['uuid'];
  /** An object relationship */
  documentByDocument: Signing_Document;
  event_type: Scalars['String'];
  id: Scalars['uuid'];
  payload: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
};


/** Record of a webhook from SignNow */
export type Signing_Webhook_EventPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "signing_webhook_event" */
export type Signing_Webhook_Event_Aggregate = {
  __typename?: 'signing_webhook_event_aggregate';
  aggregate?: Maybe<Signing_Webhook_Event_Aggregate_Fields>;
  nodes: Array<Signing_Webhook_Event>;
};

export type Signing_Webhook_Event_Aggregate_Bool_Exp = {
  count?: InputMaybe<Signing_Webhook_Event_Aggregate_Bool_Exp_Count>;
};

export type Signing_Webhook_Event_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Signing_Webhook_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Signing_Webhook_Event_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "signing_webhook_event" */
export type Signing_Webhook_Event_Aggregate_Fields = {
  __typename?: 'signing_webhook_event_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Signing_Webhook_Event_Max_Fields>;
  min?: Maybe<Signing_Webhook_Event_Min_Fields>;
};


/** aggregate fields of "signing_webhook_event" */
export type Signing_Webhook_Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Signing_Webhook_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "signing_webhook_event" */
export type Signing_Webhook_Event_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Signing_Webhook_Event_Max_Order_By>;
  min?: InputMaybe<Signing_Webhook_Event_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Signing_Webhook_Event_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "signing_webhook_event" */
export type Signing_Webhook_Event_Arr_Rel_Insert_Input = {
  data: Array<Signing_Webhook_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Signing_Webhook_Event_On_Conflict>;
};

/** Boolean expression to filter rows from the table "signing_webhook_event". All fields are combined with a logical 'AND'. */
export type Signing_Webhook_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Signing_Webhook_Event_Bool_Exp>>;
  _not?: InputMaybe<Signing_Webhook_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Signing_Webhook_Event_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document?: InputMaybe<Uuid_Comparison_Exp>;
  documentByDocument?: InputMaybe<Signing_Document_Bool_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "signing_webhook_event" */
export enum Signing_Webhook_Event_Constraint {
  /** unique or primary key constraint on columns "id" */
  SigningWebhookEventPkey = 'signing_webhook_event_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Signing_Webhook_Event_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Signing_Webhook_Event_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Signing_Webhook_Event_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "signing_webhook_event" */
export type Signing_Webhook_Event_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  document?: InputMaybe<Scalars['uuid']>;
  documentByDocument?: InputMaybe<Signing_Document_Obj_Rel_Insert_Input>;
  event_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Signing_Webhook_Event_Max_Fields = {
  __typename?: 'signing_webhook_event_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  document?: Maybe<Scalars['uuid']>;
  event_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "signing_webhook_event" */
export type Signing_Webhook_Event_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Signing_Webhook_Event_Min_Fields = {
  __typename?: 'signing_webhook_event_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  document?: Maybe<Scalars['uuid']>;
  event_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "signing_webhook_event" */
export type Signing_Webhook_Event_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "signing_webhook_event" */
export type Signing_Webhook_Event_Mutation_Response = {
  __typename?: 'signing_webhook_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Signing_Webhook_Event>;
};

/** on_conflict condition type for table "signing_webhook_event" */
export type Signing_Webhook_Event_On_Conflict = {
  constraint: Signing_Webhook_Event_Constraint;
  update_columns?: Array<Signing_Webhook_Event_Update_Column>;
  where?: InputMaybe<Signing_Webhook_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "signing_webhook_event". */
export type Signing_Webhook_Event_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document?: InputMaybe<Order_By>;
  documentByDocument?: InputMaybe<Signing_Document_Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: signing_webhook_event */
export type Signing_Webhook_Event_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Signing_Webhook_Event_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "signing_webhook_event" */
export enum Signing_Webhook_Event_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Document = 'document',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "signing_webhook_event" */
export type Signing_Webhook_Event_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  document?: InputMaybe<Scalars['uuid']>;
  event_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "signing_webhook_event" */
export type Signing_Webhook_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Signing_Webhook_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Signing_Webhook_Event_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  document?: InputMaybe<Scalars['uuid']>;
  event_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** The signnow webhook events that we are registered for.  Table cannot be an enum because the populated values are not allowed as enums. */
export type Signing_Webhook_Event_Type = {
  __typename?: 'signing_webhook_event_type';
  id: Scalars['String'];
};

/** aggregated selection of "signing_webhook_event_type" */
export type Signing_Webhook_Event_Type_Aggregate = {
  __typename?: 'signing_webhook_event_type_aggregate';
  aggregate?: Maybe<Signing_Webhook_Event_Type_Aggregate_Fields>;
  nodes: Array<Signing_Webhook_Event_Type>;
};

/** aggregate fields of "signing_webhook_event_type" */
export type Signing_Webhook_Event_Type_Aggregate_Fields = {
  __typename?: 'signing_webhook_event_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Signing_Webhook_Event_Type_Max_Fields>;
  min?: Maybe<Signing_Webhook_Event_Type_Min_Fields>;
};


/** aggregate fields of "signing_webhook_event_type" */
export type Signing_Webhook_Event_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Signing_Webhook_Event_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "signing_webhook_event_type". All fields are combined with a logical 'AND'. */
export type Signing_Webhook_Event_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Signing_Webhook_Event_Type_Bool_Exp>>;
  _not?: InputMaybe<Signing_Webhook_Event_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Signing_Webhook_Event_Type_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "signing_webhook_event_type" */
export enum Signing_Webhook_Event_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  SigningWebhookEventTypePkey = 'signing_webhook_event_type_pkey'
}

/** input type for inserting data into table "signing_webhook_event_type" */
export type Signing_Webhook_Event_Type_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Signing_Webhook_Event_Type_Max_Fields = {
  __typename?: 'signing_webhook_event_type_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Signing_Webhook_Event_Type_Min_Fields = {
  __typename?: 'signing_webhook_event_type_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "signing_webhook_event_type" */
export type Signing_Webhook_Event_Type_Mutation_Response = {
  __typename?: 'signing_webhook_event_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Signing_Webhook_Event_Type>;
};

/** on_conflict condition type for table "signing_webhook_event_type" */
export type Signing_Webhook_Event_Type_On_Conflict = {
  constraint: Signing_Webhook_Event_Type_Constraint;
  update_columns?: Array<Signing_Webhook_Event_Type_Update_Column>;
  where?: InputMaybe<Signing_Webhook_Event_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "signing_webhook_event_type". */
export type Signing_Webhook_Event_Type_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: signing_webhook_event_type */
export type Signing_Webhook_Event_Type_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "signing_webhook_event_type" */
export enum Signing_Webhook_Event_Type_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "signing_webhook_event_type" */
export type Signing_Webhook_Event_Type_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "signing_webhook_event_type" */
export type Signing_Webhook_Event_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Signing_Webhook_Event_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Signing_Webhook_Event_Type_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "signing_webhook_event_type" */
export enum Signing_Webhook_Event_Type_Update_Column {
  /** column name */
  Id = 'id'
}

export type Signing_Webhook_Event_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Signing_Webhook_Event_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Signing_Webhook_Event_Type_Bool_Exp;
};

/** update columns of table "signing_webhook_event" */
export enum Signing_Webhook_Event_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Document = 'document',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Signing_Webhook_Event_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Signing_Webhook_Event_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Signing_Webhook_Event_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Signing_Webhook_Event_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Signing_Webhook_Event_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Signing_Webhook_Event_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Signing_Webhook_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Signing_Webhook_Event_Bool_Exp;
};

/** columns and relationships of "square_credential_ownership_enum" */
export type Square_Credential_Ownership_Enum = {
  __typename?: 'square_credential_ownership_enum';
  name: Scalars['String'];
};

/** aggregated selection of "square_credential_ownership_enum" */
export type Square_Credential_Ownership_Enum_Aggregate = {
  __typename?: 'square_credential_ownership_enum_aggregate';
  aggregate?: Maybe<Square_Credential_Ownership_Enum_Aggregate_Fields>;
  nodes: Array<Square_Credential_Ownership_Enum>;
};

/** aggregate fields of "square_credential_ownership_enum" */
export type Square_Credential_Ownership_Enum_Aggregate_Fields = {
  __typename?: 'square_credential_ownership_enum_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Square_Credential_Ownership_Enum_Max_Fields>;
  min?: Maybe<Square_Credential_Ownership_Enum_Min_Fields>;
};


/** aggregate fields of "square_credential_ownership_enum" */
export type Square_Credential_Ownership_Enum_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Square_Credential_Ownership_Enum_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "square_credential_ownership_enum". All fields are combined with a logical 'AND'. */
export type Square_Credential_Ownership_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Square_Credential_Ownership_Enum_Bool_Exp>>;
  _not?: InputMaybe<Square_Credential_Ownership_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Square_Credential_Ownership_Enum_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "square_credential_ownership_enum" */
export enum Square_Credential_Ownership_Enum_Constraint {
  /** unique or primary key constraint on columns "name" */
  SquareCredentialOwnershipEnumPkey = 'square_credential_ownership_enum_pkey'
}

export enum Square_Credential_Ownership_Enum_Enum {
  Location = 'LOCATION',
  Provider = 'PROVIDER'
}

/** Boolean expression to compare columns of type "square_credential_ownership_enum_enum". All fields are combined with logical 'AND'. */
export type Square_Credential_Ownership_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Square_Credential_Ownership_Enum_Enum>;
  _in?: InputMaybe<Array<Square_Credential_Ownership_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Square_Credential_Ownership_Enum_Enum>;
  _nin?: InputMaybe<Array<Square_Credential_Ownership_Enum_Enum>>;
};

/** input type for inserting data into table "square_credential_ownership_enum" */
export type Square_Credential_Ownership_Enum_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Square_Credential_Ownership_Enum_Max_Fields = {
  __typename?: 'square_credential_ownership_enum_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Square_Credential_Ownership_Enum_Min_Fields = {
  __typename?: 'square_credential_ownership_enum_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "square_credential_ownership_enum" */
export type Square_Credential_Ownership_Enum_Mutation_Response = {
  __typename?: 'square_credential_ownership_enum_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Square_Credential_Ownership_Enum>;
};

/** input type for inserting object relation for remote table "square_credential_ownership_enum" */
export type Square_Credential_Ownership_Enum_Obj_Rel_Insert_Input = {
  data: Square_Credential_Ownership_Enum_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Square_Credential_Ownership_Enum_On_Conflict>;
};

/** on_conflict condition type for table "square_credential_ownership_enum" */
export type Square_Credential_Ownership_Enum_On_Conflict = {
  constraint: Square_Credential_Ownership_Enum_Constraint;
  update_columns?: Array<Square_Credential_Ownership_Enum_Update_Column>;
  where?: InputMaybe<Square_Credential_Ownership_Enum_Bool_Exp>;
};

/** Ordering options when selecting data from "square_credential_ownership_enum". */
export type Square_Credential_Ownership_Enum_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: square_credential_ownership_enum */
export type Square_Credential_Ownership_Enum_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "square_credential_ownership_enum" */
export enum Square_Credential_Ownership_Enum_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "square_credential_ownership_enum" */
export type Square_Credential_Ownership_Enum_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "square_credential_ownership_enum" */
export type Square_Credential_Ownership_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Square_Credential_Ownership_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Square_Credential_Ownership_Enum_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "square_credential_ownership_enum" */
export enum Square_Credential_Ownership_Enum_Update_Column {
  /** column name */
  Name = 'name'
}

export type Square_Credential_Ownership_Enum_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Square_Credential_Ownership_Enum_Set_Input>;
  /** filter the rows which have to be updated */
  where: Square_Credential_Ownership_Enum_Bool_Exp;
};

/** columns and relationships of "square_credentials" */
export type Square_Credentials = {
  __typename?: 'square_credentials';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation?: Maybe<Location>;
  ownedBy: Square_Credential_Ownership_Enum_Enum;
  provider: Scalars['uuid'];
  /** An object relationship */
  providerByProvider: User;
  squareAccessToken: Scalars['String'];
  squareAccessTokenExpirationDate: Scalars['timestamptz'];
  squareRefreshToken: Scalars['String'];
  /** An object relationship */
  square_credential_ownership_enum: Square_Credential_Ownership_Enum;
};

/** aggregated selection of "square_credentials" */
export type Square_Credentials_Aggregate = {
  __typename?: 'square_credentials_aggregate';
  aggregate?: Maybe<Square_Credentials_Aggregate_Fields>;
  nodes: Array<Square_Credentials>;
};

/** aggregate fields of "square_credentials" */
export type Square_Credentials_Aggregate_Fields = {
  __typename?: 'square_credentials_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Square_Credentials_Max_Fields>;
  min?: Maybe<Square_Credentials_Min_Fields>;
};


/** aggregate fields of "square_credentials" */
export type Square_Credentials_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Square_Credentials_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "square_credentials". All fields are combined with a logical 'AND'. */
export type Square_Credentials_Bool_Exp = {
  _and?: InputMaybe<Array<Square_Credentials_Bool_Exp>>;
  _not?: InputMaybe<Square_Credentials_Bool_Exp>;
  _or?: InputMaybe<Array<Square_Credentials_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  ownedBy?: InputMaybe<Square_Credential_Ownership_Enum_Enum_Comparison_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  providerByProvider?: InputMaybe<User_Bool_Exp>;
  squareAccessToken?: InputMaybe<String_Comparison_Exp>;
  squareAccessTokenExpirationDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  squareRefreshToken?: InputMaybe<String_Comparison_Exp>;
  square_credential_ownership_enum?: InputMaybe<Square_Credential_Ownership_Enum_Bool_Exp>;
};

/** unique or primary key constraints on table "square_credentials" */
export enum Square_Credentials_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProviderSquareCredentialsPkey = 'provider_square_credentials_pkey',
  /** unique or primary key constraint on columns "provider" */
  ProviderSquareCredentialsProviderKey = 'provider_square_credentials_provider_key',
  /** unique or primary key constraint on columns "square_access_token" */
  ProviderSquareCredentialsSquareAccessTokenKey = 'provider_square_credentials_square_access_token_key',
  /** unique or primary key constraint on columns "square_refresh_token" */
  ProviderSquareCredentialsSquareRefreshTokenKey = 'provider_square_credentials_square_refresh_token_key',
  /** unique or primary key constraint on columns "location" */
  SquareCredentialsUniqueLocationOwned = 'square_credentials_unique_location_owned'
}

/** input type for inserting data into table "square_credentials" */
export type Square_Credentials_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  ownedBy?: InputMaybe<Square_Credential_Ownership_Enum_Enum>;
  provider?: InputMaybe<Scalars['uuid']>;
  providerByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
  squareAccessToken?: InputMaybe<Scalars['String']>;
  squareAccessTokenExpirationDate?: InputMaybe<Scalars['timestamptz']>;
  squareRefreshToken?: InputMaybe<Scalars['String']>;
  square_credential_ownership_enum?: InputMaybe<Square_Credential_Ownership_Enum_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Square_Credentials_Max_Fields = {
  __typename?: 'square_credentials_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  squareAccessToken?: Maybe<Scalars['String']>;
  squareAccessTokenExpirationDate?: Maybe<Scalars['timestamptz']>;
  squareRefreshToken?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Square_Credentials_Min_Fields = {
  __typename?: 'square_credentials_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  squareAccessToken?: Maybe<Scalars['String']>;
  squareAccessTokenExpirationDate?: Maybe<Scalars['timestamptz']>;
  squareRefreshToken?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "square_credentials" */
export type Square_Credentials_Mutation_Response = {
  __typename?: 'square_credentials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Square_Credentials>;
};

/** on_conflict condition type for table "square_credentials" */
export type Square_Credentials_On_Conflict = {
  constraint: Square_Credentials_Constraint;
  update_columns?: Array<Square_Credentials_Update_Column>;
  where?: InputMaybe<Square_Credentials_Bool_Exp>;
};

/** Ordering options when selecting data from "square_credentials". */
export type Square_Credentials_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  ownedBy?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  providerByProvider?: InputMaybe<User_Order_By>;
  squareAccessToken?: InputMaybe<Order_By>;
  squareAccessTokenExpirationDate?: InputMaybe<Order_By>;
  squareRefreshToken?: InputMaybe<Order_By>;
  square_credential_ownership_enum?: InputMaybe<Square_Credential_Ownership_Enum_Order_By>;
};

/** primary key columns input for table: square_credentials */
export type Square_Credentials_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "square_credentials" */
export enum Square_Credentials_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  OwnedBy = 'ownedBy',
  /** column name */
  Provider = 'provider',
  /** column name */
  SquareAccessToken = 'squareAccessToken',
  /** column name */
  SquareAccessTokenExpirationDate = 'squareAccessTokenExpirationDate',
  /** column name */
  SquareRefreshToken = 'squareRefreshToken'
}

/** input type for updating data in table "square_credentials" */
export type Square_Credentials_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  ownedBy?: InputMaybe<Square_Credential_Ownership_Enum_Enum>;
  provider?: InputMaybe<Scalars['uuid']>;
  squareAccessToken?: InputMaybe<Scalars['String']>;
  squareAccessTokenExpirationDate?: InputMaybe<Scalars['timestamptz']>;
  squareRefreshToken?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "square_credentials" */
export type Square_Credentials_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Square_Credentials_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Square_Credentials_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  ownedBy?: InputMaybe<Square_Credential_Ownership_Enum_Enum>;
  provider?: InputMaybe<Scalars['uuid']>;
  squareAccessToken?: InputMaybe<Scalars['String']>;
  squareAccessTokenExpirationDate?: InputMaybe<Scalars['timestamptz']>;
  squareRefreshToken?: InputMaybe<Scalars['String']>;
};

/** update columns of table "square_credentials" */
export enum Square_Credentials_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  OwnedBy = 'ownedBy',
  /** column name */
  Provider = 'provider',
  /** column name */
  SquareAccessToken = 'squareAccessToken',
  /** column name */
  SquareAccessTokenExpirationDate = 'squareAccessTokenExpirationDate',
  /** column name */
  SquareRefreshToken = 'squareRefreshToken'
}

export type Square_Credentials_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Square_Credentials_Set_Input>;
  /** filter the rows which have to be updated */
  where: Square_Credentials_Bool_Exp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "accreditation" */
  accreditation: Array<Accreditation>;
  /** fetch aggregated fields from the table: "accreditation" */
  accreditation_aggregate: Accreditation_Aggregate;
  /** fetch data from the table: "accreditation" using primary key columns */
  accreditation_by_pk?: Maybe<Accreditation>;
  /** fetch data from the table: "accreditation_location_privilege" */
  accreditation_location_privilege: Array<Accreditation_Location_Privilege>;
  /** fetch aggregated fields from the table: "accreditation_location_privilege" */
  accreditation_location_privilege_aggregate: Accreditation_Location_Privilege_Aggregate;
  /** fetch data from the table: "accreditation_location_privilege" using primary key columns */
  accreditation_location_privilege_by_pk?: Maybe<Accreditation_Location_Privilege>;
  /** fetch data from the table in a streaming manner: "accreditation_location_privilege" */
  accreditation_location_privilege_stream: Array<Accreditation_Location_Privilege>;
  /** fetch data from the table in a streaming manner: "accreditation" */
  accreditation_stream: Array<Accreditation>;
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch aggregated fields from the table: "address" */
  address_aggregate: Address_Aggregate;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>;
  /** fetch data from the table in a streaming manner: "address" */
  address_stream: Array<Address>;
  /** fetch data from the table: "agreement_type" */
  agreement_type: Array<Agreement_Type>;
  /** fetch aggregated fields from the table: "agreement_type" */
  agreement_type_aggregate: Agreement_Type_Aggregate;
  /** fetch data from the table: "agreement_type" using primary key columns */
  agreement_type_by_pk?: Maybe<Agreement_Type>;
  /** fetch data from the table in a streaming manner: "agreement_type" */
  agreement_type_stream: Array<Agreement_Type>;
  /** fetch data from the table: "booking" */
  booking: Array<Booking>;
  /** fetch aggregated fields from the table: "booking" */
  booking_aggregate: Booking_Aggregate;
  /** fetch data from the table: "booking" using primary key columns */
  booking_by_pk?: Maybe<Booking>;
  /** fetch data from the table: "booking_public" */
  booking_public: Array<Booking_Public>;
  /** fetch aggregated fields from the table: "booking_public" */
  booking_public_aggregate: Booking_Public_Aggregate;
  /** fetch data from the table in a streaming manner: "booking_public" */
  booking_public_stream: Array<Booking_Public>;
  /** fetch data from the table in a streaming manner: "booking" */
  booking_stream: Array<Booking>;
  /** fetch data from the table: "booking_type" */
  booking_type: Array<Booking_Type>;
  /** fetch aggregated fields from the table: "booking_type" */
  booking_type_aggregate: Booking_Type_Aggregate;
  /** fetch data from the table: "booking_type" using primary key columns */
  booking_type_by_pk?: Maybe<Booking_Type>;
  /** fetch data from the table in a streaming manner: "booking_type" */
  booking_type_stream: Array<Booking_Type>;
  /** fetch data from the table: "cancel_reason" */
  cancel_reason: Array<Cancel_Reason>;
  /** fetch aggregated fields from the table: "cancel_reason" */
  cancel_reason_aggregate: Cancel_Reason_Aggregate;
  /** fetch data from the table: "cancel_reason" using primary key columns */
  cancel_reason_by_pk?: Maybe<Cancel_Reason>;
  /** fetch data from the table in a streaming manner: "cancel_reason" */
  cancel_reason_stream: Array<Cancel_Reason>;
  /** execute function "check_proposed_patient_booking_for_stacking" which returns "fn_check_proposed_patient_booking_for_stacking" */
  check_proposed_patient_booking_for_stacking: Array<Fn_Check_Proposed_Patient_Booking_For_Stacking>;
  /** execute function "check_proposed_patient_booking_for_stacking" and query aggregates on result of table type "fn_check_proposed_patient_booking_for_stacking" */
  check_proposed_patient_booking_for_stacking_aggregate: Fn_Check_Proposed_Patient_Booking_For_Stacking_Aggregate;
  /** fetch data from the table: "credit" */
  credit: Array<Credit>;
  /** fetch aggregated fields from the table: "credit" */
  credit_aggregate: Credit_Aggregate;
  /** fetch data from the table: "credit" using primary key columns */
  credit_by_pk?: Maybe<Credit>;
  /** fetch data from the table in a streaming manner: "credit" */
  credit_stream: Array<Credit>;
  /** fetch data from the table: "credit_transaction" */
  credit_transaction: Array<Credit_Transaction>;
  /** fetch aggregated fields from the table: "credit_transaction" */
  credit_transaction_aggregate: Credit_Transaction_Aggregate;
  /** fetch data from the table: "credit_transaction" using primary key columns */
  credit_transaction_by_pk?: Maybe<Credit_Transaction>;
  /** fetch data from the table in a streaming manner: "credit_transaction" */
  credit_transaction_stream: Array<Credit_Transaction>;
  /** fetch data from the table: "credit_type" */
  credit_type: Array<Credit_Type>;
  /** fetch aggregated fields from the table: "credit_type" */
  credit_type_aggregate: Credit_Type_Aggregate;
  /** fetch data from the table: "credit_type" using primary key columns */
  credit_type_by_pk?: Maybe<Credit_Type>;
  /** fetch data from the table in a streaming manner: "credit_type" */
  credit_type_stream: Array<Credit_Type>;
  /** fetch data from the table: "demo_location" */
  demo_location: Array<Demo_Location>;
  /** fetch aggregated fields from the table: "demo_location" */
  demo_location_aggregate: Demo_Location_Aggregate;
  /** fetch data from the table: "demo_location" using primary key columns */
  demo_location_by_pk?: Maybe<Demo_Location>;
  /** fetch data from the table in a streaming manner: "demo_location" */
  demo_location_stream: Array<Demo_Location>;
  /** fetch data from the table: "document_type" */
  document_type: Array<Document_Type>;
  /** fetch aggregated fields from the table: "document_type" */
  document_type_aggregate: Document_Type_Aggregate;
  /** fetch data from the table: "document_type" using primary key columns */
  document_type_by_pk?: Maybe<Document_Type>;
  /** fetch data from the table in a streaming manner: "document_type" */
  document_type_stream: Array<Document_Type>;
  /** fetch data from the table: "ehr_charge_ledger" */
  ehr_charge_ledger: Array<Ehr_Charge_Ledger>;
  /** fetch aggregated fields from the table: "ehr_charge_ledger" */
  ehr_charge_ledger_aggregate: Ehr_Charge_Ledger_Aggregate;
  /** fetch data from the table: "ehr_charge_ledger" using primary key columns */
  ehr_charge_ledger_by_pk?: Maybe<Ehr_Charge_Ledger>;
  /** fetch data from the table in a streaming manner: "ehr_charge_ledger" */
  ehr_charge_ledger_stream: Array<Ehr_Charge_Ledger>;
  /** fetch data from the table: "ehr_encounter" */
  ehr_encounter: Array<Ehr_Encounter>;
  /** fetch data from the table: "ehr_encounter_addendum" */
  ehr_encounter_addendum: Array<Ehr_Encounter_Addendum>;
  /** fetch aggregated fields from the table: "ehr_encounter_addendum" */
  ehr_encounter_addendum_aggregate: Ehr_Encounter_Addendum_Aggregate;
  /** fetch data from the table: "ehr_encounter_addendum" using primary key columns */
  ehr_encounter_addendum_by_pk?: Maybe<Ehr_Encounter_Addendum>;
  /** fetch data from the table in a streaming manner: "ehr_encounter_addendum" */
  ehr_encounter_addendum_stream: Array<Ehr_Encounter_Addendum>;
  /** fetch aggregated fields from the table: "ehr_encounter" */
  ehr_encounter_aggregate: Ehr_Encounter_Aggregate;
  /** fetch data from the table: "ehr_encounter" using primary key columns */
  ehr_encounter_by_pk?: Maybe<Ehr_Encounter>;
  /** fetch data from the table: "ehr_encounter_modality" */
  ehr_encounter_modality: Array<Ehr_Encounter_Modality>;
  /** fetch aggregated fields from the table: "ehr_encounter_modality" */
  ehr_encounter_modality_aggregate: Ehr_Encounter_Modality_Aggregate;
  /** fetch data from the table: "ehr_encounter_modality" using primary key columns */
  ehr_encounter_modality_by_pk?: Maybe<Ehr_Encounter_Modality>;
  /** fetch data from the table in a streaming manner: "ehr_encounter_modality" */
  ehr_encounter_modality_stream: Array<Ehr_Encounter_Modality>;
  /** fetch data from the table: "ehr_encounter_photo" */
  ehr_encounter_photo: Array<Ehr_Encounter_Photo>;
  /** fetch aggregated fields from the table: "ehr_encounter_photo" */
  ehr_encounter_photo_aggregate: Ehr_Encounter_Photo_Aggregate;
  /** fetch data from the table: "ehr_encounter_photo" using primary key columns */
  ehr_encounter_photo_by_pk?: Maybe<Ehr_Encounter_Photo>;
  /** fetch data from the table in a streaming manner: "ehr_encounter_photo" */
  ehr_encounter_photo_stream: Array<Ehr_Encounter_Photo>;
  /** fetch data from the table: "ehr_encounter_scan_3d" */
  ehr_encounter_scan_3d: Array<Ehr_Encounter_Scan_3d>;
  /** fetch aggregated fields from the table: "ehr_encounter_scan_3d" */
  ehr_encounter_scan_3d_aggregate: Ehr_Encounter_Scan_3d_Aggregate;
  /** fetch data from the table: "ehr_encounter_scan_3d_artifact" */
  ehr_encounter_scan_3d_artifact: Array<Ehr_Encounter_Scan_3d_Artifact>;
  /** fetch aggregated fields from the table: "ehr_encounter_scan_3d_artifact" */
  ehr_encounter_scan_3d_artifact_aggregate: Ehr_Encounter_Scan_3d_Artifact_Aggregate;
  /** fetch data from the table: "ehr_encounter_scan_3d_artifact" using primary key columns */
  ehr_encounter_scan_3d_artifact_by_pk?: Maybe<Ehr_Encounter_Scan_3d_Artifact>;
  /** fetch data from the table: "ehr_encounter_scan_3d_artifact_kind" */
  ehr_encounter_scan_3d_artifact_kind: Array<Ehr_Encounter_Scan_3d_Artifact_Kind>;
  /** fetch aggregated fields from the table: "ehr_encounter_scan_3d_artifact_kind" */
  ehr_encounter_scan_3d_artifact_kind_aggregate: Ehr_Encounter_Scan_3d_Artifact_Kind_Aggregate;
  /** fetch data from the table: "ehr_encounter_scan_3d_artifact_kind" using primary key columns */
  ehr_encounter_scan_3d_artifact_kind_by_pk?: Maybe<Ehr_Encounter_Scan_3d_Artifact_Kind>;
  /** fetch data from the table in a streaming manner: "ehr_encounter_scan_3d_artifact_kind" */
  ehr_encounter_scan_3d_artifact_kind_stream: Array<Ehr_Encounter_Scan_3d_Artifact_Kind>;
  /** fetch data from the table in a streaming manner: "ehr_encounter_scan_3d_artifact" */
  ehr_encounter_scan_3d_artifact_stream: Array<Ehr_Encounter_Scan_3d_Artifact>;
  /** fetch data from the table: "ehr_encounter_scan_3d" using primary key columns */
  ehr_encounter_scan_3d_by_pk?: Maybe<Ehr_Encounter_Scan_3d>;
  /** fetch data from the table in a streaming manner: "ehr_encounter_scan_3d" */
  ehr_encounter_scan_3d_stream: Array<Ehr_Encounter_Scan_3d>;
  /** fetch data from the table in a streaming manner: "ehr_encounter" */
  ehr_encounter_stream: Array<Ehr_Encounter>;
  /** fetch data from the table: "ehr_encounter_type" */
  ehr_encounter_type: Array<Ehr_Encounter_Type>;
  /** fetch aggregated fields from the table: "ehr_encounter_type" */
  ehr_encounter_type_aggregate: Ehr_Encounter_Type_Aggregate;
  /** fetch data from the table: "ehr_encounter_type" using primary key columns */
  ehr_encounter_type_by_pk?: Maybe<Ehr_Encounter_Type>;
  /** fetch data from the table in a streaming manner: "ehr_encounter_type" */
  ehr_encounter_type_stream: Array<Ehr_Encounter_Type>;
  /** fetch data from the table: "ehr_fda_product" */
  ehr_fda_product: Array<Ehr_Fda_Product>;
  /** fetch aggregated fields from the table: "ehr_fda_product" */
  ehr_fda_product_aggregate: Ehr_Fda_Product_Aggregate;
  /** fetch data from the table: "ehr_fda_product" using primary key columns */
  ehr_fda_product_by_pk?: Maybe<Ehr_Fda_Product>;
  /** fetch data from the table: "ehr_fda_product_source" */
  ehr_fda_product_source: Array<Ehr_Fda_Product_Source>;
  /** fetch aggregated fields from the table: "ehr_fda_product_source" */
  ehr_fda_product_source_aggregate: Ehr_Fda_Product_Source_Aggregate;
  /** fetch data from the table: "ehr_fda_product_source" using primary key columns */
  ehr_fda_product_source_by_pk?: Maybe<Ehr_Fda_Product_Source>;
  /** fetch data from the table in a streaming manner: "ehr_fda_product_source" */
  ehr_fda_product_source_stream: Array<Ehr_Fda_Product_Source>;
  /** fetch data from the table in a streaming manner: "ehr_fda_product" */
  ehr_fda_product_stream: Array<Ehr_Fda_Product>;
  /** fetch data from the table: "ehr_message" */
  ehr_message: Array<Ehr_Message>;
  /** fetch aggregated fields from the table: "ehr_message" */
  ehr_message_aggregate: Ehr_Message_Aggregate;
  /** fetch data from the table: "ehr_message" using primary key columns */
  ehr_message_by_pk?: Maybe<Ehr_Message>;
  /** fetch data from the table: "ehr_message_read" */
  ehr_message_read: Array<Ehr_Message_Read>;
  /** fetch aggregated fields from the table: "ehr_message_read" */
  ehr_message_read_aggregate: Ehr_Message_Read_Aggregate;
  /** fetch data from the table: "ehr_message_read" using primary key columns */
  ehr_message_read_by_pk?: Maybe<Ehr_Message_Read>;
  /** fetch data from the table in a streaming manner: "ehr_message_read" */
  ehr_message_read_stream: Array<Ehr_Message_Read>;
  /** fetch data from the table in a streaming manner: "ehr_message" */
  ehr_message_stream: Array<Ehr_Message>;
  /** fetch data from the table: "ehr_message_threads" */
  ehr_message_threads: Array<Ehr_Message_Threads>;
  /** fetch aggregated fields from the table: "ehr_message_threads" */
  ehr_message_threads_aggregate: Ehr_Message_Threads_Aggregate;
  /** fetch data from the table: "ehr_message_threads" using primary key columns */
  ehr_message_threads_by_pk?: Maybe<Ehr_Message_Threads>;
  /** fetch data from the table in a streaming manner: "ehr_message_threads" */
  ehr_message_threads_stream: Array<Ehr_Message_Threads>;
  /** fetch data from the table: "ehr_patient_card" */
  ehr_patient_card: Array<Ehr_Patient_Card>;
  /** fetch aggregated fields from the table: "ehr_patient_card" */
  ehr_patient_card_aggregate: Ehr_Patient_Card_Aggregate;
  /** fetch data from the table: "ehr_patient_card" using primary key columns */
  ehr_patient_card_by_pk?: Maybe<Ehr_Patient_Card>;
  /** fetch data from the table in a streaming manner: "ehr_patient_card" */
  ehr_patient_card_stream: Array<Ehr_Patient_Card>;
  /** fetch data from the table: "ehr_patient_consent" */
  ehr_patient_consent: Array<Ehr_Patient_Consent>;
  /** fetch data from the table: "ehr_patient_consent_action" */
  ehr_patient_consent_action: Array<Ehr_Patient_Consent_Action>;
  /** fetch aggregated fields from the table: "ehr_patient_consent_action" */
  ehr_patient_consent_action_aggregate: Ehr_Patient_Consent_Action_Aggregate;
  /** fetch data from the table: "ehr_patient_consent_action" using primary key columns */
  ehr_patient_consent_action_by_pk?: Maybe<Ehr_Patient_Consent_Action>;
  /** fetch data from the table in a streaming manner: "ehr_patient_consent_action" */
  ehr_patient_consent_action_stream: Array<Ehr_Patient_Consent_Action>;
  /** fetch aggregated fields from the table: "ehr_patient_consent" */
  ehr_patient_consent_aggregate: Ehr_Patient_Consent_Aggregate;
  /** fetch data from the table: "ehr_patient_consent" using primary key columns */
  ehr_patient_consent_by_pk?: Maybe<Ehr_Patient_Consent>;
  /** fetch data from the table in a streaming manner: "ehr_patient_consent" */
  ehr_patient_consent_stream: Array<Ehr_Patient_Consent>;
  /** fetch data from the table: "ehr_patient_consent_type" */
  ehr_patient_consent_type: Array<Ehr_Patient_Consent_Type>;
  /** fetch aggregated fields from the table: "ehr_patient_consent_type" */
  ehr_patient_consent_type_aggregate: Ehr_Patient_Consent_Type_Aggregate;
  /** fetch data from the table: "ehr_patient_consent_type" using primary key columns */
  ehr_patient_consent_type_by_pk?: Maybe<Ehr_Patient_Consent_Type>;
  /** fetch data from the table in a streaming manner: "ehr_patient_consent_type" */
  ehr_patient_consent_type_stream: Array<Ehr_Patient_Consent_Type>;
  /** fetch data from the table: "ehr_procedure" */
  ehr_procedure: Array<Ehr_Procedure>;
  /** fetch aggregated fields from the table: "ehr_procedure" */
  ehr_procedure_aggregate: Ehr_Procedure_Aggregate;
  /** fetch data from the table: "ehr_procedure_body_area" */
  ehr_procedure_body_area: Array<Ehr_Procedure_Body_Area>;
  /** fetch aggregated fields from the table: "ehr_procedure_body_area" */
  ehr_procedure_body_area_aggregate: Ehr_Procedure_Body_Area_Aggregate;
  /** fetch data from the table: "ehr_procedure_body_area" using primary key columns */
  ehr_procedure_body_area_by_pk?: Maybe<Ehr_Procedure_Body_Area>;
  /** fetch data from the table in a streaming manner: "ehr_procedure_body_area" */
  ehr_procedure_body_area_stream: Array<Ehr_Procedure_Body_Area>;
  /** fetch data from the table: "ehr_procedure_body_part" */
  ehr_procedure_body_part: Array<Ehr_Procedure_Body_Part>;
  /** fetch aggregated fields from the table: "ehr_procedure_body_part" */
  ehr_procedure_body_part_aggregate: Ehr_Procedure_Body_Part_Aggregate;
  /** fetch data from the table: "ehr_procedure_body_part" using primary key columns */
  ehr_procedure_body_part_by_pk?: Maybe<Ehr_Procedure_Body_Part>;
  /** fetch data from the table: "ehr_procedure_body_part_provider_injection_default" */
  ehr_procedure_body_part_provider_injection_default: Array<Ehr_Procedure_Body_Part_Provider_Injection_Default>;
  /** fetch aggregated fields from the table: "ehr_procedure_body_part_provider_injection_default" */
  ehr_procedure_body_part_provider_injection_default_aggregate: Ehr_Procedure_Body_Part_Provider_Injection_Default_Aggregate;
  /** fetch data from the table: "ehr_procedure_body_part_provider_injection_default" using primary key columns */
  ehr_procedure_body_part_provider_injection_default_by_pk?: Maybe<Ehr_Procedure_Body_Part_Provider_Injection_Default>;
  /** fetch data from the table in a streaming manner: "ehr_procedure_body_part_provider_injection_default" */
  ehr_procedure_body_part_provider_injection_default_stream: Array<Ehr_Procedure_Body_Part_Provider_Injection_Default>;
  /** fetch data from the table in a streaming manner: "ehr_procedure_body_part" */
  ehr_procedure_body_part_stream: Array<Ehr_Procedure_Body_Part>;
  /** fetch data from the table: "ehr_procedure" using primary key columns */
  ehr_procedure_by_pk?: Maybe<Ehr_Procedure>;
  /** fetch data from the table: "ehr_procedure_ehr_product" */
  ehr_procedure_ehr_product: Array<Ehr_Procedure_Ehr_Product>;
  /** fetch aggregated fields from the table: "ehr_procedure_ehr_product" */
  ehr_procedure_ehr_product_aggregate: Ehr_Procedure_Ehr_Product_Aggregate;
  /** fetch data from the table: "ehr_procedure_ehr_product" using primary key columns */
  ehr_procedure_ehr_product_by_pk?: Maybe<Ehr_Procedure_Ehr_Product>;
  /** fetch data from the table in a streaming manner: "ehr_procedure_ehr_product" */
  ehr_procedure_ehr_product_stream: Array<Ehr_Procedure_Ehr_Product>;
  /** fetch data from the table in a streaming manner: "ehr_procedure" */
  ehr_procedure_stream: Array<Ehr_Procedure>;
  /** fetch data from the table: "ehr_procedure_type_enum" */
  ehr_procedure_type_enum: Array<Ehr_Procedure_Type_Enum>;
  /** fetch aggregated fields from the table: "ehr_procedure_type_enum" */
  ehr_procedure_type_enum_aggregate: Ehr_Procedure_Type_Enum_Aggregate;
  /** fetch data from the table: "ehr_procedure_type_enum" using primary key columns */
  ehr_procedure_type_enum_by_pk?: Maybe<Ehr_Procedure_Type_Enum>;
  /** fetch data from the table in a streaming manner: "ehr_procedure_type_enum" */
  ehr_procedure_type_enum_stream: Array<Ehr_Procedure_Type_Enum>;
  /** fetch data from the table: "ehr_product" */
  ehr_product: Array<Ehr_Product>;
  /** fetch aggregated fields from the table: "ehr_product" */
  ehr_product_aggregate: Ehr_Product_Aggregate;
  /** fetch data from the table: "ehr_product" using primary key columns */
  ehr_product_by_pk?: Maybe<Ehr_Product>;
  /** fetch data from the table: "ehr_product_procedure" */
  ehr_product_procedure: Array<Ehr_Product_Procedure>;
  /** fetch aggregated fields from the table: "ehr_product_procedure" */
  ehr_product_procedure_aggregate: Ehr_Product_Procedure_Aggregate;
  /** fetch data from the table: "ehr_product_procedure" using primary key columns */
  ehr_product_procedure_by_pk?: Maybe<Ehr_Product_Procedure>;
  /** fetch data from the table in a streaming manner: "ehr_product_procedure" */
  ehr_product_procedure_stream: Array<Ehr_Product_Procedure>;
  /** fetch data from the table: "ehr_product_provider_usage_record_photo" */
  ehr_product_provider_usage_record_photo: Array<Ehr_Product_Provider_Usage_Record_Photo>;
  /** fetch aggregated fields from the table: "ehr_product_provider_usage_record_photo" */
  ehr_product_provider_usage_record_photo_aggregate: Ehr_Product_Provider_Usage_Record_Photo_Aggregate;
  /** fetch data from the table: "ehr_product_provider_usage_record_photo" using primary key columns */
  ehr_product_provider_usage_record_photo_by_pk?: Maybe<Ehr_Product_Provider_Usage_Record_Photo>;
  /** fetch data from the table in a streaming manner: "ehr_product_provider_usage_record_photo" */
  ehr_product_provider_usage_record_photo_stream: Array<Ehr_Product_Provider_Usage_Record_Photo>;
  /** fetch data from the table in a streaming manner: "ehr_product" */
  ehr_product_stream: Array<Ehr_Product>;
  /** fetch data from the table: "ehr_subscription" */
  ehr_subscription: Array<Ehr_Subscription>;
  /** fetch aggregated fields from the table: "ehr_subscription" */
  ehr_subscription_aggregate: Ehr_Subscription_Aggregate;
  /** fetch data from the table: "ehr_subscription" using primary key columns */
  ehr_subscription_by_pk?: Maybe<Ehr_Subscription>;
  /** fetch data from the table: "ehr_subscription_status" */
  ehr_subscription_status: Array<Ehr_Subscription_Status>;
  /** fetch aggregated fields from the table: "ehr_subscription_status" */
  ehr_subscription_status_aggregate: Ehr_Subscription_Status_Aggregate;
  /** fetch data from the table: "ehr_subscription_status" using primary key columns */
  ehr_subscription_status_by_pk?: Maybe<Ehr_Subscription_Status>;
  /** fetch data from the table in a streaming manner: "ehr_subscription_status" */
  ehr_subscription_status_stream: Array<Ehr_Subscription_Status>;
  /** fetch data from the table in a streaming manner: "ehr_subscription" */
  ehr_subscription_stream: Array<Ehr_Subscription>;
  /** fetch data from the table: "ehr_subscription_tier" */
  ehr_subscription_tier: Array<Ehr_Subscription_Tier>;
  /** fetch aggregated fields from the table: "ehr_subscription_tier" */
  ehr_subscription_tier_aggregate: Ehr_Subscription_Tier_Aggregate;
  /** fetch data from the table: "ehr_subscription_tier" using primary key columns */
  ehr_subscription_tier_by_pk?: Maybe<Ehr_Subscription_Tier>;
  /** fetch data from the table in a streaming manner: "ehr_subscription_tier" */
  ehr_subscription_tier_stream: Array<Ehr_Subscription_Tier>;
  /** fetch data from the table: "ehr_subscription_tier_term" */
  ehr_subscription_tier_term: Array<Ehr_Subscription_Tier_Term>;
  /** fetch aggregated fields from the table: "ehr_subscription_tier_term" */
  ehr_subscription_tier_term_aggregate: Ehr_Subscription_Tier_Term_Aggregate;
  /** fetch data from the table: "ehr_subscription_tier_term" using primary key columns */
  ehr_subscription_tier_term_by_pk?: Maybe<Ehr_Subscription_Tier_Term>;
  /** fetch data from the table in a streaming manner: "ehr_subscription_tier_term" */
  ehr_subscription_tier_term_stream: Array<Ehr_Subscription_Tier_Term>;
  /** fetch data from the table: "event" */
  event: Array<Event>;
  /** fetch aggregated fields from the table: "event" */
  event_aggregate: Event_Aggregate;
  /** fetch data from the table: "event" using primary key columns */
  event_by_pk?: Maybe<Event>;
  /** fetch data from the table: "event_source" */
  event_source: Array<Event_Source>;
  /** fetch aggregated fields from the table: "event_source" */
  event_source_aggregate: Event_Source_Aggregate;
  /** fetch data from the table: "event_source" using primary key columns */
  event_source_by_pk?: Maybe<Event_Source>;
  /** fetch data from the table in a streaming manner: "event_source" */
  event_source_stream: Array<Event_Source>;
  /** fetch data from the table in a streaming manner: "event" */
  event_stream: Array<Event>;
  /** fetch data from the table: "filler_procedure_delivery_tool" */
  filler_procedure_delivery_tool: Array<Filler_Procedure_Delivery_Tool>;
  /** fetch aggregated fields from the table: "filler_procedure_delivery_tool" */
  filler_procedure_delivery_tool_aggregate: Filler_Procedure_Delivery_Tool_Aggregate;
  /** fetch data from the table: "filler_procedure_delivery_tool" using primary key columns */
  filler_procedure_delivery_tool_by_pk?: Maybe<Filler_Procedure_Delivery_Tool>;
  /** fetch data from the table in a streaming manner: "filler_procedure_delivery_tool" */
  filler_procedure_delivery_tool_stream: Array<Filler_Procedure_Delivery_Tool>;
  /** fetch data from the table: "filler_procedure_face_view" */
  filler_procedure_face_view: Array<Filler_Procedure_Face_View>;
  /** fetch aggregated fields from the table: "filler_procedure_face_view" */
  filler_procedure_face_view_aggregate: Filler_Procedure_Face_View_Aggregate;
  /** fetch data from the table: "filler_procedure_face_view" using primary key columns */
  filler_procedure_face_view_by_pk?: Maybe<Filler_Procedure_Face_View>;
  /** fetch data from the table in a streaming manner: "filler_procedure_face_view" */
  filler_procedure_face_view_stream: Array<Filler_Procedure_Face_View>;
  /** fetch data from the table: "filler_procedure_injection" */
  filler_procedure_injection: Array<Filler_Procedure_Injection>;
  /** fetch aggregated fields from the table: "filler_procedure_injection" */
  filler_procedure_injection_aggregate: Filler_Procedure_Injection_Aggregate;
  /** fetch data from the table: "filler_procedure_injection" using primary key columns */
  filler_procedure_injection_by_pk?: Maybe<Filler_Procedure_Injection>;
  /** fetch data from the table in a streaming manner: "filler_procedure_injection" */
  filler_procedure_injection_stream: Array<Filler_Procedure_Injection>;
  /** fetch data from the table: "filler_procedure_injection_type" */
  filler_procedure_injection_type: Array<Filler_Procedure_Injection_Type>;
  /** fetch aggregated fields from the table: "filler_procedure_injection_type" */
  filler_procedure_injection_type_aggregate: Filler_Procedure_Injection_Type_Aggregate;
  /** fetch data from the table: "filler_procedure_injection_type" using primary key columns */
  filler_procedure_injection_type_by_pk?: Maybe<Filler_Procedure_Injection_Type>;
  /** fetch data from the table in a streaming manner: "filler_procedure_injection_type" */
  filler_procedure_injection_type_stream: Array<Filler_Procedure_Injection_Type>;
  /** fetch data from the table: "filler_procedure_product_instance" */
  filler_procedure_product_instance: Array<Filler_Procedure_Product_Instance>;
  /** fetch aggregated fields from the table: "filler_procedure_product_instance" */
  filler_procedure_product_instance_aggregate: Filler_Procedure_Product_Instance_Aggregate;
  /** fetch data from the table: "filler_procedure_product_instance" using primary key columns */
  filler_procedure_product_instance_by_pk?: Maybe<Filler_Procedure_Product_Instance>;
  /** fetch data from the table: "filler_procedure_product_instance_photo" */
  filler_procedure_product_instance_photo: Array<Filler_Procedure_Product_Instance_Photo>;
  /** fetch aggregated fields from the table: "filler_procedure_product_instance_photo" */
  filler_procedure_product_instance_photo_aggregate: Filler_Procedure_Product_Instance_Photo_Aggregate;
  /** fetch data from the table: "filler_procedure_product_instance_photo" using primary key columns */
  filler_procedure_product_instance_photo_by_pk?: Maybe<Filler_Procedure_Product_Instance_Photo>;
  /** fetch data from the table in a streaming manner: "filler_procedure_product_instance_photo" */
  filler_procedure_product_instance_photo_stream: Array<Filler_Procedure_Product_Instance_Photo>;
  /** fetch data from the table in a streaming manner: "filler_procedure_product_instance" */
  filler_procedure_product_instance_stream: Array<Filler_Procedure_Product_Instance>;
  /** fetch data from the table: "filler_space" */
  filler_space: Array<Filler_Space>;
  /** fetch aggregated fields from the table: "filler_space" */
  filler_space_aggregate: Filler_Space_Aggregate;
  /** fetch data from the table: "filler_space" using primary key columns */
  filler_space_by_pk?: Maybe<Filler_Space>;
  /** fetch data from the table in a streaming manner: "filler_space" */
  filler_space_stream: Array<Filler_Space>;
  /** fetch data from the table: "filler_zone_release" */
  filler_zone_release: Array<Filler_Zone_Release>;
  /** fetch aggregated fields from the table: "filler_zone_release" */
  filler_zone_release_aggregate: Filler_Zone_Release_Aggregate;
  /** fetch data from the table: "filler_zone_release" using primary key columns */
  filler_zone_release_by_pk?: Maybe<Filler_Zone_Release>;
  /** fetch data from the table in a streaming manner: "filler_zone_release" */
  filler_zone_release_stream: Array<Filler_Zone_Release>;
  /** fetch data from the table: "fn_check_proposed_patient_booking_for_stacking" */
  fn_check_proposed_patient_booking_for_stacking: Array<Fn_Check_Proposed_Patient_Booking_For_Stacking>;
  /** fetch aggregated fields from the table: "fn_check_proposed_patient_booking_for_stacking" */
  fn_check_proposed_patient_booking_for_stacking_aggregate: Fn_Check_Proposed_Patient_Booking_For_Stacking_Aggregate;
  /** fetch data from the table: "fn_check_proposed_patient_booking_for_stacking" using primary key columns */
  fn_check_proposed_patient_booking_for_stacking_by_pk?: Maybe<Fn_Check_Proposed_Patient_Booking_For_Stacking>;
  /** fetch data from the table in a streaming manner: "fn_check_proposed_patient_booking_for_stacking" */
  fn_check_proposed_patient_booking_for_stacking_stream: Array<Fn_Check_Proposed_Patient_Booking_For_Stacking>;
  /** fetch data from the table: "fn_get_active_notification_preferences_for_type_and_location" */
  fn_get_active_notification_preferences_for_type_and_location: Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location>;
  /** fetch aggregated fields from the table: "fn_get_active_notification_preferences_for_type_and_location" */
  fn_get_active_notification_preferences_for_type_and_location_aggregate: Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Aggregate;
  /** fetch data from the table: "fn_get_active_notification_preferences_for_type_and_location" using primary key columns */
  fn_get_active_notification_preferences_for_type_and_location_by_pk?: Maybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location>;
  /** fetch data from the table in a streaming manner: "fn_get_active_notification_preferences_for_type_and_location" */
  fn_get_active_notification_preferences_for_type_and_location_stream: Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location>;
  /** fetch data from the table: "fn_get_active_subscribers_query" */
  fn_get_active_subscribers_query: Array<Fn_Get_Active_Subscribers_Query>;
  /** fetch aggregated fields from the table: "fn_get_active_subscribers_query" */
  fn_get_active_subscribers_query_aggregate: Fn_Get_Active_Subscribers_Query_Aggregate;
  /** fetch data from the table: "fn_get_active_subscribers_query" using primary key columns */
  fn_get_active_subscribers_query_by_pk?: Maybe<Fn_Get_Active_Subscribers_Query>;
  /** fetch data from the table in a streaming manner: "fn_get_active_subscribers_query" */
  fn_get_active_subscribers_query_stream: Array<Fn_Get_Active_Subscribers_Query>;
  /** fetch data from the table: "fn_get_location_purchases_to_provider_purchases_query" */
  fn_get_location_purchases_to_provider_purchases_query: Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query>;
  /** fetch aggregated fields from the table: "fn_get_location_purchases_to_provider_purchases_query" */
  fn_get_location_purchases_to_provider_purchases_query_aggregate: Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Aggregate;
  /** fetch data from the table: "fn_get_location_purchases_to_provider_purchases_query" using primary key columns */
  fn_get_location_purchases_to_provider_purchases_query_by_pk?: Maybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query>;
  /** fetch data from the table in a streaming manner: "fn_get_location_purchases_to_provider_purchases_query" */
  fn_get_location_purchases_to_provider_purchases_query_stream: Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query>;
  /** fetch data from the table: "fn_get_stackable_booking_options_data" */
  fn_get_stackable_booking_options_data: Array<Fn_Get_Stackable_Booking_Options_Data>;
  /** fetch aggregated fields from the table: "fn_get_stackable_booking_options_data" */
  fn_get_stackable_booking_options_data_aggregate: Fn_Get_Stackable_Booking_Options_Data_Aggregate;
  /** fetch data from the table: "fn_get_stackable_booking_options_data" using primary key columns */
  fn_get_stackable_booking_options_data_by_pk?: Maybe<Fn_Get_Stackable_Booking_Options_Data>;
  /** fetch data from the table in a streaming manner: "fn_get_stackable_booking_options_data" */
  fn_get_stackable_booking_options_data_stream: Array<Fn_Get_Stackable_Booking_Options_Data>;
  /** fetch data from the table: "fn_get_user_booking_options_blockers" */
  fn_get_user_booking_options_blockers: Array<Fn_Get_User_Booking_Options_Blockers>;
  /** fetch aggregated fields from the table: "fn_get_user_booking_options_blockers" */
  fn_get_user_booking_options_blockers_aggregate: Fn_Get_User_Booking_Options_Blockers_Aggregate;
  /** fetch data from the table: "fn_get_user_booking_options_blockers" using primary key columns */
  fn_get_user_booking_options_blockers_by_pk?: Maybe<Fn_Get_User_Booking_Options_Blockers>;
  /** fetch data from the table in a streaming manner: "fn_get_user_booking_options_blockers" */
  fn_get_user_booking_options_blockers_stream: Array<Fn_Get_User_Booking_Options_Blockers>;
  /** fetch data from the table: "fn_get_user_location_procedure_unavailable_rooms" */
  fn_get_user_location_procedure_unavailable_rooms: Array<Fn_Get_User_Location_Procedure_Unavailable_Rooms>;
  /** fetch aggregated fields from the table: "fn_get_user_location_procedure_unavailable_rooms" */
  fn_get_user_location_procedure_unavailable_rooms_aggregate: Fn_Get_User_Location_Procedure_Unavailable_Rooms_Aggregate;
  /** fetch data from the table: "fn_get_user_location_procedure_unavailable_rooms" using primary key columns */
  fn_get_user_location_procedure_unavailable_rooms_by_pk?: Maybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms>;
  /** fetch data from the table in a streaming manner: "fn_get_user_location_procedure_unavailable_rooms" */
  fn_get_user_location_procedure_unavailable_rooms_stream: Array<Fn_Get_User_Location_Procedure_Unavailable_Rooms>;
  /** fetch data from the table: "fn_get_user_products_to_rentals_query" */
  fn_get_user_products_to_rentals_query: Array<Fn_Get_User_Products_To_Rentals_Query>;
  /** fetch aggregated fields from the table: "fn_get_user_products_to_rentals_query" */
  fn_get_user_products_to_rentals_query_aggregate: Fn_Get_User_Products_To_Rentals_Query_Aggregate;
  /** fetch data from the table: "fn_get_user_products_to_rentals_query" using primary key columns */
  fn_get_user_products_to_rentals_query_by_pk?: Maybe<Fn_Get_User_Products_To_Rentals_Query>;
  /** fetch data from the table in a streaming manner: "fn_get_user_products_to_rentals_query" */
  fn_get_user_products_to_rentals_query_stream: Array<Fn_Get_User_Products_To_Rentals_Query>;
  /** fetch data from the table: "fn_users_unfulfilled_product_purchases_count_by_location" */
  fn_users_unfulfilled_product_purchases_count_by_location: Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location>;
  /** fetch aggregated fields from the table: "fn_users_unfulfilled_product_purchases_count_by_location" */
  fn_users_unfulfilled_product_purchases_count_by_location_aggregate: Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Aggregate;
  /** fetch data from the table: "fn_users_unfulfilled_product_purchases_count_by_location" using primary key columns */
  fn_users_unfulfilled_product_purchases_count_by_location_by_pk?: Maybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location>;
  /** fetch data from the table in a streaming manner: "fn_users_unfulfilled_product_purchases_count_by_location" */
  fn_users_unfulfilled_product_purchases_count_by_location_stream: Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location>;
  /** fetch data from the table: "gender" */
  gender: Array<Gender>;
  /** fetch aggregated fields from the table: "gender" */
  gender_aggregate: Gender_Aggregate;
  /** fetch data from the table: "gender" using primary key columns */
  gender_by_pk?: Maybe<Gender>;
  /** fetch data from the table in a streaming manner: "gender" */
  gender_stream: Array<Gender>;
  /** execute function "get_active_notification_preferences_for_type_and_location" which returns "fn_get_active_notification_preferences_for_type_and_location" */
  get_active_notification_preferences_for_type_and_location: Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location>;
  /** execute function "get_active_notification_preferences_for_type_and_location" and query aggregates on result of table type "fn_get_active_notification_preferences_for_type_and_location" */
  get_active_notification_preferences_for_type_and_location_aggregate: Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Aggregate;
  /** execute function "get_active_notification_preferences_for_type_any_location" which returns "fn_get_active_notification_preferences_for_type_and_location" */
  get_active_notification_preferences_for_type_any_location: Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location>;
  /** execute function "get_active_notification_preferences_for_type_any_location" and query aggregates on result of table type "fn_get_active_notification_preferences_for_type_and_location" */
  get_active_notification_preferences_for_type_any_location_aggregate: Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Aggregate;
  /** execute function "get_active_subscribers_query" which returns "fn_get_active_subscribers_query" */
  get_active_subscribers_query: Array<Fn_Get_Active_Subscribers_Query>;
  /** execute function "get_active_subscribers_query" and query aggregates on result of table type "fn_get_active_subscribers_query" */
  get_active_subscribers_query_aggregate: Fn_Get_Active_Subscribers_Query_Aggregate;
  /** execute function "get_cumulative_location_plans" which returns "plan" */
  get_cumulative_location_plans: Array<Plan>;
  /** execute function "get_cumulative_location_plans" and query aggregates on result of table type "plan" */
  get_cumulative_location_plans_aggregate: Plan_Aggregate;
  /** execute function "get_location_purchases_to_provider_purchases_query" which returns "fn_get_location_purchases_to_provider_purchases_query" */
  get_location_purchases_to_provider_purchases_query: Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query>;
  /** execute function "get_location_purchases_to_provider_purchases_query" and query aggregates on result of table type "fn_get_location_purchases_to_provider_purchases_query" */
  get_location_purchases_to_provider_purchases_query_aggregate: Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Aggregate;
  /** execute function "get_stackable_booking_options_data" which returns "fn_get_stackable_booking_options_data" */
  get_stackable_booking_options_data: Array<Fn_Get_Stackable_Booking_Options_Data>;
  /** execute function "get_stackable_booking_options_data" and query aggregates on result of table type "fn_get_stackable_booking_options_data" */
  get_stackable_booking_options_data_aggregate: Fn_Get_Stackable_Booking_Options_Data_Aggregate;
  /** execute function "get_user_booking_options_blockers" which returns "fn_get_user_booking_options_blockers" */
  get_user_booking_options_blockers: Array<Fn_Get_User_Booking_Options_Blockers>;
  /** execute function "get_user_booking_options_blockers" and query aggregates on result of table type "fn_get_user_booking_options_blockers" */
  get_user_booking_options_blockers_aggregate: Fn_Get_User_Booking_Options_Blockers_Aggregate;
  /** execute function "get_user_products_to_rentals_query" which returns "fn_get_user_products_to_rentals_query" */
  get_user_products_to_rentals_query: Array<Fn_Get_User_Products_To_Rentals_Query>;
  /** execute function "get_user_products_to_rentals_query" and query aggregates on result of table type "fn_get_user_products_to_rentals_query" */
  get_user_products_to_rentals_query_aggregate: Fn_Get_User_Products_To_Rentals_Query_Aggregate;
  /** fetch data from the table: "invoice" */
  invoice: Array<Invoice>;
  /** fetch aggregated fields from the table: "invoice" */
  invoice_aggregate: Invoice_Aggregate;
  /** fetch data from the table: "invoice_billing_summary" */
  invoice_billing_summary: Array<Invoice_Billing_Summary>;
  /** fetch aggregated fields from the table: "invoice_billing_summary" */
  invoice_billing_summary_aggregate: Invoice_Billing_Summary_Aggregate;
  /** fetch data from the table in a streaming manner: "invoice_billing_summary" */
  invoice_billing_summary_stream: Array<Invoice_Billing_Summary>;
  /** fetch data from the table: "invoice" using primary key columns */
  invoice_by_pk?: Maybe<Invoice>;
  /** fetch data from the table in a streaming manner: "invoice" */
  invoice_stream: Array<Invoice>;
  /** fetch data from the table: "location" */
  location: Array<Location>;
  /** fetch aggregated fields from the table: "location" */
  location_aggregate: Location_Aggregate;
  /** fetch data from the table: "location" using primary key columns */
  location_by_pk?: Maybe<Location>;
  /** fetch data from the table: "location_procedure" */
  location_procedure: Array<Location_Procedure>;
  /** fetch aggregated fields from the table: "location_procedure" */
  location_procedure_aggregate: Location_Procedure_Aggregate;
  /** fetch data from the table: "location_procedure" using primary key columns */
  location_procedure_by_pk?: Maybe<Location_Procedure>;
  /** fetch data from the table: "location_procedure_room" */
  location_procedure_room: Array<Location_Procedure_Room>;
  /** fetch aggregated fields from the table: "location_procedure_room" */
  location_procedure_room_aggregate: Location_Procedure_Room_Aggregate;
  /** fetch data from the table: "location_procedure_room" using primary key columns */
  location_procedure_room_by_pk?: Maybe<Location_Procedure_Room>;
  /** fetch data from the table in a streaming manner: "location_procedure_room" */
  location_procedure_room_stream: Array<Location_Procedure_Room>;
  /** fetch data from the table in a streaming manner: "location_procedure" */
  location_procedure_stream: Array<Location_Procedure>;
  /** fetch data from the table: "location_product" */
  location_product: Array<Location_Product>;
  /** fetch aggregated fields from the table: "location_product" */
  location_product_aggregate: Location_Product_Aggregate;
  /** fetch data from the table: "location_product" using primary key columns */
  location_product_by_pk?: Maybe<Location_Product>;
  /** fetch data from the table in a streaming manner: "location_product" */
  location_product_stream: Array<Location_Product>;
  /** fetch data from the table in a streaming manner: "location" */
  location_stream: Array<Location>;
  /** fetch data from the table: "model" */
  model: Array<Model>;
  /** fetch aggregated fields from the table: "model" */
  model_aggregate: Model_Aggregate;
  /** fetch data from the table: "model" using primary key columns */
  model_by_pk?: Maybe<Model>;
  /** fetch data from the table: "model_count" */
  model_count: Array<Model_Count>;
  /** fetch aggregated fields from the table: "model_count" */
  model_count_aggregate: Model_Count_Aggregate;
  /** fetch data from the table: "model_count" using primary key columns */
  model_count_by_pk?: Maybe<Model_Count>;
  /** fetch data from the table in a streaming manner: "model_count" */
  model_count_stream: Array<Model_Count>;
  /** fetch data from the table: "model_product" */
  model_product: Array<Model_Product>;
  /** fetch aggregated fields from the table: "model_product" */
  model_product_aggregate: Model_Product_Aggregate;
  /** fetch data from the table: "model_product" using primary key columns */
  model_product_by_pk?: Maybe<Model_Product>;
  /** fetch data from the table in a streaming manner: "model_product" */
  model_product_stream: Array<Model_Product>;
  /** fetch data from the table in a streaming manner: "model" */
  model_stream: Array<Model>;
  /** fetch data from the table: "mso_mode" */
  mso_mode: Array<Mso_Mode>;
  /** fetch aggregated fields from the table: "mso_mode" */
  mso_mode_aggregate: Mso_Mode_Aggregate;
  /** fetch data from the table: "mso_mode" using primary key columns */
  mso_mode_by_pk?: Maybe<Mso_Mode>;
  /** fetch data from the table in a streaming manner: "mso_mode" */
  mso_mode_stream: Array<Mso_Mode>;
  /** fetch data from the table: "mso_tier" */
  mso_tier: Array<Mso_Tier>;
  /** fetch aggregated fields from the table: "mso_tier" */
  mso_tier_aggregate: Mso_Tier_Aggregate;
  /** fetch data from the table: "mso_tier" using primary key columns */
  mso_tier_by_pk?: Maybe<Mso_Tier>;
  /** fetch data from the table in a streaming manner: "mso_tier" */
  mso_tier_stream: Array<Mso_Tier>;
  /** fetch data from the table: "notification_audit_log" */
  notification_audit_log: Array<Notification_Audit_Log>;
  /** fetch aggregated fields from the table: "notification_audit_log" */
  notification_audit_log_aggregate: Notification_Audit_Log_Aggregate;
  /** fetch data from the table: "notification_audit_log" using primary key columns */
  notification_audit_log_by_pk?: Maybe<Notification_Audit_Log>;
  /** fetch data from the table in a streaming manner: "notification_audit_log" */
  notification_audit_log_stream: Array<Notification_Audit_Log>;
  /** fetch data from the table: "notification_broadcast_type" */
  notification_broadcast_type: Array<Notification_Broadcast_Type>;
  /** fetch aggregated fields from the table: "notification_broadcast_type" */
  notification_broadcast_type_aggregate: Notification_Broadcast_Type_Aggregate;
  /** fetch data from the table: "notification_broadcast_type" using primary key columns */
  notification_broadcast_type_by_pk?: Maybe<Notification_Broadcast_Type>;
  /** fetch data from the table in a streaming manner: "notification_broadcast_type" */
  notification_broadcast_type_stream: Array<Notification_Broadcast_Type>;
  /** fetch data from the table: "notification_channel" */
  notification_channel: Array<Notification_Channel>;
  /** fetch aggregated fields from the table: "notification_channel" */
  notification_channel_aggregate: Notification_Channel_Aggregate;
  /** fetch data from the table: "notification_channel" using primary key columns */
  notification_channel_by_pk?: Maybe<Notification_Channel>;
  /** fetch data from the table in a streaming manner: "notification_channel" */
  notification_channel_stream: Array<Notification_Channel>;
  /** fetch data from the table: "notification_preference" */
  notification_preference: Array<Notification_Preference>;
  /** fetch aggregated fields from the table: "notification_preference" */
  notification_preference_aggregate: Notification_Preference_Aggregate;
  /** fetch data from the table: "notification_preference" using primary key columns */
  notification_preference_by_pk?: Maybe<Notification_Preference>;
  /** fetch data from the table in a streaming manner: "notification_preference" */
  notification_preference_stream: Array<Notification_Preference>;
  /** fetch data from the table: "notification_type" */
  notification_type: Array<Notification_Type>;
  /** fetch aggregated fields from the table: "notification_type" */
  notification_type_aggregate: Notification_Type_Aggregate;
  /** fetch data from the table: "notification_type" using primary key columns */
  notification_type_by_pk?: Maybe<Notification_Type>;
  /** fetch data from the table: "notification_type_default_channel" */
  notification_type_default_channel: Array<Notification_Type_Default_Channel>;
  /** fetch aggregated fields from the table: "notification_type_default_channel" */
  notification_type_default_channel_aggregate: Notification_Type_Default_Channel_Aggregate;
  /** fetch data from the table: "notification_type_default_channel" using primary key columns */
  notification_type_default_channel_by_pk?: Maybe<Notification_Type_Default_Channel>;
  /** fetch data from the table in a streaming manner: "notification_type_default_channel" */
  notification_type_default_channel_stream: Array<Notification_Type_Default_Channel>;
  /** fetch data from the table in a streaming manner: "notification_type" */
  notification_type_stream: Array<Notification_Type>;
  /** fetch data from the table: "open" */
  open: Array<Open>;
  /** fetch aggregated fields from the table: "open" */
  open_aggregate: Open_Aggregate;
  /** fetch data from the table: "open" using primary key columns */
  open_by_pk?: Maybe<Open>;
  /** fetch data from the table in a streaming manner: "open" */
  open_stream: Array<Open>;
  /** fetch data from the table: "partner" */
  partner: Array<Partner>;
  /** fetch aggregated fields from the table: "partner" */
  partner_aggregate: Partner_Aggregate;
  /** fetch data from the table: "partner_basic" */
  partner_basic: Array<Partner_Basic>;
  /** fetch aggregated fields from the table: "partner_basic" */
  partner_basic_aggregate: Partner_Basic_Aggregate;
  /** fetch data from the table in a streaming manner: "partner_basic" */
  partner_basic_stream: Array<Partner_Basic>;
  /** fetch data from the table: "partner" using primary key columns */
  partner_by_pk?: Maybe<Partner>;
  /** fetch data from the table in a streaming manner: "partner" */
  partner_stream: Array<Partner>;
  /** fetch data from the table: "patient" */
  patient: Array<Patient>;
  /** fetch data from the table: "patient_account_event" */
  patient_account_event: Array<Patient_Account_Event>;
  /** fetch aggregated fields from the table: "patient_account_event" */
  patient_account_event_aggregate: Patient_Account_Event_Aggregate;
  /** fetch data from the table: "patient_account_event" using primary key columns */
  patient_account_event_by_pk?: Maybe<Patient_Account_Event>;
  /** fetch data from the table in a streaming manner: "patient_account_event" */
  patient_account_event_stream: Array<Patient_Account_Event>;
  /** fetch data from the table: "patient_account_event_type" */
  patient_account_event_type: Array<Patient_Account_Event_Type>;
  /** fetch aggregated fields from the table: "patient_account_event_type" */
  patient_account_event_type_aggregate: Patient_Account_Event_Type_Aggregate;
  /** fetch data from the table: "patient_account_event_type" using primary key columns */
  patient_account_event_type_by_pk?: Maybe<Patient_Account_Event_Type>;
  /** fetch data from the table in a streaming manner: "patient_account_event_type" */
  patient_account_event_type_stream: Array<Patient_Account_Event_Type>;
  /** fetch aggregated fields from the table: "patient" */
  patient_aggregate: Patient_Aggregate;
  /** fetch data from the table: "patient_auth_challenge" */
  patient_auth_challenge: Array<Patient_Auth_Challenge>;
  /** fetch aggregated fields from the table: "patient_auth_challenge" */
  patient_auth_challenge_aggregate: Patient_Auth_Challenge_Aggregate;
  /** fetch data from the table: "patient_auth_challenge" using primary key columns */
  patient_auth_challenge_by_pk?: Maybe<Patient_Auth_Challenge>;
  /** fetch data from the table in a streaming manner: "patient_auth_challenge" */
  patient_auth_challenge_stream: Array<Patient_Auth_Challenge>;
  /** fetch data from the table: "patient_bookable_ehr_procedure" */
  patient_bookable_ehr_procedure: Array<Patient_Bookable_Ehr_Procedure>;
  /** fetch aggregated fields from the table: "patient_bookable_ehr_procedure" */
  patient_bookable_ehr_procedure_aggregate: Patient_Bookable_Ehr_Procedure_Aggregate;
  /** fetch data from the table: "patient_bookable_ehr_procedure" using primary key columns */
  patient_bookable_ehr_procedure_by_pk?: Maybe<Patient_Bookable_Ehr_Procedure>;
  /** fetch data from the table in a streaming manner: "patient_bookable_ehr_procedure" */
  patient_bookable_ehr_procedure_stream: Array<Patient_Bookable_Ehr_Procedure>;
  /** fetch data from the table: "patient_booking" */
  patient_booking: Array<Patient_Booking>;
  /** fetch aggregated fields from the table: "patient_booking" */
  patient_booking_aggregate: Patient_Booking_Aggregate;
  /** fetch data from the table: "patient_booking_booking" */
  patient_booking_booking: Array<Patient_Booking_Booking>;
  /** fetch aggregated fields from the table: "patient_booking_booking" */
  patient_booking_booking_aggregate: Patient_Booking_Booking_Aggregate;
  /** fetch data from the table: "patient_booking_booking" using primary key columns */
  patient_booking_booking_by_pk?: Maybe<Patient_Booking_Booking>;
  /** fetch data from the table in a streaming manner: "patient_booking_booking" */
  patient_booking_booking_stream: Array<Patient_Booking_Booking>;
  /** fetch data from the table: "patient_booking" using primary key columns */
  patient_booking_by_pk?: Maybe<Patient_Booking>;
  /** fetch data from the table: "patient_booking_cancel_reason" */
  patient_booking_cancel_reason: Array<Patient_Booking_Cancel_Reason>;
  /** fetch aggregated fields from the table: "patient_booking_cancel_reason" */
  patient_booking_cancel_reason_aggregate: Patient_Booking_Cancel_Reason_Aggregate;
  /** fetch data from the table: "patient_booking_cancel_reason" using primary key columns */
  patient_booking_cancel_reason_by_pk?: Maybe<Patient_Booking_Cancel_Reason>;
  /** fetch data from the table in a streaming manner: "patient_booking_cancel_reason" */
  patient_booking_cancel_reason_stream: Array<Patient_Booking_Cancel_Reason>;
  /** fetch data from the table: "patient_booking_initiator" */
  patient_booking_initiator: Array<Patient_Booking_Initiator>;
  /** fetch aggregated fields from the table: "patient_booking_initiator" */
  patient_booking_initiator_aggregate: Patient_Booking_Initiator_Aggregate;
  /** fetch data from the table: "patient_booking_initiator" using primary key columns */
  patient_booking_initiator_by_pk?: Maybe<Patient_Booking_Initiator>;
  /** fetch data from the table in a streaming manner: "patient_booking_initiator" */
  patient_booking_initiator_stream: Array<Patient_Booking_Initiator>;
  /** fetch data from the table: "patient_booking_metadata" */
  patient_booking_metadata: Array<Patient_Booking_Metadata>;
  /** fetch aggregated fields from the table: "patient_booking_metadata" */
  patient_booking_metadata_aggregate: Patient_Booking_Metadata_Aggregate;
  /** fetch data from the table: "patient_booking_metadata" using primary key columns */
  patient_booking_metadata_by_pk?: Maybe<Patient_Booking_Metadata>;
  /** fetch data from the table in a streaming manner: "patient_booking_metadata" */
  patient_booking_metadata_stream: Array<Patient_Booking_Metadata>;
  /** fetch data from the table in a streaming manner: "patient_booking" */
  patient_booking_stream: Array<Patient_Booking>;
  /** fetch data from the table: "patient" using primary key columns */
  patient_by_pk?: Maybe<Patient>;
  /** fetch data from the table: "patient_last_view" */
  patient_last_view: Array<Patient_Last_View>;
  /** fetch aggregated fields from the table: "patient_last_view" */
  patient_last_view_aggregate: Patient_Last_View_Aggregate;
  /** fetch data from the table: "patient_last_view" using primary key columns */
  patient_last_view_by_pk?: Maybe<Patient_Last_View>;
  /** fetch data from the table in a streaming manner: "patient_last_view" */
  patient_last_view_stream: Array<Patient_Last_View>;
  /** fetch data from the table: "patient_medical_profile" */
  patient_medical_profile: Array<Patient_Medical_Profile>;
  /** fetch aggregated fields from the table: "patient_medical_profile" */
  patient_medical_profile_aggregate: Patient_Medical_Profile_Aggregate;
  /** fetch data from the table: "patient_medical_profile" using primary key columns */
  patient_medical_profile_by_pk?: Maybe<Patient_Medical_Profile>;
  /** fetch data from the table in a streaming manner: "patient_medical_profile" */
  patient_medical_profile_stream: Array<Patient_Medical_Profile>;
  /** fetch data from the table: "patient_registration_invite" */
  patient_registration_invite: Array<Patient_Registration_Invite>;
  /** fetch aggregated fields from the table: "patient_registration_invite" */
  patient_registration_invite_aggregate: Patient_Registration_Invite_Aggregate;
  /** fetch data from the table: "patient_registration_invite" using primary key columns */
  patient_registration_invite_by_pk?: Maybe<Patient_Registration_Invite>;
  /** fetch data from the table in a streaming manner: "patient_registration_invite" */
  patient_registration_invite_stream: Array<Patient_Registration_Invite>;
  /** fetch data from the table: "patient_session" */
  patient_session: Array<Patient_Session>;
  /** fetch aggregated fields from the table: "patient_session" */
  patient_session_aggregate: Patient_Session_Aggregate;
  /** fetch data from the table: "patient_session" using primary key columns */
  patient_session_by_pk?: Maybe<Patient_Session>;
  /** fetch data from the table in a streaming manner: "patient_session" */
  patient_session_stream: Array<Patient_Session>;
  /** fetch data from the table in a streaming manner: "patient" */
  patient_stream: Array<Patient>;
  /** fetch data from the table: "patient_webauthn_challenge" */
  patient_webauthn_challenge: Array<Patient_Webauthn_Challenge>;
  /** fetch aggregated fields from the table: "patient_webauthn_challenge" */
  patient_webauthn_challenge_aggregate: Patient_Webauthn_Challenge_Aggregate;
  /** fetch data from the table: "patient_webauthn_challenge" using primary key columns */
  patient_webauthn_challenge_by_pk?: Maybe<Patient_Webauthn_Challenge>;
  /** fetch data from the table in a streaming manner: "patient_webauthn_challenge" */
  patient_webauthn_challenge_stream: Array<Patient_Webauthn_Challenge>;
  /** fetch data from the table: "patient_webauthn_credential" */
  patient_webauthn_credential: Array<Patient_Webauthn_Credential>;
  /** fetch aggregated fields from the table: "patient_webauthn_credential" */
  patient_webauthn_credential_aggregate: Patient_Webauthn_Credential_Aggregate;
  /** fetch data from the table: "patient_webauthn_credential" using primary key columns */
  patient_webauthn_credential_by_pk?: Maybe<Patient_Webauthn_Credential>;
  /** fetch data from the table in a streaming manner: "patient_webauthn_credential" */
  patient_webauthn_credential_stream: Array<Patient_Webauthn_Credential>;
  /** fetch data from the table: "plan" */
  plan: Array<Plan>;
  /** fetch aggregated fields from the table: "plan" */
  plan_aggregate: Plan_Aggregate;
  /** fetch data from the table: "plan" using primary key columns */
  plan_by_pk?: Maybe<Plan>;
  /** fetch data from the table in a streaming manner: "plan" */
  plan_stream: Array<Plan>;
  /** fetch data from the table: "plan_type" */
  plan_type: Array<Plan_Type>;
  /** fetch aggregated fields from the table: "plan_type" */
  plan_type_aggregate: Plan_Type_Aggregate;
  /** fetch data from the table: "plan_type" using primary key columns */
  plan_type_by_pk?: Maybe<Plan_Type>;
  /** fetch data from the table in a streaming manner: "plan_type" */
  plan_type_stream: Array<Plan_Type>;
  /** fetch data from the table: "pre_procedure_photo_injection_marking" */
  pre_procedure_photo_injection_marking: Array<Pre_Procedure_Photo_Injection_Marking>;
  /** fetch aggregated fields from the table: "pre_procedure_photo_injection_marking" */
  pre_procedure_photo_injection_marking_aggregate: Pre_Procedure_Photo_Injection_Marking_Aggregate;
  /** fetch data from the table: "pre_procedure_photo_injection_marking" using primary key columns */
  pre_procedure_photo_injection_marking_by_pk?: Maybe<Pre_Procedure_Photo_Injection_Marking>;
  /** fetch data from the table in a streaming manner: "pre_procedure_photo_injection_marking" */
  pre_procedure_photo_injection_marking_stream: Array<Pre_Procedure_Photo_Injection_Marking>;
  /** fetch data from the table: "procedure" */
  procedure: Array<Procedure>;
  /** fetch aggregated fields from the table: "procedure" */
  procedure_aggregate: Procedure_Aggregate;
  /** fetch data from the table: "procedure_audio_recording" */
  procedure_audio_recording: Array<Procedure_Audio_Recording>;
  /** fetch aggregated fields from the table: "procedure_audio_recording" */
  procedure_audio_recording_aggregate: Procedure_Audio_Recording_Aggregate;
  /** fetch data from the table: "procedure_audio_recording" using primary key columns */
  procedure_audio_recording_by_pk?: Maybe<Procedure_Audio_Recording>;
  /** fetch data from the table in a streaming manner: "procedure_audio_recording" */
  procedure_audio_recording_stream: Array<Procedure_Audio_Recording>;
  /** fetch data from the table: "procedure" using primary key columns */
  procedure_by_pk?: Maybe<Procedure>;
  /** fetch data from the table in a streaming manner: "procedure" */
  procedure_stream: Array<Procedure>;
  /** fetch data from the table: "product" */
  product: Array<Product>;
  /** fetch aggregated fields from the table: "product" */
  product_aggregate: Product_Aggregate;
  /** fetch data from the table: "product" using primary key columns */
  product_by_pk?: Maybe<Product>;
  /** fetch data from the table: "product_purchase" */
  product_purchase: Array<Product_Purchase>;
  /** fetch aggregated fields from the table: "product_purchase" */
  product_purchase_aggregate: Product_Purchase_Aggregate;
  /** fetch data from the table: "product_purchase" using primary key columns */
  product_purchase_by_pk?: Maybe<Product_Purchase>;
  /** fetch data from the table in a streaming manner: "product_purchase" */
  product_purchase_stream: Array<Product_Purchase>;
  /** fetch data from the table in a streaming manner: "product" */
  product_stream: Array<Product>;
  /** fetch data from the table: "product_type" */
  product_type: Array<Product_Type>;
  /** fetch aggregated fields from the table: "product_type" */
  product_type_aggregate: Product_Type_Aggregate;
  /** fetch data from the table: "product_type" using primary key columns */
  product_type_by_pk?: Maybe<Product_Type>;
  /** fetch data from the table in a streaming manner: "product_type" */
  product_type_stream: Array<Product_Type>;
  /** fetch data from the table: "provider_direct_product_purchase" */
  provider_direct_product_purchase: Array<Provider_Direct_Product_Purchase>;
  /** fetch aggregated fields from the table: "provider_direct_product_purchase" */
  provider_direct_product_purchase_aggregate: Provider_Direct_Product_Purchase_Aggregate;
  /** fetch data from the table: "provider_direct_product_purchase" using primary key columns */
  provider_direct_product_purchase_by_pk?: Maybe<Provider_Direct_Product_Purchase>;
  /** fetch data from the table in a streaming manner: "provider_direct_product_purchase" */
  provider_direct_product_purchase_stream: Array<Provider_Direct_Product_Purchase>;
  /** fetch data from the table: "provider_direct_purchase_web_admin_view" */
  provider_direct_purchase_web_admin_view: Array<Provider_Direct_Purchase_Web_Admin_View>;
  /** fetch aggregated fields from the table: "provider_direct_purchase_web_admin_view" */
  provider_direct_purchase_web_admin_view_aggregate: Provider_Direct_Purchase_Web_Admin_View_Aggregate;
  /** fetch data from the table in a streaming manner: "provider_direct_purchase_web_admin_view" */
  provider_direct_purchase_web_admin_view_stream: Array<Provider_Direct_Purchase_Web_Admin_View>;
  /** An array relationship */
  provider_hours: Array<Provider_Hours>;
  /** An aggregate relationship */
  provider_hours_aggregate: Provider_Hours_Aggregate;
  /** fetch data from the table: "provider_hours" using primary key columns */
  provider_hours_by_pk?: Maybe<Provider_Hours>;
  /** fetch data from the table: "provider_hours_repeat_interval" */
  provider_hours_repeat_interval: Array<Provider_Hours_Repeat_Interval>;
  /** fetch aggregated fields from the table: "provider_hours_repeat_interval" */
  provider_hours_repeat_interval_aggregate: Provider_Hours_Repeat_Interval_Aggregate;
  /** fetch data from the table: "provider_hours_repeat_interval" using primary key columns */
  provider_hours_repeat_interval_by_pk?: Maybe<Provider_Hours_Repeat_Interval>;
  /** fetch data from the table in a streaming manner: "provider_hours_repeat_interval" */
  provider_hours_repeat_interval_stream: Array<Provider_Hours_Repeat_Interval>;
  /** fetch data from the table: "provider_hours_repeater" */
  provider_hours_repeater: Array<Provider_Hours_Repeater>;
  /** fetch aggregated fields from the table: "provider_hours_repeater" */
  provider_hours_repeater_aggregate: Provider_Hours_Repeater_Aggregate;
  /** fetch data from the table: "provider_hours_repeater" using primary key columns */
  provider_hours_repeater_by_pk?: Maybe<Provider_Hours_Repeater>;
  /** fetch data from the table in a streaming manner: "provider_hours_repeater" */
  provider_hours_repeater_stream: Array<Provider_Hours_Repeater>;
  /** fetch data from the table in a streaming manner: "provider_hours" */
  provider_hours_stream: Array<Provider_Hours>;
  /** fetch data from the table: "provider_patient_booking_settings" */
  provider_patient_booking_settings: Array<Provider_Patient_Booking_Settings>;
  /** fetch aggregated fields from the table: "provider_patient_booking_settings" */
  provider_patient_booking_settings_aggregate: Provider_Patient_Booking_Settings_Aggregate;
  /** fetch data from the table: "provider_patient_booking_settings" using primary key columns */
  provider_patient_booking_settings_by_pk?: Maybe<Provider_Patient_Booking_Settings>;
  /** fetch data from the table in a streaming manner: "provider_patient_booking_settings" */
  provider_patient_booking_settings_stream: Array<Provider_Patient_Booking_Settings>;
  /** fetch data from the table: "provider_procedure" */
  provider_procedure: Array<Provider_Procedure>;
  /** fetch aggregated fields from the table: "provider_procedure" */
  provider_procedure_aggregate: Provider_Procedure_Aggregate;
  /** fetch data from the table: "provider_procedure" using primary key columns */
  provider_procedure_by_pk?: Maybe<Provider_Procedure>;
  /** fetch data from the table in a streaming manner: "provider_procedure" */
  provider_procedure_stream: Array<Provider_Procedure>;
  /** fetch data from the table: "purchase_for_location" */
  purchase_for_location: Array<Purchase_For_Location>;
  /** fetch aggregated fields from the table: "purchase_for_location" */
  purchase_for_location_aggregate: Purchase_For_Location_Aggregate;
  /** fetch data from the table: "purchase_for_location" using primary key columns */
  purchase_for_location_by_pk?: Maybe<Purchase_For_Location>;
  /** fetch data from the table in a streaming manner: "purchase_for_location" */
  purchase_for_location_stream: Array<Purchase_For_Location>;
  /** fetch data from the table: "purchase_requests_list" */
  purchase_requests_list: Array<Purchase_Requests_List>;
  /** fetch aggregated fields from the table: "purchase_requests_list" */
  purchase_requests_list_aggregate: Purchase_Requests_List_Aggregate;
  /** fetch data from the table in a streaming manner: "purchase_requests_list" */
  purchase_requests_list_stream: Array<Purchase_Requests_List>;
  /** fetch data from the table: "rental_volume_discount" */
  rental_volume_discount: Array<Rental_Volume_Discount>;
  /** fetch aggregated fields from the table: "rental_volume_discount" */
  rental_volume_discount_aggregate: Rental_Volume_Discount_Aggregate;
  /** fetch data from the table: "rental_volume_discount" using primary key columns */
  rental_volume_discount_by_pk?: Maybe<Rental_Volume_Discount>;
  /** fetch data from the table in a streaming manner: "rental_volume_discount" */
  rental_volume_discount_stream: Array<Rental_Volume_Discount>;
  /** fetch data from the table: "repeating" */
  repeating: Array<Repeating>;
  /** fetch aggregated fields from the table: "repeating" */
  repeating_aggregate: Repeating_Aggregate;
  /** fetch data from the table: "repeating" using primary key columns */
  repeating_by_pk?: Maybe<Repeating>;
  /** fetch data from the table in a streaming manner: "repeating" */
  repeating_stream: Array<Repeating>;
  /** fetch data from the table: "report_preference" */
  report_preference: Array<Report_Preference>;
  /** fetch aggregated fields from the table: "report_preference" */
  report_preference_aggregate: Report_Preference_Aggregate;
  /** fetch data from the table: "report_preference" using primary key columns */
  report_preference_by_pk?: Maybe<Report_Preference>;
  /** fetch data from the table in a streaming manner: "report_preference" */
  report_preference_stream: Array<Report_Preference>;
  /** fetch data from the table: "report_type" */
  report_type: Array<Report_Type>;
  /** fetch aggregated fields from the table: "report_type" */
  report_type_aggregate: Report_Type_Aggregate;
  /** fetch data from the table: "report_type" using primary key columns */
  report_type_by_pk?: Maybe<Report_Type>;
  /** fetch data from the table in a streaming manner: "report_type" */
  report_type_stream: Array<Report_Type>;
  /** fetch data from the table: "role" */
  role: Array<Role>;
  /** fetch aggregated fields from the table: "role" */
  role_aggregate: Role_Aggregate;
  /** fetch data from the table: "role" using primary key columns */
  role_by_pk?: Maybe<Role>;
  /** fetch data from the table: "role_notification" */
  role_notification: Array<Role_Notification>;
  /** fetch aggregated fields from the table: "role_notification" */
  role_notification_aggregate: Role_Notification_Aggregate;
  /** fetch data from the table: "role_notification" using primary key columns */
  role_notification_by_pk?: Maybe<Role_Notification>;
  /** fetch data from the table in a streaming manner: "role_notification" */
  role_notification_stream: Array<Role_Notification>;
  /** fetch data from the table in a streaming manner: "role" */
  role_stream: Array<Role>;
  /** fetch data from the table: "room" */
  room: Array<Room>;
  /** fetch aggregated fields from the table: "room" */
  room_aggregate: Room_Aggregate;
  /** fetch data from the table: "room" using primary key columns */
  room_by_pk?: Maybe<Room>;
  /** fetch data from the table: "room_model" */
  room_model: Array<Room_Model>;
  /** fetch aggregated fields from the table: "room_model" */
  room_model_aggregate: Room_Model_Aggregate;
  /** fetch data from the table: "room_model" using primary key columns */
  room_model_by_pk?: Maybe<Room_Model>;
  /** fetch data from the table in a streaming manner: "room_model" */
  room_model_stream: Array<Room_Model>;
  /** fetch data from the table in a streaming manner: "room" */
  room_stream: Array<Room>;
  /** fetch data from the table: "room_type" */
  room_type: Array<Room_Type>;
  /** fetch aggregated fields from the table: "room_type" */
  room_type_aggregate: Room_Type_Aggregate;
  /** fetch data from the table: "room_type" using primary key columns */
  room_type_by_pk?: Maybe<Room_Type>;
  /** fetch data from the table in a streaming manner: "room_type" */
  room_type_stream: Array<Room_Type>;
  /** fetch data from the table: "sex" */
  sex: Array<Sex>;
  /** fetch aggregated fields from the table: "sex" */
  sex_aggregate: Sex_Aggregate;
  /** fetch data from the table: "sex" using primary key columns */
  sex_by_pk?: Maybe<Sex>;
  /** fetch data from the table in a streaming manner: "sex" */
  sex_stream: Array<Sex>;
  /** fetch data from the table: "signing_document" */
  signing_document: Array<Signing_Document>;
  /** fetch aggregated fields from the table: "signing_document" */
  signing_document_aggregate: Signing_Document_Aggregate;
  /** fetch data from the table: "signing_document" using primary key columns */
  signing_document_by_pk?: Maybe<Signing_Document>;
  /** fetch data from the table: "signing_document_status_type" */
  signing_document_status_type: Array<Signing_Document_Status_Type>;
  /** fetch aggregated fields from the table: "signing_document_status_type" */
  signing_document_status_type_aggregate: Signing_Document_Status_Type_Aggregate;
  /** fetch data from the table: "signing_document_status_type" using primary key columns */
  signing_document_status_type_by_pk?: Maybe<Signing_Document_Status_Type>;
  /** fetch data from the table in a streaming manner: "signing_document_status_type" */
  signing_document_status_type_stream: Array<Signing_Document_Status_Type>;
  /** fetch data from the table in a streaming manner: "signing_document" */
  signing_document_stream: Array<Signing_Document>;
  /** fetch data from the table: "signing_procedure_associated_documents" */
  signing_procedure_associated_documents: Array<Signing_Procedure_Associated_Documents>;
  /** fetch aggregated fields from the table: "signing_procedure_associated_documents" */
  signing_procedure_associated_documents_aggregate: Signing_Procedure_Associated_Documents_Aggregate;
  /** fetch data from the table: "signing_procedure_associated_documents" using primary key columns */
  signing_procedure_associated_documents_by_pk?: Maybe<Signing_Procedure_Associated_Documents>;
  /** fetch data from the table in a streaming manner: "signing_procedure_associated_documents" */
  signing_procedure_associated_documents_stream: Array<Signing_Procedure_Associated_Documents>;
  /** fetch data from the table: "signing_template" */
  signing_template: Array<Signing_Template>;
  /** fetch aggregated fields from the table: "signing_template" */
  signing_template_aggregate: Signing_Template_Aggregate;
  /** fetch data from the table: "signing_template" using primary key columns */
  signing_template_by_pk?: Maybe<Signing_Template>;
  /** fetch data from the table: "signing_template_equivalents" */
  signing_template_equivalents: Array<Signing_Template_Equivalents>;
  /** fetch aggregated fields from the table: "signing_template_equivalents" */
  signing_template_equivalents_aggregate: Signing_Template_Equivalents_Aggregate;
  /** fetch data from the table: "signing_template_equivalents" using primary key columns */
  signing_template_equivalents_by_pk?: Maybe<Signing_Template_Equivalents>;
  /** fetch data from the table in a streaming manner: "signing_template_equivalents" */
  signing_template_equivalents_stream: Array<Signing_Template_Equivalents>;
  /** fetch data from the table: "signing_template_kind" */
  signing_template_kind: Array<Signing_Template_Kind>;
  /** fetch aggregated fields from the table: "signing_template_kind" */
  signing_template_kind_aggregate: Signing_Template_Kind_Aggregate;
  /** fetch data from the table: "signing_template_kind" using primary key columns */
  signing_template_kind_by_pk?: Maybe<Signing_Template_Kind>;
  /** fetch data from the table in a streaming manner: "signing_template_kind" */
  signing_template_kind_stream: Array<Signing_Template_Kind>;
  /** fetch data from the table: "signing_template_source_files" */
  signing_template_source_files: Array<Signing_Template_Source_Files>;
  /** fetch aggregated fields from the table: "signing_template_source_files" */
  signing_template_source_files_aggregate: Signing_Template_Source_Files_Aggregate;
  /** fetch data from the table: "signing_template_source_files" using primary key columns */
  signing_template_source_files_by_pk?: Maybe<Signing_Template_Source_Files>;
  /** fetch data from the table in a streaming manner: "signing_template_source_files" */
  signing_template_source_files_stream: Array<Signing_Template_Source_Files>;
  /** fetch data from the table in a streaming manner: "signing_template" */
  signing_template_stream: Array<Signing_Template>;
  /** fetch data from the table: "signing_vansanity_template" */
  signing_vansanity_template: Array<Signing_Vansanity_Template>;
  /** fetch aggregated fields from the table: "signing_vansanity_template" */
  signing_vansanity_template_aggregate: Signing_Vansanity_Template_Aggregate;
  /** fetch data from the table: "signing_vansanity_template" using primary key columns */
  signing_vansanity_template_by_pk?: Maybe<Signing_Vansanity_Template>;
  /** fetch data from the table in a streaming manner: "signing_vansanity_template" */
  signing_vansanity_template_stream: Array<Signing_Vansanity_Template>;
  /** fetch data from the table: "signing_webhook_event" */
  signing_webhook_event: Array<Signing_Webhook_Event>;
  /** fetch aggregated fields from the table: "signing_webhook_event" */
  signing_webhook_event_aggregate: Signing_Webhook_Event_Aggregate;
  /** fetch data from the table: "signing_webhook_event" using primary key columns */
  signing_webhook_event_by_pk?: Maybe<Signing_Webhook_Event>;
  /** fetch data from the table in a streaming manner: "signing_webhook_event" */
  signing_webhook_event_stream: Array<Signing_Webhook_Event>;
  /** fetch data from the table: "signing_webhook_event_type" */
  signing_webhook_event_type: Array<Signing_Webhook_Event_Type>;
  /** fetch aggregated fields from the table: "signing_webhook_event_type" */
  signing_webhook_event_type_aggregate: Signing_Webhook_Event_Type_Aggregate;
  /** fetch data from the table: "signing_webhook_event_type" using primary key columns */
  signing_webhook_event_type_by_pk?: Maybe<Signing_Webhook_Event_Type>;
  /** fetch data from the table in a streaming manner: "signing_webhook_event_type" */
  signing_webhook_event_type_stream: Array<Signing_Webhook_Event_Type>;
  /** fetch data from the table: "square_credential_ownership_enum" */
  square_credential_ownership_enum: Array<Square_Credential_Ownership_Enum>;
  /** fetch aggregated fields from the table: "square_credential_ownership_enum" */
  square_credential_ownership_enum_aggregate: Square_Credential_Ownership_Enum_Aggregate;
  /** fetch data from the table: "square_credential_ownership_enum" using primary key columns */
  square_credential_ownership_enum_by_pk?: Maybe<Square_Credential_Ownership_Enum>;
  /** fetch data from the table in a streaming manner: "square_credential_ownership_enum" */
  square_credential_ownership_enum_stream: Array<Square_Credential_Ownership_Enum>;
  /** fetch data from the table: "square_credentials" */
  square_credentials: Array<Square_Credentials>;
  /** fetch aggregated fields from the table: "square_credentials" */
  square_credentials_aggregate: Square_Credentials_Aggregate;
  /** fetch data from the table: "square_credentials" using primary key columns */
  square_credentials_by_pk?: Maybe<Square_Credentials>;
  /** fetch data from the table in a streaming manner: "square_credentials" */
  square_credentials_stream: Array<Square_Credentials>;
  /** fetch data from the table: "supervisor_provider" */
  supervisor_provider: Array<Supervisor_Provider>;
  /** fetch aggregated fields from the table: "supervisor_provider" */
  supervisor_provider_aggregate: Supervisor_Provider_Aggregate;
  /** fetch data from the table: "supervisor_provider" using primary key columns */
  supervisor_provider_by_pk?: Maybe<Supervisor_Provider>;
  /** fetch data from the table: "supervisor_provider_initiated_by" */
  supervisor_provider_initiated_by: Array<Supervisor_Provider_Initiated_By>;
  /** fetch aggregated fields from the table: "supervisor_provider_initiated_by" */
  supervisor_provider_initiated_by_aggregate: Supervisor_Provider_Initiated_By_Aggregate;
  /** fetch data from the table: "supervisor_provider_initiated_by" using primary key columns */
  supervisor_provider_initiated_by_by_pk?: Maybe<Supervisor_Provider_Initiated_By>;
  /** fetch data from the table in a streaming manner: "supervisor_provider_initiated_by" */
  supervisor_provider_initiated_by_stream: Array<Supervisor_Provider_Initiated_By>;
  /** fetch data from the table in a streaming manner: "supervisor_provider" */
  supervisor_provider_stream: Array<Supervisor_Provider>;
  /** fetch data from the table: "supervisor_provider_term" */
  supervisor_provider_term: Array<Supervisor_Provider_Term>;
  /** fetch aggregated fields from the table: "supervisor_provider_term" */
  supervisor_provider_term_aggregate: Supervisor_Provider_Term_Aggregate;
  /** fetch data from the table: "supervisor_provider_term" using primary key columns */
  supervisor_provider_term_by_pk?: Maybe<Supervisor_Provider_Term>;
  /** fetch data from the table: "supervisor_provider_term_ended_by" */
  supervisor_provider_term_ended_by: Array<Supervisor_Provider_Term_Ended_By>;
  /** fetch aggregated fields from the table: "supervisor_provider_term_ended_by" */
  supervisor_provider_term_ended_by_aggregate: Supervisor_Provider_Term_Ended_By_Aggregate;
  /** fetch data from the table: "supervisor_provider_term_ended_by" using primary key columns */
  supervisor_provider_term_ended_by_by_pk?: Maybe<Supervisor_Provider_Term_Ended_By>;
  /** fetch data from the table in a streaming manner: "supervisor_provider_term_ended_by" */
  supervisor_provider_term_ended_by_stream: Array<Supervisor_Provider_Term_Ended_By>;
  /** fetch data from the table in a streaming manner: "supervisor_provider_term" */
  supervisor_provider_term_stream: Array<Supervisor_Provider_Term>;
  /** fetch data from the table: "supervisor_review_queue_item" */
  supervisor_review_queue_item: Array<Supervisor_Review_Queue_Item>;
  /** fetch aggregated fields from the table: "supervisor_review_queue_item" */
  supervisor_review_queue_item_aggregate: Supervisor_Review_Queue_Item_Aggregate;
  /** fetch data from the table: "supervisor_review_queue_item" using primary key columns */
  supervisor_review_queue_item_by_pk?: Maybe<Supervisor_Review_Queue_Item>;
  /** fetch data from the table: "supervisor_review_queue_item_status_history" */
  supervisor_review_queue_item_status_history: Array<Supervisor_Review_Queue_Item_Status_History>;
  /** fetch aggregated fields from the table: "supervisor_review_queue_item_status_history" */
  supervisor_review_queue_item_status_history_aggregate: Supervisor_Review_Queue_Item_Status_History_Aggregate;
  /** fetch data from the table: "supervisor_review_queue_item_status_history" using primary key columns */
  supervisor_review_queue_item_status_history_by_pk?: Maybe<Supervisor_Review_Queue_Item_Status_History>;
  /** fetch data from the table in a streaming manner: "supervisor_review_queue_item_status_history" */
  supervisor_review_queue_item_status_history_stream: Array<Supervisor_Review_Queue_Item_Status_History>;
  /** fetch data from the table in a streaming manner: "supervisor_review_queue_item" */
  supervisor_review_queue_item_stream: Array<Supervisor_Review_Queue_Item>;
  /** fetch data from the table: "supervisor_review_queue_source" */
  supervisor_review_queue_source: Array<Supervisor_Review_Queue_Source>;
  /** fetch aggregated fields from the table: "supervisor_review_queue_source" */
  supervisor_review_queue_source_aggregate: Supervisor_Review_Queue_Source_Aggregate;
  /** fetch data from the table: "supervisor_review_queue_source" using primary key columns */
  supervisor_review_queue_source_by_pk?: Maybe<Supervisor_Review_Queue_Source>;
  /** fetch data from the table in a streaming manner: "supervisor_review_queue_source" */
  supervisor_review_queue_source_stream: Array<Supervisor_Review_Queue_Source>;
  /** fetch data from the table: "supervisor_review_queue_status" */
  supervisor_review_queue_status: Array<Supervisor_Review_Queue_Status>;
  /** fetch aggregated fields from the table: "supervisor_review_queue_status" */
  supervisor_review_queue_status_aggregate: Supervisor_Review_Queue_Status_Aggregate;
  /** fetch data from the table: "supervisor_review_queue_status" using primary key columns */
  supervisor_review_queue_status_by_pk?: Maybe<Supervisor_Review_Queue_Status>;
  /** fetch data from the table in a streaming manner: "supervisor_review_queue_status" */
  supervisor_review_queue_status_stream: Array<Supervisor_Review_Queue_Status>;
  /** fetch data from the table: "supervisor_sampling_period_type" */
  supervisor_sampling_period_type: Array<Supervisor_Sampling_Period_Type>;
  /** fetch aggregated fields from the table: "supervisor_sampling_period_type" */
  supervisor_sampling_period_type_aggregate: Supervisor_Sampling_Period_Type_Aggregate;
  /** fetch data from the table: "supervisor_sampling_period_type" using primary key columns */
  supervisor_sampling_period_type_by_pk?: Maybe<Supervisor_Sampling_Period_Type>;
  /** fetch data from the table in a streaming manner: "supervisor_sampling_period_type" */
  supervisor_sampling_period_type_stream: Array<Supervisor_Sampling_Period_Type>;
  /** fetch data from the table: "supervisor_setting" */
  supervisor_setting: Array<Supervisor_Setting>;
  /** fetch aggregated fields from the table: "supervisor_setting" */
  supervisor_setting_aggregate: Supervisor_Setting_Aggregate;
  /** fetch data from the table: "supervisor_setting" using primary key columns */
  supervisor_setting_by_pk?: Maybe<Supervisor_Setting>;
  /** fetch data from the table in a streaming manner: "supervisor_setting" */
  supervisor_setting_stream: Array<Supervisor_Setting>;
  /** fetch data from the table: "tax_rate" */
  tax_rate: Array<Tax_Rate>;
  /** fetch aggregated fields from the table: "tax_rate" */
  tax_rate_aggregate: Tax_Rate_Aggregate;
  /** fetch data from the table: "tax_rate" using primary key columns */
  tax_rate_by_pk?: Maybe<Tax_Rate>;
  /** fetch data from the table in a streaming manner: "tax_rate" */
  tax_rate_stream: Array<Tax_Rate>;
  /** fetch data from the table: "tax_type" */
  tax_type: Array<Tax_Type>;
  /** fetch aggregated fields from the table: "tax_type" */
  tax_type_aggregate: Tax_Type_Aggregate;
  /** fetch data from the table: "tax_type" using primary key columns */
  tax_type_by_pk?: Maybe<Tax_Type>;
  /** fetch data from the table in a streaming manner: "tax_type" */
  tax_type_stream: Array<Tax_Type>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user_agreements" */
  user_agreements: Array<User_Agreements>;
  /** fetch aggregated fields from the table: "user_agreements" */
  user_agreements_aggregate: User_Agreements_Aggregate;
  /** fetch data from the table: "user_agreements" using primary key columns */
  user_agreements_by_pk?: Maybe<User_Agreements>;
  /** fetch data from the table in a streaming manner: "user_agreements" */
  user_agreements_stream: Array<User_Agreements>;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_consent" */
  user_consent: Array<User_Consent>;
  /** fetch data from the table: "user_consent_action" */
  user_consent_action: Array<User_Consent_Action>;
  /** fetch aggregated fields from the table: "user_consent_action" */
  user_consent_action_aggregate: User_Consent_Action_Aggregate;
  /** fetch data from the table: "user_consent_action" using primary key columns */
  user_consent_action_by_pk?: Maybe<User_Consent_Action>;
  /** fetch data from the table in a streaming manner: "user_consent_action" */
  user_consent_action_stream: Array<User_Consent_Action>;
  /** fetch aggregated fields from the table: "user_consent" */
  user_consent_aggregate: User_Consent_Aggregate;
  /** fetch data from the table: "user_consent" using primary key columns */
  user_consent_by_pk?: Maybe<User_Consent>;
  /** fetch data from the table in a streaming manner: "user_consent" */
  user_consent_stream: Array<User_Consent>;
  /** fetch data from the table: "user_consent_type" */
  user_consent_type: Array<User_Consent_Type>;
  /** fetch aggregated fields from the table: "user_consent_type" */
  user_consent_type_aggregate: User_Consent_Type_Aggregate;
  /** fetch data from the table: "user_consent_type" using primary key columns */
  user_consent_type_by_pk?: Maybe<User_Consent_Type>;
  /** fetch data from the table in a streaming manner: "user_consent_type" */
  user_consent_type_stream: Array<User_Consent_Type>;
  /** fetch data from the table: "user_device_push_notification_token" */
  user_device_push_notification_token: Array<User_Device_Push_Notification_Token>;
  /** fetch aggregated fields from the table: "user_device_push_notification_token" */
  user_device_push_notification_token_aggregate: User_Device_Push_Notification_Token_Aggregate;
  /** fetch data from the table: "user_device_push_notification_token" using primary key columns */
  user_device_push_notification_token_by_pk?: Maybe<User_Device_Push_Notification_Token>;
  /** fetch data from the table in a streaming manner: "user_device_push_notification_token" */
  user_device_push_notification_token_stream: Array<User_Device_Push_Notification_Token>;
  /** fetch data from the table: "user_document" */
  user_document: Array<User_Document>;
  /** fetch aggregated fields from the table: "user_document" */
  user_document_aggregate: User_Document_Aggregate;
  /** fetch data from the table: "user_document" using primary key columns */
  user_document_by_pk?: Maybe<User_Document>;
  /** fetch data from the table in a streaming manner: "user_document" */
  user_document_stream: Array<User_Document>;
  /** fetch data from the table: "user_location" */
  user_location: Array<User_Location>;
  /** fetch aggregated fields from the table: "user_location" */
  user_location_aggregate: User_Location_Aggregate;
  /** fetch data from the table: "user_location" using primary key columns */
  user_location_by_pk?: Maybe<User_Location>;
  /** fetch data from the table in a streaming manner: "user_location" */
  user_location_stream: Array<User_Location>;
  /** fetch data from the table: "user_plan" */
  user_plan: Array<User_Plan>;
  /** fetch aggregated fields from the table: "user_plan" */
  user_plan_aggregate: User_Plan_Aggregate;
  /** fetch data from the table: "user_plan" using primary key columns */
  user_plan_by_pk?: Maybe<User_Plan>;
  /** fetch data from the table in a streaming manner: "user_plan" */
  user_plan_stream: Array<User_Plan>;
  /** fetch data from the table in a streaming manner: "user" */
  user_stream: Array<User>;
  /** execute function "users_unfulfilled_product_purchases_count_by_location" which returns "fn_users_unfulfilled_product_purchases_count_by_location" */
  users_unfulfilled_product_purchases_count_by_location: Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location>;
  /** execute function "users_unfulfilled_product_purchases_count_by_location" and query aggregates on result of table type "fn_users_unfulfilled_product_purchases_count_by_location" */
  users_unfulfilled_product_purchases_count_by_location_aggregate: Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Aggregate;
  /** fetch data from the table: "version" */
  version: Array<Version>;
  /** fetch aggregated fields from the table: "version" */
  version_aggregate: Version_Aggregate;
  /** fetch data from the table: "version" using primary key columns */
  version_by_pk?: Maybe<Version>;
  /** fetch data from the table in a streaming manner: "version" */
  version_stream: Array<Version>;
};


export type Subscription_RootAccreditationArgs = {
  distinct_on?: InputMaybe<Array<Accreditation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accreditation_Order_By>>;
  where?: InputMaybe<Accreditation_Bool_Exp>;
};


export type Subscription_RootAccreditation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accreditation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accreditation_Order_By>>;
  where?: InputMaybe<Accreditation_Bool_Exp>;
};


export type Subscription_RootAccreditation_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootAccreditation_Location_PrivilegeArgs = {
  distinct_on?: InputMaybe<Array<Accreditation_Location_Privilege_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accreditation_Location_Privilege_Order_By>>;
  where?: InputMaybe<Accreditation_Location_Privilege_Bool_Exp>;
};


export type Subscription_RootAccreditation_Location_Privilege_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accreditation_Location_Privilege_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accreditation_Location_Privilege_Order_By>>;
  where?: InputMaybe<Accreditation_Location_Privilege_Bool_Exp>;
};


export type Subscription_RootAccreditation_Location_Privilege_By_PkArgs = {
  accreditation: Accreditation_Enum;
  location: Scalars['uuid'];
};


export type Subscription_RootAccreditation_Location_Privilege_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Accreditation_Location_Privilege_Stream_Cursor_Input>>;
  where?: InputMaybe<Accreditation_Location_Privilege_Bool_Exp>;
};


export type Subscription_RootAccreditation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Accreditation_Stream_Cursor_Input>>;
  where?: InputMaybe<Accreditation_Bool_Exp>;
};


export type Subscription_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAddress_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAgreement_TypeArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Type_Order_By>>;
  where?: InputMaybe<Agreement_Type_Bool_Exp>;
};


export type Subscription_RootAgreement_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Type_Order_By>>;
  where?: InputMaybe<Agreement_Type_Bool_Exp>;
};


export type Subscription_RootAgreement_Type_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootAgreement_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Agreement_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Agreement_Type_Bool_Exp>;
};


export type Subscription_RootBookingArgs = {
  distinct_on?: InputMaybe<Array<Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Order_By>>;
  where?: InputMaybe<Booking_Bool_Exp>;
};


export type Subscription_RootBooking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Order_By>>;
  where?: InputMaybe<Booking_Bool_Exp>;
};


export type Subscription_RootBooking_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootBooking_PublicArgs = {
  distinct_on?: InputMaybe<Array<Booking_Public_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Public_Order_By>>;
  where?: InputMaybe<Booking_Public_Bool_Exp>;
};


export type Subscription_RootBooking_Public_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Booking_Public_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Public_Order_By>>;
  where?: InputMaybe<Booking_Public_Bool_Exp>;
};


export type Subscription_RootBooking_Public_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Booking_Public_Stream_Cursor_Input>>;
  where?: InputMaybe<Booking_Public_Bool_Exp>;
};


export type Subscription_RootBooking_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Booking_Stream_Cursor_Input>>;
  where?: InputMaybe<Booking_Bool_Exp>;
};


export type Subscription_RootBooking_TypeArgs = {
  distinct_on?: InputMaybe<Array<Booking_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Type_Order_By>>;
  where?: InputMaybe<Booking_Type_Bool_Exp>;
};


export type Subscription_RootBooking_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Booking_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Type_Order_By>>;
  where?: InputMaybe<Booking_Type_Bool_Exp>;
};


export type Subscription_RootBooking_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootBooking_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Booking_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Booking_Type_Bool_Exp>;
};


export type Subscription_RootCancel_ReasonArgs = {
  distinct_on?: InputMaybe<Array<Cancel_Reason_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cancel_Reason_Order_By>>;
  where?: InputMaybe<Cancel_Reason_Bool_Exp>;
};


export type Subscription_RootCancel_Reason_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cancel_Reason_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cancel_Reason_Order_By>>;
  where?: InputMaybe<Cancel_Reason_Bool_Exp>;
};


export type Subscription_RootCancel_Reason_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootCancel_Reason_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cancel_Reason_Stream_Cursor_Input>>;
  where?: InputMaybe<Cancel_Reason_Bool_Exp>;
};


export type Subscription_RootCheck_Proposed_Patient_Booking_For_StackingArgs = {
  args: Check_Proposed_Patient_Booking_For_Stacking_Args;
  distinct_on?: InputMaybe<Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Order_By>>;
  where?: InputMaybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Bool_Exp>;
};


export type Subscription_RootCheck_Proposed_Patient_Booking_For_Stacking_AggregateArgs = {
  args: Check_Proposed_Patient_Booking_For_Stacking_Args;
  distinct_on?: InputMaybe<Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Order_By>>;
  where?: InputMaybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Bool_Exp>;
};


export type Subscription_RootCreditArgs = {
  distinct_on?: InputMaybe<Array<Credit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Order_By>>;
  where?: InputMaybe<Credit_Bool_Exp>;
};


export type Subscription_RootCredit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Order_By>>;
  where?: InputMaybe<Credit_Bool_Exp>;
};


export type Subscription_RootCredit_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCredit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Credit_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Bool_Exp>;
};


export type Subscription_RootCredit_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Credit_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Transaction_Order_By>>;
  where?: InputMaybe<Credit_Transaction_Bool_Exp>;
};


export type Subscription_RootCredit_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Transaction_Order_By>>;
  where?: InputMaybe<Credit_Transaction_Bool_Exp>;
};


export type Subscription_RootCredit_Transaction_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCredit_Transaction_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Credit_Transaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Transaction_Bool_Exp>;
};


export type Subscription_RootCredit_TypeArgs = {
  distinct_on?: InputMaybe<Array<Credit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Type_Order_By>>;
  where?: InputMaybe<Credit_Type_Bool_Exp>;
};


export type Subscription_RootCredit_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Type_Order_By>>;
  where?: InputMaybe<Credit_Type_Bool_Exp>;
};


export type Subscription_RootCredit_Type_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootCredit_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Credit_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Type_Bool_Exp>;
};


export type Subscription_RootDemo_LocationArgs = {
  distinct_on?: InputMaybe<Array<Demo_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demo_Location_Order_By>>;
  where?: InputMaybe<Demo_Location_Bool_Exp>;
};


export type Subscription_RootDemo_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demo_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demo_Location_Order_By>>;
  where?: InputMaybe<Demo_Location_Bool_Exp>;
};


export type Subscription_RootDemo_Location_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDemo_Location_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Demo_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Demo_Location_Bool_Exp>;
};


export type Subscription_RootDocument_TypeArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_Order_By>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Subscription_RootDocument_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_Order_By>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Subscription_RootDocument_Type_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootDocument_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Subscription_RootEhr_Charge_LedgerArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Charge_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Charge_Ledger_Order_By>>;
  where?: InputMaybe<Ehr_Charge_Ledger_Bool_Exp>;
};


export type Subscription_RootEhr_Charge_Ledger_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Charge_Ledger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Charge_Ledger_Order_By>>;
  where?: InputMaybe<Ehr_Charge_Ledger_Bool_Exp>;
};


export type Subscription_RootEhr_Charge_Ledger_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Charge_Ledger_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Charge_Ledger_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Charge_Ledger_Bool_Exp>;
};


export type Subscription_RootEhr_EncounterArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_AddendumArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Addendum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Addendum_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Addendum_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_Addendum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Addendum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Addendum_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Addendum_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_Addendum_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Encounter_Addendum_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Encounter_Addendum_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Encounter_Addendum_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Encounter_ModalityArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Modality_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Modality_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Modality_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_Modality_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Modality_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Modality_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Modality_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_Modality_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEhr_Encounter_Modality_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Encounter_Modality_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Encounter_Modality_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_PhotoArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Photo_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Photo_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_Photo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Photo_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Photo_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_Photo_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Encounter_Photo_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Encounter_Photo_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Encounter_Photo_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_Scan_3dArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_Scan_3d_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_Scan_3d_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_Scan_3d_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_Scan_3d_Artifact_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Encounter_Scan_3d_Artifact_KindArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Kind_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_Scan_3d_Artifact_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Scan_3d_Artifact_Kind_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_Scan_3d_Artifact_Kind_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEhr_Encounter_Scan_3d_Artifact_Kind_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Kind_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_Scan_3d_Artifact_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Artifact_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_Scan_3d_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Encounter_Scan_3d_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Encounter_Scan_3d_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Encounter_Scan_3d_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Encounter_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Encounter_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Type_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Type_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Encounter_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Encounter_Type_Order_By>>;
  where?: InputMaybe<Ehr_Encounter_Type_Bool_Exp>;
};


export type Subscription_RootEhr_Encounter_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEhr_Encounter_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Encounter_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Encounter_Type_Bool_Exp>;
};


export type Subscription_RootEhr_Fda_ProductArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Fda_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Fda_Product_Order_By>>;
  where?: InputMaybe<Ehr_Fda_Product_Bool_Exp>;
};


export type Subscription_RootEhr_Fda_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Fda_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Fda_Product_Order_By>>;
  where?: InputMaybe<Ehr_Fda_Product_Bool_Exp>;
};


export type Subscription_RootEhr_Fda_Product_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Fda_Product_SourceArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Fda_Product_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Fda_Product_Source_Order_By>>;
  where?: InputMaybe<Ehr_Fda_Product_Source_Bool_Exp>;
};


export type Subscription_RootEhr_Fda_Product_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Fda_Product_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Fda_Product_Source_Order_By>>;
  where?: InputMaybe<Ehr_Fda_Product_Source_Bool_Exp>;
};


export type Subscription_RootEhr_Fda_Product_Source_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEhr_Fda_Product_Source_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Fda_Product_Source_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Fda_Product_Source_Bool_Exp>;
};


export type Subscription_RootEhr_Fda_Product_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Fda_Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Fda_Product_Bool_Exp>;
};


export type Subscription_RootEhr_MessageArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Message_Order_By>>;
  where?: InputMaybe<Ehr_Message_Bool_Exp>;
};


export type Subscription_RootEhr_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Message_Order_By>>;
  where?: InputMaybe<Ehr_Message_Bool_Exp>;
};


export type Subscription_RootEhr_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Message_ReadArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Message_Read_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Message_Read_Order_By>>;
  where?: InputMaybe<Ehr_Message_Read_Bool_Exp>;
};


export type Subscription_RootEhr_Message_Read_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Message_Read_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Message_Read_Order_By>>;
  where?: InputMaybe<Ehr_Message_Read_Bool_Exp>;
};


export type Subscription_RootEhr_Message_Read_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Message_Read_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Message_Read_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Message_Read_Bool_Exp>;
};


export type Subscription_RootEhr_Message_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Message_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Message_Bool_Exp>;
};


export type Subscription_RootEhr_Message_ThreadsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Message_Threads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Message_Threads_Order_By>>;
  where?: InputMaybe<Ehr_Message_Threads_Bool_Exp>;
};


export type Subscription_RootEhr_Message_Threads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Message_Threads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Message_Threads_Order_By>>;
  where?: InputMaybe<Ehr_Message_Threads_Bool_Exp>;
};


export type Subscription_RootEhr_Message_Threads_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Message_Threads_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Message_Threads_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Message_Threads_Bool_Exp>;
};


export type Subscription_RootEhr_Patient_CardArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Card_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Card_Bool_Exp>;
};


export type Subscription_RootEhr_Patient_Card_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Card_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Card_Bool_Exp>;
};


export type Subscription_RootEhr_Patient_Card_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Patient_Card_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Patient_Card_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Patient_Card_Bool_Exp>;
};


export type Subscription_RootEhr_Patient_ConsentArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Consent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Consent_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Consent_Bool_Exp>;
};


export type Subscription_RootEhr_Patient_Consent_ActionArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Consent_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Consent_Action_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Consent_Action_Bool_Exp>;
};


export type Subscription_RootEhr_Patient_Consent_Action_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Consent_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Consent_Action_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Consent_Action_Bool_Exp>;
};


export type Subscription_RootEhr_Patient_Consent_Action_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootEhr_Patient_Consent_Action_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Patient_Consent_Action_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Patient_Consent_Action_Bool_Exp>;
};


export type Subscription_RootEhr_Patient_Consent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Consent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Consent_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Consent_Bool_Exp>;
};


export type Subscription_RootEhr_Patient_Consent_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Patient_Consent_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Patient_Consent_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Patient_Consent_Bool_Exp>;
};


export type Subscription_RootEhr_Patient_Consent_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Consent_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Consent_Type_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Consent_Type_Bool_Exp>;
};


export type Subscription_RootEhr_Patient_Consent_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Patient_Consent_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Patient_Consent_Type_Order_By>>;
  where?: InputMaybe<Ehr_Patient_Consent_Type_Bool_Exp>;
};


export type Subscription_RootEhr_Patient_Consent_Type_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootEhr_Patient_Consent_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Patient_Consent_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Patient_Consent_Type_Bool_Exp>;
};


export type Subscription_RootEhr_ProcedureArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Bool_Exp>;
};


export type Subscription_RootEhr_Procedure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Bool_Exp>;
};


export type Subscription_RootEhr_Procedure_Body_AreaArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Body_Area_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Body_Area_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Body_Area_Bool_Exp>;
};


export type Subscription_RootEhr_Procedure_Body_Area_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Body_Area_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Body_Area_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Body_Area_Bool_Exp>;
};


export type Subscription_RootEhr_Procedure_Body_Area_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Procedure_Body_Area_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Procedure_Body_Area_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Procedure_Body_Area_Bool_Exp>;
};


export type Subscription_RootEhr_Procedure_Body_PartArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Body_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Body_Part_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Body_Part_Bool_Exp>;
};


export type Subscription_RootEhr_Procedure_Body_Part_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Body_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Body_Part_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Body_Part_Bool_Exp>;
};


export type Subscription_RootEhr_Procedure_Body_Part_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Procedure_Body_Part_Provider_Injection_DefaultArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Bool_Exp>;
};


export type Subscription_RootEhr_Procedure_Body_Part_Provider_Injection_Default_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Body_Part_Provider_Injection_Default_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Bool_Exp>;
};


export type Subscription_RootEhr_Procedure_Body_Part_Provider_Injection_Default_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Procedure_Body_Part_Provider_Injection_Default_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Procedure_Body_Part_Provider_Injection_Default_Bool_Exp>;
};


export type Subscription_RootEhr_Procedure_Body_Part_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Procedure_Body_Part_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Procedure_Body_Part_Bool_Exp>;
};


export type Subscription_RootEhr_Procedure_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Procedure_Ehr_ProductArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Ehr_Product_Bool_Exp>;
};


export type Subscription_RootEhr_Procedure_Ehr_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Ehr_Product_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Ehr_Product_Bool_Exp>;
};


export type Subscription_RootEhr_Procedure_Ehr_Product_By_PkArgs = {
  ehrProcedure: Scalars['uuid'];
  ehrProduct: Scalars['uuid'];
};


export type Subscription_RootEhr_Procedure_Ehr_Product_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Procedure_Ehr_Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Procedure_Ehr_Product_Bool_Exp>;
};


export type Subscription_RootEhr_Procedure_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Procedure_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Procedure_Bool_Exp>;
};


export type Subscription_RootEhr_Procedure_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Type_Enum_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Type_Enum_Bool_Exp>;
};


export type Subscription_RootEhr_Procedure_Type_Enum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Procedure_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Procedure_Type_Enum_Order_By>>;
  where?: InputMaybe<Ehr_Procedure_Type_Enum_Bool_Exp>;
};


export type Subscription_RootEhr_Procedure_Type_Enum_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEhr_Procedure_Type_Enum_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Procedure_Type_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Procedure_Type_Enum_Bool_Exp>;
};


export type Subscription_RootEhr_ProductArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Product_Order_By>>;
  where?: InputMaybe<Ehr_Product_Bool_Exp>;
};


export type Subscription_RootEhr_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Product_Order_By>>;
  where?: InputMaybe<Ehr_Product_Bool_Exp>;
};


export type Subscription_RootEhr_Product_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Product_ProcedureArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Product_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Product_Procedure_Order_By>>;
  where?: InputMaybe<Ehr_Product_Procedure_Bool_Exp>;
};


export type Subscription_RootEhr_Product_Procedure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Product_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Product_Procedure_Order_By>>;
  where?: InputMaybe<Ehr_Product_Procedure_Bool_Exp>;
};


export type Subscription_RootEhr_Product_Procedure_By_PkArgs = {
  ehr_product: Scalars['uuid'];
  procedure: Scalars['uuid'];
};


export type Subscription_RootEhr_Product_Procedure_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Product_Procedure_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Product_Procedure_Bool_Exp>;
};


export type Subscription_RootEhr_Product_Provider_Usage_Record_PhotoArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Product_Provider_Usage_Record_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Product_Provider_Usage_Record_Photo_Order_By>>;
  where?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Bool_Exp>;
};


export type Subscription_RootEhr_Product_Provider_Usage_Record_Photo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Product_Provider_Usage_Record_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Product_Provider_Usage_Record_Photo_Order_By>>;
  where?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Bool_Exp>;
};


export type Subscription_RootEhr_Product_Provider_Usage_Record_Photo_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Product_Provider_Usage_Record_Photo_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Product_Provider_Usage_Record_Photo_Bool_Exp>;
};


export type Subscription_RootEhr_Product_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Product_Bool_Exp>;
};


export type Subscription_RootEhr_SubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Bool_Exp>;
};


export type Subscription_RootEhr_Subscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Bool_Exp>;
};


export type Subscription_RootEhr_Subscription_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Subscription_StatusArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Status_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Status_Bool_Exp>;
};


export type Subscription_RootEhr_Subscription_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Status_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Status_Bool_Exp>;
};


export type Subscription_RootEhr_Subscription_Status_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootEhr_Subscription_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Subscription_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Subscription_Status_Bool_Exp>;
};


export type Subscription_RootEhr_Subscription_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Subscription_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Subscription_Bool_Exp>;
};


export type Subscription_RootEhr_Subscription_TierArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Tier_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Tier_Bool_Exp>;
};


export type Subscription_RootEhr_Subscription_Tier_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Tier_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Tier_Bool_Exp>;
};


export type Subscription_RootEhr_Subscription_Tier_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootEhr_Subscription_Tier_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Subscription_Tier_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Subscription_Tier_Bool_Exp>;
};


export type Subscription_RootEhr_Subscription_Tier_TermArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Tier_Term_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Tier_Term_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Tier_Term_Bool_Exp>;
};


export type Subscription_RootEhr_Subscription_Tier_Term_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Tier_Term_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Tier_Term_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Tier_Term_Bool_Exp>;
};


export type Subscription_RootEhr_Subscription_Tier_Term_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEhr_Subscription_Tier_Term_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ehr_Subscription_Tier_Term_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Subscription_Tier_Term_Bool_Exp>;
};


export type Subscription_RootEventArgs = {
  distinct_on?: InputMaybe<Array<Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Order_By>>;
  where?: InputMaybe<Event_Bool_Exp>;
};


export type Subscription_RootEvent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Order_By>>;
  where?: InputMaybe<Event_Bool_Exp>;
};


export type Subscription_RootEvent_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEvent_SourceArgs = {
  distinct_on?: InputMaybe<Array<Event_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Source_Order_By>>;
  where?: InputMaybe<Event_Source_Bool_Exp>;
};


export type Subscription_RootEvent_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Source_Order_By>>;
  where?: InputMaybe<Event_Source_Bool_Exp>;
};


export type Subscription_RootEvent_Source_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootEvent_Source_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Event_Source_Stream_Cursor_Input>>;
  where?: InputMaybe<Event_Source_Bool_Exp>;
};


export type Subscription_RootEvent_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Event_Bool_Exp>;
};


export type Subscription_RootFiller_Procedure_Delivery_ToolArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Delivery_Tool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Delivery_Tool_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Delivery_Tool_Bool_Exp>;
};


export type Subscription_RootFiller_Procedure_Delivery_Tool_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Delivery_Tool_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Delivery_Tool_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Delivery_Tool_Bool_Exp>;
};


export type Subscription_RootFiller_Procedure_Delivery_Tool_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootFiller_Procedure_Delivery_Tool_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Filler_Procedure_Delivery_Tool_Stream_Cursor_Input>>;
  where?: InputMaybe<Filler_Procedure_Delivery_Tool_Bool_Exp>;
};


export type Subscription_RootFiller_Procedure_Face_ViewArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Face_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Face_View_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Face_View_Bool_Exp>;
};


export type Subscription_RootFiller_Procedure_Face_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Face_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Face_View_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Face_View_Bool_Exp>;
};


export type Subscription_RootFiller_Procedure_Face_View_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootFiller_Procedure_Face_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Filler_Procedure_Face_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Filler_Procedure_Face_View_Bool_Exp>;
};


export type Subscription_RootFiller_Procedure_InjectionArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Injection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Injection_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Injection_Bool_Exp>;
};


export type Subscription_RootFiller_Procedure_Injection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Injection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Injection_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Injection_Bool_Exp>;
};


export type Subscription_RootFiller_Procedure_Injection_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFiller_Procedure_Injection_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Filler_Procedure_Injection_Stream_Cursor_Input>>;
  where?: InputMaybe<Filler_Procedure_Injection_Bool_Exp>;
};


export type Subscription_RootFiller_Procedure_Injection_TypeArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Injection_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Injection_Type_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Injection_Type_Bool_Exp>;
};


export type Subscription_RootFiller_Procedure_Injection_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Injection_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Injection_Type_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Injection_Type_Bool_Exp>;
};


export type Subscription_RootFiller_Procedure_Injection_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootFiller_Procedure_Injection_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Filler_Procedure_Injection_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Filler_Procedure_Injection_Type_Bool_Exp>;
};


export type Subscription_RootFiller_Procedure_Product_InstanceArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Product_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Product_Instance_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Product_Instance_Bool_Exp>;
};


export type Subscription_RootFiller_Procedure_Product_Instance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Product_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Product_Instance_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Product_Instance_Bool_Exp>;
};


export type Subscription_RootFiller_Procedure_Product_Instance_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFiller_Procedure_Product_Instance_PhotoArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Product_Instance_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Product_Instance_Photo_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Bool_Exp>;
};


export type Subscription_RootFiller_Procedure_Product_Instance_Photo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Procedure_Product_Instance_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Procedure_Product_Instance_Photo_Order_By>>;
  where?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Bool_Exp>;
};


export type Subscription_RootFiller_Procedure_Product_Instance_Photo_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFiller_Procedure_Product_Instance_Photo_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Filler_Procedure_Product_Instance_Photo_Stream_Cursor_Input>>;
  where?: InputMaybe<Filler_Procedure_Product_Instance_Photo_Bool_Exp>;
};


export type Subscription_RootFiller_Procedure_Product_Instance_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Filler_Procedure_Product_Instance_Stream_Cursor_Input>>;
  where?: InputMaybe<Filler_Procedure_Product_Instance_Bool_Exp>;
};


export type Subscription_RootFiller_SpaceArgs = {
  distinct_on?: InputMaybe<Array<Filler_Space_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Space_Order_By>>;
  where?: InputMaybe<Filler_Space_Bool_Exp>;
};


export type Subscription_RootFiller_Space_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Space_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Space_Order_By>>;
  where?: InputMaybe<Filler_Space_Bool_Exp>;
};


export type Subscription_RootFiller_Space_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootFiller_Space_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Filler_Space_Stream_Cursor_Input>>;
  where?: InputMaybe<Filler_Space_Bool_Exp>;
};


export type Subscription_RootFiller_Zone_ReleaseArgs = {
  distinct_on?: InputMaybe<Array<Filler_Zone_Release_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Zone_Release_Order_By>>;
  where?: InputMaybe<Filler_Zone_Release_Bool_Exp>;
};


export type Subscription_RootFiller_Zone_Release_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Filler_Zone_Release_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Filler_Zone_Release_Order_By>>;
  where?: InputMaybe<Filler_Zone_Release_Bool_Exp>;
};


export type Subscription_RootFiller_Zone_Release_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFiller_Zone_Release_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Filler_Zone_Release_Stream_Cursor_Input>>;
  where?: InputMaybe<Filler_Zone_Release_Bool_Exp>;
};


export type Subscription_RootFn_Check_Proposed_Patient_Booking_For_StackingArgs = {
  distinct_on?: InputMaybe<Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Order_By>>;
  where?: InputMaybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Bool_Exp>;
};


export type Subscription_RootFn_Check_Proposed_Patient_Booking_For_Stacking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Check_Proposed_Patient_Booking_For_Stacking_Order_By>>;
  where?: InputMaybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Bool_Exp>;
};


export type Subscription_RootFn_Check_Proposed_Patient_Booking_For_Stacking_By_PkArgs = {
  provider_booking_id: Scalars['uuid'];
};


export type Subscription_RootFn_Check_Proposed_Patient_Booking_For_Stacking_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Check_Proposed_Patient_Booking_For_Stacking_Bool_Exp>;
};


export type Subscription_RootFn_Get_Active_Notification_Preferences_For_Type_And_LocationArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp>;
};


export type Subscription_RootFn_Get_Active_Notification_Preferences_For_Type_And_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp>;
};


export type Subscription_RootFn_Get_Active_Notification_Preferences_For_Type_And_Location_By_PkArgs = {
  location: Scalars['uuid'];
  type: Scalars['String'];
  user: Scalars['uuid'];
};


export type Subscription_RootFn_Get_Active_Notification_Preferences_For_Type_And_Location_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp>;
};


export type Subscription_RootFn_Get_Active_Subscribers_QueryArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Subscribers_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Subscribers_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Subscribers_Query_Bool_Exp>;
};


export type Subscription_RootFn_Get_Active_Subscribers_Query_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Subscribers_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Subscribers_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Subscribers_Query_Bool_Exp>;
};


export type Subscription_RootFn_Get_Active_Subscribers_Query_By_PkArgs = {
  stripeCustomerId: Scalars['String'];
};


export type Subscription_RootFn_Get_Active_Subscribers_Query_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Get_Active_Subscribers_Query_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Get_Active_Subscribers_Query_Bool_Exp>;
};


export type Subscription_RootFn_Get_Location_Purchases_To_Provider_Purchases_QueryArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Bool_Exp>;
};


export type Subscription_RootFn_Get_Location_Purchases_To_Provider_Purchases_Query_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Bool_Exp>;
};


export type Subscription_RootFn_Get_Location_Purchases_To_Provider_Purchases_Query_By_PkArgs = {
  location: Scalars['uuid'];
};


export type Subscription_RootFn_Get_Location_Purchases_To_Provider_Purchases_Query_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Bool_Exp>;
};


export type Subscription_RootFn_Get_Stackable_Booking_Options_DataArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_Stackable_Booking_Options_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Stackable_Booking_Options_Data_Order_By>>;
  where?: InputMaybe<Fn_Get_Stackable_Booking_Options_Data_Bool_Exp>;
};


export type Subscription_RootFn_Get_Stackable_Booking_Options_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_Stackable_Booking_Options_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Stackable_Booking_Options_Data_Order_By>>;
  where?: InputMaybe<Fn_Get_Stackable_Booking_Options_Data_Bool_Exp>;
};


export type Subscription_RootFn_Get_Stackable_Booking_Options_Data_By_PkArgs = {
  providerBookingId: Scalars['uuid'];
};


export type Subscription_RootFn_Get_Stackable_Booking_Options_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Get_Stackable_Booking_Options_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Get_Stackable_Booking_Options_Data_Bool_Exp>;
};


export type Subscription_RootFn_Get_User_Booking_Options_BlockersArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_User_Booking_Options_Blockers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Booking_Options_Blockers_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Booking_Options_Blockers_Bool_Exp>;
};


export type Subscription_RootFn_Get_User_Booking_Options_Blockers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_User_Booking_Options_Blockers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Booking_Options_Blockers_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Booking_Options_Blockers_Bool_Exp>;
};


export type Subscription_RootFn_Get_User_Booking_Options_Blockers_By_PkArgs = {
  bound: Scalars['String'];
  timestamp: Scalars['timestamptz'];
  type: Scalars['String'];
};


export type Subscription_RootFn_Get_User_Booking_Options_Blockers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Get_User_Booking_Options_Blockers_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Get_User_Booking_Options_Blockers_Bool_Exp>;
};


export type Subscription_RootFn_Get_User_Location_Procedure_Unavailable_RoomsArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Bool_Exp>;
};


export type Subscription_RootFn_Get_User_Location_Procedure_Unavailable_Rooms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Bool_Exp>;
};


export type Subscription_RootFn_Get_User_Location_Procedure_Unavailable_Rooms_By_PkArgs = {
  room: Scalars['uuid'];
  timespanBlockingBooking: Scalars['tstzrange'];
};


export type Subscription_RootFn_Get_User_Location_Procedure_Unavailable_Rooms_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Get_User_Location_Procedure_Unavailable_Rooms_Bool_Exp>;
};


export type Subscription_RootFn_Get_User_Products_To_Rentals_QueryArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_User_Products_To_Rentals_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Products_To_Rentals_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Products_To_Rentals_Query_Bool_Exp>;
};


export type Subscription_RootFn_Get_User_Products_To_Rentals_Query_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Get_User_Products_To_Rentals_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Products_To_Rentals_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Products_To_Rentals_Query_Bool_Exp>;
};


export type Subscription_RootFn_Get_User_Products_To_Rentals_Query_By_PkArgs = {
  user: Scalars['uuid'];
};


export type Subscription_RootFn_Get_User_Products_To_Rentals_Query_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Get_User_Products_To_Rentals_Query_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Get_User_Products_To_Rentals_Query_Bool_Exp>;
};


export type Subscription_RootFn_Users_Unfulfilled_Product_Purchases_Count_By_LocationArgs = {
  distinct_on?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Order_By>>;
  where?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp>;
};


export type Subscription_RootFn_Users_Unfulfilled_Product_Purchases_Count_By_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Order_By>>;
  where?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp>;
};


export type Subscription_RootFn_Users_Unfulfilled_Product_Purchases_Count_By_Location_By_PkArgs = {
  location: Scalars['uuid'];
  user: Scalars['uuid'];
};


export type Subscription_RootFn_Users_Unfulfilled_Product_Purchases_Count_By_Location_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp>;
};


export type Subscription_RootGenderArgs = {
  distinct_on?: InputMaybe<Array<Gender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gender_Order_By>>;
  where?: InputMaybe<Gender_Bool_Exp>;
};


export type Subscription_RootGender_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gender_Order_By>>;
  where?: InputMaybe<Gender_Bool_Exp>;
};


export type Subscription_RootGender_By_PkArgs = {
  gender: Scalars['String'];
};


export type Subscription_RootGender_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Gender_Stream_Cursor_Input>>;
  where?: InputMaybe<Gender_Bool_Exp>;
};


export type Subscription_RootGet_Active_Notification_Preferences_For_Type_And_LocationArgs = {
  args: Get_Active_Notification_Preferences_For_Type_And_Location_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp>;
};


export type Subscription_RootGet_Active_Notification_Preferences_For_Type_And_Location_AggregateArgs = {
  args: Get_Active_Notification_Preferences_For_Type_And_Location_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp>;
};


export type Subscription_RootGet_Active_Notification_Preferences_For_Type_Any_LocationArgs = {
  args: Get_Active_Notification_Preferences_For_Type_Any_Location_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp>;
};


export type Subscription_RootGet_Active_Notification_Preferences_For_Type_Any_Location_AggregateArgs = {
  args: Get_Active_Notification_Preferences_For_Type_Any_Location_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Notification_Preferences_For_Type_And_Location_Bool_Exp>;
};


export type Subscription_RootGet_Active_Subscribers_QueryArgs = {
  args: Get_Active_Subscribers_Query_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Subscribers_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Subscribers_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Subscribers_Query_Bool_Exp>;
};


export type Subscription_RootGet_Active_Subscribers_Query_AggregateArgs = {
  args: Get_Active_Subscribers_Query_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Active_Subscribers_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Active_Subscribers_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_Active_Subscribers_Query_Bool_Exp>;
};


export type Subscription_RootGet_Cumulative_Location_PlansArgs = {
  args: Get_Cumulative_Location_Plans_Args;
  distinct_on?: InputMaybe<Array<Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Subscription_RootGet_Cumulative_Location_Plans_AggregateArgs = {
  args: Get_Cumulative_Location_Plans_Args;
  distinct_on?: InputMaybe<Array<Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Subscription_RootGet_Location_Purchases_To_Provider_Purchases_QueryArgs = {
  args: Get_Location_Purchases_To_Provider_Purchases_Query_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Bool_Exp>;
};


export type Subscription_RootGet_Location_Purchases_To_Provider_Purchases_Query_AggregateArgs = {
  args: Get_Location_Purchases_To_Provider_Purchases_Query_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_Location_Purchases_To_Provider_Purchases_Query_Bool_Exp>;
};


export type Subscription_RootGet_Stackable_Booking_Options_DataArgs = {
  args: Get_Stackable_Booking_Options_Data_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Stackable_Booking_Options_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Stackable_Booking_Options_Data_Order_By>>;
  where?: InputMaybe<Fn_Get_Stackable_Booking_Options_Data_Bool_Exp>;
};


export type Subscription_RootGet_Stackable_Booking_Options_Data_AggregateArgs = {
  args: Get_Stackable_Booking_Options_Data_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_Stackable_Booking_Options_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_Stackable_Booking_Options_Data_Order_By>>;
  where?: InputMaybe<Fn_Get_Stackable_Booking_Options_Data_Bool_Exp>;
};


export type Subscription_RootGet_User_Booking_Options_BlockersArgs = {
  args: Get_User_Booking_Options_Blockers_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_User_Booking_Options_Blockers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Booking_Options_Blockers_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Booking_Options_Blockers_Bool_Exp>;
};


export type Subscription_RootGet_User_Booking_Options_Blockers_AggregateArgs = {
  args: Get_User_Booking_Options_Blockers_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_User_Booking_Options_Blockers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Booking_Options_Blockers_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Booking_Options_Blockers_Bool_Exp>;
};


export type Subscription_RootGet_User_Products_To_Rentals_QueryArgs = {
  args: Get_User_Products_To_Rentals_Query_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_User_Products_To_Rentals_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Products_To_Rentals_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Products_To_Rentals_Query_Bool_Exp>;
};


export type Subscription_RootGet_User_Products_To_Rentals_Query_AggregateArgs = {
  args: Get_User_Products_To_Rentals_Query_Args;
  distinct_on?: InputMaybe<Array<Fn_Get_User_Products_To_Rentals_Query_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Get_User_Products_To_Rentals_Query_Order_By>>;
  where?: InputMaybe<Fn_Get_User_Products_To_Rentals_Query_Bool_Exp>;
};


export type Subscription_RootInvoiceArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootInvoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootInvoice_Billing_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Billing_Summary_Order_By>>;
  where?: InputMaybe<Invoice_Billing_Summary_Bool_Exp>;
};


export type Subscription_RootInvoice_Billing_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Billing_Summary_Order_By>>;
  where?: InputMaybe<Invoice_Billing_Summary_Bool_Exp>;
};


export type Subscription_RootInvoice_Billing_Summary_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Invoice_Billing_Summary_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoice_Billing_Summary_Bool_Exp>;
};


export type Subscription_RootInvoice_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootInvoice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Invoice_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootLocationArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Subscription_RootLocation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Order_By>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Subscription_RootLocation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLocation_ProcedureArgs = {
  distinct_on?: InputMaybe<Array<Location_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Procedure_Order_By>>;
  where?: InputMaybe<Location_Procedure_Bool_Exp>;
};


export type Subscription_RootLocation_Procedure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Procedure_Order_By>>;
  where?: InputMaybe<Location_Procedure_Bool_Exp>;
};


export type Subscription_RootLocation_Procedure_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLocation_Procedure_RoomArgs = {
  distinct_on?: InputMaybe<Array<Location_Procedure_Room_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Procedure_Room_Order_By>>;
  where?: InputMaybe<Location_Procedure_Room_Bool_Exp>;
};


export type Subscription_RootLocation_Procedure_Room_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Procedure_Room_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Procedure_Room_Order_By>>;
  where?: InputMaybe<Location_Procedure_Room_Bool_Exp>;
};


export type Subscription_RootLocation_Procedure_Room_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLocation_Procedure_Room_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Location_Procedure_Room_Stream_Cursor_Input>>;
  where?: InputMaybe<Location_Procedure_Room_Bool_Exp>;
};


export type Subscription_RootLocation_Procedure_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Location_Procedure_Stream_Cursor_Input>>;
  where?: InputMaybe<Location_Procedure_Bool_Exp>;
};


export type Subscription_RootLocation_ProductArgs = {
  distinct_on?: InputMaybe<Array<Location_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Product_Order_By>>;
  where?: InputMaybe<Location_Product_Bool_Exp>;
};


export type Subscription_RootLocation_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Product_Order_By>>;
  where?: InputMaybe<Location_Product_Bool_Exp>;
};


export type Subscription_RootLocation_Product_By_PkArgs = {
  location: Scalars['uuid'];
  product: Scalars['uuid'];
};


export type Subscription_RootLocation_Product_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Location_Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Location_Product_Bool_Exp>;
};


export type Subscription_RootLocation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Location_Bool_Exp>;
};


export type Subscription_RootModelArgs = {
  distinct_on?: InputMaybe<Array<Model_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Order_By>>;
  where?: InputMaybe<Model_Bool_Exp>;
};


export type Subscription_RootModel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Order_By>>;
  where?: InputMaybe<Model_Bool_Exp>;
};


export type Subscription_RootModel_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootModel_CountArgs = {
  distinct_on?: InputMaybe<Array<Model_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Count_Order_By>>;
  where?: InputMaybe<Model_Count_Bool_Exp>;
};


export type Subscription_RootModel_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Count_Order_By>>;
  where?: InputMaybe<Model_Count_Bool_Exp>;
};


export type Subscription_RootModel_Count_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootModel_Count_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Model_Count_Stream_Cursor_Input>>;
  where?: InputMaybe<Model_Count_Bool_Exp>;
};


export type Subscription_RootModel_ProductArgs = {
  distinct_on?: InputMaybe<Array<Model_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Product_Order_By>>;
  where?: InputMaybe<Model_Product_Bool_Exp>;
};


export type Subscription_RootModel_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Product_Order_By>>;
  where?: InputMaybe<Model_Product_Bool_Exp>;
};


export type Subscription_RootModel_Product_By_PkArgs = {
  model: Scalars['uuid'];
  product: Scalars['uuid'];
};


export type Subscription_RootModel_Product_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Model_Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Model_Product_Bool_Exp>;
};


export type Subscription_RootModel_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Model_Stream_Cursor_Input>>;
  where?: InputMaybe<Model_Bool_Exp>;
};


export type Subscription_RootMso_ModeArgs = {
  distinct_on?: InputMaybe<Array<Mso_Mode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mso_Mode_Order_By>>;
  where?: InputMaybe<Mso_Mode_Bool_Exp>;
};


export type Subscription_RootMso_Mode_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mso_Mode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mso_Mode_Order_By>>;
  where?: InputMaybe<Mso_Mode_Bool_Exp>;
};


export type Subscription_RootMso_Mode_By_PkArgs = {
  mode: Scalars['String'];
};


export type Subscription_RootMso_Mode_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mso_Mode_Stream_Cursor_Input>>;
  where?: InputMaybe<Mso_Mode_Bool_Exp>;
};


export type Subscription_RootMso_TierArgs = {
  distinct_on?: InputMaybe<Array<Mso_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mso_Tier_Order_By>>;
  where?: InputMaybe<Mso_Tier_Bool_Exp>;
};


export type Subscription_RootMso_Tier_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mso_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mso_Tier_Order_By>>;
  where?: InputMaybe<Mso_Tier_Bool_Exp>;
};


export type Subscription_RootMso_Tier_By_PkArgs = {
  tier: Scalars['String'];
};


export type Subscription_RootMso_Tier_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mso_Tier_Stream_Cursor_Input>>;
  where?: InputMaybe<Mso_Tier_Bool_Exp>;
};


export type Subscription_RootNotification_Audit_LogArgs = {
  distinct_on?: InputMaybe<Array<Notification_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Audit_Log_Order_By>>;
  where?: InputMaybe<Notification_Audit_Log_Bool_Exp>;
};


export type Subscription_RootNotification_Audit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Audit_Log_Order_By>>;
  where?: InputMaybe<Notification_Audit_Log_Bool_Exp>;
};


export type Subscription_RootNotification_Audit_Log_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootNotification_Audit_Log_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notification_Audit_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Audit_Log_Bool_Exp>;
};


export type Subscription_RootNotification_Broadcast_TypeArgs = {
  distinct_on?: InputMaybe<Array<Notification_Broadcast_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Broadcast_Type_Order_By>>;
  where?: InputMaybe<Notification_Broadcast_Type_Bool_Exp>;
};


export type Subscription_RootNotification_Broadcast_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Broadcast_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Broadcast_Type_Order_By>>;
  where?: InputMaybe<Notification_Broadcast_Type_Bool_Exp>;
};


export type Subscription_RootNotification_Broadcast_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Subscription_RootNotification_Broadcast_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notification_Broadcast_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Broadcast_Type_Bool_Exp>;
};


export type Subscription_RootNotification_ChannelArgs = {
  distinct_on?: InputMaybe<Array<Notification_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Channel_Order_By>>;
  where?: InputMaybe<Notification_Channel_Bool_Exp>;
};


export type Subscription_RootNotification_Channel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Channel_Order_By>>;
  where?: InputMaybe<Notification_Channel_Bool_Exp>;
};


export type Subscription_RootNotification_Channel_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootNotification_Channel_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notification_Channel_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Channel_Bool_Exp>;
};


export type Subscription_RootNotification_PreferenceArgs = {
  distinct_on?: InputMaybe<Array<Notification_Preference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Preference_Order_By>>;
  where?: InputMaybe<Notification_Preference_Bool_Exp>;
};


export type Subscription_RootNotification_Preference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Preference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Preference_Order_By>>;
  where?: InputMaybe<Notification_Preference_Bool_Exp>;
};


export type Subscription_RootNotification_Preference_By_PkArgs = {
  channel: Notification_Channel_Enum;
  location: Scalars['uuid'];
  type: Scalars['String'];
  user: Scalars['uuid'];
};


export type Subscription_RootNotification_Preference_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notification_Preference_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Preference_Bool_Exp>;
};


export type Subscription_RootNotification_TypeArgs = {
  distinct_on?: InputMaybe<Array<Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Type_Order_By>>;
  where?: InputMaybe<Notification_Type_Bool_Exp>;
};


export type Subscription_RootNotification_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Type_Order_By>>;
  where?: InputMaybe<Notification_Type_Bool_Exp>;
};


export type Subscription_RootNotification_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootNotification_Type_Default_ChannelArgs = {
  distinct_on?: InputMaybe<Array<Notification_Type_Default_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Type_Default_Channel_Order_By>>;
  where?: InputMaybe<Notification_Type_Default_Channel_Bool_Exp>;
};


export type Subscription_RootNotification_Type_Default_Channel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Type_Default_Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Type_Default_Channel_Order_By>>;
  where?: InputMaybe<Notification_Type_Default_Channel_Bool_Exp>;
};


export type Subscription_RootNotification_Type_Default_Channel_By_PkArgs = {
  channel: Notification_Channel_Enum;
  type: Scalars['String'];
};


export type Subscription_RootNotification_Type_Default_Channel_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notification_Type_Default_Channel_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Type_Default_Channel_Bool_Exp>;
};


export type Subscription_RootNotification_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notification_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Type_Bool_Exp>;
};


export type Subscription_RootOpenArgs = {
  distinct_on?: InputMaybe<Array<Open_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Open_Order_By>>;
  where?: InputMaybe<Open_Bool_Exp>;
};


export type Subscription_RootOpen_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Open_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Open_Order_By>>;
  where?: InputMaybe<Open_Bool_Exp>;
};


export type Subscription_RootOpen_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOpen_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Open_Stream_Cursor_Input>>;
  where?: InputMaybe<Open_Bool_Exp>;
};


export type Subscription_RootPartnerArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


export type Subscription_RootPartner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


export type Subscription_RootPartner_BasicArgs = {
  distinct_on?: InputMaybe<Array<Partner_Basic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Partner_Basic_Order_By>>;
  where?: InputMaybe<Partner_Basic_Bool_Exp>;
};


export type Subscription_RootPartner_Basic_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Basic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Partner_Basic_Order_By>>;
  where?: InputMaybe<Partner_Basic_Bool_Exp>;
};


export type Subscription_RootPartner_Basic_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Partner_Basic_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Basic_Bool_Exp>;
};


export type Subscription_RootPartner_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPartner_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Partner_Stream_Cursor_Input>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


export type Subscription_RootPatientArgs = {
  distinct_on?: InputMaybe<Array<Patient_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Order_By>>;
  where?: InputMaybe<Patient_Bool_Exp>;
};


export type Subscription_RootPatient_Account_EventArgs = {
  distinct_on?: InputMaybe<Array<Patient_Account_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Account_Event_Order_By>>;
  where?: InputMaybe<Patient_Account_Event_Bool_Exp>;
};


export type Subscription_RootPatient_Account_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Account_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Account_Event_Order_By>>;
  where?: InputMaybe<Patient_Account_Event_Bool_Exp>;
};


export type Subscription_RootPatient_Account_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPatient_Account_Event_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Patient_Account_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Patient_Account_Event_Bool_Exp>;
};


export type Subscription_RootPatient_Account_Event_TypeArgs = {
  distinct_on?: InputMaybe<Array<Patient_Account_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Account_Event_Type_Order_By>>;
  where?: InputMaybe<Patient_Account_Event_Type_Bool_Exp>;
};


export type Subscription_RootPatient_Account_Event_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Account_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Account_Event_Type_Order_By>>;
  where?: InputMaybe<Patient_Account_Event_Type_Bool_Exp>;
};


export type Subscription_RootPatient_Account_Event_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootPatient_Account_Event_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Patient_Account_Event_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Patient_Account_Event_Type_Bool_Exp>;
};


export type Subscription_RootPatient_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Order_By>>;
  where?: InputMaybe<Patient_Bool_Exp>;
};


export type Subscription_RootPatient_Auth_ChallengeArgs = {
  distinct_on?: InputMaybe<Array<Patient_Auth_Challenge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Auth_Challenge_Order_By>>;
  where?: InputMaybe<Patient_Auth_Challenge_Bool_Exp>;
};


export type Subscription_RootPatient_Auth_Challenge_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Auth_Challenge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Auth_Challenge_Order_By>>;
  where?: InputMaybe<Patient_Auth_Challenge_Bool_Exp>;
};


export type Subscription_RootPatient_Auth_Challenge_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPatient_Auth_Challenge_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Patient_Auth_Challenge_Stream_Cursor_Input>>;
  where?: InputMaybe<Patient_Auth_Challenge_Bool_Exp>;
};


export type Subscription_RootPatient_Bookable_Ehr_ProcedureArgs = {
  distinct_on?: InputMaybe<Array<Patient_Bookable_Ehr_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Bookable_Ehr_Procedure_Order_By>>;
  where?: InputMaybe<Patient_Bookable_Ehr_Procedure_Bool_Exp>;
};


export type Subscription_RootPatient_Bookable_Ehr_Procedure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Bookable_Ehr_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Bookable_Ehr_Procedure_Order_By>>;
  where?: InputMaybe<Patient_Bookable_Ehr_Procedure_Bool_Exp>;
};


export type Subscription_RootPatient_Bookable_Ehr_Procedure_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPatient_Bookable_Ehr_Procedure_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Patient_Bookable_Ehr_Procedure_Stream_Cursor_Input>>;
  where?: InputMaybe<Patient_Bookable_Ehr_Procedure_Bool_Exp>;
};


export type Subscription_RootPatient_BookingArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Order_By>>;
  where?: InputMaybe<Patient_Booking_Bool_Exp>;
};


export type Subscription_RootPatient_Booking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Order_By>>;
  where?: InputMaybe<Patient_Booking_Bool_Exp>;
};


export type Subscription_RootPatient_Booking_BookingArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Booking_Order_By>>;
  where?: InputMaybe<Patient_Booking_Booking_Bool_Exp>;
};


export type Subscription_RootPatient_Booking_Booking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Booking_Order_By>>;
  where?: InputMaybe<Patient_Booking_Booking_Bool_Exp>;
};


export type Subscription_RootPatient_Booking_Booking_By_PkArgs = {
  booking: Scalars['uuid'];
  patient_booking: Scalars['uuid'];
};


export type Subscription_RootPatient_Booking_Booking_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Patient_Booking_Booking_Stream_Cursor_Input>>;
  where?: InputMaybe<Patient_Booking_Booking_Bool_Exp>;
};


export type Subscription_RootPatient_Booking_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPatient_Booking_Cancel_ReasonArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Cancel_Reason_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Cancel_Reason_Order_By>>;
  where?: InputMaybe<Patient_Booking_Cancel_Reason_Bool_Exp>;
};


export type Subscription_RootPatient_Booking_Cancel_Reason_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Cancel_Reason_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Cancel_Reason_Order_By>>;
  where?: InputMaybe<Patient_Booking_Cancel_Reason_Bool_Exp>;
};


export type Subscription_RootPatient_Booking_Cancel_Reason_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootPatient_Booking_Cancel_Reason_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Patient_Booking_Cancel_Reason_Stream_Cursor_Input>>;
  where?: InputMaybe<Patient_Booking_Cancel_Reason_Bool_Exp>;
};


export type Subscription_RootPatient_Booking_InitiatorArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Initiator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Initiator_Order_By>>;
  where?: InputMaybe<Patient_Booking_Initiator_Bool_Exp>;
};


export type Subscription_RootPatient_Booking_Initiator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Initiator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Initiator_Order_By>>;
  where?: InputMaybe<Patient_Booking_Initiator_Bool_Exp>;
};


export type Subscription_RootPatient_Booking_Initiator_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootPatient_Booking_Initiator_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Patient_Booking_Initiator_Stream_Cursor_Input>>;
  where?: InputMaybe<Patient_Booking_Initiator_Bool_Exp>;
};


export type Subscription_RootPatient_Booking_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Metadata_Order_By>>;
  where?: InputMaybe<Patient_Booking_Metadata_Bool_Exp>;
};


export type Subscription_RootPatient_Booking_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Booking_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Booking_Metadata_Order_By>>;
  where?: InputMaybe<Patient_Booking_Metadata_Bool_Exp>;
};


export type Subscription_RootPatient_Booking_Metadata_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPatient_Booking_Metadata_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Patient_Booking_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Patient_Booking_Metadata_Bool_Exp>;
};


export type Subscription_RootPatient_Booking_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Patient_Booking_Stream_Cursor_Input>>;
  where?: InputMaybe<Patient_Booking_Bool_Exp>;
};


export type Subscription_RootPatient_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPatient_Last_ViewArgs = {
  distinct_on?: InputMaybe<Array<Patient_Last_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Last_View_Order_By>>;
  where?: InputMaybe<Patient_Last_View_Bool_Exp>;
};


export type Subscription_RootPatient_Last_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Last_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Last_View_Order_By>>;
  where?: InputMaybe<Patient_Last_View_Bool_Exp>;
};


export type Subscription_RootPatient_Last_View_By_PkArgs = {
  patient: Scalars['uuid'];
  user: Scalars['uuid'];
};


export type Subscription_RootPatient_Last_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Patient_Last_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Patient_Last_View_Bool_Exp>;
};


export type Subscription_RootPatient_Medical_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Patient_Medical_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Medical_Profile_Order_By>>;
  where?: InputMaybe<Patient_Medical_Profile_Bool_Exp>;
};


export type Subscription_RootPatient_Medical_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Medical_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Medical_Profile_Order_By>>;
  where?: InputMaybe<Patient_Medical_Profile_Bool_Exp>;
};


export type Subscription_RootPatient_Medical_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPatient_Medical_Profile_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Patient_Medical_Profile_Stream_Cursor_Input>>;
  where?: InputMaybe<Patient_Medical_Profile_Bool_Exp>;
};


export type Subscription_RootPatient_Registration_InviteArgs = {
  distinct_on?: InputMaybe<Array<Patient_Registration_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Registration_Invite_Order_By>>;
  where?: InputMaybe<Patient_Registration_Invite_Bool_Exp>;
};


export type Subscription_RootPatient_Registration_Invite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Registration_Invite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Registration_Invite_Order_By>>;
  where?: InputMaybe<Patient_Registration_Invite_Bool_Exp>;
};


export type Subscription_RootPatient_Registration_Invite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPatient_Registration_Invite_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Patient_Registration_Invite_Stream_Cursor_Input>>;
  where?: InputMaybe<Patient_Registration_Invite_Bool_Exp>;
};


export type Subscription_RootPatient_SessionArgs = {
  distinct_on?: InputMaybe<Array<Patient_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Session_Order_By>>;
  where?: InputMaybe<Patient_Session_Bool_Exp>;
};


export type Subscription_RootPatient_Session_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Session_Order_By>>;
  where?: InputMaybe<Patient_Session_Bool_Exp>;
};


export type Subscription_RootPatient_Session_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPatient_Session_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Patient_Session_Stream_Cursor_Input>>;
  where?: InputMaybe<Patient_Session_Bool_Exp>;
};


export type Subscription_RootPatient_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Patient_Stream_Cursor_Input>>;
  where?: InputMaybe<Patient_Bool_Exp>;
};


export type Subscription_RootPatient_Webauthn_ChallengeArgs = {
  distinct_on?: InputMaybe<Array<Patient_Webauthn_Challenge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Webauthn_Challenge_Order_By>>;
  where?: InputMaybe<Patient_Webauthn_Challenge_Bool_Exp>;
};


export type Subscription_RootPatient_Webauthn_Challenge_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Webauthn_Challenge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Webauthn_Challenge_Order_By>>;
  where?: InputMaybe<Patient_Webauthn_Challenge_Bool_Exp>;
};


export type Subscription_RootPatient_Webauthn_Challenge_By_PkArgs = {
  patient: Scalars['uuid'];
};


export type Subscription_RootPatient_Webauthn_Challenge_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Patient_Webauthn_Challenge_Stream_Cursor_Input>>;
  where?: InputMaybe<Patient_Webauthn_Challenge_Bool_Exp>;
};


export type Subscription_RootPatient_Webauthn_CredentialArgs = {
  distinct_on?: InputMaybe<Array<Patient_Webauthn_Credential_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Webauthn_Credential_Order_By>>;
  where?: InputMaybe<Patient_Webauthn_Credential_Bool_Exp>;
};


export type Subscription_RootPatient_Webauthn_Credential_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Webauthn_Credential_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Webauthn_Credential_Order_By>>;
  where?: InputMaybe<Patient_Webauthn_Credential_Bool_Exp>;
};


export type Subscription_RootPatient_Webauthn_Credential_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPatient_Webauthn_Credential_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Patient_Webauthn_Credential_Stream_Cursor_Input>>;
  where?: InputMaybe<Patient_Webauthn_Credential_Bool_Exp>;
};


export type Subscription_RootPlanArgs = {
  distinct_on?: InputMaybe<Array<Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Subscription_RootPlan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Order_By>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Subscription_RootPlan_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlan_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plan_Stream_Cursor_Input>>;
  where?: InputMaybe<Plan_Bool_Exp>;
};


export type Subscription_RootPlan_TypeArgs = {
  distinct_on?: InputMaybe<Array<Plan_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Type_Order_By>>;
  where?: InputMaybe<Plan_Type_Bool_Exp>;
};


export type Subscription_RootPlan_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plan_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plan_Type_Order_By>>;
  where?: InputMaybe<Plan_Type_Bool_Exp>;
};


export type Subscription_RootPlan_Type_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootPlan_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plan_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Plan_Type_Bool_Exp>;
};


export type Subscription_RootPre_Procedure_Photo_Injection_MarkingArgs = {
  distinct_on?: InputMaybe<Array<Pre_Procedure_Photo_Injection_Marking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pre_Procedure_Photo_Injection_Marking_Order_By>>;
  where?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Bool_Exp>;
};


export type Subscription_RootPre_Procedure_Photo_Injection_Marking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pre_Procedure_Photo_Injection_Marking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pre_Procedure_Photo_Injection_Marking_Order_By>>;
  where?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Bool_Exp>;
};


export type Subscription_RootPre_Procedure_Photo_Injection_Marking_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPre_Procedure_Photo_Injection_Marking_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pre_Procedure_Photo_Injection_Marking_Stream_Cursor_Input>>;
  where?: InputMaybe<Pre_Procedure_Photo_Injection_Marking_Bool_Exp>;
};


export type Subscription_RootProcedureArgs = {
  distinct_on?: InputMaybe<Array<Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Procedure_Order_By>>;
  where?: InputMaybe<Procedure_Bool_Exp>;
};


export type Subscription_RootProcedure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Procedure_Order_By>>;
  where?: InputMaybe<Procedure_Bool_Exp>;
};


export type Subscription_RootProcedure_Audio_RecordingArgs = {
  distinct_on?: InputMaybe<Array<Procedure_Audio_Recording_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Procedure_Audio_Recording_Order_By>>;
  where?: InputMaybe<Procedure_Audio_Recording_Bool_Exp>;
};


export type Subscription_RootProcedure_Audio_Recording_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Procedure_Audio_Recording_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Procedure_Audio_Recording_Order_By>>;
  where?: InputMaybe<Procedure_Audio_Recording_Bool_Exp>;
};


export type Subscription_RootProcedure_Audio_Recording_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProcedure_Audio_Recording_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Procedure_Audio_Recording_Stream_Cursor_Input>>;
  where?: InputMaybe<Procedure_Audio_Recording_Bool_Exp>;
};


export type Subscription_RootProcedure_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProcedure_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Procedure_Stream_Cursor_Input>>;
  where?: InputMaybe<Procedure_Bool_Exp>;
};


export type Subscription_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_PurchaseArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchase_Order_By>>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};


export type Subscription_RootProduct_Purchase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchase_Order_By>>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};


export type Subscription_RootProduct_Purchase_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Purchase_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Purchase_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};


export type Subscription_RootProduct_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_TypeArgs = {
  distinct_on?: InputMaybe<Array<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Subscription_RootProduct_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Subscription_RootProduct_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProduct_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Subscription_RootProvider_Direct_Product_PurchaseArgs = {
  distinct_on?: InputMaybe<Array<Provider_Direct_Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Direct_Product_Purchase_Order_By>>;
  where?: InputMaybe<Provider_Direct_Product_Purchase_Bool_Exp>;
};


export type Subscription_RootProvider_Direct_Product_Purchase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Direct_Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Direct_Product_Purchase_Order_By>>;
  where?: InputMaybe<Provider_Direct_Product_Purchase_Bool_Exp>;
};


export type Subscription_RootProvider_Direct_Product_Purchase_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProvider_Direct_Product_Purchase_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Provider_Direct_Product_Purchase_Stream_Cursor_Input>>;
  where?: InputMaybe<Provider_Direct_Product_Purchase_Bool_Exp>;
};


export type Subscription_RootProvider_Direct_Purchase_Web_Admin_ViewArgs = {
  distinct_on?: InputMaybe<Array<Provider_Direct_Purchase_Web_Admin_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Direct_Purchase_Web_Admin_View_Order_By>>;
  where?: InputMaybe<Provider_Direct_Purchase_Web_Admin_View_Bool_Exp>;
};


export type Subscription_RootProvider_Direct_Purchase_Web_Admin_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Direct_Purchase_Web_Admin_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Direct_Purchase_Web_Admin_View_Order_By>>;
  where?: InputMaybe<Provider_Direct_Purchase_Web_Admin_View_Bool_Exp>;
};


export type Subscription_RootProvider_Direct_Purchase_Web_Admin_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Provider_Direct_Purchase_Web_Admin_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Provider_Direct_Purchase_Web_Admin_View_Bool_Exp>;
};


export type Subscription_RootProvider_HoursArgs = {
  distinct_on?: InputMaybe<Array<Provider_Hours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Hours_Order_By>>;
  where?: InputMaybe<Provider_Hours_Bool_Exp>;
};


export type Subscription_RootProvider_Hours_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Hours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Hours_Order_By>>;
  where?: InputMaybe<Provider_Hours_Bool_Exp>;
};


export type Subscription_RootProvider_Hours_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProvider_Hours_Repeat_IntervalArgs = {
  distinct_on?: InputMaybe<Array<Provider_Hours_Repeat_Interval_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Hours_Repeat_Interval_Order_By>>;
  where?: InputMaybe<Provider_Hours_Repeat_Interval_Bool_Exp>;
};


export type Subscription_RootProvider_Hours_Repeat_Interval_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Hours_Repeat_Interval_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Hours_Repeat_Interval_Order_By>>;
  where?: InputMaybe<Provider_Hours_Repeat_Interval_Bool_Exp>;
};


export type Subscription_RootProvider_Hours_Repeat_Interval_By_PkArgs = {
  interval: Scalars['String'];
};


export type Subscription_RootProvider_Hours_Repeat_Interval_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Provider_Hours_Repeat_Interval_Stream_Cursor_Input>>;
  where?: InputMaybe<Provider_Hours_Repeat_Interval_Bool_Exp>;
};


export type Subscription_RootProvider_Hours_RepeaterArgs = {
  distinct_on?: InputMaybe<Array<Provider_Hours_Repeater_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Hours_Repeater_Order_By>>;
  where?: InputMaybe<Provider_Hours_Repeater_Bool_Exp>;
};


export type Subscription_RootProvider_Hours_Repeater_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Hours_Repeater_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Hours_Repeater_Order_By>>;
  where?: InputMaybe<Provider_Hours_Repeater_Bool_Exp>;
};


export type Subscription_RootProvider_Hours_Repeater_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProvider_Hours_Repeater_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Provider_Hours_Repeater_Stream_Cursor_Input>>;
  where?: InputMaybe<Provider_Hours_Repeater_Bool_Exp>;
};


export type Subscription_RootProvider_Hours_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Provider_Hours_Stream_Cursor_Input>>;
  where?: InputMaybe<Provider_Hours_Bool_Exp>;
};


export type Subscription_RootProvider_Patient_Booking_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Provider_Patient_Booking_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Patient_Booking_Settings_Order_By>>;
  where?: InputMaybe<Provider_Patient_Booking_Settings_Bool_Exp>;
};


export type Subscription_RootProvider_Patient_Booking_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Patient_Booking_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Patient_Booking_Settings_Order_By>>;
  where?: InputMaybe<Provider_Patient_Booking_Settings_Bool_Exp>;
};


export type Subscription_RootProvider_Patient_Booking_Settings_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProvider_Patient_Booking_Settings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Provider_Patient_Booking_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Provider_Patient_Booking_Settings_Bool_Exp>;
};


export type Subscription_RootProvider_ProcedureArgs = {
  distinct_on?: InputMaybe<Array<Provider_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Procedure_Order_By>>;
  where?: InputMaybe<Provider_Procedure_Bool_Exp>;
};


export type Subscription_RootProvider_Procedure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Procedure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Procedure_Order_By>>;
  where?: InputMaybe<Provider_Procedure_Bool_Exp>;
};


export type Subscription_RootProvider_Procedure_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProvider_Procedure_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Provider_Procedure_Stream_Cursor_Input>>;
  where?: InputMaybe<Provider_Procedure_Bool_Exp>;
};


export type Subscription_RootPurchase_For_LocationArgs = {
  distinct_on?: InputMaybe<Array<Purchase_For_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_For_Location_Order_By>>;
  where?: InputMaybe<Purchase_For_Location_Bool_Exp>;
};


export type Subscription_RootPurchase_For_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_For_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_For_Location_Order_By>>;
  where?: InputMaybe<Purchase_For_Location_Bool_Exp>;
};


export type Subscription_RootPurchase_For_Location_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPurchase_For_Location_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Purchase_For_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Purchase_For_Location_Bool_Exp>;
};


export type Subscription_RootPurchase_Requests_ListArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Requests_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Requests_List_Order_By>>;
  where?: InputMaybe<Purchase_Requests_List_Bool_Exp>;
};


export type Subscription_RootPurchase_Requests_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Requests_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Requests_List_Order_By>>;
  where?: InputMaybe<Purchase_Requests_List_Bool_Exp>;
};


export type Subscription_RootPurchase_Requests_List_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Purchase_Requests_List_Stream_Cursor_Input>>;
  where?: InputMaybe<Purchase_Requests_List_Bool_Exp>;
};


export type Subscription_RootRental_Volume_DiscountArgs = {
  distinct_on?: InputMaybe<Array<Rental_Volume_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rental_Volume_Discount_Order_By>>;
  where?: InputMaybe<Rental_Volume_Discount_Bool_Exp>;
};


export type Subscription_RootRental_Volume_Discount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rental_Volume_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rental_Volume_Discount_Order_By>>;
  where?: InputMaybe<Rental_Volume_Discount_Bool_Exp>;
};


export type Subscription_RootRental_Volume_Discount_By_PkArgs = {
  hours: Scalars['Int'];
  location: Scalars['uuid'];
};


export type Subscription_RootRental_Volume_Discount_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Rental_Volume_Discount_Stream_Cursor_Input>>;
  where?: InputMaybe<Rental_Volume_Discount_Bool_Exp>;
};


export type Subscription_RootRepeatingArgs = {
  distinct_on?: InputMaybe<Array<Repeating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Repeating_Order_By>>;
  where?: InputMaybe<Repeating_Bool_Exp>;
};


export type Subscription_RootRepeating_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Repeating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Repeating_Order_By>>;
  where?: InputMaybe<Repeating_Bool_Exp>;
};


export type Subscription_RootRepeating_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRepeating_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Repeating_Stream_Cursor_Input>>;
  where?: InputMaybe<Repeating_Bool_Exp>;
};


export type Subscription_RootReport_PreferenceArgs = {
  distinct_on?: InputMaybe<Array<Report_Preference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Preference_Order_By>>;
  where?: InputMaybe<Report_Preference_Bool_Exp>;
};


export type Subscription_RootReport_Preference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Preference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Preference_Order_By>>;
  where?: InputMaybe<Report_Preference_Bool_Exp>;
};


export type Subscription_RootReport_Preference_By_PkArgs = {
  location: Scalars['uuid'];
  owningUser: Scalars['uuid'];
  type: Report_Type_Enum;
};


export type Subscription_RootReport_Preference_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Report_Preference_Stream_Cursor_Input>>;
  where?: InputMaybe<Report_Preference_Bool_Exp>;
};


export type Subscription_RootReport_TypeArgs = {
  distinct_on?: InputMaybe<Array<Report_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Type_Order_By>>;
  where?: InputMaybe<Report_Type_Bool_Exp>;
};


export type Subscription_RootReport_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Type_Order_By>>;
  where?: InputMaybe<Report_Type_Bool_Exp>;
};


export type Subscription_RootReport_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Subscription_RootReport_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Report_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Report_Type_Bool_Exp>;
};


export type Subscription_RootRoleArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootRole_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootRole_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Role_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Notification_Order_By>>;
  where?: InputMaybe<Role_Notification_Bool_Exp>;
};


export type Subscription_RootRole_Notification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Notification_Order_By>>;
  where?: InputMaybe<Role_Notification_Bool_Exp>;
};


export type Subscription_RootRole_Notification_By_PkArgs = {
  broadcastType: Notification_Broadcast_Type_Enum;
  notification_type: Scalars['String'];
  role: Scalars['String'];
};


export type Subscription_RootRole_Notification_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Role_Notification_Stream_Cursor_Input>>;
  where?: InputMaybe<Role_Notification_Bool_Exp>;
};


export type Subscription_RootRole_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Role_Stream_Cursor_Input>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootRoomArgs = {
  distinct_on?: InputMaybe<Array<Room_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Order_By>>;
  where?: InputMaybe<Room_Bool_Exp>;
};


export type Subscription_RootRoom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Room_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Order_By>>;
  where?: InputMaybe<Room_Bool_Exp>;
};


export type Subscription_RootRoom_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRoom_ModelArgs = {
  distinct_on?: InputMaybe<Array<Room_Model_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Model_Order_By>>;
  where?: InputMaybe<Room_Model_Bool_Exp>;
};


export type Subscription_RootRoom_Model_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Room_Model_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Model_Order_By>>;
  where?: InputMaybe<Room_Model_Bool_Exp>;
};


export type Subscription_RootRoom_Model_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRoom_Model_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Room_Model_Stream_Cursor_Input>>;
  where?: InputMaybe<Room_Model_Bool_Exp>;
};


export type Subscription_RootRoom_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Room_Stream_Cursor_Input>>;
  where?: InputMaybe<Room_Bool_Exp>;
};


export type Subscription_RootRoom_TypeArgs = {
  distinct_on?: InputMaybe<Array<Room_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Type_Order_By>>;
  where?: InputMaybe<Room_Type_Bool_Exp>;
};


export type Subscription_RootRoom_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Room_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Room_Type_Order_By>>;
  where?: InputMaybe<Room_Type_Bool_Exp>;
};


export type Subscription_RootRoom_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRoom_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Room_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Room_Type_Bool_Exp>;
};


export type Subscription_RootSexArgs = {
  distinct_on?: InputMaybe<Array<Sex_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sex_Order_By>>;
  where?: InputMaybe<Sex_Bool_Exp>;
};


export type Subscription_RootSex_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sex_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sex_Order_By>>;
  where?: InputMaybe<Sex_Bool_Exp>;
};


export type Subscription_RootSex_By_PkArgs = {
  sex: Scalars['String'];
};


export type Subscription_RootSex_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sex_Stream_Cursor_Input>>;
  where?: InputMaybe<Sex_Bool_Exp>;
};


export type Subscription_RootSigning_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Signing_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Document_Order_By>>;
  where?: InputMaybe<Signing_Document_Bool_Exp>;
};


export type Subscription_RootSigning_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Document_Order_By>>;
  where?: InputMaybe<Signing_Document_Bool_Exp>;
};


export type Subscription_RootSigning_Document_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSigning_Document_Status_TypeArgs = {
  distinct_on?: InputMaybe<Array<Signing_Document_Status_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Document_Status_Type_Order_By>>;
  where?: InputMaybe<Signing_Document_Status_Type_Bool_Exp>;
};


export type Subscription_RootSigning_Document_Status_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Document_Status_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Document_Status_Type_Order_By>>;
  where?: InputMaybe<Signing_Document_Status_Type_Bool_Exp>;
};


export type Subscription_RootSigning_Document_Status_Type_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootSigning_Document_Status_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Signing_Document_Status_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Signing_Document_Status_Type_Bool_Exp>;
};


export type Subscription_RootSigning_Document_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Signing_Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Signing_Document_Bool_Exp>;
};


export type Subscription_RootSigning_Procedure_Associated_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Order_By>>;
  where?: InputMaybe<Signing_Procedure_Associated_Documents_Bool_Exp>;
};


export type Subscription_RootSigning_Procedure_Associated_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Procedure_Associated_Documents_Order_By>>;
  where?: InputMaybe<Signing_Procedure_Associated_Documents_Bool_Exp>;
};


export type Subscription_RootSigning_Procedure_Associated_Documents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSigning_Procedure_Associated_Documents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Signing_Procedure_Associated_Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Signing_Procedure_Associated_Documents_Bool_Exp>;
};


export type Subscription_RootSigning_TemplateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Order_By>>;
  where?: InputMaybe<Signing_Template_Bool_Exp>;
};


export type Subscription_RootSigning_Template_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Order_By>>;
  where?: InputMaybe<Signing_Template_Bool_Exp>;
};


export type Subscription_RootSigning_Template_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSigning_Template_EquivalentsArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Equivalents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Equivalents_Order_By>>;
  where?: InputMaybe<Signing_Template_Equivalents_Bool_Exp>;
};


export type Subscription_RootSigning_Template_Equivalents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Equivalents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Equivalents_Order_By>>;
  where?: InputMaybe<Signing_Template_Equivalents_Bool_Exp>;
};


export type Subscription_RootSigning_Template_Equivalents_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSigning_Template_Equivalents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Signing_Template_Equivalents_Stream_Cursor_Input>>;
  where?: InputMaybe<Signing_Template_Equivalents_Bool_Exp>;
};


export type Subscription_RootSigning_Template_KindArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Kind_Order_By>>;
  where?: InputMaybe<Signing_Template_Kind_Bool_Exp>;
};


export type Subscription_RootSigning_Template_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Kind_Order_By>>;
  where?: InputMaybe<Signing_Template_Kind_Bool_Exp>;
};


export type Subscription_RootSigning_Template_Kind_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootSigning_Template_Kind_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Signing_Template_Kind_Stream_Cursor_Input>>;
  where?: InputMaybe<Signing_Template_Kind_Bool_Exp>;
};


export type Subscription_RootSigning_Template_Source_FilesArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Source_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Source_Files_Order_By>>;
  where?: InputMaybe<Signing_Template_Source_Files_Bool_Exp>;
};


export type Subscription_RootSigning_Template_Source_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Template_Source_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Template_Source_Files_Order_By>>;
  where?: InputMaybe<Signing_Template_Source_Files_Bool_Exp>;
};


export type Subscription_RootSigning_Template_Source_Files_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSigning_Template_Source_Files_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Signing_Template_Source_Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Signing_Template_Source_Files_Bool_Exp>;
};


export type Subscription_RootSigning_Template_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Signing_Template_Stream_Cursor_Input>>;
  where?: InputMaybe<Signing_Template_Bool_Exp>;
};


export type Subscription_RootSigning_Vansanity_TemplateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Vansanity_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Vansanity_Template_Order_By>>;
  where?: InputMaybe<Signing_Vansanity_Template_Bool_Exp>;
};


export type Subscription_RootSigning_Vansanity_Template_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Vansanity_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Vansanity_Template_Order_By>>;
  where?: InputMaybe<Signing_Vansanity_Template_Bool_Exp>;
};


export type Subscription_RootSigning_Vansanity_Template_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSigning_Vansanity_Template_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Signing_Vansanity_Template_Stream_Cursor_Input>>;
  where?: InputMaybe<Signing_Vansanity_Template_Bool_Exp>;
};


export type Subscription_RootSigning_Webhook_EventArgs = {
  distinct_on?: InputMaybe<Array<Signing_Webhook_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Webhook_Event_Order_By>>;
  where?: InputMaybe<Signing_Webhook_Event_Bool_Exp>;
};


export type Subscription_RootSigning_Webhook_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Webhook_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Webhook_Event_Order_By>>;
  where?: InputMaybe<Signing_Webhook_Event_Bool_Exp>;
};


export type Subscription_RootSigning_Webhook_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSigning_Webhook_Event_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Signing_Webhook_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Signing_Webhook_Event_Bool_Exp>;
};


export type Subscription_RootSigning_Webhook_Event_TypeArgs = {
  distinct_on?: InputMaybe<Array<Signing_Webhook_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Webhook_Event_Type_Order_By>>;
  where?: InputMaybe<Signing_Webhook_Event_Type_Bool_Exp>;
};


export type Subscription_RootSigning_Webhook_Event_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Signing_Webhook_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Signing_Webhook_Event_Type_Order_By>>;
  where?: InputMaybe<Signing_Webhook_Event_Type_Bool_Exp>;
};


export type Subscription_RootSigning_Webhook_Event_Type_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootSigning_Webhook_Event_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Signing_Webhook_Event_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Signing_Webhook_Event_Type_Bool_Exp>;
};


export type Subscription_RootSquare_Credential_Ownership_EnumArgs = {
  distinct_on?: InputMaybe<Array<Square_Credential_Ownership_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Square_Credential_Ownership_Enum_Order_By>>;
  where?: InputMaybe<Square_Credential_Ownership_Enum_Bool_Exp>;
};


export type Subscription_RootSquare_Credential_Ownership_Enum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Square_Credential_Ownership_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Square_Credential_Ownership_Enum_Order_By>>;
  where?: InputMaybe<Square_Credential_Ownership_Enum_Bool_Exp>;
};


export type Subscription_RootSquare_Credential_Ownership_Enum_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootSquare_Credential_Ownership_Enum_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Square_Credential_Ownership_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Square_Credential_Ownership_Enum_Bool_Exp>;
};


export type Subscription_RootSquare_CredentialsArgs = {
  distinct_on?: InputMaybe<Array<Square_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Square_Credentials_Order_By>>;
  where?: InputMaybe<Square_Credentials_Bool_Exp>;
};


export type Subscription_RootSquare_Credentials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Square_Credentials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Square_Credentials_Order_By>>;
  where?: InputMaybe<Square_Credentials_Bool_Exp>;
};


export type Subscription_RootSquare_Credentials_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSquare_Credentials_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Square_Credentials_Stream_Cursor_Input>>;
  where?: InputMaybe<Square_Credentials_Bool_Exp>;
};


export type Subscription_RootSupervisor_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Bool_Exp>;
};


export type Subscription_RootSupervisor_Provider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Bool_Exp>;
};


export type Subscription_RootSupervisor_Provider_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSupervisor_Provider_Initiated_ByArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Initiated_By_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Initiated_By_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Initiated_By_Bool_Exp>;
};


export type Subscription_RootSupervisor_Provider_Initiated_By_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Initiated_By_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Initiated_By_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Initiated_By_Bool_Exp>;
};


export type Subscription_RootSupervisor_Provider_Initiated_By_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootSupervisor_Provider_Initiated_By_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Supervisor_Provider_Initiated_By_Stream_Cursor_Input>>;
  where?: InputMaybe<Supervisor_Provider_Initiated_By_Bool_Exp>;
};


export type Subscription_RootSupervisor_Provider_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Supervisor_Provider_Stream_Cursor_Input>>;
  where?: InputMaybe<Supervisor_Provider_Bool_Exp>;
};


export type Subscription_RootSupervisor_Provider_TermArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Term_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Term_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Term_Bool_Exp>;
};


export type Subscription_RootSupervisor_Provider_Term_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Term_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Term_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Term_Bool_Exp>;
};


export type Subscription_RootSupervisor_Provider_Term_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSupervisor_Provider_Term_Ended_ByArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Term_Ended_By_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Term_Ended_By_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Term_Ended_By_Bool_Exp>;
};


export type Subscription_RootSupervisor_Provider_Term_Ended_By_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Term_Ended_By_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Term_Ended_By_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Term_Ended_By_Bool_Exp>;
};


export type Subscription_RootSupervisor_Provider_Term_Ended_By_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootSupervisor_Provider_Term_Ended_By_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Supervisor_Provider_Term_Ended_By_Stream_Cursor_Input>>;
  where?: InputMaybe<Supervisor_Provider_Term_Ended_By_Bool_Exp>;
};


export type Subscription_RootSupervisor_Provider_Term_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Supervisor_Provider_Term_Stream_Cursor_Input>>;
  where?: InputMaybe<Supervisor_Provider_Term_Bool_Exp>;
};


export type Subscription_RootSupervisor_Review_Queue_ItemArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Item_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Item_Bool_Exp>;
};


export type Subscription_RootSupervisor_Review_Queue_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Item_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Item_Bool_Exp>;
};


export type Subscription_RootSupervisor_Review_Queue_Item_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSupervisor_Review_Queue_Item_Status_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Item_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Item_Status_History_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Bool_Exp>;
};


export type Subscription_RootSupervisor_Review_Queue_Item_Status_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Item_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Item_Status_History_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Bool_Exp>;
};


export type Subscription_RootSupervisor_Review_Queue_Item_Status_History_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSupervisor_Review_Queue_Item_Status_History_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Supervisor_Review_Queue_Item_Status_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Bool_Exp>;
};


export type Subscription_RootSupervisor_Review_Queue_Item_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Supervisor_Review_Queue_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Supervisor_Review_Queue_Item_Bool_Exp>;
};


export type Subscription_RootSupervisor_Review_Queue_SourceArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Source_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Source_Bool_Exp>;
};


export type Subscription_RootSupervisor_Review_Queue_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Source_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Source_Bool_Exp>;
};


export type Subscription_RootSupervisor_Review_Queue_Source_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootSupervisor_Review_Queue_Source_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Supervisor_Review_Queue_Source_Stream_Cursor_Input>>;
  where?: InputMaybe<Supervisor_Review_Queue_Source_Bool_Exp>;
};


export type Subscription_RootSupervisor_Review_Queue_StatusArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Status_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Status_Bool_Exp>;
};


export type Subscription_RootSupervisor_Review_Queue_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Status_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Status_Bool_Exp>;
};


export type Subscription_RootSupervisor_Review_Queue_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootSupervisor_Review_Queue_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Supervisor_Review_Queue_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Supervisor_Review_Queue_Status_Bool_Exp>;
};


export type Subscription_RootSupervisor_Sampling_Period_TypeArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Sampling_Period_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Sampling_Period_Type_Order_By>>;
  where?: InputMaybe<Supervisor_Sampling_Period_Type_Bool_Exp>;
};


export type Subscription_RootSupervisor_Sampling_Period_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Sampling_Period_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Sampling_Period_Type_Order_By>>;
  where?: InputMaybe<Supervisor_Sampling_Period_Type_Bool_Exp>;
};


export type Subscription_RootSupervisor_Sampling_Period_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootSupervisor_Sampling_Period_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Supervisor_Sampling_Period_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Supervisor_Sampling_Period_Type_Bool_Exp>;
};


export type Subscription_RootSupervisor_SettingArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Setting_Order_By>>;
  where?: InputMaybe<Supervisor_Setting_Bool_Exp>;
};


export type Subscription_RootSupervisor_Setting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Setting_Order_By>>;
  where?: InputMaybe<Supervisor_Setting_Bool_Exp>;
};


export type Subscription_RootSupervisor_Setting_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSupervisor_Setting_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Supervisor_Setting_Stream_Cursor_Input>>;
  where?: InputMaybe<Supervisor_Setting_Bool_Exp>;
};


export type Subscription_RootTax_RateArgs = {
  distinct_on?: InputMaybe<Array<Tax_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tax_Rate_Order_By>>;
  where?: InputMaybe<Tax_Rate_Bool_Exp>;
};


export type Subscription_RootTax_Rate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tax_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tax_Rate_Order_By>>;
  where?: InputMaybe<Tax_Rate_Bool_Exp>;
};


export type Subscription_RootTax_Rate_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTax_Rate_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tax_Rate_Stream_Cursor_Input>>;
  where?: InputMaybe<Tax_Rate_Bool_Exp>;
};


export type Subscription_RootTax_TypeArgs = {
  distinct_on?: InputMaybe<Array<Tax_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tax_Type_Order_By>>;
  where?: InputMaybe<Tax_Type_Bool_Exp>;
};


export type Subscription_RootTax_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tax_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tax_Type_Order_By>>;
  where?: InputMaybe<Tax_Type_Bool_Exp>;
};


export type Subscription_RootTax_Type_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootTax_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tax_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Tax_Type_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_AgreementsArgs = {
  distinct_on?: InputMaybe<Array<User_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Agreements_Order_By>>;
  where?: InputMaybe<User_Agreements_Bool_Exp>;
};


export type Subscription_RootUser_Agreements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Agreements_Order_By>>;
  where?: InputMaybe<User_Agreements_Bool_Exp>;
};


export type Subscription_RootUser_Agreements_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Agreements_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Agreements_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Agreements_Bool_Exp>;
};


export type Subscription_RootUser_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_ConsentArgs = {
  distinct_on?: InputMaybe<Array<User_Consent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Consent_Order_By>>;
  where?: InputMaybe<User_Consent_Bool_Exp>;
};


export type Subscription_RootUser_Consent_ActionArgs = {
  distinct_on?: InputMaybe<Array<User_Consent_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Consent_Action_Order_By>>;
  where?: InputMaybe<User_Consent_Action_Bool_Exp>;
};


export type Subscription_RootUser_Consent_Action_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Consent_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Consent_Action_Order_By>>;
  where?: InputMaybe<User_Consent_Action_Bool_Exp>;
};


export type Subscription_RootUser_Consent_Action_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUser_Consent_Action_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Consent_Action_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Consent_Action_Bool_Exp>;
};


export type Subscription_RootUser_Consent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Consent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Consent_Order_By>>;
  where?: InputMaybe<User_Consent_Bool_Exp>;
};


export type Subscription_RootUser_Consent_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Consent_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Consent_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Consent_Bool_Exp>;
};


export type Subscription_RootUser_Consent_TypeArgs = {
  distinct_on?: InputMaybe<Array<User_Consent_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Consent_Type_Order_By>>;
  where?: InputMaybe<User_Consent_Type_Bool_Exp>;
};


export type Subscription_RootUser_Consent_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Consent_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Consent_Type_Order_By>>;
  where?: InputMaybe<User_Consent_Type_Bool_Exp>;
};


export type Subscription_RootUser_Consent_Type_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUser_Consent_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Consent_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Consent_Type_Bool_Exp>;
};


export type Subscription_RootUser_Device_Push_Notification_TokenArgs = {
  distinct_on?: InputMaybe<Array<User_Device_Push_Notification_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Device_Push_Notification_Token_Order_By>>;
  where?: InputMaybe<User_Device_Push_Notification_Token_Bool_Exp>;
};


export type Subscription_RootUser_Device_Push_Notification_Token_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Device_Push_Notification_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Device_Push_Notification_Token_Order_By>>;
  where?: InputMaybe<User_Device_Push_Notification_Token_Bool_Exp>;
};


export type Subscription_RootUser_Device_Push_Notification_Token_By_PkArgs = {
  token: Scalars['String'];
  user: Scalars['uuid'];
};


export type Subscription_RootUser_Device_Push_Notification_Token_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Device_Push_Notification_Token_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Device_Push_Notification_Token_Bool_Exp>;
};


export type Subscription_RootUser_DocumentArgs = {
  distinct_on?: InputMaybe<Array<User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Document_Order_By>>;
  where?: InputMaybe<User_Document_Bool_Exp>;
};


export type Subscription_RootUser_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Document_Order_By>>;
  where?: InputMaybe<User_Document_Bool_Exp>;
};


export type Subscription_RootUser_Document_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Document_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Document_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Document_Bool_Exp>;
};


export type Subscription_RootUser_LocationArgs = {
  distinct_on?: InputMaybe<Array<User_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Location_Order_By>>;
  where?: InputMaybe<User_Location_Bool_Exp>;
};


export type Subscription_RootUser_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Location_Order_By>>;
  where?: InputMaybe<User_Location_Bool_Exp>;
};


export type Subscription_RootUser_Location_By_PkArgs = {
  location: Scalars['uuid'];
  user: Scalars['uuid'];
};


export type Subscription_RootUser_Location_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Location_Bool_Exp>;
};


export type Subscription_RootUser_PlanArgs = {
  distinct_on?: InputMaybe<Array<User_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Plan_Order_By>>;
  where?: InputMaybe<User_Plan_Bool_Exp>;
};


export type Subscription_RootUser_Plan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Plan_Order_By>>;
  where?: InputMaybe<User_Plan_Bool_Exp>;
};


export type Subscription_RootUser_Plan_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Plan_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Plan_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Plan_Bool_Exp>;
};


export type Subscription_RootUser_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUsers_Unfulfilled_Product_Purchases_Count_By_LocationArgs = {
  args: Users_Unfulfilled_Product_Purchases_Count_By_Location_Args;
  distinct_on?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Order_By>>;
  where?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp>;
};


export type Subscription_RootUsers_Unfulfilled_Product_Purchases_Count_By_Location_AggregateArgs = {
  args: Users_Unfulfilled_Product_Purchases_Count_By_Location_Args;
  distinct_on?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Order_By>>;
  where?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp>;
};


export type Subscription_RootVersionArgs = {
  distinct_on?: InputMaybe<Array<Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Version_Order_By>>;
  where?: InputMaybe<Version_Bool_Exp>;
};


export type Subscription_RootVersion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Version_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Version_Order_By>>;
  where?: InputMaybe<Version_Bool_Exp>;
};


export type Subscription_RootVersion_By_PkArgs = {
  providerAppAndroid: Scalars['numeric'];
  providerAppIos: Scalars['String'];
};


export type Subscription_RootVersion_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Version_Stream_Cursor_Input>>;
  where?: InputMaybe<Version_Bool_Exp>;
};

/** columns and relationships of "supervisor_provider" */
export type Supervisor_Provider = {
  __typename?: 'supervisor_provider';
  createdAt: Scalars['timestamptz'];
  hardCount: Scalars['Int'];
  /** A computed field, executes function "supervisor_provider_has_accepted_term" */
  hasAcceptedTerm?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  initiatedBy: Supervisor_Provider_Initiated_By_Enum;
  /** A computed field, executes function "supervisor_provider_is_active" */
  isActive?: Maybe<Scalars['Boolean']>;
  /** A computed field, executes function "supervisor_provider_is_pending" */
  isPending?: Maybe<Scalars['Boolean']>;
  provider?: Maybe<Scalars['uuid']>;
  /** Invite-time email captured for a supervisor-initiated invitation before the provider has claimed an account. NOT a user contact address: do not use this as the user's email for messaging or notifications. The user's authoritative email lives in Cognito. */
  providerEmail?: Maybe<Scalars['String']>;
  /** Inviting provider's first name, snapshot at PROVIDER-initiated invite time. Display-only — never updated; not a lookup key. Mirrors provider_email (the SUPERVISOR-initiated snapshot). */
  providerFirstName?: Maybe<Scalars['String']>;
  /** Inviting provider's last name, snapshot at PROVIDER-initiated invite time. Display-only — never updated; not a lookup key. */
  providerLastName?: Maybe<Scalars['String']>;
  samplingPercentage: Scalars['Int'];
  samplingPeriod: Supervisor_Sampling_Period_Type_Enum;
  supervisor?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  supervisorProviderTerms: Array<Supervisor_Provider_Term>;
  /** An aggregate relationship */
  supervisorProviderTerms_aggregate: Supervisor_Provider_Term_Aggregate;
  /** An array relationship */
  supervisorReviewQueueItems: Array<Supervisor_Review_Queue_Item>;
  /** An aggregate relationship */
  supervisorReviewQueueItems_aggregate: Supervisor_Review_Queue_Item_Aggregate;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  userByProvider?: Maybe<User>;
  /** An object relationship */
  userBySupervisor?: Maybe<User>;
};


/** columns and relationships of "supervisor_provider" */
export type Supervisor_ProviderSupervisorProviderTermsArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Term_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Term_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Term_Bool_Exp>;
};


/** columns and relationships of "supervisor_provider" */
export type Supervisor_ProviderSupervisorProviderTerms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Term_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Term_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Term_Bool_Exp>;
};


/** columns and relationships of "supervisor_provider" */
export type Supervisor_ProviderSupervisorReviewQueueItemsArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Item_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Item_Bool_Exp>;
};


/** columns and relationships of "supervisor_provider" */
export type Supervisor_ProviderSupervisorReviewQueueItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Item_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Item_Bool_Exp>;
};

/** aggregated selection of "supervisor_provider" */
export type Supervisor_Provider_Aggregate = {
  __typename?: 'supervisor_provider_aggregate';
  aggregate?: Maybe<Supervisor_Provider_Aggregate_Fields>;
  nodes: Array<Supervisor_Provider>;
};

export type Supervisor_Provider_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supervisor_Provider_Aggregate_Bool_Exp_Count>;
};

export type Supervisor_Provider_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supervisor_Provider_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Supervisor_Provider_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supervisor_provider" */
export type Supervisor_Provider_Aggregate_Fields = {
  __typename?: 'supervisor_provider_aggregate_fields';
  avg?: Maybe<Supervisor_Provider_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Supervisor_Provider_Max_Fields>;
  min?: Maybe<Supervisor_Provider_Min_Fields>;
  stddev?: Maybe<Supervisor_Provider_Stddev_Fields>;
  stddev_pop?: Maybe<Supervisor_Provider_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supervisor_Provider_Stddev_Samp_Fields>;
  sum?: Maybe<Supervisor_Provider_Sum_Fields>;
  var_pop?: Maybe<Supervisor_Provider_Var_Pop_Fields>;
  var_samp?: Maybe<Supervisor_Provider_Var_Samp_Fields>;
  variance?: Maybe<Supervisor_Provider_Variance_Fields>;
};


/** aggregate fields of "supervisor_provider" */
export type Supervisor_Provider_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supervisor_Provider_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "supervisor_provider" */
export type Supervisor_Provider_Aggregate_Order_By = {
  avg?: InputMaybe<Supervisor_Provider_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supervisor_Provider_Max_Order_By>;
  min?: InputMaybe<Supervisor_Provider_Min_Order_By>;
  stddev?: InputMaybe<Supervisor_Provider_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Supervisor_Provider_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Supervisor_Provider_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Supervisor_Provider_Sum_Order_By>;
  var_pop?: InputMaybe<Supervisor_Provider_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Supervisor_Provider_Var_Samp_Order_By>;
  variance?: InputMaybe<Supervisor_Provider_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "supervisor_provider" */
export type Supervisor_Provider_Arr_Rel_Insert_Input = {
  data: Array<Supervisor_Provider_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supervisor_Provider_On_Conflict>;
};

/** aggregate avg on columns */
export type Supervisor_Provider_Avg_Fields = {
  __typename?: 'supervisor_provider_avg_fields';
  hardCount?: Maybe<Scalars['Float']>;
  samplingPercentage?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "supervisor_provider" */
export type Supervisor_Provider_Avg_Order_By = {
  hardCount?: InputMaybe<Order_By>;
  samplingPercentage?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "supervisor_provider". All fields are combined with a logical 'AND'. */
export type Supervisor_Provider_Bool_Exp = {
  _and?: InputMaybe<Array<Supervisor_Provider_Bool_Exp>>;
  _not?: InputMaybe<Supervisor_Provider_Bool_Exp>;
  _or?: InputMaybe<Array<Supervisor_Provider_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  hardCount?: InputMaybe<Int_Comparison_Exp>;
  hasAcceptedTerm?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  initiatedBy?: InputMaybe<Supervisor_Provider_Initiated_By_Enum_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  isPending?: InputMaybe<Boolean_Comparison_Exp>;
  provider?: InputMaybe<Uuid_Comparison_Exp>;
  providerEmail?: InputMaybe<String_Comparison_Exp>;
  providerFirstName?: InputMaybe<String_Comparison_Exp>;
  providerLastName?: InputMaybe<String_Comparison_Exp>;
  samplingPercentage?: InputMaybe<Int_Comparison_Exp>;
  samplingPeriod?: InputMaybe<Supervisor_Sampling_Period_Type_Enum_Comparison_Exp>;
  supervisor?: InputMaybe<Uuid_Comparison_Exp>;
  supervisorProviderTerms?: InputMaybe<Supervisor_Provider_Term_Bool_Exp>;
  supervisorProviderTerms_aggregate?: InputMaybe<Supervisor_Provider_Term_Aggregate_Bool_Exp>;
  supervisorReviewQueueItems?: InputMaybe<Supervisor_Review_Queue_Item_Bool_Exp>;
  supervisorReviewQueueItems_aggregate?: InputMaybe<Supervisor_Review_Queue_Item_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userByProvider?: InputMaybe<User_Bool_Exp>;
  userBySupervisor?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "supervisor_provider" */
export enum Supervisor_Provider_Constraint {
  /** unique or primary key constraint on columns "id" */
  SupervisorProviderPkey = 'supervisor_provider_pkey',
  /** unique or primary key constraint on columns "supervisor" */
  SupervisorProviderSupervisorEmailUnclaimedUnique = 'supervisor_provider_supervisor_email_unclaimed_unique',
  /** unique or primary key constraint on columns "provider", "supervisor" */
  UniqueActiveSupervisorProvider = 'unique_active_supervisor_provider'
}

/** input type for incrementing numeric columns in table "supervisor_provider" */
export type Supervisor_Provider_Inc_Input = {
  hardCount?: InputMaybe<Scalars['Int']>;
  samplingPercentage?: InputMaybe<Scalars['Int']>;
};

/** columns and relationships of "supervisor_provider_initiated_by" */
export type Supervisor_Provider_Initiated_By = {
  __typename?: 'supervisor_provider_initiated_by';
  name: Scalars['String'];
};

/** aggregated selection of "supervisor_provider_initiated_by" */
export type Supervisor_Provider_Initiated_By_Aggregate = {
  __typename?: 'supervisor_provider_initiated_by_aggregate';
  aggregate?: Maybe<Supervisor_Provider_Initiated_By_Aggregate_Fields>;
  nodes: Array<Supervisor_Provider_Initiated_By>;
};

/** aggregate fields of "supervisor_provider_initiated_by" */
export type Supervisor_Provider_Initiated_By_Aggregate_Fields = {
  __typename?: 'supervisor_provider_initiated_by_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Supervisor_Provider_Initiated_By_Max_Fields>;
  min?: Maybe<Supervisor_Provider_Initiated_By_Min_Fields>;
};


/** aggregate fields of "supervisor_provider_initiated_by" */
export type Supervisor_Provider_Initiated_By_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supervisor_Provider_Initiated_By_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "supervisor_provider_initiated_by". All fields are combined with a logical 'AND'. */
export type Supervisor_Provider_Initiated_By_Bool_Exp = {
  _and?: InputMaybe<Array<Supervisor_Provider_Initiated_By_Bool_Exp>>;
  _not?: InputMaybe<Supervisor_Provider_Initiated_By_Bool_Exp>;
  _or?: InputMaybe<Array<Supervisor_Provider_Initiated_By_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supervisor_provider_initiated_by" */
export enum Supervisor_Provider_Initiated_By_Constraint {
  /** unique or primary key constraint on columns "name" */
  SupervisorProviderInitiatedByPkey = 'supervisor_provider_initiated_by_pkey'
}

export enum Supervisor_Provider_Initiated_By_Enum {
  Provider = 'PROVIDER',
  Supervisor = 'SUPERVISOR'
}

/** Boolean expression to compare columns of type "supervisor_provider_initiated_by_enum". All fields are combined with logical 'AND'. */
export type Supervisor_Provider_Initiated_By_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Supervisor_Provider_Initiated_By_Enum>;
  _in?: InputMaybe<Array<Supervisor_Provider_Initiated_By_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Supervisor_Provider_Initiated_By_Enum>;
  _nin?: InputMaybe<Array<Supervisor_Provider_Initiated_By_Enum>>;
};

/** input type for inserting data into table "supervisor_provider_initiated_by" */
export type Supervisor_Provider_Initiated_By_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Supervisor_Provider_Initiated_By_Max_Fields = {
  __typename?: 'supervisor_provider_initiated_by_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Supervisor_Provider_Initiated_By_Min_Fields = {
  __typename?: 'supervisor_provider_initiated_by_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "supervisor_provider_initiated_by" */
export type Supervisor_Provider_Initiated_By_Mutation_Response = {
  __typename?: 'supervisor_provider_initiated_by_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Supervisor_Provider_Initiated_By>;
};

/** on_conflict condition type for table "supervisor_provider_initiated_by" */
export type Supervisor_Provider_Initiated_By_On_Conflict = {
  constraint: Supervisor_Provider_Initiated_By_Constraint;
  update_columns?: Array<Supervisor_Provider_Initiated_By_Update_Column>;
  where?: InputMaybe<Supervisor_Provider_Initiated_By_Bool_Exp>;
};

/** Ordering options when selecting data from "supervisor_provider_initiated_by". */
export type Supervisor_Provider_Initiated_By_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supervisor_provider_initiated_by */
export type Supervisor_Provider_Initiated_By_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "supervisor_provider_initiated_by" */
export enum Supervisor_Provider_Initiated_By_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "supervisor_provider_initiated_by" */
export type Supervisor_Provider_Initiated_By_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "supervisor_provider_initiated_by" */
export type Supervisor_Provider_Initiated_By_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supervisor_Provider_Initiated_By_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supervisor_Provider_Initiated_By_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "supervisor_provider_initiated_by" */
export enum Supervisor_Provider_Initiated_By_Update_Column {
  /** column name */
  Name = 'name'
}

export type Supervisor_Provider_Initiated_By_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supervisor_Provider_Initiated_By_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supervisor_Provider_Initiated_By_Bool_Exp;
};

/** input type for inserting data into table "supervisor_provider" */
export type Supervisor_Provider_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  hardCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  initiatedBy?: InputMaybe<Supervisor_Provider_Initiated_By_Enum>;
  provider?: InputMaybe<Scalars['uuid']>;
  /** Invite-time email captured for a supervisor-initiated invitation before the provider has claimed an account. NOT a user contact address: do not use this as the user's email for messaging or notifications. The user's authoritative email lives in Cognito. */
  providerEmail?: InputMaybe<Scalars['String']>;
  /** Inviting provider's first name, snapshot at PROVIDER-initiated invite time. Display-only — never updated; not a lookup key. Mirrors provider_email (the SUPERVISOR-initiated snapshot). */
  providerFirstName?: InputMaybe<Scalars['String']>;
  /** Inviting provider's last name, snapshot at PROVIDER-initiated invite time. Display-only — never updated; not a lookup key. */
  providerLastName?: InputMaybe<Scalars['String']>;
  samplingPercentage?: InputMaybe<Scalars['Int']>;
  samplingPeriod?: InputMaybe<Supervisor_Sampling_Period_Type_Enum>;
  supervisor?: InputMaybe<Scalars['uuid']>;
  supervisorProviderTerms?: InputMaybe<Supervisor_Provider_Term_Arr_Rel_Insert_Input>;
  supervisorReviewQueueItems?: InputMaybe<Supervisor_Review_Queue_Item_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userByProvider?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userBySupervisor?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Supervisor_Provider_Max_Fields = {
  __typename?: 'supervisor_provider_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  hardCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  /** Invite-time email captured for a supervisor-initiated invitation before the provider has claimed an account. NOT a user contact address: do not use this as the user's email for messaging or notifications. The user's authoritative email lives in Cognito. */
  providerEmail?: Maybe<Scalars['String']>;
  /** Inviting provider's first name, snapshot at PROVIDER-initiated invite time. Display-only — never updated; not a lookup key. Mirrors provider_email (the SUPERVISOR-initiated snapshot). */
  providerFirstName?: Maybe<Scalars['String']>;
  /** Inviting provider's last name, snapshot at PROVIDER-initiated invite time. Display-only — never updated; not a lookup key. */
  providerLastName?: Maybe<Scalars['String']>;
  samplingPercentage?: Maybe<Scalars['Int']>;
  supervisor?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "supervisor_provider" */
export type Supervisor_Provider_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  hardCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  /** Invite-time email captured for a supervisor-initiated invitation before the provider has claimed an account. NOT a user contact address: do not use this as the user's email for messaging or notifications. The user's authoritative email lives in Cognito. */
  providerEmail?: InputMaybe<Order_By>;
  /** Inviting provider's first name, snapshot at PROVIDER-initiated invite time. Display-only — never updated; not a lookup key. Mirrors provider_email (the SUPERVISOR-initiated snapshot). */
  providerFirstName?: InputMaybe<Order_By>;
  /** Inviting provider's last name, snapshot at PROVIDER-initiated invite time. Display-only — never updated; not a lookup key. */
  providerLastName?: InputMaybe<Order_By>;
  samplingPercentage?: InputMaybe<Order_By>;
  supervisor?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supervisor_Provider_Min_Fields = {
  __typename?: 'supervisor_provider_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  hardCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['uuid']>;
  /** Invite-time email captured for a supervisor-initiated invitation before the provider has claimed an account. NOT a user contact address: do not use this as the user's email for messaging or notifications. The user's authoritative email lives in Cognito. */
  providerEmail?: Maybe<Scalars['String']>;
  /** Inviting provider's first name, snapshot at PROVIDER-initiated invite time. Display-only — never updated; not a lookup key. Mirrors provider_email (the SUPERVISOR-initiated snapshot). */
  providerFirstName?: Maybe<Scalars['String']>;
  /** Inviting provider's last name, snapshot at PROVIDER-initiated invite time. Display-only — never updated; not a lookup key. */
  providerLastName?: Maybe<Scalars['String']>;
  samplingPercentage?: Maybe<Scalars['Int']>;
  supervisor?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "supervisor_provider" */
export type Supervisor_Provider_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  hardCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  /** Invite-time email captured for a supervisor-initiated invitation before the provider has claimed an account. NOT a user contact address: do not use this as the user's email for messaging or notifications. The user's authoritative email lives in Cognito. */
  providerEmail?: InputMaybe<Order_By>;
  /** Inviting provider's first name, snapshot at PROVIDER-initiated invite time. Display-only — never updated; not a lookup key. Mirrors provider_email (the SUPERVISOR-initiated snapshot). */
  providerFirstName?: InputMaybe<Order_By>;
  /** Inviting provider's last name, snapshot at PROVIDER-initiated invite time. Display-only — never updated; not a lookup key. */
  providerLastName?: InputMaybe<Order_By>;
  samplingPercentage?: InputMaybe<Order_By>;
  supervisor?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supervisor_provider" */
export type Supervisor_Provider_Mutation_Response = {
  __typename?: 'supervisor_provider_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Supervisor_Provider>;
};

/** input type for inserting object relation for remote table "supervisor_provider" */
export type Supervisor_Provider_Obj_Rel_Insert_Input = {
  data: Supervisor_Provider_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supervisor_Provider_On_Conflict>;
};

/** on_conflict condition type for table "supervisor_provider" */
export type Supervisor_Provider_On_Conflict = {
  constraint: Supervisor_Provider_Constraint;
  update_columns?: Array<Supervisor_Provider_Update_Column>;
  where?: InputMaybe<Supervisor_Provider_Bool_Exp>;
};

/** Ordering options when selecting data from "supervisor_provider". */
export type Supervisor_Provider_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  hardCount?: InputMaybe<Order_By>;
  hasAcceptedTerm?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiatedBy?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  isPending?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  providerEmail?: InputMaybe<Order_By>;
  providerFirstName?: InputMaybe<Order_By>;
  providerLastName?: InputMaybe<Order_By>;
  samplingPercentage?: InputMaybe<Order_By>;
  samplingPeriod?: InputMaybe<Order_By>;
  supervisor?: InputMaybe<Order_By>;
  supervisorProviderTerms_aggregate?: InputMaybe<Supervisor_Provider_Term_Aggregate_Order_By>;
  supervisorReviewQueueItems_aggregate?: InputMaybe<Supervisor_Review_Queue_Item_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userByProvider?: InputMaybe<User_Order_By>;
  userBySupervisor?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: supervisor_provider */
export type Supervisor_Provider_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "supervisor_provider" */
export enum Supervisor_Provider_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  HardCount = 'hardCount',
  /** column name */
  Id = 'id',
  /** column name */
  InitiatedBy = 'initiatedBy',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderEmail = 'providerEmail',
  /** column name */
  ProviderFirstName = 'providerFirstName',
  /** column name */
  ProviderLastName = 'providerLastName',
  /** column name */
  SamplingPercentage = 'samplingPercentage',
  /** column name */
  SamplingPeriod = 'samplingPeriod',
  /** column name */
  Supervisor = 'supervisor',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "supervisor_provider" */
export type Supervisor_Provider_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  hardCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  initiatedBy?: InputMaybe<Supervisor_Provider_Initiated_By_Enum>;
  provider?: InputMaybe<Scalars['uuid']>;
  /** Invite-time email captured for a supervisor-initiated invitation before the provider has claimed an account. NOT a user contact address: do not use this as the user's email for messaging or notifications. The user's authoritative email lives in Cognito. */
  providerEmail?: InputMaybe<Scalars['String']>;
  /** Inviting provider's first name, snapshot at PROVIDER-initiated invite time. Display-only — never updated; not a lookup key. Mirrors provider_email (the SUPERVISOR-initiated snapshot). */
  providerFirstName?: InputMaybe<Scalars['String']>;
  /** Inviting provider's last name, snapshot at PROVIDER-initiated invite time. Display-only — never updated; not a lookup key. */
  providerLastName?: InputMaybe<Scalars['String']>;
  samplingPercentage?: InputMaybe<Scalars['Int']>;
  samplingPeriod?: InputMaybe<Supervisor_Sampling_Period_Type_Enum>;
  supervisor?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Supervisor_Provider_Stddev_Fields = {
  __typename?: 'supervisor_provider_stddev_fields';
  hardCount?: Maybe<Scalars['Float']>;
  samplingPercentage?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "supervisor_provider" */
export type Supervisor_Provider_Stddev_Order_By = {
  hardCount?: InputMaybe<Order_By>;
  samplingPercentage?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Supervisor_Provider_Stddev_Pop_Fields = {
  __typename?: 'supervisor_provider_stddev_pop_fields';
  hardCount?: Maybe<Scalars['Float']>;
  samplingPercentage?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "supervisor_provider" */
export type Supervisor_Provider_Stddev_Pop_Order_By = {
  hardCount?: InputMaybe<Order_By>;
  samplingPercentage?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Supervisor_Provider_Stddev_Samp_Fields = {
  __typename?: 'supervisor_provider_stddev_samp_fields';
  hardCount?: Maybe<Scalars['Float']>;
  samplingPercentage?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "supervisor_provider" */
export type Supervisor_Provider_Stddev_Samp_Order_By = {
  hardCount?: InputMaybe<Order_By>;
  samplingPercentage?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "supervisor_provider" */
export type Supervisor_Provider_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supervisor_Provider_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supervisor_Provider_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  hardCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  initiatedBy?: InputMaybe<Supervisor_Provider_Initiated_By_Enum>;
  provider?: InputMaybe<Scalars['uuid']>;
  /** Invite-time email captured for a supervisor-initiated invitation before the provider has claimed an account. NOT a user contact address: do not use this as the user's email for messaging or notifications. The user's authoritative email lives in Cognito. */
  providerEmail?: InputMaybe<Scalars['String']>;
  /** Inviting provider's first name, snapshot at PROVIDER-initiated invite time. Display-only — never updated; not a lookup key. Mirrors provider_email (the SUPERVISOR-initiated snapshot). */
  providerFirstName?: InputMaybe<Scalars['String']>;
  /** Inviting provider's last name, snapshot at PROVIDER-initiated invite time. Display-only — never updated; not a lookup key. */
  providerLastName?: InputMaybe<Scalars['String']>;
  samplingPercentage?: InputMaybe<Scalars['Int']>;
  samplingPeriod?: InputMaybe<Supervisor_Sampling_Period_Type_Enum>;
  supervisor?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Supervisor_Provider_Sum_Fields = {
  __typename?: 'supervisor_provider_sum_fields';
  hardCount?: Maybe<Scalars['Int']>;
  samplingPercentage?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "supervisor_provider" */
export type Supervisor_Provider_Sum_Order_By = {
  hardCount?: InputMaybe<Order_By>;
  samplingPercentage?: InputMaybe<Order_By>;
};

/** columns and relationships of "supervisor_provider_term" */
export type Supervisor_Provider_Term = {
  __typename?: 'supervisor_provider_term';
  createdAt: Scalars['timestamptz'];
  endedAt?: Maybe<Scalars['timestamptz']>;
  endedBy?: Maybe<Supervisor_Provider_Term_Ended_By_Enum>;
  hardCountCompleted: Scalars['Int'];
  id: Scalars['uuid'];
  startedAt?: Maybe<Scalars['timestamptz']>;
  supervisorProvider: Scalars['uuid'];
  /** An object relationship */
  supervisorProviderBySupervisorProvider: Supervisor_Provider;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "supervisor_provider_term" */
export type Supervisor_Provider_Term_Aggregate = {
  __typename?: 'supervisor_provider_term_aggregate';
  aggregate?: Maybe<Supervisor_Provider_Term_Aggregate_Fields>;
  nodes: Array<Supervisor_Provider_Term>;
};

export type Supervisor_Provider_Term_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supervisor_Provider_Term_Aggregate_Bool_Exp_Count>;
};

export type Supervisor_Provider_Term_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supervisor_Provider_Term_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Supervisor_Provider_Term_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supervisor_provider_term" */
export type Supervisor_Provider_Term_Aggregate_Fields = {
  __typename?: 'supervisor_provider_term_aggregate_fields';
  avg?: Maybe<Supervisor_Provider_Term_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Supervisor_Provider_Term_Max_Fields>;
  min?: Maybe<Supervisor_Provider_Term_Min_Fields>;
  stddev?: Maybe<Supervisor_Provider_Term_Stddev_Fields>;
  stddev_pop?: Maybe<Supervisor_Provider_Term_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supervisor_Provider_Term_Stddev_Samp_Fields>;
  sum?: Maybe<Supervisor_Provider_Term_Sum_Fields>;
  var_pop?: Maybe<Supervisor_Provider_Term_Var_Pop_Fields>;
  var_samp?: Maybe<Supervisor_Provider_Term_Var_Samp_Fields>;
  variance?: Maybe<Supervisor_Provider_Term_Variance_Fields>;
};


/** aggregate fields of "supervisor_provider_term" */
export type Supervisor_Provider_Term_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supervisor_Provider_Term_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "supervisor_provider_term" */
export type Supervisor_Provider_Term_Aggregate_Order_By = {
  avg?: InputMaybe<Supervisor_Provider_Term_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supervisor_Provider_Term_Max_Order_By>;
  min?: InputMaybe<Supervisor_Provider_Term_Min_Order_By>;
  stddev?: InputMaybe<Supervisor_Provider_Term_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Supervisor_Provider_Term_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Supervisor_Provider_Term_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Supervisor_Provider_Term_Sum_Order_By>;
  var_pop?: InputMaybe<Supervisor_Provider_Term_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Supervisor_Provider_Term_Var_Samp_Order_By>;
  variance?: InputMaybe<Supervisor_Provider_Term_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "supervisor_provider_term" */
export type Supervisor_Provider_Term_Arr_Rel_Insert_Input = {
  data: Array<Supervisor_Provider_Term_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supervisor_Provider_Term_On_Conflict>;
};

/** aggregate avg on columns */
export type Supervisor_Provider_Term_Avg_Fields = {
  __typename?: 'supervisor_provider_term_avg_fields';
  hardCountCompleted?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "supervisor_provider_term" */
export type Supervisor_Provider_Term_Avg_Order_By = {
  hardCountCompleted?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "supervisor_provider_term". All fields are combined with a logical 'AND'. */
export type Supervisor_Provider_Term_Bool_Exp = {
  _and?: InputMaybe<Array<Supervisor_Provider_Term_Bool_Exp>>;
  _not?: InputMaybe<Supervisor_Provider_Term_Bool_Exp>;
  _or?: InputMaybe<Array<Supervisor_Provider_Term_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  endedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  endedBy?: InputMaybe<Supervisor_Provider_Term_Ended_By_Enum_Comparison_Exp>;
  hardCountCompleted?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  startedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  supervisorProvider?: InputMaybe<Uuid_Comparison_Exp>;
  supervisorProviderBySupervisorProvider?: InputMaybe<Supervisor_Provider_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "supervisor_provider_term" */
export enum Supervisor_Provider_Term_Constraint {
  /** unique or primary key constraint on columns "id" */
  SupervisorProviderTermPkey = 'supervisor_provider_term_pkey',
  /** unique or primary key constraint on columns "supervisor_provider" */
  UniqueOpenSupervisorProviderTerm = 'unique_open_supervisor_provider_term'
}

/** columns and relationships of "supervisor_provider_term_ended_by" */
export type Supervisor_Provider_Term_Ended_By = {
  __typename?: 'supervisor_provider_term_ended_by';
  name: Scalars['String'];
};

/** aggregated selection of "supervisor_provider_term_ended_by" */
export type Supervisor_Provider_Term_Ended_By_Aggregate = {
  __typename?: 'supervisor_provider_term_ended_by_aggregate';
  aggregate?: Maybe<Supervisor_Provider_Term_Ended_By_Aggregate_Fields>;
  nodes: Array<Supervisor_Provider_Term_Ended_By>;
};

/** aggregate fields of "supervisor_provider_term_ended_by" */
export type Supervisor_Provider_Term_Ended_By_Aggregate_Fields = {
  __typename?: 'supervisor_provider_term_ended_by_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Supervisor_Provider_Term_Ended_By_Max_Fields>;
  min?: Maybe<Supervisor_Provider_Term_Ended_By_Min_Fields>;
};


/** aggregate fields of "supervisor_provider_term_ended_by" */
export type Supervisor_Provider_Term_Ended_By_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supervisor_Provider_Term_Ended_By_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "supervisor_provider_term_ended_by". All fields are combined with a logical 'AND'. */
export type Supervisor_Provider_Term_Ended_By_Bool_Exp = {
  _and?: InputMaybe<Array<Supervisor_Provider_Term_Ended_By_Bool_Exp>>;
  _not?: InputMaybe<Supervisor_Provider_Term_Ended_By_Bool_Exp>;
  _or?: InputMaybe<Array<Supervisor_Provider_Term_Ended_By_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supervisor_provider_term_ended_by" */
export enum Supervisor_Provider_Term_Ended_By_Constraint {
  /** unique or primary key constraint on columns "name" */
  SupervisorProviderTermEndedByPkey = 'supervisor_provider_term_ended_by_pkey'
}

export enum Supervisor_Provider_Term_Ended_By_Enum {
  Declined = 'DECLINED',
  Provider = 'PROVIDER',
  Supervisor = 'SUPERVISOR'
}

/** Boolean expression to compare columns of type "supervisor_provider_term_ended_by_enum". All fields are combined with logical 'AND'. */
export type Supervisor_Provider_Term_Ended_By_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Supervisor_Provider_Term_Ended_By_Enum>;
  _in?: InputMaybe<Array<Supervisor_Provider_Term_Ended_By_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Supervisor_Provider_Term_Ended_By_Enum>;
  _nin?: InputMaybe<Array<Supervisor_Provider_Term_Ended_By_Enum>>;
};

/** input type for inserting data into table "supervisor_provider_term_ended_by" */
export type Supervisor_Provider_Term_Ended_By_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Supervisor_Provider_Term_Ended_By_Max_Fields = {
  __typename?: 'supervisor_provider_term_ended_by_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Supervisor_Provider_Term_Ended_By_Min_Fields = {
  __typename?: 'supervisor_provider_term_ended_by_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "supervisor_provider_term_ended_by" */
export type Supervisor_Provider_Term_Ended_By_Mutation_Response = {
  __typename?: 'supervisor_provider_term_ended_by_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Supervisor_Provider_Term_Ended_By>;
};

/** on_conflict condition type for table "supervisor_provider_term_ended_by" */
export type Supervisor_Provider_Term_Ended_By_On_Conflict = {
  constraint: Supervisor_Provider_Term_Ended_By_Constraint;
  update_columns?: Array<Supervisor_Provider_Term_Ended_By_Update_Column>;
  where?: InputMaybe<Supervisor_Provider_Term_Ended_By_Bool_Exp>;
};

/** Ordering options when selecting data from "supervisor_provider_term_ended_by". */
export type Supervisor_Provider_Term_Ended_By_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supervisor_provider_term_ended_by */
export type Supervisor_Provider_Term_Ended_By_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "supervisor_provider_term_ended_by" */
export enum Supervisor_Provider_Term_Ended_By_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "supervisor_provider_term_ended_by" */
export type Supervisor_Provider_Term_Ended_By_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "supervisor_provider_term_ended_by" */
export type Supervisor_Provider_Term_Ended_By_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supervisor_Provider_Term_Ended_By_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supervisor_Provider_Term_Ended_By_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "supervisor_provider_term_ended_by" */
export enum Supervisor_Provider_Term_Ended_By_Update_Column {
  /** column name */
  Name = 'name'
}

export type Supervisor_Provider_Term_Ended_By_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supervisor_Provider_Term_Ended_By_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supervisor_Provider_Term_Ended_By_Bool_Exp;
};

/** input type for incrementing numeric columns in table "supervisor_provider_term" */
export type Supervisor_Provider_Term_Inc_Input = {
  hardCountCompleted?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "supervisor_provider_term" */
export type Supervisor_Provider_Term_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  endedBy?: InputMaybe<Supervisor_Provider_Term_Ended_By_Enum>;
  hardCountCompleted?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  startedAt?: InputMaybe<Scalars['timestamptz']>;
  supervisorProvider?: InputMaybe<Scalars['uuid']>;
  supervisorProviderBySupervisorProvider?: InputMaybe<Supervisor_Provider_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Supervisor_Provider_Term_Max_Fields = {
  __typename?: 'supervisor_provider_term_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  endedAt?: Maybe<Scalars['timestamptz']>;
  hardCountCompleted?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  startedAt?: Maybe<Scalars['timestamptz']>;
  supervisorProvider?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "supervisor_provider_term" */
export type Supervisor_Provider_Term_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  endedAt?: InputMaybe<Order_By>;
  hardCountCompleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  startedAt?: InputMaybe<Order_By>;
  supervisorProvider?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supervisor_Provider_Term_Min_Fields = {
  __typename?: 'supervisor_provider_term_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  endedAt?: Maybe<Scalars['timestamptz']>;
  hardCountCompleted?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  startedAt?: Maybe<Scalars['timestamptz']>;
  supervisorProvider?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "supervisor_provider_term" */
export type Supervisor_Provider_Term_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  endedAt?: InputMaybe<Order_By>;
  hardCountCompleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  startedAt?: InputMaybe<Order_By>;
  supervisorProvider?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supervisor_provider_term" */
export type Supervisor_Provider_Term_Mutation_Response = {
  __typename?: 'supervisor_provider_term_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Supervisor_Provider_Term>;
};

/** on_conflict condition type for table "supervisor_provider_term" */
export type Supervisor_Provider_Term_On_Conflict = {
  constraint: Supervisor_Provider_Term_Constraint;
  update_columns?: Array<Supervisor_Provider_Term_Update_Column>;
  where?: InputMaybe<Supervisor_Provider_Term_Bool_Exp>;
};

/** Ordering options when selecting data from "supervisor_provider_term". */
export type Supervisor_Provider_Term_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  endedAt?: InputMaybe<Order_By>;
  endedBy?: InputMaybe<Order_By>;
  hardCountCompleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  startedAt?: InputMaybe<Order_By>;
  supervisorProvider?: InputMaybe<Order_By>;
  supervisorProviderBySupervisorProvider?: InputMaybe<Supervisor_Provider_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supervisor_provider_term */
export type Supervisor_Provider_Term_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "supervisor_provider_term" */
export enum Supervisor_Provider_Term_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndedAt = 'endedAt',
  /** column name */
  EndedBy = 'endedBy',
  /** column name */
  HardCountCompleted = 'hardCountCompleted',
  /** column name */
  Id = 'id',
  /** column name */
  StartedAt = 'startedAt',
  /** column name */
  SupervisorProvider = 'supervisorProvider',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "supervisor_provider_term" */
export type Supervisor_Provider_Term_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  endedBy?: InputMaybe<Supervisor_Provider_Term_Ended_By_Enum>;
  hardCountCompleted?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  startedAt?: InputMaybe<Scalars['timestamptz']>;
  supervisorProvider?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Supervisor_Provider_Term_Stddev_Fields = {
  __typename?: 'supervisor_provider_term_stddev_fields';
  hardCountCompleted?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "supervisor_provider_term" */
export type Supervisor_Provider_Term_Stddev_Order_By = {
  hardCountCompleted?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Supervisor_Provider_Term_Stddev_Pop_Fields = {
  __typename?: 'supervisor_provider_term_stddev_pop_fields';
  hardCountCompleted?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "supervisor_provider_term" */
export type Supervisor_Provider_Term_Stddev_Pop_Order_By = {
  hardCountCompleted?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Supervisor_Provider_Term_Stddev_Samp_Fields = {
  __typename?: 'supervisor_provider_term_stddev_samp_fields';
  hardCountCompleted?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "supervisor_provider_term" */
export type Supervisor_Provider_Term_Stddev_Samp_Order_By = {
  hardCountCompleted?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "supervisor_provider_term" */
export type Supervisor_Provider_Term_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supervisor_Provider_Term_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supervisor_Provider_Term_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  endedBy?: InputMaybe<Supervisor_Provider_Term_Ended_By_Enum>;
  hardCountCompleted?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  startedAt?: InputMaybe<Scalars['timestamptz']>;
  supervisorProvider?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Supervisor_Provider_Term_Sum_Fields = {
  __typename?: 'supervisor_provider_term_sum_fields';
  hardCountCompleted?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "supervisor_provider_term" */
export type Supervisor_Provider_Term_Sum_Order_By = {
  hardCountCompleted?: InputMaybe<Order_By>;
};

/** update columns of table "supervisor_provider_term" */
export enum Supervisor_Provider_Term_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndedAt = 'endedAt',
  /** column name */
  EndedBy = 'endedBy',
  /** column name */
  HardCountCompleted = 'hardCountCompleted',
  /** column name */
  Id = 'id',
  /** column name */
  StartedAt = 'startedAt',
  /** column name */
  SupervisorProvider = 'supervisorProvider',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Supervisor_Provider_Term_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supervisor_Provider_Term_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supervisor_Provider_Term_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supervisor_Provider_Term_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supervisor_Provider_Term_Var_Pop_Fields = {
  __typename?: 'supervisor_provider_term_var_pop_fields';
  hardCountCompleted?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "supervisor_provider_term" */
export type Supervisor_Provider_Term_Var_Pop_Order_By = {
  hardCountCompleted?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Supervisor_Provider_Term_Var_Samp_Fields = {
  __typename?: 'supervisor_provider_term_var_samp_fields';
  hardCountCompleted?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "supervisor_provider_term" */
export type Supervisor_Provider_Term_Var_Samp_Order_By = {
  hardCountCompleted?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Supervisor_Provider_Term_Variance_Fields = {
  __typename?: 'supervisor_provider_term_variance_fields';
  hardCountCompleted?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "supervisor_provider_term" */
export type Supervisor_Provider_Term_Variance_Order_By = {
  hardCountCompleted?: InputMaybe<Order_By>;
};

/** update columns of table "supervisor_provider" */
export enum Supervisor_Provider_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  HardCount = 'hardCount',
  /** column name */
  Id = 'id',
  /** column name */
  InitiatedBy = 'initiatedBy',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderEmail = 'providerEmail',
  /** column name */
  ProviderFirstName = 'providerFirstName',
  /** column name */
  ProviderLastName = 'providerLastName',
  /** column name */
  SamplingPercentage = 'samplingPercentage',
  /** column name */
  SamplingPeriod = 'samplingPeriod',
  /** column name */
  Supervisor = 'supervisor',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Supervisor_Provider_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supervisor_Provider_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supervisor_Provider_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supervisor_Provider_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supervisor_Provider_Var_Pop_Fields = {
  __typename?: 'supervisor_provider_var_pop_fields';
  hardCount?: Maybe<Scalars['Float']>;
  samplingPercentage?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "supervisor_provider" */
export type Supervisor_Provider_Var_Pop_Order_By = {
  hardCount?: InputMaybe<Order_By>;
  samplingPercentage?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Supervisor_Provider_Var_Samp_Fields = {
  __typename?: 'supervisor_provider_var_samp_fields';
  hardCount?: Maybe<Scalars['Float']>;
  samplingPercentage?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "supervisor_provider" */
export type Supervisor_Provider_Var_Samp_Order_By = {
  hardCount?: InputMaybe<Order_By>;
  samplingPercentage?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Supervisor_Provider_Variance_Fields = {
  __typename?: 'supervisor_provider_variance_fields';
  hardCount?: Maybe<Scalars['Float']>;
  samplingPercentage?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "supervisor_provider" */
export type Supervisor_Provider_Variance_Order_By = {
  hardCount?: InputMaybe<Order_By>;
  samplingPercentage?: InputMaybe<Order_By>;
};

/** columns and relationships of "supervisor_review_queue_item" */
export type Supervisor_Review_Queue_Item = {
  __typename?: 'supervisor_review_queue_item';
  createdAt: Scalars['timestamptz'];
  ehrEncounter: Scalars['uuid'];
  /** An object relationship */
  ehrEncounterByEhrEncounter: Ehr_Encounter;
  id: Scalars['uuid'];
  samplingPeriod?: Maybe<Supervisor_Sampling_Period_Type_Enum>;
  source: Supervisor_Review_Queue_Source_Enum;
  status: Supervisor_Review_Queue_Status_Enum;
  /** Set by trigger on every write to status. The same trigger also appends a row to supervisor_review_queue_item_status_history. Not exposed for GraphQL writes — write to status; this and the history row follow. */
  statusChangedAt: Scalars['timestamptz'];
  /** An array relationship */
  statusHistory: Array<Supervisor_Review_Queue_Item_Status_History>;
  /** An aggregate relationship */
  statusHistory_aggregate: Supervisor_Review_Queue_Item_Status_History_Aggregate;
  supervisorProvider: Scalars['uuid'];
  /** An object relationship */
  supervisorProviderBySupervisorProvider: Supervisor_Provider;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "supervisor_review_queue_item" */
export type Supervisor_Review_Queue_ItemStatusHistoryArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Item_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Item_Status_History_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Bool_Exp>;
};


/** columns and relationships of "supervisor_review_queue_item" */
export type Supervisor_Review_Queue_ItemStatusHistory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Review_Queue_Item_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Review_Queue_Item_Status_History_Order_By>>;
  where?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Bool_Exp>;
};

/** aggregated selection of "supervisor_review_queue_item" */
export type Supervisor_Review_Queue_Item_Aggregate = {
  __typename?: 'supervisor_review_queue_item_aggregate';
  aggregate?: Maybe<Supervisor_Review_Queue_Item_Aggregate_Fields>;
  nodes: Array<Supervisor_Review_Queue_Item>;
};

export type Supervisor_Review_Queue_Item_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supervisor_Review_Queue_Item_Aggregate_Bool_Exp_Count>;
};

export type Supervisor_Review_Queue_Item_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supervisor_Review_Queue_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Supervisor_Review_Queue_Item_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supervisor_review_queue_item" */
export type Supervisor_Review_Queue_Item_Aggregate_Fields = {
  __typename?: 'supervisor_review_queue_item_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Supervisor_Review_Queue_Item_Max_Fields>;
  min?: Maybe<Supervisor_Review_Queue_Item_Min_Fields>;
};


/** aggregate fields of "supervisor_review_queue_item" */
export type Supervisor_Review_Queue_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supervisor_Review_Queue_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "supervisor_review_queue_item" */
export type Supervisor_Review_Queue_Item_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supervisor_Review_Queue_Item_Max_Order_By>;
  min?: InputMaybe<Supervisor_Review_Queue_Item_Min_Order_By>;
};

/** input type for inserting array relation for remote table "supervisor_review_queue_item" */
export type Supervisor_Review_Queue_Item_Arr_Rel_Insert_Input = {
  data: Array<Supervisor_Review_Queue_Item_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supervisor_Review_Queue_Item_On_Conflict>;
};

/** Boolean expression to filter rows from the table "supervisor_review_queue_item". All fields are combined with a logical 'AND'. */
export type Supervisor_Review_Queue_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Supervisor_Review_Queue_Item_Bool_Exp>>;
  _not?: InputMaybe<Supervisor_Review_Queue_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Supervisor_Review_Queue_Item_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrEncounter?: InputMaybe<Uuid_Comparison_Exp>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  samplingPeriod?: InputMaybe<Supervisor_Sampling_Period_Type_Enum_Comparison_Exp>;
  source?: InputMaybe<Supervisor_Review_Queue_Source_Enum_Comparison_Exp>;
  status?: InputMaybe<Supervisor_Review_Queue_Status_Enum_Comparison_Exp>;
  statusChangedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  statusHistory?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Bool_Exp>;
  statusHistory_aggregate?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Aggregate_Bool_Exp>;
  supervisorProvider?: InputMaybe<Uuid_Comparison_Exp>;
  supervisorProviderBySupervisorProvider?: InputMaybe<Supervisor_Provider_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "supervisor_review_queue_item" */
export enum Supervisor_Review_Queue_Item_Constraint {
  /** unique or primary key constraint on columns "id" */
  SupervisorReviewQueueItemPkey = 'supervisor_review_queue_item_pkey',
  /** unique or primary key constraint on columns "supervisor_provider", "ehr_encounter" */
  UniqueQueueItem = 'unique_queue_item'
}

/** input type for inserting data into table "supervisor_review_queue_item" */
export type Supervisor_Review_Queue_Item_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  ehrEncounter?: InputMaybe<Scalars['uuid']>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  samplingPeriod?: InputMaybe<Supervisor_Sampling_Period_Type_Enum>;
  source?: InputMaybe<Supervisor_Review_Queue_Source_Enum>;
  status?: InputMaybe<Supervisor_Review_Queue_Status_Enum>;
  /** Set by trigger on every write to status. The same trigger also appends a row to supervisor_review_queue_item_status_history. Not exposed for GraphQL writes — write to status; this and the history row follow. */
  statusChangedAt?: InputMaybe<Scalars['timestamptz']>;
  statusHistory?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Arr_Rel_Insert_Input>;
  supervisorProvider?: InputMaybe<Scalars['uuid']>;
  supervisorProviderBySupervisorProvider?: InputMaybe<Supervisor_Provider_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Supervisor_Review_Queue_Item_Max_Fields = {
  __typename?: 'supervisor_review_queue_item_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  ehrEncounter?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Set by trigger on every write to status. The same trigger also appends a row to supervisor_review_queue_item_status_history. Not exposed for GraphQL writes — write to status; this and the history row follow. */
  statusChangedAt?: Maybe<Scalars['timestamptz']>;
  supervisorProvider?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "supervisor_review_queue_item" */
export type Supervisor_Review_Queue_Item_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  ehrEncounter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Set by trigger on every write to status. The same trigger also appends a row to supervisor_review_queue_item_status_history. Not exposed for GraphQL writes — write to status; this and the history row follow. */
  statusChangedAt?: InputMaybe<Order_By>;
  supervisorProvider?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supervisor_Review_Queue_Item_Min_Fields = {
  __typename?: 'supervisor_review_queue_item_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  ehrEncounter?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Set by trigger on every write to status. The same trigger also appends a row to supervisor_review_queue_item_status_history. Not exposed for GraphQL writes — write to status; this and the history row follow. */
  statusChangedAt?: Maybe<Scalars['timestamptz']>;
  supervisorProvider?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "supervisor_review_queue_item" */
export type Supervisor_Review_Queue_Item_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  ehrEncounter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Set by trigger on every write to status. The same trigger also appends a row to supervisor_review_queue_item_status_history. Not exposed for GraphQL writes — write to status; this and the history row follow. */
  statusChangedAt?: InputMaybe<Order_By>;
  supervisorProvider?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supervisor_review_queue_item" */
export type Supervisor_Review_Queue_Item_Mutation_Response = {
  __typename?: 'supervisor_review_queue_item_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Supervisor_Review_Queue_Item>;
};

/** input type for inserting object relation for remote table "supervisor_review_queue_item" */
export type Supervisor_Review_Queue_Item_Obj_Rel_Insert_Input = {
  data: Supervisor_Review_Queue_Item_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supervisor_Review_Queue_Item_On_Conflict>;
};

/** on_conflict condition type for table "supervisor_review_queue_item" */
export type Supervisor_Review_Queue_Item_On_Conflict = {
  constraint: Supervisor_Review_Queue_Item_Constraint;
  update_columns?: Array<Supervisor_Review_Queue_Item_Update_Column>;
  where?: InputMaybe<Supervisor_Review_Queue_Item_Bool_Exp>;
};

/** Ordering options when selecting data from "supervisor_review_queue_item". */
export type Supervisor_Review_Queue_Item_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  ehrEncounter?: InputMaybe<Order_By>;
  ehrEncounterByEhrEncounter?: InputMaybe<Ehr_Encounter_Order_By>;
  id?: InputMaybe<Order_By>;
  samplingPeriod?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  statusChangedAt?: InputMaybe<Order_By>;
  statusHistory_aggregate?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Aggregate_Order_By>;
  supervisorProvider?: InputMaybe<Order_By>;
  supervisorProviderBySupervisorProvider?: InputMaybe<Supervisor_Provider_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supervisor_review_queue_item */
export type Supervisor_Review_Queue_Item_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "supervisor_review_queue_item" */
export enum Supervisor_Review_Queue_Item_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EhrEncounter = 'ehrEncounter',
  /** column name */
  Id = 'id',
  /** column name */
  SamplingPeriod = 'samplingPeriod',
  /** column name */
  Source = 'source',
  /** column name */
  Status = 'status',
  /** column name */
  StatusChangedAt = 'statusChangedAt',
  /** column name */
  SupervisorProvider = 'supervisorProvider',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "supervisor_review_queue_item" */
export type Supervisor_Review_Queue_Item_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  ehrEncounter?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  samplingPeriod?: InputMaybe<Supervisor_Sampling_Period_Type_Enum>;
  source?: InputMaybe<Supervisor_Review_Queue_Source_Enum>;
  status?: InputMaybe<Supervisor_Review_Queue_Status_Enum>;
  /** Set by trigger on every write to status. The same trigger also appends a row to supervisor_review_queue_item_status_history. Not exposed for GraphQL writes — write to status; this and the history row follow. */
  statusChangedAt?: InputMaybe<Scalars['timestamptz']>;
  supervisorProvider?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "supervisor_review_queue_item_status_history" */
export type Supervisor_Review_Queue_Item_Status_History = {
  __typename?: 'supervisor_review_queue_item_status_history';
  changedByUserId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  fromStatus?: Maybe<Supervisor_Review_Queue_Status_Enum>;
  id: Scalars['uuid'];
  queueItem: Scalars['uuid'];
  /** An object relationship */
  supervisorReviewQueueItemByQueueItem: Supervisor_Review_Queue_Item;
  /** An object relationship */
  supervisorReviewQueueStatusByFromStatus?: Maybe<Supervisor_Review_Queue_Status>;
  /** An object relationship */
  supervisorReviewQueueStatusByToStatus: Supervisor_Review_Queue_Status;
  toStatus: Supervisor_Review_Queue_Status_Enum;
  /** An object relationship */
  userByChangedByUserId?: Maybe<User>;
};

/** aggregated selection of "supervisor_review_queue_item_status_history" */
export type Supervisor_Review_Queue_Item_Status_History_Aggregate = {
  __typename?: 'supervisor_review_queue_item_status_history_aggregate';
  aggregate?: Maybe<Supervisor_Review_Queue_Item_Status_History_Aggregate_Fields>;
  nodes: Array<Supervisor_Review_Queue_Item_Status_History>;
};

export type Supervisor_Review_Queue_Item_Status_History_Aggregate_Bool_Exp = {
  count?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Aggregate_Bool_Exp_Count>;
};

export type Supervisor_Review_Queue_Item_Status_History_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Supervisor_Review_Queue_Item_Status_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "supervisor_review_queue_item_status_history" */
export type Supervisor_Review_Queue_Item_Status_History_Aggregate_Fields = {
  __typename?: 'supervisor_review_queue_item_status_history_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Supervisor_Review_Queue_Item_Status_History_Max_Fields>;
  min?: Maybe<Supervisor_Review_Queue_Item_Status_History_Min_Fields>;
};


/** aggregate fields of "supervisor_review_queue_item_status_history" */
export type Supervisor_Review_Queue_Item_Status_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supervisor_Review_Queue_Item_Status_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "supervisor_review_queue_item_status_history" */
export type Supervisor_Review_Queue_Item_Status_History_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Max_Order_By>;
  min?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Min_Order_By>;
};

/** input type for inserting array relation for remote table "supervisor_review_queue_item_status_history" */
export type Supervisor_Review_Queue_Item_Status_History_Arr_Rel_Insert_Input = {
  data: Array<Supervisor_Review_Queue_Item_Status_History_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_On_Conflict>;
};

/** Boolean expression to filter rows from the table "supervisor_review_queue_item_status_history". All fields are combined with a logical 'AND'. */
export type Supervisor_Review_Queue_Item_Status_History_Bool_Exp = {
  _and?: InputMaybe<Array<Supervisor_Review_Queue_Item_Status_History_Bool_Exp>>;
  _not?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Bool_Exp>;
  _or?: InputMaybe<Array<Supervisor_Review_Queue_Item_Status_History_Bool_Exp>>;
  changedByUserId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  fromStatus?: InputMaybe<Supervisor_Review_Queue_Status_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  queueItem?: InputMaybe<Uuid_Comparison_Exp>;
  supervisorReviewQueueItemByQueueItem?: InputMaybe<Supervisor_Review_Queue_Item_Bool_Exp>;
  supervisorReviewQueueStatusByFromStatus?: InputMaybe<Supervisor_Review_Queue_Status_Bool_Exp>;
  supervisorReviewQueueStatusByToStatus?: InputMaybe<Supervisor_Review_Queue_Status_Bool_Exp>;
  toStatus?: InputMaybe<Supervisor_Review_Queue_Status_Enum_Comparison_Exp>;
  userByChangedByUserId?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "supervisor_review_queue_item_status_history" */
export enum Supervisor_Review_Queue_Item_Status_History_Constraint {
  /** unique or primary key constraint on columns "id" */
  SupervisorReviewQueueItemStatusHistoryPkey = 'supervisor_review_queue_item_status_history_pkey'
}

/** input type for inserting data into table "supervisor_review_queue_item_status_history" */
export type Supervisor_Review_Queue_Item_Status_History_Insert_Input = {
  changedByUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fromStatus?: InputMaybe<Supervisor_Review_Queue_Status_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  queueItem?: InputMaybe<Scalars['uuid']>;
  supervisorReviewQueueItemByQueueItem?: InputMaybe<Supervisor_Review_Queue_Item_Obj_Rel_Insert_Input>;
  supervisorReviewQueueStatusByFromStatus?: InputMaybe<Supervisor_Review_Queue_Status_Obj_Rel_Insert_Input>;
  supervisorReviewQueueStatusByToStatus?: InputMaybe<Supervisor_Review_Queue_Status_Obj_Rel_Insert_Input>;
  toStatus?: InputMaybe<Supervisor_Review_Queue_Status_Enum>;
  userByChangedByUserId?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Supervisor_Review_Queue_Item_Status_History_Max_Fields = {
  __typename?: 'supervisor_review_queue_item_status_history_max_fields';
  changedByUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  queueItem?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "supervisor_review_queue_item_status_history" */
export type Supervisor_Review_Queue_Item_Status_History_Max_Order_By = {
  changedByUserId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  queueItem?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Supervisor_Review_Queue_Item_Status_History_Min_Fields = {
  __typename?: 'supervisor_review_queue_item_status_history_min_fields';
  changedByUserId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  queueItem?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "supervisor_review_queue_item_status_history" */
export type Supervisor_Review_Queue_Item_Status_History_Min_Order_By = {
  changedByUserId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  queueItem?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "supervisor_review_queue_item_status_history" */
export type Supervisor_Review_Queue_Item_Status_History_Mutation_Response = {
  __typename?: 'supervisor_review_queue_item_status_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Supervisor_Review_Queue_Item_Status_History>;
};

/** on_conflict condition type for table "supervisor_review_queue_item_status_history" */
export type Supervisor_Review_Queue_Item_Status_History_On_Conflict = {
  constraint: Supervisor_Review_Queue_Item_Status_History_Constraint;
  update_columns?: Array<Supervisor_Review_Queue_Item_Status_History_Update_Column>;
  where?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Bool_Exp>;
};

/** Ordering options when selecting data from "supervisor_review_queue_item_status_history". */
export type Supervisor_Review_Queue_Item_Status_History_Order_By = {
  changedByUserId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fromStatus?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  queueItem?: InputMaybe<Order_By>;
  supervisorReviewQueueItemByQueueItem?: InputMaybe<Supervisor_Review_Queue_Item_Order_By>;
  supervisorReviewQueueStatusByFromStatus?: InputMaybe<Supervisor_Review_Queue_Status_Order_By>;
  supervisorReviewQueueStatusByToStatus?: InputMaybe<Supervisor_Review_Queue_Status_Order_By>;
  toStatus?: InputMaybe<Order_By>;
  userByChangedByUserId?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: supervisor_review_queue_item_status_history */
export type Supervisor_Review_Queue_Item_Status_History_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "supervisor_review_queue_item_status_history" */
export enum Supervisor_Review_Queue_Item_Status_History_Select_Column {
  /** column name */
  ChangedByUserId = 'changedByUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FromStatus = 'fromStatus',
  /** column name */
  Id = 'id',
  /** column name */
  QueueItem = 'queueItem',
  /** column name */
  ToStatus = 'toStatus'
}

/** input type for updating data in table "supervisor_review_queue_item_status_history" */
export type Supervisor_Review_Queue_Item_Status_History_Set_Input = {
  changedByUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fromStatus?: InputMaybe<Supervisor_Review_Queue_Status_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  queueItem?: InputMaybe<Scalars['uuid']>;
  toStatus?: InputMaybe<Supervisor_Review_Queue_Status_Enum>;
};

/** Streaming cursor of the table "supervisor_review_queue_item_status_history" */
export type Supervisor_Review_Queue_Item_Status_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supervisor_Review_Queue_Item_Status_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supervisor_Review_Queue_Item_Status_History_Stream_Cursor_Value_Input = {
  changedByUserId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fromStatus?: InputMaybe<Supervisor_Review_Queue_Status_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  queueItem?: InputMaybe<Scalars['uuid']>;
  toStatus?: InputMaybe<Supervisor_Review_Queue_Status_Enum>;
};

/** update columns of table "supervisor_review_queue_item_status_history" */
export enum Supervisor_Review_Queue_Item_Status_History_Update_Column {
  /** column name */
  ChangedByUserId = 'changedByUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FromStatus = 'fromStatus',
  /** column name */
  Id = 'id',
  /** column name */
  QueueItem = 'queueItem',
  /** column name */
  ToStatus = 'toStatus'
}

export type Supervisor_Review_Queue_Item_Status_History_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supervisor_Review_Queue_Item_Status_History_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supervisor_Review_Queue_Item_Status_History_Bool_Exp;
};

/** Streaming cursor of the table "supervisor_review_queue_item" */
export type Supervisor_Review_Queue_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supervisor_Review_Queue_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supervisor_Review_Queue_Item_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  ehrEncounter?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  samplingPeriod?: InputMaybe<Supervisor_Sampling_Period_Type_Enum>;
  source?: InputMaybe<Supervisor_Review_Queue_Source_Enum>;
  status?: InputMaybe<Supervisor_Review_Queue_Status_Enum>;
  /** Set by trigger on every write to status. The same trigger also appends a row to supervisor_review_queue_item_status_history. Not exposed for GraphQL writes — write to status; this and the history row follow. */
  statusChangedAt?: InputMaybe<Scalars['timestamptz']>;
  supervisorProvider?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "supervisor_review_queue_item" */
export enum Supervisor_Review_Queue_Item_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EhrEncounter = 'ehrEncounter',
  /** column name */
  Id = 'id',
  /** column name */
  SamplingPeriod = 'samplingPeriod',
  /** column name */
  Source = 'source',
  /** column name */
  Status = 'status',
  /** column name */
  StatusChangedAt = 'statusChangedAt',
  /** column name */
  SupervisorProvider = 'supervisorProvider',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Supervisor_Review_Queue_Item_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supervisor_Review_Queue_Item_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supervisor_Review_Queue_Item_Bool_Exp;
};

/** columns and relationships of "supervisor_review_queue_source" */
export type Supervisor_Review_Queue_Source = {
  __typename?: 'supervisor_review_queue_source';
  name: Scalars['String'];
};

/** aggregated selection of "supervisor_review_queue_source" */
export type Supervisor_Review_Queue_Source_Aggregate = {
  __typename?: 'supervisor_review_queue_source_aggregate';
  aggregate?: Maybe<Supervisor_Review_Queue_Source_Aggregate_Fields>;
  nodes: Array<Supervisor_Review_Queue_Source>;
};

/** aggregate fields of "supervisor_review_queue_source" */
export type Supervisor_Review_Queue_Source_Aggregate_Fields = {
  __typename?: 'supervisor_review_queue_source_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Supervisor_Review_Queue_Source_Max_Fields>;
  min?: Maybe<Supervisor_Review_Queue_Source_Min_Fields>;
};


/** aggregate fields of "supervisor_review_queue_source" */
export type Supervisor_Review_Queue_Source_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supervisor_Review_Queue_Source_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "supervisor_review_queue_source". All fields are combined with a logical 'AND'. */
export type Supervisor_Review_Queue_Source_Bool_Exp = {
  _and?: InputMaybe<Array<Supervisor_Review_Queue_Source_Bool_Exp>>;
  _not?: InputMaybe<Supervisor_Review_Queue_Source_Bool_Exp>;
  _or?: InputMaybe<Array<Supervisor_Review_Queue_Source_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supervisor_review_queue_source" */
export enum Supervisor_Review_Queue_Source_Constraint {
  /** unique or primary key constraint on columns "name" */
  SupervisorReviewQueueSourcePkey = 'supervisor_review_queue_source_pkey'
}

export enum Supervisor_Review_Queue_Source_Enum {
  AdverseEvent = 'ADVERSE_EVENT',
  HardCount = 'HARD_COUNT',
  Sampling = 'SAMPLING'
}

/** Boolean expression to compare columns of type "supervisor_review_queue_source_enum". All fields are combined with logical 'AND'. */
export type Supervisor_Review_Queue_Source_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Supervisor_Review_Queue_Source_Enum>;
  _in?: InputMaybe<Array<Supervisor_Review_Queue_Source_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Supervisor_Review_Queue_Source_Enum>;
  _nin?: InputMaybe<Array<Supervisor_Review_Queue_Source_Enum>>;
};

/** input type for inserting data into table "supervisor_review_queue_source" */
export type Supervisor_Review_Queue_Source_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Supervisor_Review_Queue_Source_Max_Fields = {
  __typename?: 'supervisor_review_queue_source_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Supervisor_Review_Queue_Source_Min_Fields = {
  __typename?: 'supervisor_review_queue_source_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "supervisor_review_queue_source" */
export type Supervisor_Review_Queue_Source_Mutation_Response = {
  __typename?: 'supervisor_review_queue_source_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Supervisor_Review_Queue_Source>;
};

/** on_conflict condition type for table "supervisor_review_queue_source" */
export type Supervisor_Review_Queue_Source_On_Conflict = {
  constraint: Supervisor_Review_Queue_Source_Constraint;
  update_columns?: Array<Supervisor_Review_Queue_Source_Update_Column>;
  where?: InputMaybe<Supervisor_Review_Queue_Source_Bool_Exp>;
};

/** Ordering options when selecting data from "supervisor_review_queue_source". */
export type Supervisor_Review_Queue_Source_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supervisor_review_queue_source */
export type Supervisor_Review_Queue_Source_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "supervisor_review_queue_source" */
export enum Supervisor_Review_Queue_Source_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "supervisor_review_queue_source" */
export type Supervisor_Review_Queue_Source_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "supervisor_review_queue_source" */
export type Supervisor_Review_Queue_Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supervisor_Review_Queue_Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supervisor_Review_Queue_Source_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "supervisor_review_queue_source" */
export enum Supervisor_Review_Queue_Source_Update_Column {
  /** column name */
  Name = 'name'
}

export type Supervisor_Review_Queue_Source_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supervisor_Review_Queue_Source_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supervisor_Review_Queue_Source_Bool_Exp;
};

/** columns and relationships of "supervisor_review_queue_status" */
export type Supervisor_Review_Queue_Status = {
  __typename?: 'supervisor_review_queue_status';
  name: Scalars['String'];
};

/** aggregated selection of "supervisor_review_queue_status" */
export type Supervisor_Review_Queue_Status_Aggregate = {
  __typename?: 'supervisor_review_queue_status_aggregate';
  aggregate?: Maybe<Supervisor_Review_Queue_Status_Aggregate_Fields>;
  nodes: Array<Supervisor_Review_Queue_Status>;
};

/** aggregate fields of "supervisor_review_queue_status" */
export type Supervisor_Review_Queue_Status_Aggregate_Fields = {
  __typename?: 'supervisor_review_queue_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Supervisor_Review_Queue_Status_Max_Fields>;
  min?: Maybe<Supervisor_Review_Queue_Status_Min_Fields>;
};


/** aggregate fields of "supervisor_review_queue_status" */
export type Supervisor_Review_Queue_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supervisor_Review_Queue_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "supervisor_review_queue_status". All fields are combined with a logical 'AND'. */
export type Supervisor_Review_Queue_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Supervisor_Review_Queue_Status_Bool_Exp>>;
  _not?: InputMaybe<Supervisor_Review_Queue_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Supervisor_Review_Queue_Status_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supervisor_review_queue_status" */
export enum Supervisor_Review_Queue_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  SupervisorReviewQueueStatusPkey = 'supervisor_review_queue_status_pkey'
}

export enum Supervisor_Review_Queue_Status_Enum {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** Boolean expression to compare columns of type "supervisor_review_queue_status_enum". All fields are combined with logical 'AND'. */
export type Supervisor_Review_Queue_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Supervisor_Review_Queue_Status_Enum>;
  _in?: InputMaybe<Array<Supervisor_Review_Queue_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Supervisor_Review_Queue_Status_Enum>;
  _nin?: InputMaybe<Array<Supervisor_Review_Queue_Status_Enum>>;
};

/** input type for inserting data into table "supervisor_review_queue_status" */
export type Supervisor_Review_Queue_Status_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Supervisor_Review_Queue_Status_Max_Fields = {
  __typename?: 'supervisor_review_queue_status_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Supervisor_Review_Queue_Status_Min_Fields = {
  __typename?: 'supervisor_review_queue_status_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "supervisor_review_queue_status" */
export type Supervisor_Review_Queue_Status_Mutation_Response = {
  __typename?: 'supervisor_review_queue_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Supervisor_Review_Queue_Status>;
};

/** input type for inserting object relation for remote table "supervisor_review_queue_status" */
export type Supervisor_Review_Queue_Status_Obj_Rel_Insert_Input = {
  data: Supervisor_Review_Queue_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supervisor_Review_Queue_Status_On_Conflict>;
};

/** on_conflict condition type for table "supervisor_review_queue_status" */
export type Supervisor_Review_Queue_Status_On_Conflict = {
  constraint: Supervisor_Review_Queue_Status_Constraint;
  update_columns?: Array<Supervisor_Review_Queue_Status_Update_Column>;
  where?: InputMaybe<Supervisor_Review_Queue_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "supervisor_review_queue_status". */
export type Supervisor_Review_Queue_Status_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supervisor_review_queue_status */
export type Supervisor_Review_Queue_Status_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "supervisor_review_queue_status" */
export enum Supervisor_Review_Queue_Status_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "supervisor_review_queue_status" */
export type Supervisor_Review_Queue_Status_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "supervisor_review_queue_status" */
export type Supervisor_Review_Queue_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supervisor_Review_Queue_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supervisor_Review_Queue_Status_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "supervisor_review_queue_status" */
export enum Supervisor_Review_Queue_Status_Update_Column {
  /** column name */
  Name = 'name'
}

export type Supervisor_Review_Queue_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supervisor_Review_Queue_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supervisor_Review_Queue_Status_Bool_Exp;
};

/** columns and relationships of "supervisor_sampling_period_type" */
export type Supervisor_Sampling_Period_Type = {
  __typename?: 'supervisor_sampling_period_type';
  name: Scalars['String'];
};

/** aggregated selection of "supervisor_sampling_period_type" */
export type Supervisor_Sampling_Period_Type_Aggregate = {
  __typename?: 'supervisor_sampling_period_type_aggregate';
  aggregate?: Maybe<Supervisor_Sampling_Period_Type_Aggregate_Fields>;
  nodes: Array<Supervisor_Sampling_Period_Type>;
};

/** aggregate fields of "supervisor_sampling_period_type" */
export type Supervisor_Sampling_Period_Type_Aggregate_Fields = {
  __typename?: 'supervisor_sampling_period_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Supervisor_Sampling_Period_Type_Max_Fields>;
  min?: Maybe<Supervisor_Sampling_Period_Type_Min_Fields>;
};


/** aggregate fields of "supervisor_sampling_period_type" */
export type Supervisor_Sampling_Period_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supervisor_Sampling_Period_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "supervisor_sampling_period_type". All fields are combined with a logical 'AND'. */
export type Supervisor_Sampling_Period_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Supervisor_Sampling_Period_Type_Bool_Exp>>;
  _not?: InputMaybe<Supervisor_Sampling_Period_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Supervisor_Sampling_Period_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "supervisor_sampling_period_type" */
export enum Supervisor_Sampling_Period_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  SupervisorSamplingPeriodTypePkey = 'supervisor_sampling_period_type_pkey'
}

export enum Supervisor_Sampling_Period_Type_Enum {
  Month = 'MONTH',
  Quarter = 'QUARTER'
}

/** Boolean expression to compare columns of type "supervisor_sampling_period_type_enum". All fields are combined with logical 'AND'. */
export type Supervisor_Sampling_Period_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Supervisor_Sampling_Period_Type_Enum>;
  _in?: InputMaybe<Array<Supervisor_Sampling_Period_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Supervisor_Sampling_Period_Type_Enum>;
  _nin?: InputMaybe<Array<Supervisor_Sampling_Period_Type_Enum>>;
};

/** input type for inserting data into table "supervisor_sampling_period_type" */
export type Supervisor_Sampling_Period_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Supervisor_Sampling_Period_Type_Max_Fields = {
  __typename?: 'supervisor_sampling_period_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Supervisor_Sampling_Period_Type_Min_Fields = {
  __typename?: 'supervisor_sampling_period_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "supervisor_sampling_period_type" */
export type Supervisor_Sampling_Period_Type_Mutation_Response = {
  __typename?: 'supervisor_sampling_period_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Supervisor_Sampling_Period_Type>;
};

/** on_conflict condition type for table "supervisor_sampling_period_type" */
export type Supervisor_Sampling_Period_Type_On_Conflict = {
  constraint: Supervisor_Sampling_Period_Type_Constraint;
  update_columns?: Array<Supervisor_Sampling_Period_Type_Update_Column>;
  where?: InputMaybe<Supervisor_Sampling_Period_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "supervisor_sampling_period_type". */
export type Supervisor_Sampling_Period_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: supervisor_sampling_period_type */
export type Supervisor_Sampling_Period_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "supervisor_sampling_period_type" */
export enum Supervisor_Sampling_Period_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "supervisor_sampling_period_type" */
export type Supervisor_Sampling_Period_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "supervisor_sampling_period_type" */
export type Supervisor_Sampling_Period_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supervisor_Sampling_Period_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supervisor_Sampling_Period_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "supervisor_sampling_period_type" */
export enum Supervisor_Sampling_Period_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Supervisor_Sampling_Period_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supervisor_Sampling_Period_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supervisor_Sampling_Period_Type_Bool_Exp;
};

/** columns and relationships of "supervisor_setting" */
export type Supervisor_Setting = {
  __typename?: 'supervisor_setting';
  createdAt: Scalars['timestamptz'];
  hardCount: Scalars['Int'];
  id: Scalars['uuid'];
  samplingPercentage: Scalars['Int'];
  samplingPeriod: Supervisor_Sampling_Period_Type_Enum;
  supervisor: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  userBySupervisor: User;
};

/** aggregated selection of "supervisor_setting" */
export type Supervisor_Setting_Aggregate = {
  __typename?: 'supervisor_setting_aggregate';
  aggregate?: Maybe<Supervisor_Setting_Aggregate_Fields>;
  nodes: Array<Supervisor_Setting>;
};

/** aggregate fields of "supervisor_setting" */
export type Supervisor_Setting_Aggregate_Fields = {
  __typename?: 'supervisor_setting_aggregate_fields';
  avg?: Maybe<Supervisor_Setting_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Supervisor_Setting_Max_Fields>;
  min?: Maybe<Supervisor_Setting_Min_Fields>;
  stddev?: Maybe<Supervisor_Setting_Stddev_Fields>;
  stddev_pop?: Maybe<Supervisor_Setting_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Supervisor_Setting_Stddev_Samp_Fields>;
  sum?: Maybe<Supervisor_Setting_Sum_Fields>;
  var_pop?: Maybe<Supervisor_Setting_Var_Pop_Fields>;
  var_samp?: Maybe<Supervisor_Setting_Var_Samp_Fields>;
  variance?: Maybe<Supervisor_Setting_Variance_Fields>;
};


/** aggregate fields of "supervisor_setting" */
export type Supervisor_Setting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Supervisor_Setting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Supervisor_Setting_Avg_Fields = {
  __typename?: 'supervisor_setting_avg_fields';
  hardCount?: Maybe<Scalars['Float']>;
  samplingPercentage?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "supervisor_setting". All fields are combined with a logical 'AND'. */
export type Supervisor_Setting_Bool_Exp = {
  _and?: InputMaybe<Array<Supervisor_Setting_Bool_Exp>>;
  _not?: InputMaybe<Supervisor_Setting_Bool_Exp>;
  _or?: InputMaybe<Array<Supervisor_Setting_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  hardCount?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  samplingPercentage?: InputMaybe<Int_Comparison_Exp>;
  samplingPeriod?: InputMaybe<Supervisor_Sampling_Period_Type_Enum_Comparison_Exp>;
  supervisor?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userBySupervisor?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "supervisor_setting" */
export enum Supervisor_Setting_Constraint {
  /** unique or primary key constraint on columns "id" */
  SupervisorSettingPkey = 'supervisor_setting_pkey',
  /** unique or primary key constraint on columns "supervisor" */
  SupervisorSettingSupervisorKey = 'supervisor_setting_supervisor_key'
}

/** input type for incrementing numeric columns in table "supervisor_setting" */
export type Supervisor_Setting_Inc_Input = {
  hardCount?: InputMaybe<Scalars['Int']>;
  samplingPercentage?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "supervisor_setting" */
export type Supervisor_Setting_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  hardCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  samplingPercentage?: InputMaybe<Scalars['Int']>;
  samplingPeriod?: InputMaybe<Supervisor_Sampling_Period_Type_Enum>;
  supervisor?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userBySupervisor?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Supervisor_Setting_Max_Fields = {
  __typename?: 'supervisor_setting_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  hardCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  samplingPercentage?: Maybe<Scalars['Int']>;
  supervisor?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Supervisor_Setting_Min_Fields = {
  __typename?: 'supervisor_setting_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  hardCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  samplingPercentage?: Maybe<Scalars['Int']>;
  supervisor?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "supervisor_setting" */
export type Supervisor_Setting_Mutation_Response = {
  __typename?: 'supervisor_setting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Supervisor_Setting>;
};

/** input type for inserting object relation for remote table "supervisor_setting" */
export type Supervisor_Setting_Obj_Rel_Insert_Input = {
  data: Supervisor_Setting_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Supervisor_Setting_On_Conflict>;
};

/** on_conflict condition type for table "supervisor_setting" */
export type Supervisor_Setting_On_Conflict = {
  constraint: Supervisor_Setting_Constraint;
  update_columns?: Array<Supervisor_Setting_Update_Column>;
  where?: InputMaybe<Supervisor_Setting_Bool_Exp>;
};

/** Ordering options when selecting data from "supervisor_setting". */
export type Supervisor_Setting_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  hardCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  samplingPercentage?: InputMaybe<Order_By>;
  samplingPeriod?: InputMaybe<Order_By>;
  supervisor?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userBySupervisor?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: supervisor_setting */
export type Supervisor_Setting_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "supervisor_setting" */
export enum Supervisor_Setting_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  HardCount = 'hardCount',
  /** column name */
  Id = 'id',
  /** column name */
  SamplingPercentage = 'samplingPercentage',
  /** column name */
  SamplingPeriod = 'samplingPeriod',
  /** column name */
  Supervisor = 'supervisor',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "supervisor_setting" */
export type Supervisor_Setting_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  hardCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  samplingPercentage?: InputMaybe<Scalars['Int']>;
  samplingPeriod?: InputMaybe<Supervisor_Sampling_Period_Type_Enum>;
  supervisor?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Supervisor_Setting_Stddev_Fields = {
  __typename?: 'supervisor_setting_stddev_fields';
  hardCount?: Maybe<Scalars['Float']>;
  samplingPercentage?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Supervisor_Setting_Stddev_Pop_Fields = {
  __typename?: 'supervisor_setting_stddev_pop_fields';
  hardCount?: Maybe<Scalars['Float']>;
  samplingPercentage?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Supervisor_Setting_Stddev_Samp_Fields = {
  __typename?: 'supervisor_setting_stddev_samp_fields';
  hardCount?: Maybe<Scalars['Float']>;
  samplingPercentage?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "supervisor_setting" */
export type Supervisor_Setting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Supervisor_Setting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Supervisor_Setting_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  hardCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  samplingPercentage?: InputMaybe<Scalars['Int']>;
  samplingPeriod?: InputMaybe<Supervisor_Sampling_Period_Type_Enum>;
  supervisor?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Supervisor_Setting_Sum_Fields = {
  __typename?: 'supervisor_setting_sum_fields';
  hardCount?: Maybe<Scalars['Int']>;
  samplingPercentage?: Maybe<Scalars['Int']>;
};

/** update columns of table "supervisor_setting" */
export enum Supervisor_Setting_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  HardCount = 'hardCount',
  /** column name */
  Id = 'id',
  /** column name */
  SamplingPercentage = 'samplingPercentage',
  /** column name */
  SamplingPeriod = 'samplingPeriod',
  /** column name */
  Supervisor = 'supervisor',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Supervisor_Setting_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Supervisor_Setting_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Supervisor_Setting_Set_Input>;
  /** filter the rows which have to be updated */
  where: Supervisor_Setting_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Supervisor_Setting_Var_Pop_Fields = {
  __typename?: 'supervisor_setting_var_pop_fields';
  hardCount?: Maybe<Scalars['Float']>;
  samplingPercentage?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Supervisor_Setting_Var_Samp_Fields = {
  __typename?: 'supervisor_setting_var_samp_fields';
  hardCount?: Maybe<Scalars['Float']>;
  samplingPercentage?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Supervisor_Setting_Variance_Fields = {
  __typename?: 'supervisor_setting_variance_fields';
  hardCount?: Maybe<Scalars['Float']>;
  samplingPercentage?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "tax_rate" */
export type Tax_Rate = {
  __typename?: 'tax_rate';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  name: Scalars['String'];
  rate: Scalars['numeric'];
  stripeId?: Maybe<Scalars['String']>;
  /** An object relationship */
  tax_type: Tax_Type;
  type: Tax_Type_Enum;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "tax_rate" */
export type Tax_Rate_Aggregate = {
  __typename?: 'tax_rate_aggregate';
  aggregate?: Maybe<Tax_Rate_Aggregate_Fields>;
  nodes: Array<Tax_Rate>;
};

export type Tax_Rate_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tax_Rate_Aggregate_Bool_Exp_Count>;
};

export type Tax_Rate_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tax_Rate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Tax_Rate_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tax_rate" */
export type Tax_Rate_Aggregate_Fields = {
  __typename?: 'tax_rate_aggregate_fields';
  avg?: Maybe<Tax_Rate_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Tax_Rate_Max_Fields>;
  min?: Maybe<Tax_Rate_Min_Fields>;
  stddev?: Maybe<Tax_Rate_Stddev_Fields>;
  stddev_pop?: Maybe<Tax_Rate_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tax_Rate_Stddev_Samp_Fields>;
  sum?: Maybe<Tax_Rate_Sum_Fields>;
  var_pop?: Maybe<Tax_Rate_Var_Pop_Fields>;
  var_samp?: Maybe<Tax_Rate_Var_Samp_Fields>;
  variance?: Maybe<Tax_Rate_Variance_Fields>;
};


/** aggregate fields of "tax_rate" */
export type Tax_Rate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tax_Rate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tax_rate" */
export type Tax_Rate_Aggregate_Order_By = {
  avg?: InputMaybe<Tax_Rate_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tax_Rate_Max_Order_By>;
  min?: InputMaybe<Tax_Rate_Min_Order_By>;
  stddev?: InputMaybe<Tax_Rate_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tax_Rate_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tax_Rate_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tax_Rate_Sum_Order_By>;
  var_pop?: InputMaybe<Tax_Rate_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tax_Rate_Var_Samp_Order_By>;
  variance?: InputMaybe<Tax_Rate_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tax_rate" */
export type Tax_Rate_Arr_Rel_Insert_Input = {
  data: Array<Tax_Rate_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tax_Rate_On_Conflict>;
};

/** aggregate avg on columns */
export type Tax_Rate_Avg_Fields = {
  __typename?: 'tax_rate_avg_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "tax_rate" */
export type Tax_Rate_Avg_Order_By = {
  rate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tax_rate". All fields are combined with a logical 'AND'. */
export type Tax_Rate_Bool_Exp = {
  _and?: InputMaybe<Array<Tax_Rate_Bool_Exp>>;
  _not?: InputMaybe<Tax_Rate_Bool_Exp>;
  _or?: InputMaybe<Array<Tax_Rate_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  rate?: InputMaybe<Numeric_Comparison_Exp>;
  stripeId?: InputMaybe<String_Comparison_Exp>;
  tax_type?: InputMaybe<Tax_Type_Bool_Exp>;
  type?: InputMaybe<Tax_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "tax_rate" */
export enum Tax_Rate_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaxRatePkey = 'tax_rate_pkey',
  /** unique or primary key constraint on columns "stripe_id" */
  TaxRateStripeIdKey = 'tax_rate_stripe_id_key',
  /** unique or primary key constraint on columns "type", "location" */
  TaxRateUniqueType = 'tax_rate_unique_type'
}

/** input type for incrementing numeric columns in table "tax_rate" */
export type Tax_Rate_Inc_Input = {
  rate?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "tax_rate" */
export type Tax_Rate_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['numeric']>;
  stripeId?: InputMaybe<Scalars['String']>;
  tax_type?: InputMaybe<Tax_Type_Obj_Rel_Insert_Input>;
  type?: InputMaybe<Tax_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Tax_Rate_Max_Fields = {
  __typename?: 'tax_rate_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['numeric']>;
  stripeId?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "tax_rate" */
export type Tax_Rate_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  stripeId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tax_Rate_Min_Fields = {
  __typename?: 'tax_rate_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['numeric']>;
  stripeId?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "tax_rate" */
export type Tax_Rate_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  stripeId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tax_rate" */
export type Tax_Rate_Mutation_Response = {
  __typename?: 'tax_rate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tax_Rate>;
};

/** input type for inserting object relation for remote table "tax_rate" */
export type Tax_Rate_Obj_Rel_Insert_Input = {
  data: Tax_Rate_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tax_Rate_On_Conflict>;
};

/** on_conflict condition type for table "tax_rate" */
export type Tax_Rate_On_Conflict = {
  constraint: Tax_Rate_Constraint;
  update_columns?: Array<Tax_Rate_Update_Column>;
  where?: InputMaybe<Tax_Rate_Bool_Exp>;
};

/** Ordering options when selecting data from "tax_rate". */
export type Tax_Rate_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  name?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  stripeId?: InputMaybe<Order_By>;
  tax_type?: InputMaybe<Tax_Type_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tax_rate */
export type Tax_Rate_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "tax_rate" */
export enum Tax_Rate_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Rate = 'rate',
  /** column name */
  StripeId = 'stripeId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "tax_rate" */
export type Tax_Rate_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['numeric']>;
  stripeId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Tax_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Tax_Rate_Stddev_Fields = {
  __typename?: 'tax_rate_stddev_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "tax_rate" */
export type Tax_Rate_Stddev_Order_By = {
  rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tax_Rate_Stddev_Pop_Fields = {
  __typename?: 'tax_rate_stddev_pop_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "tax_rate" */
export type Tax_Rate_Stddev_Pop_Order_By = {
  rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tax_Rate_Stddev_Samp_Fields = {
  __typename?: 'tax_rate_stddev_samp_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "tax_rate" */
export type Tax_Rate_Stddev_Samp_Order_By = {
  rate?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tax_rate" */
export type Tax_Rate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tax_Rate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tax_Rate_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['numeric']>;
  stripeId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Tax_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Tax_Rate_Sum_Fields = {
  __typename?: 'tax_rate_sum_fields';
  rate?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "tax_rate" */
export type Tax_Rate_Sum_Order_By = {
  rate?: InputMaybe<Order_By>;
};

/** update columns of table "tax_rate" */
export enum Tax_Rate_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Rate = 'rate',
  /** column name */
  StripeId = 'stripeId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Tax_Rate_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tax_Rate_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tax_Rate_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tax_Rate_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tax_Rate_Var_Pop_Fields = {
  __typename?: 'tax_rate_var_pop_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "tax_rate" */
export type Tax_Rate_Var_Pop_Order_By = {
  rate?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tax_Rate_Var_Samp_Fields = {
  __typename?: 'tax_rate_var_samp_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "tax_rate" */
export type Tax_Rate_Var_Samp_Order_By = {
  rate?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tax_Rate_Variance_Fields = {
  __typename?: 'tax_rate_variance_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "tax_rate" */
export type Tax_Rate_Variance_Order_By = {
  rate?: InputMaybe<Order_By>;
};

/** columns and relationships of "tax_type" */
export type Tax_Type = {
  __typename?: 'tax_type';
  id: Scalars['String'];
};

/** aggregated selection of "tax_type" */
export type Tax_Type_Aggregate = {
  __typename?: 'tax_type_aggregate';
  aggregate?: Maybe<Tax_Type_Aggregate_Fields>;
  nodes: Array<Tax_Type>;
};

/** aggregate fields of "tax_type" */
export type Tax_Type_Aggregate_Fields = {
  __typename?: 'tax_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Tax_Type_Max_Fields>;
  min?: Maybe<Tax_Type_Min_Fields>;
};


/** aggregate fields of "tax_type" */
export type Tax_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tax_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "tax_type". All fields are combined with a logical 'AND'. */
export type Tax_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Tax_Type_Bool_Exp>>;
  _not?: InputMaybe<Tax_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Tax_Type_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tax_type" */
export enum Tax_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaxTypePkey = 'tax_type_pkey'
}

export enum Tax_Type_Enum {
  Model = 'Model',
  NonTaxable = 'Non_taxable',
  Other = 'Other',
  Product = 'Product',
  Services = 'Services'
}

/** Boolean expression to compare columns of type "tax_type_enum". All fields are combined with logical 'AND'. */
export type Tax_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Tax_Type_Enum>;
  _in?: InputMaybe<Array<Tax_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Tax_Type_Enum>;
  _nin?: InputMaybe<Array<Tax_Type_Enum>>;
};

/** input type for inserting data into table "tax_type" */
export type Tax_Type_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Tax_Type_Max_Fields = {
  __typename?: 'tax_type_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Tax_Type_Min_Fields = {
  __typename?: 'tax_type_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "tax_type" */
export type Tax_Type_Mutation_Response = {
  __typename?: 'tax_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tax_Type>;
};

/** input type for inserting object relation for remote table "tax_type" */
export type Tax_Type_Obj_Rel_Insert_Input = {
  data: Tax_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tax_Type_On_Conflict>;
};

/** on_conflict condition type for table "tax_type" */
export type Tax_Type_On_Conflict = {
  constraint: Tax_Type_Constraint;
  update_columns?: Array<Tax_Type_Update_Column>;
  where?: InputMaybe<Tax_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "tax_type". */
export type Tax_Type_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tax_type */
export type Tax_Type_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "tax_type" */
export enum Tax_Type_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "tax_type" */
export type Tax_Type_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "tax_type" */
export type Tax_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tax_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tax_Type_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "tax_type" */
export enum Tax_Type_Update_Column {
  /** column name */
  Id = 'id'
}

export type Tax_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tax_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tax_Type_Bool_Exp;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** Boolean expression to compare columns of type "tstzrange". All fields are combined with logical 'AND'. */
export type Tstzrange_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['tstzrange']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['tstzrange']>>;
  _eq?: InputMaybe<Array<Scalars['tstzrange']>>;
  _gt?: InputMaybe<Array<Scalars['tstzrange']>>;
  _gte?: InputMaybe<Array<Scalars['tstzrange']>>;
  _in?: InputMaybe<Array<Array<Scalars['tstzrange']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['tstzrange']>>;
  _lte?: InputMaybe<Array<Scalars['tstzrange']>>;
  _neq?: InputMaybe<Array<Scalars['tstzrange']>>;
  _nin?: InputMaybe<Array<Array<Scalars['tstzrange']>>>;
};

/** Boolean expression to compare columns of type "tstzrange". All fields are combined with logical 'AND'. */
export type Tstzrange_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['tstzrange']>;
  _gt?: InputMaybe<Scalars['tstzrange']>;
  _gte?: InputMaybe<Scalars['tstzrange']>;
  _in?: InputMaybe<Array<Scalars['tstzrange']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['tstzrange']>;
  _lte?: InputMaybe<Scalars['tstzrange']>;
  _neq?: InputMaybe<Scalars['tstzrange']>;
  _nin?: InputMaybe<Array<Scalars['tstzrange']>>;
};

/** columns and relationships of "user" */
export type User = {
  __typename?: 'user';
  accreditation?: Maybe<Accreditation_Enum>;
  /** An object relationship */
  accreditationByAccreditation?: Maybe<Accreditation>;
  active: Scalars['Boolean'];
  address?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  addressByAddress?: Maybe<Address>;
  /** An array relationship */
  bookingsByProvider: Array<Booking>;
  /** An aggregate relationship */
  bookingsByProvider_aggregate: Booking_Aggregate;
  cognitoUserSub: Scalars['uuid'];
  /** occurred_at of the user's newest self-consent event of the given consentType iff it is GRANTED, else null (never granted, or revoked since). Raises on an unknown consent type so a typo cannot masquerade as no-consent. */
  consentedAt?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  credits: Array<Credit>;
  /** An aggregate relationship */
  credits_aggregate: Credit_Aggregate;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  ehrSubscriptions: Array<Ehr_Subscription>;
  /** An aggregate relationship */
  ehrSubscriptions_aggregate: Ehr_Subscription_Aggregate;
  /** An array relationship */
  events: Array<Event>;
  /** An aggregate relationship */
  events_aggregate: Event_Aggregate;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  lastName?: Maybe<Scalars['String']>;
  licenseExpiration?: Maybe<Scalars['date']>;
  /** This is not currently used by anything. */
  linkminkConversionId?: Maybe<Scalars['String']>;
  linkminkTracker?: Maybe<Scalars['String']>;
  malpracticeExpiration?: Maybe<Scalars['date']>;
  /** This is no longer used, but dropping is a huge pain due Hasura bug until 2.10 https://github.com/hasura/graphql-engine/issues/8415 */
  needsConfirmTwice: Scalars['Boolean'];
  /** An object relationship */
  patientBookingSettingsByProvider?: Maybe<Provider_Patient_Booking_Settings>;
  /** An array relationship */
  patients: Array<Patient>;
  /** An aggregate relationship */
  patients_aggregate: Patient_Aggregate;
  /** An array relationship */
  product_purchases: Array<Product_Purchase>;
  /** An aggregate relationship */
  product_purchases_aggregate: Product_Purchase_Aggregate;
  /** An array relationship */
  provider_hours: Array<Provider_Hours>;
  /** An aggregate relationship */
  provider_hours_aggregate: Provider_Hours_Aggregate;
  role: Role_Enum;
  /** An object relationship */
  roleByRole: Role;
  stripeCustomerId?: Maybe<Scalars['String']>;
  /** An array relationship */
  supervisorProvidersByProvider: Array<Supervisor_Provider>;
  /** An aggregate relationship */
  supervisorProvidersByProvider_aggregate: Supervisor_Provider_Aggregate;
  /** An array relationship */
  supervisorProvidersBySupervisor: Array<Supervisor_Provider>;
  /** An aggregate relationship */
  supervisorProvidersBySupervisor_aggregate: Supervisor_Provider_Aggregate;
  /** An object relationship */
  supervisor_setting?: Maybe<Supervisor_Setting>;
  unsubscribedFromNotifications: Scalars['Boolean'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  userAgreements: Array<User_Agreements>;
  /** An aggregate relationship */
  userAgreements_aggregate: User_Agreements_Aggregate;
  /** An array relationship */
  userLocations: Array<User_Location>;
  /** An aggregate relationship */
  userLocations_aggregate: User_Location_Aggregate;
  /** A computed field, executes function "user_visible_to_supervisor" */
  userVisibleToSupervisor?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  user_documents: Array<User_Document>;
  /** An aggregate relationship */
  user_documents_aggregate: User_Document_Aggregate;
  /** An array relationship */
  user_plans: Array<User_Plan>;
  /** An aggregate relationship */
  user_plans_aggregate: User_Plan_Aggregate;
  /** An array relationship */
  users_unfulfilled_product_purchases_count_by_locations: Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location>;
  /** An aggregate relationship */
  users_unfulfilled_product_purchases_count_by_locations_aggregate: Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Aggregate;
};


/** columns and relationships of "user" */
export type UserBookingsByProviderArgs = {
  distinct_on?: InputMaybe<Array<Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Order_By>>;
  where?: InputMaybe<Booking_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserBookingsByProvider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Order_By>>;
  where?: InputMaybe<Booking_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserConsentedAtArgs = {
  args: ConsentedAt_User_Args;
};


/** columns and relationships of "user" */
export type UserCreditsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Order_By>>;
  where?: InputMaybe<Credit_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCredits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Order_By>>;
  where?: InputMaybe<Credit_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserEhrSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserEhrSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ehr_Subscription_Order_By>>;
  where?: InputMaybe<Ehr_Subscription_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserEventsArgs = {
  distinct_on?: InputMaybe<Array<Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Order_By>>;
  where?: InputMaybe<Event_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Order_By>>;
  where?: InputMaybe<Event_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPatientsArgs = {
  distinct_on?: InputMaybe<Array<Patient_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Order_By>>;
  where?: InputMaybe<Patient_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPatients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Order_By>>;
  where?: InputMaybe<Patient_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserProduct_PurchasesArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchase_Order_By>>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserProduct_Purchases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Purchase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Purchase_Order_By>>;
  where?: InputMaybe<Product_Purchase_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserProvider_HoursArgs = {
  distinct_on?: InputMaybe<Array<Provider_Hours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Hours_Order_By>>;
  where?: InputMaybe<Provider_Hours_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserProvider_Hours_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Hours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Hours_Order_By>>;
  where?: InputMaybe<Provider_Hours_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserSupervisorProvidersByProviderArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserSupervisorProvidersByProvider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserSupervisorProvidersBySupervisorArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserSupervisorProvidersBySupervisor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Supervisor_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Supervisor_Provider_Order_By>>;
  where?: InputMaybe<Supervisor_Provider_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUserAgreementsArgs = {
  distinct_on?: InputMaybe<Array<User_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Agreements_Order_By>>;
  where?: InputMaybe<User_Agreements_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUserAgreements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Agreements_Order_By>>;
  where?: InputMaybe<User_Agreements_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUserLocationsArgs = {
  distinct_on?: InputMaybe<Array<User_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Location_Order_By>>;
  where?: InputMaybe<User_Location_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUserLocations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Location_Order_By>>;
  where?: InputMaybe<User_Location_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Document_Order_By>>;
  where?: InputMaybe<User_Document_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Document_Order_By>>;
  where?: InputMaybe<User_Document_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_PlansArgs = {
  distinct_on?: InputMaybe<Array<User_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Plan_Order_By>>;
  where?: InputMaybe<User_Plan_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Plan_Order_By>>;
  where?: InputMaybe<User_Plan_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUsers_Unfulfilled_Product_Purchases_Count_By_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Order_By>>;
  where?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUsers_Unfulfilled_Product_Purchases_Count_By_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Order_By>>;
  where?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp>;
};

/** aggregated selection of "user" */
export type User_Aggregate = {
  __typename?: 'user_aggregate';
  aggregate?: Maybe<User_Aggregate_Fields>;
  nodes: Array<User>;
};

export type User_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Aggregate_Bool_Exp_Count>;
};

export type User_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Select_Column_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Select_Column_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user" */
export type User_Aggregate_Fields = {
  __typename?: 'user_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Max_Fields>;
  min?: Maybe<User_Min_Fields>;
};


/** aggregate fields of "user" */
export type User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user" */
export type User_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Max_Order_By>;
  min?: InputMaybe<User_Min_Order_By>;
};

/** columns and relationships of "user_agreements" */
export type User_Agreements = {
  __typename?: 'user_agreements';
  /** An object relationship */
  agreement_type: Agreement_Type;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  type: Agreement_Type_Enum;
  updated_at: Scalars['timestamptz'];
  user: Scalars['uuid'];
  /** An object relationship */
  userByUser: User;
  version: Scalars['Int'];
};

/** aggregated selection of "user_agreements" */
export type User_Agreements_Aggregate = {
  __typename?: 'user_agreements_aggregate';
  aggregate?: Maybe<User_Agreements_Aggregate_Fields>;
  nodes: Array<User_Agreements>;
};

export type User_Agreements_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Agreements_Aggregate_Bool_Exp_Count>;
};

export type User_Agreements_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Agreements_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Agreements_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_agreements" */
export type User_Agreements_Aggregate_Fields = {
  __typename?: 'user_agreements_aggregate_fields';
  avg?: Maybe<User_Agreements_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Agreements_Max_Fields>;
  min?: Maybe<User_Agreements_Min_Fields>;
  stddev?: Maybe<User_Agreements_Stddev_Fields>;
  stddev_pop?: Maybe<User_Agreements_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Agreements_Stddev_Samp_Fields>;
  sum?: Maybe<User_Agreements_Sum_Fields>;
  var_pop?: Maybe<User_Agreements_Var_Pop_Fields>;
  var_samp?: Maybe<User_Agreements_Var_Samp_Fields>;
  variance?: Maybe<User_Agreements_Variance_Fields>;
};


/** aggregate fields of "user_agreements" */
export type User_Agreements_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Agreements_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_agreements" */
export type User_Agreements_Aggregate_Order_By = {
  avg?: InputMaybe<User_Agreements_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Agreements_Max_Order_By>;
  min?: InputMaybe<User_Agreements_Min_Order_By>;
  stddev?: InputMaybe<User_Agreements_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Agreements_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Agreements_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Agreements_Sum_Order_By>;
  var_pop?: InputMaybe<User_Agreements_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Agreements_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Agreements_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_agreements" */
export type User_Agreements_Arr_Rel_Insert_Input = {
  data: Array<User_Agreements_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Agreements_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Agreements_Avg_Fields = {
  __typename?: 'user_agreements_avg_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_agreements" */
export type User_Agreements_Avg_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_agreements". All fields are combined with a logical 'AND'. */
export type User_Agreements_Bool_Exp = {
  _and?: InputMaybe<Array<User_Agreements_Bool_Exp>>;
  _not?: InputMaybe<User_Agreements_Bool_Exp>;
  _or?: InputMaybe<Array<User_Agreements_Bool_Exp>>;
  agreement_type?: InputMaybe<Agreement_Type_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Agreement_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Uuid_Comparison_Exp>;
  userByUser?: InputMaybe<User_Bool_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_agreements" */
export enum User_Agreements_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserAgreementsPkey = 'user_agreements_pkey',
  /** unique or primary key constraint on columns "type", "user", "version" */
  UserAgreementsTypeVersionUserKey = 'user_agreements_type_version_user_key'
}

/** input type for incrementing numeric columns in table "user_agreements" */
export type User_Agreements_Inc_Input = {
  version?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_agreements" */
export type User_Agreements_Insert_Input = {
  agreement_type?: InputMaybe<Agreement_Type_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Agreement_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
  userByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Agreements_Max_Fields = {
  __typename?: 'user_agreements_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_agreements" */
export type User_Agreements_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Agreements_Min_Fields = {
  __typename?: 'user_agreements_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_agreements" */
export type User_Agreements_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_agreements" */
export type User_Agreements_Mutation_Response = {
  __typename?: 'user_agreements_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Agreements>;
};

/** on_conflict condition type for table "user_agreements" */
export type User_Agreements_On_Conflict = {
  constraint: User_Agreements_Constraint;
  update_columns?: Array<User_Agreements_Update_Column>;
  where?: InputMaybe<User_Agreements_Bool_Exp>;
};

/** Ordering options when selecting data from "user_agreements". */
export type User_Agreements_Order_By = {
  agreement_type?: InputMaybe<Agreement_Type_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  userByUser?: InputMaybe<User_Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_agreements */
export type User_Agreements_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_agreements" */
export enum User_Agreements_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  User = 'user',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "user_agreements" */
export type User_Agreements_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Agreement_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Agreements_Stddev_Fields = {
  __typename?: 'user_agreements_stddev_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_agreements" */
export type User_Agreements_Stddev_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Agreements_Stddev_Pop_Fields = {
  __typename?: 'user_agreements_stddev_pop_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_agreements" */
export type User_Agreements_Stddev_Pop_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Agreements_Stddev_Samp_Fields = {
  __typename?: 'user_agreements_stddev_samp_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_agreements" */
export type User_Agreements_Stddev_Samp_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_agreements" */
export type User_Agreements_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Agreements_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Agreements_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Agreement_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Agreements_Sum_Fields = {
  __typename?: 'user_agreements_sum_fields';
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_agreements" */
export type User_Agreements_Sum_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** update columns of table "user_agreements" */
export enum User_Agreements_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  User = 'user',
  /** column name */
  Version = 'version'
}

export type User_Agreements_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Agreements_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Agreements_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Agreements_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Agreements_Var_Pop_Fields = {
  __typename?: 'user_agreements_var_pop_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_agreements" */
export type User_Agreements_Var_Pop_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Agreements_Var_Samp_Fields = {
  __typename?: 'user_agreements_var_samp_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_agreements" */
export type User_Agreements_Var_Samp_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Agreements_Variance_Fields = {
  __typename?: 'user_agreements_variance_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_agreements" */
export type User_Agreements_Variance_Order_By = {
  version?: InputMaybe<Order_By>;
};

/** input type for inserting array relation for remote table "user" */
export type User_Arr_Rel_Insert_Input = {
  data: Array<User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  _and?: InputMaybe<Array<User_Bool_Exp>>;
  _not?: InputMaybe<User_Bool_Exp>;
  _or?: InputMaybe<Array<User_Bool_Exp>>;
  accreditation?: InputMaybe<Accreditation_Enum_Comparison_Exp>;
  accreditationByAccreditation?: InputMaybe<Accreditation_Bool_Exp>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  address?: InputMaybe<Uuid_Comparison_Exp>;
  addressByAddress?: InputMaybe<Address_Bool_Exp>;
  bookingsByProvider?: InputMaybe<Booking_Bool_Exp>;
  bookingsByProvider_aggregate?: InputMaybe<Booking_Aggregate_Bool_Exp>;
  cognitoUserSub?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credits?: InputMaybe<Credit_Bool_Exp>;
  credits_aggregate?: InputMaybe<Credit_Aggregate_Bool_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrSubscriptions?: InputMaybe<Ehr_Subscription_Bool_Exp>;
  ehrSubscriptions_aggregate?: InputMaybe<Ehr_Subscription_Aggregate_Bool_Exp>;
  events?: InputMaybe<Event_Bool_Exp>;
  events_aggregate?: InputMaybe<Event_Aggregate_Bool_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  licenseExpiration?: InputMaybe<Date_Comparison_Exp>;
  linkminkConversionId?: InputMaybe<String_Comparison_Exp>;
  linkminkTracker?: InputMaybe<String_Comparison_Exp>;
  malpracticeExpiration?: InputMaybe<Date_Comparison_Exp>;
  needsConfirmTwice?: InputMaybe<Boolean_Comparison_Exp>;
  patientBookingSettingsByProvider?: InputMaybe<Provider_Patient_Booking_Settings_Bool_Exp>;
  patients?: InputMaybe<Patient_Bool_Exp>;
  patients_aggregate?: InputMaybe<Patient_Aggregate_Bool_Exp>;
  product_purchases?: InputMaybe<Product_Purchase_Bool_Exp>;
  product_purchases_aggregate?: InputMaybe<Product_Purchase_Aggregate_Bool_Exp>;
  provider_hours?: InputMaybe<Provider_Hours_Bool_Exp>;
  provider_hours_aggregate?: InputMaybe<Provider_Hours_Aggregate_Bool_Exp>;
  role?: InputMaybe<Role_Enum_Comparison_Exp>;
  roleByRole?: InputMaybe<Role_Bool_Exp>;
  stripeCustomerId?: InputMaybe<String_Comparison_Exp>;
  supervisorProvidersByProvider?: InputMaybe<Supervisor_Provider_Bool_Exp>;
  supervisorProvidersByProvider_aggregate?: InputMaybe<Supervisor_Provider_Aggregate_Bool_Exp>;
  supervisorProvidersBySupervisor?: InputMaybe<Supervisor_Provider_Bool_Exp>;
  supervisorProvidersBySupervisor_aggregate?: InputMaybe<Supervisor_Provider_Aggregate_Bool_Exp>;
  supervisor_setting?: InputMaybe<Supervisor_Setting_Bool_Exp>;
  unsubscribedFromNotifications?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  userAgreements?: InputMaybe<User_Agreements_Bool_Exp>;
  userAgreements_aggregate?: InputMaybe<User_Agreements_Aggregate_Bool_Exp>;
  userLocations?: InputMaybe<User_Location_Bool_Exp>;
  userLocations_aggregate?: InputMaybe<User_Location_Aggregate_Bool_Exp>;
  userVisibleToSupervisor?: InputMaybe<Boolean_Comparison_Exp>;
  user_documents?: InputMaybe<User_Document_Bool_Exp>;
  user_documents_aggregate?: InputMaybe<User_Document_Aggregate_Bool_Exp>;
  user_plans?: InputMaybe<User_Plan_Bool_Exp>;
  user_plans_aggregate?: InputMaybe<User_Plan_Aggregate_Bool_Exp>;
  users_unfulfilled_product_purchases_count_by_locations?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Bool_Exp>;
  users_unfulfilled_product_purchases_count_by_locations_aggregate?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Aggregate_Bool_Exp>;
};

/** Append-only trail of staff-user self-consent events (e.g. AI_PRIVACY). The newest row per ("user", consent_type) is the current state: GRANTED means consent is in force as of occurred_at, REVOKED means withdrawn. Rows are never updated or deleted; renewals and withdrawals append new rows. There is deliberately no recorded_by column: consent is strictly self-service and nobody may record it on another user's behalf (Hasura presets "user" from the session). The unique constraint doubles as the lookup index and a double-submit guard. */
export type User_Consent = {
  __typename?: 'user_consent';
  action: User_Consent_Action_Enum;
  consentType: User_Consent_Type_Enum;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  occurredAt: Scalars['timestamptz'];
  user: Scalars['uuid'];
  /** An object relationship */
  userByUser: User;
};

/** Enum of consent trail event actions. */
export type User_Consent_Action = {
  __typename?: 'user_consent_action';
  id: Scalars['String'];
};

/** aggregated selection of "user_consent_action" */
export type User_Consent_Action_Aggregate = {
  __typename?: 'user_consent_action_aggregate';
  aggregate?: Maybe<User_Consent_Action_Aggregate_Fields>;
  nodes: Array<User_Consent_Action>;
};

/** aggregate fields of "user_consent_action" */
export type User_Consent_Action_Aggregate_Fields = {
  __typename?: 'user_consent_action_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Consent_Action_Max_Fields>;
  min?: Maybe<User_Consent_Action_Min_Fields>;
};


/** aggregate fields of "user_consent_action" */
export type User_Consent_Action_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Consent_Action_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_consent_action". All fields are combined with a logical 'AND'. */
export type User_Consent_Action_Bool_Exp = {
  _and?: InputMaybe<Array<User_Consent_Action_Bool_Exp>>;
  _not?: InputMaybe<User_Consent_Action_Bool_Exp>;
  _or?: InputMaybe<Array<User_Consent_Action_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_consent_action" */
export enum User_Consent_Action_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserConsentActionPkey = 'user_consent_action_pkey'
}

export enum User_Consent_Action_Enum {
  Granted = 'GRANTED',
  Revoked = 'REVOKED'
}

/** Boolean expression to compare columns of type "user_consent_action_enum". All fields are combined with logical 'AND'. */
export type User_Consent_Action_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Consent_Action_Enum>;
  _in?: InputMaybe<Array<User_Consent_Action_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<User_Consent_Action_Enum>;
  _nin?: InputMaybe<Array<User_Consent_Action_Enum>>;
};

/** input type for inserting data into table "user_consent_action" */
export type User_Consent_Action_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Consent_Action_Max_Fields = {
  __typename?: 'user_consent_action_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Consent_Action_Min_Fields = {
  __typename?: 'user_consent_action_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_consent_action" */
export type User_Consent_Action_Mutation_Response = {
  __typename?: 'user_consent_action_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Consent_Action>;
};

/** on_conflict condition type for table "user_consent_action" */
export type User_Consent_Action_On_Conflict = {
  constraint: User_Consent_Action_Constraint;
  update_columns?: Array<User_Consent_Action_Update_Column>;
  where?: InputMaybe<User_Consent_Action_Bool_Exp>;
};

/** Ordering options when selecting data from "user_consent_action". */
export type User_Consent_Action_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_consent_action */
export type User_Consent_Action_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "user_consent_action" */
export enum User_Consent_Action_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "user_consent_action" */
export type User_Consent_Action_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_consent_action" */
export type User_Consent_Action_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Consent_Action_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Consent_Action_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_consent_action" */
export enum User_Consent_Action_Update_Column {
  /** column name */
  Id = 'id'
}

export type User_Consent_Action_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Consent_Action_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Consent_Action_Bool_Exp;
};

/** aggregated selection of "user_consent" */
export type User_Consent_Aggregate = {
  __typename?: 'user_consent_aggregate';
  aggregate?: Maybe<User_Consent_Aggregate_Fields>;
  nodes: Array<User_Consent>;
};

/** aggregate fields of "user_consent" */
export type User_Consent_Aggregate_Fields = {
  __typename?: 'user_consent_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Consent_Max_Fields>;
  min?: Maybe<User_Consent_Min_Fields>;
};


/** aggregate fields of "user_consent" */
export type User_Consent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Consent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_consent". All fields are combined with a logical 'AND'. */
export type User_Consent_Bool_Exp = {
  _and?: InputMaybe<Array<User_Consent_Bool_Exp>>;
  _not?: InputMaybe<User_Consent_Bool_Exp>;
  _or?: InputMaybe<Array<User_Consent_Bool_Exp>>;
  action?: InputMaybe<User_Consent_Action_Enum_Comparison_Exp>;
  consentType?: InputMaybe<User_Consent_Type_Enum_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  occurredAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Uuid_Comparison_Exp>;
  userByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "user_consent" */
export enum User_Consent_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserConsentPkey = 'user_consent_pkey',
  /** unique or primary key constraint on columns "consent_type", "occurred_at", "user" */
  UserConsentUserConsentTypeOccurredAtKey = 'user_consent_user_consent_type_occurred_at_key'
}

/** input type for inserting data into table "user_consent" */
export type User_Consent_Insert_Input = {
  action?: InputMaybe<User_Consent_Action_Enum>;
  consentType?: InputMaybe<User_Consent_Type_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
  userByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Consent_Max_Fields = {
  __typename?: 'user_consent_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type User_Consent_Min_Fields = {
  __typename?: 'user_consent_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_consent" */
export type User_Consent_Mutation_Response = {
  __typename?: 'user_consent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Consent>;
};

/** on_conflict condition type for table "user_consent" */
export type User_Consent_On_Conflict = {
  constraint: User_Consent_Constraint;
  update_columns?: Array<User_Consent_Update_Column>;
  where?: InputMaybe<User_Consent_Bool_Exp>;
};

/** Ordering options when selecting data from "user_consent". */
export type User_Consent_Order_By = {
  action?: InputMaybe<Order_By>;
  consentType?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  occurredAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  userByUser?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: user_consent */
export type User_Consent_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_consent" */
export enum User_Consent_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ConsentType = 'consentType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  OccurredAt = 'occurredAt',
  /** column name */
  User = 'user'
}

/** input type for updating data in table "user_consent" */
export type User_Consent_Set_Input = {
  action?: InputMaybe<User_Consent_Action_Enum>;
  consentType?: InputMaybe<User_Consent_Type_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_consent" */
export type User_Consent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Consent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Consent_Stream_Cursor_Value_Input = {
  action?: InputMaybe<User_Consent_Action_Enum>;
  consentType?: InputMaybe<User_Consent_Type_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** Enum of user consent types tracked in user_consent. */
export type User_Consent_Type = {
  __typename?: 'user_consent_type';
  id: Scalars['String'];
};

/** aggregated selection of "user_consent_type" */
export type User_Consent_Type_Aggregate = {
  __typename?: 'user_consent_type_aggregate';
  aggregate?: Maybe<User_Consent_Type_Aggregate_Fields>;
  nodes: Array<User_Consent_Type>;
};

/** aggregate fields of "user_consent_type" */
export type User_Consent_Type_Aggregate_Fields = {
  __typename?: 'user_consent_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Consent_Type_Max_Fields>;
  min?: Maybe<User_Consent_Type_Min_Fields>;
};


/** aggregate fields of "user_consent_type" */
export type User_Consent_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Consent_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_consent_type". All fields are combined with a logical 'AND'. */
export type User_Consent_Type_Bool_Exp = {
  _and?: InputMaybe<Array<User_Consent_Type_Bool_Exp>>;
  _not?: InputMaybe<User_Consent_Type_Bool_Exp>;
  _or?: InputMaybe<Array<User_Consent_Type_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_consent_type" */
export enum User_Consent_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserConsentTypePkey = 'user_consent_type_pkey'
}

export enum User_Consent_Type_Enum {
  AiPrivacy = 'AI_PRIVACY'
}

/** Boolean expression to compare columns of type "user_consent_type_enum". All fields are combined with logical 'AND'. */
export type User_Consent_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Consent_Type_Enum>;
  _in?: InputMaybe<Array<User_Consent_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<User_Consent_Type_Enum>;
  _nin?: InputMaybe<Array<User_Consent_Type_Enum>>;
};

/** input type for inserting data into table "user_consent_type" */
export type User_Consent_Type_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Consent_Type_Max_Fields = {
  __typename?: 'user_consent_type_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Consent_Type_Min_Fields = {
  __typename?: 'user_consent_type_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_consent_type" */
export type User_Consent_Type_Mutation_Response = {
  __typename?: 'user_consent_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Consent_Type>;
};

/** on_conflict condition type for table "user_consent_type" */
export type User_Consent_Type_On_Conflict = {
  constraint: User_Consent_Type_Constraint;
  update_columns?: Array<User_Consent_Type_Update_Column>;
  where?: InputMaybe<User_Consent_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "user_consent_type". */
export type User_Consent_Type_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_consent_type */
export type User_Consent_Type_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "user_consent_type" */
export enum User_Consent_Type_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "user_consent_type" */
export type User_Consent_Type_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_consent_type" */
export type User_Consent_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Consent_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Consent_Type_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_consent_type" */
export enum User_Consent_Type_Update_Column {
  /** column name */
  Id = 'id'
}

export type User_Consent_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Consent_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Consent_Type_Bool_Exp;
};

/** update columns of table "user_consent" */
export enum User_Consent_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ConsentType = 'consentType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  OccurredAt = 'occurredAt',
  /** column name */
  User = 'user'
}

export type User_Consent_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Consent_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Consent_Bool_Exp;
};

/** unique or primary key constraints on table "user" */
export enum User_Constraint {
  /** unique or primary key constraint on columns "cognito_user_sub" */
  UserCognitoUserSubKey = 'user_cognitoUserSub_key',
  /** unique or primary key constraint on columns "linkmink_conversion_id" */
  UserLinkminkConversionIdKey = 'user_linkmink_conversion_id_key',
  /** unique or primary key constraint on columns "id" */
  UserPkey = 'user_pkey',
  /** unique or primary key constraint on columns "stripe_customer_id" */
  UserStripeCustomerIdKey = 'user_stripe_customer_id_key'
}

/** columns and relationships of "user_device_push_notification_token" */
export type User_Device_Push_Notification_Token = {
  __typename?: 'user_device_push_notification_token';
  token: Scalars['String'];
  user: Scalars['uuid'];
  /** An object relationship */
  userByUser: User;
};

/** aggregated selection of "user_device_push_notification_token" */
export type User_Device_Push_Notification_Token_Aggregate = {
  __typename?: 'user_device_push_notification_token_aggregate';
  aggregate?: Maybe<User_Device_Push_Notification_Token_Aggregate_Fields>;
  nodes: Array<User_Device_Push_Notification_Token>;
};

/** aggregate fields of "user_device_push_notification_token" */
export type User_Device_Push_Notification_Token_Aggregate_Fields = {
  __typename?: 'user_device_push_notification_token_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Device_Push_Notification_Token_Max_Fields>;
  min?: Maybe<User_Device_Push_Notification_Token_Min_Fields>;
};


/** aggregate fields of "user_device_push_notification_token" */
export type User_Device_Push_Notification_Token_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Device_Push_Notification_Token_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_device_push_notification_token". All fields are combined with a logical 'AND'. */
export type User_Device_Push_Notification_Token_Bool_Exp = {
  _and?: InputMaybe<Array<User_Device_Push_Notification_Token_Bool_Exp>>;
  _not?: InputMaybe<User_Device_Push_Notification_Token_Bool_Exp>;
  _or?: InputMaybe<Array<User_Device_Push_Notification_Token_Bool_Exp>>;
  token?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Uuid_Comparison_Exp>;
  userByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "user_device_push_notification_token" */
export enum User_Device_Push_Notification_Token_Constraint {
  /** unique or primary key constraint on columns "user", "token" */
  AppUserPushNotificationTokenPkey = 'app_user_push_notification_token_pkey'
}

/** input type for inserting data into table "user_device_push_notification_token" */
export type User_Device_Push_Notification_Token_Insert_Input = {
  token?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['uuid']>;
  userByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Device_Push_Notification_Token_Max_Fields = {
  __typename?: 'user_device_push_notification_token_max_fields';
  token?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type User_Device_Push_Notification_Token_Min_Fields = {
  __typename?: 'user_device_push_notification_token_min_fields';
  token?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_device_push_notification_token" */
export type User_Device_Push_Notification_Token_Mutation_Response = {
  __typename?: 'user_device_push_notification_token_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Device_Push_Notification_Token>;
};

/** on_conflict condition type for table "user_device_push_notification_token" */
export type User_Device_Push_Notification_Token_On_Conflict = {
  constraint: User_Device_Push_Notification_Token_Constraint;
  update_columns?: Array<User_Device_Push_Notification_Token_Update_Column>;
  where?: InputMaybe<User_Device_Push_Notification_Token_Bool_Exp>;
};

/** Ordering options when selecting data from "user_device_push_notification_token". */
export type User_Device_Push_Notification_Token_Order_By = {
  token?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  userByUser?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: user_device_push_notification_token */
export type User_Device_Push_Notification_Token_Pk_Columns_Input = {
  token: Scalars['String'];
  user: Scalars['uuid'];
};

/** select columns of table "user_device_push_notification_token" */
export enum User_Device_Push_Notification_Token_Select_Column {
  /** column name */
  Token = 'token',
  /** column name */
  User = 'user'
}

/** input type for updating data in table "user_device_push_notification_token" */
export type User_Device_Push_Notification_Token_Set_Input = {
  token?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_device_push_notification_token" */
export type User_Device_Push_Notification_Token_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Device_Push_Notification_Token_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Device_Push_Notification_Token_Stream_Cursor_Value_Input = {
  token?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_device_push_notification_token" */
export enum User_Device_Push_Notification_Token_Update_Column {
  /** column name */
  Token = 'token',
  /** column name */
  User = 'user'
}

export type User_Device_Push_Notification_Token_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Device_Push_Notification_Token_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Device_Push_Notification_Token_Bool_Exp;
};

/** columns and relationships of "user_document" */
export type User_Document = {
  __typename?: 'user_document';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  document_type: Document_Type;
  id: Scalars['uuid'];
  originalName: Scalars['String'];
  s3Name: Scalars['uuid'];
  type: Document_Type_Enum;
  updated_at: Scalars['timestamptz'];
  user: Scalars['uuid'];
  /** An object relationship */
  userByUser: User;
};

/** aggregated selection of "user_document" */
export type User_Document_Aggregate = {
  __typename?: 'user_document_aggregate';
  aggregate?: Maybe<User_Document_Aggregate_Fields>;
  nodes: Array<User_Document>;
};

export type User_Document_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Document_Aggregate_Bool_Exp_Count>;
};

export type User_Document_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Document_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_document" */
export type User_Document_Aggregate_Fields = {
  __typename?: 'user_document_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Document_Max_Fields>;
  min?: Maybe<User_Document_Min_Fields>;
};


/** aggregate fields of "user_document" */
export type User_Document_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_document" */
export type User_Document_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Document_Max_Order_By>;
  min?: InputMaybe<User_Document_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_document" */
export type User_Document_Arr_Rel_Insert_Input = {
  data: Array<User_Document_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Document_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_document". All fields are combined with a logical 'AND'. */
export type User_Document_Bool_Exp = {
  _and?: InputMaybe<Array<User_Document_Bool_Exp>>;
  _not?: InputMaybe<User_Document_Bool_Exp>;
  _or?: InputMaybe<Array<User_Document_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_type?: InputMaybe<Document_Type_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  originalName?: InputMaybe<String_Comparison_Exp>;
  s3Name?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Document_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Uuid_Comparison_Exp>;
  userByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "user_document" */
export enum User_Document_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserDocumentPkey = 'user_document_pkey',
  /** unique or primary key constraint on columns "s3_name" */
  UserDocumentS3NameKey = 'user_document_s3_name_key'
}

/** input type for inserting data into table "user_document" */
export type User_Document_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  document_type?: InputMaybe<Document_Type_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  originalName?: InputMaybe<Scalars['String']>;
  s3Name?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Document_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
  userByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Document_Max_Fields = {
  __typename?: 'user_document_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  originalName?: Maybe<Scalars['String']>;
  s3Name?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_document" */
export type User_Document_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  originalName?: InputMaybe<Order_By>;
  s3Name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Document_Min_Fields = {
  __typename?: 'user_document_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  originalName?: Maybe<Scalars['String']>;
  s3Name?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_document" */
export type User_Document_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  originalName?: InputMaybe<Order_By>;
  s3Name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_document" */
export type User_Document_Mutation_Response = {
  __typename?: 'user_document_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Document>;
};

/** on_conflict condition type for table "user_document" */
export type User_Document_On_Conflict = {
  constraint: User_Document_Constraint;
  update_columns?: Array<User_Document_Update_Column>;
  where?: InputMaybe<User_Document_Bool_Exp>;
};

/** Ordering options when selecting data from "user_document". */
export type User_Document_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Document_Type_Order_By>;
  id?: InputMaybe<Order_By>;
  originalName?: InputMaybe<Order_By>;
  s3Name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  userByUser?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: user_document */
export type User_Document_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_document" */
export enum User_Document_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalName = 'originalName',
  /** column name */
  S3Name = 's3Name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  User = 'user'
}

/** input type for updating data in table "user_document" */
export type User_Document_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalName?: InputMaybe<Scalars['String']>;
  s3Name?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Document_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_document" */
export type User_Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Document_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalName?: InputMaybe<Scalars['String']>;
  s3Name?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Document_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_document" */
export enum User_Document_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OriginalName = 'originalName',
  /** column name */
  S3Name = 's3Name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  User = 'user'
}

export type User_Document_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Document_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Document_Bool_Exp;
};

/** input type for inserting data into table "user" */
export type User_Insert_Input = {
  accreditation?: InputMaybe<Accreditation_Enum>;
  accreditationByAccreditation?: InputMaybe<Accreditation_Obj_Rel_Insert_Input>;
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['uuid']>;
  addressByAddress?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  bookingsByProvider?: InputMaybe<Booking_Arr_Rel_Insert_Input>;
  cognitoUserSub?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credits?: InputMaybe<Credit_Arr_Rel_Insert_Input>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  ehrSubscriptions?: InputMaybe<Ehr_Subscription_Arr_Rel_Insert_Input>;
  events?: InputMaybe<Event_Arr_Rel_Insert_Input>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  licenseExpiration?: InputMaybe<Scalars['date']>;
  /** This is not currently used by anything. */
  linkminkConversionId?: InputMaybe<Scalars['String']>;
  linkminkTracker?: InputMaybe<Scalars['String']>;
  malpracticeExpiration?: InputMaybe<Scalars['date']>;
  /** This is no longer used, but dropping is a huge pain due Hasura bug until 2.10 https://github.com/hasura/graphql-engine/issues/8415 */
  needsConfirmTwice?: InputMaybe<Scalars['Boolean']>;
  patientBookingSettingsByProvider?: InputMaybe<Provider_Patient_Booking_Settings_Obj_Rel_Insert_Input>;
  patients?: InputMaybe<Patient_Arr_Rel_Insert_Input>;
  product_purchases?: InputMaybe<Product_Purchase_Arr_Rel_Insert_Input>;
  provider_hours?: InputMaybe<Provider_Hours_Arr_Rel_Insert_Input>;
  role?: InputMaybe<Role_Enum>;
  roleByRole?: InputMaybe<Role_Obj_Rel_Insert_Input>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  supervisorProvidersByProvider?: InputMaybe<Supervisor_Provider_Arr_Rel_Insert_Input>;
  supervisorProvidersBySupervisor?: InputMaybe<Supervisor_Provider_Arr_Rel_Insert_Input>;
  supervisor_setting?: InputMaybe<Supervisor_Setting_Obj_Rel_Insert_Input>;
  unsubscribedFromNotifications?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userAgreements?: InputMaybe<User_Agreements_Arr_Rel_Insert_Input>;
  userLocations?: InputMaybe<User_Location_Arr_Rel_Insert_Input>;
  user_documents?: InputMaybe<User_Document_Arr_Rel_Insert_Input>;
  user_plans?: InputMaybe<User_Plan_Arr_Rel_Insert_Input>;
  users_unfulfilled_product_purchases_count_by_locations?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "user_location" */
export type User_Location = {
  __typename?: 'user_location';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Not maintained: its value carries no meaning and does not indicate whether EHR is enabled for this provider at this location. That state is the ehr_mode computed field. */
  ehrEnabled: Scalars['Boolean'];
  ehrMode?: Maybe<Scalars['String']>;
  location: Scalars['uuid'];
  /** An object relationship */
  locationByLocation: Location;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user: Scalars['uuid'];
  /** An object relationship */
  userByUser: User;
};

/** aggregated selection of "user_location" */
export type User_Location_Aggregate = {
  __typename?: 'user_location_aggregate';
  aggregate?: Maybe<User_Location_Aggregate_Fields>;
  nodes: Array<User_Location>;
};

export type User_Location_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Location_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Location_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Location_Aggregate_Bool_Exp_Count>;
};

export type User_Location_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Location_Select_Column_User_Location_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Location_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Location_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Location_Select_Column_User_Location_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Location_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Location_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Location_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_location" */
export type User_Location_Aggregate_Fields = {
  __typename?: 'user_location_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Location_Max_Fields>;
  min?: Maybe<User_Location_Min_Fields>;
};


/** aggregate fields of "user_location" */
export type User_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_location" */
export type User_Location_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Location_Max_Order_By>;
  min?: InputMaybe<User_Location_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_location" */
export type User_Location_Arr_Rel_Insert_Input = {
  data: Array<User_Location_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Location_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_location". All fields are combined with a logical 'AND'. */
export type User_Location_Bool_Exp = {
  _and?: InputMaybe<Array<User_Location_Bool_Exp>>;
  _not?: InputMaybe<User_Location_Bool_Exp>;
  _or?: InputMaybe<Array<User_Location_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ehrEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  ehrMode?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<Uuid_Comparison_Exp>;
  locationByLocation?: InputMaybe<Location_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Uuid_Comparison_Exp>;
  userByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "user_location" */
export enum User_Location_Constraint {
  /** unique or primary key constraint on columns "user", "location" */
  UserOfficePkey = 'user_office_pkey'
}

/** input type for inserting data into table "user_location" */
export type User_Location_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** Not maintained: its value carries no meaning and does not indicate whether EHR is enabled for this provider at this location. That state is the ehr_mode computed field. */
  ehrEnabled?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['uuid']>;
  locationByLocation?: InputMaybe<Location_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
  userByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Location_Max_Fields = {
  __typename?: 'user_location_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  ehrMode?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_location" */
export type User_Location_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Location_Min_Fields = {
  __typename?: 'user_location_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  ehrMode?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_location" */
export type User_Location_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_location" */
export type User_Location_Mutation_Response = {
  __typename?: 'user_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Location>;
};

/** on_conflict condition type for table "user_location" */
export type User_Location_On_Conflict = {
  constraint: User_Location_Constraint;
  update_columns?: Array<User_Location_Update_Column>;
  where?: InputMaybe<User_Location_Bool_Exp>;
};

/** Ordering options when selecting data from "user_location". */
export type User_Location_Order_By = {
  created_at?: InputMaybe<Order_By>;
  ehrEnabled?: InputMaybe<Order_By>;
  ehrMode?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  locationByLocation?: InputMaybe<Location_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  userByUser?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: user_location */
export type User_Location_Pk_Columns_Input = {
  location: Scalars['uuid'];
  user: Scalars['uuid'];
};

/** select columns of table "user_location" */
export enum User_Location_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EhrEnabled = 'ehrEnabled',
  /** column name */
  Location = 'location',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  User = 'user'
}

/** select "user_location_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_location" */
export enum User_Location_Select_Column_User_Location_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  EhrEnabled = 'ehrEnabled'
}

/** select "user_location_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_location" */
export enum User_Location_Select_Column_User_Location_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  EhrEnabled = 'ehrEnabled'
}

/** input type for updating data in table "user_location" */
export type User_Location_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** Not maintained: its value carries no meaning and does not indicate whether EHR is enabled for this provider at this location. That state is the ehr_mode computed field. */
  ehrEnabled?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_location" */
export type User_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Location_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** Not maintained: its value carries no meaning and does not indicate whether EHR is enabled for this provider at this location. That state is the ehr_mode computed field. */
  ehrEnabled?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_location" */
export enum User_Location_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EhrEnabled = 'ehrEnabled',
  /** column name */
  Location = 'location',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  User = 'user'
}

export type User_Location_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Location_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Location_Bool_Exp;
};

/** aggregate max on columns */
export type User_Max_Fields = {
  __typename?: 'user_max_fields';
  address?: Maybe<Scalars['uuid']>;
  cognitoUserSub?: Maybe<Scalars['uuid']>;
  /** occurred_at of the user's newest self-consent event of the given consentType iff it is GRANTED, else null (never granted, or revoked since). Raises on an unknown consent type so a typo cannot masquerade as no-consent. */
  consentedAt?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  licenseExpiration?: Maybe<Scalars['date']>;
  /** This is not currently used by anything. */
  linkminkConversionId?: Maybe<Scalars['String']>;
  linkminkTracker?: Maybe<Scalars['String']>;
  malpracticeExpiration?: Maybe<Scalars['date']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** aggregate max on columns */
export type User_Max_FieldsConsentedAtArgs = {
  args: ConsentedAt_User_Args;
};

/** order by max() on columns of table "user" */
export type User_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  cognitoUserSub?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  licenseExpiration?: InputMaybe<Order_By>;
  /** This is not currently used by anything. */
  linkminkConversionId?: InputMaybe<Order_By>;
  linkminkTracker?: InputMaybe<Order_By>;
  malpracticeExpiration?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Min_Fields = {
  __typename?: 'user_min_fields';
  address?: Maybe<Scalars['uuid']>;
  cognitoUserSub?: Maybe<Scalars['uuid']>;
  /** occurred_at of the user's newest self-consent event of the given consentType iff it is GRANTED, else null (never granted, or revoked since). Raises on an unknown consent type so a typo cannot masquerade as no-consent. */
  consentedAt?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  licenseExpiration?: Maybe<Scalars['date']>;
  /** This is not currently used by anything. */
  linkminkConversionId?: Maybe<Scalars['String']>;
  linkminkTracker?: Maybe<Scalars['String']>;
  malpracticeExpiration?: Maybe<Scalars['date']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** aggregate min on columns */
export type User_Min_FieldsConsentedAtArgs = {
  args: ConsentedAt_User_Args;
};

/** order by min() on columns of table "user" */
export type User_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  cognitoUserSub?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  licenseExpiration?: InputMaybe<Order_By>;
  /** This is not currently used by anything. */
  linkminkConversionId?: InputMaybe<Order_By>;
  linkminkTracker?: InputMaybe<Order_By>;
  malpracticeExpiration?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user" */
export type User_Mutation_Response = {
  __typename?: 'user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** input type for inserting object relation for remote table "user" */
export type User_Obj_Rel_Insert_Input = {
  data: User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** on_conflict condition type for table "user" */
export type User_On_Conflict = {
  constraint: User_Constraint;
  update_columns?: Array<User_Update_Column>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** Ordering options when selecting data from "user". */
export type User_Order_By = {
  accreditation?: InputMaybe<Order_By>;
  accreditationByAccreditation?: InputMaybe<Accreditation_Order_By>;
  active?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  addressByAddress?: InputMaybe<Address_Order_By>;
  bookingsByProvider_aggregate?: InputMaybe<Booking_Aggregate_Order_By>;
  cognitoUserSub?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credits_aggregate?: InputMaybe<Credit_Aggregate_Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  ehrSubscriptions_aggregate?: InputMaybe<Ehr_Subscription_Aggregate_Order_By>;
  events_aggregate?: InputMaybe<Event_Aggregate_Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  licenseExpiration?: InputMaybe<Order_By>;
  linkminkConversionId?: InputMaybe<Order_By>;
  linkminkTracker?: InputMaybe<Order_By>;
  malpracticeExpiration?: InputMaybe<Order_By>;
  needsConfirmTwice?: InputMaybe<Order_By>;
  patientBookingSettingsByProvider?: InputMaybe<Provider_Patient_Booking_Settings_Order_By>;
  patients_aggregate?: InputMaybe<Patient_Aggregate_Order_By>;
  product_purchases_aggregate?: InputMaybe<Product_Purchase_Aggregate_Order_By>;
  provider_hours_aggregate?: InputMaybe<Provider_Hours_Aggregate_Order_By>;
  role?: InputMaybe<Order_By>;
  roleByRole?: InputMaybe<Role_Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  supervisorProvidersByProvider_aggregate?: InputMaybe<Supervisor_Provider_Aggregate_Order_By>;
  supervisorProvidersBySupervisor_aggregate?: InputMaybe<Supervisor_Provider_Aggregate_Order_By>;
  supervisor_setting?: InputMaybe<Supervisor_Setting_Order_By>;
  unsubscribedFromNotifications?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userAgreements_aggregate?: InputMaybe<User_Agreements_Aggregate_Order_By>;
  userLocations_aggregate?: InputMaybe<User_Location_Aggregate_Order_By>;
  userVisibleToSupervisor?: InputMaybe<Order_By>;
  user_documents_aggregate?: InputMaybe<User_Document_Aggregate_Order_By>;
  user_plans_aggregate?: InputMaybe<User_Plan_Aggregate_Order_By>;
  users_unfulfilled_product_purchases_count_by_locations_aggregate?: InputMaybe<Fn_Users_Unfulfilled_Product_Purchases_Count_By_Location_Aggregate_Order_By>;
};

/** primary key columns input for table: user */
export type User_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "user_plan" */
export type User_Plan = {
  __typename?: 'user_plan';
  annual: Scalars['Boolean'];
  /** set by trigger */
  annualizedAt?: Maybe<Scalars['timestamptz']>;
  /** Probably remove - no real meaning since we prorate refunds now */
  benefitsEndAt?: Maybe<Scalars['timestamptz']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  plan: Scalars['uuid'];
  /** An object relationship */
  planByPlan: Plan;
  stripeId: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  user: Scalars['uuid'];
  /** An object relationship */
  userByUser: User;
};

/** aggregated selection of "user_plan" */
export type User_Plan_Aggregate = {
  __typename?: 'user_plan_aggregate';
  aggregate?: Maybe<User_Plan_Aggregate_Fields>;
  nodes: Array<User_Plan>;
};

export type User_Plan_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Plan_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Plan_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Plan_Aggregate_Bool_Exp_Count>;
};

export type User_Plan_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Plan_Select_Column_User_Plan_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Plan_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Plan_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Plan_Select_Column_User_Plan_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Plan_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Plan_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Plan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Plan_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_plan" */
export type User_Plan_Aggregate_Fields = {
  __typename?: 'user_plan_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Plan_Max_Fields>;
  min?: Maybe<User_Plan_Min_Fields>;
};


/** aggregate fields of "user_plan" */
export type User_Plan_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Plan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_plan" */
export type User_Plan_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Plan_Max_Order_By>;
  min?: InputMaybe<User_Plan_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_plan" */
export type User_Plan_Arr_Rel_Insert_Input = {
  data: Array<User_Plan_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Plan_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_plan". All fields are combined with a logical 'AND'. */
export type User_Plan_Bool_Exp = {
  _and?: InputMaybe<Array<User_Plan_Bool_Exp>>;
  _not?: InputMaybe<User_Plan_Bool_Exp>;
  _or?: InputMaybe<Array<User_Plan_Bool_Exp>>;
  annual?: InputMaybe<Boolean_Comparison_Exp>;
  annualizedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  benefitsEndAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  canceledAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  plan?: InputMaybe<Uuid_Comparison_Exp>;
  planByPlan?: InputMaybe<Plan_Bool_Exp>;
  stripeId?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Uuid_Comparison_Exp>;
  userByUser?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "user_plan" */
export enum User_Plan_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserPlanPkey = 'user_plan_pkey'
}

/** input type for inserting data into table "user_plan" */
export type User_Plan_Insert_Input = {
  annual?: InputMaybe<Scalars['Boolean']>;
  /** set by trigger */
  annualizedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Probably remove - no real meaning since we prorate refunds now */
  benefitsEndAt?: InputMaybe<Scalars['timestamptz']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  plan?: InputMaybe<Scalars['uuid']>;
  planByPlan?: InputMaybe<Plan_Obj_Rel_Insert_Input>;
  stripeId?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
  userByUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Plan_Max_Fields = {
  __typename?: 'user_plan_max_fields';
  /** set by trigger */
  annualizedAt?: Maybe<Scalars['timestamptz']>;
  /** Probably remove - no real meaning since we prorate refunds now */
  benefitsEndAt?: Maybe<Scalars['timestamptz']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  plan?: Maybe<Scalars['uuid']>;
  stripeId?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_plan" */
export type User_Plan_Max_Order_By = {
  /** set by trigger */
  annualizedAt?: InputMaybe<Order_By>;
  /** Probably remove - no real meaning since we prorate refunds now */
  benefitsEndAt?: InputMaybe<Order_By>;
  canceledAt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  stripeId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Plan_Min_Fields = {
  __typename?: 'user_plan_min_fields';
  /** set by trigger */
  annualizedAt?: Maybe<Scalars['timestamptz']>;
  /** Probably remove - no real meaning since we prorate refunds now */
  benefitsEndAt?: Maybe<Scalars['timestamptz']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  plan?: Maybe<Scalars['uuid']>;
  stripeId?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_plan" */
export type User_Plan_Min_Order_By = {
  /** set by trigger */
  annualizedAt?: InputMaybe<Order_By>;
  /** Probably remove - no real meaning since we prorate refunds now */
  benefitsEndAt?: InputMaybe<Order_By>;
  canceledAt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  stripeId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_plan" */
export type User_Plan_Mutation_Response = {
  __typename?: 'user_plan_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Plan>;
};

/** on_conflict condition type for table "user_plan" */
export type User_Plan_On_Conflict = {
  constraint: User_Plan_Constraint;
  update_columns?: Array<User_Plan_Update_Column>;
  where?: InputMaybe<User_Plan_Bool_Exp>;
};

/** Ordering options when selecting data from "user_plan". */
export type User_Plan_Order_By = {
  annual?: InputMaybe<Order_By>;
  annualizedAt?: InputMaybe<Order_By>;
  benefitsEndAt?: InputMaybe<Order_By>;
  canceledAt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  planByPlan?: InputMaybe<Plan_Order_By>;
  stripeId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  userByUser?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: user_plan */
export type User_Plan_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_plan" */
export enum User_Plan_Select_Column {
  /** column name */
  Annual = 'annual',
  /** column name */
  AnnualizedAt = 'annualizedAt',
  /** column name */
  BenefitsEndAt = 'benefitsEndAt',
  /** column name */
  CanceledAt = 'canceledAt',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Plan = 'plan',
  /** column name */
  StripeId = 'stripeId',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  User = 'user'
}

/** select "user_plan_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_plan" */
export enum User_Plan_Select_Column_User_Plan_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Annual = 'annual'
}

/** select "user_plan_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_plan" */
export enum User_Plan_Select_Column_User_Plan_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Annual = 'annual'
}

/** input type for updating data in table "user_plan" */
export type User_Plan_Set_Input = {
  annual?: InputMaybe<Scalars['Boolean']>;
  /** set by trigger */
  annualizedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Probably remove - no real meaning since we prorate refunds now */
  benefitsEndAt?: InputMaybe<Scalars['timestamptz']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  plan?: InputMaybe<Scalars['uuid']>;
  stripeId?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_plan" */
export type User_Plan_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Plan_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Plan_Stream_Cursor_Value_Input = {
  annual?: InputMaybe<Scalars['Boolean']>;
  /** set by trigger */
  annualizedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Probably remove - no real meaning since we prorate refunds now */
  benefitsEndAt?: InputMaybe<Scalars['timestamptz']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  plan?: InputMaybe<Scalars['uuid']>;
  stripeId?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_plan" */
export enum User_Plan_Update_Column {
  /** column name */
  Annual = 'annual',
  /** column name */
  AnnualizedAt = 'annualizedAt',
  /** column name */
  BenefitsEndAt = 'benefitsEndAt',
  /** column name */
  CanceledAt = 'canceledAt',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Plan = 'plan',
  /** column name */
  StripeId = 'stripeId',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  User = 'user'
}

export type User_Plan_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Plan_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Plan_Bool_Exp;
};

/** select columns of table "user" */
export enum User_Select_Column {
  /** column name */
  Accreditation = 'accreditation',
  /** column name */
  Active = 'active',
  /** column name */
  Address = 'address',
  /** column name */
  CognitoUserSub = 'cognitoUserSub',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'lastName',
  /** column name */
  LicenseExpiration = 'licenseExpiration',
  /** column name */
  LinkminkConversionId = 'linkminkConversionId',
  /** column name */
  LinkminkTracker = 'linkminkTracker',
  /** column name */
  MalpracticeExpiration = 'malpracticeExpiration',
  /** column name */
  NeedsConfirmTwice = 'needsConfirmTwice',
  /** column name */
  Role = 'role',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  UnsubscribedFromNotifications = 'unsubscribedFromNotifications',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "user_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user" */
export enum User_Select_Column_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  NeedsConfirmTwice = 'needsConfirmTwice',
  /** column name */
  UnsubscribedFromNotifications = 'unsubscribedFromNotifications'
}

/** select "user_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user" */
export enum User_Select_Column_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  NeedsConfirmTwice = 'needsConfirmTwice',
  /** column name */
  UnsubscribedFromNotifications = 'unsubscribedFromNotifications'
}

/** input type for updating data in table "user" */
export type User_Set_Input = {
  accreditation?: InputMaybe<Accreditation_Enum>;
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['uuid']>;
  cognitoUserSub?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  licenseExpiration?: InputMaybe<Scalars['date']>;
  /** This is not currently used by anything. */
  linkminkConversionId?: InputMaybe<Scalars['String']>;
  linkminkTracker?: InputMaybe<Scalars['String']>;
  malpracticeExpiration?: InputMaybe<Scalars['date']>;
  /** This is no longer used, but dropping is a huge pain due Hasura bug until 2.10 https://github.com/hasura/graphql-engine/issues/8415 */
  needsConfirmTwice?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<Role_Enum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  unsubscribedFromNotifications?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "user" */
export type User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Stream_Cursor_Value_Input = {
  accreditation?: InputMaybe<Accreditation_Enum>;
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['uuid']>;
  cognitoUserSub?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  licenseExpiration?: InputMaybe<Scalars['date']>;
  /** This is not currently used by anything. */
  linkminkConversionId?: InputMaybe<Scalars['String']>;
  linkminkTracker?: InputMaybe<Scalars['String']>;
  malpracticeExpiration?: InputMaybe<Scalars['date']>;
  /** This is no longer used, but dropping is a huge pain due Hasura bug until 2.10 https://github.com/hasura/graphql-engine/issues/8415 */
  needsConfirmTwice?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<Role_Enum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  unsubscribedFromNotifications?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "user" */
export enum User_Update_Column {
  /** column name */
  Accreditation = 'accreditation',
  /** column name */
  Active = 'active',
  /** column name */
  Address = 'address',
  /** column name */
  CognitoUserSub = 'cognitoUserSub',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'lastName',
  /** column name */
  LicenseExpiration = 'licenseExpiration',
  /** column name */
  LinkminkConversionId = 'linkminkConversionId',
  /** column name */
  LinkminkTracker = 'linkminkTracker',
  /** column name */
  MalpracticeExpiration = 'malpracticeExpiration',
  /** column name */
  NeedsConfirmTwice = 'needsConfirmTwice',
  /** column name */
  Role = 'role',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  UnsubscribedFromNotifications = 'unsubscribedFromNotifications',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type User_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Bool_Exp;
};

export type Users_Unfulfilled_Product_Purchases_Count_By_Location_Args = {
  location_param?: InputMaybe<Scalars['uuid']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "version" */
export type Version = {
  __typename?: 'version';
  providerAppAndroid: Scalars['numeric'];
  providerAppIos: Scalars['String'];
};

/** aggregated selection of "version" */
export type Version_Aggregate = {
  __typename?: 'version_aggregate';
  aggregate?: Maybe<Version_Aggregate_Fields>;
  nodes: Array<Version>;
};

/** aggregate fields of "version" */
export type Version_Aggregate_Fields = {
  __typename?: 'version_aggregate_fields';
  avg?: Maybe<Version_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Version_Max_Fields>;
  min?: Maybe<Version_Min_Fields>;
  stddev?: Maybe<Version_Stddev_Fields>;
  stddev_pop?: Maybe<Version_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Version_Stddev_Samp_Fields>;
  sum?: Maybe<Version_Sum_Fields>;
  var_pop?: Maybe<Version_Var_Pop_Fields>;
  var_samp?: Maybe<Version_Var_Samp_Fields>;
  variance?: Maybe<Version_Variance_Fields>;
};


/** aggregate fields of "version" */
export type Version_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Version_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Version_Avg_Fields = {
  __typename?: 'version_avg_fields';
  providerAppAndroid?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "version". All fields are combined with a logical 'AND'. */
export type Version_Bool_Exp = {
  _and?: InputMaybe<Array<Version_Bool_Exp>>;
  _not?: InputMaybe<Version_Bool_Exp>;
  _or?: InputMaybe<Array<Version_Bool_Exp>>;
  providerAppAndroid?: InputMaybe<Numeric_Comparison_Exp>;
  providerAppIos?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "version" */
export enum Version_Constraint {
  /** unique or primary key constraint on columns "provider_app_android", "provider_app_ios" */
  VersionPkey = 'version_pkey'
}

/** input type for incrementing numeric columns in table "version" */
export type Version_Inc_Input = {
  providerAppAndroid?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "version" */
export type Version_Insert_Input = {
  providerAppAndroid?: InputMaybe<Scalars['numeric']>;
  providerAppIos?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Version_Max_Fields = {
  __typename?: 'version_max_fields';
  providerAppAndroid?: Maybe<Scalars['numeric']>;
  providerAppIos?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Version_Min_Fields = {
  __typename?: 'version_min_fields';
  providerAppAndroid?: Maybe<Scalars['numeric']>;
  providerAppIos?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "version" */
export type Version_Mutation_Response = {
  __typename?: 'version_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Version>;
};

/** on_conflict condition type for table "version" */
export type Version_On_Conflict = {
  constraint: Version_Constraint;
  update_columns?: Array<Version_Update_Column>;
  where?: InputMaybe<Version_Bool_Exp>;
};

/** Ordering options when selecting data from "version". */
export type Version_Order_By = {
  providerAppAndroid?: InputMaybe<Order_By>;
  providerAppIos?: InputMaybe<Order_By>;
};

/** primary key columns input for table: version */
export type Version_Pk_Columns_Input = {
  providerAppAndroid: Scalars['numeric'];
  providerAppIos: Scalars['String'];
};

/** select columns of table "version" */
export enum Version_Select_Column {
  /** column name */
  ProviderAppAndroid = 'providerAppAndroid',
  /** column name */
  ProviderAppIos = 'providerAppIos'
}

/** input type for updating data in table "version" */
export type Version_Set_Input = {
  providerAppAndroid?: InputMaybe<Scalars['numeric']>;
  providerAppIos?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Version_Stddev_Fields = {
  __typename?: 'version_stddev_fields';
  providerAppAndroid?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Version_Stddev_Pop_Fields = {
  __typename?: 'version_stddev_pop_fields';
  providerAppAndroid?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Version_Stddev_Samp_Fields = {
  __typename?: 'version_stddev_samp_fields';
  providerAppAndroid?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "version" */
export type Version_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Version_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Version_Stream_Cursor_Value_Input = {
  providerAppAndroid?: InputMaybe<Scalars['numeric']>;
  providerAppIos?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Version_Sum_Fields = {
  __typename?: 'version_sum_fields';
  providerAppAndroid?: Maybe<Scalars['numeric']>;
};

/** update columns of table "version" */
export enum Version_Update_Column {
  /** column name */
  ProviderAppAndroid = 'providerAppAndroid',
  /** column name */
  ProviderAppIos = 'providerAppIos'
}

export type Version_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Version_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Version_Set_Input>;
  /** filter the rows which have to be updated */
  where: Version_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Version_Var_Pop_Fields = {
  __typename?: 'version_var_pop_fields';
  providerAppAndroid?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Version_Var_Samp_Fields = {
  __typename?: 'version_var_samp_fields';
  providerAppAndroid?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Version_Variance_Fields = {
  __typename?: 'version_variance_fields';
  providerAppAndroid?: Maybe<Scalars['Float']>;
};

export type AccreditationLocationPrivilegeListQueryVariables = Exact<{
  _in: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type AccreditationLocationPrivilegeListQuery = { __typename?: 'query_root', accreditation_location_privilege: Array<{ __typename?: 'accreditation_location_privilege', location: any, accreditation: Accreditation_Enum, canPurchasePrescriptionProducts: boolean, canBookWithoutDirector: boolean }> };

export type AccreditationLocationPrivilegeCreateMutationVariables = Exact<{
  accreditation: Accreditation_Enum;
  canPurchasePrescriptionProducts: Scalars['Boolean'];
  canBookWithoutDirector: Scalars['Boolean'];
  location: Scalars['uuid'];
}>;


export type AccreditationLocationPrivilegeCreateMutation = { __typename?: 'mutation_root', insert_accreditation_location_privilege_one?: { __typename?: 'accreditation_location_privilege', accreditation: Accreditation_Enum, canPurchasePrescriptionProducts: boolean, canBookWithoutDirector: boolean, location: any } | null | undefined };

export type AccreditationLocationPrivilegeUpdateMutationVariables = Exact<{
  accreditation: Accreditation_Enum;
  location: Scalars['uuid'];
  canPurchasePrescriptionProducts: Scalars['Boolean'];
  canBookWithoutDirector: Scalars['Boolean'];
}>;


export type AccreditationLocationPrivilegeUpdateMutation = { __typename?: 'mutation_root', update_accreditation_location_privilege_by_pk?: { __typename?: 'accreditation_location_privilege', location: any, canPurchasePrescriptionProducts: boolean, canBookWithoutDirector: boolean, accreditation: Accreditation_Enum } | null | undefined };

export type AccreditationLocationPrivilegeDeleteMutationVariables = Exact<{
  accreditation: Accreditation_Enum;
  location: Scalars['uuid'];
}>;


export type AccreditationLocationPrivilegeDeleteMutation = { __typename?: 'mutation_root', delete_accreditation_location_privilege_by_pk?: { __typename?: 'accreditation_location_privilege', location: any, accreditation: Accreditation_Enum } | null | undefined };

export type GetPortabilityDataQueryVariables = Exact<{
  model: Scalars['uuid'];
  location: Scalars['uuid'];
  lowerBound: Scalars['timestamptz'];
  upperBound: Scalars['timestamptz'];
}>;


export type GetPortabilityDataQuery = { __typename?: 'query_root', model_count: Array<{ __typename?: 'model_count', id: any, count: number, timespan: any }>, room_model_aggregate: { __typename?: 'room_model_aggregate', aggregate?: { __typename?: 'room_model_aggregate_fields', count: number } | null | undefined }, booked_portable: { __typename?: 'booking_aggregate', aggregate?: { __typename?: 'booking_aggregate_fields', count: number } | null | undefined }, booked_with_room: { __typename?: 'booking_aggregate', aggregate?: { __typename?: 'booking_aggregate_fields', count: number } | null | undefined } };

export type AvailableRoomOptionsQueryVariables = Exact<{
  location: Scalars['uuid'];
  model: Scalars['uuid'];
  lowerBound: Scalars['timestamptz'];
  upperBound: Scalars['timestamptz'];
}>;


export type AvailableRoomOptionsQuery = { __typename?: 'query_root', room: Array<{ __typename?: 'room', id: any, name?: string | null | undefined, rate: number }> };

export type GetBookingsQueryVariables = Exact<{
  _eq: Scalars['uuid'];
}>;


export type GetBookingsQuery = { __typename?: 'query_root', booking: Array<{ __typename?: 'booking', id: any, title: string, model?: any | null | undefined, timespan: any, modelRate?: number | null | undefined, roomRate?: number | null | undefined, modelTaxRate?: any | null | undefined, roomTaxRate?: any | null | undefined, recurringKey?: any | null | undefined, userByProvider: { __typename?: 'user', id: any, firstName?: string | null | undefined, lastName?: string | null | undefined }, roomByRoom?: { __typename?: 'room', name?: string | null | undefined, rate: number, id: any } | null | undefined, modelByModel?: { __typename?: 'model', id: any, name: string } | null | undefined }> };

export type DeleteBookingByPkMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteBookingByPkMutation = { __typename?: 'mutation_root', removeBooking?: { __typename?: 'RemoveBookingOutput', credit_ids: Array<any | null | undefined>, booking_id: any } | null | undefined };

export type GetOpensBookingQueryVariables = Exact<{
  _eq: Scalars['uuid'];
}>;


export type GetOpensBookingQuery = { __typename?: 'query_root', open: Array<{ __typename?: 'open', id: any, location: any, repeating?: any | null | undefined, timespan: any }> };

export type ModelForRoomsQueryVariables = Exact<{
  _in: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type ModelForRoomsQuery = { __typename?: 'query_root', room_model: Array<{ __typename?: 'room_model', id: any, room: any, model: any, timespan: any, modelByModel: { __typename?: 'model', id: any, name: string } }> };

export type ProductsForBookingQueryVariables = Exact<{
  _eq?: Maybe<Scalars['uuid']>;
}>;


export type ProductsForBookingQuery = { __typename?: 'query_root', model_product: Array<{ __typename?: 'model_product', model: any, product: any, productByProduct: { __typename?: 'product', id: any, name: string, locationProducts: Array<{ __typename?: 'location_product', stock: number, product: any, location: any }> } }> };

export type DeleteRecurringBookingMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteRecurringBookingMutation = { __typename?: 'mutation_root', removeRepeatBooking: { __typename?: 'RemoveRepeatBookingOutput', credit_id?: any | null | undefined, booking_ids: Array<any | null | undefined> } };

export type UserCreditListQueryVariables = Exact<{
  user: Scalars['uuid'];
  _in?: Maybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type UserCreditListQuery = { __typename?: 'query_root', credit: Array<{ __typename?: 'credit', id: any, description: string, currentBalance: number, initialBalance: number, expiresAt?: any | null | undefined, user: any, active: boolean, type: Credit_Type_Enum, deleted_at?: any | null | undefined }> };

export type UserCreditDeleteMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type UserCreditDeleteMutation = { __typename?: 'mutation_root', update_credit_by_pk?: { __typename?: 'credit', id: any, deleted_at?: any | null | undefined } | null | undefined };

export type UserCreditCreateMutationVariables = Exact<{
  expiresAt?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  initialBalance: Scalars['Int'];
  type: Credit_Type_Enum;
  user: Scalars['uuid'];
  location: Scalars['uuid'];
}>;


export type UserCreditCreateMutation = { __typename?: 'mutation_root', insert_credit_one?: { __typename?: 'credit', id: any, description: string, currentBalance: number, initialBalance: number, expiresAt?: any | null | undefined, user: any, active: boolean, type: Credit_Type_Enum, deleted_at?: any | null | undefined } | null | undefined };

export type UserCreditUpdateMutationVariables = Exact<{
  id: Scalars['uuid'];
  expiresAt: Scalars['timestamptz'];
  description: Scalars['String'];
  currentBalance: Scalars['Int'];
  type: Credit_Type_Enum;
}>;


export type UserCreditUpdateMutation = { __typename?: 'mutation_root', insert_credit_one?: { __typename?: 'credit', id: any, description: string, currentBalance: number, initialBalance: number, expiresAt?: any | null | undefined, active: boolean, type: Credit_Type_Enum, deleted_at?: any | null | undefined } | null | undefined };

export type ListDirectProviderPurchaseRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListDirectProviderPurchaseRequestsQuery = { __typename?: 'query_root', provider_direct_purchase_web_admin_view: Array<{ __typename?: 'provider_direct_purchase_web_admin_view', id?: any | null | undefined, cancelledAt?: any | null | undefined, createdAt?: any | null | undefined, location?: any | null | undefined, locationName?: string | null | undefined, orderedAt?: any | null | undefined, packageTrackingCode?: string | null | undefined, partner?: any | null | undefined, partnerName?: string | null | undefined, product?: any | null | undefined, productName?: string | null | undefined, productPurchase?: any | null | undefined, provider?: any | null | undefined, providerFirstName?: string | null | undefined, providerLastName?: string | null | undefined, retailPrice?: number | null | undefined, units?: number | null | undefined, wholesalePrice?: number | null | undefined }> };

export type DoNothing_DirectProviderPurchaseRequestsMutationVariables = Exact<{ [key: string]: never; }>;


export type DoNothing_DirectProviderPurchaseRequestsMutation = { __typename?: 'mutation_root', update_provider_direct_product_purchase_by_pk?: { __typename?: 'provider_direct_product_purchase', id: any } | null | undefined };

export type UpdateDirectProviderPurchaseRequestMutationVariables = Exact<{
  id: Scalars['uuid'];
  orderedAt?: Maybe<Scalars['timestamptz']>;
  trackingCode?: Maybe<Scalars['String']>;
}>;


export type UpdateDirectProviderPurchaseRequestMutation = { __typename?: 'mutation_root', update_provider_direct_product_purchase_by_pk?: { __typename?: 'provider_direct_product_purchase', id: any, orderedAt?: any | null | undefined, packageTrackingCode?: string | null | undefined } | null | undefined };

export type SetPurchaseForLocationDeletedMutationMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SetPurchaseForLocationDeletedMutationMutation = { __typename?: 'mutation_root', update_purchase_for_location_by_pk?: { __typename?: 'purchase_for_location', id: any, deletedAt?: any | null | undefined } | null | undefined };

export type CreateMsoPurchaseRequestInvoiceMutationVariables = Exact<{
  partnerId: Scalars['uuid'];
  productId: Scalars['uuid'];
  units: Scalars['Int'];
  location: Scalars['uuid'];
  purchaseRecordId: Scalars['uuid'];
}>;


export type CreateMsoPurchaseRequestInvoiceMutation = { __typename?: 'mutation_root', createMsoPurchaseRequestInvoice: { __typename?: 'CreateMsoPurchaseRequestInvoiceOutput', stripeInvoiceId: string, stripeInvoiceUrl: string, id: any } };

export type EhrSubscriptionEraFieldsFragment = { __typename?: 'ehr_subscription', id: any, provider?: any | null | undefined, partner?: any | null | undefined, status: Ehr_Subscription_Status_Enum, createdAt: any, endedAt?: any | null | undefined, tierTerms: Array<{ __typename?: 'ehr_subscription_tier_term', id: any, tier: Ehr_Subscription_Tier_Enum, endedAt?: any | null | undefined }> };

export type GetEhrSubscriptionsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetEhrSubscriptionsQuery = { __typename?: 'query_root', user_location: Array<{ __typename?: 'user_location', user: any, location: any, locationByLocation: { __typename?: 'location', id: any, partnerByPartner: { __typename?: 'partner', id: any, name: string, msoMode: Mso_Mode_Enum } } }>, mine: Array<{ __typename?: 'ehr_subscription', id: any, provider?: any | null | undefined, partner?: any | null | undefined, status: Ehr_Subscription_Status_Enum, createdAt: any, endedAt?: any | null | undefined, tierTerms: Array<{ __typename?: 'ehr_subscription_tier_term', id: any, tier: Ehr_Subscription_Tier_Enum, endedAt?: any | null | undefined }> }>, mso: Array<{ __typename?: 'ehr_subscription', id: any, provider?: any | null | undefined, partner?: any | null | undefined, status: Ehr_Subscription_Status_Enum, createdAt: any, endedAt?: any | null | undefined, tierTerms: Array<{ __typename?: 'ehr_subscription_tier_term', id: any, tier: Ehr_Subscription_Tier_Enum, endedAt?: any | null | undefined }> }> };

export type EnableEhrSubscriptionMutationVariables = Exact<{
  tier: EhrTier;
  location: Scalars['uuid'];
  partner?: Maybe<Scalars['uuid']>;
}>;


export type EnableEhrSubscriptionMutation = { __typename?: 'mutation_root', enableEhrSubscription: { __typename?: 'EhrSubscriptionOutput', id: any, status: string } };

export type ChangeEhrTierMutationVariables = Exact<{
  tier: EhrTier;
  location: Scalars['uuid'];
  partner?: Maybe<Scalars['uuid']>;
}>;


export type ChangeEhrTierMutation = { __typename?: 'mutation_root', changeEhrTier: { __typename?: 'EhrTierOutput', tier: EhrTier } };

export type CancelEhrSubscriptionMutationVariables = Exact<{
  location: Scalars['uuid'];
  partner?: Maybe<Scalars['uuid']>;
}>;


export type CancelEhrSubscriptionMutation = { __typename?: 'mutation_root', cancelEhrSubscription: { __typename?: 'EhrSubscriptionOutput', id: any, status: string } };

export type UncancelEhrSubscriptionMutationVariables = Exact<{
  location: Scalars['uuid'];
  partner?: Maybe<Scalars['uuid']>;
}>;


export type UncancelEhrSubscriptionMutation = { __typename?: 'mutation_root', uncancelEhrSubscription: { __typename?: 'EhrSubscriptionOutput', id: any, status: string } };

export type GetFinancialReportQueryVariables = Exact<{
  admin: Scalars['uuid'];
  end: Scalars['String'];
  start: Scalars['String'];
  location: Scalars['uuid'];
}>;


export type GetFinancialReportQuery = { __typename?: 'query_root', getFinancialReport: { __typename?: 'FinancialReportOutput', admin: any, location: any } };

export type LocationProductListQueryVariables = Exact<{
  _in: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type LocationProductListQuery = { __typename?: 'query_root', location_product: Array<{ __typename?: 'location_product', location: any, product: any, tax: any, price: number, stock: number, warnAtStock?: number | null | undefined, photoS3Key?: any | null | undefined, taxRate: { __typename?: 'tax_rate', id: any, name: string, rate: any, type: Tax_Type_Enum }, locationByLocation: { __typename?: 'location', id: any, name: string, providerDirectProductPurchase: boolean, providerDirectPurchaseProfitMargin?: number | null | undefined }, productByProduct: { __typename?: 'product', id: any, name: string, price: number, taxExempt: boolean }, product_type?: { __typename?: 'product_type', id: any, type: string } | null | undefined }> };

export type LocationProductDeleteMutationVariables = Exact<{
  product: Scalars['uuid'];
  location: Scalars['uuid'];
}>;


export type LocationProductDeleteMutation = { __typename?: 'mutation_root', delete_location_product_by_pk?: { __typename?: 'location_product', product: any, location: any } | null | undefined };

export type LocationProductListCreateMutationVariables = Exact<{
  location: Scalars['uuid'];
  product: Scalars['uuid'];
  stock: Scalars['Int'];
  warnAtStock?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  tax: Scalars['uuid'];
  type?: Maybe<Scalars['uuid']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
}>;


export type LocationProductListCreateMutation = { __typename?: 'mutation_root', insert_location_product_one?: { __typename?: 'location_product', location: any, product: any, price: number, stock: number, warnAtStock?: number | null | undefined, tax: any, photoS3Key?: any | null | undefined, product_type?: { __typename?: 'product_type', id: any, type: string } | null | undefined } | null | undefined };

export type LocationProductListUpdateMutationVariables = Exact<{
  tax: Scalars['uuid'];
  location: Scalars['uuid'];
  product: Scalars['uuid'];
  stock: Scalars['Int'];
  warnAtStock?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['uuid']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
}>;


export type LocationProductListUpdateMutation = { __typename?: 'mutation_root', update_location_product_by_pk?: { __typename?: 'location_product', location: any, product: any, tax: any, warnAtStock?: number | null | undefined, stock: number, price: number, photoS3Key?: any | null | undefined, product_type?: { __typename?: 'product_type', id: any, type: string } | null | undefined } | null | undefined };

export type ConfirmProductPurchaseMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type ConfirmProductPurchaseMutation = { __typename?: 'mutation_root', confirmProductPurchase?: { __typename?: 'ProductPurchaseOutput', stripeInvoiceId: string } | null | undefined };

export type LocationProductGlobalTypeListQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationProductGlobalTypeListQuery = { __typename?: 'query_root', product: Array<{ __typename?: 'product', id: any, photoS3Key?: any | null | undefined, product_type?: { __typename?: 'product_type', id: any, type: string } | null | undefined }> };

export type CreatePurchaseForLocationMutationVariables = Exact<{
  location: Scalars['uuid'];
  purchasedBy: Scalars['uuid'];
  units: Scalars['Int'];
  product: Scalars['uuid'];
}>;


export type CreatePurchaseForLocationMutation = { __typename?: 'mutation_root', insert_purchase_for_location_one?: { __typename?: 'purchase_for_location', id: any } | null | undefined };

export type ModelListQueryVariables = Exact<{ [key: string]: never; }>;


export type ModelListQuery = { __typename?: 'query_root', model: Array<{ __typename?: 'model', id: any, name: string, deleted_at?: any | null | undefined, photoS3Key?: any | null | undefined, procedures: Array<{ __typename?: 'procedure', id: any, name: string }>, modelProducts: Array<{ __typename?: 'model_product', model: any, product: any, productByProduct: { __typename?: 'product', id: any, name: string } }> }> };

export type ModelDeleteMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type ModelDeleteMutation = { __typename?: 'mutation_root', update_model_by_pk?: { __typename?: 'model', id: any, deleted_at?: any | null | undefined } | null | undefined, delete_model_product?: { __typename?: 'model_product_mutation_response', returning: Array<{ __typename?: 'model_product', product: any, model: any }> } | null | undefined };

export type ModelCreateMutationVariables = Exact<{
  name: Scalars['String'];
  photoS3Key?: Maybe<Scalars['uuid']>;
  modelProducts?: Maybe<Model_Product_Arr_Rel_Insert_Input>;
  procedures?: Maybe<Procedure_Arr_Rel_Insert_Input>;
}>;


export type ModelCreateMutation = { __typename?: 'mutation_root', insert_model_one?: { __typename?: 'model', id: any, name: string, photoS3Key?: any | null | undefined, modelProducts: Array<{ __typename?: 'model_product', model: any, product: any }>, procedures: Array<{ __typename?: 'procedure', id: any, name: string }> } | null | undefined };

export type ModelUpdateMutationVariables = Exact<{
  id: Scalars['uuid'];
  name: Scalars['String'];
  deleted_products: Array<Scalars['uuid']> | Scalars['uuid'];
  new_model_products: Array<Model_Product_Insert_Input> | Model_Product_Insert_Input;
  photoS3Key?: Maybe<Scalars['uuid']>;
}>;


export type ModelUpdateMutation = { __typename?: 'mutation_root', delete_model_product?: { __typename?: 'model_product_mutation_response', affected_rows: number } | null | undefined, insert_model_product?: { __typename?: 'model_product_mutation_response', returning: Array<{ __typename?: 'model_product', model: any, product: any }> } | null | undefined, update_model_by_pk?: { __typename?: 'model', id: any, name: string, photoS3Key?: any | null | undefined, modelProducts: Array<{ __typename?: 'model_product', model: any, product: any }> } | null | undefined };

export type ModelCountListQueryVariables = Exact<{
  _in: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type ModelCountListQuery = { __typename?: 'query_root', model_count: Array<{ __typename?: 'model_count', id: any, timespan: any, model: any, count: number, location: any, rate: number, deleted_at?: any | null | undefined, allowVolumeDiscount: boolean, photoS3Key?: any | null | undefined, roomRequired: boolean, allowNonMedicalUsers: boolean, modelByModel: { __typename?: 'model', id: any, name: string } }> };

export type ModelCountDeleteListMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type ModelCountDeleteListMutation = { __typename?: 'mutation_root', update_model_count_by_pk?: { __typename?: 'model_count', id: any, deleted_at?: any | null | undefined } | null | undefined };

export type ModelCountCreateListMutationVariables = Exact<{
  model: Scalars['uuid'];
  timespan: Scalars['tstzrange'];
  count: Scalars['Int'];
  location: Scalars['uuid'];
  rate: Scalars['Int'];
  allowVolumeDiscount: Scalars['Boolean'];
  photoS3Key?: Maybe<Scalars['uuid']>;
  roomRequired: Scalars['Boolean'];
  allowNonMedicalUsers: Scalars['Boolean'];
}>;


export type ModelCountCreateListMutation = { __typename?: 'mutation_root', insert_model_count_one?: { __typename?: 'model_count', model: any, count: number, timespan: any, deleted_at?: any | null | undefined, location: any, allowVolumeDiscount: boolean, rate: number, id: any, photoS3Key?: any | null | undefined, roomRequired: boolean, allowNonMedicalUsers: boolean } | null | undefined };

export type ModelCountCreateListManagerRoleMutationVariables = Exact<{
  model: Scalars['uuid'];
  timespan: Scalars['tstzrange'];
  count: Scalars['Int'];
  location: Scalars['uuid'];
  rate: Scalars['Int'];
  allowVolumeDiscount: Scalars['Boolean'];
  photoS3Key?: Maybe<Scalars['uuid']>;
}>;


export type ModelCountCreateListManagerRoleMutation = { __typename?: 'mutation_root', insert_model_count_one?: { __typename?: 'model_count', model: any, count: number, timespan: any, deleted_at?: any | null | undefined, location: any, allowVolumeDiscount: boolean, rate: number, id: any, photoS3Key?: any | null | undefined, roomRequired: boolean, allowNonMedicalUsers: boolean } | null | undefined };

export type ModelCountUpdateListMutationVariables = Exact<{
  timespan: Scalars['tstzrange'];
  id: Scalars['uuid'];
  rate: Scalars['Int'];
  count: Scalars['Int'];
  allowVolumeDiscount: Scalars['Boolean'];
  photoS3Key?: Maybe<Scalars['uuid']>;
  roomRequired: Scalars['Boolean'];
  allowNonMedicalUsers: Scalars['Boolean'];
}>;


export type ModelCountUpdateListMutation = { __typename?: 'mutation_root', update_model_count_by_pk?: { __typename?: 'model_count', id: any, count: number, timespan: any, allowVolumeDiscount: boolean, deleted_at?: any | null | undefined, location: any, rate: number, photoS3Key?: any | null | undefined, roomRequired: boolean, allowNonMedicalUsers: boolean } | null | undefined };

export type ModelCountUpdateListManagerRoleMutationVariables = Exact<{
  timespan: Scalars['tstzrange'];
  id: Scalars['uuid'];
  rate: Scalars['Int'];
  count: Scalars['Int'];
  allowVolumeDiscount: Scalars['Boolean'];
  photoS3Key?: Maybe<Scalars['uuid']>;
}>;


export type ModelCountUpdateListManagerRoleMutation = { __typename?: 'mutation_root', update_model_count_by_pk?: { __typename?: 'model_count', id: any, count: number, timespan: any, allowVolumeDiscount: boolean, deleted_at?: any | null | undefined, location: any, rate: number, photoS3Key?: any | null | undefined, roomRequired: boolean, allowNonMedicalUsers: boolean } | null | undefined };

export type ModelDefaultPhotosQueryVariables = Exact<{ [key: string]: never; }>;


export type ModelDefaultPhotosQuery = { __typename?: 'query_root', model: Array<{ __typename?: 'model', id: any, photoS3Key?: any | null | undefined }> };

export type GetMsoDashboardMetricQueryVariables = Exact<{
  location: Scalars['uuid'];
  metric: MsoDashboardMetric;
  interval: MsoDashboardMetricInterval;
}>;


export type GetMsoDashboardMetricQuery = { __typename?: 'query_root', GetMsoDashboardMetric: { __typename?: 'GetMsoDashboardMetricOutput', labels: Array<string>, dataset: Array<number>, display_dataset: Array<string> } };

export type GetMsoDashboardMetricStripeStagingProdQueryVariables = Exact<{
  location: Scalars['uuid'];
  metric: MsoDashboardMetric;
  interval: MsoDashboardMetricInterval;
}>;


export type GetMsoDashboardMetricStripeStagingProdQuery = { __typename?: 'query_root', GetMsoDashboardMetric: { __typename?: 'GetMsoDashboardMetricOutput', labels: Array<string>, dataset: Array<number>, display_dataset: Array<string> } };

export type GetPartnerThemeQueryVariables = Exact<{
  location: Scalars['uuid'];
}>;


export type GetPartnerThemeQuery = { __typename?: 'query_root', partner: Array<{ __typename?: 'partner', id: any, name: string, primaryColor: string, secondaryColor: string, logoS3Key?: any | null | undefined, stripeUserToCharge?: string | null | undefined, chargeUserPaymentMethod?: string | null | undefined, productOnly: boolean, msoTier: Mso_Tier_Enum, msoMode: Mso_Mode_Enum }> };

export type UpdatePartnerThemeVansanityAdminMutationVariables = Exact<{
  id: Scalars['uuid'];
  name: Scalars['String'];
  primaryColor: Scalars['String'];
  secondaryColor: Scalars['String'];
  logoS3Key?: Maybe<Scalars['uuid']>;
  stripeUserToCharge: Scalars['String'];
  location: Scalars['uuid'];
  chargeUserPaymentMethod?: Maybe<Scalars['String']>;
  productOnly: Scalars['Boolean'];
  msoTier: Mso_Tier_Enum;
  msoMode: Mso_Mode_Enum;
}>;


export type UpdatePartnerThemeVansanityAdminMutation = { __typename?: 'mutation_root', update_partner_by_pk?: { __typename?: 'partner', id: any, name: string, primaryColor: string, secondaryColor: string, logoS3Key?: any | null | undefined, productOnly: boolean, msoTier: Mso_Tier_Enum, msoMode: Mso_Mode_Enum } | null | undefined, updatePartnerStripeUserToCharge: { __typename?: 'UpdatePartnerStripeUserToChargeOutput', id: any, stripeUserToCharge: string, chargeUserPaymentMethod?: string | null | undefined } };

export type UpdatePartnerThemeLocationAdminMutationVariables = Exact<{
  id: Scalars['uuid'];
  name: Scalars['String'];
  primaryColor: Scalars['String'];
  secondaryColor: Scalars['String'];
}>;


export type UpdatePartnerThemeLocationAdminMutation = { __typename?: 'mutation_root', update_partner_by_pk?: { __typename?: 'partner', id: any, name: string, primaryColor: string, secondaryColor: string } | null | undefined };

export type GetUserByStripeIdQueryVariables = Exact<{
  stripeCustomerId: Scalars['String'];
}>;


export type GetUserByStripeIdQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: any, firstName?: string | null | undefined, lastName?: string | null | undefined, stripeCustomerId?: string | null | undefined }> };

export type GetPaymentMethodsForLocationAdminQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetPaymentMethodsForLocationAdminQuery = { __typename?: 'query_root', getPaymentMethods: Array<{ __typename?: 'GetPaymentMethodsOutput', bank?: string | null | undefined, brand?: string | null | undefined, id: string, last4: string, methodType: string }> };

export type GetPartnerPaymentMethodQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetPartnerPaymentMethodQuery = { __typename?: 'query_root', partner_by_pk?: { __typename?: 'partner', id: any, stripeUserToCharge?: string | null | undefined, chargeUserPaymentMethod?: string | null | undefined } | null | undefined };

export type CreateOpenMutationVariables = Exact<{
  frequency: Scalars['String'];
  location: Scalars['uuid'];
  id: Scalars['uuid'];
  timespan: Scalars['String'];
}>;


export type CreateOpenMutation = { __typename?: 'mutation_root', createOpen?: Array<{ __typename?: 'CreateOpenOutput', id: any, location: any, repeating?: string | null | undefined, timespan: string } | null | undefined> | null | undefined };

export type GetOpensQueryVariables = Exact<{
  _eq: Scalars['uuid'];
}>;


export type GetOpensQuery = { __typename?: 'query_root', open: Array<{ __typename?: 'open', id: any, location: any, repeating?: any | null | undefined, timespan: any, repeatingByRepeating?: { __typename?: 'repeating', frequency: string } | null | undefined }> };

export type EraseOpenByPkMutationVariables = Exact<{
  id: Scalars['uuid'];
  carryForwards?: Maybe<Scalars['Boolean']>;
}>;


export type EraseOpenByPkMutation = { __typename?: 'mutation_root', removeOpen?: Array<{ __typename?: 'DeleteOpenOutput', id: any } | null | undefined> | null | undefined };

export type ChangeOpenByPkMutationVariables = Exact<{
  timespan: Scalars['String'];
  frequency: Scalars['String'];
  location: Scalars['uuid'];
  id: Scalars['uuid'];
  carryForwards?: Maybe<Scalars['Boolean']>;
}>;


export type ChangeOpenByPkMutation = { __typename?: 'mutation_root', editOpen?: Array<{ __typename?: 'CreateOpenOutput', id: any, repeating?: string | null | undefined, timespan: string, location: any } | null | undefined> | null | undefined };

export type GetMyPaymentMethodsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetMyPaymentMethodsQuery = { __typename?: 'query_root', getPaymentMethods: Array<{ __typename?: 'GetPaymentMethodsOutput', id: string, methodType: string, isDefault: boolean, last4: string, brand?: string | null | undefined, expMonth?: number | null | undefined, expYear?: number | null | undefined, bank?: string | null | undefined }> };

export type CreateSetupIntentForPaymentMethodMutationVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type CreateSetupIntentForPaymentMethodMutation = { __typename?: 'mutation_root', createSetupIntent: { __typename?: 'CreateSetupIntentOutput', id: string, clientSecret: string } };

export type SetDefaultPaymentMethodMutationVariables = Exact<{
  id: Scalars['String'];
  type: PaymentMethodType;
  userId: Scalars['String'];
}>;


export type SetDefaultPaymentMethodMutation = { __typename?: 'mutation_root', setAsDefaultPaymentMethod: { __typename?: 'SetAsDefaultPaymentMethodOutput', id: string, isDefault: boolean } };

export type DeleteMyPaymentMethodMutationVariables = Exact<{
  id: Scalars['String'];
  type: PaymentMethodType;
  userId: Scalars['String'];
}>;


export type DeleteMyPaymentMethodMutation = { __typename?: 'mutation_root', deletePaymentMethod?: { __typename?: 'DeletePaymentMethodOutput', id: string } | null | undefined };

export type MsosChargedToPaymentMethodQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type MsosChargedToPaymentMethodQuery = { __typename?: 'query_root', partner: Array<{ __typename?: 'partner', id: any, name: string }> };

export type ListPaymentsQueryVariables = Exact<{
  location: Scalars['uuid'];
}>;


export type ListPaymentsQuery = { __typename?: 'query_root', GetPaymentsList: Array<{ __typename?: 'GetPaymentsListOutput', name: string, status: string, email: string, created: string, amount: string }> };

export type DoNothingMutationVariables = Exact<{ [key: string]: never; }>;


export type DoNothingMutation = { __typename?: 'mutation_root', update_purchase_for_location_by_pk?: { __typename?: 'purchase_for_location', id: any } | null | undefined };

export type PlanListQueryVariables = Exact<{
  _in: Scalars['uuid'];
}>;


export type PlanListQuery = { __typename?: 'query_root', get_cumulative_location_plans: Array<{ __typename?: 'plan', type: Plan_Type_Enum, name: string, monthlyCredit?: number | null | undefined, monthlyCost: number, annualCost?: number | null | undefined, location: any, id: any, discountRate?: any | null | undefined, deleted_at?: any | null | undefined, description: string, locationByLocation: { __typename?: 'location', parentLocation?: any | null | undefined } }> };

export type PlanDeleteListMutationVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type PlanDeleteListMutation = { __typename?: 'mutation_root', deletePlan?: { __typename?: 'DeletePlanOutput', id: any } | null | undefined };

export type PlanCreateListMutationVariables = Exact<{
  object: CreatePlanInput;
}>;


export type PlanCreateListMutation = { __typename?: 'mutation_root', createPlan: { __typename?: 'CreatePlanOutput', id: any, type: string, name: string, monthlyCredit?: number | null | undefined, monthlyCost: number, annualCost?: number | null | undefined, location: any, discountRate?: number | null | undefined, description: string } };

export type PlanUpdateListMutationVariables = Exact<{
  object: UpdatePlanInput;
}>;


export type PlanUpdateListMutation = { __typename?: 'mutation_root', updatePlan?: { __typename?: 'UpdatePlanOutput', id: any, type: string, name: string, monthlyCredit?: number | null | undefined, monthlyCost?: number | null | undefined, annualCost?: number | null | undefined, location: any, discountRate?: number | null | undefined, description: string } | null | undefined };

export type ProductTypeListQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductTypeListQuery = { __typename?: 'query_root', product_type: Array<{ __typename?: 'product_type', id: any, type: string }> };

export type ProductTypeCreateMutationVariables = Exact<{
  type: Scalars['String'];
}>;


export type ProductTypeCreateMutation = { __typename?: 'mutation_root', insert_product_type_one?: { __typename?: 'product_type', id: any, type: string } | null | undefined };

export type ProductTypeUpdateMutationVariables = Exact<{
  id: Scalars['uuid'];
  type: Scalars['String'];
}>;


export type ProductTypeUpdateMutation = { __typename?: 'mutation_root', update_product_type_by_pk?: { __typename?: 'product_type', id: any, type: string } | null | undefined };

export type ProductTypeDeleteMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type ProductTypeDeleteMutation = { __typename?: 'mutation_root', delete_product_type_by_pk?: { __typename?: 'product_type', id: any } | null | undefined };

export type ListPurchaseRequestsQueryVariables = Exact<{
  _in: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type ListPurchaseRequestsQuery = { __typename?: 'query_root', purchase_requests_list: Array<{ __typename?: 'purchase_requests_list', id?: any | null | undefined, createdAt?: any | null | undefined, orderPlaced?: boolean | null | undefined, productName?: string | null | undefined, productsCost?: any | null | undefined, purchasedByName?: string | null | undefined, units?: number | null | undefined, msoName?: string | null | undefined, locationName?: string | null | undefined, location?: any | null | undefined, product?: any | null | undefined, stripeInvoiceId?: string | null | undefined, stripeInvoiceUrl?: string | null | undefined, partner?: any | null | undefined, deletedAt?: any | null | undefined, trackingUrl?: string | null | undefined }> };

export type UpdatePurchaseForLocationMutationVariables = Exact<{
  id: Scalars['uuid'];
  orderPlaced: Scalars['Boolean'];
  trackingUrl?: Maybe<Scalars['String']>;
}>;


export type UpdatePurchaseForLocationMutation = { __typename?: 'mutation_root', update_purchase_for_location_by_pk?: { __typename?: 'purchase_for_location', id: any, orderPlaced: boolean, trackingUrl?: string | null | undefined } | null | undefined };

export type RoomModelListQueryVariables = Exact<{
  _in: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type RoomModelListQuery = { __typename?: 'query_root', room_model: Array<{ __typename?: 'room_model', timespan: any, room: any, model: any, id: any, modelByModel: { __typename?: 'model', id: any, name: string }, roomByRoom: { __typename?: 'room', id: any, name?: string | null | undefined } }> };

export type RoomEquipmentDeleteListMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type RoomEquipmentDeleteListMutation = { __typename?: 'mutation_root', delete_room_model_by_pk?: { __typename?: 'room_model', id: any, room: any, model: any, timespan: any } | null | undefined };

export type RoomModelCreateListMutationVariables = Exact<{
  model: Scalars['uuid'];
  timespan: Scalars['tstzrange'];
  room: Scalars['uuid'];
}>;


export type RoomModelCreateListMutation = { __typename?: 'mutation_root', insert_room_model_one?: { __typename?: 'room_model', model: any, room: any, timespan: any, id: any } | null | undefined };

export type RoomModelUpdateListMutationVariables = Exact<{
  timespan: Scalars['tstzrange'];
  id: Scalars['uuid'];
}>;


export type RoomModelUpdateListMutation = { __typename?: 'mutation_root', update_room_model_by_pk?: { __typename?: 'room_model', room: any, model: any, timespan: any, id: any } | null | undefined };

export type RoomTypeListQueryVariables = Exact<{
  _in: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type RoomTypeListQuery = { __typename?: 'query_root', room_type: Array<{ __typename?: 'room_type', id: any, name: string, location: any }> };

export type RoomTypeCreateMutationVariables = Exact<{
  location: Scalars['uuid'];
  name: Scalars['String'];
}>;


export type RoomTypeCreateMutation = { __typename?: 'mutation_root', insert_room_type_one?: { __typename?: 'room_type', id: any, name: string } | null | undefined };

export type RoomTypeUpdateMutationVariables = Exact<{
  name: Scalars['String'];
  id: Scalars['uuid'];
}>;


export type RoomTypeUpdateMutation = { __typename?: 'mutation_root', update_room_type_by_pk?: { __typename?: 'room_type', id: any, name: string } | null | undefined };

export type RoomTypeDeleteMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type RoomTypeDeleteMutation = { __typename?: 'mutation_root', delete_room_type_by_pk?: { __typename?: 'room_type', id: any, name: string } | null | undefined };

export type AllTaxRatesListQueryVariables = Exact<{
  _in: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type AllTaxRatesListQuery = { __typename?: 'query_root', tax_rate: Array<{ __typename?: 'tax_rate', id: any, location: any, rate: any, type: Tax_Type_Enum, name: string }> };

export type TaxRateDeleteMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type TaxRateDeleteMutation = { __typename?: 'mutation_root', delete_tax_rate_by_pk?: { __typename?: 'tax_rate', id: any, location: any, rate: any, type: Tax_Type_Enum, name: string } | null | undefined };

export type TaxRateCreateMutationVariables = Exact<{
  rate: Scalars['numeric'];
  location: Scalars['uuid'];
  type?: Maybe<Tax_Type_Enum>;
  name?: Maybe<Scalars['String']>;
}>;


export type TaxRateCreateMutation = { __typename?: 'mutation_root', insert_tax_rate_one?: { __typename?: 'tax_rate', id: any, location: any, rate: any, type: Tax_Type_Enum, name: string } | null | undefined };

export type TaxRateUpdateMutationVariables = Exact<{
  id: Scalars['uuid'];
  rate: Scalars['numeric'];
  name?: Maybe<Scalars['String']>;
}>;


export type TaxRateUpdateMutation = { __typename?: 'mutation_root', update_tax_rate_by_pk?: { __typename?: 'tax_rate', id: any, location: any, rate: any, type: Tax_Type_Enum, name: string } | null | undefined };

export type UserPlanListQueryVariables = Exact<{
  user: Scalars['uuid'];
  _in: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type UserPlanListQuery = { __typename?: 'query_root', user_plan: Array<{ __typename?: 'user_plan', id: any, canceledAt?: any | null | undefined, benefitsEndAt?: any | null | undefined, created_at: any, plan: any, user: any, annual: boolean, annualizedAt?: any | null | undefined, planByPlan: { __typename?: 'plan', id: any, name: string, type: Plan_Type_Enum, locationByLocation: { __typename?: 'location', id: any, name: string, usesParentLocationPlans: boolean, parentLocationByLocation?: { __typename?: 'location', name: string } | null | undefined } } }> };

export type UserPlanCancelMutationVariables = Exact<{
  object: CancelUserPlanInput;
}>;


export type UserPlanCancelMutation = { __typename?: 'mutation_root', cancelUserPlan: { __typename?: 'CancelUserPlanOutput', benefitsEndAt: any, canceledAt: any, id: any } };

export type UserPlanCreateMutationVariables = Exact<{
  object: CreateUserPlanInput;
}>;


export type UserPlanCreateMutation = { __typename?: 'mutation_root', createUserPlan?: { __typename?: 'CreateUserPlanOutput', plan: any, user: any, id: any, annual: boolean } | null | undefined };

export type UserPlanUpdateMutationVariables = Exact<{
  object: UpdateUserPlanInput;
}>;


export type UserPlanUpdateMutation = { __typename?: 'mutation_root', updateUserPlan?: { __typename?: 'UpdateUserPlanOutput', id: string, annual: boolean } | null | undefined };

export type ListUserInvoicesQueryVariables = Exact<{
  user_id: Scalars['uuid'];
  location: Scalars['uuid'];
}>;


export type ListUserInvoicesQuery = { __typename?: 'query_root', invoice: Array<{ __typename?: 'invoice', id: any, created_at?: any | null | undefined, amount_due: number, stripeId: string, stripe_hosted_invoice_url?: string | null | undefined, bookingByBooking?: { __typename?: 'booking', id: any, type: Booking_Type_Enum, modelRate?: number | null | undefined, roomRate?: number | null | undefined, timespan: any, modelByModel?: { __typename?: 'model', name: string, id: any } | null | undefined, roomByRoom?: { __typename?: 'room', id: any, name?: string | null | undefined } | null | undefined, productPurchases: Array<{ __typename?: 'product_purchase', id: any, price: number, units: number, units_fulfilled: number, productByProduct: { __typename?: 'product', id: any, name: string } }> } | null | undefined, productPurchases: Array<{ __typename?: 'product_purchase', id: any, price: number, units: number, units_fulfilled: number, productByProduct: { __typename?: 'product', id: any, name: string } }> }> };

export type UpdateProductPurchasesUnitsFulfilledMutationVariables = Exact<{
  units_fulfilled: Scalars['Int'];
  id: Scalars['uuid'];
}>;


export type UpdateProductPurchasesUnitsFulfilledMutation = { __typename?: 'mutation_root', update_product_purchase_by_pk?: { __typename?: 'product_purchase', id: any, units_fulfilled: number } | null | undefined };

export type GetStripeSubscriptionInvoicesQueryVariables = Exact<{
  location: Scalars['uuid'];
  provider: Scalars['uuid'];
}>;


export type GetStripeSubscriptionInvoicesQuery = { __typename?: 'query_root', GetStripeSubscriptionInvoices: Array<{ __typename?: 'GetStripeSubscriptionInvoicesOutput', amountDue: number, createdAt: string, stripeId: string, link: string, lineItem: { __typename?: 'GetStripeSubscriptionInvoicesLineItem', stripeId: string, name: string, totalCost: number, unitCost: number, units: number } }> };

export type RentalVolumeDiscountListQueryVariables = Exact<{
  _in: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type RentalVolumeDiscountListQuery = { __typename?: 'query_root', rental_volume_discount: Array<{ __typename?: 'rental_volume_discount', discountRate: number, hours: number, location: any }> };

export type RentalVolumeDiscountDeleteMutationVariables = Exact<{
  hours: Scalars['Int'];
  location: Scalars['uuid'];
}>;


export type RentalVolumeDiscountDeleteMutation = { __typename?: 'mutation_root', delete_rental_volume_discount_by_pk?: { __typename?: 'rental_volume_discount', hours: number, location: any } | null | undefined };

export type RentalVolumeDiscountCreateMutationVariables = Exact<{
  object: Rental_Volume_Discount_Insert_Input;
}>;


export type RentalVolumeDiscountCreateMutation = { __typename?: 'mutation_root', insert_rental_volume_discount_one?: { __typename?: 'rental_volume_discount', discountRate: number, hours: number, location: any } | null | undefined };

export type RentalVolumeDiscountUpdateMutationVariables = Exact<{
  hours: Scalars['Int'];
  location: Scalars['uuid'];
  discountRate: Scalars['Int'];
}>;


export type RentalVolumeDiscountUpdateMutation = { __typename?: 'mutation_root', update_rental_volume_discount_by_pk?: { __typename?: 'rental_volume_discount', location: any, discountRate: number, hours: number } | null | undefined };

export type UserAuthContextQueryVariables = Exact<{
  _eq: Scalars['uuid'];
}>;


export type UserAuthContextQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: any, active: boolean, firstName?: string | null | undefined, lastName?: string | null | undefined, role: Role_Enum, accreditation?: Accreditation_Enum | null | undefined, cognitoUserSub: any, userLocations: Array<{ __typename?: 'user_location', user: any, location: any, locationByLocation: { __typename?: 'location', name: string, id: any, timezone: string, bookingAllowed: boolean, parentLocation?: any | null | undefined, usesParentLocationPlans: boolean, providerDirectProductPurchase: boolean, providerDirectPurchaseProfitMargin?: number | null | undefined } }> }> };

export type CreateUserSignupMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  cognitoUserSub: Scalars['uuid'];
  role: Role_Enum;
  userLocations: User_Location_Arr_Rel_Insert_Input;
}>;


export type CreateUserSignupMutation = { __typename?: 'mutation_root', insert_user_one?: { __typename?: 'user', id: any } | null | undefined };

export type LocationProductWarnCountQueryVariables = Exact<{
  location: Scalars['uuid'];
}>;


export type LocationProductWarnCountQuery = { __typename?: 'query_root', location_product_aggregate: { __typename?: 'location_product_aggregate', aggregate?: { __typename?: 'location_product_aggregate_fields', count: number } | null | undefined } };

export type EhrProcedureListQueryVariables = Exact<{ [key: string]: never; }>;


export type EhrProcedureListQuery = { __typename?: 'query_root', ehr_procedure: Array<{ __typename?: 'ehr_procedure', id: any, name: Ehr_Procedure_Type_Enum_Enum, deleted_at?: any | null | undefined }> };

export type EhrProcedureDeleteMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type EhrProcedureDeleteMutation = { __typename?: 'mutation_root', update_ehr_procedure_by_pk?: { __typename?: 'ehr_procedure', id: any, name: Ehr_Procedure_Type_Enum_Enum, created_at: any, deleted_at?: any | null | undefined, updated_at: any } | null | undefined };

export type EhrProcedureInsertMutationVariables = Exact<{
  name: Ehr_Procedure_Type_Enum_Enum;
}>;


export type EhrProcedureInsertMutation = { __typename?: 'mutation_root', insert_ehr_procedure_one?: { __typename?: 'ehr_procedure', id: any, name: Ehr_Procedure_Type_Enum_Enum, created_at: any, deleted_at?: any | null | undefined, updated_at: any } | null | undefined };

export type EhrProcedureUpdateMutationVariables = Exact<{
  id: Scalars['uuid'];
  name: Ehr_Procedure_Type_Enum_Enum;
}>;


export type EhrProcedureUpdateMutation = { __typename?: 'mutation_root', update_ehr_procedure_by_pk?: { __typename?: 'ehr_procedure', id: any, name: Ehr_Procedure_Type_Enum_Enum, created_at: any, deleted_at?: any | null | undefined, updated_at: any } | null | undefined };

export type AllEhrProceduresQueryVariables = Exact<{ [key: string]: never; }>;


export type AllEhrProceduresQuery = { __typename?: 'query_root', ehr_procedure: Array<{ __typename?: 'ehr_procedure', id: any, name: Ehr_Procedure_Type_Enum_Enum }> };

export type EhrProductListQueryVariables = Exact<{ [key: string]: never; }>;


export type EhrProductListQuery = { __typename?: 'query_root', ehr_product: Array<{ __typename?: 'ehr_product', id: any, name: string, deletedAt?: any | null | undefined, photoS3Key?: any | null | undefined, dosages: Array<any>, unitsText: string, ehr_procedure_ehr_products: Array<{ __typename?: 'ehr_procedure_ehr_product', ehrProduct: any, ehrProcedure: any, ehrProcedureByEhrProcedure: { __typename?: 'ehr_procedure', id: any, name: Ehr_Procedure_Type_Enum_Enum } }> }> };

export type EhrProductListDeleteMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type EhrProductListDeleteMutation = { __typename?: 'mutation_root', update_ehr_product_by_pk?: { __typename?: 'ehr_product', id: any, deletedAt?: any | null | undefined } | null | undefined };

export type EhrProductListCreateMutationVariables = Exact<{
  name: Scalars['String'];
  photoS3Key?: Maybe<Scalars['uuid']>;
  dosages: Array<Scalars['numeric']> | Scalars['numeric'];
  unitsText?: Maybe<Scalars['String']>;
  ehrProceduresData: Array<Ehr_Procedure_Ehr_Product_Insert_Input> | Ehr_Procedure_Ehr_Product_Insert_Input;
}>;


export type EhrProductListCreateMutation = { __typename?: 'mutation_root', insert_ehr_product_one?: { __typename?: 'ehr_product', id: any, name: string, deletedAt?: any | null | undefined, photoS3Key?: any | null | undefined, dosages: Array<any>, unitsText: string, ehr_procedure_ehr_products: Array<{ __typename?: 'ehr_procedure_ehr_product', ehrProduct: any, ehrProcedure: any }> } | null | undefined };

export type EhrProductListUpdateMutationVariables = Exact<{
  id: Scalars['uuid'];
  name: Scalars['String'];
  photoS3Key?: Maybe<Scalars['uuid']>;
  dosages: Array<Scalars['numeric']> | Scalars['numeric'];
  unitsText?: Maybe<Scalars['String']>;
  insertObjects: Array<Ehr_Procedure_Ehr_Product_Insert_Input> | Ehr_Procedure_Ehr_Product_Insert_Input;
  ehrProduct: Scalars['uuid'];
  ehrProceduresToDelete: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type EhrProductListUpdateMutation = { __typename?: 'mutation_root', update_ehr_product_by_pk?: { __typename?: 'ehr_product', id: any, name: string, deletedAt?: any | null | undefined, photoS3Key?: any | null | undefined, dosages: Array<any>, unitsText: string, ehr_procedure_ehr_products: Array<{ __typename?: 'ehr_procedure_ehr_product', ehrProduct: any, ehrProcedure: any, ehrProcedureByEhrProcedure: { __typename?: 'ehr_procedure', id: any, name: Ehr_Procedure_Type_Enum_Enum } }> } | null | undefined, insert_ehr_procedure_ehr_product?: { __typename?: 'ehr_procedure_ehr_product_mutation_response', returning: Array<{ __typename?: 'ehr_procedure_ehr_product', ehrProcedure: any, ehrProduct: any, ehrProductByEhrProduct: { __typename?: 'ehr_product', id: any, name: string } }> } | null | undefined, delete_ehr_procedure_ehr_product?: { __typename?: 'ehr_procedure_ehr_product_mutation_response', returning: Array<{ __typename?: 'ehr_procedure_ehr_product', ehrProduct: any, ehrProcedure: any, ehrProductByEhrProduct: { __typename?: 'ehr_product', id: any, name: string } }> } | null | undefined };

export type AllLocationFragment = { __typename?: 'location', id: any, name: string, timezone: string, deleted_at?: any | null | undefined, addressByAddress: { __typename?: 'address', id: any, line1: string, line2?: string | null | undefined, city: string, state: string, zipcode: string } };

export type LocationListQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationListQuery = { __typename?: 'query_root', location: Array<{ __typename?: 'location', id: any, name: string, timezone: string, deleted_at?: any | null | undefined, bookingAllowed: boolean, providerPlanRequired: boolean, parentLocation?: any | null | undefined, usesParentLocationPlans: boolean, providerDirectProductPurchase: boolean, providerDirectPurchaseProfitMargin?: number | null | undefined, licenseDocumentRequired: boolean, licenseExpirationRequired: boolean, malpracticeRequired: boolean, medicalDirectorRequired: boolean, addressByAddress: { __typename?: 'address', id: any, line1: string, line2?: string | null | undefined, city: string, state: string, zipcode: string }, partnerByPartner: { __typename?: 'partner', id: any, name: string }, parentLocationByLocation?: { __typename?: 'location', id: any, name: string } | null | undefined, childLocationByLocation_aggregate: { __typename?: 'location_aggregate', aggregate?: { __typename?: 'location_aggregate_fields', count: number } | null | undefined } }> };

export type LocationDeleteMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type LocationDeleteMutation = { __typename?: 'mutation_root', update_location_by_pk?: { __typename?: 'location', id: any, deleted_at?: any | null | undefined } | null | undefined, delete_user_location?: { __typename?: 'user_location_mutation_response', returning: Array<{ __typename?: 'user_location', user: any, location: any }> } | null | undefined };

export type LocationCreateMutationVariables = Exact<{
  object: Location_Insert_Input;
  location: Scalars['uuid'];
}>;


export type LocationCreateMutation = { __typename?: 'mutation_root', insert_location_one?: { __typename?: 'location', id: any, name: string, timezone: string, deleted_at?: any | null | undefined, providerDirectProductPurchase: boolean, usesParentLocationPlans: boolean, providerDirectPurchaseProfitMargin?: number | null | undefined, providerPlanRequired: boolean, licenseDocumentRequired: boolean, licenseExpirationRequired: boolean, malpracticeRequired: boolean, medicalDirectorRequired: boolean, partnerByPartner: { __typename?: 'partner', id: any, name: string }, parentLocationByLocation?: { __typename?: 'location', id: any, name: string, childLocationByLocation_aggregate: { __typename?: 'location_aggregate', aggregate?: { __typename?: 'location_aggregate_fields', count: number } | null | undefined } } | null | undefined, addressByAddress: { __typename?: 'address', id: any, line1: string, line2?: string | null | undefined, city: string, state: string, zipcode: string } } | null | undefined, insert_tax_rate?: { __typename?: 'tax_rate_mutation_response', returning: Array<{ __typename?: 'tax_rate', location: any, name: string, rate: any, type: Tax_Type_Enum, id: any }> } | null | undefined };

export type LocationUpdateVansanityAdminMutationVariables = Exact<{
  id: Scalars['uuid'];
  addressId: Scalars['uuid'];
  name: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  city: Scalars['String'];
  zipcode: Scalars['String'];
  timezone: Scalars['String'];
  usesParentLocationPlans: Scalars['Boolean'];
  parentLocation?: Maybe<Scalars['uuid']>;
  partner: Scalars['uuid'];
  bookingAllowed: Scalars['Boolean'];
  providerDirectProductPurchase: Scalars['Boolean'];
  providerDirectPurchaseProfitMargin?: Maybe<Scalars['Int']>;
  providerPlanRequired: Scalars['Boolean'];
  licenseDocumentRequired: Scalars['Boolean'];
  licenseExpirationRequired: Scalars['Boolean'];
  malpracticeRequired: Scalars['Boolean'];
  medicalDirectorRequired: Scalars['Boolean'];
}>;


export type LocationUpdateVansanityAdminMutation = { __typename?: 'mutation_root', update_location_by_pk?: { __typename?: 'location', id: any, name: string, timezone: string, deleted_at?: any | null | undefined, bookingAllowed: boolean, providerPlanRequired: boolean, providerDirectProductPurchase: boolean, providerDirectPurchaseProfitMargin?: number | null | undefined, licenseDocumentRequired: boolean, licenseExpirationRequired: boolean, malpracticeRequired: boolean, medicalDirectorRequired: boolean, usesParentLocationPlans: boolean, partnerByPartner: { __typename?: 'partner', id: any, name: string }, parentLocationByLocation?: { __typename?: 'location', id: any, name: string, childLocationByLocation_aggregate: { __typename?: 'location_aggregate', aggregate?: { __typename?: 'location_aggregate_fields', count: number } | null | undefined } } | null | undefined, addressByAddress: { __typename?: 'address', id: any, line1: string, line2?: string | null | undefined, city: string, state: string, zipcode: string } } | null | undefined, update_address_by_pk?: { __typename?: 'address', id: any, city: string, line1: string, line2?: string | null | undefined, state: string, zipcode: string } | null | undefined };

export type LocationUpdateLocationAdminMutationVariables = Exact<{
  id: Scalars['uuid'];
  addressId: Scalars['uuid'];
  name: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  city: Scalars['String'];
  zipcode: Scalars['String'];
  timezone: Scalars['String'];
  providerDirectPurchaseProfitMargin?: Maybe<Scalars['Int']>;
  providerPlanRequired: Scalars['Boolean'];
  licenseDocumentRequired: Scalars['Boolean'];
  licenseExpirationRequired: Scalars['Boolean'];
  malpracticeRequired: Scalars['Boolean'];
  medicalDirectorRequired: Scalars['Boolean'];
}>;


export type LocationUpdateLocationAdminMutation = { __typename?: 'mutation_root', update_location_by_pk?: { __typename?: 'location', id: any, name: string, timezone: string, deleted_at?: any | null | undefined, bookingAllowed: boolean, providerPlanRequired: boolean, providerDirectPurchaseProfitMargin?: number | null | undefined, licenseDocumentRequired: boolean, licenseExpirationRequired: boolean, malpracticeRequired: boolean, medicalDirectorRequired: boolean, usesParentLocationPlans: boolean, partnerByPartner: { __typename?: 'partner', id: any, name: string }, parentLocationByLocation?: { __typename?: 'location', id: any, name: string, childLocationByLocation_aggregate: { __typename?: 'location_aggregate', aggregate?: { __typename?: 'location_aggregate_fields', count: number } | null | undefined } } | null | undefined, addressByAddress: { __typename?: 'address', id: any, line1: string, line2?: string | null | undefined, city: string, state: string, zipcode: string } } | null | undefined, update_address_by_pk?: { __typename?: 'address', id: any, city: string, line1: string, line2?: string | null | undefined, state: string, zipcode: string } | null | undefined };

export type CreateNewMsoMutationVariables = Exact<{
  location: Scalars['uuid'];
  msoSetupEmail: Scalars['String'];
  msoName: Scalars['String'];
}>;


export type CreateNewMsoMutation = { __typename?: 'mutation_root', createNewMso: { __typename?: 'CreateNewMsoOutput', id: any, name: string } };

export type GetLocationPurchasesToProviderPurchasesQueryVariables = Exact<{
  range_end: Scalars['timestamptz'];
  range_start: Scalars['timestamptz'];
}>;


export type GetLocationPurchasesToProviderPurchasesQuery = { __typename?: 'query_root', get_location_purchases_to_provider_purchases_query: Array<{ __typename?: 'fn_get_location_purchases_to_provider_purchases_query', provider_purchases_total: any, location_purchases_total: any, location: any }> };

export type ProceduresListQueryVariables = Exact<{ [key: string]: never; }>;


export type ProceduresListQuery = { __typename?: 'query_root', procedure: Array<{ __typename?: 'procedure', id: any, name: string, createdAt: any, model?: any | null | undefined, modelByModel?: { __typename?: 'model', id: any, name: string } | null | undefined }> };

export type DeleteProcedureMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteProcedureMutation = { __typename?: 'mutation_root', update_procedure_by_pk?: { __typename?: 'procedure', id: any, deletedAt?: any | null | undefined } | null | undefined };

export type CreateProcedureMutationVariables = Exact<{
  name: Scalars['String'];
  model?: Maybe<Scalars['uuid']>;
}>;


export type CreateProcedureMutation = { __typename?: 'mutation_root', insert_procedure_one?: { __typename?: 'procedure', id: any, name: string, createdAt: any, model?: any | null | undefined, modelByModel?: { __typename?: 'model', id: any, name: string } | null | undefined } | null | undefined };

export type UpdateProcedureMutationVariables = Exact<{
  id: Scalars['uuid'];
  name: Scalars['String'];
  model?: Maybe<Scalars['uuid']>;
}>;


export type UpdateProcedureMutation = { __typename?: 'mutation_root', update_procedure_by_pk?: { __typename?: 'procedure', id: any, name: string, deletedAt?: any | null | undefined, createdAt: any, model?: any | null | undefined, modelByModel?: { __typename?: 'model', id: any, name: string } | null | undefined } | null | undefined };

export type ListLocationProceduresQueryVariables = Exact<{
  _in: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type ListLocationProceduresQuery = { __typename?: 'query_root', location_procedure: Array<{ __typename?: 'location_procedure', id: any, location: any, procedure: any, createdAt: any, procedureByProcedure: { __typename?: 'procedure', id: any, name: string }, location_procedure_rooms: Array<{ __typename?: 'location_procedure_room', id: any, room: any, locationProcedure: any, roomByRoom: { __typename?: 'room', id: any, name?: string | null | undefined } }>, locationByLocation: { __typename?: 'location', id: any, rooms_aggregate: { __typename?: 'room_aggregate', aggregate?: { __typename?: 'room_aggregate_fields', count: number } | null | undefined } } }> };

export type DeleteLocationProcedureMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteLocationProcedureMutation = { __typename?: 'mutation_root', update_location_procedure_by_pk?: { __typename?: 'location_procedure', id: any, deletedAt?: any | null | undefined } | null | undefined, delete_location_procedure_room?: { __typename?: 'location_procedure_room_mutation_response', affected_rows: number } | null | undefined };

export type CreateLocationProcedureMutationVariables = Exact<{
  location: Scalars['uuid'];
  procedure: Scalars['uuid'];
  roomAssignments: Array<Location_Procedure_Room_Insert_Input> | Location_Procedure_Room_Insert_Input;
}>;


export type CreateLocationProcedureMutation = { __typename?: 'mutation_root', insert_location_procedure_one?: { __typename?: 'location_procedure', id: any, createdAt: any, location: any, procedure: any, procedureByProcedure: { __typename?: 'procedure', id: any, name: string }, location_procedure_rooms: Array<{ __typename?: 'location_procedure_room', id: any, room: any, locationProcedure: any }> } | null | undefined };

export type UpdateLocationProcedureMutationVariables = Exact<{
  addedRooms: Array<Location_Procedure_Room_Insert_Input> | Location_Procedure_Room_Insert_Input;
  deletedRoomIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type UpdateLocationProcedureMutation = { __typename?: 'mutation_root', insert_location_procedure_room?: { __typename?: 'location_procedure_room_mutation_response', returning: Array<{ __typename?: 'location_procedure_room', locationProcedureByLocationProcedure: { __typename?: 'location_procedure', id: any, location_procedure_rooms: Array<{ __typename?: 'location_procedure_room', id: any, locationProcedure: any, room: any }> } }> } | null | undefined, delete_location_procedure_room?: { __typename?: 'location_procedure_room_mutation_response', returning: Array<{ __typename?: 'location_procedure_room', locationProcedureByLocationProcedure: { __typename?: 'location_procedure', id: any, location_procedure_rooms: Array<{ __typename?: 'location_procedure_room', id: any, locationProcedure: any, room: any }> } }> } | null | undefined };

export type ProductListQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductListQuery = { __typename?: 'query_root', product: Array<{ __typename?: 'product', id: any, name: string, price: number, taxExempt: boolean, description: string, deleted_at?: any | null | undefined, isPrescription: boolean, photoS3Key?: any | null | undefined, product_type?: { __typename?: 'product_type', id: any, type: string } | null | undefined }> };

export type ProductListDeleteMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type ProductListDeleteMutation = { __typename?: 'mutation_root', update_product_by_pk?: { __typename?: 'product', id: any, deleted_at?: any | null | undefined } | null | undefined, delete_location_product?: { __typename?: 'location_product_mutation_response', returning: Array<{ __typename?: 'location_product', location: any, product: any }> } | null | undefined };

export type ProductListCreateMutationVariables = Exact<{
  name: Scalars['String'];
  description: Scalars['String'];
  taxExempt: Scalars['Boolean'];
  price: Scalars['Int'];
  isPrescription: Scalars['Boolean'];
  type?: Maybe<Scalars['uuid']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
}>;


export type ProductListCreateMutation = { __typename?: 'mutation_root', insert_product_one?: { __typename?: 'product', id: any, name: string, taxExempt: boolean, description: string, price: number, deleted_at?: any | null | undefined, isPrescription: boolean, photoS3Key?: any | null | undefined, product_type?: { __typename?: 'product_type', id: any, type: string } | null | undefined } | null | undefined };

export type ProductListUpdateMutationVariables = Exact<{
  id: Scalars['uuid'];
  name: Scalars['String'];
  description: Scalars['String'];
  taxExempt: Scalars['Boolean'];
  price: Scalars['Int'];
  isPrescription: Scalars['Boolean'];
  type?: Maybe<Scalars['uuid']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
}>;


export type ProductListUpdateMutation = { __typename?: 'mutation_root', update_product_by_pk?: { __typename?: 'product', id: any, name: string, taxExempt: boolean, price: number, description: string, isPrescription: boolean, photoS3Key?: any | null | undefined, product_type?: { __typename?: 'product_type', id: any, type: string } | null | undefined } | null | undefined };

export type RoomListQueryVariables = Exact<{
  _in: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type RoomListQuery = { __typename?: 'query_root', room: Array<{ __typename?: 'room', id: any, name?: string | null | undefined, description: string, rate: number, weeklyRate?: number | null | undefined, monthlyRate?: number | null | undefined, weeklyRateNonMedical?: number | null | undefined, monthlyRateNonMedical?: number | null | undefined, deleted_at?: any | null | undefined, allowVolumeDiscount: boolean, photoS3Key?: any | null | undefined, locationByLocation: { __typename?: 'location', id: any, name: string }, roomTypeByRoomType?: { __typename?: 'room_type', id: any, name: string } | null | undefined, location_procedure_rooms: Array<{ __typename?: 'location_procedure_room', id: any, room: any, locationProcedure: any, locationProcedureByLocationProcedure: { __typename?: 'location_procedure', id: any, procedureByProcedure: { __typename?: 'procedure', id: any, name: string } } }> }> };

export type RoomDeleteMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type RoomDeleteMutation = { __typename?: 'mutation_root', update_room_by_pk?: { __typename?: 'room', id: any, name?: string | null | undefined, description: string, rate: number, deleted_at?: any | null | undefined, allowVolumeDiscount: boolean, photoS3Key?: any | null | undefined, locationByLocation: { __typename?: 'location', id: any, name: string } } | null | undefined, delete_location_procedure_room?: { __typename?: 'location_procedure_room_mutation_response', returning: Array<{ __typename?: 'location_procedure_room', id: any }> } | null | undefined };

export type RoomCreateMutationVariables = Exact<{
  name: Scalars['String'];
  description: Scalars['String'];
  rate: Scalars['Int'];
  monthlyRate?: Maybe<Scalars['Int']>;
  weeklyRate?: Maybe<Scalars['Int']>;
  monthlyRateNonMedical?: Maybe<Scalars['Int']>;
  weeklyRateNonMedical?: Maybe<Scalars['Int']>;
  location: Scalars['uuid'];
  allowVolumeDiscount: Scalars['Boolean'];
  roomType?: Maybe<Scalars['uuid']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
  locationProcedures: Array<Location_Procedure_Room_Insert_Input> | Location_Procedure_Room_Insert_Input;
}>;


export type RoomCreateMutation = { __typename?: 'mutation_root', insert_room_one?: { __typename?: 'room', id: any, name?: string | null | undefined, description: string, rate: number, weeklyRate?: number | null | undefined, monthlyRate?: number | null | undefined, weeklyRateNonMedical?: number | null | undefined, monthlyRateNonMedical?: number | null | undefined, deleted_at?: any | null | undefined, allowVolumeDiscount: boolean, photoS3Key?: any | null | undefined, locationByLocation: { __typename?: 'location', id: any, name: string }, roomTypeByRoomType?: { __typename?: 'room_type', id: any, name: string } | null | undefined, location_procedure_rooms: Array<{ __typename?: 'location_procedure_room', id: any, room: any, locationProcedure: any, locationProcedureByLocationProcedure: { __typename?: 'location_procedure', id: any, procedureByProcedure: { __typename?: 'procedure', id: any, name: string } } }> } | null | undefined };

export type RoomUpdateMutationVariables = Exact<{
  id: Scalars['uuid'];
  name: Scalars['String'];
  description: Scalars['String'];
  rate: Scalars['Int'];
  monthlyRate?: Maybe<Scalars['Int']>;
  weeklyRate?: Maybe<Scalars['Int']>;
  monthlyRateNonMedical?: Maybe<Scalars['Int']>;
  weeklyRateNonMedical?: Maybe<Scalars['Int']>;
  allowVolumeDiscount: Scalars['Boolean'];
  roomType?: Maybe<Scalars['uuid']>;
  photoS3Key?: Maybe<Scalars['uuid']>;
  addProcedures: Array<Location_Procedure_Room_Insert_Input> | Location_Procedure_Room_Insert_Input;
  deleteProcedureIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type RoomUpdateMutation = { __typename?: 'mutation_root', update_room_by_pk?: { __typename?: 'room', id: any, name?: string | null | undefined, deleted_at?: any | null | undefined, description: string, allowVolumeDiscount: boolean, rate: number, weeklyRate?: number | null | undefined, monthlyRate?: number | null | undefined, weeklyRateNonMedical?: number | null | undefined, monthlyRateNonMedical?: number | null | undefined, photoS3Key?: any | null | undefined, locationByLocation: { __typename?: 'location', id: any, name: string }, roomTypeByRoomType?: { __typename?: 'room_type', id: any, name: string } | null | undefined } | null | undefined, insert_location_procedure_room?: { __typename?: 'location_procedure_room_mutation_response', returning: Array<{ __typename?: 'location_procedure_room', id: any, locationProcedure: any, room: any }> } | null | undefined, delete_location_procedure_room?: { __typename?: 'location_procedure_room_mutation_response', returning: Array<{ __typename?: 'location_procedure_room', id: any }> } | null | undefined };

export type UserListQueryVariables = Exact<{
  _in: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type UserListQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: any, active: boolean, firstName?: string | null | undefined, lastName?: string | null | undefined, role: Role_Enum, stripeCustomerId?: string | null | undefined, deleted_at?: any | null | undefined, malpracticeExpiration?: any | null | undefined, accreditation?: Accreditation_Enum | null | undefined, licenseExpiration?: any | null | undefined, userLocations: Array<{ __typename?: 'user_location', user: any, location: any, locationByLocation: { __typename?: 'location', id: any, name: string } }>, user_documents: Array<{ __typename?: 'user_document', id: any, type: Document_Type_Enum, created_at: any }>, users_unfulfilled_product_purchases_count_by_locations: Array<{ __typename?: 'fn_users_unfulfilled_product_purchases_count_by_location', user: any, location: any, unitsUnfulfilled: any }> }> };

export type UserDeleteMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type UserDeleteMutation = { __typename?: 'mutation_root', update_user_by_pk?: { __typename?: 'user', id: any, active: boolean, firstName?: string | null | undefined, lastName?: string | null | undefined, role: Role_Enum, stripeCustomerId?: string | null | undefined, deleted_at?: any | null | undefined, userLocations: Array<{ __typename?: 'user_location', user: any, location: any, locationByLocation: { __typename?: 'location', name: string, id: any } }> } | null | undefined };

export type UserCreateMutationVariables = Exact<{
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  role?: Maybe<Role_Enum>;
  userLocations?: Maybe<User_Location_Arr_Rel_Insert_Input>;
  active?: Maybe<Scalars['Boolean']>;
}>;


export type UserCreateMutation = { __typename?: 'mutation_root', insert_user_one?: { __typename?: 'user', id: any, active: boolean, firstName?: string | null | undefined, lastName?: string | null | undefined, role: Role_Enum, stripeCustomerId?: string | null | undefined, deleted_at?: any | null | undefined, userLocations: Array<{ __typename?: 'user_location', user: any, location: any, locationByLocation: { __typename?: 'location', id: any, name: string } }> } | null | undefined };

export type UserUpdateMutationVariables = Exact<{
  id: Scalars['uuid'];
  active: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  role: Role_Enum;
  insertLocations: Array<User_Location_Insert_Input> | User_Location_Insert_Input;
  deleteLocations: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type UserUpdateMutation = { __typename?: 'mutation_root', delete_user_location?: { __typename?: 'user_location_mutation_response', returning: Array<{ __typename?: 'user_location', location: any, user: any }> } | null | undefined, insert_user_location?: { __typename?: 'user_location_mutation_response', returning: Array<{ __typename?: 'user_location', user: any, location: any }> } | null | undefined, update_user_by_pk?: { __typename?: 'user', id: any, active: boolean, firstName?: string | null | undefined, lastName?: string | null | undefined, role: Role_Enum, stripeCustomerId?: string | null | undefined, userLocations: Array<{ __typename?: 'user_location', user: any, location: any, locationByLocation: { __typename?: 'location', id: any, name: string } }> } | null | undefined };

export type UserPurchaseToRentalRatioQueryVariables = Exact<{
  ratio_range_end: Scalars['timestamptz'];
  ratio_range_start_90: Scalars['timestamptz'];
  ratio_range_start_180: Scalars['timestamptz'];
  location: Scalars['uuid'];
}>;


export type UserPurchaseToRentalRatioQuery = { __typename?: 'query_root', days_180: Array<{ __typename?: 'fn_get_user_products_to_rentals_query', user: any, rentals_cost: any, products_cost: any }>, days_90: Array<{ __typename?: 'fn_get_user_products_to_rentals_query', user: any, rentals_cost: any, products_cost: any }> };

export type ProductPurchaseUnfulfilledStreamQueryVariables = Exact<{
  location_param: Scalars['uuid'];
}>;


export type ProductPurchaseUnfulfilledStreamQuery = { __typename?: 'query_root', users_unfulfilled_product_purchases_count_by_location: Array<{ __typename?: 'fn_users_unfulfilled_product_purchases_count_by_location', location: any, unitsUnfulfilled: any, user: any }> };

export type GetIsVansanityQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetIsVansanityQuery = { __typename?: 'query_root', location_by_pk?: { __typename?: 'location', id: any, partnerByPartner: { __typename?: 'partner', id: any, isVansanity: boolean } } | null | undefined };

export type GetCognitoUserDetailQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetCognitoUserDetailQuery = { __typename?: 'query_root', getCognitoUser?: { __typename?: 'getCognitoUserOutput', id: any, phone: string, phone_verified: boolean, email: string, email_verified: boolean } | null | undefined };

export type UpdateUserDetailPersonalMutationVariables = Exact<{
  id: Scalars['uuid'];
  insertAddressObjects: Array<Address_Insert_Input> | Address_Insert_Input;
  updateAddressObject?: Maybe<Address_Set_Input>;
  updateAddresses: Array<Scalars['uuid']> | Scalars['uuid'];
  addressId: Scalars['uuid'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}>;


export type UpdateUserDetailPersonalMutation = { __typename?: 'mutation_root', insert_address?: { __typename?: 'address_mutation_response', returning: Array<{ __typename?: 'address', id: any, city: string, line1: string, line2?: string | null | undefined, state: string, zipcode: string }> } | null | undefined, update_address?: { __typename?: 'address_mutation_response', returning: Array<{ __typename?: 'address', id: any, city: string, line1: string, line2?: string | null | undefined, state: string, zipcode: string }> } | null | undefined, update_user_by_pk?: { __typename?: 'user', id: any, firstName?: string | null | undefined, lastName?: string | null | undefined, address?: any | null | undefined } | null | undefined };

export type UpdateUserDetailSettingsMutationVariables = Exact<{
  id: Scalars['uuid'];
  active: Scalars['Boolean'];
  accreditation?: Maybe<Accreditation_Enum>;
  role: Role_Enum;
  licenseExpiration?: Maybe<Scalars['date']>;
  locationsDelete: Array<Scalars['uuid']> | Scalars['uuid'];
  locationsInsert: Array<User_Location_Insert_Input> | User_Location_Insert_Input;
  malpracticeExpiration?: Maybe<Scalars['date']>;
  unsubscribedFromNotifications: Scalars['Boolean'];
}>;


export type UpdateUserDetailSettingsMutation = { __typename?: 'mutation_root', update_user_by_pk?: { __typename?: 'user', id: any, accreditation?: Accreditation_Enum | null | undefined, active: boolean, role: Role_Enum, licenseExpiration?: any | null | undefined } | null | undefined, delete_user_location?: { __typename?: 'user_location_mutation_response', affected_rows: number } | null | undefined, insert_user_location?: { __typename?: 'user_location_mutation_response', returning: Array<{ __typename?: 'user_location', user: any, location: any }> } | null | undefined };

export type CreateStripeCustomerUserDetailBillingMutationVariables = Exact<{
  userId: Scalars['uuid'];
  cognitoUsername: Scalars['String'];
}>;


export type CreateStripeCustomerUserDetailBillingMutation = { __typename?: 'mutation_root', createStripeCustomer?: { __typename?: 'CreateStripeCustomerOutput', userId: any, stripeCustomerId: string } | null | undefined };

export type CheckCognitoUserConfirmedQueryVariables = Exact<{
  user_id: Scalars['uuid'];
}>;


export type CheckCognitoUserConfirmedQuery = { __typename?: 'query_root', getCognitoUser?: { __typename?: 'getCognitoUserOutput', id: any, phone_verified: boolean, user_status: string } | null | undefined };

export type ConfirmCognitoUserMutationVariables = Exact<{
  user_id: Scalars['uuid'];
}>;


export type ConfirmCognitoUserMutation = { __typename?: 'mutation_root', confirmCognitoUser?: { __typename?: 'confirmCognitoUserOutput', status: string } | null | undefined };

export type GetUserDocumentUrlsQueryVariables = Exact<{
  user: Scalars['uuid'];
}>;


export type GetUserDocumentUrlsQuery = { __typename?: 'query_root', getDownloadDocumentUrl: Array<{ __typename?: 'GetDownloadDocumentUrlOutputItem', id: any, original_name: string, type: string, url: string, created_at: any }> };

export type InsertUserDocumentMutationVariables = Exact<{
  type: Document_Type_Enum;
  s3Name: Scalars['uuid'];
  originalName: Scalars['String'];
  user: Scalars['uuid'];
}>;


export type InsertUserDocumentMutation = { __typename?: 'mutation_root', insert_user_document_one?: { __typename?: 'user_document', id: any, s3Name: any, originalName: string, type: Document_Type_Enum, updated_at: any } | null | undefined };

export type DataForUserLocationRemovalValidationQueryVariables = Exact<{
  user: Scalars['uuid'];
  locations: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type DataForUserLocationRemovalValidationQuery = { __typename?: 'query_root', user_plan_aggregate: { __typename?: 'user_plan_aggregate', aggregate?: { __typename?: 'user_plan_aggregate_fields', count: number } | null | undefined }, invoice_aggregate: { __typename?: 'invoice_aggregate', aggregate?: { __typename?: 'invoice_aggregate_fields', count: number } | null | undefined }, product_purchase: Array<{ __typename?: 'product_purchase', id: any, units: number, units_fulfilled: number }> };

export type GetHostedInvoiceQueryVariables = Exact<{
  invoiceId: Scalars['String'];
  provider?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['uuid']>;
}>;


export type GetHostedInvoiceQuery = { __typename?: 'query_root', getHostedInvoiceUrl: { __typename?: 'GetHostedInvoiceUrlOutput', hostedInvoiceUrl: string } };

export type InsertAddressSharedMutationVariables = Exact<{
  userId: Scalars['uuid'];
  addressId: Scalars['uuid'];
  address: Address_Insert_Input;
}>;


export type InsertAddressSharedMutation = { __typename?: 'mutation_root', insert_address_one?: { __typename?: 'address', id: any, city: string, line1: string, line2?: string | null | undefined, state: string, zipcode: string } | null | undefined, update_user_by_pk?: { __typename?: 'user', id: any, address?: any | null | undefined } | null | undefined };

export type UpdateAddressSharedMutationVariables = Exact<{
  id: Scalars['uuid'];
  _set: Address_Set_Input;
}>;


export type UpdateAddressSharedMutation = { __typename?: 'mutation_root', update_address_by_pk?: { __typename?: 'address', id: any, city: string, line1: string, line2?: string | null | undefined, state: string, zipcode: string } | null | undefined };

export type CreateCheckoutSessionSharedMutationVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type CreateCheckoutSessionSharedMutation = { __typename?: 'mutation_root', createCheckoutSession: { __typename?: 'CreateCheckoutSessionOutput', id: string, stripeCustomerId: string } };

export type GetDocumentUploadUrlSharedQueryVariables = Exact<{
  user: Scalars['uuid'];
  count: Scalars['Int'];
  types?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetDocumentUploadUrlSharedQuery = { __typename?: 'query_root', getUploadDocumentUrl?: Array<{ __typename?: 'GetUploadDocumentUrlOutputItem', id: string, url: string } | null | undefined> | null | undefined };

export type GetPhotoUploadUrlSharedQueryVariables = Exact<{
  user: Scalars['uuid'];
  types: Array<Scalars['String']> | Scalars['String'];
  ehrPhotoType?: Maybe<EhrPhotoType>;
}>;


export type GetPhotoUploadUrlSharedQuery = { __typename?: 'query_root', getUploadPhotoUrl: Array<{ __typename?: 'GetUploadPhotoUrlOutput', id: string, url: string }> };

export type InsertUserAgreementsSharedMutationVariables = Exact<{
  objects: Array<User_Agreements_Insert_Input> | User_Agreements_Insert_Input;
}>;


export type InsertUserAgreementsSharedMutation = { __typename?: 'mutation_root', insert_user_agreements?: { __typename?: 'user_agreements_mutation_response', returning: Array<{ __typename?: 'user_agreements', id: any, type: Agreement_Type_Enum, user: any, version: number }> } | null | undefined };

export type InsertUserDocumentSharedMutationVariables = Exact<{
  objects: Array<User_Document_Insert_Input> | User_Document_Insert_Input;
}>;


export type InsertUserDocumentSharedMutation = { __typename?: 'mutation_root', insert_user_document?: { __typename?: 'user_document_mutation_response', returning: Array<{ __typename?: 'user_document', id: any, s3Name: any, originalName: string, type: Document_Type_Enum, updated_at: any, user: any, created_at: any }> } | null | undefined };

export type PurchaseProductSharedMutationVariables = Exact<{
  objects: Array<Product_Purchase_Insert_Input> | Product_Purchase_Insert_Input;
}>;


export type PurchaseProductSharedMutation = { __typename?: 'mutation_root', insert_product_purchase?: { __typename?: 'product_purchase_mutation_response', returning: Array<{ __typename?: 'product_purchase', id: any, booking?: any | null | undefined, location: any, price: number, product: any, user: any, locationProduct?: { __typename?: 'location_product', product: any, location: any, stock: number } | null | undefined }> } | null | undefined };

export type UpdateUserSharedMutationVariables = Exact<{
  id: Scalars['uuid'];
  _set: User_Set_Input;
}>;


export type UpdateUserSharedMutation = { __typename?: 'mutation_root', update_user_by_pk?: { __typename?: 'user', id: any, accreditation?: Accreditation_Enum | null | undefined, active: boolean, address?: any | null | undefined, cognitoUserSub: any, created_at?: any | null | undefined, deleted_at?: any | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, licenseExpiration?: any | null | undefined, role: Role_Enum, stripeCustomerId?: string | null | undefined, updated_at?: any | null | undefined, malpracticeExpiration?: any | null | undefined } | null | undefined };

export type MedicalDirectorQueryVariables = Exact<{
  accreditation: Accreditation_Enum;
  location: Scalars['uuid'];
}>;


export type MedicalDirectorQuery = { __typename?: 'query_root', accreditation_location_privilege: Array<{ __typename?: 'accreditation_location_privilege', canBookWithoutDirector: boolean, accreditation: Accreditation_Enum, location: any }> };

export type MedicalDirectorRequiredLocationQueryVariables = Exact<{
  location: Scalars['uuid'];
}>;


export type MedicalDirectorRequiredLocationQuery = { __typename?: 'query_root', accreditation_location_privilege: Array<{ __typename?: 'accreditation_location_privilege', canBookWithoutDirector: boolean, accreditation: Accreditation_Enum, location: any }> };

export type GetUserDetailSharedQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserDetailSharedQuery = { __typename?: 'query_root', user_by_pk?: { __typename?: 'user', active: boolean, cognitoUserSub: any, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined, role: Role_Enum, stripeCustomerId?: string | null | undefined, accreditation?: Accreditation_Enum | null | undefined, licenseExpiration?: any | null | undefined, malpracticeExpiration?: any | null | undefined, unsubscribedFromNotifications: boolean, addressByAddress?: { __typename?: 'address', id: any, city: string, line1: string, line2?: string | null | undefined, state: string, zipcode: string } | null | undefined, userLocations: Array<{ __typename?: 'user_location', user: any, location: any, locationByLocation: { __typename?: 'location', name: string } }> } | null | undefined };

export type LocationDetailQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type LocationDetailQuery = { __typename?: 'query_root', location_by_pk?: { __typename?: 'location', id: any, name: string, timezone: string } | null | undefined };

export type AllRoomsQueryVariables = Exact<{
  _in?: Maybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type AllRoomsQuery = { __typename?: 'query_root', room: Array<{ __typename?: 'room', id: any, name?: string | null | undefined, deleted_at?: any | null | undefined, locationByLocation: { __typename?: 'location', timezone: string, name: string, id: any } }> };

export type AllLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllLocationsQuery = { __typename?: 'query_root', location: Array<{ __typename?: 'location', id: any, name: string, timezone: string, partnerByPartner: { __typename?: 'partner', msoMode: Mso_Mode_Enum } }> };

export type AllRoomTypesQueryVariables = Exact<{
  _in: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type AllRoomTypesQuery = { __typename?: 'query_root', room_type: Array<{ __typename?: 'room_type', id: any, name: string }> };

export type AllPlanTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPlanTypesQuery = { __typename?: 'query_root', plan_type: Array<{ __typename?: 'plan_type', id: string }> };

export type AllCreditTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCreditTypesQuery = { __typename?: 'query_root', credit_type: Array<{ __typename?: 'credit_type', id: string }> };

export type AllTaxRatesQueryVariables = Exact<{
  _in?: Maybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type AllTaxRatesQuery = { __typename?: 'query_root', tax_rate: Array<{ __typename?: 'tax_rate', id: any, location: any, rate: any, type: Tax_Type_Enum, name: string }> };

export type AllModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllModelsQuery = { __typename?: 'query_root', model: Array<{ __typename?: 'model', id: any, name: string, deleted_at?: any | null | undefined }> };

export type AllProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllProductsQuery = { __typename?: 'query_root', product: Array<{ __typename?: 'product', id: any, name: string, deleted_at?: any | null | undefined, taxExempt: boolean }> };

export type AllProvidersQueryVariables = Exact<{
  _in?: Maybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type AllProvidersQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: any, firstName?: string | null | undefined, lastName?: string | null | undefined, active: boolean }> };

export type AllUsersQueryVariables = Exact<{
  _in?: Maybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type AllUsersQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: any, firstName?: string | null | undefined, lastName?: string | null | undefined, active: boolean, role: Role_Enum, stripeCustomerId?: string | null | undefined }> };

export type AllRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllRolesQuery = { __typename?: 'query_root', role: Array<{ __typename?: 'role', id: string }> };

export type AllAccreditationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAccreditationsQuery = { __typename?: 'query_root', accreditation: Array<{ __typename?: 'accreditation', id: string }> };

export type AllEhrProcedureTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllEhrProcedureTypesQuery = { __typename?: 'query_root', ehr_procedure_type: Array<{ __typename?: 'ehr_procedure_type_enum', id: string }> };

export type AllPlansQueryVariables = Exact<{
  _in?: Maybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type AllPlansQuery = { __typename?: 'query_root', plan: Array<{ __typename?: 'plan', id: any, location: any, name: string, type: Plan_Type_Enum }> };

export type AllCurrentPlansQueryVariables = Exact<{
  _in: Scalars['uuid'];
}>;


export type AllCurrentPlansQuery = { __typename?: 'query_root', get_cumulative_location_plans: Array<{ __typename?: 'plan', id: any, location: any, name: string, type: Plan_Type_Enum }> };

export type AllProductTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type AllProductTypeQuery = { __typename?: 'query_root', product_type: Array<{ __typename?: 'product_type', id: any, type: string }> };

export type AllParentLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllParentLocationsQuery = { __typename?: 'query_root', location: Array<{ __typename?: 'location', id: any, name: string }> };

export type AllBookableUsersQueryVariables = Exact<{
  _in: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type AllBookableUsersQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: any, firstName?: string | null | undefined, lastName?: string | null | undefined, active: boolean }> };

export type AllPartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPartnersQuery = { __typename?: 'query_root', partner_basic: Array<{ __typename?: 'partner_basic', id?: any | null | undefined, name?: string | null | undefined }> };

export type AllProceduresQueryVariables = Exact<{ [key: string]: never; }>;


export type AllProceduresQuery = { __typename?: 'query_root', procedure: Array<{ __typename?: 'procedure', id: any, name: string }> };

export type AllLocationProceduresQueryVariables = Exact<{
  _eq: Scalars['uuid'];
}>;


export type AllLocationProceduresQuery = { __typename?: 'query_root', location_procedure: Array<{ __typename?: 'location_procedure', id: any, location: any, procedure: any, deleted_at?: any | null | undefined, procedureByProcedure: { __typename?: 'procedure', id: any, name: string } }> };

export type AllMsoTiersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllMsoTiersQuery = { __typename?: 'query_root', mso_tier: Array<{ __typename?: 'mso_tier', tier: string }> };

export type AllMsoModesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllMsoModesQuery = { __typename?: 'query_root', mso_mode: Array<{ __typename?: 'mso_mode', mode: string }> };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteUserMutation = { __typename?: 'mutation_root', deleteCognitoUser: { __typename?: 'DeleteCognitoUserOutput', id: any } };

export const EhrSubscriptionEraFieldsFragmentDoc = gql`
    fragment EhrSubscriptionEraFields on ehr_subscription {
  id
  provider
  partner
  status
  createdAt
  endedAt
  tierTerms(where: {endedAt: {_is_null: true}}) {
    id
    tier
    endedAt
  }
}
    `;
export const AllLocationFragmentDoc = gql`
    fragment AllLocation on location {
  id
  name
  timezone
  deleted_at
  addressByAddress {
    id
    line1
    line2
    city
    state
    zipcode
  }
}
    `;
export const AccreditationLocationPrivilegeListDocument = gql`
    query AccreditationLocationPrivilegeList($_in: [uuid!]!) {
  accreditation_location_privilege(where: {location: {_in: $_in}}) {
    location
    accreditation
    canPurchasePrescriptionProducts
    canBookWithoutDirector
  }
}
    `;

/**
 * __useAccreditationLocationPrivilegeListQuery__
 *
 * To run a query within a React component, call `useAccreditationLocationPrivilegeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccreditationLocationPrivilegeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccreditationLocationPrivilegeListQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useAccreditationLocationPrivilegeListQuery(baseOptions: Apollo.QueryHookOptions<AccreditationLocationPrivilegeListQuery, AccreditationLocationPrivilegeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccreditationLocationPrivilegeListQuery, AccreditationLocationPrivilegeListQueryVariables>(AccreditationLocationPrivilegeListDocument, options);
      }
export function useAccreditationLocationPrivilegeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccreditationLocationPrivilegeListQuery, AccreditationLocationPrivilegeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccreditationLocationPrivilegeListQuery, AccreditationLocationPrivilegeListQueryVariables>(AccreditationLocationPrivilegeListDocument, options);
        }
export type AccreditationLocationPrivilegeListQueryHookResult = ReturnType<typeof useAccreditationLocationPrivilegeListQuery>;
export type AccreditationLocationPrivilegeListLazyQueryHookResult = ReturnType<typeof useAccreditationLocationPrivilegeListLazyQuery>;
export type AccreditationLocationPrivilegeListQueryResult = Apollo.QueryResult<AccreditationLocationPrivilegeListQuery, AccreditationLocationPrivilegeListQueryVariables>;
export const AccreditationLocationPrivilegeCreateDocument = gql`
    mutation AccreditationLocationPrivilegeCreate($accreditation: accreditation_enum!, $canPurchasePrescriptionProducts: Boolean!, $canBookWithoutDirector: Boolean!, $location: uuid!) {
  insert_accreditation_location_privilege_one(
    object: {location: $location, canPurchasePrescriptionProducts: $canPurchasePrescriptionProducts, canBookWithoutDirector: $canBookWithoutDirector, accreditation: $accreditation}
  ) {
    accreditation
    canPurchasePrescriptionProducts
    canBookWithoutDirector
    location
  }
}
    `;
export type AccreditationLocationPrivilegeCreateMutationFn = Apollo.MutationFunction<AccreditationLocationPrivilegeCreateMutation, AccreditationLocationPrivilegeCreateMutationVariables>;

/**
 * __useAccreditationLocationPrivilegeCreateMutation__
 *
 * To run a mutation, you first call `useAccreditationLocationPrivilegeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccreditationLocationPrivilegeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accreditationLocationPrivilegeCreateMutation, { data, loading, error }] = useAccreditationLocationPrivilegeCreateMutation({
 *   variables: {
 *      accreditation: // value for 'accreditation'
 *      canPurchasePrescriptionProducts: // value for 'canPurchasePrescriptionProducts'
 *      canBookWithoutDirector: // value for 'canBookWithoutDirector'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useAccreditationLocationPrivilegeCreateMutation(baseOptions?: Apollo.MutationHookOptions<AccreditationLocationPrivilegeCreateMutation, AccreditationLocationPrivilegeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccreditationLocationPrivilegeCreateMutation, AccreditationLocationPrivilegeCreateMutationVariables>(AccreditationLocationPrivilegeCreateDocument, options);
      }
export type AccreditationLocationPrivilegeCreateMutationHookResult = ReturnType<typeof useAccreditationLocationPrivilegeCreateMutation>;
export type AccreditationLocationPrivilegeCreateMutationResult = Apollo.MutationResult<AccreditationLocationPrivilegeCreateMutation>;
export type AccreditationLocationPrivilegeCreateMutationOptions = Apollo.BaseMutationOptions<AccreditationLocationPrivilegeCreateMutation, AccreditationLocationPrivilegeCreateMutationVariables>;
export const AccreditationLocationPrivilegeUpdateDocument = gql`
    mutation AccreditationLocationPrivilegeUpdate($accreditation: accreditation_enum!, $location: uuid!, $canPurchasePrescriptionProducts: Boolean!, $canBookWithoutDirector: Boolean!) {
  update_accreditation_location_privilege_by_pk(
    pk_columns: {accreditation: $accreditation, location: $location}
    _set: {canPurchasePrescriptionProducts: $canPurchasePrescriptionProducts, canBookWithoutDirector: $canBookWithoutDirector}
  ) {
    location
    canPurchasePrescriptionProducts
    canBookWithoutDirector
    accreditation
  }
}
    `;
export type AccreditationLocationPrivilegeUpdateMutationFn = Apollo.MutationFunction<AccreditationLocationPrivilegeUpdateMutation, AccreditationLocationPrivilegeUpdateMutationVariables>;

/**
 * __useAccreditationLocationPrivilegeUpdateMutation__
 *
 * To run a mutation, you first call `useAccreditationLocationPrivilegeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccreditationLocationPrivilegeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accreditationLocationPrivilegeUpdateMutation, { data, loading, error }] = useAccreditationLocationPrivilegeUpdateMutation({
 *   variables: {
 *      accreditation: // value for 'accreditation'
 *      location: // value for 'location'
 *      canPurchasePrescriptionProducts: // value for 'canPurchasePrescriptionProducts'
 *      canBookWithoutDirector: // value for 'canBookWithoutDirector'
 *   },
 * });
 */
export function useAccreditationLocationPrivilegeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AccreditationLocationPrivilegeUpdateMutation, AccreditationLocationPrivilegeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccreditationLocationPrivilegeUpdateMutation, AccreditationLocationPrivilegeUpdateMutationVariables>(AccreditationLocationPrivilegeUpdateDocument, options);
      }
export type AccreditationLocationPrivilegeUpdateMutationHookResult = ReturnType<typeof useAccreditationLocationPrivilegeUpdateMutation>;
export type AccreditationLocationPrivilegeUpdateMutationResult = Apollo.MutationResult<AccreditationLocationPrivilegeUpdateMutation>;
export type AccreditationLocationPrivilegeUpdateMutationOptions = Apollo.BaseMutationOptions<AccreditationLocationPrivilegeUpdateMutation, AccreditationLocationPrivilegeUpdateMutationVariables>;
export const AccreditationLocationPrivilegeDeleteDocument = gql`
    mutation AccreditationLocationPrivilegeDelete($accreditation: accreditation_enum!, $location: uuid!) {
  delete_accreditation_location_privilege_by_pk(
    accreditation: $accreditation
    location: $location
  ) {
    location
    accreditation
  }
}
    `;
export type AccreditationLocationPrivilegeDeleteMutationFn = Apollo.MutationFunction<AccreditationLocationPrivilegeDeleteMutation, AccreditationLocationPrivilegeDeleteMutationVariables>;

/**
 * __useAccreditationLocationPrivilegeDeleteMutation__
 *
 * To run a mutation, you first call `useAccreditationLocationPrivilegeDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccreditationLocationPrivilegeDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accreditationLocationPrivilegeDeleteMutation, { data, loading, error }] = useAccreditationLocationPrivilegeDeleteMutation({
 *   variables: {
 *      accreditation: // value for 'accreditation'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useAccreditationLocationPrivilegeDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AccreditationLocationPrivilegeDeleteMutation, AccreditationLocationPrivilegeDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccreditationLocationPrivilegeDeleteMutation, AccreditationLocationPrivilegeDeleteMutationVariables>(AccreditationLocationPrivilegeDeleteDocument, options);
      }
export type AccreditationLocationPrivilegeDeleteMutationHookResult = ReturnType<typeof useAccreditationLocationPrivilegeDeleteMutation>;
export type AccreditationLocationPrivilegeDeleteMutationResult = Apollo.MutationResult<AccreditationLocationPrivilegeDeleteMutation>;
export type AccreditationLocationPrivilegeDeleteMutationOptions = Apollo.BaseMutationOptions<AccreditationLocationPrivilegeDeleteMutation, AccreditationLocationPrivilegeDeleteMutationVariables>;
export const GetPortabilityDataDocument = gql`
    query GetPortabilityData($model: uuid!, $location: uuid!, $lowerBound: timestamptz!, $upperBound: timestamptz!) {
  model_count(
    where: {deleted_at: {_is_null: true}, location: {_eq: $location}, model: {_eq: $model}, modelByModel: {deleted_at: {_is_null: true}}, _and: [{timespan_lower: {_lt: $upperBound}}, {timespan_upper: {_gt: $lowerBound}}]}
    limit: 1
  ) {
    id
    count
    timespan
  }
  room_model_aggregate(
    where: {_and: [{timespan_lower: {_lt: $upperBound}}, {timespan_upper: {_gt: $lowerBound}}], roomByRoom: {location: {_eq: $location}}, modelByModel: {deleted_at: {_is_null: true}}, deleted_at: {_is_null: true}, model: {_eq: $model}}
  ) {
    aggregate {
      count
    }
  }
  booked_portable: booking_aggregate(
    where: {cancelled_at: {_is_null: true}, timespan_lower: {_lt: $upperBound}, timespan_upper: {_gt: $lowerBound}, model: {_eq: $model}, location: {_eq: $location}, room: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
  booked_with_room: booking_aggregate(
    where: {cancelled_at: {_is_null: true}, timespan_lower: {_lt: $upperBound}, timespan_upper: {_gt: $lowerBound}, model: {_eq: $model}, location: {_eq: $location}, room: {_is_null: false}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetPortabilityDataQuery__
 *
 * To run a query within a React component, call `useGetPortabilityDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortabilityDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortabilityDataQuery({
 *   variables: {
 *      model: // value for 'model'
 *      location: // value for 'location'
 *      lowerBound: // value for 'lowerBound'
 *      upperBound: // value for 'upperBound'
 *   },
 * });
 */
export function useGetPortabilityDataQuery(baseOptions: Apollo.QueryHookOptions<GetPortabilityDataQuery, GetPortabilityDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortabilityDataQuery, GetPortabilityDataQueryVariables>(GetPortabilityDataDocument, options);
      }
export function useGetPortabilityDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortabilityDataQuery, GetPortabilityDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortabilityDataQuery, GetPortabilityDataQueryVariables>(GetPortabilityDataDocument, options);
        }
export type GetPortabilityDataQueryHookResult = ReturnType<typeof useGetPortabilityDataQuery>;
export type GetPortabilityDataLazyQueryHookResult = ReturnType<typeof useGetPortabilityDataLazyQuery>;
export type GetPortabilityDataQueryResult = Apollo.QueryResult<GetPortabilityDataQuery, GetPortabilityDataQueryVariables>;
export const AvailableRoomOptionsDocument = gql`
    query AvailableRoomOptions($location: uuid!, $model: uuid!, $lowerBound: timestamptz!, $upperBound: timestamptz!) {
  room(
    where: {location: {_eq: $location}, deleted_at: {_is_null: true}, _not: {bookings: {cancelled_at: {_is_null: true}, timespan_lower: {_lt: $upperBound}, timespan_upper: {_gt: $lowerBound}}}, roomModels: {deleted_at: {_is_null: true}, model: {_eq: $model}, timespan_lower: {_lt: $upperBound}, timespan_upper: {_gt: $lowerBound}}}
  ) {
    id
    name
    rate
  }
}
    `;

/**
 * __useAvailableRoomOptionsQuery__
 *
 * To run a query within a React component, call `useAvailableRoomOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableRoomOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableRoomOptionsQuery({
 *   variables: {
 *      location: // value for 'location'
 *      model: // value for 'model'
 *      lowerBound: // value for 'lowerBound'
 *      upperBound: // value for 'upperBound'
 *   },
 * });
 */
export function useAvailableRoomOptionsQuery(baseOptions: Apollo.QueryHookOptions<AvailableRoomOptionsQuery, AvailableRoomOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableRoomOptionsQuery, AvailableRoomOptionsQueryVariables>(AvailableRoomOptionsDocument, options);
      }
export function useAvailableRoomOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableRoomOptionsQuery, AvailableRoomOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableRoomOptionsQuery, AvailableRoomOptionsQueryVariables>(AvailableRoomOptionsDocument, options);
        }
export type AvailableRoomOptionsQueryHookResult = ReturnType<typeof useAvailableRoomOptionsQuery>;
export type AvailableRoomOptionsLazyQueryHookResult = ReturnType<typeof useAvailableRoomOptionsLazyQuery>;
export type AvailableRoomOptionsQueryResult = Apollo.QueryResult<AvailableRoomOptionsQuery, AvailableRoomOptionsQueryVariables>;
export const GetBookingsDocument = gql`
    query GetBookings($_eq: uuid!) {
  booking(
    where: {cancelled_at: {_is_null: true}, _or: [{roomByRoom: {location: {_eq: $_eq}}}, {location: {_eq: $_eq}}]}
  ) {
    id
    title
    userByProvider {
      id
      firstName
      lastName
    }
    roomByRoom {
      name
      rate
      id
    }
    modelByModel {
      id
      name
    }
    model
    timespan
    modelRate
    roomRate
    modelTaxRate
    roomTaxRate
    recurringKey
  }
}
    `;

/**
 * __useGetBookingsQuery__
 *
 * To run a query within a React component, call `useGetBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingsQuery({
 *   variables: {
 *      _eq: // value for '_eq'
 *   },
 * });
 */
export function useGetBookingsQuery(baseOptions: Apollo.QueryHookOptions<GetBookingsQuery, GetBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingsQuery, GetBookingsQueryVariables>(GetBookingsDocument, options);
      }
export function useGetBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingsQuery, GetBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingsQuery, GetBookingsQueryVariables>(GetBookingsDocument, options);
        }
export type GetBookingsQueryHookResult = ReturnType<typeof useGetBookingsQuery>;
export type GetBookingsLazyQueryHookResult = ReturnType<typeof useGetBookingsLazyQuery>;
export type GetBookingsQueryResult = Apollo.QueryResult<GetBookingsQuery, GetBookingsQueryVariables>;
export const DeleteBookingByPkDocument = gql`
    mutation DeleteBookingByPK($id: uuid!) {
  removeBooking(id: $id) {
    credit_ids
    booking_id
  }
}
    `;
export type DeleteBookingByPkMutationFn = Apollo.MutationFunction<DeleteBookingByPkMutation, DeleteBookingByPkMutationVariables>;

/**
 * __useDeleteBookingByPkMutation__
 *
 * To run a mutation, you first call `useDeleteBookingByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookingByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookingByPkMutation, { data, loading, error }] = useDeleteBookingByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBookingByPkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookingByPkMutation, DeleteBookingByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBookingByPkMutation, DeleteBookingByPkMutationVariables>(DeleteBookingByPkDocument, options);
      }
export type DeleteBookingByPkMutationHookResult = ReturnType<typeof useDeleteBookingByPkMutation>;
export type DeleteBookingByPkMutationResult = Apollo.MutationResult<DeleteBookingByPkMutation>;
export type DeleteBookingByPkMutationOptions = Apollo.BaseMutationOptions<DeleteBookingByPkMutation, DeleteBookingByPkMutationVariables>;
export const GetOpensBookingDocument = gql`
    query getOpensBooking($_eq: uuid!) {
  open(where: {location: {_eq: $_eq}}, order_by: {timespan: asc}) {
    id
    location
    repeating
    timespan
  }
}
    `;

/**
 * __useGetOpensBookingQuery__
 *
 * To run a query within a React component, call `useGetOpensBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpensBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpensBookingQuery({
 *   variables: {
 *      _eq: // value for '_eq'
 *   },
 * });
 */
export function useGetOpensBookingQuery(baseOptions: Apollo.QueryHookOptions<GetOpensBookingQuery, GetOpensBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpensBookingQuery, GetOpensBookingQueryVariables>(GetOpensBookingDocument, options);
      }
export function useGetOpensBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpensBookingQuery, GetOpensBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpensBookingQuery, GetOpensBookingQueryVariables>(GetOpensBookingDocument, options);
        }
export type GetOpensBookingQueryHookResult = ReturnType<typeof useGetOpensBookingQuery>;
export type GetOpensBookingLazyQueryHookResult = ReturnType<typeof useGetOpensBookingLazyQuery>;
export type GetOpensBookingQueryResult = Apollo.QueryResult<GetOpensBookingQuery, GetOpensBookingQueryVariables>;
export const ModelForRoomsDocument = gql`
    query ModelForRooms($_in: [uuid!]!) {
  room_model(where: {room: {_in: $_in}}) {
    id
    room
    model
    timespan
    modelByModel {
      id
      name
    }
  }
}
    `;

/**
 * __useModelForRoomsQuery__
 *
 * To run a query within a React component, call `useModelForRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelForRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelForRoomsQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useModelForRoomsQuery(baseOptions: Apollo.QueryHookOptions<ModelForRoomsQuery, ModelForRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelForRoomsQuery, ModelForRoomsQueryVariables>(ModelForRoomsDocument, options);
      }
export function useModelForRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelForRoomsQuery, ModelForRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelForRoomsQuery, ModelForRoomsQueryVariables>(ModelForRoomsDocument, options);
        }
export type ModelForRoomsQueryHookResult = ReturnType<typeof useModelForRoomsQuery>;
export type ModelForRoomsLazyQueryHookResult = ReturnType<typeof useModelForRoomsLazyQuery>;
export type ModelForRoomsQueryResult = Apollo.QueryResult<ModelForRoomsQuery, ModelForRoomsQueryVariables>;
export const ProductsForBookingDocument = gql`
    query ProductsForBooking($_eq: uuid) {
  model_product(where: {model: {_eq: $_eq}}) {
    model
    product
    productByProduct {
      id
      name
      locationProducts {
        stock
        product
        location
      }
    }
  }
}
    `;

/**
 * __useProductsForBookingQuery__
 *
 * To run a query within a React component, call `useProductsForBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsForBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsForBookingQuery({
 *   variables: {
 *      _eq: // value for '_eq'
 *   },
 * });
 */
export function useProductsForBookingQuery(baseOptions?: Apollo.QueryHookOptions<ProductsForBookingQuery, ProductsForBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsForBookingQuery, ProductsForBookingQueryVariables>(ProductsForBookingDocument, options);
      }
export function useProductsForBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsForBookingQuery, ProductsForBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsForBookingQuery, ProductsForBookingQueryVariables>(ProductsForBookingDocument, options);
        }
export type ProductsForBookingQueryHookResult = ReturnType<typeof useProductsForBookingQuery>;
export type ProductsForBookingLazyQueryHookResult = ReturnType<typeof useProductsForBookingLazyQuery>;
export type ProductsForBookingQueryResult = Apollo.QueryResult<ProductsForBookingQuery, ProductsForBookingQueryVariables>;
export const DeleteRecurringBookingDocument = gql`
    mutation DeleteRecurringBooking($id: uuid!) {
  removeRepeatBooking(id: $id) {
    credit_id
    booking_ids
  }
}
    `;
export type DeleteRecurringBookingMutationFn = Apollo.MutationFunction<DeleteRecurringBookingMutation, DeleteRecurringBookingMutationVariables>;

/**
 * __useDeleteRecurringBookingMutation__
 *
 * To run a mutation, you first call `useDeleteRecurringBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecurringBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecurringBookingMutation, { data, loading, error }] = useDeleteRecurringBookingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRecurringBookingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecurringBookingMutation, DeleteRecurringBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecurringBookingMutation, DeleteRecurringBookingMutationVariables>(DeleteRecurringBookingDocument, options);
      }
export type DeleteRecurringBookingMutationHookResult = ReturnType<typeof useDeleteRecurringBookingMutation>;
export type DeleteRecurringBookingMutationResult = Apollo.MutationResult<DeleteRecurringBookingMutation>;
export type DeleteRecurringBookingMutationOptions = Apollo.BaseMutationOptions<DeleteRecurringBookingMutation, DeleteRecurringBookingMutationVariables>;
export const UserCreditListDocument = gql`
    query UserCreditList($user: uuid!, $_in: [uuid!]) {
  credit(
    where: {user: {_eq: $user}, deleted_at: {_is_null: true}, location: {_in: $_in}}
    order_by: {expiresAt: desc}
  ) {
    id
    description
    currentBalance
    initialBalance
    expiresAt
    user
    active
    type
    deleted_at
  }
}
    `;

/**
 * __useUserCreditListQuery__
 *
 * To run a query within a React component, call `useUserCreditListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCreditListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCreditListQuery({
 *   variables: {
 *      user: // value for 'user'
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useUserCreditListQuery(baseOptions: Apollo.QueryHookOptions<UserCreditListQuery, UserCreditListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCreditListQuery, UserCreditListQueryVariables>(UserCreditListDocument, options);
      }
export function useUserCreditListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCreditListQuery, UserCreditListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCreditListQuery, UserCreditListQueryVariables>(UserCreditListDocument, options);
        }
export type UserCreditListQueryHookResult = ReturnType<typeof useUserCreditListQuery>;
export type UserCreditListLazyQueryHookResult = ReturnType<typeof useUserCreditListLazyQuery>;
export type UserCreditListQueryResult = Apollo.QueryResult<UserCreditListQuery, UserCreditListQueryVariables>;
export const UserCreditDeleteDocument = gql`
    mutation UserCreditDelete($id: uuid!) {
  update_credit_by_pk(pk_columns: {id: $id}, _set: {deleted_at: "now()"}) {
    id
    deleted_at
  }
}
    `;
export type UserCreditDeleteMutationFn = Apollo.MutationFunction<UserCreditDeleteMutation, UserCreditDeleteMutationVariables>;

/**
 * __useUserCreditDeleteMutation__
 *
 * To run a mutation, you first call `useUserCreditDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreditDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreditDeleteMutation, { data, loading, error }] = useUserCreditDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserCreditDeleteMutation(baseOptions?: Apollo.MutationHookOptions<UserCreditDeleteMutation, UserCreditDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreditDeleteMutation, UserCreditDeleteMutationVariables>(UserCreditDeleteDocument, options);
      }
export type UserCreditDeleteMutationHookResult = ReturnType<typeof useUserCreditDeleteMutation>;
export type UserCreditDeleteMutationResult = Apollo.MutationResult<UserCreditDeleteMutation>;
export type UserCreditDeleteMutationOptions = Apollo.BaseMutationOptions<UserCreditDeleteMutation, UserCreditDeleteMutationVariables>;
export const UserCreditCreateDocument = gql`
    mutation UserCreditCreate($expiresAt: timestamptz, $description: String!, $initialBalance: Int!, $type: credit_type_enum!, $user: uuid!, $location: uuid!) {
  insert_credit_one(
    object: {initialBalance: $initialBalance, description: $description, expiresAt: $expiresAt, type: $type, user: $user, location: $location}
  ) {
    id
    description
    currentBalance
    initialBalance
    expiresAt
    user
    active
    type
    deleted_at
  }
}
    `;
export type UserCreditCreateMutationFn = Apollo.MutationFunction<UserCreditCreateMutation, UserCreditCreateMutationVariables>;

/**
 * __useUserCreditCreateMutation__
 *
 * To run a mutation, you first call `useUserCreditCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreditCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreditCreateMutation, { data, loading, error }] = useUserCreditCreateMutation({
 *   variables: {
 *      expiresAt: // value for 'expiresAt'
 *      description: // value for 'description'
 *      initialBalance: // value for 'initialBalance'
 *      type: // value for 'type'
 *      user: // value for 'user'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useUserCreditCreateMutation(baseOptions?: Apollo.MutationHookOptions<UserCreditCreateMutation, UserCreditCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreditCreateMutation, UserCreditCreateMutationVariables>(UserCreditCreateDocument, options);
      }
export type UserCreditCreateMutationHookResult = ReturnType<typeof useUserCreditCreateMutation>;
export type UserCreditCreateMutationResult = Apollo.MutationResult<UserCreditCreateMutation>;
export type UserCreditCreateMutationOptions = Apollo.BaseMutationOptions<UserCreditCreateMutation, UserCreditCreateMutationVariables>;
export const UserCreditUpdateDocument = gql`
    mutation UserCreditUpdate($id: uuid!, $expiresAt: timestamptz!, $description: String!, $currentBalance: Int!, $type: credit_type_enum!) {
  insert_credit_one(
    object: {currentBalance: $currentBalance, description: $description, expiresAt: $expiresAt, type: $type}
  ) {
    id
    description
    currentBalance
    initialBalance
    expiresAt
    active
    type
    deleted_at
  }
}
    `;
export type UserCreditUpdateMutationFn = Apollo.MutationFunction<UserCreditUpdateMutation, UserCreditUpdateMutationVariables>;

/**
 * __useUserCreditUpdateMutation__
 *
 * To run a mutation, you first call `useUserCreditUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreditUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreditUpdateMutation, { data, loading, error }] = useUserCreditUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      expiresAt: // value for 'expiresAt'
 *      description: // value for 'description'
 *      currentBalance: // value for 'currentBalance'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUserCreditUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserCreditUpdateMutation, UserCreditUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreditUpdateMutation, UserCreditUpdateMutationVariables>(UserCreditUpdateDocument, options);
      }
export type UserCreditUpdateMutationHookResult = ReturnType<typeof useUserCreditUpdateMutation>;
export type UserCreditUpdateMutationResult = Apollo.MutationResult<UserCreditUpdateMutation>;
export type UserCreditUpdateMutationOptions = Apollo.BaseMutationOptions<UserCreditUpdateMutation, UserCreditUpdateMutationVariables>;
export const ListDirectProviderPurchaseRequestsDocument = gql`
    query ListDirectProviderPurchaseRequests {
  provider_direct_purchase_web_admin_view(order_by: {createdAt: desc}) {
    id
    cancelledAt
    createdAt
    location
    locationName
    orderedAt
    packageTrackingCode
    partner
    partnerName
    product
    productName
    productPurchase
    provider
    providerFirstName
    providerLastName
    retailPrice
    units
    wholesalePrice
  }
}
    `;

/**
 * __useListDirectProviderPurchaseRequestsQuery__
 *
 * To run a query within a React component, call `useListDirectProviderPurchaseRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDirectProviderPurchaseRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDirectProviderPurchaseRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListDirectProviderPurchaseRequestsQuery(baseOptions?: Apollo.QueryHookOptions<ListDirectProviderPurchaseRequestsQuery, ListDirectProviderPurchaseRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDirectProviderPurchaseRequestsQuery, ListDirectProviderPurchaseRequestsQueryVariables>(ListDirectProviderPurchaseRequestsDocument, options);
      }
export function useListDirectProviderPurchaseRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDirectProviderPurchaseRequestsQuery, ListDirectProviderPurchaseRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDirectProviderPurchaseRequestsQuery, ListDirectProviderPurchaseRequestsQueryVariables>(ListDirectProviderPurchaseRequestsDocument, options);
        }
export type ListDirectProviderPurchaseRequestsQueryHookResult = ReturnType<typeof useListDirectProviderPurchaseRequestsQuery>;
export type ListDirectProviderPurchaseRequestsLazyQueryHookResult = ReturnType<typeof useListDirectProviderPurchaseRequestsLazyQuery>;
export type ListDirectProviderPurchaseRequestsQueryResult = Apollo.QueryResult<ListDirectProviderPurchaseRequestsQuery, ListDirectProviderPurchaseRequestsQueryVariables>;
export const DoNothing_DirectProviderPurchaseRequestsDocument = gql`
    mutation DoNothing_DirectProviderPurchaseRequests {
  update_provider_direct_product_purchase_by_pk(
    pk_columns: {id: "89583ee8-7587-4f9a-bf31-19d1b3cfd66e"}
    _set: {}
  ) {
    id
  }
}
    `;
export type DoNothing_DirectProviderPurchaseRequestsMutationFn = Apollo.MutationFunction<DoNothing_DirectProviderPurchaseRequestsMutation, DoNothing_DirectProviderPurchaseRequestsMutationVariables>;

/**
 * __useDoNothing_DirectProviderPurchaseRequestsMutation__
 *
 * To run a mutation, you first call `useDoNothing_DirectProviderPurchaseRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoNothing_DirectProviderPurchaseRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doNothingDirectProviderPurchaseRequestsMutation, { data, loading, error }] = useDoNothing_DirectProviderPurchaseRequestsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDoNothing_DirectProviderPurchaseRequestsMutation(baseOptions?: Apollo.MutationHookOptions<DoNothing_DirectProviderPurchaseRequestsMutation, DoNothing_DirectProviderPurchaseRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoNothing_DirectProviderPurchaseRequestsMutation, DoNothing_DirectProviderPurchaseRequestsMutationVariables>(DoNothing_DirectProviderPurchaseRequestsDocument, options);
      }
export type DoNothing_DirectProviderPurchaseRequestsMutationHookResult = ReturnType<typeof useDoNothing_DirectProviderPurchaseRequestsMutation>;
export type DoNothing_DirectProviderPurchaseRequestsMutationResult = Apollo.MutationResult<DoNothing_DirectProviderPurchaseRequestsMutation>;
export type DoNothing_DirectProviderPurchaseRequestsMutationOptions = Apollo.BaseMutationOptions<DoNothing_DirectProviderPurchaseRequestsMutation, DoNothing_DirectProviderPurchaseRequestsMutationVariables>;
export const UpdateDirectProviderPurchaseRequestDocument = gql`
    mutation UpdateDirectProviderPurchaseRequest($id: uuid!, $orderedAt: timestamptz, $trackingCode: String) {
  update_provider_direct_product_purchase_by_pk(
    pk_columns: {id: $id}
    _set: {orderedAt: $orderedAt, packageTrackingCode: $trackingCode}
  ) {
    id
    orderedAt
    packageTrackingCode
  }
}
    `;
export type UpdateDirectProviderPurchaseRequestMutationFn = Apollo.MutationFunction<UpdateDirectProviderPurchaseRequestMutation, UpdateDirectProviderPurchaseRequestMutationVariables>;

/**
 * __useUpdateDirectProviderPurchaseRequestMutation__
 *
 * To run a mutation, you first call `useUpdateDirectProviderPurchaseRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDirectProviderPurchaseRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDirectProviderPurchaseRequestMutation, { data, loading, error }] = useUpdateDirectProviderPurchaseRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      orderedAt: // value for 'orderedAt'
 *      trackingCode: // value for 'trackingCode'
 *   },
 * });
 */
export function useUpdateDirectProviderPurchaseRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDirectProviderPurchaseRequestMutation, UpdateDirectProviderPurchaseRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDirectProviderPurchaseRequestMutation, UpdateDirectProviderPurchaseRequestMutationVariables>(UpdateDirectProviderPurchaseRequestDocument, options);
      }
export type UpdateDirectProviderPurchaseRequestMutationHookResult = ReturnType<typeof useUpdateDirectProviderPurchaseRequestMutation>;
export type UpdateDirectProviderPurchaseRequestMutationResult = Apollo.MutationResult<UpdateDirectProviderPurchaseRequestMutation>;
export type UpdateDirectProviderPurchaseRequestMutationOptions = Apollo.BaseMutationOptions<UpdateDirectProviderPurchaseRequestMutation, UpdateDirectProviderPurchaseRequestMutationVariables>;
export const SetPurchaseForLocationDeletedMutationDocument = gql`
    mutation SetPurchaseForLocationDeletedMutation($id: uuid!) {
  update_purchase_for_location_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    id
    deletedAt
  }
}
    `;
export type SetPurchaseForLocationDeletedMutationMutationFn = Apollo.MutationFunction<SetPurchaseForLocationDeletedMutationMutation, SetPurchaseForLocationDeletedMutationMutationVariables>;

/**
 * __useSetPurchaseForLocationDeletedMutationMutation__
 *
 * To run a mutation, you first call `useSetPurchaseForLocationDeletedMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPurchaseForLocationDeletedMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPurchaseForLocationDeletedMutationMutation, { data, loading, error }] = useSetPurchaseForLocationDeletedMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetPurchaseForLocationDeletedMutationMutation(baseOptions?: Apollo.MutationHookOptions<SetPurchaseForLocationDeletedMutationMutation, SetPurchaseForLocationDeletedMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPurchaseForLocationDeletedMutationMutation, SetPurchaseForLocationDeletedMutationMutationVariables>(SetPurchaseForLocationDeletedMutationDocument, options);
      }
export type SetPurchaseForLocationDeletedMutationMutationHookResult = ReturnType<typeof useSetPurchaseForLocationDeletedMutationMutation>;
export type SetPurchaseForLocationDeletedMutationMutationResult = Apollo.MutationResult<SetPurchaseForLocationDeletedMutationMutation>;
export type SetPurchaseForLocationDeletedMutationMutationOptions = Apollo.BaseMutationOptions<SetPurchaseForLocationDeletedMutationMutation, SetPurchaseForLocationDeletedMutationMutationVariables>;
export const CreateMsoPurchaseRequestInvoiceDocument = gql`
    mutation CreateMsoPurchaseRequestInvoice($partnerId: uuid!, $productId: uuid!, $units: Int!, $location: uuid!, $purchaseRecordId: uuid!) {
  createMsoPurchaseRequestInvoice(
    partner_id: $partnerId
    product_id: $productId
    units: $units
    location: $location
    purchase_record_id: $purchaseRecordId
  ) {
    stripeInvoiceId
    stripeInvoiceUrl
    id
  }
}
    `;
export type CreateMsoPurchaseRequestInvoiceMutationFn = Apollo.MutationFunction<CreateMsoPurchaseRequestInvoiceMutation, CreateMsoPurchaseRequestInvoiceMutationVariables>;

/**
 * __useCreateMsoPurchaseRequestInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateMsoPurchaseRequestInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMsoPurchaseRequestInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMsoPurchaseRequestInvoiceMutation, { data, loading, error }] = useCreateMsoPurchaseRequestInvoiceMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      productId: // value for 'productId'
 *      units: // value for 'units'
 *      location: // value for 'location'
 *      purchaseRecordId: // value for 'purchaseRecordId'
 *   },
 * });
 */
export function useCreateMsoPurchaseRequestInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateMsoPurchaseRequestInvoiceMutation, CreateMsoPurchaseRequestInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMsoPurchaseRequestInvoiceMutation, CreateMsoPurchaseRequestInvoiceMutationVariables>(CreateMsoPurchaseRequestInvoiceDocument, options);
      }
export type CreateMsoPurchaseRequestInvoiceMutationHookResult = ReturnType<typeof useCreateMsoPurchaseRequestInvoiceMutation>;
export type CreateMsoPurchaseRequestInvoiceMutationResult = Apollo.MutationResult<CreateMsoPurchaseRequestInvoiceMutation>;
export type CreateMsoPurchaseRequestInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateMsoPurchaseRequestInvoiceMutation, CreateMsoPurchaseRequestInvoiceMutationVariables>;
export const GetEhrSubscriptionsDocument = gql`
    query GetEhrSubscriptions($userId: uuid!) {
  user_location(where: {user: {_eq: $userId}}) {
    user
    location
    locationByLocation {
      id
      partnerByPartner {
        id
        name
        msoMode
      }
    }
  }
  mine: ehr_subscription(where: {provider: {_eq: $userId}}) {
    ...EhrSubscriptionEraFields
  }
  mso: ehr_subscription(where: {partner: {_is_null: false}}) {
    ...EhrSubscriptionEraFields
  }
}
    ${EhrSubscriptionEraFieldsFragmentDoc}`;

/**
 * __useGetEhrSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetEhrSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEhrSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEhrSubscriptionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetEhrSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<GetEhrSubscriptionsQuery, GetEhrSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEhrSubscriptionsQuery, GetEhrSubscriptionsQueryVariables>(GetEhrSubscriptionsDocument, options);
      }
export function useGetEhrSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEhrSubscriptionsQuery, GetEhrSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEhrSubscriptionsQuery, GetEhrSubscriptionsQueryVariables>(GetEhrSubscriptionsDocument, options);
        }
export type GetEhrSubscriptionsQueryHookResult = ReturnType<typeof useGetEhrSubscriptionsQuery>;
export type GetEhrSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetEhrSubscriptionsLazyQuery>;
export type GetEhrSubscriptionsQueryResult = Apollo.QueryResult<GetEhrSubscriptionsQuery, GetEhrSubscriptionsQueryVariables>;
export const EnableEhrSubscriptionDocument = gql`
    mutation EnableEhrSubscription($tier: EhrTier!, $location: uuid!, $partner: uuid) {
  enableEhrSubscription(
    object: {tier: $tier, location: $location, partner: $partner}
  ) {
    id
    status
  }
}
    `;
export type EnableEhrSubscriptionMutationFn = Apollo.MutationFunction<EnableEhrSubscriptionMutation, EnableEhrSubscriptionMutationVariables>;

/**
 * __useEnableEhrSubscriptionMutation__
 *
 * To run a mutation, you first call `useEnableEhrSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableEhrSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableEhrSubscriptionMutation, { data, loading, error }] = useEnableEhrSubscriptionMutation({
 *   variables: {
 *      tier: // value for 'tier'
 *      location: // value for 'location'
 *      partner: // value for 'partner'
 *   },
 * });
 */
export function useEnableEhrSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<EnableEhrSubscriptionMutation, EnableEhrSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableEhrSubscriptionMutation, EnableEhrSubscriptionMutationVariables>(EnableEhrSubscriptionDocument, options);
      }
export type EnableEhrSubscriptionMutationHookResult = ReturnType<typeof useEnableEhrSubscriptionMutation>;
export type EnableEhrSubscriptionMutationResult = Apollo.MutationResult<EnableEhrSubscriptionMutation>;
export type EnableEhrSubscriptionMutationOptions = Apollo.BaseMutationOptions<EnableEhrSubscriptionMutation, EnableEhrSubscriptionMutationVariables>;
export const ChangeEhrTierDocument = gql`
    mutation ChangeEhrTier($tier: EhrTier!, $location: uuid!, $partner: uuid) {
  changeEhrTier(object: {tier: $tier, location: $location, partner: $partner}) {
    tier
  }
}
    `;
export type ChangeEhrTierMutationFn = Apollo.MutationFunction<ChangeEhrTierMutation, ChangeEhrTierMutationVariables>;

/**
 * __useChangeEhrTierMutation__
 *
 * To run a mutation, you first call `useChangeEhrTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEhrTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEhrTierMutation, { data, loading, error }] = useChangeEhrTierMutation({
 *   variables: {
 *      tier: // value for 'tier'
 *      location: // value for 'location'
 *      partner: // value for 'partner'
 *   },
 * });
 */
export function useChangeEhrTierMutation(baseOptions?: Apollo.MutationHookOptions<ChangeEhrTierMutation, ChangeEhrTierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeEhrTierMutation, ChangeEhrTierMutationVariables>(ChangeEhrTierDocument, options);
      }
export type ChangeEhrTierMutationHookResult = ReturnType<typeof useChangeEhrTierMutation>;
export type ChangeEhrTierMutationResult = Apollo.MutationResult<ChangeEhrTierMutation>;
export type ChangeEhrTierMutationOptions = Apollo.BaseMutationOptions<ChangeEhrTierMutation, ChangeEhrTierMutationVariables>;
export const CancelEhrSubscriptionDocument = gql`
    mutation CancelEhrSubscription($location: uuid!, $partner: uuid) {
  cancelEhrSubscription(object: {location: $location, partner: $partner}) {
    id
    status
  }
}
    `;
export type CancelEhrSubscriptionMutationFn = Apollo.MutationFunction<CancelEhrSubscriptionMutation, CancelEhrSubscriptionMutationVariables>;

/**
 * __useCancelEhrSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelEhrSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelEhrSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelEhrSubscriptionMutation, { data, loading, error }] = useCancelEhrSubscriptionMutation({
 *   variables: {
 *      location: // value for 'location'
 *      partner: // value for 'partner'
 *   },
 * });
 */
export function useCancelEhrSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelEhrSubscriptionMutation, CancelEhrSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelEhrSubscriptionMutation, CancelEhrSubscriptionMutationVariables>(CancelEhrSubscriptionDocument, options);
      }
export type CancelEhrSubscriptionMutationHookResult = ReturnType<typeof useCancelEhrSubscriptionMutation>;
export type CancelEhrSubscriptionMutationResult = Apollo.MutationResult<CancelEhrSubscriptionMutation>;
export type CancelEhrSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelEhrSubscriptionMutation, CancelEhrSubscriptionMutationVariables>;
export const UncancelEhrSubscriptionDocument = gql`
    mutation UncancelEhrSubscription($location: uuid!, $partner: uuid) {
  uncancelEhrSubscription(object: {location: $location, partner: $partner}) {
    id
    status
  }
}
    `;
export type UncancelEhrSubscriptionMutationFn = Apollo.MutationFunction<UncancelEhrSubscriptionMutation, UncancelEhrSubscriptionMutationVariables>;

/**
 * __useUncancelEhrSubscriptionMutation__
 *
 * To run a mutation, you first call `useUncancelEhrSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUncancelEhrSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uncancelEhrSubscriptionMutation, { data, loading, error }] = useUncancelEhrSubscriptionMutation({
 *   variables: {
 *      location: // value for 'location'
 *      partner: // value for 'partner'
 *   },
 * });
 */
export function useUncancelEhrSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UncancelEhrSubscriptionMutation, UncancelEhrSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UncancelEhrSubscriptionMutation, UncancelEhrSubscriptionMutationVariables>(UncancelEhrSubscriptionDocument, options);
      }
export type UncancelEhrSubscriptionMutationHookResult = ReturnType<typeof useUncancelEhrSubscriptionMutation>;
export type UncancelEhrSubscriptionMutationResult = Apollo.MutationResult<UncancelEhrSubscriptionMutation>;
export type UncancelEhrSubscriptionMutationOptions = Apollo.BaseMutationOptions<UncancelEhrSubscriptionMutation, UncancelEhrSubscriptionMutationVariables>;
export const GetFinancialReportDocument = gql`
    query GetFinancialReport($admin: uuid!, $end: String!, $start: String!, $location: uuid!) {
  getFinancialReport(admin: $admin, end: $end, start: $start, location: $location) {
    admin
    location
  }
}
    `;

/**
 * __useGetFinancialReportQuery__
 *
 * To run a query within a React component, call `useGetFinancialReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialReportQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      end: // value for 'end'
 *      start: // value for 'start'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetFinancialReportQuery(baseOptions: Apollo.QueryHookOptions<GetFinancialReportQuery, GetFinancialReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialReportQuery, GetFinancialReportQueryVariables>(GetFinancialReportDocument, options);
      }
export function useGetFinancialReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialReportQuery, GetFinancialReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialReportQuery, GetFinancialReportQueryVariables>(GetFinancialReportDocument, options);
        }
export type GetFinancialReportQueryHookResult = ReturnType<typeof useGetFinancialReportQuery>;
export type GetFinancialReportLazyQueryHookResult = ReturnType<typeof useGetFinancialReportLazyQuery>;
export type GetFinancialReportQueryResult = Apollo.QueryResult<GetFinancialReportQuery, GetFinancialReportQueryVariables>;
export const LocationProductListDocument = gql`
    query LocationProductList($_in: [uuid!]!) {
  location_product(
    where: {location: {_in: $_in}}
    order_by: {productByProduct: {name: asc}}
  ) {
    location
    product
    tax
    price
    stock
    warnAtStock
    photoS3Key
    taxRate {
      id
      name
      rate
      type
    }
    locationByLocation {
      id
      name
      providerDirectProductPurchase
      providerDirectPurchaseProfitMargin
    }
    productByProduct {
      id
      name
      price
      taxExempt
    }
    product_type {
      id
      type
    }
  }
}
    `;

/**
 * __useLocationProductListQuery__
 *
 * To run a query within a React component, call `useLocationProductListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationProductListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationProductListQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useLocationProductListQuery(baseOptions: Apollo.QueryHookOptions<LocationProductListQuery, LocationProductListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationProductListQuery, LocationProductListQueryVariables>(LocationProductListDocument, options);
      }
export function useLocationProductListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationProductListQuery, LocationProductListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationProductListQuery, LocationProductListQueryVariables>(LocationProductListDocument, options);
        }
export type LocationProductListQueryHookResult = ReturnType<typeof useLocationProductListQuery>;
export type LocationProductListLazyQueryHookResult = ReturnType<typeof useLocationProductListLazyQuery>;
export type LocationProductListQueryResult = Apollo.QueryResult<LocationProductListQuery, LocationProductListQueryVariables>;
export const LocationProductDeleteDocument = gql`
    mutation LocationProductDelete($product: uuid!, $location: uuid!) {
  delete_location_product_by_pk(location: $location, product: $product) {
    product
    location
  }
}
    `;
export type LocationProductDeleteMutationFn = Apollo.MutationFunction<LocationProductDeleteMutation, LocationProductDeleteMutationVariables>;

/**
 * __useLocationProductDeleteMutation__
 *
 * To run a mutation, you first call `useLocationProductDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocationProductDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locationProductDeleteMutation, { data, loading, error }] = useLocationProductDeleteMutation({
 *   variables: {
 *      product: // value for 'product'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useLocationProductDeleteMutation(baseOptions?: Apollo.MutationHookOptions<LocationProductDeleteMutation, LocationProductDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocationProductDeleteMutation, LocationProductDeleteMutationVariables>(LocationProductDeleteDocument, options);
      }
export type LocationProductDeleteMutationHookResult = ReturnType<typeof useLocationProductDeleteMutation>;
export type LocationProductDeleteMutationResult = Apollo.MutationResult<LocationProductDeleteMutation>;
export type LocationProductDeleteMutationOptions = Apollo.BaseMutationOptions<LocationProductDeleteMutation, LocationProductDeleteMutationVariables>;
export const LocationProductListCreateDocument = gql`
    mutation LocationProductListCreate($location: uuid!, $product: uuid!, $stock: Int!, $warnAtStock: Int, $price: Int, $tax: uuid!, $type: uuid, $photoS3Key: uuid) {
  insert_location_product_one(
    object: {location: $location, price: $price, product: $product, stock: $stock, warnAtStock: $warnAtStock, tax: $tax, type: $type, photoS3Key: $photoS3Key}
  ) {
    location
    product
    price
    stock
    warnAtStock
    tax
    photoS3Key
    product_type {
      id
      type
    }
  }
}
    `;
export type LocationProductListCreateMutationFn = Apollo.MutationFunction<LocationProductListCreateMutation, LocationProductListCreateMutationVariables>;

/**
 * __useLocationProductListCreateMutation__
 *
 * To run a mutation, you first call `useLocationProductListCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocationProductListCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locationProductListCreateMutation, { data, loading, error }] = useLocationProductListCreateMutation({
 *   variables: {
 *      location: // value for 'location'
 *      product: // value for 'product'
 *      stock: // value for 'stock'
 *      warnAtStock: // value for 'warnAtStock'
 *      price: // value for 'price'
 *      tax: // value for 'tax'
 *      type: // value for 'type'
 *      photoS3Key: // value for 'photoS3Key'
 *   },
 * });
 */
export function useLocationProductListCreateMutation(baseOptions?: Apollo.MutationHookOptions<LocationProductListCreateMutation, LocationProductListCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocationProductListCreateMutation, LocationProductListCreateMutationVariables>(LocationProductListCreateDocument, options);
      }
export type LocationProductListCreateMutationHookResult = ReturnType<typeof useLocationProductListCreateMutation>;
export type LocationProductListCreateMutationResult = Apollo.MutationResult<LocationProductListCreateMutation>;
export type LocationProductListCreateMutationOptions = Apollo.BaseMutationOptions<LocationProductListCreateMutation, LocationProductListCreateMutationVariables>;
export const LocationProductListUpdateDocument = gql`
    mutation LocationProductListUpdate($tax: uuid!, $location: uuid!, $product: uuid!, $stock: Int!, $warnAtStock: Int, $price: Int, $type: uuid, $photoS3Key: uuid) {
  update_location_product_by_pk(
    pk_columns: {location: $location, product: $product}
    _set: {price: $price, stock: $stock, warnAtStock: $warnAtStock, tax: $tax, type: $type, photoS3Key: $photoS3Key}
  ) {
    location
    product
    tax
    warnAtStock
    stock
    price
    photoS3Key
    product_type {
      id
      type
    }
  }
}
    `;
export type LocationProductListUpdateMutationFn = Apollo.MutationFunction<LocationProductListUpdateMutation, LocationProductListUpdateMutationVariables>;

/**
 * __useLocationProductListUpdateMutation__
 *
 * To run a mutation, you first call `useLocationProductListUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocationProductListUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locationProductListUpdateMutation, { data, loading, error }] = useLocationProductListUpdateMutation({
 *   variables: {
 *      tax: // value for 'tax'
 *      location: // value for 'location'
 *      product: // value for 'product'
 *      stock: // value for 'stock'
 *      warnAtStock: // value for 'warnAtStock'
 *      price: // value for 'price'
 *      type: // value for 'type'
 *      photoS3Key: // value for 'photoS3Key'
 *   },
 * });
 */
export function useLocationProductListUpdateMutation(baseOptions?: Apollo.MutationHookOptions<LocationProductListUpdateMutation, LocationProductListUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocationProductListUpdateMutation, LocationProductListUpdateMutationVariables>(LocationProductListUpdateDocument, options);
      }
export type LocationProductListUpdateMutationHookResult = ReturnType<typeof useLocationProductListUpdateMutation>;
export type LocationProductListUpdateMutationResult = Apollo.MutationResult<LocationProductListUpdateMutation>;
export type LocationProductListUpdateMutationOptions = Apollo.BaseMutationOptions<LocationProductListUpdateMutation, LocationProductListUpdateMutationVariables>;
export const ConfirmProductPurchaseDocument = gql`
    mutation ConfirmProductPurchase($ids: [uuid!]!) {
  confirmProductPurchase(ids: $ids) {
    stripeInvoiceId
  }
}
    `;
export type ConfirmProductPurchaseMutationFn = Apollo.MutationFunction<ConfirmProductPurchaseMutation, ConfirmProductPurchaseMutationVariables>;

/**
 * __useConfirmProductPurchaseMutation__
 *
 * To run a mutation, you first call `useConfirmProductPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmProductPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmProductPurchaseMutation, { data, loading, error }] = useConfirmProductPurchaseMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useConfirmProductPurchaseMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmProductPurchaseMutation, ConfirmProductPurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmProductPurchaseMutation, ConfirmProductPurchaseMutationVariables>(ConfirmProductPurchaseDocument, options);
      }
export type ConfirmProductPurchaseMutationHookResult = ReturnType<typeof useConfirmProductPurchaseMutation>;
export type ConfirmProductPurchaseMutationResult = Apollo.MutationResult<ConfirmProductPurchaseMutation>;
export type ConfirmProductPurchaseMutationOptions = Apollo.BaseMutationOptions<ConfirmProductPurchaseMutation, ConfirmProductPurchaseMutationVariables>;
export const LocationProductGlobalTypeListDocument = gql`
    query LocationProductGlobalTypeList {
  product {
    id
    photoS3Key
    product_type {
      id
      type
    }
  }
}
    `;

/**
 * __useLocationProductGlobalTypeListQuery__
 *
 * To run a query within a React component, call `useLocationProductGlobalTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationProductGlobalTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationProductGlobalTypeListQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocationProductGlobalTypeListQuery(baseOptions?: Apollo.QueryHookOptions<LocationProductGlobalTypeListQuery, LocationProductGlobalTypeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationProductGlobalTypeListQuery, LocationProductGlobalTypeListQueryVariables>(LocationProductGlobalTypeListDocument, options);
      }
export function useLocationProductGlobalTypeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationProductGlobalTypeListQuery, LocationProductGlobalTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationProductGlobalTypeListQuery, LocationProductGlobalTypeListQueryVariables>(LocationProductGlobalTypeListDocument, options);
        }
export type LocationProductGlobalTypeListQueryHookResult = ReturnType<typeof useLocationProductGlobalTypeListQuery>;
export type LocationProductGlobalTypeListLazyQueryHookResult = ReturnType<typeof useLocationProductGlobalTypeListLazyQuery>;
export type LocationProductGlobalTypeListQueryResult = Apollo.QueryResult<LocationProductGlobalTypeListQuery, LocationProductGlobalTypeListQueryVariables>;
export const CreatePurchaseForLocationDocument = gql`
    mutation CreatePurchaseForLocation($location: uuid!, $purchasedBy: uuid!, $units: Int!, $product: uuid!) {
  insert_purchase_for_location_one(
    object: {location: $location, purchasedBy: $purchasedBy, units: $units, product: $product}
  ) {
    id
  }
}
    `;
export type CreatePurchaseForLocationMutationFn = Apollo.MutationFunction<CreatePurchaseForLocationMutation, CreatePurchaseForLocationMutationVariables>;

/**
 * __useCreatePurchaseForLocationMutation__
 *
 * To run a mutation, you first call `useCreatePurchaseForLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePurchaseForLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPurchaseForLocationMutation, { data, loading, error }] = useCreatePurchaseForLocationMutation({
 *   variables: {
 *      location: // value for 'location'
 *      purchasedBy: // value for 'purchasedBy'
 *      units: // value for 'units'
 *      product: // value for 'product'
 *   },
 * });
 */
export function useCreatePurchaseForLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreatePurchaseForLocationMutation, CreatePurchaseForLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePurchaseForLocationMutation, CreatePurchaseForLocationMutationVariables>(CreatePurchaseForLocationDocument, options);
      }
export type CreatePurchaseForLocationMutationHookResult = ReturnType<typeof useCreatePurchaseForLocationMutation>;
export type CreatePurchaseForLocationMutationResult = Apollo.MutationResult<CreatePurchaseForLocationMutation>;
export type CreatePurchaseForLocationMutationOptions = Apollo.BaseMutationOptions<CreatePurchaseForLocationMutation, CreatePurchaseForLocationMutationVariables>;
export const ModelListDocument = gql`
    query ModelList {
  model {
    id
    name
    deleted_at
    photoS3Key
    procedures(where: {deletedAt: {_is_null: true}}, order_by: {name: asc}) {
      id
      name
    }
    modelProducts {
      model
      product
      productByProduct {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useModelListQuery__
 *
 * To run a query within a React component, call `useModelListQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelListQuery({
 *   variables: {
 *   },
 * });
 */
export function useModelListQuery(baseOptions?: Apollo.QueryHookOptions<ModelListQuery, ModelListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelListQuery, ModelListQueryVariables>(ModelListDocument, options);
      }
export function useModelListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelListQuery, ModelListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelListQuery, ModelListQueryVariables>(ModelListDocument, options);
        }
export type ModelListQueryHookResult = ReturnType<typeof useModelListQuery>;
export type ModelListLazyQueryHookResult = ReturnType<typeof useModelListLazyQuery>;
export type ModelListQueryResult = Apollo.QueryResult<ModelListQuery, ModelListQueryVariables>;
export const ModelDeleteDocument = gql`
    mutation ModelDelete($id: uuid!) {
  update_model_by_pk(pk_columns: {id: $id}, _set: {deleted_at: "now()"}) {
    id
    deleted_at
  }
  delete_model_product(where: {model: {_eq: $id}}) {
    returning {
      product
      model
    }
  }
}
    `;
export type ModelDeleteMutationFn = Apollo.MutationFunction<ModelDeleteMutation, ModelDeleteMutationVariables>;

/**
 * __useModelDeleteMutation__
 *
 * To run a mutation, you first call `useModelDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModelDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modelDeleteMutation, { data, loading, error }] = useModelDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useModelDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ModelDeleteMutation, ModelDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModelDeleteMutation, ModelDeleteMutationVariables>(ModelDeleteDocument, options);
      }
export type ModelDeleteMutationHookResult = ReturnType<typeof useModelDeleteMutation>;
export type ModelDeleteMutationResult = Apollo.MutationResult<ModelDeleteMutation>;
export type ModelDeleteMutationOptions = Apollo.BaseMutationOptions<ModelDeleteMutation, ModelDeleteMutationVariables>;
export const ModelCreateDocument = gql`
    mutation ModelCreate($name: String!, $photoS3Key: uuid, $modelProducts: model_product_arr_rel_insert_input, $procedures: procedure_arr_rel_insert_input) {
  insert_model_one(
    object: {name: $name, modelProducts: $modelProducts, photoS3Key: $photoS3Key, procedures: $procedures}
  ) {
    id
    name
    photoS3Key
    modelProducts {
      model
      product
    }
    procedures {
      id
      name
    }
  }
}
    `;
export type ModelCreateMutationFn = Apollo.MutationFunction<ModelCreateMutation, ModelCreateMutationVariables>;

/**
 * __useModelCreateMutation__
 *
 * To run a mutation, you first call `useModelCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModelCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modelCreateMutation, { data, loading, error }] = useModelCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      photoS3Key: // value for 'photoS3Key'
 *      modelProducts: // value for 'modelProducts'
 *      procedures: // value for 'procedures'
 *   },
 * });
 */
export function useModelCreateMutation(baseOptions?: Apollo.MutationHookOptions<ModelCreateMutation, ModelCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModelCreateMutation, ModelCreateMutationVariables>(ModelCreateDocument, options);
      }
export type ModelCreateMutationHookResult = ReturnType<typeof useModelCreateMutation>;
export type ModelCreateMutationResult = Apollo.MutationResult<ModelCreateMutation>;
export type ModelCreateMutationOptions = Apollo.BaseMutationOptions<ModelCreateMutation, ModelCreateMutationVariables>;
export const ModelUpdateDocument = gql`
    mutation ModelUpdate($id: uuid!, $name: String!, $deleted_products: [uuid!]!, $new_model_products: [model_product_insert_input!]!, $photoS3Key: uuid) {
  delete_model_product(
    where: {_and: {model: {_eq: $id}, product: {_in: $deleted_products}}}
  ) {
    affected_rows
  }
  insert_model_product(objects: $new_model_products) {
    returning {
      model
      product
    }
  }
  update_model_by_pk(
    pk_columns: {id: $id}
    _set: {name: $name, photoS3Key: $photoS3Key}
  ) {
    id
    name
    photoS3Key
    modelProducts {
      model
      product
    }
  }
}
    `;
export type ModelUpdateMutationFn = Apollo.MutationFunction<ModelUpdateMutation, ModelUpdateMutationVariables>;

/**
 * __useModelUpdateMutation__
 *
 * To run a mutation, you first call `useModelUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModelUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modelUpdateMutation, { data, loading, error }] = useModelUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      deleted_products: // value for 'deleted_products'
 *      new_model_products: // value for 'new_model_products'
 *      photoS3Key: // value for 'photoS3Key'
 *   },
 * });
 */
export function useModelUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ModelUpdateMutation, ModelUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModelUpdateMutation, ModelUpdateMutationVariables>(ModelUpdateDocument, options);
      }
export type ModelUpdateMutationHookResult = ReturnType<typeof useModelUpdateMutation>;
export type ModelUpdateMutationResult = Apollo.MutationResult<ModelUpdateMutation>;
export type ModelUpdateMutationOptions = Apollo.BaseMutationOptions<ModelUpdateMutation, ModelUpdateMutationVariables>;
export const ModelCountListDocument = gql`
    query ModelCountList($_in: [uuid!]!) {
  model_count(where: {location: {_in: $_in}}) {
    id
    timespan
    model
    count
    location
    rate
    deleted_at
    allowVolumeDiscount
    photoS3Key
    roomRequired
    allowNonMedicalUsers
    modelByModel {
      id
      name
    }
  }
}
    `;

/**
 * __useModelCountListQuery__
 *
 * To run a query within a React component, call `useModelCountListQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelCountListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelCountListQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useModelCountListQuery(baseOptions: Apollo.QueryHookOptions<ModelCountListQuery, ModelCountListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelCountListQuery, ModelCountListQueryVariables>(ModelCountListDocument, options);
      }
export function useModelCountListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelCountListQuery, ModelCountListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelCountListQuery, ModelCountListQueryVariables>(ModelCountListDocument, options);
        }
export type ModelCountListQueryHookResult = ReturnType<typeof useModelCountListQuery>;
export type ModelCountListLazyQueryHookResult = ReturnType<typeof useModelCountListLazyQuery>;
export type ModelCountListQueryResult = Apollo.QueryResult<ModelCountListQuery, ModelCountListQueryVariables>;
export const ModelCountDeleteListDocument = gql`
    mutation ModelCountDeleteList($id: uuid!) {
  update_model_count_by_pk(pk_columns: {id: $id}, _set: {deleted_at: "now()"}) {
    id
    deleted_at
  }
}
    `;
export type ModelCountDeleteListMutationFn = Apollo.MutationFunction<ModelCountDeleteListMutation, ModelCountDeleteListMutationVariables>;

/**
 * __useModelCountDeleteListMutation__
 *
 * To run a mutation, you first call `useModelCountDeleteListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModelCountDeleteListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modelCountDeleteListMutation, { data, loading, error }] = useModelCountDeleteListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useModelCountDeleteListMutation(baseOptions?: Apollo.MutationHookOptions<ModelCountDeleteListMutation, ModelCountDeleteListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModelCountDeleteListMutation, ModelCountDeleteListMutationVariables>(ModelCountDeleteListDocument, options);
      }
export type ModelCountDeleteListMutationHookResult = ReturnType<typeof useModelCountDeleteListMutation>;
export type ModelCountDeleteListMutationResult = Apollo.MutationResult<ModelCountDeleteListMutation>;
export type ModelCountDeleteListMutationOptions = Apollo.BaseMutationOptions<ModelCountDeleteListMutation, ModelCountDeleteListMutationVariables>;
export const ModelCountCreateListDocument = gql`
    mutation ModelCountCreateList($model: uuid!, $timespan: tstzrange!, $count: Int!, $location: uuid!, $rate: Int!, $allowVolumeDiscount: Boolean!, $photoS3Key: uuid, $roomRequired: Boolean!, $allowNonMedicalUsers: Boolean!) {
  insert_model_count_one(
    object: {model: $model, count: $count, timespan: $timespan, location: $location, rate: $rate, allowVolumeDiscount: $allowVolumeDiscount, photoS3Key: $photoS3Key, roomRequired: $roomRequired, allowNonMedicalUsers: $allowNonMedicalUsers}
  ) {
    model
    count
    timespan
    deleted_at
    location
    allowVolumeDiscount
    rate
    id
    photoS3Key
    roomRequired
    allowNonMedicalUsers
  }
}
    `;
export type ModelCountCreateListMutationFn = Apollo.MutationFunction<ModelCountCreateListMutation, ModelCountCreateListMutationVariables>;

/**
 * __useModelCountCreateListMutation__
 *
 * To run a mutation, you first call `useModelCountCreateListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModelCountCreateListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modelCountCreateListMutation, { data, loading, error }] = useModelCountCreateListMutation({
 *   variables: {
 *      model: // value for 'model'
 *      timespan: // value for 'timespan'
 *      count: // value for 'count'
 *      location: // value for 'location'
 *      rate: // value for 'rate'
 *      allowVolumeDiscount: // value for 'allowVolumeDiscount'
 *      photoS3Key: // value for 'photoS3Key'
 *      roomRequired: // value for 'roomRequired'
 *      allowNonMedicalUsers: // value for 'allowNonMedicalUsers'
 *   },
 * });
 */
export function useModelCountCreateListMutation(baseOptions?: Apollo.MutationHookOptions<ModelCountCreateListMutation, ModelCountCreateListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModelCountCreateListMutation, ModelCountCreateListMutationVariables>(ModelCountCreateListDocument, options);
      }
export type ModelCountCreateListMutationHookResult = ReturnType<typeof useModelCountCreateListMutation>;
export type ModelCountCreateListMutationResult = Apollo.MutationResult<ModelCountCreateListMutation>;
export type ModelCountCreateListMutationOptions = Apollo.BaseMutationOptions<ModelCountCreateListMutation, ModelCountCreateListMutationVariables>;
export const ModelCountCreateListManagerRoleDocument = gql`
    mutation ModelCountCreateListManagerRole($model: uuid!, $timespan: tstzrange!, $count: Int!, $location: uuid!, $rate: Int!, $allowVolumeDiscount: Boolean!, $photoS3Key: uuid) {
  insert_model_count_one(
    object: {model: $model, count: $count, timespan: $timespan, location: $location, rate: $rate, allowVolumeDiscount: $allowVolumeDiscount, photoS3Key: $photoS3Key}
  ) {
    model
    count
    timespan
    deleted_at
    location
    allowVolumeDiscount
    rate
    id
    photoS3Key
    roomRequired
    allowNonMedicalUsers
  }
}
    `;
export type ModelCountCreateListManagerRoleMutationFn = Apollo.MutationFunction<ModelCountCreateListManagerRoleMutation, ModelCountCreateListManagerRoleMutationVariables>;

/**
 * __useModelCountCreateListManagerRoleMutation__
 *
 * To run a mutation, you first call `useModelCountCreateListManagerRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModelCountCreateListManagerRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modelCountCreateListManagerRoleMutation, { data, loading, error }] = useModelCountCreateListManagerRoleMutation({
 *   variables: {
 *      model: // value for 'model'
 *      timespan: // value for 'timespan'
 *      count: // value for 'count'
 *      location: // value for 'location'
 *      rate: // value for 'rate'
 *      allowVolumeDiscount: // value for 'allowVolumeDiscount'
 *      photoS3Key: // value for 'photoS3Key'
 *   },
 * });
 */
export function useModelCountCreateListManagerRoleMutation(baseOptions?: Apollo.MutationHookOptions<ModelCountCreateListManagerRoleMutation, ModelCountCreateListManagerRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModelCountCreateListManagerRoleMutation, ModelCountCreateListManagerRoleMutationVariables>(ModelCountCreateListManagerRoleDocument, options);
      }
export type ModelCountCreateListManagerRoleMutationHookResult = ReturnType<typeof useModelCountCreateListManagerRoleMutation>;
export type ModelCountCreateListManagerRoleMutationResult = Apollo.MutationResult<ModelCountCreateListManagerRoleMutation>;
export type ModelCountCreateListManagerRoleMutationOptions = Apollo.BaseMutationOptions<ModelCountCreateListManagerRoleMutation, ModelCountCreateListManagerRoleMutationVariables>;
export const ModelCountUpdateListDocument = gql`
    mutation ModelCountUpdateList($timespan: tstzrange!, $id: uuid!, $rate: Int!, $count: Int!, $allowVolumeDiscount: Boolean!, $photoS3Key: uuid, $roomRequired: Boolean!, $allowNonMedicalUsers: Boolean!) {
  update_model_count_by_pk(
    pk_columns: {id: $id}
    _set: {timespan: $timespan, rate: $rate, count: $count, allowVolumeDiscount: $allowVolumeDiscount, photoS3Key: $photoS3Key, roomRequired: $roomRequired, allowNonMedicalUsers: $allowNonMedicalUsers}
  ) {
    id
    count
    timespan
    allowVolumeDiscount
    deleted_at
    location
    rate
    id
    photoS3Key
    roomRequired
    allowNonMedicalUsers
  }
}
    `;
export type ModelCountUpdateListMutationFn = Apollo.MutationFunction<ModelCountUpdateListMutation, ModelCountUpdateListMutationVariables>;

/**
 * __useModelCountUpdateListMutation__
 *
 * To run a mutation, you first call `useModelCountUpdateListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModelCountUpdateListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modelCountUpdateListMutation, { data, loading, error }] = useModelCountUpdateListMutation({
 *   variables: {
 *      timespan: // value for 'timespan'
 *      id: // value for 'id'
 *      rate: // value for 'rate'
 *      count: // value for 'count'
 *      allowVolumeDiscount: // value for 'allowVolumeDiscount'
 *      photoS3Key: // value for 'photoS3Key'
 *      roomRequired: // value for 'roomRequired'
 *      allowNonMedicalUsers: // value for 'allowNonMedicalUsers'
 *   },
 * });
 */
export function useModelCountUpdateListMutation(baseOptions?: Apollo.MutationHookOptions<ModelCountUpdateListMutation, ModelCountUpdateListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModelCountUpdateListMutation, ModelCountUpdateListMutationVariables>(ModelCountUpdateListDocument, options);
      }
export type ModelCountUpdateListMutationHookResult = ReturnType<typeof useModelCountUpdateListMutation>;
export type ModelCountUpdateListMutationResult = Apollo.MutationResult<ModelCountUpdateListMutation>;
export type ModelCountUpdateListMutationOptions = Apollo.BaseMutationOptions<ModelCountUpdateListMutation, ModelCountUpdateListMutationVariables>;
export const ModelCountUpdateListManagerRoleDocument = gql`
    mutation ModelCountUpdateListManagerRole($timespan: tstzrange!, $id: uuid!, $rate: Int!, $count: Int!, $allowVolumeDiscount: Boolean!, $photoS3Key: uuid) {
  update_model_count_by_pk(
    pk_columns: {id: $id}
    _set: {timespan: $timespan, rate: $rate, count: $count, allowVolumeDiscount: $allowVolumeDiscount, photoS3Key: $photoS3Key}
  ) {
    id
    count
    timespan
    allowVolumeDiscount
    deleted_at
    location
    rate
    id
    photoS3Key
    roomRequired
    allowNonMedicalUsers
  }
}
    `;
export type ModelCountUpdateListManagerRoleMutationFn = Apollo.MutationFunction<ModelCountUpdateListManagerRoleMutation, ModelCountUpdateListManagerRoleMutationVariables>;

/**
 * __useModelCountUpdateListManagerRoleMutation__
 *
 * To run a mutation, you first call `useModelCountUpdateListManagerRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModelCountUpdateListManagerRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modelCountUpdateListManagerRoleMutation, { data, loading, error }] = useModelCountUpdateListManagerRoleMutation({
 *   variables: {
 *      timespan: // value for 'timespan'
 *      id: // value for 'id'
 *      rate: // value for 'rate'
 *      count: // value for 'count'
 *      allowVolumeDiscount: // value for 'allowVolumeDiscount'
 *      photoS3Key: // value for 'photoS3Key'
 *   },
 * });
 */
export function useModelCountUpdateListManagerRoleMutation(baseOptions?: Apollo.MutationHookOptions<ModelCountUpdateListManagerRoleMutation, ModelCountUpdateListManagerRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModelCountUpdateListManagerRoleMutation, ModelCountUpdateListManagerRoleMutationVariables>(ModelCountUpdateListManagerRoleDocument, options);
      }
export type ModelCountUpdateListManagerRoleMutationHookResult = ReturnType<typeof useModelCountUpdateListManagerRoleMutation>;
export type ModelCountUpdateListManagerRoleMutationResult = Apollo.MutationResult<ModelCountUpdateListManagerRoleMutation>;
export type ModelCountUpdateListManagerRoleMutationOptions = Apollo.BaseMutationOptions<ModelCountUpdateListManagerRoleMutation, ModelCountUpdateListManagerRoleMutationVariables>;
export const ModelDefaultPhotosDocument = gql`
    query ModelDefaultPhotos {
  model {
    id
    photoS3Key
  }
}
    `;

/**
 * __useModelDefaultPhotosQuery__
 *
 * To run a query within a React component, call `useModelDefaultPhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelDefaultPhotosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelDefaultPhotosQuery({
 *   variables: {
 *   },
 * });
 */
export function useModelDefaultPhotosQuery(baseOptions?: Apollo.QueryHookOptions<ModelDefaultPhotosQuery, ModelDefaultPhotosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelDefaultPhotosQuery, ModelDefaultPhotosQueryVariables>(ModelDefaultPhotosDocument, options);
      }
export function useModelDefaultPhotosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelDefaultPhotosQuery, ModelDefaultPhotosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelDefaultPhotosQuery, ModelDefaultPhotosQueryVariables>(ModelDefaultPhotosDocument, options);
        }
export type ModelDefaultPhotosQueryHookResult = ReturnType<typeof useModelDefaultPhotosQuery>;
export type ModelDefaultPhotosLazyQueryHookResult = ReturnType<typeof useModelDefaultPhotosLazyQuery>;
export type ModelDefaultPhotosQueryResult = Apollo.QueryResult<ModelDefaultPhotosQuery, ModelDefaultPhotosQueryVariables>;
export const GetMsoDashboardMetricDocument = gql`
    query GetMsoDashboardMetric($location: uuid!, $metric: MsoDashboardMetric!, $interval: MsoDashboardMetricInterval!) {
  GetMsoDashboardMetric(interval: $interval, location: $location, metric: $metric) {
    labels
    dataset
    display_dataset
  }
}
    `;

/**
 * __useGetMsoDashboardMetricQuery__
 *
 * To run a query within a React component, call `useGetMsoDashboardMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsoDashboardMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMsoDashboardMetricQuery({
 *   variables: {
 *      location: // value for 'location'
 *      metric: // value for 'metric'
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function useGetMsoDashboardMetricQuery(baseOptions: Apollo.QueryHookOptions<GetMsoDashboardMetricQuery, GetMsoDashboardMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMsoDashboardMetricQuery, GetMsoDashboardMetricQueryVariables>(GetMsoDashboardMetricDocument, options);
      }
export function useGetMsoDashboardMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMsoDashboardMetricQuery, GetMsoDashboardMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMsoDashboardMetricQuery, GetMsoDashboardMetricQueryVariables>(GetMsoDashboardMetricDocument, options);
        }
export type GetMsoDashboardMetricQueryHookResult = ReturnType<typeof useGetMsoDashboardMetricQuery>;
export type GetMsoDashboardMetricLazyQueryHookResult = ReturnType<typeof useGetMsoDashboardMetricLazyQuery>;
export type GetMsoDashboardMetricQueryResult = Apollo.QueryResult<GetMsoDashboardMetricQuery, GetMsoDashboardMetricQueryVariables>;
export const GetMsoDashboardMetricStripeStagingProdDocument = gql`
    query GetMsoDashboardMetricStripeStagingProd($location: uuid!, $metric: MsoDashboardMetric!, $interval: MsoDashboardMetricInterval!) {
  GetMsoDashboardMetric(interval: $interval, location: $location, metric: $metric) {
    labels
    dataset
    display_dataset
  }
}
    `;

/**
 * __useGetMsoDashboardMetricStripeStagingProdQuery__
 *
 * To run a query within a React component, call `useGetMsoDashboardMetricStripeStagingProdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsoDashboardMetricStripeStagingProdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMsoDashboardMetricStripeStagingProdQuery({
 *   variables: {
 *      location: // value for 'location'
 *      metric: // value for 'metric'
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function useGetMsoDashboardMetricStripeStagingProdQuery(baseOptions: Apollo.QueryHookOptions<GetMsoDashboardMetricStripeStagingProdQuery, GetMsoDashboardMetricStripeStagingProdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMsoDashboardMetricStripeStagingProdQuery, GetMsoDashboardMetricStripeStagingProdQueryVariables>(GetMsoDashboardMetricStripeStagingProdDocument, options);
      }
export function useGetMsoDashboardMetricStripeStagingProdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMsoDashboardMetricStripeStagingProdQuery, GetMsoDashboardMetricStripeStagingProdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMsoDashboardMetricStripeStagingProdQuery, GetMsoDashboardMetricStripeStagingProdQueryVariables>(GetMsoDashboardMetricStripeStagingProdDocument, options);
        }
export type GetMsoDashboardMetricStripeStagingProdQueryHookResult = ReturnType<typeof useGetMsoDashboardMetricStripeStagingProdQuery>;
export type GetMsoDashboardMetricStripeStagingProdLazyQueryHookResult = ReturnType<typeof useGetMsoDashboardMetricStripeStagingProdLazyQuery>;
export type GetMsoDashboardMetricStripeStagingProdQueryResult = Apollo.QueryResult<GetMsoDashboardMetricStripeStagingProdQuery, GetMsoDashboardMetricStripeStagingProdQueryVariables>;
export const GetPartnerThemeDocument = gql`
    query GetPartnerTheme($location: uuid!) {
  partner(where: {locations: {id: {_eq: $location}}}) {
    id
    name
    primaryColor
    secondaryColor
    logoS3Key
    stripeUserToCharge
    chargeUserPaymentMethod
    productOnly
    msoTier
    msoMode
  }
}
    `;

/**
 * __useGetPartnerThemeQuery__
 *
 * To run a query within a React component, call `useGetPartnerThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerThemeQuery({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetPartnerThemeQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerThemeQuery, GetPartnerThemeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerThemeQuery, GetPartnerThemeQueryVariables>(GetPartnerThemeDocument, options);
      }
export function useGetPartnerThemeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerThemeQuery, GetPartnerThemeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerThemeQuery, GetPartnerThemeQueryVariables>(GetPartnerThemeDocument, options);
        }
export type GetPartnerThemeQueryHookResult = ReturnType<typeof useGetPartnerThemeQuery>;
export type GetPartnerThemeLazyQueryHookResult = ReturnType<typeof useGetPartnerThemeLazyQuery>;
export type GetPartnerThemeQueryResult = Apollo.QueryResult<GetPartnerThemeQuery, GetPartnerThemeQueryVariables>;
export const UpdatePartnerThemeVansanityAdminDocument = gql`
    mutation UpdatePartnerThemeVansanityAdmin($id: uuid!, $name: String!, $primaryColor: String!, $secondaryColor: String!, $logoS3Key: uuid, $stripeUserToCharge: String!, $location: uuid!, $chargeUserPaymentMethod: String, $productOnly: Boolean!, $msoTier: mso_tier_enum!, $msoMode: mso_mode_enum!) {
  update_partner_by_pk(
    pk_columns: {id: $id}
    _set: {name: $name, primaryColor: $primaryColor, secondaryColor: $secondaryColor, logoS3Key: $logoS3Key, productOnly: $productOnly, msoTier: $msoTier, msoMode: $msoMode}
  ) {
    id
    name
    primaryColor
    secondaryColor
    logoS3Key
    productOnly
    msoTier
    msoMode
  }
  updatePartnerStripeUserToCharge(
    object: {location: $location, id: $id, stripeUserToCharge: $stripeUserToCharge, chargeUserPaymentMethod: $chargeUserPaymentMethod}
  ) {
    id
    stripeUserToCharge
    chargeUserPaymentMethod
  }
}
    `;
export type UpdatePartnerThemeVansanityAdminMutationFn = Apollo.MutationFunction<UpdatePartnerThemeVansanityAdminMutation, UpdatePartnerThemeVansanityAdminMutationVariables>;

/**
 * __useUpdatePartnerThemeVansanityAdminMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerThemeVansanityAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerThemeVansanityAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerThemeVansanityAdminMutation, { data, loading, error }] = useUpdatePartnerThemeVansanityAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      primaryColor: // value for 'primaryColor'
 *      secondaryColor: // value for 'secondaryColor'
 *      logoS3Key: // value for 'logoS3Key'
 *      stripeUserToCharge: // value for 'stripeUserToCharge'
 *      location: // value for 'location'
 *      chargeUserPaymentMethod: // value for 'chargeUserPaymentMethod'
 *      productOnly: // value for 'productOnly'
 *      msoTier: // value for 'msoTier'
 *      msoMode: // value for 'msoMode'
 *   },
 * });
 */
export function useUpdatePartnerThemeVansanityAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnerThemeVansanityAdminMutation, UpdatePartnerThemeVansanityAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnerThemeVansanityAdminMutation, UpdatePartnerThemeVansanityAdminMutationVariables>(UpdatePartnerThemeVansanityAdminDocument, options);
      }
export type UpdatePartnerThemeVansanityAdminMutationHookResult = ReturnType<typeof useUpdatePartnerThemeVansanityAdminMutation>;
export type UpdatePartnerThemeVansanityAdminMutationResult = Apollo.MutationResult<UpdatePartnerThemeVansanityAdminMutation>;
export type UpdatePartnerThemeVansanityAdminMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerThemeVansanityAdminMutation, UpdatePartnerThemeVansanityAdminMutationVariables>;
export const UpdatePartnerThemeLocationAdminDocument = gql`
    mutation UpdatePartnerThemeLocationAdmin($id: uuid!, $name: String!, $primaryColor: String!, $secondaryColor: String!) {
  update_partner_by_pk(
    pk_columns: {id: $id}
    _set: {name: $name, primaryColor: $primaryColor, secondaryColor: $secondaryColor}
  ) {
    id
    name
    primaryColor
    secondaryColor
  }
}
    `;
export type UpdatePartnerThemeLocationAdminMutationFn = Apollo.MutationFunction<UpdatePartnerThemeLocationAdminMutation, UpdatePartnerThemeLocationAdminMutationVariables>;

/**
 * __useUpdatePartnerThemeLocationAdminMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerThemeLocationAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerThemeLocationAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerThemeLocationAdminMutation, { data, loading, error }] = useUpdatePartnerThemeLocationAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      primaryColor: // value for 'primaryColor'
 *      secondaryColor: // value for 'secondaryColor'
 *   },
 * });
 */
export function useUpdatePartnerThemeLocationAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnerThemeLocationAdminMutation, UpdatePartnerThemeLocationAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnerThemeLocationAdminMutation, UpdatePartnerThemeLocationAdminMutationVariables>(UpdatePartnerThemeLocationAdminDocument, options);
      }
export type UpdatePartnerThemeLocationAdminMutationHookResult = ReturnType<typeof useUpdatePartnerThemeLocationAdminMutation>;
export type UpdatePartnerThemeLocationAdminMutationResult = Apollo.MutationResult<UpdatePartnerThemeLocationAdminMutation>;
export type UpdatePartnerThemeLocationAdminMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerThemeLocationAdminMutation, UpdatePartnerThemeLocationAdminMutationVariables>;
export const GetUserByStripeIdDocument = gql`
    query GetUserByStripeId($stripeCustomerId: String!) {
  user(where: {stripeCustomerId: {_eq: $stripeCustomerId}}) {
    id
    firstName
    lastName
    stripeCustomerId
  }
}
    `;

/**
 * __useGetUserByStripeIdQuery__
 *
 * To run a query within a React component, call `useGetUserByStripeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByStripeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByStripeIdQuery({
 *   variables: {
 *      stripeCustomerId: // value for 'stripeCustomerId'
 *   },
 * });
 */
export function useGetUserByStripeIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserByStripeIdQuery, GetUserByStripeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByStripeIdQuery, GetUserByStripeIdQueryVariables>(GetUserByStripeIdDocument, options);
      }
export function useGetUserByStripeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByStripeIdQuery, GetUserByStripeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByStripeIdQuery, GetUserByStripeIdQueryVariables>(GetUserByStripeIdDocument, options);
        }
export type GetUserByStripeIdQueryHookResult = ReturnType<typeof useGetUserByStripeIdQuery>;
export type GetUserByStripeIdLazyQueryHookResult = ReturnType<typeof useGetUserByStripeIdLazyQuery>;
export type GetUserByStripeIdQueryResult = Apollo.QueryResult<GetUserByStripeIdQuery, GetUserByStripeIdQueryVariables>;
export const GetPaymentMethodsForLocationAdminDocument = gql`
    query GetPaymentMethodsForLocationAdmin($userId: uuid!) {
  getPaymentMethods(object: {userId: $userId}) {
    bank
    brand
    id
    last4
    methodType
  }
}
    `;

/**
 * __useGetPaymentMethodsForLocationAdminQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodsForLocationAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsForLocationAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodsForLocationAdminQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetPaymentMethodsForLocationAdminQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentMethodsForLocationAdminQuery, GetPaymentMethodsForLocationAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodsForLocationAdminQuery, GetPaymentMethodsForLocationAdminQueryVariables>(GetPaymentMethodsForLocationAdminDocument, options);
      }
export function useGetPaymentMethodsForLocationAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodsForLocationAdminQuery, GetPaymentMethodsForLocationAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodsForLocationAdminQuery, GetPaymentMethodsForLocationAdminQueryVariables>(GetPaymentMethodsForLocationAdminDocument, options);
        }
export type GetPaymentMethodsForLocationAdminQueryHookResult = ReturnType<typeof useGetPaymentMethodsForLocationAdminQuery>;
export type GetPaymentMethodsForLocationAdminLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodsForLocationAdminLazyQuery>;
export type GetPaymentMethodsForLocationAdminQueryResult = Apollo.QueryResult<GetPaymentMethodsForLocationAdminQuery, GetPaymentMethodsForLocationAdminQueryVariables>;
export const GetPartnerPaymentMethodDocument = gql`
    query GetPartnerPaymentMethod($id: uuid!) {
  partner_by_pk(id: $id) {
    id
    stripeUserToCharge
    chargeUserPaymentMethod
  }
}
    `;

/**
 * __useGetPartnerPaymentMethodQuery__
 *
 * To run a query within a React component, call `useGetPartnerPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerPaymentMethodQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPartnerPaymentMethodQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerPaymentMethodQuery, GetPartnerPaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerPaymentMethodQuery, GetPartnerPaymentMethodQueryVariables>(GetPartnerPaymentMethodDocument, options);
      }
export function useGetPartnerPaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerPaymentMethodQuery, GetPartnerPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerPaymentMethodQuery, GetPartnerPaymentMethodQueryVariables>(GetPartnerPaymentMethodDocument, options);
        }
export type GetPartnerPaymentMethodQueryHookResult = ReturnType<typeof useGetPartnerPaymentMethodQuery>;
export type GetPartnerPaymentMethodLazyQueryHookResult = ReturnType<typeof useGetPartnerPaymentMethodLazyQuery>;
export type GetPartnerPaymentMethodQueryResult = Apollo.QueryResult<GetPartnerPaymentMethodQuery, GetPartnerPaymentMethodQueryVariables>;
export const CreateOpenDocument = gql`
    mutation CreateOpen($frequency: String!, $location: uuid!, $id: uuid!, $timespan: String!) {
  createOpen(
    object: {location: $location, frequency: $frequency, timespan: $timespan, id: $id}
  ) {
    id
    location
    repeating
    timespan
  }
}
    `;
export type CreateOpenMutationFn = Apollo.MutationFunction<CreateOpenMutation, CreateOpenMutationVariables>;

/**
 * __useCreateOpenMutation__
 *
 * To run a mutation, you first call `useCreateOpenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpenMutation, { data, loading, error }] = useCreateOpenMutation({
 *   variables: {
 *      frequency: // value for 'frequency'
 *      location: // value for 'location'
 *      id: // value for 'id'
 *      timespan: // value for 'timespan'
 *   },
 * });
 */
export function useCreateOpenMutation(baseOptions?: Apollo.MutationHookOptions<CreateOpenMutation, CreateOpenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOpenMutation, CreateOpenMutationVariables>(CreateOpenDocument, options);
      }
export type CreateOpenMutationHookResult = ReturnType<typeof useCreateOpenMutation>;
export type CreateOpenMutationResult = Apollo.MutationResult<CreateOpenMutation>;
export type CreateOpenMutationOptions = Apollo.BaseMutationOptions<CreateOpenMutation, CreateOpenMutationVariables>;
export const GetOpensDocument = gql`
    query GetOpens($_eq: uuid!) {
  open(where: {location: {_eq: $_eq}}) {
    id
    location
    repeating
    repeatingByRepeating {
      frequency
    }
    timespan
  }
}
    `;

/**
 * __useGetOpensQuery__
 *
 * To run a query within a React component, call `useGetOpensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpensQuery({
 *   variables: {
 *      _eq: // value for '_eq'
 *   },
 * });
 */
export function useGetOpensQuery(baseOptions: Apollo.QueryHookOptions<GetOpensQuery, GetOpensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpensQuery, GetOpensQueryVariables>(GetOpensDocument, options);
      }
export function useGetOpensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpensQuery, GetOpensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpensQuery, GetOpensQueryVariables>(GetOpensDocument, options);
        }
export type GetOpensQueryHookResult = ReturnType<typeof useGetOpensQuery>;
export type GetOpensLazyQueryHookResult = ReturnType<typeof useGetOpensLazyQuery>;
export type GetOpensQueryResult = Apollo.QueryResult<GetOpensQuery, GetOpensQueryVariables>;
export const EraseOpenByPkDocument = gql`
    mutation EraseOpenByPK($id: uuid!, $carryForwards: Boolean) {
  removeOpen(object: {id: $id, carryForwards: $carryForwards}) {
    id
  }
}
    `;
export type EraseOpenByPkMutationFn = Apollo.MutationFunction<EraseOpenByPkMutation, EraseOpenByPkMutationVariables>;

/**
 * __useEraseOpenByPkMutation__
 *
 * To run a mutation, you first call `useEraseOpenByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEraseOpenByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eraseOpenByPkMutation, { data, loading, error }] = useEraseOpenByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      carryForwards: // value for 'carryForwards'
 *   },
 * });
 */
export function useEraseOpenByPkMutation(baseOptions?: Apollo.MutationHookOptions<EraseOpenByPkMutation, EraseOpenByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EraseOpenByPkMutation, EraseOpenByPkMutationVariables>(EraseOpenByPkDocument, options);
      }
export type EraseOpenByPkMutationHookResult = ReturnType<typeof useEraseOpenByPkMutation>;
export type EraseOpenByPkMutationResult = Apollo.MutationResult<EraseOpenByPkMutation>;
export type EraseOpenByPkMutationOptions = Apollo.BaseMutationOptions<EraseOpenByPkMutation, EraseOpenByPkMutationVariables>;
export const ChangeOpenByPkDocument = gql`
    mutation ChangeOpenByPK($timespan: String!, $frequency: String!, $location: uuid!, $id: uuid!, $carryForwards: Boolean) {
  editOpen(
    object: {id: $id, location: $location, frequency: $frequency, timespan: $timespan, carryForwards: $carryForwards}
  ) {
    id
    repeating
    timespan
    location
  }
}
    `;
export type ChangeOpenByPkMutationFn = Apollo.MutationFunction<ChangeOpenByPkMutation, ChangeOpenByPkMutationVariables>;

/**
 * __useChangeOpenByPkMutation__
 *
 * To run a mutation, you first call `useChangeOpenByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOpenByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOpenByPkMutation, { data, loading, error }] = useChangeOpenByPkMutation({
 *   variables: {
 *      timespan: // value for 'timespan'
 *      frequency: // value for 'frequency'
 *      location: // value for 'location'
 *      id: // value for 'id'
 *      carryForwards: // value for 'carryForwards'
 *   },
 * });
 */
export function useChangeOpenByPkMutation(baseOptions?: Apollo.MutationHookOptions<ChangeOpenByPkMutation, ChangeOpenByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeOpenByPkMutation, ChangeOpenByPkMutationVariables>(ChangeOpenByPkDocument, options);
      }
export type ChangeOpenByPkMutationHookResult = ReturnType<typeof useChangeOpenByPkMutation>;
export type ChangeOpenByPkMutationResult = Apollo.MutationResult<ChangeOpenByPkMutation>;
export type ChangeOpenByPkMutationOptions = Apollo.BaseMutationOptions<ChangeOpenByPkMutation, ChangeOpenByPkMutationVariables>;
export const GetMyPaymentMethodsDocument = gql`
    query GetMyPaymentMethods($userId: uuid!) {
  getPaymentMethods(object: {userId: $userId}) {
    id
    methodType
    isDefault
    last4
    brand
    expMonth
    expYear
    bank
  }
}
    `;

/**
 * __useGetMyPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetMyPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPaymentMethodsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMyPaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<GetMyPaymentMethodsQuery, GetMyPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPaymentMethodsQuery, GetMyPaymentMethodsQueryVariables>(GetMyPaymentMethodsDocument, options);
      }
export function useGetMyPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPaymentMethodsQuery, GetMyPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPaymentMethodsQuery, GetMyPaymentMethodsQueryVariables>(GetMyPaymentMethodsDocument, options);
        }
export type GetMyPaymentMethodsQueryHookResult = ReturnType<typeof useGetMyPaymentMethodsQuery>;
export type GetMyPaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetMyPaymentMethodsLazyQuery>;
export type GetMyPaymentMethodsQueryResult = Apollo.QueryResult<GetMyPaymentMethodsQuery, GetMyPaymentMethodsQueryVariables>;
export const CreateSetupIntentForPaymentMethodDocument = gql`
    mutation CreateSetupIntentForPaymentMethod($userId: uuid!) {
  createSetupIntent(object: {userId: $userId}) {
    id
    clientSecret
  }
}
    `;
export type CreateSetupIntentForPaymentMethodMutationFn = Apollo.MutationFunction<CreateSetupIntentForPaymentMethodMutation, CreateSetupIntentForPaymentMethodMutationVariables>;

/**
 * __useCreateSetupIntentForPaymentMethodMutation__
 *
 * To run a mutation, you first call `useCreateSetupIntentForPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetupIntentForPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetupIntentForPaymentMethodMutation, { data, loading, error }] = useCreateSetupIntentForPaymentMethodMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateSetupIntentForPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<CreateSetupIntentForPaymentMethodMutation, CreateSetupIntentForPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSetupIntentForPaymentMethodMutation, CreateSetupIntentForPaymentMethodMutationVariables>(CreateSetupIntentForPaymentMethodDocument, options);
      }
export type CreateSetupIntentForPaymentMethodMutationHookResult = ReturnType<typeof useCreateSetupIntentForPaymentMethodMutation>;
export type CreateSetupIntentForPaymentMethodMutationResult = Apollo.MutationResult<CreateSetupIntentForPaymentMethodMutation>;
export type CreateSetupIntentForPaymentMethodMutationOptions = Apollo.BaseMutationOptions<CreateSetupIntentForPaymentMethodMutation, CreateSetupIntentForPaymentMethodMutationVariables>;
export const SetDefaultPaymentMethodDocument = gql`
    mutation SetDefaultPaymentMethod($id: String!, $type: PaymentMethodType!, $userId: String!) {
  setAsDefaultPaymentMethod(object: {id: $id, type: $type, userId: $userId}) {
    id
    isDefault
  }
}
    `;
export type SetDefaultPaymentMethodMutationFn = Apollo.MutationFunction<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>;

/**
 * __useSetDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultPaymentMethodMutation, { data, loading, error }] = useSetDefaultPaymentMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSetDefaultPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>(SetDefaultPaymentMethodDocument, options);
      }
export type SetDefaultPaymentMethodMutationHookResult = ReturnType<typeof useSetDefaultPaymentMethodMutation>;
export type SetDefaultPaymentMethodMutationResult = Apollo.MutationResult<SetDefaultPaymentMethodMutation>;
export type SetDefaultPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>;
export const DeleteMyPaymentMethodDocument = gql`
    mutation DeleteMyPaymentMethod($id: String!, $type: PaymentMethodType!, $userId: String!) {
  deletePaymentMethod(object: {id: $id, type: $type, userId: $userId}) {
    id
  }
}
    `;
export type DeleteMyPaymentMethodMutationFn = Apollo.MutationFunction<DeleteMyPaymentMethodMutation, DeleteMyPaymentMethodMutationVariables>;

/**
 * __useDeleteMyPaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeleteMyPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyPaymentMethodMutation, { data, loading, error }] = useDeleteMyPaymentMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteMyPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMyPaymentMethodMutation, DeleteMyPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMyPaymentMethodMutation, DeleteMyPaymentMethodMutationVariables>(DeleteMyPaymentMethodDocument, options);
      }
export type DeleteMyPaymentMethodMutationHookResult = ReturnType<typeof useDeleteMyPaymentMethodMutation>;
export type DeleteMyPaymentMethodMutationResult = Apollo.MutationResult<DeleteMyPaymentMethodMutation>;
export type DeleteMyPaymentMethodMutationOptions = Apollo.BaseMutationOptions<DeleteMyPaymentMethodMutation, DeleteMyPaymentMethodMutationVariables>;
export const MsosChargedToPaymentMethodDocument = gql`
    query MsosChargedToPaymentMethod($id: String!) {
  partner(where: {chargeUserPaymentMethod: {_eq: $id}}) {
    id
    name
  }
}
    `;

/**
 * __useMsosChargedToPaymentMethodQuery__
 *
 * To run a query within a React component, call `useMsosChargedToPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useMsosChargedToPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMsosChargedToPaymentMethodQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMsosChargedToPaymentMethodQuery(baseOptions: Apollo.QueryHookOptions<MsosChargedToPaymentMethodQuery, MsosChargedToPaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MsosChargedToPaymentMethodQuery, MsosChargedToPaymentMethodQueryVariables>(MsosChargedToPaymentMethodDocument, options);
      }
export function useMsosChargedToPaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MsosChargedToPaymentMethodQuery, MsosChargedToPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MsosChargedToPaymentMethodQuery, MsosChargedToPaymentMethodQueryVariables>(MsosChargedToPaymentMethodDocument, options);
        }
export type MsosChargedToPaymentMethodQueryHookResult = ReturnType<typeof useMsosChargedToPaymentMethodQuery>;
export type MsosChargedToPaymentMethodLazyQueryHookResult = ReturnType<typeof useMsosChargedToPaymentMethodLazyQuery>;
export type MsosChargedToPaymentMethodQueryResult = Apollo.QueryResult<MsosChargedToPaymentMethodQuery, MsosChargedToPaymentMethodQueryVariables>;
export const ListPaymentsDocument = gql`
    query ListPayments($location: uuid!) {
  GetPaymentsList(location: $location) {
    name
    status
    email
    created
    amount
  }
}
    `;

/**
 * __useListPaymentsQuery__
 *
 * To run a query within a React component, call `useListPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPaymentsQuery({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useListPaymentsQuery(baseOptions: Apollo.QueryHookOptions<ListPaymentsQuery, ListPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPaymentsQuery, ListPaymentsQueryVariables>(ListPaymentsDocument, options);
      }
export function useListPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPaymentsQuery, ListPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPaymentsQuery, ListPaymentsQueryVariables>(ListPaymentsDocument, options);
        }
export type ListPaymentsQueryHookResult = ReturnType<typeof useListPaymentsQuery>;
export type ListPaymentsLazyQueryHookResult = ReturnType<typeof useListPaymentsLazyQuery>;
export type ListPaymentsQueryResult = Apollo.QueryResult<ListPaymentsQuery, ListPaymentsQueryVariables>;
export const DoNothingDocument = gql`
    mutation DoNothing {
  update_purchase_for_location_by_pk(
    pk_columns: {id: "89583ee8-7587-4f9a-bf31-19d1b3cfd66e"}
    _set: {}
  ) {
    id
  }
}
    `;
export type DoNothingMutationFn = Apollo.MutationFunction<DoNothingMutation, DoNothingMutationVariables>;

/**
 * __useDoNothingMutation__
 *
 * To run a mutation, you first call `useDoNothingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoNothingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doNothingMutation, { data, loading, error }] = useDoNothingMutation({
 *   variables: {
 *   },
 * });
 */
export function useDoNothingMutation(baseOptions?: Apollo.MutationHookOptions<DoNothingMutation, DoNothingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoNothingMutation, DoNothingMutationVariables>(DoNothingDocument, options);
      }
export type DoNothingMutationHookResult = ReturnType<typeof useDoNothingMutation>;
export type DoNothingMutationResult = Apollo.MutationResult<DoNothingMutation>;
export type DoNothingMutationOptions = Apollo.BaseMutationOptions<DoNothingMutation, DoNothingMutationVariables>;
export const PlanListDocument = gql`
    query PlanList($_in: uuid!) {
  get_cumulative_location_plans(args: {base_location: $_in}) {
    type
    name
    monthlyCredit
    monthlyCost
    annualCost
    location
    id
    discountRate
    deleted_at
    description
    locationByLocation {
      parentLocation
    }
  }
}
    `;

/**
 * __usePlanListQuery__
 *
 * To run a query within a React component, call `usePlanListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanListQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function usePlanListQuery(baseOptions: Apollo.QueryHookOptions<PlanListQuery, PlanListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanListQuery, PlanListQueryVariables>(PlanListDocument, options);
      }
export function usePlanListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanListQuery, PlanListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanListQuery, PlanListQueryVariables>(PlanListDocument, options);
        }
export type PlanListQueryHookResult = ReturnType<typeof usePlanListQuery>;
export type PlanListLazyQueryHookResult = ReturnType<typeof usePlanListLazyQuery>;
export type PlanListQueryResult = Apollo.QueryResult<PlanListQuery, PlanListQueryVariables>;
export const PlanDeleteListDocument = gql`
    mutation PlanDeleteList($id: uuid = "") {
  deletePlan(object: {id: $id}) {
    id
  }
}
    `;
export type PlanDeleteListMutationFn = Apollo.MutationFunction<PlanDeleteListMutation, PlanDeleteListMutationVariables>;

/**
 * __usePlanDeleteListMutation__
 *
 * To run a mutation, you first call `usePlanDeleteListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlanDeleteListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [planDeleteListMutation, { data, loading, error }] = usePlanDeleteListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlanDeleteListMutation(baseOptions?: Apollo.MutationHookOptions<PlanDeleteListMutation, PlanDeleteListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlanDeleteListMutation, PlanDeleteListMutationVariables>(PlanDeleteListDocument, options);
      }
export type PlanDeleteListMutationHookResult = ReturnType<typeof usePlanDeleteListMutation>;
export type PlanDeleteListMutationResult = Apollo.MutationResult<PlanDeleteListMutation>;
export type PlanDeleteListMutationOptions = Apollo.BaseMutationOptions<PlanDeleteListMutation, PlanDeleteListMutationVariables>;
export const PlanCreateListDocument = gql`
    mutation PlanCreateList($object: CreatePlanInput!) {
  createPlan(object: $object) {
    id
    type
    name
    monthlyCredit
    monthlyCost
    annualCost
    location
    id
    discountRate
    description
  }
}
    `;
export type PlanCreateListMutationFn = Apollo.MutationFunction<PlanCreateListMutation, PlanCreateListMutationVariables>;

/**
 * __usePlanCreateListMutation__
 *
 * To run a mutation, you first call `usePlanCreateListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlanCreateListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [planCreateListMutation, { data, loading, error }] = usePlanCreateListMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function usePlanCreateListMutation(baseOptions?: Apollo.MutationHookOptions<PlanCreateListMutation, PlanCreateListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlanCreateListMutation, PlanCreateListMutationVariables>(PlanCreateListDocument, options);
      }
export type PlanCreateListMutationHookResult = ReturnType<typeof usePlanCreateListMutation>;
export type PlanCreateListMutationResult = Apollo.MutationResult<PlanCreateListMutation>;
export type PlanCreateListMutationOptions = Apollo.BaseMutationOptions<PlanCreateListMutation, PlanCreateListMutationVariables>;
export const PlanUpdateListDocument = gql`
    mutation PlanUpdateList($object: UpdatePlanInput!) {
  updatePlan(object: $object) {
    id
    type
    name
    monthlyCredit
    monthlyCost
    annualCost
    location
    id
    discountRate
    description
  }
}
    `;
export type PlanUpdateListMutationFn = Apollo.MutationFunction<PlanUpdateListMutation, PlanUpdateListMutationVariables>;

/**
 * __usePlanUpdateListMutation__
 *
 * To run a mutation, you first call `usePlanUpdateListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlanUpdateListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [planUpdateListMutation, { data, loading, error }] = usePlanUpdateListMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function usePlanUpdateListMutation(baseOptions?: Apollo.MutationHookOptions<PlanUpdateListMutation, PlanUpdateListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlanUpdateListMutation, PlanUpdateListMutationVariables>(PlanUpdateListDocument, options);
      }
export type PlanUpdateListMutationHookResult = ReturnType<typeof usePlanUpdateListMutation>;
export type PlanUpdateListMutationResult = Apollo.MutationResult<PlanUpdateListMutation>;
export type PlanUpdateListMutationOptions = Apollo.BaseMutationOptions<PlanUpdateListMutation, PlanUpdateListMutationVariables>;
export const ProductTypeListDocument = gql`
    query ProductTypeList {
  product_type {
    id
    type
  }
}
    `;

/**
 * __useProductTypeListQuery__
 *
 * To run a query within a React component, call `useProductTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductTypeListQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductTypeListQuery(baseOptions?: Apollo.QueryHookOptions<ProductTypeListQuery, ProductTypeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductTypeListQuery, ProductTypeListQueryVariables>(ProductTypeListDocument, options);
      }
export function useProductTypeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductTypeListQuery, ProductTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductTypeListQuery, ProductTypeListQueryVariables>(ProductTypeListDocument, options);
        }
export type ProductTypeListQueryHookResult = ReturnType<typeof useProductTypeListQuery>;
export type ProductTypeListLazyQueryHookResult = ReturnType<typeof useProductTypeListLazyQuery>;
export type ProductTypeListQueryResult = Apollo.QueryResult<ProductTypeListQuery, ProductTypeListQueryVariables>;
export const ProductTypeCreateDocument = gql`
    mutation ProductTypeCreate($type: String!) {
  insert_product_type_one(object: {type: $type}) {
    id
    type
  }
}
    `;
export type ProductTypeCreateMutationFn = Apollo.MutationFunction<ProductTypeCreateMutation, ProductTypeCreateMutationVariables>;

/**
 * __useProductTypeCreateMutation__
 *
 * To run a mutation, you first call `useProductTypeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductTypeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productTypeCreateMutation, { data, loading, error }] = useProductTypeCreateMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useProductTypeCreateMutation(baseOptions?: Apollo.MutationHookOptions<ProductTypeCreateMutation, ProductTypeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductTypeCreateMutation, ProductTypeCreateMutationVariables>(ProductTypeCreateDocument, options);
      }
export type ProductTypeCreateMutationHookResult = ReturnType<typeof useProductTypeCreateMutation>;
export type ProductTypeCreateMutationResult = Apollo.MutationResult<ProductTypeCreateMutation>;
export type ProductTypeCreateMutationOptions = Apollo.BaseMutationOptions<ProductTypeCreateMutation, ProductTypeCreateMutationVariables>;
export const ProductTypeUpdateDocument = gql`
    mutation ProductTypeUpdate($id: uuid!, $type: String!) {
  update_product_type_by_pk(pk_columns: {id: $id}, _set: {type: $type}) {
    id
    type
  }
}
    `;
export type ProductTypeUpdateMutationFn = Apollo.MutationFunction<ProductTypeUpdateMutation, ProductTypeUpdateMutationVariables>;

/**
 * __useProductTypeUpdateMutation__
 *
 * To run a mutation, you first call `useProductTypeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductTypeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productTypeUpdateMutation, { data, loading, error }] = useProductTypeUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useProductTypeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProductTypeUpdateMutation, ProductTypeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductTypeUpdateMutation, ProductTypeUpdateMutationVariables>(ProductTypeUpdateDocument, options);
      }
export type ProductTypeUpdateMutationHookResult = ReturnType<typeof useProductTypeUpdateMutation>;
export type ProductTypeUpdateMutationResult = Apollo.MutationResult<ProductTypeUpdateMutation>;
export type ProductTypeUpdateMutationOptions = Apollo.BaseMutationOptions<ProductTypeUpdateMutation, ProductTypeUpdateMutationVariables>;
export const ProductTypeDeleteDocument = gql`
    mutation ProductTypeDelete($id: uuid!) {
  delete_product_type_by_pk(id: $id) {
    id
  }
}
    `;
export type ProductTypeDeleteMutationFn = Apollo.MutationFunction<ProductTypeDeleteMutation, ProductTypeDeleteMutationVariables>;

/**
 * __useProductTypeDeleteMutation__
 *
 * To run a mutation, you first call `useProductTypeDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductTypeDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productTypeDeleteMutation, { data, loading, error }] = useProductTypeDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductTypeDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ProductTypeDeleteMutation, ProductTypeDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductTypeDeleteMutation, ProductTypeDeleteMutationVariables>(ProductTypeDeleteDocument, options);
      }
export type ProductTypeDeleteMutationHookResult = ReturnType<typeof useProductTypeDeleteMutation>;
export type ProductTypeDeleteMutationResult = Apollo.MutationResult<ProductTypeDeleteMutation>;
export type ProductTypeDeleteMutationOptions = Apollo.BaseMutationOptions<ProductTypeDeleteMutation, ProductTypeDeleteMutationVariables>;
export const ListPurchaseRequestsDocument = gql`
    query ListPurchaseRequests($_in: [uuid!]!) {
  purchase_requests_list(where: {location: {_in: $_in}}) {
    id
    createdAt
    orderPlaced
    productName
    productsCost
    purchasedByName
    units
    msoName
    locationName
    location
    product
    stripeInvoiceId
    stripeInvoiceUrl
    partner
    deletedAt
    trackingUrl
  }
}
    `;

/**
 * __useListPurchaseRequestsQuery__
 *
 * To run a query within a React component, call `useListPurchaseRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPurchaseRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPurchaseRequestsQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useListPurchaseRequestsQuery(baseOptions: Apollo.QueryHookOptions<ListPurchaseRequestsQuery, ListPurchaseRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPurchaseRequestsQuery, ListPurchaseRequestsQueryVariables>(ListPurchaseRequestsDocument, options);
      }
export function useListPurchaseRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPurchaseRequestsQuery, ListPurchaseRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPurchaseRequestsQuery, ListPurchaseRequestsQueryVariables>(ListPurchaseRequestsDocument, options);
        }
export type ListPurchaseRequestsQueryHookResult = ReturnType<typeof useListPurchaseRequestsQuery>;
export type ListPurchaseRequestsLazyQueryHookResult = ReturnType<typeof useListPurchaseRequestsLazyQuery>;
export type ListPurchaseRequestsQueryResult = Apollo.QueryResult<ListPurchaseRequestsQuery, ListPurchaseRequestsQueryVariables>;
export const UpdatePurchaseForLocationDocument = gql`
    mutation UpdatePurchaseForLocation($id: uuid!, $orderPlaced: Boolean!, $trackingUrl: String) {
  update_purchase_for_location_by_pk(
    pk_columns: {id: $id}
    _set: {orderPlaced: $orderPlaced, trackingUrl: $trackingUrl}
  ) {
    id
    orderPlaced
    trackingUrl
  }
}
    `;
export type UpdatePurchaseForLocationMutationFn = Apollo.MutationFunction<UpdatePurchaseForLocationMutation, UpdatePurchaseForLocationMutationVariables>;

/**
 * __useUpdatePurchaseForLocationMutation__
 *
 * To run a mutation, you first call `useUpdatePurchaseForLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePurchaseForLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePurchaseForLocationMutation, { data, loading, error }] = useUpdatePurchaseForLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      orderPlaced: // value for 'orderPlaced'
 *      trackingUrl: // value for 'trackingUrl'
 *   },
 * });
 */
export function useUpdatePurchaseForLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePurchaseForLocationMutation, UpdatePurchaseForLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePurchaseForLocationMutation, UpdatePurchaseForLocationMutationVariables>(UpdatePurchaseForLocationDocument, options);
      }
export type UpdatePurchaseForLocationMutationHookResult = ReturnType<typeof useUpdatePurchaseForLocationMutation>;
export type UpdatePurchaseForLocationMutationResult = Apollo.MutationResult<UpdatePurchaseForLocationMutation>;
export type UpdatePurchaseForLocationMutationOptions = Apollo.BaseMutationOptions<UpdatePurchaseForLocationMutation, UpdatePurchaseForLocationMutationVariables>;
export const RoomModelListDocument = gql`
    query RoomModelList($_in: [uuid!]!) {
  room_model(where: {roomByRoom: {location: {_in: $_in}}}) {
    timespan
    room
    model
    id
    modelByModel {
      id
      name
    }
    roomByRoom {
      id
      name
    }
  }
}
    `;

/**
 * __useRoomModelListQuery__
 *
 * To run a query within a React component, call `useRoomModelListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomModelListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomModelListQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useRoomModelListQuery(baseOptions: Apollo.QueryHookOptions<RoomModelListQuery, RoomModelListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomModelListQuery, RoomModelListQueryVariables>(RoomModelListDocument, options);
      }
export function useRoomModelListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomModelListQuery, RoomModelListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomModelListQuery, RoomModelListQueryVariables>(RoomModelListDocument, options);
        }
export type RoomModelListQueryHookResult = ReturnType<typeof useRoomModelListQuery>;
export type RoomModelListLazyQueryHookResult = ReturnType<typeof useRoomModelListLazyQuery>;
export type RoomModelListQueryResult = Apollo.QueryResult<RoomModelListQuery, RoomModelListQueryVariables>;
export const RoomEquipmentDeleteListDocument = gql`
    mutation RoomEquipmentDeleteList($id: uuid!) {
  delete_room_model_by_pk(id: $id) {
    id
    room
    model
    timespan
  }
}
    `;
export type RoomEquipmentDeleteListMutationFn = Apollo.MutationFunction<RoomEquipmentDeleteListMutation, RoomEquipmentDeleteListMutationVariables>;

/**
 * __useRoomEquipmentDeleteListMutation__
 *
 * To run a mutation, you first call `useRoomEquipmentDeleteListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoomEquipmentDeleteListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roomEquipmentDeleteListMutation, { data, loading, error }] = useRoomEquipmentDeleteListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoomEquipmentDeleteListMutation(baseOptions?: Apollo.MutationHookOptions<RoomEquipmentDeleteListMutation, RoomEquipmentDeleteListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RoomEquipmentDeleteListMutation, RoomEquipmentDeleteListMutationVariables>(RoomEquipmentDeleteListDocument, options);
      }
export type RoomEquipmentDeleteListMutationHookResult = ReturnType<typeof useRoomEquipmentDeleteListMutation>;
export type RoomEquipmentDeleteListMutationResult = Apollo.MutationResult<RoomEquipmentDeleteListMutation>;
export type RoomEquipmentDeleteListMutationOptions = Apollo.BaseMutationOptions<RoomEquipmentDeleteListMutation, RoomEquipmentDeleteListMutationVariables>;
export const RoomModelCreateListDocument = gql`
    mutation RoomModelCreateList($model: uuid!, $timespan: tstzrange!, $room: uuid!) {
  insert_room_model_one(object: {model: $model, room: $room, timespan: $timespan}) {
    model
    room
    timespan
    id
  }
}
    `;
export type RoomModelCreateListMutationFn = Apollo.MutationFunction<RoomModelCreateListMutation, RoomModelCreateListMutationVariables>;

/**
 * __useRoomModelCreateListMutation__
 *
 * To run a mutation, you first call `useRoomModelCreateListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoomModelCreateListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roomModelCreateListMutation, { data, loading, error }] = useRoomModelCreateListMutation({
 *   variables: {
 *      model: // value for 'model'
 *      timespan: // value for 'timespan'
 *      room: // value for 'room'
 *   },
 * });
 */
export function useRoomModelCreateListMutation(baseOptions?: Apollo.MutationHookOptions<RoomModelCreateListMutation, RoomModelCreateListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RoomModelCreateListMutation, RoomModelCreateListMutationVariables>(RoomModelCreateListDocument, options);
      }
export type RoomModelCreateListMutationHookResult = ReturnType<typeof useRoomModelCreateListMutation>;
export type RoomModelCreateListMutationResult = Apollo.MutationResult<RoomModelCreateListMutation>;
export type RoomModelCreateListMutationOptions = Apollo.BaseMutationOptions<RoomModelCreateListMutation, RoomModelCreateListMutationVariables>;
export const RoomModelUpdateListDocument = gql`
    mutation RoomModelUpdateList($timespan: tstzrange!, $id: uuid!) {
  update_room_model_by_pk(pk_columns: {id: $id}, _set: {timespan: $timespan}) {
    room
    model
    timespan
    id
  }
}
    `;
export type RoomModelUpdateListMutationFn = Apollo.MutationFunction<RoomModelUpdateListMutation, RoomModelUpdateListMutationVariables>;

/**
 * __useRoomModelUpdateListMutation__
 *
 * To run a mutation, you first call `useRoomModelUpdateListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoomModelUpdateListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roomModelUpdateListMutation, { data, loading, error }] = useRoomModelUpdateListMutation({
 *   variables: {
 *      timespan: // value for 'timespan'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoomModelUpdateListMutation(baseOptions?: Apollo.MutationHookOptions<RoomModelUpdateListMutation, RoomModelUpdateListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RoomModelUpdateListMutation, RoomModelUpdateListMutationVariables>(RoomModelUpdateListDocument, options);
      }
export type RoomModelUpdateListMutationHookResult = ReturnType<typeof useRoomModelUpdateListMutation>;
export type RoomModelUpdateListMutationResult = Apollo.MutationResult<RoomModelUpdateListMutation>;
export type RoomModelUpdateListMutationOptions = Apollo.BaseMutationOptions<RoomModelUpdateListMutation, RoomModelUpdateListMutationVariables>;
export const RoomTypeListDocument = gql`
    query RoomTypeList($_in: [uuid!]!) {
  room_type(where: {location: {_in: $_in}}) {
    id
    name
    location
  }
}
    `;

/**
 * __useRoomTypeListQuery__
 *
 * To run a query within a React component, call `useRoomTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomTypeListQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useRoomTypeListQuery(baseOptions: Apollo.QueryHookOptions<RoomTypeListQuery, RoomTypeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomTypeListQuery, RoomTypeListQueryVariables>(RoomTypeListDocument, options);
      }
export function useRoomTypeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomTypeListQuery, RoomTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomTypeListQuery, RoomTypeListQueryVariables>(RoomTypeListDocument, options);
        }
export type RoomTypeListQueryHookResult = ReturnType<typeof useRoomTypeListQuery>;
export type RoomTypeListLazyQueryHookResult = ReturnType<typeof useRoomTypeListLazyQuery>;
export type RoomTypeListQueryResult = Apollo.QueryResult<RoomTypeListQuery, RoomTypeListQueryVariables>;
export const RoomTypeCreateDocument = gql`
    mutation RoomTypeCreate($location: uuid!, $name: String!) {
  insert_room_type_one(object: {location: $location, name: $name}) {
    id
    name
  }
}
    `;
export type RoomTypeCreateMutationFn = Apollo.MutationFunction<RoomTypeCreateMutation, RoomTypeCreateMutationVariables>;

/**
 * __useRoomTypeCreateMutation__
 *
 * To run a mutation, you first call `useRoomTypeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoomTypeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roomTypeCreateMutation, { data, loading, error }] = useRoomTypeCreateMutation({
 *   variables: {
 *      location: // value for 'location'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRoomTypeCreateMutation(baseOptions?: Apollo.MutationHookOptions<RoomTypeCreateMutation, RoomTypeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RoomTypeCreateMutation, RoomTypeCreateMutationVariables>(RoomTypeCreateDocument, options);
      }
export type RoomTypeCreateMutationHookResult = ReturnType<typeof useRoomTypeCreateMutation>;
export type RoomTypeCreateMutationResult = Apollo.MutationResult<RoomTypeCreateMutation>;
export type RoomTypeCreateMutationOptions = Apollo.BaseMutationOptions<RoomTypeCreateMutation, RoomTypeCreateMutationVariables>;
export const RoomTypeUpdateDocument = gql`
    mutation RoomTypeUpdate($name: String!, $id: uuid!) {
  update_room_type_by_pk(pk_columns: {id: $id}, _set: {name: $name}) {
    id
    name
  }
}
    `;
export type RoomTypeUpdateMutationFn = Apollo.MutationFunction<RoomTypeUpdateMutation, RoomTypeUpdateMutationVariables>;

/**
 * __useRoomTypeUpdateMutation__
 *
 * To run a mutation, you first call `useRoomTypeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoomTypeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roomTypeUpdateMutation, { data, loading, error }] = useRoomTypeUpdateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoomTypeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RoomTypeUpdateMutation, RoomTypeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RoomTypeUpdateMutation, RoomTypeUpdateMutationVariables>(RoomTypeUpdateDocument, options);
      }
export type RoomTypeUpdateMutationHookResult = ReturnType<typeof useRoomTypeUpdateMutation>;
export type RoomTypeUpdateMutationResult = Apollo.MutationResult<RoomTypeUpdateMutation>;
export type RoomTypeUpdateMutationOptions = Apollo.BaseMutationOptions<RoomTypeUpdateMutation, RoomTypeUpdateMutationVariables>;
export const RoomTypeDeleteDocument = gql`
    mutation RoomTypeDelete($id: uuid!) {
  delete_room_type_by_pk(id: $id) {
    id
    name
  }
}
    `;
export type RoomTypeDeleteMutationFn = Apollo.MutationFunction<RoomTypeDeleteMutation, RoomTypeDeleteMutationVariables>;

/**
 * __useRoomTypeDeleteMutation__
 *
 * To run a mutation, you first call `useRoomTypeDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoomTypeDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roomTypeDeleteMutation, { data, loading, error }] = useRoomTypeDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoomTypeDeleteMutation(baseOptions?: Apollo.MutationHookOptions<RoomTypeDeleteMutation, RoomTypeDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RoomTypeDeleteMutation, RoomTypeDeleteMutationVariables>(RoomTypeDeleteDocument, options);
      }
export type RoomTypeDeleteMutationHookResult = ReturnType<typeof useRoomTypeDeleteMutation>;
export type RoomTypeDeleteMutationResult = Apollo.MutationResult<RoomTypeDeleteMutation>;
export type RoomTypeDeleteMutationOptions = Apollo.BaseMutationOptions<RoomTypeDeleteMutation, RoomTypeDeleteMutationVariables>;
export const AllTaxRatesListDocument = gql`
    query AllTaxRatesList($_in: [uuid!]!) {
  tax_rate(where: {location: {_in: $_in}}) {
    id
    location
    rate
    type
    name
  }
}
    `;

/**
 * __useAllTaxRatesListQuery__
 *
 * To run a query within a React component, call `useAllTaxRatesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTaxRatesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTaxRatesListQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useAllTaxRatesListQuery(baseOptions: Apollo.QueryHookOptions<AllTaxRatesListQuery, AllTaxRatesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTaxRatesListQuery, AllTaxRatesListQueryVariables>(AllTaxRatesListDocument, options);
      }
export function useAllTaxRatesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTaxRatesListQuery, AllTaxRatesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTaxRatesListQuery, AllTaxRatesListQueryVariables>(AllTaxRatesListDocument, options);
        }
export type AllTaxRatesListQueryHookResult = ReturnType<typeof useAllTaxRatesListQuery>;
export type AllTaxRatesListLazyQueryHookResult = ReturnType<typeof useAllTaxRatesListLazyQuery>;
export type AllTaxRatesListQueryResult = Apollo.QueryResult<AllTaxRatesListQuery, AllTaxRatesListQueryVariables>;
export const TaxRateDeleteDocument = gql`
    mutation TaxRateDelete($id: uuid!) {
  delete_tax_rate_by_pk(id: $id) {
    id
    location
    rate
    type
    name
  }
}
    `;
export type TaxRateDeleteMutationFn = Apollo.MutationFunction<TaxRateDeleteMutation, TaxRateDeleteMutationVariables>;

/**
 * __useTaxRateDeleteMutation__
 *
 * To run a mutation, you first call `useTaxRateDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaxRateDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taxRateDeleteMutation, { data, loading, error }] = useTaxRateDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaxRateDeleteMutation(baseOptions?: Apollo.MutationHookOptions<TaxRateDeleteMutation, TaxRateDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaxRateDeleteMutation, TaxRateDeleteMutationVariables>(TaxRateDeleteDocument, options);
      }
export type TaxRateDeleteMutationHookResult = ReturnType<typeof useTaxRateDeleteMutation>;
export type TaxRateDeleteMutationResult = Apollo.MutationResult<TaxRateDeleteMutation>;
export type TaxRateDeleteMutationOptions = Apollo.BaseMutationOptions<TaxRateDeleteMutation, TaxRateDeleteMutationVariables>;
export const TaxRateCreateDocument = gql`
    mutation TaxRateCreate($rate: numeric!, $location: uuid!, $type: tax_type_enum, $name: String) {
  insert_tax_rate_one(
    object: {location: $location, name: $name, rate: $rate, type: $type}
  ) {
    id
    location
    rate
    type
    name
  }
}
    `;
export type TaxRateCreateMutationFn = Apollo.MutationFunction<TaxRateCreateMutation, TaxRateCreateMutationVariables>;

/**
 * __useTaxRateCreateMutation__
 *
 * To run a mutation, you first call `useTaxRateCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaxRateCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taxRateCreateMutation, { data, loading, error }] = useTaxRateCreateMutation({
 *   variables: {
 *      rate: // value for 'rate'
 *      location: // value for 'location'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useTaxRateCreateMutation(baseOptions?: Apollo.MutationHookOptions<TaxRateCreateMutation, TaxRateCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaxRateCreateMutation, TaxRateCreateMutationVariables>(TaxRateCreateDocument, options);
      }
export type TaxRateCreateMutationHookResult = ReturnType<typeof useTaxRateCreateMutation>;
export type TaxRateCreateMutationResult = Apollo.MutationResult<TaxRateCreateMutation>;
export type TaxRateCreateMutationOptions = Apollo.BaseMutationOptions<TaxRateCreateMutation, TaxRateCreateMutationVariables>;
export const TaxRateUpdateDocument = gql`
    mutation TaxRateUpdate($id: uuid!, $rate: numeric!, $name: String) {
  update_tax_rate_by_pk(pk_columns: {id: $id}, _set: {rate: $rate, name: $name}) {
    id
    location
    rate
    type
    name
  }
}
    `;
export type TaxRateUpdateMutationFn = Apollo.MutationFunction<TaxRateUpdateMutation, TaxRateUpdateMutationVariables>;

/**
 * __useTaxRateUpdateMutation__
 *
 * To run a mutation, you first call `useTaxRateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaxRateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taxRateUpdateMutation, { data, loading, error }] = useTaxRateUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      rate: // value for 'rate'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useTaxRateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TaxRateUpdateMutation, TaxRateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaxRateUpdateMutation, TaxRateUpdateMutationVariables>(TaxRateUpdateDocument, options);
      }
export type TaxRateUpdateMutationHookResult = ReturnType<typeof useTaxRateUpdateMutation>;
export type TaxRateUpdateMutationResult = Apollo.MutationResult<TaxRateUpdateMutation>;
export type TaxRateUpdateMutationOptions = Apollo.BaseMutationOptions<TaxRateUpdateMutation, TaxRateUpdateMutationVariables>;
export const UserPlanListDocument = gql`
    query UserPlanList($user: uuid!, $_in: [uuid!]!) {
  user_plan(
    where: {user: {_eq: $user}, planByPlan: {_or: [{location: {_in: $_in}}, {locationByLocation: {childLocationByLocation: {usesParentLocationPlans: {_eq: true}, id: {_in: $_in}}}}]}}
    order_by: {id: asc}
  ) {
    id
    canceledAt
    benefitsEndAt
    created_at
    plan
    user
    annual
    annualizedAt
    planByPlan {
      id
      name
      type
      locationByLocation {
        id
        name
        usesParentLocationPlans
        parentLocationByLocation {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useUserPlanListQuery__
 *
 * To run a query within a React component, call `useUserPlanListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPlanListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPlanListQuery({
 *   variables: {
 *      user: // value for 'user'
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useUserPlanListQuery(baseOptions: Apollo.QueryHookOptions<UserPlanListQuery, UserPlanListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPlanListQuery, UserPlanListQueryVariables>(UserPlanListDocument, options);
      }
export function useUserPlanListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPlanListQuery, UserPlanListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPlanListQuery, UserPlanListQueryVariables>(UserPlanListDocument, options);
        }
export type UserPlanListQueryHookResult = ReturnType<typeof useUserPlanListQuery>;
export type UserPlanListLazyQueryHookResult = ReturnType<typeof useUserPlanListLazyQuery>;
export type UserPlanListQueryResult = Apollo.QueryResult<UserPlanListQuery, UserPlanListQueryVariables>;
export const UserPlanCancelDocument = gql`
    mutation UserPlanCancel($object: CancelUserPlanInput!) {
  cancelUserPlan(object: $object) {
    benefitsEndAt
    canceledAt
    id
  }
}
    `;
export type UserPlanCancelMutationFn = Apollo.MutationFunction<UserPlanCancelMutation, UserPlanCancelMutationVariables>;

/**
 * __useUserPlanCancelMutation__
 *
 * To run a mutation, you first call `useUserPlanCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserPlanCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userPlanCancelMutation, { data, loading, error }] = useUserPlanCancelMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUserPlanCancelMutation(baseOptions?: Apollo.MutationHookOptions<UserPlanCancelMutation, UserPlanCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserPlanCancelMutation, UserPlanCancelMutationVariables>(UserPlanCancelDocument, options);
      }
export type UserPlanCancelMutationHookResult = ReturnType<typeof useUserPlanCancelMutation>;
export type UserPlanCancelMutationResult = Apollo.MutationResult<UserPlanCancelMutation>;
export type UserPlanCancelMutationOptions = Apollo.BaseMutationOptions<UserPlanCancelMutation, UserPlanCancelMutationVariables>;
export const UserPlanCreateDocument = gql`
    mutation UserPlanCreate($object: CreateUserPlanInput!) {
  createUserPlan(object: $object) {
    plan
    user
    id
    annual
  }
}
    `;
export type UserPlanCreateMutationFn = Apollo.MutationFunction<UserPlanCreateMutation, UserPlanCreateMutationVariables>;

/**
 * __useUserPlanCreateMutation__
 *
 * To run a mutation, you first call `useUserPlanCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserPlanCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userPlanCreateMutation, { data, loading, error }] = useUserPlanCreateMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUserPlanCreateMutation(baseOptions?: Apollo.MutationHookOptions<UserPlanCreateMutation, UserPlanCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserPlanCreateMutation, UserPlanCreateMutationVariables>(UserPlanCreateDocument, options);
      }
export type UserPlanCreateMutationHookResult = ReturnType<typeof useUserPlanCreateMutation>;
export type UserPlanCreateMutationResult = Apollo.MutationResult<UserPlanCreateMutation>;
export type UserPlanCreateMutationOptions = Apollo.BaseMutationOptions<UserPlanCreateMutation, UserPlanCreateMutationVariables>;
export const UserPlanUpdateDocument = gql`
    mutation UserPlanUpdate($object: UpdateUserPlanInput!) {
  updateUserPlan(object: $object) {
    id
    annual
  }
}
    `;
export type UserPlanUpdateMutationFn = Apollo.MutationFunction<UserPlanUpdateMutation, UserPlanUpdateMutationVariables>;

/**
 * __useUserPlanUpdateMutation__
 *
 * To run a mutation, you first call `useUserPlanUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserPlanUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userPlanUpdateMutation, { data, loading, error }] = useUserPlanUpdateMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUserPlanUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserPlanUpdateMutation, UserPlanUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserPlanUpdateMutation, UserPlanUpdateMutationVariables>(UserPlanUpdateDocument, options);
      }
export type UserPlanUpdateMutationHookResult = ReturnType<typeof useUserPlanUpdateMutation>;
export type UserPlanUpdateMutationResult = Apollo.MutationResult<UserPlanUpdateMutation>;
export type UserPlanUpdateMutationOptions = Apollo.BaseMutationOptions<UserPlanUpdateMutation, UserPlanUpdateMutationVariables>;
export const ListUserInvoicesDocument = gql`
    query ListUserInvoices($user_id: uuid!, $location: uuid!) {
  invoice(
    where: {_or: [{productPurchases: {user: {_eq: $user_id}, location: {_eq: $location}}}, {bookingByBooking: {provider: {_eq: $user_id}, location: {_eq: $location}}}]}
    order_by: {created_at: desc}
  ) {
    id
    created_at
    amount_due
    stripeId
    stripe_hosted_invoice_url
    bookingByBooking {
      id
      type
      modelRate
      roomRate
      timespan
      modelByModel {
        name
        id
      }
      roomByRoom {
        id
        name
      }
      productPurchases {
        id
        price
        units
        units_fulfilled
        productByProduct {
          id
          name
        }
      }
    }
    productPurchases {
      id
      price
      units
      units_fulfilled
      productByProduct {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useListUserInvoicesQuery__
 *
 * To run a query within a React component, call `useListUserInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUserInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUserInvoicesQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useListUserInvoicesQuery(baseOptions: Apollo.QueryHookOptions<ListUserInvoicesQuery, ListUserInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUserInvoicesQuery, ListUserInvoicesQueryVariables>(ListUserInvoicesDocument, options);
      }
export function useListUserInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUserInvoicesQuery, ListUserInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUserInvoicesQuery, ListUserInvoicesQueryVariables>(ListUserInvoicesDocument, options);
        }
export type ListUserInvoicesQueryHookResult = ReturnType<typeof useListUserInvoicesQuery>;
export type ListUserInvoicesLazyQueryHookResult = ReturnType<typeof useListUserInvoicesLazyQuery>;
export type ListUserInvoicesQueryResult = Apollo.QueryResult<ListUserInvoicesQuery, ListUserInvoicesQueryVariables>;
export const UpdateProductPurchasesUnitsFulfilledDocument = gql`
    mutation UpdateProductPurchasesUnitsFulfilled($units_fulfilled: Int!, $id: uuid!) {
  update_product_purchase_by_pk(
    pk_columns: {id: $id}
    _set: {units_fulfilled: $units_fulfilled}
  ) {
    id
    units_fulfilled
  }
}
    `;
export type UpdateProductPurchasesUnitsFulfilledMutationFn = Apollo.MutationFunction<UpdateProductPurchasesUnitsFulfilledMutation, UpdateProductPurchasesUnitsFulfilledMutationVariables>;

/**
 * __useUpdateProductPurchasesUnitsFulfilledMutation__
 *
 * To run a mutation, you first call `useUpdateProductPurchasesUnitsFulfilledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductPurchasesUnitsFulfilledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductPurchasesUnitsFulfilledMutation, { data, loading, error }] = useUpdateProductPurchasesUnitsFulfilledMutation({
 *   variables: {
 *      units_fulfilled: // value for 'units_fulfilled'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateProductPurchasesUnitsFulfilledMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductPurchasesUnitsFulfilledMutation, UpdateProductPurchasesUnitsFulfilledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductPurchasesUnitsFulfilledMutation, UpdateProductPurchasesUnitsFulfilledMutationVariables>(UpdateProductPurchasesUnitsFulfilledDocument, options);
      }
export type UpdateProductPurchasesUnitsFulfilledMutationHookResult = ReturnType<typeof useUpdateProductPurchasesUnitsFulfilledMutation>;
export type UpdateProductPurchasesUnitsFulfilledMutationResult = Apollo.MutationResult<UpdateProductPurchasesUnitsFulfilledMutation>;
export type UpdateProductPurchasesUnitsFulfilledMutationOptions = Apollo.BaseMutationOptions<UpdateProductPurchasesUnitsFulfilledMutation, UpdateProductPurchasesUnitsFulfilledMutationVariables>;
export const GetStripeSubscriptionInvoicesDocument = gql`
    query GetStripeSubscriptionInvoices($location: uuid!, $provider: uuid!) {
  GetStripeSubscriptionInvoices(location: $location, provider: $provider) {
    amountDue
    createdAt
    stripeId
    link
    lineItem {
      stripeId
      name
      totalCost
      unitCost
      units
    }
  }
}
    `;

/**
 * __useGetStripeSubscriptionInvoicesQuery__
 *
 * To run a query within a React component, call `useGetStripeSubscriptionInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeSubscriptionInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeSubscriptionInvoicesQuery({
 *   variables: {
 *      location: // value for 'location'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useGetStripeSubscriptionInvoicesQuery(baseOptions: Apollo.QueryHookOptions<GetStripeSubscriptionInvoicesQuery, GetStripeSubscriptionInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeSubscriptionInvoicesQuery, GetStripeSubscriptionInvoicesQueryVariables>(GetStripeSubscriptionInvoicesDocument, options);
      }
export function useGetStripeSubscriptionInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeSubscriptionInvoicesQuery, GetStripeSubscriptionInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeSubscriptionInvoicesQuery, GetStripeSubscriptionInvoicesQueryVariables>(GetStripeSubscriptionInvoicesDocument, options);
        }
export type GetStripeSubscriptionInvoicesQueryHookResult = ReturnType<typeof useGetStripeSubscriptionInvoicesQuery>;
export type GetStripeSubscriptionInvoicesLazyQueryHookResult = ReturnType<typeof useGetStripeSubscriptionInvoicesLazyQuery>;
export type GetStripeSubscriptionInvoicesQueryResult = Apollo.QueryResult<GetStripeSubscriptionInvoicesQuery, GetStripeSubscriptionInvoicesQueryVariables>;
export const RentalVolumeDiscountListDocument = gql`
    query RentalVolumeDiscountList($_in: [uuid!]!) {
  rental_volume_discount(where: {location: {_in: $_in}}) {
    discountRate
    hours
    location
  }
}
    `;

/**
 * __useRentalVolumeDiscountListQuery__
 *
 * To run a query within a React component, call `useRentalVolumeDiscountListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRentalVolumeDiscountListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRentalVolumeDiscountListQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useRentalVolumeDiscountListQuery(baseOptions: Apollo.QueryHookOptions<RentalVolumeDiscountListQuery, RentalVolumeDiscountListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RentalVolumeDiscountListQuery, RentalVolumeDiscountListQueryVariables>(RentalVolumeDiscountListDocument, options);
      }
export function useRentalVolumeDiscountListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RentalVolumeDiscountListQuery, RentalVolumeDiscountListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RentalVolumeDiscountListQuery, RentalVolumeDiscountListQueryVariables>(RentalVolumeDiscountListDocument, options);
        }
export type RentalVolumeDiscountListQueryHookResult = ReturnType<typeof useRentalVolumeDiscountListQuery>;
export type RentalVolumeDiscountListLazyQueryHookResult = ReturnType<typeof useRentalVolumeDiscountListLazyQuery>;
export type RentalVolumeDiscountListQueryResult = Apollo.QueryResult<RentalVolumeDiscountListQuery, RentalVolumeDiscountListQueryVariables>;
export const RentalVolumeDiscountDeleteDocument = gql`
    mutation RentalVolumeDiscountDelete($hours: Int!, $location: uuid!) {
  delete_rental_volume_discount_by_pk(hours: $hours, location: $location) {
    hours
    location
  }
}
    `;
export type RentalVolumeDiscountDeleteMutationFn = Apollo.MutationFunction<RentalVolumeDiscountDeleteMutation, RentalVolumeDiscountDeleteMutationVariables>;

/**
 * __useRentalVolumeDiscountDeleteMutation__
 *
 * To run a mutation, you first call `useRentalVolumeDiscountDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRentalVolumeDiscountDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rentalVolumeDiscountDeleteMutation, { data, loading, error }] = useRentalVolumeDiscountDeleteMutation({
 *   variables: {
 *      hours: // value for 'hours'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useRentalVolumeDiscountDeleteMutation(baseOptions?: Apollo.MutationHookOptions<RentalVolumeDiscountDeleteMutation, RentalVolumeDiscountDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RentalVolumeDiscountDeleteMutation, RentalVolumeDiscountDeleteMutationVariables>(RentalVolumeDiscountDeleteDocument, options);
      }
export type RentalVolumeDiscountDeleteMutationHookResult = ReturnType<typeof useRentalVolumeDiscountDeleteMutation>;
export type RentalVolumeDiscountDeleteMutationResult = Apollo.MutationResult<RentalVolumeDiscountDeleteMutation>;
export type RentalVolumeDiscountDeleteMutationOptions = Apollo.BaseMutationOptions<RentalVolumeDiscountDeleteMutation, RentalVolumeDiscountDeleteMutationVariables>;
export const RentalVolumeDiscountCreateDocument = gql`
    mutation RentalVolumeDiscountCreate($object: rental_volume_discount_insert_input!) {
  insert_rental_volume_discount_one(object: $object) {
    discountRate
    hours
    location
  }
}
    `;
export type RentalVolumeDiscountCreateMutationFn = Apollo.MutationFunction<RentalVolumeDiscountCreateMutation, RentalVolumeDiscountCreateMutationVariables>;

/**
 * __useRentalVolumeDiscountCreateMutation__
 *
 * To run a mutation, you first call `useRentalVolumeDiscountCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRentalVolumeDiscountCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rentalVolumeDiscountCreateMutation, { data, loading, error }] = useRentalVolumeDiscountCreateMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useRentalVolumeDiscountCreateMutation(baseOptions?: Apollo.MutationHookOptions<RentalVolumeDiscountCreateMutation, RentalVolumeDiscountCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RentalVolumeDiscountCreateMutation, RentalVolumeDiscountCreateMutationVariables>(RentalVolumeDiscountCreateDocument, options);
      }
export type RentalVolumeDiscountCreateMutationHookResult = ReturnType<typeof useRentalVolumeDiscountCreateMutation>;
export type RentalVolumeDiscountCreateMutationResult = Apollo.MutationResult<RentalVolumeDiscountCreateMutation>;
export type RentalVolumeDiscountCreateMutationOptions = Apollo.BaseMutationOptions<RentalVolumeDiscountCreateMutation, RentalVolumeDiscountCreateMutationVariables>;
export const RentalVolumeDiscountUpdateDocument = gql`
    mutation RentalVolumeDiscountUpdate($hours: Int!, $location: uuid!, $discountRate: Int!) {
  update_rental_volume_discount_by_pk(
    pk_columns: {hours: $hours, location: $location}
    _set: {discountRate: $discountRate}
  ) {
    location
    discountRate
    hours
  }
}
    `;
export type RentalVolumeDiscountUpdateMutationFn = Apollo.MutationFunction<RentalVolumeDiscountUpdateMutation, RentalVolumeDiscountUpdateMutationVariables>;

/**
 * __useRentalVolumeDiscountUpdateMutation__
 *
 * To run a mutation, you first call `useRentalVolumeDiscountUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRentalVolumeDiscountUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rentalVolumeDiscountUpdateMutation, { data, loading, error }] = useRentalVolumeDiscountUpdateMutation({
 *   variables: {
 *      hours: // value for 'hours'
 *      location: // value for 'location'
 *      discountRate: // value for 'discountRate'
 *   },
 * });
 */
export function useRentalVolumeDiscountUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RentalVolumeDiscountUpdateMutation, RentalVolumeDiscountUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RentalVolumeDiscountUpdateMutation, RentalVolumeDiscountUpdateMutationVariables>(RentalVolumeDiscountUpdateDocument, options);
      }
export type RentalVolumeDiscountUpdateMutationHookResult = ReturnType<typeof useRentalVolumeDiscountUpdateMutation>;
export type RentalVolumeDiscountUpdateMutationResult = Apollo.MutationResult<RentalVolumeDiscountUpdateMutation>;
export type RentalVolumeDiscountUpdateMutationOptions = Apollo.BaseMutationOptions<RentalVolumeDiscountUpdateMutation, RentalVolumeDiscountUpdateMutationVariables>;
export const UserAuthContextDocument = gql`
    query UserAuthContext($_eq: uuid!) {
  user(where: {cognitoUserSub: {_eq: $_eq}}) {
    id
    active
    firstName
    lastName
    role
    accreditation
    cognitoUserSub
    userLocations {
      user
      location
      locationByLocation {
        name
        id
        timezone
        bookingAllowed
        parentLocation
        usesParentLocationPlans
        providerDirectProductPurchase
        providerDirectPurchaseProfitMargin
      }
    }
  }
}
    `;

/**
 * __useUserAuthContextQuery__
 *
 * To run a query within a React component, call `useUserAuthContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAuthContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAuthContextQuery({
 *   variables: {
 *      _eq: // value for '_eq'
 *   },
 * });
 */
export function useUserAuthContextQuery(baseOptions: Apollo.QueryHookOptions<UserAuthContextQuery, UserAuthContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAuthContextQuery, UserAuthContextQueryVariables>(UserAuthContextDocument, options);
      }
export function useUserAuthContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAuthContextQuery, UserAuthContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAuthContextQuery, UserAuthContextQueryVariables>(UserAuthContextDocument, options);
        }
export type UserAuthContextQueryHookResult = ReturnType<typeof useUserAuthContextQuery>;
export type UserAuthContextLazyQueryHookResult = ReturnType<typeof useUserAuthContextLazyQuery>;
export type UserAuthContextQueryResult = Apollo.QueryResult<UserAuthContextQuery, UserAuthContextQueryVariables>;
export const CreateUserSignupDocument = gql`
    mutation CreateUserSignup($firstName: String!, $lastName: String!, $cognitoUserSub: uuid!, $role: role_enum!, $userLocations: user_location_arr_rel_insert_input!) {
  insert_user_one(
    object: {cognitoUserSub: $cognitoUserSub, firstName: $firstName, lastName: $lastName, role: $role, userLocations: $userLocations}
  ) {
    id
  }
}
    `;
export type CreateUserSignupMutationFn = Apollo.MutationFunction<CreateUserSignupMutation, CreateUserSignupMutationVariables>;

/**
 * __useCreateUserSignupMutation__
 *
 * To run a mutation, you first call `useCreateUserSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserSignupMutation, { data, loading, error }] = useCreateUserSignupMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      cognitoUserSub: // value for 'cognitoUserSub'
 *      role: // value for 'role'
 *      userLocations: // value for 'userLocations'
 *   },
 * });
 */
export function useCreateUserSignupMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserSignupMutation, CreateUserSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserSignupMutation, CreateUserSignupMutationVariables>(CreateUserSignupDocument, options);
      }
export type CreateUserSignupMutationHookResult = ReturnType<typeof useCreateUserSignupMutation>;
export type CreateUserSignupMutationResult = Apollo.MutationResult<CreateUserSignupMutation>;
export type CreateUserSignupMutationOptions = Apollo.BaseMutationOptions<CreateUserSignupMutation, CreateUserSignupMutationVariables>;
export const LocationProductWarnCountDocument = gql`
    query LocationProductWarnCount($location: uuid!) {
  location_product_aggregate(
    where: {_and: {location: {_eq: $location}, triggeredWarning: {_eq: true}}}
  ) {
    aggregate {
      count(columns: product)
    }
  }
}
    `;

/**
 * __useLocationProductWarnCountQuery__
 *
 * To run a query within a React component, call `useLocationProductWarnCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationProductWarnCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationProductWarnCountQuery({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useLocationProductWarnCountQuery(baseOptions: Apollo.QueryHookOptions<LocationProductWarnCountQuery, LocationProductWarnCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationProductWarnCountQuery, LocationProductWarnCountQueryVariables>(LocationProductWarnCountDocument, options);
      }
export function useLocationProductWarnCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationProductWarnCountQuery, LocationProductWarnCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationProductWarnCountQuery, LocationProductWarnCountQueryVariables>(LocationProductWarnCountDocument, options);
        }
export type LocationProductWarnCountQueryHookResult = ReturnType<typeof useLocationProductWarnCountQuery>;
export type LocationProductWarnCountLazyQueryHookResult = ReturnType<typeof useLocationProductWarnCountLazyQuery>;
export type LocationProductWarnCountQueryResult = Apollo.QueryResult<LocationProductWarnCountQuery, LocationProductWarnCountQueryVariables>;
export const EhrProcedureListDocument = gql`
    query EhrProcedureList {
  ehr_procedure(order_by: {name: asc}, where: {deleted_at: {_is_null: true}}) {
    id
    name
    deleted_at
  }
}
    `;

/**
 * __useEhrProcedureListQuery__
 *
 * To run a query within a React component, call `useEhrProcedureListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEhrProcedureListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEhrProcedureListQuery({
 *   variables: {
 *   },
 * });
 */
export function useEhrProcedureListQuery(baseOptions?: Apollo.QueryHookOptions<EhrProcedureListQuery, EhrProcedureListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EhrProcedureListQuery, EhrProcedureListQueryVariables>(EhrProcedureListDocument, options);
      }
export function useEhrProcedureListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EhrProcedureListQuery, EhrProcedureListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EhrProcedureListQuery, EhrProcedureListQueryVariables>(EhrProcedureListDocument, options);
        }
export type EhrProcedureListQueryHookResult = ReturnType<typeof useEhrProcedureListQuery>;
export type EhrProcedureListLazyQueryHookResult = ReturnType<typeof useEhrProcedureListLazyQuery>;
export type EhrProcedureListQueryResult = Apollo.QueryResult<EhrProcedureListQuery, EhrProcedureListQueryVariables>;
export const EhrProcedureDeleteDocument = gql`
    mutation EhrProcedureDelete($id: uuid!) {
  update_ehr_procedure_by_pk(pk_columns: {id: $id}, _set: {deleted_at: "now()"}) {
    id
    name
    created_at
    deleted_at
    updated_at
  }
}
    `;
export type EhrProcedureDeleteMutationFn = Apollo.MutationFunction<EhrProcedureDeleteMutation, EhrProcedureDeleteMutationVariables>;

/**
 * __useEhrProcedureDeleteMutation__
 *
 * To run a mutation, you first call `useEhrProcedureDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEhrProcedureDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ehrProcedureDeleteMutation, { data, loading, error }] = useEhrProcedureDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEhrProcedureDeleteMutation(baseOptions?: Apollo.MutationHookOptions<EhrProcedureDeleteMutation, EhrProcedureDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EhrProcedureDeleteMutation, EhrProcedureDeleteMutationVariables>(EhrProcedureDeleteDocument, options);
      }
export type EhrProcedureDeleteMutationHookResult = ReturnType<typeof useEhrProcedureDeleteMutation>;
export type EhrProcedureDeleteMutationResult = Apollo.MutationResult<EhrProcedureDeleteMutation>;
export type EhrProcedureDeleteMutationOptions = Apollo.BaseMutationOptions<EhrProcedureDeleteMutation, EhrProcedureDeleteMutationVariables>;
export const EhrProcedureInsertDocument = gql`
    mutation EhrProcedureInsert($name: ehr_procedure_type_enum_enum!) {
  insert_ehr_procedure_one(object: {name: $name}) {
    id
    name
    created_at
    deleted_at
    updated_at
  }
}
    `;
export type EhrProcedureInsertMutationFn = Apollo.MutationFunction<EhrProcedureInsertMutation, EhrProcedureInsertMutationVariables>;

/**
 * __useEhrProcedureInsertMutation__
 *
 * To run a mutation, you first call `useEhrProcedureInsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEhrProcedureInsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ehrProcedureInsertMutation, { data, loading, error }] = useEhrProcedureInsertMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEhrProcedureInsertMutation(baseOptions?: Apollo.MutationHookOptions<EhrProcedureInsertMutation, EhrProcedureInsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EhrProcedureInsertMutation, EhrProcedureInsertMutationVariables>(EhrProcedureInsertDocument, options);
      }
export type EhrProcedureInsertMutationHookResult = ReturnType<typeof useEhrProcedureInsertMutation>;
export type EhrProcedureInsertMutationResult = Apollo.MutationResult<EhrProcedureInsertMutation>;
export type EhrProcedureInsertMutationOptions = Apollo.BaseMutationOptions<EhrProcedureInsertMutation, EhrProcedureInsertMutationVariables>;
export const EhrProcedureUpdateDocument = gql`
    mutation EhrProcedureUpdate($id: uuid!, $name: ehr_procedure_type_enum_enum!) {
  update_ehr_procedure_by_pk(pk_columns: {id: $id}, _set: {name: $name}) {
    id
    name
    created_at
    deleted_at
    updated_at
  }
}
    `;
export type EhrProcedureUpdateMutationFn = Apollo.MutationFunction<EhrProcedureUpdateMutation, EhrProcedureUpdateMutationVariables>;

/**
 * __useEhrProcedureUpdateMutation__
 *
 * To run a mutation, you first call `useEhrProcedureUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEhrProcedureUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ehrProcedureUpdateMutation, { data, loading, error }] = useEhrProcedureUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEhrProcedureUpdateMutation(baseOptions?: Apollo.MutationHookOptions<EhrProcedureUpdateMutation, EhrProcedureUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EhrProcedureUpdateMutation, EhrProcedureUpdateMutationVariables>(EhrProcedureUpdateDocument, options);
      }
export type EhrProcedureUpdateMutationHookResult = ReturnType<typeof useEhrProcedureUpdateMutation>;
export type EhrProcedureUpdateMutationResult = Apollo.MutationResult<EhrProcedureUpdateMutation>;
export type EhrProcedureUpdateMutationOptions = Apollo.BaseMutationOptions<EhrProcedureUpdateMutation, EhrProcedureUpdateMutationVariables>;
export const AllEhrProceduresDocument = gql`
    query AllEhrProcedures {
  ehr_procedure(where: {deleted_at: {_is_null: true}}) {
    id
    name
  }
}
    `;

/**
 * __useAllEhrProceduresQuery__
 *
 * To run a query within a React component, call `useAllEhrProceduresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEhrProceduresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllEhrProceduresQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllEhrProceduresQuery(baseOptions?: Apollo.QueryHookOptions<AllEhrProceduresQuery, AllEhrProceduresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllEhrProceduresQuery, AllEhrProceduresQueryVariables>(AllEhrProceduresDocument, options);
      }
export function useAllEhrProceduresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllEhrProceduresQuery, AllEhrProceduresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllEhrProceduresQuery, AllEhrProceduresQueryVariables>(AllEhrProceduresDocument, options);
        }
export type AllEhrProceduresQueryHookResult = ReturnType<typeof useAllEhrProceduresQuery>;
export type AllEhrProceduresLazyQueryHookResult = ReturnType<typeof useAllEhrProceduresLazyQuery>;
export type AllEhrProceduresQueryResult = Apollo.QueryResult<AllEhrProceduresQuery, AllEhrProceduresQueryVariables>;
export const EhrProductListDocument = gql`
    query EhrProductList {
  ehr_product(where: {deletedAt: {_is_null: true}}, order_by: {name: asc}) {
    id
    name
    deletedAt
    photoS3Key
    dosages
    unitsText
    ehr_procedure_ehr_products {
      ehrProduct
      ehrProcedure
      ehrProcedureByEhrProcedure {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useEhrProductListQuery__
 *
 * To run a query within a React component, call `useEhrProductListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEhrProductListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEhrProductListQuery({
 *   variables: {
 *   },
 * });
 */
export function useEhrProductListQuery(baseOptions?: Apollo.QueryHookOptions<EhrProductListQuery, EhrProductListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EhrProductListQuery, EhrProductListQueryVariables>(EhrProductListDocument, options);
      }
export function useEhrProductListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EhrProductListQuery, EhrProductListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EhrProductListQuery, EhrProductListQueryVariables>(EhrProductListDocument, options);
        }
export type EhrProductListQueryHookResult = ReturnType<typeof useEhrProductListQuery>;
export type EhrProductListLazyQueryHookResult = ReturnType<typeof useEhrProductListLazyQuery>;
export type EhrProductListQueryResult = Apollo.QueryResult<EhrProductListQuery, EhrProductListQueryVariables>;
export const EhrProductListDeleteDocument = gql`
    mutation EhrProductListDelete($id: uuid!) {
  update_ehr_product_by_pk(pk_columns: {id: $id}, _set: {deletedAt: "now()"}) {
    id
    deletedAt
  }
}
    `;
export type EhrProductListDeleteMutationFn = Apollo.MutationFunction<EhrProductListDeleteMutation, EhrProductListDeleteMutationVariables>;

/**
 * __useEhrProductListDeleteMutation__
 *
 * To run a mutation, you first call `useEhrProductListDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEhrProductListDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ehrProductListDeleteMutation, { data, loading, error }] = useEhrProductListDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEhrProductListDeleteMutation(baseOptions?: Apollo.MutationHookOptions<EhrProductListDeleteMutation, EhrProductListDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EhrProductListDeleteMutation, EhrProductListDeleteMutationVariables>(EhrProductListDeleteDocument, options);
      }
export type EhrProductListDeleteMutationHookResult = ReturnType<typeof useEhrProductListDeleteMutation>;
export type EhrProductListDeleteMutationResult = Apollo.MutationResult<EhrProductListDeleteMutation>;
export type EhrProductListDeleteMutationOptions = Apollo.BaseMutationOptions<EhrProductListDeleteMutation, EhrProductListDeleteMutationVariables>;
export const EhrProductListCreateDocument = gql`
    mutation EhrProductListCreate($name: String!, $photoS3Key: uuid, $dosages: [numeric!]!, $unitsText: String, $ehrProceduresData: [ehr_procedure_ehr_product_insert_input!]!) {
  insert_ehr_product_one(
    object: {name: $name, photoS3Key: $photoS3Key, dosages: $dosages, unitsText: $unitsText, ehr_procedure_ehr_products: {data: $ehrProceduresData}}
  ) {
    id
    name
    deletedAt
    photoS3Key
    dosages
    unitsText
    ehr_procedure_ehr_products {
      ehrProduct
      ehrProcedure
    }
  }
}
    `;
export type EhrProductListCreateMutationFn = Apollo.MutationFunction<EhrProductListCreateMutation, EhrProductListCreateMutationVariables>;

/**
 * __useEhrProductListCreateMutation__
 *
 * To run a mutation, you first call `useEhrProductListCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEhrProductListCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ehrProductListCreateMutation, { data, loading, error }] = useEhrProductListCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      photoS3Key: // value for 'photoS3Key'
 *      dosages: // value for 'dosages'
 *      unitsText: // value for 'unitsText'
 *      ehrProceduresData: // value for 'ehrProceduresData'
 *   },
 * });
 */
export function useEhrProductListCreateMutation(baseOptions?: Apollo.MutationHookOptions<EhrProductListCreateMutation, EhrProductListCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EhrProductListCreateMutation, EhrProductListCreateMutationVariables>(EhrProductListCreateDocument, options);
      }
export type EhrProductListCreateMutationHookResult = ReturnType<typeof useEhrProductListCreateMutation>;
export type EhrProductListCreateMutationResult = Apollo.MutationResult<EhrProductListCreateMutation>;
export type EhrProductListCreateMutationOptions = Apollo.BaseMutationOptions<EhrProductListCreateMutation, EhrProductListCreateMutationVariables>;
export const EhrProductListUpdateDocument = gql`
    mutation EhrProductListUpdate($id: uuid!, $name: String!, $photoS3Key: uuid, $dosages: [numeric!]!, $unitsText: String, $insertObjects: [ehr_procedure_ehr_product_insert_input!]!, $ehrProduct: uuid!, $ehrProceduresToDelete: [uuid!]!) {
  update_ehr_product_by_pk(
    pk_columns: {id: $id}
    _set: {name: $name, photoS3Key: $photoS3Key, dosages: $dosages, unitsText: $unitsText}
  ) {
    id
    name
    deletedAt
    photoS3Key
    dosages
    unitsText
    ehr_procedure_ehr_products {
      ehrProduct
      ehrProcedure
      ehrProcedureByEhrProcedure {
        id
        name
      }
    }
  }
  insert_ehr_procedure_ehr_product(objects: $insertObjects) {
    returning {
      ehrProcedure
      ehrProduct
      ehrProductByEhrProduct {
        id
        name
      }
    }
  }
  delete_ehr_procedure_ehr_product(
    where: {ehrProduct: {_eq: $ehrProduct}, ehrProcedure: {_in: $ehrProceduresToDelete}}
  ) {
    returning {
      ehrProduct
      ehrProcedure
      ehrProductByEhrProduct {
        id
        name
      }
    }
  }
}
    `;
export type EhrProductListUpdateMutationFn = Apollo.MutationFunction<EhrProductListUpdateMutation, EhrProductListUpdateMutationVariables>;

/**
 * __useEhrProductListUpdateMutation__
 *
 * To run a mutation, you first call `useEhrProductListUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEhrProductListUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ehrProductListUpdateMutation, { data, loading, error }] = useEhrProductListUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      photoS3Key: // value for 'photoS3Key'
 *      dosages: // value for 'dosages'
 *      unitsText: // value for 'unitsText'
 *      insertObjects: // value for 'insertObjects'
 *      ehrProduct: // value for 'ehrProduct'
 *      ehrProceduresToDelete: // value for 'ehrProceduresToDelete'
 *   },
 * });
 */
export function useEhrProductListUpdateMutation(baseOptions?: Apollo.MutationHookOptions<EhrProductListUpdateMutation, EhrProductListUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EhrProductListUpdateMutation, EhrProductListUpdateMutationVariables>(EhrProductListUpdateDocument, options);
      }
export type EhrProductListUpdateMutationHookResult = ReturnType<typeof useEhrProductListUpdateMutation>;
export type EhrProductListUpdateMutationResult = Apollo.MutationResult<EhrProductListUpdateMutation>;
export type EhrProductListUpdateMutationOptions = Apollo.BaseMutationOptions<EhrProductListUpdateMutation, EhrProductListUpdateMutationVariables>;
export const LocationListDocument = gql`
    query LocationList {
  location {
    id
    name
    timezone
    deleted_at
    bookingAllowed
    providerPlanRequired
    parentLocation
    usesParentLocationPlans
    providerDirectProductPurchase
    providerDirectPurchaseProfitMargin
    licenseDocumentRequired
    licenseExpirationRequired
    malpracticeRequired
    medicalDirectorRequired
    addressByAddress {
      id
      line1
      line2
      city
      state
      zipcode
    }
    partnerByPartner {
      id
      name
    }
    parentLocationByLocation {
      id
      name
    }
    childLocationByLocation_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useLocationListQuery__
 *
 * To run a query within a React component, call `useLocationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationListQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocationListQuery(baseOptions?: Apollo.QueryHookOptions<LocationListQuery, LocationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationListQuery, LocationListQueryVariables>(LocationListDocument, options);
      }
export function useLocationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationListQuery, LocationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationListQuery, LocationListQueryVariables>(LocationListDocument, options);
        }
export type LocationListQueryHookResult = ReturnType<typeof useLocationListQuery>;
export type LocationListLazyQueryHookResult = ReturnType<typeof useLocationListLazyQuery>;
export type LocationListQueryResult = Apollo.QueryResult<LocationListQuery, LocationListQueryVariables>;
export const LocationDeleteDocument = gql`
    mutation LocationDelete($id: uuid!) {
  update_location_by_pk(pk_columns: {id: $id}, _set: {deleted_at: "now()"}) {
    id
    deleted_at
  }
  delete_user_location(where: {location: {_eq: $id}}) {
    returning {
      user
      location
    }
  }
}
    `;
export type LocationDeleteMutationFn = Apollo.MutationFunction<LocationDeleteMutation, LocationDeleteMutationVariables>;

/**
 * __useLocationDeleteMutation__
 *
 * To run a mutation, you first call `useLocationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locationDeleteMutation, { data, loading, error }] = useLocationDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationDeleteMutation(baseOptions?: Apollo.MutationHookOptions<LocationDeleteMutation, LocationDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocationDeleteMutation, LocationDeleteMutationVariables>(LocationDeleteDocument, options);
      }
export type LocationDeleteMutationHookResult = ReturnType<typeof useLocationDeleteMutation>;
export type LocationDeleteMutationResult = Apollo.MutationResult<LocationDeleteMutation>;
export type LocationDeleteMutationOptions = Apollo.BaseMutationOptions<LocationDeleteMutation, LocationDeleteMutationVariables>;
export const LocationCreateDocument = gql`
    mutation LocationCreate($object: location_insert_input!, $location: uuid!) {
  insert_location_one(object: $object) {
    id
    name
    timezone
    deleted_at
    providerDirectProductPurchase
    usesParentLocationPlans
    providerDirectPurchaseProfitMargin
    providerPlanRequired
    licenseDocumentRequired
    licenseExpirationRequired
    malpracticeRequired
    medicalDirectorRequired
    partnerByPartner {
      id
      name
    }
    parentLocationByLocation {
      id
      name
      childLocationByLocation_aggregate {
        aggregate {
          count
        }
      }
    }
    addressByAddress {
      id
      line1
      line2
      city
      state
      zipcode
    }
  }
  insert_tax_rate(
    objects: [{name: "Product", location: $location, rate: 0.0, type: Product}, {name: "Model", location: $location, rate: 0.0, type: Model}, {name: "Services", location: $location, rate: 0.0, type: Services}, {name: "Non_taxable", location: $location, rate: 0.0, type: Non_taxable}]
  ) {
    returning {
      location
      name
      rate
      type
      id
    }
  }
}
    `;
export type LocationCreateMutationFn = Apollo.MutationFunction<LocationCreateMutation, LocationCreateMutationVariables>;

/**
 * __useLocationCreateMutation__
 *
 * To run a mutation, you first call `useLocationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locationCreateMutation, { data, loading, error }] = useLocationCreateMutation({
 *   variables: {
 *      object: // value for 'object'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useLocationCreateMutation(baseOptions?: Apollo.MutationHookOptions<LocationCreateMutation, LocationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocationCreateMutation, LocationCreateMutationVariables>(LocationCreateDocument, options);
      }
export type LocationCreateMutationHookResult = ReturnType<typeof useLocationCreateMutation>;
export type LocationCreateMutationResult = Apollo.MutationResult<LocationCreateMutation>;
export type LocationCreateMutationOptions = Apollo.BaseMutationOptions<LocationCreateMutation, LocationCreateMutationVariables>;
export const LocationUpdateVansanityAdminDocument = gql`
    mutation LocationUpdateVansanityAdmin($id: uuid!, $addressId: uuid!, $name: String!, $line1: String!, $line2: String, $state: String!, $city: String!, $zipcode: String!, $timezone: String!, $usesParentLocationPlans: Boolean!, $parentLocation: uuid, $partner: uuid!, $bookingAllowed: Boolean!, $providerDirectProductPurchase: Boolean!, $providerDirectPurchaseProfitMargin: Int, $providerPlanRequired: Boolean!, $licenseDocumentRequired: Boolean!, $licenseExpirationRequired: Boolean!, $malpracticeRequired: Boolean!, $medicalDirectorRequired: Boolean!) {
  update_location_by_pk(
    pk_columns: {id: $id}
    _set: {name: $name, timezone: $timezone, bookingAllowed: $bookingAllowed, parentLocation: $parentLocation, usesParentLocationPlans: $usesParentLocationPlans, partner: $partner, providerDirectProductPurchase: $providerDirectProductPurchase, providerDirectPurchaseProfitMargin: $providerDirectPurchaseProfitMargin, providerPlanRequired: $providerPlanRequired, licenseDocumentRequired: $licenseDocumentRequired, licenseExpirationRequired: $licenseExpirationRequired, malpracticeRequired: $malpracticeRequired, medicalDirectorRequired: $medicalDirectorRequired}
  ) {
    id
    name
    timezone
    deleted_at
    bookingAllowed
    providerPlanRequired
    providerDirectProductPurchase
    providerDirectPurchaseProfitMargin
    licenseDocumentRequired
    licenseExpirationRequired
    malpracticeRequired
    medicalDirectorRequired
    partnerByPartner {
      id
      name
    }
    usesParentLocationPlans
    parentLocationByLocation {
      id
      name
      childLocationByLocation_aggregate {
        aggregate {
          count
        }
      }
    }
    addressByAddress {
      id
      line1
      line2
      city
      state
      zipcode
    }
  }
  update_address_by_pk(
    pk_columns: {id: $addressId}
    _set: {city: $city, line1: $line1, line2: $line2, state: $state, zipcode: $zipcode}
  ) {
    id
    city
    line1
    line2
    state
    zipcode
  }
}
    `;
export type LocationUpdateVansanityAdminMutationFn = Apollo.MutationFunction<LocationUpdateVansanityAdminMutation, LocationUpdateVansanityAdminMutationVariables>;

/**
 * __useLocationUpdateVansanityAdminMutation__
 *
 * To run a mutation, you first call `useLocationUpdateVansanityAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocationUpdateVansanityAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locationUpdateVansanityAdminMutation, { data, loading, error }] = useLocationUpdateVansanityAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      addressId: // value for 'addressId'
 *      name: // value for 'name'
 *      line1: // value for 'line1'
 *      line2: // value for 'line2'
 *      state: // value for 'state'
 *      city: // value for 'city'
 *      zipcode: // value for 'zipcode'
 *      timezone: // value for 'timezone'
 *      usesParentLocationPlans: // value for 'usesParentLocationPlans'
 *      parentLocation: // value for 'parentLocation'
 *      partner: // value for 'partner'
 *      bookingAllowed: // value for 'bookingAllowed'
 *      providerDirectProductPurchase: // value for 'providerDirectProductPurchase'
 *      providerDirectPurchaseProfitMargin: // value for 'providerDirectPurchaseProfitMargin'
 *      providerPlanRequired: // value for 'providerPlanRequired'
 *      licenseDocumentRequired: // value for 'licenseDocumentRequired'
 *      licenseExpirationRequired: // value for 'licenseExpirationRequired'
 *      malpracticeRequired: // value for 'malpracticeRequired'
 *      medicalDirectorRequired: // value for 'medicalDirectorRequired'
 *   },
 * });
 */
export function useLocationUpdateVansanityAdminMutation(baseOptions?: Apollo.MutationHookOptions<LocationUpdateVansanityAdminMutation, LocationUpdateVansanityAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocationUpdateVansanityAdminMutation, LocationUpdateVansanityAdminMutationVariables>(LocationUpdateVansanityAdminDocument, options);
      }
export type LocationUpdateVansanityAdminMutationHookResult = ReturnType<typeof useLocationUpdateVansanityAdminMutation>;
export type LocationUpdateVansanityAdminMutationResult = Apollo.MutationResult<LocationUpdateVansanityAdminMutation>;
export type LocationUpdateVansanityAdminMutationOptions = Apollo.BaseMutationOptions<LocationUpdateVansanityAdminMutation, LocationUpdateVansanityAdminMutationVariables>;
export const LocationUpdateLocationAdminDocument = gql`
    mutation LocationUpdateLocationAdmin($id: uuid!, $addressId: uuid!, $name: String!, $line1: String!, $line2: String, $state: String!, $city: String!, $zipcode: String!, $timezone: String!, $providerDirectPurchaseProfitMargin: Int, $providerPlanRequired: Boolean!, $licenseDocumentRequired: Boolean!, $licenseExpirationRequired: Boolean!, $malpracticeRequired: Boolean!, $medicalDirectorRequired: Boolean!) {
  update_location_by_pk(
    pk_columns: {id: $id}
    _set: {name: $name, timezone: $timezone, providerPlanRequired: $providerPlanRequired, providerDirectPurchaseProfitMargin: $providerDirectPurchaseProfitMargin, licenseDocumentRequired: $licenseDocumentRequired, licenseExpirationRequired: $licenseExpirationRequired, malpracticeRequired: $malpracticeRequired, medicalDirectorRequired: $medicalDirectorRequired}
  ) {
    id
    name
    timezone
    deleted_at
    bookingAllowed
    providerPlanRequired
    providerDirectPurchaseProfitMargin
    licenseDocumentRequired
    licenseExpirationRequired
    malpracticeRequired
    medicalDirectorRequired
    partnerByPartner {
      id
      name
    }
    usesParentLocationPlans
    parentLocationByLocation {
      id
      name
      childLocationByLocation_aggregate {
        aggregate {
          count
        }
      }
    }
    addressByAddress {
      id
      line1
      line2
      city
      state
      zipcode
    }
  }
  update_address_by_pk(
    pk_columns: {id: $addressId}
    _set: {city: $city, line1: $line1, line2: $line2, state: $state, zipcode: $zipcode}
  ) {
    id
    city
    line1
    line2
    state
    zipcode
  }
}
    `;
export type LocationUpdateLocationAdminMutationFn = Apollo.MutationFunction<LocationUpdateLocationAdminMutation, LocationUpdateLocationAdminMutationVariables>;

/**
 * __useLocationUpdateLocationAdminMutation__
 *
 * To run a mutation, you first call `useLocationUpdateLocationAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLocationUpdateLocationAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [locationUpdateLocationAdminMutation, { data, loading, error }] = useLocationUpdateLocationAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      addressId: // value for 'addressId'
 *      name: // value for 'name'
 *      line1: // value for 'line1'
 *      line2: // value for 'line2'
 *      state: // value for 'state'
 *      city: // value for 'city'
 *      zipcode: // value for 'zipcode'
 *      timezone: // value for 'timezone'
 *      providerDirectPurchaseProfitMargin: // value for 'providerDirectPurchaseProfitMargin'
 *      providerPlanRequired: // value for 'providerPlanRequired'
 *      licenseDocumentRequired: // value for 'licenseDocumentRequired'
 *      licenseExpirationRequired: // value for 'licenseExpirationRequired'
 *      malpracticeRequired: // value for 'malpracticeRequired'
 *      medicalDirectorRequired: // value for 'medicalDirectorRequired'
 *   },
 * });
 */
export function useLocationUpdateLocationAdminMutation(baseOptions?: Apollo.MutationHookOptions<LocationUpdateLocationAdminMutation, LocationUpdateLocationAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LocationUpdateLocationAdminMutation, LocationUpdateLocationAdminMutationVariables>(LocationUpdateLocationAdminDocument, options);
      }
export type LocationUpdateLocationAdminMutationHookResult = ReturnType<typeof useLocationUpdateLocationAdminMutation>;
export type LocationUpdateLocationAdminMutationResult = Apollo.MutationResult<LocationUpdateLocationAdminMutation>;
export type LocationUpdateLocationAdminMutationOptions = Apollo.BaseMutationOptions<LocationUpdateLocationAdminMutation, LocationUpdateLocationAdminMutationVariables>;
export const CreateNewMsoDocument = gql`
    mutation CreateNewMso($location: uuid!, $msoSetupEmail: String!, $msoName: String!) {
  createNewMso(
    object: {location: $location, msoSetupEmail: $msoSetupEmail, msoName: $msoName}
  ) {
    id
    name
  }
}
    `;
export type CreateNewMsoMutationFn = Apollo.MutationFunction<CreateNewMsoMutation, CreateNewMsoMutationVariables>;

/**
 * __useCreateNewMsoMutation__
 *
 * To run a mutation, you first call `useCreateNewMsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewMsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewMsoMutation, { data, loading, error }] = useCreateNewMsoMutation({
 *   variables: {
 *      location: // value for 'location'
 *      msoSetupEmail: // value for 'msoSetupEmail'
 *      msoName: // value for 'msoName'
 *   },
 * });
 */
export function useCreateNewMsoMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewMsoMutation, CreateNewMsoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewMsoMutation, CreateNewMsoMutationVariables>(CreateNewMsoDocument, options);
      }
export type CreateNewMsoMutationHookResult = ReturnType<typeof useCreateNewMsoMutation>;
export type CreateNewMsoMutationResult = Apollo.MutationResult<CreateNewMsoMutation>;
export type CreateNewMsoMutationOptions = Apollo.BaseMutationOptions<CreateNewMsoMutation, CreateNewMsoMutationVariables>;
export const GetLocationPurchasesToProviderPurchasesDocument = gql`
    query GetLocationPurchasesToProviderPurchases($range_end: timestamptz!, $range_start: timestamptz!) {
  get_location_purchases_to_provider_purchases_query(
    args: {range_end: $range_end, range_start: $range_start}
  ) {
    provider_purchases_total
    location_purchases_total
    location
  }
}
    `;

/**
 * __useGetLocationPurchasesToProviderPurchasesQuery__
 *
 * To run a query within a React component, call `useGetLocationPurchasesToProviderPurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationPurchasesToProviderPurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationPurchasesToProviderPurchasesQuery({
 *   variables: {
 *      range_end: // value for 'range_end'
 *      range_start: // value for 'range_start'
 *   },
 * });
 */
export function useGetLocationPurchasesToProviderPurchasesQuery(baseOptions: Apollo.QueryHookOptions<GetLocationPurchasesToProviderPurchasesQuery, GetLocationPurchasesToProviderPurchasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationPurchasesToProviderPurchasesQuery, GetLocationPurchasesToProviderPurchasesQueryVariables>(GetLocationPurchasesToProviderPurchasesDocument, options);
      }
export function useGetLocationPurchasesToProviderPurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationPurchasesToProviderPurchasesQuery, GetLocationPurchasesToProviderPurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationPurchasesToProviderPurchasesQuery, GetLocationPurchasesToProviderPurchasesQueryVariables>(GetLocationPurchasesToProviderPurchasesDocument, options);
        }
export type GetLocationPurchasesToProviderPurchasesQueryHookResult = ReturnType<typeof useGetLocationPurchasesToProviderPurchasesQuery>;
export type GetLocationPurchasesToProviderPurchasesLazyQueryHookResult = ReturnType<typeof useGetLocationPurchasesToProviderPurchasesLazyQuery>;
export type GetLocationPurchasesToProviderPurchasesQueryResult = Apollo.QueryResult<GetLocationPurchasesToProviderPurchasesQuery, GetLocationPurchasesToProviderPurchasesQueryVariables>;
export const ProceduresListDocument = gql`
    query ProceduresList {
  procedure(where: {deletedAt: {_is_null: true}}) {
    id
    name
    createdAt
    model
    modelByModel {
      id
      name
    }
  }
}
    `;

/**
 * __useProceduresListQuery__
 *
 * To run a query within a React component, call `useProceduresListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProceduresListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProceduresListQuery({
 *   variables: {
 *   },
 * });
 */
export function useProceduresListQuery(baseOptions?: Apollo.QueryHookOptions<ProceduresListQuery, ProceduresListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProceduresListQuery, ProceduresListQueryVariables>(ProceduresListDocument, options);
      }
export function useProceduresListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProceduresListQuery, ProceduresListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProceduresListQuery, ProceduresListQueryVariables>(ProceduresListDocument, options);
        }
export type ProceduresListQueryHookResult = ReturnType<typeof useProceduresListQuery>;
export type ProceduresListLazyQueryHookResult = ReturnType<typeof useProceduresListLazyQuery>;
export type ProceduresListQueryResult = Apollo.QueryResult<ProceduresListQuery, ProceduresListQueryVariables>;
export const DeleteProcedureDocument = gql`
    mutation DeleteProcedure($id: uuid!) {
  update_procedure_by_pk(pk_columns: {id: $id}, _set: {deletedAt: "now()"}) {
    id
    deletedAt
  }
}
    `;
export type DeleteProcedureMutationFn = Apollo.MutationFunction<DeleteProcedureMutation, DeleteProcedureMutationVariables>;

/**
 * __useDeleteProcedureMutation__
 *
 * To run a mutation, you first call `useDeleteProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProcedureMutation, { data, loading, error }] = useDeleteProcedureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProcedureMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProcedureMutation, DeleteProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProcedureMutation, DeleteProcedureMutationVariables>(DeleteProcedureDocument, options);
      }
export type DeleteProcedureMutationHookResult = ReturnType<typeof useDeleteProcedureMutation>;
export type DeleteProcedureMutationResult = Apollo.MutationResult<DeleteProcedureMutation>;
export type DeleteProcedureMutationOptions = Apollo.BaseMutationOptions<DeleteProcedureMutation, DeleteProcedureMutationVariables>;
export const CreateProcedureDocument = gql`
    mutation CreateProcedure($name: String!, $model: uuid) {
  insert_procedure_one(object: {name: $name, model: $model, bodyParts: []}) {
    id
    name
    createdAt
    model
    modelByModel {
      id
      name
    }
  }
}
    `;
export type CreateProcedureMutationFn = Apollo.MutationFunction<CreateProcedureMutation, CreateProcedureMutationVariables>;

/**
 * __useCreateProcedureMutation__
 *
 * To run a mutation, you first call `useCreateProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcedureMutation, { data, loading, error }] = useCreateProcedureMutation({
 *   variables: {
 *      name: // value for 'name'
 *      model: // value for 'model'
 *   },
 * });
 */
export function useCreateProcedureMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcedureMutation, CreateProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcedureMutation, CreateProcedureMutationVariables>(CreateProcedureDocument, options);
      }
export type CreateProcedureMutationHookResult = ReturnType<typeof useCreateProcedureMutation>;
export type CreateProcedureMutationResult = Apollo.MutationResult<CreateProcedureMutation>;
export type CreateProcedureMutationOptions = Apollo.BaseMutationOptions<CreateProcedureMutation, CreateProcedureMutationVariables>;
export const UpdateProcedureDocument = gql`
    mutation UpdateProcedure($id: uuid!, $name: String!, $model: uuid) {
  update_procedure_by_pk(
    pk_columns: {id: $id}
    _set: {name: $name, model: $model}
  ) {
    id
    name
    deletedAt
    createdAt
    model
    modelByModel {
      id
      name
    }
  }
}
    `;
export type UpdateProcedureMutationFn = Apollo.MutationFunction<UpdateProcedureMutation, UpdateProcedureMutationVariables>;

/**
 * __useUpdateProcedureMutation__
 *
 * To run a mutation, you first call `useUpdateProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcedureMutation, { data, loading, error }] = useUpdateProcedureMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      model: // value for 'model'
 *   },
 * });
 */
export function useUpdateProcedureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcedureMutation, UpdateProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcedureMutation, UpdateProcedureMutationVariables>(UpdateProcedureDocument, options);
      }
export type UpdateProcedureMutationHookResult = ReturnType<typeof useUpdateProcedureMutation>;
export type UpdateProcedureMutationResult = Apollo.MutationResult<UpdateProcedureMutation>;
export type UpdateProcedureMutationOptions = Apollo.BaseMutationOptions<UpdateProcedureMutation, UpdateProcedureMutationVariables>;
export const ListLocationProceduresDocument = gql`
    query ListLocationProcedures($_in: [uuid!]!) {
  location_procedure(where: {location: {_in: $_in}, deletedAt: {_is_null: true}}) {
    id
    location
    procedure
    createdAt
    procedureByProcedure {
      id
      name
    }
    location_procedure_rooms {
      id
      room
      locationProcedure
      roomByRoom {
        id
        name
      }
    }
    locationByLocation {
      id
      rooms_aggregate(where: {deleted_at: {_is_null: true}}) {
        aggregate {
          count
        }
      }
    }
  }
}
    `;

/**
 * __useListLocationProceduresQuery__
 *
 * To run a query within a React component, call `useListLocationProceduresQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLocationProceduresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLocationProceduresQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useListLocationProceduresQuery(baseOptions: Apollo.QueryHookOptions<ListLocationProceduresQuery, ListLocationProceduresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLocationProceduresQuery, ListLocationProceduresQueryVariables>(ListLocationProceduresDocument, options);
      }
export function useListLocationProceduresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLocationProceduresQuery, ListLocationProceduresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLocationProceduresQuery, ListLocationProceduresQueryVariables>(ListLocationProceduresDocument, options);
        }
export type ListLocationProceduresQueryHookResult = ReturnType<typeof useListLocationProceduresQuery>;
export type ListLocationProceduresLazyQueryHookResult = ReturnType<typeof useListLocationProceduresLazyQuery>;
export type ListLocationProceduresQueryResult = Apollo.QueryResult<ListLocationProceduresQuery, ListLocationProceduresQueryVariables>;
export const DeleteLocationProcedureDocument = gql`
    mutation DeleteLocationProcedure($id: uuid!) {
  update_location_procedure_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    id
    deletedAt
  }
  delete_location_procedure_room(where: {locationProcedure: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteLocationProcedureMutationFn = Apollo.MutationFunction<DeleteLocationProcedureMutation, DeleteLocationProcedureMutationVariables>;

/**
 * __useDeleteLocationProcedureMutation__
 *
 * To run a mutation, you first call `useDeleteLocationProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationProcedureMutation, { data, loading, error }] = useDeleteLocationProcedureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationProcedureMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationProcedureMutation, DeleteLocationProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationProcedureMutation, DeleteLocationProcedureMutationVariables>(DeleteLocationProcedureDocument, options);
      }
export type DeleteLocationProcedureMutationHookResult = ReturnType<typeof useDeleteLocationProcedureMutation>;
export type DeleteLocationProcedureMutationResult = Apollo.MutationResult<DeleteLocationProcedureMutation>;
export type DeleteLocationProcedureMutationOptions = Apollo.BaseMutationOptions<DeleteLocationProcedureMutation, DeleteLocationProcedureMutationVariables>;
export const CreateLocationProcedureDocument = gql`
    mutation CreateLocationProcedure($location: uuid!, $procedure: uuid!, $roomAssignments: [location_procedure_room_insert_input!]!) {
  insert_location_procedure_one(
    object: {location: $location, procedure: $procedure, location_procedure_rooms: {data: $roomAssignments}}
  ) {
    id
    createdAt
    location
    procedure
    procedureByProcedure {
      id
      name
    }
    location_procedure_rooms {
      id
      room
      locationProcedure
    }
  }
}
    `;
export type CreateLocationProcedureMutationFn = Apollo.MutationFunction<CreateLocationProcedureMutation, CreateLocationProcedureMutationVariables>;

/**
 * __useCreateLocationProcedureMutation__
 *
 * To run a mutation, you first call `useCreateLocationProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationProcedureMutation, { data, loading, error }] = useCreateLocationProcedureMutation({
 *   variables: {
 *      location: // value for 'location'
 *      procedure: // value for 'procedure'
 *      roomAssignments: // value for 'roomAssignments'
 *   },
 * });
 */
export function useCreateLocationProcedureMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationProcedureMutation, CreateLocationProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationProcedureMutation, CreateLocationProcedureMutationVariables>(CreateLocationProcedureDocument, options);
      }
export type CreateLocationProcedureMutationHookResult = ReturnType<typeof useCreateLocationProcedureMutation>;
export type CreateLocationProcedureMutationResult = Apollo.MutationResult<CreateLocationProcedureMutation>;
export type CreateLocationProcedureMutationOptions = Apollo.BaseMutationOptions<CreateLocationProcedureMutation, CreateLocationProcedureMutationVariables>;
export const UpdateLocationProcedureDocument = gql`
    mutation UpdateLocationProcedure($addedRooms: [location_procedure_room_insert_input!]!, $deletedRoomIds: [uuid!]!) {
  insert_location_procedure_room(objects: $addedRooms) {
    returning {
      locationProcedureByLocationProcedure {
        id
        location_procedure_rooms {
          id
          locationProcedure
          room
        }
      }
    }
  }
  delete_location_procedure_room(where: {room: {_in: $deletedRoomIds}}) {
    returning {
      locationProcedureByLocationProcedure {
        id
        location_procedure_rooms {
          id
          locationProcedure
          room
        }
      }
    }
  }
}
    `;
export type UpdateLocationProcedureMutationFn = Apollo.MutationFunction<UpdateLocationProcedureMutation, UpdateLocationProcedureMutationVariables>;

/**
 * __useUpdateLocationProcedureMutation__
 *
 * To run a mutation, you first call `useUpdateLocationProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationProcedureMutation, { data, loading, error }] = useUpdateLocationProcedureMutation({
 *   variables: {
 *      addedRooms: // value for 'addedRooms'
 *      deletedRoomIds: // value for 'deletedRoomIds'
 *   },
 * });
 */
export function useUpdateLocationProcedureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationProcedureMutation, UpdateLocationProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationProcedureMutation, UpdateLocationProcedureMutationVariables>(UpdateLocationProcedureDocument, options);
      }
export type UpdateLocationProcedureMutationHookResult = ReturnType<typeof useUpdateLocationProcedureMutation>;
export type UpdateLocationProcedureMutationResult = Apollo.MutationResult<UpdateLocationProcedureMutation>;
export type UpdateLocationProcedureMutationOptions = Apollo.BaseMutationOptions<UpdateLocationProcedureMutation, UpdateLocationProcedureMutationVariables>;
export const ProductListDocument = gql`
    query ProductList {
  product {
    id
    name
    price
    taxExempt
    description
    deleted_at
    isPrescription
    photoS3Key
    product_type {
      id
      type
    }
  }
}
    `;

/**
 * __useProductListQuery__
 *
 * To run a query within a React component, call `useProductListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductListQuery(baseOptions?: Apollo.QueryHookOptions<ProductListQuery, ProductListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListQuery, ProductListQueryVariables>(ProductListDocument, options);
      }
export function useProductListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListQuery, ProductListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListQuery, ProductListQueryVariables>(ProductListDocument, options);
        }
export type ProductListQueryHookResult = ReturnType<typeof useProductListQuery>;
export type ProductListLazyQueryHookResult = ReturnType<typeof useProductListLazyQuery>;
export type ProductListQueryResult = Apollo.QueryResult<ProductListQuery, ProductListQueryVariables>;
export const ProductListDeleteDocument = gql`
    mutation ProductListDelete($id: uuid!) {
  update_product_by_pk(pk_columns: {id: $id}, _set: {deleted_at: "now()"}) {
    id
    deleted_at
  }
  delete_location_product(where: {product: {_eq: $id}}) {
    returning {
      location
      product
    }
  }
}
    `;
export type ProductListDeleteMutationFn = Apollo.MutationFunction<ProductListDeleteMutation, ProductListDeleteMutationVariables>;

/**
 * __useProductListDeleteMutation__
 *
 * To run a mutation, you first call `useProductListDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductListDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productListDeleteMutation, { data, loading, error }] = useProductListDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductListDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ProductListDeleteMutation, ProductListDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductListDeleteMutation, ProductListDeleteMutationVariables>(ProductListDeleteDocument, options);
      }
export type ProductListDeleteMutationHookResult = ReturnType<typeof useProductListDeleteMutation>;
export type ProductListDeleteMutationResult = Apollo.MutationResult<ProductListDeleteMutation>;
export type ProductListDeleteMutationOptions = Apollo.BaseMutationOptions<ProductListDeleteMutation, ProductListDeleteMutationVariables>;
export const ProductListCreateDocument = gql`
    mutation ProductListCreate($name: String!, $description: String!, $taxExempt: Boolean!, $price: Int!, $isPrescription: Boolean!, $type: uuid, $photoS3Key: uuid) {
  insert_product_one(
    object: {name: $name, description: $description, taxExempt: $taxExempt, price: $price, isPrescription: $isPrescription, type: $type, photoS3Key: $photoS3Key}
  ) {
    id
    name
    taxExempt
    description
    price
    deleted_at
    isPrescription
    photoS3Key
    product_type {
      id
      type
    }
  }
}
    `;
export type ProductListCreateMutationFn = Apollo.MutationFunction<ProductListCreateMutation, ProductListCreateMutationVariables>;

/**
 * __useProductListCreateMutation__
 *
 * To run a mutation, you first call `useProductListCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductListCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productListCreateMutation, { data, loading, error }] = useProductListCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      taxExempt: // value for 'taxExempt'
 *      price: // value for 'price'
 *      isPrescription: // value for 'isPrescription'
 *      type: // value for 'type'
 *      photoS3Key: // value for 'photoS3Key'
 *   },
 * });
 */
export function useProductListCreateMutation(baseOptions?: Apollo.MutationHookOptions<ProductListCreateMutation, ProductListCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductListCreateMutation, ProductListCreateMutationVariables>(ProductListCreateDocument, options);
      }
export type ProductListCreateMutationHookResult = ReturnType<typeof useProductListCreateMutation>;
export type ProductListCreateMutationResult = Apollo.MutationResult<ProductListCreateMutation>;
export type ProductListCreateMutationOptions = Apollo.BaseMutationOptions<ProductListCreateMutation, ProductListCreateMutationVariables>;
export const ProductListUpdateDocument = gql`
    mutation ProductListUpdate($id: uuid!, $name: String!, $description: String!, $taxExempt: Boolean!, $price: Int!, $isPrescription: Boolean!, $type: uuid, $photoS3Key: uuid) {
  update_product_by_pk(
    pk_columns: {id: $id}
    _set: {name: $name, description: $description, taxExempt: $taxExempt, price: $price, isPrescription: $isPrescription, type: $type, photoS3Key: $photoS3Key}
  ) {
    id
    name
    taxExempt
    price
    description
    isPrescription
    photoS3Key
    product_type {
      id
      type
    }
  }
}
    `;
export type ProductListUpdateMutationFn = Apollo.MutationFunction<ProductListUpdateMutation, ProductListUpdateMutationVariables>;

/**
 * __useProductListUpdateMutation__
 *
 * To run a mutation, you first call `useProductListUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductListUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productListUpdateMutation, { data, loading, error }] = useProductListUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      taxExempt: // value for 'taxExempt'
 *      price: // value for 'price'
 *      isPrescription: // value for 'isPrescription'
 *      type: // value for 'type'
 *      photoS3Key: // value for 'photoS3Key'
 *   },
 * });
 */
export function useProductListUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProductListUpdateMutation, ProductListUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductListUpdateMutation, ProductListUpdateMutationVariables>(ProductListUpdateDocument, options);
      }
export type ProductListUpdateMutationHookResult = ReturnType<typeof useProductListUpdateMutation>;
export type ProductListUpdateMutationResult = Apollo.MutationResult<ProductListUpdateMutation>;
export type ProductListUpdateMutationOptions = Apollo.BaseMutationOptions<ProductListUpdateMutation, ProductListUpdateMutationVariables>;
export const RoomListDocument = gql`
    query RoomList($_in: [uuid!]!) {
  room(where: {location: {_in: $_in}}) {
    id
    name
    description
    rate
    weeklyRate
    monthlyRate
    weeklyRateNonMedical
    monthlyRateNonMedical
    deleted_at
    allowVolumeDiscount
    photoS3Key
    locationByLocation {
      id
      name
    }
    roomTypeByRoomType {
      id
      name
    }
    location_procedure_rooms {
      id
      room
      locationProcedure
      locationProcedureByLocationProcedure {
        id
        procedureByProcedure {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useRoomListQuery__
 *
 * To run a query within a React component, call `useRoomListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomListQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useRoomListQuery(baseOptions: Apollo.QueryHookOptions<RoomListQuery, RoomListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomListQuery, RoomListQueryVariables>(RoomListDocument, options);
      }
export function useRoomListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomListQuery, RoomListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomListQuery, RoomListQueryVariables>(RoomListDocument, options);
        }
export type RoomListQueryHookResult = ReturnType<typeof useRoomListQuery>;
export type RoomListLazyQueryHookResult = ReturnType<typeof useRoomListLazyQuery>;
export type RoomListQueryResult = Apollo.QueryResult<RoomListQuery, RoomListQueryVariables>;
export const RoomDeleteDocument = gql`
    mutation RoomDelete($id: uuid!) {
  update_room_by_pk(pk_columns: {id: $id}, _set: {deleted_at: "now()"}) {
    id
    name
    description
    rate
    deleted_at
    allowVolumeDiscount
    photoS3Key
    locationByLocation {
      id
      name
    }
  }
  delete_location_procedure_room(where: {room: {_eq: $id}}) {
    returning {
      id
    }
  }
}
    `;
export type RoomDeleteMutationFn = Apollo.MutationFunction<RoomDeleteMutation, RoomDeleteMutationVariables>;

/**
 * __useRoomDeleteMutation__
 *
 * To run a mutation, you first call `useRoomDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoomDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roomDeleteMutation, { data, loading, error }] = useRoomDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoomDeleteMutation(baseOptions?: Apollo.MutationHookOptions<RoomDeleteMutation, RoomDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RoomDeleteMutation, RoomDeleteMutationVariables>(RoomDeleteDocument, options);
      }
export type RoomDeleteMutationHookResult = ReturnType<typeof useRoomDeleteMutation>;
export type RoomDeleteMutationResult = Apollo.MutationResult<RoomDeleteMutation>;
export type RoomDeleteMutationOptions = Apollo.BaseMutationOptions<RoomDeleteMutation, RoomDeleteMutationVariables>;
export const RoomCreateDocument = gql`
    mutation RoomCreate($name: String!, $description: String!, $rate: Int!, $monthlyRate: Int, $weeklyRate: Int, $monthlyRateNonMedical: Int, $weeklyRateNonMedical: Int, $location: uuid!, $allowVolumeDiscount: Boolean!, $roomType: uuid, $photoS3Key: uuid, $locationProcedures: [location_procedure_room_insert_input!]!) {
  insert_room_one(
    object: {name: $name, description: $description, rate: $rate, weeklyRate: $weeklyRate, monthlyRate: $monthlyRate, weeklyRateNonMedical: $weeklyRateNonMedical, monthlyRateNonMedical: $monthlyRateNonMedical, location: $location, allowVolumeDiscount: $allowVolumeDiscount, roomType: $roomType, photoS3Key: $photoS3Key, location_procedure_rooms: {data: $locationProcedures}}
  ) {
    id
    name
    description
    rate
    weeklyRate
    monthlyRate
    weeklyRateNonMedical
    monthlyRateNonMedical
    deleted_at
    allowVolumeDiscount
    photoS3Key
    locationByLocation {
      id
      name
    }
    roomTypeByRoomType {
      id
      name
    }
    location_procedure_rooms {
      id
      room
      locationProcedure
      locationProcedureByLocationProcedure {
        id
        procedureByProcedure {
          id
          name
        }
      }
    }
  }
}
    `;
export type RoomCreateMutationFn = Apollo.MutationFunction<RoomCreateMutation, RoomCreateMutationVariables>;

/**
 * __useRoomCreateMutation__
 *
 * To run a mutation, you first call `useRoomCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoomCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roomCreateMutation, { data, loading, error }] = useRoomCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      rate: // value for 'rate'
 *      monthlyRate: // value for 'monthlyRate'
 *      weeklyRate: // value for 'weeklyRate'
 *      monthlyRateNonMedical: // value for 'monthlyRateNonMedical'
 *      weeklyRateNonMedical: // value for 'weeklyRateNonMedical'
 *      location: // value for 'location'
 *      allowVolumeDiscount: // value for 'allowVolumeDiscount'
 *      roomType: // value for 'roomType'
 *      photoS3Key: // value for 'photoS3Key'
 *      locationProcedures: // value for 'locationProcedures'
 *   },
 * });
 */
export function useRoomCreateMutation(baseOptions?: Apollo.MutationHookOptions<RoomCreateMutation, RoomCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RoomCreateMutation, RoomCreateMutationVariables>(RoomCreateDocument, options);
      }
export type RoomCreateMutationHookResult = ReturnType<typeof useRoomCreateMutation>;
export type RoomCreateMutationResult = Apollo.MutationResult<RoomCreateMutation>;
export type RoomCreateMutationOptions = Apollo.BaseMutationOptions<RoomCreateMutation, RoomCreateMutationVariables>;
export const RoomUpdateDocument = gql`
    mutation RoomUpdate($id: uuid!, $name: String!, $description: String!, $rate: Int!, $monthlyRate: Int, $weeklyRate: Int, $monthlyRateNonMedical: Int, $weeklyRateNonMedical: Int, $allowVolumeDiscount: Boolean!, $roomType: uuid, $photoS3Key: uuid, $addProcedures: [location_procedure_room_insert_input!]!, $deleteProcedureIds: [uuid!]!) {
  update_room_by_pk(
    pk_columns: {id: $id}
    _set: {name: $name, description: $description, rate: $rate, weeklyRate: $weeklyRate, monthlyRate: $monthlyRate, weeklyRateNonMedical: $weeklyRateNonMedical, monthlyRateNonMedical: $monthlyRateNonMedical, allowVolumeDiscount: $allowVolumeDiscount, roomType: $roomType, photoS3Key: $photoS3Key}
  ) {
    id
    name
    deleted_at
    description
    allowVolumeDiscount
    rate
    weeklyRate
    monthlyRate
    weeklyRateNonMedical
    monthlyRateNonMedical
    photoS3Key
    locationByLocation {
      id
      name
    }
    roomTypeByRoomType {
      id
      name
    }
  }
  insert_location_procedure_room(objects: $addProcedures) {
    returning {
      id
      locationProcedure
      room
    }
  }
  delete_location_procedure_room(where: {id: {_in: $deleteProcedureIds}}) {
    returning {
      id
    }
  }
}
    `;
export type RoomUpdateMutationFn = Apollo.MutationFunction<RoomUpdateMutation, RoomUpdateMutationVariables>;

/**
 * __useRoomUpdateMutation__
 *
 * To run a mutation, you first call `useRoomUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoomUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roomUpdateMutation, { data, loading, error }] = useRoomUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      rate: // value for 'rate'
 *      monthlyRate: // value for 'monthlyRate'
 *      weeklyRate: // value for 'weeklyRate'
 *      monthlyRateNonMedical: // value for 'monthlyRateNonMedical'
 *      weeklyRateNonMedical: // value for 'weeklyRateNonMedical'
 *      allowVolumeDiscount: // value for 'allowVolumeDiscount'
 *      roomType: // value for 'roomType'
 *      photoS3Key: // value for 'photoS3Key'
 *      addProcedures: // value for 'addProcedures'
 *      deleteProcedureIds: // value for 'deleteProcedureIds'
 *   },
 * });
 */
export function useRoomUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RoomUpdateMutation, RoomUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RoomUpdateMutation, RoomUpdateMutationVariables>(RoomUpdateDocument, options);
      }
export type RoomUpdateMutationHookResult = ReturnType<typeof useRoomUpdateMutation>;
export type RoomUpdateMutationResult = Apollo.MutationResult<RoomUpdateMutation>;
export type RoomUpdateMutationOptions = Apollo.BaseMutationOptions<RoomUpdateMutation, RoomUpdateMutationVariables>;
export const UserListDocument = gql`
    query UserList($_in: [uuid!]!) {
  user(where: {userLocations: {location: {_in: $_in}}}, order_by: {lastName: asc}) {
    id
    active
    firstName
    lastName
    role
    stripeCustomerId
    deleted_at
    malpracticeExpiration
    accreditation
    licenseExpiration
    userLocations {
      user
      location
      locationByLocation {
        id
        name
      }
    }
    user_documents {
      id
      type
      created_at
    }
    users_unfulfilled_product_purchases_count_by_locations {
      user
      location
      unitsUnfulfilled
    }
  }
}
    `;

/**
 * __useUserListQuery__
 *
 * To run a query within a React component, call `useUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useUserListQuery(baseOptions: Apollo.QueryHookOptions<UserListQuery, UserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
      }
export function useUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserListQuery, UserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
        }
export type UserListQueryHookResult = ReturnType<typeof useUserListQuery>;
export type UserListLazyQueryHookResult = ReturnType<typeof useUserListLazyQuery>;
export type UserListQueryResult = Apollo.QueryResult<UserListQuery, UserListQueryVariables>;
export const UserDeleteDocument = gql`
    mutation userDelete($id: uuid!) {
  update_user_by_pk(pk_columns: {id: $id}, _set: {deleted_at: "now()"}) {
    id
    active
    firstName
    lastName
    role
    stripeCustomerId
    deleted_at
    userLocations {
      user
      location
      locationByLocation {
        name
        id
      }
    }
  }
}
    `;
export type UserDeleteMutationFn = Apollo.MutationFunction<UserDeleteMutation, UserDeleteMutationVariables>;

/**
 * __useUserDeleteMutation__
 *
 * To run a mutation, you first call `useUserDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDeleteMutation, { data, loading, error }] = useUserDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDeleteMutation(baseOptions?: Apollo.MutationHookOptions<UserDeleteMutation, UserDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserDeleteMutation, UserDeleteMutationVariables>(UserDeleteDocument, options);
      }
export type UserDeleteMutationHookResult = ReturnType<typeof useUserDeleteMutation>;
export type UserDeleteMutationResult = Apollo.MutationResult<UserDeleteMutation>;
export type UserDeleteMutationOptions = Apollo.BaseMutationOptions<UserDeleteMutation, UserDeleteMutationVariables>;
export const UserCreateDocument = gql`
    mutation userCreate($firstName: String, $lastName: String, $role: role_enum, $userLocations: user_location_arr_rel_insert_input, $active: Boolean) {
  insert_user_one(
    object: {active: $active, firstName: $firstName, lastName: $lastName, role: $role, userLocations: $userLocations}
  ) {
    id
    active
    firstName
    lastName
    role
    stripeCustomerId
    deleted_at
    userLocations {
      user
      location
      locationByLocation {
        id
        name
      }
    }
  }
}
    `;
export type UserCreateMutationFn = Apollo.MutationFunction<UserCreateMutation, UserCreateMutationVariables>;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      role: // value for 'role'
 *      userLocations: // value for 'userLocations'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUserCreateMutation(baseOptions?: Apollo.MutationHookOptions<UserCreateMutation, UserCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreateMutation, UserCreateMutationVariables>(UserCreateDocument, options);
      }
export type UserCreateMutationHookResult = ReturnType<typeof useUserCreateMutation>;
export type UserCreateMutationResult = Apollo.MutationResult<UserCreateMutation>;
export type UserCreateMutationOptions = Apollo.BaseMutationOptions<UserCreateMutation, UserCreateMutationVariables>;
export const UserUpdateDocument = gql`
    mutation UserUpdate($id: uuid!, $active: Boolean!, $firstName: String, $lastName: String, $role: role_enum!, $insertLocations: [user_location_insert_input!]!, $deleteLocations: [uuid!]!) {
  delete_user_location(
    where: {_and: {location: {_in: $deleteLocations}, user: {_eq: $id}}}
  ) {
    returning {
      location
      user
    }
  }
  insert_user_location(objects: $insertLocations) {
    returning {
      user
      location
    }
  }
  update_user_by_pk(
    pk_columns: {id: $id}
    _set: {active: $active, firstName: $firstName, lastName: $lastName, role: $role}
  ) {
    id
    active
    firstName
    lastName
    role
    stripeCustomerId
    userLocations {
      user
      location
      locationByLocation {
        id
        name
      }
    }
  }
}
    `;
export type UserUpdateMutationFn = Apollo.MutationFunction<UserUpdateMutation, UserUpdateMutationVariables>;

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      role: // value for 'role'
 *      insertLocations: // value for 'insertLocations'
 *      deleteLocations: // value for 'deleteLocations'
 *   },
 * });
 */
export function useUserUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateMutation, UserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateMutation, UserUpdateMutationVariables>(UserUpdateDocument, options);
      }
export type UserUpdateMutationHookResult = ReturnType<typeof useUserUpdateMutation>;
export type UserUpdateMutationResult = Apollo.MutationResult<UserUpdateMutation>;
export type UserUpdateMutationOptions = Apollo.BaseMutationOptions<UserUpdateMutation, UserUpdateMutationVariables>;
export const UserPurchaseToRentalRatioDocument = gql`
    query UserPurchaseToRentalRatio($ratio_range_end: timestamptz!, $ratio_range_start_90: timestamptz!, $ratio_range_start_180: timestamptz!, $location: uuid!) {
  days_180: get_user_products_to_rentals_query(
    args: {range_start: $ratio_range_start_180, range_end: $ratio_range_end, invoice_location: $location}
  ) {
    user
    rentals_cost
    products_cost
  }
  days_90: get_user_products_to_rentals_query(
    args: {range_start: $ratio_range_start_90, range_end: $ratio_range_end, invoice_location: $location}
  ) {
    user
    rentals_cost
    products_cost
  }
}
    `;

/**
 * __useUserPurchaseToRentalRatioQuery__
 *
 * To run a query within a React component, call `useUserPurchaseToRentalRatioQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPurchaseToRentalRatioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPurchaseToRentalRatioQuery({
 *   variables: {
 *      ratio_range_end: // value for 'ratio_range_end'
 *      ratio_range_start_90: // value for 'ratio_range_start_90'
 *      ratio_range_start_180: // value for 'ratio_range_start_180'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useUserPurchaseToRentalRatioQuery(baseOptions: Apollo.QueryHookOptions<UserPurchaseToRentalRatioQuery, UserPurchaseToRentalRatioQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPurchaseToRentalRatioQuery, UserPurchaseToRentalRatioQueryVariables>(UserPurchaseToRentalRatioDocument, options);
      }
export function useUserPurchaseToRentalRatioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPurchaseToRentalRatioQuery, UserPurchaseToRentalRatioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPurchaseToRentalRatioQuery, UserPurchaseToRentalRatioQueryVariables>(UserPurchaseToRentalRatioDocument, options);
        }
export type UserPurchaseToRentalRatioQueryHookResult = ReturnType<typeof useUserPurchaseToRentalRatioQuery>;
export type UserPurchaseToRentalRatioLazyQueryHookResult = ReturnType<typeof useUserPurchaseToRentalRatioLazyQuery>;
export type UserPurchaseToRentalRatioQueryResult = Apollo.QueryResult<UserPurchaseToRentalRatioQuery, UserPurchaseToRentalRatioQueryVariables>;
export const ProductPurchaseUnfulfilledStreamDocument = gql`
    query ProductPurchaseUnfulfilledStream($location_param: uuid!) {
  users_unfulfilled_product_purchases_count_by_location(
    args: {location_param: $location_param}
  ) {
    location
    unitsUnfulfilled
    user
  }
}
    `;

/**
 * __useProductPurchaseUnfulfilledStreamQuery__
 *
 * To run a query within a React component, call `useProductPurchaseUnfulfilledStreamQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPurchaseUnfulfilledStreamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPurchaseUnfulfilledStreamQuery({
 *   variables: {
 *      location_param: // value for 'location_param'
 *   },
 * });
 */
export function useProductPurchaseUnfulfilledStreamQuery(baseOptions: Apollo.QueryHookOptions<ProductPurchaseUnfulfilledStreamQuery, ProductPurchaseUnfulfilledStreamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPurchaseUnfulfilledStreamQuery, ProductPurchaseUnfulfilledStreamQueryVariables>(ProductPurchaseUnfulfilledStreamDocument, options);
      }
export function useProductPurchaseUnfulfilledStreamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPurchaseUnfulfilledStreamQuery, ProductPurchaseUnfulfilledStreamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPurchaseUnfulfilledStreamQuery, ProductPurchaseUnfulfilledStreamQueryVariables>(ProductPurchaseUnfulfilledStreamDocument, options);
        }
export type ProductPurchaseUnfulfilledStreamQueryHookResult = ReturnType<typeof useProductPurchaseUnfulfilledStreamQuery>;
export type ProductPurchaseUnfulfilledStreamLazyQueryHookResult = ReturnType<typeof useProductPurchaseUnfulfilledStreamLazyQuery>;
export type ProductPurchaseUnfulfilledStreamQueryResult = Apollo.QueryResult<ProductPurchaseUnfulfilledStreamQuery, ProductPurchaseUnfulfilledStreamQueryVariables>;
export const GetIsVansanityDocument = gql`
    query GetIsVansanity($id: uuid!) {
  location_by_pk(id: $id) {
    id
    partnerByPartner {
      id
      isVansanity
    }
  }
}
    `;

/**
 * __useGetIsVansanityQuery__
 *
 * To run a query within a React component, call `useGetIsVansanityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsVansanityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsVansanityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIsVansanityQuery(baseOptions: Apollo.QueryHookOptions<GetIsVansanityQuery, GetIsVansanityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIsVansanityQuery, GetIsVansanityQueryVariables>(GetIsVansanityDocument, options);
      }
export function useGetIsVansanityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIsVansanityQuery, GetIsVansanityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIsVansanityQuery, GetIsVansanityQueryVariables>(GetIsVansanityDocument, options);
        }
export type GetIsVansanityQueryHookResult = ReturnType<typeof useGetIsVansanityQuery>;
export type GetIsVansanityLazyQueryHookResult = ReturnType<typeof useGetIsVansanityLazyQuery>;
export type GetIsVansanityQueryResult = Apollo.QueryResult<GetIsVansanityQuery, GetIsVansanityQueryVariables>;
export const GetCognitoUserDetailDocument = gql`
    query GetCognitoUserDetail($id: uuid!) {
  getCognitoUser(object: {id: $id}) {
    id
    phone
    phone_verified
    email
    email_verified
  }
}
    `;

/**
 * __useGetCognitoUserDetailQuery__
 *
 * To run a query within a React component, call `useGetCognitoUserDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCognitoUserDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCognitoUserDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCognitoUserDetailQuery(baseOptions: Apollo.QueryHookOptions<GetCognitoUserDetailQuery, GetCognitoUserDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCognitoUserDetailQuery, GetCognitoUserDetailQueryVariables>(GetCognitoUserDetailDocument, options);
      }
export function useGetCognitoUserDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCognitoUserDetailQuery, GetCognitoUserDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCognitoUserDetailQuery, GetCognitoUserDetailQueryVariables>(GetCognitoUserDetailDocument, options);
        }
export type GetCognitoUserDetailQueryHookResult = ReturnType<typeof useGetCognitoUserDetailQuery>;
export type GetCognitoUserDetailLazyQueryHookResult = ReturnType<typeof useGetCognitoUserDetailLazyQuery>;
export type GetCognitoUserDetailQueryResult = Apollo.QueryResult<GetCognitoUserDetailQuery, GetCognitoUserDetailQueryVariables>;
export const UpdateUserDetailPersonalDocument = gql`
    mutation UpdateUserDetailPersonal($id: uuid!, $insertAddressObjects: [address_insert_input!]!, $updateAddressObject: address_set_input = {}, $updateAddresses: [uuid!]!, $addressId: uuid!, $firstName: String!, $lastName: String!) {
  insert_address(objects: $insertAddressObjects) {
    returning {
      id
      city
      line1
      line2
      state
      zipcode
    }
  }
  update_address(where: {id: {_in: $updateAddresses}}, _set: $updateAddressObject) {
    returning {
      id
      city
      line1
      line2
      state
      zipcode
    }
  }
  update_user_by_pk(
    pk_columns: {id: $id}
    _set: {firstName: $firstName, lastName: $lastName, address: $addressId}
  ) {
    id
    firstName
    lastName
    address
  }
}
    `;
export type UpdateUserDetailPersonalMutationFn = Apollo.MutationFunction<UpdateUserDetailPersonalMutation, UpdateUserDetailPersonalMutationVariables>;

/**
 * __useUpdateUserDetailPersonalMutation__
 *
 * To run a mutation, you first call `useUpdateUserDetailPersonalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDetailPersonalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDetailPersonalMutation, { data, loading, error }] = useUpdateUserDetailPersonalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      insertAddressObjects: // value for 'insertAddressObjects'
 *      updateAddressObject: // value for 'updateAddressObject'
 *      updateAddresses: // value for 'updateAddresses'
 *      addressId: // value for 'addressId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useUpdateUserDetailPersonalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDetailPersonalMutation, UpdateUserDetailPersonalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDetailPersonalMutation, UpdateUserDetailPersonalMutationVariables>(UpdateUserDetailPersonalDocument, options);
      }
export type UpdateUserDetailPersonalMutationHookResult = ReturnType<typeof useUpdateUserDetailPersonalMutation>;
export type UpdateUserDetailPersonalMutationResult = Apollo.MutationResult<UpdateUserDetailPersonalMutation>;
export type UpdateUserDetailPersonalMutationOptions = Apollo.BaseMutationOptions<UpdateUserDetailPersonalMutation, UpdateUserDetailPersonalMutationVariables>;
export const UpdateUserDetailSettingsDocument = gql`
    mutation UpdateUserDetailSettings($id: uuid!, $active: Boolean!, $accreditation: accreditation_enum, $role: role_enum!, $licenseExpiration: date, $locationsDelete: [uuid!]!, $locationsInsert: [user_location_insert_input!]!, $malpracticeExpiration: date, $unsubscribedFromNotifications: Boolean!) {
  update_user_by_pk(
    pk_columns: {id: $id}
    _set: {accreditation: $accreditation, active: $active, role: $role, licenseExpiration: $licenseExpiration, malpracticeExpiration: $malpracticeExpiration, unsubscribedFromNotifications: $unsubscribedFromNotifications}
  ) {
    id
    accreditation
    active
    role
    licenseExpiration
  }
  delete_user_location(
    where: {user: {_eq: $id}, location: {_in: $locationsDelete}}
  ) {
    affected_rows
  }
  insert_user_location(
    objects: $locationsInsert
    on_conflict: {constraint: user_office_pkey, update_columns: []}
  ) {
    returning {
      user
      location
    }
  }
}
    `;
export type UpdateUserDetailSettingsMutationFn = Apollo.MutationFunction<UpdateUserDetailSettingsMutation, UpdateUserDetailSettingsMutationVariables>;

/**
 * __useUpdateUserDetailSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserDetailSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDetailSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDetailSettingsMutation, { data, loading, error }] = useUpdateUserDetailSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *      accreditation: // value for 'accreditation'
 *      role: // value for 'role'
 *      licenseExpiration: // value for 'licenseExpiration'
 *      locationsDelete: // value for 'locationsDelete'
 *      locationsInsert: // value for 'locationsInsert'
 *      malpracticeExpiration: // value for 'malpracticeExpiration'
 *      unsubscribedFromNotifications: // value for 'unsubscribedFromNotifications'
 *   },
 * });
 */
export function useUpdateUserDetailSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDetailSettingsMutation, UpdateUserDetailSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDetailSettingsMutation, UpdateUserDetailSettingsMutationVariables>(UpdateUserDetailSettingsDocument, options);
      }
export type UpdateUserDetailSettingsMutationHookResult = ReturnType<typeof useUpdateUserDetailSettingsMutation>;
export type UpdateUserDetailSettingsMutationResult = Apollo.MutationResult<UpdateUserDetailSettingsMutation>;
export type UpdateUserDetailSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateUserDetailSettingsMutation, UpdateUserDetailSettingsMutationVariables>;
export const CreateStripeCustomerUserDetailBillingDocument = gql`
    mutation CreateStripeCustomerUserDetailBilling($userId: uuid!, $cognitoUsername: String!) {
  createStripeCustomer(
    object: {userId: $userId, cognitoUsername: $cognitoUsername}
  ) {
    userId
    stripeCustomerId
  }
}
    `;
export type CreateStripeCustomerUserDetailBillingMutationFn = Apollo.MutationFunction<CreateStripeCustomerUserDetailBillingMutation, CreateStripeCustomerUserDetailBillingMutationVariables>;

/**
 * __useCreateStripeCustomerUserDetailBillingMutation__
 *
 * To run a mutation, you first call `useCreateStripeCustomerUserDetailBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeCustomerUserDetailBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeCustomerUserDetailBillingMutation, { data, loading, error }] = useCreateStripeCustomerUserDetailBillingMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      cognitoUsername: // value for 'cognitoUsername'
 *   },
 * });
 */
export function useCreateStripeCustomerUserDetailBillingMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripeCustomerUserDetailBillingMutation, CreateStripeCustomerUserDetailBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripeCustomerUserDetailBillingMutation, CreateStripeCustomerUserDetailBillingMutationVariables>(CreateStripeCustomerUserDetailBillingDocument, options);
      }
export type CreateStripeCustomerUserDetailBillingMutationHookResult = ReturnType<typeof useCreateStripeCustomerUserDetailBillingMutation>;
export type CreateStripeCustomerUserDetailBillingMutationResult = Apollo.MutationResult<CreateStripeCustomerUserDetailBillingMutation>;
export type CreateStripeCustomerUserDetailBillingMutationOptions = Apollo.BaseMutationOptions<CreateStripeCustomerUserDetailBillingMutation, CreateStripeCustomerUserDetailBillingMutationVariables>;
export const CheckCognitoUserConfirmedDocument = gql`
    query CheckCognitoUserConfirmed($user_id: uuid!) {
  getCognitoUser(object: {id: $user_id}) {
    id
    phone_verified
    user_status
  }
}
    `;

/**
 * __useCheckCognitoUserConfirmedQuery__
 *
 * To run a query within a React component, call `useCheckCognitoUserConfirmedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCognitoUserConfirmedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCognitoUserConfirmedQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useCheckCognitoUserConfirmedQuery(baseOptions: Apollo.QueryHookOptions<CheckCognitoUserConfirmedQuery, CheckCognitoUserConfirmedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckCognitoUserConfirmedQuery, CheckCognitoUserConfirmedQueryVariables>(CheckCognitoUserConfirmedDocument, options);
      }
export function useCheckCognitoUserConfirmedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckCognitoUserConfirmedQuery, CheckCognitoUserConfirmedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckCognitoUserConfirmedQuery, CheckCognitoUserConfirmedQueryVariables>(CheckCognitoUserConfirmedDocument, options);
        }
export type CheckCognitoUserConfirmedQueryHookResult = ReturnType<typeof useCheckCognitoUserConfirmedQuery>;
export type CheckCognitoUserConfirmedLazyQueryHookResult = ReturnType<typeof useCheckCognitoUserConfirmedLazyQuery>;
export type CheckCognitoUserConfirmedQueryResult = Apollo.QueryResult<CheckCognitoUserConfirmedQuery, CheckCognitoUserConfirmedQueryVariables>;
export const ConfirmCognitoUserDocument = gql`
    mutation ConfirmCognitoUser($user_id: uuid!) {
  confirmCognitoUser(object: {id: $user_id}) {
    status
  }
}
    `;
export type ConfirmCognitoUserMutationFn = Apollo.MutationFunction<ConfirmCognitoUserMutation, ConfirmCognitoUserMutationVariables>;

/**
 * __useConfirmCognitoUserMutation__
 *
 * To run a mutation, you first call `useConfirmCognitoUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmCognitoUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmCognitoUserMutation, { data, loading, error }] = useConfirmCognitoUserMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useConfirmCognitoUserMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmCognitoUserMutation, ConfirmCognitoUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmCognitoUserMutation, ConfirmCognitoUserMutationVariables>(ConfirmCognitoUserDocument, options);
      }
export type ConfirmCognitoUserMutationHookResult = ReturnType<typeof useConfirmCognitoUserMutation>;
export type ConfirmCognitoUserMutationResult = Apollo.MutationResult<ConfirmCognitoUserMutation>;
export type ConfirmCognitoUserMutationOptions = Apollo.BaseMutationOptions<ConfirmCognitoUserMutation, ConfirmCognitoUserMutationVariables>;
export const GetUserDocumentUrlsDocument = gql`
    query GetUserDocumentUrls($user: uuid!) {
  getDownloadDocumentUrl(object: {user: $user}) {
    id
    original_name
    type
    url
    created_at
  }
}
    `;

/**
 * __useGetUserDocumentUrlsQuery__
 *
 * To run a query within a React component, call `useGetUserDocumentUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDocumentUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDocumentUrlsQuery({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useGetUserDocumentUrlsQuery(baseOptions: Apollo.QueryHookOptions<GetUserDocumentUrlsQuery, GetUserDocumentUrlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDocumentUrlsQuery, GetUserDocumentUrlsQueryVariables>(GetUserDocumentUrlsDocument, options);
      }
export function useGetUserDocumentUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDocumentUrlsQuery, GetUserDocumentUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDocumentUrlsQuery, GetUserDocumentUrlsQueryVariables>(GetUserDocumentUrlsDocument, options);
        }
export type GetUserDocumentUrlsQueryHookResult = ReturnType<typeof useGetUserDocumentUrlsQuery>;
export type GetUserDocumentUrlsLazyQueryHookResult = ReturnType<typeof useGetUserDocumentUrlsLazyQuery>;
export type GetUserDocumentUrlsQueryResult = Apollo.QueryResult<GetUserDocumentUrlsQuery, GetUserDocumentUrlsQueryVariables>;
export const InsertUserDocumentDocument = gql`
    mutation InsertUserDocument($type: document_type_enum!, $s3Name: uuid!, $originalName: String!, $user: uuid!) {
  insert_user_document_one(
    object: {originalName: $originalName, s3Name: $s3Name, type: $type, user: $user}
  ) {
    id
    s3Name
    originalName
    type
    updated_at
  }
}
    `;
export type InsertUserDocumentMutationFn = Apollo.MutationFunction<InsertUserDocumentMutation, InsertUserDocumentMutationVariables>;

/**
 * __useInsertUserDocumentMutation__
 *
 * To run a mutation, you first call `useInsertUserDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserDocumentMutation, { data, loading, error }] = useInsertUserDocumentMutation({
 *   variables: {
 *      type: // value for 'type'
 *      s3Name: // value for 's3Name'
 *      originalName: // value for 'originalName'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useInsertUserDocumentMutation(baseOptions?: Apollo.MutationHookOptions<InsertUserDocumentMutation, InsertUserDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertUserDocumentMutation, InsertUserDocumentMutationVariables>(InsertUserDocumentDocument, options);
      }
export type InsertUserDocumentMutationHookResult = ReturnType<typeof useInsertUserDocumentMutation>;
export type InsertUserDocumentMutationResult = Apollo.MutationResult<InsertUserDocumentMutation>;
export type InsertUserDocumentMutationOptions = Apollo.BaseMutationOptions<InsertUserDocumentMutation, InsertUserDocumentMutationVariables>;
export const DataForUserLocationRemovalValidationDocument = gql`
    query DataForUserLocationRemovalValidation($user: uuid!, $locations: [uuid!]!) {
  user_plan_aggregate(
    where: {user: {_eq: $user}, canceledAt: {_is_null: true}, planByPlan: {_or: [{location: {_in: $locations}}, {locationByLocation: {childLocationByLocation: {usesParentLocationPlans: {_eq: true}, id: {_in: $locations}}}}]}}
  ) {
    aggregate {
      count
    }
  }
  invoice_aggregate(
    where: {status: {_eq: "draft"}, _or: [{bookingByBooking: {provider: {_eq: $user}, location: {_in: $locations}}}, {productPurchases: {user: {_eq: $user}, location: {_in: $locations}}}]}
  ) {
    aggregate {
      count
    }
  }
  product_purchase(
    where: {user: {_eq: $user}, cancelledAt: {_is_null: true}, location: {_in: $locations}}
  ) {
    id
    units
    units_fulfilled
  }
}
    `;

/**
 * __useDataForUserLocationRemovalValidationQuery__
 *
 * To run a query within a React component, call `useDataForUserLocationRemovalValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataForUserLocationRemovalValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataForUserLocationRemovalValidationQuery({
 *   variables: {
 *      user: // value for 'user'
 *      locations: // value for 'locations'
 *   },
 * });
 */
export function useDataForUserLocationRemovalValidationQuery(baseOptions: Apollo.QueryHookOptions<DataForUserLocationRemovalValidationQuery, DataForUserLocationRemovalValidationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataForUserLocationRemovalValidationQuery, DataForUserLocationRemovalValidationQueryVariables>(DataForUserLocationRemovalValidationDocument, options);
      }
export function useDataForUserLocationRemovalValidationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataForUserLocationRemovalValidationQuery, DataForUserLocationRemovalValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataForUserLocationRemovalValidationQuery, DataForUserLocationRemovalValidationQueryVariables>(DataForUserLocationRemovalValidationDocument, options);
        }
export type DataForUserLocationRemovalValidationQueryHookResult = ReturnType<typeof useDataForUserLocationRemovalValidationQuery>;
export type DataForUserLocationRemovalValidationLazyQueryHookResult = ReturnType<typeof useDataForUserLocationRemovalValidationLazyQuery>;
export type DataForUserLocationRemovalValidationQueryResult = Apollo.QueryResult<DataForUserLocationRemovalValidationQuery, DataForUserLocationRemovalValidationQueryVariables>;
export const GetHostedInvoiceDocument = gql`
    query GetHostedInvoice($invoiceId: String!, $provider: uuid, $location: uuid) {
  getHostedInvoiceUrl(
    invoiceId: $invoiceId
    provider: $provider
    location: $location
  ) {
    hostedInvoiceUrl
  }
}
    `;

/**
 * __useGetHostedInvoiceQuery__
 *
 * To run a query within a React component, call `useGetHostedInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHostedInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHostedInvoiceQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      provider: // value for 'provider'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetHostedInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetHostedInvoiceQuery, GetHostedInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHostedInvoiceQuery, GetHostedInvoiceQueryVariables>(GetHostedInvoiceDocument, options);
      }
export function useGetHostedInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHostedInvoiceQuery, GetHostedInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHostedInvoiceQuery, GetHostedInvoiceQueryVariables>(GetHostedInvoiceDocument, options);
        }
export type GetHostedInvoiceQueryHookResult = ReturnType<typeof useGetHostedInvoiceQuery>;
export type GetHostedInvoiceLazyQueryHookResult = ReturnType<typeof useGetHostedInvoiceLazyQuery>;
export type GetHostedInvoiceQueryResult = Apollo.QueryResult<GetHostedInvoiceQuery, GetHostedInvoiceQueryVariables>;
export const InsertAddressSharedDocument = gql`
    mutation InsertAddressShared($userId: uuid!, $addressId: uuid!, $address: address_insert_input!) {
  insert_address_one(object: $address) {
    id
    city
    line1
    line2
    state
    zipcode
  }
  update_user_by_pk(pk_columns: {id: $userId}, _set: {address: $addressId}) {
    id
    address
  }
}
    `;
export type InsertAddressSharedMutationFn = Apollo.MutationFunction<InsertAddressSharedMutation, InsertAddressSharedMutationVariables>;

/**
 * __useInsertAddressSharedMutation__
 *
 * To run a mutation, you first call `useInsertAddressSharedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAddressSharedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAddressSharedMutation, { data, loading, error }] = useInsertAddressSharedMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      addressId: // value for 'addressId'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useInsertAddressSharedMutation(baseOptions?: Apollo.MutationHookOptions<InsertAddressSharedMutation, InsertAddressSharedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAddressSharedMutation, InsertAddressSharedMutationVariables>(InsertAddressSharedDocument, options);
      }
export type InsertAddressSharedMutationHookResult = ReturnType<typeof useInsertAddressSharedMutation>;
export type InsertAddressSharedMutationResult = Apollo.MutationResult<InsertAddressSharedMutation>;
export type InsertAddressSharedMutationOptions = Apollo.BaseMutationOptions<InsertAddressSharedMutation, InsertAddressSharedMutationVariables>;
export const UpdateAddressSharedDocument = gql`
    mutation UpdateAddressShared($id: uuid!, $_set: address_set_input!) {
  update_address_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
    city
    line1
    line2
    state
    zipcode
  }
}
    `;
export type UpdateAddressSharedMutationFn = Apollo.MutationFunction<UpdateAddressSharedMutation, UpdateAddressSharedMutationVariables>;

/**
 * __useUpdateAddressSharedMutation__
 *
 * To run a mutation, you first call `useUpdateAddressSharedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressSharedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressSharedMutation, { data, loading, error }] = useUpdateAddressSharedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateAddressSharedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddressSharedMutation, UpdateAddressSharedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddressSharedMutation, UpdateAddressSharedMutationVariables>(UpdateAddressSharedDocument, options);
      }
export type UpdateAddressSharedMutationHookResult = ReturnType<typeof useUpdateAddressSharedMutation>;
export type UpdateAddressSharedMutationResult = Apollo.MutationResult<UpdateAddressSharedMutation>;
export type UpdateAddressSharedMutationOptions = Apollo.BaseMutationOptions<UpdateAddressSharedMutation, UpdateAddressSharedMutationVariables>;
export const CreateCheckoutSessionSharedDocument = gql`
    mutation CreateCheckoutSessionShared($userId: uuid!) {
  createCheckoutSession(object: {userId: $userId}) {
    id
    stripeCustomerId
  }
}
    `;
export type CreateCheckoutSessionSharedMutationFn = Apollo.MutationFunction<CreateCheckoutSessionSharedMutation, CreateCheckoutSessionSharedMutationVariables>;

/**
 * __useCreateCheckoutSessionSharedMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutSessionSharedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutSessionSharedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutSessionSharedMutation, { data, loading, error }] = useCreateCheckoutSessionSharedMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateCheckoutSessionSharedMutation(baseOptions?: Apollo.MutationHookOptions<CreateCheckoutSessionSharedMutation, CreateCheckoutSessionSharedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCheckoutSessionSharedMutation, CreateCheckoutSessionSharedMutationVariables>(CreateCheckoutSessionSharedDocument, options);
      }
export type CreateCheckoutSessionSharedMutationHookResult = ReturnType<typeof useCreateCheckoutSessionSharedMutation>;
export type CreateCheckoutSessionSharedMutationResult = Apollo.MutationResult<CreateCheckoutSessionSharedMutation>;
export type CreateCheckoutSessionSharedMutationOptions = Apollo.BaseMutationOptions<CreateCheckoutSessionSharedMutation, CreateCheckoutSessionSharedMutationVariables>;
export const GetDocumentUploadUrlSharedDocument = gql`
    query GetDocumentUploadUrlShared($user: uuid!, $count: Int!, $types: [String!]) {
  getUploadDocumentUrl(object: {user: $user, count: $count, types: $types}) {
    id
    url
  }
}
    `;

/**
 * __useGetDocumentUploadUrlSharedQuery__
 *
 * To run a query within a React component, call `useGetDocumentUploadUrlSharedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentUploadUrlSharedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentUploadUrlSharedQuery({
 *   variables: {
 *      user: // value for 'user'
 *      count: // value for 'count'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useGetDocumentUploadUrlSharedQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentUploadUrlSharedQuery, GetDocumentUploadUrlSharedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentUploadUrlSharedQuery, GetDocumentUploadUrlSharedQueryVariables>(GetDocumentUploadUrlSharedDocument, options);
      }
export function useGetDocumentUploadUrlSharedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentUploadUrlSharedQuery, GetDocumentUploadUrlSharedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentUploadUrlSharedQuery, GetDocumentUploadUrlSharedQueryVariables>(GetDocumentUploadUrlSharedDocument, options);
        }
export type GetDocumentUploadUrlSharedQueryHookResult = ReturnType<typeof useGetDocumentUploadUrlSharedQuery>;
export type GetDocumentUploadUrlSharedLazyQueryHookResult = ReturnType<typeof useGetDocumentUploadUrlSharedLazyQuery>;
export type GetDocumentUploadUrlSharedQueryResult = Apollo.QueryResult<GetDocumentUploadUrlSharedQuery, GetDocumentUploadUrlSharedQueryVariables>;
export const GetPhotoUploadUrlSharedDocument = gql`
    query GetPhotoUploadUrlShared($user: uuid!, $types: [String!]!, $ehrPhotoType: EhrPhotoType) {
  getUploadPhotoUrl(
    object: {user: $user, types: $types, ehrPhotoType: $ehrPhotoType}
  ) {
    id
    url
  }
}
    `;

/**
 * __useGetPhotoUploadUrlSharedQuery__
 *
 * To run a query within a React component, call `useGetPhotoUploadUrlSharedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhotoUploadUrlSharedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhotoUploadUrlSharedQuery({
 *   variables: {
 *      user: // value for 'user'
 *      types: // value for 'types'
 *      ehrPhotoType: // value for 'ehrPhotoType'
 *   },
 * });
 */
export function useGetPhotoUploadUrlSharedQuery(baseOptions: Apollo.QueryHookOptions<GetPhotoUploadUrlSharedQuery, GetPhotoUploadUrlSharedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPhotoUploadUrlSharedQuery, GetPhotoUploadUrlSharedQueryVariables>(GetPhotoUploadUrlSharedDocument, options);
      }
export function useGetPhotoUploadUrlSharedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPhotoUploadUrlSharedQuery, GetPhotoUploadUrlSharedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPhotoUploadUrlSharedQuery, GetPhotoUploadUrlSharedQueryVariables>(GetPhotoUploadUrlSharedDocument, options);
        }
export type GetPhotoUploadUrlSharedQueryHookResult = ReturnType<typeof useGetPhotoUploadUrlSharedQuery>;
export type GetPhotoUploadUrlSharedLazyQueryHookResult = ReturnType<typeof useGetPhotoUploadUrlSharedLazyQuery>;
export type GetPhotoUploadUrlSharedQueryResult = Apollo.QueryResult<GetPhotoUploadUrlSharedQuery, GetPhotoUploadUrlSharedQueryVariables>;
export const InsertUserAgreementsSharedDocument = gql`
    mutation InsertUserAgreementsShared($objects: [user_agreements_insert_input!]!) {
  insert_user_agreements(objects: $objects) {
    returning {
      id
      type
      user
      version
    }
  }
}
    `;
export type InsertUserAgreementsSharedMutationFn = Apollo.MutationFunction<InsertUserAgreementsSharedMutation, InsertUserAgreementsSharedMutationVariables>;

/**
 * __useInsertUserAgreementsSharedMutation__
 *
 * To run a mutation, you first call `useInsertUserAgreementsSharedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserAgreementsSharedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserAgreementsSharedMutation, { data, loading, error }] = useInsertUserAgreementsSharedMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertUserAgreementsSharedMutation(baseOptions?: Apollo.MutationHookOptions<InsertUserAgreementsSharedMutation, InsertUserAgreementsSharedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertUserAgreementsSharedMutation, InsertUserAgreementsSharedMutationVariables>(InsertUserAgreementsSharedDocument, options);
      }
export type InsertUserAgreementsSharedMutationHookResult = ReturnType<typeof useInsertUserAgreementsSharedMutation>;
export type InsertUserAgreementsSharedMutationResult = Apollo.MutationResult<InsertUserAgreementsSharedMutation>;
export type InsertUserAgreementsSharedMutationOptions = Apollo.BaseMutationOptions<InsertUserAgreementsSharedMutation, InsertUserAgreementsSharedMutationVariables>;
export const InsertUserDocumentSharedDocument = gql`
    mutation InsertUserDocumentShared($objects: [user_document_insert_input!]!) {
  insert_user_document(objects: $objects) {
    returning {
      id
      s3Name
      originalName
      type
      updated_at
      user
      created_at
    }
  }
}
    `;
export type InsertUserDocumentSharedMutationFn = Apollo.MutationFunction<InsertUserDocumentSharedMutation, InsertUserDocumentSharedMutationVariables>;

/**
 * __useInsertUserDocumentSharedMutation__
 *
 * To run a mutation, you first call `useInsertUserDocumentSharedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserDocumentSharedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserDocumentSharedMutation, { data, loading, error }] = useInsertUserDocumentSharedMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertUserDocumentSharedMutation(baseOptions?: Apollo.MutationHookOptions<InsertUserDocumentSharedMutation, InsertUserDocumentSharedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertUserDocumentSharedMutation, InsertUserDocumentSharedMutationVariables>(InsertUserDocumentSharedDocument, options);
      }
export type InsertUserDocumentSharedMutationHookResult = ReturnType<typeof useInsertUserDocumentSharedMutation>;
export type InsertUserDocumentSharedMutationResult = Apollo.MutationResult<InsertUserDocumentSharedMutation>;
export type InsertUserDocumentSharedMutationOptions = Apollo.BaseMutationOptions<InsertUserDocumentSharedMutation, InsertUserDocumentSharedMutationVariables>;
export const PurchaseProductSharedDocument = gql`
    mutation PurchaseProductShared($objects: [product_purchase_insert_input!]!) {
  insert_product_purchase(objects: $objects) {
    returning {
      id
      booking
      location
      price
      product
      user
      locationProduct {
        product
        location
        stock
      }
    }
  }
}
    `;
export type PurchaseProductSharedMutationFn = Apollo.MutationFunction<PurchaseProductSharedMutation, PurchaseProductSharedMutationVariables>;

/**
 * __usePurchaseProductSharedMutation__
 *
 * To run a mutation, you first call `usePurchaseProductSharedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseProductSharedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseProductSharedMutation, { data, loading, error }] = usePurchaseProductSharedMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function usePurchaseProductSharedMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseProductSharedMutation, PurchaseProductSharedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseProductSharedMutation, PurchaseProductSharedMutationVariables>(PurchaseProductSharedDocument, options);
      }
export type PurchaseProductSharedMutationHookResult = ReturnType<typeof usePurchaseProductSharedMutation>;
export type PurchaseProductSharedMutationResult = Apollo.MutationResult<PurchaseProductSharedMutation>;
export type PurchaseProductSharedMutationOptions = Apollo.BaseMutationOptions<PurchaseProductSharedMutation, PurchaseProductSharedMutationVariables>;
export const UpdateUserSharedDocument = gql`
    mutation UpdateUserShared($id: uuid!, $_set: user_set_input!) {
  update_user_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
    accreditation
    active
    address
    cognitoUserSub
    created_at
    deleted_at
    firstName
    lastName
    licenseExpiration
    role
    stripeCustomerId
    updated_at
    malpracticeExpiration
  }
}
    `;
export type UpdateUserSharedMutationFn = Apollo.MutationFunction<UpdateUserSharedMutation, UpdateUserSharedMutationVariables>;

/**
 * __useUpdateUserSharedMutation__
 *
 * To run a mutation, you first call `useUpdateUserSharedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSharedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSharedMutation, { data, loading, error }] = useUpdateUserSharedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateUserSharedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSharedMutation, UpdateUserSharedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSharedMutation, UpdateUserSharedMutationVariables>(UpdateUserSharedDocument, options);
      }
export type UpdateUserSharedMutationHookResult = ReturnType<typeof useUpdateUserSharedMutation>;
export type UpdateUserSharedMutationResult = Apollo.MutationResult<UpdateUserSharedMutation>;
export type UpdateUserSharedMutationOptions = Apollo.BaseMutationOptions<UpdateUserSharedMutation, UpdateUserSharedMutationVariables>;
export const MedicalDirectorDocument = gql`
    query MedicalDirector($accreditation: accreditation_enum!, $location: uuid!) {
  accreditation_location_privilege(
    where: {accreditation: {_eq: $accreditation}, location: {_eq: $location}}
  ) {
    canBookWithoutDirector
    accreditation
    location
  }
}
    `;

/**
 * __useMedicalDirectorQuery__
 *
 * To run a query within a React component, call `useMedicalDirectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicalDirectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicalDirectorQuery({
 *   variables: {
 *      accreditation: // value for 'accreditation'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useMedicalDirectorQuery(baseOptions: Apollo.QueryHookOptions<MedicalDirectorQuery, MedicalDirectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedicalDirectorQuery, MedicalDirectorQueryVariables>(MedicalDirectorDocument, options);
      }
export function useMedicalDirectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedicalDirectorQuery, MedicalDirectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedicalDirectorQuery, MedicalDirectorQueryVariables>(MedicalDirectorDocument, options);
        }
export type MedicalDirectorQueryHookResult = ReturnType<typeof useMedicalDirectorQuery>;
export type MedicalDirectorLazyQueryHookResult = ReturnType<typeof useMedicalDirectorLazyQuery>;
export type MedicalDirectorQueryResult = Apollo.QueryResult<MedicalDirectorQuery, MedicalDirectorQueryVariables>;
export const MedicalDirectorRequiredLocationDocument = gql`
    query MedicalDirectorRequiredLocation($location: uuid!) {
  accreditation_location_privilege(where: {location: {_eq: $location}}) {
    canBookWithoutDirector
    accreditation
    location
  }
}
    `;

/**
 * __useMedicalDirectorRequiredLocationQuery__
 *
 * To run a query within a React component, call `useMedicalDirectorRequiredLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicalDirectorRequiredLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicalDirectorRequiredLocationQuery({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useMedicalDirectorRequiredLocationQuery(baseOptions: Apollo.QueryHookOptions<MedicalDirectorRequiredLocationQuery, MedicalDirectorRequiredLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedicalDirectorRequiredLocationQuery, MedicalDirectorRequiredLocationQueryVariables>(MedicalDirectorRequiredLocationDocument, options);
      }
export function useMedicalDirectorRequiredLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedicalDirectorRequiredLocationQuery, MedicalDirectorRequiredLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedicalDirectorRequiredLocationQuery, MedicalDirectorRequiredLocationQueryVariables>(MedicalDirectorRequiredLocationDocument, options);
        }
export type MedicalDirectorRequiredLocationQueryHookResult = ReturnType<typeof useMedicalDirectorRequiredLocationQuery>;
export type MedicalDirectorRequiredLocationLazyQueryHookResult = ReturnType<typeof useMedicalDirectorRequiredLocationLazyQuery>;
export type MedicalDirectorRequiredLocationQueryResult = Apollo.QueryResult<MedicalDirectorRequiredLocationQuery, MedicalDirectorRequiredLocationQueryVariables>;
export const GetUserDetailSharedDocument = gql`
    query GetUserDetailShared($id: uuid!) {
  user_by_pk(id: $id) {
    active
    cognitoUserSub
    firstName
    id
    lastName
    role
    stripeCustomerId
    accreditation
    licenseExpiration
    malpracticeExpiration
    unsubscribedFromNotifications
    addressByAddress {
      id
      city
      line1
      line2
      state
      zipcode
    }
    userLocations {
      user
      location
      locationByLocation {
        name
      }
    }
  }
}
    `;

/**
 * __useGetUserDetailSharedQuery__
 *
 * To run a query within a React component, call `useGetUserDetailSharedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDetailSharedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDetailSharedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserDetailSharedQuery(baseOptions: Apollo.QueryHookOptions<GetUserDetailSharedQuery, GetUserDetailSharedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDetailSharedQuery, GetUserDetailSharedQueryVariables>(GetUserDetailSharedDocument, options);
      }
export function useGetUserDetailSharedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDetailSharedQuery, GetUserDetailSharedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDetailSharedQuery, GetUserDetailSharedQueryVariables>(GetUserDetailSharedDocument, options);
        }
export type GetUserDetailSharedQueryHookResult = ReturnType<typeof useGetUserDetailSharedQuery>;
export type GetUserDetailSharedLazyQueryHookResult = ReturnType<typeof useGetUserDetailSharedLazyQuery>;
export type GetUserDetailSharedQueryResult = Apollo.QueryResult<GetUserDetailSharedQuery, GetUserDetailSharedQueryVariables>;
export const LocationDetailDocument = gql`
    query LocationDetail($id: uuid!) {
  location_by_pk(id: $id) {
    id
    name
    timezone
  }
}
    `;

/**
 * __useLocationDetailQuery__
 *
 * To run a query within a React component, call `useLocationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationDetailQuery(baseOptions: Apollo.QueryHookOptions<LocationDetailQuery, LocationDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationDetailQuery, LocationDetailQueryVariables>(LocationDetailDocument, options);
      }
export function useLocationDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationDetailQuery, LocationDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationDetailQuery, LocationDetailQueryVariables>(LocationDetailDocument, options);
        }
export type LocationDetailQueryHookResult = ReturnType<typeof useLocationDetailQuery>;
export type LocationDetailLazyQueryHookResult = ReturnType<typeof useLocationDetailLazyQuery>;
export type LocationDetailQueryResult = Apollo.QueryResult<LocationDetailQuery, LocationDetailQueryVariables>;
export const AllRoomsDocument = gql`
    query AllRooms($_in: [uuid!] = "") {
  room(where: {location: {_in: $_in}}) {
    id
    name
    deleted_at
    locationByLocation {
      timezone
      name
      id
    }
  }
}
    `;

/**
 * __useAllRoomsQuery__
 *
 * To run a query within a React component, call `useAllRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRoomsQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useAllRoomsQuery(baseOptions?: Apollo.QueryHookOptions<AllRoomsQuery, AllRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllRoomsQuery, AllRoomsQueryVariables>(AllRoomsDocument, options);
      }
export function useAllRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllRoomsQuery, AllRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllRoomsQuery, AllRoomsQueryVariables>(AllRoomsDocument, options);
        }
export type AllRoomsQueryHookResult = ReturnType<typeof useAllRoomsQuery>;
export type AllRoomsLazyQueryHookResult = ReturnType<typeof useAllRoomsLazyQuery>;
export type AllRoomsQueryResult = Apollo.QueryResult<AllRoomsQuery, AllRoomsQueryVariables>;
export const AllLocationsDocument = gql`
    query AllLocations {
  location {
    id
    name
    timezone
    partnerByPartner {
      msoMode
    }
  }
}
    `;

/**
 * __useAllLocationsQuery__
 *
 * To run a query within a React component, call `useAllLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllLocationsQuery(baseOptions?: Apollo.QueryHookOptions<AllLocationsQuery, AllLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllLocationsQuery, AllLocationsQueryVariables>(AllLocationsDocument, options);
      }
export function useAllLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllLocationsQuery, AllLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllLocationsQuery, AllLocationsQueryVariables>(AllLocationsDocument, options);
        }
export type AllLocationsQueryHookResult = ReturnType<typeof useAllLocationsQuery>;
export type AllLocationsLazyQueryHookResult = ReturnType<typeof useAllLocationsLazyQuery>;
export type AllLocationsQueryResult = Apollo.QueryResult<AllLocationsQuery, AllLocationsQueryVariables>;
export const AllRoomTypesDocument = gql`
    query AllRoomTypes($_in: [uuid!]!) {
  room_type(where: {location: {_in: $_in}}) {
    id
    name
  }
}
    `;

/**
 * __useAllRoomTypesQuery__
 *
 * To run a query within a React component, call `useAllRoomTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRoomTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRoomTypesQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useAllRoomTypesQuery(baseOptions: Apollo.QueryHookOptions<AllRoomTypesQuery, AllRoomTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllRoomTypesQuery, AllRoomTypesQueryVariables>(AllRoomTypesDocument, options);
      }
export function useAllRoomTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllRoomTypesQuery, AllRoomTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllRoomTypesQuery, AllRoomTypesQueryVariables>(AllRoomTypesDocument, options);
        }
export type AllRoomTypesQueryHookResult = ReturnType<typeof useAllRoomTypesQuery>;
export type AllRoomTypesLazyQueryHookResult = ReturnType<typeof useAllRoomTypesLazyQuery>;
export type AllRoomTypesQueryResult = Apollo.QueryResult<AllRoomTypesQuery, AllRoomTypesQueryVariables>;
export const AllPlanTypesDocument = gql`
    query AllPlanTypes {
  plan_type {
    id
  }
}
    `;

/**
 * __useAllPlanTypesQuery__
 *
 * To run a query within a React component, call `useAllPlanTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPlanTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPlanTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPlanTypesQuery(baseOptions?: Apollo.QueryHookOptions<AllPlanTypesQuery, AllPlanTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPlanTypesQuery, AllPlanTypesQueryVariables>(AllPlanTypesDocument, options);
      }
export function useAllPlanTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPlanTypesQuery, AllPlanTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPlanTypesQuery, AllPlanTypesQueryVariables>(AllPlanTypesDocument, options);
        }
export type AllPlanTypesQueryHookResult = ReturnType<typeof useAllPlanTypesQuery>;
export type AllPlanTypesLazyQueryHookResult = ReturnType<typeof useAllPlanTypesLazyQuery>;
export type AllPlanTypesQueryResult = Apollo.QueryResult<AllPlanTypesQuery, AllPlanTypesQueryVariables>;
export const AllCreditTypesDocument = gql`
    query AllCreditTypes {
  credit_type {
    id
  }
}
    `;

/**
 * __useAllCreditTypesQuery__
 *
 * To run a query within a React component, call `useAllCreditTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCreditTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCreditTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCreditTypesQuery(baseOptions?: Apollo.QueryHookOptions<AllCreditTypesQuery, AllCreditTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCreditTypesQuery, AllCreditTypesQueryVariables>(AllCreditTypesDocument, options);
      }
export function useAllCreditTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCreditTypesQuery, AllCreditTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCreditTypesQuery, AllCreditTypesQueryVariables>(AllCreditTypesDocument, options);
        }
export type AllCreditTypesQueryHookResult = ReturnType<typeof useAllCreditTypesQuery>;
export type AllCreditTypesLazyQueryHookResult = ReturnType<typeof useAllCreditTypesLazyQuery>;
export type AllCreditTypesQueryResult = Apollo.QueryResult<AllCreditTypesQuery, AllCreditTypesQueryVariables>;
export const AllTaxRatesDocument = gql`
    query AllTaxRates($_in: [uuid!]) {
  tax_rate(where: {location: {_in: $_in}}) {
    id
    location
    rate
    type
    name
  }
}
    `;

/**
 * __useAllTaxRatesQuery__
 *
 * To run a query within a React component, call `useAllTaxRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTaxRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTaxRatesQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useAllTaxRatesQuery(baseOptions?: Apollo.QueryHookOptions<AllTaxRatesQuery, AllTaxRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTaxRatesQuery, AllTaxRatesQueryVariables>(AllTaxRatesDocument, options);
      }
export function useAllTaxRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTaxRatesQuery, AllTaxRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTaxRatesQuery, AllTaxRatesQueryVariables>(AllTaxRatesDocument, options);
        }
export type AllTaxRatesQueryHookResult = ReturnType<typeof useAllTaxRatesQuery>;
export type AllTaxRatesLazyQueryHookResult = ReturnType<typeof useAllTaxRatesLazyQuery>;
export type AllTaxRatesQueryResult = Apollo.QueryResult<AllTaxRatesQuery, AllTaxRatesQueryVariables>;
export const AllModelsDocument = gql`
    query AllModels {
  model {
    id
    name
    deleted_at
  }
}
    `;

/**
 * __useAllModelsQuery__
 *
 * To run a query within a React component, call `useAllModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllModelsQuery(baseOptions?: Apollo.QueryHookOptions<AllModelsQuery, AllModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllModelsQuery, AllModelsQueryVariables>(AllModelsDocument, options);
      }
export function useAllModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllModelsQuery, AllModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllModelsQuery, AllModelsQueryVariables>(AllModelsDocument, options);
        }
export type AllModelsQueryHookResult = ReturnType<typeof useAllModelsQuery>;
export type AllModelsLazyQueryHookResult = ReturnType<typeof useAllModelsLazyQuery>;
export type AllModelsQueryResult = Apollo.QueryResult<AllModelsQuery, AllModelsQueryVariables>;
export const AllProductsDocument = gql`
    query AllProducts {
  product {
    id
    name
    deleted_at
    taxExempt
  }
}
    `;

/**
 * __useAllProductsQuery__
 *
 * To run a query within a React component, call `useAllProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllProductsQuery(baseOptions?: Apollo.QueryHookOptions<AllProductsQuery, AllProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllProductsQuery, AllProductsQueryVariables>(AllProductsDocument, options);
      }
export function useAllProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllProductsQuery, AllProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllProductsQuery, AllProductsQueryVariables>(AllProductsDocument, options);
        }
export type AllProductsQueryHookResult = ReturnType<typeof useAllProductsQuery>;
export type AllProductsLazyQueryHookResult = ReturnType<typeof useAllProductsLazyQuery>;
export type AllProductsQueryResult = Apollo.QueryResult<AllProductsQuery, AllProductsQueryVariables>;
export const AllProvidersDocument = gql`
    query AllProviders($_in: [uuid!] = "") {
  user(
    where: {role: {_eq: Provider}, userLocations: {location: {_in: $_in}}, deleted_at: {_is_null: true}, active: {_eq: true}}
  ) {
    id
    firstName
    lastName
    active
  }
}
    `;

/**
 * __useAllProvidersQuery__
 *
 * To run a query within a React component, call `useAllProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProvidersQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useAllProvidersQuery(baseOptions?: Apollo.QueryHookOptions<AllProvidersQuery, AllProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllProvidersQuery, AllProvidersQueryVariables>(AllProvidersDocument, options);
      }
export function useAllProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllProvidersQuery, AllProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllProvidersQuery, AllProvidersQueryVariables>(AllProvidersDocument, options);
        }
export type AllProvidersQueryHookResult = ReturnType<typeof useAllProvidersQuery>;
export type AllProvidersLazyQueryHookResult = ReturnType<typeof useAllProvidersLazyQuery>;
export type AllProvidersQueryResult = Apollo.QueryResult<AllProvidersQuery, AllProvidersQueryVariables>;
export const AllUsersDocument = gql`
    query AllUsers($_in: [uuid!] = "") {
  user(where: {userLocations: {location: {_in: $_in}}}) {
    id
    firstName
    lastName
    active
    role
    stripeCustomerId
  }
}
    `;

/**
 * __useAllUsersQuery__
 *
 * To run a query within a React component, call `useAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useAllUsersQuery(baseOptions?: Apollo.QueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, options);
      }
export function useAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, options);
        }
export type AllUsersQueryHookResult = ReturnType<typeof useAllUsersQuery>;
export type AllUsersLazyQueryHookResult = ReturnType<typeof useAllUsersLazyQuery>;
export type AllUsersQueryResult = Apollo.QueryResult<AllUsersQuery, AllUsersQueryVariables>;
export const AllRolesDocument = gql`
    query AllRoles {
  role {
    id
  }
}
    `;

/**
 * __useAllRolesQuery__
 *
 * To run a query within a React component, call `useAllRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllRolesQuery(baseOptions?: Apollo.QueryHookOptions<AllRolesQuery, AllRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllRolesQuery, AllRolesQueryVariables>(AllRolesDocument, options);
      }
export function useAllRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllRolesQuery, AllRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllRolesQuery, AllRolesQueryVariables>(AllRolesDocument, options);
        }
export type AllRolesQueryHookResult = ReturnType<typeof useAllRolesQuery>;
export type AllRolesLazyQueryHookResult = ReturnType<typeof useAllRolesLazyQuery>;
export type AllRolesQueryResult = Apollo.QueryResult<AllRolesQuery, AllRolesQueryVariables>;
export const AllAccreditationsDocument = gql`
    query AllAccreditations {
  accreditation {
    id
  }
}
    `;

/**
 * __useAllAccreditationsQuery__
 *
 * To run a query within a React component, call `useAllAccreditationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAccreditationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAccreditationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAccreditationsQuery(baseOptions?: Apollo.QueryHookOptions<AllAccreditationsQuery, AllAccreditationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAccreditationsQuery, AllAccreditationsQueryVariables>(AllAccreditationsDocument, options);
      }
export function useAllAccreditationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAccreditationsQuery, AllAccreditationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAccreditationsQuery, AllAccreditationsQueryVariables>(AllAccreditationsDocument, options);
        }
export type AllAccreditationsQueryHookResult = ReturnType<typeof useAllAccreditationsQuery>;
export type AllAccreditationsLazyQueryHookResult = ReturnType<typeof useAllAccreditationsLazyQuery>;
export type AllAccreditationsQueryResult = Apollo.QueryResult<AllAccreditationsQuery, AllAccreditationsQueryVariables>;
export const AllEhrProcedureTypesDocument = gql`
    query AllEhrProcedureTypes {
  ehr_procedure_type: ehr_procedure_type_enum {
    id: name
  }
}
    `;

/**
 * __useAllEhrProcedureTypesQuery__
 *
 * To run a query within a React component, call `useAllEhrProcedureTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEhrProcedureTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllEhrProcedureTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllEhrProcedureTypesQuery(baseOptions?: Apollo.QueryHookOptions<AllEhrProcedureTypesQuery, AllEhrProcedureTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllEhrProcedureTypesQuery, AllEhrProcedureTypesQueryVariables>(AllEhrProcedureTypesDocument, options);
      }
export function useAllEhrProcedureTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllEhrProcedureTypesQuery, AllEhrProcedureTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllEhrProcedureTypesQuery, AllEhrProcedureTypesQueryVariables>(AllEhrProcedureTypesDocument, options);
        }
export type AllEhrProcedureTypesQueryHookResult = ReturnType<typeof useAllEhrProcedureTypesQuery>;
export type AllEhrProcedureTypesLazyQueryHookResult = ReturnType<typeof useAllEhrProcedureTypesLazyQuery>;
export type AllEhrProcedureTypesQueryResult = Apollo.QueryResult<AllEhrProcedureTypesQuery, AllEhrProcedureTypesQueryVariables>;
export const AllPlansDocument = gql`
    query AllPlans($_in: [uuid!]) {
  plan(where: {location: {_in: $_in}}) {
    id
    location
    name
    type
  }
}
    `;

/**
 * __useAllPlansQuery__
 *
 * To run a query within a React component, call `useAllPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPlansQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useAllPlansQuery(baseOptions?: Apollo.QueryHookOptions<AllPlansQuery, AllPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPlansQuery, AllPlansQueryVariables>(AllPlansDocument, options);
      }
export function useAllPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPlansQuery, AllPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPlansQuery, AllPlansQueryVariables>(AllPlansDocument, options);
        }
export type AllPlansQueryHookResult = ReturnType<typeof useAllPlansQuery>;
export type AllPlansLazyQueryHookResult = ReturnType<typeof useAllPlansLazyQuery>;
export type AllPlansQueryResult = Apollo.QueryResult<AllPlansQuery, AllPlansQueryVariables>;
export const AllCurrentPlansDocument = gql`
    query AllCurrentPlans($_in: uuid!) {
  get_cumulative_location_plans(
    args: {base_location: $_in}
    where: {deleted_at: {_is_null: true}}
  ) {
    id
    location
    name
    type
  }
}
    `;

/**
 * __useAllCurrentPlansQuery__
 *
 * To run a query within a React component, call `useAllCurrentPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCurrentPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCurrentPlansQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useAllCurrentPlansQuery(baseOptions: Apollo.QueryHookOptions<AllCurrentPlansQuery, AllCurrentPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCurrentPlansQuery, AllCurrentPlansQueryVariables>(AllCurrentPlansDocument, options);
      }
export function useAllCurrentPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCurrentPlansQuery, AllCurrentPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCurrentPlansQuery, AllCurrentPlansQueryVariables>(AllCurrentPlansDocument, options);
        }
export type AllCurrentPlansQueryHookResult = ReturnType<typeof useAllCurrentPlansQuery>;
export type AllCurrentPlansLazyQueryHookResult = ReturnType<typeof useAllCurrentPlansLazyQuery>;
export type AllCurrentPlansQueryResult = Apollo.QueryResult<AllCurrentPlansQuery, AllCurrentPlansQueryVariables>;
export const AllProductTypeDocument = gql`
    query AllProductType {
  product_type {
    id
    type
  }
}
    `;

/**
 * __useAllProductTypeQuery__
 *
 * To run a query within a React component, call `useAllProductTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProductTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProductTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllProductTypeQuery(baseOptions?: Apollo.QueryHookOptions<AllProductTypeQuery, AllProductTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllProductTypeQuery, AllProductTypeQueryVariables>(AllProductTypeDocument, options);
      }
export function useAllProductTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllProductTypeQuery, AllProductTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllProductTypeQuery, AllProductTypeQueryVariables>(AllProductTypeDocument, options);
        }
export type AllProductTypeQueryHookResult = ReturnType<typeof useAllProductTypeQuery>;
export type AllProductTypeLazyQueryHookResult = ReturnType<typeof useAllProductTypeLazyQuery>;
export type AllProductTypeQueryResult = Apollo.QueryResult<AllProductTypeQuery, AllProductTypeQueryVariables>;
export const AllParentLocationsDocument = gql`
    query AllParentLocations {
  location {
    id
    name
  }
}
    `;

/**
 * __useAllParentLocationsQuery__
 *
 * To run a query within a React component, call `useAllParentLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllParentLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllParentLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllParentLocationsQuery(baseOptions?: Apollo.QueryHookOptions<AllParentLocationsQuery, AllParentLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllParentLocationsQuery, AllParentLocationsQueryVariables>(AllParentLocationsDocument, options);
      }
export function useAllParentLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllParentLocationsQuery, AllParentLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllParentLocationsQuery, AllParentLocationsQueryVariables>(AllParentLocationsDocument, options);
        }
export type AllParentLocationsQueryHookResult = ReturnType<typeof useAllParentLocationsQuery>;
export type AllParentLocationsLazyQueryHookResult = ReturnType<typeof useAllParentLocationsLazyQuery>;
export type AllParentLocationsQueryResult = Apollo.QueryResult<AllParentLocationsQuery, AllParentLocationsQueryVariables>;
export const AllBookableUsersDocument = gql`
    query AllBookableUsers($_in: [uuid!]!) {
  user(
    where: {role: {_in: [Provider, LocationAdmin, Manager]}, userLocations: {location: {_in: $_in}}, deleted_at: {_is_null: true}, _or: [{active: {_eq: true}}, {role: {_in: [LocationAdmin, Manager]}}]}
  ) {
    id
    firstName
    lastName
    active
  }
}
    `;

/**
 * __useAllBookableUsersQuery__
 *
 * To run a query within a React component, call `useAllBookableUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllBookableUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBookableUsersQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useAllBookableUsersQuery(baseOptions: Apollo.QueryHookOptions<AllBookableUsersQuery, AllBookableUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllBookableUsersQuery, AllBookableUsersQueryVariables>(AllBookableUsersDocument, options);
      }
export function useAllBookableUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllBookableUsersQuery, AllBookableUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllBookableUsersQuery, AllBookableUsersQueryVariables>(AllBookableUsersDocument, options);
        }
export type AllBookableUsersQueryHookResult = ReturnType<typeof useAllBookableUsersQuery>;
export type AllBookableUsersLazyQueryHookResult = ReturnType<typeof useAllBookableUsersLazyQuery>;
export type AllBookableUsersQueryResult = Apollo.QueryResult<AllBookableUsersQuery, AllBookableUsersQueryVariables>;
export const AllPartnersDocument = gql`
    query AllPartners {
  partner_basic {
    id
    name
  }
}
    `;

/**
 * __useAllPartnersQuery__
 *
 * To run a query within a React component, call `useAllPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPartnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPartnersQuery(baseOptions?: Apollo.QueryHookOptions<AllPartnersQuery, AllPartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPartnersQuery, AllPartnersQueryVariables>(AllPartnersDocument, options);
      }
export function useAllPartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPartnersQuery, AllPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPartnersQuery, AllPartnersQueryVariables>(AllPartnersDocument, options);
        }
export type AllPartnersQueryHookResult = ReturnType<typeof useAllPartnersQuery>;
export type AllPartnersLazyQueryHookResult = ReturnType<typeof useAllPartnersLazyQuery>;
export type AllPartnersQueryResult = Apollo.QueryResult<AllPartnersQuery, AllPartnersQueryVariables>;
export const AllProceduresDocument = gql`
    query AllProcedures {
  procedure(where: {deletedAt: {_is_null: true}}) {
    id
    name
  }
}
    `;

/**
 * __useAllProceduresQuery__
 *
 * To run a query within a React component, call `useAllProceduresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProceduresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProceduresQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllProceduresQuery(baseOptions?: Apollo.QueryHookOptions<AllProceduresQuery, AllProceduresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllProceduresQuery, AllProceduresQueryVariables>(AllProceduresDocument, options);
      }
export function useAllProceduresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllProceduresQuery, AllProceduresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllProceduresQuery, AllProceduresQueryVariables>(AllProceduresDocument, options);
        }
export type AllProceduresQueryHookResult = ReturnType<typeof useAllProceduresQuery>;
export type AllProceduresLazyQueryHookResult = ReturnType<typeof useAllProceduresLazyQuery>;
export type AllProceduresQueryResult = Apollo.QueryResult<AllProceduresQuery, AllProceduresQueryVariables>;
export const AllLocationProceduresDocument = gql`
    query AllLocationProcedures($_eq: uuid!) {
  location_procedure(where: {location: {_eq: $_eq}}) {
    id
    location
    procedure
    deleted_at: deletedAt
    procedureByProcedure {
      id
      name
    }
  }
}
    `;

/**
 * __useAllLocationProceduresQuery__
 *
 * To run a query within a React component, call `useAllLocationProceduresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLocationProceduresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLocationProceduresQuery({
 *   variables: {
 *      _eq: // value for '_eq'
 *   },
 * });
 */
export function useAllLocationProceduresQuery(baseOptions: Apollo.QueryHookOptions<AllLocationProceduresQuery, AllLocationProceduresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllLocationProceduresQuery, AllLocationProceduresQueryVariables>(AllLocationProceduresDocument, options);
      }
export function useAllLocationProceduresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllLocationProceduresQuery, AllLocationProceduresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllLocationProceduresQuery, AllLocationProceduresQueryVariables>(AllLocationProceduresDocument, options);
        }
export type AllLocationProceduresQueryHookResult = ReturnType<typeof useAllLocationProceduresQuery>;
export type AllLocationProceduresLazyQueryHookResult = ReturnType<typeof useAllLocationProceduresLazyQuery>;
export type AllLocationProceduresQueryResult = Apollo.QueryResult<AllLocationProceduresQuery, AllLocationProceduresQueryVariables>;
export const AllMsoTiersDocument = gql`
    query AllMsoTiers {
  mso_tier {
    tier
  }
}
    `;

/**
 * __useAllMsoTiersQuery__
 *
 * To run a query within a React component, call `useAllMsoTiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMsoTiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMsoTiersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllMsoTiersQuery(baseOptions?: Apollo.QueryHookOptions<AllMsoTiersQuery, AllMsoTiersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllMsoTiersQuery, AllMsoTiersQueryVariables>(AllMsoTiersDocument, options);
      }
export function useAllMsoTiersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllMsoTiersQuery, AllMsoTiersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllMsoTiersQuery, AllMsoTiersQueryVariables>(AllMsoTiersDocument, options);
        }
export type AllMsoTiersQueryHookResult = ReturnType<typeof useAllMsoTiersQuery>;
export type AllMsoTiersLazyQueryHookResult = ReturnType<typeof useAllMsoTiersLazyQuery>;
export type AllMsoTiersQueryResult = Apollo.QueryResult<AllMsoTiersQuery, AllMsoTiersQueryVariables>;
export const AllMsoModesDocument = gql`
    query AllMsoModes {
  mso_mode {
    mode
  }
}
    `;

/**
 * __useAllMsoModesQuery__
 *
 * To run a query within a React component, call `useAllMsoModesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMsoModesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMsoModesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllMsoModesQuery(baseOptions?: Apollo.QueryHookOptions<AllMsoModesQuery, AllMsoModesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllMsoModesQuery, AllMsoModesQueryVariables>(AllMsoModesDocument, options);
      }
export function useAllMsoModesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllMsoModesQuery, AllMsoModesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllMsoModesQuery, AllMsoModesQueryVariables>(AllMsoModesDocument, options);
        }
export type AllMsoModesQueryHookResult = ReturnType<typeof useAllMsoModesQuery>;
export type AllMsoModesLazyQueryHookResult = ReturnType<typeof useAllMsoModesLazyQuery>;
export type AllMsoModesQueryResult = Apollo.QueryResult<AllMsoModesQuery, AllMsoModesQueryVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: uuid!) {
  deleteCognitoUser(object: {id: $id}) {
    id
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;